import { TypedDocumentNode as DocumentNode } from "@graphql-typed-document-node/core";
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = {
  [_ in K]?: never;
};
export type Incremental<T> =
  | T
  | { [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  /** Swan account number */
  AccountNumber: { input: string; output: string };
  /**
   * The amount given with fractional digits, where fractions must be compliant to the currency definition. Up to 14 significant figures. Negative amounts are signed by minus. The decimal separator is a dot.
   *
   * Example: Valid representations for EUR with up to two decimals are:
   *
   * 1056
   * 5768.2
   * -1.50
   * 5877.78
   */
  AmountValue: { input: string; output: string };
  AuditId: { input: string; output: string };
  AuthorizationId: { input: string; output: string };
  /** Bank Identifier Code */
  BIC: { input: string; output: string };
  /** Country code alpha 2 (ISO 3166) */
  CCA2: { input: string; output: string };
  /** Country code alpha 3 (ISO 3166) */
  CCA3: { input: string; output: string };
  CardToken: { input: string; output: string };
  /** currency code alpha 3 (ISO 4217) */
  Currency: { input: string; output: string };
  /** Date with YYYY-MM-DD format */
  Date: { input: string; output: string };
  /**
   * Date time (ISO 8601 with time information)
   * ex: 2021-04-12T16:28:22.867Z
   */
  DateTime: { input: string; output: string };
  EmailAddress: { input: string; output: string };
  HexColorCode: { input: string; output: string };
  /** International Bank Account Number */
  IBAN: { input: string; output: string };
  /** 6 digits numeric passcode */
  PIN: { input: string; output: string };
  /**
   * E.164 standard format phone number
   *
   * Examples
   * +551155256325
   * +44207183875
   */
  PhoneNumber: { input: string; output: string };
  /**
   * SEPA Creditor Identifier
   * format :
   *     1 – 2: ISO Country Code
   *     3 – 4: Check Digit
   *     5 – 7: Creditor Business Code – you (Creditor) choose this. The default is ZZZ
   *     8 - 35: Creditor National Identifier – a consecutive number that will be assigned by country
   * example:
   *     FR11ABC123456
   */
  SepaCreditorIdentifier: { input: string; output: string };
  /**
   * SEPA Identifier
   * max 35 Latin characters as follow :
   *     a b c d e f g h i j k l m n o p q r s t u v w x y z
   *     A B C D E F G H I J K L M N O P Q R S T U V W X Y Z
   *     0 1 2 3 4 5 6 7 8 9
   *     / - ? : ( ) . , '  +
   * with some follow extra rules :
   *     Content must not start or end with a ‘/’
   *     Content must not contain ‘//’s
   */
  SepaReference: { input: string; output: string };
  TokenRequestorId: { input: string; output: string };
  /**
   * URL that follows the WHATWG URL Standard.
   *
   * [Examples of parsed URLs](https://url.spec.whatwg.org/#example-url-parsing) may be found in the Standard itself.
   */
  URL: { input: string; output: string };
  Upload: { input: unknown; output: unknown };
  WalletToken: { input: string; output: string };
};

export type AcceptConsentInput = {
  consentId: Scalars["String"]["input"];
};

/** Rejection returned when the Consent purpose is not allowed */
export type AcceptConsentNotAllowedForConsentPurposeRejection = Rejection & {
  __typename: "AcceptConsentNotAllowedForConsentPurposeRejection";
  message: Scalars["String"]["output"];
};

export type AcceptConsentPayload =
  | AcceptConsentNotAllowedForConsentPurposeRejection
  | AcceptConsentSuccessPayload
  | ConsentNotFoundRejection
  | NotAllowedUserStatusRejection
  | NotReachableConsentStatusRejection
  | OperationNotAllowedRejection
  | UserNotFoundRejection;

export type AcceptConsentSuccessPayload = {
  __typename: "AcceptConsentSuccessPayload";
  consent?: Maybe<Consent>;
};

/** Whether you call it a wallet, monetary account, payment account or bank account, the notion of account is fundamental at Swan. All payment flows necessarily go through an account. */
export type Account = {
  __typename: "Account";
  /**
   * Bank Identifier Code
   * Only if the account membership has `canViewAccount=true` & this account has `paymentLevel=Unlimited`
   */
  BIC: Scalars["BIC"]["output"];
  /**
   * International Bank Account Number
   * Only if the account membership has `canViewAccount=true` & this account has `paymentLevel=Unlimited`
   */
  IBAN?: Maybe<Scalars["IBAN"]["output"]>;
  /** A list of balances regarding an account. */
  balances?: Maybe<AccountBalances>;
  /** Download link to the main account iban's bank details */
  bankDetails?: Maybe<Scalars["String"]["output"]>;
  /** `true` if the main IBAN refuses all Sepa Direct Debit received */
  blockSDD?: Maybe<Scalars["Boolean"]["output"]>;
  /** Cash account type */
  cashAccountType: CashAccountType;
  /** Country of the account */
  country: AccountCountry;
  /** Created date */
  createdAt: Scalars["DateTime"]["output"];
  /** account's credit limit settings */
  creditLimitSettings?: Maybe<CreditLimitSettings>;
  /** Currency */
  currency: Scalars["Currency"]["output"];
  /**
   * List of funding source created on the account
   *
   * Implements the Relay Connection interface, used to paginate list of element ([Learn More](https://docs.swan.io/api/pagination))
   */
  fundingSources?: Maybe<FundingSourceConnection>;
  /** Account holder */
  holder: AccountHolder;
  /** Unique identifier of an account */
  id: Scalars["ID"]["output"];
  /**
   * A list of invoices of an account.
   * The list is ordered by creation date (from newest to oldest)
   *
   * Implements the Relay Connection interface, used to paginate list of element ([Learn More](https://docs.swan.io/api/pagination))
   */
  invoices?: Maybe<InvoiceConnection>;
  /** Language used for account statements */
  language: AccountLanguage;
  /**
   * Legal Documents linked to the account
   *
   * Implements the Relay Connection interface, used to paginate lists of elements. ([Learn More](https://docs.swan.io/developers/using-api/pagination))
   */
  legalDocuments?: Maybe<LegalDocumentConnection>;
  /** Legal representative account membership */
  legalRepresentativeMembership: AccountMembership;
  /**
   * List of account membership for this account
   *
   * Implements the Relay Connection interface, used to paginate lists of elements. ([Learn More](https://docs.swan.io/developers/using-api/pagination))
   */
  memberships: AccountMembershipConnection;
  /** List of merchant profiles created on the account */
  merchantProfiles?: Maybe<MerchantProfileConnection>;
  /** Account name */
  name: Scalars["String"]["output"];
  /** Unique account number */
  number: Scalars["AccountNumber"]["output"];
  /** Partnership status */
  partnershipStatusInfo?: Maybe<PartnershipStatusInfo>;
  /** Type of the account : EMoney if account holder has not finished the KYC requirements, PaymentService otherwise */
  paymentAccountType: PaymentAccountType;
  /** Payment level */
  paymentLevel: PaymentLevel;
  /**
   * A list of receive Direct Mandates of an account.
   *
   * Implements the Relay Connection interface, used to paginate list of element ([Learn More](https://docs.swan.io/api/pagination))
   */
  receivedDirectDebitMandates?: Maybe<ReceivedDirectDebitMandateConnection>;
  /** `true`if a consent is required to fetch new transactions */
  requiredConsentToFetchNewTransactions: Scalars["Boolean"]["output"];
  /** Settings of the account */
  settings: AccountSettings;
  /**
   * A list of standing orders regarding an account.
   *
   * Implements the Relay Connection interface, used to paginate list of element ([Learn More](https://docs.swan.io/api/pagination))
   */
  standingOrders: StandingOrderConnection;
  /**
   * List of statements of an account.
   *
   * Implements the Relay Connection interface, used to paginate lists of elements. ([Learn More](https://docs.swan.io/developers/using-api/pagination))
   * *For a Project access token, this is all the transactions of the project (only available with project access token)*
   */
  statements?: Maybe<StatementConnection>;
  /** Status of the account */
  statusInfo: AccountStatusInfo;
  /**
   * A list of transactions of an account.
   *
   * Implements the Relay Connection interface, used to paginate lists of elements. ([Learn More](https://docs.swan.io/developers/using-api/pagination))
   */
  transactions?: Maybe<TransactionConnection>;
  /**
   * List of trusted beneficiaries of an account.
   *
   * Implements the Relay Connection interface, used to paginate list of element ([Learn More](https://docs.swan.io/api/pagination))
   */
  trustedBeneficiaries: TrustedBeneficiaryConnection;
  /** Updated date */
  updatedAt: Scalars["DateTime"]["output"];
  /** Date of the account going from eMoney to PaymentService */
  upgradedAt?: Maybe<Scalars["DateTime"]["output"]>;
  /**
   * List of Virtual IBAN
   *
   * Implements the Relay Connection interface, used to paginate lists of elements. ([Learn More](https://docs.swan.io/developers/using-api/pagination))
   */
  virtualIbanEntries: VirtualIbanEntryConnection;
};

/** Whether you call it a wallet, monetary account, payment account or bank account, the notion of account is fundamental at Swan. All payment flows necessarily go through an account. */
export type AccountFundingSourcesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  filters?: InputMaybe<FundingSourceFiltersInput>;
  first?: Scalars["Int"]["input"];
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<FundingSourceOrderByInput>;
};

/** Whether you call it a wallet, monetary account, payment account or bank account, the notion of account is fundamental at Swan. All payment flows necessarily go through an account. */
export type AccountInvoicesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  first?: Scalars["Int"]["input"];
};

/** Whether you call it a wallet, monetary account, payment account or bank account, the notion of account is fundamental at Swan. All payment flows necessarily go through an account. */
export type AccountLegalDocumentsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  filters?: InputMaybe<LegalDocumentsFilterInput>;
  first?: Scalars["Int"]["input"];
};

/** Whether you call it a wallet, monetary account, payment account or bank account, the notion of account is fundamental at Swan. All payment flows necessarily go through an account. */
export type AccountMembershipsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  filters?: InputMaybe<MembershipsFilterInput>;
  first?: Scalars["Int"]["input"];
  orderBy?: InputMaybe<AccountMembershipOrderByInput>;
};

/** Whether you call it a wallet, monetary account, payment account or bank account, the notion of account is fundamental at Swan. All payment flows necessarily go through an account. */
export type AccountMerchantProfilesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  filters?: InputMaybe<MerchantProfileFiltersInput>;
  first?: Scalars["Int"]["input"];
  orderBy?: InputMaybe<MerchantProfileOrderByInput>;
};

/** Whether you call it a wallet, monetary account, payment account or bank account, the notion of account is fundamental at Swan. All payment flows necessarily go through an account. */
export type AccountReceivedDirectDebitMandatesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  filters?: InputMaybe<AccountReceivedDirectDebitMandateFiltersInput>;
  first?: Scalars["Int"]["input"];
  orderBy?: InputMaybe<AccountReceivedDirectDebitOrderByInput>;
};

/** Whether you call it a wallet, monetary account, payment account or bank account, the notion of account is fundamental at Swan. All payment flows necessarily go through an account. */
export type AccountStandingOrdersArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  filters?: InputMaybe<AccountStandingOrderFiltersInput>;
  first?: Scalars["Int"]["input"];
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<AccountStandingOrderOrderByInput>;
};

/** Whether you call it a wallet, monetary account, payment account or bank account, the notion of account is fundamental at Swan. All payment flows necessarily go through an account. */
export type AccountStatementsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  filters?: InputMaybe<StatementFiltersInput>;
  first?: Scalars["Int"]["input"];
  orderBy?: InputMaybe<StatementsOrderByInput>;
};

/** Whether you call it a wallet, monetary account, payment account or bank account, the notion of account is fundamental at Swan. All payment flows necessarily go through an account. */
export type AccountTransactionsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  filters?: InputMaybe<TransactionsFiltersInput>;
  first?: Scalars["Int"]["input"];
  orderBy?: InputMaybe<TransactionsOrderByInput>;
};

/** Whether you call it a wallet, monetary account, payment account or bank account, the notion of account is fundamental at Swan. All payment flows necessarily go through an account. */
export type AccountTrustedBeneficiariesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  filters?: InputMaybe<TrustedBeneficiaryFiltersInput>;
  first?: Scalars["Int"]["input"];
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<TrustedBeneficiaryOrderByInput>;
};

/** Whether you call it a wallet, monetary account, payment account or bank account, the notion of account is fundamental at Swan. All payment flows necessarily go through an account. */
export type AccountVirtualIbanEntriesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  filters?: InputMaybe<VirtualIbanEntriesFilterInput>;
  first?: Scalars["Int"]["input"];
};

/** Account and Requested Card, it the return type of accountByCardToken & accountByCardId; */
export type AccountAndCard = {
  __typename: "AccountAndCard";
  /** Account */
  account: Account;
  /** Requested Card */
  cardRequested: Card;
};

/** A list of balances regarding an account. */
export type AccountBalances = {
  __typename: "AccountBalances";
  /** Balance composed of booked, pending transactions and rolling reserve used known at the time of calculation. */
  available: Amount;
  /** Balance just composed of booked transactions. */
  booked: Amount;
  /** Balance just composed of pending transactions. */
  pending: Amount;
  /** Balance just composed of rolling reserve used in booked transactions. */
  reserved: Amount;
};

/** Account Closed status information */
export type AccountClosedStatus = AccountStatusInfo & {
  __typename: "AccountClosedStatus";
  closedAt: Scalars["DateTime"]["output"];
  closingAt: Scalars["DateTime"]["output"];
  /**
   * Reason why the account is suspended
   * @deprecated Use `reasonInfo` instead.
   */
  reason: Scalars["String"]["output"];
  /** Reason why the account is currently closed */
  reasonInfo: CloseAccountStatusReason;
  /** Account status (always Closed for type AccountClosedStatus) */
  status: AccountStatus;
};

/** Account Closing status information */
export type AccountClosingStatus = AccountStatusInfo & {
  __typename: "AccountClosingStatus";
  closingAt: Scalars["DateTime"]["output"];
  /**
   * Reason why the account is suspended
   * @deprecated Use `reasonInfo` instead.
   */
  reason: Scalars["String"]["output"];
  /** Reason why the account is currently in closing */
  reasonInfo: CloseAccountStatusReason;
  /** Account status (always Closing for type AccountClosingStatus) */
  status: AccountStatus;
};

/** Implements the Relay Connection interface, used to paginate lists of elements. ([Learn More](https://docs.swan.io/developers/using-api/pagination)) */
export type AccountConnection = Connection & {
  __typename: "AccountConnection";
  /** AccountEdge list */
  edges: Array<AccountEdge>;
  /** Information about the current, the previous and the next page */
  pageInfo: PageInfo;
  /** Total number of element in the list */
  totalCount: Scalars["Int"]["output"];
};

/**
 * Refers to the country of the account. It will determine the country code of the local IBAN of the account.
 *
 * Available Account Country: CCA3
 */
export type AccountCountry =
  /** Belgian account with an Belgian IBAN, starting with BE (Coming Soon, not supported yet). */
  | "BEL"
  /** German account with a German IBAN, starting with DE. */
  | "DEU"
  /** Spanish account with a Spanish IBAN, starting with ES. */
  | "ESP"
  /** French account with a French IBAN, starting with FR. */
  | "FRA"
  /** Italian account with an Italian IBAN, starting with IT. */
  | "ITA"
  /** Dutch account with a Dutch IBAN, starting with NL. */
  | "NLD";

/** Implements the Relay Edge interface */
export type AccountEdge = Edge & {
  __typename: "AccountEdge";
  /** Opaque identifier pointing to this node in the pagination mechanism */
  cursor: Scalars["String"]["output"];
  /** The account */
  node: Account;
};

/** Filters that can be applied when listing accounts */
export type AccountFilterInput = {
  /** Filter by the main IBAN */
  mainIBAN?: InputMaybe<Scalars["String"]["input"]>;
  /** Filter by payment level */
  paymentLevels?: InputMaybe<Array<PaymentLevel>>;
  /**
   * Search string to look for.
   *
   * Search will be performed in following fields:
   *  - Account holder's first name
   *  - Account holder's last name
   *  - Account holder's email
   *  - Account holder's ID
   *  - Name
   *  - Number
   *  - ID
   */
  search?: InputMaybe<Scalars["String"]["input"]>;
  /** Filter by status */
  status?: InputMaybe<Array<AccountStatus>>;
};

export type AccountFundingLimitsReachedReason =
  /** Account Holder funding limit exceeded */
  | "FundingLimitExceededRejection"
  /** Global funding limit exceeded */
  | "GlobalFundingLimitExceededRejection"
  /** Global instant funding limit exceeded */
  | "GlobalInstantFundingLimitExceededRejection"
  /** Account Holder instant funding limit exceeded */
  | "InstantFundingLimitExceededRejection"
  /** Insufficient funds rejection */
  | "InsufficientFundsRejection"
  /** Project funding limit exceeded */
  | "ProjectFundingLimitExceededRejection"
  /** Project instant funding limit exceeded */
  | "ProjectInstantFundingLimitExceededRejection";

/** The account holder is the person who owns the money stored in the account. The account holder can be one of your customers, whether it is a natural person or a legal person, or quite simply you. */
export type AccountHolder = {
  __typename: "AccountHolder";
  /**
   * List of accounts owned by the account holder.
   *
   * Implements the Relay Connection interface, used to paginate lists of elements. ([Learn More](https://docs.swan.io/developers/using-api/pagination))
   */
  accounts: AccountConnection;
  /** Created date. */
  createdDate: Scalars["DateTime"]["output"];
  /**
   * List of external account owned by the account holder
   *
   * Implements the Relay Connection interface, used to paginate lists of elements. ([Learn More](https://docs.swan.io/developers/using-api/pagination))
   */
  externalAccounts: ExternalAccountConnection;
  /** Funding limit settings */
  fundingLimitSettings?: Maybe<FundingLimitSettings>;
  /**
   * List of funding limit settings change request for an account holder
   *
   * Implements the Relay Connection interface, used to paginate lists of elements. ([Learn More](https://docs.swan.io/developers/using-api/pagination))
   */
  fundingLimitSettingsChangeRequests: FundingLimitSettingsChangeRequestConnection;
  /** Unique identifier of the account holder. */
  id: Scalars["ID"]["output"];
  /** Account holder type information. */
  info: AccountHolderInfo;
  /** Account holder onboarding */
  onboarding?: Maybe<Onboarding>;
  /**
   * A list of Payment Mandates for an account holder.
   *
   * Implements the Relay Connection interface, used to paginate list of element ([Learn More](https://docs.swan.io/api/pagination))
   */
  paymentMandates?: Maybe<PaymentMandateConnection>;
  /** Residency address. */
  residencyAddress: AddressInfo;
  /** Account holder risk info */
  riskInfo?: Maybe<AccountHolderRiskInfo>;
  /** Account holder status information. */
  statusInfo?: Maybe<AccountHolderStatusInfo>;
  /**
   * List of supporting document collection for an account holder
   *
   * Implements the Relay Connection interface, used to paginate lists of elements. ([Learn More](https://docs.swan.io/developers/using-api/pagination))
   */
  supportingDocumentCollections: SupportingDocumentCollectionConnection;
  /** Updated date. */
  updatedDate: Scalars["DateTime"]["output"];
  /**
   * Verification status.
   * *Banking regulations require financial institutions such as Swan to know and verify their customers in order to comply with their anti-money laundering and terrorist financing obligations. In banking jargon, we talk about KYC (Know Your Customers) procedure*
   */
  verificationStatus: VerificationStatus;
  /** Account holder verification Status information. */
  verificationStatusInfo: AccountHolderVerificationStatusInfo;
};

/** The account holder is the person who owns the money stored in the account. The account holder can be one of your customers, whether it is a natural person or a legal person, or quite simply you. */
export type AccountHolderAccountsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: Scalars["Int"]["input"];
  orderBy?: InputMaybe<AccountOrderByInput>;
};

/** The account holder is the person who owns the money stored in the account. The account holder can be one of your customers, whether it is a natural person or a legal person, or quite simply you. */
export type AccountHolderExternalAccountsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: Scalars["Int"]["input"];
};

/** The account holder is the person who owns the money stored in the account. The account holder can be one of your customers, whether it is a natural person or a legal person, or quite simply you. */
export type AccountHolderFundingLimitSettingsChangeRequestsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: Scalars["Int"]["input"];
};

/** The account holder is the person who owns the money stored in the account. The account holder can be one of your customers, whether it is a natural person or a legal person, or quite simply you. */
export type AccountHolderPaymentMandatesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  filters?: InputMaybe<PaymentMandateFiltersInput>;
  first?: Scalars["Int"]["input"];
  orderBy?: InputMaybe<PaymentMandateOrderByInput>;
};

/** The account holder is the person who owns the money stored in the account. The account holder can be one of your customers, whether it is a natural person or a legal person, or quite simply you. */
export type AccountHolderSupportingDocumentCollectionsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  filters?: InputMaybe<SupportingDocumentCollectionFilterInput>;
  first?: Scalars["Int"]["input"];
};

export type AccountHolderAccountsCreationLimitRejection = Rejection & {
  __typename: "AccountHolderAccountsCreationLimitRejection";
  message: Scalars["String"]["output"];
};

export type AccountHolderAccountsStatusNotEligibleRejection = Rejection & {
  __typename: "AccountHolderAccountsStatusNotEligibleRejection";
  /** Reason why the account holder's accounts are not eligible to open an additional account */
  message: Scalars["String"]["output"];
};

export type AccountHolderAccountsTypeNotEligibleRejection = Rejection & {
  __typename: "AccountHolderAccountsTypeNotEligibleRejection";
  /** Reason why the account holder's accounts are not eligible to open an additional account */
  message: Scalars["String"]["output"];
};

/** Account Holder Canceled Status Information */
export type AccountHolderCanceledStatusInfo = AccountHolderStatusInfo & {
  __typename: "AccountHolderCanceledStatusInfo";
  /** Reason why the account holder is suspended. */
  reason: Scalars["String"]["output"];
  /** Status of the account holder. */
  status: AccountHolderStatus;
};

export type AccountHolderCompanyInfo = AccountHolderInfo & {
  __typename: "AccountHolderCompanyInfo";
  /** Acquisition Channel to specify how the user joined, such as "InboundOrganic", "OutboundSales", etc. */
  acquisitionChannel?: Maybe<AcquisitionChannel>;
  /** Business activity. */
  businessActivity: BusinessActivity;
  /**
   * Business activity description.
   * This must be 1024 characters long maximum.
   */
  businessActivityDescription: Scalars["String"]["output"];
  /** Registration date of the company. */
  companyRegistrationDate?: Maybe<Scalars["Date"]["output"]>;
  /** Legal form of the company (SAS, SCI, SASU, ...). */
  companyType?: Maybe<CompanyType>;
  /**
   * The ultimate beneficiary is defined as the natural person (s) who own or control, directly or indirectly, the reporting company.
   *
   * The ultimate beneficiary is :
   * - either the natural person (s) who hold, directly or indirectly, more than 25% of the capital or the rights of vote of the reporting company;
   * - either the natural person (s) who exercise, by other means, a power of control of the company;
   */
  individualUltimateBeneficialOwners: Array<IndividualUltimateBeneficialOwner>;
  /** Legal representative personal address */
  legalRepresentativePersonalAddress?: Maybe<AddressInformation>;
  /** Estimated monthly payment volume (euro). */
  monthlyPaymentVolume: MonthlyPaymentVolume;
  /** Name of the company. */
  name: Scalars["String"]["output"];
  /**
   * Registration number of the company (for example, Système d'Identification du Répertoire des ENtreprises [SIREN] in France, ...).
   * - Length must be from 0 to 50 characters.
   */
  registrationNumber?: Maybe<Scalars["String"]["output"]>;
  /** Returns the list of representatives of a company. */
  representatives: Array<Representative>;
  /** Tax Identification Number */
  taxIdentificationNumber?: Maybe<Scalars["String"]["output"]>;
  /** Trade name of the company */
  tradeName?: Maybe<Scalars["String"]["output"]>;
  /** Account holder type (always Company for type AccountHolderCompanyInfo) */
  type: AccountHolderType;
  /** Unique number that identifies a taxable person (business) or non-taxable legal entity that is registered for VAT */
  vatNumber?: Maybe<Scalars["String"]["output"]>;
};

/** Implements the Relay Connection interface, used to paginate lists of elements. ([(Learn More)](https://docs.swan.io/developers/using-api/pagination/)) */
export type AccountHolderConnection = Connection & {
  __typename: "AccountHolderConnection";
  /** AccountHolderEdge list. */
  edges: Array<AccountHolderEdge>;
  /** Information about the current, the previous and the next page. */
  pageInfo: PageInfo;
  /** Total number of element in the list. */
  totalCount: Scalars["Int"]["output"];
};

export type AccountHolderDueDiligenceLevel = "Common" | "Enhanced" | "Refused" | "Simplified";

/** Implements the Relay Edge interface. */
export type AccountHolderEdge = Edge & {
  __typename: "AccountHolderEdge";
  /** Opaque identifier pointing to this node in the pagination mechanism. */
  cursor: Scalars["String"]["output"];
  /** The account holder. */
  node: AccountHolder;
};

/** Account Holder Enabled Status Information */
export type AccountHolderEnabledStatusInfo = AccountHolderStatusInfo & {
  __typename: "AccountHolderEnabledStatusInfo";
  /** Status of the account holder. */
  status: AccountHolderStatus;
};

/** Filters that can be applied when listing account holders */
export type AccountHolderFilterInput = {
  /** Filter by birth date */
  birthDate?: InputMaybe<Scalars["String"]["input"]>;
  /**
   * Search by first name
   *
   * @deprecated(reason: "use `search` instead")
   */
  firstName?: InputMaybe<Scalars["String"]["input"]>;
  /**
   * Search by last name
   *
   * @deprecated(reason: "use `search` instead")
   */
  lastName?: InputMaybe<Scalars["String"]["input"]>;
  /**
   * Filter by registration number of the company
   * (for example, Système d'Identification du Répertoire des ENtreprises [SIREN] in France, ...).
   *
   * - Length must be from 0 to 50 characters.
   */
  registrationNumber?: InputMaybe<Scalars["String"]["input"]>;
  /**
   * Search string to look for
   *
   * Search will be performed in following fields:
   *  - First name
   *  - Last name
   *  - Company name
   *  - ID
   */
  search?: InputMaybe<Scalars["String"]["input"]>;
  /** Filter by status */
  status?: InputMaybe<Array<AccountHolderStatus>>;
  /** Filter by type */
  types?: InputMaybe<Array<AccountHolderType>>;
  /** Filter by verification status */
  verificationStatus?: InputMaybe<Array<VerificationStatus>>;
};

/** Individual account holder. */
export type AccountHolderIndividualInfo = AccountHolderInfo & {
  __typename: "AccountHolderIndividualInfo";
  /** Acquisition Channel to specify how the user joined, such as "InboundOrganic", "OutboundSales", etc. */
  acquisitionChannel?: Maybe<AcquisitionChannel>;
  /** Employment status of the account holder (regulatory questions). */
  employmentStatus: EmploymentStatus;
  /** Monthly income of the account holder (regulatory questions). */
  monthlyIncome: MonthlyIncome;
  /** Account Holder's first name and last name. */
  name: Scalars["String"]["output"];
  /** Tax Identification Number */
  taxIdentificationNumber?: Maybe<Scalars["String"]["output"]>;
  /** Account holder type (always Individual for type AccountHolderIndividualInfo). */
  type: AccountHolderType;
  /** User of the individual account holder. */
  user: User;
};

/** Account holder types. */
export type AccountHolderInfo = {
  /** Account holder name */
  name: Scalars["String"]["output"];
  /** Account holder type */
  type: AccountHolderType;
};

/** Rejection returned when the Account Holder was not found */
export type AccountHolderNotFoundRejection = Rejection & {
  __typename: "AccountHolderNotFoundRejection";
  message: Scalars["String"]["output"];
};

export type AccountHolderNotStartedVerificationStatusInfo = AccountHolderVerificationStatusInfo & {
  __typename: "AccountHolderNotStartedVerificationStatusInfo";
  /** Verification Status of the account holder. */
  status: VerificationStatus;
};

/** Union type for account holder onboarding - returned by accountHolderOnboarding query */
export type AccountHolderOnboarding =
  | CompanyAccountHolderOnboarding
  | IndividualAccountHolderOnboarding;

/** Base interface for account holder onboarding */
export type AccountHolderOnboardingBase = {
  createdAt: Scalars["DateTime"]["output"];
  id: Scalars["ID"]["output"];
  /** OAuth parameters provided in order to redirect the user at the end of the flow */
  oAuthRedirectParameters?: Maybe<OAuthRedirectParameters>;
  projectInfo: ProjectInfo;
  statusInfo: OnboardingStatusInfo;
  supportingDocumentCollection?: Maybe<SupportingDocumentCollection>;
  updatedAt: Scalars["DateTime"]["output"];
};

/** Connection type for paginated AccountHolderOnboarding results */
export type AccountHolderOnboardingConnection = Connection & {
  __typename: "AccountHolderOnboardingConnection";
  /** AccountHolderOnboardingEdge list */
  edges: Array<AccountHolderOnboardingEdge>;
  /** Information about the current, the previous and the next page */
  pageInfo: PageInfo;
  /** Total number of elements in the list */
  totalCount: Scalars["Int"]["output"];
};

/** Edge type for AccountHolderOnboarding in a paginated list */
export type AccountHolderOnboardingEdge = Edge & {
  __typename: "AccountHolderOnboardingEdge";
  /** Opaque identifier pointing to this account holder onboarding node in the pagination mechanism */
  cursor: Scalars["String"]["output"];
  /** The AccountHolderOnboarding */
  node: AccountHolderOnboarding;
};

/** Result payload for account holder onboarding query */
export type AccountHolderOnboardingPayload =
  | AccountHolderOnboardingSuccessPayload
  | ForbiddenRejection
  | InternalErrorRejection
  | OnboardingNotFoundRejection;

/** Success response with account holder onboarding information */
export type AccountHolderOnboardingSuccessPayload = {
  __typename: "AccountHolderOnboardingSuccessPayload";
  onboarding: AccountHolderOnboarding;
};

/** Field we can use when ordering that can be applied when listing account holders */
export type AccountHolderOrderByFieldInput = "createdAt" | "updatedAt";

/** Order that can be applied when listing account holders */
export type AccountHolderOrderByInput = {
  direction?: InputMaybe<OrderByDirection>;
  field?: InputMaybe<AccountHolderOrderByFieldInput>;
};

export type AccountHolderPendingVerificationStatusInfo = AccountHolderVerificationStatusInfo & {
  __typename: "AccountHolderPendingVerificationStatusInfo";
  /** ISO Date string at which the account holder status was set to Pending */
  pendingAt: Scalars["DateTime"]["output"];
  /** Verification Status of the account holder. */
  status: VerificationStatus;
};

export type AccountHolderProjectSettingsNotEligibleRejection = Rejection & {
  __typename: "AccountHolderProjectSettingsNotEligibleRejection";
  message: Scalars["String"]["output"];
};

export type AccountHolderRefusedVerificationStatusInfo = AccountHolderVerificationStatusInfo & {
  __typename: "AccountHolderRefusedVerificationStatusInfo";
  /** Reason for which the account holder was refused */
  reason: Scalars["String"]["output"];
  /** ISO Date string at which the account holder status was set to Refused */
  refusedAt: Scalars["DateTime"]["output"];
  /** Verification Status of the account holder. */
  status: VerificationStatus;
};

export type AccountHolderRiskInfo = {
  __typename: "AccountHolderRiskInfo";
  amlRiskLevel?: Maybe<AmlRiskLevel>;
  amlScore?: Maybe<Scalars["Int"]["output"]>;
  dueDiligenceLevel?: Maybe<AccountHolderDueDiligenceLevel>;
};

/** Account holder status. */
export type AccountHolderStatus =
  /** When the account holder is canceled. */
  | "Canceled"
  /** When the account holder is enabled. */
  | "Enabled"
  /** When the account holder is suspended. */
  | "Suspended";

/** Account Holder Status Information */
export type AccountHolderStatusInfo = {
  /** Status of the account holder. */
  status: AccountHolderStatus;
};

export type AccountHolderStatusNotEligibleRejection = Rejection & {
  __typename: "AccountHolderStatusNotEligibleRejection";
  /** Reason why the account holder is not eligible to open an additional account */
  message: Scalars["String"]["output"];
};

/** Account Holder Suspended Status Information */
export type AccountHolderSuspendedStatusInfo = AccountHolderStatusInfo & {
  __typename: "AccountHolderSuspendedStatusInfo";
  /** Reason why the account holder is suspended. */
  reason: Scalars["String"]["output"];
  /** Status of the account holder. */
  status: AccountHolderStatus;
};

/** Account holder type */
export type AccountHolderType =
  /** Company (Legal person) */
  | "Company"
  /** Individual (Natural person) */
  | "Individual";

/**
 * Rejection returned if the account holder type is individual.
 * An individual account holder can't create a b2b received direct debit mandate.
 */
export type AccountHolderTypeIndividualRejection = Rejection & {
  __typename: "AccountHolderTypeIndividualRejection";
  message: Scalars["String"]["output"];
};

export type AccountHolderTypeNotEligibleRejection = Rejection & {
  __typename: "AccountHolderTypeNotEligibleRejection";
  /** Reason why the account holder is not eligible */
  message: Scalars["String"]["output"];
};

/** Account Holder Verification Status Information */
export type AccountHolderVerificationStatusInfo = {
  /** Verification Status of the account holder. */
  status: VerificationStatus;
};

export type AccountHolderVerificationStatusNotEligibleRejection = Rejection & {
  __typename: "AccountHolderVerificationStatusNotEligibleRejection";
  /** Reason why the account holder is not eligible to open an additional account */
  message: Scalars["String"]["output"];
};

export type AccountHolderVerifiedVerificationStatusInfo = AccountHolderVerificationStatusInfo & {
  __typename: "AccountHolderVerifiedVerificationStatusInfo";
  /** Verification Status of the account holder. */
  status: VerificationStatus;
  /** ISO Date string at which the account holder status was set to Verified */
  verifiedAt: Scalars["DateTime"]["output"];
};

export type AccountHolderWaitingForInformationVerificationStatusInfo =
  AccountHolderVerificationStatusInfo & {
    __typename: "AccountHolderWaitingForInformationVerificationStatusInfo";
    /**
     * @deprecated(reason: "Use `waitingForInformationAt` instead")
     * @deprecated Use `waitingForInformationAt` instead
     */
    WaitingForInformationAt: Scalars["DateTime"]["output"];
    accountHolderId: Scalars["String"]["output"];
    /** Verification Status of the account holder. */
    status: VerificationStatus;
    verificationRequirements: Array<VerificationRequirement>;
    /** ISO Date string at which the account holder status was set to WaitingForInformation */
    waitingForInformationAt: Scalars["DateTime"]["output"];
  };

/** Language: ISO 639-1 language code */
export type AccountLanguage = "de" | "en" | "es" | "fi" | "fr" | "it" | "nl" | "pt";

/**
 * An account membership represents the rights of a user for a given account.
 *
 * *Each account is administered by an account membership having the capacity of legal representative. He has the possibility of delegating rights on this account to other users.*
 */
export type AccountMembership = {
  __typename: "AccountMembership";
  /** List of accepted identification level */
  acceptedIdentificationLevels: Array<Maybe<IdentificationLevel>>;
  /** account of the account membership */
  account?: Maybe<Account>;
  /**
   * Refers to the country of the account. It will determine the country code of the local IBAN of the account.
   *
   * Available Account Country: CCA3
   */
  accountCountry: AccountCountry;
  /** The type of the account holder linked to the account membership. */
  accountHolderType: AccountHolderType;
  /** Unique identifier of the account of the account membership */
  accountId: Scalars["ID"]["output"];
  /** `true` if this account membership can initiate credit transfers */
  canInitiatePayments: Scalars["Boolean"]["output"];
  /** `true` if this account membership can invite, update, suspend or resume memberships */
  canManageAccountMembership: Scalars["Boolean"]["output"];
  /** `true` if this account membership can add or canceled beneficiaries */
  canManageBeneficiaries: Scalars["Boolean"]["output"];
  /** `true` if this account membership can manage cards for himself or to the memberships he manages */
  canManageCards: Scalars["Boolean"]["output"];
  /** `true` if this account membership can view account balances and transactions history */
  canViewAccount: Scalars["Boolean"]["output"];
  /** account membership's cards */
  cards: CardConnection;
  /** Created date */
  createdAt: Scalars["DateTime"]["output"];
  /** Disabled date */
  disabledAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** email */
  email: Scalars["String"]["output"];
  /** Indicate if the identity bound to the account membership has required identification level */
  hasRequiredIdentificationLevel?: Maybe<Scalars["Boolean"]["output"]>;
  /** Unique identifier of an account membership */
  id: Scalars["ID"]["output"];
  /** Language of the account membership */
  language?: Maybe<AccountLanguage>;
  /** `true` if this account membership having the capacity of the legal representative of the account holder. */
  legalRepresentative: Scalars["Boolean"]["output"];
  /** Residency address of the member */
  residencyAddress?: Maybe<AddressInfo>;
  /** Periodic Spending */
  spending?: Maybe<Spending>;
  /** Periodic Spending limit list */
  spendingLimits?: Maybe<Array<SpendingLimit>>;
  /** status of the account membership */
  statusInfo: AccountMembershipStatusInfo;
  /** Tax Identification Number of the member */
  taxIdentificationNumber?: Maybe<Scalars["String"]["output"]>;
  /** Updated date */
  updatedAt: Scalars["DateTime"]["output"];
  /** user of this account membership */
  user?: Maybe<User>;
  /** version of the account membership started from '1' and incremented at every updates */
  version: Scalars["String"]["output"];
};

/**
 * An account membership represents the rights of a user for a given account.
 *
 * *Each account is administered by an account membership having the capacity of legal representative. He has the possibility of delegating rights on this account to other users.*
 */
export type AccountMembershipCardsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  filters?: InputMaybe<CardFiltersInput>;
  first?: Scalars["Int"]["input"];
  orderBy?: InputMaybe<CardOrderByInput>;
};

/** when a user is bound with the error to the account membership */
export type AccountMembershipBindingUserErrorStatusInfo = AccountMembershipStatusInfo & {
  __typename: "AccountMembershipBindingUserErrorStatusInfo";
  /** `true` if the birth date of the bound user doesn't match with the invitation */
  birthDateMatchError: Scalars["Boolean"]["output"];
  /** `true` if the email of the bound user doesn't match with the invitation */
  emailVerifiedMatchError: Scalars["Boolean"]["output"];
  /** `true` if the first name of the bound user doesn't match with the invitation */
  firstNameMatchError: Scalars["Boolean"]["output"];
  /** `true` if Swan hasn't verified the user's identity */
  idVerifiedMatchError: Scalars["Boolean"]["output"];
  /** `true` if the last name of the bound user doesn't match with the invitation */
  lastNameMatchError: Scalars["Boolean"]["output"];
  /** `true` if the phone number of the bound user doesn't match with the invitation */
  phoneNumberMatchError: Scalars["Boolean"]["output"];
  /** restricted to a user */
  restrictedTo: RestrictedTo;
  /** AccountMembership status (always BindingUserError for type AccountMembershipBindingUserErrorStatusInfo) */
  status: AccountMembershipStatus;
};

export type AccountMembershipCannotBeDisabledRejection = Rejection & {
  __typename: "AccountMembershipCannotBeDisabledRejection";
  accountMembershipId: Scalars["String"]["output"];
  message: Scalars["String"]["output"];
};

export type AccountMembershipCannotBeUpdatedRejection = Rejection & {
  __typename: "AccountMembershipCannotBeUpdatedRejection";
  id: Scalars["String"]["output"];
  message: Scalars["String"]["output"];
};

/** Implements the Relay Connection interface, used to paginate lists of elements. ([Learn More](https://docs.swan.io/developers/using-api/pagination)) */
export type AccountMembershipConnection = Connection & {
  __typename: "AccountMembershipConnection";
  /** AccountMembershipEdge list */
  edges: Array<AccountMembershipEdge>;
  /** Information about the current, the previous and the next page */
  pageInfo: PageInfo;
  /** Total number of element in the list */
  totalCount: Scalars["Int"]["output"];
};

/** when the user has to consent to invite a new account membership */
export type AccountMembershipConsentPendingStatusInfo = AccountMembershipStatusInfo & {
  __typename: "AccountMembershipConsentPendingStatusInfo";
  /** The consent required to invite this account membership */
  consent: Consent;
  /** restricted to a user */
  restrictedTo: RestrictedTo;
  /** AccountMembership status (always ConsentPending for type AccountMembershipConsentPendingStatusInfo) */
  status: AccountMembershipStatus;
};

/** when the account membership is disabled */
export type AccountMembershipDisabledStatusInfo = AccountMembershipStatusInfo & {
  __typename: "AccountMembershipDisabledStatusInfo";
  /** reason why the account membership is disabled */
  reason: Scalars["String"]["output"];
  /** AccountMembership status (always Disabled for type AccountMembershipDisabledStatusInfo) */
  status: AccountMembershipStatus;
};

/** Implements the Relay Edge interface */
export type AccountMembershipEdge = Edge & {
  __typename: "AccountMembershipEdge";
  /** Opaque identifier pointing to this node in the pagination mechanism */
  cursor: Scalars["String"]["output"];
  /** The account membership */
  node: AccountMembership;
};

/** when the account membership is enabled */
export type AccountMembershipEnabledStatusInfo = AccountMembershipStatusInfo & {
  __typename: "AccountMembershipEnabledStatusInfo";
  /** AccountMembership status (always Enabled for type AccountMembershipEnabledStatusInfo) */
  status: AccountMembershipStatus;
};

/** when a new account membership is invited and there is no user bound yet */
export type AccountMembershipInvitationSentStatusInfo = AccountMembershipStatusInfo & {
  __typename: "AccountMembershipInvitationSentStatusInfo";
  /** restricted to a user */
  restrictedTo: RestrictedTo;
  /** AccountMembership status (always InvitationSent for type AccountMembershipInvitationSentStatusInfo) */
  status: AccountMembershipStatus;
};

/** Rejection returned when the Account Membership is not allowed to use an operation. */
export type AccountMembershipNotAllowedRejection = Rejection & {
  __typename: "AccountMembershipNotAllowedRejection";
  message: Scalars["String"]["output"];
};

export type AccountMembershipNotEligibleRejection = Rejection & {
  __typename: "AccountMembershipNotEligibleRejection";
  /** Reason why the user is not eligible */
  message: Scalars["String"]["output"];
};

export type AccountMembershipNotFoundRejection = Rejection & {
  __typename: "AccountMembershipNotFoundRejection";
  id: Scalars["String"]["output"];
  message: Scalars["String"]["output"];
};

/** Rejection returned if invitation has not been sent to user yet */
export type AccountMembershipNotReadyToBeBoundRejection = Rejection & {
  __typename: "AccountMembershipNotReadyToBeBoundRejection";
  id: Scalars["String"]["output"];
  message: Scalars["String"]["output"];
};

export type AccountMembershipNotReadyToBeUpdatedRejection = {
  __typename: "AccountMembershipNotReadyToBeUpdatedRejection";
  message: Scalars["String"]["output"];
};

/** Field we can use when ordering that can be applied when listing account memberships */
export type AccountMembershipOrderByFieldInput = "createdAt" | "updatedAt";

/** Order that can be applied when listing account memberships */
export type AccountMembershipOrderByInput = {
  direction?: InputMaybe<OrderByDirection>;
  field?: InputMaybe<AccountMembershipOrderByFieldInput>;
};

/** AccountMembership enabled */
export type AccountMembershipStatus =
  /** when the user bound with errors to the account membership */
  | "BindingUserError"
  /** when the consent to invite the account membership is pending */
  | "ConsentPending"
  /** when the account membership is disabled */
  | "Disabled"
  /** when the account membership is enabled */
  | "Enabled"
  /** when the account membership is invited */
  | "InvitationSent"
  /** when the account membership is suspended */
  | "Suspended";

/** here are the different account membership status: */
export type AccountMembershipStatusInfo = {
  /** AccountMembership status */
  status: AccountMembershipStatus;
};

export type AccountMembershipStatusNotEligibleRejection = Rejection & {
  __typename: "AccountMembershipStatusNotEligibleRejection";
  /** Reason why the user status is not eligible */
  message: Scalars["String"]["output"];
};

/** when the account membership is suspended */
export type AccountMembershipSuspendedStatusInfo = AccountMembershipStatusInfo & {
  __typename: "AccountMembershipSuspendedStatusInfo";
  /** reason why the account membership is suspended */
  reason: Scalars["String"]["output"];
  /** AccountMembership status (always Suspended for type AccountMembershipSuspendedStatusInfo) */
  status: AccountMembershipStatus;
};

/** Filters that can be applied when listing account memberships */
export type AccountMembershipsFilterInput = {
  /** Filter by account */
  accountId?: InputMaybe<Scalars["ID"]["input"]>;
  /** Can the user initiate payments on this account */
  canInitiatePayments?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Can the user manage account membership */
  canManageAccountMembership?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Can the user manage beneficiaries */
  canManageBeneficiaries?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** `true` if this account membership can manage cards for himself or to the memberships he manages */
  canManageCards?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Can the user view account */
  canViewAccount?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Filter by email */
  email?: InputMaybe<Scalars["String"]["input"]>;
  /**
   * Search by first name
   *
   * @deprecated(reason: "use `search` instead")
   */
  firstName?: InputMaybe<Scalars["String"]["input"]>;
  /**
   * Search by last name
   *
   * @deprecated(reason: "use `search` instead")
   */
  lastName?: InputMaybe<Scalars["String"]["input"]>;
  /**
   * Search string to look for
   *
   * Search will be performed in following fields:
   * - First name
   * - Last name
   * - Email
   * - ID
   */
  search?: InputMaybe<Scalars["String"]["input"]>;
  /** Account memberships status/statuses we're looking for */
  status?: InputMaybe<Array<AccountMembershipStatus>>;
};

/** Thrown when an related account is not eligible to the feature */
export type AccountNotEligibleRejection = Rejection & {
  __typename: "AccountNotEligibleRejection";
  message: Scalars["String"]["output"];
};

/** Rejection returned if the account was not found or if the user does not have the rights to know that the card exists */
export type AccountNotFoundRejection = Rejection & {
  __typename: "AccountNotFoundRejection";
  id: Scalars["String"]["output"];
  message: Scalars["String"]["output"];
};

/** Account Opened status information */
export type AccountOpenedStatus = AccountStatusInfo & {
  __typename: "AccountOpenedStatus";
  /** Account status (always Opened for type AccountOpenedStatus) */
  status: AccountStatus;
};

/** Fields that can be used when ordering accounts */
export type AccountOrderByFieldInput = "createdAt" | "updatedAt";

/** Order that can be applied when listing accounts */
export type AccountOrderByInput = {
  direction?: InputMaybe<OrderByDirection>;
  field?: InputMaybe<AccountOrderByFieldInput>;
};

/** Filter that can be passed to get the received direct debit mandate in a specific data range */
export type AccountReceivedDirectDebitMandateFiltersInput = {
  /** To filter on scheme values */
  scheme?: InputMaybe<Array<ReceivedDirectDebitMandateScheme>>;
  /** To filter on status values */
  status?: InputMaybe<Array<ReceivedDirectDebitMandateStatus>>;
};

/** Field we can use when ordering that can be applied when listing receives direct debit mandate results */
export type AccountReceivedDirectDebitOrderByFieldInput = "createdAt" | "updatedAt";

/** Order that can be applied when listing receives direct debit mandate results */
export type AccountReceivedDirectDebitOrderByInput = {
  direction?: InputMaybe<OrderByDirection>;
  field?: InputMaybe<AccountReceivedDirectDebitOrderByFieldInput>;
};

export type AccountSettings = {
  __typename: "AccountSettings";
  /** Wether or not the account is allowed to initiate bulk payment transfers without the beneficiary verification */
  allowBulkCreditTransfersWithoutBeneficiaryVerification?: Maybe<Scalars["Boolean"]["output"]>;
};

/** Filters that can be applied when listing Standing orders */
export type AccountStandingOrderFiltersInput = {
  status?: InputMaybe<Array<StandingOrderStatus>>;
};

/** Field we can use when ordering that can be applied when listing standing order results */
export type AccountStandingOrderOrderByFieldInput = "createdAt" | "updatedAt";

/** Order that can be applied when listing standing order results */
export type AccountStandingOrderOrderByInput = {
  direction?: InputMaybe<OrderByDirection>;
  field?: InputMaybe<AccountStandingOrderOrderByFieldInput>;
};

/**
 * [NEW] The different type of statement actually available
 * - PDF will be a PDF file with the statement information
 */
export type AccountStatementFormat = "CSV" | "PDF";

/** [NEW] Status information of the account statement */
export type AccountStatementStatus = "Failed" | "Generated" | "Pending" | "Voided";

/** [NEW] Statement Status Information */
export type AccountStatementStatusInfo = {
  /** status of the Statement */
  status: AccountStatementStatus;
};

export type AccountStatus =
  /** When the account is closed */
  | "Closed"
  /** When the account is currently closing */
  | "Closing"
  /** When the account is opened */
  | "Opened"
  /** When the account is suspended */
  | "Suspended";

export type AccountStatusInfo = {
  /** Account status */
  status: AccountStatus;
};

/** Account Suspended status information */
export type AccountSuspendedStatus = AccountStatusInfo & {
  __typename: "AccountSuspendedStatus";
  /**
   * Reason why the account is suspended
   * @deprecated Use `reasonInfo` instead.
   */
  reason: Scalars["String"]["output"];
  /** Reason why the account is currently suspend */
  reasonInfo: SuspendAccountStatusReason;
  /** Account status (always Suspended for type AccountSuspendedStatus) */
  status: AccountStatus;
};

export type AccountTypeNotEligibleRejection = Rejection & {
  __typename: "AccountTypeNotEligibleRejection";
  /** Reason why the account type is not eligible */
  message: Scalars["String"]["output"];
};

/** Account Verification */
export type AccountVerification = {
  /** Creation date of the account verification */
  createdAt: Scalars["DateTime"]["output"];
  /** Unique identifier of the Account Verification */
  id: Scalars["ID"]["output"];
  /** Account Verification Status Information */
  statusInfo: AccountVerificationStatusInfo;
  /** Last update date of the account verification */
  updatedAt: Scalars["DateTime"]["output"];
};

/**
 * Rejection returned when the external account has already been rejected.
 *
 * In such a case, contact Swan directly to resolve the situation for this specific account holder.
 */
export type AccountVerificationAlreadyRejectedRejection = Rejection & {
  __typename: "AccountVerificationAlreadyRejectedRejection";
  message: Scalars["String"]["output"];
};

/** Account Verification Status */
export type AccountVerificationStatus =
  /**
   * We could not automatically match the external iban based on last received transfer.
   * Manuel review process is underway
   */
  | "PendingReview"
  /** We are waiting for the end user to send a credit transfer from his external iban to any Swan owned iban */
  | "PendingVerification"
  /** Account verification has been rejected */
  | "Rejected"
  /** Account has been verified */
  | "Verified";

/** Account Verification Status Information */
export type AccountVerificationStatusInfo = {
  /** Account verification status */
  status: AccountVerificationStatus;
};

/** Rejection returned when the Account Verification is not in the expected status */
export type AccountVerificationWrongStatusRejection = Rejection & {
  __typename: "AccountVerificationWrongStatusRejection";
  message: Scalars["String"]["output"];
};

/** Acquisition channel. */
export type AcquisitionChannel =
  | "InboundOrganic"
  | "InboundReferral"
  | "OutboundAccountingFirm"
  | "OutboundSales";

export type ActionNotAllowedRejection = Rejection & {
  __typename: "ActionNotAllowedRejection";
  message: Scalars["String"]["output"];
};

/** Inputs to activate a digital card */
export type ActivateDigitalCardInput = {
  /** URL the user is redirected to after consent has been given */
  consentRedirectUrl: Scalars["String"]["input"];
  /** Unique identifier of a digital card */
  digitalCardId: Scalars["ID"]["input"];
};

/** Payload returned on mutation completion */
export type ActivateDigitalCardPayload =
  | AccountMembershipNotAllowedRejection
  | ActivateDigitalCardSuccessPayload
  | BadAccountStatusRejection
  | CardCanNotBeDigitalizedRejection
  | DigitalCardNotFoundRejection
  | MissingMandatoryFieldRejection
  | UserNotCardHolderRejection
  | ValidationRejection;

export type ActivateDigitalCardSuccessPayload = {
  __typename: "ActivateDigitalCardSuccessPayload";
  /**
   * Digital Card used for ApplePay or GooglePay
   *
   * The consent can be found in the digital card status information.
   */
  digitalCard: PendingDigitalCard;
};

export type ActivatePhysicalCardInput = {
  /** URL the user is redirected to after consent has been given */
  consentRedirectUrl: Scalars["String"]["input"];
  /** Unique identifier present on physical card */
  identifier: Scalars["String"]["input"];
};

export type ActivatePhysicalCardPayload =
  | ActivatePhysicalCardSuccessPayload
  | BadAccountStatusRejection
  | CannotActivatePhysicalCardRejection
  | CardNotFoundRejection
  | ForbiddenRejection
  | PhysicalCardNotFoundRejection
  | PhysicalCardWrongStatusRejection
  | UserNotCardHolderRejection
  | ValidationRejection;

export type ActivatePhysicalCardSuccessPayload = {
  __typename: "ActivatePhysicalCardSuccessPayload";
  /** The consent required to activate this physical card */
  consent: Consent;
  /** The physicalCard to activate */
  physicalCard: PhysicalCard;
};

export type ActiveMerchantPaymentLinkStatusInfo = MerchantPaymentLinkStatusInfo & {
  __typename: "ActiveMerchantPaymentLinkStatusInfo";
  /**
   * The date when the payment link expires.
   * By default the payment link expires 120 days after it was created.
   */
  expiresAt: Scalars["DateTime"]["output"];
  status: MerchantPaymentLinkStatus;
};

/** Inputs to add a new account membership */
export type AddAccountMembershipInput = {
  /** Unique identifier of a given account */
  accountId: Scalars["ID"]["input"];
  /** `true` if this account membership can initiate credit transfers */
  canInitiatePayments: Scalars["Boolean"]["input"];
  /** `true` if this account membership can invite, update, suspend or resume account membership */
  canManageAccountMembership: Scalars["Boolean"]["input"];
  /** `true` if this account membership can add or canceled beneficiaries */
  canManageBeneficiaries: Scalars["Boolean"]["input"];
  /** `true` if this account membership can manage cards for himself or to the memberships he manages */
  canManageCards?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** `true` if this account membership can view account balances and transactions history */
  canViewAccount: Scalars["Boolean"]["input"];
  /** URL the user is redirected to after consent has been given */
  consentRedirectUrl?: InputMaybe<Scalars["String"]["input"]>;
  /** Email address */
  email: Scalars["String"]["input"];
  /** Language of the account membership */
  language?: InputMaybe<AccountLanguage>;
  /** Residency address of the member to be added */
  residencyAddress?: InputMaybe<ResidencyAddressInput>;
  /** Restricted to a user if necessary */
  restrictedTo: RestrictedToInput;
  /** Tax Identification Number of the user added */
  taxIdentificationNumber?: InputMaybe<Scalars["String"]["input"]>;
};

export type AddAccountMembershipPayload =
  | AddAccountMembershipSuccessPayload
  | BadAccountStatusRejection
  | ForbiddenRejection
  | InvalidPhoneNumberRejection
  | MissingPhoneNumberRestrictionRejection
  | PermissionCannotBeGrantedRejection
  | ValidationRejection;

export type AddAccountMembershipSuccessPayload = {
  __typename: "AddAccountMembershipSuccessPayload";
  accountMembership: AccountMembership;
};

/** Inputs to add a new account membership */
export type AddAccountMembershipsInput = {
  /** Unique identifier of a given account */
  accountId: Scalars["ID"]["input"];
  /** URL the user is redirected to after consent has been given */
  consentRedirectUrl?: InputMaybe<Scalars["String"]["input"]>;
  /** Memberships to add to the account */
  memberships: Array<MembershipInfoInput>;
};

export type AddAccountMembershipsPayload =
  | AddAccountMembershipsSuccessPayload
  | BadAccountStatusRejection
  | ForbiddenRejection
  | InvalidPhoneNumberRejection
  | MissingPhoneNumberRestrictionRejection
  | PermissionCannotBeGrantedRejection
  | TooManyItemsRejection
  | ValidationRejection;

export type AddAccountMembershipsSuccessPayload = {
  __typename: "AddAccountMembershipsSuccessPayload";
  accountMemberships: Array<AccountMembership>;
};

/** Inputs to add a new card */
export type AddCardInput = {
  /** Unique identifier of a given account membership */
  accountMembershipId: Scalars["ID"]["input"];
  /** Card expiration date  if `null` it does not have an expiration date */
  cardContractExpiryDate?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** The id of the card product to use to create the new card. */
  cardProductId?: InputMaybe<Scalars["ID"]["input"]>;
  /** URL the user is redirected to after consent has been given */
  consentRedirectUrl: Scalars["String"]["input"];
  /** `true` if this card allows transactions at eCommerce sites */
  eCommerce: Scalars["Boolean"]["input"];
  /** `true` if this card allows payments outside of the country */
  international: Scalars["Boolean"]["input"];
  /** Card name */
  name?: InputMaybe<Scalars["String"]["input"]>;
  /** `true` if this card allows transactions outside of the card's main currency */
  nonMainCurrencyTransactions: Scalars["Boolean"]["input"];
  /** Spending limit */
  spendingLimit?: InputMaybe<SpendingLimitInput>;
  /** `true` to show the card confidential information in the same request */
  viewCardNumber?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** `true` if this card allows cash withdrawals */
  withdrawal: Scalars["Boolean"]["input"];
};

export type AddCardPayload =
  | AccountMembershipNotAllowedRejection
  | AddCardSuccessPayload
  | BadAccountStatusRejection
  | CardProductDisabledRejection
  | CardProductInvalidFundingTypeRejection
  | CardProductSuspendedRejection
  | EnabledCardDesignNotFoundRejection
  | ForbiddenRejection
  | MissingMandatoryFieldRejection
  | ValidationRejection;

export type AddCardSuccessPayload = {
  __typename: "AddCardSuccessPayload";
  /** The new card added */
  card: Card;
};

/** Input to add a new cards */
export type AddCardsInput = {
  /** The id of the card product to use to create the new cards. */
  cardProductId?: InputMaybe<Scalars["ID"]["input"]>;
  /** The configuration of all the cards you want to add */
  cards: Array<CardConfigInput>;
  /** URL the user is redirected to after consent has been given */
  consentRedirectUrl: Scalars["String"]["input"];
};

export type AddCardsPayload =
  | AccountMembershipNotAllowedRejection
  | AddCardsSuccessPayload
  | AddingCardsToDifferentAccountsRejection
  | BadAccountStatusRejection
  | CardProductDisabledRejection
  | CardProductInvalidFundingTypeRejection
  | CardProductNotApplicableToPhysicalCardsRejection
  | CardProductSuspendedRejection
  | EnabledCardDesignNotFoundRejection
  | InvalidShippingProviderRejection
  | MissingMandatoryFieldRejection
  | TooManyItemsRejection
  | ValidationRejection;

export type AddCardsSuccessPayload = {
  __typename: "AddCardsSuccessPayload";
  /** The newly created cards */
  cards: Array<Card>;
};

/** Input to add a new cards */
export type AddCardsWithGroupDeliveryInput = {
  /** The id of the card product to use to create the new cards. */
  cardProductId?: InputMaybe<Scalars["ID"]["input"]>;
  /** The configuration of all the cards you want to add */
  cards: Array<CardConfigWithGroupDeliveryInput>;
  /** URL the user is redirected to after consent has been given */
  consentRedirectUrl: Scalars["String"]["input"];
  /** Address to deliver the printed physical cards */
  groupDeliveryAddress: CompleteAddressWithContactInput;
};

export type AddCardsWithGroupDeliveryPayload =
  | AccountMembershipNotAllowedRejection
  | AddCardsWithGroupDeliverySuccessPayload
  | AddingCardsToDifferentAccountsRejection
  | BadAccountStatusRejection
  | CardProductDisabledRejection
  | CardProductInvalidFundingTypeRejection
  | CardProductNotApplicableToPhysicalCardsRejection
  | CardProductSuspendedRejection
  | EnabledCardDesignNotFoundRejection
  | MissingMandatoryFieldRejection
  | TooManyItemsRejection
  | ValidationRejection;

export type AddCardsWithGroupDeliverySuccessPayload = {
  __typename: "AddCardsWithGroupDeliverySuccessPayload";
  /** The newly created cards */
  cards: Array<Card>;
};

/** Inputs to add a new digital card */
export type AddDigitalCardInput = {
  /** Unique identifier of a card */
  cardId: Scalars["ID"]["input"];
  /** URL the user is redirected to after consent has been given */
  consentRedirectUrl: Scalars["String"]["input"];
  /** Provider for which to generate a digitalCard */
  walletProvider: WalletProviderType;
};

/** Payload returned on mutation completion */
export type AddDigitalCardPayload =
  | AccountMembershipNotAllowedRejection
  | AddDigitalCardSuccessPayload
  | ApplePayNotAllowedForProjectRejection
  | BadAccountStatusRejection
  | CardCanNotBeDigitalizedRejection
  | CardNotFoundRejection
  | CardProductDisabledRejection
  | EnabledCardDesignNotFoundRejection
  | MissingMandatoryFieldRejection
  | UserNotCardHolderRejection
  | ValidationRejection;

export type AddDigitalCardSuccessPayload = {
  __typename: "AddDigitalCardSuccessPayload";
  /**
   * Digital Card used for ApplePay or GooglePay
   *
   * The consent can be found in the digital card status information.
   */
  digitalCard: PendingDigitalCard;
};

/** Input to add a Direct Debit Funding Source */
export type AddDirectDebitFundingSourceInput = {
  /**
   * Id of the account on which to create a funding source.
   * Money will be funded to this account when an `initiateFundingRequest` is done using this funding source
   */
  accountId: Scalars["ID"]["input"];
  /** URL the user is redirected to after consent has been given */
  consentRedirectUrl: Scalars["String"]["input"];
  /**
   * IBAN to use in the direct debit transaction that will be triggered when funding the account.
   * Money will be debited from this IBAN when an `initiateFundingRequest` is done using this funding source
   */
  iban: Scalars["IBAN"]["input"];
  /** Name to give to this funding source */
  name?: InputMaybe<Scalars["String"]["input"]>;
  /** Scheme of the underlying payment mandate */
  scheme: SepaDirectDebitScheme;
};

/** Add Direct Debit Funding Source Payload */
export type AddDirectDebitFundingSourcePayload =
  | AccountVerificationAlreadyRejectedRejection
  | AddDirectDebitFundingSourceSuccessPayload
  | ForbiddenRejection
  | IbanNotReachableRejection
  | NotFoundRejection
  | ValidationRejection;

/** Add Direct Debit Funding Source Success Payload */
export type AddDirectDebitFundingSourceSuccessPayload = {
  __typename: "AddDirectDebitFundingSourceSuccessPayload";
  /** The created funding source */
  fundingSource: FundingSource;
};

export type AddExternalAccountBalanceInput = {
  /** Amount of the balance */
  amount: AmountInput;
  /** Unique identifier of a given external account */
  externalAccountId: Scalars["ID"]["input"];
  /** Last changed Date */
  lastChangedAt: Scalars["DateTime"]["input"];
  /** Type of the balance */
  type: ExternalAccountBalanceType;
};

export type AddExternalAccountBalancePayload =
  | AddExternalAccountBalanceSuccessPayload
  | ExternalAccountBalanceAlreadyExistsRejection
  | ForbiddenRejection
  | ValidationRejection;

export type AddExternalAccountBalanceSuccessPayload = {
  __typename: "AddExternalAccountBalanceSuccessPayload";
  /** The added external balance */
  externalAccountBalance: ExternalAccountBalance;
};

export type AddExternalAccountInput = {
  /** Bank Identifier Code */
  BIC: Scalars["BIC"]["input"];
  /** International Bank Account Number */
  IBAN: Scalars["IBAN"]["input"];
  /** Unique identifier of a given account holder */
  accountHolderId: Scalars["ID"]["input"];
  /** Balances */
  balances?: InputMaybe<Array<ExternalAccountBalanceInput>>;
  /** Type of account */
  cashAccountType: CashAccountType;
  /** Country */
  country: Scalars["CCA3"]["input"];
  /** Currency */
  currency: Scalars["Currency"]["input"];
  /** External account identifier */
  externalId: Scalars["String"]["input"];
  /** Account Holder name */
  holderName: Scalars["String"]["input"];
  /** Name of the account */
  name?: InputMaybe<Scalars["String"]["input"]>;
  /** Original Created date */
  originalCreatedAt: Scalars["DateTime"]["input"];
  /** Source of the account information */
  source: Scalars["String"]["input"];
  /** Usage information of the account */
  usage: ExternalAccountUsage;
};

export type AddExternalAccountPayload =
  | AddExternalAccountSuccessPayload
  | ExternalAccountAlreadyExistsRejection
  | ForbiddenRejection
  | IbanValidationRejection
  | ValidationRejection;

export type AddExternalAccountSuccessPayload = {
  __typename: "AddExternalAccountSuccessPayload";
  /** The added external account */
  externalAccount: ExternalAccount;
};

export type AddExternalIdentificationIdentityDocumentInput = {
  allFirstNames: Array<Scalars["String"]["input"]>;
  birthCity?: InputMaybe<Scalars["String"]["input"]>;
  birthCountry?: InputMaybe<Scalars["CCA3"]["input"]>;
  birthDate: Scalars["String"]["input"];
  birthLastName?: InputMaybe<Scalars["String"]["input"]>;
  expiryDate?: InputMaybe<Scalars["String"]["input"]>;
  firstName: Scalars["String"]["input"];
  gender: Gender;
  issueDate?: InputMaybe<Scalars["String"]["input"]>;
  issuingCountry?: InputMaybe<Scalars["CCA3"]["input"]>;
  lastName: Scalars["String"]["input"];
  mrz?: InputMaybe<Scalars["String"]["input"]>;
  nationality: Scalars["CCA3"]["input"];
  number?: InputMaybe<Scalars["String"]["input"]>;
  type: IdentityDocumentType;
};

export type AddExternalIdentificationInput = {
  externalId: Scalars["String"]["input"];
  identityDocument: AddExternalIdentificationIdentityDocumentInput;
  userId: Scalars["String"]["input"];
};

export type AddExternalIdentificationPayload =
  | AddExternalIdentificationSuccessPayload
  | ForbiddenRejection
  | UserNotFoundRejection
  | ValidationRejection;

export type AddExternalIdentificationSuccessPayload = {
  __typename: "AddExternalIdentificationSuccessPayload";
  createdAt: Scalars["DateTime"]["output"];
  externalId: Scalars["String"]["output"];
  facePhotoDocumentId?: Maybe<Scalars["ID"]["output"]>;
  id: Scalars["ID"]["output"];
  identityDocumentId?: Maybe<Scalars["ID"]["output"]>;
  /**
   * Status could be `Valid` or `Invalid`.
   * `Invalid` status is caused by a mismatch between the user information given to `addExternalIdentification` mutation
   * and user information given during the onboarding by the user him-self
   */
  status: SwanIdentificationStatus;
  updatedAt: Scalars["DateTime"]["output"];
  userId: Scalars["String"]["output"];
};

/** Inputs to add a new request for funding limit settings change */
export type AddFundingLimitSettingsChangeRequestInput = {
  /** Unique identifier of a given account holder */
  accountHolderId: Scalars["ID"]["input"];
  /** Requested amount settings for the funding limit */
  fundingLimit: FundingLimitAmountInput;
  /** Requested amount settings for the instant funding limit */
  instantFundingLimit: FundingLimitAmountInput;
};

/** Payload returned on mutation completion */
export type AddFundingLimitSettingsChangeRequestPayload =
  | AccountHolderNotFoundRejection
  | AddFundingLimitSettingsChangeRequestSuccessPayload
  | ForbiddenRejection
  | FundingLimitSettingsChangeRequestBadAmountRejection
  | ValidationRejection;

/** Add Funding Limit Settings Change Request Success Payload */
export type AddFundingLimitSettingsChangeRequestSuccessPayload = {
  __typename: "AddFundingLimitSettingsChangeRequestSuccessPayload";
  /** The new request for funding limit settings change */
  fundingLimitSettingsChangeRequest: FundingLimitSettingsChangeRequest;
};

/** Inputs to add an Internal Direct Debit Payment Mandate */
export type AddInternalDirectDebitPaymentMandateInput = {
  /** ID of the Swan account of the debtor */
  debtorAccountId: Scalars["ID"]["input"];
  /** Language that will be used to produce the mandate PDF document */
  language?: InputMaybe<MandateLanguage>;
  /** Custom name of the Internal Direct Debit mandate */
  name?: InputMaybe<Scalars["String"]["input"]>;
  /** The ID of the concerned merchant payment method */
  paymentMethodId: Scalars["ID"]["input"];
  /** Reference of the payment mandate */
  reference?: InputMaybe<Scalars["String"]["input"]>;
  /** Determines whether the payment mandate is a one-off or recurrent */
  sequence?: InputMaybe<InternalDirectDebitSequence>;
  /** Signature date of the Internal Direct Debit mandate */
  signatureDate?: InputMaybe<Scalars["Date"]["input"]>;
};

/** Union type return by the addInternalDirectDebitPaymentMandate mutation */
export type AddInternalDirectDebitPaymentMandatePayload =
  | AddInternalDirectDebitPaymentMandateSuccessPayload
  | DebtorAccountClosedRejection
  | DebtorAccountNotAllowedRejection
  | ForbiddenRejection
  | IbanNotReachableRejection
  | IbanNotValidRejection
  | InternalErrorRejection
  | MerchantProfileNotValidRejection
  | NotFoundRejection
  | PaymentMandateReferenceAlreadyUsedRejection
  | PaymentMethodNotCompatibleRejection
  | SchemeWrongRejection;

/** Return type in case of a successful response of the addInternalDirectDebitPaymentMandate mutation */
export type AddInternalDirectDebitPaymentMandateSuccessPayload = {
  __typename: "AddInternalDirectDebitPaymentMandateSuccessPayload";
  paymentMandate: InternalPaymentDirectDebitMandate;
};

export type AddOrUpdateExternalAccountBalanceInput = {
  /** Amount of the balance */
  amount: AmountInput;
  /** Unique identifier of a given external account */
  externalAccountId: Scalars["ID"]["input"];
  /** Last changed Date */
  lastChangedAt: Scalars["DateTime"]["input"];
  /** Type of the balance */
  type: ExternalAccountBalanceType;
};

export type AddOrUpdateExternalAccountBalancePayload =
  | AddOrUpdateExternalAccountBalanceSuccessPayload
  | ForbiddenRejection
  | ValidationRejection;

export type AddOrUpdateExternalAccountBalanceSuccessPayload = {
  __typename: "AddOrUpdateExternalAccountBalanceSuccessPayload";
  /** The added external balance */
  externalAccountBalance: ExternalAccountBalance;
};

/** Inputs to add a received internal direct debit mandate B2b. */
export type AddReceivedInternalDirectDebitB2bMandateInput = {
  /** URL the user is redirected to after consent has been given */
  consentRedirectUrl: Scalars["String"]["input"];
  /** Label that will be displayed along with this received direct debit mandate in the web banking */
  name?: InputMaybe<Scalars["String"]["input"]>;
  /** The associated Payment Mandate ID */
  paymentMandateId: Scalars["ID"]["input"];
};

/** Union type return by the addReceivedInternalDirectDebitB2bMandate mutation */
export type AddReceivedInternalDirectDebitB2bMandatePayload =
  | AccountHolderTypeIndividualRejection
  | AddReceivedInternalDirectDebitB2bMandateSuccessPayload
  | ForbiddenRejection
  | PaymentMandateMandateNotFoundRejection
  | ValidationRejection;

/** Return type in case of a successful response of the addReceivedInternalDirectDebitB2bMandate mutation */
export type AddReceivedInternalDirectDebitB2bMandateSuccessPayload = {
  __typename: "AddReceivedInternalDirectDebitB2bMandateSuccessPayload";
  /** The received direct debit mandate is added */
  receivedDirectDebitMandate: ReceivedDirectDebitMandate;
};

/** Inputs to add a received sepa direct debit mandate B2b. */
export type AddReceivedSepaDirectDebitB2bMandateInput = {
  /** URL the user is redirected to after consent has been given */
  consentRedirectUrl: Scalars["String"]["input"];
  /** The Sepa Creditor Identifier of the creditor */
  creditorIdentifier: Scalars["String"]["input"];
  /** The name of the creditor */
  creditorName: Scalars["String"]["input"];
  /** The Swan Iban of the debtor */
  iban: Scalars["String"]["input"];
  /** The unique identifier of the received direct debit mandate */
  mandateReference: Scalars["String"]["input"];
  /** Label that will be displayed along with this received direct debit mandate in the web banking */
  name?: InputMaybe<Scalars["String"]["input"]>;
  /** Sequence of the mandate */
  sequence: SepaReceivedDirectDebitMandateSequence;
  /** Date of signature of the mandate */
  signatureDate?: InputMaybe<Scalars["Date"]["input"]>;
};

/** Union type return by the addReceivedSepaDirectDebitB2bMandate mutation */
export type AddReceivedSepaDirectDebitB2bMandatePayload =
  | AccountHolderTypeIndividualRejection
  | AccountNotFoundRejection
  | AddReceivedSepaDirectDebitB2bMandateSuccessPayload
  | ForbiddenRejection
  | ValidationRejection;

/** Return type in case of a successful response of the addReceivedSepaDirectDebitB2bMandate mutation */
export type AddReceivedSepaDirectDebitB2bMandateSuccessPayload = {
  __typename: "AddReceivedSepaDirectDebitB2bMandateSuccessPayload";
  /** The received direct debit mandate is added */
  receivedDirectDebitMandate: ReceivedDirectDebitMandate;
};

export type AddSepaDirectDebitPaymentMandateInput = {
  /** Debtor of the SEPA Direct Debit Payment Mandate */
  debtor: SepaPaymentMandateDebtorInput;
  /** Language that will be used to produce the mandate PDF document */
  language: MandateLanguage;
  /** Custom name of the SEPA Direct Debit Payment Mandate */
  name?: InputMaybe<Scalars["String"]["input"]>;
  /** Specifies payment ID of a SEPA Direct Debit CORE or B2B payment method. */
  paymentMethodId: Scalars["ID"]["input"];
  /** Unique reference of the SEPA Direct Debit Payment Mandate. */
  reference?: InputMaybe<Scalars["String"]["input"]>;
  /** Determines whether the payment mandate is a one-off or recurrent */
  sequence: DirectDebitSequence;
  /** Signature date of the SEPA Direct Debit Payment Mandate */
  signatureDate: Scalars["Date"]["input"];
};

/** Union type return by the addSepaDirectDebitPaymentMandate mutation */
export type AddSepaDirectDebitPaymentMandatePayload =
  | AddSepaDirectDebitPaymentMandateSuccessPayload
  | DebtorAccountClosedRejection
  | DebtorAccountNotAllowedRejection
  | ForbiddenRejection
  | IbanNotReachableRejection
  | IbanNotValidRejection
  | InternalErrorRejection
  | MerchantProfileNotValidRejection
  | NotFoundRejection
  | PaymentMandateReferenceAlreadyUsedRejection
  | PaymentMethodNotCompatibleRejection
  | SchemeWrongRejection
  | ValidationRejection;

/** Return type in case of a successful response of the addSepaDirectDebitPaymentMandate mutation */
export type AddSepaDirectDebitPaymentMandateSuccessPayload = {
  __typename: "AddSepaDirectDebitPaymentMandateSuccessPayload";
  paymentMandate: SepaPaymentDirectDebitMandate;
};

/** Inputs to add a new card */
export type AddSingleUseVirtualCardInput = {
  /** Unique identifier of a given account membership */
  accountMembershipId: Scalars["ID"]["input"];
  /** Card expiration date only for Single Use Virtual Card One-off, if `null` the Single Use Virtual Card will have a default expiration of plus 30 days */
  cardContractExpiryDate?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** The id of the card product to use to create the new card. */
  cardProductId?: InputMaybe<Scalars["ID"]["input"]>;
  /** URL the user is redirected to after consent has been given */
  consentRedirectUrl: Scalars["String"]["input"];
  /** Card name */
  name?: InputMaybe<Scalars["String"]["input"]>;
  /** Spending limit */
  spendingLimit: SpendingLimitInput;
  /** `true` to show the card confidential information in the same request */
  viewCardNumber?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type AddSingleUseVirtualCardPayload =
  | AccountMembershipNotAllowedRejection
  | AddSingleUseVirtualCardSuccessForProjectOwnerPayload
  | AddSingleUseVirtualCardSuccessForUserPayload
  | BadAccountStatusRejection
  | CardProductDisabledRejection
  | CardProductInvalidFundingTypeRejection
  | CardProductSuspendedRejection
  | EnabledCardDesignNotFoundRejection
  | MissingMandatoryFieldRejection
  | ValidationRejection;

export type AddSingleUseVirtualCardSuccessForProjectOwnerPayload = {
  __typename: "AddSingleUseVirtualCardSuccessForProjectOwnerPayload";
  /** The new card added */
  card: Card;
  /** Card confidential */
  confidential: CardConfidential;
};

export type AddSingleUseVirtualCardSuccessForUserPayload = {
  __typename: "AddSingleUseVirtualCardSuccessForUserPayload";
  /** The new card added */
  card: Card;
};

/** Input to add a new single-use virtual cards */
export type AddSingleUseVirtualCardsInput = {
  /** The id of the card product to use to create the new cards. */
  cardProductId?: InputMaybe<Scalars["ID"]["input"]>;
  /** The configuration of all the cards you want to add */
  cards: Array<SingleUseVirtualCardConfigInput>;
  /** URL the user is redirected to after consent has been given */
  consentRedirectUrl: Scalars["String"]["input"];
};

export type AddSingleUseVirtualCardsPayload =
  | AccountMembershipNotAllowedRejection
  | AddSingleUseVirtualCardsSuccessPayload
  | AddingCardsToDifferentAccountsRejection
  | BadAccountStatusRejection
  | CardProductDisabledRejection
  | CardProductInvalidFundingTypeRejection
  | CardProductSuspendedRejection
  | EnabledCardDesignNotFoundRejection
  | MissingMandatoryFieldRejection
  | TooManyItemsRejection
  | ValidationRejection;

export type AddSingleUseVirtualCardsSuccessPayload = {
  __typename: "AddSingleUseVirtualCardsSuccessPayload";
  /** The newly created single use virtual cards */
  cards: Array<Card>;
};

/** Input to add an international trusted beneficiary */
export type AddTrustedInternationalBeneficiaryInput = {
  /** Account ID of the account on which the beneficiary will be created */
  accountId: Scalars["ID"]["input"];
  /** When the consent flow is finished the user is redirected to this URL */
  consentRedirectUrl: Scalars["String"]["input"];
  /** Currency of the international beneficiary account */
  currency: Scalars["Currency"]["input"];
  /** Currency-specific details of the beneficiary */
  details: Array<InternationalBeneficiaryDetailsInput>;
  /** Name of the created beneficiary */
  label?: InputMaybe<Scalars["String"]["input"]>;
  /** Account holder name of the international trusted beneficiary */
  name: Scalars["String"]["input"];
  /** Route that Swan will use to transfer the funds to that beneficiary */
  route: InternationalCreditTransferRouteInput;
};

/** Add international trusted beneficiary payload */
export type AddTrustedInternationalBeneficiaryPayload =
  | AccountNotFoundRejection
  | AddTrustedInternationalBeneficiarySuccessPayload
  | ForbiddenRejection
  | InternalErrorRejection
  | ValidationRejection;

/** Add international trusted beneficiary success payload */
export type AddTrustedInternationalBeneficiarySuccessPayload = {
  __typename: "AddTrustedInternationalBeneficiarySuccessPayload";
  /** The created beneficiary */
  trustedBeneficiary: TrustedInternationalBeneficiary;
};

/** Input to add a SEPA trusted beneficiaries */
export type AddTrustedSepaBeneficiariesInput = {
  /** Account ID of the account on which the beneficiaries will be created */
  accountId: Scalars["ID"]["input"];
  /** When the consent flow is finished the user is redirected to this URL */
  consentRedirectUrl: Scalars["String"]["input"];
  /** List of SEPA trusted beneficiaries */
  sepaBeneficiaries: Array<TrustedSepaBeneficiaryInput>;
};

/** Add sepa trusted beneficiaries payload */
export type AddTrustedSepaBeneficiariesPayload =
  | AccountNotFoundRejection
  | AddTrustedSepaBeneficiariesSuccessPayload
  | ForbiddenRejection
  | ValidationRejection;

/** Add SEPA trusted beneficiaries success payload */
export type AddTrustedSepaBeneficiariesSuccessPayload = {
  __typename: "AddTrustedSepaBeneficiariesSuccessPayload";
  /** The created trusted sepa beneficiaries */
  trustedBeneficiaries: Array<TrustedSepaBeneficiary>;
};

/** Input to add a SEPA trusted beneficiary */
export type AddTrustedSepaBeneficiaryInput = {
  /** Account ID of the account on which the beneficiary will be created */
  accountId: Scalars["ID"]["input"];
  /** Beneficiary address */
  address?: InputMaybe<AddressInput>;
  /** When the consent flow is finished the user is redirected to this URL */
  consentRedirectUrl: Scalars["String"]["input"];
  /** IBAN of the SEPA trusted beneficiary */
  iban: Scalars["IBAN"]["input"];
  /** Label of the SEPA trusted beneficiary. If not provided, the name will be used. */
  label?: InputMaybe<Scalars["String"]["input"]>;
  /** Name of the SEPA trusted beneficiary */
  name: Scalars["String"]["input"];
};

/** Add sepa trusted beneficiary payload */
export type AddTrustedSepaBeneficiaryPayload =
  | AccountNotFoundRejection
  | AddTrustedSepaBeneficiarySuccessPayload
  | ForbiddenRejection
  | InternalErrorRejection
  | ValidationRejection;

/** Add SEPA trusted beneficiary success payload */
export type AddTrustedSepaBeneficiarySuccessPayload = {
  __typename: "AddTrustedSepaBeneficiarySuccessPayload";
  /** The created trusted sepa beneficiary */
  trustedBeneficiary: TrustedSepaBeneficiary;
};

export type AddVirtualIbanEntryPayload =
  | AccountNotFoundRejection
  | AddVirtualIbanEntrySuccessPayload
  | BadAccountStatusRejection
  | ForbiddenRejection
  | ValidationRejection;

export type AddVirtualIbanEntrySuccessPayload = {
  __typename: "AddVirtualIbanEntrySuccessPayload";
  virtualIbanEntry: VirtualIbanEntry;
};

/** Input to Add a Virtual IBAN */
export type AddVirtualIbanInput = {
  /** Unique identifier of a given account */
  accountId: Scalars["ID"]["input"];
};

/** Input values needed to add a webhook subscription */
export type AddWebhookSubscriptionInput = {
  /**
   * The endpoint URL events will be sent to
   * (max 255 characters)
   */
  endpoint: Scalars["String"]["input"];
  /**
   * The types of subscribed events
   * A subset of unique IDs from `webhookEventTypes`
   */
  eventTypes: Array<Scalars["ID"]["input"]>;
  /**
   * A short descriptive label for the subscription
   * (max 255 characters)
   */
  label: Scalars["String"]["input"];
  /**
   * The optional secret to secure incoming webhook calls. We recommend a UUID-4 to be future proof.
   * (max 36 characters)
   */
  secret?: InputMaybe<Scalars["String"]["input"]>;
  /** Control if the subscription should be enabled on creation */
  status: WebhookSubscriptionCreationStatus;
};

/** Rejection returned if the attempting to add cards to different accounts. */
export type AddingCardsToDifferentAccountsRejection = Rejection & {
  __typename: "AddingCardsToDifferentAccountsRejection";
  message: Scalars["String"]["output"];
};

export type AdditionalInformation = DefaultAdditionalInformation | OtherAdditionalInformation;

export type AdditionalInformationInput = {
  defaultInformation?: InputMaybe<DefaultAdditionalInformationInput>;
  otherInformation?: InputMaybe<OtherAdditionalInformationInput>;
};

export type AdditionalInformationRequirements = {
  __typename: "AdditionalInformationRequirements";
  additionalInformation: Array<AdditionalInformationType>;
};

export type AdditionalInformationType =
  | "NumberOfEmployees"
  | "NumberOfOwners"
  | "NumberOfProperties";

/** Address Information */
export type Address = {
  __typename: "Address";
  /** address line 1 */
  addressLine1?: Maybe<Scalars["String"]["output"]>;
  /** addressLine2 */
  addressLine2?: Maybe<Scalars["String"]["output"]>;
  /** city */
  city?: Maybe<Scalars["String"]["output"]>;
  /** country */
  country?: Maybe<Scalars["CCA3"]["output"]>;
  /** postal code (max 10 characters) */
  postalCode?: Maybe<Scalars["String"]["output"]>;
  /** state */
  state?: Maybe<Scalars["String"]["output"]>;
};

/** Address information. */
export type AddressInfo = {
  __typename: "AddressInfo";
  /** Address line 1. */
  addressLine1?: Maybe<Scalars["String"]["output"]>;
  /** Address line 2. */
  addressLine2?: Maybe<Scalars["String"]["output"]>;
  /** City. */
  city?: Maybe<Scalars["String"]["output"]>;
  /** Country. */
  country?: Maybe<Scalars["CCA3"]["output"]>;
  /** Postal code. */
  postalCode?: Maybe<Scalars["String"]["output"]>;
  /** State. */
  state?: Maybe<Scalars["String"]["output"]>;
};

/** Address */
export type AddressInformation = {
  __typename: "AddressInformation";
  /** Address */
  addressLine1: Scalars["String"]["output"];
  /** Address */
  addressLine2?: Maybe<Scalars["String"]["output"]>;
  /** City */
  city: Scalars["String"]["output"];
  /** Country */
  country: Scalars["CCA3"]["output"];
  /** Postal code */
  postalCode: Scalars["String"]["output"];
  /** State */
  state?: Maybe<Scalars["String"]["output"]>;
};

/** Address */
export type AddressInformationInput = {
  /** Address */
  addressLine1?: InputMaybe<Scalars["String"]["input"]>;
  /** Address */
  addressLine2?: InputMaybe<Scalars["String"]["input"]>;
  /** City */
  city?: InputMaybe<Scalars["String"]["input"]>;
  /** Country */
  country: Scalars["CCA3"]["input"];
  /** Postal code */
  postalCode?: InputMaybe<Scalars["String"]["input"]>;
  /** State */
  state?: InputMaybe<Scalars["String"]["input"]>;
};

/** Address Information */
export type AddressInput = {
  /** address line 1 (max 100 characters) */
  addressLine1?: InputMaybe<Scalars["String"]["input"]>;
  /** address line 2 (max 100 characters) */
  addressLine2?: InputMaybe<Scalars["String"]["input"]>;
  /** city (max 100 characters) */
  city?: InputMaybe<Scalars["String"]["input"]>;
  /** country code */
  country: Scalars["CCA3"]["input"];
  /** postal code (max 10 characters) */
  postalCode?: InputMaybe<Scalars["String"]["input"]>;
  /** state (max 100 characters) */
  state?: InputMaybe<Scalars["String"]["input"]>;
};

/** Input to Allow SDD */
export type AllowSddInput = {
  /** Unique identifier of a given account */
  accountId: Scalars["ID"]["input"];
};

export type AllowSddPayload =
  | AccountNotFoundRejection
  | AllowSddSuccessPayload
  | ValidationRejection;

export type AllowSddSuccessPayload = {
  __typename: "AllowSddSuccessPayload";
  account: Account;
};

export type AllowSddVirtualIbanEntryInput = {
  ibanEntryId: Scalars["ID"]["input"];
};

export type AllowSddVirtualIbanEntryPayload =
  | AllowSddVirtualIbanEntrySuccessPayload
  | BadAccountStatusRejection
  | ValidationRejection;

export type AllowSddVirtualIbanEntrySuccessPayload = {
  __typename: "AllowSddVirtualIbanEntrySuccessPayload";
  virtualIbanEntry: VirtualIbanEntry;
};

export type AllowedValue = {
  __typename: "AllowedValue";
  key: Scalars["String"]["output"];
  name: Scalars["String"]["output"];
};

/** Rejection returned if card already has a valid Physical Card */
export type AlreadyValidPhysicalCardRejection = Rejection & {
  __typename: "AlreadyValidPhysicalCardRejection";
  message: Scalars["String"]["output"];
};

export type AmlRiskLevel = "High" | "Low" | "Medium" | "TooHigh";

/** Amount with its currency */
export type Amount = {
  __typename: "Amount";
  /** currency */
  currency: Scalars["Currency"]["output"];
  /** value of the amount */
  value: Scalars["AmountValue"]["output"];
};

/** Amount with its currency */
export type AmountInput = {
  /** currency */
  currency: Scalars["Currency"]["input"];
  /** value of the amount */
  value: Scalars["AmountValue"]["input"];
};

/** Rejection return if the project is not configured to allow Apple Pay */
export type ApplePayNotAllowedForProjectRejection = Rejection & {
  __typename: "ApplePayNotAllowedForProjectRejection";
  id: Scalars["String"]["output"];
  message: Scalars["String"]["output"];
};

/** Approved Funding Limit */
export type ApprovedFundingLimit = {
  __typename: "ApprovedFundingLimit";
  /** Requested amount settings for the funding limit */
  fundingLimit: FundingLimitAmount;
  /** Requested amount settings for the instant funding limit */
  instantFundingLimit: FundingLimitAmount;
};

/** A method used to authenticate a user */
export type Authenticator = {
  __typename: "Authenticator";
  /** Accept-Language header used during registration */
  acceptLanguage?: Maybe<Scalars["String"]["output"]>;
  /** Device Brand parsed from the user agent (eg: Acer, Alcatel, Amazon, Apple, ...) */
  brand?: Maybe<Scalars["String"]["output"]>;
  /** Device Model parsed from the user agent */
  model?: Maybe<Scalars["String"]["output"]>;
  /** Operating System parsed from the user agent (eg AIX, Amiga OS, Android, Arch, Bada, BeOS, BlackBerry, ...) */
  os?: Maybe<Scalars["String"]["output"]>;
  /**
   * The phone number used for the creation of the authenticator
   * @deprecated Field no longer supported
   */
  otpPhoneNumber?: Maybe<Scalars["String"]["output"]>;
  /** Type of authenticator */
  type: AuthenticatorType;
  /** Raw user agent */
  userAgent?: Maybe<Scalars["String"]["output"]>;
};

export type AuthenticatorType =
  /** Deprecated: swan authenticator */
  | "Swan"
  /** A Swan web authenticator */
  | "SwanWeb";

/** Type of the card authorization transaction */
export type AuthorizationType =
  /** Classic authorization, nominal use-case, in order to hold the amount in the available balance that will be debited in the following days */
  | "Classic"
  /** Usually an authorization used by a merchant to verify if the card exists and can successfully receive a future authorization */
  | "DataRequest"
  /**
   * Pre-authorization.
   * Usually an authorization in order to hold the amount in the available balance that will be updated in a second time with the final amount (gaz station, car rent, etc)
   */
  | "PreAuthorization";

/** Rejection returned if the status account is not valid */
export type BadAccountStatusRejection = Rejection & {
  __typename: "BadAccountStatusRejection";
  id: Scalars["String"]["output"];
  message: Scalars["String"]["output"];
};

/** Rejection when an inputs contains an error */
export type BadRequestRejection = Rejection & {
  __typename: "BadRequestRejection";
  message: Scalars["String"]["output"];
};

/** Balance Information */
export type Balance = {
  __typename: "Balance";
  /** Matching account for this balance */
  account: Account;
  /** A list of balances regarding an account. */
  balances?: Maybe<AccountBalances>;
  /** Last SCT IN transaction */
  lastSctIn?: Maybe<SepaCreditTransferTransaction>;
  /** Last SCT OUT transaction */
  lastSctOut?: Maybe<SepaCreditTransferTransaction>;
};

/** Information about the banking institution */
export type Bank = {
  __typename: "Bank";
  /** Bank address (We might only be able to fill in the country) */
  address: Address;
  /** Bank BIC code */
  bic: Scalars["BIC"]["output"];
  /** Bank Branch Code */
  branch?: Maybe<Scalars["String"]["output"]>;
  /** Bank name */
  name: Scalars["String"]["output"];
  /** Bank local identifier (unique by country) */
  nationalId: Scalars["String"]["output"];
};

/** Basic Physical Card Info */
export type BasicPhysicalCardInfo = {
  __typename: "BasicPhysicalCardInfo";
  /** Masked Card Number */
  cardMaskedNumber: Scalars["String"]["output"];
  /** Custom Options */
  customOptions: PhysicalCardCustomOptions;
  /** Physical Card expiration date  with MM/YY string format */
  expiryDate?: Maybe<Scalars["String"]["output"]>;
  /** Unique identifier present on physical card */
  identifier?: Maybe<Scalars["String"]["output"]>;
  /** `true` if physical card is expired */
  isExpired: Scalars["Boolean"]["output"];
  /** Offline Spending limit defined by Swan */
  offlineSpendingLimit: Amount;
};

export type Beneficiary = TrustedSepaBeneficiary | UnsavedSepaBeneficiary;

/** Input parameters for a beneficiary */
export type BeneficiaryInput = {
  sepa?: InputMaybe<SepaBeneficiaryInput>;
  swanAccount?: InputMaybe<SwanAccountBeneficiaryInput>;
  trustedBeneficiaryId?: InputMaybe<Scalars["ID"]["input"]>;
};

/** Beneficiary type */
export type BeneficiaryType =
  /** for Internal transfer */
  | "Internal"
  /** for International transfer */
  | "International"
  /** for SEPA transfer */
  | "Sepa";

/** Rejection returned if a BeneficiaryVerificationToken was consumed in a transfer initiation */
export type BeneficiaryVerificationTokenAlreadyConsumedRejection = Rejection & {
  __typename: "BeneficiaryVerificationTokenAlreadyConsumedRejection";
  beneficiaryVerificationTokens: Array<Scalars["String"]["output"]>;
  message: Scalars["String"]["output"];
};

export type BindAccountMembershipInput = {
  accountMembershipId: Scalars["ID"]["input"];
};

export type BindAccountMembershipPayload =
  | AccountMembershipNotFoundRejection
  | AccountMembershipNotReadyToBeBoundRejection
  | BadAccountStatusRejection
  | BindAccountMembershipSuccessPayload
  | IdentityAlreadyBindToAccountMembershipRejection
  | RestrictedToUserRejection
  | ValidationRejection;

export type BindAccountMembershipSuccessPayload = {
  __typename: "BindAccountMembershipSuccessPayload";
  accountMembership: AccountMembership;
};

export type BirthInfo = {
  __typename: "BirthInfo";
  birthDate?: Maybe<Scalars["Date"]["output"]>;
  city?: Maybe<Scalars["String"]["output"]>;
  country?: Maybe<Scalars["CCA3"]["output"]>;
  postalCode?: Maybe<Scalars["String"]["output"]>;
};

export type BirthInfoInput = {
  birthDate?: InputMaybe<Scalars["Date"]["input"]>;
  city?: InputMaybe<Scalars["String"]["input"]>;
  country?: InputMaybe<Scalars["CCA3"]["input"]>;
  postalCode?: InputMaybe<Scalars["String"]["input"]>;
};

export type BlacklistedPhoneNumberRejection = Rejection & {
  __typename: "BlacklistedPhoneNumberRejection";
  /** @deprecated Use 'BlocklistedPhoneNumberRejection' instead */
  message: Scalars["String"]["output"];
};

export type BlocklistedPhoneNumberRejection = Rejection & {
  __typename: "BlocklistedPhoneNumberRejection";
  message: Scalars["String"]["output"];
};

export type BookedBalanceAfter = {
  __typename: "BookedBalanceAfter";
  /** Balance value. Use this instead of `bookedBalanceAfter` */
  amount?: Maybe<Amount>;
  /** [COMING SOON] Sequence number assigned to each booked transaction. It increments by 1 with every new transaction affecting the account's booked balance, ensuring a chronological record */
  sequenceNumber?: Maybe<Scalars["Int"]["output"]>;
};

/** Booked transaction status information */
export type BookedTransactionStatusInfo = TransactionStatusInfo & {
  __typename: "BookedTransactionStatusInfo";
  /** Information of the balance after the transaction is booked */
  balanceAfter: BookedBalanceAfter;
  /** The Date when the transaction is posted to an account on the Swan books. */
  bookingDate: Scalars["DateTime"]["output"];
  /** unique identifier of the transaction */
  id: Scalars["ID"]["output"];
  /** status of the transaction */
  status: TransactionStatus;
  /** The Date when the transaction is considered effective in accounting */
  valueDate: Scalars["DateTime"]["output"];
};

/** Business activity. */
export type BusinessActivity =
  | "AdministrativeServices"
  | "Agriculture"
  | "Arts"
  | "BusinessAndRetail"
  | "Construction"
  | "Education"
  | "ElectricalDistributionAndWaterSupply"
  | "FinancialAndInsuranceOperations"
  | "Health"
  | "Housekeeping"
  | "InformationAndCommunication"
  | "LodgingAndFoodServices"
  | "ManufacturingAndMining"
  | "Other"
  | "PublicAdministration"
  | "RealEstate"
  | "ScientificActivities"
  | "Transportation";

export type CalledByABotRejection = Rejection & {
  __typename: "CalledByABotRejection";
  message: Scalars["String"]["output"];
};

export type CancelCapitalDepositCaseInput = {
  id: Scalars["ID"]["input"];
};

export type CancelCapitalDepositCasePayload =
  | CancelCapitalDepositCaseSuccessPayload
  | CapitalDepositCaseCanNotBeCanceledRejection
  | CapitalDepositCaseCanNotBeFoundRejection
  | ForbiddenRejection
  | InternalErrorRejection;

export type CancelCapitalDepositCaseSuccessPayload = {
  __typename: "CancelCapitalDepositCaseSuccessPayload";
  capitalDepositCase?: Maybe<CapitalDepositCase>;
};

/** Inputs to cancel a card */
export type CancelCardInput = {
  /** Unique identifier of a card */
  cardId: Scalars["ID"]["input"];
};

export type CancelCardPayload =
  | AccountMembershipNotAllowedRejection
  | CancelCardSuccessPayload
  | CardNotFoundRejection
  | ForbiddenRejection
  | ValidationRejection;

export type CancelCardSuccessPayload = {
  __typename: "CancelCardSuccessPayload";
  /** The canceled card */
  card: Card;
};

/** Input of the `cancelConsent` mutation */
export type CancelConsentInput = {
  consentId: Scalars["ID"]["input"];
};

/** Payload of the `cancelConsent` mutation */
export type CancelConsentPayload =
  | CancelConsentSuccessPayload
  | ConsentNotFoundRejection
  | NotReachableConsentStatusRejection;

/** Success payload of the `cancelConsent` mutation */
export type CancelConsentSuccessPayload = {
  __typename: "CancelConsentSuccessPayload";
  consent: Consent;
};

/** Inputs to cancel a digital card */
export type CancelDigitalCardInput = {
  /** Unique identifier of a digital card */
  digitalCardId: Scalars["ID"]["input"];
};

export type CancelDigitalCardPayload =
  | AccountMembershipNotAllowedRejection
  | CancelDigitalCardSuccessPayload
  | CardNotFoundRejection
  | DigitalCardNotFoundRejection
  | ForbiddenRejection
  | ValidationRejection;

export type CancelDigitalCardSuccessPayload = {
  __typename: "CancelDigitalCardSuccessPayload";
  /** The canceled digital card */
  digitalCard: DigitalCard;
};

/** Cancel Funding Source Input */
export type CancelFundingSourceInput = {
  /** ID of the funding source to cancel */
  id: Scalars["ID"]["input"];
};

/** Cancel Funding Source Payload */
export type CancelFundingSourcePayload =
  | CancelFundingSourceSuccessPayload
  | ForbiddenRejection
  | NotFoundRejection;

/** Cancel Funding Source Success Payload */
export type CancelFundingSourceSuccessPayload = {
  __typename: "CancelFundingSourceSuccessPayload";
  /** Canceled Funding Source */
  fundingSource?: Maybe<FundingSource>;
};

export type CancelMerchantPaymentInput = {
  /** Amount to cancel from the Merchant Payment (Not available for SDD) */
  amount?: InputMaybe<AmountInput>;
  /** ID of the Merchant Payment */
  merchantPaymentId: Scalars["ID"]["input"];
};

export type CancelMerchantPaymentMethodUpdateRequestInput = {
  /** ID of the MerchantPaymentMethod update request */
  requestUpdateId: Scalars["ID"]["input"];
};

export type CancelMerchantPaymentMethodUpdateRequestPayload =
  | CancelMerchantPaymentMethodUpdateRequestSuccessPayload
  | ForbiddenRejection
  | InternalErrorRejection
  | NotFoundRejection
  | UpdateRequestNotPendingReviewRejection;

export type CancelMerchantPaymentMethodUpdateRequestSuccessPayload = {
  __typename: "CancelMerchantPaymentMethodUpdateRequestSuccessPayload";
  requestUpdateId?: Maybe<Scalars["ID"]["output"]>;
};

export type CancelMerchantPaymentPayload =
  | CancelMerchantPaymentSuccessPayload
  | ForbiddenRejection
  | InternalErrorRejection
  | MerchantPaymentMethodNotCompatibleRejection
  | MerchantPaymentNotCancellableRejection
  | MerchantPaymentNotFoundRejection
  | MerchantPaymentNotPartiallyCancellableRejection
  | ValidationRejection;

export type CancelMerchantPaymentSuccessPayload = {
  __typename: "CancelMerchantPaymentSuccessPayload";
  merchantPayment: MerchantPayment;
};

export type CancelMerchantProfileUpdateRequestInput = {
  /** ID of the MerchantProfile update request */
  requestUpdateId: Scalars["ID"]["input"];
};

export type CancelMerchantProfileUpdateRequestPayload =
  | CancelMerchantProfileUpdateRequestSuccessPayload
  | ForbiddenRejection
  | InternalErrorRejection
  | NotFoundRejection
  | UpdateRequestNotPendingReviewRejection;

export type CancelMerchantProfileUpdateRequestSuccessPayload = {
  __typename: "CancelMerchantProfileUpdateRequestSuccessPayload";
  requestUpdateId?: Maybe<Scalars["ID"]["output"]>;
};

/** Inputs to cancel a physical card */
export type CancelPhysicalCardInput = {
  /** Unique identifier of a card */
  cardId: Scalars["ID"]["input"];
  /** Reason why the physical card is canceled */
  reason: CancelPhysicalCardReason;
};

export type CancelPhysicalCardPayload =
  | AccountMembershipNotAllowedRejection
  | CancelPhysicalCardSuccessPayload
  | CardNotFoundRejection
  | ForbiddenRejection
  | PhysicalCardNotFoundRejection
  | ValidationRejection;

/** reason why the physical card is canceled */
export type CancelPhysicalCardReason =
  /** When the cardholder wants to block his card */
  | "Blocked"
  /** When the card doesn't work anymore */
  | "Defected"
  /** When the card has been stolen */
  | "Lost"
  /** When the cardholder never received the card */
  | "NonReceived"
  /** When the card has been stolen */
  | "Stolen";

export type CancelPhysicalCardSuccessPayload = {
  __typename: "CancelPhysicalCardSuccessPayload";
  /** The canceled physical card */
  physicalCard: PhysicalCard;
};

export type CancelStandingOrderInput = {
  standingOrderId: Scalars["String"]["input"];
};

export type CancelStandingOrderPayload =
  | CancelStandingOrderSuccessPayload
  | ForbiddenRejection
  | InternalErrorRejection
  | StandingOrderNotFoundRejection;

export type CancelStandingOrderSuccessPayload = {
  __typename: "CancelStandingOrderSuccessPayload";
  standingOrder: StandingOrder;
};

/** Cancel transaction */
export type CancelTransactionInput = {
  /** transaction ID to cancel */
  transactionId: Scalars["ID"]["input"];
};

export type CancelTransactionPayload = CancelTransactionSuccessPayload | ForbiddenRejection;

export type CancelTransactionSuccessPayload = {
  __typename: "CancelTransactionSuccessPayload";
  message: Scalars["String"]["output"];
};

export type CancelVirtualIbanEntryInput = {
  virtualIbanEntryId: Scalars["ID"]["input"];
};

export type CancelVirtualIbanEntryPayload =
  | AccountNotFoundRejection
  | BadAccountStatusRejection
  | CancelVirtualIbanEntrySuccessPayload
  | IbanEntryNotFoundRejection
  | InternalErrorRejection
  | ValidationRejection;

export type CancelVirtualIbanEntrySuccessPayload = {
  __typename: "CancelVirtualIbanEntrySuccessPayload";
  virtualIbanEntry: VirtualIbanEntry;
};

/** Funding Source Canceled Reason */
export type CanceledFundingSourceReason =
  /** Underlying mandate has been canceled */
  | "MandateCanceled"
  /** Underlying mandate has expired */
  | "MandateExpired"
  /** User has canceled his funding source */
  | "UserCanceled";

/** Funding Source Canceled status information */
export type CanceledFundingSourceStatusInfo = FundingSourceStatusInfo & {
  __typename: "CanceledFundingSourceStatusInfo";
  /** Date at which the funding source was canceled */
  canceledAt: Scalars["Date"]["output"];
  /** Date at which the funding source was enabled */
  enabledAt?: Maybe<Scalars["Date"]["output"]>;
  /** Reason code of the cancellation */
  reasonCode: CanceledFundingSourceReason;
  /** Funding Source Canceled status */
  status: FundingSourceStatus;
};

/** Describes an identification level for the process associated to this identification that has been cancelled by the end-user */
export type CanceledIdentificationLevelStatusInfo = {
  __typename: "CanceledIdentificationLevelStatusInfo";
  /** Always set to `Cancelled` */
  status: SwanIdentificationStatus;
};

/** Canceled transaction status information */
export type CanceledTransactionStatusInfo = TransactionStatusInfo & {
  __typename: "CanceledTransactionStatusInfo";
  /** The date when the transaction was canceled */
  canceledDate?: Maybe<Scalars["DateTime"]["output"]>;
  /** unique identifier of the transaction */
  id: Scalars["ID"]["output"];
  /** status of the transaction */
  status: TransactionStatus;
};

/** Rejection returned when the Physical Card cannot be activated */
export type CannotActivatePhysicalCardRejection = Rejection & {
  __typename: "CannotActivatePhysicalCardRejection";
  identifier: Scalars["String"]["output"];
  message: Scalars["String"]["output"];
};

/** Capital deposit case for a company. */
export type CapitalDepositCase = {
  __typename: "CapitalDepositCase";
  /** Unique identifier of the company account. */
  companyAccountId?: Maybe<Scalars["String"]["output"]>;
  /** Name of the company. */
  companyName: Scalars["String"]["output"];
  /** Onboarding information of the company. */
  companyOnboarding?: Maybe<Onboarding>;
  /** Created date */
  createdAt: Scalars["DateTime"]["output"];
  /** Documents to provide to fulfill the capital deposit case. */
  documents: Array<CapitalDepositDocument>;
  /** Unique identifier of a capital deposit case. */
  id: Scalars["String"]["output"];
  /** List of the company’s shareholders. */
  shareholders: Array<Shareholder>;
  /**
   * Status of the capital deposit case.
   * @deprecated(reason: "use `statusInfo` instead")
   * @deprecated use `statusInfo` instead
   */
  status: CapitalDepositCaseStatus;
  /** Capital deposit case status information. */
  statusInfo: CapitalDepositCaseStatusInfo;
  /** Amount of the capital deposit. */
  totalCapitalDepositAmount: Amount;
  /** Updated date */
  updatedAt: Scalars["DateTime"]["output"];
};

/** Rejection returned if the capital deposit case cannot be canceled in its current state */
export type CapitalDepositCaseCanNotBeCanceledRejection = Rejection & {
  __typename: "CapitalDepositCaseCanNotBeCanceledRejection";
  id: Scalars["String"]["output"];
  message: Scalars["String"]["output"];
};

/** Rejection returned if the capital deposit case cannot be found */
export type CapitalDepositCaseCanNotBeFoundRejection = Rejection & {
  __typename: "CapitalDepositCaseCanNotBeFoundRejection";
  id: Scalars["String"]["output"];
  message: Scalars["String"]["output"];
};

/** Rejection returned if the capital deposit case cannot be updated */
export type CapitalDepositCaseCanNotBeUpdatedRejection = Rejection & {
  __typename: "CapitalDepositCaseCanNotBeUpdatedRejection";
  id: Scalars["String"]["output"];
  message: Scalars["String"]["output"];
};

export type CapitalDepositCaseCanceledStatusInfo = CapitalDepositCaseStatusInfo & {
  __typename: "CapitalDepositCaseCanceledStatusInfo";
  /** Canceled */
  status: CapitalDepositStatus;
};

/** Rejection returned if the capital deposit case's company cannot be updated */
export type CapitalDepositCaseCompanyCannotBeUpdatedRejection = Rejection & {
  __typename: "CapitalDepositCaseCompanyCannotBeUpdatedRejection";
  id: Scalars["String"]["output"];
  message: Scalars["String"]["output"];
};

export type CapitalDepositCaseCompletedStatusInfo = CapitalDepositCaseStatusInfo & {
  __typename: "CapitalDepositCaseCompletedStatusInfo";
  /** Completed */
  status: CapitalDepositStatus;
};

/** Implements the Relay Connection interface, used to paginate list of elements ([Learn More](https://docs.swan.io/api/pagination)) */
export type CapitalDepositCaseConnection = Connection & {
  __typename: "CapitalDepositCaseConnection";
  /** CapitalDepositCaseEdge list */
  edges: Array<CapitalDepositCaseEdge>;
  /** Information about the current, the previous and the next page */
  pageInfo: PageInfo;
  /** Total number of elements in the list */
  totalCount: Scalars["Int"]["output"];
};

/** Implements the Relay Edge interface */
export type CapitalDepositCaseEdge = Edge & {
  __typename: "CapitalDepositCaseEdge";
  /** Opaque identifier pointing to this capital deposit case node in the pagination mechanism */
  cursor: Scalars["String"]["output"];
  /** The CapitalDepositCase */
  node: CapitalDepositCase;
};

/** Filters that can be applied when listing capital deposit cases */
export type CapitalDepositCaseFiltersInput = {
  /**
   * Search string to look for
   *
   * Search will be performed in following fields:
   *  - Company shareholder's name
   *  - Individual shareholder's first name
   *  - Individual shareholder's last name
   *  - Company name
   *  - ID
   */
  search?: InputMaybe<Scalars["String"]["input"]>;
  /** Filter by statuses */
  statuses?: InputMaybe<Array<CapitalDepositStatus>>;
};

/** Field we can use when ordering that can be applied when listing capital deposit cases */
export type CapitalDepositCaseOrderByFieldInput = "createdAt" | "id" | "updatedAt";

/** Order that can be applied when listing capital deposit cases */
export type CapitalDepositCaseOrderByInput = {
  direction?: InputMaybe<OrderByDirection>;
  field?: InputMaybe<CapitalDepositCaseOrderByFieldInput>;
};

export type CapitalDepositCasePendingInternalReviewStatusInfo = CapitalDepositCaseStatusInfo & {
  __typename: "CapitalDepositCasePendingInternalReviewStatusInfo";
  /** PendingInternalReview */
  status: CapitalDepositStatus;
};

/**
 * Status of a capital deposit case.
 * @deprecated look for enum `CapitalDepositStatus` instead.
 */
export type CapitalDepositCaseStatus =
  /** The capital deposit case is canceled. */
  | "Canceled"
  /** The capital deposit case is completed. */
  | "Completed"
  /** Technical state when the mutation to create a new capital deposit case is called. */
  | "Initiated"
  /** Swan is waiting for the notary to wire the share capital on the account of the company being registered. */
  | "WaitingForNotaryTransfer"
  /** Swan is waiting for you to provide the Register Extract. */
  | "WaitingForRegisterExtract"
  /** A new capital deposit case is created and Swan is waiting for the required information to be provided and each shareholder to wire their share of share capital. */
  | "WaitingForRequirements"
  /** Swan is waiting for the notary to provide the Share Deposit Certificate. */
  | "WaitingForShareDepositCertificate";

export type CapitalDepositCaseStatusInfo = {
  /** Status of the capital deposit case. */
  status: CapitalDepositStatus;
};

export type CapitalDepositCaseWaitingForAdditionalInformationStatusInfo =
  CapitalDepositCaseStatusInfo & {
    __typename: "CapitalDepositCaseWaitingForAdditionalInformationStatusInfo";
    /** WaitingForAdditionalInformation */
    status: CapitalDepositStatus;
  };

export type CapitalDepositCaseWaitingForInitialRequirementsStatusInfo =
  CapitalDepositCaseStatusInfo & {
    __typename: "CapitalDepositCaseWaitingForInitialRequirementsStatusInfo";
    /** WaitingForInitialRequirements */
    status: CapitalDepositStatus;
  };

export type CapitalDepositCaseWaitingForNotaryShareDepositCertificateStatusInfo =
  CapitalDepositCaseStatusInfo & {
    __typename: "CapitalDepositCaseWaitingForNotaryShareDepositCertificateStatusInfo";
    /** WaitingForNotaryShareDepositCertificate */
    status: CapitalDepositStatus;
  };

export type CapitalDepositCaseWaitingForNotaryTransferStatusInfo = CapitalDepositCaseStatusInfo & {
  __typename: "CapitalDepositCaseWaitingForNotaryTransferStatusInfo";
  /** WaitingForNotaryTransfer */
  status: CapitalDepositStatus;
};

export type CapitalDepositCaseWaitingForRegisterExtractStatusInfo = CapitalDepositCaseStatusInfo & {
  __typename: "CapitalDepositCaseWaitingForRegisterExtractStatusInfo";
  /** WaitingForRegisterExtract */
  status: CapitalDepositStatus;
};

/** Document provided for a capital deposit case. */
export type CapitalDepositDocument = {
  __typename: "CapitalDepositDocument";
  /** Created date */
  createdAt: Scalars["DateTime"]["output"];
  /** Url to download the document, null if it has not already been uploaded. */
  downloadUrl?: Maybe<Scalars["String"]["output"]>;
  /** Unique identifier of a document. */
  id: Scalars["String"]["output"];
  /** Information about capital deposit case. */
  relatedCapitalDepositCase?: Maybe<CapitalDepositCase>;
  /** Information about shareholder. */
  relatedShareholder?: Maybe<Shareholder>;
  /**
   * Status of the document.
   * @deprecated use statusInfo.status
   */
  status: CapitalDepositDocumentStatus;
  /** Status info of the document. */
  statusInfo: CapitalDepositDocumentStatusInfo;
  /** Type of the document. */
  type: CapitalDepositDocumentType;
  /** Updated date */
  updatedAt: Scalars["DateTime"]["output"];
  /** Date when the last version of the document has been uploaded. */
  uploadedAt?: Maybe<Scalars["Date"]["output"]>;
};

/**
 * Rejection returned if the document from a capital deposit case cannot be uploaded in its context
 * @deprecated(reason: "use `CapitalDepositDocumentCanNotBeUploadedRejection` instead")
 */
export type CapitalDepositDocumentCanNotBeUploaded = Rejection & {
  __typename: "CapitalDepositDocumentCanNotBeUploaded";
  id: Scalars["String"]["output"];
  message: Scalars["String"]["output"];
};

/** Rejection returned if the document from a capital deposit case cannot be uploaded in its context */
export type CapitalDepositDocumentCanNotBeUploadedRejection = Rejection & {
  __typename: "CapitalDepositDocumentCanNotBeUploadedRejection";
  id: Scalars["String"]["output"];
  message: Scalars["String"]["output"];
};

/** Capital Deposit Document with Pending status */
export type CapitalDepositDocumentPendingStatusInfo = CapitalDepositDocumentStatusInfo & {
  __typename: "CapitalDepositDocumentPendingStatusInfo";
  /** Pending */
  status: CapitalDepositDocumentStatus;
};

/** Capital Deposit Document with Refused status */
export type CapitalDepositDocumentRefusedStatusInfo = CapitalDepositDocumentStatusInfo & {
  __typename: "CapitalDepositDocumentRefusedStatusInfo";
  /** Reason for the rejection. */
  reasonCode: DocumentReasonCode;
  /** Refused */
  status: CapitalDepositDocumentStatus;
};

/** Status of the Capital Deposit Case */
export type CapitalDepositDocumentStatus =
  /** Document is not uploaded yet. */
  | "Pending"
  /** Document has been refused by Swan, it must be uploaded again. */
  | "Refused"
  /** Document has been uploaded but not verified by Swan yet. */
  | "Uploaded"
  /** Document has been uploaded and verified by Swan. */
  | "Validated";

/** Status info of the document. */
export type CapitalDepositDocumentStatusInfo = {
  /** Status of the document. */
  status: CapitalDepositDocumentStatus;
};

/** Type of the document. */
export type CapitalDepositDocumentType =
  /** Legal document required for company’s formation. */
  | "ArticlesOfIncorporation"
  /** Created by the Notary, it certifies the capital of the company to have been deposited with the appropriate share for each shareholder. */
  | "CapitalShareDepositCertificate"
  /** Lease agreement in the name of the business or Proof of Individual Address if the company is hosted by one of the legal representative. */
  | "CompanyLeaseAgreement"
  /** Document submitted to your tax bureau at the end of the last business period. */
  | "CorporateIncomeTaxReturn"
  /** Signed power of attorney document to give the power to act on behalf. */
  | "PowerOfAttorney"
  /** Can be either passport, national id card or resident permit. */
  | "ProofOfIdentity"
  /** Can be a utility bill (water, electricity or gas), a telephone bill or a rental receipt. The document must have been issued within the last 3 months. */
  | "ProofOfIndividualAddress"
  /** Commercial registry extract issued within the last 3 months. */
  | "RegisterExtract";

/** Capital Deposit Document with Uploaded status */
export type CapitalDepositDocumentUploadedStatusInfo = CapitalDepositDocumentStatusInfo & {
  __typename: "CapitalDepositDocumentUploadedStatusInfo";
  /** Uploaded */
  status: CapitalDepositDocumentStatus;
};

/** Capital Deposit Document with Validated status */
export type CapitalDepositDocumentValidatedStatusInfo = CapitalDepositDocumentStatusInfo & {
  __typename: "CapitalDepositDocumentValidatedStatusInfo";
  /** Validated */
  status: CapitalDepositDocumentStatus;
};

/** Rejection returned if the shareholder cannot be updated in its current state */
export type CapitalDepositShareholderCanNotBeUpdatedRejection = Rejection & {
  __typename: "CapitalDepositShareholderCanNotBeUpdatedRejection";
  id: Scalars["String"]["output"];
  message: Scalars["String"]["output"];
};

/** Rejection returned if the shareholder cannot be found */
export type CapitalDepositShareholderCannotBeFoundRejection = Rejection & {
  __typename: "CapitalDepositShareholderCannotBeFoundRejection";
  id: Scalars["String"]["output"];
  message: Scalars["String"]["output"];
};

/** Status of a capital deposit case. */
export type CapitalDepositStatus =
  /** The case has been canceled upon request. A capital deposit can be canceled at any time before completion by contacting Swan Support. When canceled, the associated shareholder is also canceled. */
  | "Canceled"
  /** The notary has approved all documents and transferred the funds to the newly created company. The capital deposit process is complete. */
  | "Completed"
  /** Swan is reviewing the information and documents provided. */
  | "PendingInternalReview"
  /** After review, Swan has requested additional details or corrections from the customer and is awaiting their response. */
  | "WaitingForAdditionalInformation"
  /** The case has been initiated and is waiting for shareholder verification, fund transfers, document uploads, and completion of company onboarding. */
  | "WaitingForInitialRequirements"
  /** The notary is reviewing the deposited funds and documents, then preparing and uploading the share deposit certificate to Swan. */
  | "WaitingForNotaryShareDepositCertificate"
  /** The notary is reviewing the register extract. If the document is rejected by either Swan or the notary, the case will return to WaitingForRegisterExtract. */
  | "WaitingForNotaryTransfer"
  /** The company must upload its register extract for review by the notary. */
  | "WaitingForRegisterExtract";

/** Card */
export type Card = {
  __typename: "Card";
  /** Account membership to define the cardholder and the account linked to the card. */
  accountMembership: AccountMembership;
  /** Card expiration date  if `null` it does not have an expiration date */
  cardContractExpiryDate?: Maybe<Scalars["DateTime"]["output"]>;
  /** URL of the card design */
  cardDesignUrl: Scalars["String"]["output"];
  /** Masked Card Number */
  cardMaskedNumber: Scalars["String"]["output"];
  /** Card product */
  cardProduct: CardProduct;
  /**
   * URL of the card with masked card information (like its number) and with full card information if connected user consented beforehand
   * @deprecated Use cardMaskedNumber, expiryDate and cardDesignUrl to recreate the content of this page
   */
  cardUrl: Scalars["String"]["output"];
  /** Created date */
  createdAt: Scalars["DateTime"]["output"];
  /** Digital Cards linked to this card */
  digitalCards: DigitalCardConnection;
  /** `true` if this card allows transactions at eCommerce sites */
  eCommerce: Scalars["Boolean"]["output"];
  /** Card expiry date with MM/YY format */
  expiryDate?: Maybe<Scalars["String"]["output"]>;
  /** Unique identifier of a card */
  id: Scalars["ID"]["output"];
  /** Card insurance subscription */
  insuranceSubscription?: Maybe<CardInsuranceSubscription>;
  /** `true` if this card allows payments outside of the country */
  international: Scalars["Boolean"]["output"];
  /** Issuing Country */
  issuingCountry: Scalars["CCA3"]["output"];
  /** Main Currency */
  mainCurrency: Scalars["Currency"]["output"];
  /** Card name */
  name?: Maybe<Scalars["String"]["output"]>;
  /** `true` if this card allows transactions outside of the card's main currency */
  nonMainCurrencyTransactions: Scalars["Boolean"]["output"];
  /** Physical card if the cardholder has ordered one */
  physicalCard?: Maybe<PhysicalCard>;
  /** Periodic Spending */
  spending?: Maybe<Spending>;
  /** Periodic Spending limit list */
  spendingLimits?: Maybe<Array<SpendingLimit>>;
  /** Card status information */
  statusInfo: CardStatusInfo;
  /**
   * List of transactions of a card.
   *
   * Implements the Relay Connection interface, used to paginate lists of elements. ([Learn More](https://docs.swan.io/developers/using-api/pagination))
   */
  transactions?: Maybe<TransactionConnection>;
  /** Type of a card */
  type: CardType;
  /** Updated date */
  updatedAt: Scalars["DateTime"]["output"];
  /** `true` if this card allows cash withdrawals */
  withdrawal: Scalars["Boolean"]["output"];
};

/** Card */
export type CardDigitalCardsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  filters?: InputMaybe<DigitalCardFiltersInput>;
  first?: Scalars["Int"]["input"];
  orderBy?: InputMaybe<DigitalCardOrderByInput>;
};

/** Card */
export type CardTransactionsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  filters?: InputMaybe<TransactionsFiltersInput>;
  first?: Scalars["Int"]["input"];
  orderBy?: InputMaybe<TransactionsOrderByInput>;
};

export type CardAuthorizationType = "Classic" | "DataRequest" | "PreAuthorization";

/** Rejection returned if the card could not be digitalized */
export type CardCanNotBeDigitalizedRejection = Rejection & {
  __typename: "CardCanNotBeDigitalizedRejection";
  id: Scalars["String"]["output"];
  message: Scalars["String"]["output"];
};

/** Card Canceled Status Information */
export type CardCanceledStatusInfo = CardStatusInfo & {
  __typename: "CardCanceledStatusInfo";
  /** Reason why the card is canceled */
  reason: Scalars["String"]["output"];
  /** Card status (always Canceled for type CardCanceledStatusInfo). */
  status: CardStatus;
};

/** Card Canceling Status Information */
export type CardCancelingStatusInfo = CardStatusInfo & {
  __typename: "CardCancelingStatusInfo";
  /** Reason why the card is about to be canceled. */
  reason: Scalars["String"]["output"];
  /** Card status (always Canceling for type CardCancelingStatusInfo). */
  status: CardStatus;
};

export type CardConfidential = {
  __typename: "CardConfidential";
  /** Card verification value */
  cvv: Scalars["String"]["output"];
  /** Expiration date */
  expiryDate: Scalars["String"]["output"];
  /** Card number */
  pan: Scalars["String"]["output"];
};

export type CardConfigInput = {
  /** Unique identifier of a given account membership */
  accountMembershipId: Scalars["ID"]["input"];
  /** Card expiration date  if `null` it does not have an expiration date */
  cardContractExpiryDate?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** `true` if this card allows transactions at eCommerce sites */
  eCommerce: Scalars["Boolean"]["input"];
  /** `true` if this card allows payments outside of the country */
  international: Scalars["Boolean"]["input"];
  /** Card name */
  name?: InputMaybe<Scalars["String"]["input"]>;
  /** `true` if this card allows transactions outside of the card's main currency */
  nonMainCurrencyTransactions: Scalars["Boolean"]["input"];
  /** If used a physical card will be printed and sent to the given address */
  physicalCard?: InputMaybe<PhysicalCardConfigInput>;
  /** Spending limit */
  spendingLimit: SpendingLimitInput;
  /** `true` if this card allows cash withdrawals */
  withdrawal: Scalars["Boolean"]["input"];
};

export type CardConfigWithGroupDeliveryInput = {
  /** Unique identifier of a given account membership */
  accountMembershipId: Scalars["ID"]["input"];
  /** Card expiration date  if `null` it does not have an expiration date */
  cardContractExpiryDate?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** `true` if this card allows transactions at eCommerce sites */
  eCommerce: Scalars["Boolean"]["input"];
  /** `true` if this card allows payments outside of the country */
  international: Scalars["Boolean"]["input"];
  /** Card name */
  name?: InputMaybe<Scalars["String"]["input"]>;
  /** `true` if this card allows transactions outside of the card's main currency */
  nonMainCurrencyTransactions: Scalars["Boolean"]["input"];
  /** Custom options to use for physical cards. */
  physicalCardCustomOptions?: InputMaybe<PhysicalCardCustomOptionsForGroupDeliveryInput>;
  /** `true` when you wish for print an associated physical card */
  printPhysicalCard: Scalars["Boolean"]["input"];
  /** Spending limit */
  spendingLimit: SpendingLimitInput;
  /** `true` if this card allows cash withdrawals */
  withdrawal: Scalars["Boolean"]["input"];
};

/** Implements the Relay Connection interface, used to paginate lists of elements. ([Learn More](https://docs.swan.io/developers/using-api/pagination)) */
export type CardConnection = Connection & {
  __typename: "CardConnection";
  /** CardEdge list */
  edges: Array<CardEdge>;
  /** Information about the current, the previous and the next page */
  pageInfo: PageInfo;
  /** Total number of element in the list */
  totalCount: Scalars["Int"]["output"];
};

/** when the user has to consent to add this card */
export type CardConsentPendingStatusInfo = CardStatusInfo & {
  __typename: "CardConsentPendingStatusInfo";
  /** The consent required to add this card */
  consent: Consent;
  /** Card status (always ConsentPending for type CardConsentPendingStatusInfo) */
  status: CardStatus;
};

export type CardDesignBackground = {
  __typename: "CardDesignBackground";
  /** Card design background url */
  cardBackgroundUrl: Scalars["String"]["output"];
  /** Card design background text color */
  cardTextColor: Scalars["String"]["output"];
  /** Created date */
  createdAt: Scalars["DateTime"]["output"];
  /** Unique identifier of a project card design background */
  id: Scalars["ID"]["output"];
  /** Card design background name */
  name: Scalars["String"]["output"];
  /** Card design background type */
  type: Scalars["String"]["output"];
  /** Updated date */
  updatedAt: Scalars["DateTime"]["output"];
};

/** Project Card Design Background Type */
export type CardDesignBackgroundType =
  /** when Card design background is black */
  | "Black"
  /** when Card design background is customized */
  | "Custom"
  /** when Card design background is light */
  | "Silver";

/** Card designs Status */
export type CardDesignStatus =
  /** when card design are Disabled */
  | "Disabled"
  /** when card design are in Draft */
  | "Draft"
  /** when card design are Enabled */
  | "Enabled"
  /** when card design are ToReview */
  | "ToReview";

export type CardDetails = CardInDetails | CardOutDetails;

/** Implements the Relay Edge interface */
export type CardEdge = Edge & {
  __typename: "CardEdge";
  /** Opaque identifier pointing to this node in the pagination mechanism */
  cursor: Scalars["String"]["output"];
  /** The Card entry */
  node: Card;
};

/** Card Enabled Status Information */
export type CardEnabledStatusInfo = CardStatusInfo & {
  __typename: "CardEnabledStatusInfo";
  /** Card status (always Enabled for type CardEnabledStatusInfo). */
  status: CardStatus;
};

/** Filters that can be applied when listing cards */
export type CardFiltersInput = {
  /** Filter by accountId */
  accountId?: InputMaybe<Scalars["String"]["input"]>;
  /**
   * Search string to look for
   *
   * Search will be performed in following fields:
   *  - Embossed line
   *  - Card masked number
   *  - Name
   *  - ID
   */
  search?: InputMaybe<Scalars["String"]["input"]>;
  /**
   * Filter by status
   *
   * @deprecated(reason: "use filter `statuses` instead")
   */
  status?: InputMaybe<CardStatus>;
  /** Filter by status */
  statuses?: InputMaybe<Array<CardStatus>>;
  /**
   * Filter by type
   *
   * @deprecated(reason: "use filter `types` instead")
   */
  type?: InputMaybe<CardType>;
  /** Filter by type */
  types?: InputMaybe<Array<CardType>>;
  /**
   * Filter by User ID
   *
   * Only usable on Cards query
   */
  userId?: InputMaybe<Scalars["String"]["input"]>;
};

export type CardFundingType =
  /** Default funding type for cards */
  | "Debit"
  /** Credit funding type for cards */
  | "DeferredDebit";

export type CardInDetails = {
  __typename: "CardInDetails";
  /** payment mandate used for this transaction */
  paymentMandate: CardPaymentMandate;
};

export type CardInMerchant = {
  __typename: "CardInMerchant";
  /** MerchantProfile */
  merchantProfile: MerchantProfile;
};

export type CardInsuranceConfiguration = {
  __typename: "CardInsuranceConfiguration";
  availableInsurancePackages?: Maybe<Array<CardInsurancePackage>>;
  defaultInsurancePackage?: Maybe<CardInsurancePackage>;
};

export type CardInsurancePackage = {
  __typename: "CardInsurancePackage";
  id: Scalars["ID"]["output"];
  level: CardInsurancePackageLevel;
  name: Scalars["String"]["output"];
  noticeUrl?: Maybe<Scalars["String"]["output"]>;
};

export type CardInsurancePackageLevel = "Basic" | "Custom" | "Essential" | "Premium";

export type CardInsuranceSubscription = {
  __typename: "CardInsuranceSubscription";
  claimsUrl: Scalars["String"]["output"];
  createdAt: Scalars["DateTime"]["output"];
  id: Scalars["ID"]["output"];
  package: CardInsurancePackage;
  statusInfo: CardInsuranceSubscriptionStatusInfo;
  updatedAt: Scalars["DateTime"]["output"];
};

export type CardInsuranceSubscriptionCanceledStatusInfo = CardInsuranceSubscriptionStatusInfo & {
  __typename: "CardInsuranceSubscriptionCanceledStatusInfo";
  canceledAt: Scalars["DateTime"]["output"];
  status: CardInsuranceSubscriptionStatus;
};

export type CardInsuranceSubscriptionEnabledStatusInfo = CardInsuranceSubscriptionStatusInfo & {
  __typename: "CardInsuranceSubscriptionEnabledStatusInfo";
  enabledAt: Scalars["DateTime"]["output"];
  status: CardInsuranceSubscriptionStatus;
};

export type CardInsuranceSubscriptionPendingStatusInfo = CardInsuranceSubscriptionStatusInfo & {
  __typename: "CardInsuranceSubscriptionPendingStatusInfo";
  status: CardInsuranceSubscriptionStatus;
};

export type CardInsuranceSubscriptionProcessingStatusInfo = CardInsuranceSubscriptionStatusInfo & {
  __typename: "CardInsuranceSubscriptionProcessingStatusInfo";
  processingStartedAt: Scalars["DateTime"]["output"];
  status: CardInsuranceSubscriptionStatus;
};

export type CardInsuranceSubscriptionStatus = "Canceled" | "Enabled" | "Pending" | "Processing";

export type CardInsuranceSubscriptionStatusInfo = {
  status: CardInsuranceSubscriptionStatus;
};

export type CardMerchant = CardInMerchant | CardOutMerchant;

export type CardMerchantPayment = MerchantPayment & {
  __typename: "CardMerchantPayment";
  /** amount */
  amount: Amount;
  /**
   * Authorized date
   * @deprecated use authorizedAt in statusInfo instead
   */
  authorizedAt?: Maybe<Scalars["DateTime"]["output"]>;
  balance: MerchantBalance;
  /** The billing address associated to the payment */
  billingAddress?: Maybe<Address>;
  /**
   * Canceled date
   * @deprecated use canceledAt in statusInfo instead
   */
  canceledAt?: Maybe<Scalars["DateTime"]["output"]>;
  /**
   * Captured date
   * @deprecated use capturedAt in statusInfo instead
   */
  capturedAt?: Maybe<Scalars["DateTime"]["output"]>;
  /**
   * Created date
   * @deprecated use createdAt in statusInfo instead
   */
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  /**
   * Disputed date
   * @deprecated use disputedAt in statusInfo instead
   */
  disputedAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** an arbitrary identifier that was defined by you when you created this payment */
  externalReference?: Maybe<Scalars["String"]["output"]>;
  /** unique identifier of a merchant payment */
  id: Scalars["ID"]["output"];
  /** Label */
  label?: Maybe<Scalars["String"]["output"]>;
  /** merchant profile associated to the merchant payment */
  merchantProfile: MerchantProfile;
  /** payment link associated to the merchant payment */
  paymentLink?: Maybe<MerchantPaymentLink>;
  /** payment link associated to the merchant payment */
  paymentMandate: PaymentMandate;
  /** payment method associated to the merchant payment */
  paymentMethod: MerchantPaymentMethod;
  reference?: Maybe<Scalars["String"]["output"]>;
  /**
   * Refunded date
   * @deprecated use refundedAt in statusInfo instead
   */
  refundedAt?: Maybe<Scalars["DateTime"]["output"]>;
  /**
   * Rejected date
   * @deprecated use rejectedAt in statusInfo instead
   */
  rejectedAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** status information */
  statusInfo: MerchantPaymentStatusInfo;
  threeDs?: Maybe<ThreeDs>;
  /**
   * List of transactions associated with the Merchant Payment.
   *
   * Implements the Relay Connection interface, used to paginate lists of elements. ([Learn More](https://docs.swan.io/developers/using-api/pagination))
   */
  transactions?: Maybe<TransactionConnection>;
  /** Updated date */
  updatedAt: Scalars["DateTime"]["output"];
};

export type CardMerchantPaymentTransactionsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  filters?: InputMaybe<TransactionsFiltersInput>;
  first?: Scalars["Int"]["input"];
  orderBy?: InputMaybe<TransactionsOrderByInput>;
};

/** COMING SOON */
export type CardMerchantPaymentMethod = MerchantPaymentMethod & {
  __typename: "CardMerchantPaymentMethod";
  /** Date at which the Merchant Payment Method was created */
  createdAt: Scalars["Date"]["output"];
  /** Unique identifier tied to every version of a given Merchant Payment Method */
  id: Scalars["ID"]["output"];
  /** Merchant Profile to which the Payment Method is attached */
  merchantProfile: MerchantProfile;
  /** Unique identifier for a given merchant Payment Method, identical for every version of a given Merchant Payment Method Type */
  methodId: Scalars["ID"]["output"];
  /** The Merchant Payment Method payment amount limit */
  paymentAmountLimit?: Maybe<Amount>;
  /**
   * Reason of rejection when the status is Rejected
   * @deprecated Use statusInfo.rejectionReason instead
   */
  rejectReason?: Maybe<MerchantPaymentMethodCardRejectReason>;
  /** Rolling Reserve applied to the Merchant Payment Method */
  rollingReserve?: Maybe<RollingReserve>;
  /** Status of the Merchant Payment Method */
  statusInfo: MerchantPaymentMethodStatusInfo;
  /** The Merchant Payment Method Type */
  type: MerchantPaymentMethodType;
  /** Date at which the Merchant Payment Method was last updated */
  updatedAt: Scalars["Date"]["output"];
  /** Version of the Merchant Payment Method */
  version: Scalars["Int"]["output"];
};

/** Rejection returned if the card was not found or if the user does not have the rights to know that the account exists */
export type CardNotFoundRejection = Rejection & {
  __typename: "CardNotFoundRejection";
  id: Scalars["String"]["output"];
  message: Scalars["String"]["output"];
};

/** Field we can use when ordering that can be applied when listing cards */
export type CardOrderByFieldInput = "createdAt" | "id" | "updatedAt";

/** Order that can be applied when listing cards */
export type CardOrderByInput = {
  direction?: InputMaybe<OrderByDirection>;
  field?: InputMaybe<CardOrderByFieldInput>;
};

export type CardOutDetails = {
  __typename: "CardOutDetails";
  /** card used for this transaction */
  card?: Maybe<Card>;
  /** card numbers masked (Primary Account Number) */
  maskedPan: Scalars["String"]["output"];
};

export type CardOutMerchant = {
  __typename: "CardOutMerchant";
  /** category of the payment flow */
  category: Category;
  /** merchant acquirer id */
  merchantAcquirerId?: Maybe<Scalars["String"]["output"]>;
  /** merchant category code (MCC) */
  merchantCategoryCode: Scalars["String"]["output"];
  /**
   * merchant category description
   * Enum that explains what the MCC corresponds to in a more readable way
   */
  merchantCategoryDescription: MerchantCategoryDescription;
  /** merchant city */
  merchantCity: Scalars["String"]["output"];
  /** merchant country */
  merchantCountry?: Maybe<Scalars["CCA3"]["output"]>;
  /** unique identifier of the merchant */
  merchantId: Scalars["String"]["output"];
  /** merchant name */
  merchantName: Scalars["String"]["output"];
  /** merchant postal code */
  merchantPostalCode?: Maybe<Scalars["String"]["output"]>;
  /** sub merchant id */
  subMerchantId?: Maybe<Scalars["String"]["output"]>;
};

export type CardPackageLevel = "Essential" | "Premium" | "Standard";

export type CardPaymentMandate = PaymentMandate & {
  __typename: "CardPaymentMandate";
  /** Account Holder information */
  accountHolder: AccountHolder;
  /** The card associated to this mandate */
  card: ExternalCard;
  /** Creation date of the Payment Mandate */
  createdAt: Scalars["DateTime"]["output"];
  /** Date of the the last transaction executed for the concerned Payment Mandate */
  executedAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** Expiry date of the Payment Mandate */
  expiredAt?: Maybe<Scalars["Date"]["output"]>;
  /** Unique identifier of the Payment Mandate */
  id: Scalars["ID"]["output"];
  /** Custom name of the mandate */
  name?: Maybe<Scalars["String"]["output"]>;
  /** Payment Mandate status information */
  statusInfo: PaymentMandateStatusInfo;
  /**
   * List of transactions associated with the Card Mandate.
   *
   * Implements the Relay Connection interface, used to paginate lists of elements. ([Learn More](https://docs.swan.io/developers/using-api/pagination))
   */
  transactions?: Maybe<TransactionConnection>;
  /** Last Update date of the Payment Mandate */
  updatedAt: Scalars["DateTime"]["output"];
};

export type CardPaymentMandateTransactionsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  filters?: InputMaybe<TransactionsFiltersInput>;
  first?: Scalars["Int"]["input"];
  orderBy?: InputMaybe<TransactionsOrderByInput>;
};

export type CardPaymentMandateCategory = "Commercial" | "Consumer";

export type CardPaymentMandateScheme =
  | "AmericanExpress"
  | "CartesBancaires"
  | "Mastercard"
  | "Other"
  | "Visa";

export type CardPaymentMandateType = "Charge" | "Credit" | "Debit" | "Deferred" | "Prepaid";

export type CardPaymentMethodInput = {
  /** Determine whether the payment method must be activated or not */
  activate?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** Location where the card should be printed from */
export type CardPrintingHub = "France" | "Spain";

/** when the card is in the process of being ready to use */
export type CardProcessingStatusInfo = CardStatusInfo & {
  __typename: "CardProcessingStatusInfo";
  /** Card status (always Processing for type CardProcessingStatusInfo) */
  status: CardStatus;
};

/** Card Product */
export type CardProduct = {
  __typename: "CardProduct";
  applicableToPhysicalCards: Scalars["Boolean"]["output"];
  cardDesigns: Array<CardProductDesign>;
  cardPackage?: Maybe<CardPackageLevel>;
  /** Card printing available shipping providers */
  cardPrintingAvailableShippingProviders: Array<ShippingProvider>;
  /** Card printing hub */
  cardPrintingHub?: Maybe<CardPrintingHub>;
  companySpendingLimit: SpendingLimit;
  createdAt: Scalars["DateTime"]["output"];
  defaultCardProduct: Scalars["Boolean"]["output"];
  fundingType: CardProductFundingType;
  id: Scalars["ID"]["output"];
  individualSpendingLimit: SpendingLimit;
  insurance?: Maybe<CardInsuranceConfiguration>;
  name?: Maybe<Scalars["String"]["output"]>;
  projectId: Scalars["ID"]["output"];
  status: CardProductStatus;
  updatedAt: Scalars["DateTime"]["output"];
};

/** Card Product */
export type CardProductCardPrintingAvailableShippingProvidersArgs = {
  shippingAddressCountry: Scalars["CCA3"]["input"];
};

/** Card design of a Card Product */
export type CardProductDesign = {
  __typename: "CardProductDesign";
  /** Accent color */
  accentColor: Scalars["String"]["output"];
  /** Card Background of the Card design */
  cardBackground: CardDesignBackground;
  /** Card Design URL */
  cardDesignUrl?: Maybe<Scalars["String"]["output"]>;
  /** Logo url 300 dpi */
  cardProjectLogo300dpiUrl?: Maybe<Scalars["String"]["output"]>;
  /** Logo url 300 dpi */
  cardProjectLogo600dpiUrl?: Maybe<Scalars["String"]["output"]>;
  /** Logo url svg */
  cardProjectLogoSvgUrl?: Maybe<Scalars["String"]["output"]>;
  /** Created date */
  createdAt: Scalars["DateTime"]["output"];
  /** Unique identifier of a card design */
  id: Scalars["ID"]["output"];
  /** Status of the card design */
  status: CardDesignStatus;
  /** Updated date */
  updatedAt: Scalars["DateTime"]["output"];
  /** Design version */
  version: Scalars["Int"]["output"];
  /** Zoom level */
  zoomRatioProjectLogo?: Maybe<Scalars["Int"]["output"]>;
};

/** Rejection returned if the card product is disabled. */
export type CardProductDisabledRejection = Rejection & {
  __typename: "CardProductDisabledRejection";
  message: Scalars["String"]["output"];
};

export type CardProductFundingType =
  /** Debit card product, associated to debit card */
  | "Debit"
  /** Deferred debit card product, associated to credit card */
  | "DeferredDebit";

/**
 * Rejection returned when a card product funding type is invalid.
 * It can occur for example when an individual account holder tries to create a card with a credit card product.
 */
export type CardProductInvalidFundingTypeRejection = Rejection & {
  __typename: "CardProductInvalidFundingTypeRejection";
  message: Scalars["String"]["output"];
};

/** Rejection returned if the card product is not applicable to physical card. */
export type CardProductNotApplicableToPhysicalCardsRejection = Rejection & {
  __typename: "CardProductNotApplicableToPhysicalCardsRejection";
  message: Scalars["String"]["output"];
};

export type CardProductNotFoundRejection = Rejection & {
  __typename: "CardProductNotFoundRejection";
  message: Scalars["String"]["output"];
};

/** Card Product Status */
export type CardProductStatus =
  /** When card product is suspended */
  | "Disabled"
  /** When card product is Enabled */
  | "Enabled"
  /** When card product is waiting for review */
  | "PendingReview"
  /** When card product is suspended */
  | "Suspended";

/** Rejection returned if the card product is suspended. */
export type CardProductSuspendedRejection = Rejection & {
  __typename: "CardProductSuspendedRejection";
  message: Scalars["String"]["output"];
};

export type CardProductUsedRejection = Rejection & {
  __typename: "CardProductUsedRejection";
  message: Scalars["String"]["output"];
};

/** Rejection returned when the card sensitive info are no longer available */
export type CardSensitiveInfoNoLongerAvailableRejection = Rejection & {
  __typename: "CardSensitiveInfoNoLongerAvailableRejection";
  message: Scalars["String"]["output"];
};

/** Card settings for a Project */
export type CardSettings = {
  __typename: "CardSettings";
  /** Accent color */
  accentColor: Scalars["String"]["output"];
  /**
   * Flag used to indicate if ApplePay is activated for the project
   * @deprecated Field no longer supported
   */
  allowsApplePay: Scalars["Boolean"]["output"];
  /** Card Background of the Card Settings */
  cardBackground: CardSettingsBackground;
  /** Card Design URL */
  cardDesignUrl?: Maybe<Scalars["String"]["output"]>;
  /** Logo url 300 dpi */
  cardProjectLogo300dpiUrl?: Maybe<Scalars["String"]["output"]>;
  /** Logo url 300 dpi */
  cardProjectLogo600dpiUrl?: Maybe<Scalars["String"]["output"]>;
  /** Logo url svg */
  cardProjectLogoSvgUrl?: Maybe<Scalars["String"]["output"]>;
  /** Created date */
  createdAt: Scalars["DateTime"]["output"];
  /** Unique identifier of a project card settings */
  id: Scalars["ID"]["output"];
  /** Status of the card settings */
  status: ProjectCardStatus;
  /** Updated date */
  updatedAt: Scalars["DateTime"]["output"];
  /** Settings version */
  version: Scalars["Int"]["output"];
  /** Zoom level */
  zoomRatioProjectLogo?: Maybe<Scalars["Int"]["output"]>;
};

export type CardSettingsBackground = {
  __typename: "CardSettingsBackground";
  /** Card settings background url */
  cardBackgroundUrl: Scalars["String"]["output"];
  /** Card settings background text color */
  cardTextColor: Scalars["String"]["output"];
  /** Created date */
  createdAt: Scalars["DateTime"]["output"];
  /** Unique identifier of a project card settings */
  id: Scalars["ID"]["output"];
  /** Card settings background name */
  name: Scalars["String"]["output"];
  /** Card settings background type */
  type: Scalars["String"]["output"];
  /** Updated date */
  updatedAt: Scalars["DateTime"]["output"];
};

/** Card Settings Background Type */
export type CardSettingsBackgroundType =
  /** when Card background is black */
  | "Black"
  /** when Card background is customized */
  | "Custom"
  /** when Card background is light */
  | "Silver";

/** Card Status */
export type CardStatus =
  /** when the card is canceled */
  | "Canceled"
  /** when the card is about to be canceled */
  | "Canceling"
  /** when the consent to add this card is pending */
  | "ConsentPending"
  /** when the card is enabled */
  | "Enabled"
  /** when the card is in the process of being ready to use */
  | "Processing";

/** Card Status Information */
export type CardStatusInfo = {
  /** Status of the card. */
  status: CardStatus;
};

/** Card transaction */
export type CardTransaction = Transaction & {
  __typename: "CardTransaction";
  /** matching account for the transaction */
  account?: Maybe<Account>;
  /** amount */
  amount: Amount;
  /**
   * type of the authorization.
   * Only available for:
   * - authorization transaction
   * - debit transaction linked to a previous authorization transaction
   */
  authorizationType?: Maybe<AuthorizationType>;
  /** [DEPRECATED] booked balance after this transaction. Deprecated in favor of statusInfo.balance.amount on BookedTransactionStatusInfo */
  bookedBalanceAfter?: Maybe<Amount>;
  /** cardDetails associated */
  cardDetails?: Maybe<CardDetails>;
  /** name of the counterparty. e.g Merchant name, Creditor name, Beneficiary Name ... */
  counterparty: Scalars["String"]["output"];
  /** created date */
  createdAt: Scalars["DateTime"]["output"];
  /** currency exchange if any */
  currencyExchange: Array<ReportExchangeRate>;
  /** enriched data of the merchant */
  enrichedTransactionInfo?: Maybe<EnrichedTransactionInfo>;
  /** a date that reflects the execution date of a transaction from a user viewpoint. Can be used for sorting transactions. */
  executionDate: Scalars["DateTime"]["output"];
  /**
   * an arbitrary identifier that was defined by you when you created this transaction.
   *
   * For example, you can define it in the CreditTransferInput mutation.
   */
  externalReference?: Maybe<Scalars["String"]["output"]>;
  /** unique identifier of the transaction */
  id: Scalars["ID"]["output"];
  /** `true` if this transaction can still be cancelled */
  isCancelable: Scalars["Boolean"]["output"];
  /** label */
  label: Scalars["String"]["output"];
  /** merchant associated */
  merchant?: Maybe<CardMerchant>;
  /** origin transaction associated to this transaction */
  originTransaction?: Maybe<Transaction>;
  /** ID of the origin transaction associated to this transaction */
  originTransactionId?: Maybe<Scalars["String"]["output"]>;
  /** original amount and currency of the transaction */
  originalAmount: Amount;
  /** payment associated to this transaction */
  payment?: Maybe<Payment>;
  /** ID of the payment associated to this transaction */
  paymentId?: Maybe<Scalars["String"]["output"]>;
  /** payment method identifier used for this transaction. e.g masked PAN or IBAN or accountNumber */
  paymentMethodIdentifier: Scalars["String"]["output"];
  /** payment product used for this transaction */
  paymentProduct: PaymentProduct;
  /** project id of the transaction */
  projectId: Scalars["ID"]["output"];
  /** external identifier of the transaction */
  reference: Scalars["String"]["output"];
  /** a date that reflects the time at which the user asked the transaction to be executed */
  requestedExecutionAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** reserved amount of the transaction computed with the rolling reserve. */
  reservedAmount?: Maybe<Amount>;
  /** date on which reserved funds become available. */
  reservedAmountReleasedAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** side (Credit or Debit) */
  side: TransactionSide;
  /** true if a transaction statement can be generated for this transaction */
  statementCanBeGenerated?: Maybe<Scalars["Boolean"]["output"]>;
  /** status information */
  statusInfo: TransactionStatusInfo;
  supportingDocumentCollections: SupportingDocumentCollectionConnection;
  /** unique identifier of the terminal */
  terminalId?: Maybe<Scalars["String"]["output"]>;
  /** indicator of the transit type used (optional) */
  transactionTransportType?: Maybe<TransactionTransportType>;
  /** type */
  type: TransactionTypeEnum;
  /** updated date */
  updatedAt: Scalars["DateTime"]["output"];
};

/** Card transaction */
export type CardTransactionSupportingDocumentCollectionsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  filters?: InputMaybe<SupportingDocumentCollectionFilterInput>;
  first?: Scalars["Int"]["input"];
};

export type CardTransactionCategory =
  | "InStore"
  | "Other"
  | "Withdrawal"
  | "eCommerce"
  | "eCommerceWith3DS";

/** Card Type */
export type CardType =
  /** When card is Single Use Virtual */
  | "SingleUseVirtual"
  /** When card is Virtual */
  | "Virtual"
  /** When card is Virtual and Physical */
  | "VirtualAndPhysical";

/** Rejection returned when the Card is not the expected status */
export type CardWrongStatusRejection = Rejection & {
  __typename: "CardWrongStatusRejection";
  currentStatus: CardStatus;
  expectedStatus: CardStatus;
  identifier: Scalars["String"]["output"];
  message: Scalars["String"]["output"];
};

/** Cash account type (Always Current) */
export type CashAccountType =
  | "CashIncome"
  | "CashPayment"
  | "CashTrading"
  | "Charges"
  | "ClearingParticipantSettlementAccount"
  | "Commission"
  /** When the account is a current account. */
  | "Current"
  | "LimitedLiquiditySavingsAccount"
  | "Loan"
  | "MarginalLending"
  | "MoneyMarket"
  | "NonResidentExternal"
  | "OtherAccount"
  | "OverNightDeposit"
  | "Overdraft"
  | "Salary"
  | "Savings"
  | "Settlement"
  | "Tax"
  | "TransactingAccount";

/** Payment flow available options */
export type Category =
  /** In store payment */
  | "InStore"
  /** Other payment */
  | "Other"
  /** Cash withdraw (atm) */
  | "Withdrawal"
  /** Online (remote) payment */
  | "eCommerce"
  /** Secured online (remote) payment */
  | "eCommerceWith3DS";

/** Enum CategoryPurpose - Purpose of the payment transaction */
export type CategoryPurpose =
  /** Account Sweep */
  | "AccountSweep"
  /** Account Top-Up */
  | "AccountTopUp"
  /** Bonus Payment */
  | "BonusPayment"
  /** Card Bulk Settlement */
  | "CardBulkSettlement"
  /** Card Fee Collection */
  | "CardFeeCollection"
  /** Cash in Transit Payment */
  | "CashInTransitPayment"
  /** Cash Management */
  | "CashManagement"
  /** Cash Order Direct Debit */
  | "CashOrderDirectDebit"
  /** Commercial Reimbursement */
  | "CommercialReimbursement"
  /** Credit Card Payment */
  | "CreditCardPayment"
  /** Credit Card Reimbursement */
  | "CreditCardReimbursement"
  /** Debit Card Payment */
  | "DebitCardPayment"
  /** Debit Card Reimbursement */
  | "DebitCardReimbursement"
  /** Deliver Against Payment */
  | "DeliverAgainstPayment"
  /** Direct Debit Representment */
  | "DirectDebitRepresentment"
  /** Dividend Payment */
  | "DividendPayment"
  /** Dodd Frank Cross Border */
  | "DoddFrankCrossBorder"
  /** E-Payment */
  | "EPayment"
  /** Fee Interest Payment */
  | "FeeInterestPayment"
  /** Foreign Currency Domestic */
  | "ForeignCurrencyDomestic"
  /** General P2P Payment */
  | "GeneralP2PPayment"
  /** Government Payment */
  | "GovernmentPayment"
  /** Hedging Payment */
  | "HedgingPayment"
  /** Interest Payment */
  | "InterestPayment"
  /** Intra-Company Payment */
  | "IntraCompanyPayment"
  /** Loan Transfer */
  | "LoanTransfer"
  /** Lockbox Cash Handling */
  | "LockboxCashHandling"
  /** Mobile P2B Payment */
  | "MobileP2BPayment"
  /** Mobile P2P Payment */
  | "MobileP2PPayment"
  /** Other */
  | "Other"
  /** Pension Payment */
  | "PensionPayment"
  /** Receive Against Payment */
  | "ReceiveAgainstPayment"
  /** Salary Payment */
  | "SalaryPayment"
  /** Savings Transfer */
  | "SavingsTransfer"
  /** Securities Payment */
  | "SecuritiesPayment"
  /** Social Security Benefit */
  | "SocialSecurityBenefit"
  /** Supplier Payment */
  | "SupplierPayment"
  /** Tax Payment */
  | "TaxPayment"
  /** Trade Finance Payment */
  | "TradeFinancePayment"
  /** Trade Settlement */
  | "TradeSettlement"
  /** Treasury Payment */
  | "TreasuryPayment"
  /** VAT Payment */
  | "VATPayment"
  /** Vostro Payment */
  | "VostroPayment"
  /** Withholding Tax Payment */
  | "WithholdingTaxPayment"
  /** Zero Balance Account */
  | "ZeroBalanceAccount";

/** Certificate */
export type Certificate = {
  /**
   * CertificateType
   *
   * Can be either LEAF or INTERMEDIATE
   */
  key: Scalars["String"]["input"];
  /** Base64 value of the certificate */
  value: Scalars["String"]["input"];
};

export type CheckMerchantPayment = MerchantPayment & {
  __typename: "CheckMerchantPayment";
  /** amount */
  amount: Amount;
  /**
   * Authorized date
   * @deprecated use authorizedAt in statusInfo instead
   */
  authorizedAt?: Maybe<Scalars["DateTime"]["output"]>;
  balance: MerchantBalance;
  /** The billing address associated to the payment */
  billingAddress?: Maybe<Address>;
  /**
   * Canceled date
   * @deprecated use canceledAt in statusInfo instead
   */
  canceledAt?: Maybe<Scalars["DateTime"]["output"]>;
  /**
   * Captured date
   * @deprecated use capturedAt in statusInfo instead
   */
  capturedAt?: Maybe<Scalars["DateTime"]["output"]>;
  /**
   * Created date
   * @deprecated use createdAt in statusInfo instead
   */
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  /**
   * Disputed date
   * @deprecated use disputedAt in statusInfo instead
   */
  disputedAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** an arbitrary identifier that was defined by you when you created this payment */
  externalReference?: Maybe<Scalars["String"]["output"]>;
  /** unique identifier of a merchant payment */
  id: Scalars["ID"]["output"];
  /** Label */
  label?: Maybe<Scalars["String"]["output"]>;
  /** merchant profile associated to the merchant payment */
  merchantProfile: MerchantProfile;
  /**
   * Not applicable to checks, TO BE REMOVED
   * @deprecated Not applicable to checks
   */
  paymentLink?: Maybe<MerchantPaymentLink>;
  /**
   * Not applicable to checks, TO BE REMOVED
   * @deprecated Not applicable to checks
   */
  paymentMandate: PaymentMandate;
  /** payment method associated to the merchant payment */
  paymentMethod: MerchantPaymentMethod;
  reference?: Maybe<Scalars["String"]["output"]>;
  /**
   * Refunded date
   * @deprecated use refundedAt in statusInfo instead
   */
  refundedAt?: Maybe<Scalars["DateTime"]["output"]>;
  /**
   * Rejected date
   * @deprecated use rejectedAt in statusInfo instead
   */
  rejectedAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** status information */
  statusInfo: MerchantPaymentStatusInfo;
  /**
   * List of transactions associated with the Merchant Payment.
   *
   * Implements the Relay Connection interface, used to paginate lists of elements. ([Learn More](https://docs.swan.io/developers/using-api/pagination))
   */
  transactions?: Maybe<TransactionConnection>;
  /** Updated date */
  updatedAt: Scalars["DateTime"]["output"];
};

export type CheckMerchantPaymentTransactionsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  filters?: InputMaybe<TransactionsFiltersInput>;
  first?: Scalars["Int"]["input"];
  orderBy?: InputMaybe<TransactionsOrderByInput>;
};

/** CheckMerchantPaymentMethod */
export type CheckMerchantPaymentMethod = MerchantPaymentMethod & {
  __typename: "CheckMerchantPaymentMethod";
  /** Date at which the Merchant Payment Method was created */
  createdAt: Scalars["Date"]["output"];
  /** Unique identifier tied to every version of a given Merchant Payment Method */
  id: Scalars["ID"]["output"];
  /** Merchant Profile to which the Payment Method is attached */
  merchantProfile: MerchantProfile;
  /** Unique identifier for a given merchant Payment Method, identical for every version of a given Merchant Payment Method Type */
  methodId: Scalars["ID"]["output"];
  /** The Merchant Payment Method payment amount limit */
  paymentAmountLimit?: Maybe<Amount>;
  /** Rolling Reserve applied to the Merchant Payment Method */
  rollingReserve?: Maybe<RollingReserve>;
  /** Status of the Merchant Payment Method */
  statusInfo: MerchantPaymentMethodStatusInfo;
  /** The Merchant Payment Method Type */
  type: MerchantPaymentMethodType;
  /** Date at which the Merchant Payment Method was last updated */
  updatedAt: Scalars["Date"]["output"];
  /** Version of the Merchant Payment Method */
  version: Scalars["Int"]["output"];
};

export type CheckPaymentMethodInput = {
  /** Determine whether the payment method must be activated or not */
  activate?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type CheckRejection = Rejection & {
  __typename: "CheckRejection";
  fnciInfo: FnciInfo;
  message: Scalars["String"]["output"];
};

/** Check transaction */
export type CheckTransaction = Transaction & {
  __typename: "CheckTransaction";
  /** matching account for the transaction */
  account?: Maybe<Account>;
  /** amount */
  amount: Amount;
  /** [DEPRECATED] booked balance after this transaction. Deprecated in favor of statusInfo.balance.amount on BookedTransactionStatusInfo */
  bookedBalanceAfter?: Maybe<Amount>;
  /**
   * 31-caracter unique identifier located at the bottom of the check.
   * CMC7 is composed of 3 sections (check number (7 char.), check issuing bank code (12 char.), check holder account number (12 char.)).
   * Combined with RLMC key, it  allows the check traceability.
   */
  cmc7: Scalars["String"]["output"];
  /** name of the counterparty. e.g Merchant name, Creditor name, Beneficiary Name ... */
  counterparty: Scalars["String"]["output"];
  /** created date */
  createdAt: Scalars["DateTime"]["output"];
  /** a date that reflects the execution date of a transaction from a user viewpoint. Can be used for sorting transactions. */
  executionDate: Scalars["DateTime"]["output"];
  /**
   * an arbitrary identifier that was defined by you when you created this transaction.
   *
   * For example, you can define it in the CreditTransferInput mutation.
   */
  externalReference?: Maybe<Scalars["String"]["output"]>;
  /** unique identifier of the transaction */
  id: Scalars["ID"]["output"];
  /** `true` if this transaction can still be cancelled */
  isCancelable: Scalars["Boolean"]["output"];
  /** label */
  label: Scalars["String"]["output"];
  /** merchant profile associated */
  merchant?: Maybe<MerchantProfile>;
  /** origin transaction associated to this transaction */
  originTransaction?: Maybe<Transaction>;
  /** ID of the origin transaction associated to this transaction */
  originTransactionId?: Maybe<Scalars["String"]["output"]>;
  /** payment associated to this transaction */
  payment?: Maybe<Payment>;
  /** ID of the payment associated to this transaction */
  paymentId?: Maybe<Scalars["String"]["output"]>;
  /** payment method identifier used for this transaction: check number */
  paymentMethodIdentifier: Scalars["String"]["output"];
  /** payment product used for this transaction */
  paymentProduct: PaymentProduct;
  /** project id of the transaction */
  projectId: Scalars["ID"]["output"];
  /** reference assigned by the initiating party, to unambiguously identify the transaction. This reference is passed on, unchanged, throughout the entire end-to-end chain. */
  reference: Scalars["String"]["output"];
  /** a date that reflects the time at which the user asked the transaction to be executed */
  requestedExecutionAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** reserved amount of the transaction computed with the rolling reserve. */
  reservedAmount?: Maybe<Amount>;
  /** date on which reserved funds become available */
  reservedAmountReleasedAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** return reason */
  returnReason?: Maybe<TransactionReasonCode>;
  /**
   * 2-digit key used to check the integrity of the CMC7 line, located at the bottom right of the check.
   * Combined with CMC7 line, it allows the check traceability.
   */
  rlmcKey: Scalars["String"]["output"];
  /** side (Credit or Debit) */
  side: TransactionSide;
  /** true if a transaction statement can be generated for this transaction */
  statementCanBeGenerated?: Maybe<Scalars["Boolean"]["output"]>;
  /** status information */
  statusInfo: TransactionStatusInfo;
  supportingDocumentCollections: SupportingDocumentCollectionConnection;
  /** type */
  type: TransactionTypeEnum;
  /** updated date */
  updatedAt: Scalars["DateTime"]["output"];
};

/** Check transaction */
export type CheckTransactionSupportingDocumentCollectionsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  filters?: InputMaybe<SupportingDocumentCollectionFilterInput>;
  first?: Scalars["Int"]["input"];
};

export type CloseAccountInput = {
  accountId: Scalars["ID"]["input"];
  /** URL the user is redirected to after consent has been given */
  consentRedirectUrl: Scalars["String"]["input"];
  reason: PartnerCloseAccountReasonInput;
};

export type CloseAccountPayload =
  | AccountNotFoundRejection
  | BadAccountStatusRejection
  | CloseAccountSuccessPayload
  | ForbiddenRejection
  | InternalErrorRejection
  | ValidationRejection;

/** Define a reason with a message and a specific type for closing account action */
export type CloseAccountReason = Reason & {
  __typename: "CloseAccountReason";
  message?: Maybe<Scalars["String"]["output"]>;
  type: CloseAccountReasonType;
};

/** Specific type for closing account action */
export type CloseAccountReasonType =
  /** Capital Deposit Reason */
  | "CapitalDepositReason"
  /** Compliance Reason */
  | "ComplianceReason"
  /** Inactivity */
  | "Inactivity"
  /** Partner Reason */
  | "PartnerReason";

/** Union between PartnerCloseAccountReasonType and InternalCloseAccountReason */
export type CloseAccountStatusReason = CloseAccountReason;

export type CloseAccountSuccessPayload = {
  __typename: "CloseAccountSuccessPayload";
  consent: Consent;
};

export type ClosedAccountNotUpgradableRejection = Rejection & {
  __typename: "ClosedAccountNotUpgradableRejection";
  message: Scalars["String"]["output"];
};

/** Company account holder onboarding */
export type CompanyAccountHolderOnboarding = AccountHolderOnboardingBase & {
  __typename: "CompanyAccountHolderOnboarding";
  accountAdmin?: Maybe<CompanyAccountHolderOnboardingAccountAdmin>;
  accountInfo?: Maybe<CompanyAccountHolderOnboardingAccount>;
  company?: Maybe<CompanyInfo>;
  createdAt: Scalars["DateTime"]["output"];
  id: Scalars["ID"]["output"];
  /** OAuth parameters provided in order to redirect the user at the end of the flow */
  oAuthRedirectParameters?: Maybe<OAuthRedirectParameters>;
  projectInfo: ProjectInfo;
  statusInfo: OnboardingStatusInfo;
  supportingDocumentCollection?: Maybe<SupportingDocumentCollection>;
  updatedAt: Scalars["DateTime"]["output"];
};

/** Company account information for onboarding */
export type CompanyAccountHolderOnboardingAccount = {
  __typename: "CompanyAccountHolderOnboardingAccount";
  country?: Maybe<AccountCountry>;
  intendedUsages?: Maybe<Array<CompanyAccountIntendedUsage>>;
  name?: Maybe<Scalars["String"]["output"]>;
};

/** Company account admin information for onboarding */
export type CompanyAccountHolderOnboardingAccountAdmin = {
  __typename: "CompanyAccountHolderOnboardingAccountAdmin";
  address?: Maybe<AddressInfo>;
  birthInfo?: Maybe<BirthInfo>;
  email?: Maybe<Scalars["String"]["output"]>;
  firstName?: Maybe<Scalars["String"]["output"]>;
  lastName?: Maybe<Scalars["String"]["output"]>;
  nationality?: Maybe<Scalars["CCA3"]["output"]>;
  preferredLanguage?: Maybe<AccountLanguage>;
  taxIdentificationNumber?: Maybe<Scalars["String"]["output"]>;
  typeOfRepresentation?: Maybe<TypeOfRepresentation>;
  unitedStatesTaxInfo?: Maybe<UnitedStatesTaxInfo>;
};

/** Input for company account admin information during onboarding */
export type CompanyAccountHolderOnboardingAccountAdminInput = {
  address?: InputMaybe<ResidencyAddressInput>;
  birthInfo?: InputMaybe<BirthInfoInput>;
  email?: InputMaybe<Scalars["String"]["input"]>;
  firstName?: InputMaybe<Scalars["String"]["input"]>;
  lastName?: InputMaybe<Scalars["String"]["input"]>;
  nationality?: InputMaybe<Scalars["CCA3"]["input"]>;
  preferredLanguage?: InputMaybe<AccountLanguage>;
  taxIdentificationNumber?: InputMaybe<Scalars["String"]["input"]>;
  typeOfRepresentation?: InputMaybe<TypeOfRepresentation>;
  unitedStatesTaxInfo?: InputMaybe<UnitedStatesTaxInfoInput>;
  userDeviceInfo?: InputMaybe<UserDeviceInfoInput>;
};

/** Input for company account admin information during onboarding update */
export type CompanyAccountHolderOnboardingAccountAdminUpdateInput = {
  address?: InputMaybe<ResidencyAddressInput>;
  birthInfo?: InputMaybe<BirthInfoInput>;
  email?: InputMaybe<Scalars["String"]["input"]>;
  firstName?: InputMaybe<Scalars["String"]["input"]>;
  lastName?: InputMaybe<Scalars["String"]["input"]>;
  nationality?: InputMaybe<Scalars["CCA3"]["input"]>;
  preferredLanguage?: InputMaybe<AccountLanguage>;
  taxIdentificationNumber?: InputMaybe<Scalars["String"]["input"]>;
  typeOfRepresentation?: InputMaybe<TypeOfRepresentation>;
  unitedStatesTaxInfo?: InputMaybe<UnitedStatesTaxInfoInput>;
};

/** Input for company account information during onboarding */
export type CompanyAccountHolderOnboardingAccountInput = {
  country: AccountCountry;
  intendedUsages?: InputMaybe<Array<CompanyAccountIntendedUsage>>;
  name?: InputMaybe<Scalars["String"]["input"]>;
};

/** Input for company account information during onboarding update */
export type CompanyAccountHolderOnboardingAccountUpdateInput = {
  intendedUsages?: InputMaybe<Array<CompanyAccountIntendedUsage>>;
  name?: InputMaybe<Scalars["String"]["input"]>;
};

/** Company account intended usage */
export type CompanyAccountIntendedUsage = "Placeholder";

export type CompanyHeadcount =
  | "Between1And10"
  | "Between11And50"
  | "Between51And250"
  | "MoreThan250";

/** Company registry information */
export type CompanyInfo = {
  __typename: "CompanyInfo";
  /** Company headquarters address */
  address?: Maybe<AddressInfo>;
  /** Business activity description */
  businessActivityDescription?: Maybe<Scalars["String"]["output"]>;
  /** Business classification code (NAF code for France) */
  businessClassificationCode?: Maybe<Scalars["String"]["output"]>;
  /** Company type */
  companyType?: Maybe<CompanyType>;
  /** Forecast yearly income range */
  forecastYearlyIncome?: Maybe<ForecastYearlyIncome>;
  /** The current company headcount */
  headcount?: Maybe<CompanyHeadcount>;
  /** Legal form of the company */
  legalForm?: Maybe<Scalars["String"]["output"]>;
  /** Monthly payment volume */
  monthlyPaymentVolume?: Maybe<MonthlyPaymentVolume>;
  /** Company legal name */
  name?: Maybe<Scalars["String"]["output"]>;
  /** Company registration date */
  registrationDate?: Maybe<Scalars["Date"]["output"]>;
  /** Registration number (e.g., SIREN for France) */
  registrationNumber: Scalars["String"]["output"];
  /** Regulatory classification of the company */
  regulatoryClassification?: Maybe<RegulatoryClassification>;
  /** The list of representatives of the company */
  representatives?: Maybe<Array<Maybe<OnboardingRepresentative>>>;
  /** Tax identification number */
  taxIdentificationNumber?: Maybe<Scalars["String"]["output"]>;
  /** Trade name (if different from legal name) */
  tradeName?: Maybe<Scalars["String"]["output"]>;
  /** Ultimate beneficial owners */
  ultimateBeneficialOwners?: Maybe<Array<Maybe<UltimateBeneficialOwner>>>;
  /** VAT identification number */
  vatNumber?: Maybe<Scalars["String"]["output"]>;
  /** Company websites */
  websites?: Maybe<Array<Scalars["String"]["output"]>>;
};

/** Input for company information during onboarding */
export type CompanyInfoInput = {
  acquisitionChannel?: InputMaybe<AcquisitionChannel>;
  address?: InputMaybe<ResidencyAddressInput>;
  businessActivityDescription?: InputMaybe<Scalars["String"]["input"]>;
  businessClassificationCode?: InputMaybe<Scalars["String"]["input"]>;
  companyType?: InputMaybe<CompanyType>;
  forecastYearlyIncome?: InputMaybe<ForecastYearlyIncome>;
  headcount?: InputMaybe<CompanyHeadcount>;
  legalForm?: InputMaybe<LegalForm>;
  monthlyPaymentVolume?: InputMaybe<MonthlyPaymentVolume>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  registrationDate?: InputMaybe<Scalars["Date"]["input"]>;
  registrationNumber?: InputMaybe<Scalars["String"]["input"]>;
  regulatoryClassification?: InputMaybe<RegulatoryClassification>;
  representatives?: InputMaybe<Array<OnboardingRepresentativeInput>>;
  signupDate?: InputMaybe<Scalars["Date"]["input"]>;
  taxIdentificationNumber?: InputMaybe<Scalars["String"]["input"]>;
  tradeName?: InputMaybe<Scalars["String"]["input"]>;
  ultimateBeneficialOwners?: InputMaybe<Array<UltimateBeneficialOwnerInput>>;
  vatNumber?: InputMaybe<Scalars["String"]["input"]>;
  websites?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

/** Input for fetching company registry data */
export type CompanyInfoRegistryDataInput = {
  /** Registration number of the company (e.g., SIREN for France) */
  registrationNumber: Scalars["String"]["input"];
  /** Residency address country code (ISO 3166-1 alpha-3) */
  residencyAddressCountry: RegistryCountry;
};

/** Result payload for company info registry data query */
export type CompanyInfoRegistryDataPayload =
  | CompanyInfoRegistryDataSuccessPayload
  | CompanyRegistryNotFoundRejection
  | CompanyRegistryUnavailableRejection
  | ForbiddenRejection
  | InternalErrorRejection
  | ValidationRejection;

/** Success response with comprehensive company information */
export type CompanyInfoRegistryDataSuccessPayload = {
  __typename: "CompanyInfoRegistryDataSuccessPayload";
  companyInfo: CompanyInfo;
};

/** Input for company information during onboarding update */
export type CompanyInfoUpdateInput = {
  address?: InputMaybe<ResidencyAddressInput>;
  businessActivityDescription?: InputMaybe<Scalars["String"]["input"]>;
  businessClassificationCode?: InputMaybe<Scalars["String"]["input"]>;
  companyType?: InputMaybe<CompanyType>;
  forecastYearlyIncome?: InputMaybe<ForecastYearlyIncome>;
  headcount?: InputMaybe<CompanyHeadcount>;
  legalForm?: InputMaybe<LegalForm>;
  monthlyPaymentVolume?: InputMaybe<MonthlyPaymentVolume>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  registrationDate?: InputMaybe<Scalars["Date"]["input"]>;
  registrationNumber?: InputMaybe<Scalars["String"]["input"]>;
  regulatoryClassification?: InputMaybe<RegulatoryClassification>;
  representatives?: InputMaybe<Array<OnboardingRepresentativeInput>>;
  taxIdentificationNumber?: InputMaybe<Scalars["String"]["input"]>;
  tradeName?: InputMaybe<Scalars["String"]["input"]>;
  ultimateBeneficialOwners?: InputMaybe<Array<UltimateBeneficialOwnerInput>>;
  vatNumber?: InputMaybe<Scalars["String"]["input"]>;
  websites?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

/** Rejection returned if registration number is not correct */
export type CompanyRegistryNotFoundRejection = Rejection & {
  __typename: "CompanyRegistryNotFoundRejection";
  country: Scalars["String"]["output"];
  message: Scalars["String"]["output"];
  registrationNumber: Scalars["String"]["output"];
};

/** Rejection returned when the company registry service is temporarily unavailable */
export type CompanyRegistryUnavailableRejection = Rejection & {
  __typename: "CompanyRegistryUnavailableRejection";
  message: Scalars["String"]["output"];
};

export type CompanyRepresentative = {
  __typename: "CompanyRepresentative";
  /** Legal entity name of the representative (for Company type). */
  entityName?: Maybe<Scalars["String"]["output"]>;
  /** Legal form of the representative's legal entity. */
  legalForm?: Maybe<Scalars["String"]["output"]>;
  /** Registration number of the representative’s legal entity. */
  registrationNumber?: Maybe<Scalars["String"]["output"]>;
  /** Residency address of the representative. */
  residencyAddress?: Maybe<AddressInformation>;
  /** List of representative roles. */
  roles?: Maybe<Array<Scalars["String"]["output"]>>;
};

/** Company shareholder info. */
export type CompanyShareholder = {
  __typename: "CompanyShareholder";
  /** Company name. */
  name: Scalars["String"]["output"];
  /** Whether the shareholder is an individual or a company. */
  type: ShareholderType;
};

/** Type of company. */
export type CompanyType =
  | "Association"
  | "Company"
  | "HomeOwnerAssociation"
  | "Other"
  | "SelfEmployed";

export type CompanyVerificationRenewalAccountAdmin = {
  __typename: "CompanyVerificationRenewalAccountAdmin";
  birthInfo: BirthInfo;
  email: Scalars["String"]["output"];
  firstName: Scalars["String"]["output"];
  lastName: Scalars["String"]["output"];
  typeOfRepresentation?: Maybe<TypeOfRepresentation>;
};

export type CompanyVerificationRenewalAccountAdminInput = {
  birthInfo?: InputMaybe<BirthInfoInput>;
  email?: InputMaybe<Scalars["String"]["input"]>;
  firstName?: InputMaybe<Scalars["String"]["input"]>;
  lastName?: InputMaybe<Scalars["String"]["input"]>;
  typeOfRepresentation?: InputMaybe<TypeOfRepresentation>;
};

export type CompanyVerificationRenewalCompanyInfo = {
  __typename: "CompanyVerificationRenewalCompanyInfo";
  businessActivityDescription: Scalars["String"]["output"];
  monthlyPaymentVolume: MonthlyPaymentVolume;
  name: Scalars["String"]["output"];
  residencyAddress: Address;
  ultimateBeneficialOwners: Array<VerificationRenewalUltimateBeneficialOwner>;
  verificationRenewalId: Scalars["String"]["output"];
};

export type CompanyVerificationRenewalInfo = VerificationRenewalInfoBase & {
  __typename: "CompanyVerificationRenewalInfo";
  accountAdmin: CompanyVerificationRenewalAccountAdmin;
  additionalDetails?: Maybe<Scalars["String"]["output"]>;
  company: CompanyVerificationRenewalCompanyInfo;
  type: AccountHolderType;
};

export type CompanyVerificationRenewalInfoInput = {
  businessActivityDescription?: InputMaybe<Scalars["String"]["input"]>;
  monthlyPaymentVolume?: InputMaybe<MonthlyPaymentVolume>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  residencyAddress?: InputMaybe<ResidencyAddressInput>;
  ultimateBeneficialOwners?: InputMaybe<Array<VerificationRenewalUltimateBeneficialOwnerInput>>;
};

/** Complete Address Information */
export type CompleteAddressInput = {
  /** address line 1 (max 38 characters) */
  addressLine1: Scalars["String"]["input"];
  /** address line 2 (max 38 characters) */
  addressLine2?: InputMaybe<Scalars["String"]["input"]>;
  /** city (max 30 characters) `^\p{L}+(\p{L}|[0-9]|-|'|\s)*(\p{L}|[0-9])+$` */
  city: Scalars["String"]["input"];
  /** country code */
  country: Scalars["CCA3"]["input"];
  /** postal code (max 10 characters) `^[0-9A-Z- ]{1,10}$` */
  postalCode: Scalars["String"]["input"];
  /** state (max 30 characters) `^\p{L}+(\p{L}|-|'|\s)*\p{L}+` */
  state?: InputMaybe<Scalars["String"]["input"]>;
};

/** Complete Address Information with a contact */
export type CompleteAddressWithContactInput = {
  /** address line 1 (max 38 characters) */
  addressLine1: Scalars["String"]["input"];
  /** address line 2 (max 38 characters) */
  addressLine2?: InputMaybe<Scalars["String"]["input"]>;
  /** city (max 30 characters) `^\p{L}+(\p{L}|[0-9]|-|'|\s)*(\p{L}|[0-9])+$` */
  city: Scalars["String"]["input"];
  /** contact company name (max 38 characters) */
  companyName?: InputMaybe<Scalars["String"]["input"]>;
  /** country code */
  country: Scalars["CCA3"]["input"];
  /** contact first name */
  firstName: Scalars["String"]["input"];
  /** contact last name */
  lastName: Scalars["String"]["input"];
  /** contact phone number */
  phoneNumber: Scalars["PhoneNumber"]["input"];
  /** postal code (max 10 characters) `^[0-9A-Z- ]{1,10}$` */
  postalCode: Scalars["String"]["input"];
  /** state (max 30 characters) `^\p{L}+(\p{L}|-|'|\s)*\p{L}+` */
  state?: InputMaybe<Scalars["String"]["input"]>;
};

/**
 * Complete Digital Card used for ApplePay or GooglePay
 *
 * Once the pending phase is over, more data will be available in the response
 */
export type CompleteDigitalCard = DigitalCard & {
  __typename: "CompleteDigitalCard";
  /** The card contract ID */
  cardContractId: Scalars["ID"]["output"];
  /**
   * Masked DPAN with the last four digits visible
   *
   * This value is present in the user wallet application
   */
  cardMaskedNumber: Scalars["String"]["output"];
  /** Created date */
  createdAt: Scalars["DateTime"]["output"];
  /**
   * Device
   * In case of a wallet application, some information about the device will be provided
   */
  device: Device;
  /** Unique identifier of a digital card */
  id: Scalars["ID"]["output"];
  /** The project ID */
  projectId: Scalars["ID"]["output"];
  /**
   * Digital Card status information
   *
   * In this type the status will be either ConsentPending or Pending
   */
  statusInfo: CompleteDigitalCardStatusInfo;
  /** Reference of the token in another system (ex: Mastercard) */
  tokenReferenceId?: Maybe<Scalars["String"]["output"]>;
  /** The type of digitalization that created this digital card. */
  type: DigitalizationType;
  /** Updated date */
  updatedAt: Scalars["DateTime"]["output"];
  /** Wallet Provider (ApplePay, GooglePay ...) */
  walletProvider: WalletProvider;
};

/** Complete Digital Card Status */
export type CompleteDigitalCardStatus =
  /**
   * when the digital card is canceled
   *
   * this is a final state
   */
  | "Canceled"
  /** when the digital card is enabled */
  | "Enabled"
  /**
   * when the digital card is suspended
   *
   * the transactions will be blocked
   */
  | "Suspended";

/** Complete Digital Card Status Information */
export type CompleteDigitalCardStatusInfo = {
  /** Status of the digital card. */
  status: CompleteDigitalCardStatus;
};

export type CompleteUserCreationInput = {
  code: Scalars["String"]["input"];
  requestId: Scalars["String"]["input"];
  userInformation: UserInformationInput;
};

export type CompleteUserCreationPayload =
  | CompleteUserCreationSuccessPayload
  | OperationNotAllowedRejection
  | SmsProviderRejection
  | UserBlockedRejection
  | ValidationRejection
  | WrongCodeRejection;

export type CompleteUserCreationSuccessPayload = {
  __typename: "CompleteUserCreationSuccessPayload";
  user: User;
  userAlreadyExisted: Scalars["Boolean"]["output"];
};

export type CompletedMerchantPaymentLinkStatusInfo = MerchantPaymentLinkStatusInfo & {
  __typename: "CompletedMerchantPaymentLinkStatusInfo";
  /** The time when the customer completed the payment. */
  completedAt: Scalars["DateTime"]["output"];
  status: MerchantPaymentLinkStatus;
};

export type CompletedVerificationRenewal = VerificationRenewal & {
  __typename: "CompletedVerificationRenewal";
  accountHolderId: Scalars["String"]["output"];
  /** Completed date */
  completedAt?: Maybe<Scalars["DateTime"]["output"]>;
  createdAt: Scalars["DateTime"]["output"];
  dueDate?: Maybe<Scalars["DateTime"]["output"]>;
  id: Scalars["ID"]["output"];
  /** Verification renewal information */
  info: VerificationRenewalInfo;
  status: VerificationRenewalStatus;
  supportTicketId?: Maybe<Scalars["String"]["output"]>;
  updatedAt: Scalars["DateTime"]["output"];
};

/** Inputs to confirm physical card renewal */
export type ConfirmPhysicalCardRenewalInput = {
  /** Address to deliver the physical card */
  address: CompleteAddressInput;
  /** Unique identifier of a card */
  cardId: Scalars["ID"]["input"];
  /** Custom Options */
  customOptions?: InputMaybe<PhysicalCardCustomOptionsInput>;
};

export type ConfirmPhysicalCardRenewalPayload =
  | CardNotFoundRejection
  | ConfirmPhysicalCardRenewalSuccessPayload
  | ForbiddenRejection
  | InvalidShippingProviderRejection
  | PhysicalCardWrongStatusRejection
  | ValidationRejection;

export type ConfirmPhysicalCardRenewalSuccessPayload = {
  __typename: "ConfirmPhysicalCardRenewalSuccessPayload";
  /** Physical card has been updated */
  physicalCard: PhysicalCard;
};

/** Relay Connection type, used to paginate list of element ([Learn More](https://docs.swan.io/api/pagination)) */
export type Connection = {
  /** Edge list */
  edges: Array<Edge>;
  /** Information about the current, the previous and the next page */
  pageInfo: PageInfo;
  /** Total number of element in the list */
  totalCount: Scalars["Int"]["output"];
};

/** Some sensitive operation at Swan, such as initiating a payment, require consent */
export type Consent = {
  __typename: "Consent";
  /** date when the consent is accepted */
  acceptedAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** date when the consent is canceled */
  canceledAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** unique hash of the consent */
  challenge?: Maybe<Scalars["String"]["output"]>;
  /** Redirect the user to this URL to start the consent flow */
  consentUrl: Scalars["String"]["output"];
  /** created date */
  createdAt: Scalars["DateTime"]["output"];
  /** date when the consent expire */
  expiredAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** unique identifier of the consent */
  id: Scalars["ID"]["output"];
  /** purpose of the consent */
  purpose: ConsentPurpose;
  /** When the consent flow is finished the user is redirected to this URL */
  redirectUrl: Scalars["String"]["output"];
  /** date when the consent is refused */
  refusedAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** `true` if the consent requires a Strong Customer Authentication */
  requireSCA: Scalars["Boolean"]["output"];
  /** date when the `consentUrl` was request the first time */
  startedAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** status of the consent */
  status: ConsentStatus;
  /** updated date */
  updatedAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** user who initiated the consent */
  user?: Maybe<User>;
  /** userId who initiated the consent */
  userId: Scalars["String"]["output"];
};

/** Implements the Relay Connection interface, used to paginate list of element ([Learn More](https://docs.swan.io/api/pagination)) */
export type ConsentConnection = Connection & {
  __typename: "ConsentConnection";
  /** ConsentEdge list */
  edges: Array<ConsentEdge>;
  /** Information about the current, the previous and the next page */
  pageInfo: PageInfo;
  /** Total number of element in the list */
  totalCount: Scalars["Int"]["output"];
};

/** Implements the Relay Edge interface */
export type ConsentEdge = Edge & {
  __typename: "ConsentEdge";
  /** Opaque identifier pointing to this consent node in the pagination mechanism */
  cursor: Scalars["String"]["output"];
  /** The consent */
  node: Consent;
};

/** Consent ID with related execution order */
export type ConsentIdWithOrder = {
  /** Consent ID */
  consentId: Scalars["String"]["input"];
  /** Execution order. Consents are granted in ascending order. Consents with the same order may be granted in parallel. */
  order?: Scalars["Int"]["input"];
};

/** Rejection returned if a consent was not found */
export type ConsentNotFoundRejection = Rejection & {
  __typename: "ConsentNotFoundRejection";
  consentId: Scalars["String"]["output"];
  message: Scalars["String"]["output"];
};

/** Purpose of a consent */
export type ConsentPurpose =
  /** when accepting the partnership conditions */
  | "AcceptPartnershipConditions"
  /** when activating a digital card */
  | "ActivateDigitalCard"
  /** when activating a physical card */
  | "ActivatePhysicalCard"
  /** when inviting a new account membership */
  | "AddAccountMembership"
  /** when adding several account memberships */
  | "AddAccountMemberships"
  /** when adding a beneficiary */
  | "AddBeneficiary"
  /** when adding a virtual card */
  | "AddCard"
  /** when adding multiple cards */
  | "AddCards"
  /** when adding a digital card */
  | "AddDigitalCard"
  /** when adding a payment direct debit mandate */
  | "AddDirectDebitPaymentMandate"
  /** when closing an account */
  | "CloseAccount"
  /** when the consent is a multiple consent */
  | "ConsentToMultipleConsents"
  /** when enabling a mandate */
  | "EnableMandate"
  /** when initiating a credit transfer */
  | "InitPayment"
  /** when initiating a funding request */
  | "InitiateFundingRequest"
  /** when initiating an instant funding request */
  | "InitiateInstantFundingRequest"
  /** when initiating an international credit transfer */
  | "InitiateInternationalCreditTransfer"
  /** when opting-out from Verification of Payee for Bulk Payments */
  | "OptOutBulkVerificationOfPayee"
  /** when requesting to print physical card */
  | "PrintPhysicalCard"
  /** when Requesting a credit limit */
  | "RequestCreditLimit"
  /** when resuming an account membership */
  | "ResumeAccountMembership"
  /** when resuming a physical card */
  | "ResumePhysicalCard"
  /** when returning a transaction for direct debit */
  | "ReturnTransactionForDirectDebit"
  /** when returning a transaction for international credit transfer */
  | "ReturnTransactionForInternationalCreditTransfer"
  /** when scheduling a standing order */
  | "ScheduleStandingOrder"
  /** if the consent originates from a 3DS flow */
  | "ThreeDsPayment"
  /** when updating an account membership */
  | "UpdateAccountMembership"
  /** when updating an account settings */
  | "UpdateAccountSettings"
  /** when updating a card */
  | "UpdateCard"
  /** when updating a server consent project settings */
  | "UpdateServerConsentProjectSettings"
  /** when viewing card confidential of a virtual card */
  | "ViewCardNumbers"
  /** when requesting to view physical card PIN */
  | "ViewPhysicalCardPin";

/** Status of a consent */
export type ConsentStatus =
  /** when the user accepted */
  | "Accepted"
  /** when the user or the project decided to cancel the consent */
  | "Canceled"
  /** when the consent is created */
  | "Created"
  /** when the user credentials were refused */
  | "CredentialRefused"
  /** when the user refused */
  | "CustomerRefused"
  /** when the consent is expired */
  | "Expired"
  /** when something went wrong */
  | "Failed"
  /** when the operation is committing */
  | "OperationCommitting"
  /** when the consentUrl has been requested */
  | "Started";

export type ConsentTypeNotSupportedByServerConsentRejection = Rejection & {
  __typename: "ConsentTypeNotSupportedByServerConsentRejection";
  message: Scalars["String"]["output"];
};

/** Rejection returned when a the consent is already linked to another multi consent */
export type ConsentsAlreadyLinkedToMultiConsentRejection = Rejection & {
  __typename: "ConsentsAlreadyLinkedToMultiConsentRejection";
  /** IDs of the consents that are already linked to another multi consent */
  consentIds: Array<Scalars["String"]["output"]>;
  message: Scalars["String"]["output"];
};

export type ConsentsFiltersInput = {
  userId?: InputMaybe<Scalars["String"]["input"]>;
};

/** Rejection returned when all provided consents are not in created status */
export type ConsentsNotAllInCreatedStatusRejection = Rejection & {
  __typename: "ConsentsNotAllInCreatedStatusRejection";
  /** IDs of the consents that are not in created status */
  consentIds: Array<Scalars["String"]["output"]>;
  message: Scalars["String"]["output"];
};

/** Rejection returned when a consent ID passed as input does not exist. */
export type ConsentsNotFoundRejection = Rejection & {
  __typename: "ConsentsNotFoundRejection";
  ids: Array<Scalars["String"]["output"]>;
  message: Scalars["String"]["output"];
};

/** Inputs to create a capital deposit case. */
export type CreateCapitalDepositCaseInput = {
  /** Name ("Dénomination sociale") of the company being registered and for which the capital is being deposited. */
  companyName: Scalars["String"]["input"];
  /** Array of shareholders of type company ("personne morale"). */
  companyShareholders: Array<InputMaybe<OnboardCompanyShareholderInput>>;
  /** Array of shareholders of type individual ("personne physique"). */
  individualShareholders: Array<InputMaybe<OnboardIndividualShareholderInput>>;
  /** Information required for the onboarding of a company. */
  onboardingCapitalDepositCompany: OnboardCompanyAccountHolderInput;
};

export type CreateCapitalDepositCasePayload =
  | BadRequestRejection
  | CreateCapitalDepositCaseSuccessPayload
  | ForbiddenRejection
  | InternalErrorRejection
  | ValidationRejection;

export type CreateCapitalDepositCaseSuccessPayload = {
  __typename: "CreateCapitalDepositCaseSuccessPayload";
  capitalDepositCase: CapitalDepositCase;
};

/** Input for creating a company account holder onboarding */
export type CreateCompanyAccountHolderOnboardingInput = {
  /** Account admin information for the company account holder */
  accountAdmin: CompanyAccountHolderOnboardingAccountAdminInput;
  /** Account information for the company account holder */
  accountInfo: CompanyAccountHolderOnboardingAccountInput;
  /** Company information */
  company: CompanyInfoInput;
  /** OAuth redirect parameters for the onboarding flow */
  oAuthRedirectParameters?: InputMaybe<OAuthRedirectParametersInput>;
};

/** Payload for creating a company account holder onboarding */
export type CreateCompanyAccountHolderOnboardingPayload =
  | CreateCompanyAccountHolderOnboardingSuccessPayload
  | ForbiddenRejection
  | ValidationRejection;

/** Success response for creating a company account holder onboarding */
export type CreateCompanyAccountHolderOnboardingSuccessPayload = {
  __typename: "CreateCompanyAccountHolderOnboardingSuccessPayload";
  /** The created company account holder onboarding */
  onboarding: CompanyAccountHolderOnboarding;
};

export type CreateInPersonPaymentIntentInput = {
  amount: AmountInput;
  externalReference?: InputMaybe<Scalars["String"]["input"]>;
  idempotencyKey?: InputMaybe<Scalars["String"]["input"]>;
  label?: InputMaybe<Scalars["String"]["input"]>;
  merchantProfileId: Scalars["ID"]["input"];
  reference?: InputMaybe<Scalars["String"]["input"]>;
};

export type CreateInPersonPaymentIntentPayload =
  | CreateInPersonPaymentIntentSuccessPayload
  | ForbiddenRejection
  | InternalErrorRejection
  | NotFoundRejection;

export type CreateInPersonPaymentIntentSuccessPayload = {
  __typename: "CreateInPersonPaymentIntentSuccessPayload";
  paymentIntent: PaymentIntent;
};

/** Input for creating an individual account holder onboarding */
export type CreateIndividualAccountHolderOnboardingInput = {
  /** Account admin information for the individual account holder */
  accountAdmin: IndividualAccountHolderOnboardingAccountAdminInput;
  /** Account information for the individual account holder */
  accountInfo: IndividualAccountHolderOnboardingAccountInput;
  /** OAuth redirect parameters for the onboarding flow */
  oAuthRedirectParameters?: InputMaybe<OAuthRedirectParametersInput>;
};

/** Payload for creating an individual account holder onboarding */
export type CreateIndividualAccountHolderOnboardingPayload =
  | CreateIndividualAccountHolderOnboardingSuccessPayload
  | ForbiddenRejection
  | ValidationRejection;

/** Success response for creating an individual account holder onboarding */
export type CreateIndividualAccountHolderOnboardingSuccessPayload = {
  __typename: "CreateIndividualAccountHolderOnboardingSuccessPayload";
  /** The created individual account holder onboarding */
  onboarding: IndividualAccountHolderOnboarding;
};

export type CreateMerchantPaymentLinkInput = {
  /** Amount to be paid to sucessfully complete the payment. */
  amount: AmountInput;
  /**
   * The customer billing Address
   * These fields should be completed also to pre-fill a SEPA direct debit mandate.
   *
   * We strongly advice to complete these fields if merchants want to get paid through card payment method, in order to minimize the risk of payment rejection by Visa / Mastercard schemes
   */
  billingAddress?: InputMaybe<AddressInput>;
  /** URL to redirect the user to if they cancel their payment */
  cancelRedirectUrl?: InputMaybe<Scalars["URL"]["input"]>;
  /**
   * We will use the information specified here to prefill the payment link fields
   * depending on the payment method the end user chooses.
   * Keep in mind that your end customer will be able to edit these fields.
   */
  customer?: InputMaybe<CustomerInput>;
  /**
   * The date when the payment link expires.
   * If not specified, the default time will be 120 days
   */
  expiresAt?: InputMaybe<Scalars["DateTime"]["input"]>;
  /**
   * Any string that you want to be attached to this payment link.
   * Usually something to help you reference the link in an external system.
   */
  externalReference?: InputMaybe<Scalars["String"]["input"]>;
  /** Label of the concerned payment collection, which will be displayed on Swan bank statement	and on the Swan merchant payment page. */
  label?: InputMaybe<Scalars["String"]["input"]>;
  /**
   * The language used for the payment page.
   * Default is the browser's language, or English if not available.
   */
  language?: InputMaybe<Language>;
  /** The Merchant Profile to link this Payment Link to */
  merchantProfileId: Scalars["ID"]["input"];
  /**
   * List of payment methods enabled for this payment link.
   * If you want to make payment possible via SEPA Direct Debit, the list should be populated either by a SEPA Direct Debit CORE or B2B.
   */
  paymentMethodIds: Array<Scalars["String"]["input"]>;
  /** Merchant Website URL to redirect the user to when the payment is completed. */
  redirectUrl?: InputMaybe<Scalars["URL"]["input"]>;
  /**
   * Optional field intended to provide a way for you to include a reference number or code.
   * The customer will most likely see this value on their bank statement, though we can't know as every banking platform is different.
   */
  reference?: InputMaybe<Scalars["String"]["input"]>;
  /**
   * A date that reflects the time at which the user asked the transaction to be executed.
   * For card transactions, request execution must occur within 7 days after authorization or the authorization may expire.
   * For SEPA Direct Debit transactions, request execution must occur up to 1 year in the future.
   *
   * Default value means that the execution will be as soon as possible
   */
  requestedExecutionAt?: InputMaybe<Scalars["DateTime"]["input"]>;
  /**
   * Controls if the payment mandate created from this payment link is for one-time use or can be reused
   * This is applicable for card and SEPA Direct Debit payment methods only.
   * If not specified, the default value is OneOff.
   */
  sequence?: InputMaybe<PaymentMandateSequence>;
};

export type CreateMerchantPaymentLinkPayload =
  | CreateMerchantPaymentLinkSuccessPayload
  | ForbiddenRejection
  | InternalErrorRejection
  | MerchantPaymentMethodNotActiveRejection
  | MerchantProfileWrongStatusRejection
  | PaymentMethodNotCompatibleRejection
  | ValidationRejection;

export type CreateMerchantPaymentLinkSuccessPayload = {
  __typename: "CreateMerchantPaymentLinkSuccessPayload";
  merchantPaymentLink: MerchantPaymentLink;
};

/** Input of the `createMultiConsent` mutation */
export type CreateMultiConsentInput = {
  /** A list of consent IDs with their related execution orders */
  orderedConsentIds: Array<ConsentIdWithOrder>;
  /** URL the user is redirected to after consent has been given */
  redirectUrl: Scalars["String"]["input"];
};

/** Payload of the `createMultiConsent` mutation */
export type CreateMultiConsentPayload =
  | ConsentsAlreadyLinkedToMultiConsentRejection
  | ConsentsNotAllInCreatedStatusRejection
  | ConsentsNotFoundRejection
  | CreateMultiConsentSuccessPayload
  | TooManyChildConsentsRejection;

/** Success payload of the `createMultiConsent` mutation */
export type CreateMultiConsentSuccessPayload = {
  __typename: "CreateMultiConsentSuccessPayload";
  consent?: Maybe<Consent>;
};

/** Input for creating a company account holder onboarding */
export type CreatePublicCompanyAccountHolderOnboardingInput = {
  /** Account admin information for the company account holder */
  accountAdmin: CompanyAccountHolderOnboardingAccountAdminInput;
  /** Account information for the company account holder */
  accountInfo: CompanyAccountHolderOnboardingAccountInput;
  /** Company information */
  company: CompanyInfoInput;
  /** ID of the project. */
  projectId: Scalars["ID"]["input"];
};

/** Payload for creating a company account holder onboarding */
export type CreatePublicCompanyAccountHolderOnboardingPayload =
  | CreatePublicCompanyAccountHolderOnboardingSuccessPayload
  | ForbiddenRejection
  | PublicOnboardingDisabledRejection
  | ValidationRejection;

/** Success response for creating a company account holder onboarding */
export type CreatePublicCompanyAccountHolderOnboardingSuccessPayload = {
  __typename: "CreatePublicCompanyAccountHolderOnboardingSuccessPayload";
  /** The created company account holder onboarding */
  onboarding: CompanyAccountHolderOnboarding;
};

/** Input for creating a public individual account holder onboarding */
export type CreatePublicIndividualAccountHolderOnboardingInput = {
  /** Account admin information for the individual account holder */
  accountAdmin: PublicIndividualAccountHolderOnboardingAccountAdminInput;
  /** Account information for the individual account holder */
  accountInfo: PublicIndividualAccountHolderOnboardingAccountInput;
};

/** Payload for creating a public individual account holder onboarding */
export type CreatePublicIndividualAccountHolderOnboardingPayload =
  | CreatePublicIndividualAccountHolderOnboardingSuccessPayload
  | ForbiddenRejection
  | PublicOnboardingDisabledRejection
  | ValidationRejection;

/** Success response for creating a public individual account holder onboarding */
export type CreatePublicIndividualAccountHolderOnboardingSuccessPayload = {
  __typename: "CreatePublicIndividualAccountHolderOnboardingSuccessPayload";
  /** The created public individual account holder onboarding */
  onboarding: IndividualAccountHolderOnboarding;
};

/** Inputs to set the repayment details for the SepaDirectDebitB2B */
export type CreditLimitSepaDirectDebitB2BInput = {
  /** SEPA Direct Debit Payment Mandate debtor IBAN. */
  IBAN: Scalars["String"]["input"];
  /** SEPA Direct Debit Payment Mandate debtor address. */
  address: CompleteAddressInput;
  /** SEPA Direct Debit Payment Mandate debtor name. */
  name: Scalars["String"]["input"];
};

export type CreditLimitSettings = {
  __typename: "CreditLimitSettings";
  /** Authorized amount for the credit limit settings */
  authorizedAmount?: Maybe<Amount>;
  /** The amount currently available for borrowing */
  createdAt: Scalars["DateTime"]["output"];
  /** The different requests made for a credit limit. */
  creditLimitSettingsRequests: CreditLimitSettingsRequestConnection;
  currentCycle?: Maybe<RepaymentCycle>;
  cycles?: Maybe<RepaymentCycleConnection>;
  id: Scalars["ID"]["output"];
  /** The total amount owed */
  owedAmount: Amount;
  repaymentSettings: RepaymentSettings;
  statusInfo: CreditLimitSettingsStatusInfo;
  updatedAt: Scalars["DateTime"]["output"];
};

/** Inputs on the maximum credit limits requested. */
export type CreditLimitSettingsInput = {
  amount: AmountInput;
  message?: InputMaybe<Scalars["String"]["input"]>;
};

/** Rejection when an inputs contains an error */
export type CreditLimitSettingsNotFoundRejection = Rejection & {
  __typename: "CreditLimitSettingsNotFoundRejection";
  message: Scalars["String"]["output"];
};

/** Credit limit requested by the account’s legal representative. */
export type CreditLimitSettingsRequest = {
  __typename: "CreditLimitSettingsRequest";
  /** The amount claimed for the credit limits. */
  amount: Amount;
  /** The consent of the credit settings request. */
  consent: Consent;
  createdAt: Scalars["DateTime"]["output"];
  /** The ID of the credit settings request */
  id: Scalars["ID"]["output"];
  /** The amount claimed for the credit limits. */
  message?: Maybe<Scalars["String"]["output"]>;
  /** The repayment settings used for the reimbursements. */
  repaymentSettings: RepaymentSettings;
  /** The status of the credit settings request. */
  statusInfo: CreditLimitSettingsRequestStatusInfo;
  updatedAt: Scalars["DateTime"]["output"];
};

export type CreditLimitSettingsRequestApprovedStatusInfo = CreditLimitSettingsRequestStatusInfo & {
  __typename: "CreditLimitSettingsRequestApprovedStatusInfo";
  approvedAt: Scalars["DateTime"]["output"];
  status: CreditLimitSettingsRequestStatus;
};

export type CreditLimitSettingsRequestCanceledStatusInfo = CreditLimitSettingsRequestStatusInfo & {
  __typename: "CreditLimitSettingsRequestCanceledStatusInfo";
  canceledAt: Scalars["DateTime"]["output"];
  status: CreditLimitSettingsRequestStatus;
};

export type CreditLimitSettingsRequestConnection = Connection & {
  __typename: "CreditLimitSettingsRequestConnection";
  /** CardSettingsRequestEdge list */
  edges: Array<CreditLimitSettingsRequestEdge>;
  /** Information about the current, the previous and the next page */
  pageInfo: PageInfo;
  /** Total number of element in the list */
  totalCount: Scalars["Int"]["output"];
};

export type CreditLimitSettingsRequestConsentPendingStatusInfo =
  CreditLimitSettingsRequestStatusInfo & {
    __typename: "CreditLimitSettingsRequestConsentPendingStatusInfo";
    status: CreditLimitSettingsRequestStatus;
  };

/** Implements the Relay Edge interface */
export type CreditLimitSettingsRequestEdge = Edge & {
  __typename: "CreditLimitSettingsRequestEdge";
  /** Opaque identifier pointing to this node in the pagination mechanism */
  cursor: Scalars["String"]["output"];
  /** The Repayment Cycle entry */
  node: CreditLimitSettingsRequest;
};

export type CreditLimitSettingsRequestPendingReviewStatusInfo =
  CreditLimitSettingsRequestStatusInfo & {
    __typename: "CreditLimitSettingsRequestPendingReviewStatusInfo";
    status: CreditLimitSettingsRequestStatus;
  };

export type CreditLimitSettingsRequestRefusedStatusInfo = CreditLimitSettingsRequestStatusInfo & {
  __typename: "CreditLimitSettingsRequestRefusedStatusInfo";
  reasons: Array<Maybe<Scalars["String"]["output"]>>;
  refusedAt: Scalars["DateTime"]["output"];
  status: CreditLimitSettingsRequestStatus;
};

export type CreditLimitSettingsRequestStatus =
  | "Approved"
  | "Canceled"
  | "ConsentPending"
  | "Frozen"
  | "PendingReview"
  | "Refused";

export type CreditLimitSettingsRequestStatusInfo = {
  /** The status of the credit settings request. */
  status: CreditLimitSettingsRequestStatus;
};

export type CreditLimitSettingsStatusInfo = {
  /** The status of the credit limit. */
  status?: Maybe<CreditLimitStatus>;
};

export type CreditLimitStatus = "Activated" | "Deactivated" | "Pending" | "Suspended";

export type CreditLimitStatusActivatedInfo = CreditLimitSettingsStatusInfo & {
  __typename: "CreditLimitStatusActivatedInfo";
  status: CreditLimitStatus;
};

export type CreditLimitStatusDeactivatedInfo = CreditLimitSettingsStatusInfo & {
  __typename: "CreditLimitStatusDeactivatedInfo";
  /** The date when the credit limit got deactivated. */
  deactivatedAt: Scalars["DateTime"]["output"];
  status: CreditLimitStatus;
};

export type CreditLimitStatusPendingInfo = CreditLimitSettingsStatusInfo & {
  __typename: "CreditLimitStatusPendingInfo";
  status: CreditLimitStatus;
};

export type CreditLimitStatusSuspendedInfo = CreditLimitSettingsStatusInfo & {
  __typename: "CreditLimitStatusSuspendedInfo";
  status: CreditLimitStatus;
  /** The date when the credit limit got suspended. */
  suspendedAt: Scalars["DateTime"]["output"];
};

/** A statement represent metadata around a banking document that list all of the BOOKED banking transactions that have happened between startDate and endDate */
export type CreditStatement = {
  __typename: "CreditStatement";
  /** booked balance at the end of the window */
  closingBalance: Amount;
  /** ending date of the date window */
  closingDate: Scalars["DateTime"]["output"];
  /** created date */
  createdAt: Scalars["DateTime"]["output"];
  /** unique identifier of the statement */
  id: Scalars["ID"]["output"];
  /** booked balance at the start of the window */
  openingBalance: Amount;
  /** starting date of the date window */
  openingDate: Scalars["DateTime"]["output"];
  /** repayment cycle related to the statement */
  repaymentCycle?: Maybe<RepaymentCycle>;
  /** status of the statement */
  status: StatementStatus;
  /** the sum of credit transactions during the window */
  totalCredits: Amount;
  /** the sum of debit transactions during the window */
  totalDebits: Amount;
  /** type of statement (ex: PDF) */
  type: StatementInfo;
  /** updated date */
  updatedAt: Scalars["DateTime"]["output"];
};

export type CreditStatementPayload =
  | AccountNotFoundRejection
  | CreditStatement
  | CreditStatementSuccessPayload
  | ForbiddenRejection;

export type CreditStatementSuccessPayload = {
  __typename: "CreditStatementSuccessPayload";
  creditStatement?: Maybe<CreditStatement>;
};

/** Credit transfer */
export type CreditTransferInput = {
  /** amount of the transfer */
  amount: AmountInput;
  /**
   * * COMING SOON *
   * if the transfer will credit a new SEPA beneficiary and beneficiary verification was prepared with the 'verifyBeneficiary' mutation
   * Mandatory for batch transfer initiations unless the user opts-out from VoP.
   */
  beneficiaryVerificationToken?: InputMaybe<Scalars["String"]["input"]>;
  /**
   * ** COMING SOON**
   * categoryPurpose - Purpose of the payment transaction
   */
  categoryPurpose?: InputMaybe<CategoryPurpose>;
  /** an arbitrary identifier that you can define to easily identify this transaction later */
  externalReference?: InputMaybe<Scalars["String"]["input"]>;
  /** label (max 140 characters) */
  label?: InputMaybe<Scalars["String"]["input"]>;
  /**
   * ** COMING SOON**
   * labelType (default: unstructured)
   */
  labelType?: InputMaybe<LabelType>;
  /** if the transfer will execute as instant and fallbacked to a regular one if an error happend during the instant transfer */
  mode?: InputMaybe<CreditTransferMode>;
  /** reference assigned by the initiating party, to unambiguously identify the transaction. This reference is passed on, unchanged, throughout the entire end-to-end chain (regex [a-zA-Z0-9-?.+,/':() ]{1,35} and cannot begin nor end with /. Also, // is not allowed) */
  reference?: InputMaybe<Scalars["String"]["input"]>;
  /** requested date at which the credit transfer will try to be executed, if `null` the credit transfer is executed right away */
  requestedExecutionAt?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** if the transfer will credit a new SEPA beneficiary */
  sepaBeneficiary?: InputMaybe<SepaBeneficiaryInput>;
  /** if the transfer will credit a new swan account beneficiary */
  swanAccountBeneficiary?: InputMaybe<SwanAccountBeneficiaryInput>;
  /** if the transfer will credit an existing beneficiary */
  trustedBeneficiaryId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type CreditTransferMode = "InstantWithFallback" | "InstantWithoutFallback" | "Regular";

/** [DEPRECATED] Custom information for a CSV statement */
export type CsvStatement = StatementInfo & {
  __typename: "CsvStatement";
  /** date at which the link will not be useable anymore */
  expiresAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** statement type */
  type?: Maybe<StatementType>;
  /** temporary public url on which the file can be accessed */
  url?: Maybe<Scalars["String"]["output"]>;
};

export type Customer = {
  __typename: "Customer";
  /**
   * A customer id present in a third-party system.
   * Alows to link a customer to a payment link and by extension, to a Merchant Payment.
   */
  externalCustomerId?: Maybe<Scalars["String"]["output"]>;
  iban?: Maybe<Scalars["String"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
};

export type CustomerInput = {
  /**
   * A customer ID present in a third-party system.
   * Alows to link a customer to a payment link and by extension, to a merchant payment.
   */
  externalCustomerId?: InputMaybe<Scalars["String"]["input"]>;
  /** Customer IBAN */
  iban?: InputMaybe<Scalars["String"]["input"]>;
  /** Customer name */
  name?: InputMaybe<Scalars["String"]["input"]>;
};

export type DateField = Field & {
  __typename: "DateField";
  example?: Maybe<Scalars["String"]["output"]>;
  key: Scalars["String"]["output"];
  name: Scalars["String"]["output"];
  required: Scalars["Boolean"]["output"];
  validationRegex?: Maybe<Scalars["String"]["output"]>;
};

export type DayEnum =
  | "Friday"
  | "Monday"
  | "Saturday"
  | "Sunday"
  | "Thursday"
  | "Tuesday"
  | "Wednesday";

export type DeactivateUserInput = {
  /** ID of the user to deactivate */
  userId: Scalars["ID"]["input"];
};

export type DeactivateUserPayload =
  | DeactivateUserSuccess
  | UserAlreadyDeactivatedRejection
  | UserCannotBeDeactivatedRejection
  | UserNotFoundRejection;

export type DeactivateUserSuccess = {
  __typename: "DeactivateUserSuccess";
  user: User;
};

/** Rejection returned when the Debtor is closed */
export type DebtorAccountClosedRejection = Rejection & {
  __typename: "DebtorAccountClosedRejection";
  message: Scalars["String"]["output"];
};

/** Rejection returned when the Debtor does not belong to the same project as the creditor */
export type DebtorAccountNotAllowedRejection = Rejection & {
  __typename: "DebtorAccountNotAllowedRejection";
  message: Scalars["String"]["output"];
};

export type DefaultAdditionalInformation = {
  __typename: "DefaultAdditionalInformation";
  type: AdditionalInformationType;
  value: Scalars["String"]["output"];
};

export type DefaultAdditionalInformationInput = {
  type: AdditionalInformationType;
  value: Scalars["String"]["input"];
};

/** Deferred transaction status information */
export type DeferredTransactionStatusInfo = TransactionStatusInfo & {
  __typename: "DeferredTransactionStatusInfo";
  /** The date when the deferred amount of this transaction is released */
  deferredEndDate?: Maybe<Scalars["DateTime"]["output"]>;
  /** unique identifier of the transaction */
  id: Scalars["ID"]["output"];
  /** the associated repayment cycle id */
  repaymentCycleId: Scalars["ID"]["output"];
  /** status of the transaction */
  status: TransactionStatus;
};

/** if value is not set, the existing value will be erased */
export type DeletablePaymentFrequency = {
  value?: InputMaybe<MerchantProfilePaymentFrequency>;
};

/** Input for the `deleteExportFile` mutation. */
export type DeleteExportFileInput = {
  /**
   * The `exportId` generated by a previous call to any export mutation.
   *
   * NB: The export needs to be completed for the file to be deleted.
   */
  exportId: Scalars["String"]["input"];
};

export type DeleteExportFilePayload =
  | DeleteExportFileSuccessPayload
  | StillExportingRejection
  | UnknownExportRejection;

/** Payload of the `deleteExportFile` mutation in case of success. */
export type DeleteExportFileSuccessPayload = {
  __typename: "DeleteExportFileSuccessPayload";
  /** The exportId of the deleted file. */
  exportId: Scalars["String"]["output"];
};

export type DeleteSupportingDocumentInput = {
  /** Id of the supporting document to delete */
  id: Scalars["ID"]["input"];
};

export type DeleteSupportingDocumentPayload =
  | DeleteSupportingDocumentSuccessPayload
  | ForbiddenRejection
  | InternalErrorRejection
  | SupportingDocumentCollectionNotFoundRejection
  | SupportingDocumentCollectionStatusDoesNotAllowDeletionRejection
  | SupportingDocumentNotFoundRejection
  | SupportingDocumentStatusDoesNotAllowDeletionRejection
  | ValidationRejection;

export type DeleteSupportingDocumentSuccessPayload = {
  __typename: "DeleteSupportingDocumentSuccessPayload";
  id: Scalars["String"]["output"];
};

export type DenySddInput = {
  accountId: Scalars["ID"]["input"];
};

export type DenySddPayload =
  | AccountNotFoundRejection
  | BadAccountStatusRejection
  | DenySddSuccessPayload
  | InvalidArgumentRejection
  | ValidationRejection;

export type DenySddSuccessPayload = {
  __typename: "DenySddSuccessPayload";
  account: Account;
};

export type DenySddVirtualIbanEntryInput = {
  ibanEntryId: Scalars["ID"]["input"];
};

export type DenySddVirtualIbanEntryPayload =
  | BadAccountStatusRejection
  | DenySddVirtualIbanEntrySuccessPayload
  | ValidationRejection;

export type DenySddVirtualIbanEntrySuccessPayload = {
  __typename: "DenySddVirtualIbanEntrySuccessPayload";
  virtualIbanEntry: VirtualIbanEntry;
};

/** Device */
export type Device = {
  __typename: "Device";
  /**
   * Device name
   * End user defined name of the device on which the card id provided
   */
  name?: Maybe<Scalars["String"]["output"]>;
  /** The type of device. It can be a Phone, Tablet, Watch */
  type?: Maybe<Scalars["String"]["output"]>;
};

/** Digital Card used for ApplePay or GooglePay */
export type DigitalCard = {
  /** The card contract ID */
  cardContractId: Scalars["ID"]["output"];
  /** Created date */
  createdAt: Scalars["DateTime"]["output"];
  /** Unique identifier of a digital card */
  id: Scalars["ID"]["output"];
  /** The project ID */
  projectId: Scalars["ID"]["output"];
  /** Reference of the token in another system (ex: Mastercard) */
  tokenReferenceId?: Maybe<Scalars["String"]["output"]>;
  /** The type of digitalization that created this digital card. */
  type: DigitalizationType;
  /** Updated date */
  updatedAt: Scalars["DateTime"]["output"];
  /** Wallet Provider (ApplePay, GooglePay ...) */
  walletProvider: WalletProvider;
};

/** Digital Card Canceled Status Information */
export type DigitalCardCanceledStatusInfo = CompleteDigitalCardStatusInfo & {
  __typename: "DigitalCardCanceledStatusInfo";
  /** Cancel Date */
  canceledAt: Scalars["DateTime"]["output"];
  /** Enable Date */
  enabledAt: Scalars["DateTime"]["output"];
  /** Card status (always Canceled for type DigitalCardCanceledStatusInfo). */
  status: CompleteDigitalCardStatus;
};

/** Implements the Relay Connection interface, used to paginate lists of elements. ([Learn More](https://docs.swan.io/developers/using-api/pagination)) */
export type DigitalCardConnection = Connection & {
  __typename: "DigitalCardConnection";
  /** CardEdge list */
  edges: Array<DigitalCardEdge>;
  /** Information about the current, the previous and the next page */
  pageInfo: PageInfo;
  /** Total number of element in the list */
  totalCount: Scalars["Int"]["output"];
};

/** Digital Card ConsentPending Status Information */
export type DigitalCardConsentPendingStatusInfo = PendingDigitalCardStatusInfo & {
  __typename: "DigitalCardConsentPendingStatusInfo";
  /** A reference to the consent to validate */
  consent: Consent;
  /** Digital Card status (always ConsentPending for type DigitalCardConsentPendingStatusInfo). */
  status: PendingDigitalCardStatus;
};

/** Digital Card Declined Status Information */
export type DigitalCardDeclinedStatusInfo = PendingDigitalCardStatusInfo & {
  __typename: "DigitalCardDeclinedStatusInfo";
  /** Digital Card status (always Declined for type DigitalCardDeclinedStatusInfo). */
  status: PendingDigitalCardStatus;
};

/** Implements the Relay Edge interface */
export type DigitalCardEdge = Edge & {
  __typename: "DigitalCardEdge";
  /** Opaque identifier pointing to this node in the pagination mechanism */
  cursor: Scalars["String"]["output"];
  /** The Card entry */
  node: DigitalCard;
};

/** Digital Card Enabled Status Information */
export type DigitalCardEnabledStatusInfo = CompleteDigitalCardStatusInfo & {
  __typename: "DigitalCardEnabledStatusInfo";
  /** Enable Date */
  enabledAt: Scalars["DateTime"]["output"];
  /** Digital Card status (always Enabled for type DigitalCardEnabledStatusInfo). */
  status: CompleteDigitalCardStatus;
};

/** Filters that can be applied when listing digitalCards */
export type DigitalCardFiltersInput = {
  /** The digital card masker number */
  cardMaskedNumber?: InputMaybe<Scalars["String"]["input"]>;
  /** The id of the digitalCard */
  id?: InputMaybe<Scalars["String"]["input"]>;
  /**
   * The status of the digital card.
   * Available statuses are:
   * - Declined
   * - ConsentPending
   * - Pending
   * - Enabled
   * - Suspended
   * - Canceled
   * It can be a CompleteDigitalCardStatus or a PendingDigitalCardStatus
   */
  status?: InputMaybe<Scalars["String"]["input"]>;
  /** Reference of the token in another system (ex: Mastercard) */
  tokenReferenceId?: InputMaybe<Scalars["String"]["input"]>;
  /** Tokens references in another system (ex: Mastercard) */
  tokenReferenceIds?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** The ID of the wallet provider in the scheme system */
  walletProviderId?: InputMaybe<Scalars["String"]["input"]>;
  /** Either ApplePay or GooglePay */
  walletProviderName?: InputMaybe<Scalars["String"]["input"]>;
};

/** Rejection returned when the Digital Card does not exist */
export type DigitalCardNotFoundRejection = Rejection & {
  __typename: "DigitalCardNotFoundRejection";
  identifier: Scalars["String"]["output"];
  message: Scalars["String"]["output"];
};

/** Field we can use when ordering that can be applied when listing digital cards */
export type DigitalCardOrderByFieldInput = "createdAt" | "id" | "updatedAt";

/** Order that can be applied when listing digital cards */
export type DigitalCardOrderByInput = {
  direction?: InputMaybe<OrderByDirection>;
  field?: InputMaybe<DigitalCardOrderByFieldInput>;
};

/** Digital Card Pending Status Information */
export type DigitalCardPendingStatusInfo = PendingDigitalCardStatusInfo & {
  __typename: "DigitalCardPendingStatusInfo";
  /** Digital Card status (always Pending for type DigitalCardPendingStatusInfo). */
  status: PendingDigitalCardStatus;
};

/** Digital Card Suspended Status Information */
export type DigitalCardSuspendedStatusInfo = CompleteDigitalCardStatusInfo & {
  __typename: "DigitalCardSuspendedStatusInfo";
  /** Enable Date */
  enabledAt: Scalars["DateTime"]["output"];
  /** Digital Card status (always Suspended for type DigitalCardSuspendedStatusInfo). */
  status: CompleteDigitalCardStatus;
  /** Suspend Date */
  suspendedAt: Scalars["DateTime"]["output"];
};

/** Digitalization Type */
export type DigitalizationType =
  /** This digital card was created based on a PAN stored into a merchant application (ex: iTunes) */
  | "CardOnFile"
  /** This digital card was created by an in app provisioning */
  | "InApp"
  /**
   * This digital card was created by direct input of the PAN into a wallet application
   *
   * This direct input can also be done using the device camera
   */
  | "Manual"
  /** We could not get the source of the digitalization */
  | "Unknown";

/** Direct Debit Account Verification */
export type DirectDebitAccountVerification = AccountVerification & {
  __typename: "DirectDebitAccountVerification";
  /** Creation date of the account verification */
  createdAt: Scalars["DateTime"]["output"];
  /** IBAN of the account to cross check with account holder information */
  iban: Scalars["IBAN"]["output"];
  /** Unique identifier of the Account Verification */
  id: Scalars["ID"]["output"];
  /** Account Verification Status Information */
  statusInfo: AccountVerificationStatusInfo;
  /** Last update date of the account verification */
  updatedAt: Scalars["DateTime"]["output"];
};

/** Funding Source with Direct Debit Mandate */
export type DirectDebitFundingSource = FundingSource & {
  __typename: "DirectDebitFundingSource";
  /**
   * Can be queried to check the status of the account verification for this funding source.
   * If the account verification is PendingVerification, you should ask your account holder to wire some money from his external account to any swan account
   */
  accountVerification: DirectDebitAccountVerification;
  /** Created date */
  createdAt: Scalars["DateTime"]["output"];
  /**
   * IBAN to use in the direct debit transaction that will be triggered when funding the account.
   * Money will be debited from this IBAN when an `initiateFundingRequest` is done using this funding source
   */
  iban: Scalars["IBAN"]["output"];
  /** ID of the Funding Source */
  id: Scalars["ID"]["output"];
  /** Name of the Funding Source */
  name?: Maybe<Scalars["String"]["output"]>;
  /**
   * Can be queried to check the status of payment payment Mandate.
   * If the payment mandate is ConsentPending, you should confirm it to enable this funding source
   */
  paymentMandate: PaymentDirectDebitMandate;
  /** Funding Source status information */
  statusInfo: FundingSourceStatusInfo;
  /** Last updated date */
  updatedAt: Scalars["DateTime"]["output"];
};

export type DirectDebitSequence = "OneOff" | "Recurrent";

/** Input to disable an account membership */
export type DisableAccountMembershipInput = {
  /** Unique identifier of the account membership to disable */
  accountMembershipId: Scalars["ID"]["input"];
};

export type DisableAccountMembershipPayload =
  | AccountMembershipCannotBeDisabledRejection
  | AccountMembershipNotFoundRejection
  | DisableAccountMembershipSuccessPayload
  | ForbiddenRejection
  | InternalErrorRejection
  | LegalRepresentativeAccountMembershipCannotBeDisabledRejection
  | UserNotAllowedToDisableItsOwnAccountMembershipRejection
  | ValidationRejection;

export type DisableAccountMembershipSuccessPayload = {
  __typename: "DisableAccountMembershipSuccessPayload";
  accountMembership?: Maybe<AccountMembership>;
};

export type DisableMerchantPaymentMethodInput = {
  /** ID of the merchant payment method to disable */
  merchantPaymentMethodId: Scalars["ID"]["input"];
};

export type DisableMerchantPaymentMethodPayload =
  | DisableMerchantPaymentMethodSuccessPayload
  | ForbiddenRejection
  | InternalErrorRejection
  | MerchantPaymentMethodWrongStatusRejection
  | NotFoundRejection;

export type DisableMerchantPaymentMethodSuccessPayload = {
  __typename: "DisableMerchantPaymentMethodSuccessPayload";
  /** Merchant Payment Method ID */
  merchantPaymentMethodId: Scalars["ID"]["output"];
};

export type DisableMerchantProfileInput = {
  /** ID of the merchant profile to disable */
  merchantProfileId: Scalars["ID"]["input"];
};

export type DisableMerchantProfilePayload =
  | DisableMerchantProfileSuccessPayload
  | ForbiddenRejection
  | InternalErrorRejection
  | NotFoundRejection;

export type DisableMerchantProfileSuccessPayload = {
  __typename: "DisableMerchantProfileSuccessPayload";
  /** Merchant Profile */
  merchantProfile: MerchantProfile;
};

/** StatusInfo when funding limit settings has been disabled */
export type DisabledFundingLimitSettingsStatusInfo = FundingLimitSettingsStatusInfo & {
  __typename: "DisabledFundingLimitSettingsStatusInfo";
  reason: Scalars["String"]["output"];
  status: FundingLimitSettingsStatus;
};

/** EnabledMerchantPaymentMethodStatusInfo */
export type DisabledMerchantPaymentMethodStatusInfo = MerchantPaymentMethodStatusInfo & {
  __typename: "DisabledMerchantPaymentMethodStatusInfo";
  /** Merchant Payment Method disabled date */
  disabledAt: Scalars["Date"]["output"];
  status: MerchantPaymentMethodStatus;
};

/** DisabledMerchantProfileStatusInfo */
export type DisabledMerchantProfileStatusInfo = MerchantProfileStatusInfo & {
  __typename: "DisabledMerchantProfileStatusInfo";
  disabledAt: Scalars["Date"]["output"];
  status: MerchantProfileStatus;
};

/** Rejection returned if the document cannot be found */
export type DocumentCanNotBeFoundRejection = Rejection & {
  __typename: "DocumentCanNotBeFoundRejection";
  id: Scalars["String"]["output"];
  message: Scalars["String"]["output"];
};

/** Rejection returned if the document cannot be rejected */
export type DocumentCanNotBeRejectedRejection = Rejection & {
  __typename: "DocumentCanNotBeRejectedRejection";
  id: Scalars["String"]["output"];
  message: Scalars["String"]["output"];
};

/** Retrieved document extracted from the identity verification */
export type DocumentFile = {
  downloadUrl: Scalars["String"]["output"];
};

/** From which side the document picture was taken */
export type DocumentFileSide = "BothSides" | "SideA" | "SideB" | "Unknown";

/** Rejection returned if the document-parent link is missing */
export type DocumentParentLinkMissingRejection = Rejection & {
  __typename: "DocumentParentLinkMissingRejection";
  id: Scalars["String"]["output"];
  message: Scalars["String"]["output"];
};

/** Reason code of the document. */
export type DocumentReasonCode =
  /** Document is damaged, in poor condition, or has not been uploaded in the correct file type. */
  | "BadDocumentQuality"
  /** Company name in document doesn't match our records. */
  | "CompanyNameMismatch"
  /** Document refused for compliance reasons. */
  | "ComplianceReason"
  /** Declared amount in document doesn't match the expected amount. */
  | "DeclaredAmountMismatch"
  /** One of the provided documents is too old. */
  | "ExpiredDocument"
  /** Only part of the document was provided. */
  | "FullDocumentRequired"
  /** The signature is not handwritten or electronically certified. */
  | "HandwrittenOrCertifiedElectronicSignatureRequired"
  /** Address in document doesn't match our records. */
  | "InvalidAddress"
  /** Bank name in articles of association document is invalid. */
  | "InvalidDepositBankName"
  /** Default value when none of the other values is appropriate. */
  | "InvalidDocument"
  /** Some information is missing. */
  | "InvalidOrMissingData"
  /** Missing identity document of accommodation provider. */
  | "MissingAccommodationProviderId"
  /** Missing identity document and proof of accommodation from accommodation provider. */
  | "MissingAccommodationProviderIdLetter"
  /** Missing proof of accommodation from accommodation provider. */
  | "MissingAccommodationProviderLetter"
  /** Missing company domiciliation statement. */
  | "MissingCompanyDomiciliationStatement"
  /** Missing the register extract of the company providing accommodation and ID document of the legal representative. */
  | "MissingCompanyProviderRegisterExtract"
  /** Missing accommodation provider's proof of address. */
  | "MissingProviderProofOfAddress"
  /** Missing accommodation provider's proof of address and ID document. */
  | "MissingProviderProofOfAddressAndIdDocument"
  /** Document must be signed, either by hand or electronically with certification. */
  | "MissingSignature"
  /** Power of attorney must be provided to Swan. */
  | "PowerOfAttorneyToSwanRequired"
  /** Accommodation provider's identity document must be in full color. */
  | "ProviderColorIdDocumentRequired"
  /** Document cannot be accepted for the requested document type. Refer to the [list of accepted documents](https://docs.swan.io/partnership/document-center/proof-address/). */
  | "UnacceptableDocument";

/** The type of the document */
export type DocumentType =
  | "DriversLicense"
  | "Face"
  | "IdCard"
  | "Passport"
  | "Report"
  | "ResidencePermit";

/** The document corresponding to a driver's license */
export type DriversLicenseDocument = {
  __typename: "DriversLicenseDocument";
  /** List of the associated files */
  files: Array<DriversLicenseDocumentFile>;
  /** Unique identifier of the driver's license document */
  id: Scalars["String"]["output"];
  /** The type of the document */
  type: DocumentType;
};

/** The file associated to the driver's license document */
export type DriversLicenseDocumentFile = DocumentFile & {
  __typename: "DriversLicenseDocumentFile";
  /** The file's temporary download url */
  downloadUrl: Scalars["String"]["output"];
  /** From which side the deiver's license's picture was taken */
  side: DocumentFileSide;
};

export type DuplicateCheckRejection = Rejection & {
  __typename: "DuplicateCheckRejection";
  id: Scalars["String"]["output"];
  message: Scalars["String"]["output"];
};

/**
 * Edge type containing the node and cursor. The node is not defined in the interface because generic is not supported by GraphQL
 * but all implementation contains its own node property according to the paginated type.
 */
export type Edge = {
  /** Opaque identifier pointing to this node in the pagination mechanism */
  cursor: Scalars["String"]["output"];
};

/** Employment status. */
export type EmploymentStatus =
  | "Craftsman"
  | "Employee"
  | "Entrepreneur"
  | "Farmer"
  | "Manager"
  | "Practitioner"
  | "Retiree"
  | "ShopOwner"
  | "Student"
  | "Unemployed";

/** Inputs to enable a received direct debit mandate, i.e. to move its status back from suspended. */
export type EnableReceivedDirectDebitMandateInput = {
  /** URL the user is redirected to after consent has been given */
  consentRedirectUrl?: InputMaybe<Scalars["String"]["input"]>;
  /** The received direct debit id to enable */
  receivedDirectDebitMandateId: Scalars["ID"]["input"];
};

/** Union type return by the enableReceivedDirectDebitMandate mutation */
export type EnableReceivedDirectDebitMandatePayload =
  | EnableReceivedDirectDebitMandateSuccessPayload
  | ForbiddenRejection
  | ReceivedDirectDebitMandateCanceledRejection
  | ReceivedDirectDebitMandateNotFoundRejection
  | ValidationRejection;

/** Return type in case of a successful response of the enableReceivedDirectDebitMandate mutation */
export type EnableReceivedDirectDebitMandateSuccessPayload = {
  __typename: "EnableReceivedDirectDebitMandateSuccessPayload";
  /** The received direct debit mandate is enable, i.e that it is moved back to from the suspended to the enabled status */
  receivedDirectDebitMandate: ReceivedDirectDebitMandate;
};

/** Rejection returned if the card product don't have a card design enabled */
export type EnabledCardDesignNotFoundRejection = Rejection & {
  __typename: "EnabledCardDesignNotFoundRejection";
  message: Scalars["String"]["output"];
};

/** StatusInfo when the funding limit settings is enabled */
export type EnabledFundingLimitSettingsStatusInfo = FundingLimitSettingsStatusInfo & {
  __typename: "EnabledFundingLimitSettingsStatusInfo";
  status: FundingLimitSettingsStatus;
};

/** Funding Source Enabled status information */
export type EnabledFundingSourceStatusInfo = FundingSourceStatusInfo & {
  __typename: "EnabledFundingSourceStatusInfo";
  /** Date at which the funding source was enabled */
  enabledAt: Scalars["Date"]["output"];
  /** Funding Source Enabled status */
  status: FundingSourceStatus;
};

/** EnabledMerchantPaymentMethodStatusInfo */
export type EnabledMerchantPaymentMethodStatusInfo = MerchantPaymentMethodStatusInfo & {
  __typename: "EnabledMerchantPaymentMethodStatusInfo";
  /** Merchant Payment Method enabled date */
  enabledAt: Scalars["Date"]["output"];
  status: MerchantPaymentMethodStatus;
};

/** EnabledMerchantProfileStatusInfo */
export type EnabledMerchantProfileStatusInfo = MerchantProfileStatusInfo & {
  __typename: "EnabledMerchantProfileStatusInfo";
  enabledAt: Scalars["Date"]["output"];
  status: MerchantProfileStatus;
};

export type EnrichedTransactionInfo = {
  __typename: "EnrichedTransactionInfo";
  /** Merchant address */
  address?: Maybe<Scalars["String"]["output"]>;
  /** Transaction carbon footprint in micrograms of CO2 emitted */
  carbonFootprint?: Maybe<Scalars["String"]["output"]>;
  /** Merchant category */
  category?: Maybe<MerchantCategory>;
  /** Merchant city */
  city?: Maybe<Scalars["String"]["output"]>;
  /** Merchant email */
  contactEmail?: Maybe<Scalars["String"]["output"]>;
  /** Merchant phone */
  contactPhone?: Maybe<Scalars["String"]["output"]>;
  /** Merchant website */
  contactWebsite?: Maybe<Scalars["String"]["output"]>;
  /** Merchant country */
  country?: Maybe<Scalars["CCA3"]["output"]>;
  /** Well formatted merchant name */
  enrichedMerchantName?: Maybe<Scalars["String"]["output"]>;
  /** Is merchant a subcription */
  isSubscription?: Maybe<Scalars["Boolean"]["output"]>;
  /** Merchant location latitude */
  latitude?: Maybe<Scalars["String"]["output"]>;
  /** URL of the merchant logo */
  logoUrl?: Maybe<Scalars["String"]["output"]>;
  /** Merchant location longitude */
  longitude?: Maybe<Scalars["String"]["output"]>;
  /** Merchant postal code */
  postalCode?: Maybe<Scalars["String"]["output"]>;
  /** Merchant subcategory */
  subcategory?: Maybe<MerchantSubCategory>;
};

export type EnvType = "Live" | "Sandbox";

export type EventTypeHavingReachedSubscriptionLimits = {
  __typename: "EventTypeHavingReachedSubscriptionLimits";
  eventType: Scalars["String"]["output"];
  subscriptionCount: Scalars["Int"]["output"];
};

export type ExemptThreeDsStatusInfo = ThreeDsStatusInfo & {
  __typename: "ExemptThreeDsStatusInfo";
  status: IncomingThreeDsStatus;
};

export type ExpectedMonthlyMerchantProcessingVolume =
  | "Between5000And10000"
  | "Between10000And100000"
  | "LessThan5000"
  | "MoreThan100000";

/** Describes an identification level for the process associated to this identification that has expired and is no longer considered valid */
export type ExpiredIdentificationLevelStatusInfo = {
  __typename: "ExpiredIdentificationLevelStatusInfo";
  /** When this identification level expired */
  expiredAt: Scalars["Date"]["output"];
  /** Always set to `Expired` */
  status: SwanIdentificationStatus;
};

export type ExpiredMerchantPaymentLinkStatusInfo = MerchantPaymentLinkStatusInfo & {
  __typename: "ExpiredMerchantPaymentLinkStatusInfo";
  /**
   * The date when the payment link expired.
   * By default the payment link expires 120 days after it was created.
   */
  expiredAt: Scalars["DateTime"]["output"];
  status: MerchantPaymentLinkStatus;
};

export type ExpiredTransactionStatementStatusInfo = TransactionStatementStatusInfo & {
  __typename: "ExpiredTransactionStatementStatusInfo";
  /** date at which the document expired */
  expiredAt: Scalars["DateTime"]["output"];
  /** status of the transaction statement */
  status: TransactionStatementStatusEnum;
};

/** An export is the process of exporting a collection of entities from a project */
export type Export = {
  __typename: "Export";
  /** Created date */
  createdAt: Scalars["DateTime"]["output"];
  /** Unique identifier of an export */
  id: Scalars["ID"]["output"];
  /** Status information of an export */
  statusInfo: ExportStatusInfo;
  /** Type of data exported */
  type: ExportType;
};

/** Input filters for the `exportAccountData` mutation. */
export type ExportAccountDataFilters = {
  /** Possible main IBAN. */
  mainIBAN?: InputMaybe<Scalars["String"]["input"]>;
  /** Possible payment level type. */
  paymentLevels?: InputMaybe<Array<PaymentLevelType>>;
  /** Search string to look for in accounts. */
  search?: InputMaybe<Scalars["String"]["input"]>;
  /** Possible values for account status. */
  status?: InputMaybe<Array<AccountStatus>>;
};

/** Input for the `exportAccountData` mutation. */
export type ExportAccountDataInput = {
  /** If provided, the email address that will receive a notification when the export is completed. */
  email?: InputMaybe<Scalars["String"]["input"]>;
  /** Account filters. */
  filters?: InputMaybe<ExportAccountDataFilters>;
};

/** Input filters for the `exportAccountHolderData` mutation. */
export type ExportAccountHolderDataFilters = {
  /** Birth date to filter account holders. */
  birthDate?: InputMaybe<Scalars["String"]["input"]>;
  /** Registration number to filter account holders. */
  registrationNumber?: InputMaybe<Scalars["String"]["input"]>;
  /** Search string to look for in account holders. */
  search?: InputMaybe<Scalars["String"]["input"]>;
  /** Possible account holder status. */
  status?: InputMaybe<Array<AccountHolderStatus>>;
  /** Possible account holder type. */
  types?: InputMaybe<Array<AccountHolderType>>;
  /** Possible values for account holder verification status. */
  verificationStatus?: InputMaybe<Array<VerificationStatus>>;
};

/** Input for the `exportAccountHolderData` mutation. */
export type ExportAccountHolderDataInput = {
  /** If provided, the email address that will receive a notification when the export is completed. */
  email?: InputMaybe<Scalars["String"]["input"]>;
  /** Account holder filters. */
  filters?: InputMaybe<ExportAccountHolderDataFilters>;
};

/** Input filters for the `exportAccountMembershipData` mutation. */
export type ExportAccountMembershipDataFilters = {
  /** Value for AccountId. */
  accountId?: InputMaybe<Scalars["String"]["input"]>;
  /** Value for canInitiatePayments. */
  canInitiatePayments?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Value for canManageAccountMembership. */
  canManageAccountMembership?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Value for canManageBeneficiaries. */
  canManageBeneficiaries?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Value for canManageCards. */
  canManageCards?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Value for canViewAccount. */
  canViewAccount?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Can be a partial email. */
  email?: InputMaybe<Scalars["String"]["input"]>;
  /** Search string to look for in account memberships. */
  search?: InputMaybe<Scalars["String"]["input"]>;
  /** Possible values for account membership verification status. */
  status?: InputMaybe<Array<AccountMembershipStatus>>;
};

/** Input for the `exportAccountMembershipData` mutation. */
export type ExportAccountMembershipDataInput = {
  /** If provided, the email address that will receive a notification when the export is completed. */
  email?: InputMaybe<Scalars["String"]["input"]>;
  /** Account membership filters. */
  filters?: InputMaybe<ExportAccountMembershipDataFilters>;
};

/** Input filters for the `exportCardData` mutation. */
export type ExportCardDataFilters = {
  /** Value for AccountId. */
  accountId?: InputMaybe<Scalars["String"]["input"]>;
  /** Search string to look for in cards. */
  search?: InputMaybe<Scalars["String"]["input"]>;
  /** Possible values for card status. */
  statuses?: InputMaybe<Array<CardStatus>>;
  /** Possible values for card type. */
  types?: InputMaybe<Array<CardType>>;
  /** Value for UserId. */
  userId?: InputMaybe<Scalars["String"]["input"]>;
};

/** Input for the `exportCardData` mutation. */
export type ExportCardDataInput = {
  /** If provided, the email address that will receive a notification when the export is completed. */
  email?: InputMaybe<Scalars["String"]["input"]>;
  /** Card filters. */
  filters?: InputMaybe<ExportCardDataFilters>;
};

/** Export Completed Status Information */
export type ExportCompletedStatusInfo = ExportStatusInfo & {
  __typename: "ExportCompletedStatusInfo";
  /** Status of the export. */
  status: ExportStatus;
};

/** Implements the Relay Connection interface, used to paginate list of elements ([Learn More](https://docs.swan.io/api/pagination)) */
export type ExportConnection = Connection & {
  __typename: "ExportConnection";
  /** ExportEdge list */
  edges: Array<ExportEdge>;
  /** Information about the current, the previous and the next page */
  pageInfo: PageInfo;
  /** Total number of elements in the list */
  totalCount: Scalars["Int"]["output"];
};

/** Common types shared across all export mutations. */
export type ExportDataPayload =
  | ExportDataSuccessPayload
  | MaximumDailyExportsReachedRejection
  | MaximumSimultaneousExportsRejection
  | ValidationRejection;

/** Payload of any export mutation in case of success. */
export type ExportDataSuccessPayload = {
  __typename: "ExportDataSuccessPayload";
  /**
   * The unique identifier of the data export process running on our end.
   *
   * Used to generate a temporary download link when the process is completed.
   */
  exportId: Scalars["String"]["output"];
};

/** Implements the Relay Edge interface */
export type ExportEdge = Edge & {
  __typename: "ExportEdge";
  /** Opaque identifier pointing to this export node in the pagination mechanism */
  cursor: Scalars["String"]["output"];
  /** The export */
  node: Export;
};

/** Export Expired Status Information */
export type ExportExpiredStatusInfo = ExportStatusInfo & {
  __typename: "ExportExpiredStatusInfo";
  /** Status of the export. */
  status: ExportStatus;
};

/** Export Failed Status Information */
export type ExportFailedStatusInfo = ExportStatusInfo & {
  __typename: "ExportFailedStatusInfo";
  /** Status of the export. */
  status: ExportStatus;
};

export type ExportFilterInput = {
  /**
   * Filter to only retrieve exports of these types
   * Defaults to all types indiscriminately
   */
  exportTypes?: InputMaybe<Array<ExportType>>;
  /**
   * Lower bound to retrieve exports created after this moment
   * Defaults to no bound
   */
  isAfterCreatedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
  /**
   * Upper bound to retrieve exports created before this moment
   * Defaults to no bound
   */
  isBeforeCreatedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
  /**
   * Filter to only retrieve exports with these statuses
   * Defaults to ally statuses indiscriminately
   */
  statuses?: InputMaybe<Array<ExportStatus>>;
};

/** Input filters for the `exportOnboardingData` mutation. */
export type ExportOnboardingDataFilters = {
  /** Can be a partial email. */
  email?: InputMaybe<Scalars["String"]["input"]>;
  /** Search string to look for in onboardings. */
  search?: InputMaybe<Scalars["String"]["input"]>;
  /** Possible values for onboarding status. */
  status?: InputMaybe<Array<OnboardingStatus>>;
  /** Possible account holder type. */
  types?: InputMaybe<Array<AccountHolderType>>;
};

/** Input for the `exportOnboardingData` mutation. */
export type ExportOnboardingDataInput = {
  /** If provided, the email address that will receive a notification when the export is completed. */
  email?: InputMaybe<Scalars["String"]["input"]>;
  /** Onboarding filters. */
  filters?: InputMaybe<ExportOnboardingDataFilters>;
};

/** Export Running Status Information */
export type ExportRunningStatusInfo = ExportStatusInfo & {
  __typename: "ExportRunningStatusInfo";
  /** Status of the export. */
  status: ExportStatus;
};

/** The status of any given export */
export type ExportStatus = "Completed" | "Expired" | "Failed" | "Running";

/** Export Status Information */
export type ExportStatusInfo = {
  /** Status of the export. */
  status: ExportStatus;
};

/** Input filters for the `exportTransactionData` mutation. */
export type ExportTransactionDataFilters = {
  /** An exact amount value. */
  amount?: InputMaybe<Scalars["AmountValue"]["input"]>;
  /** Rejected transactions that had a fallback. */
  includeRejectedWithFallback?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Above an amount value (inclusive). */
  isAboveAmount?: InputMaybe<Scalars["AmountValue"]["input"]>;
  /** Date after an executation date value (inclusive). */
  isAfterExecutionDate?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** Date after an updatedAt value (inclusive). */
  isAfterUpdatedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** Date before an executionDate value (exclusive) */
  isBeforeExecutionDate?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** Date before an updatedAt value (exclusive). */
  isBeforeUpdatedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** Below an amount value (inclusive). */
  isBelowAmount?: InputMaybe<Scalars["AmountValue"]["input"]>;
  /** Possible values for transaction payment product. */
  paymentProduct?: InputMaybe<Array<PaymentProduct>>;
  /** Search string to look for in the transaction. */
  search?: InputMaybe<Scalars["String"]["input"]>;
  /** Possible values for transaction status. */
  status?: InputMaybe<Array<TransactionStatus>>;
  /** Possible values for transaction type. */
  type?: InputMaybe<Array<TransactionTypeEnum>>;
};

/** Input for the `exportTransactionData` mutation. */
export type ExportTransactionDataInput = {
  /** If provided, the email address that will receive a notification when the export is completed. */
  email?: InputMaybe<Scalars["String"]["input"]>;
  /** Transaction filters. */
  filters?: InputMaybe<ExportTransactionDataFilters>;
};

/** The type of data exported for any given export */
export type ExportType =
  | "AccountHolders"
  | "AccountMemberships"
  | "Accounts"
  | "Cards"
  | "Onboardings"
  | "Transactions"
  | "Users";

/** Input filters for the `exportUserData` mutation. */
export type ExportUserDataFilters = {
  /** Birth date filter. */
  birthDate?: InputMaybe<Scalars["Date"]["input"]>;
  /** Identification level filter. */
  identificationLevel?: InputMaybe<IdentificationLevelInput>;
  /** Mobile phone number filter. */
  mobilePhoneNumber?: InputMaybe<Scalars["String"]["input"]>;
  /** Nationality filter (ISO 3166-1 alpha-3 country code). */
  nationalityCCA3?: InputMaybe<Scalars["CCA3"]["input"]>;
  /** Preferred notification channel filter. */
  preferredNotificationChannel?: InputMaybe<PreferredNotificationChannel>;
  /** Search string to look for in users. */
  search?: InputMaybe<Scalars["String"]["input"]>;
  /** User status filter. */
  status?: InputMaybe<Array<UserStatus>>;
};

/** Input for the `exportUserData` mutation. */
export type ExportUserDataInput = {
  /** If provided, the email address that will receive a notification when the export is completed. */
  email?: InputMaybe<Scalars["String"]["input"]>;
  /** User filters. */
  filters?: InputMaybe<ExportUserDataFilters>;
};

export type ExternalAccount = {
  __typename: "ExternalAccount";
  /** Bank Identifier Code */
  BIC: Scalars["BIC"]["output"];
  /** International Bank Account Number */
  IBAN: Scalars["IBAN"]["output"];
  /** Account holder for the external account */
  accountHolder?: Maybe<AccountHolder>;
  /**
   * A list of balances regarding an external account.
   *
   * Implements the Relay Connection interface, used to paginate lists of elements. ([Learn More](https://docs.swan.io/developers/using-api/pagination))
   */
  balances: ExternalBalanceConnection;
  /** Type of the account */
  cashAccountType: CashAccountType;
  /** Country */
  country: Scalars["CCA3"]["output"];
  /** Created date */
  createdAt: Scalars["DateTime"]["output"];
  /** Currency */
  currency: Scalars["Currency"]["output"];
  /** External account identifier following ISO-20022 standard */
  externalId: Scalars["String"]["output"];
  /** Account Holder name */
  holderName: Scalars["String"]["output"];
  /** Unique identifier of an external account */
  id: Scalars["ID"]["output"];
  /** Financial institution */
  institution?: Maybe<FinancialInstitution>;
  /** Name of the account */
  name?: Maybe<Scalars["String"]["output"]>;
  /** Original Created date */
  originalCreatedAt: Scalars["DateTime"]["output"];
  /** Source used for this account */
  source: ExternalAccountDataSource;
  /** Updated date */
  updatedAt: Scalars["DateTime"]["output"];
  /** Usage information of the account */
  usage: ExternalAccountUsage;
};

export type ExternalAccountBalancesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: Scalars["Int"]["input"];
};

export type ExternalAccountAlreadyExistsRejection = Rejection & {
  __typename: "ExternalAccountAlreadyExistsRejection";
  accountHolderId: Scalars["String"]["output"];
  iban: Scalars["String"]["output"];
  message: Scalars["String"]["output"];
};

export type ExternalAccountBalance = {
  __typename: "ExternalAccountBalance";
  /** Amount with currency */
  amount?: Maybe<Amount>;
  /** Unique identifier of an external balance */
  id: Scalars["ID"]["output"];
  /** Last changed Date */
  lastChangedAt: Scalars["DateTime"]["output"];
  /** Type of Balance */
  type: ExternalAccountBalanceType;
};

export type ExternalAccountBalanceAlreadyExistsRejection = Rejection & {
  __typename: "ExternalAccountBalanceAlreadyExistsRejection";
  lastChangedAt: Scalars["DateTime"]["output"];
  message: Scalars["String"]["output"];
  type: ExternalAccountBalanceType;
};

export type ExternalAccountBalanceInput = {
  /** Amount with currency */
  amount: AmountInput;
  /** Last changed Date */
  lastChangedAt: Scalars["DateTime"]["input"];
  /** Type of Balance */
  type: ExternalAccountBalanceType;
};

export type ExternalAccountBalanceType =
  /** Balance of the account at the end of the pre-agreed account reporting period */
  | "ClosingBooked"
  /** Balance composed of booked entries and pending items known at the time of calculation */
  | "Expected"
  /** Available balance calculated in the course of the account servicer's business day, at the time specified, and subject to further changes during the business day */
  | "InterimAvailable"
  /** Other balance */
  | "Other"
  /** Balance of the account at the previously closed account reporting period */
  | "PreviouslyClosedBooked"
  /** Value-date balance */
  | "ValueDate";

/** Implements the Relay Connection interface, used to paginate the lists of elements. ([Learn More](https://docs.swan.io/developers/using-api/pagination)) */
export type ExternalAccountConnection = Connection & {
  __typename: "ExternalAccountConnection";
  /** ExternalAccountEdge list */
  edges: Array<ExternalAccountEdge>;
  /** Information about the current, the previous and the next page */
  pageInfo: PageInfo;
  /** Total number of elements in the list */
  totalCount: Scalars["Int"]["output"];
};

export type ExternalAccountDataSource = {
  __typename: "ExternalAccountDataSource";
  name: Scalars["String"]["output"];
  type: ExternalAccountDataSourceType;
};

export type ExternalAccountDataSourceType =
  /** When manually added by the partner */
  "Push";

/** Implements the Relay Edge interface */
export type ExternalAccountEdge = Edge & {
  __typename: "ExternalAccountEdge";
  /** Opaque identifier pointing to this node in the pagination mechanism */
  cursor: Scalars["String"]["output"];
  /** The external account */
  node: ExternalAccount;
};

export type ExternalAccountUsage = "Association" | "Organization" | "Private" | "Unknown";

/** Implements the Relay Connection interface, used to paginate lists of elements. ([Learn More](https://docs.swan.io/developers/using-api/pagination)) */
export type ExternalBalanceConnection = Connection & {
  __typename: "ExternalBalanceConnection";
  /** ExternalBalanceEdge list */
  edges: Array<ExternalBalanceEdge>;
  /** Information about the current, the previous and the next page */
  pageInfo: PageInfo;
  /** Total number of elements in the list */
  totalCount: Scalars["Int"]["output"];
};

/** Implements the Relay Edge interface */
export type ExternalBalanceEdge = Edge & {
  __typename: "ExternalBalanceEdge";
  /** Opaque identifier pointing to this node in the pagination mechanism */
  cursor: Scalars["String"]["output"];
  /** The external balance */
  node: ExternalAccountBalance;
};

export type ExternalCard = {
  __typename: "ExternalCard";
  /** The card's first 6 digits - Bank Identification Number */
  bin: Scalars["String"]["output"];
  /**
   * deprecated: The card type
   * @deprecated The cardType field is deprecated, use the type field instead
   */
  cardType?: Maybe<CardPaymentMandateType>;
  /** The card category */
  category?: Maybe<CardPaymentMandateCategory>;
  /** The card's bank country */
  country?: Maybe<Scalars["CCA2"]["output"]>;
  /** The card's expiry date */
  expiryDate?: Maybe<Scalars["String"]["output"]>;
  /** The card's last digits */
  lastDigits: Scalars["String"]["output"];
  /** The local card scheme */
  localScheme?: Maybe<CardPaymentMandateScheme>;
  /** The card scheme */
  scheme: CardPaymentMandateScheme;
  /** The card type */
  type?: Maybe<CardPaymentMandateType>;
};

/** The document corresponding to a face photo */
export type FacePhotoDocument = {
  __typename: "FacePhotoDocument";
  /** Unique identifier of the face photo document. For privacy reasons, no temporary download url is exposed for this document */
  id: Scalars["String"]["output"];
  /** The type of the document */
  type: DocumentType;
};

export type FailedStatusInfo = AccountStatementStatusInfo & {
  __typename: "FailedStatusInfo";
  /** status of the statement */
  status: AccountStatementStatus;
};

export type FailedThreeDsReason = "AuthenticationExpired" | "AuthenticationFailed" | "Other";

export type FailedThreeDsStatusInfo = ThreeDsStatusInfo & {
  __typename: "FailedThreeDsStatusInfo";
  reasonCode: FailedThreeDsReason;
  status: IncomingThreeDsStatus;
};

export type FailedTransactionStatementStatusInfo = TransactionStatementStatusInfo & {
  __typename: "FailedTransactionStatementStatusInfo";
  /** reason of the failure */
  reason?: Maybe<Scalars["String"]["output"]>;
  /** status of the transaction statement */
  status: TransactionStatementStatusEnum;
};

/** Fee creditor */
export type FeeCreditor = {
  /** account number */
  accountNumber: Scalars["AccountNumber"]["output"];
  /** full name of the creditor */
  name: Scalars["String"]["output"];
};

export type FeeDebtor = {
  /** account number */
  accountNumber: Scalars["AccountNumber"]["output"];
  /** full name of the debtor */
  name: Scalars["String"]["output"];
};

/** Fee creditor for Incoming transaction */
export type FeeInCreditor = FeeCreditor & {
  __typename: "FeeInCreditor";
  /** account number */
  accountNumber: Scalars["AccountNumber"]["output"];
  /** full name of the creditor */
  name: Scalars["String"]["output"];
};

/** Fee debtor for Incoming transaction */
export type FeeInDebtor = FeeDebtor & {
  __typename: "FeeInDebtor";
  /** account number */
  accountNumber: Scalars["AccountNumber"]["output"];
  /** full name of the creditor */
  name: Scalars["String"]["output"];
};

/** Fee creditor for Outgoing transaction */
export type FeeOutCreditor = FeeCreditor & {
  __typename: "FeeOutCreditor";
  /** account number */
  accountNumber: Scalars["AccountNumber"]["output"];
  /** full name of the creditor */
  name: Scalars["String"]["output"];
};

/** Fee debtor for Outgoing transaction */
export type FeeOutDebtor = FeeDebtor & {
  __typename: "FeeOutDebtor";
  /** account number */
  accountNumber: Scalars["AccountNumber"]["output"];
  /** full name of the creditor */
  name: Scalars["String"]["output"];
};

export type FeeSettingsNotFoundRejection = Rejection & {
  __typename: "FeeSettingsNotFoundRejection";
  message: Scalars["String"]["output"];
};

/** Fee Transaction */
export type FeeTransaction = Transaction & {
  __typename: "FeeTransaction";
  /** matching account for the transaction */
  account?: Maybe<Account>;
  /** amount */
  amount: Amount;
  /** [DEPRECATED] booked balance after this transaction. Deprecated in favor of statusInfo.balance.amount on BookedTransactionStatusInfo */
  bookedBalanceAfter?: Maybe<Amount>;
  /** name of the counterparty. e.g Merchant name, Creditor name, Beneficiary Name ... */
  counterparty: Scalars["String"]["output"];
  /** created date */
  createdAt: Scalars["DateTime"]["output"];
  /** creditor information */
  creditor: FeeCreditor;
  /** debtor information */
  debtor: FeeDebtor;
  /** a date that reflects the execution date of a transaction from a user viewpoint. Can be used for sorting transactions. */
  executionDate: Scalars["DateTime"]["output"];
  /**
   * an arbitrary identifier that was defined by you when you created this transaction.
   *
   * For example, you can define it in the CreditTransferInput mutation.
   */
  externalReference?: Maybe<Scalars["String"]["output"]>;
  /** feesType */
  feesType: FeesTypeEnum;
  /** unique identifier of the transaction */
  id: Scalars["ID"]["output"];
  /** `true` if this transaction can still be cancelled */
  isCancelable: Scalars["Boolean"]["output"];
  /** label */
  label: Scalars["String"]["output"];
  /** origin transaction associated to this transaction */
  originTransaction?: Maybe<Transaction>;
  /** ID of the origin transaction associated to this transaction */
  originTransactionId?: Maybe<Scalars["String"]["output"]>;
  /** payment associated to this transaction */
  payment?: Maybe<Payment>;
  /** ID of the payment associated to this transaction */
  paymentId?: Maybe<Scalars["String"]["output"]>;
  /** payment method identifier used for this transaction. e.g masked PAN or IBAN or accountNumber */
  paymentMethodIdentifier: Scalars["String"]["output"];
  /** payment product used for this transaction */
  paymentProduct: PaymentProduct;
  /** project id of the transaction */
  projectId: Scalars["ID"]["output"];
  /** reference assigned by the initiating party, to unambiguously identify the transaction. This reference is passed on, unchanged, throughout the entire reference chain. */
  reference: Scalars["String"]["output"];
  /** a date that reflects the time at which the user asked the transaction to be executed */
  requestedExecutionAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** side (Credit or Debit) */
  side: TransactionSide;
  /** true if a transaction statement can be generated for this transaction */
  statementCanBeGenerated?: Maybe<Scalars["Boolean"]["output"]>;
  /** status information */
  statusInfo: TransactionStatusInfo;
  supportingDocumentCollections: SupportingDocumentCollectionConnection;
  /** type */
  type: TransactionTypeEnum;
  /** updated date */
  updatedAt: Scalars["DateTime"]["output"];
};

/** Fee Transaction */
export type FeeTransactionSupportingDocumentCollectionsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  filters?: InputMaybe<SupportingDocumentCollectionFilterInput>;
  first?: Scalars["Int"]["input"];
};

/** Fees type */
export type FeesTypeEnum =
  /** Monthly account membership subscription fee charged on the last day of the month */
  | "AccountMembershipSubscription"
  /** Other banking fee */
  | "BankingFee"
  /** Monthly account subscription fee charged on the last day of the month */
  | "BusinessAccountSubscription"
  /** Online payment made with card issued by American Express */
  | "CardAcquiringAmex"
  /** Chargeback on an online card payment */
  | "CardAcquiringChargeback"
  /** Online payment made with a commercial card issued by Cartes Bancaires */
  | "CardAcquiringCommercialCB"
  /** Online payment made with a commercial card issued by Visa or Mastercard outside the European Economic Area */
  | "CardAcquiringCommercialVisaMcOutsideEEA"
  /** Online payment made with a commercial card issued by Visa or Mastercard within the European Economic Area */
  | "CardAcquiringCommercialVisaMcWithinEEA"
  /** Online payment made with a commercial card within the European Economic Area */
  | "CardAcquiringCommercialWithinEEA"
  /** Online payment made with a consumer card issued by Cartes Bancaires */
  | "CardAcquiringConsumerCB"
  /** Online payment made with a consumer card issued by Visa or Mastercard outside the European Economic Area */
  | "CardAcquiringConsumerVisaMcOutsideEEA"
  /** Online payment made with a consumer card issued by Visa or Mastercard within the European Economic Area */
  | "CardAcquiringConsumerVisaMcWithinEEA"
  /** Online payment made with a consumer card within the European Economic Area */
  | "CardAcquiringConsumerWithinEEA"
  /** Online payment made with a consumer or commercial card issued outside the European Economic Area */
  | "CardAcquiringOutsideEEA"
  /** Card transaction in foreign currency */
  | "CardPaymentsOutsideSEPA"
  /** Fee for sending a card transaction */
  | "CardTransaction"
  /** Cash withdrawal in foreign currency */
  | "CashWithdrawalsOutsideSEPA"
  /** Cash withdrawal */
  | "CashWithdrawalsWithinSEPA"
  /** Fee for the deposit of a physical check */
  | "CheckDeposit"
  /** Rejection of a physical check */
  | "CheckIncident"
  /** Return of a physical check */
  | "CheckReturn"
  /** Drafting circulation letter */
  | "CirculationLetterDraftingFee"
  /** Account opening fee for a business account */
  | "CompanyAccountHolderVerified"
  /** Fee for drafting a confirmation letter attesting to the existence of a Swan account */
  | "ConfirmationLetterDraftingFee"
  /** Direct debit rejection */
  | "DirectDebitRejection"
  /** Document issuance */
  | "DocumentIssuance"
  /** Fee for improper use of account */
  | "ImproperUseOfAccount"
  /** Account inactive within the past 12 months */
  | "InactiveAccount"
  /** Monthly account subscription fee charged on the last day of the month */
  | "IndividualAccountSubscription"
  /** Fee for sending or receiving a SEPA Instant Credit Transfer */
  | "InstantSepaCreditTransferIn"
  /** Fee for sending or receiving a SEPA Instant Credit Transfer */
  | "InstantSepaCreditTransferOut"
  /** Fee for performing a credit transfer not denominated and executed in euros on group 1 currencies */
  | "InternationalCreditTransferInGroup1"
  /** Fee for performing a credit transfer not denominated and executed in euros on group 2 currencies */
  | "InternationalCreditTransferInGroup2"
  /** Fee for performing a credit transfer not denominated and executed in euros on group 3 currencies */
  | "InternationalCreditTransferInGroup3"
  /** Fee for performing a credit transfer not denominated and executed in euros on group 4 currencies */
  | "InternationalCreditTransferInGroup4"
  /** Fee for performing a credit transfer not denominated and executed in euros on group 1 currencies */
  | "InternationalCreditTransferOutGroup1"
  /** Fee for performing a credit transfer not denominated and executed in euros on group 2 currencies */
  | "InternationalCreditTransferOutGroup2"
  /** Fee for performing a credit transfer not denominated and executed in euros on group 3 currencies */
  | "InternationalCreditTransferOutGroup3"
  /** Fee for performing a credit transfer not denominated and executed in euros on group 4 currencies */
  | "InternationalCreditTransferOutGroup4"
  /** Fee for performing a credit transfer via the Swift network */
  | "InternationalCreditTransferOutSwiftGroup1"
  /** Fee for delivering physical cards with an express delivery provider */
  | "PhysicalCardDeliveryExpress"
  /** Fee for delivering physical cards within France */
  | "PhysicalCardDeliveryFrance"
  /** Fee for delivering physical cards outside of France */
  | "PhysicalCardDeliveryIntl"
  /** Fee for delivering physical cards within Spain */
  | "PhysicalCardDeliverySpain"
  /** Fee for the process of printing physical cards */
  | "PhysicalCardPrinting"
  /** Processing judicial or administrative seizure */
  | "ProcessingJudicialOrAdministrativeSeizure"
  /** Incoming B2B SEPA Direct Debit (Merchant) */
  | "SddInB2bMerchant"
  /** Incoming Core SEPA Direct Debit (Merchant) */
  | "SddInCoreMerchant"
  /** Fee for sending or receiving a SEPA Credit Transfer */
  | "SepaCreditTransferIn"
  /** Fee for sending or receiving a SEPA Credit Transfer */
  | "SepaCreditTransferOut"
  /** Fee for processing a SEPA creditor identifier request */
  | "SepaCreditorIdentifierRequest"
  /** Fee for sending or receiving a SEPA Direct Debit */
  | "SepaDirectDebitIn"
  /** Fee for an incoming B2B SEPA Direct Debit up to 200€ */
  | "SepaDirectDebitInB2bLevel1"
  /** Fee for an incoming B2B SEPA Direct Debit more than 200€ */
  | "SepaDirectDebitInB2bLevel2"
  /** Fee for an incoming Core SEPA Direct Debit up to 200€ */
  | "SepaDirectDebitInCoreLevel1"
  /** Fee for an incoming Core SEPA Direct Debit more than 200€ */
  | "SepaDirectDebitInCoreLevel2"
  /** Fee for the return of a Core SEPA Direct Debit */
  | "SepaDirectDebitInCoreReturn"
  /** Fee for sending or receiving a SEPA Direct Debit */
  | "SepaDirectDebitOut"
  /** Fee for creating and enabling a single-use virtual card */
  | "SingleUseVirtualCard"
  /** Unauthorized overdraft */
  | "UnauthorizedOverdraft"
  /** Monthly card subscription fee charged on the last day of the month */
  | "VirtualCardSubscription";

export type Field = {
  key: Scalars["String"]["output"];
  name: Scalars["String"]["output"];
  required: Scalars["Boolean"]["output"];
};

export type FieldValidationError =
  /** When the associated field's value is invalid */
  | "Invalid"
  /** When the associated field's value is missing */
  | "Missing";

export type FinalizeAccountHolderOnboardingInput = {
  onboardingId: Scalars["String"]["input"];
};

export type FinalizeAccountHolderOnboardingPayload =
  | FinalizeAccountHolderOnboardingSuccessPayload
  | ForbiddenRejection
  | InternalErrorRejection
  | OnboardingAlreadyFinalizedRejection
  | OnboardingNotFoundRejection
  | OnboardingNotReadyForFinalizationRejection;

export type FinalizeAccountHolderOnboardingSuccessPayload = {
  __typename: "FinalizeAccountHolderOnboardingSuccessPayload";
  onboarding: AccountHolderOnboarding;
};

export type FinalizeOnboardingInput = {
  onboardingId: Scalars["String"]["input"];
};

export type FinalizeOnboardingPayload =
  | FinalizeOnboardingSuccessPayload
  | ForbiddenRejection
  | InternalErrorRejection
  | OnboardingNotCompletedRejection
  | ValidationRejection;

export type FinalizeOnboardingSuccessPayload = {
  __typename: "FinalizeOnboardingSuccessPayload";
  onboarding: Onboarding;
};

export type FinalizeVerificationRenewalInput = {
  verificationRenewalId: Scalars["ID"]["input"];
};

export type FinalizeVerificationRenewalPayload =
  | FinalizeVerificationRenewalSuccessPayload
  | ForbiddenRejection
  | ValidationRejection
  | VerificationRenewalNotFoundRejection
  | VerificationRenewalUpdateNotAllowedRejection;

export type FinalizeVerificationRenewalSuccessPayload = {
  __typename: "FinalizeVerificationRenewalSuccessPayload";
  verificationRenewal: VerificationRenewal;
};

export type FinancialInstitution = {
  __typename: "FinancialInstitution";
  country: Scalars["CCA3"]["output"];
  id: Scalars["ID"]["output"];
  name: Scalars["String"]["output"];
};

export type FnciColorCode =
  /** The check doesn't match any fraudulent record from the FNCI (Fichier National des Chèques Impayés). */
  | "Green"
  /** The check matches fraudulent records from the FNCI (Fichier National des Chèques Impayés). */
  | "Orange"
  /** The check matches fraudulent records from the FNCI (Fichier National des Chèques Impayés). */
  | "Red"
  /** The check matches fraudulent records from the FNCI (Fichier National des Chèques Impayés). */
  | "White";

export type FnciInfo = {
  __typename: "FnciInfo";
  colorCode: FnciColorCode;
  cpt1: Scalars["Int"]["output"];
  cpt2: Scalars["Int"]["output"];
  cpt3: Scalars["Int"]["output"];
  holderEstablishment: Scalars["String"]["output"];
  responseCode: Scalars["Int"]["output"];
};

export type ForbiddenRejection = Rejection & {
  __typename: "ForbiddenRejection";
  message: Scalars["String"]["output"];
};

export type ForecastYearlyIncome =
  | "From0To500000"
  | "From500001To1000000"
  | "From1000001To5000000"
  | "MoreThan5000000";

export type FundingLimit = {
  __typename: "FundingLimit";
  /** Maximum Funding Amount authorized */
  amount: Amount;
  /** Funding Amount that has already been used during the interval */
  funding?: Maybe<Amount>;
  /** Interval in number of calendar days where the limit is applied */
  rollingDays: Scalars["Int"]["output"];
};

/** Funding Limit Amount */
export type FundingLimitAmount = {
  __typename: "FundingLimitAmount";
  /** The amount settings */
  amount: Amount;
};

/** Funding Limit Amount Input */
export type FundingLimitAmountInput = {
  /** The amount settings */
  amount: AmountInput;
};

/** Rejection returned when the Account Holder Funding has been exceeded */
export type FundingLimitExceededRejection = Rejection & {
  __typename: "FundingLimitExceededRejection";
  message: Scalars["String"]["output"];
};

export type FundingLimitSettings = {
  __typename: "FundingLimitSettings";
  /** Periodic funding limit */
  fundingLimit?: Maybe<FundingLimit>;
  /** Related change request */
  fundingLimitSettingsChangeRequest?: Maybe<FundingLimitSettingsChangeRequest>;
  /** Instant funding limit */
  instantFundingLimit?: Maybe<InstantFundingLimit>;
  /** Status of the resource */
  statusInfo: FundingLimitSettingsStatusInfo;
};

/** Funding Limit Settings Change Request */
export type FundingLimitSettingsChangeRequest = {
  __typename: "FundingLimitSettingsChangeRequest";
  /** Approved amount settings for the the instant funding limit and the funding limit */
  approved?: Maybe<ApprovedFundingLimit>;
  /** Date of creation */
  createdAt?: Maybe<Scalars["Date"]["output"]>;
  /** Requested amount settings for the funding limit */
  fundingLimit: FundingLimitAmount;
  /** Unique identifier of a funding limit settings change request */
  id: Scalars["ID"]["output"];
  /** Requested amount settings for the instant funding limit */
  instantFundingLimit: FundingLimitAmount;
  /** Status of the request */
  statusInfo: FundingLimitSettingsChangeRequestStatusInfo;
  /** Date of last update */
  updatedAt?: Maybe<Scalars["Date"]["output"]>;
};

/** StatusInfo when funding limit settings change request has been approved */
export type FundingLimitSettingsChangeRequestApprovedStatusInfo =
  FundingLimitSettingsChangeRequestStatusInfo & {
    __typename: "FundingLimitSettingsChangeRequestApprovedStatusInfo";
    reason: Scalars["String"]["output"];
    status: FundingLimitSettingsChangeRequestStatus;
  };

/** Funding Limit Settings Change Request Bad Amount Rejection */
export type FundingLimitSettingsChangeRequestBadAmountRejection = Rejection & {
  __typename: "FundingLimitSettingsChangeRequestBadAmountRejection";
  message: Scalars["String"]["output"];
};

/** Implements the Relay Connection interface, used to paginate lists of elements. ([Learn More](https://docs.swan.io/developers/using-api/pagination)) */
export type FundingLimitSettingsChangeRequestConnection = Connection & {
  __typename: "FundingLimitSettingsChangeRequestConnection";
  /** FundingLimitSettingsChangeRequestEdge list */
  edges: Array<FundingLimitSettingsChangeRequestEdge>;
  /** Information about the current, the previous and the next page */
  pageInfo: PageInfo;
  /** Total number of element in the list */
  totalCount: Scalars["Int"]["output"];
};

/** Implements the Relay Edge interface */
export type FundingLimitSettingsChangeRequestEdge = Edge & {
  __typename: "FundingLimitSettingsChangeRequestEdge";
  /** Opaque identifier pointing to this onboarding node in the pagination mechanism */
  cursor: Scalars["String"]["output"];
  /** The FundingLimitSettingsChangeRequest */
  node: FundingLimitSettingsChangeRequest;
};

/** Filters that can be applied when listing funding limit settings change requests */
export type FundingLimitSettingsChangeRequestFiltersInput = {
  /** Filter by IDs */
  id?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** Filter by status */
  status?: InputMaybe<Array<FundingLimitSettingsChangeRequestStatus>>;
};

/** Field we can use when ordering that can be applied when listing funding limit settings change requests */
export type FundingLimitSettingsChangeRequestOrderByFieldInput = "createdAt" | "id" | "updatedAt";

/** Order that can be applied when listing funding limit settings change requests */
export type FundingLimitSettingsChangeRequestOrderByInput = {
  direction?: InputMaybe<OrderByDirection>;
  field?: InputMaybe<FundingLimitSettingsChangeRequestOrderByFieldInput>;
};

/** StatusInfo when funding limit settings change request is pending */
export type FundingLimitSettingsChangeRequestPendingStatusInfo =
  FundingLimitSettingsChangeRequestStatusInfo & {
    __typename: "FundingLimitSettingsChangeRequestPendingStatusInfo";
    status: FundingLimitSettingsChangeRequestStatus;
  };

/** StatusInfo when funding limit settings change request has been rejected */
export type FundingLimitSettingsChangeRequestRefusedStatusInfo =
  FundingLimitSettingsChangeRequestStatusInfo & {
    __typename: "FundingLimitSettingsChangeRequestRefusedStatusInfo";
    reason: Scalars["String"]["output"];
    status: FundingLimitSettingsChangeRequestStatus;
  };

/** Funding Limit Settings Change Request Status */
export type FundingLimitSettingsChangeRequestStatus =
  /** When the request is approved */
  | "Approved"
  /** When the request is in pending */
  | "Pending"
  /** When the request is refused */
  | "Refused"
  /** When the request is in waiting for information */
  | "WaitingForInformation";

/** Object containing details about funding limit settings change request status */
export type FundingLimitSettingsChangeRequestStatusInfo = {
  /** Current limit settings change request status. */
  status: FundingLimitSettingsChangeRequestStatus;
};

/** StatusInfo when funding limit settings change request is waiting for more information */
export type FundingLimitSettingsChangeRequestWaitingForInformationStatusInfo =
  FundingLimitSettingsChangeRequestStatusInfo & {
    __typename: "FundingLimitSettingsChangeRequestWaitingForInformationStatusInfo";
    status: FundingLimitSettingsChangeRequestStatus;
  };

/** Possible values for funding limit settings status */
export type FundingLimitSettingsStatus =
  /** When the funding limit settings is disabled */
  | "Disabled"
  /** When the funding limit settings is enabled */
  | "Enabled"
  /** When the funding limit settings is suspended */
  | "Suspended";

/** Object containing details about funding limit settings status */
export type FundingLimitSettingsStatusInfo = {
  /** Current funding limit settings. */
  status: FundingLimitSettingsStatus;
};

/** Funding Source */
export type FundingSource = {
  /** Created date */
  createdAt: Scalars["DateTime"]["output"];
  /** ID of the Funding Source */
  id: Scalars["ID"]["output"];
  /** Name of the Funding Source */
  name?: Maybe<Scalars["String"]["output"]>;
  /** Funding Source status information */
  statusInfo: FundingSourceStatusInfo;
  /** Last updated date */
  updatedAt: Scalars["DateTime"]["output"];
};

/** Please see the Connection interface */
export type FundingSourceConnection = Connection & {
  __typename: "FundingSourceConnection";
  edges: Array<FundingSourceEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars["Int"]["output"];
};

/** Please see the Connection interface */
export type FundingSourceEdge = Edge & {
  __typename: "FundingSourceEdge";
  cursor: Scalars["String"]["output"];
  node: FundingSource;
};

/** Filters that can be applied when listing Funding Sources */
export type FundingSourceFiltersInput = {
  status: Array<FundingSourceStatus>;
};

export type FundingSourceNotFoundRejection = Rejection & {
  __typename: "FundingSourceNotFoundRejection";
  id: Scalars["String"]["output"];
  message: Scalars["String"]["output"];
};

/** Field we can use when ordering that can be applied when listing funding source results */
export type FundingSourceOrderByFieldInput = "createdAt" | "updatedAt";

/** Order that can be applied when listing funding source results */
export type FundingSourceOrderByInput = {
  direction?: InputMaybe<OrderByDirection>;
  field?: InputMaybe<FundingSourceOrderByFieldInput>;
};

/** Funding Source Statuses */
export type FundingSourceStatus = "Canceled" | "Enabled" | "Pending" | "Rejected" | "Suspended";

/** Funding Source status information */
export type FundingSourceStatusInfo = {
  /** Funding Source Pending status */
  status: FundingSourceStatus;
};

/** Rejection returned when the Funding Source is not in the expected status */
export type FundingSourceWrongStatusRejection = Rejection & {
  __typename: "FundingSourceWrongStatusRejection";
  currentStatus: FundingSourceStatus;
  expectedStatus: FundingSourceStatus;
  message: Scalars["String"]["output"];
};

export type Gender = "Female" | "Male" | "Unknown";

/** Inputs to generate an account */
export type GenerateAccountStatementInput = {
  /** Unique identifier of an account */
  accountId: Scalars["ID"]["input"];
  /** ending date of the date window */
  closingDate: Scalars["DateTime"]["input"];
  /** [NEW] Format of statement to generate */
  format?: InputMaybe<AccountStatementFormat>;
  /** language to generate the statement in (default to account's language) */
  language?: InputMaybe<AccountLanguage>;
  /** starting date of the date window */
  openingDate: Scalars["DateTime"]["input"];
  /** [DEPRECATED] Type of statement to generate */
  statementType?: InputMaybe<StatementType>;
};

export type GenerateCapitalDepositDocumentUploadUrlInput = {
  /** Unique identifier of the capitalDepositCase associated to the document. */
  capitalDepositCaseId: Scalars["ID"]["input"];
  /** Unique identifier of the document. */
  documentId: Scalars["ID"]["input"];
  /** Filename of the document. */
  filename: Scalars["String"]["input"];
};

export type GenerateCapitalDepositDocumentUploadUrlPayload =
  | BadRequestRejection
  | CapitalDepositDocumentCanNotBeUploaded
  | CapitalDepositDocumentCanNotBeUploadedRejection
  | ForbiddenRejection
  | GenerateCapitalDepositDocumentUploadUrlSuccessPayload
  | InternalErrorRejection;

export type GenerateCapitalDepositDocumentUploadUrlSuccessPayload = {
  __typename: "GenerateCapitalDepositDocumentUploadUrlSuccessPayload";
  /** URL to be used to upload the document. */
  uploadUrl?: Maybe<Scalars["String"]["output"]>;
};

export type GenerateCreditStatementFailurePayload = {
  __typename: "GenerateCreditStatementFailurePayload";
  message: Scalars["String"]["output"];
};

/** Inputs to generate a credit statement */
export type GenerateCreditStatementInput = {
  /** The account which will be used to generate the credit statement */
  accountId: Scalars["ID"]["input"];
  /** language to generate the statement in (default to account's language) */
  language?: InputMaybe<AccountLanguage>;
  /** The repayment cycle which will be used to generated the credit statement. */
  repaymentCycleId: Scalars["ID"]["input"];
};

export type GenerateCreditStatementPayload =
  | AccountHolderNotFoundRejection
  | AccountNotFoundRejection
  | BadRequestRejection
  | CreditLimitSettingsNotFoundRejection
  | CreditStatement
  | ForbiddenRejection
  | RepaymentCycleNotFoundRejection;

/** Input for the `generateExportDownloadLink` mutation. */
export type GenerateExportDownloadLinkInput = {
  /**
   * The `exportId` generated by a previous call to any export mutation.
   *
   * NB: The export needs to be completed for the link to be generated.
   */
  exportId: Scalars["String"]["input"];
};

export type GenerateExportDownloadLinkPayload =
  | GenerateExportDownloadLinkSuccessPayload
  | StillExportingRejection
  | UnknownExportRejection;

/** Payload of the `generateExportDownloadLink` mutation in case of success. */
export type GenerateExportDownloadLinkSuccessPayload = {
  __typename: "GenerateExportDownloadLinkSuccessPayload";
  /**
   * A temporary link to download the related export file.
   *
   * NB: This link lasts a few minutes only.
   */
  link: Scalars["String"]["output"];
};

export type GenerateIdentificationDocumentUploadUrlInput = {
  documentFileSide: DocumentFileSide;
  fileName: Scalars["String"]["input"];
  identificationDocumentId: Scalars["ID"]["input"];
};

export type GenerateIdentificationDocumentUploadUrlPayload =
  | ForbiddenRejection
  | GenerateIdentificationDocumentUploadUrlSuccessPayload
  | IdentificationDocumentNotFoundRejection
  | ValidationRejection;

export type GenerateIdentificationDocumentUploadUrlSuccessPayload = {
  __typename: "GenerateIdentificationDocumentUploadUrlSuccessPayload";
  upload: IdentificationDocumentUploadInfo;
};

export type GenerateSupportingDocumentUploadUrlInput = {
  /** Name of the document which will be sent */
  filename: Scalars["String"]["input"];
  /** Unique identifier of a supporting document collection */
  supportingDocumentCollectionId: Scalars["ID"]["input"];
  /** Purpose of document */
  supportingDocumentPurpose?: InputMaybe<SupportingDocumentPurposeEnum>;
  /** Type of document */
  supportingDocumentType?: InputMaybe<SupportingDocumentType>;
};

export type GenerateSupportingDocumentUploadUrlPayload =
  | ForbiddenRejection
  | GenerateSupportingDocumentUploadUrlSuccessPayload
  | InternalErrorRejection
  | SupportingDocumentCollectionNotFoundRejection
  | SupportingDocumentUploadNotAllowedRejection
  | ValidationRejection;

export type GenerateSupportingDocumentUploadUrlSuccessPayload = {
  __typename: "GenerateSupportingDocumentUploadUrlSuccessPayload";
  /** Id of the supporting document created for this uploadUrl */
  supportingDocumentId: Scalars["String"]["output"];
  /** Info to upload the document : url and fields to add along file in form (POST) */
  upload: SupportingDocumentUploadInfo;
};

/** Inputs to generate an account */
export type GenerateTransactionStatementInput = {
  /** Language to use to generate the statement (account language will be used by default). Must be compliant with RFC 5646. */
  language?: InputMaybe<TransactionStatementLanguage>;
  /** Id of the transaction for which the statement is generated. */
  transactionId: Scalars["ID"]["input"];
};

/** Result of the generation. */
export type GenerateTransactionStatementPayload =
  | ForbiddenRejection
  | GenerateTransactionStatementSuccessPayload
  | GenerationNotAllowedRejection
  | TransactionNotFoundRejection
  | ValidationRejection;

export type GenerateTransactionStatementSuccessPayload = {
  __typename: "GenerateTransactionStatementSuccessPayload";
  transactionStatement?: Maybe<TransactionStatement>;
};

export type GenerateTransactionSupportingDocumentUploadUrlInput = {
  /** Name of the document which will be sent */
  filename: Scalars["String"]["input"];
  /** Purpose of document */
  supportingDocumentPurpose: SupportingDocumentPurposeEnum;
  /** Type of document */
  supportingDocumentType?: InputMaybe<SupportingDocumentType>;
  /** Transaction for which the document is uploaded */
  transactionId: Scalars["ID"]["input"];
};

export type GenerateTransactionSupportingDocumentUploadUrlPayload =
  | AccountNotFoundRejection
  | ForbiddenRejection
  | GenerateTransactionSupportingDocumentUploadUrlSuccessPayload
  | InternalErrorRejection
  | TransactionNotFoundRejection
  | ValidationRejection;

export type GenerateTransactionSupportingDocumentUploadUrlSuccessPayload = {
  __typename: "GenerateTransactionSupportingDocumentUploadUrlSuccessPayload";
  /** Id of the supporting document collection the supporting document is related to */
  supportingDocumentCollectionId: Scalars["String"]["output"];
  /** Id of the supporting document created for this uploadUrl */
  supportingDocumentId: Scalars["String"]["output"];
  /** Info to upload the document : url and fields to add along file in form (POST) */
  upload: SupportingDocumentUploadInfo;
};

export type GeneratedStatusInfo = AccountStatementStatusInfo & {
  __typename: "GeneratedStatusInfo";
  /** status of the statement */
  status: AccountStatementStatus;
  /** Public url on which the file can be accessed */
  url: Scalars["URL"]["output"];
};

export type GeneratedTransactionStatementStatusInfo = TransactionStatementStatusInfo & {
  __typename: "GeneratedTransactionStatementStatusInfo";
  /** date at which the document will expire */
  expiresAt: Scalars["DateTime"]["output"];
  /** status of the transaction statement */
  status: TransactionStatementStatusEnum;
  /** temporary public url on which the file can be accessed */
  url: Scalars["URL"]["output"];
};

/** Rejection returned if a transaction statement can’t be generated for this transaction. */
export type GenerationNotAllowedRejection = Rejection & {
  __typename: "GenerationNotAllowedRejection";
  message: Scalars["String"]["output"];
};

export type GeolocInput = {
  lat: Scalars["Float"]["input"];
  lng: Scalars["Float"]["input"];
};

/** Rejection returned when the Global Funding has been exceeded */
export type GlobalFundingLimitExceededRejection = Rejection & {
  __typename: "GlobalFundingLimitExceededRejection";
  message: Scalars["String"]["output"];
};

/** Rejection returned when the Global Instant Funding limit has been exceeded */
export type GlobalInstantFundingLimitExceededRejection = Rejection & {
  __typename: "GlobalInstantFundingLimitExceededRejection";
  message: Scalars["String"]["output"];
};

/** Input of the `grantConsentWithServerSignature` mutation */
export type GrantConsentWithServerSignatureInput = {
  /** ID of the consent to grant */
  consentId: Scalars["ID"]["input"];
  /** Consent challenge signed with server consent credentials */
  signature: Scalars["String"]["input"];
};

/** Payload of the `grantConsentWithServerSignature` mutation */
export type GrantConsentWithServerSignaturePayload =
  | ConsentNotFoundRejection
  | ConsentTypeNotSupportedByServerConsentRejection
  | ForbiddenRejection
  | GrantConsentWithServerSignatureSuccessPayload
  | NotReachableConsentStatusRejection
  | ProjectNotFoundRejection
  | ServerConsentCredentialsNotValidOrOutdatedRejection
  | ServerConsentNotAllowedForConsentOperationRejection
  | ServerConsentNotAllowedForProjectRejection
  | ServerConsentProjectCredentialMissingRejection
  | ServerConsentProjectCredentialNotFoundRejection
  | ServerConsentProjectSettingsNotFoundRejection
  | ServerConsentSignatureNotValidRejection;

/** Success payload of the `grantConsentWithServerSignature` mutation */
export type GrantConsentWithServerSignatureSuccessPayload = {
  __typename: "GrantConsentWithServerSignatureSuccessPayload";
  consent: Consent;
};

/** Rejection returned when the IBAN is not reachable */
export type IbanNotReachableRejection = Rejection & {
  __typename: "IBANNotReachableRejection";
  message: Scalars["String"]["output"];
};

/** Rejection returned when the IBAN is not valid */
export type IbanNotValidRejection = Rejection & {
  __typename: "IBANNotValidRejection";
  message: Scalars["String"]["output"];
};

/** Virtual IBAN Status */
export type IbanStatus =
  /** When the virtual IBAN refuse definitely to receive Sepa payments */
  | "Canceled"
  /** When the virtual IBAN accept to receive Sepa payments */
  | "Enabled"
  /** When the virtual IBAN refuse temporarily to receive Sepa payments */
  | "Suspended";

/** Rejection returned when the Iban Entry was not found */
export type IbanEntryNotFoundRejection = Rejection & {
  __typename: "IbanEntryNotFoundRejection";
  id: Scalars["String"]["output"];
  message: Scalars["String"]["output"];
};

/** ibanValidation input */
export type IbanValidationInput = {
  /** IBAN to validate */
  iban: Scalars["IBAN"]["input"];
};

export type IbanValidationRejection = Rejection & {
  __typename: "IbanValidationRejection";
  message: Scalars["String"]["output"];
};

/** IbanValidationResult */
export type IbanValidationResult = InvalidIban | ValidIban;

/** The document corresponding to an ID card */
export type IdCardDocument = {
  __typename: "IdCardDocument";
  /** The date at which the ID card expires */
  expiryDate?: Maybe<Scalars["Date"]["output"]>;
  /** List of the associated files */
  files: Array<IdCardDocumentFile>;
  /** Unique identifier of the ID card document */
  id: Scalars["String"]["output"];
  /** The date at which the ID card was issued */
  issueDate?: Maybe<Scalars["Date"]["output"]>;
  /** Machine-readable zone code of the ID card */
  mrz?: Maybe<Scalars["String"]["output"]>;
  /** Number of the ID card */
  number?: Maybe<Scalars["String"]["output"]>;
  /** The type of the document */
  type: DocumentType;
};

/** The file associated to the ID card document */
export type IdCardDocumentFile = DocumentFile & {
  __typename: "IdCardDocumentFile";
  /** The file's temporary download url */
  downloadUrl: Scalars["String"]["output"];
  /** From which side the ID card's picture was taken */
  side: DocumentFileSide;
};

/**
 * In the chance that a request is made while still concurrently processing the
 * first request under the same idempotencyKey,
 * the APIs will return this rejection.
 */
export type IdempotencyConflictRejection = Rejection & {
  __typename: "IdempotencyConflictRejection";
  message: Scalars["String"]["output"];
};

/** The identification represents an ongoing identification process or its result */
export type Identification = {
  __typename: "Identification";
  /** Creation date of the identification */
  createdAt: Scalars["DateTime"]["output"];
  /** The available documents related to the identification (id doc, selfie, report...) */
  documents?: Maybe<Array<IdentificationDocument>>;
  /** Unique identifier of the identification */
  id: Scalars["String"]["output"];
  /** The identity document type used for the current identification (passport, id card ...) */
  identityDocumentType?: Maybe<IdentityDocumentType>;
  /** The status and results associated to the available identification processes */
  levels: IdentificationLevelStatusesInfo;
  /** The process that was used for this identification */
  process: IdentificationProcess;
  /** The global status of the identification */
  status: SwanIdentificationStatus;
  /** Last update date of the identification */
  updatedAt: Scalars["DateTime"]["output"];
};

/** Fields we can use when ordering that can be applied when listing identifications */
export type IdentificationConnection = {
  __typename: "IdentificationConnection";
  /** IdentificationEdge list */
  edges: Array<IdentificationEdge>;
  /** Information about the current, the previous and the next page */
  pageInfo: PageInfo;
  /** Total number of element in the list */
  totalCount: Scalars["Int"]["output"];
};

/** Union representing all the possible identification document types */
export type IdentificationDocument =
  | DriversLicenseDocument
  | FacePhotoDocument
  | IdCardDocument
  | PassportDocument
  | ReportDocument
  | ResidencePermitDocument;

export type IdentificationDocumentNotFoundRejection = Rejection & {
  __typename: "IdentificationDocumentNotFoundRejection";
  message: Scalars["String"]["output"];
};

export type IdentificationDocumentPostField = {
  __typename: "IdentificationDocumentPostField";
  key: Scalars["String"]["output"];
  value: Scalars["String"]["output"];
};

export type IdentificationDocumentUploadInfo = {
  __typename: "IdentificationDocumentUploadInfo";
  fields: Array<IdentificationDocumentPostField>;
  url: Scalars["String"]["output"];
};

/** Implements the Relay Edge interface */
export type IdentificationEdge = Edge & {
  __typename: "IdentificationEdge";
  /** Opaque identifier pointing to this node in the pagination mechanism */
  cursor: Scalars["String"]["output"];
  /** The identification entry */
  node: Identification;
};

/** Filter that can be passed to get the identifications in specific data ranges */
export type IdentificationFiltersInput = {
  /** To filter on level values */
  levels?: InputMaybe<Array<IdentificationLevel>>;
  /** To filter on process values */
  processes?: InputMaybe<Array<IdentificationProcess>>;
  /** To filter on status values */
  statuses?: InputMaybe<Array<SwanIdentificationStatus>>;
};

/**
 * If requested by sending the right parameters to the initial oauth2 url,
 * it contains the identification level that is requested to be fulfilled
 * after the oauth2 consent by starting the right identification.
 *
 * QES => use the `startFourthlineQesIdentification` mutation
 *
 * Expert => use the `startUbbleExpertIdVerificationIdentification` mutation
 *
 * PVID => use the `startUbblePvidIdVerificationIdentification` mutation
 *
 * Auto => use query `recommendedIdentificationFlow` to let Swan recommend the best flow and level for a user
 */
export type IdentificationFlowLevel = "Auto" | "Expert" | "PVID" | "QES";

/** The various reasons that can lead to an invalid identification level */
export type IdentificationInvalidReason =
  /** Face must be fully present in the photo */
  | "AbsentOrIncompleteFace"
  /** Applicant used a device that has been technically altered / modified */
  | "AlteredDevice"
  /** Light on actual document is insufficient */
  | "BadDocumentLighting"
  /** Something about the document is damaged (could be as tiny as a bent corner) */
  | "DamagedDocument"
  /** Expiry date of document has passed */
  | "ExpiredDocument"
  /** Attempt to commit fraud detected */
  | "FraudDetected"
  /** Video quality isn’t sufficient or video is missing required information */
  | "InadequateVideo"
  /** Lighting on applicant’s face is insufficient */
  | "InsufficientApplicantLighting"
  /** Applicant isn’t meeting movement requirements */
  | "InsufficientApplicantLiveness"
  /** Internet connection quality is insufficient */
  | "InsufficientConnectionQuality"
  /** Video of document doesn’t meet movement requirements */
  | "InsufficientDocumentLiveness"
  /** Document is blurry or otherwise distorted */
  | "InsufficientDocumentReadability"
  /** Face is blurry or otherwise distorted */
  | "InsufficientFaceReadability"
  /** Video is blurry or otherwise distorted */
  | "InsufficientVideoReadability"
  /** There was a technical error */
  | "InternalError"
  /** Address is not valid or accepted */
  | "InvalidAddress"
  /** Identification data is invalid or missing */
  | "InvalidOrMissingData"
  /** Applicant seems to be doing verification against their will */
  | "InvoluntaryIdentification"
  /** Geolocation data is required but not available */
  | "MissingGeolocationData"
  /** Applicant appears on unacceptable news list */
  | "NegativeNewsHit"
  /** Applicant’s identity does not match the expected ID info */
  | "NonMatchingIdentity"
  /** Applicant presented a duplicate of the document (digital or paper) */
  | "NonOriginalDocument"
  /** Applicant appears on a sanctions list */
  | "SanctionListHit"
  /** Applicant required to provide a second document */
  | "SecondDocumentRequired"
  /** There was a technical error with the electronic signature process */
  | "TechnicalSignatureError"
  /** The time to complete the signature timed out */
  | "TimeoutSignatureFlow"
  /** Document not on list of acceptable document types */
  | "UnacceptableDocument"
  /** Applicant is under the minimum required age */
  | "UnderageApplicant";

/** Possible value for the field IdentificationLevel */
export type IdentificationLevel =
  /** Human identity verification */
  | "Expert"
  /** Identity verification with PVID */
  | "PVID"
  /** Identity verification with Qualified Electronic Signature */
  | "QES";

/** User identification levels input payload. */
export type IdentificationLevelInput =
  /** Identity verified by an expert (Ubble-like) */
  | "Expert"
  /** Identity verified by an expert with a Remote Identity Verification Service */
  | "PVID"
  /** Identity verified by an expert and a Qualified Electronic Signature has been done */
  | "QES";

/**
 * Union representing all the possible statuses: not supported, not started, pending, valid, invalid, cancelled, expired
 * Each variant contains its relevant data, for example invalid contains a `reason` field, expired contains an `expiredAt` field, valid contains a `documents` field
 */
export type IdentificationLevelStatusInfo =
  | CanceledIdentificationLevelStatusInfo
  | ExpiredIdentificationLevelStatusInfo
  | InvalidIdentificationLevelStatusInfo
  | NotStartedIdentificationLevelStatusInfo
  | NotSupportedIdentificationLevelStatusInfo
  | PendingIdentificationLevelStatusInfo
  | StartedIdentificationLevelStatusInfo
  | ValidIdentificationLevelStatusInfo;

/** The status and results associated to the available identification processes */
export type IdentificationLevelStatusesInfo = {
  __typename: "IdentificationLevelStatusesInfo";
  /** The status and results associated to the expert level */
  expert: IdentificationLevelStatusInfo;
  /** The status and results associated to the Remote Identity Verification Service level */
  pvid: IdentificationLevelStatusInfo;
  /** The status and results associated to the Qualified Electronic Signature level */
  qes: IdentificationLevelStatusInfo;
};

/** Identification levels */
export type IdentificationLevels = {
  __typename: "IdentificationLevels";
  PVID: Scalars["Boolean"]["output"];
  QES: Scalars["Boolean"]["output"];
  expert: Scalars["Boolean"]["output"];
};

/** Process of the identification */
export type IdentificationProcess =
  /** Identity verified by an expert */
  | "Expert"
  /** Identity verified by an expert with a Remote Identity Verification Service */
  | "PVID"
  /** Identity verified by an expert and a Qualified Electronic Signature has been done */
  | "QES";

/** Fields we can use when ordering that can be applied when listing identifications */
export type IdentificationsOrderByField = "createdAt" | "updatedAt";

/** Order that can be applied when listing identifications */
export type IdentificationsOrderByInput = {
  /** The order in which the Identification list should be ordered */
  direction?: InputMaybe<OrderByDirection>;
  /** The field by which the Identification list should be ordered */
  field?: InputMaybe<IdentificationsOrderByField>;
};

/** Rejection returned if identity and the account memberships are already bind */
export type IdentityAlreadyBindToAccountMembershipRejection = Rejection & {
  __typename: "IdentityAlreadyBindToAccountMembershipRejection";
  accountId: Scalars["String"]["output"];
  identityId: Scalars["String"]["output"];
  message: Scalars["String"]["output"];
};

/** The type of the identity document */
export type IdentityDocumentType = "DriversLicense" | "IdCard" | "Passport" | "ResidencePermit";

/** Data used for in app provisioning */
export type InAppProvisioningData = {
  __typename: "InAppProvisioningData";
  /** Cryptographic OTP used to pre-validate digitalization */
  activationData: Scalars["String"]["output"];
  /** Encrypted card data */
  encryptedData: Scalars["String"]["output"];
  /** Base64 public key used with the wallet provider public key to encrypt the card data */
  ephemeralPublicKey: Scalars["String"]["output"];
  /** IV used to encrypt the card Data (Useful for Google Pay) */
  iv?: Maybe<Scalars["String"]["output"]>;
  /** hash algorithm used during encryption of the card data (Useful for Google Pay) */
  oaepHashingAlgorithm?: Maybe<Scalars["String"]["output"]>;
  /** public key fingerprint of the key used to encrypt card data (Useful for Google Pay) */
  publicKeyFingerprint?: Maybe<Scalars["String"]["output"]>;
};

export type InPersonCardMerchantPaymentMethod = MerchantPaymentMethod & {
  __typename: "InPersonCardMerchantPaymentMethod";
  /** Date at which the Merchant Payment Method was created */
  createdAt: Scalars["Date"]["output"];
  /** Unique identifier tied to every version of a given Merchant Payment Method */
  id: Scalars["ID"]["output"];
  /** Merchant Profile to which the Payment Method is attached */
  merchantProfile: MerchantProfile;
  /** Unique identifier for a given merchant Payment Method, identical for every version of a given Merchant Payment Method Type */
  methodId: Scalars["ID"]["output"];
  /** The Merchant Payment Method payment amount limit */
  paymentAmountLimit?: Maybe<Amount>;
  /** Rolling Reserve applied to the Merchant Payment Method */
  rollingReserve?: Maybe<RollingReserve>;
  /** Status of the Merchant Payment Method */
  statusInfo: MerchantPaymentMethodStatusInfo;
  /** The Merchant Payment Method Type */
  type: MerchantPaymentMethodType;
  /** Date at which the Merchant Payment Method was last updated */
  updatedAt: Scalars["Date"]["output"];
  /** Version of the Merchant Payment Method */
  version: Scalars["Int"]["output"];
};

export type InPersonCardPaymentMethodInput = {
  /** If `true`, the Payment Method will be Pending Review */
  activate?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type IncomingThreeDsStatus =
  | "Exempt"
  | "Failed"
  | "NotRequested"
  | "Requested"
  | "Succeeded";

/** Individual account holder onboarding */
export type IndividualAccountHolderOnboarding = AccountHolderOnboardingBase & {
  __typename: "IndividualAccountHolderOnboarding";
  accountAdmin?: Maybe<IndividualAccountHolderOnboardingAccountAdmin>;
  accountInfo?: Maybe<IndividualAccountHolderOnboardingAccount>;
  createdAt: Scalars["DateTime"]["output"];
  id: Scalars["ID"]["output"];
  /** OAuth parameters provided in order to redirect the user at the end of the flow */
  oAuthRedirectParameters?: Maybe<OAuthRedirectParameters>;
  projectInfo: ProjectInfo;
  statusInfo: OnboardingStatusInfo;
  supportingDocumentCollection?: Maybe<SupportingDocumentCollection>;
  updatedAt: Scalars["DateTime"]["output"];
};

/** Individual account information for onboarding */
export type IndividualAccountHolderOnboardingAccount = {
  __typename: "IndividualAccountHolderOnboardingAccount";
  country?: Maybe<AccountCountry>;
  intendedUsages?: Maybe<Array<IndividualAccountIntendedUsage>>;
  name?: Maybe<Scalars["String"]["output"]>;
};

/** Individual account admin information for onboarding */
export type IndividualAccountHolderOnboardingAccountAdmin = {
  __typename: "IndividualAccountHolderOnboardingAccountAdmin";
  address?: Maybe<AddressInfo>;
  birthInfo?: Maybe<BirthInfo>;
  email?: Maybe<Scalars["String"]["output"]>;
  employmentStatus?: Maybe<EmploymentStatus>;
  firstName?: Maybe<Scalars["String"]["output"]>;
  lastName?: Maybe<Scalars["String"]["output"]>;
  monthlyIncome?: Maybe<MonthlyIncome>;
  nationality?: Maybe<Scalars["CCA3"]["output"]>;
  preferredLanguage?: Maybe<AccountLanguage>;
  sourcesOfFunds?: Maybe<Array<IndividualAccountSourceOfFunds>>;
  taxIdentificationNumber?: Maybe<Scalars["String"]["output"]>;
  unitedStatesTaxInfo?: Maybe<UnitedStatesTaxInfo>;
};

/** Input for individual account admin information during onboarding */
export type IndividualAccountHolderOnboardingAccountAdminInput = {
  acquisitionChannel?: InputMaybe<AcquisitionChannel>;
  address?: InputMaybe<ResidencyAddressInput>;
  birthInfo?: InputMaybe<BirthInfoInput>;
  email?: InputMaybe<Scalars["String"]["input"]>;
  employmentStatus?: InputMaybe<EmploymentStatus>;
  firstName?: InputMaybe<Scalars["String"]["input"]>;
  lastName?: InputMaybe<Scalars["String"]["input"]>;
  monthlyIncome?: InputMaybe<MonthlyIncome>;
  nationality?: InputMaybe<Scalars["CCA3"]["input"]>;
  preferredLanguage?: InputMaybe<AccountLanguage>;
  signupDate?: InputMaybe<Scalars["Date"]["input"]>;
  sourcesOfFunds?: InputMaybe<Array<IndividualAccountSourceOfFunds>>;
  taxIdentificationNumber?: InputMaybe<Scalars["String"]["input"]>;
  unitedStatesTaxInfo?: InputMaybe<UnitedStatesTaxInfoInput>;
  userDeviceInfo?: InputMaybe<UserDeviceInfoInput>;
};

/** Input for individual account information during onboarding */
export type IndividualAccountHolderOnboardingAccountInput = {
  country: AccountCountry;
  intendedUsages?: InputMaybe<Array<IndividualAccountIntendedUsage>>;
  name?: InputMaybe<Scalars["String"]["input"]>;
};

export type IndividualAccountIntendedUsage =
  | "FamilySupport"
  | "Investment"
  | "PersonalUse"
  | "Salary"
  | "SelfEmployment";

export type IndividualAccountSourceOfFunds =
  | "BusinessActivity"
  | "CapitalGains"
  | "FamilyContributions"
  | "InheritanceOrGift"
  | "Other"
  | "PersonalWealth"
  | "RealEstateIncome"
  | "Salary"
  | "SaleOfAssets"
  | "SelfEmployment";

export type IndividualRepresentative = {
  __typename: "IndividualRepresentative";
  /** Birth city of the representative. */
  birthCity?: Maybe<Scalars["String"]["output"]>;
  /** Postal code of the birth city. */
  birthCityPostalCode?: Maybe<Scalars["String"]["output"]>;
  /** Birth country code of the representative. */
  birthCountryCode?: Maybe<Scalars["CCA3"]["output"]>;
  /** Birth date of the representative. */
  birthDate?: Maybe<Scalars["String"]["output"]>;
  /** First name of the representative. */
  firstName?: Maybe<Scalars["String"]["output"]>;
  /** Gender of the representative (Male, Female, or Unknown). */
  gender?: Maybe<Gender>;
  /** Last name of the representative. */
  lastName?: Maybe<Scalars["String"]["output"]>;
  /** Nationality of the representative. */
  nationality?: Maybe<Scalars["CCA3"]["output"]>;
  /** Preferred first name of the representative. */
  preferredFirstName?: Maybe<Scalars["String"]["output"]>;
  /** Residency address of the representative. */
  residencyAddress?: Maybe<AddressInformation>;
  /** List of representative roles. */
  roles?: Maybe<Array<Scalars["String"]["output"]>>;
};

/** Individual shareholder info. */
export type IndividualShareholder = {
  __typename: "IndividualShareholder";
  /** Birth date of the shareholder. */
  birthDate: Scalars["String"]["output"];
  /** First name of the shareholder. */
  firstName: Scalars["String"]["output"];
  /** Last name of the shareholder. */
  lastName: Scalars["String"]["output"];
  /** CCA3 code for the country of nationality of the shareholder. */
  nationality: Scalars["CCA3"]["output"];
  /** Whether the shareholder is an individual or a company. */
  type: ShareholderType;
};

/**
 * Individual Ultimate Beneficial Owner
 * You need to describe the natural person (s) who hold, directly or indirectly, more than 25% of the capital or the rights of vote of the reporting company.
 * Please describe the company (s) that owns the company that wishes to open an account, when an individual holds in fine more than 25%
 */
export type IndividualUltimateBeneficialOwner = {
  __typename: "IndividualUltimateBeneficialOwner";
  /** individual birth city */
  birthCity?: Maybe<Scalars["String"]["output"]>;
  /** individual birth city postal code */
  birthCityPostalCode?: Maybe<Scalars["String"]["output"]>;
  /** individual birth country code */
  birthCountryCode?: Maybe<Scalars["CCA3"]["output"]>;
  /** individual birth date */
  birthDate?: Maybe<Scalars["DateTime"]["output"]>;
  /** individual first name */
  firstName?: Maybe<Scalars["String"]["output"]>;
  /** gender */
  gender?: Maybe<Gender>;
  /** Ultimate beneficial owner's identity document details */
  identityDocumentDetails?: Maybe<UboIdentityDocumentDetails>;
  /** Information relating to the type of the UBO */
  info: IndividualUltimateBeneficialOwnerInfo;
  /** individual last name */
  lastName?: Maybe<Scalars["String"]["output"]>;
  /** Individual beneficial owner residency Address */
  residencyAddress?: Maybe<AddressInformation>;
  /** Individual beneficial owner Tax or Identification Number */
  taxIdentificationNumber?: Maybe<Scalars["String"]["output"]>;
};

/** Define the type of the UBO */
export type IndividualUltimateBeneficialOwnerInfo = {
  /** Individual type */
  type: IndividualUltimateBeneficialOwnerTypeEnum;
};

export type IndividualUltimateBeneficialOwnerInput = {
  /** Individual birth city. Length must be from 0 to 100 characters */
  birthCity?: InputMaybe<Scalars["String"]["input"]>;
  /** Individual birth city postal code. Length must be from 0 to 50 characters */
  birthCityPostalCode?: InputMaybe<Scalars["String"]["input"]>;
  /** Individual birth country code */
  birthCountryCode?: InputMaybe<Scalars["CCA3"]["input"]>;
  /** Individual birth date. Must be a valid date in the YYYY/MM/DD format */
  birthDate?: InputMaybe<Scalars["String"]["input"]>;
  /** Define UBO is a Direct Owner */
  direct?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Individual beneficial owner first name. Length must be from 0 to 100 characters */
  firstName?: InputMaybe<Scalars["String"]["input"]>;
  /** Gender */
  gender?: InputMaybe<Gender>;
  /** Ultimate beneficial owner's identity document details */
  identityDocumentDetails?: InputMaybe<UboIdentityDocumentDetailsInput>;
  /** Define UBO is an Indirect Owner */
  indirect?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Individual beneficial owner last name. Length must be from 0 to 100 characters */
  lastName?: InputMaybe<Scalars["String"]["input"]>;
  /** Individual beneficial owner residency address */
  residencyAddress?: InputMaybe<ResidencyAddressInput>;
  /** Individual beneficial owner Tax or Identification Number */
  taxIdentificationNumber?: InputMaybe<Scalars["String"]["input"]>;
  /** Total of capital (in percentage, ex: 50 = 50%). Must be between 1 and 100. */
  totalCapitalPercentage?: InputMaybe<Scalars["Float"]["input"]>;
  /** Define UBO is a Legal Representative */
  type?: InputMaybe<IndividualUltimateBeneficialOwnerTypeEnum>;
};

/** Individual Ultimate beneficial owner nature */
export type IndividualUltimateBeneficialOwnerTypeEnum =
  /** The Beneficial Owner have shares */
  | "HasCapital"
  /** The Beneficial Owner is the representant legal */
  | "LegalRepresentative"
  /** Other */
  | "Other";

/** Individual Ultimate Beneficial Owner Type Has Capital */
export type IndividualUltimateBeneficialOwnerTypeHasCapital =
  IndividualUltimateBeneficialOwnerInfo & {
    __typename: "IndividualUltimateBeneficialOwnerTypeHasCapital";
    /** Define UBO is an Direct Owner */
    direct?: Maybe<Scalars["Boolean"]["output"]>;
    /** Define UBO is an Indirect Owner */
    indirect?: Maybe<Scalars["Boolean"]["output"]>;
    /** Total of capital (in percentage, ex: 50 = 50%) */
    totalCapitalPercentage?: Maybe<Scalars["Float"]["output"]>;
    /** Individual type */
    type: IndividualUltimateBeneficialOwnerTypeEnum;
  };

/** Individual Ultimate Beneficial Owner Type Legal Representative */
export type IndividualUltimateBeneficialOwnerTypeLegalRepresentative =
  IndividualUltimateBeneficialOwnerInfo & {
    __typename: "IndividualUltimateBeneficialOwnerTypeLegalRepresentative";
    /** Individual type */
    type: IndividualUltimateBeneficialOwnerTypeEnum;
  };

/** Individual Ultimate Beneficial Owner Type Other */
export type IndividualUltimateBeneficialOwnerTypeOther = IndividualUltimateBeneficialOwnerInfo & {
  __typename: "IndividualUltimateBeneficialOwnerTypeOther";
  /** Individual type */
  type: IndividualUltimateBeneficialOwnerTypeEnum;
};

export type IndividualVerificationRenewalAccountAdmin = {
  __typename: "IndividualVerificationRenewalAccountAdmin";
  employmentStatus: EmploymentStatus;
  firstName: Scalars["String"]["output"];
  lastName: Scalars["String"]["output"];
  monthlyIncome: MonthlyIncome;
  residencyAddress: Address;
};

export type IndividualVerificationRenewalAccountAdminInput = {
  employmentStatus?: InputMaybe<EmploymentStatus>;
  firstName?: InputMaybe<Scalars["String"]["input"]>;
  lastName?: InputMaybe<Scalars["String"]["input"]>;
  monthlyIncome?: InputMaybe<MonthlyIncome>;
  residencyAddress?: InputMaybe<ResidencyAddressInput>;
};

export type IndividualVerificationRenewalInfo = VerificationRenewalInfoBase & {
  __typename: "IndividualVerificationRenewalInfo";
  accountAdmin: IndividualVerificationRenewalAccountAdmin;
  additionalDetails?: Maybe<Scalars["String"]["output"]>;
  type: AccountHolderType;
};

export type InitiateCheckMerchantPaymentInput = {
  /** Amount of the concerned payment collection. For check deposit, the amount should not exceed 10 000€. */
  amount: AmountInput;
  /**
   * 31-character unique identifier located at the bottom of the check.
   * CMC7 is composed of 3 sections (check number (7 characters), check issuing bank code (12 characters), check holder account number (12 characters)).
   * Combined with RLMC key, it  allows the check to be traced.
   */
  cmc7: Scalars["String"]["input"];
  /**
   * Any string that you want to be attached to this payment collection.
   * Usually something to help you reference the payment in an external system.
   */
  externalReference?: InputMaybe<Scalars["String"]["input"]>;
  /**
   * Label of the concerned payment collection, which will be displayed on Swan bank statement.
   * If empty, default label will be set as "Check N° [1st 7 characters of CMC7]
   */
  label?: InputMaybe<Scalars["String"]["input"]>;
  /** ID of the merchant profile associated to the Swan creditor account. */
  merchantProfileId: Scalars["ID"]["input"];
  /** End-to-end reference of the concerned payment collection. */
  reference?: InputMaybe<Scalars["String"]["input"]>;
  /**
   * 2-digit key used to check the integrity of the CMC7 line, located at the bottom right of the check.
   * Combined with CMC7 line, it allows the check to be traced.
   */
  rlmcKey: Scalars["String"]["input"];
};

export type InitiateCheckMerchantPaymentPayload =
  | CheckRejection
  | DuplicateCheckRejection
  | ForbiddenRejection
  | InitiateCheckMerchantPaymentSuccessPayload
  | InternalErrorRejection
  | NotFoundRejection
  | ValidationRejection;

export type InitiateCheckMerchantPaymentSuccessPayload = {
  __typename: "InitiateCheckMerchantPaymentSuccessPayload";
  checkMerchantPayment: MerchantPayment;
  /** Details of the FNCI (Fichier national des chèques irréguliers) response */
  fnciInfo: FnciInfo;
};

/** Initiate credit transfers */
export type InitiateCreditTransfersInput = {
  /** account id to be debited identified by id */
  accountId?: InputMaybe<Scalars["ID"]["input"]>;
  /** account to be debited identified by number */
  accountNumber?: InputMaybe<Scalars["AccountNumber"]["input"]>;
  /** URL the user is redirected to after consent has been given */
  consentRedirectUrl: Scalars["String"]["input"];
  /** credit transfers (max 2500 records) */
  creditTransfers: Array<CreditTransferInput>;
  /**
   * A unique key used to ensure this operation executes only once, regardless of how many times it’s submitted.
   * If you provide the same idempotencyKey within a 24-hour period, the API will return the result of the original request
   * rather than executing the operation again. Use UUID v4 format recommended.
   */
  idempotencyKey?: InputMaybe<Scalars["String"]["input"]>;
};

export type InitiateCreditTransfersPayload =
  | AccountNotFoundRejection
  | BeneficiaryVerificationTokenAlreadyConsumedRejection
  | ForbiddenRejection
  | IdempotencyConflictRejection
  | InitiateCreditTransfersSuccessPayload
  | InternalErrorRejection
  | ValidationRejection;

export type InitiateCreditTransfersSuccessPayload = {
  __typename: "InitiateCreditTransfersSuccessPayload";
  /** Results of the beneficiary verifications in the same order as the beneficiary inputs */
  beneficiaryVerificationResults?: Maybe<Array<Maybe<VerifyBeneficiaryResult>>>;
  payment: Payment;
};

/** Input to initiate a funding request */
export type InitiateFundingRequestInput = {
  /** Amount of the requested funding, i.e. amount that will credit the concerned Swan account and debit the external funding source. */
  amount: AmountInput;
  /** Url to which the authorized account member must be redirected once the consent has been finalized. */
  consentRedirectUrl: Scalars["String"]["input"];
  /** ID of the funding source to be used to fund the concerned account */
  fundingSourceId: Scalars["ID"]["input"];
  /**
   * *SOON TO BE DEPRECATED*
   * If `true` the funds should be available immediately. If `false` or `null`, the funds will be available
   * after the resolution of the credit transaction.
   */
  isInstant?: InputMaybe<Scalars["Boolean"]["input"]>;
  /**
   * Label of the funding request that will be shown on the account holder statement and on the debtor account used
   * Always starts with 'Partner Name' truncated at 19 characters followed by a space.
   * If empty, default label is "Partner Name - Account Holder Name".
   */
  label?: InputMaybe<Scalars["String"]["input"]>;
  /** Reference of the funding request that will be shown on the account holder statement and on the debtor account used. */
  reference?: InputMaybe<Scalars["String"]["input"]>;
  /**
   * When the funding request should be executed. If `null`, it will be executed as soon as possible.
   * It is not possible to define this value when the option `isInstant` is set to true.
   */
  requestedExecutionAt?: InputMaybe<Scalars["DateTime"]["input"]>;
};

/** Initiate A Funding Request Payload */
export type InitiateFundingRequestPayload =
  | AccountVerificationWrongStatusRejection
  | ForbiddenRejection
  | FundingLimitExceededRejection
  | FundingSourceNotFoundRejection
  | FundingSourceWrongStatusRejection
  | GlobalFundingLimitExceededRejection
  | GlobalInstantFundingLimitExceededRejection
  | InitiateFundingRequestSuccessPayload
  | InstantFundingLimitExceededRejection
  | InsufficientFundsRejection
  | ProjectFundingLimitExceededRejection
  | ProjectInstantFundingLimitExceededRejection
  | ValidationRejection;

/** Initiate A Funding Request Success Payload */
export type InitiateFundingRequestSuccessPayload = {
  __typename: "InitiateFundingRequestSuccessPayload";
  /** Details of the funding payment created */
  payment: Payment;
};

/** Input to create a quote and an international beneficiary */
export type InitiateInternationalCreditTransferInput = {
  /** Account ID of the originator of the international credit transfer */
  accountId?: InputMaybe<Scalars["ID"]["input"]>;
  /** Account number if the beneficiary is a swan account */
  accountNumber?: InputMaybe<Scalars["AccountNumber"]["input"]>;
  /** When the consent flow is finished the user is redirected to this URL */
  consentRedirectUrl: Scalars["String"]["input"];
  /** External reference */
  externalReference?: InputMaybe<Scalars["String"]["input"]>;
  /** if the transfer will credit a new international beneficiary */
  internationalBeneficiary?: InputMaybe<InternationalBeneficiaryInput>;
  /** Transfer details */
  internationalCreditTransferDetails: Array<InternationalCreditTransferDetailsInput>;
  /** Language used to output errors */
  language?: InputMaybe<InternationalCreditTransferDisplayLanguage>;
  /** Target amount of the international credit transfer */
  targetAmount: AmountInput;
  /**
   * * COMING SOON *
   * if the transfer will credit an existing international beneficiary
   */
  trustedBeneficiaryId?: InputMaybe<Scalars["ID"]["input"]>;
};

/** Initiate International Credit Transfer Response Payload */
export type InitiateInternationalCreditTransferResponsePayload =
  | AccountNotFoundRejection
  | ForbiddenRejection
  | InitiateInternationalCreditTransferResponseSuccessPayload
  | InternalErrorRejection
  | ValidationRejection;

/** Initiate International Credit Transfer Response Success Payload */
export type InitiateInternationalCreditTransferResponseSuccessPayload = {
  __typename: "InitiateInternationalCreditTransferResponseSuccessPayload";
  /** Details of the international credit transfer created */
  payment: Payment;
  /** Details for the quote of international credit transfer */
  quote: InternationalCreditTransferQuote;
};

export type InitiateMerchantPaymentCollectionInput = {
  /** Amount of the concerned payment collection. For check deposit, the amount should not exceed 10 000€. */
  amount: AmountInput;
  /** external reference (JSON) that can be used by the Swan merchant for reconciliation purposes */
  externalReference?: InputMaybe<Scalars["String"]["input"]>;
  /** Internal direct debit type of payment collection */
  internalDirectDebit?: InputMaybe<InternalDirectDebitPaymentCollectionInput>;
  /**
   * Label of the concerned payment collection, which will be displayed on Swan bank statement -
   * For checks transaction, if empty, default label will be set as "Check N° [1st part of CMC7 - 7 char.]
   */
  label?: InputMaybe<Scalars["String"]["input"]>;
  /** end-to-end reference of the concerned payment collection */
  reference?: InputMaybe<Scalars["String"]["input"]>;
};

export type InitiateMerchantPaymentCollectionPayload =
  | BadRequestRejection
  | ForbiddenRejection
  | InitiateMerchantPaymentCollectionSuccessPayload
  | InternalErrorRejection
  | NotFoundRejection
  | ValidationRejection;

export type InitiateMerchantPaymentCollectionSuccessPayload = {
  __typename: "InitiateMerchantPaymentCollectionSuccessPayload";
  merchantPaymentCollection: Payment;
};

export type InitiateSepaDirectDebitMerchantPaymentInput = {
  /** Amount of the concerned payment collection */
  amount: AmountInput;
  /**
   * Any string that you want to be attached to this payment.
   * Usually something to help you reference it in an external system.
   */
  externalReference?: InputMaybe<Scalars["String"]["input"]>;
  /** Label of the concerned payment collection, which will be displayed on Swan bank statement. */
  label?: InputMaybe<Scalars["String"]["input"]>;
  /** Payment Mandate ID generated by Swan */
  mandateId: Scalars["ID"]["input"];
  /** End-to-end reference of the concerned payment collection. */
  reference?: InputMaybe<Scalars["String"]["input"]>;
  /** Date at which the Swan merchant wishes the payment to be executed */
  requestedExecutionAt?: InputMaybe<Scalars["DateTime"]["input"]>;
};

export type InitiateSepaDirectDebitMerchantPaymentPayload =
  | ForbiddenRejection
  | InitiateSepaDirectDebitMerchantPaymentSuccessPayload
  | InternalErrorRejection
  | NotFoundRejection
  | ValidationRejection;

export type InitiateSepaDirectDebitMerchantPaymentSuccessPayload = {
  __typename: "InitiateSepaDirectDebitMerchantPaymentSuccessPayload";
  merchantPayment: MerchantPayment;
  /** @deprecated use merchantPayment instead */
  paymentId: Scalars["ID"]["output"];
};

export type InstantFundingLimit = {
  __typename: "InstantFundingLimit";
  /** Maximum Instant Funding Amount authorized */
  amount: Amount;
  /** Instant Funding Amount that has already been used */
  funding?: Maybe<Amount>;
};

/** Rejection returned when the Account Holder Instant Funding limit has been exceeded */
export type InstantFundingLimitExceededRejection = Rejection & {
  __typename: "InstantFundingLimitExceededRejection";
  message: Scalars["String"]["output"];
};

/** Rejection returned when the Available balance is insufficient */
export type InsufficientFundsRejection = Rejection & {
  __typename: "InsufficientFundsRejection";
  message: Scalars["String"]["output"];
};

/** Internal Beneficiary */
export type InternalBeneficiary = {
  __typename: "InternalBeneficiary";
  /**
   * account number if the beneficiary is a swan account
   * @deprecated because it is not already implemented (a default value is set).
   */
  accountNumber: Scalars["AccountNumber"]["output"];
  /**
   * unique identifier of a beneficiary
   * *SOON TO BE DEPRECATED*
   * Always empty, It will be removed soon.
   * @deprecated this field is never filled. It will be removed soon.
   */
  id?: Maybe<Scalars["ID"]["output"]>;
  /**
   * `true` if this new beneficiary is the account holder himself in an other financial institution.
   * *SOON TO BE DEPRECATED*
   * Not used. It will be removed soon.
   * @deprecated this field is never filled. It will be removed soon.
   */
  isMyOwnIban: Scalars["Boolean"]["output"];
  /** full name of the beneficiary */
  name: Scalars["String"]["output"];
};

/** Internal Credit Transfer transaction */
export type InternalCreditTransfer = Transaction & {
  __typename: "InternalCreditTransfer";
  /** matching account for the transaction */
  account?: Maybe<Account>;
  /** amount */
  amount: Amount;
  /** [DEPRECATED] booked balance after this transaction. Deprecated in favor of statusInfo.balance.amount on BookedTransactionStatusInfo */
  bookedBalanceAfter?: Maybe<Amount>;
  /** name of the counterparty. e.g Merchant name, Creditor name, Beneficiary Name ... */
  counterparty: Scalars["String"]["output"];
  /** created date */
  createdAt: Scalars["DateTime"]["output"];
  /** creditor information */
  creditor: InternalCreditTransferCreditor;
  /** debtor information */
  debtor: InternalCreditTransferDebtor;
  /** a date that reflects the execution date of a transaction from a user viewpoint. Can be used for sorting transactions. */
  executionDate: Scalars["DateTime"]["output"];
  /**
   * an arbitrary identifier that was defined by you when you created this transaction.
   *
   * For example, you can define it in the CreditTransferInput mutation.
   */
  externalReference?: Maybe<Scalars["String"]["output"]>;
  /** unique identifier of the transaction */
  id: Scalars["ID"]["output"];
  /** `true` if this transaction can still be cancelled */
  isCancelable: Scalars["Boolean"]["output"];
  /** label */
  label: Scalars["String"]["output"];
  /** origin transaction associated to this transaction */
  originTransaction?: Maybe<Transaction>;
  /** ID of the origin transaction associated to this transaction */
  originTransactionId?: Maybe<Scalars["String"]["output"]>;
  /** payment associated to this transaction */
  payment?: Maybe<Payment>;
  /** ID of the payment associated to this transaction */
  paymentId?: Maybe<Scalars["String"]["output"]>;
  /** payment method identifier used for this transaction. e.g masked PAN or IBAN or accountNumber */
  paymentMethodIdentifier: Scalars["String"]["output"];
  /** payment product used for this transaction */
  paymentProduct: PaymentProduct;
  /** project id of the transaction */
  projectId: Scalars["ID"]["output"];
  /** reference assigned by the initiating party, to unambiguously identify the transaction. This reference is passed on, unchanged, throughout the entire reference chain. */
  reference: Scalars["String"]["output"];
  /** a date that reflects the time at which the user asked the transaction to be executed */
  requestedExecutionAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** r-transaction reason */
  returnReason?: Maybe<TransactionReasonCode>;
  /** side (Credit or Debit) */
  side: TransactionSide;
  /** true if a transaction statement can be generated for this transaction */
  statementCanBeGenerated?: Maybe<Scalars["Boolean"]["output"]>;
  /** status information */
  statusInfo: TransactionStatusInfo;
  supportingDocumentCollections: SupportingDocumentCollectionConnection;
  /** type */
  type: TransactionTypeEnum;
  /** updated date */
  updatedAt: Scalars["DateTime"]["output"];
};

/** Internal Credit Transfer transaction */
export type InternalCreditTransferSupportingDocumentCollectionsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  filters?: InputMaybe<SupportingDocumentCollectionFilterInput>;
  first?: Scalars["Int"]["input"];
};

/** Internal Credit Transfer creditor */
export type InternalCreditTransferCreditor = {
  /** account number */
  accountNumber: Scalars["AccountNumber"]["output"];
  /** full name of the Creditor */
  name: Scalars["String"]["output"];
};

/** Internal Credit Transfer debtor */
export type InternalCreditTransferDebtor = {
  /** account number */
  accountNumber: Scalars["AccountNumber"]["output"];
  /** full name of the debtor */
  name: Scalars["String"]["output"];
};

/** Internal Credit Transfer creditor for Incoming transaction */
export type InternalCreditTransferInCreditor = InternalCreditTransferCreditor & {
  __typename: "InternalCreditTransferInCreditor";
  /** account number */
  accountNumber: Scalars["AccountNumber"]["output"];
  /** full name of the creditor */
  name: Scalars["String"]["output"];
};

/** Internal Credit Transfer debtor for Incoming transaction */
export type InternalCreditTransferInDebtor = InternalCreditTransferDebtor & {
  __typename: "InternalCreditTransferInDebtor";
  /** account number */
  accountNumber: Scalars["AccountNumber"]["output"];
  /** full name of the creditor */
  name: Scalars["String"]["output"];
};

/** Internal Credit Transfer creditor for Outgoing transaction */
export type InternalCreditTransferOutCreditor = InternalCreditTransferCreditor & {
  __typename: "InternalCreditTransferOutCreditor";
  /** account number */
  accountNumber: Scalars["AccountNumber"]["output"];
  /** full name of the creditor */
  name: Scalars["String"]["output"];
};

/** Internal Credit Transfer debtor for Outgoing transaction */
export type InternalCreditTransferOutDebtor = InternalCreditTransferDebtor & {
  __typename: "InternalCreditTransferOutDebtor";
  /** account number */
  accountNumber: Scalars["AccountNumber"]["output"];
  /** full name of the creditor */
  name: Scalars["String"]["output"];
};

/** InternalDirectDebitB2BMerchantPaymentMethod */
export type InternalDirectDebitB2BMerchantPaymentMethod = MerchantPaymentMethod & {
  __typename: "InternalDirectDebitB2BMerchantPaymentMethod";
  /** Date at which the Merchant Payment Method was created */
  createdAt: Scalars["Date"]["output"];
  /** Unique identifier tied to every version of a given Merchant Payment Method */
  id: Scalars["ID"]["output"];
  /** Merchant Profile to which the Payment Method is attached */
  merchantProfile: MerchantProfile;
  /** Unique identifier for a given merchant Payment Method, identical for every version of a given Merchant Payment Method Type */
  methodId: Scalars["ID"]["output"];
  /** Rolling Reserve applied to the Merchant Payment Method */
  rollingReserve?: Maybe<RollingReserve>;
  /** Status of the Merchant Payment Method */
  statusInfo: MerchantPaymentMethodStatusInfo;
  /** The Merchant Payment Method Type */
  type: MerchantPaymentMethodType;
  /** Date at which the Merchant Payment Method was last updated */
  updatedAt: Scalars["Date"]["output"];
  /** Version of the Merchant Payment Method */
  version: Scalars["Int"]["output"];
};

export type InternalDirectDebitB2BPaymentMethodInput = {
  /** If `true`, the Payment Method will be Pending Review */
  activate?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** Internal Direct Debit Creditor */
export type InternalDirectDebitCreditor = {
  __typename: "InternalDirectDebitCreditor";
  /** unique identifier of the creditor account */
  accountId: Scalars["ID"]["output"];
};

/** Internal Direct Debit Debtor */
export type InternalDirectDebitDebtor = {
  __typename: "InternalDirectDebitDebtor";
  /** unique identifier of the debtor account */
  accountId: Scalars["ID"]["output"];
};

export type InternalDirectDebitMandate = {
  /** Unique identifier of the internal direct debit mandate, generated by Swan */
  id: Scalars["ID"]["output"];
};

export type InternalDirectDebitPaymentCollectionInput = {
  /** ID of the concerned payment mandate */
  mandateId: Scalars["ID"]["input"];
  /** Date at which the Swan merchant wishes the payment to be executed */
  requestedExecutionAt?: InputMaybe<Scalars["DateTime"]["input"]>;
};

export type InternalDirectDebitSequence = "OneOff" | "Recurrent";

/** InternalDirectDebitStandardMerchantPaymentMethod */
export type InternalDirectDebitStandardMerchantPaymentMethod = MerchantPaymentMethod & {
  __typename: "InternalDirectDebitStandardMerchantPaymentMethod";
  /** Date at which the Merchant Payment Method was created */
  createdAt: Scalars["Date"]["output"];
  /** Unique identifier tied to every version of a given Merchant Payment Method */
  id: Scalars["ID"]["output"];
  /** Merchant Profile to which the Payment Method is attached */
  merchantProfile: MerchantProfile;
  /** Unique identifier for a given merchant Payment Method, identical for every version of a given Merchant Payment Method Type */
  methodId: Scalars["ID"]["output"];
  /** Rolling Reserve applied to the Merchant Payment Method */
  rollingReserve?: Maybe<RollingReserve>;
  /** Status of the Merchant Payment Method */
  statusInfo: MerchantPaymentMethodStatusInfo;
  /** The Merchant Payment Method Type */
  type: MerchantPaymentMethodType;
  /** Date at which the Merchant Payment Method was last updated */
  updatedAt: Scalars["Date"]["output"];
  /** Version of the Merchant Payment Method */
  version: Scalars["Int"]["output"];
};

export type InternalDirectDebitStandardPaymentMethodInput = {
  /** If `true`, the Payment Method will be Pending Review */
  activate?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** Internal Direct Debit transaction */
export type InternalDirectDebitTransaction = Transaction & {
  __typename: "InternalDirectDebitTransaction";
  /** matching account for the transaction */
  account?: Maybe<Account>;
  /** amount */
  amount: Amount;
  /** [DEPRECATED] booked balance after this transaction. Deprecated in favor of statusInfo.balance.amount on BookedTransactionStatusInfo */
  bookedBalanceAfter?: Maybe<Amount>;
  /** name of the counterparty. e.g Merchant name, Creditor name, Beneficiary Name ... */
  counterparty: Scalars["String"]["output"];
  /** created date */
  createdAt: Scalars["DateTime"]["output"];
  /** creditor information */
  creditor: InternalDirectDebitCreditor;
  /** debtor information */
  debtor: InternalDirectDebitDebtor;
  /** a date that reflects the execution date of a transaction from a user viewpoint. Can be used for sorting transactions. */
  executionDate: Scalars["DateTime"]["output"];
  /**
   * an arbitrary identifier that was defined by you when you created this transaction.
   *
   * For example, you can define it in the CreditTransferInput mutation.
   */
  externalReference?: Maybe<Scalars["String"]["output"]>;
  /** unique identifier of the transaction */
  id: Scalars["ID"]["output"];
  /** `true` if this transaction can still be cancelled */
  isCancelable: Scalars["Boolean"]["output"];
  /** label */
  label: Scalars["String"]["output"];
  /** matching Internal mandate for the transaction */
  mandate?: Maybe<InternalDirectDebitMandate>;
  /** merchant profile associated */
  merchant?: Maybe<MerchantProfile>;
  /** origin transaction associated to this transaction */
  originTransaction?: Maybe<Transaction>;
  /** ID of the origin transaction associated to this transaction */
  originTransactionId?: Maybe<Scalars["String"]["output"]>;
  /** payment associated to this transaction */
  payment?: Maybe<Payment>;
  /** ID of the payment associated to this transaction */
  paymentId?: Maybe<Scalars["String"]["output"]>;
  /** payment method identifier used for this transaction: accountNumber */
  paymentMethodIdentifier: Scalars["String"]["output"];
  /** payment product used for this transaction */
  paymentProduct: PaymentProduct;
  /** project id of the transaction */
  projectId: Scalars["ID"]["output"];
  /** reference assigned by the initiating party, to unambiguously identify the transaction. This reference is passed on, unchanged, throughout the entire end-to-end chain. */
  reference: Scalars["String"]["output"];
  /** a date that reflects the time at which the user asked the transaction to be executed */
  requestedExecutionAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** reserved amount of the transaction computed with the rolling reserve. */
  reservedAmount?: Maybe<Amount>;
  /** date on which reserved funds become available. */
  reservedAmountReleasedAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** r-transaction reason */
  returnReason?: Maybe<TransactionReasonCode>;
  /** side (Credit or Debit) */
  side: TransactionSide;
  /** true if a transaction statement can be generated for this transaction */
  statementCanBeGenerated?: Maybe<Scalars["Boolean"]["output"]>;
  /** status information */
  statusInfo: TransactionStatusInfo;
  supportingDocumentCollections: SupportingDocumentCollectionConnection;
  /** type */
  type: TransactionTypeEnum;
  /** updated date */
  updatedAt: Scalars["DateTime"]["output"];
};

/** Internal Direct Debit transaction */
export type InternalDirectDebitTransactionSupportingDocumentCollectionsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  filters?: InputMaybe<SupportingDocumentCollectionFilterInput>;
  first?: Scalars["Int"]["input"];
};

/** Rejection returned on unexpected server error */
export type InternalErrorRejection = Rejection & {
  __typename: "InternalErrorRejection";
  message: Scalars["String"]["output"];
};

/** Payment direct debit mandate for Internal */
export type InternalPaymentDirectDebitMandate = InternalDirectDebitMandate &
  PaymentDirectDebitMandate &
  PaymentMandate & {
    __typename: "InternalPaymentDirectDebitMandate";
    /** Account Holder information */
    accountHolder: AccountHolder;
    /** Creation date of the Internal Direct Debit Payment Mandate */
    createdAt: Scalars["DateTime"]["output"];
    /** Internal Direct Debit Payment Mandate creditor information */
    creditor: InternalPaymentMandateCreditor;
    /** Internal Direct Debit Payment Mandate debtor information */
    debtor: InternalPaymentMandateDebtor;
    /** Date of the the last transaction executed for the concerned Internal Direct Debit Payment Mandate */
    executedAt?: Maybe<Scalars["DateTime"]["output"]>;
    /** Expiry date of the Internal Direct Debit Payment Mandate */
    expiredAt?: Maybe<Scalars["Date"]["output"]>;
    /** Unique identifier of the Internal Direct Debit Payment Mandate */
    id: Scalars["ID"]["output"];
    /** Language that will be used to produce the mandate PDF document */
    language: Scalars["String"]["output"];
    /** Internal Direct Debit Payment Mandate PDF document URL */
    mandateDocumentUrl: Scalars["String"]["output"];
    /** Custom name of the mandate */
    name?: Maybe<Scalars["String"]["output"]>;
    /** Unique reference of the Internal Direct Debit Payment Mandate */
    reference: Scalars["String"]["output"];
    /** Internal Direct Debit Payment Mandate scheme */
    scheme: InternalPaymentMandateScheme;
    /** Internal Direct Debit Payment Mandate sequence */
    sequence: PaymentMandateSequence;
    /** Signature date of the Internal Direct Debit Payment Mandate */
    signatureDate?: Maybe<Scalars["Date"]["output"]>;
    /** Internal Direct Debit Payment Mandate status information */
    statusInfo: PaymentMandateStatusInfo;
    /**
     * List of transactions associated with the Internal Payment Direct Debit Mandate.
     *
     * Implements the Relay Connection interface, used to paginate lists of elements. ([Learn More](https://docs.swan.io/developers/using-api/pagination))
     */
    transactions?: Maybe<TransactionConnection>;
    /** Internal direct debit ultimate creditor name */
    ultimateCreditorName?: Maybe<Scalars["String"]["output"]>;
    /** Last Update date of the Internal Direct Debit Payment Mandate */
    updatedAt: Scalars["DateTime"]["output"];
  };

/** Payment direct debit mandate for Internal */
export type InternalPaymentDirectDebitMandateTransactionsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  filters?: InputMaybe<TransactionsFiltersInput>;
  first?: Scalars["Int"]["input"];
  orderBy?: InputMaybe<TransactionsOrderByInput>;
};

export type InternalPaymentMandateCreditor = PaymentMandateCreditor & {
  __typename: "InternalPaymentMandateCreditor";
  /** Internal Direct Debit Payment Mandate creditor address */
  address: Address;
  /** Internal Direct Debit Payment Mandate creditor UUID */
  id: Scalars["ID"]["output"];
  /** Internal Direct Debit Payment Mandate Creditor Idenfier */
  identifier: Scalars["ID"]["output"];
  /** Internal Direct Debit Payment Mandate creditor name */
  name: Scalars["String"]["output"];
};

export type InternalPaymentMandateDebtor = PaymentMandateDebtor & {
  __typename: "InternalPaymentMandateDebtor";
  /** Internal Direct Debit Payment Mandate debtor address. Mandatory for non EEA Countries */
  accountId?: Maybe<Scalars["ID"]["output"]>;
  /** Internal Direct Debit Payment Mandate debtor address. Mandatory for non EEA Countries */
  address?: Maybe<Address>;
  /** Internal Direct Debit Payment Mandate debtor country */
  country: Scalars["CCA3"]["output"];
  /** Internal Direct Debit Payment Mandate debtor e-mail */
  email: Scalars["String"]["output"];
  /** Internal Direct Debit Payment Mandate debtor name */
  name: Scalars["String"]["output"];
};

export type InternalPaymentMandateScheme =
  /** Internal Direct Debit B2B */
  | "InternalDirectDebitB2b"
  /** Internal Direct Debit Standard */
  | "InternalDirectDebitStandard";

/** Received direct debit mandate for SEPA */
export type InternalReceivedDirectDebitMandate = InternalDirectDebitMandate &
  ReceivedDirectDebitMandate & {
    __typename: "InternalReceivedDirectDebitMandate";
    /** Account of the received internal direct debit mandate debtor */
    account?: Maybe<Account>;
    /** Creation date of the received internal direct debit mandate */
    createdAt: Scalars["DateTime"]["output"];
    /** Received internal direct debit creditor */
    creditor: InternalReceivedDirectDebitMandateCreditor;
    /** Date of the last internal direct debit transaction executed for the concerned received internal direct debit mandate */
    executedAt?: Maybe<Scalars["DateTime"]["output"]>;
    /** Expiry date of the received internal direct debit mandate, computed automatically (36 months from the executedAt date) */
    expiredAt?: Maybe<Scalars["Date"]["output"]>;
    /** Iban of the received internal direct debit mandate debtor */
    iban: Scalars["IBAN"]["output"];
    /** Unique identifier of the received internal direct debit mandate, generated by Swan */
    id: Scalars["ID"]["output"];
    /** Mandate name */
    name?: Maybe<Scalars["String"]["output"]>;
    /** Received internal direct debit Unique Mandate Reference (UMR) */
    reference: Scalars["String"]["output"];
    /** Received internal direct debit mandate scheme */
    scheme: InternalReceivedDirectDebitMandateScheme;
    /** Received internal direct debit mandate sequence */
    sequence: InternalReceivedDirectDebitMandateSequence;
    /** Date of signature of the received internal direct debit mandate */
    signatureDate?: Maybe<Scalars["Date"]["output"]>;
    /** Mandate status information of the received internal direct debit mandate */
    statusInfo: ReceivedDirectDebitMandateStatusInfo;
    /**
     * List of transactions associated with the Internal Receive Direct Debit Mandate.
     *
     * Implements the Relay Connection interface, used to paginate lists of elements. ([Learn More](https://docs.swan.io/developers/using-api/pagination))
     */
    transactions?: Maybe<TransactionConnection>;
    /** Received internal direct debit ultimate creditor name */
    ultimateCreditorName?: Maybe<Scalars["String"]["output"]>;
    /** Last Update date of the received internal direct debit mandate */
    updatedAt: Scalars["DateTime"]["output"];
    /** Version of the received internal direct debit mandate */
    version: Scalars["String"]["output"];
  };

/** Received direct debit mandate for SEPA */
export type InternalReceivedDirectDebitMandateTransactionsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  filters?: InputMaybe<TransactionsFiltersInput>;
  first?: Scalars["Int"]["input"];
};

/** Internal received direct debit mandate creditor */
export type InternalReceivedDirectDebitMandateCreditor = {
  __typename: "InternalReceivedDirectDebitMandateCreditor";
  /** Address of the creditor */
  address: Address;
  /** Creditor identifier */
  identifier: Scalars["String"]["output"];
  /** Name of the creditor */
  name: Scalars["String"]["output"];
};

/** Received internal direct debit mandate scheme */
export type InternalReceivedDirectDebitMandateScheme =
  /** When the received internal direct debit mandate can only be used for internal B2B direct debit transactions */
  | "InternalDirectDebitB2b"
  /** When the received internal direct debit mandate can only be used for internal Standard direct debit transactions */
  | "InternalDirectDebitStandard";

/** Internal received direct debit mandate sequence */
export type InternalReceivedDirectDebitMandateSequence =
  /** When the authorisation is given once by the Debtor to collect only one single internal direct debit */
  | "OneOff"
  /** When the authorisation by the Debtor can be used for regular internal direct debits initiated by the Creditor */
  | "Recurrent";

/** Address of an international beneficiary */
export type InternationalAddressInput = {
  /** Address 1 */
  address1?: InputMaybe<Scalars["String"]["input"]>;
  /** City */
  city?: InputMaybe<Scalars["String"]["input"]>;
  /** Country */
  country?: InputMaybe<Scalars["String"]["input"]>;
  /** State */
  state?: InputMaybe<Scalars["String"]["input"]>;
  /** Zip Code */
  zipCode?: InputMaybe<Scalars["String"]["input"]>;
};

export type InternationalBeneficiary = {
  /** Currency of the international beneficiary */
  currency: Scalars["Currency"]["output"];
  /** Currency-specific details of the beneficiary */
  details: Array<InternationalCreditTransferDetails>;
  /** name of the beneficiary */
  name: Scalars["String"]["output"];
  /** Route that Swan will use to transfer the funds */
  route: InternationalCreditTransferRoute;
};

/** International Beneficiary Details */
export type InternationalBeneficiaryDetailsInput = {
  /** Key */
  key: Scalars["String"]["input"];
  /** Value */
  value: Scalars["String"]["input"];
};

/** International Beneficiary Dynamic Forms */
export type InternationalBeneficiaryDynamicForms = {
  __typename: "InternationalBeneficiaryDynamicForms";
  /** Schemes */
  schemes: Array<Scheme>;
};

/** International Beneficiary */
export type InternationalBeneficiaryInput = {
  /** Currency of the international beneficiary account */
  currency: Scalars["Currency"]["input"];
  /** Currency-specific details of the beneficiary */
  details: Array<InternationalBeneficiaryDetailsInput>;
  /** Account holder name */
  name: Scalars["String"]["input"];
  /** Route that Swan will use to transfer the funds */
  route: InternationalCreditTransferRouteInput;
  /** Whether to save or not this beneficiary to the beneficiary list of the debited account */
  save?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type InternationalCreditTransferCreditor =
  | InternationalCreditTransferInCreditor
  | InternationalCreditTransferInDebtor
  | InternationalCreditTransferOutCreditor;

/** International Currency Exchange / Quote */
export type InternationalCreditTransferCurrencyExchange = {
  __typename: "InternationalCreditTransferCurrencyExchange";
  /** Rate of the quote */
  exchangeRate: Scalars["String"]["output"];
  /** Fees */
  feesAmount?: Maybe<Amount>;
  /** Source amount of the quote */
  sourceAmount?: Maybe<Amount>;
  /** target amount of the quote */
  targetAmount?: Maybe<Amount>;
};

export type InternationalCreditTransferDebtor =
  | InternationalCreditTransferInCreditor
  | InternationalCreditTransferInDebtor
  | InternationalCreditTransferOutDebtor;

/** International Credit Transfer - Currency-specific details of the beneficiary */
export type InternationalCreditTransferDetails = {
  __typename: "InternationalCreditTransferDetails";
  /** Key */
  key: Scalars["String"]["output"];
  /** Value */
  value: Scalars["String"]["output"];
};

/** International Credit Transfer Details */
export type InternationalCreditTransferDetailsInput = {
  /** Key */
  key: Scalars["String"]["input"];
  /** Value */
  value: Scalars["String"]["input"];
};

/** Language: ISO 639-1 language code */
export type InternationalCreditTransferDisplayLanguage =
  /** German */
  | "de"
  /** British English */
  | "en"
  /** Spanish */
  | "es"
  /** French */
  | "fr"
  /** Italian */
  | "it"
  /** Dutch */
  | "nl"
  /** Portuguese */
  | "pt";

/** International Credit Transfer Dynamic Form */
export type InternationalCreditTransferDynamicForm = {
  __typename: "InternationalCreditTransferDynamicForm";
  /** List of international transaction fields */
  fields: Array<Field>;
  /** Number of fields that need to be updated to fill the form completely. Please re run the query internationalCreditTransferTransactionDetailsDynamicForm with updated refreshableFields if the value of this field is not 0 */
  remainingFieldsToRefreshCount: Scalars["Int"]["output"];
};

/** International Credit Transfer In - Creditor info */
export type InternationalCreditTransferInCreditor = {
  __typename: "InternationalCreditTransferInCreditor";
  /** Bank Identifier Code */
  BIC: Scalars["BIC"]["output"];
  /**
   * International Bank Account Number
   * Only if the account membership has `canViewAccount=true` & this account has `paymentLevel=Unlimited`
   */
  IBAN: Scalars["IBAN"]["output"];
  /** maskedIBAN if the beneficiary is a an account in an other financial institution */
  maskedIBAN: Scalars["String"]["output"];
  /** Account holder name */
  name: Scalars["String"]["output"];
  /** identifier of a Virtual IBAN */
  virtualIBANEntryId?: Maybe<Scalars["ID"]["output"]>;
};

export type InternationalCreditTransferInDebtor = {
  __typename: "InternationalCreditTransferInDebtor";
  /** Account Number */
  accountNumber: Scalars["String"]["output"];
  /** BIC */
  bic?: Maybe<Scalars["String"]["output"]>;
  /** Account holder name */
  name: Scalars["String"]["output"];
};

/** International Credit Transfer Out - Creditor info */
export type InternationalCreditTransferOutCreditor = {
  __typename: "InternationalCreditTransferOutCreditor";
  /** Currency of the international beneficiary account */
  currency: Scalars["Currency"]["output"];
  /** Currency-specific details of the beneficiary */
  details: Array<InternationalCreditTransferDetails>;
  /** Account holder name */
  name: Scalars["String"]["output"];
  /** Route that Swan will use to transfer the funds */
  route: InternationalCreditTransferRoute;
};

export type InternationalCreditTransferOutDebtor = {
  __typename: "InternationalCreditTransferOutDebtor";
  /** Account holder name */
  name: Scalars["String"]["output"];
};

/** International Quote */
export type InternationalCreditTransferQuote = {
  __typename: "InternationalCreditTransferQuote";
  /** Rate of the quote */
  exchangeRate: Scalars["String"]["output"];
  /** Fees */
  feesAmount: Amount;
  /** Source amount of the quote */
  sourceAmount: Amount;
  /** target amount of the quote */
  targetAmount: Amount;
};

/** International Credit Transfer Route */
export type InternationalCreditTransferRoute =
  /** American ACH for low-value payments */
  | "Aba"
  /** Argentinian local route */
  | "Argentina"
  /** Australian local route */
  | "Australian"
  /** Australian local route Bpay usually used for bill payments */
  | "AustralianBpay"
  /** Brazilian local route */
  | "Brazil"
  /** Canadian local route */
  | "Canadian"
  /** Chilean local route */
  | "Chile"
  /** Costa Rican local route */
  | "CostaRica"
  /** Czech local route */
  | "Czech"
  /** Emirate local route */
  | "Emirates"
  /** American credit transfers service for large-value and time-critical payments */
  | "FedwireLocal"
  /** M-PAiSA */
  | "FijiMobile"
  /** Faster Payment System */
  | "HongKongFps"
  /** Hong Kong's local route */
  | "Hongkong"
  /** Hungarian local route */
  | "Hungarian"
  /** Local route using an IBAN as recipient account identifier */
  | "Iban"
  /** Indian local route */
  | "Indian"
  /** Indian instant payment system Unified Payments Interface */
  | "IndianUpi"
  /** Indonesian local route */
  | "Indonesian"
  /** Canadian payment network Interac */
  | "Interac"
  /** Israeli local route */
  | "IsraeliLocal"
  /** Japanese local route */
  | "Japanese"
  /** Kenyan local route */
  | "KenyaLocal"
  /** Kenyan mobile payment network M-PESA */
  | "KenyaMobile"
  /** Malaysian local route */
  | "Malaysian"
  /** Malaysian payment network DuitNow */
  | "MalaysianDuitnow"
  /** Mexican local route */
  | "Mexican"
  /** Moroccan local route */
  | "Morocco"
  /** Nepalese local route */
  | "Nepal"
  /** New Zealand local route */
  | "NewZealand"
  /** Filipino local route */
  | "Philippines"
  /** Filipino mobile payment network */
  | "PhilippinesMobile"
  /** Polish local route */
  | "Polish"
  /** Ukranian local route */
  | "PrivatBank"
  /** Singapore local route */
  | "Singapore"
  /** Singapore mobile payment network PayNow */
  | "SingaporePaynow"
  /** British local route */
  | "SortCode"
  /** South African local route */
  | "SouthAfrica"
  /** South Korean payment network Paygate */
  | "SouthKoreanPaygate"
  /** South Korean payment network Paygate for corporates */
  | "SouthKoreanPaygateBusiness"
  /** Swift */
  | "SwiftCode"
  /** Thai local route */
  | "Thailand"
  /** Turkish local route */
  | "TurkishEarthport"
  /** Unknown route */
  | "Unknown"
  /** Uruguayan local route */
  | "Uruguay"
  /** Vietnamese local route */
  | "VietnameEarthport";

/** International Credit Transfer Route */
export type InternationalCreditTransferRouteInput =
  /** American ACH for low-value payments */
  | "Aba"
  /** Argentinian local route */
  | "Argentina"
  /** Australian local route */
  | "Australian"
  /** Australian local route Bpay usually used for bill payments */
  | "AustralianBpay"
  /** Brazilian local route */
  | "Brazil"
  /** Canadian local route */
  | "Canadian"
  /** Chilean local route */
  | "Chile"
  /** Costa Rican local route */
  | "CostaRica"
  /** Czech local route */
  | "Czech"
  /** Emirate local route */
  | "Emirates"
  /** American credit transfers service for large-value and time-critical payments */
  | "FedwireLocal"
  /** M-PAiSA */
  | "FijiMobile"
  /** Faster Payment System */
  | "HongKongFps"
  /** Hong Kong's local route */
  | "Hongkong"
  /** Hungarian local route */
  | "Hungarian"
  /** Local route using an IBAN as recipient account identifier */
  | "Iban"
  /** Indian local route */
  | "Indian"
  /** Indian instant payment system Unified Payments Interface */
  | "IndianUpi"
  /** Indonesian local route */
  | "Indonesian"
  /** Canadian payment network Interac */
  | "Interac"
  /** Israeli local route */
  | "IsraeliLocal"
  /** Japanese local route */
  | "Japanese"
  /** Kenyan local route */
  | "KenyaLocal"
  /** Kenyan mobile payment network M-PESA */
  | "KenyaMobile"
  /** Malaysian local route */
  | "Malaysian"
  /** Malaysian payment network DuitNow */
  | "MalaysianDuitnow"
  /** Mexican local route */
  | "Mexican"
  /** Moroccan local route */
  | "Morocco"
  /** Nepalese local route */
  | "Nepal"
  /** New Zealand local route */
  | "NewZealand"
  /** Filipino local route */
  | "Philippines"
  /** Filipino mobile payment network */
  | "PhilippinesMobile"
  /** Polish local route */
  | "Polish"
  /** Ukranian local route */
  | "PrivatBank"
  /** Singapore local route */
  | "Singapore"
  /** Singapore mobile payment network PayNow */
  | "SingaporePaynow"
  /** British local route */
  | "SortCode"
  /** South African local route */
  | "SouthAfrica"
  /** South Korean payment network Paygate */
  | "SouthKoreanPaygate"
  /** South Korean payment network Paygate for corporates */
  | "SouthKoreanPaygateBusiness"
  /** Swift */
  | "SwiftCode"
  /** Thai local route */
  | "Thailand"
  /** Turkish local route */
  | "TurkishEarthport"
  /** Uruguayan local route */
  | "Uruguay"
  /** Vietnamese local route */
  | "VietnameEarthport";

/** International Credfit Transfer transaction */
export type InternationalCreditTransferTransaction = Transaction & {
  __typename: "InternationalCreditTransferTransaction";
  /** matching account for this transaction */
  account?: Maybe<Account>;
  /** amount */
  amount: Amount;
  /** International beneficiary linked to the transaction */
  beneficiary?: Maybe<InternationalBeneficiary>;
  /** [DEPRECATED] booked balance after this transaction. Deprecated in favor of statusInfo.balance.amount on BookedTransactionStatusInfo */
  bookedBalanceAfter?: Maybe<Amount>;
  /** name of the counterparty. e.g Merchant name, Creditor name, Beneficiary Name ... */
  counterparty: Scalars["String"]["output"];
  /** created date */
  createdAt: Scalars["DateTime"]["output"];
  /** creditor information */
  creditor: InternationalCreditTransferCreditor;
  /** quote given by our international provider */
  currencyExchange: InternationalCreditTransferCurrencyExchange;
  /** debtor information */
  debtor: InternationalCreditTransferDebtor;
  /** The delivery estimate indicates the expected time for the transfer to reach the beneficiary's bank account. */
  estimatedDeliveryAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** a date that reflects the execution date of a transaction from a user viewpoint. Can be used for sorting transactions. */
  executionDate: Scalars["DateTime"]["output"];
  /**
   * an arbitrary identifier that was defined by you when you created this transaction.
   *
   * For example, you can define it in the CreditTransferInput mutation.
   */
  externalReference?: Maybe<Scalars["String"]["output"]>;
  /** @deprecated(reason: "use `currencyExchange.feesAmount` instead") */
  fees?: Maybe<Amount>;
  /** unique identifier of the transaction */
  id: Scalars["ID"]["output"];
  /** instructed amount */
  instructedAmount?: Maybe<Amount>;
  /** list of fees charged by intermediary banks when receiving an International Credit Transfer */
  intermediaryBankFees?: Maybe<Array<Amount>>;
  /** `true` if this transaction can still be cancelled */
  isCancelable: Scalars["Boolean"]["output"];
  /** label */
  label: Scalars["String"]["output"];
  /** origin transaction associated to this transaction */
  originTransaction?: Maybe<Transaction>;
  /** ID of the origin transaction associated to this transaction */
  originTransactionId?: Maybe<Scalars["String"]["output"]>;
  /** payment associated to this transaction */
  payment?: Maybe<Payment>;
  /** ID of the payment associated to this transaction */
  paymentId?: Maybe<Scalars["String"]["output"]>;
  /** payment method identifier used for this transaction. e.g masked PAN or IBAN or accountNumber */
  paymentMethodIdentifier: Scalars["String"]["output"];
  /** payment product used for this transaction */
  paymentProduct: PaymentProduct;
  /** project id of the transaction */
  projectId: Scalars["ID"]["output"];
  /** external identifier of the transaction */
  reference: Scalars["String"]["output"];
  /** a date that reflects the time at which the user asked the transaction to be executed */
  requestedExecutionAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** return reason */
  returnReason?: Maybe<TransactionReasonCode>;
  /** side (Credit or Debit) */
  side: TransactionSide;
  /** true if a transaction statement can be generated for this transaction */
  statementCanBeGenerated?: Maybe<Scalars["Boolean"]["output"]>;
  /** status information */
  statusInfo: TransactionStatusInfo;
  supportingDocumentCollections: SupportingDocumentCollectionConnection;
  /** type */
  type: TransactionTypeEnum;
  /** updated date */
  updatedAt: Scalars["DateTime"]["output"];
};

/** International Credfit Transfer transaction */
export type InternationalCreditTransferTransactionSupportingDocumentCollectionsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  filters?: InputMaybe<SupportingDocumentCollectionFilterInput>;
  first?: Scalars["Int"]["input"];
};

/** Rejection returned on invalid argument error */
export type InvalidArgumentRejection = Rejection & {
  __typename: "InvalidArgumentRejection";
  code: InvalidArgumentRejectionCode;
  fields: Array<InvalidArgumentRejectionField>;
  message: Scalars["String"]["output"];
};

export type InvalidArgumentRejectionCode = "INVALID_INPUT";

export type InvalidArgumentRejectionField = {
  __typename: "InvalidArgumentRejectionField";
  errors: Array<Scalars["String"]["output"]>;
  name: Scalars["String"]["output"];
};

/** Information about the invalidity of the IBAN */
export type InvalidIban = {
  __typename: "InvalidIban";
  /** Enum that can be used to discriminate on the error */
  code: InvalidIbanCode;
  /** Iban from input */
  iban: Scalars["IBAN"]["output"];
  /** Message that give a bit of context during development */
  message: Scalars["String"]["output"];
};

/** InvalidIbanCode */
export type InvalidIbanCode =
  /** We do not know the banking institution referenced in this IBAN. */
  | "InvalidBank"
  /** The IBAN does not verify the mod97 algorithm */
  | "InvalidChecksum"
  /** Iban is either too short (<2) or does not match this country's specified length */
  | "InvalidLength"
  /** We do not know this IBAN Structure (Meaning that the country code is probably wrong) */
  | "InvalidStructure";

/** Describes an invalid identification level for the process associated to this identification, and the invalid reason can be accessed */
export type InvalidIdentificationLevelStatusInfo = {
  __typename: "InvalidIdentificationLevelStatusInfo";
  /** The reasons why this identification level is invalid */
  reasons?: Maybe<Array<IdentificationInvalidReason>>;
  /** Always set to `Invalid` */
  status: SwanIdentificationStatus;
};

export type InvalidMerchantPaymentMethodError = {
  __typename: "InvalidMerchantPaymentMethodError";
  code: InvalidMerchantPaymentMethodErrorCode;
  id?: Maybe<Scalars["String"]["output"]>;
  message: Scalars["String"]["output"];
  type: Scalars["String"]["output"];
};

export type InvalidMerchantPaymentMethodErrorCode =
  | "AlreadyActive"
  | "AlreadyInactive"
  | "InvalidSepaDirectDebitConfiguration"
  | "MissingPaymentMethod"
  | "Suspended";

export type InvalidPaymentMethodRequestRejection = Rejection & {
  __typename: "InvalidPaymentMethodRequestRejection";
  message: Scalars["String"]["output"];
  paymentMethods: Array<InvalidMerchantPaymentMethodError>;
};

/** Rejection returned if phone number is not well formatted */
export type InvalidPhoneNumberRejection = Rejection & {
  __typename: "InvalidPhoneNumberRejection";
  message: Scalars["String"]["output"];
};

/** Rejection returned if registration number is not correct */
export type InvalidRegistrationNumberRejection = Rejection & {
  __typename: "InvalidRegistrationNumberRejection";
  message: Scalars["String"]["output"];
};

/** Rejection returned when the provided shipping provider is not compatible with the card printing hub and shipping country */
export type InvalidShippingProviderRejection = Rejection & {
  __typename: "InvalidShippingProviderRejection";
  message: Scalars["String"]["output"];
};

/** Rejection returned if siren number is not well formatted */
export type InvalidSirenNumberRejection = Rejection & {
  __typename: "InvalidSirenNumberRejection";
  message: Scalars["String"]["output"];
};

/** Invoice */
export type Invoice = {
  __typename: "Invoice";
  /** account id */
  accountId: Scalars["ID"]["output"];
  /** due amount */
  amount: Amount;
  /** ending date of the billing window */
  closingDate: Scalars["DateTime"]["output"];
  /** creation date */
  createdAt: Scalars["DateTime"]["output"];
  /** date at which the link will not be useable anymore */
  expiresAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** unique id */
  id: Scalars["ID"]["output"];
  /** name of the invoice */
  name: Scalars["String"]["output"];
  /** starting date of the billing window */
  openingDate: Scalars["DateTime"]["output"];
  /** status of the invoice */
  status: InvoiceStatus;
  /** type of the invoice */
  type: InvoiceType;
  /** last update date */
  updatedAt: Scalars["DateTime"]["output"];
  /** temporary public url on which the file can be accessible */
  url?: Maybe<Scalars["String"]["output"]>;
};

/** Please see the Connection interface */
export type InvoiceConnection = Connection & {
  __typename: "InvoiceConnection";
  edges: Array<InvoiceEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars["Int"]["output"];
};

/** Please see the Edge interface */
export type InvoiceEdge = Edge & {
  __typename: "InvoiceEdge";
  cursor: Scalars["String"]["output"];
  node: Invoice;
};

/** The different statuses of invoice */
export type InvoiceStatus = "Failed" | "NotPaid" | "Paid" | "PaymentDue" | "Pending" | "Voided";

export type InvoiceType = "Invoice" | "RefundNote";

/** Key value details */
export type KeyValue = {
  __typename: "KeyValue";
  /** Key */
  key: Scalars["String"]["output"];
  /** Value */
  value: Scalars["String"]["output"];
};

/** Format of remittance label */
export type LabelType =
  /** Invoice reference following the ISO 11649 standard */
  | "Iso"
  /** Invoice reference following the Belgian standard - OGM-VCS is a known naming in Belgium */
  | "OgmVcs"
  /** Invoice reference in a structured format of up to 35 alphanumeric characters */
  | "Structured"
  /** Unstructured remittance information as currently used in label */
  | "Unstructured";

export type Language = "de" | "en" | "es" | "fi" | "fr" | "it" | "nl" | "pt";

export type LegalDocument = {
  __typename: "LegalDocument";
  /** ID of the legal document */
  id: Scalars["ID"]["output"];
  /** Language of the Legal Document */
  language: AccountLanguage;
  /** Status of the Legal Document */
  statusInfo: LegalDocumentStatusInfo;
  /** Type of the legal document */
  type: LegalDocumentType;
  /** Url to download the Document */
  url: Scalars["String"]["output"];
};

export type LegalDocumentActiveStatusInfo = LegalDocumentStatusInfo & {
  __typename: "LegalDocumentActiveStatusInfo";
  /** Activation date */
  activatedAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** Creation date */
  createdAt: Scalars["DateTime"]["output"];
  /** LegalDocument status (always Active for type LegalDocumentActiveStatusInfo) */
  status: LegalDocumentStatus;
};

/** Implements the Relay Connection interface, used to paginate the lists of elements. ([Learn More](https://docs.swan.io/developers/using-api/pagination)) */
export type LegalDocumentConnection = Connection & {
  __typename: "LegalDocumentConnection";
  /** LegalDocumentEdge list */
  edges: Array<LegalDocumentEdge>;
  /** Information about the current, the previous and the next page */
  pageInfo: PageInfo;
  /** Total number of element in the list */
  totalCount: Scalars["Int"]["output"];
};

/** Implements the Relay Edge interface */
export type LegalDocumentEdge = Edge & {
  __typename: "LegalDocumentEdge";
  /** Opaque identifier pointing to this node in the pagination mechanism */
  cursor: Scalars["String"]["output"];
  /** The account membership */
  node: LegalDocument;
};

export type LegalDocumentInactiveStatusInfo = LegalDocumentStatusInfo & {
  __typename: "LegalDocumentInactiveStatusInfo";
  /** Activation date */
  activatedAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** Creation date */
  createdAt: Scalars["DateTime"]["output"];
  /** Deactivation date */
  deactivatedAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** LegalDocument status (always Inactive for type LegalDocumentInactiveStatusInfo) */
  status: LegalDocumentStatus;
};

export type LegalDocumentStatus =
  /** When the LegalDocument is currently active on the account */
  | "Active"
  /** When the LegalDocument is no more active on the account */
  | "Inactive"
  /** When the LegalDocument will be the next active on the account */
  | "Upcoming";

export type LegalDocumentStatusInfo = {
  /** LegalDocument Status */
  status: LegalDocumentStatus;
};

export type LegalDocumentType =
  /** Swan Terms & Conditions of Use */
  "SwanTCU";

export type LegalDocumentUpcomingStatusInfo = LegalDocumentStatusInfo & {
  __typename: "LegalDocumentUpcomingStatusInfo";
  /** Creation date */
  createdAt: Scalars["DateTime"]["output"];
  /** Date when the LegalDocument will be activated */
  effectiveDate?: Maybe<Scalars["DateTime"]["output"]>;
  /** LegalDocument status (always Upcoming for type LegalDocumentUpcomingStatusInfo) */
  status: LegalDocumentStatus;
};

export type LegalDocumentsFilterInput = {
  status?: InputMaybe<LegalDocumentStatus>;
  type?: InputMaybe<LegalDocumentType>;
};

/** Legal form of the company */
export type LegalForm = "Placeholder";

export type LegalRepresentativeAccountMembershipCannotBeDisabledRejection = Rejection & {
  __typename: "LegalRepresentativeAccountMembershipCannotBeDisabledRejection";
  accountMembershipId: Scalars["String"]["output"];
  message: Scalars["String"]["output"];
};

export type LegalRepresentativeAccountMembershipCannotBeSuspendedRejection = Rejection & {
  __typename: "LegalRepresentativeAccountMembershipCannotBeSuspendedRejection";
  id: Scalars["String"]["output"];
  message: Scalars["String"]["output"];
};

export type LegalRepresentativeEmailCannotBeUpdatedRejection = {
  __typename: "LegalRepresentativeEmailCannotBeUpdatedRejection";
  message: Scalars["String"]["output"];
};

export type LegalRepresentativePermissionsCannotBeUpdatedRejection = {
  __typename: "LegalRepresentativePermissionsCannotBeUpdatedRejection";
  message: Scalars["String"]["output"];
};

/** Language: ISO 639-1 language code */
export type MandateLanguage = "de" | "en" | "es" | "fi" | "fr" | "it" | "nl" | "pt";

/** Rejection returned when the project has already reached the maximum daily exports. */
export type MaximumDailyExportsReachedRejection = Rejection & {
  __typename: "MaximumDailyExportsReachedRejection";
  message: Scalars["String"]["output"];
};

/** Rejection returned if notification daily rate limit has been reached */
export type MaximumDailyInvitationsReachedRejection = Rejection & {
  __typename: "MaximumDailyInvitationsReachedRejection";
  message: Scalars["String"]["output"];
};

/** Rejection returned when the project has already started exports of the same type. */
export type MaximumSimultaneousExportsRejection = Rejection & {
  __typename: "MaximumSimultaneousExportsRejection";
  message: Scalars["String"]["output"];
};

export type MembershipInfoInput = {
  /** `true` if this account membership can initiate credit transfers */
  canInitiatePayments: Scalars["Boolean"]["input"];
  /** `true` if this account membership can invite, update, suspend or resume account membership */
  canManageAccountMembership: Scalars["Boolean"]["input"];
  /** `true` if this account membership can add or canceled beneficiaries */
  canManageBeneficiaries: Scalars["Boolean"]["input"];
  /** `true` if this account membership can manage cards for himself or to the memberships he manages */
  canManageCards?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** `true` if this account membership can view account balances and transactions history */
  canViewAccount: Scalars["Boolean"]["input"];
  /** Email address */
  email: Scalars["String"]["input"];
  /** Language of the account membership */
  language?: InputMaybe<AccountLanguage>;
  /** Residency address of the member to be added */
  residencyAddress?: InputMaybe<ResidencyAddressInput>;
  /** Restricted to a user if necessary */
  restrictedTo: RestrictedToInput;
  /** Tax Identification Number of the user added */
  taxIdentificationNumber?: InputMaybe<Scalars["String"]["input"]>;
};

/** Filters that can be applied when listing account memberships */
export type MembershipsFilterInput = {
  /** Can the user initiate payments on this account */
  canInitiatePayments?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Can the user manage account membership */
  canManageAccountMembership?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Can the user manage beneficiaries */
  canManageBeneficiaries?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** `true` if this account membership can manage cards for himself or to the memberships he manages */
  canManageCards?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Can the user view account */
  canViewAccount?: InputMaybe<Scalars["Boolean"]["input"]>;
  /**
   * Search by email
   *
   * @deprecated(reason: "use `search` instead")
   */
  email?: InputMaybe<Scalars["String"]["input"]>;
  /**
   * Search by first name
   *
   * @deprecated(reason: "use `search` instead")
   */
  firstName?: InputMaybe<Scalars["String"]["input"]>;
  /**
   * Search by last name
   *
   * @deprecated(reason: "use `search` instead")
   */
  lastName?: InputMaybe<Scalars["String"]["input"]>;
  /**
   * Search string to look for
   *
   * Search will be performed in following fields:
   * - First name
   * - Last name
   * - Email
   * - ID
   */
  search?: InputMaybe<Scalars["String"]["input"]>;
  /** Account memberships status/statuses we're looking for */
  status?: InputMaybe<Array<AccountMembershipStatus>>;
  /** Filter by user */
  userId?: InputMaybe<Scalars["String"]["input"]>;
};

/** The different balances of the payment. Use this to understand in details what actions have been taken on the payment and what actions can be taken moving forward. */
export type MerchantBalance = {
  __typename: "MerchantBalance";
  /** The amount that can be canceled on this payment */
  availableToCancel: Amount;
  /** The amount that can be captured on this payment */
  availableToCapture: Amount;
  /** The amount that can be refunded on this payment */
  availableToRefund: Amount;
  /** The amount authorised */
  totalAuthorized: Amount;
  /** The amount canceled */
  totalCanceled: Amount;
  /** The amount captured */
  totalCaptured: Amount;
  /** The amount disputed */
  totalDisputed: Amount;
  /** The amount refunded */
  totalRefunded: Amount;
};

/** Rejection returned when the Merchant Card Payment is declined */
export type MerchantCardPaymentDeclinedRejection = Rejection & {
  __typename: "MerchantCardPaymentDeclinedRejection";
  message: Scalars["String"]["output"];
};

export type MerchantCategory =
  | "Culture"
  | "Entertainment"
  | "Finance"
  | "Groceries"
  | "HealthAndBeauty"
  | "HomeAndUtilities"
  | "Other"
  | "ProfessionalServices"
  | "PublicAdministrations"
  | "Restaurants"
  | "Shopping"
  | "Software"
  | "Transport"
  | "Travel";

/** MerchantCategoryDescription */
export type MerchantCategoryDescription =
  | "AccessoryAndApparelStoresMiscellaneous"
  | "AccountingAuditingAndBookkeepingServices"
  | "AdvertisingServices"
  | "AgriculturalCooperatives"
  | "AirCarriersAirlinesNotElsewhereClassified"
  | "AirConditioningAndRefrigerationRepairShops"
  | "AirConditioningHeatingAndPlumbingContractors"
  | "AirlinesAirCarriers"
  | "AirportsAirportTerminalsFlyingFields"
  | "AlterationsMendingSeamstressesTailors"
  | "AmbulanceServices"
  | "AmusementParksCarnivalsCircusesFortuneTellers"
  | "AntiqueReproductionStores"
  | "AntiqueShopsSalesRepairsAndRestorationServices"
  | "ApplianceRepairShopsElectricalAndSmall"
  | "AquariumsDolphinariumsZoosAndSeaquariums"
  | "ArchitecturalEngineeringAndSurveyingServices"
  | "ArtDealersAndGalleries"
  | "ArtistSupplyStoresCraftShops"
  | "AssociationsCivicSocialAndFraternal"
  | "AthleticFieldsCommercialSportsProfessionalSportsClubsSportsPromoters"
  | "AttorneysLegalServices"
  | "AutoStoreHomeSupplyStores"
  | "AutomatedCashDisbursementsCustomerFinancialInstitution"
  | "AutomobileAndTruckDealersSalesServiceRepairsPartsAndLeasing"
  | "AutomobileAndTruckDealersUsedOnlySales"
  | "AutomobileAssociations"
  | "AutomobileParkingLotsAndGarages"
  | "AutomobileRentalAgencyNotElsewhereClassified"
  | "AutomotiveBodyRepairShops"
  | "AutomotivePaintShops"
  | "AutomotivePartsAccessoriesStores"
  | "AutomotiveServiceShops"
  | "AutomotiveTireStores"
  | "BailAndBondPayments"
  | "Bakeries"
  | "BandsOrchestrasAndMiscellaneousEntertainersNotElsewhereClassified"
  | "BarberAndBeautyShops"
  | "BarsCocktailLoungesDiscothequesNightclubsAndTavernsDrinkingPlacesAlcoholicBeverages"
  | "BicycleShopsSalesAndService"
  | "BoatDealers"
  | "BoatLeasesAndBoatRentals"
  | "BookStores"
  | "BooksPeriodicalsAndNewspapers"
  | "BowlingAlleys"
  | "BridgeAndRoadFeesTolls"
  | "BuildingMaterialsLumberStores"
  | "BusLines"
  | "BusinessServicesNotElsewhereClassified"
  | "BuyingOrShoppingClubsServices"
  | "CableSatelliteAndOtherPayTelevisionAndRadioServices"
  | "CameraAndPhotographicSupplyStores"
  | "CamperDealersRecreationalAndUtilityTrailers"
  | "CampgroundsAndTrailerParks"
  | "CandyNutConfectioneryStores"
  | "CarRentalAgencies"
  | "CarWashes"
  | "CardGiftNoveltyAndSouvenirShops"
  | "CarpentryContractors"
  | "CarpetAndUpholsteryCleaning"
  | "Caterers"
  | "ChemicalsAndAlliedProductsNotElsewhereClassified"
  | "ChildCareServices"
  | "ChildrenAndInfantsWearStores"
  | "ChiropodistsPodiatrists"
  | "Chiropractors"
  | "CigarStoresAndStands"
  | "CleaningAndMaintenanceJanitorialServices"
  | "CleaningGarmentAndLaundryServices"
  | "ClockJewelryAndWatchRepairShops"
  | "ClockJewelryWatchAndSilverwareStore"
  | "ClothingRentalCostumesUniformsAndFormalWear"
  | "ClubsCountryClubsMembershipAthleticRecreationSportsPrivateGolfCourses"
  | "CollegesUniversitiesProfessionalSchoolsAndJuniorColleges"
  | "CommercialArtGraphicsPhotography"
  | "CommercialEquipmentNotElsewhereClassified"
  | "CommercialFootwear"
  | "ComputerMaintenanceRepairAndServicesNotElsewhereClassified"
  | "ComputerNetworkOrInformationServices"
  | "ComputerProgrammingDataProcessingAndIntegratedSystemsDesignServices"
  | "ComputerSoftwareStores"
  | "ComputersComputerPeripheralEquipmentSoftware"
  | "ConcreteWorkContractors"
  | "ConstructionMaterialsNotElsewhereClassified"
  | "ConsultingManagementAndPublicRelationsServices"
  | "ConsumerCreditReportingAgencies"
  | "ContractorsSpecialTradeNotElsewhereClassified"
  | "CosmeticStores"
  | "CourierServiceAirAndGroundFreightForwarders"
  | "CourtCostsIncludingAlimonyAndChildSupport"
  | "CruiseLines"
  | "CrystalAndGlasswareStores"
  | "DairyProductsStores"
  | "DanceHallsSchoolsAndStudios"
  | "DatingServices"
  | "DebtMarriagePersonalCounselingService"
  | "DentalAndMedicalLaboratories"
  | "DentalLaboratoryMedicalOphthalmicHospitalEquipmentAndSupplies"
  | "DentistsOrthodontists"
  | "DepartmentStores"
  | "DetectiveAgenciesProtectiveAgenciesSecurityServicesIncludingArmoredCarsGuardDogs"
  | "DigitalGoodsAudiovisualMediaIncludingBooksMoviesAndMusic"
  | "DigitalGoodsGames"
  | "DigitalGoodsMultiCategory"
  | "DigitalGoodsSoftwareApplicationsExcludingGames"
  | "DirectMarketingCatalogMerchants"
  | "DirectMarketingCombinationCatalogAndRetailMerchants"
  | "DirectMarketingContinuitySubscriptionMerchants"
  | "DirectMarketingInboundTelemarketingMerchants"
  | "DirectMarketingInsuranceServices"
  | "DirectMarketingOtherDirectMarketersNotElsewhereClassified"
  | "DirectMarketingOutboundTelemarketingMerchants"
  | "DirectMarketingTravelRelatedArrangementServices"
  | "DiscountStores"
  | "DoctorsNotElsewhereClassified"
  | "DoorToDoorSales"
  | "DraperyUpholsteryAndWindowCoveringsStores"
  | "DrugStoresPharmacies"
  | "DrugsDrugProprietorsAndDruggistsSundries"
  | "DryCleaners"
  | "DurableGoodsNotElsewhereClassified"
  | "DutyFreeStores"
  | "EatingPlacesRestaurants"
  | "ElectricRazorStoresSalesAndService"
  | "ElectricVehicleCharging"
  | "ElectricalContractors"
  | "ElectricalPartsAndEquipment"
  | "ElectronicRepairShops"
  | "ElectronicSales"
  | "EmploymentAgenciesTemporaryHelpServices"
  | "EquipmentFurnitureAndHomeFurnishingsStoresExceptAppliances"
  | "EquipmentRentalAndLeasingServicesFurnitureRentalToolRental"
  | "ExterminatingAndDisinfectingServices"
  | "FabricNeedleworkPieceGoodsAndSewingStores"
  | "FamilyClothingStores"
  | "FastFoodRestaurants"
  | "Fines"
  | "FireplaceFireplaceScreensAndAccessoriesStores"
  | "FloorCoveringStores"
  | "Florists"
  | "FloristsSuppliesNurseryStockAndFlowers"
  | "FreezerLockerMeatProvisioners"
  | "FuelDealersCoalFuelOilLiquefiedPetroleumWood"
  | "FuelDispenserAutomated"
  | "FuneralServiceAndCrematories"
  | "FurnitureReupholsteryAndRepairRefinishing"
  | "FurriersAndFurShops"
  | "GamblingTransactions"
  | "GameToyAndHobbyShops"
  | "GeneralContractorsResidentialAndCommercial"
  | "GlassPaintWallpaperStores"
  | "GolfCoursesPublic"
  | "GovernmentLicensedHorseOrDogRacingUSRegionOnly"
  | "GovernmentOwnedLotterySpecificCountries"
  | "GovernmentOwnedLotteryUSRegionOnly"
  | "GovernmentServicesNotElsewhereClassified"
  | "GroceryStoresSupermarkets"
  | "HardwareEquipmentAndSupplies"
  | "HardwareStores"
  | "HatCleaningShopsShoeRepairShopsShoeShineParlors"
  | "HealthAndBeautySpas"
  | "HealthPractitionersMedicalServicesNotElsewhereClassified"
  | "HearingAidsSalesServiceSupplyStores"
  | "HomeSupplyWarehouseStores"
  | "HorticulturalAndLandscapingServices"
  | "Hospitals"
  | "HouseholdApplianceStores"
  | "IndustrialSuppliesNotElsewhereClassified"
  | "InformationRetrievalServices"
  | "InsulationMasonryPlasteringStoneworkAndTileSettingContractors"
  | "InsuranceSalesUnderwritingAndPremiums"
  | "InternetGamblingUSRegionOnly"
  | "IntraGovernmentPurchasesGovernmentOnly"
  | "KeyEntryTelecomMerchantProvidingSingleLocalAndLongDistancePhoneCallsUsingACentralAccessNumberInANonFaceToFaceEnvironmentUsingKeyEntry"
  | "LaundryServicesFamilyAndCommercial"
  | "LawnAndGardenSupplyStores"
  | "LeatherGoodsAndLuggageStores"
  | "LimousinesAndTaxicabs"
  | "LodgingHotelsMotelsResorts"
  | "LodgingHotelsMotelsResortsNotElsewhereClassified"
  | "ManualCashDisbursementsCustomerFinancialInstitution"
  | "MarinasMarineServiceSupplies"
  | "MassageParlors"
  | "MenAndBoysClothingAndAccessoriesStores"
  | "MenAndWomenClothingStores"
  | "MenWomenAndChildrenUniformsAndCommercialClothing"
  | "MerchandiseAndServicesCustomerFinancialInstitution"
  | "MetalServiceCentersAndOffices"
  | "MiscellaneousAndSpecialtyRetailStores"
  | "MiscellaneousAutomotiveAircraftAndFarmEquipmentDealersNotElsewhereClassified"
  | "MiscellaneousFoodStoresConvenienceStoresMarketsSpecialtyStores"
  | "MiscellaneousGeneralMerchandiseStores"
  | "MiscellaneousHouseFurnishingSpecialtyShops"
  | "MiscellaneousPublishingAndPrinting"
  | "MiscellaneousRepairShopsAndRelatedServices"
  | "MobileHomeDealers"
  | "MoneySendFunding"
  | "MoneySendInterCountry"
  | "MoneySendIntraCountry"
  | "MoneyTransfer"
  | "MotionPictureAndVideoTapeProductionAndDistribution"
  | "MotionPictureTheaters"
  | "MotorFreightCarriersTruckingLocalLongDistanceMovingAndStorageCompaniesLocalDelivery"
  | "MotorHomeAndRecreationalVehicleRental"
  | "MotorHomeDealers"
  | "MotorVehicleSuppliesAndNewParts"
  | "MotorcycleShopsAndDealers"
  | "MusicStoresMusicalInstrumentsPianosSheetMusic"
  | "NewsDealersAndNewsstands"
  | "NondurableGoodsNotElsewhereClassified"
  | "NursingAndPersonalCareFacilities"
  | "OfficeAndCommercialFurniture"
  | "OfficePhotographicPhotocopyAndMicrofilmEquipment"
  | "OfficeSchoolSupplyAndStationeryStores"
  | "OpticiansOpticalGoodsAndEyeglasses"
  | "OptometristsOphthalmologists"
  | "OrganizationsCharitableAndSocialService"
  | "OrganizationsMembershipNotElsewhereClassified"
  | "OrganizationsPolitical"
  | "OrganizationsReligious"
  | "OrthopedicGoodsArtificialLimbStores"
  | "OsteopathicPhysicians"
  | "OtherServicesNotElsewhereClassified"
  | "PackageStoresBeerWineAndLiquor"
  | "PaintsVarnishesAndSupplies"
  | "PassengerRailways"
  | "PawnShops"
  | "PaymentTransactionCustomerFinancialInstitution"
  | "PaymentTransactionMerchant"
  | "PetShopsPetFoodAndSupplies"
  | "PetroleumAndPetroleumProducts"
  | "PhotoDevelopingPhotofinishingLaboratories"
  | "PhotographicStudios"
  | "PieceGoodsNotionsAndOtherDryGoods"
  | "PlumbingAndHeatingEquipment"
  | "PoiFundingTransactions"
  | "PoolAndBilliardEstablishments"
  | "PostalServicesGovernmentOnly"
  | "PreciousStonesAndMetalsWatchesAndJewelry"
  | "ProfessionalServicesNotElsewhereClassified"
  | "PublicWarehousingFarmProductsRefrigeratedGoodsHouseholdGoodsStorage"
  | "QuasiCashCustomerFinancialInstitution"
  | "QuasiCashMerchant"
  | "QuickCopyReproductionAndBlueprintingServices"
  | "RailroadsFreight"
  | "RealEstateAgentsAndManagersRentals"
  | "RecordShops"
  | "RecreationServicesNotElsewhereClassified"
  | "RecreationalAndSportingCamps"
  | "ReligiousGoodsStores"
  | "RoofingAndSidingSheetMetalWorkContractors"
  | "SalvageAndWreckingYards"
  | "SanitationPolishingAndSpecialtyCleaningPreparations"
  | "SchoolsAndEducationalServicesNotElsewhereClassified"
  | "SchoolsBusinessAndSecretarial"
  | "SchoolsCorrespondence"
  | "SchoolsElementaryAndSecondary"
  | "SchoolsTradeAndVocational"
  | "SecondHandStoresUsedMerchandiseStores"
  | "SecuritiesBrokersDealers"
  | "ServiceStationsWithOrWithoutAncillaryServices"
  | "ShoeStores"
  | "SnowmobileDealers"
  | "SportingGoodsStores"
  | "SportsApparelRidingApparelStores"
  | "StampAndCoinStoresPhilatelicAndNumismaticSupplies"
  | "StationeryOfficeSuppliesPrintingAndWritingPaper"
  | "StenographicAndSecretarialSupportServices"
  | "SwimmingPoolsSalesAndSupplies"
  | "TaxPayments"
  | "TaxPreparationService"
  | "TelecommunicationEquipmentIncludingTelephoneSales"
  | "TelecommunicationServicesIncludingButNotLimitedToPrepaidPhoneServicesAndRecurringPhoneServices"
  | "TelegraphServices"
  | "TentAndAwningShops"
  | "TestingLaboratoriesNonMedical"
  | "TheatricalProducersExceptMotionPicturesAndTicketAgencies"
  | "Timeshares"
  | "TireRetreadingAndRepairShops"
  | "TouristAttractionsAndExhibits"
  | "TowingServices"
  | "TransportationServicesNotElsewhereClassified"
  | "TransportationSuburbanAndLocalCommuterPassengerIncludingFerries"
  | "TravelAgenciesAndTourOperators"
  | "TruckRental"
  | "TypesettingPlateMakingAndRelatedServices"
  | "TypewriterStoresRentalsSalesService"
  | "Unknown"
  | "UtilitiesElectricGasHeatingOilSanitaryWater"
  | "VarietyStores"
  | "VeterinaryServices"
  | "VideoAmusementGameSupplies"
  | "VideoEntertainmentRentalStores"
  | "VideoGameArcadesOrEstablishments"
  | "WeldingRepair"
  | "WholesaleClubs"
  | "WigAndToupeeShops"
  | "WomenAccessoryAndSpecialtyStores"
  | "WomenReadyToWearStores";

export type MerchantPayment = {
  /** amount */
  amount: Amount;
  /**
   * Authorized date
   * @deprecated use authorizedAt in statusInfo instead
   */
  authorizedAt?: Maybe<Scalars["DateTime"]["output"]>;
  balance: MerchantBalance;
  /** The billing address associated to the payment */
  billingAddress?: Maybe<Address>;
  /**
   * Canceled date
   * @deprecated use canceledAt in statusInfo instead
   */
  canceledAt?: Maybe<Scalars["DateTime"]["output"]>;
  /**
   * Captured date
   * @deprecated use capturedAt in statusInfo instead
   */
  capturedAt?: Maybe<Scalars["DateTime"]["output"]>;
  /**
   * Created date
   * @deprecated use createdAt in statusInfo instead
   */
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  /**
   * Disputed date
   * @deprecated use disputedAt in statusInfo instead
   */
  disputedAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** an arbitrary identifier that was defined by you when you created this payment */
  externalReference?: Maybe<Scalars["String"]["output"]>;
  /** unique identifier of a merchant payment */
  id: Scalars["ID"]["output"];
  /** Label */
  label?: Maybe<Scalars["String"]["output"]>;
  /** merchant profile associated to the merchant payment */
  merchantProfile: MerchantProfile;
  /**
   * payment link associated to the merchant payment
   * @deprecated The field is available on concrete types where relevant
   */
  paymentLink?: Maybe<MerchantPaymentLink>;
  /**
   * payment link associated to the merchant payment
   * @deprecated The field is available on concrete types where relevant
   */
  paymentMandate: PaymentMandate;
  /** payment method associated to the merchant payment */
  paymentMethod: MerchantPaymentMethod;
  reference?: Maybe<Scalars["String"]["output"]>;
  /**
   * Refunded date
   * @deprecated use refundedAt in statusInfo instead
   */
  refundedAt?: Maybe<Scalars["DateTime"]["output"]>;
  /**
   * Rejected date
   * @deprecated use rejectedAt in statusInfo instead
   */
  rejectedAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** status information */
  statusInfo: MerchantPaymentStatusInfo;
  /**
   * List of transactions associated with the Merchant Payment.
   *
   * Implements the Relay Connection interface, used to paginate lists of elements. ([Learn More](https://docs.swan.io/developers/using-api/pagination))
   */
  transactions?: Maybe<TransactionConnection>;
  /** Updated date */
  updatedAt: Scalars["DateTime"]["output"];
};

export type MerchantPaymentTransactionsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  filters?: InputMaybe<TransactionsFiltersInput>;
  first?: Scalars["Int"]["input"];
  orderBy?: InputMaybe<TransactionsOrderByInput>;
};

/** Merchant Payment status authorized */
export type MerchantPaymentAuthorized = MerchantPaymentStatusInfo & {
  __typename: "MerchantPaymentAuthorized";
  /** Authorized date */
  authorizedAt: Scalars["DateTime"]["output"];
  /** Created date */
  createdAt: Scalars["DateTime"]["output"];
  /** status of the merchant payment */
  status: MerchantPaymentStatus;
};

/** Merchant Payment status canceled */
export type MerchantPaymentCanceled = MerchantPaymentStatusInfo & {
  __typename: "MerchantPaymentCanceled";
  /** Canceled date */
  canceledAt: Scalars["DateTime"]["output"];
  /** Created date */
  createdAt: Scalars["DateTime"]["output"];
  /** status of the merchant payment */
  status: MerchantPaymentStatus;
};

/** Merchant Payment status captured */
export type MerchantPaymentCaptured = MerchantPaymentStatusInfo & {
  __typename: "MerchantPaymentCaptured";
  /** Authorized date */
  authorizedAt: Scalars["DateTime"]["output"];
  /** Captured date */
  capturedAt: Scalars["DateTime"]["output"];
  /** Created date */
  createdAt: Scalars["DateTime"]["output"];
  /** status of the merchant payment */
  status: MerchantPaymentStatus;
};

/** Implements the Relay Connection interface, used to paginate list of element ([Learn More](https://docs.swan.io/api/pagination)) */
export type MerchantPaymentConnection = Connection & {
  __typename: "MerchantPaymentConnection";
  /** Edge list */
  edges: Array<MerchantPaymentEdge>;
  /** Information about the current, the previous and the next page */
  pageInfo: PageInfo;
  /** Total number of element in the list */
  totalCount: Scalars["Int"]["output"];
};

/** Merchant Payment status disputed */
export type MerchantPaymentDisputed = MerchantPaymentStatusInfo & {
  __typename: "MerchantPaymentDisputed";
  /** Authorized date */
  authorizedAt: Scalars["DateTime"]["output"];
  /** Captured date */
  capturedAt: Scalars["DateTime"]["output"];
  /** Created date */
  createdAt: Scalars["DateTime"]["output"];
  /** Disputed date */
  disputedAt: Scalars["DateTime"]["output"];
  /** status of the merchant payment */
  status: MerchantPaymentStatus;
};

/** Implements the Relay Edge interface */
export type MerchantPaymentEdge = Edge & {
  __typename: "MerchantPaymentEdge";
  /** Opaque identifier pointing to this node in the pagination mechanism */
  cursor: Scalars["String"]["output"];
  node: MerchantPayment;
};

/** Filters that can be applied when listing merchant payments */
export type MerchantPaymentFiltersInput = {
  accountId?: InputMaybe<Scalars["String"]["input"]>;
  /** Filter by amount (amount is greater than a given amount) */
  amountGreaterThan?: InputMaybe<Scalars["AmountValue"]["input"]>;
  /** Filter by amount (amount is less than a given amount) */
  amountSmallerThan?: InputMaybe<Scalars["AmountValue"]["input"]>;
  /** Filter by createdAt (created after a given date) */
  isAfterCreatedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** Filter by createdAt (created before a given date) */
  isBeforeCreatedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** Filter by Method Type */
  paymentMethod?: InputMaybe<Array<MerchantPaymentMethodType>>;
  /**
   * Search string to look for
   *
   * Search will be performed in following fields:
   *  - Label
   *  - Reference
   *  - External Reference
   *  - Amount
   */
  search?: InputMaybe<Scalars["String"]["input"]>;
  /** Filter by status */
  status?: InputMaybe<Array<MerchantPaymentStatus>>;
};

/** Merchant Payment status initiated */
export type MerchantPaymentInitiated = MerchantPaymentStatusInfo & {
  __typename: "MerchantPaymentInitiated";
  /** Created date */
  createdAt: Scalars["DateTime"]["output"];
  /** status of the merchant payment */
  status: MerchantPaymentStatus;
};

export type MerchantPaymentLink = {
  __typename: "MerchantPaymentLink";
  /** Amount to be paid to successfully complete the payment. */
  amount: Amount;
  /**
   * The customer billing Address
   * These fields should be completed also to pre-fill a SEPA direct debit mandate.
   *
   * We strongly advice to complete these fields if merchants want to get paid through card payment method, in order to minimize the risk of payment rejection by Visa / Mastercard schemes
   */
  billingAddress?: Maybe<Address>;
  /** URL to redirect the user to if they cancel their payment */
  cancelRedirectUrl?: Maybe<Scalars["String"]["output"]>;
  createdAt: Scalars["DateTime"]["output"];
  /**
   *  We will use the information specified here to prefill the payment link fields
   * depending on the payment method the end user chooses.
   * Keep in mind that your end customer will be able to edit these fields.
   */
  customer?: Maybe<Customer>;
  /**
   * Any string that you want to be attached to this payment link.
   * Usually something to help you reference the link in an external system.
   */
  externalReference?: Maybe<Scalars["String"]["output"]>;
  /** Merchant payment link's unique ID. */
  id: Scalars["String"]["output"];
  /** Label of the concerned payment collection, which will be displayed on Swan bank statement	and on the Swan merchant payment page. */
  label?: Maybe<Scalars["String"]["output"]>;
  /**
   * The language used for the payment page.
   * Default is the browser's language, or English if not available.
   */
  language?: Maybe<Scalars["String"]["output"]>;
  /** The Merchant Profile to link this Payment Link to */
  merchantProfile: MerchantProfile;
  /**
   * List of payment methods IDs enabled for this payment link.
   * If the array is empty Swan will allow all the payment methods that are enabled for the merchant profile (except for Check and Internal Direct Debit)
   */
  paymentMethods: Array<MerchantPaymentMethod>;
  /** ID of the related project */
  projectId: Scalars["ID"]["output"];
  /** Merchant Website URL to redirect the user to when the payment is completed. */
  redirectUrl?: Maybe<Scalars["String"]["output"]>;
  /**
   * Optional field intended to provide a way for you to include a reference number or code.
   * The customer will most likely see this value on their bank statement, though we can't know as every banking platform is different.
   */
  reference?: Maybe<Scalars["String"]["output"]>;
  /**
   *   A date that reflects the time at which the user asked the transaction to be executed.
   * For card transactions, request execution must occur within 7 days after authorization or the authorization may expire.
   * For SEPA Direct Debit transactions, request execution must occur up to 1 year in the future.
   *
   * Default value means that the execution will be as soon as possible
   */
  requestedExecutionAt?: Maybe<Scalars["DateTime"]["output"]>;
  /**
   * Controls if the payment mandate created from this payment link is for one-time use or can be reused
   * This is applicable for card and SEPA Direct Debit payment methods only.
   */
  sequence: PaymentMandateSequence;
  /** The merchant payment link status. */
  statusInfo: MerchantPaymentLinkStatusInfo;
  /** The URL at which the customer can complete the payment. */
  url: Scalars["String"]["output"];
};

/** Implements the Relay Connection interface, used to paginate list of element ([Learn More](https://docs.swan.io/api/pagination)) */
export type MerchantPaymentLinkConnection = Connection & {
  __typename: "MerchantPaymentLinkConnection";
  /** Edge list */
  edges: Array<MerchantPaymentLinkEdge>;
  /** Information about the current, the previous and the next page */
  pageInfo: PageInfo;
  /** Total number of element in the list */
  totalCount: Scalars["Int"]["output"];
};

/** Implements the Relay Edge interface */
export type MerchantPaymentLinkEdge = Edge & {
  __typename: "MerchantPaymentLinkEdge";
  /** Opaque identifier pointing to this node in the pagination mechanism */
  cursor: Scalars["String"]["output"];
  node: MerchantPaymentLink;
};

/** Filters that can be applied when listing merchant payment links */
export type MerchantPaymentLinkFiltersInput = {
  /** Filter by amount (amount is greater than a given amount) */
  amountGreaterThan?: InputMaybe<Scalars["AmountValue"]["input"]>;
  /** Filter by amount (amount is less than a given amount) */
  amountSmallerThan?: InputMaybe<Scalars["AmountValue"]["input"]>;
  /** Filter by createdAt (created after a given date) */
  isAfterCreatedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** Filter by createdAt (created before a given date) */
  isBeforeCreatedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
  /**
   * Search string to look for
   *
   * Search will be performed in following fields:
   *  - Label
   *  - Reference
   *  - Amount
   */
  search?: InputMaybe<Scalars["String"]["input"]>;
  /** Filter by status */
  status?: InputMaybe<Array<MerchantPaymentLinkStatus>>;
};

/** Field we can use when ordering that can be applied when listing merchant payment links */
export type MerchantPaymentLinkOrderByFieldInput = "createdAt" | "label" | "url";

/** Order that can be applied when listing merchant payment links */
export type MerchantPaymentLinkOrderByInput = {
  direction?: InputMaybe<OrderByDirection>;
  field?: InputMaybe<MerchantPaymentLinkOrderByFieldInput>;
};

export type MerchantPaymentLinkStatus =
  /** Customers can still use the merchant payment link to pay. */
  | "Active"
  /** The customer completed the payment. */
  | "Completed"
  /** The merchant payment link is expired. */
  | "Expired";

export type MerchantPaymentLinkStatusInfo = {
  status: MerchantPaymentLinkStatus;
};

/** Base object for the different Payment Methods available */
export type MerchantPaymentMethod = {
  /** Date at which the Merchant Payment Method was created */
  createdAt: Scalars["Date"]["output"];
  /** Unique identifier tied to every version of a given Merchant Payment Method */
  id: Scalars["ID"]["output"];
  /** Merchant Profile to which the Payment Method is attached */
  merchantProfile: MerchantProfile;
  /** Unique identifier for a given merchant Payment Method, identical for every version of a given Merchant Payment Method Type */
  methodId: Scalars["ID"]["output"];
  /** Rolling Reserve applied to the Merchant Payment Method */
  rollingReserve?: Maybe<RollingReserve>;
  /** Status of the Merchant Payment Method */
  statusInfo: MerchantPaymentMethodStatusInfo;
  /** The Merchant Payment Method Type */
  type: MerchantPaymentMethodType;
  /** Date at which the Merchant Payment Method was last updated */
  updatedAt: Scalars["Date"]["output"];
  /** Version of the Merchant Payment Method */
  version: Scalars["Int"]["output"];
};

/** The different rejection reasons for a CardMerchantPaymentMethod */
export type MerchantPaymentMethodCardRejectReason =
  | "SwanRefused"
  | "SwanTechnicalErrorOccurred"
  | "UnsupportedBusiness";

/** Rejection returned when the Merchant Payment Method is not active */
export type MerchantPaymentMethodNotActiveRejection = Rejection & {
  __typename: "MerchantPaymentMethodNotActiveRejection";
  message: Scalars["String"]["output"];
  paymentMethodIds?: Maybe<Array<Scalars["String"]["output"]>>;
};

export type MerchantPaymentMethodNotCompatibleRejection = Rejection & {
  __typename: "MerchantPaymentMethodNotCompatibleRejection";
  id: Scalars["String"]["output"];
  message: Scalars["String"]["output"];
};

/** The different rejection reasons a MerchantPaymentMethod can have */
export type MerchantPaymentMethodRejectionReason =
  /** We gave a custom criteria to the partner and it’s in violation */
  | "ContractualCriteriaNotFulfilled"
  /** General rejection where we don't want to provide more info (eg, fraudster with sensitive info) */
  | "GenericRejection"
  /** Merchant denied or failed to provide a relevant requested information */
  | "InconsistentOrMissingInformation"
  /** Payment method requested makes no sense for the business model */
  | "InvalidUseCase"
  | "SuspiciousBehavior"
  /** General rejection where an error occurred on Swan's side. */
  | "SwanTechnicalErrorOccurred"
  | "UnsupportedActivity"
  /** Merchant profile is not supported */
  | "UnsupportedMerchantProfile"
  /** Partner isn’t allowed to request this payment method */
  | "UnsupportedPaymentMethod";

export type MerchantPaymentMethodSepaDirectDebitInvalidRejection = Rejection & {
  __typename: "MerchantPaymentMethodSepaDirectDebitInvalidRejection";
  message: Scalars["String"]["output"];
};

/** The different statuses a MerchantPaymentMethod can have */
export type MerchantPaymentMethodStatus =
  | "Disabled"
  | "Enabled"
  | "PendingReview"
  | "Rejected"
  | "Suspended"
  | "WaitingForInformation";

/** The payment method status information */
export type MerchantPaymentMethodStatusInfo = {
  /** Merchant Payment Method Status */
  status: MerchantPaymentMethodStatus;
};

/** The different statuses a MerchantPaymentMethod can have */
export type MerchantPaymentMethodType =
  | "Card"
  | "Check"
  | "InPersonCard"
  | "InternalDirectDebitB2b"
  | "InternalDirectDebitStandard"
  | "SepaDirectDebitB2b"
  | "SepaDirectDebitCore";

export type MerchantPaymentMethodUpdateRequest = {
  id: Scalars["ID"]["output"];
};

export type MerchantPaymentMethodWrongStatusRejection = Rejection & {
  __typename: "MerchantPaymentMethodWrongStatusRejection";
  message: Scalars["String"]["output"];
};

export type MerchantPaymentNotCancellableRejection = Rejection & {
  __typename: "MerchantPaymentNotCancellableRejection";
  id: Scalars["String"]["output"];
  message: Scalars["String"]["output"];
};

export type MerchantPaymentNotFoundRejection = Rejection & {
  __typename: "MerchantPaymentNotFoundRejection";
  id: Scalars["String"]["output"];
  message: Scalars["String"]["output"];
};

export type MerchantPaymentNotPartiallyCancellableRejection = Rejection & {
  __typename: "MerchantPaymentNotPartiallyCancellableRejection";
  id: Scalars["String"]["output"];
  message: Scalars["String"]["output"];
};

/** Field we can use when ordering that can be applied when listing merchant payments */
export type MerchantPaymentOrderByFieldInput =
  | "amount"
  | "createdAt"
  | "externalReference"
  | "label"
  | "status";

/** Order that can be applied when listing merchant payments */
export type MerchantPaymentOrderByInput = {
  direction?: InputMaybe<OrderByDirection>;
  field?: InputMaybe<MerchantPaymentOrderByFieldInput>;
};

/** Merchant Payment status partially disputed */
export type MerchantPaymentPartiallyDisputed = MerchantPaymentStatusInfo & {
  __typename: "MerchantPaymentPartiallyDisputed";
  /** Authorized date */
  authorizedAt: Scalars["DateTime"]["output"];
  /** Captured date */
  capturedAt: Scalars["DateTime"]["output"];
  /** Created date */
  createdAt: Scalars["DateTime"]["output"];
  /** Disputed date */
  disputedAt: Scalars["DateTime"]["output"];
  /** status of the merchant payment */
  status: MerchantPaymentStatus;
};

/** Merchant Payment status rejected */
export type MerchantPaymentRejected = MerchantPaymentStatusInfo & {
  __typename: "MerchantPaymentRejected";
  /** Created date */
  createdAt: Scalars["DateTime"]["output"];
  /** Rejected date */
  rejectedAt: Scalars["DateTime"]["output"];
  /** rejected reason */
  rejectedReasonCode: MerchantPaymentRejectedReason;
  /** status of the merchant payment */
  status: MerchantPaymentStatus;
};

export type MerchantPaymentRejectedReason =
  | "AmountInvalid"
  | "BankRefused"
  | "CardDetailsInvalid"
  | "CardExpired"
  | "CardNotSupported"
  | "CheckNotReceived"
  | "CheckReceivedLate"
  | "DebtorAccountClosed"
  | "DebtorAccountConsumer"
  | "DebtorAccountUnknown"
  | "DebtorDeceased"
  | "InsufficientFunds"
  | "InvalidPinAttemptsExceeded"
  | "MandateInvalid"
  | "ReasonNotSpecifiedByBank"
  | "ReasonNotSpecifiedByDebtor"
  | "RegulatoryReason"
  | "RejectedByCardAcquirer"
  | "RejectedByCardIssuer"
  | "SoftDecline3dsExpiration"
  | "SoftDecline3dsFailure"
  | "SoftDecline3dsNotSupported"
  | "SoftDecline3dsRequired"
  | "SoftDeclineCardAmountLimitsExceeded"
  | "SoftDeclineCardDetailsInvalid"
  | "SoftDeclineCardExpired"
  | "SoftDeclineCardNotActivated"
  | "SoftDeclineCardNotSupported"
  | "SoftDeclineCvcCheckFailed"
  | "SoftDeclineCvcInvalid"
  | "SoftDeclineInsufficientFunds"
  | "SoftDeclineInvalidPinAttemptsExceeded"
  | "SoftDeclinePinInvalid"
  | "SoftDeclinePinRequired"
  | "SoftDeclineRefundTimeLimitExceeded"
  | "SoftDeclineRejectedByCardIssuer"
  | "SoftDeclineSwanTechnicalErrorOccurred"
  | "SoftDeclineTransactionAmountIncorrect"
  | "SuspiciousCheck"
  | "SwanRefused"
  | "SwanTechnicalErrorOccurred"
  | "TransactionDuplicated"
  | "TransactionOnAccountTypeNotAllowed"
  | "TransactionTypeNotAllowed";

/** Merchant Payment status */
export type MerchantPaymentStatus =
  | "Authorized"
  | "Canceled"
  | "Captured"
  | "Disputed"
  | "Initiated"
  | "PartiallyDisputed"
  | "Rejected";

/** Merchant Payment Status Information */
export type MerchantPaymentStatusInfo = {
  /** Created date */
  createdAt: Scalars["DateTime"]["output"];
  /** status of the merchant payment */
  status: MerchantPaymentStatus;
};

/** Merchant Profile */
export type MerchantProfile = {
  __typename: "MerchantProfile";
  /**
   * Your accent color, used in white label interfaces.
   * This color would also be inherited in the Swan Merchant Payment page.
   */
  accentColor?: Maybe<Scalars["String"]["output"]>;
  /** The Account ID this Merchant Profile is linked to */
  accountId: Scalars["ID"]["output"];
  /** Additional information about the merchant profile */
  additionalInformation: Array<AdditionalInformation>;
  /** created date */
  createdAt: Scalars["DateTime"]["output"];
  /** Where the payer are generally based. */
  customerRegion?: Maybe<MerchantProfileCustomerRegion>;
  /** expected average basket value. */
  expectedAverageBasket: Amount;
  /** Expected annual activity volumes for all payment method */
  expectedMonthlyMerchantProcessingVolume: ExpectedMonthlyMerchantProcessingVolume;
  /**
   * Expected annual activity volumes for all payment method
   * @deprecated use expectedMonthlyMerchantProcessingVolume instead
   */
  expectedMonthlyPaymentVolume: Amount;
  /** The Merchant Profile ID */
  id: Scalars["ID"]["output"];
  /**
   * Url of an example typical invoice issued by the merchant.
   * @deprecated Unused, will be removed in future versions
   */
  invoiceExampleUrl?: Maybe<Scalars["String"]["output"]>;
  /** Url of the merchant's logo */
  merchantLogoUrl?: Maybe<Scalars["String"]["output"]>;
  /** Business name of the merchant, i.e. name that will be displayed on debtors' bank statements */
  merchantName: Scalars["String"]["output"];
  /**
   * Returns a list of merchant payment links
   *
   * Implements the Relay Connection interface, used to paginate list of element ([Learn More](https://docs.swan.io/api/pagination))
   */
  merchantPaymentLinks?: Maybe<MerchantPaymentLinkConnection>;
  /** Payment Methods associated */
  merchantPaymentMethods?: Maybe<Array<MerchantPaymentMethod>>;
  /**
   * Returns a list of merchant payments
   *
   * Implements the Relay Connection interface, used to paginate list of element ([Learn More](https://docs.swan.io/api/pagination))
   */
  merchantPayments?: Maybe<MerchantPaymentConnection>;
  /**
   * Url of the merchant's website
   * @deprecated Use merchantWebsiteUrl instead
   */
  merchantWebsite?: Maybe<Scalars["String"]["output"]>;
  /** Url of the merchant's website */
  merchantWebsiteUrl?: Maybe<Scalars["String"]["output"]>;
  /** The type of payments accepted by the merchant. Can be OneOff (no returning payers in general), Recurrent (returning payers), or a mix of both OneOffAndRecurrent. */
  paymentFrequency?: Maybe<MerchantProfilePaymentFrequency>;
  /** Type of product sold. List of value: Goods, Services, VirtualGoods, GiftsAndDonations. Gifts and donations can be club subscription or collection of donations (for associations), tips collection, contributions for local authorities */
  productType: ProductType;
  /** Update Requested associated */
  requestMerchantProfileUpdate?: Maybe<RequestMerchantProfileUpdate>;
  /**
   * Updates Requested associated
   * @deprecated Field no longer supported
   */
  requestedMerchantProfileUpdates?: Maybe<Array<RequestMerchantProfileUpdate>>;
  /**
   * The URL of the main social network of the merchant.
   * @deprecated use socialNetworkUrl instead
   */
  socialNetwork?: Maybe<Scalars["String"]["output"]>;
  /** The URL of the main social network of the merchant. */
  socialNetworkUrl?: Maybe<Scalars["String"]["output"]>;
  /** The status of the merchant profile */
  statusInfo: MerchantProfileStatusInfo;
  /**
   * The URL of the support website or help center of the merchant.
   * @deprecated use supportWebsiteUrl instead
   */
  supportWebsite?: Maybe<Scalars["String"]["output"]>;
  /** The URL of the support website or help center of the merchant. */
  supportWebsiteUrl?: Maybe<Scalars["String"]["output"]>;
  supportingDocumentCollections: SupportingDocumentCollectionConnection;
  /**
   * The URL of the terms and conditions of the merchant.
   * @deprecated use termsAndConditionsUrl instead
   */
  termsAndConditions?: Maybe<Scalars["String"]["output"]>;
  /** The URL of the terms and conditions of the merchant. */
  termsAndConditionsUrl?: Maybe<Scalars["String"]["output"]>;
  /** updated date */
  updatedAt: Scalars["DateTime"]["output"];
};

/** Merchant Profile */
export type MerchantProfileMerchantPaymentLinksArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  filters?: InputMaybe<MerchantPaymentLinkFiltersInput>;
  first?: Scalars["Int"]["input"];
  orderBy?: InputMaybe<MerchantPaymentLinkOrderByInput>;
};

/** Merchant Profile */
export type MerchantProfileMerchantPaymentsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  filters?: InputMaybe<MerchantPaymentFiltersInput>;
  first?: Scalars["Int"]["input"];
  orderBy?: InputMaybe<MerchantPaymentOrderByInput>;
};

/** Merchant Profile */
export type MerchantProfileSupportingDocumentCollectionsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  filters?: InputMaybe<SupportingDocumentCollectionFilterInput>;
  first?: Scalars["Int"]["input"];
};

export type MerchantProfileConnection = Connection & {
  __typename: "MerchantProfileConnection";
  /** Edge list */
  edges: Array<MerchantProfileEdge>;
  /** Information about the current, the previous and the next page */
  pageInfo: PageInfo;
  /** Total number of element in the list */
  totalCount: Scalars["Int"]["output"];
};

export type MerchantProfileCustomerRegion = "Domestic" | "European" | "International";

export type MerchantProfileEdge = Edge & {
  __typename: "MerchantProfileEdge";
  /** Opaque identifier pointing to this node in the pagination mechanism */
  cursor: Scalars["String"]["output"];
  node: MerchantProfile;
};

/** Filters that can be applied when listing Funding Sources */
export type MerchantProfileFiltersInput = {
  status?: InputMaybe<Array<MerchantProfileStatus>>;
};

export type MerchantProfileNotValidRejection = Rejection & {
  __typename: "MerchantProfileNotValidRejection";
  message: Scalars["String"]["output"];
};

export type MerchantProfileOrderByFieldInput = "createdAt" | "updatedAt";

export type MerchantProfileOrderByInput = {
  direction?: InputMaybe<OrderByDirection>;
  field?: InputMaybe<MerchantProfileOrderByFieldInput>;
};

export type MerchantProfilePaymentFrequency = "OneOff" | "OneOffAndRecurrent" | "Recurrent";

/** RejectedMerchantProfileRejectionReasonEnum */
export type MerchantProfileRejectionReason =
  /** Doesn’t respect a custom criteria discussed with partners */
  | "ContractualCriteriaNotFulfilled"
  /** Duplicate profile found by the risk team (or in the future programmatically) */
  | "DuplicateProfile"
  /** General rejection where we don't want to provide more info (eg, fraudster with sensitive info) */
  | "GenericRejection"
  /** Something is highly inconsistent, for example a completely different unrelated website */
  | "InconsistentOrMissingInformation"
  /** Risk alerting popped up for a weird processing pattern */
  | "SuspiciousBehavior"
  /** Prohibited activity/NACE code, automatically applied if there's a hit/match */
  | "UnsupportedActivity";

/** Merchant Profile Statuses */
export type MerchantProfileStatus =
  /** Disabled */
  | "Disabled"
  /** Enabled */
  | "Enabled"
  /** A Merchant Profile is created in the PendingReview status */
  | "PendingReview"
  /** Rejected */
  | "Rejected"
  /** Suspended */
  | "Suspended";

/** Merchant Profile Status Information */
export type MerchantProfileStatusInfo = {
  status: MerchantProfileStatus;
};

/** Rejection returned when the Merchant Profile is not in the expected status */
export type MerchantProfileWrongStatusRejection = Rejection & {
  __typename: "MerchantProfileWrongStatusRejection";
  currentStatus: MerchantProfileStatus;
  expectedStatus: MerchantProfileStatus;
  message: Scalars["String"]["output"];
};

export type MerchantRequirementType =
  | "CustomerRegion"
  | "ExpectedAverageBasket"
  | "ExpectedMonthlyMerchantProcessingVolume"
  | "MerchantWebsite"
  | "PaymentFrequency"
  | "ProductType"
  | "SocialNetwork"
  | "SupportWebsite"
  | "TermsAndConditions";

export type MerchantRequirements = {
  __typename: "MerchantRequirements";
  fields: Array<MerchantRequirementType>;
};

export type MerchantSubCategory =
  | "AdvertisingAndMarketing"
  | "Airlines"
  | "AtmWithdrawal"
  | "BarsAndRestaurants"
  | "BookkeepingAndConsultancy"
  | "BooksAndNewspapers"
  | "CarRental"
  | "CharityAndNonProfitOrganizations"
  | "CigarShops"
  | "CinemasAndShows"
  | "ClothingShoesAndAccessories"
  | "CoffeeAndBakeries"
  | "ComputersAndElectronicDevices"
  | "ConstructionAndOddJobs"
  | "CourierAndLogistics"
  | "DepartmentStores"
  | "Education"
  | "EnergyProviders"
  | "FerriesAndBoats"
  | "FinancialServices"
  | "FitnessAndSports"
  | "Flowers"
  | "FoodDelivery"
  | "Furniture"
  | "GamblingAndBettingActivities"
  | "GamesAndToys"
  | "Gardening"
  | "GovernmentAndCityCouncils"
  | "Hairdressing"
  | "HardwareStores"
  | "Healthcare"
  | "HotelsAndAccommodation"
  | "HouseholdItems"
  | "HrAndRecruiting"
  | "IndustrialCleaning"
  | "Insurance"
  | "Laundries"
  | "LegalActivities"
  | "LiquorStore"
  | "MetroBusAndTrains"
  | "MotorVehiclesRepairsAndAccessories"
  | "Museums"
  | "OfficeRental"
  | "Other"
  | "OtherLeisureActivities"
  | "OtherProfessionalServices"
  | "OtherStores"
  | "OtherTransportProviders"
  | "PerfumesAndCosmetics"
  | "Pets"
  | "Pharmacies"
  | "PhoneAndInternetServicesProviders"
  | "PrivateMobilityServices"
  | "PubsAndNightclubs"
  | "RealEstate"
  | "ReligiousOrganizations"
  | "ServiceStations"
  | "SoftwareServices"
  | "SpaAndBeautyTreatments"
  | "StationaryServices"
  | "StreamingPlatforms"
  | "SupermarketsAndOtherGroceryStores"
  | "ThemeParks"
  | "TicketsAndEvents"
  | "TollsAndParkings"
  | "TravelAgents"
  | "VideoGames";

export type MerchantVerificationRequirements =
  | AdditionalInformationRequirements
  | MerchantRequirements
  | OtherAdditionalInformationRequirements
  | SupportingDocumentRequirements;

export type MissingAddressItemRejection = Rejection & {
  __typename: "MissingAddressItemRejection";
  addressLine1?: Maybe<Scalars["String"]["output"]>;
  city?: Maybe<Scalars["String"]["output"]>;
  message: Scalars["String"]["output"];
  postalCode?: Maybe<Scalars["String"]["output"]>;
};

export type MissingBirthDateRejection = {
  __typename: "MissingBirthDateRejection";
  message: Scalars["String"]["output"];
};

/** Rejection returned when mandatory fields are missing from the call. */
export type MissingMandatoryFieldRejection = Rejection & {
  __typename: "MissingMandatoryFieldRejection";
  message: Scalars["String"]["output"];
};

/** Rejection returned when the phone number is missing and the account membership has advanced permissions */
export type MissingPhoneNumberRestrictionRejection = Rejection & {
  __typename: "MissingPhoneNumberRestrictionRejection";
  message: Scalars["String"]["output"];
};

/** Monthly income. */
export type MonthlyIncome =
  /** between 500 and 1500 */
  | "Between500And1500"
  /** between 1500 and 3000 */
  | "Between1500And3000"
  /** between 3000 and 4500 */
  | "Between3000And4500"
  /** less than 500 */
  | "LessThan500"
  /** more than 4500 */
  | "MoreThan4500";

/** Monthly payment volume. */
export type MonthlyPaymentVolume =
  | "Between10000And50000"
  | "Between50000And100000"
  | "LessThan10000"
  | "MoreThan100000";

export type MonthlyPeriod = {
  __typename: "MonthlyPeriod";
  dayOfMonth: Scalars["Int"]["output"];
};

export type MultipleAccountsSettings = {
  __typename: "MultipleAccountsSettings";
  accountCreationLimit: Scalars["Int"]["output"];
  canOpenAccount: Scalars["Boolean"]["output"];
};

export type Mutation = {
  __typename: "Mutation";
  /** COMING SOON */
  acceptConsent?: Maybe<AcceptConsentPayload>;
  /**
   * Activate a Digital Card to push to ApplePay or GooglePay
   *
   * This mutation is restricted to an User access token ([Learn More](https://docs.swan.io/developers/using-api/authentication)) and ask the user to consent to this request.
   *
   * The user must be the cardholder
   *
   * A digital card will only be valid for 1 hour after consent validation
   */
  activateDigitalCard: ActivateDigitalCardPayload;
  /**
   * Activate a Physical Card.
   *
   * This mutation is restricted to an User access token ([Learn More](https://docs.swan.io/developers/using-api/authentication)) and ask the user to consent to this request.
   *
   * The user must have the account membership for this card
   */
  activatePhysicalCard: ActivatePhysicalCardPayload;
  /**
   * Add a new account membership to an account.
   *
   * *This mutation is restricted to an User access token ([Learn More](https://docs.swan.io/developers/using-api/authentication)) and ask the user to consent to this request.*
   *
   * *The user must have an account membership for this account with the attribute `canManageAccountMembership=true`.*
   *
   * *If any permission is given, a consent will be required.*
   */
  addAccountMembership: AddAccountMembershipPayload;
  /**
   * Add multiple new account memberships to account
   *
   * *This mutation is restricted to an User access token ([Learn More](https://docs.swan.io/developers/using-api/authentication)) and ask the user to consent to this request.*
   *
   * *The user must have an account membership for this account with the attribute `canManageAccountMembership=true`.*
   *
   * *If any permission is given to any membership, a consent will be required.*
   */
  addAccountMemberships: AddAccountMembershipsPayload;
  /**
   * Add a new card to an account membership.
   *
   * This mutation is restricted to an User access token ([Learn More](https://docs.swan.io/developers/using-api/authentication)) and ask the user to consent to this request.
   *
   * The user must have an account membership for this account with the permission `canManageCards=true`.
   */
  addCard: AddCardPayload;
  /**
   * Add several cards
   *
   * This mutation is restricted to an User access token ([Learn More](https://docs.swan.io/developers/using-api/authentication)) and ask the user to consent to this request.
   *
   * The user must have an account membership for this account with the attribute `canManageAccountMembership=true`.
   */
  addCards: AddCardsPayload;
  /**
   * Add several cards with Group Delivery
   *
   * This mutation is restricted to an User access token ([Learn More](https://docs.swan.io/developers/using-api/authentication)) and ask the user to consent to this request.
   *
   * The user must have an account membership for this account with the attribute `canManageAccountMembership=true`.
   */
  addCardsWithGroupDelivery: AddCardsWithGroupDeliveryPayload;
  /**
   * Add a Digital Card to push to ApplePay or GooglePay
   *
   * This mutation is restricted to an User access token ([Learn More](https://docs.swan.io/developers/using-api/authentication)) and ask the user to consent to this request.
   *
   * The user must be the cardholder
   *
   * A digital card will only be valid for 1 hour after consent validation
   */
  addDigitalCard: AddDigitalCardPayload;
  /**
   * Add a funding source to an account
   *
   * This mutation is restricted to an User access token ([Learn More](https://docs.swan.io/api/authentication)) and ask the user to consent to this request.
   *
   * The user must have an account membership for this account with the attribute `canManageAccountMembership=true`.
   */
  addDirectDebitFundingSource?: Maybe<AddDirectDebitFundingSourcePayload>;
  /**
   * Add an external account to an account holder.
   *
   * This mutation is restricted to a [Project access token](https://docs.swan.io/developers/using-api/authentication/).
   */
  addExternalAccount: AddExternalAccountPayload;
  /**
   * Add an external balance to an external account.
   *
   * This mutation is restricted to a [Project access token](https://docs.swan.io/developers/using-api/authentication/).
   * @deprecated use `AddOrUpdateExternalAccountBalance` instead
   */
  addExternalAccountBalance: AddExternalAccountBalancePayload;
  addExternalIdentification: AddExternalIdentificationPayload;
  /**
   * Add a new request for funding limit settings change.
   *
   * This mutation is restricted to a [Project access token](https://docs.swan.io/developers/using-api/authentication/).
   */
  addFundingLimitSettingsChangeRequest: AddFundingLimitSettingsChangeRequestPayload;
  /** Allows to add an internal direct debit payment mandate. */
  addInternalDirectDebitPaymentMandate: AddInternalDirectDebitPaymentMandatePayload;
  /**
   * Add an external balance to an external account.
   * If a balance already exist for the day, the balance amount will be updated.
   *
   * This mutation is restricted to a [Project access token](https://docs.swan.io/developers/using-api/authentication/).
   */
  addOrUpdateExternalAccountBalance: AddOrUpdateExternalAccountBalancePayload;
  /**
   * Allows to add a received internal direct debit mandate B2b.
   *
   * *This mutation is restricted to an User access token ([Learn More](https://docs.swan.io/api/authentication)) and ask the user to consent to this request with the Swan app.*
   *
   * *The user must be able to initiate payments for this account.*
   */
  addReceivedInternalDirectDebitB2bMandate: AddReceivedInternalDirectDebitB2bMandatePayload;
  /**
   * Allows to add a received sepa direct debit mandate B2b.
   *
   * *This mutation is restricted to an User access token ([Learn More](https://docs.swan.io/api/authentication)) and ask the user to consent to this request with the Swan app.*
   *
   * *The user must be able to initiate payments for this account.*
   */
  addReceivedSepaDirectDebitB2bMandate: AddReceivedSepaDirectDebitB2bMandatePayload;
  addSepaDirectDebitPaymentMandate?: Maybe<AddSepaDirectDebitPaymentMandatePayload>;
  /** Add a new Single Use Virtual Card to an account membership. */
  addSingleUseVirtualCard: AddSingleUseVirtualCardPayload;
  /**
   * Add several single-use virtual cards
   *
   * This mutation is restricted to an User access token ([Learn More](https://docs.swan.io/developers/using-api/authentication)) and ask the user to consent to this request.
   *
   * The user must have an account membership for this account with the attribute `canManageAccountMembership=true`.
   */
  addSingleUseVirtualCards: AddSingleUseVirtualCardsPayload;
  /**
   * Add an international trusted beneficiary to an account
   *
   * This mutation is restricted to an User access token ([Learn More](https://docs.swan.io/api/authentication)) and ask the user to consent to this request.
   */
  addTrustedInternationalBeneficiary?: Maybe<AddTrustedInternationalBeneficiaryPayload>;
  /**
   * Add a list of trusted SEPA beneficiaries to an account
   *
   * This mutation is restricted to an User access token ([Learn More](https://docs.swan.io/api/authentication)) and ask the user to consent to this request.
   */
  addTrustedSepaBeneficiaries?: Maybe<AddTrustedSepaBeneficiariesPayload>;
  /**
   * Add a trusted SEPA beneficiary to an account
   *
   * This mutation is restricted to an User access token ([Learn More](https://docs.swan.io/api/authentication)) and ask the user to consent to this request.
   */
  addTrustedSepaBeneficiary?: Maybe<AddTrustedSepaBeneficiaryPayload>;
  /** Add a new Virtual IBAN. */
  addVirtualIbanEntry?: Maybe<AddVirtualIbanEntryPayload>;
  /** Add a webhook subscription */
  addWebhookSubscription: WebhookSubscriptionPayload;
  /** Allows to receive Sepa Direct Debit on an account. */
  allowSdd: AllowSddPayload;
  /** Allows to receive Sepa Direct Debit on a Virtual IBAN. */
  allowSddVirtualIbanEntry: AllowSddVirtualIbanEntryPayload;
  /**
   * Bind a user to an account membership
   *
   * *This mutation is restricted to an User access token ([Learn More](https://docs.swan.io/developers/using-api/authentication)) and ask the user to consent to this request.*
   */
  bindAccountMembership: BindAccountMembershipPayload;
  /**
   * Cancel a capital deposit case.
   *
   * This mutation is restricted to a Project access token ([Learn More](https://docs.swan.io/api/authentication)).
   */
  cancelCapitalDepositCase: CancelCapitalDepositCasePayload;
  /** Cancel a Card */
  cancelCard: CancelCardPayload;
  /** Cancels a consent. */
  cancelConsent: CancelConsentPayload;
  /** Cancel a Digital Card */
  cancelDigitalCard: CancelDigitalCardPayload;
  /** Cancel a funding source */
  cancelFundingSource?: Maybe<CancelFundingSourcePayload>;
  /** Cancel a Merchant Payment */
  cancelMerchantPayment?: Maybe<CancelMerchantPaymentPayload>;
  /** Cancel a MerchantPaymentMethod update request */
  cancelMerchantPaymentMethodUpdateRequest?: Maybe<CancelMerchantPaymentMethodUpdateRequestPayload>;
  /** Cancel a MerchantProfile update request */
  cancelMerchantProfileUpdateRequest?: Maybe<CancelMerchantProfileUpdateRequestPayload>;
  /** Cancel a physical card. */
  cancelPhysicalCard: CancelPhysicalCardPayload;
  /**
   * Cancel a standing Order
   *
   * The user must have an account membership to the account and the permission to initiate credit transfer
   */
  cancelStandingOrder: CancelStandingOrderPayload;
  /**
   * Cancels an UPCOMING credit transfer
   *
   *  *The user must have an account membership for this account with the attribute `canInitiatePayments=true`.*
   */
  cancelTransaction: CancelTransactionPayload;
  /** Cancels a Virtual IBAN. */
  cancelVirtualIbanEntry: CancelVirtualIbanEntryPayload;
  /**
   * Closes an account.
   *
   * *This mutation is restricted to an User access token ([Learn More](https://docs.swan.io/developers/using-api/authentication)) and ask the user to consent to this request with the Swan app.*
   *
   * *The user must have a legal representative account membership for this account.*
   */
  closeAccount: CloseAccountPayload;
  /** COMING SOON : Complete User Creation */
  completeUserCreation: CompleteUserCreationPayload;
  /** Confirm Physical Card Renewal */
  confirmPhysicalCardRenewal: ConfirmPhysicalCardRenewalPayload;
  /**
   * Create a capital deposit case.
   *
   * This mutation is restricted to a Project access token ([Learn More](https://docs.swan.io/api/authentication)).
   */
  createCapitalDepositCase: CreateCapitalDepositCasePayload;
  /**
   * Creates an onboarding for a new company account holder.
   *
   * This mutation is restricted to a [Project access token](https://docs.swan.io/developers/using-api/authentication/).
   *
   * @comingSoon -> this query is not available yet, and its shape is subject to breaking change
   */
  createCompanyAccountHolderOnboarding: CreateCompanyAccountHolderOnboardingPayload;
  /**
   * COMING SOON
   * Create an in-person payment intent for a merchant profile
   */
  createInPersonPaymentIntent?: Maybe<CreateInPersonPaymentIntentPayload>;
  /**
   * Creates an onboarding for a new individual account holder.
   *
   * This mutation is restricted to a [Project access token](https://docs.swan.io/developers/using-api/authentication/).
   *
   * @comingSoon -> this query is not available yet, and its shape is subject to breaking change
   */
  createIndividualAccountHolderOnboarding: CreateIndividualAccountHolderOnboardingPayload;
  /** Create a unique URL for a merchant to collect payment from a customer */
  createMerchantPaymentLink: CreateMerchantPaymentLinkPayload;
  /**
   * Create a multi consent, which represents a consent of several other consents,
   * executed in parallel or sequentially depending on the `order` input value
   *
   * This mutation is restricted to a User access token ([Learn More](https://docs.swan.io/api/authentication)) and ask the user to consent to this request.
   */
  createMultiConsent?: Maybe<CreateMultiConsentPayload>;
  /**
   * Creates an onboarding for a new company account holder, belonging the target project.
   *
   * This mutation is restricted to unauthenticated access (no token)
   *
   * @comingSoon -> this query is not available yet, and its shape is subject to breaking change
   */
  createPublicCompanyAccountHolderOnboarding: CreatePublicCompanyAccountHolderOnboardingPayload;
  /**
   * Creates an onboarding for a new individual account holder without authentication.
   *
   * This mutation is restricted to unauthenticated access (no token)
   *
   * @comingSoon -> this query is not available yet, and its shape is subject to breaking change
   */
  createPublicIndividualAccountHolderOnboarding: CreatePublicIndividualAccountHolderOnboardingPayload;
  /** Deactivate an User */
  deactivateUser: DeactivateUserPayload;
  /** Delete file with exported data. */
  deleteExportFile?: Maybe<DeleteExportFilePayload>;
  /**
   * Delete a supporting document, in case uploaded file is not what was wanted. This action can not be undone.
   *
   * This mutation can only be used on an "Uploaded" supporting document of a "WaitingForDocument" supporting document collection.
   *
   * This mutation is restricted to a [Project access token](https://docs.swan.io/developers/using-api/authentication/).
   */
  deleteSupportingDocument: DeleteSupportingDocumentPayload;
  /** Allows to refuse all Sepa Direct Debit received on an account. */
  denySdd: DenySddPayload;
  /** Allows to refuse all Sepa Direct Debit received on a Virtual IBAN. */
  denySddVirtualIbanEntry: DenySddVirtualIbanEntryPayload;
  /**
   * Disable an account membership
   *
   * This mutation is callable with a User access token and a Project access token ([Learn More](https://docs.swan.io/developers/using-api/authentication))
   *
   * With a User access token, the user must have the permission to manage account membership of the account
   */
  disableAccountMembership: DisableAccountMembershipPayload;
  /** Disable a merchant payment method */
  disableMerchantPaymentMethod?: Maybe<DisableMerchantPaymentMethodPayload>;
  /** Disable a merchant profile */
  disableMerchantProfile?: Maybe<DisableMerchantProfilePayload>;
  /**
   * Allows to enable a received mandate in the Suspended status.
   *
   * *For B2b received direct debit mandate, this mutation is restricted to an User access token([Learn More](https://docs.swan.io/api/authentication)) and ask the user to consent to this request with the Swan app.*
   *
   * *The user must be able to initiate payments for this account.*
   */
  enableReceivedDirectDebitMandate: EnableReceivedDirectDebitMandatePayload;
  /**
   * Export all accounts of a project.
   *
   * NB: This mutation only starts an asynchronous process and returns its identifier.
   */
  exportAccountData?: Maybe<ExportDataPayload>;
  /**
   * Export all account Holder of a project.
   *
   * NB: This mutation only starts an asynchronous process and returns its identifier.
   */
  exportAccountHolderData?: Maybe<ExportDataPayload>;
  /**
   * Export all account memberships of a project.
   *
   * NB: This mutation only starts an asynchronous process and returns its identifier.
   */
  exportAccountMembershipData?: Maybe<ExportDataPayload>;
  /**
   * Export all cards of a project.
   *
   * NB: This mutation only starts an asynchronous process and returns its identifier.
   */
  exportCardData?: Maybe<ExportDataPayload>;
  /**
   * Export all onboardings of a project.
   *
   * NB: This mutation only starts an asynchronous process and returns its identifier.
   */
  exportOnboardingData?: Maybe<ExportDataPayload>;
  /**
   * Export all transactions of a project.
   * NB: This mutation only starts an asynchronous process and returns its identifier.
   */
  exportTransactionData?: Maybe<ExportDataPayload>;
  /**
   * Export all users of a project.
   *
   * NB: This mutation only starts an asynchronous process and returns its identifier.
   */
  exportUserData?: Maybe<ExportDataPayload>;
  /**
   * Finalize an account holder onboarding, leading to the opening of a new account for your client, who thus becomes the account holder.
   *
   * *This mutation is restricted to a User access token ([Learn More](https://docs.swan.io/developers/using-api/authentication)).*
   *
   * @comingSoon -> this query is not available yet, and its shape is subject to breaking change
   */
  finalizeAccountHolderOnboarding: FinalizeAccountHolderOnboardingPayload;
  /**
   * Finalize an onboarding led to the opening of a new account for your client, who thus become the account holder.
   *
   * *This mutation is restricted to an User access token ([Learn More](https://docs.swan.io/developers/using-api/authentication)).*
   */
  finalizeOnboarding: FinalizeOnboardingPayload;
  /** Internal Beta - do not use */
  finalizeVerificationRenewal: FinalizeVerificationRenewalPayload;
  /** Generate an account statement */
  generateAccountStatement: Statement;
  /**
   * Generate an url allowing the upload of a document which unique identifier is specified in parameters.
   *
   * This mutation is restricted to an Project access token ([Learn More](https://docs.swan.io/api/authentication)).
   */
  generateCapitalDepositDocumentUploadUrl: GenerateCapitalDepositDocumentUploadUrlPayload;
  /** Generate a credit statement on a given account for a specific cycle. */
  generateCreditStatement: GenerateCreditStatementPayload;
  /** Create a temporary download link for a completed export. */
  generateExportDownloadLink?: Maybe<GenerateExportDownloadLinkPayload>;
  /**
   * Generate and return a pre-signed URL to upload a unique file for an identification
   *
   * *This mutation is restricted to a Project access token ([Learn More](https://docs.swan.io/api/authentication))*
   */
  generateIdentificationDocumentUploadUrl: GenerateIdentificationDocumentUploadUrlPayload;
  /**
   * Generate and return a presigned URL to upload a unique file for the supporting document collection
   *
   * This mutation is restricted to a [Project access token](https://docs.swan.io/developers/using-api/authentication/).
   */
  generateSupportingDocumentUploadUrl: GenerateSupportingDocumentUploadUrlPayload;
  /** Generate a transaction statement for a booked incoming or outgoing Credit Transfer. */
  generateTransactionStatement: GenerateTransactionStatementPayload;
  /**
   * Generate and return a presigned URL to upload a file to justify a transaction
   *
   * This mutation is restricted to a [Project access token](https://docs.swan.io/developers/using-api/authentication/).
   */
  generateTransactionSupportingDocumentUploadUrl: GenerateTransactionSupportingDocumentUploadUrlPayload;
  /** Grant consent with a server signature */
  grantConsentWithServerSignature: GrantConsentWithServerSignaturePayload;
  initiateCheckMerchantPayment?: Maybe<InitiateCheckMerchantPaymentPayload>;
  /**
   * Initiates a credit transfer to an other Swan account or to an IBAN
   *
   * *This mutation is restricted to an User access token ([Learn More](https://docs.swan.io/api/authentication)) and if necessary ask the user to consent to this request.*
   *
   * *The user must have an account membership for this account with the attribute `canInitiatePayments=true`.*
   */
  initiateCreditTransfers: InitiateCreditTransfersPayload;
  /**
   * Initiate a funding request.
   * This mutation is restricted to an User access token ([Learn More](https://docs.swan.io/api/authentication)).
   * The user must have an account membership for this account with the attribute `canInitiateCreditTransfer=true`.
   */
  initiateFundingRequest?: Maybe<InitiateFundingRequestPayload>;
  /** Create an international transfer */
  initiateInternationalCreditTransfer?: Maybe<InitiateInternationalCreditTransferResponsePayload>;
  initiateMerchantPaymentCollection?: Maybe<InitiateMerchantPaymentCollectionPayload>;
  initiateSepaDirectDebitMerchantPayment: InitiateSepaDirectDebitMerchantPaymentPayload;
  /**
   * Creates an onboarding for a new company account holder.
   *
   * This mutation is restricted to a [Project access token](https://docs.swan.io/developers/using-api/authentication/).
   */
  onboardCompanyAccountHolder: OnboardCompanyAccountHolderPayload;
  /**
   * Creates an onboarding for a new individual account holder.
   *
   * This mutation is restricted to a [Project access token](https://docs.swan.io/developers/using-api/authentication/).
   */
  onboardIndividualAccountHolder: OnboardIndividualAccountHolderPayload;
  /** Open an additional account */
  openAccount: OpenAccountPayload;
  /**
   * Print Physical Card.
   *
   * This mutation is restricted to an User access token ([Learn More](https://docs.swan.io/developers/using-api/authentication)) and ask the user to consent to this request.
   */
  printPhysicalCard: PrintPhysicalCardPayload;
  /**
   * Probe a Webhook callback endpoint
   * It will send a test event with a random id and the test event type
   * It will return the status code of the response
   * if the endpoint responds and the generated event id
   */
  probeWebhookEndpoint: ProbeWebhookEndpointPayload;
  /**
   * initiates a refund for a list of booked transaction
   *
   * *This mutation is restricted to an User access token ([Learn More](https://docs.swan.io/api/authentication)) and if necessary ask the user to consent to this request.*
   *
   * *The user must have an account membership on the accounts that are beneficiary of the transaction with the attribute `canInitiatePayments=true`.*
   */
  refund: RefundPayload;
  /** Remove a webhook subscription */
  removeWebhookSubscription: RemoveWebhookSubscriptionPayload;
  /** Replays the endpoint call of a previous event */
  replayWebhookEvent: ReplayWebhookEventPayload;
  /** Request a credit limit with given settings */
  requestCreditLimitSettings?: Maybe<RequestCreditLimitSettingsPayload>;
  /** Request merchant payment methods for a merchant profile */
  requestMerchantPaymentMethods?: Maybe<RequestMerchantPaymentMethodsPayload>;
  requestMerchantPaymentMethodsUpdate?: Maybe<RequestMerchantPaymentMethodsUpdatePayload>;
  /** Request a merchant profile to a company account holder */
  requestMerchantProfile?: Maybe<RequestMerchantProfilePayload>;
  /** Request an update of a MerchantProfile */
  requestMerchantProfileUpdate?: Maybe<RequestMerchantProfileUpdatePayload>;
  /**
   * Ask for Swan's compliance team to review given supporting document collection.
   *
   * This mutation is restricted to a [Project access token](https://docs.swan.io/developers/using-api/authentication/).
   */
  requestSupportingDocumentCollectionReview: RequestSupportingDocumentCollectionReviewPayload;
  /**
   * COMING SOON
   * Request a terminal connection token for a merchant profile
   */
  requestTerminalConnectionToken?: Maybe<RequestTerminalConnectionTokenPayload>;
  /**
   * Resumes an account membership already suspended.
   *
   * *This mutation is restricted to an User access token ([Learn More](https://docs.swan.io/developers/using-api/authentication)) and ask the user to consent to this request.*
   *
   * *The user must have an account membership for this account with the attribute `canManageAccountMembership=true`.*
   */
  resumeAccountMembership: ResumeAccountMembershipPayload;
  /**
   * Resume a Physical Card.
   *
   * This mutation is restricted to an User access token ([Learn More](https://docs.swan.io/developers/using-api/authentication)) and ask the user to consent to this request.
   *
   * The user must have the account membership for this card
   */
  resumePhysicalCard: ResumePhysicalCardPayload;
  /** Initiates a refund on a booked outgoing SEPA Direct Debit Core transaction. For more details, refer to [Swan docs](https://docs.swan.io/topics/payments/direct-debit/#refunded). */
  returnTransaction: ReturnTransactionPayload;
  /**
   * Schedule a standing Order
   *
   * This mutation is restricted to an User access token ([Learn More](https://docs.swan.io/api/authentication)) and ask the user to consent to this request.
   *
   * The user must have an account membership to the account and the permission to initiate credit transfer
   */
  scheduleStandingOrder: ScheduleStandingOrderPayload;
  /**
   * Send an email invitation to an account member that has been added to your account.
   *
   * *This mutation is restricted to a User access token ([Learn More](https://docs.swan.io/developers/using-api/authentication)).*
   *
   * *The user must have an account membership for this account with the attribute `canManageAccountMembership=true`.*
   */
  sendAccountMembershipInviteNotification: SendAccountMembershipInviteNotificationPayload;
  /** COMING SOON */
  startUserCreation: StartUserCreationPayload;
  /**
   * Suspends an account membership.
   *
   * This mutation requires either a [Project or User access token](https://docs.swan.io/developers/using-api/authentication/) with the `canManageAccountMembership` permission.
   */
  suspendAccountMembership: SuspendAccountMembershipPayload;
  /** Suspend a Physical Card. */
  suspendPhysicalCard: SuspendPhysicalCardPayload;
  /**
   * Allows to suspend a received direct debit mandate in the Enabled status.
   *
   * *The user must be able to initiate payments for this account.*
   */
  suspendReceivedDirectDebitMandate: SuspendReceivedDirectDebitMandatePayload;
  /** Update an account. */
  updateAccount: UpdateAccountPayload;
  updateAccountHolder: UpdateAccountHolderPayload;
  updateAccountHolderRiskInfo: UpdateAccountHolderRiskInfoPayload;
  /**
   * Updates an account membership.
   *
   * *This mutation is restricted to an User access token ([Learn More](https://docs.swan.io/developers/using-api/authentication)) and ask the user to consent to this request.*
   *
   * *The user must have an account membership for this account with the attribute `canManageAccountMembership=true`.*
   */
  updateAccountMembership: UpdateAccountMembershipPayload;
  /** Update an account settings. */
  updateAccountSettings: UpdateAccountSettingsPayload;
  /**
   * Update a capital deposit case
   *
   * This mutation is restricted to a Project access token ([Learn More](https://docs.swan.io/api/authentication)).
   */
  updateCapitalDepositCaseCompany: UpdateCapitalDepositCaseCompanyPayload;
  /**
   * Update a shareholder's capital deposit amount.
   *
   * This mutation is restricted to a Project access token ([Learn More](https://docs.swan.io/api/authentication)).
   */
  updateCapitalDepositShareholderAmount: UpdateCapitalDepositShareholderAmountPayload;
  /** Update a Card. */
  updateCard?: Maybe<UpdateCardPayload>;
  /**
   * Updates an existing company account holder onboarding.
   *
   * This mutation is restricted to a [Project access token](https://docs.swan.io/developers/using-api/authentication/).
   *
   * @comingSoon -> this query is not available yet, and its shape is subject to breaking change
   */
  updateCompanyAccountHolderOnboarding: UpdateCompanyAccountHolderOnboardingPayload;
  /**
   * Updates a company onboarding.
   *
   * If you aim to update Ultimate Beneficiary Owners, you need to provide all of them as they are going to be overridden by your update payload.
   *
   * This mutation is restricted to a [Project access token](https://docs.swan.io/developers/using-api/authentication/).
   */
  updateCompanyOnboarding: UpdateCompanyOnboardingPayload;
  /** Internal Beta - do not use */
  updateCompanyVerificationRenewal: UpdateCompanyVerificationRenewalPayload;
  /**
   * Updates an existing individual account holder onboarding.
   *
   * This mutation is restricted to a [Project access token](https://docs.swan.io/developers/using-api/authentication/).
   *
   * @comingSoon -> this query is not available yet, and its shape is subject to breaking change
   */
  updateIndividualAccountHolderOnboarding: UpdateIndividualAccountHolderOnboardingPayload;
  /**
   * Updates an individual onboarding.
   *
   * This mutation is restricted to a [Project access token](https://docs.swan.io/developers/using-api/authentication/).
   */
  updateIndividualOnboarding: UpdateIndividualOnboardingPayload;
  /** Internal Beta - do not use */
  updateIndividualVerificationRenewal: UpdateIndividualVerificationRenewalPayload;
  /**
   * Updates an existing public company account holder onboarding.
   *
   * This mutation is restricted to a [Project access token](https://swan.io/developers/using-api/authentication/).
   *
   * @comingSoon -> this query is not available yet, and its shape is subject to breaking change
   */
  updatePublicCompanyAccountHolderOnboarding: UpdatePublicCompanyAccountHolderOnboardingPayload;
  /**
   * Updates an existing individual account holder onboarding.
   *
   * This mutation is restricted to unauthenticated access (no token)
   *
   * @comingSoon -> this query is not available yet, and its shape is subject to breaking change
   */
  updatePublicIndividualAccountHolderOnboarding: UpdatePublicIndividualAccountHolderOnboardingPayload;
  /**
   * Allows to update a received sepa direct debit mandate B2b.
   *
   * *This mutation is restricted to an User access token ([Learn More](https://docs.swan.io/api/authentication)) and ask the user to consent to this request with the Swan app.*
   *
   * *The user must be able to initiate payments for this account.*
   */
  updateReceivedSepaDirectDebitB2bMandate: UpdateReceivedSepaDirectDebitB2bMandatePayload;
  updateSupportingDocument: UpdateSupportingDocumentPayload;
  /**
   * Updates user preferred consent notification channel.
   *
   * *This mutation is restricted to a Project access token ([Learn More](https://docs.swan.io/api/authentication))*
   */
  updateUserConsentSettings: UpdateUserConsentSettingsPayload;
  /** Update a Webhook Subscription */
  updateWebhookSubscription: WebhookSubscriptionPayload;
  /**
   * Get a beneficiary token to initiate SEPA Credit Transfers and Instant SEPA Credit Transfers.
   * Note: This feature is in development and will be available soon to meet the European Instant Payments Regulation (IPR) requirements, effective October 9th, 2025.
   */
  verifyBeneficiary: VerifyBeneficiaryPayload;
  /**
   * Reveal the card numbers in the consent page once consent has been given by the cardholder
   *
   * This mutation is restricted to an User access token ([Learn More](https://docs.swan.io/developers/using-api/authentication)) and ask the user to consent to this request.
   *
   * The user must have the account membership for this card
   */
  viewCardNumbers: ViewCardNumbersPayload;
  /**
   * Obtain individual iframes containing sensitive card information from an accepted consent
   *
   * This mutation is restricted to user access token ([Learn More](https://docs.swan.io/developers/using-api/authentication/#tokens-user)).
   *
   * Conditions apply
   */
  viewCardNumbersWithConsent: ViewCardNumbersWithConsentPayload;
  /**
   * Reveal the physical card numbers in the consent page once consent has been given by the cardholder
   *
   * This mutation is restricted to an User access token ([Learn More](https://docs.swan.io/developers/using-api/authentication)) and ask the user to consent to this request.
   *
   * The user must have the account membership for this card
   */
  viewPhysicalCardNumbers: ViewPhysicalCardNumbersPayload;
  /**
   * Reveal the PIN code on Swan app after his consent
   *
   * This mutation is restricted to an User access token ([Learn More](https://docs.swan.io/developers/using-api/authentication)) and ask the user to consent to this request.
   *
   * The user must have the account membership for this card
   */
  viewPhysicalCardPin: ViewPhysicalCardPinPayload;
};

export type MutationAcceptConsentArgs = {
  input: AcceptConsentInput;
};

export type MutationActivateDigitalCardArgs = {
  input?: InputMaybe<ActivateDigitalCardInput>;
};

export type MutationActivatePhysicalCardArgs = {
  input: ActivatePhysicalCardInput;
};

export type MutationAddAccountMembershipArgs = {
  input: AddAccountMembershipInput;
};

export type MutationAddAccountMembershipsArgs = {
  input: AddAccountMembershipsInput;
};

export type MutationAddCardArgs = {
  input: AddCardInput;
};

export type MutationAddCardsArgs = {
  input: AddCardsInput;
};

export type MutationAddCardsWithGroupDeliveryArgs = {
  input: AddCardsWithGroupDeliveryInput;
};

export type MutationAddDigitalCardArgs = {
  input?: InputMaybe<AddDigitalCardInput>;
};

export type MutationAddDirectDebitFundingSourceArgs = {
  input: AddDirectDebitFundingSourceInput;
};

export type MutationAddExternalAccountArgs = {
  input: AddExternalAccountInput;
};

export type MutationAddExternalAccountBalanceArgs = {
  input: AddExternalAccountBalanceInput;
};

export type MutationAddExternalIdentificationArgs = {
  input: AddExternalIdentificationInput;
};

export type MutationAddFundingLimitSettingsChangeRequestArgs = {
  input: AddFundingLimitSettingsChangeRequestInput;
};

export type MutationAddInternalDirectDebitPaymentMandateArgs = {
  input: AddInternalDirectDebitPaymentMandateInput;
};

export type MutationAddOrUpdateExternalAccountBalanceArgs = {
  input: AddOrUpdateExternalAccountBalanceInput;
};

export type MutationAddReceivedInternalDirectDebitB2bMandateArgs = {
  input: AddReceivedInternalDirectDebitB2bMandateInput;
};

export type MutationAddReceivedSepaDirectDebitB2bMandateArgs = {
  input: AddReceivedSepaDirectDebitB2bMandateInput;
};

export type MutationAddSepaDirectDebitPaymentMandateArgs = {
  input: AddSepaDirectDebitPaymentMandateInput;
};

export type MutationAddSingleUseVirtualCardArgs = {
  input: AddSingleUseVirtualCardInput;
};

export type MutationAddSingleUseVirtualCardsArgs = {
  input: AddSingleUseVirtualCardsInput;
};

export type MutationAddTrustedInternationalBeneficiaryArgs = {
  input: AddTrustedInternationalBeneficiaryInput;
};

export type MutationAddTrustedSepaBeneficiariesArgs = {
  input: AddTrustedSepaBeneficiariesInput;
};

export type MutationAddTrustedSepaBeneficiaryArgs = {
  input: AddTrustedSepaBeneficiaryInput;
};

export type MutationAddVirtualIbanEntryArgs = {
  input?: InputMaybe<AddVirtualIbanInput>;
};

export type MutationAddWebhookSubscriptionArgs = {
  input: AddWebhookSubscriptionInput;
};

export type MutationAllowSddArgs = {
  input: AllowSddInput;
};

export type MutationAllowSddVirtualIbanEntryArgs = {
  input: AllowSddVirtualIbanEntryInput;
};

export type MutationBindAccountMembershipArgs = {
  input: BindAccountMembershipInput;
};

export type MutationCancelCapitalDepositCaseArgs = {
  input: CancelCapitalDepositCaseInput;
};

export type MutationCancelCardArgs = {
  input?: InputMaybe<CancelCardInput>;
};

export type MutationCancelConsentArgs = {
  input: CancelConsentInput;
};

export type MutationCancelDigitalCardArgs = {
  input?: InputMaybe<CancelDigitalCardInput>;
};

export type MutationCancelFundingSourceArgs = {
  input: CancelFundingSourceInput;
};

export type MutationCancelMerchantPaymentArgs = {
  input: CancelMerchantPaymentInput;
};

export type MutationCancelMerchantPaymentMethodUpdateRequestArgs = {
  input: CancelMerchantPaymentMethodUpdateRequestInput;
};

export type MutationCancelMerchantProfileUpdateRequestArgs = {
  input: CancelMerchantProfileUpdateRequestInput;
};

export type MutationCancelPhysicalCardArgs = {
  input?: InputMaybe<CancelPhysicalCardInput>;
};

export type MutationCancelStandingOrderArgs = {
  input: CancelStandingOrderInput;
};

export type MutationCancelTransactionArgs = {
  input: CancelTransactionInput;
};

export type MutationCancelVirtualIbanEntryArgs = {
  input: CancelVirtualIbanEntryInput;
};

export type MutationCloseAccountArgs = {
  input: CloseAccountInput;
};

export type MutationCompleteUserCreationArgs = {
  input: CompleteUserCreationInput;
};

export type MutationConfirmPhysicalCardRenewalArgs = {
  input: ConfirmPhysicalCardRenewalInput;
};

export type MutationCreateCapitalDepositCaseArgs = {
  input: CreateCapitalDepositCaseInput;
};

export type MutationCreateCompanyAccountHolderOnboardingArgs = {
  input: CreateCompanyAccountHolderOnboardingInput;
};

export type MutationCreateInPersonPaymentIntentArgs = {
  input: CreateInPersonPaymentIntentInput;
};

export type MutationCreateIndividualAccountHolderOnboardingArgs = {
  input: CreateIndividualAccountHolderOnboardingInput;
};

export type MutationCreateMerchantPaymentLinkArgs = {
  input: CreateMerchantPaymentLinkInput;
};

export type MutationCreateMultiConsentArgs = {
  input: CreateMultiConsentInput;
};

export type MutationCreatePublicCompanyAccountHolderOnboardingArgs = {
  input: CreatePublicCompanyAccountHolderOnboardingInput;
};

export type MutationCreatePublicIndividualAccountHolderOnboardingArgs = {
  input: CreatePublicIndividualAccountHolderOnboardingInput;
};

export type MutationDeactivateUserArgs = {
  input: DeactivateUserInput;
};

export type MutationDeleteExportFileArgs = {
  input: DeleteExportFileInput;
};

export type MutationDeleteSupportingDocumentArgs = {
  input: DeleteSupportingDocumentInput;
};

export type MutationDenySddArgs = {
  input?: InputMaybe<DenySddInput>;
};

export type MutationDenySddVirtualIbanEntryArgs = {
  input: DenySddVirtualIbanEntryInput;
};

export type MutationDisableAccountMembershipArgs = {
  input?: InputMaybe<DisableAccountMembershipInput>;
};

export type MutationDisableMerchantPaymentMethodArgs = {
  input: DisableMerchantPaymentMethodInput;
};

export type MutationDisableMerchantProfileArgs = {
  input: DisableMerchantProfileInput;
};

export type MutationEnableReceivedDirectDebitMandateArgs = {
  input: EnableReceivedDirectDebitMandateInput;
};

export type MutationExportAccountDataArgs = {
  input: ExportAccountDataInput;
};

export type MutationExportAccountHolderDataArgs = {
  input: ExportAccountHolderDataInput;
};

export type MutationExportAccountMembershipDataArgs = {
  input: ExportAccountMembershipDataInput;
};

export type MutationExportCardDataArgs = {
  input: ExportCardDataInput;
};

export type MutationExportOnboardingDataArgs = {
  input: ExportOnboardingDataInput;
};

export type MutationExportTransactionDataArgs = {
  input: ExportTransactionDataInput;
};

export type MutationExportUserDataArgs = {
  input: ExportUserDataInput;
};

export type MutationFinalizeAccountHolderOnboardingArgs = {
  input: FinalizeAccountHolderOnboardingInput;
};

export type MutationFinalizeOnboardingArgs = {
  input: FinalizeOnboardingInput;
};

export type MutationFinalizeVerificationRenewalArgs = {
  input: FinalizeVerificationRenewalInput;
};

export type MutationGenerateAccountStatementArgs = {
  input: GenerateAccountStatementInput;
};

export type MutationGenerateCapitalDepositDocumentUploadUrlArgs = {
  input: GenerateCapitalDepositDocumentUploadUrlInput;
};

export type MutationGenerateCreditStatementArgs = {
  input: GenerateCreditStatementInput;
};

export type MutationGenerateExportDownloadLinkArgs = {
  input: GenerateExportDownloadLinkInput;
};

export type MutationGenerateIdentificationDocumentUploadUrlArgs = {
  input: GenerateIdentificationDocumentUploadUrlInput;
};

export type MutationGenerateSupportingDocumentUploadUrlArgs = {
  input: GenerateSupportingDocumentUploadUrlInput;
};

export type MutationGenerateTransactionStatementArgs = {
  input: GenerateTransactionStatementInput;
};

export type MutationGenerateTransactionSupportingDocumentUploadUrlArgs = {
  input: GenerateTransactionSupportingDocumentUploadUrlInput;
};

export type MutationGrantConsentWithServerSignatureArgs = {
  input: GrantConsentWithServerSignatureInput;
};

export type MutationInitiateCheckMerchantPaymentArgs = {
  input: InitiateCheckMerchantPaymentInput;
};

export type MutationInitiateCreditTransfersArgs = {
  input: InitiateCreditTransfersInput;
};

export type MutationInitiateFundingRequestArgs = {
  input: InitiateFundingRequestInput;
};

export type MutationInitiateInternationalCreditTransferArgs = {
  input: InitiateInternationalCreditTransferInput;
};

export type MutationInitiateMerchantPaymentCollectionArgs = {
  input: InitiateMerchantPaymentCollectionInput;
};

export type MutationInitiateSepaDirectDebitMerchantPaymentArgs = {
  input: InitiateSepaDirectDebitMerchantPaymentInput;
};

export type MutationOnboardCompanyAccountHolderArgs = {
  input?: InputMaybe<OnboardCompanyAccountHolderInput>;
};

export type MutationOnboardIndividualAccountHolderArgs = {
  input?: InputMaybe<OnboardIndividualAccountHolderInput>;
};

export type MutationOpenAccountArgs = {
  input: OpenAccountInput;
};

export type MutationPrintPhysicalCardArgs = {
  input: PrintPhysicalCardInput;
};

export type MutationProbeWebhookEndpointArgs = {
  input: ProbeWebhookEndpointInput;
};

export type MutationRefundArgs = {
  input: RefundInput;
};

export type MutationRemoveWebhookSubscriptionArgs = {
  input: WebhookSubscriptionIdInput;
};

export type MutationReplayWebhookEventArgs = {
  input: ReplayWebhookEventInput;
};

export type MutationRequestCreditLimitSettingsArgs = {
  input: RequestCreditLimitSettingsInput;
};

export type MutationRequestMerchantPaymentMethodsArgs = {
  input: RequestMerchantPaymentMethodsInput;
};

export type MutationRequestMerchantPaymentMethodsUpdateArgs = {
  input: RequestMerchantPaymentMethodsUpdateInput;
};

export type MutationRequestMerchantProfileArgs = {
  input: RequestMerchantProfileInput;
};

export type MutationRequestMerchantProfileUpdateArgs = {
  input: RequestMerchantProfileUpdateInput;
};

export type MutationRequestSupportingDocumentCollectionReviewArgs = {
  input?: InputMaybe<RequestSupportingDocumentCollectionReviewInput>;
};

export type MutationRequestTerminalConnectionTokenArgs = {
  input: RequestTerminalConnectionTokenInput;
};

export type MutationResumeAccountMembershipArgs = {
  input?: InputMaybe<ResumeAccountMembershipInput>;
};

export type MutationResumePhysicalCardArgs = {
  input?: InputMaybe<ResumePhysicalCardInput>;
};

export type MutationReturnTransactionArgs = {
  input: ReturnTransactionInput;
};

export type MutationScheduleStandingOrderArgs = {
  input: ScheduleStandingOrderInput;
};

export type MutationSendAccountMembershipInviteNotificationArgs = {
  input: SendAccountMembershipInviteNotificationInput;
};

export type MutationStartUserCreationArgs = {
  input: StartUserCreationInput;
};

export type MutationSuspendAccountMembershipArgs = {
  input: SuspendAccountMembershipInput;
};

export type MutationSuspendPhysicalCardArgs = {
  input?: InputMaybe<SuspendPhysicalCardInput>;
};

export type MutationSuspendReceivedDirectDebitMandateArgs = {
  input: SuspendReceivedDirectDebitMandateInput;
};

export type MutationUpdateAccountArgs = {
  input: UpdateAccountInput;
};

export type MutationUpdateAccountHolderArgs = {
  input: UpdateAccountHolderInput;
};

export type MutationUpdateAccountHolderRiskInfoArgs = {
  input: UpdateAccountHolderRiskInfoInput;
};

export type MutationUpdateAccountMembershipArgs = {
  input: UpdateAccountMembershipInput;
};

export type MutationUpdateAccountSettingsArgs = {
  input: UpdateAccountSettingsInput;
};

export type MutationUpdateCapitalDepositCaseCompanyArgs = {
  input: UpdateCapitalDepositCaseCompanyInput;
};

export type MutationUpdateCapitalDepositShareholderAmountArgs = {
  input: UpdateCapitalDepositShareholderAmountInput;
};

export type MutationUpdateCardArgs = {
  input?: InputMaybe<UpdateCardInput>;
};

export type MutationUpdateCompanyAccountHolderOnboardingArgs = {
  input: UpdateCompanyAccountHolderOnboardingInput;
};

export type MutationUpdateCompanyOnboardingArgs = {
  input?: InputMaybe<UpdateCompanyOnboardingInput>;
};

export type MutationUpdateCompanyVerificationRenewalArgs = {
  input: UpdateCompanyVerificationRenewalInput;
};

export type MutationUpdateIndividualAccountHolderOnboardingArgs = {
  input: UpdateIndividualAccountHolderOnboardingInput;
};

export type MutationUpdateIndividualOnboardingArgs = {
  input: UpdateIndividualOnboardingInput;
};

export type MutationUpdateIndividualVerificationRenewalArgs = {
  input: UpdateIndividualVerificationRenewalInput;
};

export type MutationUpdatePublicCompanyAccountHolderOnboardingArgs = {
  input: UpdatePublicCompanyAccountHolderOnboardingInput;
};

export type MutationUpdatePublicIndividualAccountHolderOnboardingArgs = {
  input: UpdatePublicIndividualAccountHolderOnboardingInput;
};

export type MutationUpdateReceivedSepaDirectDebitB2bMandateArgs = {
  input: UpdateReceivedSepaDirectDebitB2bMandateInput;
};

export type MutationUpdateSupportingDocumentArgs = {
  input: UpdateSupportingDocumentInput;
};

export type MutationUpdateUserConsentSettingsArgs = {
  input: UpdateUserConsentSettingsInput;
};

export type MutationUpdateWebhookSubscriptionArgs = {
  input: UpdateWebhookSubscriptionInput;
};

export type MutationVerifyBeneficiaryArgs = {
  input: VerifyBeneficiaryInput;
};

export type MutationViewCardNumbersArgs = {
  input: ViewCardNumbersInput;
};

export type MutationViewCardNumbersWithConsentArgs = {
  input: ViewCardNumbersWithConsentInput;
};

export type MutationViewPhysicalCardNumbersArgs = {
  input: ViewPhysicalCardNumbersInput;
};

export type MutationViewPhysicalCardPinArgs = {
  input: ViewPhysicalCardPinInput;
};

export type NestedWebhookEventLogFiltersInput = {
  endDate?: InputMaybe<Scalars["DateTime"]["input"]>;
  eventId?: InputMaybe<Scalars["ID"]["input"]>;
  eventType?: InputMaybe<Scalars["String"]["input"]>;
  resourceId?: InputMaybe<Scalars["ID"]["input"]>;
  startDate?: InputMaybe<Scalars["DateTime"]["input"]>;
  statusCode?: InputMaybe<Scalars["Int"]["input"]>;
  statusText?: InputMaybe<StatusText>;
};

/** Rejection returned when the User status is not allowed */
export type NotAllowedUserStatusRejection = Rejection & {
  __typename: "NotAllowedUserStatusRejection";
  message: Scalars["String"]["output"];
};

/** Rejection returned if the entity was not found or if the user does not have the rights to know that the account exists */
export type NotFoundRejection = Rejection & {
  __typename: "NotFoundRejection";
  id: Scalars["String"]["output"];
  message: Scalars["String"]["output"];
};

export type NotLegalRepresentativeRejection = Rejection & {
  __typename: "NotLegalRepresentativeRejection";
  message: Scalars["String"]["output"];
};

/** Rejection returned when consent status couldn't change */
export type NotReachableConsentStatusRejection = Rejection & {
  __typename: "NotReachableConsentStatusRejection";
  currentStatus?: Maybe<ConsentStatus>;
  message: Scalars["String"]["output"];
  unreachableStatus?: Maybe<ConsentStatus>;
};

export type NotRequestedThreeDsStatusInfo = ThreeDsStatusInfo & {
  __typename: "NotRequestedThreeDsStatusInfo";
  status: IncomingThreeDsStatus;
};

/**
 * @deprecated Use 'StartedIdentificationLevelStatusInfo' instead. Deprecated to ensure consistency and clear identification status behavior
 * Describes an identification level that hasn't started for the process of the current identification
 */
export type NotStartedIdentificationLevelStatusInfo = {
  __typename: "NotStartedIdentificationLevelStatusInfo";
  /**
   * Always set to `NotStarted`
   * @deprecated Use 'Started' instead. Deprecated to ensure consistency and clear identification status behavior.
   */
  status: SwanIdentificationStatus;
};

/** Rejection returned if the queried service doesn't support the country code */
export type NotSupportedCountryRejection = Rejection & {
  __typename: "NotSupportedCountryRejection";
  message: Scalars["String"]["output"];
};

/** Describes an identification level that's not supported for the process of the current identification */
export type NotSupportedIdentificationLevelStatusInfo = {
  __typename: "NotSupportedIdentificationLevelStatusInfo";
  /** Always set to `NotSupported` */
  status: SwanIdentificationStatus;
};

export type NotificationReminderPlannings = {
  __typename: "NotificationReminderPlannings";
  activatePhysicalCardReminders: Array<PlanningSetting>;
  createdAt: Scalars["DateTime"]["output"];
  updatedAt: Scalars["DateTime"]["output"];
};

/** Extra parameters provided by partner */
export type OAuthRedirectParameters = {
  __typename: "OAuthRedirectParameters";
  /** URL used to redirect the user at the end of the onboarding process. If `null` the user is redirected to the white label web banking. */
  redirectUrl?: Maybe<Scalars["String"]["output"]>;
  /** Custom state provided by partner to prevent XSRF attack, will be filled by onBoardingId in case of nullity. */
  state?: Maybe<Scalars["String"]["output"]>;
};

export type OAuthRedirectParametersInput = {
  /** URL used to redirect the user at the end of the onboarding process. If `null` the user is redirected to the white label web banking. Length must be from 0 to 255 characters */
  redirectUrl?: InputMaybe<Scalars["String"]["input"]>;
  /** Custom state provided by partner to prevent XSRF attack, will be filled by onBoardingId in case of nullity. Length must be from 0 to 255 characters */
  state?: InputMaybe<Scalars["String"]["input"]>;
};

/** Inputs to onboard a new company account holder */
export type OnboardCompanyAccountHolderInput = {
  /** Country of the account created at the end of onboarding. */
  accountCountry?: InputMaybe<AccountCountry>;
  /**
   * Account name of the company account holder.
   * - Length must be from 0 to 100 characters
   */
  accountName?: InputMaybe<Scalars["String"]["input"]>;
  /** Use the `acquisitionChannel` field to specify how the user joined, such as "InboundOrganic", "OutboundSales", etc. */
  acquisitionChannel?: InputMaybe<AcquisitionChannel>;
  /** Business activity. */
  businessActivity?: InputMaybe<BusinessActivity>;
  /**
   * Description of the business activity.
   * - Length must be from 0 to 1024 characters.
   */
  businessActivityDescription?: InputMaybe<Scalars["String"]["input"]>;
  /** Type of the company (Association ...). */
  companyType?: InputMaybe<CompanyType>;
  /**
   * Email of the legal representative.
   * - Length must be from 0 to 255 characters.
   * - Valid format (regex):
   *   ```
   *   /^[A-Z0-9_+.-]*[A-Z0-9_+-]@([A-Z0-9][A-Z0-9-]*\.)+[A-Z]{2,}$/i
   *   ```
   * - Some email providers are not accepted by our system.
   */
  email?: InputMaybe<Scalars["String"]["input"]>;
  /**
   * The ultimate beneficial owner is defined as the natural person (s) who own or control, directly and/or indirectly, the reporting company.
   *
   * The ultimate beneficial owner is :
   * - either the natural person (s) who hold, directly or indirectly, more than 25% of the capital or the rights of vote of the reporting company;
   * - either the natural person (s) who exercise, by other means, a power of control of the company;
   */
  individualUltimateBeneficialOwners?: InputMaybe<Array<IndividualUltimateBeneficialOwnerInput>>;
  /** Is the company registered with their country's national register (for example, Registre du Commerce et des Sociétés [RCS] in France). */
  isRegistered?: InputMaybe<Scalars["Boolean"]["input"]>;
  /**
   * Language of the onboarding process.
   * - Accepted languages: `["en", "fr", "nl", "de", "it", "es", "pt", "fi"]`
   */
  language?: InputMaybe<Scalars["String"]["input"]>;
  /** Legal representative personal address. */
  legalRepresentativePersonalAddress?: InputMaybe<AddressInformationInput>;
  /** Estimated monthly payment volume (euro). */
  monthlyPaymentVolume?: InputMaybe<MonthlyPaymentVolume>;
  /**
   * Company name.
   * - Length must be from 0 to 100 characters.
   * - Valid format (regex):
   *   ```
   *   /^(?:(?<!http(s)*:\/\/|www\.|&lt;|&gt;)[!-.\/-;A-Z[-`a-zÀ-ÖÙ-öº-ƿǄ-ʯʹ-ʽΈ-ΊΎ-ΡΣ-ҁҊ-Ֆա-ևႠ-Ⴥა-ჺᄀ-፜፩-ᎏᵫ-ᶚḀ-῾ⴀ-ⴥ⺀-⿕ぁ-ゖゝ-ㇿ㋿-鿯鿿-ꒌꙀ-ꙮꚀ-ꚙꜦ-ꞇꞍ-ꞿꥠ-ꥼＡ-Ｚａ-ｚ/]|¿|¡| |'|-|Ά|Ό|=|\?|@|\[|]|\||‘|’)*$/
   *   ```
   */
  name?: InputMaybe<Scalars["String"]["input"]>;
  /** Extra parameters provided by partner. */
  oAuthRedirectParameters?: InputMaybe<OAuthRedirectParametersInput>;
  /**
   * Registration number of the company (for example, Système d'Identification du Répertoire des ENtreprises [SIREN] in France, ...).
   * - Length must be from 0 to 50 characters.
   */
  registrationNumber?: InputMaybe<Scalars["String"]["input"]>;
  /** Inputs to add a representative */
  representatives?: InputMaybe<Array<RepresentativeInput>>;
  /**
   * Residency address of the head office.
   * - Must be in a European country.
   */
  residencyAddress?: InputMaybe<ResidencyAddressInput>;
  /**
   * Tax Identification Number.
   * - Must be from 0 to 16 characters.
   */
  taxIdentificationNumber?: InputMaybe<Scalars["String"]["input"]>;
  /** Trade name of the company. */
  tradeName?: InputMaybe<Scalars["String"]["input"]>;
  /** Type of representation (legal representative or power of attorney). */
  typeOfRepresentation?: InputMaybe<TypeOfRepresentation>;
  /**
   * VAT number of the company.
   * - (AT)?U[0-9]{8} |                              # Austria
   * - (BE)?0[0-9]{9} |                              # Belgium
   * - (BG)?[0-9]{9,10} |                            # Bulgaria
   * - (CY)?[0-9]{8}L |                              # Cyprus
   * - (CZ)?[0-9]{8,10} |                            # Czech Republic
   * - (DE)?[0-9]{9} |                               # Germany
   * - (DK)?[0-9]{8} |                               # Denmark
   * - (EE)?[0-9]{9} |                               # Estonia
   * - (EL|GR)?[0-9]{9} |                            # Greece
   * - (ES)?[0-9A-Z][0-9]{7}[0-9A-Z] |               # Spain
   * - (FI)?[0-9]{8} |                               # Finland
   * - (FR)?[0-9A-Z]{2}[0-9]{9} |                    # France
   * - (GB)?([0-9]{9}([0-9]{3})?|[A-Z]{2}[0-9]{3}) | # United Kingdom
   * - (HU)?[0-9]{8} |                               # Hungary
   * - (IE)?[0-9]S[0-9]{5}L |                        # Ireland
   * - (IT)?[0-9]{11} |                              # Italy
   * - (LT)?([0-9]{9}|[0-9]{12}) |                   # Lithuania
   * - (LU)?[0-9]{8} |                               # Luxembourg
   * - (LV)?[0-9]{11} |                              # Latvia
   * - (MT)?[0-9]{8} |                               # Malta
   * - (NL)?[0-9]{9}B[0-9]{2} |                      # Netherlands
   * - (PL)?[0-9]{10} |                              # Poland
   * - (PT)?[0-9]{9} |                               # Portugal
   * - (RO)?[0-9]{2,10} |                            # Romania
   * - (SE)?[0-9]{12} |                              # Sweden
   * - (SI)?[0-9]{8} |                               # Slovenia
   * - (SK)?[0-9]{10}                                # Slovakia
   */
  vatNumber?: InputMaybe<Scalars["String"]["input"]>;
};

export type OnboardCompanyAccountHolderPayload =
  | BadRequestRejection
  | ForbiddenRejection
  | OnboardCompanyAccountHolderSuccessPayload
  | ValidationRejection;

export type OnboardCompanyAccountHolderSuccessPayload = {
  __typename: "OnboardCompanyAccountHolderSuccessPayload";
  onboarding: Onboarding;
};

/** Information on the shareholder. */
export type OnboardCompanyShareholderInput = {
  /** Amount the shareholder has to deposit. */
  capitalDepositAmount: AmountInput;
  /** Name ("Dénomination sociale") of the shareholder. */
  name: Scalars["String"]["input"];
  /** Information required for the onboarding of a company shareholder. */
  onboardingInfo: OnboardCompanyAccountHolderInput;
};

/** Inputs to onboard a new individual account holder */
export type OnboardIndividualAccountHolderInput = {
  /** Country of the account created at the end of onboarding. */
  accountCountry?: InputMaybe<AccountCountry>;
  /**
   * Account name of the individual account holder.
   * - Length must be from 0 to 100 characters.
   */
  accountName?: InputMaybe<Scalars["String"]["input"]>;
  /** Use the `acquisitionChannel` field to specify how the user joined, such as "InboundOrganic", "OutboundSales", etc. */
  acquisitionChannel?: InputMaybe<AcquisitionChannel>;
  /**
   * Email of the legal representative.
   * - Length must be from 0 to 255 characters.
   * - Valid format (regex):
   *   ```
   *   /^[A-Z0-9_+.-]*[A-Z0-9_+-]@([A-Z0-9][A-Z0-9-]*\.)+[A-Z]{2,}$/i
   *   ```
   * - Some email providers are not accepted by our system.
   */
  email?: InputMaybe<Scalars["String"]["input"]>;
  /** Employment status of the individual account holder. */
  employmentStatus?: InputMaybe<EmploymentStatus>;
  /**
   * Language of the onboarding process.
   * - Accepted languages: `["en", "fr", "nl", "de", "it", "es", "pt", "fi"]`
   */
  language?: InputMaybe<Scalars["String"]["input"]>;
  /** Monthly income of the individual account holder (euro). */
  monthlyIncome?: InputMaybe<MonthlyIncome>;
  /** Extra parameters provided by partner. */
  oAuthRedirectParameters?: InputMaybe<OAuthRedirectParametersInput>;
  /**
   * Residency address of the individual account holder.
   * - Must be in a European country.
   */
  residencyAddress?: InputMaybe<ResidencyAddressInput>;
  /**
   * Tax Identification Number.
   * - Must be from 0 to 16 characters.
   */
  taxIdentificationNumber?: InputMaybe<Scalars["String"]["input"]>;
};

export type OnboardIndividualAccountHolderPayload =
  | ForbiddenRejection
  | OnboardIndividualAccountHolderSuccessPayload
  | ValidationRejection;

export type OnboardIndividualAccountHolderSuccessPayload = {
  __typename: "OnboardIndividualAccountHolderSuccessPayload";
  onboarding: Onboarding;
};

/** Information on the shareholder. */
export type OnboardIndividualShareholderInput = {
  /** Birthdate of the shareholder in the YYYY/MM/DD format. */
  birthDate: Scalars["String"]["input"];
  /** Amount the shareholder has to deposit. */
  capitalDepositAmount: AmountInput;
  /** First name of the shareholder. */
  firstName: Scalars["String"]["input"];
  /** Last name of the shareholder. */
  lastName: Scalars["String"]["input"];
  /** CCA3 code for the country of nationality of the shareholder. */
  nationality: Scalars["CCA3"]["input"];
  /** Information required for the onboarding of a individual shareholder. */
  onboardingInfo: OnboardIndividualAccountHolderInput;
};

/** Information provided during the onboarding process of an individual or a company */
export type Onboarding = {
  __typename: "Onboarding";
  /** Account opened after the onboarding finalization */
  account?: Maybe<Account>;
  /** Account Country */
  accountCountry: AccountCountry;
  /** Account holder created at the end of the onboarding process */
  accountHolder?: Maybe<AccountHolder>;
  /** Account name */
  accountName?: Maybe<Scalars["String"]["output"]>;
  /** Acquisition Channel to specify how the user joined, such as "InboundOrganic", "OutboundSales", etc. */
  acquisitionChannel?: Maybe<AcquisitionChannel>;
  /** Creation date */
  createdAt: Scalars["DateTime"]["output"];
  /** Email */
  email?: Maybe<Scalars["String"]["output"]>;
  /** Finalization date */
  finalizedAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** Unique identifier of an onboarding */
  id: Scalars["String"]["output"];
  /** Information regarding the Individual or the company to onboard */
  info: OnboardingAccountHolderInfo;
  /**
   * Language of the onboarding process.
   * - Accepted languages: `["en", "fr", "nl", "de", "it", "es", "pt", "fi"]`
   */
  language?: Maybe<AccountLanguage>;
  /** List of accepted identification level for the legal representative */
  legalRepresentativeAcceptedIdentificationLevels: Array<Maybe<IdentificationLevel>>;
  /** Extra parameters provided by partner */
  oAuthRedirectParameters?: Maybe<OAuthRedirectParameters>;
  /** Redirect the legal representative of a new account holder to this URL to start the onboarding process */
  onboardingUrl?: Maybe<Scalars["String"]["output"]>;
  /** Status (valid/invalid/finalized) and details of errors on fields */
  statusInfo: OnboardingStatusInfo;
  /** List of supporting document collection owned by the account holder. */
  supportingDocumentCollection: SupportingDocumentCollection;
  /** Swan TCU URL */
  tcuUrl: Scalars["String"]["output"];
  /** Creation date */
  updatedAt: Scalars["DateTime"]["output"];
};

/** The onboarding could be for an Individual or a company */
export type OnboardingAccountHolderInfo = {
  /** Account holder type */
  type: AccountHolderType;
};

/** Rejection returned if the onboarding is already finalized */
export type OnboardingAlreadyFinalizedRejection = Rejection & {
  __typename: "OnboardingAlreadyFinalizedRejection";
  message: Scalars["String"]["output"];
  onboardingId: Scalars["String"]["output"];
};

/** Company Account Holder Information */
export type OnboardingCompanyAccountHolderInfo = OnboardingAccountHolderInfo & {
  __typename: "OnboardingCompanyAccountHolderInfo";
  /** business activity */
  businessActivity?: Maybe<BusinessActivity>;
  /**
   * business activity description
   * This must be 1024 characters long maximum.
   */
  businessActivityDescription?: Maybe<Scalars["String"]["output"]>;
  /** legal form of the company (SAS, SCI, SASU, ...) */
  companyType?: Maybe<CompanyType>;
  /**
   * The ultimate beneficiary is defined as the natural person (s) who own or control, directly or indirectly, the reporting company.
   *
   * The ultimate beneficiary is :
   * - either the natural person (s) who hold, directly or indirectly, more than 25% of the capital or the rights of vote of the reporting company;
   * - either the natural person (s) who exercise, by other means, a power of control of the company;
   */
  individualUltimateBeneficialOwners?: Maybe<Array<IndividualUltimateBeneficialOwner>>;
  /** Is company registered at RCS in its country */
  isRegistered?: Maybe<Scalars["Boolean"]["output"]>;
  /** Legal representative personal address */
  legalRepresentativePersonalAddress?: Maybe<AddressInformation>;
  /** estimated monthly payment volume (euro) */
  monthlyPaymentVolume?: Maybe<MonthlyPaymentVolume>;
  /** Name of the company. */
  name?: Maybe<Scalars["String"]["output"]>;
  /**
   * Registration number of the company (for example, Système d'Identification du Répertoire des ENtreprises [SIREN] in France, ...).
   * - Length must be from 0 to 50 characters.
   */
  registrationNumber?: Maybe<Scalars["String"]["output"]>;
  /** Returns the list of representatives of a company. */
  representatives?: Maybe<Array<Representative>>;
  /** residency address of the head office (Must be in a European country) */
  residencyAddress?: Maybe<AddressInfo>;
  /** Tax Identification Number */
  taxIdentificationNumber?: Maybe<Scalars["String"]["output"]>;
  /** Trade name of the company */
  tradeName?: Maybe<Scalars["String"]["output"]>;
  /** Account holder type (always Company for type OnboardingCompanyAccountHolderInfo) */
  type: AccountHolderType;
  /** Type of representation (legal representative or power of attorney) */
  typeOfRepresentation?: Maybe<TypeOfRepresentation>;
  /** Unique number that identifies a taxable person (business) or non-taxable legal entity that is registered for VAT */
  vatNumber?: Maybe<Scalars["String"]["output"]>;
};

export type OnboardingCompanyRepresentative = {
  __typename: "OnboardingCompanyRepresentative";
  address?: Maybe<AddressInfo>;
  entityName?: Maybe<Scalars["String"]["output"]>;
  legalForm?: Maybe<Scalars["String"]["output"]>;
  registrationNumber?: Maybe<Scalars["String"]["output"]>;
  roles?: Maybe<Array<Scalars["String"]["output"]>>;
};

/** Implements the Relay Connection interface, used to paginate lists of elements. ([Learn More](https://docs.swan.io/developers/using-api/pagination)) */
export type OnboardingConnection = Connection & {
  __typename: "OnboardingConnection";
  /** OnboardingEdge list */
  edges: Array<OnboardingEdge>;
  /** Information about the current, the previous and the next page */
  pageInfo: PageInfo;
  /** Total number of element in the list */
  totalCount: Scalars["Int"]["output"];
};

/** Implements the Relay Edge interface */
export type OnboardingEdge = Edge & {
  __typename: "OnboardingEdge";
  /** Opaque identifier pointing to this onboarding node in the pagination mechanism */
  cursor: Scalars["String"]["output"];
  /** The Onboarding */
  node: Onboarding;
};

/** Filters that can be applied when listing onboardings */
export type OnboardingFiltersInput = {
  /** Filter by email */
  email?: InputMaybe<Scalars["String"]["input"]>;
  /**
   * Search string to look for
   *
   * Search will be performed in following fields:
   *  - Account holder's first name
   *  - Account holder's last name
   *  - Account holder's company name
   *  - Account holder's ID
   *  - Email
   *  - ID
   */
  search?: InputMaybe<Scalars["String"]["input"]>;
  /** Filter by status */
  status?: InputMaybe<Array<OnboardingStatus>>;
  /** Filter by type */
  types?: InputMaybe<Array<AccountHolderType>>;
};

/** StatusInfo when onboarding has been finalized */
export type OnboardingFinalizedStatusInfo = OnboardingStatusInfo & {
  __typename: "OnboardingFinalizedStatusInfo";
  status: OnboardingStatus;
};

/** Individual Account Holder Information */
export type OnboardingIndividualAccountHolderInfo = OnboardingAccountHolderInfo & {
  __typename: "OnboardingIndividualAccountHolderInfo";
  /** employment status of the individual account holder */
  employmentStatus?: Maybe<EmploymentStatus>;
  /** monthly income of the individual account holder */
  monthlyIncome?: Maybe<MonthlyIncome>;
  /** residency address of the individual account holder (must be in a European country) */
  residencyAddress?: Maybe<AddressInfo>;
  /** Tax Identification Number */
  taxIdentificationNumber?: Maybe<Scalars["String"]["output"]>;
  /** Account holder type (always Individual for type OnboardingIndividualAccountHolderInfo) */
  type: AccountHolderType;
};

export type OnboardingIndividualRepresentative = {
  __typename: "OnboardingIndividualRepresentative";
  address?: Maybe<AddressInfo>;
  birthInfo?: Maybe<BirthInfo>;
  firstName?: Maybe<Scalars["String"]["output"]>;
  lastName?: Maybe<Scalars["String"]["output"]>;
  nationality?: Maybe<Scalars["CCA3"]["output"]>;
  preferredFirstName?: Maybe<Scalars["String"]["output"]>;
  roles?: Maybe<Array<Scalars["String"]["output"]>>;
  sex?: Maybe<Sex>;
};

export type OnboardingInfo = {
  __typename: "OnboardingInfo";
  /** Country of the account that will be created at the end of the onboarding process */
  accountCountry?: Maybe<AccountCountry>;
  /** Account name */
  accountName?: Maybe<Scalars["String"]["output"]>;
  /** Acquisition Channel to specify how the user joined, such as "InboundOrganic", "OutboundSales", etc. */
  acquisitionChannel?: Maybe<AcquisitionChannel>;
  /** email */
  email?: Maybe<Scalars["String"]["output"]>;
  /** Unique identifier of an onboarding */
  id: Scalars["String"]["output"];
  /** Information regarding the Individual or the company to onboard */
  info: OnboardingAccountHolderInfo;
  /**
   * Language of the onboarding process.
   * - Accepted languages: `["en", "fr", "nl", "de", "it", "es", "pt", "fi"]`
   */
  language?: Maybe<AccountLanguage>;
  /** List of accepted identification level for the legal representative */
  legalRepresentativeAcceptedIdentificationLevels: Array<Maybe<IdentificationLevel>>;
  /** Extra parameters provided by partner */
  oAuthRedirectParameters?: Maybe<OAuthRedirectParameters>;
  /** Redirect the legal representative of a new account holder to this URL to start the onboarding process */
  onboardingUrl: Scalars["String"]["output"];
  /** Project infos you set in the dashboard */
  projectInfo?: Maybe<ProjectInfo>;
  /** Status (valid/invalid/finalized) and details of errors on fields */
  statusInfo: OnboardingStatusInfo;
  /** Supporting document collection related to onboarding. */
  supportingDocumentCollection: SupportingDocumentCollection;
  /** Swan TCU URL */
  tcuUrl: Scalars["String"]["output"];
};

/** StatusInfo when onboarding has still at least one incorrect field */
export type OnboardingInvalidStatusInfo = OnboardingStatusInfo & {
  __typename: "OnboardingInvalidStatusInfo";
  errors: Array<ValidationError>;
  status: OnboardingStatus;
};

/** Rejection returned if an onboarding is not completed */
export type OnboardingNotCompletedRejection = Rejection & {
  __typename: "OnboardingNotCompletedRejection";
  message: Scalars["String"]["output"];
  onboarding: Onboarding;
  /** @deprecated use `onboarding.id` instead */
  onboardingId: Scalars["String"]["output"];
};

/** Rejection returned if the onboarding was not found */
export type OnboardingNotFoundRejection = Rejection & {
  __typename: "OnboardingNotFoundRejection";
  id: Scalars["String"]["output"];
  message: Scalars["String"]["output"];
};

/** Rejection returned if finalizing an onboarding fails because the onboarding is not ready for finalization. */
export type OnboardingNotReadyForFinalizationRejection = Rejection & {
  __typename: "OnboardingNotReadyForFinalizationRejection";
  message: Scalars["String"]["output"];
  onboarding: AccountHolderOnboarding;
};

/** Field we can use when ordering that can be applied when listing onboardings */
export type OnboardingOrderByFieldInput = "createdAt" | "finalizedAt" | "updatedAt";

/** Order that can be applied when listing onboardings */
export type OnboardingOrderByInput = {
  direction?: InputMaybe<OrderByDirection>;
  field?: InputMaybe<OnboardingOrderByFieldInput>;
};

export type OnboardingRepresentative =
  | OnboardingCompanyRepresentative
  | OnboardingIndividualRepresentative;

/** Input for onboarding representative (company or individual) */
export type OnboardingRepresentativeInput = {
  address?: InputMaybe<ResidencyAddressInput>;
  birthInfo?: InputMaybe<BirthInfoInput>;
  email?: InputMaybe<Scalars["String"]["input"]>;
  entityName?: InputMaybe<Scalars["String"]["input"]>;
  firstName?: InputMaybe<Scalars["String"]["input"]>;
  lastName?: InputMaybe<Scalars["String"]["input"]>;
  legalForm?: InputMaybe<Scalars["String"]["input"]>;
  nationality?: InputMaybe<Scalars["CCA3"]["input"]>;
  preferredFirstName?: InputMaybe<Scalars["String"]["input"]>;
  registrationNumber?: InputMaybe<Scalars["String"]["input"]>;
  roles?: InputMaybe<Array<Scalars["String"]["input"]>>;
  sex?: InputMaybe<Sex>;
  type: RepresentativeType;
};

/** Possible values for onboarding status */
export type OnboardingStatus =
  /** When the onboarding is finalized */
  | "Finalized"
  /** when the onboarding is invalid. Final status */
  | "Invalid"
  /** When the onboarding is valid. Final status */
  | "Valid";

/** Object containing details about onboarding status (valid/invalid and why it is invalid/already finalized) */
export type OnboardingStatusInfo = {
  /** Current onboarding status. Onboarding can only be finalized if status is "valid" */
  status: OnboardingStatus;
};

/** StatusInfo when onboarding has all onboarding fields are correctly filled */
export type OnboardingValidStatusInfo = OnboardingStatusInfo & {
  __typename: "OnboardingValidStatusInfo";
  status: OnboardingStatus;
};

/** Inputs to open an additional account */
export type OpenAccountInput = {
  /** Unique identifier of an account holder */
  accountHolderId: Scalars["ID"]["input"];
  /** Language of the additional account */
  language?: InputMaybe<AccountLanguage>;
  /** Name of the additional account */
  name?: InputMaybe<Scalars["String"]["input"]>;
};

export type OpenAccountPayload =
  | AccountHolderAccountsCreationLimitRejection
  | AccountHolderAccountsStatusNotEligibleRejection
  | AccountHolderAccountsTypeNotEligibleRejection
  | AccountHolderNotFoundRejection
  | AccountHolderProjectSettingsNotEligibleRejection
  | AccountHolderStatusNotEligibleRejection
  | AccountHolderTypeNotEligibleRejection
  | AccountHolderVerificationStatusNotEligibleRejection
  | AccountMembershipNotEligibleRejection
  | ForbiddenRejection
  | InternalErrorRejection
  | OpenAccountSuccessPayload
  | ProjectSettingsNotFoundRejection;

export type OpenAccountSuccessPayload = {
  __typename: "OpenAccountSuccessPayload";
  account: Account;
};

export type OperationNotAllowedRejection = Rejection & {
  __typename: "OperationNotAllowedRejection";
  message: Scalars["String"]["output"];
};

export type OrderByDirection = "Asc" | "Desc";

export type OtherAdditionalInformation = {
  __typename: "OtherAdditionalInformation";
  description: Scalars["String"]["output"];
  value: Scalars["String"]["output"];
};

export type OtherAdditionalInformationInput = {
  description: Scalars["String"]["input"];
  value: Scalars["String"]["input"];
};

export type OtherAdditionalInformationRequirements = {
  __typename: "OtherAdditionalInformationRequirements";
  otherAdditionalInformation: Array<Scalars["String"]["output"]>;
};

/** https://www.twilio.com/docs/verify/supported-languages */
export type OtpLocale =
  | "af"
  | "ar"
  | "ca"
  | "cs"
  | "da"
  | "de"
  | "el"
  | "en"
  | "es"
  | "et"
  | "fi"
  | "fr"
  | "he"
  | "hi"
  | "hr"
  | "hu"
  | "id"
  | "it"
  | "ja"
  | "kn"
  | "ko"
  | "lt"
  | "mr"
  | "ms"
  | "nb"
  | "nl"
  | "pl"
  | "pt"
  | "ro"
  | "ru"
  | "sk"
  | "sv"
  | "te"
  | "th"
  | "tl"
  | "tr"
  | "uk"
  | "vi"
  | "zh";

export type PinNotReadyRejection = Rejection & {
  __typename: "PINNotReadyRejection";
  message: Scalars["String"]["output"];
  physicalCardIdentifier: Scalars["String"]["output"];
};

/** Implements PageInfo from the Relay Connections Specification - information about a page in the pagination mechanism */
export type PageInfo = {
  __typename: "PageInfo";
  /** Opaque identifier pointing to the last node of the page */
  endCursor?: Maybe<Scalars["String"]["output"]>;
  /** Indicates whether more edges exist following this page */
  hasNextPage?: Maybe<Scalars["Boolean"]["output"]>;
  /** Indicates whether more edges exist preceding this page */
  hasPreviousPage?: Maybe<Scalars["Boolean"]["output"]>;
  /** Opaque identifier pointing to the first node of the page */
  startCursor?: Maybe<Scalars["String"]["output"]>;
};

/** Input version */
export type PartnerCloseAccountReasonInput = {
  message?: InputMaybe<Scalars["String"]["input"]>;
  type: PartnerCloseAccountReasonType;
};

/** Specific type for closing account action */
export type PartnerCloseAccountReasonType =
  /** Simple closing request */
  "ClosingRequested";

/** Partnership Status Accepted */
export type PartnershipAcceptedStatusInfo = PartnershipStatusInfo & {
  __typename: "PartnershipAcceptedStatusInfo";
  /** Accepted date of the partnership for this account */
  acceptedDate: Scalars["DateTime"]["output"];
  /** Partnership status (always Accepted for type PartnershipAcceptedStatusInfo) */
  status: PartnershipStatus;
};

/** Partnership Status canceled */
export type PartnershipCanceledStatusInfo = PartnershipStatusInfo & {
  __typename: "PartnershipCanceledStatusInfo";
  /** Accepted date of the partnership for this account */
  acceptedDate: Scalars["DateTime"]["output"];
  /** Canceled date of the partnership for this account */
  canceledDate: Scalars["DateTime"]["output"];
  /** Reason of the cancelation */
  reason: Scalars["String"]["output"];
  /** Partnership status (always Canceled for type PartnershipCanceledStatusInfo) */
  status: PartnershipStatus;
};

/** Partnership Status currently cancelling */
export type PartnershipCancelingStatusInfo = PartnershipStatusInfo & {
  __typename: "PartnershipCancelingStatusInfo";
  /** Accepted date of the partnership for this account */
  acceptedDate: Scalars["DateTime"]["output"];
  /** Canceled date of the partnership for this account */
  canceledAfter: Scalars["DateTime"]["output"];
  /** Partnership status (always Canceling for type PartnershipCancelingStatusInfo) */
  status: PartnershipStatus;
};

export type PartnershipStatus =
  /** When the partnership is accepted by the account holder for this account */
  | "Accepted"
  /** When the partnership was canceled by you or the account holder */
  | "Canceled"
  /** When you decide to stop the partnership, you have 2 months notice */
  | "Canceling";

/** Partnership Status information */
export type PartnershipStatusInfo = {
  /** Status of the partnership for this account */
  status: PartnershipStatus;
};

/** The document corresponding to a passport */
export type PassportDocument = {
  __typename: "PassportDocument";
  /** The date at which the passport expires */
  expiryDate?: Maybe<Scalars["Date"]["output"]>;
  /** List of the associated files */
  files: Array<PassportDocumentFile>;
  /** Unique identifier of the passport document */
  id: Scalars["String"]["output"];
  /** The date at which the passport was issued */
  issueDate?: Maybe<Scalars["Date"]["output"]>;
  /** Machine-readable zone code of the passport */
  mrz?: Maybe<Scalars["String"]["output"]>;
  /** Number of the passport */
  number?: Maybe<Scalars["String"]["output"]>;
  /** The type of the document */
  type: DocumentType;
};

/** The file associated to the passport document */
export type PassportDocumentFile = DocumentFile & {
  __typename: "PassportDocumentFile";
  /** The file's temporary download url */
  downloadUrl: Scalars["String"]["output"];
  /** From which side the passport's picture was taken */
  side: DocumentFileSide;
};

/**
 * A Payment represents a set of transactions linked to the same payment act.
 *
 * This payment act can be initiated:
 * - either from a user
 * - either from a merchant
 * - either from you
 * - either from Swan
 */
export type Payment = {
  __typename: "Payment";
  /** created date */
  createdAt: Scalars["DateTime"]["output"];
  /** unique identifier of a payment */
  id: Scalars["ID"]["output"];
  /** standing order that has initiated this payment */
  standingOrder?: Maybe<StandingOrder>;
  /** status information */
  statusInfo: PaymentStatusInfo;
  /**
   * list of transactions associated to this payment
   *
   * Implements the Relay Connection interface, used to paginate lists of elements. ([Learn More](https://docs.swan.io/developers/using-api/pagination))
   */
  transactions?: Maybe<TransactionConnection>;
  /** updated date */
  updatedAt: Scalars["DateTime"]["output"];
};

/**
 * A Payment represents a set of transactions linked to the same payment act.
 *
 * This payment act can be initiated:
 * - either from a user
 * - either from a merchant
 * - either from you
 * - either from Swan
 */
export type PaymentTransactionsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  filters?: InputMaybe<TransactionsFiltersInput>;
  first?: Scalars["Int"]["input"];
  orderBy?: InputMaybe<TransactionsOrderByInput>;
};

export type PaymentAccountType =
  /** When the account holder if the account hasn't met KYC requirements */
  | "EMoney"
  /** When all KYC requirements are met */
  | "PaymentService";

/** Please see the Connection interface */
export type PaymentConnection = Connection & {
  __typename: "PaymentConnection";
  edges: Array<PaymentEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars["Int"]["output"];
};

/** Payment status consent pending */
export type PaymentConsentPending = PaymentStatusInfo & {
  __typename: "PaymentConsentPending";
  /** The consent required to initiate this payment */
  consent: Consent;
  /** status of the payment */
  status: PaymentStatus;
};

export type PaymentDirectDebitMandate = {
  /** Unique identifier of the Direct Debit Payment Mandate */
  id: Scalars["ID"]["output"];
};

/** Please see the Connection interface */
export type PaymentEdge = Edge & {
  __typename: "PaymentEdge";
  cursor: Scalars["String"]["output"];
  node: Payment;
};

/** Filters that can be applied when listing payments */
export type PaymentFiltersInput = {
  status?: InputMaybe<Array<PaymentStatus>>;
};

/** Payment status initiated */
export type PaymentInitiated = PaymentStatusInfo & {
  __typename: "PaymentInitiated";
  /** status of the payment */
  status: PaymentStatus;
};

export type PaymentIntent = {
  __typename: "PaymentIntent";
  secret: Scalars["String"]["output"];
};

/** Payment Level of the account */
export type PaymentLevel =
  /** When the account is limited to 0€ within 30 days and with no IBAN */
  | "Limited"
  /** When the account holder is fully verified and then the account is unlimited with an IBAN */
  | "Unlimited";

export type PaymentLevelType = "Limited" | "Unlimited";

export type PaymentMandate = {
  /** Account Holder information */
  accountHolder: AccountHolder;
  /** Creation date of the Payment Mandate */
  createdAt: Scalars["DateTime"]["output"];
  /** Date of the the last transaction executed for the concerned Payment Mandate */
  executedAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** Expiry date of the Payment Mandate */
  expiredAt?: Maybe<Scalars["Date"]["output"]>;
  /** Unique identifier of the Payment Mandate */
  id: Scalars["ID"]["output"];
  /** Custom name of the mandate */
  name?: Maybe<Scalars["String"]["output"]>;
  /** Payment Mandate status information */
  statusInfo: PaymentMandateStatusInfo;
  /** List of transactions associated with the Payment Mandate. */
  transactions?: Maybe<TransactionConnection>;
  /** Last Update date of the Payment Mandate */
  updatedAt: Scalars["DateTime"]["output"];
};

export type PaymentMandateTransactionsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  filters?: InputMaybe<TransactionsFiltersInput>;
  first?: Scalars["Int"]["input"];
};

export type PaymentMandateCanceledReason =
  /** When the Payment Mandate is expired */
  | "MandateExpired"
  /** When the user requested to cancel the Payment Mandate */
  | "RequestedByUser";

/** Payment Mandate Canceled status information */
export type PaymentMandateCanceledStatusInfo = PaymentMandateStatusInfo & {
  __typename: "PaymentMandateCanceledStatusInfo";
  /** Date of Cancellation of the mandate. */
  canceledAt: Scalars["DateTime"]["output"];
  /** Reason behind the Payment Mandate Canceled status */
  reason: PaymentMandateCanceledReason;
  /** Payment Mandate status (always Canceled for type PaymentMandateCanceledStatusInfo). */
  status: PaymentMandateStatus;
};

/** Implements the Relay Connection interface, used to paginate list of element ([Learn More](https://docs.swan.io/api/pagination)) */
export type PaymentMandateConnection = Connection & {
  __typename: "PaymentMandateConnection";
  /** PaymentMandateEdge list */
  edges: Array<PaymentMandateEdge>;
  /** Information about the current, the previous and the next page */
  pageInfo: PageInfo;
  /** Total number of elements in the list */
  totalCount: Scalars["Int"]["output"];
};

/** Payment Mandate Consent Pending status information */
export type PaymentMandateConsentPendingStatusInfo = PaymentMandateStatusInfo & {
  __typename: "PaymentMandateConsentPendingStatusInfo";
  /** Consent information required to enable the concerned Payment Mandate */
  consent: Consent;
  /** Payment Mandate status (always Enabled for type PaymentMandateEnableedStatusInfo). */
  status: PaymentMandateStatus;
};

export type PaymentMandateCreditor = {
  /** Creditor address */
  address: Address;
  /** Creditor UUID */
  id: Scalars["ID"]["output"];
  /** Creditor name */
  name: Scalars["String"]["output"];
};

export type PaymentMandateDebtor = {
  /** Debtor country */
  country: Scalars["CCA3"]["output"];
  /** Debtor e-mail */
  email?: Maybe<Scalars["String"]["output"]>;
  /** Debtor name */
  name: Scalars["String"]["output"];
};

/** Implements the Relay Edge interface */
export type PaymentMandateEdge = Edge & {
  __typename: "PaymentMandateEdge";
  /** Opaque identifier pointing to this onboarding node in the pagination mechanism */
  cursor: Scalars["String"]["output"];
  /** The payment mandate */
  node: PaymentMandate;
};

/** Payment Mandate Enabled status information */
export type PaymentMandateEnabledStatusInfo = PaymentMandateStatusInfo & {
  __typename: "PaymentMandateEnabledStatusInfo";
  /** Payment Mandate status (always Enabled for type PaymentMandateEnabledStatusInfo). */
  status: PaymentMandateStatus;
};

/** Filter that can be passed to get the payment mandate in a specific data range */
export type PaymentMandateFiltersInput = {
  /** To filter on scheme values */
  scheme?: InputMaybe<Array<PaymentMandateScheme>>;
  /** To filter on status values */
  status?: InputMaybe<Array<PaymentMandateStatus>>;
};

/** Error returned if the payment mandate was not found */
export type PaymentMandateMandateNotFoundRejection = Rejection & {
  __typename: "PaymentMandateMandateNotFoundRejection";
  id: Scalars["String"]["output"];
  message: Scalars["String"]["output"];
};

/** Field we can use when ordering that can be applied when listing payment mandate results */
export type PaymentMandateOrderByFieldInput = "createdAt" | "updatedAt";

/** Order that can be applied when listing payment mandate results */
export type PaymentMandateOrderByInput = {
  direction?: InputMaybe<OrderByDirection>;
  field?: InputMaybe<PaymentMandateOrderByFieldInput>;
};

/** Rejection returned if the payment mandate reference is already used for the same creditor */
export type PaymentMandateReferenceAlreadyUsedRejection = Rejection & {
  __typename: "PaymentMandateReferenceAlreadyUsedRejection";
  message: Scalars["String"]["output"];
};

/** Payment Mandate Rejected status information */
export type PaymentMandateRejectedStatusInfo = PaymentMandateStatusInfo & {
  __typename: "PaymentMandateRejectedStatusInfo";
  /** Payment Mandate status (always Rejected for type PaymentMandateSuspendedStatusInfo). */
  status: PaymentMandateStatus;
};

export type PaymentMandateScheme =
  /** Card Cartes Bancaires */
  | "CardCartesBancaires"
  /** Card Mastercard */
  | "CardMastercard"
  /** Card Visa */
  | "CardVisa"
  /** Internal Direct Debit B2B */
  | "InternalDirectDebitB2b"
  /** Internal Direct Debit Standard */
  | "InternalDirectDebitStandard"
  /** SEPA Direct Debit B2B */
  | "SepaDirectDebitB2b"
  /** SEPA Direct Debit Core */
  | "SepaDirectDebitCore";

/** Payment Mandate Sequence */
export type PaymentMandateSequence =
  /** The Payment Mandate can be used only once */
  | "OneOff"
  /** The Payment Mandate can be used for recurrent collections */
  | "Recurrent";

/** Payment Mandate status */
export type PaymentMandateStatus = "Canceled" | "ConsentPending" | "Enabled" | "Rejected";

/** Payment Mandate status information */
export type PaymentMandateStatusInfo = {
  /** Status of the payment mandate. */
  status: PaymentMandateStatus;
};

/** Rejection returned when a payment method is not compatible for the requested mutation */
export type PaymentMethodNotCompatibleRejection = Rejection & {
  __typename: "PaymentMethodNotCompatibleRejection";
  message: Scalars["String"]["output"];
};

/** Field we can use when ordering that can be applied when listing payment */
export type PaymentOrderByFieldInput = "createdAt" | "updatedAt";

/** Order that can be applied when listing payments */
export type PaymentOrderByInput = {
  direction?: InputMaybe<OrderByDirection>;
  field?: InputMaybe<PaymentOrderByFieldInput>;
};

/** Payment product */
export type PaymentProduct =
  /** When the payment is a Card operation */
  | "Card"
  /** When the payment is a Check operation */
  | "Check"
  /** When the payment is a Fees operation */
  | "Fees"
  /** When the payment is an Internal Credit Transfer operation */
  | "InternalCreditTransfer"
  /** When the payment is an Internal Direct Debit operation */
  | "InternalDirectDebit"
  /** When the payment is an International Credit Transfer operation */
  | "InternationalCreditTransfer"
  /** When the payment is a Sepa Credit Transfer operation */
  | "SEPACreditTransfer"
  /** When the payment is a Sepa Direct Debit operation */
  | "SEPADirectDebit";

/** Payment status rejected */
export type PaymentRejected = PaymentStatusInfo & {
  __typename: "PaymentRejected";
  /** rejected reason */
  reason: Scalars["String"]["output"];
  /** status of the payment */
  status: PaymentStatus;
};

/** Payment status */
export type PaymentStatus =
  /** when a consent is pending before initiating the payment */
  | "ConsentPending"
  /** when the payment has been initiated */
  | "Initiated"
  /** when the payment has been rejected */
  | "Rejected";

/** Payment Status Information */
export type PaymentStatusInfo = {
  /** status of the payment */
  status: PaymentStatus;
};

/** [DEPRECATED] Custom information for a PDF statement */
export type PdfStatement = StatementInfo & {
  __typename: "PdfStatement";
  /** date at which the link will not be useable anymore */
  expiresAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** statement type */
  type?: Maybe<StatementType>;
  /** temporary public url on which the file can be accessed */
  url?: Maybe<Scalars["String"]["output"]>;
};

/** Pending Consent when the account membership will be updated */
export type PendingConsentAccountMembershipUpdate = {
  __typename: "PendingConsentAccountMembershipUpdate";
  /** New account membership version waiting for consent */
  accountMembershipId: AccountMembership;
  /** The consent required to update the account membership */
  consent: Consent;
};

/** Pending Digital Card used for ApplePay or GooglePay */
export type PendingDigitalCard = DigitalCard & {
  __typename: "PendingDigitalCard";
  /** The card contract ID */
  cardContractId: Scalars["ID"]["output"];
  /** Created date */
  createdAt: Scalars["DateTime"]["output"];
  /** Unique identifier of a digital card */
  id: Scalars["ID"]["output"];
  /**
   * Data to provide to the wallet during InApp Provisioning
   *
   * Signature Data is mandatory for ApplePay
   *
   * This data is only available for a digital card in
   * - status: Pending
   * - type: InApp
   */
  inAppProvisioningData?: Maybe<InAppProvisioningData>;
  /** The project ID */
  projectId: Scalars["ID"]["output"];
  /**
   * Digital Card status information
   *
   * In this type the status will be either ConsentPending or Pending
   */
  statusInfo: PendingDigitalCardStatusInfo;
  /** Reference of the token in another system (ex: Mastercard) */
  tokenReferenceId?: Maybe<Scalars["String"]["output"]>;
  /** The type of digitalization that created this digital card. */
  type: DigitalizationType;
  /** Updated date */
  updatedAt: Scalars["DateTime"]["output"];
  /** Wallet Provider (ApplePay, GooglePay ...) */
  walletProvider: WalletProvider;
};

/** Pending Digital Card used for ApplePay or GooglePay */
export type PendingDigitalCardInAppProvisioningDataArgs = {
  signatureData?: InputMaybe<SignatureData>;
};

/** Pending Digital Card Status */
export type PendingDigitalCardStatus =
  /** when the digital card is waiting for the user to finish his consent */
  | "ConsentPending"
  /**
   * when the creation of a digital card is declined
   *
   * this is a final state
   */
  | "Declined"
  /** when the digital card is pending the end of the digitalization process */
  | "Pending";

/** Pending Digital Card Status Information */
export type PendingDigitalCardStatusInfo = {
  /** Status of the digital card. */
  status: PendingDigitalCardStatus;
};

/** Funding Source Pending status information */
export type PendingFundingSourceStatusInfo = FundingSourceStatusInfo & {
  __typename: "PendingFundingSourceStatusInfo";
  /** Funding Source Pending status */
  status: FundingSourceStatus;
};

/** Describes an identification level that is pending for the process of the current identification, requiring an operation not related to the end-user to progress */
export type PendingIdentificationLevelStatusInfo = {
  __typename: "PendingIdentificationLevelStatusInfo";
  /** Always set to `Pending` */
  status: SwanIdentificationStatus;
};

/** PendingMerchantPaymentMethodStatusInfo */
export type PendingMerchantPaymentMethodStatusInfo = MerchantPaymentMethodStatusInfo & {
  __typename: "PendingMerchantPaymentMethodStatusInfo";
  status: MerchantPaymentMethodStatus;
};

/** PendingReviewMerchantProfileStatusInfo */
export type PendingReviewMerchantProfileStatusInfo = MerchantProfileStatusInfo & {
  __typename: "PendingReviewMerchantProfileStatusInfo";
  status: MerchantProfileStatus;
};

/** Pending Verification Information */
export type PendingReviewStatusInfo = AccountVerificationStatusInfo & {
  __typename: "PendingReviewStatusInfo";
  /** Account verification status (PendingReview) */
  status: AccountVerificationStatus;
};

export type PendingStatusInfo = AccountStatementStatusInfo & {
  __typename: "PendingStatusInfo";
  /** status of the statement */
  status: AccountStatementStatus;
};

export type PendingTransactionStatementStatusInfo = TransactionStatementStatusInfo & {
  __typename: "PendingTransactionStatementStatusInfo";
  /** status of the transaction statement */
  status: TransactionStatementStatusEnum;
};

/** Pending transaction status information */
export type PendingTransactionStatusInfo = TransactionStatusInfo & {
  __typename: "PendingTransactionStatusInfo";
  /** unique identifier of the transaction */
  id: Scalars["ID"]["output"];
  /** The date when the pending amount of this transaction is released on the available balance of this account if not booked */
  pendingEndDate?: Maybe<Scalars["DateTime"]["output"]>;
  /** status of the transaction */
  status: TransactionStatus;
};

export type PendingVerificationRenewal = VerificationRenewal & {
  __typename: "PendingVerificationRenewal";
  accountHolderId: Scalars["String"]["output"];
  createdAt: Scalars["DateTime"]["output"];
  dueDate?: Maybe<Scalars["DateTime"]["output"]>;
  id: Scalars["ID"]["output"];
  /** Verification renewal information */
  info: VerificationRenewalInfo;
  status: VerificationRenewalStatus;
  supportTicketId?: Maybe<Scalars["String"]["output"]>;
  updatedAt: Scalars["DateTime"]["output"];
};

/** Pending Verification Information */
export type PendingVerificationStatusInfo = AccountVerificationStatusInfo & {
  __typename: "PendingVerificationStatusInfo";
  /** Account verification status (PendingVerification) */
  status: AccountVerificationStatus;
};

export type PermissionCannotBeGrantedRejection = Rejection & {
  __typename: "PermissionCannotBeGrantedRejection";
  message: Scalars["String"]["output"];
};

/** Physical Card */
export type PhysicalCard = {
  __typename: "PhysicalCard";
  /** Masked Card Number */
  cardMaskedNumber: Scalars["String"]["output"];
  /** Custom Options */
  customOptions: PhysicalCardCustomOptions;
  /** Physical Card expiration date  with MM/YY string format */
  expiryDate?: Maybe<Scalars["String"]["output"]>;
  /** Unique identifier present on physical card, such identifier is null if the status is ToActivate or Canceled. This identifier is updated when a renewed card is activated */
  identifier?: Maybe<Scalars["String"]["output"]>;
  /** Offline Spending limit defined by Swan */
  offlineSpendingLimit: Amount;
  /** every previous Physical Card information */
  previousPhysicalCards: Array<BasicPhysicalCardInfo>;
  /** Physical Card status information */
  statusInfo: PhysicalCardStatusInfo;
};

/** Physical Card Activated Status Information */
export type PhysicalCardActivatedStatusInfo = PhysicalCardStatusInfo & {
  __typename: "PhysicalCardActivatedStatusInfo";
  /** Physical Card status (always Activated for type PhysicalCardEnabledStatusInfo). */
  status: PhysicalCardStatus;
};

/** Physical Card Canceled Status Information */
export type PhysicalCardCanceledStatusInfo = PhysicalCardStatusInfo & {
  __typename: "PhysicalCardCanceledStatusInfo";
  /** Reason why the card is canceled. */
  reason: Scalars["String"]["output"];
  /** Physical Card status (always Canceled for type PhysicalCardCanceledStatusInfo). */
  status: PhysicalCardStatus;
};

/** Physical Card Canceling Status Information */
export type PhysicalCardCancelingStatusInfo = PhysicalCardStatusInfo & {
  __typename: "PhysicalCardCancelingStatusInfo";
  /** Reason why the card is canceled. */
  reason: Scalars["String"]["output"];
  /** Physical Card status (always Canceling for type PhysicalCardCancelingStatusInfo). */
  status: PhysicalCardStatus;
};

export type PhysicalCardConfigInput = {
  /** `true` if the user must choose their PIN Code */
  choosePin?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Address to deliver the physical card */
  deliveryAddress: CompleteAddressInput;
  /** Custom options to use for physical cards. */
  physicalCardCustomOptions?: InputMaybe<PhysicalCardCustomOptionsInput>;
};

/** when the user has to authorize production of the physical card */
export type PhysicalCardConsentPendingStatusInfo = PhysicalCardStatusInfo & {
  __typename: "PhysicalCardConsentPendingStatusInfo";
  /** The consent required to authorize production of the physical card */
  consent: Consent;
  /** Physical Card status (always ConsentPending for type PhysicalCardConsentPendingStatusInfo) */
  status: PhysicalCardStatus;
};

/** Custom options for physical card. */
export type PhysicalCardCustomOptions = {
  __typename: "PhysicalCardCustomOptions";
  /** Additional line embossed on the card. */
  additionalPrintedLine?: Maybe<Scalars["String"]["output"]>;
  /** Chosen shipping provider */
  chosenShippingProvider?: Maybe<Scalars["String"]["output"]>;
  /** Custom cardholder name */
  customCardHolderName?: Maybe<Scalars["String"]["output"]>;
};

export type PhysicalCardCustomOptionsForGroupDeliveryInput = {
  /**
   * Additional line to be embossed on the card.
   *
   * This field will only be taken into account for custom card design that include it. ([Learn More](https://docs.swan.io/guide/issue-cards#order-cards-with-additional-line))
   *
   * Max length allowed: 26 characters.
   * Characters allowed: alphanumeric’*’ ‘.’ ‘-’ ‘/’ apostrophe
   */
  additionalPrintedLine?: InputMaybe<Scalars["String"]["input"]>;
  /** Alternative printed card owner. */
  customCardHolderName?: InputMaybe<Scalars["String"]["input"]>;
};

export type PhysicalCardCustomOptionsForPrintInput = {
  /**
   * Additional line to be printed on the card.
   *
   * This field will only be taken into account for custom card design that include it. ([Learn More](https://docs.swan.io/guide/issue-cards#order-cards-with-additional-line))
   *
   * Max length allowed: 26 characters.
   * Characters allowed: alphanumeric’*’ ‘.’ ‘-’ ‘/’ apostrophe
   */
  additionalPrintedLine?: InputMaybe<Scalars["String"]["input"]>;
  /** Alternative printed card owner. */
  customCardHolderName?: InputMaybe<Scalars["String"]["input"]>;
  /** The shipping provider used to deliver the card */
  shippingProvider?: InputMaybe<ShippingProvider>;
};

export type PhysicalCardCustomOptionsInput = {
  /**
   * Additional line to be embossed on the card.
   *
   * This field will only be taken into account for custom card design that include it. ([Learn More](https://docs.swan.io/guide/issue-cards#order-cards-with-additional-line))
   *
   * Max length allowed: 26 characters.
   * Characters allowed: alphanumeric’*’ ‘.’ ‘-’ ‘/’ apostrophe
   */
  additionalPrintedLine?: InputMaybe<Scalars["String"]["input"]>;
  /** Alternative printed card owner. */
  customCardHolderName?: InputMaybe<Scalars["String"]["input"]>;
  /** The shipping provider used to deliver the card */
  shippingProvider?: InputMaybe<ShippingProvider>;
};

/** Rejection returned when the Physical Card does not exist */
export type PhysicalCardNotFoundRejection = Rejection & {
  __typename: "PhysicalCardNotFoundRejection";
  identifier: Scalars["String"]["output"];
  message: Scalars["String"]["output"];
};

/** when the physical card is in the process of being ready to use */
export type PhysicalCardProcessingStatusInfo = PhysicalCardStatusInfo & {
  __typename: "PhysicalCardProcessingStatusInfo";
  /** Physical card status (always Processing for type PhysicalCardProcessingStatusInfo) */
  status: PhysicalCardStatus;
};

/** Physical Card Renewed Status Information */
export type PhysicalCardRenewedStatusInfo = PhysicalCardStatusInfo & {
  __typename: "PhysicalCardRenewedStatusInfo";
  /** address to deliver the physical card */
  address: Address;
  /** Estimated delivery date */
  estimatedDeliveryDate?: Maybe<Scalars["DateTime"]["output"]>;
  /** `true` if PIN Code is available. */
  isPINReady: Scalars["Boolean"]["output"];
  /** New physical Card info */
  newPhysicalCard: BasicPhysicalCardInfo;
  /** Name of the shipping provider */
  shippingProvider?: Maybe<ShippingProvider>;
  /** Physical Card status (always Renewed for type PhysicalCardRenewedStatusInfo). */
  status: PhysicalCardStatus;
  /** Shipping tracking number */
  trackingNumber?: Maybe<Scalars["String"]["output"]>;
};

/** Physical Card Status */
export type PhysicalCardStatus =
  /** Physical card is activated and can be used */
  | "Activated"
  /** Physical card is canceled, can’t be used, and can’t be restored */
  | "Canceled"
  /** Physical card is in the process of being canceled; card can’t be used or restored */
  | "Canceling"
  /** Consent to authorize physical card production is pending */
  | "ConsentPending"
  /** Physical card is in processing and can’t be used yet */
  | "Processing"
  /** Physical card is renewed but hasn’t made a transaction since renewal */
  | "Renewed"
  /** Physical card is suspended and can’t be used */
  | "Suspended"
  /** Physical card needs to be activated by cardholder */
  | "ToActivate"
  /** Physical card is in the process of being renewed */
  | "ToRenew";

/** Physical Card Status Information */
export type PhysicalCardStatusInfo = {
  /** Status of the physical card. */
  status: PhysicalCardStatus;
};

/** Physical Card Suspended Status Information */
export type PhysicalCardSuspendedStatusInfo = PhysicalCardStatusInfo & {
  __typename: "PhysicalCardSuspendedStatusInfo";
  /** Reason why the card is suspended. */
  reason: Scalars["String"]["output"];
  /** Physical Card status (always Suspended for type PhysicalCardSuspendedStatusInfo). */
  status: PhysicalCardStatus;
};

/** Physical Card To Activate Status Information */
export type PhysicalCardToActivateStatusInfo = PhysicalCardStatusInfo & {
  __typename: "PhysicalCardToActivateStatusInfo";
  /** address to deliver the physical card */
  address: Address;
  /** Estimated delivery date */
  estimatedDeliveryDate?: Maybe<Scalars["DateTime"]["output"]>;
  /** `true` if PIN Code is available. */
  isPINReady: Scalars["Boolean"]["output"];
  /** Name of the shipping provider */
  shippingProvider?: Maybe<ShippingProvider>;
  /** Physical Card status (always ToActivate for type PhysicalCardToActivateStatusInfo). */
  status: PhysicalCardStatus;
  /** Shipping tracking number */
  trackingNumber?: Maybe<Scalars["String"]["output"]>;
};

/** when the physical card is in the process of being renewed */
export type PhysicalCardToRenewStatusInfo = PhysicalCardStatusInfo & {
  __typename: "PhysicalCardToRenewStatusInfo";
  /** registered address to deliver the new physical card */
  address: Address;
  /** Physical card status (always ToRenew for type PhysicalCardToRenewStatusInfo) */
  status: PhysicalCardStatus;
};

/** Rejection returned when the Physical Card is not the expected status */
export type PhysicalCardWrongStatusRejection = Rejection & {
  __typename: "PhysicalCardWrongStatusRejection";
  currentStatus: PhysicalCardStatus;
  expectedStatus: PhysicalCardStatus;
  identifier: Scalars["String"]["output"];
  message: Scalars["String"]["output"];
};

export type PlanningSetting = {
  __typename: "PlanningSetting";
  timeUnit: PlanningTimeUnit;
  timeValue: Scalars["Int"]["output"];
};

export type PlanningTimeUnit = "days" | "hours" | "minutes";

export type PreProvisioningSuvCardSettings = {
  __typename: "PreProvisioningSUVCardSettings";
  ownerProvisioningSUVCards?: Maybe<Scalars["ID"]["output"]>;
  preProvisioningSUVCards: Scalars["Boolean"]["output"];
  preProvisioningSUVCardsAvailablePercentage: Scalars["Float"]["output"];
  preProvisioningSUVNumberOfCards: Scalars["Int"]["output"];
};

export type PreferredNotificationChannel =
  /** Use In-App notification */
  | "App"
  /** Use Swan SMS */
  | "Sms";

/** Inputs to print a physical card */
export type PrintPhysicalCardInput = {
  /** Address to deliver the physical card */
  address: CompleteAddressInput;
  /** Unique identifier of a card */
  cardId: Scalars["ID"]["input"];
  /** `true` if the user must choose their PIN */
  choosePin?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** URL the user is redirected to after consent has been given */
  consentRedirectUrl: Scalars["String"]["input"];
  /** Custom options to use for physical cards. */
  physicalCardCustomOptions?: InputMaybe<PhysicalCardCustomOptionsForPrintInput>;
};

export type PrintPhysicalCardPayload =
  | AccountMembershipNotAllowedRejection
  | AlreadyValidPhysicalCardRejection
  | BadAccountStatusRejection
  | BadRequestRejection
  | CardNotFoundRejection
  | CardProductDisabledRejection
  | CardProductNotApplicableToPhysicalCardsRejection
  | InvalidShippingProviderRejection
  | MissingMandatoryFieldRejection
  | PrintPhysicalCardSuccessPayload
  | ValidationRejection;

export type PrintPhysicalCardSuccessPayload = {
  __typename: "PrintPhysicalCardSuccessPayload";
  /** The physicalCard created */
  physicalCard: PhysicalCard;
};

/** Values to provide for probing a callback endpoint */
export type ProbeWebhookEndpointInput = {
  /**
   * The endpoint URL the test event will be sent to
   * (max 255 characters)
   */
  endpoint: Scalars["String"]["input"];
  /** A shared secret as proof of identity */
  secret?: InputMaybe<Scalars["String"]["input"]>;
};

export type ProbeWebhookEndpointPayload =
  | InternalErrorRejection
  | InvalidArgumentRejection
  | ProbeWebhookEndpointSuccessPayload;

export type ProbeWebhookEndpointSuccessPayload = {
  __typename: "ProbeWebhookEndpointSuccessPayload";
  eventId: Scalars["ID"]["output"];
  responseStatus?: Maybe<Scalars["Int"]["output"]>;
};

/** Type of product sold. Gifts and donations can be club subscription or collection of donations (for associations), tips collection, contributions for local authorities */
export type ProductType = "GiftsAndDonations" | "Goods" | "Services" | "VirtualGoods";

/** Thrown when a plan already has a subscription */
export type ProjectAlreadyHasSubscriptionRejection = Rejection & {
  __typename: "ProjectAlreadyHasSubscriptionRejection";
  message: Scalars["String"]["output"];
};

export type ProjectCardDesigns = {
  __typename: "ProjectCardDesigns";
  /** Project card product designs */
  cardDesigns: Array<CardProductDesign>;
  /** Unique identifier of a project */
  id: Scalars["ID"]["output"];
  /** Visual Id from the issuing card processor (Monext) */
  issuingProcessorVisualId?: Maybe<Scalars["String"]["output"]>;
  /** Project name */
  name?: Maybe<Scalars["String"]["output"]>;
  /** Project's pre provisioning suv card settings */
  preProvisioningSUVCardSettings?: Maybe<PreProvisioningSuvCardSettings>;
  /** Specific card product for companies */
  specificCardProductCodeForCompanies?: Maybe<Scalars["String"]["output"]>;
};

export type ProjectCardSettings = {
  __typename: "ProjectCardSettings";
  /** Project's card settings */
  cardSettings: Array<CardSettings>;
  /** Unique identifier of a project */
  id: Scalars["ID"]["output"];
  /** Visual Id from the issuing card processor (Monext) */
  issuingProcessorVisualId?: Maybe<Scalars["String"]["output"]>;
  /** Project name */
  name?: Maybe<Scalars["String"]["output"]>;
  /** Project's pre provisioning suv card settings */
  preProvisioningSUVCardSettings?: Maybe<PreProvisioningSuvCardSettings>;
  /** Specific card product for companies */
  specificCardProductCodeForCompanies?: Maybe<Scalars["String"]["output"]>;
};

/** Project Card Settings Background Type */
export type ProjectCardSettingsBackgroundType =
  /** when Card setting background is black */
  | "Black"
  /** when Card setting background is customized */
  | "Custom"
  /** when Card setting background is light */
  | "Silver";

/** Card Status */
export type ProjectCardStatus =
  /** when project's card settings are Disabled */
  | "Disabled"
  /** when project's card settings are Enabled */
  | "Enabled"
  /** when project's card settings are Initiated */
  | "Initiated"
  /** when project's card settings are Rejected */
  | "Rejected"
  /** when project's card settings are Suspended */
  | "Suspended"
  /** when project's card settings are ToReview */
  | "ToReview";

export type ProjectForbiddenRejection = Rejection & {
  __typename: "ProjectForbiddenRejection";
  message: Scalars["String"]["output"];
};

/** Rejection returned when the Project Funding has been exceeded */
export type ProjectFundingLimitExceededRejection = Rejection & {
  __typename: "ProjectFundingLimitExceededRejection";
  message: Scalars["String"]["output"];
};

/** Public information of a `Project` */
export type ProjectInfo = {
  __typename: "ProjectInfo";
  B2BMembershipIDVerification?: Maybe<Scalars["Boolean"]["output"]>;
  /** Your accent color, used in white label interfaces. Most of the time for call to actions */
  accentColor?: Maybe<Scalars["String"]["output"]>;
  /**
   * the currently active card settings
   * @deprecated Use cardProduct.cardDesigns instead
   */
  activeCardSettings?: Maybe<CardSettings>;
  /** Flag that determines if desktop authentication is enabled for this project */
  allowsDesktopAuthentication: Scalars["Boolean"]["output"];
  /** The card products associated with this project. */
  cardProducts?: Maybe<Array<CardProduct>>;
  /** Your custom subdomain used in consents */
  customConsentSubdomain?: Maybe<Scalars["String"]["output"]>;
  expectedMerchantProfileAdditionalInformation: Array<AdditionalInformationType>;
  /** Unique identifier of the project */
  id: Scalars["ID"]["output"];
  /** URL of your logo */
  logoUri?: Maybe<Scalars["String"]["output"]>;
  multipleAccountsSettings: MultipleAccountsSettings;
  /** Your project name displayed in white label interfaces and in the terms and conditions */
  name: Scalars["String"]["output"];
  /** Your OAuth client id */
  oAuthClientId?: Maybe<Scalars["String"]["output"]>;
  /** The related project settings */
  projectSettingsId: Scalars["ID"]["output"];
  requireSupportingDocumentsDuringOnboarding?: Maybe<Scalars["Boolean"]["output"]>;
  requireUbosDuringOnboarding?: Maybe<Scalars["Boolean"]["output"]>;
  /** Project status */
  status: ProjectStatus;
  supportingDocumentSettings?: Maybe<SupportingDocumentSettings>;
  /** Unique id of your current Terms and Conditions of Use */
  tcuDocumentId: Scalars["String"]["output"];
  /** URL to your Terms and Conditions of Use document depending on the provided language */
  tcuDocumentUri: Scalars["String"]["output"];
  /** The type of your project */
  type: ProjectType;
  /** Web banking settings */
  webBankingSettings?: Maybe<WebBankingSettings>;
};

/** Public information of a `Project` */
export type ProjectInfoTcuDocumentUriArgs = {
  language: Scalars["String"]["input"];
};

/** Rejection returned when the Project Instant Funding limit has been exceeded */
export type ProjectInstantFundingLimitExceededRejection = Rejection & {
  __typename: "ProjectInstantFundingLimitExceededRejection";
  message: Scalars["String"]["output"];
};

export type ProjectInvalidStatusRejection = Rejection & {
  __typename: "ProjectInvalidStatusRejection";
  message: Scalars["String"]["output"];
};

export type ProjectNotFound = Rejection & {
  __typename: "ProjectNotFound";
  message: Scalars["String"]["output"];
};

/** Rejection returned when the project is not found */
export type ProjectNotFoundRejection = Rejection & {
  __typename: "ProjectNotFoundRejection";
  message: Scalars["String"]["output"];
};

/** Rejection returned when the project settings of a project are not found */
export type ProjectSettingsByProjectIdNotFoundRejection = Rejection & {
  __typename: "ProjectSettingsByProjectIdNotFoundRejection";
  message: Scalars["String"]["output"];
};

export type ProjectSettingsForbiddenError = Rejection & {
  __typename: "ProjectSettingsForbiddenError";
  message: Scalars["String"]["output"];
};

export type ProjectSettingsNotFound = Rejection & {
  __typename: "ProjectSettingsNotFound";
  message: Scalars["String"]["output"];
};

export type ProjectSettingsNotFoundRejection = Rejection & {
  __typename: "ProjectSettingsNotFoundRejection";
  message: Scalars["String"]["output"];
};

export type ProjectSettingsStatusNotReachable = Rejection & {
  __typename: "ProjectSettingsStatusNotReachable";
  message: Scalars["String"]["output"];
};

export type ProjectStatus =
  | "BetaLiveAccess"
  | "Disabled"
  | "Enabled"
  | "FullLiveAccess"
  | "Initiated"
  | "LimitedLiveAccess"
  | "MeetingScheduled"
  | "PendingCompliance"
  | "PendingLiveReview"
  | "Rejected"
  | "Suspended"
  | "ToReview";

export type ProjectType =
  | "COMPANY"
  | "COMPANY_AND_CUSTOMERS"
  | "Company"
  | "CompanyAndCustomers"
  | "INDIVIDUAL"
  | "Individual";

/** Result payload for public account holder onboarding query */
export type PublicAccountHolderOnboardingPayload =
  | ForbiddenRejection
  | InternalErrorRejection
  | OnboardingAlreadyFinalizedRejection
  | OnboardingNotFoundRejection
  | PublicAccountHolderOnboardingSuccessPayload
  | PublicOnboardingDisabledRejection;

/** Success response with account holder onboarding information */
export type PublicAccountHolderOnboardingSuccessPayload = {
  __typename: "PublicAccountHolderOnboardingSuccessPayload";
  onboarding: AccountHolderOnboarding;
};

/** Input for fetching company registry data */
export type PublicCompanyInfoRegistryDataInput = {
  /** Registration number of the company (e.g., SIREN for France) */
  registrationNumber: Scalars["String"]["input"];
  /** Residency address country code (ISO 3166-1 alpha-3) */
  residencyAddressCountry: RegistryCountry;
};

/** Result payload for company info registry data query */
export type PublicCompanyInfoRegistryDataPayload =
  | CompanyRegistryNotFoundRejection
  | CompanyRegistryUnavailableRejection
  | ForbiddenRejection
  | InternalErrorRejection
  | PublicCompanyInfoRegistryDataSuccessPayload
  | ValidationRejection;

/** Success response with comprehensive company information */
export type PublicCompanyInfoRegistryDataSuccessPayload = {
  __typename: "PublicCompanyInfoRegistryDataSuccessPayload";
  companyInfo: CompanyInfo;
};

/** Input for public individual account holder onboarding */
export type PublicIndividualAccountHolderOnboardingAccountAdminInput = {
  address?: InputMaybe<ResidencyAddressInput>;
  birthInfo?: InputMaybe<BirthInfoInput>;
  email?: InputMaybe<Scalars["String"]["input"]>;
  employmentStatus?: InputMaybe<EmploymentStatus>;
  firstName?: InputMaybe<Scalars["String"]["input"]>;
  lastName?: InputMaybe<Scalars["String"]["input"]>;
  monthlyIncome?: InputMaybe<MonthlyIncome>;
  nationality?: InputMaybe<Scalars["CCA3"]["input"]>;
  preferredLanguage?: InputMaybe<AccountLanguage>;
  sourcesOfFunds?: InputMaybe<Array<IndividualAccountSourceOfFunds>>;
  taxIdentificationNumber?: InputMaybe<Scalars["String"]["input"]>;
  unitedStatesTaxInfo?: InputMaybe<UnitedStatesTaxInfoInput>;
};

/** Input for public individual account holder onboarding */
export type PublicIndividualAccountHolderOnboardingAccountInput = {
  country: AccountCountry;
  intendedUsages?: InputMaybe<Array<IndividualAccountIntendedUsage>>;
  name?: InputMaybe<Scalars["String"]["input"]>;
};

/** Rejection returned when the public onboarding is disabled */
export type PublicOnboardingDisabledRejection = Rejection & {
  __typename: "PublicOnboardingDisabledRejection";
  message: Scalars["String"]["output"];
};

export type Query = {
  __typename: "Query";
  /** Returns an account from its id. */
  account?: Maybe<Account>;
  /** Returns an account holder from its id. */
  accountHolder?: Maybe<AccountHolder>;
  /**
   * Returns an account holder onboarding from its id.
   *
   * *This query is restricted to a Project access token ([Learn More](https://docs.swan.io/developers/using-api/authentication))*
   *
   * @comingSoon -> this query is not available yet, and its shape is subject to breaking change
   */
  accountHolderOnboarding: AccountHolderOnboardingPayload;
  /**
   * Returns the list of account holder onboardings.
   *
   * Implements the Relay Connection interface, used to paginate lists of elements. ([Learn More](https://docs.swan.io/developers/using-api/pagination))
   *
   * *This query is restricted to a Project access token ([Learn More](https://docs.swan.io/developers/using-api/authentication))*
   */
  accountHolderOnboardings: AccountHolderOnboardingConnection;
  /**
   * Returns the list of account holders.
   *
   * Implements the Relay Connection interface, used to paginate lists of elements. ([(Learn More)](https://docs.swan.io/developers/using-api/pagination/))
   *
   * - For a **Project access token**, returns all account holders of the project.
   * - For a **User access token**, returns account holders of accounts where the user has membership.
   */
  accountHolders: AccountHolderConnection;
  accountInvoice?: Maybe<Invoice>;
  /** Returns an account membership from its id. */
  accountMembership?: Maybe<AccountMembership>;
  /**
   * The list of account memberships
   *
   * Implements the Relay Connection interface, used to paginate lists of elements. ([Learn More](https://docs.swan.io/developers/using-api/pagination))
   */
  accountMemberships: AccountMembershipConnection;
  /** Returns an account statement by id */
  accountStatement: Statement;
  /**
   * Returns the list of accounts.
   *
   * Implements the Relay Connection interface, used to paginate lists of elements. ([Learn More](https://docs.swan.io/developers/using-api/pagination))
   *
   * *For a Project access token, this is all the accounts of the project and for an User access token, these are the accounts of which the user has an account membership.*
   */
  accounts: AccountConnection;
  /** Return the capital deposit case for the provided id. */
  capitalDepositCase?: Maybe<CapitalDepositCase>;
  /**
   * Returns the list of capital deposit cases.
   *
   * Implements the Relay Connection interface, used to paginate list of element ([Learn More](https://docs.swan.io/api/pagination))
   *
   * *This query is restricted to a Project access token ([Learn More](https://docs.swan.io/api/authentication))*
   */
  capitalDepositCases: CapitalDepositCaseConnection;
  /** Return the CapitalDepositDocument for the provided id. */
  capitalDepositDocument?: Maybe<CapitalDepositDocument>;
  /** Returns a card from its id. */
  card?: Maybe<Card>;
  /**
   * Returns the list of cards.
   *
   * Implements the Relay Connection interface, used to paginate lists of elements. ([Learn More](https://docs.swan.io/developers/using-api/pagination))
   *
   * *For a Project access token, this is all the cards of the project and for an User access token, these are the cards owned by the user whom have an account membership.*
   */
  cards: CardConnection;
  /**
   * Fetch comprehensive company registry data by registration number and optional country.
   * Returns detailed company information including representatives and beneficial owners.
   * @comingSoon -> this query is not available yet, and its shape is subject to breaking change
   */
  companyInfoRegistryData: CompanyInfoRegistryDataPayload;
  /** Returns a consent by its id. */
  consent: Consent;
  /**
   * Return the list of consents
   *
   * For a User access token : return the list of consents for the signed-in user
   * For a Project access token : return the list of consents for the project. This list can be filtered by userId
   *
   * *([Learn more on authentication](https://docs.swan.io/api/authentication))*
   */
  consents: ConsentConnection;
  /** Returns an credit statement by id */
  creditStatement: CreditStatementPayload;
  exports: ExportConnection;
  /** Returns a request for funding limit settings change from its id. */
  fundingLimitSettingsChangeRequest?: Maybe<FundingLimitSettingsChangeRequest>;
  /** Returns funding source by id. */
  fundingSource?: Maybe<FundingSource>;
  /** Allows to check iban validation. It also returns its bank and reachability information */
  ibanValidation?: Maybe<IbanValidationResult>;
  /** Returns an international beneficiary dynamic forms. */
  internationalBeneficiaryDynamicForms?: Maybe<InternationalBeneficiaryDynamicForms>;
  /** Request an international credit transfer quote. */
  internationalCreditTransferQuote?: Maybe<InternationalCreditTransferQuote>;
  /** Returns an international credit transfer dynamic form. */
  internationalCreditTransferTransactionDetailsDynamicForm?: Maybe<InternationalCreditTransferDynamicForm>;
  /** Return a merchant payment by id */
  merchantPayment?: Maybe<MerchantPayment>;
  /** Return a merchant payment link by id */
  merchantPaymentLink?: Maybe<MerchantPaymentLink>;
  /** Returns a merchant payment method by id. */
  merchantPaymentMethod?: Maybe<MerchantPaymentMethod>;
  /** Returns a merchant payment method update request by id. */
  merchantPaymentMethodUpdateRequest?: Maybe<MerchantPaymentMethodUpdateRequest>;
  /**
   * Returns a list of merchant payments
   *
   * Implements the Relay Connection interface, used to paginate list of element ([Learn More](https://docs.swan.io/api/pagination))
   */
  merchantPayments?: Maybe<MerchantPaymentConnection>;
  /** Returns a merchant profile by id. */
  merchantProfile?: Maybe<MerchantProfile>;
  /** Returns a merchant profile update request by id. */
  merchantProfileUpdateRequest?: Maybe<RequestMerchantProfileUpdate>;
  /** Returns merchant profiles. */
  merchantProfiles: MerchantProfileConnection;
  /** Get notification reminder planning for notifications with reminders */
  notificationReminderPlannings?: Maybe<NotificationReminderPlannings>;
  /**
   * Returns an onboarding from its id.
   *
   * *This query is restricted to a Project access token ([Learn More](https://docs.swan.io/developers/using-api/authentication))*
   */
  onboarding: Onboarding;
  /**
   * Returns the list of onboardings.
   *
   * Implements the Relay Connection interface, used to paginate lists of elements. ([Learn More](https://docs.swan.io/developers/using-api/pagination))
   *
   * *This query is restricted to data export or to a Project access token ([Learn More](https://docs.swan.io/developers/using-api/authentication))*
   */
  onboardings: OnboardingConnection;
  /** Returns a payment from its id. */
  payment: Payment;
  /** Returns a payment mandate from its id. */
  paymentMandate?: Maybe<PaymentMandate>;
  /**
   * List of payments.
   *
   * Implements the Relay Connection interface, used to paginate lists of elements. ([Learn More](https://docs.swan.io/developers/using-api/pagination))
   * *For a Project access token, this is all the payments of the project and for an User access token, these are the payments initiated by the user*
   */
  payments: PaymentConnection;
  /** Returns the project infos you set in the dashboard. */
  projectInfo: ProjectInfo;
  /**
   * Returns an account holder onboarding from its id without authentication.
   * This query can be used in unauthenticated contexts to fetch onboarding information.
   *
   * @comingSoon -> this query is not available yet, and its shape is subject to breaking change
   */
  publicAccountHolderOnboarding: PublicAccountHolderOnboardingPayload;
  /**
   * Fetch comprehensive company registry data by registration number and optional country.
   * Returns detailed company information including representatives and beneficial owners.
   * @comingSoon -> this query is not available yet, and its shape is subject to breaking change
   */
  publicCompanyInfoRegistryData: PublicCompanyInfoRegistryDataPayload;
  /** Returns a received direct debit mandate from its id. */
  receivedDirectDebitMandate?: Maybe<ReceivedDirectDebitMandate>;
  /** Return the Shareholder for the provided id. */
  shareholder?: Maybe<Shareholder>;
  /** Returns standing order from its id. */
  standingOrder?: Maybe<StandingOrder>;
  /** Returns a supporting document collection from its id. */
  supportingDocumentCollection?: Maybe<SupportingDocumentCollection>;
  /**
   * Returns the list of supporting document collections.
   *
   * Implements the Relay Connection interface, used to paginate lists of elements. ([Learn More](https://docs.swan.io/developers/using-api/pagination))
   */
  supportingDocumentCollections: SupportingDocumentCollectionConnection;
  /**
   * Returns a transaction from its id.
   *
   * *This query is restricted to a Project access token ([Learn More](https://docs.swan.io/developers/using-api/authentication))*
   */
  transaction: Transaction;
  /** Returns a transaction statement in PDF for the provided Id */
  transactionStatement: TransactionStatement;
  /**
   * List of transactions of a project.
   *
   * Implements the Relay Connection interface, used to paginate lists of elements. ([Learn More](https://docs.swan.io/developers/using-api/pagination))
   * *For a Project access token, this is all the transactions of the project (only available with project access token)*
   */
  transactions: TransactionConnection;
  /** Returns a trusted beneficiary from its ID. */
  trustedBeneficiary?: Maybe<TrustedBeneficiary>;
  /**
   * Returns a User
   *
   * For a Project access token : it requires a user id and returns the user for the given id
   * For a User access token : returns the signed-in user and all of their data at Swan
   *
   * *([Learn more on authentication](https://docs.swan.io/api/authentication))*
   */
  user?: Maybe<User>;
  /**
   * Returns the list of user that joined the project
   * The search field allows to search in : id, phonNumber, firstName, allFirstNames, lastName
   *
   * *This query is restricted to a Project access token ([Learn More](https://docs.swan.io/api/authentication))*
   */
  users: UserConnection;
  /** Internal Beta - do not use */
  verificationRenewal?: Maybe<VerificationRenewal>;
  /** A single webhook eventLog, queried by its id */
  webhookEventLog?: Maybe<WebhookEventLog>;
  /**
   * Get all webhook event logs.
   *
   * implements forward paging (Relay)
   */
  webhookEventLogs?: Maybe<WebhookEventLogsConnection>;
  /**
   * The list of supported event types
   * Event types are just IDs (i.e. "account.created")
   */
  webhookEventTypes: Array<Scalars["String"]["output"]>;
  /** A webhook subscription, queried by its id */
  webhookSubscription?: Maybe<WebhookSubscription>;
  /**
   * Get all webhook subscriptions
   *
   * implements forward paging (Relay)
   */
  webhookSubscriptions: WebhookSubscriptionsConnection;
};

export type QueryAccountArgs = {
  accountId: Scalars["ID"]["input"];
};

export type QueryAccountHolderArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryAccountHolderOnboardingArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryAccountHolderOnboardingsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  filters?: InputMaybe<OnboardingFiltersInput>;
  first?: Scalars["Int"]["input"];
  orderBy?: InputMaybe<OnboardingOrderByInput>;
};

export type QueryAccountHoldersArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  filters?: InputMaybe<AccountHolderFilterInput>;
  first?: Scalars["Int"]["input"];
  orderBy?: InputMaybe<AccountHolderOrderByInput>;
};

export type QueryAccountInvoiceArgs = {
  invoiceId: Scalars["ID"]["input"];
};

export type QueryAccountMembershipArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryAccountMembershipsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  filters?: InputMaybe<AccountMembershipsFilterInput>;
  first?: Scalars["Int"]["input"];
  orderBy?: InputMaybe<AccountMembershipOrderByInput>;
};

export type QueryAccountStatementArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryAccountsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  filters?: InputMaybe<AccountFilterInput>;
  first?: Scalars["Int"]["input"];
  orderBy?: InputMaybe<AccountOrderByInput>;
};

export type QueryCapitalDepositCaseArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryCapitalDepositCasesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  filters?: InputMaybe<CapitalDepositCaseFiltersInput>;
  first?: Scalars["Int"]["input"];
  orderBy?: InputMaybe<CapitalDepositCaseOrderByInput>;
};

export type QueryCapitalDepositDocumentArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryCardArgs = {
  cardId: Scalars["ID"]["input"];
};

export type QueryCardsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  filters?: InputMaybe<CardFiltersInput>;
  first?: Scalars["Int"]["input"];
  orderBy?: InputMaybe<CardOrderByInput>;
};

export type QueryCompanyInfoRegistryDataArgs = {
  input: CompanyInfoRegistryDataInput;
};

export type QueryConsentArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryConsentsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  filters?: InputMaybe<ConsentsFiltersInput>;
  first?: Scalars["Int"]["input"];
};

export type QueryCreditStatementArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryExportsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  filters?: InputMaybe<ExportFilterInput>;
  first?: Scalars["Int"]["input"];
};

export type QueryFundingLimitSettingsChangeRequestArgs = {
  fundingLimitSettingsChangeRequestId: Scalars["ID"]["input"];
};

export type QueryFundingSourceArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryIbanValidationArgs = {
  input?: InputMaybe<IbanValidationInput>;
};

export type QueryInternationalBeneficiaryDynamicFormsArgs = {
  amount: AmountInput;
  dynamicFields?: InputMaybe<Array<InternationalBeneficiaryDetailsInput>>;
  language?: InputMaybe<InternationalCreditTransferDisplayLanguage>;
};

export type QueryInternationalCreditTransferQuoteArgs = {
  accountId: Scalars["ID"]["input"];
  language?: InputMaybe<InternationalCreditTransferDisplayLanguage>;
  route?: InputMaybe<InternationalCreditTransferRouteInput>;
  targetAmount: AmountInput;
};

export type QueryInternationalCreditTransferTransactionDetailsDynamicFormArgs = {
  internationalBeneficiary: InternationalBeneficiaryInput;
  language?: InputMaybe<InternationalCreditTransferDisplayLanguage>;
  refreshableFields?: InputMaybe<Array<InternationalCreditTransferDetailsInput>>;
  targetAmount: AmountInput;
};

export type QueryMerchantPaymentArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryMerchantPaymentLinkArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryMerchantPaymentMethodArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryMerchantPaymentMethodUpdateRequestArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryMerchantPaymentsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  filters?: InputMaybe<MerchantPaymentFiltersInput>;
  first?: Scalars["Int"]["input"];
  orderBy?: InputMaybe<MerchantPaymentOrderByInput>;
};

export type QueryMerchantProfileArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryMerchantProfileUpdateRequestArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryMerchantProfilesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  filters?: InputMaybe<MerchantProfileFiltersInput>;
  first?: Scalars["Int"]["input"];
  orderBy?: InputMaybe<MerchantProfileOrderByInput>;
};

export type QueryOnboardingArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryOnboardingsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  filters?: InputMaybe<OnboardingFiltersInput>;
  first?: Scalars["Int"]["input"];
  orderBy?: InputMaybe<OnboardingOrderByInput>;
};

export type QueryPaymentArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryPaymentMandateArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryPaymentsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  filters?: InputMaybe<PaymentFiltersInput>;
  first?: Scalars["Int"]["input"];
  orderBy?: InputMaybe<PaymentOrderByInput>;
};

export type QueryPublicAccountHolderOnboardingArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryPublicCompanyInfoRegistryDataArgs = {
  input: PublicCompanyInfoRegistryDataInput;
};

export type QueryReceivedDirectDebitMandateArgs = {
  receivedDirectDebitMandateId: Scalars["ID"]["input"];
};

export type QueryShareholderArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryStandingOrderArgs = {
  standingOrderId: Scalars["ID"]["input"];
};

export type QuerySupportingDocumentCollectionArgs = {
  id: Scalars["ID"]["input"];
};

export type QuerySupportingDocumentCollectionsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  filters?: InputMaybe<SupportingDocumentCollectionFilterInput>;
  first?: Scalars["Int"]["input"];
  orderBy?: InputMaybe<SupportingDocumentCollectionOrderByInput>;
};

export type QueryTransactionArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryTransactionStatementArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryTransactionsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  filters?: InputMaybe<TransactionsFiltersInput>;
  first?: Scalars["Int"]["input"];
  orderBy?: InputMaybe<TransactionsOrderByInput>;
};

export type QueryTrustedBeneficiaryArgs = {
  id: Scalars["String"]["input"];
};

export type QueryUserArgs = {
  id?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryUsersArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  filters?: InputMaybe<UserFilterInput>;
  first?: Scalars["Int"]["input"];
  search?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryVerificationRenewalArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryWebhookEventLogArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryWebhookEventLogsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  filters?: InputMaybe<WebhookEventLogFiltersInput>;
  first?: Scalars["Int"]["input"];
};

export type QueryWebhookSubscriptionArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryWebhookSubscriptionsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  first?: Scalars["Int"]["input"];
};

export type RadioField = Field & {
  __typename: "RadioField";
  allowedValues: Array<AllowedValue>;
  key: Scalars["String"]["output"];
  name: Scalars["String"]["output"];
  refreshDynamicFieldsOnChange: Scalars["Boolean"]["output"];
  required: Scalars["Boolean"]["output"];
};

/** Information that can be used to determine where the iban can be used */
export type Reachability = {
  __typename: "Reachability";
  /** Can be used for transfer over SEPA (can be used in initiateCreditTransfer mutation) */
  sepaCreditTransfer: Scalars["Boolean"]["output"];
  /** Can be used for instant transfer over SEPA */
  sepaCreditTransferInst: Scalars["Boolean"]["output"];
  /** Can be used for B2B direct debit over SEPA */
  sepaDirectDebitB2b: Scalars["Boolean"]["output"];
  /** Can be used for direct debit over SEPA */
  sepaDirectDebitCore: Scalars["Boolean"]["output"];
};

/** Define a reason with a message */
export type Reason = {
  message?: Maybe<Scalars["String"]["output"]>;
};

/** Input version */
export type ReasonInput = {
  message?: InputMaybe<Scalars["String"]["input"]>;
};

/** Interface for Received Direct Debit Mandate */
export type ReceivedDirectDebitMandate = {
  /** Creation date of the received direct debit mandate */
  createdAt: Scalars["DateTime"]["output"];
  /** Date of the last direct debit transaction executed for the concerned received direct debit mandate */
  executedAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** Expiry date of the received direct debit mandate */
  expiredAt?: Maybe<Scalars["Date"]["output"]>;
  /** Unique identifier of the Payment Mandate */
  id: Scalars["ID"]["output"];
  /** Mandate name */
  name?: Maybe<Scalars["String"]["output"]>;
  /** Date of signature of the received direct debit mandate */
  signatureDate?: Maybe<Scalars["Date"]["output"]>;
  /** Mandate status information of the received direct debit mandate */
  statusInfo: ReceivedDirectDebitMandateStatusInfo;
  /** Last Update date of the received direct debit mandate */
  updatedAt: Scalars["DateTime"]["output"];
  /** Version of the received direct debit mandate */
  version: Scalars["String"]["output"];
};

/** Rejection returned if the received direct debit mandate already exist */
export type ReceivedDirectDebitMandateAlreadyExistRejection = Rejection & {
  __typename: "ReceivedDirectDebitMandateAlreadyExistRejection";
  id: Scalars["String"]["output"];
  message: Scalars["String"]["output"];
};

/** Received direct debit mandate is canceled and therefore can't be enabled/suspended or updated */
export type ReceivedDirectDebitMandateCanceledRejection = Rejection & {
  __typename: "ReceivedDirectDebitMandateCanceledRejection";
  id: Scalars["String"]["output"];
  message: Scalars["String"]["output"];
};

/** Implements the Relay Connection interface, used to paginate list of element ([Learn More](https://docs.swan.io/api/pagination)) */
export type ReceivedDirectDebitMandateConnection = Connection & {
  __typename: "ReceivedDirectDebitMandateConnection";
  /** ReceivedDirectDebitMandateEdge list */
  edges: Array<ReceivedDirectDebitMandateEdge>;
  /** Information about the current, the previous and the next page */
  pageInfo: PageInfo;
  /** Total number of elements in the list */
  totalCount: Scalars["Int"]["output"];
};

/** Implements the Relay Edge interface */
export type ReceivedDirectDebitMandateEdge = Edge & {
  __typename: "ReceivedDirectDebitMandateEdge";
  /** Opaque identifier pointing to this onboarding node in the pagination mechanism */
  cursor: Scalars["String"]["output"];
  /** The received direct debit mandate */
  node: ReceivedDirectDebitMandate;
};

/** Rejection returned if the received direct debit mandate is not a B2b mandate */
export type ReceivedDirectDebitMandateNotB2bRejection = Rejection & {
  __typename: "ReceivedDirectDebitMandateNotB2bRejection";
  id: Scalars["String"]["output"];
  message: Scalars["String"]["output"];
};

/**
 * Error returned if the received direct debit mandate was not found or if the user does not have the rights to receive information abo
 * ut the existence of the received direct debit mandate
 */
export type ReceivedDirectDebitMandateNotFoundRejection = Rejection & {
  __typename: "ReceivedDirectDebitMandateNotFoundRejection";
  id: Scalars["String"]["output"];
  message: Scalars["String"]["output"];
};

/** Received Direct Debit Mandate Scheme */
export type ReceivedDirectDebitMandateScheme =
  /** When the received direct debit mandate can only be used for SEPA B2B direct debit transactions */
  | "SepaDirectDebitB2b"
  /** When the received direct debit mandate can only be used for SEPA Core direct debit transactions */
  | "SepaDirectDebitCore";

/** Received Direct Debit Mandate Statuses */
export type ReceivedDirectDebitMandateStatus =
  /** When the received direct debit mandate is canceled */
  | "Canceled"
  /** When the received direct debit mandate requires the initiation of a consent process */
  | "ConsentInitiationPending"
  /** When the received direct debit mandate is pending consent completion */
  | "ConsentPending"
  /** When the received direct debit mandate is enabled */
  | "Enabled"
  /** When the received direct debit mandate is suspended */
  | "Suspended";

/** Received Direct Debit Mandate status information */
export type ReceivedDirectDebitMandateStatusInfo = {
  /** Received Direct Debit Mandate status */
  status: ReceivedDirectDebitMandateStatus;
};

/** Received Direct Debit Mandate Canceled status information */
export type ReceivedDirectDebitMandateStatusInfoCanceled = ReceivedDirectDebitMandateStatusInfo & {
  __typename: "ReceivedDirectDebitMandateStatusInfoCanceled";
  /** Date of cancellation */
  canceledAt: Scalars["DateTime"]["output"];
  /** Received Direct Debit Mandate status (always Canceled for type ReceivedDirectDebitMandateStatusInfoCanceled) */
  status: ReceivedDirectDebitMandateStatus;
};

/** Received Direct Debit Mandate ConsentInitiationPending status information */
export type ReceivedDirectDebitMandateStatusInfoConsentInitiationPending =
  ReceivedDirectDebitMandateStatusInfo & {
    __typename: "ReceivedDirectDebitMandateStatusInfoConsentInitiationPending";
    /** Received Direct Debit Mandate status (always ConsentInitiationPending for type ReceivedDirectDebitMandateStatusInfoConsentInitiationPending) */
    status: ReceivedDirectDebitMandateStatus;
  };

/** Received Direct Debit Mandate ConsentPending status information */
export type ReceivedDirectDebitMandateStatusInfoConsentPending =
  ReceivedDirectDebitMandateStatusInfo & {
    __typename: "ReceivedDirectDebitMandateStatusInfoConsentPending";
    /** The consent required to consent to a received direct debit mandate */
    consent: Consent;
    /** Received Direct Debit Mandate status (always ConsentInitiationPending for type ReceivedDirectDebitMandateStatusInfoConsentPending) */
    status: ReceivedDirectDebitMandateStatus;
  };

/** Received Direct Debit Mandate Enabled status information */
export type ReceivedDirectDebitMandateStatusInfoEnabled = ReceivedDirectDebitMandateStatusInfo & {
  __typename: "ReceivedDirectDebitMandateStatusInfoEnabled";
  /** Date at which the received direct debit mandate has been moved to the enabled status */
  enabledAt: Scalars["DateTime"]["output"];
  /** Received Direct Debit Mandate status (always Enabled for type ReceivedDirectDebitMandateStatusInfoEnabled) */
  status: ReceivedDirectDebitMandateStatus;
};

/** Received Direct Debit Mandate Suspended status information */
export type ReceivedDirectDebitMandateStatusInfoSuspended = ReceivedDirectDebitMandateStatusInfo & {
  __typename: "ReceivedDirectDebitMandateStatusInfoSuspended";
  /** Received Direct Debit Mandate status (always Suspended for type ReceivedDirectDebitMandateStatusInfoSuspended) */
  status: ReceivedDirectDebitMandateStatus;
  /** Date of the last time the received direct debit mandate has been moved to the suspended status */
  suspendedAt: Scalars["DateTime"]["output"];
};

/** Input to select the beneficiary and the originator to perform a refund */
export type RefundInput = {
  /** url the user is redirected to after consent has been given */
  consentRedirectUrl: Scalars["String"]["input"];
  /** transactions to refund */
  refundTransactions: Array<RefundTransaction>;
};

/** The respond body to a refund mutation */
export type RefundPayload = RefundRejection | RefundSuccessPayload;

/** Rejection returned if the transaction status is not correct for the desired action */
export type RefundRejection = Rejection & {
  __typename: "RefundRejection";
  code: RefundRejectionCode;
  message: Scalars["String"]["output"];
};

/** Reason code that explains why we can't refund the transactions */
export type RefundRejectionCode =
  /** Error server */
  | "ServerError"
  /** The transaction status is not Booked */
  | "TransactionNonRefundable"
  /** The transaction couldn't be found or the user doesn't have the 'canInitiatePayment' rights on the account */
  | "TransactionNotFound";

/** Consent generated by the refund mutation */
export type RefundSuccessPayload = {
  __typename: "RefundSuccessPayload";
  /** optional consent that need to be validated for the refund to go through */
  consent?: Maybe<Consent>;
};

/** Information about the transaction to refund */
export type RefundTransaction = {
  /** amount to refund in the same currency as the account */
  amount: AmountInput;
  /**
   * only used when the transaction was a credit transfer
   *
   * date when the credit transfer will be executed, if `null` the credit transfer is executed today
   */
  executionDate?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** label for the refund transaction (max 140 characters) */
  label?: InputMaybe<Scalars["String"]["input"]>;
  /** id of the transaction to refund */
  originTransactionId: Scalars["String"]["input"];
  /**
   * reference assigned by the initiating party, to unambiguously identify the transaction.
   * This reference is passed on, unchanged, throughout the entire end-to-end chain for credit transfers. (regex [A-Za-z0-9(\\-)(\\_)(\\?)(\\.)(\\+),' ]{1,35})
   */
  reference?: InputMaybe<Scalars["String"]["input"]>;
};

export type RefusedVerificationRenewal = VerificationRenewal & {
  __typename: "RefusedVerificationRenewal";
  accountHolderId: Scalars["String"]["output"];
  createdAt: Scalars["DateTime"]["output"];
  dueDate?: Maybe<Scalars["DateTime"]["output"]>;
  id: Scalars["ID"]["output"];
  /** Verification renewal information */
  info: VerificationRenewalInfo;
  /** Refused date */
  refusedAt?: Maybe<Scalars["DateTime"]["output"]>;
  status: VerificationRenewalStatus;
  supportTicketId?: Maybe<Scalars["String"]["output"]>;
  updatedAt: Scalars["DateTime"]["output"];
};

/** Currently supported countries in the registry querying */
export type RegistryCountry = "FRA";

export type RegulatoryClassification =
  | "FinancialInstitution"
  | "NonFinancialActive"
  | "NonFinancialPassive";

/** Funding Source Rejected Reason */
export type RejectedFundingSourceReason = "AccountVerificationRejected";

/** Funding Source Rejected status information */
export type RejectedFundingSourceStatusInfo = FundingSourceStatusInfo & {
  __typename: "RejectedFundingSourceStatusInfo";
  /** Reason code of the rejection */
  reasonCode: RejectedFundingSourceReason;
  /** Date at which the funding source was rejected */
  rejectedAt: Scalars["Date"]["output"];
  /** Funding Source Rejected status */
  status: FundingSourceStatus;
};

/** RejectedMerchantPaymentMethodStatusInfo */
export type RejectedMerchantPaymentMethodStatusInfo = MerchantPaymentMethodStatusInfo & {
  __typename: "RejectedMerchantPaymentMethodStatusInfo";
  /** Merchant Payment Method rejected date */
  rejectedAt: Scalars["Date"]["output"];
  /** Merchant Payment Methode rejection reason */
  rejectionReason: MerchantPaymentMethodRejectionReason;
  status: MerchantPaymentMethodStatus;
};

/** RejectedMerchantProfileStatusInfo */
export type RejectedMerchantProfileStatusInfo = MerchantProfileStatusInfo & {
  __typename: "RejectedMerchantProfileStatusInfo";
  rejectedAt: Scalars["Date"]["output"];
  rejectionReason: MerchantProfileRejectionReason;
  status: MerchantProfileStatus;
};

/** The following reason code for a rejected transaction are defined: */
export type RejectedReasonCode =
  /** The account linked to this card is closed. */
  | "AccountClosed"
  /** Rejected because the account holder is deceased */
  | "AccountHolderDeceased"
  /** Rejected by the account membership */
  | "AccountMembershipRefused"
  /** Rejected because the account is suspended */
  | "AccountSuspended"
  /** Rejected because the account is unknown */
  | "AccountUnknown"
  /** Rejected because the declared amount does not match the amount on the check */
  | "AmountMismatch"
  /** Rejected by the bank */
  | "BankRefused"
  /** Rejected because the creditor bank is not reachable */
  | "BeneficiaryBankNotReachable"
  /** Rejected because the amount beneficiary name the check and the name declared through the API don't match */
  | "BeneficiaryMismatch"
  /** Rejected because the beneficiary is missing or incorrect */
  | "BeneficiaryMissingOrIncorrect"
  /** The card holder canceled the transaction. */
  | "CanceledByCardHolder"
  /** The card is expired. */
  | "CardExpired"
  /** The card isn't activated. */
  | "CardNotActivated"
  /** Rejected because the given card number is invalid */
  | "CardNumberInvalid"
  /** The card is temporarily or permanently blocked, or it's expired. */
  | "CardOutOfOrder"
  /** The card is permanently blocked. */
  | "CardPermanentlyBlocked"
  /** The card is suspended. */
  | "CardSuspended"
  /** The card is unknown. */
  | "CardUnknown"
  /** Rejected because the card holder asked for the cancellation */
  | "CardholderCancellation"
  /** Rejected because the check was not received */
  | "CheckNotReceived"
  /** Rejected because the check was received more than 30 days after it was declared to Swan */
  | "CheckReceivedLate"
  /** Rejected because the creditor bank is offline */
  | "CreditorBankOffline"
  /** Rejected following an error from the creditor bank */
  | "CreditorBankTechnicalErrorOccurred"
  /** Rejected following a timeout from the creditor bank */
  | "CreditorBankTimeout"
  /** Rejected because the date on the check is invalid (unreadable or in the future for example) */
  | "DateInvalid"
  /** Rejected because the date is missing on the check */
  | "DateMissing"
  /** Rejected because the debtor account is closed */
  | "DebtorAccountClosed"
  /** Rejected because the debtor is a non business account and the transaction is a B2B SEPA Direct Debit transaction */
  | "DebtorAccountConsumer"
  /** Rejected because the debtor account is unknown */
  | "DebtorAccountUnknown"
  /** Rejected because the debtor bank is offline */
  | "DebtorBankOffline"
  /** Rejected following an error from the debtor bank */
  | "DebtorBankTechnicalErrorOccurred"
  /** Rejected following a timeout from the debtor bank */
  | "DebtorBankTimeout"
  /** Rejected because the debtor account holder is dead */
  | "DebtorDeceased"
  /** Rejected because the name of the payer is missing on the check */
  | "DebtorNameMissing"
  /** The digital card is deactivated. */
  | "DigitalCardDeactivated"
  /** There was a problem when enrolling the digital card. */
  | "DigitalCardEnrollmentInvalid"
  /** The digital card issuer rejected the transaction. */
  | "DigitalCardRefusal"
  /** The digital card is suspended. */
  | "DigitalCardSuspended"
  /** The digital card either is inactive, is expired, or doesn't exist. */
  | "DigitalCardTokenInvalid"
  /** Rejected because the digital wallet's token is deactivated */
  | "DigitalWalletDeactivated"
  /** Rejected because of a problem encountered during the enrolment request (for example, a token error) */
  | "DigitalWalletEnrolmentInvalid"
  /** Rejected because the digital wallet's issuer refused the transaction */
  | "DigitalWalletRefusal"
  /** Rejected because the digital wallet's token is suspended */
  | "DigitalWalletSuspended"
  /** Rejected because the digital wallet's does not exist, is not active or has an expired date */
  | "DigitalWalletTokenInvalid"
  /** This request can't be honored. Contact Support with any questions. */
  | "DoNotHonor"
  /** Rejected because the check has not been signed. */
  | "EndorsementMissing"
  /** Rejected because of a fraud suspicion */
  | "FraudSuspected"
  /** Rejected because the beneficiary IBAN is invalid */
  | "IbanInvalid"
  /** Rejected because the beneficiary IBAN is suspended */
  | "IbanSuspended"
  /** This card can't be used for in-person transactions. */
  | "InPersonTransactionsNotAuthorized"
  /** Rejected because of insufficient funds on the account */
  | "InsufficientFunds"
  /** Rejected because the given amount is invalid */
  | "InvalidAmount"
  /** The expiration date provided doesn't match the expiration date on the card. */
  | "InvalidExpirationDate"
  /** Rejected because the digital amount on the check is missing or unreadable */
  | "InvalidOrMissingAmount"
  /** Rejected because the PIN is invalid */
  | "InvalidPin"
  /** The card holder entered the incorrect PIN too many times. */
  | "InvalidPinAttemptsExceeded"
  /** Rejected because the security number entered does not match the one on the card */
  | "InvalidSecurityNumber"
  /** Rejected because of invalid transfer date */
  | "InvalidTransferDate"
  /** Paying with the card's magstripe isn't supported by this merchant. */
  | "MagstripeNotSupported"
  /** Rejected by debtor because the mandate is invalid */
  | "MandateInvalid"
  /** The merchant couldn't be found or doesn't exist. */
  | "MerchantNotFound"
  /** The merchant didn't use 3-D Secure (3DS). */
  | "MerchantShouldResubmitAuthorization"
  /** Rejected because the expiration date is not available in the transaction */
  | "MissingExpirationDate"
  /** Rejected because purchase made by chip but without any Pin code entered */
  | "MissingPin"
  /** Rejected because the mandate has been revoked or does not exist */
  | "NoMandate"
  /** Rejected by the partner (you) */
  | "PartnerRefused"
  /** Rejected following an error or a timeout from the partner */
  | "PartnerTechnicalErrorOccurred"
  /** Rejected because the maximum amount allowed on the given period has been exceeded */
  | "PeriodAmountLimitExceeded"
  /** Rejected because the maximum number of transactions on the given period has been exceeded */
  | "PeriodNbTransactionLimitExceeded"
  /** The maximum number of transactions allowed during the given period is exceeded. */
  | "PeriodTransactionNumberLimitExceeded"
  /** The PIN entered by the card holder is incorrect. */
  | "PinInvalid"
  /** The card holder didn't enter their PIN. */
  | "PinRequired"
  /** The card holder must enter their PIN while completing a transaction to reactivate their card. */
  | "PinRequiredForFurtherTransaction"
  /** Rejected by bank with no specified reason */
  | "ReasonNotSpecifiedByBank"
  /** Rejected by debtor with no specified reason */
  | "ReasonNotSpecifiedByDebtor"
  /** Rejected by bank for regulatory reason */
  | "RegulatoryReason"
  /** Rejected because the Swipe method is not supported, a retry using the Chip and PIN method is necessary */
  | "RetryWithChipAndPin"
  /** Rejected because the signature is missing on the check */
  | "SignatureMissing"
  /** Rejected because the check is suspicious */
  | "SuspiciousCheck"
  /** Rejected because the debtor or the creditor bank is offline */
  | "SwanOffline"
  /** Rejected by Swan */
  | "SwanRefused"
  /** A technical error occurred. */
  | "SwanTechnicalErrorOccurred"
  /** Rejected because of a Swan timeout */
  | "SwanTimeout"
  /** Rejected because the terms and conditions limit has been exceeded */
  | "TermsAndConditionsLimitExceeded"
  /** There was an error with 3-D Secure (3DS). */
  | "ThreeDsError"
  /** The maximum spending limit for the given period is exceeded. */
  | "TransactionAmountLimitExceeded"
  /** The transaction isn't in a supported currency. */
  | "TransactionCurrencyIncorrect"
  /** Rejected by bank because this transaction is duplicated */
  | "TransactionDuplicated"
  /** Rejected because the transaction is forbidden on this type of account */
  | "TransactionOnAccountTypeNotAllowed"
  /** The account doesn't allowed this transaction type. */
  | "TransactionTypeNotAllowed";

/** Rejected transaction status information */
export type RejectedTransactionStatusInfo = TransactionStatusInfo & {
  __typename: "RejectedTransactionStatusInfo";
  /** `true` if the transaction had a fallback */
  hasFallback: Scalars["Boolean"]["output"];
  /** unique identifier of the transaction */
  id: Scalars["ID"]["output"];
  /** reason code */
  reason: RejectedReasonCode;
  /** status of the transaction */
  status: TransactionStatus;
};

/** Rejected Verification Reason */
export type RejectedVerificationReason = "HolderDidNotMatch";

/** Rejected Information */
export type RejectedVerificationStatusInfo = AccountVerificationStatusInfo & {
  __typename: "RejectedVerificationStatusInfo";
  /** Rejected Reason */
  reason: RejectedVerificationReason;
  /** Date at which the verification was rejected */
  rejectedAt: Scalars["DateTime"]["output"];
  /** Account verification status (Rejected) */
  status: AccountVerificationStatus;
};

export type Rejection = {
  message: Scalars["String"]["output"];
};

export type ReleasedReason =
  /** Authorization has been superseded by an advice */
  | "AdviceReceived"
  /** Authorization fully captured by one or more debits */
  | "Captured"
  /** Authorization expired */
  | "Expired"
  /** Authorization manually released by Swan */
  | "ManuallyReleased"
  /** Authorization released by the merchant */
  | "MerchantReleased"
  /** Authorization released for other/undefined reasons */
  | "Other";

/** Released card transaction status information */
export type ReleasedTransactionStatusInfo = TransactionStatusInfo & {
  __typename: "ReleasedTransactionStatusInfo";
  /** unique identifier of the transaction */
  id: Scalars["ID"]["output"];
  /** reason of the released transaction */
  reason: ReleasedReason;
  /** The date when the transaction was released */
  releaseDate: Scalars["DateTime"]["output"];
  /** status of the transaction */
  status: TransactionStatus;
};

export type RemoveWebhookSubscriptionPayload =
  | InternalErrorRejection
  | InvalidArgumentRejection
  | RemoveWebhookSubscriptionSuccessPayload
  | WebhookSubscriptionNotFoundRejection;

export type RemoveWebhookSubscriptionSuccessPayload = {
  __typename: "RemoveWebhookSubscriptionSuccessPayload";
  subscriptionRemovedSuccessfully: Scalars["Boolean"]["output"];
};

export type RepaymentCycle = {
  __typename: "RepaymentCycle";
  endDate: Scalars["Date"]["output"];
  id: Scalars["ID"]["output"];
  /** The current cycle's balance. */
  owedAmount: Amount;
  startDate: Scalars["Date"]["output"];
  /** The repayment's balance's status */
  status: RepaymentCycleStatus;
};

export type RepaymentCycleConnection = Connection & {
  __typename: "RepaymentCycleConnection";
  /** RepaymentCycleEdge list */
  edges: Array<RepaymentCycleEdge>;
  /** Information about the current, the previous and the next page */
  pageInfo: PageInfo;
  /** Total number of element in the list */
  totalCount: Scalars["Int"]["output"];
};

/** Implements the Relay Edge interface */
export type RepaymentCycleEdge = Edge & {
  __typename: "RepaymentCycleEdge";
  /** Opaque identifier pointing to this node in the pagination mechanism */
  cursor: Scalars["String"]["output"];
  /** The Repayment Cycle entry */
  node: RepaymentCycle;
};

export type RepaymentCycleLength = MonthlyPeriod | WeeklyPeriod;

/** Inputs on the period between two reimbursement. */
export type RepaymentCycleLengthInput = {
  monthly?: InputMaybe<RepaymentCycleMonthlyInput>;
  weekly?: InputMaybe<RepaymentCycleWeeklyInput>;
};

/** Input about when the repayment should occurs monthly. */
export type RepaymentCycleMonthlyInput = {
  /** The day of the month when the reimbursement should occurs (ie: every 15th of each month). */
  dayOfMonth: Scalars["Int"]["input"];
};

/** Rejection when a repayment cycle is not found */
export type RepaymentCycleNotFoundRejection = Rejection & {
  __typename: "RepaymentCycleNotFoundRejection";
  message: Scalars["String"]["output"];
};

export type RepaymentCyclePeriod = "Monthly" | "Weekly";

export type RepaymentCycleStatus = "Due" | "Overdue" | "Repaid" | "Submitted";

/** Input about when the repayment should occurs weekly (ie: Every Friday each 2 weeks). */
export type RepaymentCycleWeeklyInput = {
  /** The day of the month where the reimbursement should occurs. */
  dayOfWeek: DayEnum;
  /** How many weeks should pass between two reimbursement (ie: every 3 weeks). */
  weekCount: Scalars["Int"]["input"];
};

export type RepaymentMethod = SepaDirectDebitB2b;

/** Inputs on the repayment methods which will be used for the reimbursement. */
export type RepaymentMethodInput = {
  sepaDirectDebitB2B: CreditLimitSepaDirectDebitB2BInput;
};

export type RepaymentMethodType = "SepaDirectDebitB2b";

/** Rejection when a repayment is not found */
export type RepaymentNotFoundRejection = Rejection & {
  __typename: "RepaymentNotFoundRejection";
  message: Scalars["String"]["output"];
};

export type RepaymentSettings = {
  __typename: "RepaymentSettings";
  /** The period between two reimbursement. */
  repaymentCycleLength: RepaymentCycleLength;
  /** The repayment method used for the reimbursement. */
  repaymentMethod: RepaymentMethod;
};

/** Inputs for the repayment settings. */
export type RepaymentSettingsInput = {
  repaymentMethod: RepaymentMethodInput;
};

/** Rejection when a repayment is not found */
export type RepaymentWrongStatusRejection = Rejection & {
  __typename: "RepaymentWrongStatusRejection";
  message: Scalars["String"]["output"];
};

/** Rejection when a repayment is not found */
export type RepaymentWrongStatusTransitionRejection = Rejection & {
  __typename: "RepaymentWrongStatusTransitionRejection";
  message: Scalars["String"]["output"];
};

/** Input to replay a Webhook event */
export type ReplayWebhookEventInput = {
  /** The ID of the subscription you want the webhook event to be retried on */
  subscriptionId?: InputMaybe<Scalars["ID"]["input"]>;
  /** The ID of a webhook Event */
  webhookEventId: Scalars["ID"]["input"];
};

/** Invoke Webhook Endpoint Payload */
export type ReplayWebhookEventPayload =
  | InternalErrorRejection
  | InvalidArgumentRejection
  | ReplayWebhookEventSuccessPayload
  | WebhookEventLogNotFoundRejection
  | WebhookSubscriptionNotFoundRejection;

/** Invoke Webhook Endpoint Success Payload */
export type ReplayWebhookEventSuccessPayload = {
  __typename: "ReplayWebhookEventSuccessPayload";
  endpointStatus?: Maybe<Scalars["Int"]["output"]>;
  webhookEventLogEntryId: Scalars["ID"]["output"];
};

/** The document corresponding to a identification report */
export type ReportDocument = {
  __typename: "ReportDocument";
  /** List of the associated files */
  files: Array<ReportDocumentFile>;
  /** Unique identifier of the report document */
  id: Scalars["String"]["output"];
  /** The type of the document */
  type: DocumentType;
};

/** The file associated to the report document */
export type ReportDocumentFile = DocumentFile & {
  __typename: "ReportDocumentFile";
  /** The file's temporary download url */
  downloadUrl: Scalars["String"]["output"];
};

/** here is the exchange rate detail */
export type ReportExchangeRate = {
  __typename: "ReportExchangeRate";
  contractIdentification?: Maybe<Scalars["String"]["output"]>;
  exchangeRate: Scalars["Float"]["output"];
  quotationDate: Scalars["Date"]["output"];
  sourceCurrency: Scalars["Currency"]["output"];
  targetCurrency: Scalars["Currency"]["output"];
  unitCurrency: Scalars["Currency"]["output"];
};

export type Representative = CompanyRepresentative | IndividualRepresentative;

/** Rejection returned if the mutation cannot be executed because the representative is incomplete */
export type RepresentativeIncompleteRejection = Rejection & {
  __typename: "RepresentativeIncompleteRejection";
  fields: Array<ValidationFieldError>;
  message: Scalars["String"]["output"];
};

export type RepresentativeInput = {
  /** Birth city of the representative. Length must be between 0 and 100 characters. */
  birthCity?: InputMaybe<Scalars["String"]["input"]>;
  /** Postal code of the birth city. Length must be between 0 and 50 characters. */
  birthCityPostalCode?: InputMaybe<Scalars["String"]["input"]>;
  /** Birth country code of the representative. Must be a valid alpha-3 country code (ISO 3166). */
  birthCountryCode?: InputMaybe<Scalars["CCA3"]["input"]>;
  /** Birth date of the representative. Must be a valid date in the YYYY/MM/DD format. */
  birthDate?: InputMaybe<Scalars["String"]["input"]>;
  /** Legal entity name of the representative (for Company type). */
  entityName?: InputMaybe<Scalars["String"]["input"]>;
  /** First name of the representative. */
  firstName?: InputMaybe<Scalars["String"]["input"]>;
  /** Gender of the representative (Male, Female, or Unknown). */
  gender?: InputMaybe<Gender>;
  /** Last name of the representative. */
  lastName?: InputMaybe<Scalars["String"]["input"]>;
  /** Legal form of the representative's legal entity. */
  legalForm?: InputMaybe<Scalars["String"]["input"]>;
  /** Nationality of the representative. Must be a valid alpha-3 country code (ISO 3166). */
  nationality?: InputMaybe<Scalars["CCA3"]["input"]>;
  /** Preferred first name of the representative. */
  preferredFirstName?: InputMaybe<Scalars["String"]["input"]>;
  /** Registration number of the representative’s legal entity. */
  registrationNumber?: InputMaybe<Scalars["String"]["input"]>;
  /** Residency address of the representative. */
  residencyAddress?: InputMaybe<ResidencyAddressInput>;
  /** List of representative roles. */
  roles?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** Type of representative (Individual or Company). */
  type: RepresentativeType;
};

export type RepresentativeType = "Company" | "Individual";

/** Inputs to request a credit limit */
export type RequestCreditLimitSettingsInput = {
  /** The accountId which will benefit from the credit limits */
  accountId: Scalars["String"]["input"];
  /** URL the user is redirected to after consent has been given */
  consentRedirectUrl: Scalars["String"]["input"];
  /** The settings chosen for the credit limits */
  creditLimitSettings: CreditLimitSettingsInput;
  /** The reccurence of the reimbursements. */
  cycleLength: RepaymentCycleLengthInput;
  /** The repayments method used to reimburse the loans. */
  repaymentSettings: RepaymentSettingsInput;
};

export type RequestCreditLimitSettingsPayload =
  | AccountHolderNotFoundRejection
  | AccountNotFoundRejection
  | BadRequestRejection
  | ForbiddenRejection
  | MissingAddressItemRejection
  | NotLegalRepresentativeRejection
  | RequestCreditLimitSettingsSuccessPayload;

export type RequestCreditLimitSettingsSuccessPayload = {
  __typename: "RequestCreditLimitSettingsSuccessPayload";
  /** The created credit limits request */
  creditLimitSettingsRequest: CreditLimitSettingsRequest;
};

export type RequestMerchantPaymentMethodsInput = {
  /** Input for Card payment method */
  card?: InputMaybe<CardPaymentMethodInput>;
  /** Input for Check payment method */
  check?: InputMaybe<CheckPaymentMethodInput>;
  /** Input for In Person Card payment method */
  inPersonCard?: InputMaybe<InPersonCardPaymentMethodInput>;
  /** Input for the Internal Direct Debit B2B payment method */
  internalDirectDebitB2B?: InputMaybe<InternalDirectDebitB2BPaymentMethodInput>;
  /** Input for the Internal Direct Debit Standard payment method */
  internalDirectDebitStandard?: InputMaybe<InternalDirectDebitStandardPaymentMethodInput>;
  /** ID of the Merchant Profile */
  merchantProfileId: Scalars["ID"]["input"];
  /** Input for the Sepa Direct Debit B2B payment method */
  sepaDirectDebitB2B?: InputMaybe<SepaDirectDebitB2BPaymentMethodInput>;
  /** Input for the Sepa Direct Debit Core payment method */
  sepaDirectDebitCore?: InputMaybe<SepaDirectDebitCorePaymentMethodInput>;
};

export type RequestMerchantPaymentMethodsPayload =
  | ForbiddenRejection
  | InternalErrorRejection
  | InvalidPaymentMethodRequestRejection
  | NotFoundRejection
  | RequestMerchantPaymentMethodsSuccessPayload
  | ValidationRejection;

export type RequestMerchantPaymentMethodsSuccessPayload = {
  __typename: "RequestMerchantPaymentMethodsSuccessPayload";
  merchantProfile?: Maybe<MerchantProfile>;
};

export type RequestMerchantPaymentMethodsUpdateInput = {
  /** ID of the merchant payment method */
  paymentMethodId: Scalars["ID"]["input"];
  /** Input for the Sepa Direct Debit payment method */
  sepaDirectDebit: SepaDirectDebitPaymentMethodInput;
};

export type RequestMerchantPaymentMethodsUpdatePayload =
  | ForbiddenRejection
  | InternalErrorRejection
  | MerchantPaymentMethodSepaDirectDebitInvalidRejection
  | MerchantPaymentMethodWrongStatusRejection
  | NotFoundRejection
  | RequestMerchantPaymentMethodsUpdateSuccessPayload
  | ValidationRejection;

export type RequestMerchantPaymentMethodsUpdateSuccessPayload = {
  __typename: "RequestMerchantPaymentMethodsUpdateSuccessPayload";
  paymentMethodId: Scalars["String"]["output"];
  requestId: Scalars["String"]["output"];
};

/** Input to add a Merchant Profile */
export type RequestMerchantProfileInput = {
  /**
   * Your accent color, used in white label interfaces.
   * This color would also be inherited in the Swan Merchant Payment page.
   */
  accentColor?: InputMaybe<Scalars["String"]["input"]>;
  /** ID of the Swan account which the merchantProfile is associated to */
  accountId: Scalars["ID"]["input"];
  /** Additional information about the merchant profile */
  additionalInformation?: InputMaybe<Array<AdditionalInformationInput>>;
  /** Where the payer are generally based. */
  customerRegion?: InputMaybe<MerchantProfileCustomerRegion>;
  /** expected average basket value. */
  expectedAverageBasket: AmountInput;
  /** Expected annual activity volumes for all payment method */
  expectedMonthlyMerchantProcessingVolume?: InputMaybe<ExpectedMonthlyMerchantProcessingVolume>;
  /** Base64 encoded merchant's logo */
  merchantLogo?: InputMaybe<Scalars["String"]["input"]>;
  /** Business name of the merchant, i.e. name that will be displayed on debtors' bank statements */
  merchantName: Scalars["String"]["input"];
  /** Url of the merchant's website */
  merchantWebsiteUrl?: InputMaybe<Scalars["URL"]["input"]>;
  /** The type of payments accepted by the merchant. Can be OneOff (no returning payers in general), Recurrent (returning payers), or a mix of both OneOffAndRecurrent. */
  paymentFrequency?: InputMaybe<MerchantProfilePaymentFrequency>;
  /** Type of product sold. Gifts and donations can be club subscription or collection of donations (for associations), tips collection, contributions for local authorities */
  productType: ProductType;
  /** The URL of the main social network of the merchant. */
  socialNetworkUrl?: InputMaybe<Scalars["URL"]["input"]>;
  /** The URL of the support website or help center of the merchant. */
  supportWebsiteUrl?: InputMaybe<Scalars["URL"]["input"]>;
  /** The URL of the terms and conditions of the merchant. */
  termsAndConditionsUrl?: InputMaybe<Scalars["URL"]["input"]>;
};

/** Request Merchant Profile Payload */
export type RequestMerchantProfilePayload =
  | AccountNotFoundRejection
  | ForbiddenRejection
  | InternalErrorRejection
  | RequestMerchantProfileSuccessPayload
  | ValidationRejection;

/** Request Merchant Profile Success Payload */
export type RequestMerchantProfileSuccessPayload = {
  __typename: "RequestMerchantProfileSuccessPayload";
  /** Merchant Profile */
  merchantProfile: MerchantProfile;
};

/** Request Update Merchant Profile */
export type RequestMerchantProfileUpdate = {
  __typename: "RequestMerchantProfileUpdate";
  /** Additional information about the merchant profile */
  additionalInformation: Array<AdditionalInformation>;
  /** created date */
  createdAt: Scalars["DateTime"]["output"];
  /** Where the payer are generally based. */
  customerRegion?: Maybe<MerchantProfileCustomerRegion>;
  /** expected average basket value. */
  expectedAverageBasket?: Maybe<Amount>;
  /** Expected annual activity volumes for all payment method */
  expectedMonthlyMerchantProcessingVolume?: Maybe<ExpectedMonthlyMerchantProcessingVolume>;
  /**
   * Expected annual activity volumes for all payment method
   * @deprecated use expectedMonthlyMerchantProcessingVolume instead
   */
  expectedMonthlyPaymentVolume?: Maybe<Amount>;
  /** The Request ID */
  id: Scalars["ID"]["output"];
  /**
   * Url of an example typical invoice issued by the merchant.
   * @deprecated Unused, will be removed in future versions
   */
  invoiceExampleUrl?: Maybe<Scalars["String"]["output"]>;
  /** Url of the merchant's logo */
  merchantLogoUrl?: Maybe<Scalars["String"]["output"]>;
  /** Business name of the merchant, i.e. name that will be displayed on debtors' bank statements */
  merchantName?: Maybe<Scalars["String"]["output"]>;
  /** The Merchant Profile ID to update */
  merchantProfileId: Scalars["ID"]["output"];
  /**
   * Url of the merchant's website
   * @deprecated Use merchantWebsiteUrl instead
   */
  merchantWebsite?: Maybe<Scalars["String"]["output"]>;
  /** Url of the merchant's website */
  merchantWebsiteUrl?: Maybe<Scalars["String"]["output"]>;
  /** The type of payments accepted by the merchant. Can be OneOff (no returning payers in general), Recurrent (returning payers), or a mix of both OneOffAndRecurrent. */
  paymentFrequency?: Maybe<MerchantProfilePaymentFrequency>;
  /** Type of product sold. List of value: Goods, Services, VirtualGoods, GiftsAndDonations. Gifts and donations can be club subscription or collection of donations (for associations), tips collection, contributions for local authorities */
  productType?: Maybe<ProductType>;
  /**
   * The URL of the main social network of the merchant.
   * @deprecated use socialNetworkUrl instead
   */
  socialNetwork?: Maybe<Scalars["String"]["output"]>;
  /** The URL of the main social network of the merchant. */
  socialNetworkUrl?: Maybe<Scalars["String"]["output"]>;
  /** The status of the request */
  status: RequestMerchantProfileUpdateStatus;
  /**
   * The URL of the support website or help center of the merchant.
   * @deprecated use supportWebsiteUrl instead
   */
  supportWebsite?: Maybe<Scalars["String"]["output"]>;
  /** The URL of the support website or help center of the merchant. */
  supportWebsiteUrl?: Maybe<Scalars["String"]["output"]>;
  /**
   * The URL of the terms and conditions of the merchant.
   * @deprecated use termsAndConditionsUrl instead
   */
  termsAndConditions?: Maybe<Scalars["String"]["output"]>;
  /** The URL of the terms and conditions of the merchant. */
  termsAndConditionsUrl?: Maybe<Scalars["String"]["output"]>;
  /** updated date */
  updatedAt: Scalars["DateTime"]["output"];
};

/** Input to update a Merchant Profile */
export type RequestMerchantProfileUpdateInput = {
  /**
   * Your accent color, used in white label interfaces.
   * This color would also be inherited in the Swan Merchant Payment page.
   * Unlike the other fields in this mutation, the value specified here updates the merchant profile's accent color immediately.
   */
  accentColor?: InputMaybe<Scalars["String"]["input"]>;
  /**
   * Additional information about the merchant profile.
   * Don't add the field to the mutation if you want to keep the existing value.
   */
  additionalInformation?: InputMaybe<Array<AdditionalInformationInput>>;
  /**
   * Where the payer are generally based.
   * Don't add the field to the mutation if you want to keep the existing value.
   */
  customerRegion?: InputMaybe<MerchantProfileCustomerRegion>;
  /**
   * expected average basket value.
   * Don't add the field to the mutation if you want to keep the existing value.
   */
  expectedAverageBasket?: InputMaybe<AmountInput>;
  /**
   * Expected annual activity volumes for all payment methods.
   * Don't add the field to the mutation if you want to keep the existing value.
   */
  expectedMonthlyMerchantProcessingVolume?: InputMaybe<ExpectedMonthlyMerchantProcessingVolume>;
  /**
   * base64 encoded merchant's logo.
   * Use '' to delete the field. Don't add the field to the mutation if you want to keep the existing value.
   */
  merchantLogo?: InputMaybe<Scalars["String"]["input"]>;
  /**
   * Business name of the merchant, i.e. name that will be displayed on debtors' bank statements.
   * Don't add the field to the mutation if you want to keep the existing value.
   */
  merchantName?: InputMaybe<Scalars["String"]["input"]>;
  /** ID of the MerchantProfile to update */
  merchantProfileId: Scalars["ID"]["input"];
  /**
   * Url of the merchant's website.
   * Use '' to delete the field. Don't add the field to the mutation if you want to keep the existing value.
   */
  merchantWebsiteUrl?: InputMaybe<Scalars["String"]["input"]>;
  /**
   * The type of payments accepted by the merchant. Can be OneOff (no returning payers in general), Recurrent (returning payers), or a mix of both OneOffAndRecurrent.
   * Don't add the field to the mutation if you want to keep the existing value.
   */
  paymentFrequency?: InputMaybe<MerchantProfilePaymentFrequency>;
  /**
   * Type of product sold. Gifts and donations can be club subscription or collection of donations (for associations), tips collection, contributions for local authorities.
   * Don't add the field to the mutation if you want to keep the existing value.
   */
  productType?: InputMaybe<ProductType>;
  /**
   * The URL of the main social network of the merchant.
   * Use '' to delete the field. Don't add the field to the mutation if you want to keep the existing value.
   */
  socialNetworkUrl?: InputMaybe<Scalars["String"]["input"]>;
  /**
   * The URL of the support website or help center of the merchant.
   * Use '' to delete the field. Don't add the field to the mutation if you want to keep the existing value.
   */
  supportWebsiteUrl?: InputMaybe<Scalars["String"]["input"]>;
  /**
   * The URL of the terms and conditions of the merchant.
   * Use '' to delete the field. Don't add the field to the mutation if you want to keep the existing value.
   */
  termsAndConditionsUrl?: InputMaybe<Scalars["String"]["input"]>;
};

/** Add Merchant Profile Payload */
export type RequestMerchantProfileUpdatePayload =
  | AccountNotFoundRejection
  | ForbiddenRejection
  | InternalErrorRejection
  | RequestMerchantProfileUpdateSuccessPayload
  | ValidationRejection;

/** Request Merchant Profile Update Statuses */
export type RequestMerchantProfileUpdateStatus =
  /** A Request that has been canceled by the user */
  | "Canceled"
  /** A Request that has already been approved */
  | "Enabled"
  /** A Request is created in the PendingReview status */
  | "PendingReview"
  /** A Request that has already been rejected */
  | "Rejected";

/** Add Merchant Profile Success Payload */
export type RequestMerchantProfileUpdateSuccessPayload = {
  __typename: "RequestMerchantProfileUpdateSuccessPayload";
  merchantProfile: MerchantProfile;
  /**
   * Request Update Merchant Profile
   * @deprecated Use merchantProfile instead
   */
  requestMerchantProfileUpdate: RequestMerchantProfileUpdate;
};

export type RequestSupportingDocumentCollectionReviewInput = {
  /** Id of the supporting document collection to review. */
  supportingDocumentCollectionId: Scalars["ID"]["input"];
};

export type RequestSupportingDocumentCollectionReviewPayload =
  | ForbiddenRejection
  | RequestSupportingDocumentCollectionReviewSuccessPayload
  | SupportingDocumentCollectionNotFoundRejection
  | SupportingDocumentCollectionStatusNotAllowedRejection
  | ValidationRejection;

export type RequestSupportingDocumentCollectionReviewSuccessPayload = {
  __typename: "RequestSupportingDocumentCollectionReviewSuccessPayload";
  supportingDocumentCollection: SupportingDocumentCollection;
};

export type RequestTerminalConnectionTokenInput = {
  merchantProfileId: Scalars["ID"]["input"];
};

export type RequestTerminalConnectionTokenPayload =
  | ForbiddenRejection
  | InternalErrorRejection
  | NotFoundRejection
  | RequestTerminalConnectionTokenSuccessPayload;

export type RequestTerminalConnectionTokenSuccessPayload = {
  __typename: "RequestTerminalConnectionTokenSuccessPayload";
  connectionToken: Scalars["String"]["output"];
};

export type RequestedThreeDsStatusInfo = ThreeDsStatusInfo & {
  __typename: "RequestedThreeDsStatusInfo";
  status: IncomingThreeDsStatus;
};

/** The document corresponding to a residence permit */
export type ResidencePermitDocument = {
  __typename: "ResidencePermitDocument";
  /** The date at which the residence permit expires */
  expiryDate?: Maybe<Scalars["Date"]["output"]>;
  /** List of the associated files */
  files: Array<ResidencePermitDocumentFile>;
  /** Unique identifier of the residence permit document */
  id: Scalars["String"]["output"];
  /** The date at which the residence permit was issued */
  issueDate?: Maybe<Scalars["Date"]["output"]>;
  /** Machine-readable zone code of the residence permit */
  mrz?: Maybe<Scalars["String"]["output"]>;
  /** Number of the residence permit */
  number?: Maybe<Scalars["String"]["output"]>;
  /** The type of the document */
  type: DocumentType;
};

/** The file associated to the resident permit document */
export type ResidencePermitDocumentFile = DocumentFile & {
  __typename: "ResidencePermitDocumentFile";
  /** The file's temporary download url */
  downloadUrl: Scalars["String"]["output"];
  /** From which side the residence permit's picture was taken */
  side: DocumentFileSide;
};

export type ResidencyAddressInput = {
  /** Address line 1. Length must be from 0 to 255 characters */
  addressLine1?: InputMaybe<Scalars["String"]["input"]>;
  /** AddressLine2. Length must be from 0 to 255 characters */
  addressLine2?: InputMaybe<Scalars["String"]["input"]>;
  /** City. Length must be from 0 to 100 characters */
  city?: InputMaybe<Scalars["String"]["input"]>;
  /** Country */
  country?: InputMaybe<Scalars["CCA3"]["input"]>;
  /** Postal code. Length must be from 0 to 50 characters */
  postalCode?: InputMaybe<Scalars["String"]["input"]>;
  /** State of residency. Length must be from 0 to 100 characters */
  state?: InputMaybe<Scalars["String"]["input"]>;
};

/** Account membership restricted to */
export type RestrictedTo = {
  __typename: "RestrictedTo";
  /** birth date */
  birthDate?: Maybe<Scalars["Date"]["output"]>;
  /** first name */
  firstName: Scalars["String"]["output"];
  /** last name */
  lastName: Scalars["String"]["output"];
  /**
   * phone number
   * We're introducing more flexibility in the process to invite & bind new account members (cf [public roadmap](https://swanio.notion.site/Swan-Public-Roadmap-385e4b2e91b3409786a6c8e885654a22?p=a59db00a478e4faaaefbd901e1ed7ed3&pm=s) on notion).
   * For some use cases, it would be possible to invite an account member without their mobile phone number.
   * Please note that the phone number will remain mandatory at the invitation (despite being optional in the Graph) until the new flow is delivered. It is hidden behind a feature toggle
   */
  phoneNumber?: Maybe<Scalars["String"]["output"]>;
};

/** Input when the account membership is restricted to a verified user */
export type RestrictedToInput = {
  /** Account member birth date */
  birthDate?: InputMaybe<Scalars["Date"]["input"]>;
  /** Account member first name */
  firstName: Scalars["String"]["input"];
  /** Account member last name */
  lastName: Scalars["String"]["input"];
  /**
   * Account member phone number
   * We're introducing more flexibility in the process to invite & bind new account members (cf [public roadmap](https://swanio.notion.site/Swan-Public-Roadmap-385e4b2e91b3409786a6c8e885654a22?p=a59db00a478e4faaaefbd901e1ed7ed3&pm=s) on notion).
   * For some use cases, it would be possible to invite an account member without their mobile phone number.
   * Please note that the phone number will remain mandatory at the invitation (despite being optional in the Graph) until the new flow is delivered. It is hidden behind a feature toggle
   */
  phoneNumber?: InputMaybe<Scalars["PhoneNumber"]["input"]>;
};

/** Rejection returned if the mutation cannot be executed in another context than user */
export type RestrictedToUserRejection = Rejection & {
  __typename: "RestrictedToUserRejection";
  message: Scalars["String"]["output"];
};

export type ResumeAccountMembershipInput = {
  /** Unique identifier of a given account membership to resume */
  accountMembershipId: Scalars["ID"]["input"];
  /** URL the user is redirected to after consent has been given */
  consentRedirectUrl: Scalars["String"]["input"];
};

export type ResumeAccountMembershipPayload =
  | ForbiddenRejection
  | ResumeAccountMembershipSuccessPayload
  | UserNotAllowedToManageAccountMembershipRejection
  | ValidationRejection;

export type ResumeAccountMembershipSuccessPayload = {
  __typename: "ResumeAccountMembershipSuccessPayload";
  consent: Consent;
};

/** Inputs to resume a physical card */
export type ResumePhysicalCardInput = {
  /** Unique identifier of a card */
  cardId: Scalars["ID"]["input"];
  /** URL the user is redirected to after consent has been given */
  consentRedirectUrl: Scalars["String"]["input"];
};

export type ResumePhysicalCardPayload =
  | CardNotFoundRejection
  | ForbiddenRejection
  | PhysicalCardNotFoundRejection
  | PhysicalCardWrongStatusRejection
  | ResumePhysicalCardSuccessPayload
  | UserNotCardHolderRejection
  | ValidationRejection;

export type ResumePhysicalCardSuccessPayload = {
  __typename: "ResumePhysicalCardSuccessPayload";
  /** The consent required to resume a physical card */
  consent: Consent;
  /** The physicalCard to resume */
  physicalCard: PhysicalCard;
};

export type ReturnTransactionInput = {
  /** URL the user is redirected to after consent has been given */
  consentRedirectUrl: Scalars["String"]["input"];
  /** The id of the transaction to return */
  transactionId: Scalars["String"]["input"];
};

export type ReturnTransactionPayload =
  | ForbiddenRejection
  | ReturnTransactionRejection
  | ReturnTransactionSuccessPayload
  | TransactionNotFoundRejection;

/** Rejection returned if the refund is not applicable for this transaction */
export type ReturnTransactionRejection = Rejection & {
  __typename: "ReturnTransactionRejection";
  message: Scalars["String"]["output"];
};

/** Return type in case of a successful response of the RefundTransaction mutation */
export type ReturnTransactionSuccessPayload = {
  __typename: "ReturnTransactionSuccessPayload";
  consent: Consent;
};

/**
 * Percentage over a number of business days, that is applied to all funds collected to compute a Reserved amount
 * This amount cannot be used over the corresponding business days
 */
export type RollingReserve = {
  __typename: "RollingReserve";
  /** Percentage of the funding amount to be reserved */
  percentage: Scalars["Int"]["output"];
  /** Number of business days the computed amount is reserved */
  rollingDays: Scalars["Int"]["output"];
};

/** External Beneficiary type SEPA */
export type SepaBeneficiary = {
  __typename: "SEPABeneficiary";
  /** beneficiary address */
  address?: Maybe<Address>;
  /**
   * unique identifier of a beneficiary
   * *SOON TO BE DEPRECATED*
   * Always empty, It will be removed soon.
   * @deprecated this field is never filled. It will be removed soon.
   */
  id?: Maybe<Scalars["ID"]["output"]>;
  /** maskedIBAN if the beneficiary is a an account in an other financial institution */
  maskedIBAN?: Maybe<Scalars["String"]["output"]>;
  /** full name of the beneficiary */
  name: Scalars["String"]["output"];
};

/** Sepa Credit Transfer Creditor */
export type SepaCreditTransferCreditor = {
  /** BIC */
  BIC?: Maybe<Scalars["String"]["output"]>;
  /** IBAN */
  IBAN?: Maybe<Scalars["String"]["output"]>;
  /** maskedIBAN */
  maskedIBAN: Scalars["String"]["output"];
  /** full name of the creditor */
  name: Scalars["String"]["output"];
};

/** Sepa Credit Transfer Debtor */
export type SepaCreditTransferDebtor = {
  /** BIC */
  BIC?: Maybe<Scalars["String"]["output"]>;
  /** IBAN */
  IBAN?: Maybe<Scalars["String"]["output"]>;
  /** maskedIBAN */
  maskedIBAN: Scalars["String"]["output"];
  /** full name of the debtor */
  name: Scalars["String"]["output"];
};

/** Sepa Credit Transfer Creditor for Incoming transaction */
export type SepaCreditTransferInCreditor = SepaCreditTransferCreditor & {
  __typename: "SEPACreditTransferInCreditor";
  /** BIC */
  BIC?: Maybe<Scalars["String"]["output"]>;
  /** IBAN */
  IBAN?: Maybe<Scalars["String"]["output"]>;
  /**
   * account number
   * @deprecated because it is not already implemented (a default value is set).
   */
  accountNumber: Scalars["AccountNumber"]["output"];
  /** maskedIBAN */
  maskedIBAN: Scalars["String"]["output"];
  /** full name of the creditor */
  name: Scalars["String"]["output"];
  /** identifier of a Virtual IBAN */
  virtualIBANEntryId?: Maybe<Scalars["ID"]["output"]>;
};

/** Sepa Credit Transfer Debtor for Incoming transaction */
export type SepaCreditTransferInDebtor = SepaCreditTransferDebtor & {
  __typename: "SEPACreditTransferInDebtor";
  /** BIC */
  BIC?: Maybe<Scalars["String"]["output"]>;
  /** IBAN */
  IBAN?: Maybe<Scalars["String"]["output"]>;
  /** maskedIBAN */
  maskedIBAN: Scalars["String"]["output"];
  /** full name of the debtor (max 70 characters) */
  name: Scalars["String"]["output"];
  /** identifier of a Virtual IBAN */
  virtualIBANEntryId?: Maybe<Scalars["ID"]["output"]>;
};

/**
 * *SOON TO BE DEPRECATED*
 * Sepa Credit Transfer Debtor for Incoming transaction
 */
export type SepaCreditTransferInternalInDebtor = SepaCreditTransferDebtor & {
  __typename: "SEPACreditTransferInternalInDebtor";
  /** BIC */
  BIC?: Maybe<Scalars["String"]["output"]>;
  /** IBAN */
  IBAN?: Maybe<Scalars["String"]["output"]>;
  /**
   * account number
   * @deprecated because it is not already implemented (a default value is set).
   */
  accountNumber: Scalars["AccountNumber"]["output"];
  /** maskedIBAN */
  maskedIBAN: Scalars["String"]["output"];
  /** full name of the debtor */
  name: Scalars["String"]["output"];
  /** identifier of a Virtual IBAN */
  virtualIBANEntryId?: Maybe<Scalars["ID"]["output"]>;
};

/**
 * *SOON TO BE DEPRECATED*
 * Sepa Credit Transfer Creditor for internal transaction
 */
export type SepaCreditTransferInternalOutCreditor = SepaCreditTransferCreditor & {
  __typename: "SEPACreditTransferInternalOutCreditor";
  /** BIC */
  BIC?: Maybe<Scalars["String"]["output"]>;
  /** IBAN */
  IBAN?: Maybe<Scalars["String"]["output"]>;
  /** account number */
  accountNumber: Scalars["AccountNumber"]["output"];
  /**
   * beneficiary if the beneficiary is already saved
   * *SOON TO BE DEPRECATED*
   * Always empty, It will be removed soon.
   * @deprecated this field is always empty. It will be removed soon.
   */
  beneficiary?: Maybe<InternalBeneficiary>;
  /** maskedIBAN */
  maskedIBAN: Scalars["String"]["output"];
  /** full name of the creditor */
  name: Scalars["String"]["output"];
  /** identifier of a Virtual IBAN */
  virtualIBANEntryId?: Maybe<Scalars["ID"]["output"]>;
};

/** Sepa Credit Transfer Creditor for Outgoing transaction */
export type SepaCreditTransferOutCreditor = SepaCreditTransferCreditor & {
  __typename: "SEPACreditTransferOutCreditor";
  /** BIC */
  BIC?: Maybe<Scalars["String"]["output"]>;
  /** IBAN */
  IBAN?: Maybe<Scalars["String"]["output"]>;
  /**
   * beneficiary if the beneficiary is already saved
   * *SOON TO BE DEPRECATED*
   * Always empty, It will be removed soon.
   * @deprecated this field is always empty. It will be removed soon.
   */
  beneficiary?: Maybe<SepaBeneficiary>;
  /** maskedIBAN */
  maskedIBAN: Scalars["String"]["output"];
  /** full name of the creditor */
  name: Scalars["String"]["output"];
};

/** Sepa Credit Transfer Debtor for internal transaction */
export type SepaCreditTransferOutDebtor = SepaCreditTransferDebtor & {
  __typename: "SEPACreditTransferOutDebtor";
  /** BIC */
  BIC?: Maybe<Scalars["String"]["output"]>;
  /** IBAN */
  IBAN?: Maybe<Scalars["String"]["output"]>;
  /**
   * account number
   * @deprecated because it is not already implemented (a default value is set).
   */
  accountNumber: Scalars["AccountNumber"]["output"];
  /** maskedIBAN */
  maskedIBAN: Scalars["String"]["output"];
  /** full name of the debtor */
  name: Scalars["String"]["output"];
  /** identifier of a Virtual IBAN */
  virtualIBANEntryId?: Maybe<Scalars["ID"]["output"]>;
};

/** Sepa Credit Transfer transaction */
export type SepaCreditTransferTransaction = Transaction & {
  __typename: "SEPACreditTransferTransaction";
  /** matching account for the transaction */
  account?: Maybe<Account>;
  /** amount */
  amount: Amount;
  /** SEPA beneficiary linked to the transaction */
  beneficiary?: Maybe<Beneficiary>;
  /** Result of the beneficiary verification */
  beneficiaryVerificationResult?: Maybe<VerifyBeneficiaryResult>;
  /** [DEPRECATED] booked balance after this transaction. Deprecated in favor of statusInfo.balance.amount on BookedTransactionStatusInfo */
  bookedBalanceAfter?: Maybe<Amount>;
  /**
   * ** COMING SOON**
   * categoryPurpose - Purpose of the payment transaction
   */
  categoryPurpose?: Maybe<CategoryPurpose>;
  /** name of the counterparty. e.g Merchant name, Creditor name, Beneficiary Name ... */
  counterparty: Scalars["String"]["output"];
  /** created date */
  createdAt: Scalars["DateTime"]["output"];
  /** creditor information */
  creditor: SepaCreditTransferCreditor;
  /** debtor information */
  debtor: SepaCreditTransferDebtor;
  /** a date that reflects the execution date of a transaction from a user viewpoint. Can be used for sorting transactions. */
  executionDate: Scalars["DateTime"]["output"];
  /**
   * an arbitrary identifier that was defined by you when you created this transaction.
   *
   * For example, you can define it in the CreditTransferInput mutation.
   */
  externalReference?: Maybe<Scalars["String"]["output"]>;
  /** unique identifier of the transaction */
  id: Scalars["ID"]["output"];
  /** `true` if this transaction can still be cancelled */
  isCancelable: Scalars["Boolean"]["output"];
  /** label (max 140 characters) */
  label: Scalars["String"]["output"];
  /** type of the label of the transaction. The default type is unstructured. */
  labelType: LabelType;
  /** origin transaction associated to this transaction */
  originTransaction?: Maybe<Transaction>;
  /** ID of the origin transaction associated to this transaction */
  originTransactionId?: Maybe<Scalars["String"]["output"]>;
  /** payment associated to this transaction */
  payment?: Maybe<Payment>;
  /** ID of the payment associated to this transaction */
  paymentId?: Maybe<Scalars["String"]["output"]>;
  /** payment method identifier used for this transaction. e.g masked PAN or IBAN or accountNumber */
  paymentMethodIdentifier: Scalars["String"]["output"];
  /** payment product used for this transaction */
  paymentProduct: PaymentProduct;
  /** project id of the transaction */
  projectId: Scalars["ID"]["output"];
  /** reference assigned by the initiating party, to unambiguously identify the transaction. This reference is passed on, unchanged, throughout the entire end-to-end chain. */
  reference: Scalars["String"]["output"];
  /** a date that reflects the time at which the user asked the transaction to be executed */
  requestedExecutionAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** r-transaction reason */
  returnReason?: Maybe<TransactionReasonCode>;
  /** side (Credit or Debit) */
  side: TransactionSide;
  /** true if a transaction statement can be generated for this transaction */
  statementCanBeGenerated?: Maybe<Scalars["Boolean"]["output"]>;
  /** status information */
  statusInfo: TransactionStatusInfo;
  supportingDocumentCollections: SupportingDocumentCollectionConnection;
  /** type */
  type: TransactionTypeEnum;
  /** updated date */
  updatedAt: Scalars["DateTime"]["output"];
};

/** Sepa Credit Transfer transaction */
export type SepaCreditTransferTransactionSupportingDocumentCollectionsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  filters?: InputMaybe<SupportingDocumentCollectionFilterInput>;
  first?: Scalars["Int"]["input"];
};

/** Sepa Direct Debit Creditor */
export type SepaDirectDebitCreditor = {
  /** BIC */
  BIC?: Maybe<Scalars["String"]["output"]>;
  /** IBAN */
  IBAN?: Maybe<Scalars["String"]["output"]>;
  /** maskedIBAN */
  maskedIBAN: Scalars["String"]["output"];
  /** full name of the creditor */
  name: Scalars["String"]["output"];
};

/** Sepa Direct Debit Debtor */
export type SepaDirectDebitDebtor = {
  /** BIC */
  BIC?: Maybe<Scalars["String"]["output"]>;
  /** IBAN */
  IBAN?: Maybe<Scalars["String"]["output"]>;
  /** maskedIBAN */
  maskedIBAN: Scalars["String"]["output"];
  /** full name of the debtor */
  name: Scalars["String"]["output"];
};

/** Sepa Direct Debit Creditor for Input transaction */
export type SepaDirectDebitInCreditor = SepaDirectDebitCreditor & {
  __typename: "SEPADirectDebitInCreditor";
  /** BIC */
  BIC?: Maybe<Scalars["String"]["output"]>;
  /** IBAN */
  IBAN?: Maybe<Scalars["String"]["output"]>;
  /** account number */
  accountNumber: Scalars["AccountNumber"]["output"];
  /** maskedIBAN */
  maskedIBAN: Scalars["String"]["output"];
  /** full name of the creditor */
  name: Scalars["String"]["output"];
  /** identifier of a Virtual IBAN */
  virtualIBANEntryId?: Maybe<Scalars["ID"]["output"]>;
};

/** Sepa Direct Debtor for Input transaction */
export type SepaDirectDebitInDebtor = SepaDirectDebitDebtor & {
  __typename: "SEPADirectDebitInDebtor";
  /** BIC */
  BIC?: Maybe<Scalars["String"]["output"]>;
  /** IBAN */
  IBAN?: Maybe<Scalars["String"]["output"]>;
  /**
   * beneficiary if the beneficiary is already saved
   * *SOON TO BE DEPRECATED*
   * Always empty, It will be removed soon.
   * @deprecated this field is always empty. It will be removed soon.
   */
  beneficiary?: Maybe<SepaBeneficiary>;
  /** maskedIBAN */
  maskedIBAN: Scalars["String"]["output"];
  /** full name of the debtor */
  name: Scalars["String"]["output"];
  /** identifier of a Virtual IBAN */
  virtualIBANEntryId?: Maybe<Scalars["ID"]["output"]>;
};

export type SepaDirectDebitMandate = {
  /** Unique identifier of the received direct debit mandate, generated by Swan */
  id: Scalars["ID"]["output"];
};

/** Sepa Direct Debit Creditor for Outgoing transaction */
export type SepaDirectDebitOutCreditor = SepaDirectDebitCreditor & {
  __typename: "SEPADirectDebitOutCreditor";
  /** BIC */
  BIC?: Maybe<Scalars["String"]["output"]>;
  /** IBAN */
  IBAN?: Maybe<Scalars["String"]["output"]>;
  /**
   * beneficiary if the beneficiary is already saved
   * *SOON TO BE DEPRECATED*
   * Always empty, It will be removed soon.
   * @deprecated this field is always empty. It will be removed soon.
   */
  beneficiary?: Maybe<SepaBeneficiary>;
  /** maskedIBAN */
  maskedIBAN: Scalars["String"]["output"];
  /** full name of the creditor (max 70 characters) */
  name: Scalars["String"]["output"];
  /** identifier of a Virtual IBAN */
  virtualIBANEntryId?: Maybe<Scalars["ID"]["output"]>;
};

/** Sepa Direct Debtor for Outgoing transaction */
export type SepaDirectDebitOutDebtor = SepaDirectDebitDebtor & {
  __typename: "SEPADirectDebitOutDebtor";
  /** BIC */
  BIC?: Maybe<Scalars["String"]["output"]>;
  /** IBAN */
  IBAN?: Maybe<Scalars["String"]["output"]>;
  /**
   * account number
   * @deprecated because it is not already implemented (a default value is set).
   */
  accountNumber: Scalars["AccountNumber"]["output"];
  /** maskedIBAN */
  maskedIBAN: Scalars["String"]["output"];
  /** full name of the debtor */
  name: Scalars["String"]["output"];
  /** identifier of a Virtual IBAN */
  virtualIBANEntryId?: Maybe<Scalars["ID"]["output"]>;
};

/** Scheme that will be used to create the underlying payment mandate for this funding source */
export type SepaDirectDebitScheme =
  /** Sepa Direct Debit B2B Scheme */
  | "SepaDirectDebitB2b"
  /** Sepa Direct Debit Core Scheme */
  | "SepaDirectDebitCore";

/** Sepa Direct Debit transaction */
export type SepaDirectDebitTransaction = Transaction & {
  __typename: "SEPADirectDebitTransaction";
  /** matching account for the transaction */
  account?: Maybe<Account>;
  /** amount */
  amount: Amount;
  /** [DEPRECATED] booked balance after this transaction. Deprecated in favor of statusInfo.balance.amount on BookedTransactionStatusInfo */
  bookedBalanceAfter?: Maybe<Amount>;
  /** name of the counterparty. e.g Merchant name, Creditor name, Beneficiary Name ... */
  counterparty: Scalars["String"]["output"];
  /** created date */
  createdAt: Scalars["DateTime"]["output"];
  /** creditor information */
  creditor: SepaDirectDebitCreditor;
  /** debtor information */
  debtor: SepaDirectDebitDebtor;
  /** a date that reflects the execution date of a transaction from a user viewpoint. Can be used for sorting transactions. */
  executionDate: Scalars["DateTime"]["output"];
  /**
   * an arbitrary identifier that was defined by you when you created this transaction.
   *
   * For example, you can define it in the CreditTransferInput mutation.
   */
  externalReference?: Maybe<Scalars["String"]["output"]>;
  /** unique identifier of the transaction */
  id: Scalars["ID"]["output"];
  /** `true` if this transaction can still be cancelled */
  isCancelable: Scalars["Boolean"]["output"];
  /** label */
  label: Scalars["String"]["output"];
  /** matching SEPA mandate for the transaction */
  mandate?: Maybe<SepaDirectDebitMandate>;
  /** merchant profile associated */
  merchant?: Maybe<MerchantProfile>;
  /** origin transaction associated to this transaction */
  originTransaction?: Maybe<Transaction>;
  /** ID of the origin transaction associated to this transaction */
  originTransactionId?: Maybe<Scalars["String"]["output"]>;
  /** payment associated to this transaction */
  payment?: Maybe<Payment>;
  /** ID of the payment associated to this transaction */
  paymentId?: Maybe<Scalars["String"]["output"]>;
  /** payment method identifier used for this transaction. e.g masked PAN or IBAN or accountNumber */
  paymentMethodIdentifier: Scalars["String"]["output"];
  /** payment product used for this transaction */
  paymentProduct: PaymentProduct;
  /** project id of the transaction */
  projectId: Scalars["ID"]["output"];
  /** reference assigned by the initiating party, to unambiguously identify the transaction. This reference is passed on, unchanged, throughout the entire end-to-end chain. */
  reference: Scalars["String"]["output"];
  /** a date that reflects the time at which the user asked the transaction to be executed */
  requestedExecutionAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** reserved amount of the transaction computed with the rolling reserve. */
  reservedAmount?: Maybe<Amount>;
  /** date on which reserved funds become available. */
  reservedAmountReleasedAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** r-transaction reason */
  returnReason?: Maybe<TransactionReasonCode>;
  /** side (Credit or Debit) */
  side: TransactionSide;
  /** true if a transaction statement can be generated for this transaction */
  statementCanBeGenerated?: Maybe<Scalars["Boolean"]["output"]>;
  /** status information */
  statusInfo: TransactionStatusInfo;
  supportingDocumentCollections: SupportingDocumentCollectionConnection;
  /** type */
  type: TransactionTypeEnum;
  /** updated date */
  updatedAt: Scalars["DateTime"]["output"];
};

/** Sepa Direct Debit transaction */
export type SepaDirectDebitTransactionSupportingDocumentCollectionsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  filters?: InputMaybe<SupportingDocumentCollectionFilterInput>;
  first?: Scalars["Int"]["input"];
};

/** Payment direct debit mandate for SEPA */
export type SepaPaymentDirectDebitMandate = PaymentDirectDebitMandate &
  PaymentMandate &
  SepaDirectDebitMandate & {
    __typename: "SEPAPaymentDirectDebitMandate";
    /** Account Holder information */
    accountHolder: AccountHolder;
    /** Creation date of the SEPA Direct Debit Payment Mandate */
    createdAt: Scalars["DateTime"]["output"];
    /** SEPA Direct Debit Payment Mandate creditor information */
    creditor: SepaPaymentMandateCreditor;
    /** SEPA Direct Debit Payment Mandate debtor information */
    debtor: SepaPaymentMandateDebtor;
    /** Date of the the last transaction executed for the concerned SEPA Direct Debit Payment Mandate */
    executedAt?: Maybe<Scalars["DateTime"]["output"]>;
    /** Expiry date of the SEPA Direct Debit Payment Mandate */
    expiredAt?: Maybe<Scalars["Date"]["output"]>;
    /** Unique identifier of the SEPA Direct Debit Payment Mandate */
    id: Scalars["ID"]["output"];
    /** SEPA Direct Debit Payment Mandate PDF document URL */
    mandateDocumentUrl: Scalars["String"]["output"];
    /** Custom name of the mandate */
    name?: Maybe<Scalars["String"]["output"]>;
    /** Unique reference of the SEPA Direct Debit Payment Mandate */
    reference: Scalars["String"]["output"];
    /** SEPA Direct Debit Payment Mandate scheme */
    scheme: SepaPaymentMandateScheme;
    /** SEPA Direct Debit Payment Mandate sequence */
    sequence: PaymentMandateSequence;
    /** Signature date of the SEPA Direct Debit Payment Mandate */
    signatureDate?: Maybe<Scalars["Date"]["output"]>;
    /** SEPA Direct Debit Payment Mandate status information */
    statusInfo: PaymentMandateStatusInfo;
    /**
     * List of transactions associated with the SEPA Payment Direct Debit Mandate.
     *
     * Implements the Relay Connection interface, used to paginate lists of elements. ([Learn More](https://docs.swan.io/developers/using-api/pagination))
     */
    transactions?: Maybe<TransactionConnection>;
    /** SEPA direct debit ultimate creditor name */
    ultimateCreditorName?: Maybe<Scalars["String"]["output"]>;
    /** Last Update date of the SEPA Direct Debit Payment Mandate */
    updatedAt: Scalars["DateTime"]["output"];
  };

/** Payment direct debit mandate for SEPA */
export type SepaPaymentDirectDebitMandateTransactionsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  filters?: InputMaybe<TransactionsFiltersInput>;
  first?: Scalars["Int"]["input"];
  orderBy?: InputMaybe<TransactionsOrderByInput>;
};

export type SepaPaymentMandateCreditor = PaymentMandateCreditor & {
  __typename: "SEPAPaymentMandateCreditor";
  /** SEPA Direct Debit Payment Mandate creditor address */
  address: Address;
  /** SEPA Direct Debit Payment Mandate creditor UUID */
  id: Scalars["ID"]["output"];
  /** SEPA Direct Debit Payment Mandate Sepa Creditor Idenfier (SCI) */
  identifier: Scalars["SepaCreditorIdentifier"]["output"];
  /** SEPA Direct Debit Payment Mandate creditor name */
  name: Scalars["String"]["output"];
};

export type SepaPaymentMandateDebtor = PaymentMandateDebtor & {
  __typename: "SEPAPaymentMandateDebtor";
  /** SEPA Direct Debit Payment Mandate debtor address. Mandatory for non EEA Countries */
  address?: Maybe<Address>;
  /** SEPA Direct Debit Payment Mandate debtor country */
  country: Scalars["CCA3"]["output"];
  /** SEPA Direct Debit Payment Mandate debtor e-mail */
  email?: Maybe<Scalars["String"]["output"]>;
  /** SEPA Direct Debit Payment Mandate debtor IBAN */
  iban: Scalars["IBAN"]["output"];
  /** SEPA Direct Debit Payment Mandate debtor name */
  name: Scalars["String"]["output"];
};

export type SepaPaymentMandateScheme =
  /** SEPA Direct Debit B2B */
  | "SepaDirectDebitB2b"
  /** SEPA Direct Debit Core */
  | "SepaDirectDebitCore";

/** Received direct debit mandate for SEPA */
export type SepaReceivedDirectDebitMandate = ReceivedDirectDebitMandate &
  SepaDirectDebitMandate & {
    __typename: "SEPAReceivedDirectDebitMandate";
    /** Account of the received SEPA direct debit mandate debtor */
    account?: Maybe<Account>;
    /** Creation date of the received SEPA direct debit mandate */
    createdAt: Scalars["DateTime"]["output"];
    /** Received SEPA direct debit creditor */
    creditor: SepaReceivedDirectDebitMandateCreditor;
    /** Date of the last SEPA direct debit transaction executed for the concerned received SEPA direct debit mandate */
    executedAt?: Maybe<Scalars["DateTime"]["output"]>;
    /** Expiry date of the received SEPA direct debit mandate, computed automatically (36 months from the executedAt date) */
    expiredAt?: Maybe<Scalars["Date"]["output"]>;
    /** Iban of the received SEPA direct debit mandate debtor */
    iban: Scalars["IBAN"]["output"];
    /** Unique identifier of the Card Payment Mandate */
    id: Scalars["ID"]["output"];
    /** Mandate name */
    name?: Maybe<Scalars["String"]["output"]>;
    /** Received SEPA direct debit Unique Mandate Reference (UMR) */
    reference: Scalars["String"]["output"];
    /** Received SEPA direct debit mandate scheme */
    scheme: SepaReceivedDirectDebitMandateScheme;
    /** Received SEPA direct debit mandate sequence */
    sequence: SepaReceivedDirectDebitMandateSequence;
    /** Date of signature of the received SEPA direct debit mandate */
    signatureDate?: Maybe<Scalars["Date"]["output"]>;
    /** Mandate status information of the received SEPA direct debit mandate */
    statusInfo: ReceivedDirectDebitMandateStatusInfo;
    /**
     * List of transactions associated with the SEPA Receive Direct Debit Mandate.
     *
     * Implements the Relay Connection interface, used to paginate lists of elements. ([Learn More](https://docs.swan.io/developers/using-api/pagination))
     */
    transactions?: Maybe<TransactionConnection>;
    /** Received SEPA direct debit ultimate creditor name */
    ultimateCreditorName?: Maybe<Scalars["String"]["output"]>;
    /** Last Update date of the received SEPA direct debit mandate */
    updatedAt: Scalars["DateTime"]["output"];
    /** Version of the received SEPA direct debit mandate */
    version: Scalars["String"]["output"];
  };

/** Received direct debit mandate for SEPA */
export type SepaReceivedDirectDebitMandateTransactionsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  filters?: InputMaybe<TransactionsFiltersInput>;
  first?: Scalars["Int"]["input"];
  orderBy?: InputMaybe<TransactionsOrderByInput>;
};

/** SEPA received direct debit mandate creditor */
export type SepaReceivedDirectDebitMandateCreditor = {
  __typename: "SEPAReceivedDirectDebitMandateCreditor";
  /** Address of the SEPA creditor */
  address: Address;
  /** SEPA Creditor identifier (SCI) */
  identifier: Scalars["String"]["output"];
  /** Name of the SEPA creditor */
  name: Scalars["String"]["output"];
};

/** Received SEPA direct debit mandate scheme */
export type SepaReceivedDirectDebitMandateScheme =
  /** When the received SEPA direct debit mandate can only be used for SEPA B2B direct debit transactions */
  | "SepaDirectDebitB2b"
  /** When the received SEPA direct debit mandate can only be used for SEPA Core direct debit transactions */
  | "SepaDirectDebitCore";

/** SEPA received direct debit mandate sequence */
export type SepaReceivedDirectDebitMandateSequence =
  /** When the authorisation is given once by the SEPA Debtor to collect only one single SEPA direct debit */
  | "OneOff"
  /** When the authorisation by the Debtor can be used for regular SEPA direct debits initiated by the Creditor */
  | "Recurrent";

export type ScheduleStandingOrderInput = {
  /** Account the Standing Order will be attached to */
  accountId: Scalars["String"]["input"];
  /**
   * Fix Amount that will be periodically transferred
   * *the value must be empty when `targetAvailableBalance` is defined*
   */
  amount?: InputMaybe<AmountInput>;
  /** URL the user is redirected to after consent has been given */
  consentRedirectUrl: Scalars["String"]["input"];
  /** Transfer mode of the Standing Order */
  creditTransferMode?: InputMaybe<CreditTransferMode>;
  /** Earlier date the Standing Order will be executed */
  firstExecutionDate?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** label (max 140 characters) */
  label?: InputMaybe<Scalars["String"]["input"]>;
  /** Latest date the Standing Order will be executed */
  lastExecutionDate?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** Scheduled period of Standing Order */
  period: StandingOrderPeriod;
  /** reference assigned by the initiating party, to unambiguously identify the transaction. This reference is passed on, unchanged, throughout the entire end-to-end chain. (regex [A-Za-z0-9(\\-)(\\_)(\\?)(\\.)(\\+),' ]{1,35}) */
  reference?: InputMaybe<Scalars["String"]["input"]>;
  /** SEPA beneficiary of the Standing ORder */
  sepaBeneficiary?: InputMaybe<SepaBeneficiaryInput>;
  /**
   * Target available balance that will be used for periodically clipping the account
   * *the value must be empty when `amount` is defined*
   */
  targetAvailableBalance?: InputMaybe<AmountInput>;
};

export type ScheduleStandingOrderPayload =
  | ForbiddenRejection
  | InternalErrorRejection
  | InvalidArgumentRejection
  | ScheduleStandingOrderSuccessPayload;

export type ScheduleStandingOrderSuccessPayload = {
  __typename: "ScheduleStandingOrderSuccessPayload";
  /** Result of the beneficiary verification */
  beneficiaryVerificationResult?: Maybe<VerifyBeneficiaryResult>;
  standingOrder: StandingOrder;
};

export type Scheme = {
  __typename: "Scheme";
  fields: Array<Field>;
  remainingFieldsToRefreshCount: Scalars["Int"]["output"];
  title: Scalars["String"]["output"];
  type: InternationalCreditTransferRouteInput;
};

/** Rejection returned when adding a B2B mandate with an Individual debtor */
export type SchemeWrongRejection = Rejection & {
  __typename: "SchemeWrongRejection";
  message: Scalars["String"]["output"];
};

export type SelectField = Field & {
  __typename: "SelectField";
  allowedValues: Array<AllowedValue>;
  key: Scalars["String"]["output"];
  name: Scalars["String"]["output"];
  refreshDynamicFieldsOnChange: Scalars["Boolean"]["output"];
  required: Scalars["Boolean"]["output"];
};

/** Inputs to send an account membership invitation */
export type SendAccountMembershipInviteNotificationInput = {
  /** Unique identifier of a given account membership to invite */
  accountMembershipId: Scalars["ID"]["input"];
};

export type SendAccountMembershipInviteNotificationPayload =
  | AccountMembershipNotFoundRejection
  | AccountMembershipStatusNotEligibleRejection
  | ForbiddenRejection
  | MaximumDailyInvitationsReachedRejection
  | SendAccountMembershipInviteNotificationSuccessPayload
  | UserNotAllowedToManageAccountMembershipRejection
  | UserNotAllowedToSendAccountMembershipInvitationRejection
  | ValidationRejection;

/** Result when invitation notification request is successfully sent */
export type SendAccountMembershipInviteNotificationSuccessPayload = {
  __typename: "SendAccountMembershipInviteNotificationSuccessPayload";
  notificationRequestId: Scalars["ID"]["output"];
};

/** Sepa beneficiary account */
export type SepaBeneficiaryInput = {
  /** beneficiary address */
  address?: InputMaybe<AddressInput>;
  /** International Bank Account Number */
  iban: Scalars["IBAN"]["input"];
  /** Full name of the beneficiary (min 2 characters, max 70 characters). The name should not include any special characters. */
  name: Scalars["String"]["input"];
  /** `true` if this new beneficiary will be saved to the beneficiary list of the debited account. */
  save?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** SepaDirectDebitB2BMerchantPaymentMethod */
export type SepaDirectDebitB2BMerchantPaymentMethod = MerchantPaymentMethod & {
  __typename: "SepaDirectDebitB2BMerchantPaymentMethod";
  /** Date at which the Merchant Payment Method was created */
  createdAt: Scalars["Date"]["output"];
  /** Unique identifier tied to every version of a given Merchant Payment Method */
  id: Scalars["ID"]["output"];
  /** Merchant Profile to which the Payment Method is attached */
  merchantProfile: MerchantProfile;
  /** Unique identifier for a given merchant Payment Method, identical for every version of a given Merchant Payment Method Type */
  methodId: Scalars["ID"]["output"];
  /** The Merchant Payment Method payment amount limit */
  paymentAmountLimit?: Maybe<Amount>;
  /** Rolling Reserve applied to the Merchant Payment Method */
  rollingReserve?: Maybe<RollingReserve>;
  /** When the above is false, the value of the Sepa Creditor Identifier used */
  sepaCreditorIdentifier?: Maybe<Scalars["String"]["output"]>;
  /** Status of the Merchant Payment Method */
  statusInfo: MerchantPaymentMethodStatusInfo;
  /** The Merchant Payment Method Type */
  type: MerchantPaymentMethodType;
  updateRequest?: Maybe<SepaDirectDebitPaymentMethodUpdateRequest>;
  /** Date at which the Merchant Payment Method was last updated */
  updatedAt: Scalars["Date"]["output"];
  /** Whether this payment method uses the Swan Sepa Creditor Identifier */
  useSwanSepaCreditorIdentifier: Scalars["Boolean"]["output"];
  /** Version of the Merchant Payment Method */
  version: Scalars["Int"]["output"];
};

export type SepaDirectDebitB2BPaymentMethodInput = {
  /** If `true`, the Payment Method will be Enabled */
  activate?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Your own SCI - Mandatory if the useSwanCreditorIdentifier is set to false, otherwise Swan does not take this input into account (even if not empty) */
  sepaCreditorIdentifier?: InputMaybe<Scalars["String"]["input"]>;
  /** If `true`, the transaction will be created with the Swan Creditor Identifier */
  useSwanSepaCreditorIdentifier?: Scalars["Boolean"]["input"];
};

export type SepaDirectDebitB2b = {
  __typename: "SepaDirectDebitB2b";
  /** The mandate used for the Sepa Direct Debit B2B. */
  mandate?: Maybe<ReceivedDirectDebitMandate>;
};

/** SepaDirectDebitCoreMerchantPaymentMethod */
export type SepaDirectDebitCoreMerchantPaymentMethod = MerchantPaymentMethod & {
  __typename: "SepaDirectDebitCoreMerchantPaymentMethod";
  /** Date at which the Merchant Payment Method was created */
  createdAt: Scalars["Date"]["output"];
  /** Unique identifier tied to every version of a given Merchant Payment Method */
  id: Scalars["ID"]["output"];
  /** Merchant Profile to which the Payment Method is attached */
  merchantProfile: MerchantProfile;
  /** Unique identifier for a given merchant Payment Method, identical for every version of a given Merchant Payment Method Type */
  methodId: Scalars["ID"]["output"];
  /** The Merchant Payment Method payment amount limit */
  paymentAmountLimit?: Maybe<Amount>;
  /** Rolling Reserve applied to the Merchant Payment Method */
  rollingReserve?: Maybe<RollingReserve>;
  /** When the above is false, the value of the Sepa Creditor Identifier used */
  sepaCreditorIdentifier?: Maybe<Scalars["String"]["output"]>;
  /** Status of the Merchant Payment Method */
  statusInfo: MerchantPaymentMethodStatusInfo;
  /** The Merchant Payment Method Type */
  type: MerchantPaymentMethodType;
  updateRequest?: Maybe<SepaDirectDebitPaymentMethodUpdateRequest>;
  /** Date at which the Merchant Payment Method was last updated */
  updatedAt: Scalars["Date"]["output"];
  /** Whether this payment method uses the Swan Sepa Creditor Identifier */
  useSwanSepaCreditorIdentifier: Scalars["Boolean"]["output"];
  /** Version of the Merchant Payment Method */
  version: Scalars["Int"]["output"];
};

export type SepaDirectDebitCorePaymentMethodInput = {
  /** If `true`, the Payment Method will be Pending Review */
  activate?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Your own SCI - Mandatory if the useSwanCreditorIdentifier is set to false, otherwise Swan does not take this input into account (even if not empty) */
  sepaCreditorIdentifier?: InputMaybe<Scalars["String"]["input"]>;
  /** If `true`, the transaction will be created with the Swan Creditor Identifier */
  useSwanSepaCreditorIdentifier?: Scalars["Boolean"]["input"];
};

export type SepaDirectDebitMerchantPayment = MerchantPayment & {
  __typename: "SepaDirectDebitMerchantPayment";
  /** amount */
  amount: Amount;
  /**
   * Authorized date
   * @deprecated use authorizedAt in statusInfo instead
   */
  authorizedAt?: Maybe<Scalars["DateTime"]["output"]>;
  balance: MerchantBalance;
  /** The billing address associated to the payment */
  billingAddress?: Maybe<Address>;
  /**
   * Canceled date
   * @deprecated use canceledAt in statusInfo instead
   */
  canceledAt?: Maybe<Scalars["DateTime"]["output"]>;
  /**
   * Captured date
   * @deprecated use capturedAt in statusInfo instead
   */
  capturedAt?: Maybe<Scalars["DateTime"]["output"]>;
  /**
   * Created date
   * @deprecated use createdAt in statusInfo instead
   */
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  /**
   * Disputed date
   * @deprecated use disputedAt in statusInfo instead
   */
  disputedAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** an arbitrary identifier that was defined by you when you created this payment */
  externalReference?: Maybe<Scalars["String"]["output"]>;
  /** unique identifier of a merchant payment */
  id: Scalars["ID"]["output"];
  /** Label */
  label?: Maybe<Scalars["String"]["output"]>;
  /** merchant profile associated to the merchant payment */
  merchantProfile: MerchantProfile;
  /** payment link associated to the merchant payment */
  paymentLink?: Maybe<MerchantPaymentLink>;
  /** payment link associated to the merchant payment */
  paymentMandate: PaymentMandate;
  /** payment method associated to the merchant payment */
  paymentMethod: MerchantPaymentMethod;
  reference?: Maybe<Scalars["String"]["output"]>;
  /**
   * Refunded date
   * @deprecated use refundedAt in statusInfo instead
   */
  refundedAt?: Maybe<Scalars["DateTime"]["output"]>;
  /**
   * Rejected date
   * @deprecated use rejectedAt in statusInfo instead
   */
  rejectedAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** status information */
  statusInfo: MerchantPaymentStatusInfo;
  /**
   * List of transactions associated with the Merchant Payment.
   *
   * Implements the Relay Connection interface, used to paginate lists of elements. ([Learn More](https://docs.swan.io/developers/using-api/pagination))
   */
  transactions?: Maybe<TransactionConnection>;
  /** Updated date */
  updatedAt: Scalars["DateTime"]["output"];
};

export type SepaDirectDebitMerchantPaymentTransactionsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  filters?: InputMaybe<TransactionsFiltersInput>;
  first?: Scalars["Int"]["input"];
  orderBy?: InputMaybe<TransactionsOrderByInput>;
};

export type SepaDirectDebitPaymentCollectionInput = {
  /** Payment Mandate ID generated by Swan */
  mandateId: Scalars["ID"]["input"];
  /** Date at which the Swan merchant wishes the payment to be executed */
  requestedExecutionAt?: InputMaybe<Scalars["DateTime"]["input"]>;
};

export type SepaDirectDebitPaymentMethodInput = {
  /** Your own SCI - Mandatory if the useSwanCreditorIdentifier is set to false */
  sepaCreditorIdentifier?: InputMaybe<Scalars["String"]["input"]>;
  /** If `true`, the transaction will be created with the Swan Creditor Identifier */
  useSwanSepaCreditorIdentifier?: Scalars["Boolean"]["input"];
};

export type SepaDirectDebitPaymentMethodUpdateRequest = MerchantPaymentMethodUpdateRequest & {
  __typename: "SepaDirectDebitPaymentMethodUpdateRequest";
  id: Scalars["ID"]["output"];
  /** Your own SCI - Mandatory if the useSwanCreditorIdentifier is set to false */
  sepaCreditorIdentifier?: Maybe<Scalars["String"]["output"]>;
  /** If `true`, the transaction will be created with the Swan Creditor Identifier */
  useSwanSepaCreditorIdentifier: Scalars["Boolean"]["output"];
};

export type SepaPaymentMandateDebtorInput = {
  /** SEPA Direct Debit Payment Mandate debtor IBAN */
  IBAN: Scalars["String"]["input"];
  address: AddressInput;
  /** SEPA Direct Debit Payment Mandate debtor name */
  name: Scalars["String"]["input"];
};

/** Rejection returned when signature is not valid or remote IP address is not allowed */
export type ServerConsentCredentialsNotValidOrOutdatedRejection = Rejection & {
  __typename: "ServerConsentCredentialsNotValidOrOutdatedRejection";
  message: Scalars["String"]["output"];
};

/** Rejection returned when server consent is not allowed on the consent */
export type ServerConsentNotAllowedForConsentOperationRejection = Rejection & {
  __typename: "ServerConsentNotAllowedForConsentOperationRejection";
  message: Scalars["String"]["output"];
};

/** Rejection returned when server consent is not allowed for the project associated with the consent */
export type ServerConsentNotAllowedForProjectRejection = Rejection & {
  __typename: "ServerConsentNotAllowedForProjectRejection";
  message: Scalars["String"]["output"];
};

/** Rejection returned when there are no server consent credentials for the project */
export type ServerConsentProjectCredentialMissingRejection = Rejection & {
  __typename: "ServerConsentProjectCredentialMissingRejection";
  message: Scalars["String"]["output"];
};

/** Rejection returned when the server consent project credentials are not found */
export type ServerConsentProjectCredentialNotFoundRejection = Rejection & {
  __typename: "ServerConsentProjectCredentialNotFoundRejection";
  message: Scalars["String"]["output"];
};

/** Rejection returned when the server consent project settings are not found */
export type ServerConsentProjectSettingsNotFoundRejection = Rejection & {
  __typename: "ServerConsentProjectSettingsNotFoundRejection";
  message: Scalars["String"]["output"];
};

/**
 * Rejection returned when the signature is not valid
 * @Deprecated
 */
export type ServerConsentSignatureNotValidRejection = Rejection & {
  __typename: "ServerConsentSignatureNotValidRejection";
  message: Scalars["String"]["output"];
};

/** Settled transaction status information */
export type SettledTransactionStatusInfo = TransactionStatusInfo & {
  __typename: "SettledTransactionStatusInfo";
  /** unique identifier of the transaction */
  id: Scalars["ID"]["output"];
  /** the date when the transaction got settled. */
  settledAt: Scalars["Date"]["output"];
  /** the booked transaction which settled this transaction. */
  settlementTransactionId: Scalars["String"]["output"];
  /** status of the transaction */
  status: TransactionStatus;
};

export type Sex = "Female" | "Male" | "Unknown";

/** Shareholder of a company creating a Capital Deposit Case */
export type Shareholder = {
  __typename: "Shareholder";
  /** Unique identifier of the shareholder account. */
  accountId?: Maybe<Scalars["String"]["output"]>;
  /** Amount the shareholder has to deposit. */
  capitalDepositAmount: Amount;
  /** Created date */
  createdAt: Scalars["DateTime"]["output"];
  /** Shareholder documents for the capital deposit case */
  documents: Array<CapitalDepositDocument>;
  /** Unique identifier of a shareholder. */
  id: Scalars["ID"]["output"];
  /** Extra information about the shareholder */
  info: ShareholderInfo;
  /** Onboarding information of the shareholder. */
  onboarding?: Maybe<Onboarding>;
  /** Information about capital deposit case. */
  relatedCapitalDepositCase: CapitalDepositCase;
  /** Status of the shareholder during the process with Swan. */
  status: ShareholderStatus;
  /** Updated date */
  updatedAt: Scalars["DateTime"]["output"];
};

/** Shareholder information. */
export type ShareholderInfo = CompanyShareholder | IndividualShareholder;

/** Status of the shareholder during the process with Swan. */
export type ShareholderStatus =
  /** When the capital deposit of the shareholder is canceled. */
  | "CapitalDepositCanceled"
  /** When the shareholder's capital is wired to the notary. */
  | "CapitalFundsWiredToNotary"
  /** When the shareholder has wired their share of the capital. */
  | "CapitalTransferred"
  /** Waiting for the shareholder to finalize their onboarding. */
  | "PendingOnboarding"
  /** Waiting for the shareholder to wire their share of the capital on their temporary Swan account. */
  | "WaitingForTransfer"
  /** Waiting for Swan compliance team to verify the shareholder. */
  | "WaitingForVerification";

/** Shareholder type to identify individuals and companies. */
export type ShareholderType =
  /** Company shareholder type. */
  | "Company"
  /** Individual shareholder type. */
  | "Individual";

export type ShippingProvider =
  | "CorreosTracked"
  | "CorreosUntracked"
  | "DHL"
  | "LaPosteTracked"
  | "LaPosteUntracked"
  | "NACEX";

/** Signature data used during apple pay inApp provisioning */
export type SignatureData = {
  /** list of apple generated certificates */
  certificates: Array<Certificate>;
  /** nonce */
  nonce: Scalars["String"]["input"];
  /** nonce signed by the secure element */
  nonceSignature: Scalars["String"]["input"];
};

export type SimulationCardType = "Physical" | "Virtual";

export type SingleUseVirtualCardConfigInput = {
  /** Unique identifier of a given account membership */
  accountMembershipId: Scalars["ID"]["input"];
  /** Card expiration date only for Single Use Virtual Card One-off, if `null` the Single Use Virtual Card will have a default expiration of plus 30 days */
  cardContractExpiryDate?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** Card name */
  name?: InputMaybe<Scalars["String"]["input"]>;
  /** Spending limit */
  spendingLimit: SpendingLimitInput;
};

export type SmsProviderRejection = Rejection & {
  __typename: "SmsProviderRejection";
  message: Scalars["String"]["output"];
};

/** Spending */
export type Spending = {
  __typename: "Spending";
  /** amount spent during the period */
  amount?: Maybe<Amount>;
  /** period concerned */
  period: SpendingLimitPeriod;
};

/** Spending limits */
export type SpendingLimit = {
  __typename: "SpendingLimit";
  /** sum of amount of spending authorized during the period */
  amount: Amount;
  /** period concerned */
  period: SpendingLimitPeriod;
  /** type of limit (defined by the Partner, defined by Swan, etc.) */
  type: SpendingLimitType;
};

export type SpendingLimitCalendarDayModeInput = {
  /** a starting hour for the spending limit (0 to 23). */
  startHour?: Scalars["Int"]["input"];
};

export type SpendingLimitCalendarModeInput = {
  /** a daily based calendar spending limit. */
  daily?: InputMaybe<SpendingLimitCalendarDayModeInput>;
  /** a monthly based calendar spending limit. */
  monthly?: InputMaybe<SpendingLimitCalendarMonthModeInput>;
  /** a weekly based calendar spending limit. */
  weekly?: InputMaybe<SpendingLimitCalendarWeekModeInput>;
};

export type SpendingLimitCalendarMonthModeInput = {
  /** a day in month for the spending limit (1 to 31). */
  startDay?: Scalars["Int"]["input"];
  /** a starting hour for the spending limit (0 to 23). */
  startHour?: Scalars["Int"]["input"];
};

export type SpendingLimitCalendarWeekModeInput = {
  /** a day of week enum. */
  startDay?: DayEnum;
  /** a starting hour for the spending limit (0 to 23). */
  startHour?: Scalars["Int"]["input"];
};

/** Inputs when editing spending limit configuration */
export type SpendingLimitInput = {
  /** sum of amount of spending authorized during the period */
  amount: AmountInput;
  /** period concerned */
  period: SpendingLimitPeriodInput;
};

export type SpendingLimitModeInput = {
  /** a fixed calendar period starting either at a given hour of day, a given hour and day in week/month */
  calendar?: InputMaybe<SpendingLimitCalendarModeInput>;
  /** a rolling period, defining a period of x days/weeks/months. */
  rolling?: InputMaybe<SpendingLimitRollingModeInput>;
};

/** Available period to compute spending limits */
export type SpendingLimitPeriod = "Always" | "Daily" | "Monthly" | "Weekly";

/** Available period to compute spending limits */
export type SpendingLimitPeriodInput = "Always" | "Daily" | "Monthly" | "Weekly";

export type SpendingLimitRollingModeInput = {
  /** a rolling value for a spending limit. For a monthly period, only 1 is valid. */
  rollingValue: Scalars["Int"]["input"];
};

/** Available type of spending limits */
export type SpendingLimitType =
  /** for the account holder - defined by the partner */
  | "AccountHolder"
  /** for the partner - defined by Swan */
  | "Partner";

export type StandingOrder = {
  __typename: "StandingOrder";
  /** Account of the Standing Order */
  account: Account;
  /** Fixed Amount that will be regularly transferred */
  amount?: Maybe<Amount>;
  /** Date the Standing Order has been created */
  createdAt: Scalars["Date"]["output"];
  /** Identity that scheduled the Standing Order */
  createdBy: User;
  /** Transfer mode of the Standing Order */
  creditTransferMode?: Maybe<CreditTransferMode>;
  /** Earlier date the Standing Order will be executed */
  firstExecutionDate?: Maybe<Scalars["DateTime"]["output"]>;
  /** Standing Order unique identifier */
  id: Scalars["ID"]["output"];
  /** label that will be transferred to the beneficiary */
  label?: Maybe<Scalars["String"]["output"]>;
  /** Latest date the Standing Order will be executed */
  lastExecutionDate?: Maybe<Scalars["DateTime"]["output"]>;
  /** Next execution date of the Standing Order, if any */
  nextExecutionDate?: Maybe<Scalars["Date"]["output"]>;
  /**
   * List of payments of an standing order.
   *
   * Implements the Relay Connection interface, used to paginate lists of elements. ([Learn More](https://docs.swan.io/developers/using-api/pagination))
   */
  payments: PaymentConnection;
  /** Scheduled period of Standing Order */
  period: StandingOrderPeriod;
  /** reference that will be transferred to the beneficiary throughout the entire end-to-end chain */
  reference?: Maybe<Scalars["String"]["output"]>;
  /**
   * *SOON TO BE DEPRECATED*
   * SEPA beneficiary of the Standing Order
   */
  sepaBeneficiary: SepaBeneficiary;
  /** Status of the Standing Order */
  statusInfo: StandingOrderStatusInfo;
  /** Target available balance value that will be used for periodically clipping the account */
  targetAvailableBalance?: Maybe<Amount>;
  /**
   * List of transactions of a standing order.
   *
   * Implements the Relay Connection interface, used to paginate lists of elements. ([Learn More](https://docs.swan.io/developers/using-api/pagination))
   */
  transactions?: Maybe<TransactionConnection>;
  /** Last date the Standing Order has been updated */
  updatedAt: Scalars["Date"]["output"];
};

export type StandingOrderPaymentsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  filters?: InputMaybe<PaymentFiltersInput>;
  first?: Scalars["Int"]["input"];
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<PaymentOrderByInput>;
};

export type StandingOrderTransactionsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  filters?: InputMaybe<TransactionsFiltersInput>;
  first?: Scalars["Int"]["input"];
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<TransactionsOrderByInput>;
};

export type StandingOrderCanceledStatusInfo = StandingOrderStatusInfo & {
  __typename: "StandingOrderCanceledStatusInfo";
  canceledAt: Scalars["Date"]["output"];
  status: StandingOrderStatus;
};

/** Please see the Connection interface */
export type StandingOrderConnection = Connection & {
  __typename: "StandingOrderConnection";
  edges: Array<StandingOrderEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars["Int"]["output"];
};

export type StandingOrderConsentPendingStatusInfo = StandingOrderStatusInfo & {
  __typename: "StandingOrderConsentPendingStatusInfo";
  consent: Consent;
  status: StandingOrderStatus;
};

/** Please see the Connection interface */
export type StandingOrderEdge = Edge & {
  __typename: "StandingOrderEdge";
  cursor: Scalars["String"]["output"];
  node: StandingOrder;
};

export type StandingOrderEnabledStatusInfo = StandingOrderStatusInfo & {
  __typename: "StandingOrderEnabledStatusInfo";
  status: StandingOrderStatus;
};

/** Rejection returned when Standing Order is not found */
export type StandingOrderNotFoundRejection = Rejection & {
  __typename: "StandingOrderNotFoundRejection";
  message: Scalars["String"]["output"];
};

export type StandingOrderPeriod = "Daily" | "Monthly" | "Weekly";

export type StandingOrderStatus = "Canceled" | "ConsentPending" | "Enabled";

export type StandingOrderStatusInfo = {
  status: StandingOrderStatus;
};

export type StartUserCreationInput = {
  locale?: InputMaybe<OtpLocale>;
  mobilePhoneNumber: Scalars["PhoneNumber"]["input"];
};

export type StartUserCreationPayload =
  | BlacklistedPhoneNumberRejection
  | BlocklistedPhoneNumberRejection
  | CalledByABotRejection
  | OperationNotAllowedRejection
  | StartUserCreationSuccess;

export type StartUserCreationSuccess = {
  __typename: "StartUserCreationSuccess";
  requestId: Scalars["String"]["output"];
};

/** Describes an identification level that has started for the process of the current identification */
export type StartedIdentificationLevelStatusInfo = {
  __typename: "StartedIdentificationLevelStatusInfo";
  /** Always set to `Started` */
  status: SwanIdentificationStatus;
};

/** A statement represent metadata around a banking document that list all of the BOOKED banking transactions that have happened between startDate and endDate */
export type Statement = {
  __typename: "Statement";
  /** account of the statement */
  account: Account;
  /** booked balance at the end of the window */
  closingBalance: Amount;
  /** ending date of the date window */
  closingDate: Scalars["DateTime"]["output"];
  /** created date */
  createdAt: Scalars["DateTime"]["output"];
  /** [NEW] the sum of credit fee transactions during the window */
  feeCredits: Amount;
  /** [NEW] the sum of debit fee transactions during the window */
  feeDebits: Amount;
  /** [DEPRECATED] the sum of fee transactions during the window */
  fees: Amount;
  /** [NEW] format of statements (ex: PDF) */
  format: AccountStatementFormat;
  /** unique identifier of the statement */
  id: Scalars["ID"]["output"];
  /** booked balance at the start of the window */
  openingBalance: Amount;
  /** starting date of the date window */
  openingDate: Scalars["DateTime"]["output"];
  /** period of statement (either custom or monthly) */
  period?: Maybe<StatementPeriod>;
  /** [DEPRECATED] status of the statement */
  status: StatementStatus;
  /** [NEW] status of the statement */
  statusInfo: AccountStatementStatusInfo;
  /** the sum of credit transactions during the window */
  totalCredits: Amount;
  /** the sum of debit transactions during the window */
  totalDebits: Amount;
  /** [DEPRECATED] type of statements (ex: PDF) */
  type: Array<Maybe<StatementInfo>>;
  /** updated date */
  updatedAt: Scalars["DateTime"]["output"];
};

/** Implements the Relay Connection interface, used to paginate lists of elements. ([Learn More](https://docs.swan.io/developers/using-api/pagination)). */
export type StatementConnection = Connection & {
  __typename: "StatementConnection";
  edges: Array<StatementEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars["Int"]["output"];
};

/** Implements the Relay Edge interface. */
export type StatementEdge = Edge & {
  __typename: "StatementEdge";
  cursor: Scalars["String"]["output"];
  node: Statement;
};

/** Filter that can be given to give the statement in a specific data range */
export type StatementFiltersInput = {
  /** To filter after an updatedAt value */
  isAfterUpdatedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** To filter before an updatedAt value */
  isBeforeUpdatedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** To filter on a specific period of statement (either custom or monthly) */
  period?: InputMaybe<StatementPeriod>;
};

/** [DEPRECATED] Custom information for a certain type of statement */
export type StatementInfo = {
  type?: Maybe<StatementType>;
};

/** The different periods of statement */
export type StatementPeriod = "Custom" | "Monthly";

/** [DEPRECATED] The different statuses of statement */
export type StatementStatus = "Available" | "Failed" | "Pending";

/**
 * [DEPRECATED] The different type of statement actually available
 * - PDF will be a PDF file with the statement information
 */
export type StatementType = "CSV" | "PDF";

export type StatementsOrderByField = "closingDate" | "openingDate";

/** [NEW] The criteria to sort statements */
export type StatementsOrderByInput = {
  direction?: InputMaybe<OrderByDirection>;
  field?: InputMaybe<StatementsOrderByField>;
};

export type StatusText = "Failure" | "Success";

/** Rejection returned when the corresponding export is still ongoing. */
export type StillExportingRejection = Rejection & {
  __typename: "StillExportingRejection";
  message: Scalars["String"]["output"];
};

/** Rejection returned when subscription limit has been reached for specific eventTypes */
export type SubscriptionLimitsRejection = Rejection & {
  __typename: "SubscriptionLimitsRejection";
  message: Scalars["String"]["output"];
  subscriptionLimits: Array<Maybe<EventTypeHavingReachedSubscriptionLimits>>;
};

export type SucceededThreeDsStatusInfo = ThreeDsStatusInfo & {
  __typename: "SucceededThreeDsStatusInfo";
  status: IncomingThreeDsStatus;
};

/** Supporting document used for compliance */
export type SupportingDocument = {
  __typename: "SupportingDocument";
  /** Created date */
  createdAt: Scalars["DateTime"]["output"];
  /** Unique identifier of the document */
  id: Scalars["String"]["output"];
  /** Supporting document status information */
  statusInfo: SupportingDocumentStatusInfo;
  /** Purpose of supporting document */
  supportingDocumentPurpose: SupportingDocumentPurposeEnum;
  /** Type of supporting Document */
  supportingDocumentType?: Maybe<SupportingDocumentType>;
  /** Updated date */
  updatedAt: Scalars["DateTime"]["output"];
};

export type SupportingDocumentAccountHolder = {
  __typename: "SupportingDocumentAccountHolder";
  id?: Maybe<Scalars["ID"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
};

export type SupportingDocumentCollectMode =
  | "API"
  | "EndCustomer"
  | "EndCustomerCcPartner"
  | "Partner";

/**
 * Collection of supporting documents used for compliance
 *
 * Fetching SupportingDocument is restricted to Project access token
 */
export type SupportingDocumentCollection = {
  __typename: "SupportingDocumentCollection";
  accountHolder: SupportingDocumentAccountHolder;
  /** Created date */
  createdAt: Scalars["DateTime"]["output"];
  /** Unique identifier of the supporting document collection */
  id: Scalars["String"]["output"];
  onboarding: SupportingDocumentOnboarding;
  projectInfo: ProjectInfo;
  relatedInfo: SupportingDocumentCollectionRelatedInfo;
  /** List of required supporting document purposes for this supporting document collection */
  requiredSupportingDocumentPurposes: Array<SupportingDocumentPurpose>;
  /** Status of the supporting document collection */
  statusInfo: SupportingDocumentCollectionStatusInfo;
  /** SupportingDocumentCollection URL to Swan portal */
  supportingDocumentCollectionUrl: Scalars["String"]["output"];
  /** List of supported documents contained in the supporting document collection */
  supportingDocuments: Array<SupportingDocument>;
  transaction: SupportingDocumentTransaction;
  type: SupportingDocumentCollectionType;
  /** Updated date */
  updatedAt: Scalars["DateTime"]["output"];
  /** Verification renewal id */
  verificationRenewalId?: Maybe<Scalars["String"]["output"]>;
};

/** Onboarding supporting document collection */
export type SupportingDocumentCollectionAccountHolderVerificationRenewalRelatedInfo =
  SupportingDocumentCollectionRelatedInfo & {
    __typename: "SupportingDocumentCollectionAccountHolderVerificationRenewalRelatedInfo";
    type: SupportingDocumentCollectionType;
  };

/** Supporting document collection with Approved status */
export type SupportingDocumentCollectionApprovedStatusInfo =
  SupportingDocumentCollectionStatusInfo & {
    __typename: "SupportingDocumentCollectionApprovedStatusInfo";
    /** Date on which the supporting document collection has been approved */
    approvedAt: Scalars["DateTime"]["output"];
    /** When the supporting document collection is approved */
    status: SupportingDocumentCollectionStatus;
  };

/** Supporting document collection with Canceled status */
export type SupportingDocumentCollectionCanceledStatusInfo =
  SupportingDocumentCollectionStatusInfo & {
    __typename: "SupportingDocumentCollectionCanceledStatusInfo";
    /** Date on which the supporting document collection has been canceled */
    canceledAt: Scalars["DateTime"]["output"];
    /** When the supporting document collection is canceled */
    status: SupportingDocumentCollectionStatus;
  };

/** Implements the Relay Connection interface, used to paginate lists of elements. ([Learn More](https://docs.swan.io/developers/using-api/pagination)) */
export type SupportingDocumentCollectionConnection = Connection & {
  __typename: "SupportingDocumentCollectionConnection";
  /** SupportingDocumentCollectionEdge list */
  edges: Array<SupportingDocumentCollectionEdge>;
  /** Information about the current, the previous and the next page */
  pageInfo: PageInfo;
  /** Total number of element in the list */
  totalCount: Scalars["Int"]["output"];
};

/** Implements the Relay Edge interface */
export type SupportingDocumentCollectionEdge = Edge & {
  __typename: "SupportingDocumentCollectionEdge";
  /** Opaque identifier pointing to this node in the pagination mechanism */
  cursor: Scalars["String"]["output"];
  /** The supporting document collection */
  node: SupportingDocumentCollection;
};

/** Filters that can be applied when listing supporting document collections */
export type SupportingDocumentCollectionFilterInput = {
  /** Supporting document collection status we're looking for */
  status?: InputMaybe<Array<SupportingDocumentCollectionStatus>>;
  /** Supporting document collection type/types we're looking for */
  type?: InputMaybe<Array<SupportingDocumentCollectionType>>;
};

/** Merchant Profile supporting document collection: related to a Merchant Profile */
export type SupportingDocumentCollectionMerchantProfileRelatedInfo =
  SupportingDocumentCollectionRelatedInfo & {
    __typename: "SupportingDocumentCollectionMerchantProfileRelatedInfo";
    type: SupportingDocumentCollectionType;
  };

/** Rejection returned if the supporting document collection was not found */
export type SupportingDocumentCollectionNotFoundRejection = Rejection & {
  __typename: "SupportingDocumentCollectionNotFoundRejection";
  id: Scalars["String"]["output"];
  message: Scalars["String"]["output"];
};

/** Onboarding supporting document collection */
export type SupportingDocumentCollectionOnboardingRelatedInfo =
  SupportingDocumentCollectionRelatedInfo & {
    __typename: "SupportingDocumentCollectionOnboardingRelatedInfo";
    type: SupportingDocumentCollectionType;
  };

/** Field we can use when ordering that can be applied when listing onboardings */
export type SupportingDocumentCollectionOrderByFieldInput = "createdAt" | "id";

/** Order that can be applied when listing onboardings */
export type SupportingDocumentCollectionOrderByInput = {
  direction: OrderByDirection;
  field: SupportingDocumentCollectionOrderByFieldInput;
};

/** Supporting document collection with PendingReview status */
export type SupportingDocumentCollectionPendingReviewStatusInfo =
  SupportingDocumentCollectionStatusInfo & {
    __typename: "SupportingDocumentCollectionPendingReviewStatusInfo";
    /** When the supporting document collection is completed and in compliance review */
    status: SupportingDocumentCollectionStatus;
  };

/** Supporting document collection with Rejected status */
export type SupportingDocumentCollectionRejectedStatusInfo =
  SupportingDocumentCollectionStatusInfo & {
    __typename: "SupportingDocumentCollectionRejectedStatusInfo";
    /** Date on which the supporting document collection has been rejected */
    rejectedAt: Scalars["DateTime"]["output"];
    /** When the supporting document collection is rejected */
    status: SupportingDocumentCollectionStatus;
  };

export type SupportingDocumentCollectionRelatedInfo = {
  /**
   * Type of the supporting document collection
   * - Onboarding is the one created along with an onboarding
   * - AccountHolderVerificationRenewal is created for verification renewal
   * - Transaction is related to a transaction
   */
  type: SupportingDocumentCollectionType;
};

/** Verification status of a supporting document collection */
export type SupportingDocumentCollectionStatus =
  /** When the supporting document collection is approved. Final status */
  | "Approved"
  /** When the supporting document collection is canceled. Final status */
  | "Canceled"
  /** When the supporting document collection is completed and in compliance review */
  | "PendingReview"
  /** When the supporting document collection is rejected. Final status */
  | "Rejected"
  /** When the supporting document collection is created and on going */
  | "WaitingForDocument";

/** Rejection returned if supporting document cannot be deleted because its supporting document collection status is not WaitingForDocument */
export type SupportingDocumentCollectionStatusDoesNotAllowDeletionRejection = Rejection & {
  __typename: "SupportingDocumentCollectionStatusDoesNotAllowDeletionRejection";
  message: Scalars["String"]["output"];
  supportingDocumentCollection: SupportingDocumentCollection;
  supportingDocumentCollectionStatus: SupportingDocumentCollectionStatus;
};

/** Rejection returned if supporting document cannot be updated because its supporting document collection status is not WaitingForDocument */
export type SupportingDocumentCollectionStatusDoesNotAllowUpdateRejection = Rejection & {
  __typename: "SupportingDocumentCollectionStatusDoesNotAllowUpdateRejection";
  message: Scalars["String"]["output"];
  supportingDocumentCollection: SupportingDocumentCollection;
  supportingDocumentCollectionStatus: SupportingDocumentCollectionStatus;
};

export type SupportingDocumentCollectionStatusInfo = {
  /** Status of the supporting document collection */
  status: SupportingDocumentCollectionStatus;
};

/** Rejection returned if the status transition is not allowed */
export type SupportingDocumentCollectionStatusNotAllowedRejection = Rejection & {
  __typename: "SupportingDocumentCollectionStatusNotAllowedRejection";
  message: Scalars["String"]["output"];
  newStatus: SupportingDocumentCollectionStatus;
  oldStatus: SupportingDocumentCollectionStatus;
};

/** Transaction supporting document collection: related to a transaction */
export type SupportingDocumentCollectionTransactionRelatedInfo =
  SupportingDocumentCollectionRelatedInfo & {
    __typename: "SupportingDocumentCollectionTransactionRelatedInfo";
    transaction: Transaction;
    /** @deprecated use `transaction.id` instead */
    transactionId: Scalars["String"]["output"];
    type: SupportingDocumentCollectionType;
  };

export type SupportingDocumentCollectionType =
  | "AccountHolderVerificationRenewal"
  | "Merchant"
  | "Onboarding"
  | "Transaction";

/** Supporting document collection with WaitingForUpload status */
export type SupportingDocumentCollectionWaitingForDocumentStatusInfo =
  SupportingDocumentCollectionStatusInfo & {
    __typename: "SupportingDocumentCollectionWaitingForDocumentStatusInfo";
    /** When the Supporting Document Collection is created */
    status: SupportingDocumentCollectionStatus;
  };

export type SupportingDocumentCommunicationLanguageSettings = "en" | "fr";

/** Rejection returned if the supporting document was not found */
export type SupportingDocumentNotFoundRejection = Rejection & {
  __typename: "SupportingDocumentNotFoundRejection";
  id: Scalars["String"]["output"];
  message: Scalars["String"]["output"];
};

/** Supporting document with NotUploaded status. */
export type SupportingDocumentNotUploadedStatusInfo = SupportingDocumentStatusInfo & {
  __typename: "SupportingDocumentNotUploadedStatusInfo";
  /** When the document has not been updated on time. */
  status: SupportingDocumentStatus;
};

export type SupportingDocumentOnboarding = {
  __typename: "SupportingDocumentOnboarding";
  id?: Maybe<Scalars["ID"]["output"]>;
};

export type SupportingDocumentPostField = {
  __typename: "SupportingDocumentPostField";
  key: Scalars["String"]["output"];
  value: Scalars["String"]["output"];
};

/** Details of a supporting document purpose */
export type SupportingDocumentPurpose = {
  __typename: "SupportingDocumentPurpose";
  /** Corresponding supporting document types accepted for this supporting document purpose */
  acceptableSupportingDocumentTypes: Array<SupportingDocumentType>;
  /** Corresponding Supporting Document Purpose Description translation according to accept-language header */
  description: Scalars["String"]["output"];
  /** Corresponding Supporting Document Purpose Title translation according to accept-language header */
  label: Scalars["String"]["output"];
  /** Technical name of the purpose */
  name: SupportingDocumentPurposeEnum;
};

/** Supporting document purpose */
export type SupportingDocumentPurposeEnum =
  /** Decision of appointment of Administrator */
  | "AdministratorDecisionOfAppointment"
  /** Proof of association registration */
  | "AssociationRegistration"
  /** Banking */
  | "Banking"
  /** Proof of the company creation process */
  | "CompanyFormationRegistration"
  /** Company Obligations */
  | "CompanyObligations"
  /** Proof of company registration */
  | "CompanyRegistration"
  /** Company Treasury */
  | "CompanyTreasury"
  /** Donation */
  | "Donation"
  /** Financial Statements */
  | "FinancialStatements"
  /** Gambling Prize Winnings */
  | "GamblingPrizeWinnings"
  /** Minutes Of The General Assembly */
  | "GeneralAssemblyMinutes"
  /** Inheritance */
  | "Inheritance"
  /** Investment */
  | "Investment"
  /** Proof of identity of the legal representative */
  | "LegalRepresentativeProofOfIdentity"
  /** NIF Accreditation Card */
  | "NIFAccreditationCard"
  /** Other */
  | "Other"
  /** Politically exposed person declaration */
  | "PepDeclaration"
  /** Personal Income */
  | "PersonalIncome"
  /** Personal Savings */
  | "PersonalSavings"
  /** Signed power of attorney document to give the power to act on behalf. */
  | "PowerOfAttorney"
  /** Decision of appointment of the President */
  | "PresidentDecisionOfAppointment"
  /** Document demonstrating that the company is actively conducting business (e.g., invoices, contracts) */
  | "ProofOfBusinessActivity"
  /** Proof of company address */
  | "ProofOfCompanyAddress"
  /** Proof of company income */
  | "ProofOfCompanyIncome"
  /** Proof of identity */
  | "ProofOfIdentity"
  /** Proof of individual address */
  | "ProofOfIndividualAddress"
  /** Proof of individual income */
  | "ProofOfIndividualIncome"
  /** Proof of origin of funds */
  | "ProofOfOriginOfFunds"
  /** Real Estate Income */
  | "RealEstateIncome"
  /** Signed status */
  | "SignedStatus"
  /** Sworn statement */
  | "SwornStatement"
  /** Trade */
  | "Trade"
  /** UBO Declaration */
  | "UBODeclaration"
  /** Declaration form used to confirm whether an individual qualifies as a U.S. person */
  | "USPersonStatusDeclaration"
  /** Proof of address of the Ultimate Beneficial Owner */
  | "UltimateBeneficialOwnerProofOfAddress"
  /** Proof of identity of the Ultimate Beneficial Owner */
  | "UltimateBeneficialOwnerProofOfIdentity";

/** Refused supporting document reason code */
export type SupportingDocumentReasonCode =
  /** The quality of the document is really low. */
  | "BadDocumentQuality"
  /** The company name in document doesn’t match our records. */
  | "CompanyNameMismatch"
  /** The document must be dated less than 3 months ago. */
  | "ExpiredDocument"
  /** Full Document required. */
  | "FullDocumentRequired"
  /** The beneficiary IBAN on the document we received does not match the information requested for the transaction. */
  | "IbanMismatch"
  /** The address in document doesn’t match our records. */
  | "InvalidAddress"
  /** The document is not valid. */
  | "InvalidDocument"
  /** The name of shareholder is not clearly visible or some fields are not duely completed. */
  | "InvalidOrMissingData"
  /** The document appears to be inconsistent with the specified transaction. */
  | "InvalidTransaction"
  /** The document provided is missing essential details required to comprehend the transaction's nature. Please submit an additional supporting document to supplement the initial one. */
  | "MissingDescription"
  /** Documents are not signed or dated. */
  | "MissingSignature"
  /** Other */
  | "Other"
  /** The document must be in color. */
  | "ProviderColorIdDocumentRequired"
  /** The amount on the document we received does not match the information requested for the transaction. */
  | "TransactionAmountMismatch"
  /** The date on the document we received does not match the information requested for the transaction. */
  | "TransactionDateMismatch"
  /** The issuer or beneficiary name on the document we received does not match the information requested for the transaction. */
  | "TransactionNameMismatch"
  /** Document cannot be accepted for the requested document type. */
  | "UnacceptableDocument";

/** Supporting document with Refused status */
export type SupportingDocumentRefusedStatusInfo = SupportingDocumentStatusInfo & {
  __typename: "SupportingDocumentRefusedStatusInfo";
  /** Original file name */
  filename: Scalars["String"]["output"];
  /** Reason why the supporting document has been refused */
  reason: Scalars["String"]["output"];
  /** Reason code why the supporting document has been refused */
  reasonCode: SupportingDocumentReasonCode;
  /** Date on which the supporting document collection has been refused */
  refusedAt: Scalars["DateTime"]["output"];
  /** When the document has been refused by Swan */
  status: SupportingDocumentStatus;
};

export type SupportingDocumentRequirements = {
  __typename: "SupportingDocumentRequirements";
  supportingDocumentPurposes: Array<SupportingDocumentPurposeEnum>;
};

export type SupportingDocumentSettings = {
  __typename: "SupportingDocumentSettings";
  collectMode: SupportingDocumentCollectMode;
  communicationLanguage?: Maybe<SupportingDocumentCommunicationLanguageSettings>;
  emailContact?: Maybe<Scalars["String"]["output"]>;
};

/** Verification status of a document */
export type SupportingDocumentStatus =
  /** Document has not been uploaded on time. */
  | "NotUploaded"
  /** Document has been refused by Swan. */
  | "Refused"
  /** Document has been uploaded but not verified by Swan yet. */
  | "Uploaded"
  /** Document has been uploaded and verified by Swan. */
  | "Validated"
  /** Document is not uploaded yet. */
  | "WaitingForUpload";

/** Rejection returned if supporting document cannot be deleted because of its status */
export type SupportingDocumentStatusDoesNotAllowDeletionRejection = Rejection & {
  __typename: "SupportingDocumentStatusDoesNotAllowDeletionRejection";
  message: Scalars["String"]["output"];
  status: SupportingDocumentStatus;
  supportingDocument: SupportingDocument;
};

/** Rejection returned if supporting document cannot be updated because of its status */
export type SupportingDocumentStatusDoesNotAllowUpdateRejection = Rejection & {
  __typename: "SupportingDocumentStatusDoesNotAllowUpdateRejection";
  message: Scalars["String"]["output"];
  status: SupportingDocumentStatus;
  supportingDocument: SupportingDocument;
};

export type SupportingDocumentStatusInfo = {
  /** Status of the supporting document */
  status: SupportingDocumentStatus;
};

/** Rejection returned if the status transition is not allowed */
export type SupportingDocumentStatusNotAllowedRejection = Rejection & {
  __typename: "SupportingDocumentStatusNotAllowedRejection";
  message: Scalars["String"]["output"];
  newStatus: SupportingDocumentStatus;
  oldStatus: SupportingDocumentStatus;
};

export type SupportingDocumentTransaction = {
  __typename: "SupportingDocumentTransaction";
  id?: Maybe<Scalars["ID"]["output"]>;
};

/** Specific type for document */
export type SupportingDocumentType =
  /** Account statement */
  | "AccountStatement"
  /** Legal document required for company’s formation */
  | "ArticlesOfIncorporation"
  /** Document with details such as bank name, address, account number and account holder */
  | "BankAccountDetails"
  /** Bank Statement */
  | "BankStatement"
  /** By Laws */
  | "ByLaws"
  /** Share Deposit Certificate */
  | "CapitalShareDepositCertificate"
  /** Official document confirming that an individual has voluntarily renounced their citizenship */
  | "CertificateOfLossOfNationality"
  /** Lease agreement in the name of the business or Proof of Individual Address if the company is hosted by one of the legal representative */
  | "CompanyLeaseAgreement"
  /** Document submitted to your tax bureau at the end of the last business period */
  | "CorporateIncomeTaxReturn"
  /** Decision of appointment */
  | "DecisionOfAppointment"
  /** Deed of donation */
  | "DeedOfDonation"
  /** Deed of sale */
  | "DeedOfSale"
  /** Deed of succession */
  | "DeedOfSuccession"
  /** Driving license */
  | "DrivingLicense"
  /** Financial Statements */
  | "FinancialStatements"
  /** Home Insurance contract */
  | "HomeInsurance"
  /** Income Tax return or tax-exemption certificate dating less than 2 years */
  | "IncomeTaxReturn"
  /** Invoice */
  | "Invoice"
  /** Association registration proof for french association */
  | "JOAFFEExtract"
  /** Loan contract */
  | "LoanContract"
  /** Meeting's minutes */
  | "MeetingMinutes"
  /** NIF Accreditation Card */
  | "NIFAccreditationCard"
  /** NationalIdCard */
  | "NationalIdCard"
  /** Notarial deed */
  | "NotarialDeed"
  /** Other */
  | "Other"
  /** Passport */
  | "Passport"
  /** A pay slip dating less than 3 months */
  | "PaySlip"
  /** Politically exposed person declaration */
  | "PepDeclaration"
  /** Telephone Bill issued within the last 3 months */
  | "PhoneBill"
  /** Signed power of attorney document to give the power to act on behalf */
  | "PowerOfAttorney"
  /** Commercial registry extract issued within the last 3 months */
  | "RegisterExtract"
  /** Rental Receipt issued within the last 3 months */
  | "RentReceipt"
  /** Resident permit */
  | "ResidentPermit"
  /** Selfie */
  | "Selfie"
  /** Sworn statement */
  | "SwornStatement"
  /** Ultimate Beneficial Owner Declaration */
  | "UBODeclaration"
  /** Water, Electricity or Gas Bill issued within the last 3 months */
  | "UtilityBill"
  /** IRS form used by non-U.S. persons to certify their foreign status and claim tax treaty benefits */
  | "W8"
  /** IRS form used to confirm a U.S. person's taxpayer identification number and tax status */
  | "W9"
  /** Winnings Certificate */
  | "WinningsCertificate";

export type SupportingDocumentUploadInfo = {
  __typename: "SupportingDocumentUploadInfo";
  fields: Array<SupportingDocumentPostField>;
  url: Scalars["String"]["output"];
};

/** Rejection returned if the supporting document collection cannot receive supporting documents anymore */
export type SupportingDocumentUploadNotAllowedRejection = Rejection & {
  __typename: "SupportingDocumentUploadNotAllowedRejection";
  message: Scalars["String"]["output"];
  supportingDocumentCollectionStatus: SupportingDocumentCollectionStatus;
};

/** Supporting document with Uploaded status */
export type SupportingDocumentUploadedStatusInfo = SupportingDocumentStatusInfo & {
  __typename: "SupportingDocumentUploadedStatusInfo";
  /** Original file name */
  filename: Scalars["String"]["output"];
  /** When the document has been uploaded but not verified by Swan yet */
  status: SupportingDocumentStatus;
};

/** Supporting document with Validated status */
export type SupportingDocumentValidatedStatusInfo = SupportingDocumentStatusInfo & {
  __typename: "SupportingDocumentValidatedStatusInfo";
  /** Original file name */
  filename: Scalars["String"]["output"];
  /** Reason why the supporting document has been validated */
  reason: Scalars["String"]["output"];
  /** When the document has been uploaded and verified by Swan */
  status: SupportingDocumentStatus;
  /** Date on which the supporting document has been validated */
  validatedAt: Scalars["DateTime"]["output"];
};

/** Supporting document with WaitingForUpload status */
export type SupportingDocumentWaitingForUploadStatusInfo = SupportingDocumentStatusInfo & {
  __typename: "SupportingDocumentWaitingForUploadStatusInfo";
  /** When the document is not uploaded yet */
  status: SupportingDocumentStatus;
  supportingDocumentId: Scalars["String"]["output"];
  /** Info to upload the document : url and fields to add along file in form (POST) */
  upload: SupportingDocumentUploadInfo;
};

export type SuspendAccountMembershipInput = {
  accountMembershipId: Scalars["ID"]["input"];
};

export type SuspendAccountMembershipPayload =
  | InternalErrorRejection
  | LegalRepresentativeAccountMembershipCannotBeSuspendedRejection
  | SuspendAccountMembershipSuccessPayload
  | UserNotAllowedToManageAccountMembershipRejection
  | UserNotAllowedToSuspendItsOwnAccountMembershipRejection
  | ValidationRejection;

export type SuspendAccountMembershipSuccessPayload = {
  __typename: "SuspendAccountMembershipSuccessPayload";
  accountMembership: AccountMembership;
};

/** Define a reason with a message and a specific type for suspend account action */
export type SuspendAccountReason = Reason & {
  __typename: "SuspendAccountReason";
  message?: Maybe<Scalars["String"]["output"]>;
  type: SuspendAccountReasonType;
};

/** Input version */
export type SuspendAccountReasonInput = {
  message?: InputMaybe<Scalars["String"]["input"]>;
  type: SuspendAccountReasonType;
};

/** Specific type for suspend account action */
export type SuspendAccountReasonType =
  /** Simple suspend request */
  "SuspendRequested";

/** SuspendAccountStatusReason */
export type SuspendAccountStatusReason = SuspendAccountReason;

/** Inputs to suspend a physical card */
export type SuspendPhysicalCardInput = {
  /** Unique identifier of a card */
  cardId: Scalars["ID"]["input"];
};

export type SuspendPhysicalCardPayload =
  | AccountMembershipNotAllowedRejection
  | CardNotFoundRejection
  | ForbiddenRejection
  | PhysicalCardNotFoundRejection
  | SuspendPhysicalCardSuccessPayload
  | ValidationRejection;

export type SuspendPhysicalCardSuccessPayload = {
  __typename: "SuspendPhysicalCardSuccessPayload";
  /** The physicalCard suspended */
  physicalCard: PhysicalCard;
};

/** Inputs to suspend a received direct debit mandate */
export type SuspendReceivedDirectDebitMandateInput = {
  receivedDirectDebitMandateId: Scalars["ID"]["input"];
};

/** Union type returned by the suspendReceivedDirectDebitMandate mutation */
export type SuspendReceivedDirectDebitMandatePayload =
  | ForbiddenRejection
  | ReceivedDirectDebitMandateCanceledRejection
  | ReceivedDirectDebitMandateNotFoundRejection
  | SuspendReceivedDirectDebitMandateSuccessPayload
  | SuspendReceivedDirectDebitMandatedRejection
  | ValidationRejection;

/** Return type in case of a successful response of the suspendReceivedDirectDebitMandate mutation */
export type SuspendReceivedDirectDebitMandateSuccessPayload = {
  __typename: "SuspendReceivedDirectDebitMandateSuccessPayload";
  /** the received direct debit mandate is suspended */
  receivedDirectDebitMandate: ReceivedDirectDebitMandate;
};

/** Rejection returned if the SuspendReceivedDirectDebitMandatedRejection mutation is rejected */
export type SuspendReceivedDirectDebitMandatedRejection = Rejection & {
  __typename: "SuspendReceivedDirectDebitMandatedRejection";
  message: Scalars["String"]["output"];
  reason: SuspendReceivedDirectDebitMandatedRejectionReason;
};

/** Enum of reasons of rejection for suspendReceivedDirectDebitMandate mutation */
export type SuspendReceivedDirectDebitMandatedRejectionReason =
  /** Received direct debit mandate is canceled and therefore can't be suspend */
  "ReceivedDirectDebitMandateCanceled";

/** StatusInfo when funding limit settings has been suspended */
export type SuspendedFundingLimitSettingsStatusInfo = FundingLimitSettingsStatusInfo & {
  __typename: "SuspendedFundingLimitSettingsStatusInfo";
  reason: Scalars["String"]["output"];
  status: FundingLimitSettingsStatus;
};

/** Funding Source Suspended status information */
export type SuspendedFundingSourceStatusInfo = FundingSourceStatusInfo & {
  __typename: "SuspendedFundingSourceStatusInfo";
  /** Funding Source Suspended status */
  status: FundingSourceStatus;
  /** Date at which the funding source was suspended */
  suspendedAt: Scalars["Date"]["output"];
};

/** SuspendedMerchantPaymentMethodStatusInfo */
export type SuspendedMerchantPaymentMethodStatusInfo = MerchantPaymentMethodStatusInfo & {
  __typename: "SuspendedMerchantPaymentMethodStatusInfo";
  status: MerchantPaymentMethodStatus;
  /** Merchant Payment Method suspended date */
  suspendedAt: Scalars["Date"]["output"];
};

/** SuspendedMerchantProfileStatusInfo */
export type SuspendedMerchantProfileStatusInfo = MerchantProfileStatusInfo & {
  __typename: "SuspendedMerchantProfileStatusInfo";
  status: MerchantProfileStatus;
  suspendedAt: Scalars["Date"]["output"];
};

export type SuspendedVerificationRenewal = VerificationRenewal & {
  __typename: "SuspendedVerificationRenewal";
  accountHolderId: Scalars["String"]["output"];
  createdAt: Scalars["DateTime"]["output"];
  dueDate?: Maybe<Scalars["DateTime"]["output"]>;
  id: Scalars["ID"]["output"];
  /** Verification renewal information */
  info: VerificationRenewalInfo;
  status: VerificationRenewalStatus;
  supportTicketId?: Maybe<Scalars["String"]["output"]>;
  updatedAt: Scalars["DateTime"]["output"];
};

/** Swan account beneficiary */
export type SwanAccountBeneficiaryInput = {
  /** account number to be credited */
  accountNumber: Scalars["AccountNumber"]["input"];
  /** full name of the beneficiary  (max 70 characters) */
  name: Scalars["String"]["input"];
  /** `true` if this new beneficiary will be saved to the beneficiary list of the debited account. */
  save: Scalars["Boolean"]["input"];
};

/** Status values of an identification */
export type SwanIdentificationStatus =
  /** When the user canceled the identification process or the identification service was unavailable */
  | "Canceled"
  /** When the identification is no longer valid */
  | "Expired"
  /** When the identification is invalid */
  | "Invalid"
  /** When the identification hasn't been started yet */
  | "NotStarted"
  /** When the identification does not support an identification level */
  | "NotSupported"
  /** When the identification process is currently being treated by a manual or automatic process */
  | "Pending"
  /** When the identification has been started */
  | "Started"
  /** When the identification is valid */
  | "Valid";

export type SwanTcuDocumentEffectiveDateNotAllowedRejection = Rejection & {
  __typename: "SwanTCUDocumentEffectiveDateNotAllowedRejection";
  message: Scalars["String"]["output"];
};

export type SwanTcuDocumentNotFoundRejection = Rejection & {
  __typename: "SwanTCUDocumentNotFoundRejection";
  message: Scalars["String"]["output"];
};

export type SwanTcuDocumentStatusNotAllowedRejection = Rejection & {
  __typename: "SwanTCUDocumentStatusNotAllowedRejection";
  message: Scalars["String"]["output"];
};

export type TextField = Field & {
  __typename: "TextField";
  displayFormat?: Maybe<Scalars["String"]["output"]>;
  example?: Maybe<Scalars["String"]["output"]>;
  key: Scalars["String"]["output"];
  maxLength?: Maybe<Scalars["Int"]["output"]>;
  minLength?: Maybe<Scalars["Int"]["output"]>;
  name: Scalars["String"]["output"];
  refreshDynamicFieldsOnChange: Scalars["Boolean"]["output"];
  required: Scalars["Boolean"]["output"];
  validationRegex?: Maybe<Scalars["String"]["output"]>;
};

/** The details of the 3DS challenge associated to the payment. */
export type ThreeDs = {
  __typename: "ThreeDS";
  /** The status of the 3DS challenge */
  statusInfo: ThreeDsStatusInfo;
};

export type ThreeDsStatusInfo = {
  status: IncomingThreeDsStatus;
};

/** Rejection returned when trying to create a multi consent with too many child consents */
export type TooManyChildConsentsRejection = Rejection & {
  __typename: "TooManyChildConsentsRejection";
  message: Scalars["String"]["output"];
};

/** Rejection returned if too many items are given */
export type TooManyItemsRejection = Rejection & {
  __typename: "TooManyItemsRejection";
  message: Scalars["String"]["output"];
};

/** Transaction */
export type Transaction = {
  /** matching account for this transaction */
  account?: Maybe<Account>;
  /** amount */
  amount: Amount;
  /** [DEPRECATED] booked balance after this transaction. Deprecated in favor of statusInfo.balance.amount on BookedTransactionStatusInfo */
  bookedBalanceAfter?: Maybe<Amount>;
  /** name of the counterparty. e.g Merchant name, Creditor name, Beneficiary Name ... */
  counterparty: Scalars["String"]["output"];
  /** created date */
  createdAt: Scalars["DateTime"]["output"];
  /** a date that reflects the execution date of a transaction from a user viewpoint. Can be used for sorting transactions. */
  executionDate: Scalars["DateTime"]["output"];
  /**
   * an arbitrary identifier that was defined by you when you created this transaction.
   *
   * For example, you can define it in the CreditTransferInput mutation.
   */
  externalReference?: Maybe<Scalars["String"]["output"]>;
  /** unique identifier of the transaction */
  id: Scalars["ID"]["output"];
  /** `true` if this transaction can still be cancelled */
  isCancelable: Scalars["Boolean"]["output"];
  /** label */
  label: Scalars["String"]["output"];
  /** origin transaction associated to this transaction */
  originTransaction?: Maybe<Transaction>;
  /** ID of the origin transaction associated to this transaction */
  originTransactionId?: Maybe<Scalars["String"]["output"]>;
  /** payment associated to this transaction */
  payment?: Maybe<Payment>;
  /** ID of the payment associated to this transaction */
  paymentId?: Maybe<Scalars["String"]["output"]>;
  /** payment method identifier used for this transaction. e.g masked PAN or IBAN or accountNumber */
  paymentMethodIdentifier: Scalars["String"]["output"];
  /** payment product used for this transaction */
  paymentProduct: PaymentProduct;
  /** project id of the transaction */
  projectId: Scalars["ID"]["output"];
  /** external identifier of the transaction */
  reference: Scalars["String"]["output"];
  /** a date that reflects the time at which the user asked the transaction to be executed */
  requestedExecutionAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** side (Credit or Debit) */
  side: TransactionSide;
  /** true if a transaction statement can be generated for this transaction */
  statementCanBeGenerated?: Maybe<Scalars["Boolean"]["output"]>;
  /** status information */
  statusInfo: TransactionStatusInfo;
  supportingDocumentCollections: SupportingDocumentCollectionConnection;
  /** type */
  type: TransactionTypeEnum;
  /** updated date */
  updatedAt: Scalars["DateTime"]["output"];
};

/** Transaction */
export type TransactionSupportingDocumentCollectionsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  filters?: InputMaybe<SupportingDocumentCollectionFilterInput>;
  first?: Scalars["Int"]["input"];
};

/** Please see the Connection interface */
export type TransactionConnection = Connection & {
  __typename: "TransactionConnection";
  edges: Array<TransactionEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars["Int"]["output"];
};

/** Please see the Edge interface */
export type TransactionEdge = Edge & {
  __typename: "TransactionEdge";
  cursor: Scalars["String"]["output"];
  node: Transaction;
};

/** Rejection returned if the transaction was not found */
export type TransactionNotFoundRejection = Rejection & {
  __typename: "TransactionNotFoundRejection";
  message: Scalars["String"]["output"];
  transactionId: Scalars["ID"]["output"];
};

/** The following reason codes for a r-transaction are defined: */
export type TransactionReasonCode =
  /** Rejected because the account is closed */
  | "AccountClosed"
  /** Rejected because the account holder is deceased */
  | "AccountHolderDeceased"
  /** Rejected because the beneficiary account has a limit that can be unblocked */
  | "AccountLimited"
  /** Rejected because the account is suspended */
  | "AccountSuspended"
  /** Rejected because the account is unknown */
  | "AccountUnknown"
  /** Rejected by the bank */
  | "BankRefused"
  /** Creditor account is blocked */
  | "BeneficiaryAccountBlocked"
  /** Creditor account is closed */
  | "BeneficiaryAccountClosed"
  /** Creditor account number is incorrect */
  | "BeneficiaryAccountIncorrect"
  /** Creditor account number does not exist */
  | "BeneficiaryAccountUnknown"
  /** The account number matches, but the creditor’s name does not */
  | "BeneficiaryBankBicInvalid"
  /** Rejected because the creditor bank is not reachable */
  | "BeneficiaryBankNotReachable"
  /** The account number matches, but the creditor's name does not */
  | "BeneficiaryBranchCodeInvalid"
  /** The recipient’s account currency is different than the transfer currency */
  | "BeneficiaryCurrencyInvalid"
  /** Customer is deceased */
  | "BeneficiaryDeceased"
  /** The recipient's ID document number is invalid */
  | "BeneficiaryIdNumberInvalid"
  /** Recipient phone number is incorrect */
  | "BeneficiaryPhoneNumberInvalid"
  /** The recipient’s account currency is different than the transfer currency */
  | "BeneficiaryRutNumberInvalid"
  /** Tax ID doesn't match recipient's name */
  | "BeneficiaryTaxIdInvalid"
  /** Tax ID is suspended */
  | "BeneficiaryTaxIdSuspended"
  /** Rejected because the card is expired */
  | "CardExpired"
  /** Rejected because the card is not activated yet */
  | "CardNotActivated"
  /** Rejected because the card has been permanently blocked */
  | "CardPermanentlyBlocked"
  /** Rejected because the card is suspended */
  | "CardSuspended"
  /** The payer has blocked the check payment */
  | "CheckBlocked"
  /** Invalid check */
  | "CheckInvalid"
  /** Invalid check number */
  | "CheckNumberInvalid"
  /** The check payment can’t be fulfilled because it’s too old */
  | "CheckOutdated"
  /** Rejected because the creditor bank is offline */
  | "CreditorBankOffline"
  /** Rejected following an error from the creditor bank */
  | "CreditorBankTechnicalErrorOccurred"
  /** Rejected following a timeout from the creditor bank */
  | "CreditorBankTimeout"
  /** Debtor Account Blocked */
  | "DebtorAccountBlocked"
  /** Rejected because the debtor account is closed */
  | "DebtorAccountClosed"
  /** Rejected because the debtor is a non business account and the transaction is a B2B SEPA Direct Debit transaction */
  | "DebtorAccountConsumer"
  /** Rejected because the debtor account is unknown */
  | "DebtorAccountUnknown"
  /** Rejected because the debtor bank is offline */
  | "DebtorBankOffline"
  /** Rejected following an error from the debtor bank */
  | "DebtorBankTechnicalErrorOccurred"
  /** Rejected following a timeout from the debtor bank */
  | "DebtorBankTimeout"
  /** Rejected because the debtor account holder is dead */
  | "DebtorDeceased"
  /** The check payment can’t be fulfilled because the signature is missing or invalid */
  | "EndorsementMissingOrInvalid"
  /** The check payment can’t be fulfilled because of a fraud */
  | "Fraudulent"
  /** Funds already transferred back to the originator */
  | "FundsAlreadyTransferredBack"
  /** Rejected because of insufficient funds on the account */
  | "InsufficientFunds"
  /** The account number matches, but the creditor’s name does not */
  | "InvalidCreditorName"
  /** Rejected because the expiration date entered does not match the one on the card */
  | "InvalidExpirationDate"
  /** Rejected because the PIN is invalid */
  | "InvalidPin"
  /** Rejected because there were too many invalid tries on the PIN validation */
  | "InvalidPinAttemptsExceeded"
  /** Rejected because the security number entered does not match the one on the card */
  | "InvalidSecurityNumber"
  /** Funds cannot be reimbursed by beneficiary bank/legal decision */
  | "LegalOrBankDecision"
  /** Rejected by debtor because the mandate is invalid */
  | "MandateInvalid"
  /** The check payment can’t be fulfilled because a mandatory piece of information is missing on the check */
  | "MandatoryReferenceMissingOnCheck"
  /** Rejected because the merchant must request a new transaction with authorisation */
  | "MerchantShouldResubmitAuthorization"
  /** No answer from customer */
  | "NoAnswerFromBeneficiary"
  /** No original transaction received */
  | "NoOriginalTransactionReceived"
  /** Rejected by the partner (you) */
  | "PartnerRefused"
  /** Rejected following an error or a timeout from the partner */
  | "PartnerTechnicalErrorOccurred"
  /** Rejected because the maximum amount allowed on the given period has been exceeded */
  | "PeriodAmountLimitExceeded"
  /** Rejected because the maximum number of transactions on the given period has been exceeded */
  | "PeriodNbTransactionLimitExceeded"
  /** Rejected because a transaction with PIN code is required to continue to using the card */
  | "PinRequiredForFurtherTransaction"
  /** Rejected by bank with no specified reason */
  | "ReasonNotSpecifiedByBank"
  /** Reason unspecified */
  | "ReasonNotSpecifiedByBeneficiary"
  /** Rejected by debtor with no specified reason */
  | "ReasonNotSpecifiedByDebtor"
  /** Customer request */
  | "ReasonNotSpecifiedByOriginator"
  /** Recall request accepted by beneficiary bank or beneficiary */
  | "RecallAccepted"
  /** The creditor requested the transaction to be refunded */
  | "RefundRequestedByCreditor"
  /** Refund requested by end customer */
  | "RefundRequestedByDebtor"
  /** Rejected by bank for regulatory reason */
  | "RegulatoryReason"
  /** Invalid RLMC key, please control the key and the check number */
  | "RlmcKeyInvalid"
  /** The check payment can’t be fulfilled because the signature is invalid */
  | "SignatureInvalid"
  /** Rejected because the debtor or the creditor bank is offline */
  | "SwanOffline"
  /** Rejected by Swan */
  | "SwanRefused"
  /** Rejected because of a Swan technical error */
  | "SwanTechnicalErrorOccurred"
  /** Rejected because of a Swan timeout */
  | "SwanTimeout"
  /** Recipient bank can't accept the payments from 3rd party */
  | "TargetCurrencyNotAvailable"
  /** Technical issue resulting in incorrect transactions sent out */
  | "TechnicalIssue"
  /** Rejected because the terms and conditions limit has been exceeded */
  | "TermsAndConditionsLimitExceeded"
  /** Wrong transaction amount */
  | "TransactionAmountIncorrect"
  /** Rejected because the maximum amount for a transaction has been exceeded */
  | "TransactionAmountLimitExceeded"
  /** Rejected by bank because this transaction is duplicated */
  | "TransactionDuplicated"
  /** Rejected because the transaction is forbidden on this type of account */
  | "TransactionOnAccountTypeNotAllowed"
  /** Recipient account doesn't support payments to this card type */
  | "TransactionOnCardTypeNotAllowed"
  /** The recipient’s account currency is different than the transfer currency */
  | "TransactionPurposeInvalid"
  /** Invalid payment reference */
  | "TransactionReferenceInvalid"
  /** Rejected because the type of transaction is forbidden on the account */
  | "TransactionTypeNotAllowed";

/** Transaction side */
export type TransactionSide =
  /** when the transaction credit the account */
  | "Credit"
  /** when the transaction debit the account */
  | "Debit";

/** A transaction statement represent metadata around a BOOKED transaction */
export type TransactionStatement = {
  __typename: "TransactionStatement";
  /** matching account for this transaction statement */
  account: Account;
  /** date at which the statement generation has been requested */
  createdAt: Scalars["DateTime"]["output"];
  /** unique identifier of the transaction statement */
  id: Scalars["ID"]["output"];
  /** projectId of this transaction */
  projectId: Scalars["ID"]["output"];
  /** status information of the transaction statement */
  statusInfo: TransactionStatementStatusInfo;
  /** transaction for which the statement is generated */
  transaction?: Maybe<Transaction>;
  /** date at which the statement generation status has been updated */
  updatedAt: Scalars["DateTime"]["output"];
};

/** Language: ISO 639-1 language code */
export type TransactionStatementLanguage = "de" | "en" | "es" | "fi" | "fr" | "it" | "nl" | "pt";

/** The different statuses of transaction statement */
export type TransactionStatementStatusEnum = "Expired" | "Failed" | "Generated" | "Pending";

export type TransactionStatementStatusInfo = {
  /** status of the transaction statement */
  status: TransactionStatementStatusEnum;
};

/** Transaction status */
export type TransactionStatus =
  /** when the transaction is posted to the Swan book and impact the booked balance */
  | "Booked"
  /** when a pending transaction is canceled and the amount is released on the available balance */
  | "Canceled"
  /** when the transaction is done via a deferred debit card */
  | "Deferred"
  /** when the transaction is pending and the amount impact the available balance */
  | "Pending"
  /** when the transaction is rejected */
  | "Rejected"
  /** when a card authorization is released after X days or fully consumed by X debits */
  | "Released"
  /** when the transaction has successfully been posted on the Swan book through another booked transaction. */
  | "Settled"
  /** when the transaction is upcoming (scheduled credit transfer, direct debit ...) */
  | "Upcoming";

/** Transaction Status information */
export type TransactionStatusInfo = {
  /** unique identifier of the transaction */
  id: Scalars["ID"]["output"];
  /** status of the transaction */
  status: TransactionStatus;
};

/** Indicator of the transit type used */
export type TransactionTransportType =
  | "AuthorizedAggregatedSplitClearing"
  | "DebtRecovery"
  | "Other"
  | "PostAuthorizedAggregated"
  | "PostAuthorizedAggregatedMaestro"
  | "Prefunded"
  | "RealTimeAuthorized";

/** Transaction Type */
export type TransactionTypeEnum =
  /** When a card chargeback debited a Swan account. */
  | "CardInChargeback"
  /** When a card chargeback reversal credited a Swan account. */
  | "CardInChargebackReversal"
  /** When a card credit credited a Swan account. */
  | "CardInCredit"
  /** A card issued from a Swan account received an authorization or advice. */
  | "CardOutAuthorization"
  /** A card issued from a Swan account received a credit. */
  | "CardOutCredit"
  /** A credit received by a card issued from a Swan account was reversed. The amount is debited from the Swan account. */
  | "CardOutCreditReversal"
  /** A card issued from a Swan account received a debit. */
  | "CardOutDebit"
  /** A debit received by card issued from a Swan account was reversed. The amount is credited to the Swan account. */
  | "CardOutDebitReversal"
  /** When a Check credited a Swan account. */
  | "CheckIn"
  /** When a Check credited a Swan account and Swan or the debtor returned the funds. */
  | "CheckInReturn"
  /** When a fee is credited to a Swan account. */
  | "FeesIn"
  /** When a fee is debited from a Swan account. */
  | "FeesOut"
  /** When an internal Credit Transfer credited a Swan account. */
  | "InternalCreditTransferIn"
  /** When an internal Credit Transfer credited a Swan account, Swan or the Swan creditor asked for a recall of the transaction, and Swan or the Swan debtor accepted the recall request. */
  | "InternalCreditTransferInRecall"
  /** When an internal Credit Transfer credited a Swan account and Swan or the Swan debtor returned the funds. */
  | "InternalCreditTransferInReturn"
  /** When an internal Credit Transfer debited a Swan account. */
  | "InternalCreditTransferOut"
  /** When an internal Credit Transfer debited a Swan account, Swan or the Swan debtor asked for a recall of the transaction, and Swan or the Swan creditor accepted the recall request. */
  | "InternalCreditTransferOutRecall"
  /** When an internal Credit Transfer debited a Swan account and Swan or the Swan creditor returned the funds. */
  | "InternalCreditTransferOutReturn"
  /** A credit received by a card issued from a Swan account was reversed. The amount is debited from the Swan account. */
  | "InternalDirectDebitIn"
  /** When an Internal Direct Debit credited a Swan account and Swan or the debtor returned the funds. */
  | "InternalDirectDebitInReturn"
  /** When an Internal Direct Debit debited a Swan account. */
  | "InternalDirectDebitOut"
  /** When an Internal Direct Debit debited a Swan account and Swan or the debtor returned the funds. */
  | "InternalDirectDebitOutReturn"
  /** When an International Credit Transfer credited a Swan account. */
  | "InternationalCreditTransferIn"
  /** When an International Credit Transfer credited a Swan account and Swan or the Swan debtor returned the funds. */
  | "InternationalCreditTransferInReturn"
  /** When an International Credit Transfer debited a Swan account. */
  | "InternationalCreditTransferOut"
  /** When an International Credit Transfer debited a Swan account and Swan or the Swan debtor returned it. */
  | "InternationalCreditTransferOutReturn"
  /** When a Sepa Credit Transfer credited a Swan account. */
  | "SepaCreditTransferIn"
  /** When a Sepa Credit Transfer credited a Swan account, Swan or the Swan creditor asked for a recall of the transaction, and the debtor bank or the debtor accepted the recall request. */
  | "SepaCreditTransferInRecall"
  /** When a Sepa Credit Transfer credited a Swan account and Swan or the Swan debtor returned the funds. */
  | "SepaCreditTransferInReturn"
  /** When a Sepa Credit Transfer debited a Swan account. */
  | "SepaCreditTransferOut"
  /** When a Sepa Credit Transfer debited a Swan account, Swan or the Swan debtor asked for a recall of the transaction, and the creditor bank or the creditor accepted the recall request. */
  | "SepaCreditTransferOutRecall"
  /** When a Sepa Credit Transfer debited a Swan account and the creditor bank or the creditor returned the funds. */
  | "SepaCreditTransferOutReturn"
  /** When a Sepa Direct Debit credited a Swan account. */
  | "SepaDirectDebitIn"
  /** When a Sepa Direct Debit credited a Swan account and the debtor bank or the debtor returned it. */
  | "SepaDirectDebitInReturn"
  /**
   * *COMING SOON*
   * When a Sepa Direct Debit credited a Swan account and Swan or the Swan creditor reversed it.
   */
  | "SepaDirectDebitInReversal"
  /** When a Sepa Direct Debit debited a Swan account. */
  | "SepaDirectDebitOut"
  /** When a Sepa Direct Debit debited a Swan account and Swan or the Swan debtor returned it. */
  | "SepaDirectDebitOutReturn"
  /** When a Sepa Direct Debit debited a Swan account and the creditor bank or the creditor reversed it. */
  | "SepaDirectDebitOutReversal"
  /** When an instant Sepa Credit Transfer credited a Swan account. */
  | "SepaInstantCreditTransferIn"
  /** When a Sepa Instant Credit Transfer credited a Swan account, Swan or the Swan creditor asked for a recall of the transaction, and the debtor bank or the debtor accepted the recall request. */
  | "SepaInstantCreditTransferInRecall"
  /** When an instant Sepa Credit Transfer debited a Swan account. */
  | "SepaInstantCreditTransferOut"
  /** When a Sepa Instant Credit Transfer debited a Swan account, Swan or the Swan debtor asked for a recall of the transaction, and the creditor bank or the creditor accepted the recall request. */
  | "SepaInstantCreditTransferOutRecall";

/** the criteria to filter transactions */
export type TransactionsFiltersInput = {
  /** To filter an exact amount value */
  amount?: InputMaybe<Scalars["AmountValue"]["input"]>;
  /** To filter so it includes rejected transactions that had a fallback (`true` by default) */
  includeRejectedWithFallback?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** To filter above an amount value (inclusive) */
  isAboveAmount?: InputMaybe<Scalars["AmountValue"]["input"]>;
  /** To filter after an executionDate value (inclusive) */
  isAfterExecutionDate?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** To filter after an updatedAt value (inclusive) */
  isAfterUpdatedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** To filter before an executionDate value (exclusive) */
  isBeforeExecutionDate?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** To filter before an updatedAt value (exclusive) */
  isBeforeUpdatedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** To filter below an amount value (inclusive) */
  isBelowAmount?: InputMaybe<Scalars["AmountValue"]["input"]>;
  /** To filter on some Payment Products (all if empty) */
  paymentProduct?: InputMaybe<Array<PaymentProduct>>;
  /**
   * Search string to look for
   *
   * Search will be performed in following fields:
   * - ID
   * - Counterparty
   * - Label
   * - Reference
   * - Amount (DEPRECATED: use new filters instead)
   */
  search?: InputMaybe<Scalars["String"]["input"]>;
  /** To filter on some Transaction Status (all if empty) */
  status?: InputMaybe<Array<TransactionStatus>>;
  /** To filter on some transaction types */
  type?: InputMaybe<Array<TransactionTypeEnum>>;
};

export type TransactionsOrderByField = "createdAt" | "executionDate" | "id" | "updatedAt";

/** the criteria to sort transactions */
export type TransactionsOrderByInput = {
  direction?: InputMaybe<OrderByDirection>;
  field?: InputMaybe<TransactionsOrderByField>;
};

/** TrustedBeneficiary */
export type TrustedBeneficiary = {
  /** created date */
  createdAt: Scalars["DateTime"]["output"];
  /** unique identifier of a trusted beneficiary */
  id: Scalars["ID"]["output"];
  /** label of the beneficiary */
  label: Scalars["String"]["output"];
  /** full name of the beneficiary */
  name: Scalars["String"]["output"];
  /** status information */
  statusInfo: TrustedBeneficiaryStatusInfo;
  /** List of transactions associated with the Trusted Beneficiary. */
  transactions?: Maybe<TransactionConnection>;
  /** type of the beneficiary */
  type: BeneficiaryType;
  /** updated date */
  updatedAt: Scalars["DateTime"]["output"];
};

/** TrustedBeneficiary */
export type TrustedBeneficiaryTransactionsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  filters?: InputMaybe<TransactionsFiltersInput>;
  first?: Scalars["Int"]["input"];
};

/** TrustedBeneficiary status canceled */
export type TrustedBeneficiaryCanceledStatusInfo = TrustedBeneficiaryStatusInfo & {
  __typename: "TrustedBeneficiaryCanceledStatusInfo";
  /** canceled Date */
  canceledAt: Scalars["DateTime"]["output"];
  /** status of the beneficiary (set to `Canceled`) */
  status: TrustedBeneficiaryStatus;
};

/** Please see the Connection interface */
export type TrustedBeneficiaryConnection = Connection & {
  __typename: "TrustedBeneficiaryConnection";
  edges: Array<TrustedBeneficiaryEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars["Int"]["output"];
};

/** TrustedBeneficiary status consent pending */
export type TrustedBeneficiaryConsentPendingStatusInfo = TrustedBeneficiaryStatusInfo & {
  __typename: "TrustedBeneficiaryConsentPendingStatusInfo";
  /** The consent required to initiate this beneficiary */
  consent: Consent;
  /** status of the beneficiary  (set to `ConsentPending`) */
  status: TrustedBeneficiaryStatus;
};

/** Please see the Edge interface */
export type TrustedBeneficiaryEdge = Edge & {
  __typename: "TrustedBeneficiaryEdge";
  cursor: Scalars["String"]["output"];
  node: TrustedBeneficiary;
};

/** TrustedBeneficiary status enabled */
export type TrustedBeneficiaryEnabledStatusInfo = TrustedBeneficiaryStatusInfo & {
  __typename: "TrustedBeneficiaryEnabledStatusInfo";
  /** enabled Date */
  enabledAt: Scalars["DateTime"]["output"];
  /** status of the beneficiary (set to `Enabled`) */
  status: TrustedBeneficiaryStatus;
};

/** Filters that can be applied when listing trusted beneficiaries */
export type TrustedBeneficiaryFiltersInput = {
  currency?: InputMaybe<Scalars["Currency"]["input"]>;
  label?: InputMaybe<Scalars["String"]["input"]>;
  status?: InputMaybe<Array<TrustedBeneficiaryStatus>>;
  type?: InputMaybe<Array<BeneficiaryType>>;
};

/** Rejection returned if the trusted beneficiary was not found or if the user does not have the rights to know that the beneficiary exists */
export type TrustedBeneficiaryNotFoundRejection = Rejection & {
  __typename: "TrustedBeneficiaryNotFoundRejection";
  id: Scalars["String"]["output"];
  message: Scalars["String"]["output"];
};

/** Field we can use when ordering that can be applied when listing trusted beneficiaries */
export type TrustedBeneficiaryOrderByFieldInput = "createdAt" | "label" | "updatedAt";

/** Order that can be applied when listing trusted beneficiaries */
export type TrustedBeneficiaryOrderByInput = {
  direction?: InputMaybe<OrderByDirection>;
  field?: InputMaybe<TrustedBeneficiaryOrderByFieldInput>;
};

/** TrustedBeneficiary status */
export type TrustedBeneficiaryStatus =
  /** when the beneficiary has been canceled */
  | "Canceled"
  /** when a consent is pending before initiating */
  | "ConsentPending"
  /** when the beneficiary has been enabled */
  | "Enabled";

/** TrustedBeneficiary status information */
export type TrustedBeneficiaryStatusInfo = {
  /** status of the beneficiary */
  status: TrustedBeneficiaryStatus;
};

/** Trusted Internal Beneficiary */
export type TrustedInternalBeneficiary = TrustedBeneficiary & {
  __typename: "TrustedInternalBeneficiary";
  /** beneficiary account Id */
  accountId: Scalars["ID"]["output"];
  /** created date */
  createdAt: Scalars["DateTime"]["output"];
  /** unique identifier of a trusted beneficiary */
  id: Scalars["ID"]["output"];
  /** label of the beneficiary */
  label: Scalars["String"]["output"];
  /** full name of the beneficiary */
  name: Scalars["String"]["output"];
  /** status information */
  statusInfo: TrustedBeneficiaryStatusInfo;
  /** List of transactions associated with the Trusted Beneficiary. */
  transactions?: Maybe<TransactionConnection>;
  /** type of the beneficiary */
  type: BeneficiaryType;
  /** updated date */
  updatedAt: Scalars["DateTime"]["output"];
};

/** Trusted Internal Beneficiary */
export type TrustedInternalBeneficiaryTransactionsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  filters?: InputMaybe<TransactionsFiltersInput>;
  first?: Scalars["Int"]["input"];
};

/** Trusted International Beneficiary */
export type TrustedInternationalBeneficiary = InternationalBeneficiary &
  TrustedBeneficiary & {
    __typename: "TrustedInternationalBeneficiary";
    /** created date */
    createdAt: Scalars["DateTime"]["output"];
    /** Currency of the international beneficiary */
    currency: Scalars["Currency"]["output"];
    /** Currency-specific details of the beneficiary */
    details: Array<InternationalCreditTransferDetails>;
    /** unique identifier of a trusted beneficiary */
    id: Scalars["ID"]["output"];
    /** label of the beneficiary */
    label: Scalars["String"]["output"];
    /** name of the beneficiary */
    name: Scalars["String"]["output"];
    /** Route that Swan will use to transfer the funds */
    route: InternationalCreditTransferRoute;
    /** status information */
    statusInfo: TrustedBeneficiaryStatusInfo;
    /** List of transactions associated with the Trusted Beneficiary. */
    transactions?: Maybe<TransactionConnection>;
    /** type of the beneficiary */
    type: BeneficiaryType;
    /** updated date */
    updatedAt: Scalars["DateTime"]["output"];
  };

/** Trusted International Beneficiary */
export type TrustedInternationalBeneficiaryTransactionsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  filters?: InputMaybe<TransactionsFiltersInput>;
  first?: Scalars["Int"]["input"];
};

/** Trusted SEPA Beneficiary type SEPA */
export type TrustedSepaBeneficiary = TrustedBeneficiary & {
  __typename: "TrustedSepaBeneficiary";
  /** beneficiary address */
  address?: Maybe<Address>;
  /** created date */
  createdAt: Scalars["DateTime"]["output"];
  /** IBAN if the beneficiary is a an account in an other financial institution */
  iban: Scalars["IBAN"]["output"];
  /** unique identifier of a trusted beneficiary */
  id: Scalars["ID"]["output"];
  /** label of the beneficiary */
  label: Scalars["String"]["output"];
  /** full name of the beneficiary */
  name: Scalars["String"]["output"];
  /** status information */
  statusInfo: TrustedBeneficiaryStatusInfo;
  /** List of transactions associated with the Trusted Beneficiary. */
  transactions?: Maybe<TransactionConnection>;
  /** type of the beneficiary */
  type: BeneficiaryType;
  /** updated date */
  updatedAt: Scalars["DateTime"]["output"];
};

/** Trusted SEPA Beneficiary type SEPA */
export type TrustedSepaBeneficiaryTransactionsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  filters?: InputMaybe<TransactionsFiltersInput>;
  first?: Scalars["Int"]["input"];
};

export type TrustedSepaBeneficiaryInput = {
  /** Beneficiary address */
  address?: InputMaybe<AddressInput>;
  /** IBAN of the SEPA trusted beneficiary */
  iban: Scalars["IBAN"]["input"];
  /** Label of the SEPA trusted beneficiary. If not provided, the name will be used. */
  label?: InputMaybe<Scalars["String"]["input"]>;
  /** Name of the SEPA trusted beneficiary */
  name: Scalars["String"]["input"];
};

/** Quality of the account holder doing the onboarding */
export type TypeOfRepresentation =
  /** The account holder is the legal representative */
  | "LegalRepresentative"
  /** The account holder has a power of attorney */
  | "PowerOfAttorney";

export type UboIdentityDocumentDetails = {
  __typename: "UBOIdentityDocumentDetails";
  /** Expiry date of the identity document */
  expiryDate?: Maybe<Scalars["String"]["output"]>;
  /** Issue date of the identity document */
  issueDate?: Maybe<Scalars["String"]["output"]>;
  /** Issuing authority of the identity document */
  issuingAuthority?: Maybe<Scalars["String"]["output"]>;
  /** Number of the identity document */
  number?: Maybe<Scalars["String"]["output"]>;
  /** Type of identity document */
  type?: Maybe<UboIdentityDocumentType>;
};

export type UboIdentityDocumentDetailsInput = {
  /** Expiry date of the identity document */
  expiryDate?: InputMaybe<Scalars["String"]["input"]>;
  /** Issue date of the identity document */
  issueDate?: InputMaybe<Scalars["String"]["input"]>;
  /** Issuing authority of the identity document */
  issuingAuthority?: InputMaybe<Scalars["String"]["input"]>;
  /** Number of the identity document */
  number?: InputMaybe<Scalars["String"]["input"]>;
  /** Type of identity document */
  type?: InputMaybe<UboIdentityDocumentType>;
};

export type UboIdentityDocumentType = "IdCard" | "Passport";

export type UltimateBeneficialOwner = {
  __typename: "UltimateBeneficialOwner";
  address?: Maybe<AddressInfo>;
  birthInfo?: Maybe<BirthInfo>;
  controlTypes?: Maybe<Array<UltimateBeneficialOwnerControlType>>;
  firstName?: Maybe<Scalars["String"]["output"]>;
  identityDocumentInfo?: Maybe<UltimateBeneficialOwnerIdentityDocumentInfo>;
  lastName?: Maybe<Scalars["String"]["output"]>;
  ownership?: Maybe<UltimateBeneficialOwnerOwnership>;
  qualificationType?: Maybe<UltimateBeneficialOwnerQualificationType>;
  sex?: Maybe<Sex>;
  taxIdentificationNumber?: Maybe<Scalars["String"]["output"]>;
  unitedStatesTaxInfo?: Maybe<UnitedStatesTaxInfo>;
};

export type UltimateBeneficialOwnerControlType =
  | "ControlViaTrustOrSimilar"
  | "RightToAppointOrRemoveBoard"
  | "ShareholderAgreementOrContract"
  | "StrategicOrManagerialInfluence"
  | "VotingRights";

export type UltimateBeneficialOwnerIdentityDocumentInfo = {
  __typename: "UltimateBeneficialOwnerIdentityDocumentInfo";
  expiryDate?: Maybe<Scalars["Date"]["output"]>;
  issueDate?: Maybe<Scalars["Date"]["output"]>;
  issuingAuthority?: Maybe<Scalars["String"]["output"]>;
  number?: Maybe<Scalars["String"]["output"]>;
  type?: Maybe<UboIdentityDocumentType>;
};

export type UltimateBeneficialOwnerIdentityDocumentInfoInput = {
  expiryDate?: InputMaybe<Scalars["Date"]["input"]>;
  issueDate?: InputMaybe<Scalars["Date"]["input"]>;
  issuingAuthority?: InputMaybe<Scalars["String"]["input"]>;
  number?: InputMaybe<Scalars["String"]["input"]>;
  type?: InputMaybe<UboIdentityDocumentType>;
};

/** The Ultimate Beneficial Owner could be for an Individual or a Company and these can Direct or Indirect */
export type UltimateBeneficialOwnerInfo = {
  /** Ultimate Beneficial Owner Unique Identifier . */
  id: Scalars["ID"]["output"];
  /** Shares ratio of the parent company. Example: 50 if the share ratio is 50%. */
  parentCompanyShareRatio: Scalars["Float"]["output"];
  /** Ultimate beneficial owner type. */
  type: UltimateBeneficialOwnerType;
};

export type UltimateBeneficialOwnerInput = {
  address?: InputMaybe<ResidencyAddressInput>;
  birthInfo?: InputMaybe<BirthInfoInput>;
  controlTypes?: InputMaybe<Array<UltimateBeneficialOwnerControlType>>;
  firstName?: InputMaybe<Scalars["String"]["input"]>;
  identityDocumentInfo?: InputMaybe<UltimateBeneficialOwnerIdentityDocumentInfoInput>;
  lastName?: InputMaybe<Scalars["String"]["input"]>;
  ownership?: InputMaybe<UltimateBeneficialOwnerOwnershipInput>;
  qualificationType?: InputMaybe<UltimateBeneficialOwnerQualificationType>;
  sex?: InputMaybe<Sex>;
  taxIdentificationNumber?: InputMaybe<Scalars["String"]["input"]>;
  unitedStatesTaxInfo?: InputMaybe<UnitedStatesTaxInfoInput>;
};

export type UltimateBeneficialOwnerOwnership = {
  __typename: "UltimateBeneficialOwnerOwnership";
  totalPercentage?: Maybe<Scalars["Float"]["output"]>;
  type: UltimateBeneficialOwnerOwnershipType;
};

export type UltimateBeneficialOwnerOwnershipInput = {
  totalPercentage?: InputMaybe<Scalars["Float"]["input"]>;
  type: UltimateBeneficialOwnerOwnershipType;
};

export type UltimateBeneficialOwnerOwnershipType = "Direct" | "DirectAndIndirect" | "Indirect";

export type UltimateBeneficialOwnerQualificationType =
  | "Control"
  | "LegalRepresentative"
  | "Ownership";

/** Ultimate Beneficial Owner type. */
export type UltimateBeneficialOwnerType =
  /** Direct Company Owner (Legal person). */
  | "DirectCompany"
  /** Direct Individual Owner (Natural person) . */
  | "DirectIndividual"
  /** Indirect Company Owner (Legal person). */
  | "IndirectCompany"
  /** Indirect Individual Owner (Natural person). */
  | "IndirectIndividual";

export type UnitedStatesTaxInfo = {
  __typename: "UnitedStatesTaxInfo";
  /** is the ultimate benefial owner a US person as defined by the Foreign Account Tax Compliance Act (FATCA) */
  isUnitedStatesPerson?: Maybe<Scalars["Boolean"]["output"]>;
  unitedStatesTaxIdentificationNumber?: Maybe<Scalars["String"]["output"]>;
};

export type UnitedStatesTaxInfoInput = {
  /** is the ultimate benefial owner a US person as defined by the Foreign Account Tax Compliance Act (FATCA) */
  isUnitedStatesPerson: Scalars["Boolean"]["input"];
  unitedStatesTaxIdentificationNumber?: InputMaybe<Scalars["String"]["input"]>;
};

/** Rejection returned when the provided `exportId` is not found. */
export type UnknownExportRejection = Rejection & {
  __typename: "UnknownExportRejection";
  message: Scalars["String"]["output"];
};

export type UnsavedInternationalBeneficiary = InternationalBeneficiary & {
  __typename: "UnsavedInternationalBeneficiary";
  /** Currency of the international beneficiary */
  currency: Scalars["Currency"]["output"];
  /** Currency-specific details of the beneficiary */
  details: Array<InternationalCreditTransferDetails>;
  /** name of the beneficiary */
  name: Scalars["String"]["output"];
  /** Route that Swan will use to transfer the funds */
  route: InternationalCreditTransferRoute;
};

export type UnsavedSepaBeneficiary = {
  __typename: "UnsavedSepaBeneficiary";
  /** address of the beneficiary */
  address?: Maybe<Address>;
  /** IBAN of the beneficiary */
  iban: Scalars["IBAN"]["output"];
  /** name of the beneficiary */
  name: Scalars["String"]["output"];
};

/** Upcoming transaction status information */
export type UpcomingTransactionStatusInfo = TransactionStatusInfo & {
  __typename: "UpcomingTransactionStatusInfo";
  /** The date when the transaction will be executed */
  executionDate: Scalars["DateTime"]["output"];
  /** unique identifier of the transaction */
  id: Scalars["ID"]["output"];
  /** status of the transaction */
  status: TransactionStatus;
};

export type UpdateAccountHolderInput = {
  accountHolderId: Scalars["ID"]["input"];
  taxIdentificationNumber?: InputMaybe<Scalars["String"]["input"]>;
  vatNumber?: InputMaybe<Scalars["String"]["input"]>;
};

export type UpdateAccountHolderPayload =
  | AccountHolderNotFoundRejection
  | UpdateAccountHolderSuccessPayload
  | ValidationRejection;

export type UpdateAccountHolderRiskInfoInput = {
  accountHolderId: Scalars["ID"]["input"];
  hasAdverseMedia: Scalars["Boolean"]["input"];
  hasFrozenAssets: Scalars["Boolean"]["input"];
  isPoliticallyExposed: Scalars["Boolean"]["input"];
};

export type UpdateAccountHolderRiskInfoPayload =
  | AccountHolderNotFoundRejection
  | ForbiddenRejection
  | UpdateAccountHolderRiskInfoSuccessPayload
  | ValidationRejection;

export type UpdateAccountHolderRiskInfoSuccessPayload = {
  __typename: "UpdateAccountHolderRiskInfoSuccessPayload";
  accountHolderId: Scalars["ID"]["output"];
  hasAdverseMedia: Scalars["Boolean"]["output"];
  hasFrozenAssets: Scalars["Boolean"]["output"];
  isPoliticallyExposed: Scalars["Boolean"]["output"];
};

export type UpdateAccountHolderSuccessPayload = {
  __typename: "UpdateAccountHolderSuccessPayload";
  accountHolder: AccountHolder;
};

/** Inputs to update an account */
export type UpdateAccountInput = {
  /** Unique identifier of an account */
  accountId: Scalars["ID"]["input"];
  /** Language */
  language?: InputMaybe<AccountLanguage>;
  /** Name */
  name?: InputMaybe<Scalars["String"]["input"]>;
};

/** Inputs to update an account membership */
export type UpdateAccountMembershipInput = {
  /** Unique identifier of an account membership */
  accountMembershipId: Scalars["ID"]["input"];
  /** `true` if this account membership can initiate credit transfers */
  canInitiatePayments?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** `true` if this account membership can invite, update, suspend or resume memberships */
  canManageAccountMembership?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** `true` if this account membership can add or canceled beneficiaries */
  canManageBeneficiaries?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** `true` if this account membership can manage cards for himself or to the memberships he manages */
  canManageCards?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** `true` if this account membership can view account balances and transactions history */
  canViewAccount?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** URL the user is redirected to after consent has been given */
  consentRedirectUrl: Scalars["String"]["input"];
  /** Email address */
  email?: InputMaybe<Scalars["String"]["input"]>;
  /** Language of the account membership */
  language?: InputMaybe<AccountLanguage>;
  /** Residency address of the member to be added */
  residencyAddress?: InputMaybe<ResidencyAddressInput>;
  /** Restricted to a user if necessary */
  restrictedTo?: InputMaybe<UpdatedRestrictedToInput>;
  /** Periodic Spending limit */
  spendingLimit?: InputMaybe<SpendingLimitInput>;
  /** Tax Identification Number of the user added */
  taxIdentificationNumber?: InputMaybe<Scalars["String"]["input"]>;
};

export type UpdateAccountMembershipPayload =
  | AccountMembershipCannotBeUpdatedRejection
  | AccountMembershipNotFoundRejection
  | AccountMembershipNotReadyToBeUpdatedRejection
  | AccountNotFoundRejection
  | ForbiddenRejection
  | InternalErrorRejection
  | InvalidPhoneNumberRejection
  | LegalRepresentativeEmailCannotBeUpdatedRejection
  | LegalRepresentativePermissionsCannotBeUpdatedRejection
  | MissingBirthDateRejection
  | MissingPhoneNumberRestrictionRejection
  | PermissionCannotBeGrantedRejection
  | UpdateAccountMembershipSuccessPayload
  | UserNotAllowedToManageAccountMembershipRejection
  | ValidationRejection;

export type UpdateAccountMembershipSuccessPayload = {
  __typename: "UpdateAccountMembershipSuccessPayload";
  consent: Consent;
};

export type UpdateAccountPayload =
  | AccountNotFoundRejection
  | BadAccountStatusRejection
  | ForbiddenRejection
  | InternalErrorRejection
  | UpdateAccountSuccessPayload
  | ValidationRejection;

export type UpdateAccountSettingsConsentPending = {
  __typename: "UpdateAccountSettingsConsentPending";
  consent: Consent;
};

export type UpdateAccountSettingsInput = {
  /** Unique identifier of the account */
  accountId: Scalars["ID"]["input"];
  /** Allow or disallow bulk credit transfers without beneficiary verification */
  allowBulkCreditTransfersWithoutBeneficiaryVerification: Scalars["Boolean"]["input"];
  /**
   * When setting allowBulkCreditTransfersWithoutBeneficiaryVerification to true, the consentRedirectUrl is required
   * otherwise it is not needed
   */
  consentRedirectUrl?: InputMaybe<Scalars["String"]["input"]>;
};

export type UpdateAccountSettingsPayload =
  | AccountHolderNotFoundRejection
  | AccountHolderTypeNotEligibleRejection
  | AccountMembershipNotEligibleRejection
  | AccountMembershipNotFoundRejection
  | AccountMembershipStatusNotEligibleRejection
  | AccountNotFoundRejection
  | AccountTypeNotEligibleRejection
  | ForbiddenRejection
  | InternalErrorRejection
  | UpdateAccountSettingsConsentPending
  | UpdateAccountSettingsSuccess
  | ValidationRejection;

export type UpdateAccountSettingsSuccess = {
  __typename: "UpdateAccountSettingsSuccess";
  account: Account;
};

export type UpdateAccountSuccessPayload = {
  __typename: "UpdateAccountSuccessPayload";
  account: Account;
};

export type UpdateCapitalDepositCaseCompanyInput = {
  capitalDepositCaseId: Scalars["ID"]["input"];
  companyName?: InputMaybe<Scalars["String"]["input"]>;
  residencyAddress?: InputMaybe<ResidencyAddressInput>;
};

export type UpdateCapitalDepositCaseCompanyPayload =
  | BadRequestRejection
  | CapitalDepositCaseCanNotBeFoundRejection
  | CapitalDepositCaseCompanyCannotBeUpdatedRejection
  | ForbiddenRejection
  | InternalErrorRejection
  | UpdateCapitalDepositCaseCompanySuccessPayload
  | ValidationRejection;

export type UpdateCapitalDepositCaseCompanySuccessPayload = {
  __typename: "UpdateCapitalDepositCaseCompanySuccessPayload";
  capitalDepositCase: CapitalDepositCase;
};

/** Input to update a shareholder's capital deposit amount. */
export type UpdateCapitalDepositShareholderAmountInput = {
  shareholderAmount: AmountInput;
  shareholderId: Scalars["ID"]["input"];
};

/** Payload to update a shareholder's capital deposit amount. */
export type UpdateCapitalDepositShareholderAmountPayload =
  | CapitalDepositCaseCanNotBeFoundRejection
  | CapitalDepositCaseCanNotBeUpdatedRejection
  | CapitalDepositShareholderCanNotBeUpdatedRejection
  | CapitalDepositShareholderCannotBeFoundRejection
  | ForbiddenRejection
  | InternalErrorRejection
  | UpdateCapitalDepositShareholderAmountSuccessPayload
  | ValidationRejection;

export type UpdateCapitalDepositShareholderAmountSuccessPayload = {
  __typename: "UpdateCapitalDepositShareholderAmountSuccessPayload";
  shareholder: Shareholder;
};

/** Input to Update Card */
export type UpdateCardInput = {
  /** Card expiration date  if `null` it does not have an expiration date */
  cardContractExpiryDate?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** Unique identifier of the card to update */
  cardId: Scalars["ID"]["input"];
  /** URL the user is redirected to after consent has been given */
  consentRedirectUrl: Scalars["String"]["input"];
  /** `true` if this card allows transactions at eCommerce sites */
  eCommerce: Scalars["Boolean"]["input"];
  /** `true` if this card allows payments outside of the country */
  international: Scalars["Boolean"]["input"];
  /** Card name */
  name?: InputMaybe<Scalars["String"]["input"]>;
  /** `true` if this card allows transactions outside of the card's main currency */
  nonMainCurrencyTransactions: Scalars["Boolean"]["input"];
  /** Periodic Spending limit */
  spendingLimit?: InputMaybe<SpendingLimitInput>;
  /** `true` if this card allows cash withdrawals */
  withdrawal: Scalars["Boolean"]["input"];
};

export type UpdateCardPayload =
  | AccountMembershipNotAllowedRejection
  | AccountNotFoundRejection
  | CardNotFoundRejection
  | ForbiddenRejection
  | UpdateCardSuccessPayload
  | ValidationRejection;

export type UpdateCardSuccessPayload = {
  __typename: "UpdateCardSuccessPayload";
  consent: Consent;
};

/** Input for updating a company account holder onboarding */
export type UpdateCompanyAccountHolderOnboardingInput = {
  /** Account admin information for the company account holder */
  accountAdmin?: InputMaybe<CompanyAccountHolderOnboardingAccountAdminUpdateInput>;
  /** Account information for the company account holder */
  accountInfo?: InputMaybe<CompanyAccountHolderOnboardingAccountUpdateInput>;
  /** Company information */
  company?: InputMaybe<CompanyInfoUpdateInput>;
  /** ID of the onboarding to update */
  onboardingId: Scalars["ID"]["input"];
};

/** Payload for updating a company account holder onboarding */
export type UpdateCompanyAccountHolderOnboardingPayload =
  | ForbiddenRejection
  | InternalErrorRejection
  | OnboardingAlreadyFinalizedRejection
  | OnboardingNotFoundRejection
  | UpdateCompanyAccountHolderOnboardingSuccessPayload
  | ValidationRejection;

/** Success response for updating a company account holder onboarding */
export type UpdateCompanyAccountHolderOnboardingSuccessPayload = {
  __typename: "UpdateCompanyAccountHolderOnboardingSuccessPayload";
  /** The updated company account holder onboarding */
  onboarding: CompanyAccountHolderOnboarding;
};

export type UpdateCompanyOnboardingInput = {
  /** Country of the account created at the end of onboarding. */
  accountCountry?: InputMaybe<AccountCountry>;
  /**
   * Account name of the company account holder.
   * - Length must be from 0 to 100 characters
   */
  accountName?: InputMaybe<Scalars["String"]["input"]>;
  /** Use the `acquisitionChannel` field to specify how the user joined, such as "InboundOrganic", "OutboundSales", etc. */
  acquisitionChannel?: InputMaybe<AcquisitionChannel>;
  /** Business activity. */
  businessActivity?: InputMaybe<BusinessActivity>;
  /**
   * Description of the business activity.
   * - Length must be from 0 to 1024 characters.
   */
  businessActivityDescription?: InputMaybe<Scalars["String"]["input"]>;
  /** Type of the company (Association ...). */
  companyType?: InputMaybe<CompanyType>;
  /**
   * Email of the legal representative.
   * - Length must be from 0 to 255 characters.
   * - Valid format (regex):
   *   ```
   *   /^[A-Z0-9_+.-]*[A-Z0-9_+-]@([A-Z0-9][A-Z0-9-]*\.)+[A-Z]{2,}$/i
   *   ```
   * - Some email providers are not accepted by our system.
   */
  email?: InputMaybe<Scalars["String"]["input"]>;
  /**
   * The ultimate beneficial owner is defined as the natural person (s) who own or control, directly and/or indirectly, the reporting company.
   *
   * The ultimate beneficial owner is :
   * - either the natural person (s) who hold, directly or indirectly, more than 25% of the capital or the rights of vote of the reporting company;
   * - either the natural person (s) who exercise, by other means, a power of control of the company;
   */
  individualUltimateBeneficialOwners?: InputMaybe<Array<IndividualUltimateBeneficialOwnerInput>>;
  /** Is the company registered with their country's national register (for example, Registre du Commerce et des Sociétés [RCS] in France). */
  isRegistered?: InputMaybe<Scalars["Boolean"]["input"]>;
  /**
   * Language of the onboarding process.
   * - Accepted languages: `["en", "fr", "nl", "de", "it", "es", "pt", "fi"]`
   */
  language?: InputMaybe<Scalars["String"]["input"]>;
  /** Legal representative personal address. */
  legalRepresentativePersonalAddress?: InputMaybe<AddressInformationInput>;
  /** Estimated monthly payment volume (euro). */
  monthlyPaymentVolume?: InputMaybe<MonthlyPaymentVolume>;
  /**
   * Company name.
   * - Length must be from 0 to 100 characters.
   * - Valid format (regex):
   *   ```
   *   /^(?:(?<!http(s)*:\/\/|www\.|&lt;|&gt;)[!-.\/-;A-Z[-`a-zÀ-ÖÙ-öº-ƿǄ-ʯʹ-ʽΈ-ΊΎ-ΡΣ-ҁҊ-Ֆա-ևႠ-Ⴥა-ჺᄀ-፜፩-ᎏᵫ-ᶚḀ-῾ⴀ-ⴥ⺀-⿕ぁ-ゖゝ-ㇿ㋿-鿯鿿-ꒌꙀ-ꙮꚀ-ꚙꜦ-ꞇꞍ-ꞿꥠ-ꥼＡ-Ｚａ-ｚ/]|¿|¡| |'|-|Ά|Ό|=|\?|@|\[|]|\||‘|’)*$/
   *   ```
   */
  name?: InputMaybe<Scalars["String"]["input"]>;
  /** ID of the onboarding to update. */
  onboardingId: Scalars["ID"]["input"];
  /**
   * Registration number of the company (for example, Système d'Identification du Répertoire des ENtreprises [SIREN] in France, ...).
   * - Length must be from 0 to 50 characters.
   */
  registrationNumber?: InputMaybe<Scalars["String"]["input"]>;
  /** Inputs to add a representative */
  representatives?: InputMaybe<Array<RepresentativeInput>>;
  /**
   * Residency address of the head office.
   * - Must be in a European country.
   */
  residencyAddress?: InputMaybe<ResidencyAddressInput>;
  /**
   * Tax Identification Number.
   * - Must be from 0 to 16 characters.
   */
  taxIdentificationNumber?: InputMaybe<Scalars["String"]["input"]>;
  /** Trade name of the company. */
  tradeName?: InputMaybe<Scalars["String"]["input"]>;
  /** Type of representation (legal representative or power of attorney). */
  typeOfRepresentation?: InputMaybe<TypeOfRepresentation>;
  /**
   * VAT number of the company.
   * - (AT)?U[0-9]{8} |                              # Austria
   * - (BE)?0[0-9]{9} |                              # Belgium
   * - (BG)?[0-9]{9,10} |                            # Bulgaria
   * - (CY)?[0-9]{8}L |                              # Cyprus
   * - (CZ)?[0-9]{8,10} |                            # Czech Republic
   * - (DE)?[0-9]{9} |                               # Germany
   * - (DK)?[0-9]{8} |                               # Denmark
   * - (EE)?[0-9]{9} |                               # Estonia
   * - (EL|GR)?[0-9]{9} |                            # Greece
   * - (ES)?[0-9A-Z][0-9]{7}[0-9A-Z] |               # Spain
   * - (FI)?[0-9]{8} |                               # Finland
   * - (FR)?[0-9A-Z]{2}[0-9]{9} |                    # France
   * - (GB)?([0-9]{9}([0-9]{3})?|[A-Z]{2}[0-9]{3}) | # United Kingdom
   * - (HU)?[0-9]{8} |                               # Hungary
   * - (IE)?[0-9]S[0-9]{5}L |                        # Ireland
   * - (IT)?[0-9]{11} |                              # Italy
   * - (LT)?([0-9]{9}|[0-9]{12}) |                   # Lithuania
   * - (LU)?[0-9]{8} |                               # Luxembourg
   * - (LV)?[0-9]{11} |                              # Latvia
   * - (MT)?[0-9]{8} |                               # Malta
   * - (NL)?[0-9]{9}B[0-9]{2} |                      # Netherlands
   * - (PL)?[0-9]{10} |                              # Poland
   * - (PT)?[0-9]{9} |                               # Portugal
   * - (RO)?[0-9]{2,10} |                            # Romania
   * - (SE)?[0-9]{12} |                              # Sweden
   * - (SI)?[0-9]{8} |                               # Slovenia
   * - (SK)?[0-9]{10}                                # Slovakia
   */
  vatNumber?: InputMaybe<Scalars["String"]["input"]>;
};

/** Possible results for mutation `updateCompanyOnboarding` */
export type UpdateCompanyOnboardingPayload =
  | ForbiddenRejection
  | InternalErrorRejection
  | UpdateCompanyOnboardingSuccessPayload
  | ValidationRejection;

/** Result when updateCompanyOnboarding is a success */
export type UpdateCompanyOnboardingSuccessPayload = {
  __typename: "UpdateCompanyOnboardingSuccessPayload";
  onboarding: OnboardingInfo;
};

export type UpdateCompanyVerificationRenewalInput = {
  accountAdmin?: InputMaybe<CompanyVerificationRenewalAccountAdminInput>;
  additionalDetails?: InputMaybe<Scalars["String"]["input"]>;
  company?: InputMaybe<CompanyVerificationRenewalInfoInput>;
  verificationRenewalId: Scalars["ID"]["input"];
};

export type UpdateCompanyVerificationRenewalPayload =
  | ForbiddenRejection
  | UpdateCompanyVerificationRenewalSuccessPayload
  | ValidationRejection
  | VerificationRenewalNotFoundRejection
  | VerificationRenewalUpdateNotAllowedRejection;

export type UpdateCompanyVerificationRenewalSuccessPayload = {
  __typename: "UpdateCompanyVerificationRenewalSuccessPayload";
  verificationRenewal: VerificationRenewal;
};

/** Updatable account administrator information for an individual onboarding */
export type UpdateIndividualAccountHolderOnboardingAccountAdminInput = {
  address?: InputMaybe<ResidencyAddressInput>;
  birthInfo?: InputMaybe<BirthInfoInput>;
  email?: InputMaybe<Scalars["String"]["input"]>;
  employmentStatus?: InputMaybe<EmploymentStatus>;
  firstName?: InputMaybe<Scalars["String"]["input"]>;
  lastName?: InputMaybe<Scalars["String"]["input"]>;
  monthlyIncome?: InputMaybe<MonthlyIncome>;
  nationality?: InputMaybe<Scalars["CCA3"]["input"]>;
  preferredLanguage?: InputMaybe<AccountLanguage>;
  sourcesOfFunds?: InputMaybe<Array<IndividualAccountSourceOfFunds>>;
  taxIdentificationNumber?: InputMaybe<Scalars["String"]["input"]>;
  unitedStatesTaxInfo?: InputMaybe<UnitedStatesTaxInfoInput>;
};

/** Updatable account information for an individual onboarding */
export type UpdateIndividualAccountHolderOnboardingAccountInput = {
  intendedUsages?: InputMaybe<Array<IndividualAccountIntendedUsage>>;
  name?: InputMaybe<Scalars["String"]["input"]>;
};

/** Input for updating an individual account holder onboarding */
export type UpdateIndividualAccountHolderOnboardingInput = {
  /** Updatable account admin information for the individual account holder */
  accountAdmin?: InputMaybe<UpdateIndividualAccountHolderOnboardingAccountAdminInput>;
  /** Account information for the individual account holder */
  accountInfo?: InputMaybe<UpdateIndividualAccountHolderOnboardingAccountInput>;
  /** The unique identifier of the onboarding to update */
  onboardingId: Scalars["ID"]["input"];
};

/** Payload for updating an individual account holder onboarding */
export type UpdateIndividualAccountHolderOnboardingPayload =
  | ForbiddenRejection
  | UpdateIndividualAccountHolderOnboardingSuccessPayload
  | ValidationRejection;

/** Success response for updating an individual account holder onboarding */
export type UpdateIndividualAccountHolderOnboardingSuccessPayload = {
  __typename: "UpdateIndividualAccountHolderOnboardingSuccessPayload";
  /** The updated individual account holder onboarding */
  onboarding: IndividualAccountHolderOnboarding;
};

export type UpdateIndividualOnboardingInput = {
  /** Country of the account created at the end of onboarding. */
  accountCountry?: InputMaybe<AccountCountry>;
  /**
   * Account name of the individual account holder.
   * - Length must be from 0 to 100 characters.
   */
  accountName?: InputMaybe<Scalars["String"]["input"]>;
  /** Use the `acquisitionChannel` field to specify how the user joined, such as "InboundOrganic", "OutboundSales", etc. */
  acquisitionChannel?: InputMaybe<AcquisitionChannel>;
  /**
   * Email of the legal representative.
   * - Length must be from 0 to 255 characters.
   * - Valid format (regex):
   *   ```
   *   /^[A-Z0-9_+.-]*[A-Z0-9_+-]@([A-Z0-9][A-Z0-9-]*\.)+[A-Z]{2,}$/i
   *   ```
   * - Some email providers are not accepted by our system.
   */
  email?: InputMaybe<Scalars["String"]["input"]>;
  /** Employment status of the individual account holder. */
  employmentStatus?: InputMaybe<EmploymentStatus>;
  /**
   * Language of the onboarding process.
   * - Accepted languages: `["en", "fr", "nl", "de", "it", "es", "pt", "fi"]`
   */
  language?: InputMaybe<Scalars["String"]["input"]>;
  /** Monthly income of the individual account holder (euro). */
  monthlyIncome?: InputMaybe<MonthlyIncome>;
  /** ID of the onboarding to update. */
  onboardingId: Scalars["ID"]["input"];
  /**
   * Residency address of the individual account holder.
   * - Must be in a European country.
   */
  residencyAddress?: InputMaybe<ResidencyAddressInput>;
  /**
   *   Tax Identification Number.
   * - Must be from 0 to 16 characters.
   */
  taxIdentificationNumber?: InputMaybe<Scalars["String"]["input"]>;
};

/** Possible result types for `updateIndividualOnboarding` */
export type UpdateIndividualOnboardingPayload =
  | ForbiddenRejection
  | InternalErrorRejection
  | UpdateIndividualOnboardingSuccessPayload
  | ValidationRejection;

/** Type of result when updateIndividualOnboarding is a success */
export type UpdateIndividualOnboardingSuccessPayload = {
  __typename: "UpdateIndividualOnboardingSuccessPayload";
  onboarding: OnboardingInfo;
};

export type UpdateIndividualVerificationRenewalInput = {
  accountAdmin?: InputMaybe<IndividualVerificationRenewalAccountAdminInput>;
  additionalDetails?: InputMaybe<Scalars["String"]["input"]>;
  verificationRenewalId: Scalars["ID"]["input"];
};

export type UpdateIndividualVerificationRenewalPayload =
  | ForbiddenRejection
  | UpdateIndividualVerificationRenewalSuccessPayload
  | ValidationRejection
  | VerificationRenewalNotFoundRejection
  | VerificationRenewalUpdateNotAllowedRejection;

export type UpdateIndividualVerificationRenewalSuccessPayload = {
  __typename: "UpdateIndividualVerificationRenewalSuccessPayload";
  verificationRenewal: VerificationRenewal;
};

/** Input for updating a public company account holder onboarding */
export type UpdatePublicCompanyAccountHolderOnboardingInput = {
  /** Account admin information for the company account holder */
  accountAdmin?: InputMaybe<CompanyAccountHolderOnboardingAccountAdminUpdateInput>;
  /** Account information for the company account holder */
  accountInfo?: InputMaybe<CompanyAccountHolderOnboardingAccountUpdateInput>;
  /** Company information */
  company?: InputMaybe<CompanyInfoUpdateInput>;
  /** ID of the onboarding to update */
  onboardingId: Scalars["ID"]["input"];
};

/** Payload for updating a public company account holder onboarding */
export type UpdatePublicCompanyAccountHolderOnboardingPayload =
  | ForbiddenRejection
  | InternalErrorRejection
  | OnboardingAlreadyFinalizedRejection
  | OnboardingNotFoundRejection
  | PublicOnboardingDisabledRejection
  | UpdatePublicCompanyAccountHolderOnboardingSuccessPayload
  | ValidationRejection;

/** Success response for updating a public company account holder onboarding */
export type UpdatePublicCompanyAccountHolderOnboardingSuccessPayload = {
  __typename: "UpdatePublicCompanyAccountHolderOnboardingSuccessPayload";
  /** The updated company account holder onboarding */
  onboarding: CompanyAccountHolderOnboarding;
};

/** Updatable account administrator information for an individual onboarding */
export type UpdatePublicIndividualAccountHolderOnboardingAccountAdminInput = {
  address?: InputMaybe<ResidencyAddressInput>;
  birthInfo?: InputMaybe<BirthInfoInput>;
  email?: InputMaybe<Scalars["String"]["input"]>;
  employmentStatus?: InputMaybe<EmploymentStatus>;
  firstName?: InputMaybe<Scalars["String"]["input"]>;
  lastName?: InputMaybe<Scalars["String"]["input"]>;
  monthlyIncome?: InputMaybe<MonthlyIncome>;
  nationality?: InputMaybe<Scalars["CCA3"]["input"]>;
  preferredLanguage?: InputMaybe<AccountLanguage>;
  sourceOfFunds?: InputMaybe<IndividualAccountSourceOfFunds>;
  taxIdentificationNumber?: InputMaybe<Scalars["String"]["input"]>;
  unitedStatesTaxInfo?: InputMaybe<UnitedStatesTaxInfoInput>;
};

/** Updatable account information for an individual onboarding */
export type UpdatePublicIndividualAccountHolderOnboardingAccountInput = {
  intendedUsages?: InputMaybe<Array<IndividualAccountIntendedUsage>>;
  name?: InputMaybe<Scalars["String"]["input"]>;
};

/** Input for updating an individual account holder onboarding */
export type UpdatePublicIndividualAccountHolderOnboardingInput = {
  /** Updatable account admin information for the individual account holder */
  accountAdmin?: InputMaybe<UpdateIndividualAccountHolderOnboardingAccountAdminInput>;
  /** Account information for the individual account holder */
  accountInfo?: InputMaybe<UpdateIndividualAccountHolderOnboardingAccountInput>;
  /** The unique identifier of the onboarding to update */
  onboardingId: Scalars["ID"]["input"];
};

/** Payload for updating an individual account holder onboarding */
export type UpdatePublicIndividualAccountHolderOnboardingPayload =
  | ForbiddenRejection
  | InternalErrorRejection
  | OnboardingAlreadyFinalizedRejection
  | OnboardingNotFoundRejection
  | PublicOnboardingDisabledRejection
  | UpdatePublicIndividualAccountHolderOnboardingSuccessPayload
  | ValidationRejection;

/** Success response for updating an individual account holder onboarding */
export type UpdatePublicIndividualAccountHolderOnboardingSuccessPayload = {
  __typename: "UpdatePublicIndividualAccountHolderOnboardingSuccessPayload";
  /** The updated individual account holder onboarding */
  onboarding: IndividualAccountHolderOnboarding;
};

/** Inputs to update a received sepa direct debit mandate B2b. */
export type UpdateReceivedSepaDirectDebitB2bMandateInput = {
  /** URL the user is redirected to after consent has been given */
  consentRedirectUrl: Scalars["String"]["input"];
  /** The Sepa Creditor Identifier of the creditor */
  creditorIdentifier?: InputMaybe<Scalars["String"]["input"]>;
  /** The name of the creditor */
  creditorName?: InputMaybe<Scalars["String"]["input"]>;
  /** The Swan Iban of the debtor */
  iban?: InputMaybe<Scalars["String"]["input"]>;
  /** The unique identifier of the received direct debit mandate */
  mandateReference?: InputMaybe<Scalars["String"]["input"]>;
  /** Label that will be displayed along with this received direct debit mandate in the web banking */
  name?: InputMaybe<Scalars["String"]["input"]>;
  /** The unique mandate id */
  receivedDirectDebitMandateId: Scalars["ID"]["input"];
};

/** Union type returned by the updateReceivedSepaDirectDebitB2bMandate mutation */
export type UpdateReceivedSepaDirectDebitB2bMandatePayload =
  | AccountNotFoundRejection
  | ForbiddenRejection
  | ReceivedDirectDebitMandateAlreadyExistRejection
  | ReceivedDirectDebitMandateNotB2bRejection
  | ReceivedDirectDebitMandateNotFoundRejection
  | UpdateReceivedSepaDirectDebitB2bMandateSuccessPayload
  | ValidationRejection;

/** Return type in case of a successful response of the updateReceivedSepaDirectDebitB2bMandate mutation */
export type UpdateReceivedSepaDirectDebitB2bMandateSuccessPayload = {
  __typename: "UpdateReceivedSepaDirectDebitB2bMandateSuccessPayload";
  /** The received direct debit mandate updated */
  receivedDirectDebitMandate: ReceivedDirectDebitMandate;
};

export type UpdateRequestNotPendingReviewRejection = Rejection & {
  __typename: "UpdateRequestNotPendingReviewRejection";
  message: Scalars["String"]["output"];
  requestUpdateId?: Maybe<Scalars["ID"]["output"]>;
};

export type UpdateSupportingDocumentInput = {
  supportingDocumentId: Scalars["ID"]["input"];
  supportingDocumentPurpose?: InputMaybe<SupportingDocumentPurposeEnum>;
  supportingDocumentType?: InputMaybe<SupportingDocumentType>;
};

export type UpdateSupportingDocumentPayload =
  | ForbiddenRejection
  | InternalErrorRejection
  | SupportingDocumentCollectionNotFoundRejection
  | SupportingDocumentCollectionStatusDoesNotAllowUpdateRejection
  | SupportingDocumentNotFoundRejection
  | SupportingDocumentStatusDoesNotAllowUpdateRejection
  | UpdateSupportingDocumentSuccessPayload
  | ValidationRejection;

export type UpdateSupportingDocumentSuccessPayload = {
  __typename: "UpdateSupportingDocumentSuccessPayload";
  supportingDocument: SupportingDocument;
};

export type UpdateUserConsentSettingsInput = {
  /** Preferred consent notification channel, Sms or App */
  preferredNotificationChannel: PreferredNotificationChannel;
  /** Swan user id */
  userId: Scalars["ID"]["input"];
};

export type UpdateUserConsentSettingsPayload =
  | UpdateUserConsentSettingsSuccessPayload
  | UpdateUserConsentSettingsTokenRejection;

export type UpdateUserConsentSettingsSuccessPayload = {
  __typename: "UpdateUserConsentSettingsSuccessPayload";
  userConsentSettings: UserConsentSettings;
};

export type UpdateUserConsentSettingsTokenRejection = Rejection & {
  __typename: "UpdateUserConsentSettingsTokenRejection";
  message: Scalars["String"]["output"];
};

/** Input values needed to update a Webhook Subscription */
export type UpdateWebhookSubscriptionInput = {
  /**
   * The endpoint URL events will be sent to
   * (max 255 characters)
   */
  endpoint: Scalars["String"]["input"];
  /**
   * The types of subscribed events
   * A subset of unique IDs from `webhookEventTypes`
   */
  eventTypes: Array<Scalars["ID"]["input"]>;
  /** Subscription to update */
  id: Scalars["ID"]["input"];
  /**
   * A short descriptive label for the subscription
   * (max 255 characters)
   */
  label: Scalars["String"]["input"];
  /**
   * The optional secret to secure incoming webhook calls. We recommend a UUID-4 to be future proof.
   * (max 36 characters)
   */
  secret?: InputMaybe<Scalars["String"]["input"]>;
  /** Control if the subscription should be enabled or not */
  status: WebhookSubscriptionCreationStatus;
};

/** Input when the account membership is restricted to a verified user */
export type UpdatedRestrictedToInput = {
  /** Account member birth date */
  birthDate?: InputMaybe<Scalars["Date"]["input"]>;
  /** Account member first name */
  firstName?: InputMaybe<Scalars["String"]["input"]>;
  /** Account member last name */
  lastName?: InputMaybe<Scalars["String"]["input"]>;
  /** Account member phone number */
  phoneNumber?: InputMaybe<Scalars["String"]["input"]>;
};

/** The User is the unique user, natural person, of the Swan app. */
export type User = {
  __typename: "User";
  /**
   * The list of account memberships
   *
   * Implements the Relay Connection interface, used to paginate lists of elements. ([Learn More](https://docs.swan.io/developers/using-api/pagination))
   */
  accountMemberships: AccountMembershipConnection;
  /** list of first names */
  allFirstNames?: Maybe<Array<Scalars["String"]["output"]>>;
  /** the methods used to authenticate this user */
  authenticators?: Maybe<Array<Authenticator>>;
  /** birth city */
  birthCity?: Maybe<Scalars["String"]["output"]>;
  /** birth country */
  birthCountry?: Maybe<Scalars["CCA3"]["output"]>;
  /** birth date */
  birthDate?: Maybe<Scalars["Date"]["output"]>;
  /** Birth last name */
  birthLastName?: Maybe<Scalars["String"]["output"]>;
  /** Creation date of the user */
  createdAt: Scalars["DateTime"]["output"];
  /**
   * @deprecated Use verifiedEmails field instead
   * @deprecated Use verifiedEmails field instead
   */
  emailAddresses: Array<Scalars["String"]["output"]>;
  /** first name */
  firstName?: Maybe<Scalars["String"]["output"]>;
  /** full name : concatenation of firstName + [ birthLastName | lastName ] depending on preferredLastName setting */
  fullName?: Maybe<Scalars["String"]["output"]>;
  /** unique identifier of the user */
  id: Scalars["ID"]["output"];
  /**
   * List of identification levels available for the user.
   *
   * Whenever TRUE, it means the identification was successful for the associated level.
   */
  identificationLevels?: Maybe<IdentificationLevels>;
  identifications?: Maybe<IdentificationConnection>;
  /** Date on which the user joined the project. Joining the project is done after the first accepted OAuth login. */
  joinedAt: Scalars["DateTime"]["output"];
  /** last name */
  lastName?: Maybe<Scalars["String"]["output"]>;
  /** mobile phone number with the international format (Example: +33689788967) */
  mobilePhoneNumber?: Maybe<Scalars["PhoneNumber"]["output"]>;
  /** nationality */
  nationalityCCA3?: Maybe<Scalars["CCA3"]["output"]>;
  /** The last name that the user prefers to use */
  preferredLastName?: Maybe<Scalars["String"]["output"]>;
  /**
   * Preferred notification channel
   *
   * When it is "null" it means that the preferences have not been updated. Default SMS in use
   */
  preferredNotificationChannel?: Maybe<PreferredNotificationChannel>;
  /** Status of the user */
  status?: Maybe<UserStatus>;
  /** Last update date of the user */
  updatedAt: Scalars["DateTime"]["output"];
  /** Returns the verified emails */
  verifiedEmails: Array<Scalars["String"]["output"]>;
};

/** The User is the unique user, natural person, of the Swan app. */
export type UserAccountMembershipsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  filters?: InputMaybe<AccountMembershipsFilterInput>;
  first?: Scalars["Int"]["input"];
};

/** The User is the unique user, natural person, of the Swan app. */
export type UserIdentificationsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  filters?: InputMaybe<IdentificationFiltersInput>;
  first?: Scalars["Int"]["input"];
  orderBy?: InputMaybe<IdentificationsOrderByInput>;
};

export type UserAlreadyDeactivatedRejection = {
  __typename: "UserAlreadyDeactivatedRejection";
  /** Message */
  message: Scalars["String"]["output"];
  /** User id */
  userId: Scalars["ID"]["output"];
};

export type UserBlockedRejection = Rejection & {
  __typename: "UserBlockedRejection";
  message: Scalars["String"]["output"];
};

export type UserCannotBeDeactivatedRejection = {
  __typename: "UserCannotBeDeactivatedRejection";
  /** Reason */
  message: Scalars["String"]["output"];
  /** User id */
  userId: Scalars["ID"]["output"];
};

/** Implements the Relay Connection interface, used to paginate list of element ([Learn More](https://docs.swan.io/api/pagination)) */
export type UserConnection = Connection & {
  __typename: "UserConnection";
  /** UserEdge list */
  edges: Array<UserEdge>;
  /** Information about the current, the previous and the next page */
  pageInfo: PageInfo;
  /** Total number of element in the list */
  totalCount: Scalars["Int"]["output"];
};

export type UserConsentSettings = {
  __typename: "UserConsentSettings";
  /** Preferred notification channel */
  preferredNotificationChannel: PreferredNotificationChannel;
  /** Project identifier */
  projectId: Scalars["String"]["output"];
  /** User identifier */
  userId: Scalars["String"]["output"];
};

export type UserDeviceInfoInput = {
  geoloc?: InputMaybe<GeolocInput>;
  ip?: InputMaybe<Scalars["String"]["input"]>;
  userAgent?: InputMaybe<Scalars["String"]["input"]>;
};

/** Implements the Relay Edge interface */
export type UserEdge = Edge & {
  __typename: "UserEdge";
  /** Opaque identifier pointing to this consent node in the pagination mechanism */
  cursor: Scalars["String"]["output"];
  /** The user */
  node: User;
};

/** Filters that can be applied when listing users */
export type UserFilterInput = {
  /** Filter by birth date */
  birthDate?: InputMaybe<Scalars["Date"]["input"]>;
  /**
   * Filter by first name
   *
   * @deprecated(reason: "use `search` instead")
   */
  firstName?: InputMaybe<Scalars["String"]["input"]>;
  /** Filter by identification level */
  identificationLevel?: InputMaybe<IdentificationLevelInput>;
  /**
   * Search by last name
   *
   * @deprecated(reason: "use `search` instead")
   */
  lastName?: InputMaybe<Scalars["String"]["input"]>;
  /** Filter by phone number */
  mobilePhoneNumber?: InputMaybe<Scalars["String"]["input"]>;
  /** Filter by nationality */
  nationalityCCA3?: InputMaybe<Scalars["CCA3"]["input"]>;
  /** Filter by preferred notification channel */
  preferredNotificationChannel?: InputMaybe<PreferredNotificationChannel>;
  /**
   * Search string to look for (min length : 3 characters)
   *
   * Search will be performed in following fields:
   *  - First name
   *  - Last name
   *  - Mobile phone number
   *  - ID
   */
  search?: InputMaybe<Scalars["String"]["input"]>;
  /** Filter by status */
  status?: InputMaybe<Array<UserStatus>>;
};

export type UserInformationInput = {
  birthDate: Scalars["Date"]["input"];
  firstName: Scalars["String"]["input"];
  lastName: Scalars["String"]["input"];
};

export type UserNotAllowedToDisableItsOwnAccountMembershipRejection = Rejection & {
  __typename: "UserNotAllowedToDisableItsOwnAccountMembershipRejection";
  accountMembershipId: Scalars["String"]["output"];
  message: Scalars["String"]["output"];
};

/** Rejection returned if a identity does not have enough permission to manage account membership */
export type UserNotAllowedToManageAccountMembershipRejection = Rejection & {
  __typename: "UserNotAllowedToManageAccountMembershipRejection";
  message: Scalars["String"]["output"];
};

/** Rejection returned if the user's membership is not enabled. */
export type UserNotAllowedToSendAccountMembershipInvitationRejection = Rejection & {
  __typename: "UserNotAllowedToSendAccountMembershipInvitationRejection";
  message: Scalars["String"]["output"];
};

export type UserNotAllowedToSuspendItsOwnAccountMembershipRejection = Rejection & {
  __typename: "UserNotAllowedToSuspendItsOwnAccountMembershipRejection";
  accountMembershipId: Scalars["String"]["output"];
  message: Scalars["String"]["output"];
};

/** Rejection returned when the User is not the cardholder */
export type UserNotCardHolderRejection = Rejection & {
  __typename: "UserNotCardHolderRejection";
  message: Scalars["String"]["output"];
};

export type UserNotFoundRejection = Rejection & {
  __typename: "UserNotFoundRejection";
  /** User id */
  id: Scalars["ID"]["output"];
  /** Message */
  message: Scalars["String"]["output"];
};

/** Field we can use when ordering that can be applied when listing users */
export type UserOrderByFieldInput = "createdAt" | "updatedAt";

/** Order that can be applied when listing users */
export type UserOrderByInput = {
  direction?: InputMaybe<OrderByDirection>;
  field?: InputMaybe<UserOrderByFieldInput>;
};

export type UserStatus =
  /** Users with Active status are able to login & use Swan. */
  | "Active"
  /** Users in Blocked status are not able to login for security reason. Their phone number can't be reused. */
  | "Blocked"
  /** Users in Deactivated status don't use Swan anymore and won't ever be able to login. Their phone number can be reused as a new number. */
  | "Deactivated";

/** Information extracted from a valid IBAN */
export type ValidIban = {
  __typename: "ValidIban";
  /** Account Number extracted from the IBAN */
  accountNumber: Scalars["String"]["output"];
  /** Bank that owns this IBAN */
  bank: Bank;
  /** Checksum extracted from the IBAN */
  checksum: Scalars["String"]["output"];
  /** Iban from input */
  iban: Scalars["IBAN"]["output"];
  /** Reachability of this IBAN over different payment methods */
  reachability: Reachability;
};

/** Describes a valid identification level for the process associated to this identification, and identification documents can be accessed */
export type ValidIdentificationLevelStatusInfo = {
  __typename: "ValidIdentificationLevelStatusInfo";
  /** Always set to `Valid` */
  status: SwanIdentificationStatus;
};

/** A detail of a validation error : what field is errored and why */
export type ValidationError = {
  __typename: "ValidationError";
  /** Human readable message explaining the errors */
  details?: Maybe<Scalars["String"]["output"]>;
  /** Constraints that are not matched on the Onboarding property */
  errors?: Maybe<Array<FieldValidationError>>;
  /** Onboarding property that is not matching requirements to allow a finalization */
  field: Scalars["String"]["output"];
};

export type ValidationFieldError = {
  __typename: "ValidationFieldError";
  code: ValidationFieldErrorCode;
  message: Scalars["String"]["output"];
  path: Array<Scalars["String"]["output"]>;
};

export type ValidationFieldErrorCode =
  | "InvalidString"
  | "InvalidType"
  | "TooLong"
  | "TooShort"
  | "UnrecognizedKeys";

/** Rejection returned if an input contains invalid data */
export type ValidationRejection = Rejection & {
  __typename: "ValidationRejection";
  fields: Array<ValidationFieldError>;
  message: Scalars["String"]["output"];
};

/** Verification Renewals */
export type VerificationRenewal = {
  /** Unique identifier of account holder */
  accountHolderId: Scalars["String"]["output"];
  /** Created date */
  createdAt: Scalars["DateTime"]["output"];
  /** Due date of the verification renewal */
  dueDate?: Maybe<Scalars["DateTime"]["output"]>;
  /** Unique identifier of a verification renewal */
  id: Scalars["ID"]["output"];
  /** Verification renewal information */
  info: VerificationRenewalInfo;
  /** Status of the verification renewal */
  status: VerificationRenewalStatus;
  /** Zendesk Ticket ID */
  supportTicketId?: Maybe<Scalars["String"]["output"]>;
  /** Updated date */
  updatedAt: Scalars["DateTime"]["output"];
};

export type VerificationRenewalInfo =
  | CompanyVerificationRenewalInfo
  | IndividualVerificationRenewalInfo;

export type VerificationRenewalInfoBase = {
  type: AccountHolderType;
};

export type VerificationRenewalNotFoundRejection = Rejection & {
  __typename: "VerificationRenewalNotFoundRejection";
  id: Scalars["ID"]["output"];
  message: Scalars["String"]["output"];
};

export type VerificationRenewalRequirement =
  /** Account Holder Details Required */
  | "AccountHolderDetailsRequired"
  /** Legal Representative Details Required */
  | "LegalRepresentativeDetailsRequired"
  /** Swan is requesting more information on the account holders */
  | "Other"
  /** Swan is requesting some Supporting Documents */
  | "SupportingDocumentsRequired"
  /** Swan is requesting some tax identifier */
  | "TaxIdRequired"
  /** Swan is requesting some clarification on the UBO */
  | "UboDetailsRequired";

export type VerificationRenewalStatus =
  | "Completed"
  | "Pending"
  | "Refused"
  | "Suspended"
  | "WaitingForInformation";

export type VerificationRenewalUltimateBeneficialOwner = {
  __typename: "VerificationRenewalUltimateBeneficialOwner";
  address?: Maybe<AddressInfo>;
  birthInfo?: Maybe<BirthInfo>;
  firstName?: Maybe<Scalars["String"]["output"]>;
  lastName?: Maybe<Scalars["String"]["output"]>;
  ownership?: Maybe<UltimateBeneficialOwnerOwnership>;
  qualificationType?: Maybe<UltimateBeneficialOwnerQualificationType>;
  sex?: Maybe<Sex>;
  taxIdentificationNumber?: Maybe<Scalars["String"]["output"]>;
};

export type VerificationRenewalUltimateBeneficialOwnerInput = {
  address?: InputMaybe<ResidencyAddressInput>;
  birthInfo?: InputMaybe<BirthInfoInput>;
  firstName?: InputMaybe<Scalars["String"]["input"]>;
  lastName?: InputMaybe<Scalars["String"]["input"]>;
  ownership?: InputMaybe<UltimateBeneficialOwnerOwnershipInput>;
  qualificationType?: InputMaybe<UltimateBeneficialOwnerQualificationType>;
  sex?: InputMaybe<Sex>;
  taxIdentificationNumber?: InputMaybe<Scalars["String"]["input"]>;
};

export type VerificationRenewalUpdateNotAllowedRejection = Rejection & {
  __typename: "VerificationRenewalUpdateNotAllowedRejection";
  id: Scalars["ID"]["output"];
  message: Scalars["String"]["output"];
};

/** Implements the Relay Connection interface, used to paginate lists of elements. ([Learn More](https://docs.swan.io/developers/using-api/pagination)) */
export type VerificationRenewalsConnection = Connection & {
  __typename: "VerificationRenewalsConnection";
  /** VerificationRenewalsEdge list */
  edges: Array<VerificationRenewalsEdge>;
  /** Information about the current, the previous and the next page */
  pageInfo: PageInfo;
  /** Total number of element in the list */
  totalCount: Scalars["Int"]["output"];
};

/** Implements the Relay Edge interface */
export type VerificationRenewalsEdge = Edge & {
  __typename: "VerificationRenewalsEdge";
  /** Opaque identifier pointing to this onboarding node in the pagination mechanism */
  cursor: Scalars["String"]["output"];
  /** The VerificationRenewal */
  node: VerificationRenewal;
};

/** Field we can use when ordering that can be applied when listing verification renewals */
export type VerificationRenewalsOrderByFieldInput = "createdAt" | "id" | "updatedAt";

/** Order that can be applied when listing verification renewals */
export type VerificationRenewalsOrderByInput = {
  direction?: InputMaybe<OrderByDirection>;
  field?: InputMaybe<VerificationRenewalsOrderByFieldInput>;
};

/**
 * Account Holder Verification Requirement
 *
 * It is a sub status for the Account Holder when his verification status is WaitingForInformation
 */
export type VerificationRequirement = {
  __typename: "VerificationRequirement";
  id: Scalars["ID"]["output"];
  type: VerificationRequirementType;
};

export type VerificationRequirementType =
  /** Swan is requesting for a 1st transfer */
  | "FirstTransferRequired"
  /** Swan is requesting some clarification on the legal representative or on the account member with legal representative permissions */
  | "LegalRepresentativeDetailsRequired"
  /** Swan is requesting some clarification on the organization */
  | "OrganizationDetailsRequired"
  /** Swan is requesting more information on the account holders */
  | "Other"
  /** Swan is requesting some Supporting Documents */
  | "SupportingDocumentsRequired"
  /** Swan is requesting some tax identifier */
  | "TaxIdRequired"
  /** Swan is requesting some clarification on the UBO */
  | "UboDetailsRequired";

export type VerificationRequirementsNotUpdatableRejection = Rejection & {
  __typename: "VerificationRequirementsNotUpdatableRejection";
  accountHolderId: Scalars["String"]["output"];
  accountHolderVerificationStatus: VerificationStatus;
  message: Scalars["String"]["output"];
};

/** Verification status of an account holder */
export type VerificationStatus =
  /** When the account holder has not started to answer the verification process. */
  | "NotStarted"
  /** When the verification process is pending. */
  | "Pending"
  /** When the account holder is refused. */
  | "Refused"
  /** When the account holder is verified. */
  | "Verified"
  /** When Swan is waiting for information about the account holder to continue the verification process. */
  | "WaitingForInformation";

/** Enabled Information */
export type VerifiedStatusInfo = AccountVerificationStatusInfo & {
  __typename: "VerifiedStatusInfo";
  /** Account verification status (Verified) */
  status: AccountVerificationStatus;
  /** Date at which the verification was verified */
  verifiedAt: Scalars["DateTime"]["output"];
};

/** Verification with a partial match of beneficiary details */
export type VerifyBeneficiaryCloseMatch = VerifyBeneficiaryResult & {
  __typename: "VerifyBeneficiaryCloseMatch";
  /** Suggested name for the beneficiary from the verification service */
  nameSuggestion: Scalars["String"]["output"];
  /** Beneficiary verification status */
  status: VerifyBeneficiaryStatus;
};

/** Input parameters required to verify a beneficiary */
export type VerifyBeneficiaryInput = {
  beneficiary: BeneficiaryInput;
};

/** Successful verification with an exact match */
export type VerifyBeneficiaryMatch = VerifyBeneficiaryResult & {
  __typename: "VerifyBeneficiaryMatch";
  /** Beneficiary verification status */
  status: VerifyBeneficiaryStatus;
};

/** Verification with no match of beneficiary details */
export type VerifyBeneficiaryNoMatch = VerifyBeneficiaryResult & {
  __typename: "VerifyBeneficiaryNoMatch";
  /** Beneficiary verification status */
  status: VerifyBeneficiaryStatus;
};

/** Verification where the beneficiary details couldn't be confirmed */
export type VerifyBeneficiaryNotPossible = VerifyBeneficiaryResult & {
  __typename: "VerifyBeneficiaryNotPossible";
  /** Beneficiary verification status */
  status: VerifyBeneficiaryStatus;
};

/** Possible responses when initiating a beneficiary */
export type VerifyBeneficiaryPayload =
  | AccountNotFoundRejection
  | ForbiddenRejection
  | InternalErrorRejection
  | TrustedBeneficiaryNotFoundRejection
  | ValidationRejection
  | VerifyBeneficiarySuccessPayload;

export type VerifyBeneficiaryResult = {
  /**
   * Verify beneficiary result status: Match, VerificationNotPossible,
   * NoMatch, CloseMatch
   */
  status: VerifyBeneficiaryStatus;
};

export type VerifyBeneficiaryStatus =
  | "CloseMatch"
  | "Match"
  | "NoMatch"
  | "VerificationNotPossible";

export type VerifyBeneficiarySuccessPayload = {
  __typename: "VerifyBeneficiarySuccessPayload";
  /** Beneficiary verification token to initiate a credit transfer */
  beneficiaryVerificationToken: Scalars["String"]["output"];
  /** Token expiration timestamp */
  expiresAt: Scalars["DateTime"]["output"];
  /** Result from the verification of payee provider */
  verifyBeneficiaryResult: VerifyBeneficiaryResult;
};

export type ViewCardNumbersInput = {
  /** Unique identifier of a card */
  cardId: Scalars["ID"]["input"];
  /** URL the user is redirected to after consent has been given */
  consentRedirectUrl: Scalars["String"]["input"];
};

export type ViewCardNumbersPayload =
  | CardNotFoundRejection
  | ForbiddenRejection
  | UserNotCardHolderRejection
  | ValidationRejection
  | ViewCardNumbersSuccessPayload;

export type ViewCardNumbersSuccessPayload = {
  __typename: "ViewCardNumbersSuccessPayload";
  /** The consent required to view card numbers */
  consent: Consent;
};

export type ViewCardNumbersWithConsentInput = {
  /** Unique identifier of an accepted view card number consent */
  consentId: Scalars["String"]["input"];
};

export type ViewCardNumbersWithConsentPayload =
  | CardNotFoundRejection
  | CardSensitiveInfoNoLongerAvailableRejection
  | ForbiddenRejection
  | ViewCardNumbersWithConsentSuccessPayload;

export type ViewCardNumbersWithConsentSuccessPayload = {
  __typename: "ViewCardNumbersWithConsentSuccessPayload";
  cardholderName: Scalars["String"]["output"];
  cvvIframeUrl: Scalars["String"]["output"];
  expiryDateIframeUrl: Scalars["String"]["output"];
  panIframeUrl: Scalars["String"]["output"];
};

export type ViewPhysicalCardNumbersInput = {
  /** Unique identifier of a card */
  cardId: Scalars["ID"]["input"];
  /** URL the user is redirected to after consent has been given */
  consentRedirectUrl: Scalars["String"]["input"];
};

export type ViewPhysicalCardNumbersPayload =
  | CardNotFoundRejection
  | ForbiddenRejection
  | UserNotCardHolderRejection
  | ValidationRejection
  | ViewPhysicalCardNumbersSuccessPayload;

export type ViewPhysicalCardNumbersSuccessPayload = {
  __typename: "ViewPhysicalCardNumbersSuccessPayload";
  /** The consent required to view card numbers */
  consent: Consent;
};

export type ViewPhysicalCardPinInput = {
  /** Unique identifier of a card */
  cardId: Scalars["ID"]["input"];
  /** URL the user is redirected to after consent has been given */
  consentRedirectUrl: Scalars["String"]["input"];
};

export type ViewPhysicalCardPinPayload =
  | CardNotFoundRejection
  | ForbiddenRejection
  | PinNotReadyRejection
  | PhysicalCardNotFoundRejection
  | UserNotCardHolderRejection
  | ValidationRejection
  | ViewPhysicalCardPinSuccessPayload;

export type ViewPhysicalCardPinSuccessPayload = {
  __typename: "ViewPhysicalCardPinSuccessPayload";
  /** The consent required to view card numbers */
  consent: Consent;
};

/** Virtual IBAN can be used by the account holder to receive SCT (Sepa Credit Transfer) or to be debited by SDD (Sepa Direct Debit). */
export type VirtualIbanEntry = {
  __typename: "VirtualIBANEntry";
  /** Bank Identifier Code */
  BIC: Scalars["BIC"]["output"];
  /** International Bank Account Number */
  IBAN: Scalars["IBAN"]["output"];
  /** Download link to the virtual iban's bank details */
  bankDetails?: Maybe<Scalars["String"]["output"]>;
  /** `true` if the Virtual IBAN refuses all Sepa Direct Debit received */
  blockSDD: Scalars["Boolean"]["output"];
  /** Unique identifier of a Virtual IBAN entry */
  id: Scalars["ID"]["output"];
  /** Label (could be used to identify) */
  label?: Maybe<Scalars["String"]["output"]>;
  /** Status of the Iban */
  status: IbanStatus;
};

/** Implements the Relay Connection interface, used to paginate lists of elements. ([Learn More](https://docs.swan.io/developers/using-api/pagination)) */
export type VirtualIbanEntryConnection = Connection & {
  __typename: "VirtualIBANEntryConnection";
  /** VirtualIBANEntryEdge list */
  edges: Array<VirtualIbanEntryEdge>;
  /** Information about the current, the previous and the next page */
  pageInfo: PageInfo;
  /** Total number of element in the list */
  totalCount: Scalars["Int"]["output"];
};

/** Implements the Relay Edge interface */
export type VirtualIbanEntryEdge = Edge & {
  __typename: "VirtualIBANEntryEdge";
  /** Opaque identifier pointing to this node in the pagination mechanism */
  cursor: Scalars["String"]["output"];
  /** The virtual iban entry */
  node: VirtualIbanEntry;
};

/** Filters that can be applied when listing virtual iban entries */
export type VirtualIbanEntriesFilterInput = {
  /** unique identifiers of the virtual IBAN entries to fetch */
  ids?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type VoidedStatusInfo = AccountStatementStatusInfo & {
  __typename: "VoidedStatusInfo";
  /** status of the statement */
  status: AccountStatementStatus;
  /** Public url on which the voided file can be accessed */
  url: Scalars["URL"]["output"];
};

/** WaitingForInformationMerchantPaymentMethodStatusInfo */
export type WaitingForInformationMerchantPaymentMethodStatusInfo =
  MerchantPaymentMethodStatusInfo & {
    __typename: "WaitingForInformationMerchantPaymentMethodStatusInfo";
    status: MerchantPaymentMethodStatus;
    /** List of requirements that should be fulfilled */
    verificationRequirements: Array<MerchantVerificationRequirements>;
    /** Merchant Payment Method waitingForInformation date */
    waitingForInformationAt: Scalars["Date"]["output"];
  };

export type WaitingForInformationVerificationRenewal = VerificationRenewal & {
  __typename: "WaitingForInformationVerificationRenewal";
  accountCountries?: Maybe<Array<AccountCountry>>;
  accountHolderId: Scalars["String"]["output"];
  createdAt: Scalars["DateTime"]["output"];
  dueDate?: Maybe<Scalars["DateTime"]["output"]>;
  id: Scalars["ID"]["output"];
  /** Verification renewal information */
  info: VerificationRenewalInfo;
  status: VerificationRenewalStatus;
  supportTicketId?: Maybe<Scalars["String"]["output"]>;
  supportingDocumentCollection?: Maybe<SupportingDocumentCollection>;
  updatedAt: Scalars["DateTime"]["output"];
  verificationRequirements: Array<VerificationRenewalRequirement>;
};

/** Wallet Provider (ApplePay, GooglePay ...) */
export type WalletProvider = {
  __typename: "WalletProvider";
  /** id of the Wallet Provider */
  id: Scalars["String"]["output"];
  /** name of the Wallet Provider (Apple / Google / Amazon or Unknown) */
  name: Scalars["String"]["output"];
};

/** Wallet Provider */
export type WalletProviderType = "ApplePay" | "GooglePay";

export type WebBankingSettings = {
  __typename: "WebBankingSettings";
  canAddNewMembers?: Maybe<Scalars["Boolean"]["output"]>;
  canCreateMerchantPaymentLinks?: Maybe<Scalars["Boolean"]["output"]>;
  canCreateMerchantProfile?: Maybe<Scalars["Boolean"]["output"]>;
  canInitiateCheckMerchantPayments?: Maybe<Scalars["Boolean"]["output"]>;
  canInitiatePaymentsToNewBeneficiaries?: Maybe<Scalars["Boolean"]["output"]>;
  canManageVirtualIbans?: Maybe<Scalars["Boolean"]["output"]>;
  canOpenAccount?: Maybe<Scalars["Boolean"]["output"]>;
  canOrderPhysicalCards?: Maybe<Scalars["Boolean"]["output"]>;
  canOrderVirtualCards?: Maybe<Scalars["Boolean"]["output"]>;
  canRequestChecksPaymentMethod?: Maybe<Scalars["Boolean"]["output"]>;
  canRequestInternalDirectDebitB2BPaymentMethod?: Maybe<Scalars["Boolean"]["output"]>;
  canRequestInternalDirectDebitCorePaymentMethod?: Maybe<Scalars["Boolean"]["output"]>;
  canRequestOnlineCardsPaymentMethod?: Maybe<Scalars["Boolean"]["output"]>;
  canRequestSepaDirectDebitB2BPaymentMethod?: Maybe<Scalars["Boolean"]["output"]>;
  canRequestSepaDirectDebitCorePaymentMethod?: Maybe<Scalars["Boolean"]["output"]>;
  canUpdateCards?: Maybe<Scalars["Boolean"]["output"]>;
  canViewAccountDetails?: Maybe<Scalars["Boolean"]["output"]>;
  canViewAccountStatement?: Maybe<Scalars["Boolean"]["output"]>;
  canViewMembers?: Maybe<Scalars["Boolean"]["output"]>;
  canViewPaymentList?: Maybe<Scalars["Boolean"]["output"]>;
};

/**
 * A WebhookEvent Log for webhooks service.
 * It describes the response and call context for webhook endpoints
 * for a specific event.
 */
export type WebhookEventLog = {
  __typename: "WebhookEventLog";
  /** Date the EventLog has been created */
  createdAt: Scalars["DateTime"]["output"];
  /** Duration of the callback in MS */
  duration: Scalars["Int"]["output"];
  /** Date the Event has been generated */
  eventDate: Scalars["DateTime"]["output"];
  /** Unique identifier of the event that triggered this eventLog */
  eventId: Scalars["ID"]["output"];
  /** The type of the triggering event */
  eventType: Scalars["String"]["output"];
  /** Unique identifier of the EventLog */
  id: Scalars["ID"]["output"];
  /** Request payload send to callback in string format, jsonable. */
  requestPayload: Scalars["String"]["output"];
  /** Unique identifier linked of the resource carried by the Event */
  resourceId: Scalars["ID"]["output"];
  /** Response payload get by the callback in string format, jsonable. */
  responsePayload?: Maybe<Scalars["String"]["output"]>;
  /** Rank of this retry */
  retryCount?: Maybe<Scalars["Int"]["output"]>;
  /** The callback response status in number format. */
  statusCode?: Maybe<Scalars["Int"]["output"]>;
  /** The callback response status in text format. */
  statusText?: Maybe<StatusText>;
  /** The webhook that triggered the event. */
  webhookSubscription?: Maybe<WebhookSubscription>;
  /**
   * Endpoint of the associated subscription (inherited)
   * This holds the endpoint value of when the log was created, whereas
   * webhookSubscription.endpoint holds the current value of the endpoint
   * (it may have changed).
   */
  webhookSubscriptionEndpoint?: Maybe<Scalars["String"]["output"]>;
  /**
   * Label of the associated subscription (inherited)
   * This holds the label value of when the log was created, whereas
   * webhookSubscription.label holds the current value of the label
   * (it may have changed).
   */
  webhookSubscriptionLabel?: Maybe<Scalars["String"]["output"]>;
};

/** Filters that can be applied when listing eventLogs */
export type WebhookEventLogFiltersInput = {
  endDate?: InputMaybe<Scalars["DateTime"]["input"]>;
  eventId?: InputMaybe<Scalars["ID"]["input"]>;
  eventType?: InputMaybe<Scalars["String"]["input"]>;
  resourceId?: InputMaybe<Scalars["ID"]["input"]>;
  startDate?: InputMaybe<Scalars["DateTime"]["input"]>;
  statusCode?: InputMaybe<Scalars["Int"]["input"]>;
  statusText?: InputMaybe<StatusText>;
  webhookSubscriptionId?: InputMaybe<Scalars["ID"]["input"]>;
};

/** Rejection returned when Webhook event log id is not found */
export type WebhookEventLogNotFoundRejection = Rejection & {
  __typename: "WebhookEventLogNotFoundRejection";
  message: Scalars["String"]["output"];
};

/** Relay Connection for Webhook Eventlog */
export type WebhookEventLogsConnection = Connection & {
  __typename: "WebhookEventLogsConnection";
  edges: Array<WebhookEventLogsEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars["Int"]["output"];
};

/** Relay Edge for Webhook Event Logs */
export type WebhookEventLogsEdge = Edge & {
  __typename: "WebhookEventLogsEdge";
  cursor: Scalars["String"]["output"];
  node: WebhookEventLog;
};

/**
 * A Subscription to the webhooks service.
 * It describes the registration of a callback url (the endpoint)
 * and a list of event types the client wants to be notified of.
 */
export type WebhookSubscription = {
  __typename: "WebhookSubscription";
  /** Date the Subscription has been created */
  createdAt: Scalars["DateTime"]["output"];
  /** The callback URL to be used for POSTing events */
  endpoint: Scalars["String"]["output"];
  /**
   * The types of subscribed events
   * A simple list of event names as strings
   */
  eventTypes: Array<Scalars["String"]["output"]>;
  /** Unique identifier of the Subscription */
  id: Scalars["ID"]["output"];
  /** KPI data about the subscription (7 last days) */
  kpi?: Maybe<WebhookSubscriptionKpi>;
  /** A client provided short description of the Subscription */
  label: Scalars["String"]["output"];
  /**
   * The optional secret to secure incoming webhook calls. We recommend a UUID-4 to be future proof.
   * (max 36 characters)
   */
  secret?: Maybe<Scalars["String"]["output"]>;
  /** The current state of the Subscription */
  statusInfo: WebhookSubscriptionStatusInfo;
  /**
   *   Last date the Subscription has been updated,
   * except for state changes
   */
  updatedAt: Scalars["DateTime"]["output"];
  /** Array of webhook event logs related to the subscription */
  webhookEventLogs?: Maybe<WebhookEventLogsConnection>;
};

/**
 * A Subscription to the webhooks service.
 * It describes the registration of a callback url (the endpoint)
 * and a list of event types the client wants to be notified of.
 */
export type WebhookSubscriptionWebhookEventLogsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  filters?: InputMaybe<NestedWebhookEventLogFiltersInput>;
  first?: Scalars["Int"]["input"];
};

export type WebhookSubscriptionBrokenStatusInfo = WebhookSubscriptionStatusInfo & {
  __typename: "WebhookSubscriptionBrokenStatusInfo";
  brokenAt: Scalars["DateTime"]["output"];
  status: WebhookSubscriptionStatus;
};

export type WebhookSubscriptionCreationStatus = "Disabled" | "Enabled";

export type WebhookSubscriptionDisabledStatusInfo = WebhookSubscriptionStatusInfo & {
  __typename: "WebhookSubscriptionDisabledStatusInfo";
  disabledAt: Scalars["DateTime"]["output"];
  status: WebhookSubscriptionStatus;
};

export type WebhookSubscriptionEnabledStatusInfo = WebhookSubscriptionStatusInfo & {
  __typename: "WebhookSubscriptionEnabledStatusInfo";
  enabledAt: Scalars["DateTime"]["output"];
  status: WebhookSubscriptionStatus;
};

/** Input values needed to delete or modify a webhook subscription */
export type WebhookSubscriptionIdInput = {
  /** The webhook subscription id */
  webhookSubscriptionId: Scalars["ID"]["input"];
};

export type WebhookSubscriptionKpi = {
  __typename: "WebhookSubscriptionKpi";
  /**
   * Total number of eventLogs that failed associated to this subscription
   * errorRate = (errorRate/totalHits) * 100, rounded
   */
  errorRate: Scalars["Float"]["output"];
  /** Total number of eventLogs associated to this subscription */
  totalHits: Scalars["Int"]["output"];
};

/** Rejection returned when Webhook Subscription is not found */
export type WebhookSubscriptionNotFoundRejection = Rejection & {
  __typename: "WebhookSubscriptionNotFoundRejection";
  message: Scalars["String"]["output"];
};

export type WebhookSubscriptionPayload =
  | InternalErrorRejection
  | InvalidArgumentRejection
  | SubscriptionLimitsRejection
  | WebhookSubscriptionNotFoundRejection
  | WebhookSubscriptionSuccessPayload;

/**
 * State of a Webhook Subscription
 * It is either Enabled or Disabled by the owner,
 * ot set to Broken when delivery fails repeatedly.
 */
export type WebhookSubscriptionStatus = "Broken" | "Disabled" | "Enabled";

export type WebhookSubscriptionStatusInfo = {
  status: WebhookSubscriptionStatus;
};

export type WebhookSubscriptionSuccessPayload = {
  __typename: "WebhookSubscriptionSuccessPayload";
  webhookSubscription: WebhookSubscription;
};

/** Relay Connection for Webhook Subscriptions */
export type WebhookSubscriptionsConnection = Connection & {
  __typename: "WebhookSubscriptionsConnection";
  edges: Array<WebhookSubscriptionsEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars["Int"]["output"];
};

/** Relay Edge for Webhook Subscriptions */
export type WebhookSubscriptionsEdge = Edge & {
  __typename: "WebhookSubscriptionsEdge";
  cursor: Scalars["String"]["output"];
  node: WebhookSubscription;
};

export type WeeklyPeriod = {
  __typename: "WeeklyPeriod";
  dayOfWeek: DayEnum;
  weekCount: Scalars["Int"]["output"];
};

export type WrongCodeRejection = Rejection & {
  __typename: "WrongCodeRejection";
  message: Scalars["String"]["output"];
};

/** Rejection returned when a parameter has a wrong value */
export type WrongValueProvidedRejection = Rejection & {
  __typename: "WrongValueProvidedRejection";
  message: Scalars["String"]["output"];
  parameterName: Scalars["String"]["output"];
  valueProvided: Scalars["String"]["output"];
};

type TransactionDetails_CardTransaction_Fragment = {
  __typename: "CardTransaction";
  reservedAmountReleasedAt?: string | null;
  id: string;
  side: TransactionSide;
  type: TransactionTypeEnum;
  label: string;
  counterparty: string;
  reference: string;
  externalReference?: string | null;
  statementCanBeGenerated?: boolean | null;
  createdAt: string;
  executionDate: string;
  updatedAt: string;
  originalAmount: { __typename: "Amount"; currency: string; value: string };
  reservedAmount?: { __typename: "Amount"; currency: string; value: string } | null;
  cardDetails?:
    | {
        __typename: "CardInDetails";
        paymentMandate: {
          __typename: "CardPaymentMandate";
          id: string;
          name?: string | null;
          createdAt: string;
          updatedAt: string;
          executedAt?: string | null;
        };
      }
    | {
        __typename: "CardOutDetails";
        maskedPan: string;
        card?: {
          __typename: "Card";
          id: string;
          name?: string | null;
          accountMembership: {
            __typename: "AccountMembership";
            id: string;
            user?: {
              __typename: "User";
              id: string;
              firstName?: string | null;
              preferredLastName?: string | null;
              fullName?: string | null;
            } | null;
          };
        } | null;
      }
    | null;
  merchant?:
    | { __typename: "CardInMerchant" }
    | {
        __typename: "CardOutMerchant";
        merchantId: string;
        merchantCity: string;
        merchantCountry?: string | null;
      }
    | null;
  enrichedTransactionInfo?: {
    __typename: "EnrichedTransactionInfo";
    enrichedMerchantName?: string | null;
    isSubscription?: boolean | null;
    carbonFootprint?: string | null;
    contactEmail?: string | null;
    contactPhone?: string | null;
    contactWebsite?: string | null;
    logoUrl?: string | null;
    category?: MerchantCategory | null;
    subcategory?: MerchantSubCategory | null;
    address?: string | null;
    city?: string | null;
    postalCode?: string | null;
    country?: string | null;
  } | null;
  currencyExchange: Array<{ __typename: "ReportExchangeRate"; exchangeRate: number }>;
  payment?: { __typename: "Payment"; id: string; createdAt: string } | null;
  originTransaction?:
    | {
        __typename: "CardTransaction";
        id: string;
        type: TransactionTypeEnum;
        executionDate: string;
        amount: { __typename: "Amount"; currency: string; value: string };
        statusInfo:
          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
          | {
              __typename: "RejectedTransactionStatusInfo";
              status: TransactionStatus;
              reason: RejectedReasonCode;
            }
          | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
      }
    | {
        __typename: "CheckTransaction";
        id: string;
        type: TransactionTypeEnum;
        executionDate: string;
        amount: { __typename: "Amount"; currency: string; value: string };
        statusInfo:
          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
          | {
              __typename: "RejectedTransactionStatusInfo";
              status: TransactionStatus;
              reason: RejectedReasonCode;
            }
          | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
      }
    | {
        __typename: "FeeTransaction";
        id: string;
        type: TransactionTypeEnum;
        executionDate: string;
        amount: { __typename: "Amount"; currency: string; value: string };
        statusInfo:
          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
          | {
              __typename: "RejectedTransactionStatusInfo";
              status: TransactionStatus;
              reason: RejectedReasonCode;
            }
          | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
      }
    | {
        __typename: "InternalCreditTransfer";
        id: string;
        type: TransactionTypeEnum;
        executionDate: string;
        amount: { __typename: "Amount"; currency: string; value: string };
        statusInfo:
          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
          | {
              __typename: "RejectedTransactionStatusInfo";
              status: TransactionStatus;
              reason: RejectedReasonCode;
            }
          | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
      }
    | {
        __typename: "InternalDirectDebitTransaction";
        id: string;
        type: TransactionTypeEnum;
        executionDate: string;
        amount: { __typename: "Amount"; currency: string; value: string };
        statusInfo:
          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
          | {
              __typename: "RejectedTransactionStatusInfo";
              status: TransactionStatus;
              reason: RejectedReasonCode;
            }
          | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
      }
    | {
        __typename: "InternationalCreditTransferTransaction";
        id: string;
        type: TransactionTypeEnum;
        executionDate: string;
        amount: { __typename: "Amount"; currency: string; value: string };
        statusInfo:
          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
          | {
              __typename: "RejectedTransactionStatusInfo";
              status: TransactionStatus;
              reason: RejectedReasonCode;
            }
          | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
      }
    | {
        __typename: "SEPACreditTransferTransaction";
        id: string;
        type: TransactionTypeEnum;
        executionDate: string;
        amount: { __typename: "Amount"; currency: string; value: string };
        statusInfo:
          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
          | {
              __typename: "RejectedTransactionStatusInfo";
              status: TransactionStatus;
              reason: RejectedReasonCode;
            }
          | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
      }
    | {
        __typename: "SEPADirectDebitTransaction";
        id: string;
        type: TransactionTypeEnum;
        executionDate: string;
        amount: { __typename: "Amount"; currency: string; value: string };
        statusInfo:
          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
          | {
              __typename: "RejectedTransactionStatusInfo";
              status: TransactionStatus;
              reason: RejectedReasonCode;
            }
          | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
      }
    | null;
  statusInfo:
    | { __typename: "BookedTransactionStatusInfo"; bookingDate: string; status: TransactionStatus }
    | {
        __typename: "CanceledTransactionStatusInfo";
        canceledDate?: string | null;
        status: TransactionStatus;
      }
    | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
    | {
        __typename: "PendingTransactionStatusInfo";
        pendingEndDate?: string | null;
        status: TransactionStatus;
      }
    | {
        __typename: "RejectedTransactionStatusInfo";
        reason: RejectedReasonCode;
        status: TransactionStatus;
      }
    | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
    | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
    | {
        __typename: "UpcomingTransactionStatusInfo";
        executionDate: string;
        status: TransactionStatus;
      };
  amount: { __typename: "Amount"; currency: string; value: string };
};

type TransactionDetails_CheckTransaction_Fragment = {
  __typename: "CheckTransaction";
  reservedAmountReleasedAt?: string | null;
  cmc7: string;
  rlmcKey: string;
  id: string;
  side: TransactionSide;
  type: TransactionTypeEnum;
  label: string;
  counterparty: string;
  reference: string;
  externalReference?: string | null;
  statementCanBeGenerated?: boolean | null;
  createdAt: string;
  executionDate: string;
  updatedAt: string;
  reservedAmount?: { __typename: "Amount"; currency: string; value: string } | null;
  payment?: { __typename: "Payment"; id: string; createdAt: string } | null;
  originTransaction?:
    | {
        __typename: "CardTransaction";
        id: string;
        type: TransactionTypeEnum;
        executionDate: string;
        amount: { __typename: "Amount"; currency: string; value: string };
        statusInfo:
          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
          | {
              __typename: "RejectedTransactionStatusInfo";
              status: TransactionStatus;
              reason: RejectedReasonCode;
            }
          | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
      }
    | {
        __typename: "CheckTransaction";
        id: string;
        type: TransactionTypeEnum;
        executionDate: string;
        amount: { __typename: "Amount"; currency: string; value: string };
        statusInfo:
          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
          | {
              __typename: "RejectedTransactionStatusInfo";
              status: TransactionStatus;
              reason: RejectedReasonCode;
            }
          | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
      }
    | {
        __typename: "FeeTransaction";
        id: string;
        type: TransactionTypeEnum;
        executionDate: string;
        amount: { __typename: "Amount"; currency: string; value: string };
        statusInfo:
          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
          | {
              __typename: "RejectedTransactionStatusInfo";
              status: TransactionStatus;
              reason: RejectedReasonCode;
            }
          | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
      }
    | {
        __typename: "InternalCreditTransfer";
        id: string;
        type: TransactionTypeEnum;
        executionDate: string;
        amount: { __typename: "Amount"; currency: string; value: string };
        statusInfo:
          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
          | {
              __typename: "RejectedTransactionStatusInfo";
              status: TransactionStatus;
              reason: RejectedReasonCode;
            }
          | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
      }
    | {
        __typename: "InternalDirectDebitTransaction";
        id: string;
        type: TransactionTypeEnum;
        executionDate: string;
        amount: { __typename: "Amount"; currency: string; value: string };
        statusInfo:
          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
          | {
              __typename: "RejectedTransactionStatusInfo";
              status: TransactionStatus;
              reason: RejectedReasonCode;
            }
          | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
      }
    | {
        __typename: "InternationalCreditTransferTransaction";
        id: string;
        type: TransactionTypeEnum;
        executionDate: string;
        amount: { __typename: "Amount"; currency: string; value: string };
        statusInfo:
          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
          | {
              __typename: "RejectedTransactionStatusInfo";
              status: TransactionStatus;
              reason: RejectedReasonCode;
            }
          | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
      }
    | {
        __typename: "SEPACreditTransferTransaction";
        id: string;
        type: TransactionTypeEnum;
        executionDate: string;
        amount: { __typename: "Amount"; currency: string; value: string };
        statusInfo:
          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
          | {
              __typename: "RejectedTransactionStatusInfo";
              status: TransactionStatus;
              reason: RejectedReasonCode;
            }
          | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
      }
    | {
        __typename: "SEPADirectDebitTransaction";
        id: string;
        type: TransactionTypeEnum;
        executionDate: string;
        amount: { __typename: "Amount"; currency: string; value: string };
        statusInfo:
          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
          | {
              __typename: "RejectedTransactionStatusInfo";
              status: TransactionStatus;
              reason: RejectedReasonCode;
            }
          | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
      }
    | null;
  statusInfo:
    | { __typename: "BookedTransactionStatusInfo"; bookingDate: string; status: TransactionStatus }
    | {
        __typename: "CanceledTransactionStatusInfo";
        canceledDate?: string | null;
        status: TransactionStatus;
      }
    | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
    | {
        __typename: "PendingTransactionStatusInfo";
        pendingEndDate?: string | null;
        status: TransactionStatus;
      }
    | {
        __typename: "RejectedTransactionStatusInfo";
        reason: RejectedReasonCode;
        status: TransactionStatus;
      }
    | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
    | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
    | {
        __typename: "UpcomingTransactionStatusInfo";
        executionDate: string;
        status: TransactionStatus;
      };
  amount: { __typename: "Amount"; currency: string; value: string };
};

type TransactionDetails_FeeTransaction_Fragment = {
  __typename: "FeeTransaction";
  feesType: FeesTypeEnum;
  id: string;
  side: TransactionSide;
  type: TransactionTypeEnum;
  label: string;
  counterparty: string;
  reference: string;
  externalReference?: string | null;
  statementCanBeGenerated?: boolean | null;
  createdAt: string;
  executionDate: string;
  updatedAt: string;
  creditor:
    | { __typename: "FeeInCreditor"; name: string }
    | { __typename: "FeeOutCreditor"; name: string };
  originTransaction?:
    | {
        __typename: "CardTransaction";
        id: string;
        label: string;
        type: TransactionTypeEnum;
        updatedAt: string;
        executionDate: string;
        createdAt: string;
        statusInfo:
          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
          | {
              __typename: "RejectedTransactionStatusInfo";
              reason: RejectedReasonCode;
              status: TransactionStatus;
            }
          | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
        amount: { __typename: "Amount"; currency: string; value: string };
      }
    | {
        __typename: "CheckTransaction";
        id: string;
        label: string;
        type: TransactionTypeEnum;
        updatedAt: string;
        executionDate: string;
        createdAt: string;
        statusInfo:
          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
          | {
              __typename: "RejectedTransactionStatusInfo";
              reason: RejectedReasonCode;
              status: TransactionStatus;
            }
          | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
        amount: { __typename: "Amount"; currency: string; value: string };
      }
    | {
        __typename: "FeeTransaction";
        id: string;
        label: string;
        type: TransactionTypeEnum;
        updatedAt: string;
        executionDate: string;
        createdAt: string;
        statusInfo:
          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
          | {
              __typename: "RejectedTransactionStatusInfo";
              reason: RejectedReasonCode;
              status: TransactionStatus;
            }
          | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
        amount: { __typename: "Amount"; currency: string; value: string };
      }
    | {
        __typename: "InternalCreditTransfer";
        id: string;
        label: string;
        type: TransactionTypeEnum;
        updatedAt: string;
        executionDate: string;
        createdAt: string;
        statusInfo:
          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
          | {
              __typename: "RejectedTransactionStatusInfo";
              reason: RejectedReasonCode;
              status: TransactionStatus;
            }
          | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
        amount: { __typename: "Amount"; currency: string; value: string };
      }
    | {
        __typename: "InternalDirectDebitTransaction";
        id: string;
        label: string;
        type: TransactionTypeEnum;
        updatedAt: string;
        executionDate: string;
        createdAt: string;
        statusInfo:
          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
          | {
              __typename: "RejectedTransactionStatusInfo";
              reason: RejectedReasonCode;
              status: TransactionStatus;
            }
          | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
        amount: { __typename: "Amount"; currency: string; value: string };
      }
    | {
        __typename: "InternationalCreditTransferTransaction";
        id: string;
        label: string;
        type: TransactionTypeEnum;
        updatedAt: string;
        executionDate: string;
        createdAt: string;
        statusInfo:
          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
          | {
              __typename: "RejectedTransactionStatusInfo";
              reason: RejectedReasonCode;
              status: TransactionStatus;
            }
          | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
        amount: { __typename: "Amount"; currency: string; value: string };
      }
    | {
        __typename: "SEPACreditTransferTransaction";
        id: string;
        label: string;
        type: TransactionTypeEnum;
        updatedAt: string;
        executionDate: string;
        createdAt: string;
        statusInfo:
          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
          | {
              __typename: "RejectedTransactionStatusInfo";
              reason: RejectedReasonCode;
              status: TransactionStatus;
            }
          | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
        amount: { __typename: "Amount"; currency: string; value: string };
      }
    | {
        __typename: "SEPADirectDebitTransaction";
        id: string;
        label: string;
        type: TransactionTypeEnum;
        updatedAt: string;
        executionDate: string;
        createdAt: string;
        statusInfo:
          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
          | {
              __typename: "RejectedTransactionStatusInfo";
              reason: RejectedReasonCode;
              status: TransactionStatus;
            }
          | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
        amount: { __typename: "Amount"; currency: string; value: string };
      }
    | null;
  payment?: { __typename: "Payment"; id: string; createdAt: string } | null;
  statusInfo:
    | { __typename: "BookedTransactionStatusInfo"; bookingDate: string; status: TransactionStatus }
    | {
        __typename: "CanceledTransactionStatusInfo";
        canceledDate?: string | null;
        status: TransactionStatus;
      }
    | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
    | {
        __typename: "PendingTransactionStatusInfo";
        pendingEndDate?: string | null;
        status: TransactionStatus;
      }
    | {
        __typename: "RejectedTransactionStatusInfo";
        reason: RejectedReasonCode;
        status: TransactionStatus;
      }
    | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
    | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
    | {
        __typename: "UpcomingTransactionStatusInfo";
        executionDate: string;
        status: TransactionStatus;
      };
  amount: { __typename: "Amount"; currency: string; value: string };
};

type TransactionDetails_InternalCreditTransfer_Fragment = {
  __typename: "InternalCreditTransfer";
  id: string;
  side: TransactionSide;
  type: TransactionTypeEnum;
  label: string;
  counterparty: string;
  reference: string;
  externalReference?: string | null;
  statementCanBeGenerated?: boolean | null;
  createdAt: string;
  executionDate: string;
  updatedAt: string;
  creditor:
    | { __typename: "InternalCreditTransferInCreditor"; name: string }
    | { __typename: "InternalCreditTransferOutCreditor"; name: string };
  payment?: { __typename: "Payment"; id: string; createdAt: string } | null;
  originTransaction?:
    | {
        __typename: "CardTransaction";
        id: string;
        type: TransactionTypeEnum;
        executionDate: string;
        amount: { __typename: "Amount"; currency: string; value: string };
        statusInfo:
          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
          | {
              __typename: "RejectedTransactionStatusInfo";
              status: TransactionStatus;
              reason: RejectedReasonCode;
            }
          | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
      }
    | {
        __typename: "CheckTransaction";
        id: string;
        type: TransactionTypeEnum;
        executionDate: string;
        amount: { __typename: "Amount"; currency: string; value: string };
        statusInfo:
          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
          | {
              __typename: "RejectedTransactionStatusInfo";
              status: TransactionStatus;
              reason: RejectedReasonCode;
            }
          | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
      }
    | {
        __typename: "FeeTransaction";
        id: string;
        type: TransactionTypeEnum;
        executionDate: string;
        amount: { __typename: "Amount"; currency: string; value: string };
        statusInfo:
          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
          | {
              __typename: "RejectedTransactionStatusInfo";
              status: TransactionStatus;
              reason: RejectedReasonCode;
            }
          | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
      }
    | {
        __typename: "InternalCreditTransfer";
        id: string;
        type: TransactionTypeEnum;
        executionDate: string;
        amount: { __typename: "Amount"; currency: string; value: string };
        statusInfo:
          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
          | {
              __typename: "RejectedTransactionStatusInfo";
              status: TransactionStatus;
              reason: RejectedReasonCode;
            }
          | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
      }
    | {
        __typename: "InternalDirectDebitTransaction";
        id: string;
        type: TransactionTypeEnum;
        executionDate: string;
        amount: { __typename: "Amount"; currency: string; value: string };
        statusInfo:
          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
          | {
              __typename: "RejectedTransactionStatusInfo";
              status: TransactionStatus;
              reason: RejectedReasonCode;
            }
          | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
      }
    | {
        __typename: "InternationalCreditTransferTransaction";
        id: string;
        type: TransactionTypeEnum;
        executionDate: string;
        amount: { __typename: "Amount"; currency: string; value: string };
        statusInfo:
          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
          | {
              __typename: "RejectedTransactionStatusInfo";
              status: TransactionStatus;
              reason: RejectedReasonCode;
            }
          | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
      }
    | {
        __typename: "SEPACreditTransferTransaction";
        id: string;
        type: TransactionTypeEnum;
        executionDate: string;
        amount: { __typename: "Amount"; currency: string; value: string };
        statusInfo:
          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
          | {
              __typename: "RejectedTransactionStatusInfo";
              status: TransactionStatus;
              reason: RejectedReasonCode;
            }
          | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
      }
    | {
        __typename: "SEPADirectDebitTransaction";
        id: string;
        type: TransactionTypeEnum;
        executionDate: string;
        amount: { __typename: "Amount"; currency: string; value: string };
        statusInfo:
          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
          | {
              __typename: "RejectedTransactionStatusInfo";
              status: TransactionStatus;
              reason: RejectedReasonCode;
            }
          | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
      }
    | null;
  statusInfo:
    | { __typename: "BookedTransactionStatusInfo"; bookingDate: string; status: TransactionStatus }
    | {
        __typename: "CanceledTransactionStatusInfo";
        canceledDate?: string | null;
        status: TransactionStatus;
      }
    | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
    | {
        __typename: "PendingTransactionStatusInfo";
        pendingEndDate?: string | null;
        status: TransactionStatus;
      }
    | {
        __typename: "RejectedTransactionStatusInfo";
        reason: RejectedReasonCode;
        status: TransactionStatus;
      }
    | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
    | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
    | {
        __typename: "UpcomingTransactionStatusInfo";
        executionDate: string;
        status: TransactionStatus;
      };
  amount: { __typename: "Amount"; currency: string; value: string };
};

type TransactionDetails_InternalDirectDebitTransaction_Fragment = {
  __typename: "InternalDirectDebitTransaction";
  reservedAmountReleasedAt?: string | null;
  id: string;
  side: TransactionSide;
  type: TransactionTypeEnum;
  label: string;
  counterparty: string;
  reference: string;
  externalReference?: string | null;
  statementCanBeGenerated?: boolean | null;
  createdAt: string;
  executionDate: string;
  updatedAt: string;
  reservedAmount?: { __typename: "Amount"; currency: string; value: string } | null;
  creditor: { __typename: "InternalDirectDebitCreditor"; accountId: string };
  mandate?:
    | { __typename: "InternalPaymentDirectDebitMandate"; id: string }
    | { __typename: "InternalReceivedDirectDebitMandate"; id: string }
    | null;
  payment?: { __typename: "Payment"; id: string; createdAt: string } | null;
  originTransaction?:
    | {
        __typename: "CardTransaction";
        id: string;
        type: TransactionTypeEnum;
        executionDate: string;
        amount: { __typename: "Amount"; currency: string; value: string };
        statusInfo:
          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
          | {
              __typename: "RejectedTransactionStatusInfo";
              status: TransactionStatus;
              reason: RejectedReasonCode;
            }
          | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
      }
    | {
        __typename: "CheckTransaction";
        id: string;
        type: TransactionTypeEnum;
        executionDate: string;
        amount: { __typename: "Amount"; currency: string; value: string };
        statusInfo:
          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
          | {
              __typename: "RejectedTransactionStatusInfo";
              status: TransactionStatus;
              reason: RejectedReasonCode;
            }
          | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
      }
    | {
        __typename: "FeeTransaction";
        id: string;
        type: TransactionTypeEnum;
        executionDate: string;
        amount: { __typename: "Amount"; currency: string; value: string };
        statusInfo:
          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
          | {
              __typename: "RejectedTransactionStatusInfo";
              status: TransactionStatus;
              reason: RejectedReasonCode;
            }
          | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
      }
    | {
        __typename: "InternalCreditTransfer";
        id: string;
        type: TransactionTypeEnum;
        executionDate: string;
        amount: { __typename: "Amount"; currency: string; value: string };
        statusInfo:
          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
          | {
              __typename: "RejectedTransactionStatusInfo";
              status: TransactionStatus;
              reason: RejectedReasonCode;
            }
          | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
      }
    | {
        __typename: "InternalDirectDebitTransaction";
        id: string;
        type: TransactionTypeEnum;
        executionDate: string;
        amount: { __typename: "Amount"; currency: string; value: string };
        statusInfo:
          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
          | {
              __typename: "RejectedTransactionStatusInfo";
              status: TransactionStatus;
              reason: RejectedReasonCode;
            }
          | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
      }
    | {
        __typename: "InternationalCreditTransferTransaction";
        id: string;
        type: TransactionTypeEnum;
        executionDate: string;
        amount: { __typename: "Amount"; currency: string; value: string };
        statusInfo:
          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
          | {
              __typename: "RejectedTransactionStatusInfo";
              status: TransactionStatus;
              reason: RejectedReasonCode;
            }
          | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
      }
    | {
        __typename: "SEPACreditTransferTransaction";
        id: string;
        type: TransactionTypeEnum;
        executionDate: string;
        amount: { __typename: "Amount"; currency: string; value: string };
        statusInfo:
          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
          | {
              __typename: "RejectedTransactionStatusInfo";
              status: TransactionStatus;
              reason: RejectedReasonCode;
            }
          | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
      }
    | {
        __typename: "SEPADirectDebitTransaction";
        id: string;
        type: TransactionTypeEnum;
        executionDate: string;
        amount: { __typename: "Amount"; currency: string; value: string };
        statusInfo:
          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
          | {
              __typename: "RejectedTransactionStatusInfo";
              status: TransactionStatus;
              reason: RejectedReasonCode;
            }
          | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
      }
    | null;
  statusInfo:
    | { __typename: "BookedTransactionStatusInfo"; bookingDate: string; status: TransactionStatus }
    | {
        __typename: "CanceledTransactionStatusInfo";
        canceledDate?: string | null;
        status: TransactionStatus;
      }
    | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
    | {
        __typename: "PendingTransactionStatusInfo";
        pendingEndDate?: string | null;
        status: TransactionStatus;
      }
    | {
        __typename: "RejectedTransactionStatusInfo";
        reason: RejectedReasonCode;
        status: TransactionStatus;
      }
    | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
    | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
    | {
        __typename: "UpcomingTransactionStatusInfo";
        executionDate: string;
        status: TransactionStatus;
      };
  amount: { __typename: "Amount"; currency: string; value: string };
};

type TransactionDetails_InternationalCreditTransferTransaction_Fragment = {
  __typename: "InternationalCreditTransferTransaction";
  reference: string;
  paymentProduct: PaymentProduct;
  id: string;
  side: TransactionSide;
  type: TransactionTypeEnum;
  label: string;
  counterparty: string;
  externalReference?: string | null;
  statementCanBeGenerated?: boolean | null;
  createdAt: string;
  executionDate: string;
  updatedAt: string;
  creditor:
    | { __typename: "InternationalCreditTransferInCreditor"; name: string }
    | { __typename: "InternationalCreditTransferInDebtor" }
    | {
        __typename: "InternationalCreditTransferOutCreditor";
        name: string;
        details: Array<{
          __typename: "InternationalCreditTransferDetails";
          key: string;
          value: string;
        }>;
      };
  statusInfo:
    | { __typename: "BookedTransactionStatusInfo"; bookingDate: string; status: TransactionStatus }
    | {
        __typename: "CanceledTransactionStatusInfo";
        canceledDate?: string | null;
        status: TransactionStatus;
      }
    | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
    | {
        __typename: "PendingTransactionStatusInfo";
        pendingEndDate?: string | null;
        status: TransactionStatus;
      }
    | {
        __typename: "RejectedTransactionStatusInfo";
        reason: RejectedReasonCode;
        status: TransactionStatus;
      }
    | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
    | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
    | {
        __typename: "UpcomingTransactionStatusInfo";
        executionDate: string;
        status: TransactionStatus;
      };
  internationalCurrencyExchange: {
    __typename: "InternationalCreditTransferCurrencyExchange";
    exchangeRate: string;
    sourceAmount?: { __typename: "Amount"; currency: string; value: string } | null;
    targetAmount?: { __typename: "Amount"; currency: string; value: string } | null;
  };
  beneficiary?:
    | {
        __typename: "TrustedInternationalBeneficiary";
        name: string;
        currency: string;
        route: InternationalCreditTransferRoute;
        details: Array<{
          __typename: "InternationalCreditTransferDetails";
          key: string;
          value: string;
        }>;
      }
    | {
        __typename: "UnsavedInternationalBeneficiary";
        name: string;
        currency: string;
        route: InternationalCreditTransferRoute;
        details: Array<{
          __typename: "InternationalCreditTransferDetails";
          key: string;
          value: string;
        }>;
      }
    | null;
  payment?: { __typename: "Payment"; id: string; createdAt: string } | null;
  originTransaction?:
    | {
        __typename: "CardTransaction";
        id: string;
        type: TransactionTypeEnum;
        executionDate: string;
        amount: { __typename: "Amount"; currency: string; value: string };
        statusInfo:
          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
          | {
              __typename: "RejectedTransactionStatusInfo";
              status: TransactionStatus;
              reason: RejectedReasonCode;
            }
          | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
      }
    | {
        __typename: "CheckTransaction";
        id: string;
        type: TransactionTypeEnum;
        executionDate: string;
        amount: { __typename: "Amount"; currency: string; value: string };
        statusInfo:
          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
          | {
              __typename: "RejectedTransactionStatusInfo";
              status: TransactionStatus;
              reason: RejectedReasonCode;
            }
          | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
      }
    | {
        __typename: "FeeTransaction";
        id: string;
        type: TransactionTypeEnum;
        executionDate: string;
        amount: { __typename: "Amount"; currency: string; value: string };
        statusInfo:
          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
          | {
              __typename: "RejectedTransactionStatusInfo";
              status: TransactionStatus;
              reason: RejectedReasonCode;
            }
          | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
      }
    | {
        __typename: "InternalCreditTransfer";
        id: string;
        type: TransactionTypeEnum;
        executionDate: string;
        amount: { __typename: "Amount"; currency: string; value: string };
        statusInfo:
          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
          | {
              __typename: "RejectedTransactionStatusInfo";
              status: TransactionStatus;
              reason: RejectedReasonCode;
            }
          | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
      }
    | {
        __typename: "InternalDirectDebitTransaction";
        id: string;
        type: TransactionTypeEnum;
        executionDate: string;
        amount: { __typename: "Amount"; currency: string; value: string };
        statusInfo:
          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
          | {
              __typename: "RejectedTransactionStatusInfo";
              status: TransactionStatus;
              reason: RejectedReasonCode;
            }
          | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
      }
    | {
        __typename: "InternationalCreditTransferTransaction";
        id: string;
        type: TransactionTypeEnum;
        executionDate: string;
        amount: { __typename: "Amount"; currency: string; value: string };
        statusInfo:
          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
          | {
              __typename: "RejectedTransactionStatusInfo";
              status: TransactionStatus;
              reason: RejectedReasonCode;
            }
          | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
      }
    | {
        __typename: "SEPACreditTransferTransaction";
        id: string;
        type: TransactionTypeEnum;
        executionDate: string;
        amount: { __typename: "Amount"; currency: string; value: string };
        statusInfo:
          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
          | {
              __typename: "RejectedTransactionStatusInfo";
              status: TransactionStatus;
              reason: RejectedReasonCode;
            }
          | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
      }
    | {
        __typename: "SEPADirectDebitTransaction";
        id: string;
        type: TransactionTypeEnum;
        executionDate: string;
        amount: { __typename: "Amount"; currency: string; value: string };
        statusInfo:
          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
          | {
              __typename: "RejectedTransactionStatusInfo";
              status: TransactionStatus;
              reason: RejectedReasonCode;
            }
          | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
      }
    | null;
  amount: { __typename: "Amount"; currency: string; value: string };
};

type TransactionDetails_SepaCreditTransferTransaction_Fragment = {
  __typename: "SEPACreditTransferTransaction";
  id: string;
  side: TransactionSide;
  type: TransactionTypeEnum;
  label: string;
  counterparty: string;
  reference: string;
  externalReference?: string | null;
  statementCanBeGenerated?: boolean | null;
  createdAt: string;
  executionDate: string;
  updatedAt: string;
  creditor:
    | { __typename: "SEPACreditTransferInCreditor"; name: string; IBAN?: string | null }
    | { __typename: "SEPACreditTransferInternalOutCreditor"; name: string; IBAN?: string | null }
    | { __typename: "SEPACreditTransferOutCreditor"; name: string; IBAN?: string | null };
  debtor:
    | { __typename: "SEPACreditTransferInDebtor"; name: string; IBAN?: string | null }
    | { __typename: "SEPACreditTransferInternalInDebtor"; name: string; IBAN?: string | null }
    | { __typename: "SEPACreditTransferOutDebtor"; name: string; IBAN?: string | null };
  beneficiary?:
    | {
        __typename: "TrustedSepaBeneficiary";
        iban: string;
        id: string;
        label: string;
        name: string;
        type: BeneficiaryType;
        createdAt: string;
        address?: {
          __typename: "Address";
          addressLine1?: string | null;
          addressLine2?: string | null;
          city?: string | null;
          country?: string | null;
          postalCode?: string | null;
          state?: string | null;
        } | null;
        statusInfo:
          | { __typename: "TrustedBeneficiaryCanceledStatusInfo"; status: TrustedBeneficiaryStatus }
          | {
              __typename: "TrustedBeneficiaryConsentPendingStatusInfo";
              status: TrustedBeneficiaryStatus;
            }
          | { __typename: "TrustedBeneficiaryEnabledStatusInfo"; status: TrustedBeneficiaryStatus };
      }
    | {
        __typename: "UnsavedSepaBeneficiary";
        name: string;
        iban: string;
        address?: {
          __typename: "Address";
          addressLine1?: string | null;
          addressLine2?: string | null;
          city?: string | null;
          country?: string | null;
          postalCode?: string | null;
          state?: string | null;
        } | null;
      }
    | null;
  payment?: { __typename: "Payment"; id: string; createdAt: string } | null;
  originTransaction?:
    | {
        __typename: "CardTransaction";
        id: string;
        type: TransactionTypeEnum;
        executionDate: string;
        amount: { __typename: "Amount"; currency: string; value: string };
        statusInfo:
          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
          | {
              __typename: "RejectedTransactionStatusInfo";
              status: TransactionStatus;
              reason: RejectedReasonCode;
            }
          | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
      }
    | {
        __typename: "CheckTransaction";
        id: string;
        type: TransactionTypeEnum;
        executionDate: string;
        amount: { __typename: "Amount"; currency: string; value: string };
        statusInfo:
          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
          | {
              __typename: "RejectedTransactionStatusInfo";
              status: TransactionStatus;
              reason: RejectedReasonCode;
            }
          | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
      }
    | {
        __typename: "FeeTransaction";
        id: string;
        type: TransactionTypeEnum;
        executionDate: string;
        amount: { __typename: "Amount"; currency: string; value: string };
        statusInfo:
          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
          | {
              __typename: "RejectedTransactionStatusInfo";
              status: TransactionStatus;
              reason: RejectedReasonCode;
            }
          | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
      }
    | {
        __typename: "InternalCreditTransfer";
        id: string;
        type: TransactionTypeEnum;
        executionDate: string;
        amount: { __typename: "Amount"; currency: string; value: string };
        statusInfo:
          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
          | {
              __typename: "RejectedTransactionStatusInfo";
              status: TransactionStatus;
              reason: RejectedReasonCode;
            }
          | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
      }
    | {
        __typename: "InternalDirectDebitTransaction";
        id: string;
        type: TransactionTypeEnum;
        executionDate: string;
        amount: { __typename: "Amount"; currency: string; value: string };
        statusInfo:
          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
          | {
              __typename: "RejectedTransactionStatusInfo";
              status: TransactionStatus;
              reason: RejectedReasonCode;
            }
          | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
      }
    | {
        __typename: "InternationalCreditTransferTransaction";
        id: string;
        type: TransactionTypeEnum;
        executionDate: string;
        amount: { __typename: "Amount"; currency: string; value: string };
        statusInfo:
          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
          | {
              __typename: "RejectedTransactionStatusInfo";
              status: TransactionStatus;
              reason: RejectedReasonCode;
            }
          | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
      }
    | {
        __typename: "SEPACreditTransferTransaction";
        id: string;
        type: TransactionTypeEnum;
        executionDate: string;
        amount: { __typename: "Amount"; currency: string; value: string };
        statusInfo:
          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
          | {
              __typename: "RejectedTransactionStatusInfo";
              status: TransactionStatus;
              reason: RejectedReasonCode;
            }
          | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
      }
    | {
        __typename: "SEPADirectDebitTransaction";
        id: string;
        type: TransactionTypeEnum;
        executionDate: string;
        amount: { __typename: "Amount"; currency: string; value: string };
        statusInfo:
          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
          | {
              __typename: "RejectedTransactionStatusInfo";
              status: TransactionStatus;
              reason: RejectedReasonCode;
            }
          | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
      }
    | null;
  statusInfo:
    | { __typename: "BookedTransactionStatusInfo"; bookingDate: string; status: TransactionStatus }
    | {
        __typename: "CanceledTransactionStatusInfo";
        canceledDate?: string | null;
        status: TransactionStatus;
      }
    | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
    | {
        __typename: "PendingTransactionStatusInfo";
        pendingEndDate?: string | null;
        status: TransactionStatus;
      }
    | {
        __typename: "RejectedTransactionStatusInfo";
        reason: RejectedReasonCode;
        status: TransactionStatus;
      }
    | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
    | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
    | {
        __typename: "UpcomingTransactionStatusInfo";
        executionDate: string;
        status: TransactionStatus;
      };
  amount: { __typename: "Amount"; currency: string; value: string };
};

type TransactionDetails_SepaDirectDebitTransaction_Fragment = {
  __typename: "SEPADirectDebitTransaction";
  reservedAmountReleasedAt?: string | null;
  id: string;
  side: TransactionSide;
  type: TransactionTypeEnum;
  label: string;
  counterparty: string;
  reference: string;
  externalReference?: string | null;
  statementCanBeGenerated?: boolean | null;
  createdAt: string;
  executionDate: string;
  updatedAt: string;
  creditor:
    | { __typename: "SEPADirectDebitInCreditor"; name: string; IBAN?: string | null }
    | { __typename: "SEPADirectDebitOutCreditor"; name: string; IBAN?: string | null };
  debtor:
    | { __typename: "SEPADirectDebitInDebtor"; name: string; IBAN?: string | null }
    | { __typename: "SEPADirectDebitOutDebtor"; name: string; IBAN?: string | null };
  reservedAmount?: { __typename: "Amount"; value: string; currency: string } | null;
  mandate?:
    | {
        __typename: "SEPAPaymentDirectDebitMandate";
        id: string;
        debtor: { __typename: "SEPAPaymentMandateDebtor"; name: string };
      }
    | {
        __typename: "SEPAReceivedDirectDebitMandate";
        ultimateCreditorName?: string | null;
        id: string;
      }
    | null;
  payment?: { __typename: "Payment"; id: string; createdAt: string } | null;
  originTransaction?:
    | {
        __typename: "CardTransaction";
        id: string;
        type: TransactionTypeEnum;
        executionDate: string;
        amount: { __typename: "Amount"; currency: string; value: string };
        statusInfo:
          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
          | {
              __typename: "RejectedTransactionStatusInfo";
              status: TransactionStatus;
              reason: RejectedReasonCode;
            }
          | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
      }
    | {
        __typename: "CheckTransaction";
        id: string;
        type: TransactionTypeEnum;
        executionDate: string;
        amount: { __typename: "Amount"; currency: string; value: string };
        statusInfo:
          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
          | {
              __typename: "RejectedTransactionStatusInfo";
              status: TransactionStatus;
              reason: RejectedReasonCode;
            }
          | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
      }
    | {
        __typename: "FeeTransaction";
        id: string;
        type: TransactionTypeEnum;
        executionDate: string;
        amount: { __typename: "Amount"; currency: string; value: string };
        statusInfo:
          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
          | {
              __typename: "RejectedTransactionStatusInfo";
              status: TransactionStatus;
              reason: RejectedReasonCode;
            }
          | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
      }
    | {
        __typename: "InternalCreditTransfer";
        id: string;
        type: TransactionTypeEnum;
        executionDate: string;
        amount: { __typename: "Amount"; currency: string; value: string };
        statusInfo:
          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
          | {
              __typename: "RejectedTransactionStatusInfo";
              status: TransactionStatus;
              reason: RejectedReasonCode;
            }
          | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
      }
    | {
        __typename: "InternalDirectDebitTransaction";
        id: string;
        type: TransactionTypeEnum;
        executionDate: string;
        amount: { __typename: "Amount"; currency: string; value: string };
        statusInfo:
          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
          | {
              __typename: "RejectedTransactionStatusInfo";
              status: TransactionStatus;
              reason: RejectedReasonCode;
            }
          | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
      }
    | {
        __typename: "InternationalCreditTransferTransaction";
        id: string;
        type: TransactionTypeEnum;
        executionDate: string;
        amount: { __typename: "Amount"; currency: string; value: string };
        statusInfo:
          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
          | {
              __typename: "RejectedTransactionStatusInfo";
              status: TransactionStatus;
              reason: RejectedReasonCode;
            }
          | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
      }
    | {
        __typename: "SEPACreditTransferTransaction";
        id: string;
        type: TransactionTypeEnum;
        executionDate: string;
        amount: { __typename: "Amount"; currency: string; value: string };
        statusInfo:
          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
          | {
              __typename: "RejectedTransactionStatusInfo";
              status: TransactionStatus;
              reason: RejectedReasonCode;
            }
          | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
      }
    | {
        __typename: "SEPADirectDebitTransaction";
        id: string;
        type: TransactionTypeEnum;
        executionDate: string;
        amount: { __typename: "Amount"; currency: string; value: string };
        statusInfo:
          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
          | {
              __typename: "RejectedTransactionStatusInfo";
              status: TransactionStatus;
              reason: RejectedReasonCode;
            }
          | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
      }
    | null;
  statusInfo:
    | { __typename: "BookedTransactionStatusInfo"; bookingDate: string; status: TransactionStatus }
    | {
        __typename: "CanceledTransactionStatusInfo";
        canceledDate?: string | null;
        status: TransactionStatus;
      }
    | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
    | {
        __typename: "PendingTransactionStatusInfo";
        pendingEndDate?: string | null;
        status: TransactionStatus;
      }
    | {
        __typename: "RejectedTransactionStatusInfo";
        reason: RejectedReasonCode;
        status: TransactionStatus;
      }
    | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
    | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
    | {
        __typename: "UpcomingTransactionStatusInfo";
        executionDate: string;
        status: TransactionStatus;
      };
  amount: { __typename: "Amount"; currency: string; value: string };
};

export type TransactionDetailsFragment =
  | TransactionDetails_CardTransaction_Fragment
  | TransactionDetails_CheckTransaction_Fragment
  | TransactionDetails_FeeTransaction_Fragment
  | TransactionDetails_InternalCreditTransfer_Fragment
  | TransactionDetails_InternalDirectDebitTransaction_Fragment
  | TransactionDetails_InternationalCreditTransferTransaction_Fragment
  | TransactionDetails_SepaCreditTransferTransaction_Fragment
  | TransactionDetails_SepaDirectDebitTransaction_Fragment;

export type AddressDetailsFragment = {
  __typename: "Address";
  addressLine1?: string | null;
  addressLine2?: string | null;
  city?: string | null;
  country?: string | null;
  postalCode?: string | null;
  state?: string | null;
};

export type AccountHolderForCardSettingsFragment = {
  __typename: "AccountHolder";
  id: string;
  info:
    | { __typename: "AccountHolderCompanyInfo"; name: string; type: AccountHolderType }
    | { __typename: "AccountHolderIndividualInfo"; name: string; type: AccountHolderType };
};

export type IdentificationLevelsFragment = {
  __typename: "IdentificationLevels";
  expert: boolean;
  QES: boolean;
  PVID: boolean;
};

export type AuthStatusQueryVariables = Exact<{ [key: string]: never }>;

export type AuthStatusQuery = {
  __typename: "Query";
  user?: { __typename: "User"; id: string } | null;
};

type IdentificationLevelFragment_CanceledIdentificationLevelStatusInfo = {
  __typename: "CanceledIdentificationLevelStatusInfo";
  status: SwanIdentificationStatus;
};

type IdentificationLevelFragment_ExpiredIdentificationLevelStatusInfo = {
  __typename: "ExpiredIdentificationLevelStatusInfo";
  status: SwanIdentificationStatus;
  expiredAt: string;
};

type IdentificationLevelFragment_InvalidIdentificationLevelStatusInfo = {
  __typename: "InvalidIdentificationLevelStatusInfo";
  reasons?: Array<IdentificationInvalidReason> | null;
  status: SwanIdentificationStatus;
};

type IdentificationLevelFragment_NotStartedIdentificationLevelStatusInfo = {
  __typename: "NotStartedIdentificationLevelStatusInfo";
};

type IdentificationLevelFragment_NotSupportedIdentificationLevelStatusInfo = {
  __typename: "NotSupportedIdentificationLevelStatusInfo";
  status: SwanIdentificationStatus;
};

type IdentificationLevelFragment_PendingIdentificationLevelStatusInfo = {
  __typename: "PendingIdentificationLevelStatusInfo";
  status: SwanIdentificationStatus;
};

type IdentificationLevelFragment_StartedIdentificationLevelStatusInfo = {
  __typename: "StartedIdentificationLevelStatusInfo";
  status: SwanIdentificationStatus;
};

type IdentificationLevelFragment_ValidIdentificationLevelStatusInfo = {
  __typename: "ValidIdentificationLevelStatusInfo";
  status: SwanIdentificationStatus;
};

export type IdentificationLevelFragment =
  | IdentificationLevelFragment_CanceledIdentificationLevelStatusInfo
  | IdentificationLevelFragment_ExpiredIdentificationLevelStatusInfo
  | IdentificationLevelFragment_InvalidIdentificationLevelStatusInfo
  | IdentificationLevelFragment_NotStartedIdentificationLevelStatusInfo
  | IdentificationLevelFragment_NotSupportedIdentificationLevelStatusInfo
  | IdentificationLevelFragment_PendingIdentificationLevelStatusInfo
  | IdentificationLevelFragment_StartedIdentificationLevelStatusInfo
  | IdentificationLevelFragment_ValidIdentificationLevelStatusInfo;

export type IdentificationFragment = {
  __typename: "Identification";
  id: string;
  process: IdentificationProcess;
  levels: {
    __typename: "IdentificationLevelStatusesInfo";
    expert:
      | { __typename: "CanceledIdentificationLevelStatusInfo"; status: SwanIdentificationStatus }
      | {
          __typename: "ExpiredIdentificationLevelStatusInfo";
          status: SwanIdentificationStatus;
          expiredAt: string;
        }
      | {
          __typename: "InvalidIdentificationLevelStatusInfo";
          reasons?: Array<IdentificationInvalidReason> | null;
          status: SwanIdentificationStatus;
        }
      | { __typename: "NotStartedIdentificationLevelStatusInfo" }
      | {
          __typename: "NotSupportedIdentificationLevelStatusInfo";
          status: SwanIdentificationStatus;
        }
      | { __typename: "PendingIdentificationLevelStatusInfo"; status: SwanIdentificationStatus }
      | { __typename: "StartedIdentificationLevelStatusInfo"; status: SwanIdentificationStatus }
      | { __typename: "ValidIdentificationLevelStatusInfo"; status: SwanIdentificationStatus };
    pvid:
      | { __typename: "CanceledIdentificationLevelStatusInfo"; status: SwanIdentificationStatus }
      | {
          __typename: "ExpiredIdentificationLevelStatusInfo";
          status: SwanIdentificationStatus;
          expiredAt: string;
        }
      | {
          __typename: "InvalidIdentificationLevelStatusInfo";
          reasons?: Array<IdentificationInvalidReason> | null;
          status: SwanIdentificationStatus;
        }
      | { __typename: "NotStartedIdentificationLevelStatusInfo" }
      | {
          __typename: "NotSupportedIdentificationLevelStatusInfo";
          status: SwanIdentificationStatus;
        }
      | { __typename: "PendingIdentificationLevelStatusInfo"; status: SwanIdentificationStatus }
      | { __typename: "StartedIdentificationLevelStatusInfo"; status: SwanIdentificationStatus }
      | { __typename: "ValidIdentificationLevelStatusInfo"; status: SwanIdentificationStatus };
    qes:
      | { __typename: "CanceledIdentificationLevelStatusInfo"; status: SwanIdentificationStatus }
      | {
          __typename: "ExpiredIdentificationLevelStatusInfo";
          status: SwanIdentificationStatus;
          expiredAt: string;
        }
      | {
          __typename: "InvalidIdentificationLevelStatusInfo";
          reasons?: Array<IdentificationInvalidReason> | null;
          status: SwanIdentificationStatus;
        }
      | { __typename: "NotStartedIdentificationLevelStatusInfo" }
      | {
          __typename: "NotSupportedIdentificationLevelStatusInfo";
          status: SwanIdentificationStatus;
        }
      | { __typename: "PendingIdentificationLevelStatusInfo"; status: SwanIdentificationStatus }
      | { __typename: "StartedIdentificationLevelStatusInfo"; status: SwanIdentificationStatus }
      | { __typename: "ValidIdentificationLevelStatusInfo"; status: SwanIdentificationStatus };
  };
};

type TrustedBeneficiaryDetails_TrustedInternalBeneficiary_Fragment = {
  __typename: "TrustedInternalBeneficiary";
  accountId: string;
  id: string;
  label: string;
  name: string;
  type: BeneficiaryType;
  createdAt: string;
  statusInfo:
    | { __typename: "TrustedBeneficiaryCanceledStatusInfo"; status: TrustedBeneficiaryStatus }
    | { __typename: "TrustedBeneficiaryConsentPendingStatusInfo"; status: TrustedBeneficiaryStatus }
    | { __typename: "TrustedBeneficiaryEnabledStatusInfo"; status: TrustedBeneficiaryStatus };
};

type TrustedBeneficiaryDetails_TrustedInternationalBeneficiary_Fragment = {
  __typename: "TrustedInternationalBeneficiary";
  currency: string;
  route: InternationalCreditTransferRoute;
  id: string;
  label: string;
  name: string;
  type: BeneficiaryType;
  createdAt: string;
  details: Array<{ __typename: "InternationalCreditTransferDetails"; key: string; value: string }>;
  statusInfo:
    | { __typename: "TrustedBeneficiaryCanceledStatusInfo"; status: TrustedBeneficiaryStatus }
    | { __typename: "TrustedBeneficiaryConsentPendingStatusInfo"; status: TrustedBeneficiaryStatus }
    | { __typename: "TrustedBeneficiaryEnabledStatusInfo"; status: TrustedBeneficiaryStatus };
};

type TrustedBeneficiaryDetails_TrustedSepaBeneficiary_Fragment = {
  __typename: "TrustedSepaBeneficiary";
  iban: string;
  id: string;
  label: string;
  name: string;
  type: BeneficiaryType;
  createdAt: string;
  address?: {
    __typename: "Address";
    addressLine1?: string | null;
    addressLine2?: string | null;
    city?: string | null;
    country?: string | null;
    postalCode?: string | null;
    state?: string | null;
  } | null;
  statusInfo:
    | { __typename: "TrustedBeneficiaryCanceledStatusInfo"; status: TrustedBeneficiaryStatus }
    | { __typename: "TrustedBeneficiaryConsentPendingStatusInfo"; status: TrustedBeneficiaryStatus }
    | { __typename: "TrustedBeneficiaryEnabledStatusInfo"; status: TrustedBeneficiaryStatus };
};

export type TrustedBeneficiaryDetailsFragment =
  | TrustedBeneficiaryDetails_TrustedInternalBeneficiary_Fragment
  | TrustedBeneficiaryDetails_TrustedInternationalBeneficiary_Fragment
  | TrustedBeneficiaryDetails_TrustedSepaBeneficiary_Fragment;

export type LastIdentificationQueryVariables = Exact<{
  accountMembershipId: Scalars["ID"]["input"];
}>;

export type LastIdentificationQuery = {
  __typename: "Query";
  accountMembership?: {
    __typename: "AccountMembership";
    id: string;
    user?: {
      __typename: "User";
      id: string;
      identifications?: {
        __typename: "IdentificationConnection";
        edges: Array<{
          __typename: "IdentificationEdge";
          node: {
            __typename: "Identification";
            id: string;
            process: IdentificationProcess;
            levels: {
              __typename: "IdentificationLevelStatusesInfo";
              expert:
                | {
                    __typename: "CanceledIdentificationLevelStatusInfo";
                    status: SwanIdentificationStatus;
                  }
                | {
                    __typename: "ExpiredIdentificationLevelStatusInfo";
                    status: SwanIdentificationStatus;
                    expiredAt: string;
                  }
                | {
                    __typename: "InvalidIdentificationLevelStatusInfo";
                    reasons?: Array<IdentificationInvalidReason> | null;
                    status: SwanIdentificationStatus;
                  }
                | { __typename: "NotStartedIdentificationLevelStatusInfo" }
                | {
                    __typename: "NotSupportedIdentificationLevelStatusInfo";
                    status: SwanIdentificationStatus;
                  }
                | {
                    __typename: "PendingIdentificationLevelStatusInfo";
                    status: SwanIdentificationStatus;
                  }
                | {
                    __typename: "StartedIdentificationLevelStatusInfo";
                    status: SwanIdentificationStatus;
                  }
                | {
                    __typename: "ValidIdentificationLevelStatusInfo";
                    status: SwanIdentificationStatus;
                  };
              pvid:
                | {
                    __typename: "CanceledIdentificationLevelStatusInfo";
                    status: SwanIdentificationStatus;
                  }
                | {
                    __typename: "ExpiredIdentificationLevelStatusInfo";
                    status: SwanIdentificationStatus;
                    expiredAt: string;
                  }
                | {
                    __typename: "InvalidIdentificationLevelStatusInfo";
                    reasons?: Array<IdentificationInvalidReason> | null;
                    status: SwanIdentificationStatus;
                  }
                | { __typename: "NotStartedIdentificationLevelStatusInfo" }
                | {
                    __typename: "NotSupportedIdentificationLevelStatusInfo";
                    status: SwanIdentificationStatus;
                  }
                | {
                    __typename: "PendingIdentificationLevelStatusInfo";
                    status: SwanIdentificationStatus;
                  }
                | {
                    __typename: "StartedIdentificationLevelStatusInfo";
                    status: SwanIdentificationStatus;
                  }
                | {
                    __typename: "ValidIdentificationLevelStatusInfo";
                    status: SwanIdentificationStatus;
                  };
              qes:
                | {
                    __typename: "CanceledIdentificationLevelStatusInfo";
                    status: SwanIdentificationStatus;
                  }
                | {
                    __typename: "ExpiredIdentificationLevelStatusInfo";
                    status: SwanIdentificationStatus;
                    expiredAt: string;
                  }
                | {
                    __typename: "InvalidIdentificationLevelStatusInfo";
                    reasons?: Array<IdentificationInvalidReason> | null;
                    status: SwanIdentificationStatus;
                  }
                | { __typename: "NotStartedIdentificationLevelStatusInfo" }
                | {
                    __typename: "NotSupportedIdentificationLevelStatusInfo";
                    status: SwanIdentificationStatus;
                  }
                | {
                    __typename: "PendingIdentificationLevelStatusInfo";
                    status: SwanIdentificationStatus;
                  }
                | {
                    __typename: "StartedIdentificationLevelStatusInfo";
                    status: SwanIdentificationStatus;
                  }
                | {
                    __typename: "ValidIdentificationLevelStatusInfo";
                    status: SwanIdentificationStatus;
                  };
            };
          };
        }>;
      } | null;
    } | null;
  } | null;
};

export type AccountMembershipPermissionsFragment = {
  __typename: "AccountMembership";
  id: string;
  canViewAccount: boolean;
  canManageBeneficiaries: boolean;
  canInitiatePayments: boolean;
  canManageAccountMembership: boolean;
  canManageCards: boolean;
  legalRepresentative: boolean;
  statusInfo:
    | { __typename: "AccountMembershipBindingUserErrorStatusInfo"; status: AccountMembershipStatus }
    | { __typename: "AccountMembershipConsentPendingStatusInfo"; status: AccountMembershipStatus }
    | { __typename: "AccountMembershipDisabledStatusInfo"; status: AccountMembershipStatus }
    | { __typename: "AccountMembershipEnabledStatusInfo"; status: AccountMembershipStatus }
    | { __typename: "AccountMembershipInvitationSentStatusInfo"; status: AccountMembershipStatus }
    | { __typename: "AccountMembershipSuspendedStatusInfo"; status: AccountMembershipStatus };
  allCards: { __typename: "CardConnection"; totalCount: number };
  account?: {
    __typename: "Account";
    id: string;
    paymentLevel: PaymentLevel;
    statusInfo:
      | { __typename: "AccountClosedStatus"; status: AccountStatus }
      | { __typename: "AccountClosingStatus"; status: AccountStatus }
      | { __typename: "AccountOpenedStatus"; status: AccountStatus }
      | { __typename: "AccountSuspendedStatus"; status: AccountStatus };
    merchantProfiles?: { __typename: "MerchantProfileConnection"; totalCount: number } | null;
  } | null;
};

export type WebBankingSettingsFragment = {
  __typename: "WebBankingSettings";
  canViewAccountStatement?: boolean | null;
  canViewAccountDetails?: boolean | null;
  canAddNewMembers?: boolean | null;
  canViewMembers?: boolean | null;
  canViewPaymentList?: boolean | null;
  canOrderPhysicalCards?: boolean | null;
  canInitiatePaymentsToNewBeneficiaries?: boolean | null;
  canOrderVirtualCards?: boolean | null;
  canManageVirtualIbans?: boolean | null;
  canCreateMerchantProfile?: boolean | null;
  canRequestOnlineCardsPaymentMethod?: boolean | null;
  canRequestSepaDirectDebitCorePaymentMethod?: boolean | null;
  canRequestSepaDirectDebitB2BPaymentMethod?: boolean | null;
  canRequestInternalDirectDebitCorePaymentMethod?: boolean | null;
  canRequestInternalDirectDebitB2BPaymentMethod?: boolean | null;
  canRequestChecksPaymentMethod?: boolean | null;
  canInitiateCheckMerchantPayments?: boolean | null;
  canCreateMerchantPaymentLinks?: boolean | null;
  canUpdateCards?: boolean | null;
};

export type AccountAreaQueryVariables = Exact<{
  accountMembershipId: Scalars["ID"]["input"];
}>;

export type AccountAreaQuery = {
  __typename: "Query";
  accountMembership?: {
    __typename: "AccountMembership";
    id: string;
    canViewAccount: boolean;
    canManageBeneficiaries: boolean;
    canInitiatePayments: boolean;
    canManageAccountMembership: boolean;
    canManageCards: boolean;
    legalRepresentative: boolean;
    accountId: string;
    accountCountry: AccountCountry;
    createdAt: string;
    updatedAt: string;
    email: string;
    hasRequiredIdentificationLevel?: boolean | null;
    language?: AccountLanguage | null;
    taxIdentificationNumber?: string | null;
    account?: {
      __typename: "Account";
      IBAN?: string | null;
      bankDetails?: string | null;
      language: AccountLanguage;
      id: string;
      paymentLevel: PaymentLevel;
      paymentAccountType: PaymentAccountType;
      name: string;
      country: AccountCountry;
      statusInfo:
        | { __typename: "AccountClosedStatus"; status: AccountStatus }
        | { __typename: "AccountClosingStatus"; status: AccountStatus }
        | { __typename: "AccountOpenedStatus"; status: AccountStatus }
        | { __typename: "AccountSuspendedStatus"; status: AccountStatus };
      balances?: {
        __typename: "AccountBalances";
        available: { __typename: "Amount"; value: string; currency: string };
        pending: { __typename: "Amount"; value: string; currency: string };
        booked: { __typename: "Amount"; value: string; currency: string };
        reserved: { __typename: "Amount"; value: string; currency: string };
      } | null;
      holder: {
        __typename: "AccountHolder";
        id: string;
        verificationStatus: VerificationStatus;
        info:
          | { __typename: "AccountHolderCompanyInfo"; type: AccountHolderType; name: string }
          | { __typename: "AccountHolderIndividualInfo"; type: AccountHolderType; name: string };
        supportingDocumentCollections: {
          __typename: "SupportingDocumentCollectionConnection";
          edges: Array<{
            __typename: "SupportingDocumentCollectionEdge";
            node: {
              __typename: "SupportingDocumentCollection";
              id: string;
              statusInfo:
                | {
                    __typename: "SupportingDocumentCollectionApprovedStatusInfo";
                    status: SupportingDocumentCollectionStatus;
                  }
                | {
                    __typename: "SupportingDocumentCollectionCanceledStatusInfo";
                    status: SupportingDocumentCollectionStatus;
                  }
                | {
                    __typename: "SupportingDocumentCollectionPendingReviewStatusInfo";
                    status: SupportingDocumentCollectionStatus;
                  }
                | {
                    __typename: "SupportingDocumentCollectionRejectedStatusInfo";
                    status: SupportingDocumentCollectionStatus;
                  }
                | {
                    __typename: "SupportingDocumentCollectionWaitingForDocumentStatusInfo";
                    status: SupportingDocumentCollectionStatus;
                  };
            };
          }>;
        };
      };
      transactions?: { __typename: "TransactionConnection"; totalCount: number } | null;
      accountMembershipsWithBindingUserError: {
        __typename: "AccountMembershipConnection";
        totalCount: number;
      };
      merchantProfiles?: { __typename: "MerchantProfileConnection"; totalCount: number } | null;
    } | null;
    user?: {
      __typename: "User";
      id: string;
      birthDate?: string | null;
      firstName?: string | null;
      lastName?: string | null;
      birthLastName?: string | null;
      preferredLastName?: string | null;
      fullName?: string | null;
      mobilePhoneNumber?: string | null;
      verifiedEmails: Array<string>;
      accountMemberships: { __typename: "AccountMembershipConnection"; totalCount: number };
    } | null;
    statusInfo:
      | {
          __typename: "AccountMembershipBindingUserErrorStatusInfo";
          emailVerifiedMatchError: boolean;
          idVerifiedMatchError: boolean;
          status: AccountMembershipStatus;
          restrictedTo: {
            __typename: "RestrictedTo";
            birthDate?: string | null;
            firstName: string;
            lastName: string;
            phoneNumber?: string | null;
          };
        }
      | { __typename: "AccountMembershipConsentPendingStatusInfo"; status: AccountMembershipStatus }
      | { __typename: "AccountMembershipDisabledStatusInfo"; status: AccountMembershipStatus }
      | { __typename: "AccountMembershipEnabledStatusInfo"; status: AccountMembershipStatus }
      | {
          __typename: "AccountMembershipInvitationSentStatusInfo";
          status: AccountMembershipStatus;
          restrictedTo: {
            __typename: "RestrictedTo";
            birthDate?: string | null;
            firstName: string;
            lastName: string;
            phoneNumber?: string | null;
          };
        }
      | { __typename: "AccountMembershipSuspendedStatusInfo"; status: AccountMembershipStatus };
    allCards: { __typename: "CardConnection"; totalCount: number };
    residencyAddress?: {
      __typename: "AddressInfo";
      addressLine1?: string | null;
      postalCode?: string | null;
      city?: string | null;
      country?: string | null;
    } | null;
    activeCards: { __typename: "CardConnection"; totalCount: number };
  } | null;
  projectInfo: {
    __typename: "ProjectInfo";
    id: string;
    accentColor?: string | null;
    name: string;
    logoUri?: string | null;
    B2BMembershipIDVerification?: boolean | null;
    webBankingSettings?: {
      __typename: "WebBankingSettings";
      canViewAccountStatement?: boolean | null;
      canViewAccountDetails?: boolean | null;
      canAddNewMembers?: boolean | null;
      canViewMembers?: boolean | null;
      canViewPaymentList?: boolean | null;
      canOrderPhysicalCards?: boolean | null;
      canInitiatePaymentsToNewBeneficiaries?: boolean | null;
      canOrderVirtualCards?: boolean | null;
      canManageVirtualIbans?: boolean | null;
      canCreateMerchantProfile?: boolean | null;
      canRequestOnlineCardsPaymentMethod?: boolean | null;
      canRequestSepaDirectDebitCorePaymentMethod?: boolean | null;
      canRequestSepaDirectDebitB2BPaymentMethod?: boolean | null;
      canRequestInternalDirectDebitCorePaymentMethod?: boolean | null;
      canRequestInternalDirectDebitB2BPaymentMethod?: boolean | null;
      canRequestChecksPaymentMethod?: boolean | null;
      canInitiateCheckMerchantPayments?: boolean | null;
      canCreateMerchantPaymentLinks?: boolean | null;
      canUpdateCards?: boolean | null;
    } | null;
    supportingDocumentSettings?: {
      __typename: "SupportingDocumentSettings";
      collectMode: SupportingDocumentCollectMode;
    } | null;
  };
  user?: {
    __typename: "User";
    id: string;
    firstName?: string | null;
    preferredLastName?: string | null;
    fullName?: string | null;
    mobilePhoneNumber?: string | null;
    identificationLevels?: {
      __typename: "IdentificationLevels";
      expert: boolean;
      QES: boolean;
      PVID: boolean;
    } | null;
  } | null;
};

export type AccountDetailsIbanPageQueryVariables = Exact<{
  accountId: Scalars["ID"]["input"];
}>;

export type AccountDetailsIbanPageQuery = {
  __typename: "Query";
  account?: {
    __typename: "Account";
    id: string;
    IBAN?: string | null;
    BIC: string;
    bankDetails?: string | null;
    name: string;
    statusInfo:
      | { __typename: "AccountClosedStatus"; status: AccountStatus }
      | { __typename: "AccountClosingStatus"; status: AccountStatus }
      | { __typename: "AccountOpenedStatus"; status: AccountStatus }
      | { __typename: "AccountSuspendedStatus"; status: AccountStatus };
    holder: {
      __typename: "AccountHolder";
      id: string;
      verificationStatus: VerificationStatus;
      info:
        | { __typename: "AccountHolderCompanyInfo"; name: string }
        | { __typename: "AccountHolderIndividualInfo"; name: string };
      residencyAddress: {
        __typename: "AddressInfo";
        addressLine1?: string | null;
        addressLine2?: string | null;
        city?: string | null;
        postalCode?: string | null;
        country?: string | null;
      };
    };
  } | null;
};

export type AccountDetailsVirtualIbansPageQueryVariables = Exact<{
  accountId: Scalars["ID"]["input"];
  first: Scalars["Int"]["input"];
  after?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type AccountDetailsVirtualIbansPageQuery = {
  __typename: "Query";
  account?: {
    __typename: "Account";
    id: string;
    virtualIbanEntries: {
      __typename: "VirtualIBANEntryConnection";
      totalCount: number;
      pageInfo: { __typename: "PageInfo"; endCursor?: string | null; hasNextPage?: boolean | null };
      edges: Array<{
        __typename: "VirtualIBANEntryEdge";
        node: {
          __typename: "VirtualIBANEntry";
          id: string;
          IBAN: string;
          BIC: string;
          status: IbanStatus;
          bankDetails?: string | null;
        };
      }>;
    };
  } | null;
};

export type AddVirtualIbanMutationVariables = Exact<{
  accountId: Scalars["ID"]["input"];
}>;

export type AddVirtualIbanMutation = {
  __typename: "Mutation";
  addVirtualIbanEntry?:
    | { __typename: "AccountNotFoundRejection" }
    | {
        __typename: "AddVirtualIbanEntrySuccessPayload";
        virtualIbanEntry: { __typename: "VirtualIBANEntry"; id: string };
      }
    | { __typename: "BadAccountStatusRejection" }
    | { __typename: "ForbiddenRejection" }
    | { __typename: "ValidationRejection" }
    | null;
};

export type CancelVirtualIbanMutationVariables = Exact<{
  virtualIbanId: Scalars["ID"]["input"];
}>;

export type CancelVirtualIbanMutation = {
  __typename: "Mutation";
  cancelVirtualIbanEntry:
    | { __typename: "AccountNotFoundRejection" }
    | { __typename: "BadAccountStatusRejection" }
    | {
        __typename: "CancelVirtualIbanEntrySuccessPayload";
        virtualIbanEntry: { __typename: "VirtualIBANEntry"; id: string };
      }
    | { __typename: "IbanEntryNotFoundRejection" }
    | { __typename: "InternalErrorRejection" }
    | { __typename: "ValidationRejection" };
};

export type CreditLimitSettingsRequestFragment = {
  __typename: "CreditLimitSettingsRequest";
  id: string;
  updatedAt: string;
  statusInfo:
    | { __typename: "CreditLimitSettingsRequestApprovedStatusInfo" }
    | { __typename: "CreditLimitSettingsRequestCanceledStatusInfo" }
    | { __typename: "CreditLimitSettingsRequestConsentPendingStatusInfo" }
    | { __typename: "CreditLimitSettingsRequestPendingReviewStatusInfo" }
    | { __typename: "CreditLimitSettingsRequestRefusedStatusInfo" };
  amount: { __typename: "Amount"; value: string; currency: string };
};

export type CreditLimitPageQueryVariables = Exact<{
  accountId: Scalars["ID"]["input"];
}>;

export type CreditLimitPageQuery = {
  __typename: "Query";
  account?: {
    __typename: "Account";
    id: string;
    IBAN?: string | null;
    legalRepresentativeMembership: { __typename: "AccountMembership"; id: string };
    holder: {
      __typename: "AccountHolder";
      id: string;
      info:
        | { __typename: "AccountHolderCompanyInfo"; name: string }
        | { __typename: "AccountHolderIndividualInfo"; name: string };
      residencyAddress: {
        __typename: "AddressInfo";
        addressLine1?: string | null;
        city?: string | null;
        postalCode?: string | null;
        country?: string | null;
      };
    };
    creditLimitSettings?: {
      __typename: "CreditLimitSettings";
      creditLimitSettingsRequests: {
        __typename: "CreditLimitSettingsRequestConnection";
        edges: Array<{
          __typename: "CreditLimitSettingsRequestEdge";
          node: {
            __typename: "CreditLimitSettingsRequest";
            id: string;
            updatedAt: string;
            statusInfo:
              | { __typename: "CreditLimitSettingsRequestApprovedStatusInfo" }
              | { __typename: "CreditLimitSettingsRequestCanceledStatusInfo" }
              | { __typename: "CreditLimitSettingsRequestConsentPendingStatusInfo" }
              | { __typename: "CreditLimitSettingsRequestPendingReviewStatusInfo" }
              | { __typename: "CreditLimitSettingsRequestRefusedStatusInfo" };
            amount: { __typename: "Amount"; value: string; currency: string };
          };
        }>;
      };
      authorizedAmount?: { __typename: "Amount"; currency: string; value: string } | null;
      repaymentSettings: {
        __typename: "RepaymentSettings";
        repaymentCycleLength:
          | { __typename: "MonthlyPeriod"; dayOfMonth: number }
          | { __typename: "WeeklyPeriod"; dayOfWeek: DayEnum };
        repaymentMethod: {
          __typename: "SepaDirectDebitB2b";
          mandate?:
            | {
                __typename: "InternalReceivedDirectDebitMandate";
                name?: string | null;
                iban: string;
                id: string;
                account?: {
                  __typename: "Account";
                  holder: {
                    __typename: "AccountHolder";
                    residencyAddress: {
                      __typename: "AddressInfo";
                      addressLine1?: string | null;
                      addressLine2?: string | null;
                      city?: string | null;
                      country?: string | null;
                      postalCode?: string | null;
                      state?: string | null;
                    };
                  };
                } | null;
              }
            | {
                __typename: "SEPAReceivedDirectDebitMandate";
                name?: string | null;
                iban: string;
                id: string;
                account?: {
                  __typename: "Account";
                  holder: {
                    __typename: "AccountHolder";
                    residencyAddress: {
                      __typename: "AddressInfo";
                      addressLine1?: string | null;
                      addressLine2?: string | null;
                      city?: string | null;
                      country?: string | null;
                      postalCode?: string | null;
                      state?: string | null;
                    };
                  };
                } | null;
              }
            | null;
        };
      };
      currentCycle?: {
        __typename: "RepaymentCycle";
        id: string;
        startDate: string;
        endDate: string;
        status: RepaymentCycleStatus;
        owedAmount: { __typename: "Amount"; value: string; currency: string };
      } | null;
      cycles?: {
        __typename: "RepaymentCycleConnection";
        edges: Array<{
          __typename: "RepaymentCycleEdge";
          node: {
            __typename: "RepaymentCycle";
            id: string;
            startDate: string;
            endDate: string;
            status: RepaymentCycleStatus;
            owedAmount: { __typename: "Amount"; value: string; currency: string };
          };
        }>;
      } | null;
      statusInfo:
        | { __typename: "CreditLimitStatusActivatedInfo"; status: CreditLimitStatus }
        | { __typename: "CreditLimitStatusDeactivatedInfo"; status: CreditLimitStatus }
        | { __typename: "CreditLimitStatusPendingInfo"; status: CreditLimitStatus }
        | { __typename: "CreditLimitStatusSuspendedInfo"; status: CreditLimitStatus };
    } | null;
  } | null;
};

export type GenerateCreditStatementMutationVariables = Exact<{
  input: GenerateCreditStatementInput;
}>;

export type GenerateCreditStatementMutation = {
  __typename: "Mutation";
  generateCreditStatement:
    | { __typename: "AccountHolderNotFoundRejection"; message: string }
    | { __typename: "AccountNotFoundRejection"; message: string }
    | { __typename: "BadRequestRejection"; message: string }
    | { __typename: "CreditLimitSettingsNotFoundRejection"; message: string }
    | {
        __typename: "CreditStatement";
        id: string;
        type:
          | { __typename: "CsvStatement"; url?: string | null }
          | { __typename: "PdfStatement"; url?: string | null };
      }
    | { __typename: "ForbiddenRejection"; message: string }
    | { __typename: "RepaymentCycleNotFoundRejection"; message: string };
};

export type AccountDetailsBillingPageQueryVariables = Exact<{
  accountId: Scalars["ID"]["input"];
  first: Scalars["Int"]["input"];
  after?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type AccountDetailsBillingPageQuery = {
  __typename: "Query";
  account?: {
    __typename: "Account";
    id: string;
    invoices?: {
      __typename: "InvoiceConnection";
      totalCount: number;
      edges: Array<{
        __typename: "InvoiceEdge";
        cursor: string;
        node: {
          __typename: "Invoice";
          openingDate: string;
          closingDate: string;
          id: string;
          type: InvoiceType;
          name: string;
          createdAt: string;
          updatedAt: string;
          status: InvoiceStatus;
          url?: string | null;
          amount: { __typename: "Amount"; currency: string; value: string };
        };
      }>;
      pageInfo: { __typename: "PageInfo"; endCursor?: string | null; hasNextPage?: boolean | null };
    } | null;
  } | null;
};

export type AccountDetailsSettingsPageQueryVariables = Exact<{
  accountId: Scalars["ID"]["input"];
  filters?: InputMaybe<LegalDocumentsFilterInput>;
  language: Scalars["String"]["input"];
}>;

export type AccountDetailsSettingsPageQuery = {
  __typename: "Query";
  account?: {
    __typename: "Account";
    id: string;
    country: AccountCountry;
    language: AccountLanguage;
    name: string;
    legalDocuments?: {
      __typename: "LegalDocumentConnection";
      edges: Array<{
        __typename: "LegalDocumentEdge";
        node: {
          __typename: "LegalDocument";
          id: string;
          type: LegalDocumentType;
          url: string;
          statusInfo:
            | { __typename: "LegalDocumentActiveStatusInfo"; status: LegalDocumentStatus }
            | { __typename: "LegalDocumentInactiveStatusInfo"; status: LegalDocumentStatus }
            | { __typename: "LegalDocumentUpcomingStatusInfo"; status: LegalDocumentStatus };
        };
      }>;
    } | null;
    statusInfo:
      | { __typename: "AccountClosedStatus"; status: AccountStatus }
      | { __typename: "AccountClosingStatus"; status: AccountStatus }
      | { __typename: "AccountOpenedStatus"; status: AccountStatus }
      | { __typename: "AccountSuspendedStatus"; status: AccountStatus };
    holder: {
      __typename: "AccountHolder";
      id: string;
      info:
        | {
            __typename: "AccountHolderCompanyInfo";
            vatNumber?: string | null;
            registrationNumber?: string | null;
            taxIdentificationNumber?: string | null;
          }
        | { __typename: "AccountHolderIndividualInfo"; taxIdentificationNumber?: string | null };
      residencyAddress: { __typename: "AddressInfo"; country?: string | null };
    };
  } | null;
  projectInfo: { __typename: "ProjectInfo"; id: string; tcuDocumentUri: string; name: string };
};

export type UpdateAccountLanguageMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
  language: AccountLanguage;
}>;

export type UpdateAccountLanguageMutation = {
  __typename: "Mutation";
  updateAccount:
    | { __typename: "AccountNotFoundRejection" }
    | { __typename: "BadAccountStatusRejection" }
    | { __typename: "ForbiddenRejection" }
    | { __typename: "InternalErrorRejection" }
    | { __typename: "UpdateAccountSuccessPayload"; account: { __typename: "Account"; id: string } }
    | { __typename: "ValidationRejection" };
};

export type UpdateAccountMutationVariables = Exact<{
  updateAccountInput: UpdateAccountInput;
  updateAccountHolderInput: UpdateAccountHolderInput;
}>;

export type UpdateAccountMutation = {
  __typename: "Mutation";
  updateAccount:
    | { __typename: "AccountNotFoundRejection" }
    | { __typename: "BadAccountStatusRejection" }
    | { __typename: "ForbiddenRejection" }
    | { __typename: "InternalErrorRejection" }
    | {
        __typename: "UpdateAccountSuccessPayload";
        account: { __typename: "Account"; id: string; name: string };
      }
    | { __typename: "ValidationRejection" };
  updateAccountHolder:
    | { __typename: "AccountHolderNotFoundRejection" }
    | {
        __typename: "UpdateAccountHolderSuccessPayload";
        accountHolder: { __typename: "AccountHolder"; id: string };
      }
    | { __typename: "ValidationRejection" };
};

export type AccountStatementsPageQueryVariables = Exact<{
  accountId: Scalars["ID"]["input"];
  first: Scalars["Int"]["input"];
  after?: InputMaybe<Scalars["String"]["input"]>;
  filters?: InputMaybe<StatementFiltersInput>;
}>;

export type AccountStatementsPageQuery = {
  __typename: "Query";
  account?: {
    __typename: "Account";
    id: string;
    name: string;
    number: string;
    holder: {
      __typename: "AccountHolder";
      id: string;
      info:
        | { __typename: "AccountHolderCompanyInfo"; name: string }
        | { __typename: "AccountHolderIndividualInfo"; name: string };
    };
    statements?: {
      __typename: "StatementConnection";
      totalCount: number;
      pageInfo: { __typename: "PageInfo"; endCursor?: string | null; hasNextPage?: boolean | null };
      edges: Array<{
        __typename: "StatementEdge";
        cursor: string;
        node: {
          __typename: "Statement";
          id: string;
          closingDate: string;
          openingDate: string;
          createdAt: string;
          status: StatementStatus;
          period?: StatementPeriod | null;
          type: Array<
            | { __typename: "CsvStatement"; url?: string | null }
            | { __typename: "PdfStatement"; url?: string | null }
            | null
          >;
        };
      }>;
    } | null;
  } | null;
};

export type AccountMembershipsTotalCountFragment = {
  __typename: "AccountMembership";
  id: string;
  account?: {
    __typename: "Account";
    id: string;
    memberships: { __typename: "AccountMembershipConnection"; totalCount: number };
  } | null;
};

export type CardListItemFragment = {
  __typename: "Card";
  id: string;
  type: CardType;
  name?: string | null;
  cardDesignUrl: string;
  statusInfo:
    | { __typename: "CardCanceledStatusInfo"; status: CardStatus }
    | { __typename: "CardCancelingStatusInfo"; status: CardStatus }
    | { __typename: "CardConsentPendingStatusInfo"; status: CardStatus }
    | { __typename: "CardEnabledStatusInfo"; status: CardStatus }
    | { __typename: "CardProcessingStatusInfo"; status: CardStatus };
  spendingLimits?: Array<{
    __typename: "SpendingLimit";
    period: SpendingLimitPeriod;
    amount: { __typename: "Amount"; currency: string; value: string };
  }> | null;
  spending?: {
    __typename: "Spending";
    period: SpendingLimitPeriod;
    amount?: { __typename: "Amount"; currency: string; value: string } | null;
  } | null;
  physicalCard?: {
    __typename: "PhysicalCard";
    statusInfo:
      | { __typename: "PhysicalCardActivatedStatusInfo"; status: PhysicalCardStatus }
      | { __typename: "PhysicalCardCanceledStatusInfo"; status: PhysicalCardStatus }
      | { __typename: "PhysicalCardCancelingStatusInfo"; status: PhysicalCardStatus }
      | { __typename: "PhysicalCardConsentPendingStatusInfo"; status: PhysicalCardStatus }
      | { __typename: "PhysicalCardProcessingStatusInfo"; status: PhysicalCardStatus }
      | { __typename: "PhysicalCardRenewedStatusInfo"; status: PhysicalCardStatus }
      | { __typename: "PhysicalCardSuspendedStatusInfo"; status: PhysicalCardStatus }
      | { __typename: "PhysicalCardToActivateStatusInfo"; status: PhysicalCardStatus }
      | { __typename: "PhysicalCardToRenewStatusInfo"; status: PhysicalCardStatus };
  } | null;
  cardProduct: { __typename: "CardProduct"; fundingType: CardProductFundingType };
  insuranceSubscription?: {
    __typename: "CardInsuranceSubscription";
    id: string;
    package: {
      __typename: "CardInsurancePackage";
      id: string;
      name: string;
      level: CardInsurancePackageLevel;
      noticeUrl?: string | null;
    };
  } | null;
  accountMembership: {
    __typename: "AccountMembership";
    id: string;
    account?: {
      __typename: "Account";
      id: string;
      number: string;
      holder: {
        __typename: "AccountHolder";
        id: string;
        info:
          | { __typename: "AccountHolderCompanyInfo"; name: string; type: AccountHolderType }
          | { __typename: "AccountHolderIndividualInfo"; name: string; type: AccountHolderType };
      };
    } | null;
    statusInfo:
      | {
          __typename: "AccountMembershipBindingUserErrorStatusInfo";
          restrictedTo: { __typename: "RestrictedTo"; firstName: string; lastName: string };
        }
      | { __typename: "AccountMembershipConsentPendingStatusInfo" }
      | { __typename: "AccountMembershipDisabledStatusInfo" }
      | { __typename: "AccountMembershipEnabledStatusInfo" }
      | {
          __typename: "AccountMembershipInvitationSentStatusInfo";
          restrictedTo: { __typename: "RestrictedTo"; firstName: string; lastName: string };
        }
      | { __typename: "AccountMembershipSuspendedStatusInfo" };
    user?: {
      __typename: "User";
      id: string;
      firstName?: string | null;
      preferredLastName?: string | null;
      fullName?: string | null;
    } | null;
  };
};

export type CardListPageDataFragment = {
  __typename: "CardConnection";
  pageInfo: { __typename: "PageInfo"; endCursor?: string | null; hasNextPage?: boolean | null };
  edges: Array<{
    __typename: "CardEdge";
    cursor: string;
    node: {
      __typename: "Card";
      id: string;
      type: CardType;
      name?: string | null;
      cardDesignUrl: string;
      statusInfo:
        | { __typename: "CardCanceledStatusInfo"; status: CardStatus }
        | { __typename: "CardCancelingStatusInfo"; status: CardStatus }
        | { __typename: "CardConsentPendingStatusInfo"; status: CardStatus }
        | { __typename: "CardEnabledStatusInfo"; status: CardStatus }
        | { __typename: "CardProcessingStatusInfo"; status: CardStatus };
      spendingLimits?: Array<{
        __typename: "SpendingLimit";
        period: SpendingLimitPeriod;
        amount: { __typename: "Amount"; currency: string; value: string };
      }> | null;
      spending?: {
        __typename: "Spending";
        period: SpendingLimitPeriod;
        amount?: { __typename: "Amount"; currency: string; value: string } | null;
      } | null;
      physicalCard?: {
        __typename: "PhysicalCard";
        statusInfo:
          | { __typename: "PhysicalCardActivatedStatusInfo"; status: PhysicalCardStatus }
          | { __typename: "PhysicalCardCanceledStatusInfo"; status: PhysicalCardStatus }
          | { __typename: "PhysicalCardCancelingStatusInfo"; status: PhysicalCardStatus }
          | { __typename: "PhysicalCardConsentPendingStatusInfo"; status: PhysicalCardStatus }
          | { __typename: "PhysicalCardProcessingStatusInfo"; status: PhysicalCardStatus }
          | { __typename: "PhysicalCardRenewedStatusInfo"; status: PhysicalCardStatus }
          | { __typename: "PhysicalCardSuspendedStatusInfo"; status: PhysicalCardStatus }
          | { __typename: "PhysicalCardToActivateStatusInfo"; status: PhysicalCardStatus }
          | { __typename: "PhysicalCardToRenewStatusInfo"; status: PhysicalCardStatus };
      } | null;
      cardProduct: { __typename: "CardProduct"; fundingType: CardProductFundingType };
      insuranceSubscription?: {
        __typename: "CardInsuranceSubscription";
        id: string;
        package: {
          __typename: "CardInsurancePackage";
          id: string;
          name: string;
          level: CardInsurancePackageLevel;
          noticeUrl?: string | null;
        };
      } | null;
      accountMembership: {
        __typename: "AccountMembership";
        id: string;
        account?: {
          __typename: "Account";
          id: string;
          number: string;
          holder: {
            __typename: "AccountHolder";
            id: string;
            info:
              | { __typename: "AccountHolderCompanyInfo"; name: string; type: AccountHolderType }
              | {
                  __typename: "AccountHolderIndividualInfo";
                  name: string;
                  type: AccountHolderType;
                };
          };
        } | null;
        statusInfo:
          | {
              __typename: "AccountMembershipBindingUserErrorStatusInfo";
              restrictedTo: { __typename: "RestrictedTo"; firstName: string; lastName: string };
            }
          | { __typename: "AccountMembershipConsentPendingStatusInfo" }
          | { __typename: "AccountMembershipDisabledStatusInfo" }
          | { __typename: "AccountMembershipEnabledStatusInfo" }
          | {
              __typename: "AccountMembershipInvitationSentStatusInfo";
              restrictedTo: { __typename: "RestrictedTo"; firstName: string; lastName: string };
            }
          | { __typename: "AccountMembershipSuspendedStatusInfo" };
        user?: {
          __typename: "User";
          id: string;
          firstName?: string | null;
          preferredLastName?: string | null;
          fullName?: string | null;
        } | null;
      };
    };
  }>;
};

export type CardListPageQueryVariables = Exact<{
  filters?: InputMaybe<CardFiltersInput>;
  first: Scalars["Int"]["input"];
  after?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type CardListPageQuery = {
  __typename: "Query";
  cards: {
    __typename: "CardConnection";
    pageInfo: { __typename: "PageInfo"; endCursor?: string | null; hasNextPage?: boolean | null };
    edges: Array<{
      __typename: "CardEdge";
      cursor: string;
      node: {
        __typename: "Card";
        id: string;
        type: CardType;
        name?: string | null;
        cardDesignUrl: string;
        statusInfo:
          | { __typename: "CardCanceledStatusInfo"; status: CardStatus }
          | { __typename: "CardCancelingStatusInfo"; status: CardStatus }
          | { __typename: "CardConsentPendingStatusInfo"; status: CardStatus }
          | { __typename: "CardEnabledStatusInfo"; status: CardStatus }
          | { __typename: "CardProcessingStatusInfo"; status: CardStatus };
        spendingLimits?: Array<{
          __typename: "SpendingLimit";
          period: SpendingLimitPeriod;
          amount: { __typename: "Amount"; currency: string; value: string };
        }> | null;
        spending?: {
          __typename: "Spending";
          period: SpendingLimitPeriod;
          amount?: { __typename: "Amount"; currency: string; value: string } | null;
        } | null;
        physicalCard?: {
          __typename: "PhysicalCard";
          statusInfo:
            | { __typename: "PhysicalCardActivatedStatusInfo"; status: PhysicalCardStatus }
            | { __typename: "PhysicalCardCanceledStatusInfo"; status: PhysicalCardStatus }
            | { __typename: "PhysicalCardCancelingStatusInfo"; status: PhysicalCardStatus }
            | { __typename: "PhysicalCardConsentPendingStatusInfo"; status: PhysicalCardStatus }
            | { __typename: "PhysicalCardProcessingStatusInfo"; status: PhysicalCardStatus }
            | { __typename: "PhysicalCardRenewedStatusInfo"; status: PhysicalCardStatus }
            | { __typename: "PhysicalCardSuspendedStatusInfo"; status: PhysicalCardStatus }
            | { __typename: "PhysicalCardToActivateStatusInfo"; status: PhysicalCardStatus }
            | { __typename: "PhysicalCardToRenewStatusInfo"; status: PhysicalCardStatus };
        } | null;
        cardProduct: { __typename: "CardProduct"; fundingType: CardProductFundingType };
        insuranceSubscription?: {
          __typename: "CardInsuranceSubscription";
          id: string;
          package: {
            __typename: "CardInsurancePackage";
            id: string;
            name: string;
            level: CardInsurancePackageLevel;
            noticeUrl?: string | null;
          };
        } | null;
        accountMembership: {
          __typename: "AccountMembership";
          id: string;
          account?: {
            __typename: "Account";
            id: string;
            number: string;
            holder: {
              __typename: "AccountHolder";
              id: string;
              info:
                | { __typename: "AccountHolderCompanyInfo"; name: string; type: AccountHolderType }
                | {
                    __typename: "AccountHolderIndividualInfo";
                    name: string;
                    type: AccountHolderType;
                  };
            };
          } | null;
          statusInfo:
            | {
                __typename: "AccountMembershipBindingUserErrorStatusInfo";
                restrictedTo: { __typename: "RestrictedTo"; firstName: string; lastName: string };
              }
            | { __typename: "AccountMembershipConsentPendingStatusInfo" }
            | { __typename: "AccountMembershipDisabledStatusInfo" }
            | { __typename: "AccountMembershipEnabledStatusInfo" }
            | {
                __typename: "AccountMembershipInvitationSentStatusInfo";
                restrictedTo: { __typename: "RestrictedTo"; firstName: string; lastName: string };
              }
            | { __typename: "AccountMembershipSuspendedStatusInfo" };
          user?: {
            __typename: "User";
            id: string;
            firstName?: string | null;
            preferredLastName?: string | null;
            fullName?: string | null;
          } | null;
        };
      };
    }>;
  };
};

export type AccountMembershipCardListPageQueryVariables = Exact<{
  accountMembershipId: Scalars["ID"]["input"];
  filters?: InputMaybe<CardFiltersInput>;
  first: Scalars["Int"]["input"];
  after?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type AccountMembershipCardListPageQuery = {
  __typename: "Query";
  accountMembership?: {
    __typename: "AccountMembership";
    id: string;
    cards: {
      __typename: "CardConnection";
      pageInfo: { __typename: "PageInfo"; endCursor?: string | null; hasNextPage?: boolean | null };
      edges: Array<{
        __typename: "CardEdge";
        cursor: string;
        node: {
          __typename: "Card";
          id: string;
          type: CardType;
          name?: string | null;
          cardDesignUrl: string;
          statusInfo:
            | { __typename: "CardCanceledStatusInfo"; status: CardStatus }
            | { __typename: "CardCancelingStatusInfo"; status: CardStatus }
            | { __typename: "CardConsentPendingStatusInfo"; status: CardStatus }
            | { __typename: "CardEnabledStatusInfo"; status: CardStatus }
            | { __typename: "CardProcessingStatusInfo"; status: CardStatus };
          spendingLimits?: Array<{
            __typename: "SpendingLimit";
            period: SpendingLimitPeriod;
            amount: { __typename: "Amount"; currency: string; value: string };
          }> | null;
          spending?: {
            __typename: "Spending";
            period: SpendingLimitPeriod;
            amount?: { __typename: "Amount"; currency: string; value: string } | null;
          } | null;
          physicalCard?: {
            __typename: "PhysicalCard";
            statusInfo:
              | { __typename: "PhysicalCardActivatedStatusInfo"; status: PhysicalCardStatus }
              | { __typename: "PhysicalCardCanceledStatusInfo"; status: PhysicalCardStatus }
              | { __typename: "PhysicalCardCancelingStatusInfo"; status: PhysicalCardStatus }
              | { __typename: "PhysicalCardConsentPendingStatusInfo"; status: PhysicalCardStatus }
              | { __typename: "PhysicalCardProcessingStatusInfo"; status: PhysicalCardStatus }
              | { __typename: "PhysicalCardRenewedStatusInfo"; status: PhysicalCardStatus }
              | { __typename: "PhysicalCardSuspendedStatusInfo"; status: PhysicalCardStatus }
              | { __typename: "PhysicalCardToActivateStatusInfo"; status: PhysicalCardStatus }
              | { __typename: "PhysicalCardToRenewStatusInfo"; status: PhysicalCardStatus };
          } | null;
          cardProduct: { __typename: "CardProduct"; fundingType: CardProductFundingType };
          insuranceSubscription?: {
            __typename: "CardInsuranceSubscription";
            id: string;
            package: {
              __typename: "CardInsurancePackage";
              id: string;
              name: string;
              level: CardInsurancePackageLevel;
              noticeUrl?: string | null;
            };
          } | null;
          accountMembership: {
            __typename: "AccountMembership";
            id: string;
            account?: {
              __typename: "Account";
              id: string;
              number: string;
              holder: {
                __typename: "AccountHolder";
                id: string;
                info:
                  | {
                      __typename: "AccountHolderCompanyInfo";
                      name: string;
                      type: AccountHolderType;
                    }
                  | {
                      __typename: "AccountHolderIndividualInfo";
                      name: string;
                      type: AccountHolderType;
                    };
              };
            } | null;
            statusInfo:
              | {
                  __typename: "AccountMembershipBindingUserErrorStatusInfo";
                  restrictedTo: { __typename: "RestrictedTo"; firstName: string; lastName: string };
                }
              | { __typename: "AccountMembershipConsentPendingStatusInfo" }
              | { __typename: "AccountMembershipDisabledStatusInfo" }
              | { __typename: "AccountMembershipEnabledStatusInfo" }
              | {
                  __typename: "AccountMembershipInvitationSentStatusInfo";
                  restrictedTo: { __typename: "RestrictedTo"; firstName: string; lastName: string };
                }
              | { __typename: "AccountMembershipSuspendedStatusInfo" };
            user?: {
              __typename: "User";
              id: string;
              firstName?: string | null;
              preferredLastName?: string | null;
              fullName?: string | null;
            } | null;
          };
        };
      }>;
    };
    account?: {
      __typename: "Account";
      id: string;
      memberships: { __typename: "AccountMembershipConnection"; totalCount: number };
    } | null;
  } | null;
};

export type CardCountQueryVariables = Exact<{
  filters?: InputMaybe<CardFiltersInput>;
  first: Scalars["Int"]["input"];
}>;

export type CardCountQuery = {
  __typename: "Query";
  cards: {
    __typename: "CardConnection";
    totalCount: number;
    edges: Array<{
      __typename: "CardEdge";
      cursor: string;
      node: { __typename: "Card"; id: string };
    }>;
  };
};

type DigitalCard_CompleteDigitalCard_Fragment = {
  __typename: "CompleteDigitalCard";
  id: string;
  createdAt: string;
  updatedAt: string;
  device: { __typename: "Device"; name?: string | null; type?: string | null };
  walletProvider: { __typename: "WalletProvider"; id: string; name: string };
};

type DigitalCard_PendingDigitalCard_Fragment = {
  __typename: "PendingDigitalCard";
  id: string;
  createdAt: string;
  updatedAt: string;
  walletProvider: { __typename: "WalletProvider"; id: string; name: string };
};

export type DigitalCardFragment =
  | DigitalCard_CompleteDigitalCard_Fragment
  | DigitalCard_PendingDigitalCard_Fragment;

export type CardPageQueryVariables = Exact<{
  cardId: Scalars["ID"]["input"];
}>;

export type CardPageQuery = {
  __typename: "Query";
  projectInfo: {
    __typename: "ProjectInfo";
    id: string;
    B2BMembershipIDVerification?: boolean | null;
  };
  card?: {
    __typename: "Card";
    id: string;
    type: CardType;
    cardMaskedNumber: string;
    expiryDate?: string | null;
    name?: string | null;
    cardDesignUrl: string;
    mainCurrency: string;
    eCommerce: boolean;
    withdrawal: boolean;
    nonMainCurrencyTransactions: boolean;
    international: boolean;
    issuingCountry: string;
    insuranceSubscription?: {
      __typename: "CardInsuranceSubscription";
      id: string;
      claimsUrl: string;
      package: {
        __typename: "CardInsurancePackage";
        id: string;
        name: string;
        level: CardInsurancePackageLevel;
        noticeUrl?: string | null;
      };
    } | null;
    statusInfo:
      | { __typename: "CardCanceledStatusInfo"; status: CardStatus }
      | { __typename: "CardCancelingStatusInfo"; status: CardStatus }
      | { __typename: "CardConsentPendingStatusInfo"; status: CardStatus }
      | { __typename: "CardEnabledStatusInfo"; status: CardStatus }
      | { __typename: "CardProcessingStatusInfo"; status: CardStatus };
    cardProduct: {
      __typename: "CardProduct";
      id: string;
      name?: string | null;
      fundingType: CardProductFundingType;
      projectId: string;
      status: CardProductStatus;
      createdAt: string;
      updatedAt: string;
      applicableToPhysicalCards: boolean;
      defaultCardProduct: boolean;
      companySpendingLimit: {
        __typename: "SpendingLimit";
        period: SpendingLimitPeriod;
        amount: { __typename: "Amount"; value: string; currency: string };
      };
      individualSpendingLimit: {
        __typename: "SpendingLimit";
        period: SpendingLimitPeriod;
        amount: { __typename: "Amount"; value: string; currency: string };
      };
      cardDesigns: Array<{
        __typename: "CardProductDesign";
        id: string;
        version: number;
        cardProjectLogoSvgUrl?: string | null;
        cardProjectLogo300dpiUrl?: string | null;
        cardProjectLogo600dpiUrl?: string | null;
        zoomRatioProjectLogo?: number | null;
        cardDesignUrl?: string | null;
        accentColor: string;
        createdAt: string;
        updatedAt: string;
        status: CardDesignStatus;
        cardBackground: {
          __typename: "CardDesignBackground";
          id: string;
          name: string;
          type: string;
          cardTextColor: string;
          cardBackgroundUrl: string;
          createdAt: string;
          updatedAt: string;
        };
      }>;
      insurance?: {
        __typename: "CardInsuranceConfiguration";
        defaultInsurancePackage?: {
          __typename: "CardInsurancePackage";
          id: string;
          name: string;
          level: CardInsurancePackageLevel;
          noticeUrl?: string | null;
        } | null;
        availableInsurancePackages?: Array<{
          __typename: "CardInsurancePackage";
          id: string;
          name: string;
          level: CardInsurancePackageLevel;
          noticeUrl?: string | null;
        }> | null;
      } | null;
    };
    accountMembership: {
      __typename: "AccountMembership";
      id: string;
      canManageAccountMembership: boolean;
      hasRequiredIdentificationLevel?: boolean | null;
      canViewAccount: boolean;
      canManageBeneficiaries: boolean;
      canInitiatePayments: boolean;
      canManageCards: boolean;
      statusInfo:
        | {
            __typename: "AccountMembershipBindingUserErrorStatusInfo";
            idVerifiedMatchError: boolean;
            firstNameMatchError: boolean;
            lastNameMatchError: boolean;
            phoneNumberMatchError: boolean;
            emailVerifiedMatchError: boolean;
            birthDateMatchError: boolean;
            status: AccountMembershipStatus;
            restrictedTo: { __typename: "RestrictedTo"; firstName: string; lastName: string };
          }
        | {
            __typename: "AccountMembershipConsentPendingStatusInfo";
            status: AccountMembershipStatus;
          }
        | { __typename: "AccountMembershipDisabledStatusInfo"; status: AccountMembershipStatus }
        | { __typename: "AccountMembershipEnabledStatusInfo"; status: AccountMembershipStatus }
        | {
            __typename: "AccountMembershipInvitationSentStatusInfo";
            status: AccountMembershipStatus;
            restrictedTo: { __typename: "RestrictedTo"; firstName: string; lastName: string };
          }
        | { __typename: "AccountMembershipSuspendedStatusInfo"; status: AccountMembershipStatus };
      user?: {
        __typename: "User";
        id: string;
        firstName?: string | null;
        preferredLastName?: string | null;
        fullName?: string | null;
        verifiedEmails: Array<string>;
        identificationLevels?: {
          __typename: "IdentificationLevels";
          expert: boolean;
          QES: boolean;
          PVID: boolean;
        } | null;
      } | null;
      account?: {
        __typename: "Account";
        id: string;
        paymentLevel: PaymentLevel;
        holder: {
          __typename: "AccountHolder";
          id: string;
          residencyAddress: {
            __typename: "AddressInfo";
            addressLine1?: string | null;
            addressLine2?: string | null;
            city?: string | null;
            postalCode?: string | null;
            country?: string | null;
          };
          info:
            | { __typename: "AccountHolderCompanyInfo"; name: string; type: AccountHolderType }
            | { __typename: "AccountHolderIndividualInfo"; name: string; type: AccountHolderType };
        };
      } | null;
    };
    spendingLimits?: Array<{
      __typename: "SpendingLimit";
      period: SpendingLimitPeriod;
      type: SpendingLimitType;
      amount: { __typename: "Amount"; currency: string; value: string };
    }> | null;
    spending?: {
      __typename: "Spending";
      period: SpendingLimitPeriod;
      amount?: { __typename: "Amount"; currency: string; value: string } | null;
    } | null;
    digitalCards: {
      __typename: "DigitalCardConnection";
      edges: Array<{
        __typename: "DigitalCardEdge";
        node:
          | {
              __typename: "CompleteDigitalCard";
              id: string;
              createdAt: string;
              updatedAt: string;
              device: { __typename: "Device"; name?: string | null; type?: string | null };
              walletProvider: { __typename: "WalletProvider"; id: string; name: string };
            }
          | {
              __typename: "PendingDigitalCard";
              id: string;
              createdAt: string;
              updatedAt: string;
              walletProvider: { __typename: "WalletProvider"; id: string; name: string };
            };
      }>;
    };
    transactions?: { __typename: "TransactionConnection"; totalCount: number } | null;
    physicalCard?: {
      __typename: "PhysicalCard";
      expiryDate?: string | null;
      cardMaskedNumber: string;
      identifier?: string | null;
      statusInfo:
        | { __typename: "PhysicalCardActivatedStatusInfo"; status: PhysicalCardStatus }
        | { __typename: "PhysicalCardCanceledStatusInfo"; status: PhysicalCardStatus }
        | { __typename: "PhysicalCardCancelingStatusInfo"; status: PhysicalCardStatus }
        | {
            __typename: "PhysicalCardConsentPendingStatusInfo";
            status: PhysicalCardStatus;
            consent: { __typename: "Consent"; id: string; consentUrl: string };
          }
        | { __typename: "PhysicalCardProcessingStatusInfo"; status: PhysicalCardStatus }
        | {
            __typename: "PhysicalCardRenewedStatusInfo";
            isPINReady: boolean;
            estimatedDeliveryDate?: string | null;
            trackingNumber?: string | null;
            shippingProvider?: ShippingProvider | null;
            status: PhysicalCardStatus;
            address: {
              __typename: "Address";
              addressLine1?: string | null;
              addressLine2?: string | null;
              city?: string | null;
              country?: string | null;
              postalCode?: string | null;
              state?: string | null;
            };
          }
        | { __typename: "PhysicalCardSuspendedStatusInfo"; status: PhysicalCardStatus }
        | {
            __typename: "PhysicalCardToActivateStatusInfo";
            isPINReady: boolean;
            estimatedDeliveryDate?: string | null;
            trackingNumber?: string | null;
            shippingProvider?: ShippingProvider | null;
            status: PhysicalCardStatus;
            address: {
              __typename: "Address";
              addressLine1?: string | null;
              addressLine2?: string | null;
              city?: string | null;
              country?: string | null;
              postalCode?: string | null;
              state?: string | null;
            };
          }
        | {
            __typename: "PhysicalCardToRenewStatusInfo";
            status: PhysicalCardStatus;
            address: {
              __typename: "Address";
              addressLine1?: string | null;
              addressLine2?: string | null;
              city?: string | null;
              postalCode?: string | null;
              country?: string | null;
            };
          };
      previousPhysicalCards: Array<{
        __typename: "BasicPhysicalCardInfo";
        cardMaskedNumber: string;
        expiryDate?: string | null;
        isExpired: boolean;
        customOptions: {
          __typename: "PhysicalCardCustomOptions";
          additionalPrintedLine?: string | null;
        };
        offlineSpendingLimit: { __typename: "Amount"; currency: string; value: string };
      }>;
    } | null;
  } | null;
};

export type CardTransactionsPageQueryVariables = Exact<{
  cardId: Scalars["ID"]["input"];
  first: Scalars["Int"]["input"];
  canQueryCardOnTransaction: Scalars["Boolean"]["input"];
  after?: InputMaybe<Scalars["String"]["input"]>;
  filters?: InputMaybe<TransactionsFiltersInput>;
}>;

export type CardTransactionsPageQuery = {
  __typename: "Query";
  card?: {
    __typename: "Card";
    id: string;
    cardDesignUrl: string;
    statusInfo:
      | { __typename: "CardCanceledStatusInfo"; status: CardStatus }
      | { __typename: "CardCancelingStatusInfo"; status: CardStatus }
      | { __typename: "CardConsentPendingStatusInfo"; status: CardStatus }
      | { __typename: "CardEnabledStatusInfo"; status: CardStatus }
      | { __typename: "CardProcessingStatusInfo"; status: CardStatus };
    accountMembership: {
      __typename: "AccountMembership";
      id: string;
      statusInfo:
        | {
            __typename: "AccountMembershipBindingUserErrorStatusInfo";
            restrictedTo: { __typename: "RestrictedTo"; firstName: string; lastName: string };
          }
        | { __typename: "AccountMembershipConsentPendingStatusInfo" }
        | { __typename: "AccountMembershipDisabledStatusInfo" }
        | { __typename: "AccountMembershipEnabledStatusInfo" }
        | {
            __typename: "AccountMembershipInvitationSentStatusInfo";
            restrictedTo: { __typename: "RestrictedTo"; firstName: string; lastName: string };
          }
        | { __typename: "AccountMembershipSuspendedStatusInfo" };
      user?: {
        __typename: "User";
        id: string;
        firstName?: string | null;
        preferredLastName?: string | null;
        fullName?: string | null;
      } | null;
    };
    transactions?: {
      __typename: "TransactionConnection";
      totalCount: number;
      pageInfo: { __typename: "PageInfo"; endCursor?: string | null; hasNextPage?: boolean | null };
      edges: Array<{
        __typename: "TransactionEdge";
        node:
          | {
              __typename: "CardTransaction";
              reservedAmountReleasedAt?: string | null;
              id: string;
              side: TransactionSide;
              type: TransactionTypeEnum;
              label: string;
              counterparty: string;
              reference: string;
              externalReference?: string | null;
              statementCanBeGenerated?: boolean | null;
              createdAt: string;
              executionDate: string;
              updatedAt: string;
              originalAmount: { __typename: "Amount"; currency: string; value: string };
              reservedAmount?: { __typename: "Amount"; currency: string; value: string } | null;
              cardDetails?:
                | {
                    __typename: "CardInDetails";
                    paymentMandate: {
                      __typename: "CardPaymentMandate";
                      id: string;
                      name?: string | null;
                      createdAt: string;
                      updatedAt: string;
                      executedAt?: string | null;
                    };
                  }
                | {
                    __typename: "CardOutDetails";
                    maskedPan: string;
                    card?: {
                      __typename: "Card";
                      id: string;
                      name?: string | null;
                      accountMembership: {
                        __typename: "AccountMembership";
                        id: string;
                        user?: {
                          __typename: "User";
                          id: string;
                          firstName?: string | null;
                          preferredLastName?: string | null;
                          fullName?: string | null;
                        } | null;
                      };
                    } | null;
                  }
                | null;
              merchant?:
                | { __typename: "CardInMerchant" }
                | {
                    __typename: "CardOutMerchant";
                    merchantId: string;
                    merchantCity: string;
                    merchantCountry?: string | null;
                  }
                | null;
              enrichedTransactionInfo?: {
                __typename: "EnrichedTransactionInfo";
                enrichedMerchantName?: string | null;
                isSubscription?: boolean | null;
                carbonFootprint?: string | null;
                contactEmail?: string | null;
                contactPhone?: string | null;
                contactWebsite?: string | null;
                logoUrl?: string | null;
                category?: MerchantCategory | null;
                subcategory?: MerchantSubCategory | null;
                address?: string | null;
                city?: string | null;
                postalCode?: string | null;
                country?: string | null;
              } | null;
              currencyExchange: Array<{ __typename: "ReportExchangeRate"; exchangeRate: number }>;
              payment?: { __typename: "Payment"; id: string; createdAt: string } | null;
              originTransaction?:
                | {
                    __typename: "CardTransaction";
                    id: string;
                    type: TransactionTypeEnum;
                    executionDate: string;
                    amount: { __typename: "Amount"; currency: string; value: string };
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          status: TransactionStatus;
                          reason: RejectedReasonCode;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                  }
                | {
                    __typename: "CheckTransaction";
                    id: string;
                    type: TransactionTypeEnum;
                    executionDate: string;
                    amount: { __typename: "Amount"; currency: string; value: string };
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          status: TransactionStatus;
                          reason: RejectedReasonCode;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                  }
                | {
                    __typename: "FeeTransaction";
                    id: string;
                    type: TransactionTypeEnum;
                    executionDate: string;
                    amount: { __typename: "Amount"; currency: string; value: string };
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          status: TransactionStatus;
                          reason: RejectedReasonCode;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                  }
                | {
                    __typename: "InternalCreditTransfer";
                    id: string;
                    type: TransactionTypeEnum;
                    executionDate: string;
                    amount: { __typename: "Amount"; currency: string; value: string };
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          status: TransactionStatus;
                          reason: RejectedReasonCode;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                  }
                | {
                    __typename: "InternalDirectDebitTransaction";
                    id: string;
                    type: TransactionTypeEnum;
                    executionDate: string;
                    amount: { __typename: "Amount"; currency: string; value: string };
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          status: TransactionStatus;
                          reason: RejectedReasonCode;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                  }
                | {
                    __typename: "InternationalCreditTransferTransaction";
                    id: string;
                    type: TransactionTypeEnum;
                    executionDate: string;
                    amount: { __typename: "Amount"; currency: string; value: string };
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          status: TransactionStatus;
                          reason: RejectedReasonCode;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                  }
                | {
                    __typename: "SEPACreditTransferTransaction";
                    id: string;
                    type: TransactionTypeEnum;
                    executionDate: string;
                    amount: { __typename: "Amount"; currency: string; value: string };
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          status: TransactionStatus;
                          reason: RejectedReasonCode;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                  }
                | {
                    __typename: "SEPADirectDebitTransaction";
                    id: string;
                    type: TransactionTypeEnum;
                    executionDate: string;
                    amount: { __typename: "Amount"; currency: string; value: string };
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          status: TransactionStatus;
                          reason: RejectedReasonCode;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                  }
                | null;
              statusInfo:
                | {
                    __typename: "BookedTransactionStatusInfo";
                    bookingDate: string;
                    status: TransactionStatus;
                  }
                | {
                    __typename: "CanceledTransactionStatusInfo";
                    canceledDate?: string | null;
                    status: TransactionStatus;
                  }
                | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                | {
                    __typename: "PendingTransactionStatusInfo";
                    pendingEndDate?: string | null;
                    status: TransactionStatus;
                  }
                | {
                    __typename: "RejectedTransactionStatusInfo";
                    reason: RejectedReasonCode;
                    status: TransactionStatus;
                  }
                | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                | {
                    __typename: "UpcomingTransactionStatusInfo";
                    executionDate: string;
                    status: TransactionStatus;
                  };
              amount: { __typename: "Amount"; currency: string; value: string };
            }
          | {
              __typename: "CheckTransaction";
              reservedAmountReleasedAt?: string | null;
              cmc7: string;
              rlmcKey: string;
              id: string;
              side: TransactionSide;
              type: TransactionTypeEnum;
              label: string;
              counterparty: string;
              reference: string;
              externalReference?: string | null;
              statementCanBeGenerated?: boolean | null;
              createdAt: string;
              executionDate: string;
              updatedAt: string;
              reservedAmount?: { __typename: "Amount"; currency: string; value: string } | null;
              payment?: { __typename: "Payment"; id: string; createdAt: string } | null;
              originTransaction?:
                | {
                    __typename: "CardTransaction";
                    id: string;
                    type: TransactionTypeEnum;
                    executionDate: string;
                    amount: { __typename: "Amount"; currency: string; value: string };
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          status: TransactionStatus;
                          reason: RejectedReasonCode;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                  }
                | {
                    __typename: "CheckTransaction";
                    id: string;
                    type: TransactionTypeEnum;
                    executionDate: string;
                    amount: { __typename: "Amount"; currency: string; value: string };
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          status: TransactionStatus;
                          reason: RejectedReasonCode;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                  }
                | {
                    __typename: "FeeTransaction";
                    id: string;
                    type: TransactionTypeEnum;
                    executionDate: string;
                    amount: { __typename: "Amount"; currency: string; value: string };
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          status: TransactionStatus;
                          reason: RejectedReasonCode;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                  }
                | {
                    __typename: "InternalCreditTransfer";
                    id: string;
                    type: TransactionTypeEnum;
                    executionDate: string;
                    amount: { __typename: "Amount"; currency: string; value: string };
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          status: TransactionStatus;
                          reason: RejectedReasonCode;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                  }
                | {
                    __typename: "InternalDirectDebitTransaction";
                    id: string;
                    type: TransactionTypeEnum;
                    executionDate: string;
                    amount: { __typename: "Amount"; currency: string; value: string };
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          status: TransactionStatus;
                          reason: RejectedReasonCode;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                  }
                | {
                    __typename: "InternationalCreditTransferTransaction";
                    id: string;
                    type: TransactionTypeEnum;
                    executionDate: string;
                    amount: { __typename: "Amount"; currency: string; value: string };
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          status: TransactionStatus;
                          reason: RejectedReasonCode;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                  }
                | {
                    __typename: "SEPACreditTransferTransaction";
                    id: string;
                    type: TransactionTypeEnum;
                    executionDate: string;
                    amount: { __typename: "Amount"; currency: string; value: string };
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          status: TransactionStatus;
                          reason: RejectedReasonCode;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                  }
                | {
                    __typename: "SEPADirectDebitTransaction";
                    id: string;
                    type: TransactionTypeEnum;
                    executionDate: string;
                    amount: { __typename: "Amount"; currency: string; value: string };
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          status: TransactionStatus;
                          reason: RejectedReasonCode;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                  }
                | null;
              statusInfo:
                | {
                    __typename: "BookedTransactionStatusInfo";
                    bookingDate: string;
                    status: TransactionStatus;
                  }
                | {
                    __typename: "CanceledTransactionStatusInfo";
                    canceledDate?: string | null;
                    status: TransactionStatus;
                  }
                | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                | {
                    __typename: "PendingTransactionStatusInfo";
                    pendingEndDate?: string | null;
                    status: TransactionStatus;
                  }
                | {
                    __typename: "RejectedTransactionStatusInfo";
                    reason: RejectedReasonCode;
                    status: TransactionStatus;
                  }
                | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                | {
                    __typename: "UpcomingTransactionStatusInfo";
                    executionDate: string;
                    status: TransactionStatus;
                  };
              amount: { __typename: "Amount"; currency: string; value: string };
            }
          | {
              __typename: "FeeTransaction";
              feesType: FeesTypeEnum;
              id: string;
              side: TransactionSide;
              type: TransactionTypeEnum;
              label: string;
              counterparty: string;
              reference: string;
              externalReference?: string | null;
              statementCanBeGenerated?: boolean | null;
              createdAt: string;
              executionDate: string;
              updatedAt: string;
              creditor:
                | { __typename: "FeeInCreditor"; name: string }
                | { __typename: "FeeOutCreditor"; name: string };
              originTransaction?:
                | {
                    __typename: "CardTransaction";
                    id: string;
                    label: string;
                    type: TransactionTypeEnum;
                    updatedAt: string;
                    executionDate: string;
                    createdAt: string;
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          reason: RejectedReasonCode;
                          status: TransactionStatus;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                    amount: { __typename: "Amount"; currency: string; value: string };
                  }
                | {
                    __typename: "CheckTransaction";
                    id: string;
                    label: string;
                    type: TransactionTypeEnum;
                    updatedAt: string;
                    executionDate: string;
                    createdAt: string;
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          reason: RejectedReasonCode;
                          status: TransactionStatus;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                    amount: { __typename: "Amount"; currency: string; value: string };
                  }
                | {
                    __typename: "FeeTransaction";
                    id: string;
                    label: string;
                    type: TransactionTypeEnum;
                    updatedAt: string;
                    executionDate: string;
                    createdAt: string;
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          reason: RejectedReasonCode;
                          status: TransactionStatus;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                    amount: { __typename: "Amount"; currency: string; value: string };
                  }
                | {
                    __typename: "InternalCreditTransfer";
                    id: string;
                    label: string;
                    type: TransactionTypeEnum;
                    updatedAt: string;
                    executionDate: string;
                    createdAt: string;
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          reason: RejectedReasonCode;
                          status: TransactionStatus;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                    amount: { __typename: "Amount"; currency: string; value: string };
                  }
                | {
                    __typename: "InternalDirectDebitTransaction";
                    id: string;
                    label: string;
                    type: TransactionTypeEnum;
                    updatedAt: string;
                    executionDate: string;
                    createdAt: string;
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          reason: RejectedReasonCode;
                          status: TransactionStatus;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                    amount: { __typename: "Amount"; currency: string; value: string };
                  }
                | {
                    __typename: "InternationalCreditTransferTransaction";
                    id: string;
                    label: string;
                    type: TransactionTypeEnum;
                    updatedAt: string;
                    executionDate: string;
                    createdAt: string;
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          reason: RejectedReasonCode;
                          status: TransactionStatus;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                    amount: { __typename: "Amount"; currency: string; value: string };
                  }
                | {
                    __typename: "SEPACreditTransferTransaction";
                    id: string;
                    label: string;
                    type: TransactionTypeEnum;
                    updatedAt: string;
                    executionDate: string;
                    createdAt: string;
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          reason: RejectedReasonCode;
                          status: TransactionStatus;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                    amount: { __typename: "Amount"; currency: string; value: string };
                  }
                | {
                    __typename: "SEPADirectDebitTransaction";
                    id: string;
                    label: string;
                    type: TransactionTypeEnum;
                    updatedAt: string;
                    executionDate: string;
                    createdAt: string;
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          reason: RejectedReasonCode;
                          status: TransactionStatus;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                    amount: { __typename: "Amount"; currency: string; value: string };
                  }
                | null;
              payment?: { __typename: "Payment"; id: string; createdAt: string } | null;
              statusInfo:
                | {
                    __typename: "BookedTransactionStatusInfo";
                    bookingDate: string;
                    status: TransactionStatus;
                  }
                | {
                    __typename: "CanceledTransactionStatusInfo";
                    canceledDate?: string | null;
                    status: TransactionStatus;
                  }
                | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                | {
                    __typename: "PendingTransactionStatusInfo";
                    pendingEndDate?: string | null;
                    status: TransactionStatus;
                  }
                | {
                    __typename: "RejectedTransactionStatusInfo";
                    reason: RejectedReasonCode;
                    status: TransactionStatus;
                  }
                | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                | {
                    __typename: "UpcomingTransactionStatusInfo";
                    executionDate: string;
                    status: TransactionStatus;
                  };
              amount: { __typename: "Amount"; currency: string; value: string };
            }
          | {
              __typename: "InternalCreditTransfer";
              id: string;
              side: TransactionSide;
              type: TransactionTypeEnum;
              label: string;
              counterparty: string;
              reference: string;
              externalReference?: string | null;
              statementCanBeGenerated?: boolean | null;
              createdAt: string;
              executionDate: string;
              updatedAt: string;
              creditor:
                | { __typename: "InternalCreditTransferInCreditor"; name: string }
                | { __typename: "InternalCreditTransferOutCreditor"; name: string };
              payment?: { __typename: "Payment"; id: string; createdAt: string } | null;
              originTransaction?:
                | {
                    __typename: "CardTransaction";
                    id: string;
                    type: TransactionTypeEnum;
                    executionDate: string;
                    amount: { __typename: "Amount"; currency: string; value: string };
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          status: TransactionStatus;
                          reason: RejectedReasonCode;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                  }
                | {
                    __typename: "CheckTransaction";
                    id: string;
                    type: TransactionTypeEnum;
                    executionDate: string;
                    amount: { __typename: "Amount"; currency: string; value: string };
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          status: TransactionStatus;
                          reason: RejectedReasonCode;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                  }
                | {
                    __typename: "FeeTransaction";
                    id: string;
                    type: TransactionTypeEnum;
                    executionDate: string;
                    amount: { __typename: "Amount"; currency: string; value: string };
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          status: TransactionStatus;
                          reason: RejectedReasonCode;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                  }
                | {
                    __typename: "InternalCreditTransfer";
                    id: string;
                    type: TransactionTypeEnum;
                    executionDate: string;
                    amount: { __typename: "Amount"; currency: string; value: string };
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          status: TransactionStatus;
                          reason: RejectedReasonCode;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                  }
                | {
                    __typename: "InternalDirectDebitTransaction";
                    id: string;
                    type: TransactionTypeEnum;
                    executionDate: string;
                    amount: { __typename: "Amount"; currency: string; value: string };
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          status: TransactionStatus;
                          reason: RejectedReasonCode;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                  }
                | {
                    __typename: "InternationalCreditTransferTransaction";
                    id: string;
                    type: TransactionTypeEnum;
                    executionDate: string;
                    amount: { __typename: "Amount"; currency: string; value: string };
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          status: TransactionStatus;
                          reason: RejectedReasonCode;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                  }
                | {
                    __typename: "SEPACreditTransferTransaction";
                    id: string;
                    type: TransactionTypeEnum;
                    executionDate: string;
                    amount: { __typename: "Amount"; currency: string; value: string };
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          status: TransactionStatus;
                          reason: RejectedReasonCode;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                  }
                | {
                    __typename: "SEPADirectDebitTransaction";
                    id: string;
                    type: TransactionTypeEnum;
                    executionDate: string;
                    amount: { __typename: "Amount"; currency: string; value: string };
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          status: TransactionStatus;
                          reason: RejectedReasonCode;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                  }
                | null;
              statusInfo:
                | {
                    __typename: "BookedTransactionStatusInfo";
                    bookingDate: string;
                    status: TransactionStatus;
                  }
                | {
                    __typename: "CanceledTransactionStatusInfo";
                    canceledDate?: string | null;
                    status: TransactionStatus;
                  }
                | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                | {
                    __typename: "PendingTransactionStatusInfo";
                    pendingEndDate?: string | null;
                    status: TransactionStatus;
                  }
                | {
                    __typename: "RejectedTransactionStatusInfo";
                    reason: RejectedReasonCode;
                    status: TransactionStatus;
                  }
                | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                | {
                    __typename: "UpcomingTransactionStatusInfo";
                    executionDate: string;
                    status: TransactionStatus;
                  };
              amount: { __typename: "Amount"; currency: string; value: string };
            }
          | {
              __typename: "InternalDirectDebitTransaction";
              reservedAmountReleasedAt?: string | null;
              id: string;
              side: TransactionSide;
              type: TransactionTypeEnum;
              label: string;
              counterparty: string;
              reference: string;
              externalReference?: string | null;
              statementCanBeGenerated?: boolean | null;
              createdAt: string;
              executionDate: string;
              updatedAt: string;
              reservedAmount?: { __typename: "Amount"; currency: string; value: string } | null;
              creditor: { __typename: "InternalDirectDebitCreditor"; accountId: string };
              mandate?:
                | { __typename: "InternalPaymentDirectDebitMandate"; id: string }
                | { __typename: "InternalReceivedDirectDebitMandate"; id: string }
                | null;
              payment?: { __typename: "Payment"; id: string; createdAt: string } | null;
              originTransaction?:
                | {
                    __typename: "CardTransaction";
                    id: string;
                    type: TransactionTypeEnum;
                    executionDate: string;
                    amount: { __typename: "Amount"; currency: string; value: string };
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          status: TransactionStatus;
                          reason: RejectedReasonCode;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                  }
                | {
                    __typename: "CheckTransaction";
                    id: string;
                    type: TransactionTypeEnum;
                    executionDate: string;
                    amount: { __typename: "Amount"; currency: string; value: string };
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          status: TransactionStatus;
                          reason: RejectedReasonCode;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                  }
                | {
                    __typename: "FeeTransaction";
                    id: string;
                    type: TransactionTypeEnum;
                    executionDate: string;
                    amount: { __typename: "Amount"; currency: string; value: string };
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          status: TransactionStatus;
                          reason: RejectedReasonCode;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                  }
                | {
                    __typename: "InternalCreditTransfer";
                    id: string;
                    type: TransactionTypeEnum;
                    executionDate: string;
                    amount: { __typename: "Amount"; currency: string; value: string };
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          status: TransactionStatus;
                          reason: RejectedReasonCode;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                  }
                | {
                    __typename: "InternalDirectDebitTransaction";
                    id: string;
                    type: TransactionTypeEnum;
                    executionDate: string;
                    amount: { __typename: "Amount"; currency: string; value: string };
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          status: TransactionStatus;
                          reason: RejectedReasonCode;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                  }
                | {
                    __typename: "InternationalCreditTransferTransaction";
                    id: string;
                    type: TransactionTypeEnum;
                    executionDate: string;
                    amount: { __typename: "Amount"; currency: string; value: string };
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          status: TransactionStatus;
                          reason: RejectedReasonCode;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                  }
                | {
                    __typename: "SEPACreditTransferTransaction";
                    id: string;
                    type: TransactionTypeEnum;
                    executionDate: string;
                    amount: { __typename: "Amount"; currency: string; value: string };
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          status: TransactionStatus;
                          reason: RejectedReasonCode;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                  }
                | {
                    __typename: "SEPADirectDebitTransaction";
                    id: string;
                    type: TransactionTypeEnum;
                    executionDate: string;
                    amount: { __typename: "Amount"; currency: string; value: string };
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          status: TransactionStatus;
                          reason: RejectedReasonCode;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                  }
                | null;
              statusInfo:
                | {
                    __typename: "BookedTransactionStatusInfo";
                    bookingDate: string;
                    status: TransactionStatus;
                  }
                | {
                    __typename: "CanceledTransactionStatusInfo";
                    canceledDate?: string | null;
                    status: TransactionStatus;
                  }
                | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                | {
                    __typename: "PendingTransactionStatusInfo";
                    pendingEndDate?: string | null;
                    status: TransactionStatus;
                  }
                | {
                    __typename: "RejectedTransactionStatusInfo";
                    reason: RejectedReasonCode;
                    status: TransactionStatus;
                  }
                | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                | {
                    __typename: "UpcomingTransactionStatusInfo";
                    executionDate: string;
                    status: TransactionStatus;
                  };
              amount: { __typename: "Amount"; currency: string; value: string };
            }
          | {
              __typename: "InternationalCreditTransferTransaction";
              reference: string;
              paymentProduct: PaymentProduct;
              id: string;
              side: TransactionSide;
              type: TransactionTypeEnum;
              label: string;
              counterparty: string;
              externalReference?: string | null;
              statementCanBeGenerated?: boolean | null;
              createdAt: string;
              executionDate: string;
              updatedAt: string;
              creditor:
                | { __typename: "InternationalCreditTransferInCreditor"; name: string }
                | { __typename: "InternationalCreditTransferInDebtor" }
                | {
                    __typename: "InternationalCreditTransferOutCreditor";
                    name: string;
                    details: Array<{
                      __typename: "InternationalCreditTransferDetails";
                      key: string;
                      value: string;
                    }>;
                  };
              statusInfo:
                | {
                    __typename: "BookedTransactionStatusInfo";
                    bookingDate: string;
                    status: TransactionStatus;
                  }
                | {
                    __typename: "CanceledTransactionStatusInfo";
                    canceledDate?: string | null;
                    status: TransactionStatus;
                  }
                | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                | {
                    __typename: "PendingTransactionStatusInfo";
                    pendingEndDate?: string | null;
                    status: TransactionStatus;
                  }
                | {
                    __typename: "RejectedTransactionStatusInfo";
                    reason: RejectedReasonCode;
                    status: TransactionStatus;
                  }
                | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                | {
                    __typename: "UpcomingTransactionStatusInfo";
                    executionDate: string;
                    status: TransactionStatus;
                  };
              internationalCurrencyExchange: {
                __typename: "InternationalCreditTransferCurrencyExchange";
                exchangeRate: string;
                sourceAmount?: { __typename: "Amount"; currency: string; value: string } | null;
                targetAmount?: { __typename: "Amount"; currency: string; value: string } | null;
              };
              beneficiary?:
                | {
                    __typename: "TrustedInternationalBeneficiary";
                    name: string;
                    currency: string;
                    route: InternationalCreditTransferRoute;
                    details: Array<{
                      __typename: "InternationalCreditTransferDetails";
                      key: string;
                      value: string;
                    }>;
                  }
                | {
                    __typename: "UnsavedInternationalBeneficiary";
                    name: string;
                    currency: string;
                    route: InternationalCreditTransferRoute;
                    details: Array<{
                      __typename: "InternationalCreditTransferDetails";
                      key: string;
                      value: string;
                    }>;
                  }
                | null;
              payment?: { __typename: "Payment"; id: string; createdAt: string } | null;
              originTransaction?:
                | {
                    __typename: "CardTransaction";
                    id: string;
                    type: TransactionTypeEnum;
                    executionDate: string;
                    amount: { __typename: "Amount"; currency: string; value: string };
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          status: TransactionStatus;
                          reason: RejectedReasonCode;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                  }
                | {
                    __typename: "CheckTransaction";
                    id: string;
                    type: TransactionTypeEnum;
                    executionDate: string;
                    amount: { __typename: "Amount"; currency: string; value: string };
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          status: TransactionStatus;
                          reason: RejectedReasonCode;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                  }
                | {
                    __typename: "FeeTransaction";
                    id: string;
                    type: TransactionTypeEnum;
                    executionDate: string;
                    amount: { __typename: "Amount"; currency: string; value: string };
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          status: TransactionStatus;
                          reason: RejectedReasonCode;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                  }
                | {
                    __typename: "InternalCreditTransfer";
                    id: string;
                    type: TransactionTypeEnum;
                    executionDate: string;
                    amount: { __typename: "Amount"; currency: string; value: string };
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          status: TransactionStatus;
                          reason: RejectedReasonCode;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                  }
                | {
                    __typename: "InternalDirectDebitTransaction";
                    id: string;
                    type: TransactionTypeEnum;
                    executionDate: string;
                    amount: { __typename: "Amount"; currency: string; value: string };
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          status: TransactionStatus;
                          reason: RejectedReasonCode;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                  }
                | {
                    __typename: "InternationalCreditTransferTransaction";
                    id: string;
                    type: TransactionTypeEnum;
                    executionDate: string;
                    amount: { __typename: "Amount"; currency: string; value: string };
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          status: TransactionStatus;
                          reason: RejectedReasonCode;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                  }
                | {
                    __typename: "SEPACreditTransferTransaction";
                    id: string;
                    type: TransactionTypeEnum;
                    executionDate: string;
                    amount: { __typename: "Amount"; currency: string; value: string };
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          status: TransactionStatus;
                          reason: RejectedReasonCode;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                  }
                | {
                    __typename: "SEPADirectDebitTransaction";
                    id: string;
                    type: TransactionTypeEnum;
                    executionDate: string;
                    amount: { __typename: "Amount"; currency: string; value: string };
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          status: TransactionStatus;
                          reason: RejectedReasonCode;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                  }
                | null;
              amount: { __typename: "Amount"; currency: string; value: string };
            }
          | {
              __typename: "SEPACreditTransferTransaction";
              id: string;
              side: TransactionSide;
              type: TransactionTypeEnum;
              label: string;
              counterparty: string;
              reference: string;
              externalReference?: string | null;
              statementCanBeGenerated?: boolean | null;
              createdAt: string;
              executionDate: string;
              updatedAt: string;
              creditor:
                | { __typename: "SEPACreditTransferInCreditor"; name: string; IBAN?: string | null }
                | {
                    __typename: "SEPACreditTransferInternalOutCreditor";
                    name: string;
                    IBAN?: string | null;
                  }
                | {
                    __typename: "SEPACreditTransferOutCreditor";
                    name: string;
                    IBAN?: string | null;
                  };
              debtor:
                | { __typename: "SEPACreditTransferInDebtor"; name: string; IBAN?: string | null }
                | {
                    __typename: "SEPACreditTransferInternalInDebtor";
                    name: string;
                    IBAN?: string | null;
                  }
                | { __typename: "SEPACreditTransferOutDebtor"; name: string; IBAN?: string | null };
              beneficiary?:
                | {
                    __typename: "TrustedSepaBeneficiary";
                    iban: string;
                    id: string;
                    label: string;
                    name: string;
                    type: BeneficiaryType;
                    createdAt: string;
                    address?: {
                      __typename: "Address";
                      addressLine1?: string | null;
                      addressLine2?: string | null;
                      city?: string | null;
                      country?: string | null;
                      postalCode?: string | null;
                      state?: string | null;
                    } | null;
                    statusInfo:
                      | {
                          __typename: "TrustedBeneficiaryCanceledStatusInfo";
                          status: TrustedBeneficiaryStatus;
                        }
                      | {
                          __typename: "TrustedBeneficiaryConsentPendingStatusInfo";
                          status: TrustedBeneficiaryStatus;
                        }
                      | {
                          __typename: "TrustedBeneficiaryEnabledStatusInfo";
                          status: TrustedBeneficiaryStatus;
                        };
                  }
                | {
                    __typename: "UnsavedSepaBeneficiary";
                    name: string;
                    iban: string;
                    address?: {
                      __typename: "Address";
                      addressLine1?: string | null;
                      addressLine2?: string | null;
                      city?: string | null;
                      country?: string | null;
                      postalCode?: string | null;
                      state?: string | null;
                    } | null;
                  }
                | null;
              payment?: { __typename: "Payment"; id: string; createdAt: string } | null;
              originTransaction?:
                | {
                    __typename: "CardTransaction";
                    id: string;
                    type: TransactionTypeEnum;
                    executionDate: string;
                    amount: { __typename: "Amount"; currency: string; value: string };
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          status: TransactionStatus;
                          reason: RejectedReasonCode;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                  }
                | {
                    __typename: "CheckTransaction";
                    id: string;
                    type: TransactionTypeEnum;
                    executionDate: string;
                    amount: { __typename: "Amount"; currency: string; value: string };
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          status: TransactionStatus;
                          reason: RejectedReasonCode;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                  }
                | {
                    __typename: "FeeTransaction";
                    id: string;
                    type: TransactionTypeEnum;
                    executionDate: string;
                    amount: { __typename: "Amount"; currency: string; value: string };
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          status: TransactionStatus;
                          reason: RejectedReasonCode;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                  }
                | {
                    __typename: "InternalCreditTransfer";
                    id: string;
                    type: TransactionTypeEnum;
                    executionDate: string;
                    amount: { __typename: "Amount"; currency: string; value: string };
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          status: TransactionStatus;
                          reason: RejectedReasonCode;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                  }
                | {
                    __typename: "InternalDirectDebitTransaction";
                    id: string;
                    type: TransactionTypeEnum;
                    executionDate: string;
                    amount: { __typename: "Amount"; currency: string; value: string };
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          status: TransactionStatus;
                          reason: RejectedReasonCode;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                  }
                | {
                    __typename: "InternationalCreditTransferTransaction";
                    id: string;
                    type: TransactionTypeEnum;
                    executionDate: string;
                    amount: { __typename: "Amount"; currency: string; value: string };
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          status: TransactionStatus;
                          reason: RejectedReasonCode;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                  }
                | {
                    __typename: "SEPACreditTransferTransaction";
                    id: string;
                    type: TransactionTypeEnum;
                    executionDate: string;
                    amount: { __typename: "Amount"; currency: string; value: string };
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          status: TransactionStatus;
                          reason: RejectedReasonCode;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                  }
                | {
                    __typename: "SEPADirectDebitTransaction";
                    id: string;
                    type: TransactionTypeEnum;
                    executionDate: string;
                    amount: { __typename: "Amount"; currency: string; value: string };
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          status: TransactionStatus;
                          reason: RejectedReasonCode;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                  }
                | null;
              statusInfo:
                | {
                    __typename: "BookedTransactionStatusInfo";
                    bookingDate: string;
                    status: TransactionStatus;
                  }
                | {
                    __typename: "CanceledTransactionStatusInfo";
                    canceledDate?: string | null;
                    status: TransactionStatus;
                  }
                | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                | {
                    __typename: "PendingTransactionStatusInfo";
                    pendingEndDate?: string | null;
                    status: TransactionStatus;
                  }
                | {
                    __typename: "RejectedTransactionStatusInfo";
                    reason: RejectedReasonCode;
                    status: TransactionStatus;
                  }
                | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                | {
                    __typename: "UpcomingTransactionStatusInfo";
                    executionDate: string;
                    status: TransactionStatus;
                  };
              amount: { __typename: "Amount"; currency: string; value: string };
            }
          | {
              __typename: "SEPADirectDebitTransaction";
              reservedAmountReleasedAt?: string | null;
              id: string;
              side: TransactionSide;
              type: TransactionTypeEnum;
              label: string;
              counterparty: string;
              reference: string;
              externalReference?: string | null;
              statementCanBeGenerated?: boolean | null;
              createdAt: string;
              executionDate: string;
              updatedAt: string;
              creditor:
                | { __typename: "SEPADirectDebitInCreditor"; name: string; IBAN?: string | null }
                | { __typename: "SEPADirectDebitOutCreditor"; name: string; IBAN?: string | null };
              debtor:
                | { __typename: "SEPADirectDebitInDebtor"; name: string; IBAN?: string | null }
                | { __typename: "SEPADirectDebitOutDebtor"; name: string; IBAN?: string | null };
              reservedAmount?: { __typename: "Amount"; value: string; currency: string } | null;
              mandate?:
                | {
                    __typename: "SEPAPaymentDirectDebitMandate";
                    id: string;
                    debtor: { __typename: "SEPAPaymentMandateDebtor"; name: string };
                  }
                | {
                    __typename: "SEPAReceivedDirectDebitMandate";
                    ultimateCreditorName?: string | null;
                    id: string;
                  }
                | null;
              payment?: { __typename: "Payment"; id: string; createdAt: string } | null;
              originTransaction?:
                | {
                    __typename: "CardTransaction";
                    id: string;
                    type: TransactionTypeEnum;
                    executionDate: string;
                    amount: { __typename: "Amount"; currency: string; value: string };
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          status: TransactionStatus;
                          reason: RejectedReasonCode;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                  }
                | {
                    __typename: "CheckTransaction";
                    id: string;
                    type: TransactionTypeEnum;
                    executionDate: string;
                    amount: { __typename: "Amount"; currency: string; value: string };
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          status: TransactionStatus;
                          reason: RejectedReasonCode;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                  }
                | {
                    __typename: "FeeTransaction";
                    id: string;
                    type: TransactionTypeEnum;
                    executionDate: string;
                    amount: { __typename: "Amount"; currency: string; value: string };
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          status: TransactionStatus;
                          reason: RejectedReasonCode;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                  }
                | {
                    __typename: "InternalCreditTransfer";
                    id: string;
                    type: TransactionTypeEnum;
                    executionDate: string;
                    amount: { __typename: "Amount"; currency: string; value: string };
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          status: TransactionStatus;
                          reason: RejectedReasonCode;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                  }
                | {
                    __typename: "InternalDirectDebitTransaction";
                    id: string;
                    type: TransactionTypeEnum;
                    executionDate: string;
                    amount: { __typename: "Amount"; currency: string; value: string };
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          status: TransactionStatus;
                          reason: RejectedReasonCode;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                  }
                | {
                    __typename: "InternationalCreditTransferTransaction";
                    id: string;
                    type: TransactionTypeEnum;
                    executionDate: string;
                    amount: { __typename: "Amount"; currency: string; value: string };
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          status: TransactionStatus;
                          reason: RejectedReasonCode;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                  }
                | {
                    __typename: "SEPACreditTransferTransaction";
                    id: string;
                    type: TransactionTypeEnum;
                    executionDate: string;
                    amount: { __typename: "Amount"; currency: string; value: string };
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          status: TransactionStatus;
                          reason: RejectedReasonCode;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                  }
                | {
                    __typename: "SEPADirectDebitTransaction";
                    id: string;
                    type: TransactionTypeEnum;
                    executionDate: string;
                    amount: { __typename: "Amount"; currency: string; value: string };
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          status: TransactionStatus;
                          reason: RejectedReasonCode;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                  }
                | null;
              statusInfo:
                | {
                    __typename: "BookedTransactionStatusInfo";
                    bookingDate: string;
                    status: TransactionStatus;
                  }
                | {
                    __typename: "CanceledTransactionStatusInfo";
                    canceledDate?: string | null;
                    status: TransactionStatus;
                  }
                | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                | {
                    __typename: "PendingTransactionStatusInfo";
                    pendingEndDate?: string | null;
                    status: TransactionStatus;
                  }
                | {
                    __typename: "RejectedTransactionStatusInfo";
                    reason: RejectedReasonCode;
                    status: TransactionStatus;
                  }
                | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                | {
                    __typename: "UpcomingTransactionStatusInfo";
                    executionDate: string;
                    status: TransactionStatus;
                  };
              amount: { __typename: "Amount"; currency: string; value: string };
            };
      }>;
    } | null;
  } | null;
};

export type PrintPhysicalCardMutationVariables = Exact<{
  input: PrintPhysicalCardInput;
}>;

export type PrintPhysicalCardMutation = {
  __typename: "Mutation";
  printPhysicalCard:
    | { __typename: "AccountMembershipNotAllowedRejection" }
    | { __typename: "AlreadyValidPhysicalCardRejection" }
    | { __typename: "BadAccountStatusRejection" }
    | { __typename: "BadRequestRejection" }
    | { __typename: "CardNotFoundRejection" }
    | { __typename: "CardProductDisabledRejection" }
    | { __typename: "CardProductNotApplicableToPhysicalCardsRejection" }
    | { __typename: "InvalidShippingProviderRejection" }
    | { __typename: "MissingMandatoryFieldRejection" }
    | {
        __typename: "PrintPhysicalCardSuccessPayload";
        physicalCard: {
          __typename: "PhysicalCard";
          statusInfo:
            | { __typename: "PhysicalCardActivatedStatusInfo" }
            | { __typename: "PhysicalCardCanceledStatusInfo" }
            | { __typename: "PhysicalCardCancelingStatusInfo" }
            | {
                __typename: "PhysicalCardConsentPendingStatusInfo";
                consent: { __typename: "Consent"; id: string; consentUrl: string };
              }
            | { __typename: "PhysicalCardProcessingStatusInfo" }
            | { __typename: "PhysicalCardRenewedStatusInfo" }
            | { __typename: "PhysicalCardSuspendedStatusInfo" }
            | { __typename: "PhysicalCardToActivateStatusInfo" }
            | { __typename: "PhysicalCardToRenewStatusInfo" };
        };
      }
    | { __typename: "ValidationRejection" };
};

export type ConsentCallbackPageQueryVariables = Exact<{
  consentId: Scalars["ID"]["input"];
}>;

export type ConsentCallbackPageQuery = {
  __typename: "Query";
  consent: { __typename: "Consent"; id: string; status: ConsentStatus };
};

export type StandingOrdersHistoryPageQueryVariables = Exact<{
  standingOrderId: Scalars["ID"]["input"];
  first: Scalars["Int"]["input"];
  canQueryCardOnTransaction: Scalars["Boolean"]["input"];
  after?: InputMaybe<Scalars["String"]["input"]>;
  filters?: InputMaybe<PaymentFiltersInput>;
  orderBy?: InputMaybe<PaymentOrderByInput>;
}>;

export type StandingOrdersHistoryPageQuery = {
  __typename: "Query";
  standingOrder?: {
    __typename: "StandingOrder";
    id: string;
    label?: string | null;
    reference?: string | null;
    period: StandingOrderPeriod;
    firstExecutionDate?: string | null;
    lastExecutionDate?: string | null;
    statusInfo:
      | { __typename: "StandingOrderCanceledStatusInfo"; status: StandingOrderStatus }
      | { __typename: "StandingOrderConsentPendingStatusInfo"; status: StandingOrderStatus }
      | { __typename: "StandingOrderEnabledStatusInfo"; status: StandingOrderStatus };
    targetAvailableBalance?: { __typename: "Amount"; value: string } | null;
    amount?: { __typename: "Amount"; value: string } | null;
    sepaBeneficiary: { __typename: "SEPABeneficiary"; name: string };
    payments: {
      __typename: "PaymentConnection";
      pageInfo: { __typename: "PageInfo"; endCursor?: string | null; hasNextPage?: boolean | null };
      edges: Array<{
        __typename: "PaymentEdge";
        node: {
          __typename: "Payment";
          id: string;
          transactions?: {
            __typename: "TransactionConnection";
            totalCount: number;
            pageInfo: {
              __typename: "PageInfo";
              endCursor?: string | null;
              hasNextPage?: boolean | null;
            };
            edges: Array<{
              __typename: "TransactionEdge";
              node:
                | {
                    __typename: "CardTransaction";
                    reservedAmountReleasedAt?: string | null;
                    id: string;
                    side: TransactionSide;
                    type: TransactionTypeEnum;
                    label: string;
                    counterparty: string;
                    reference: string;
                    externalReference?: string | null;
                    statementCanBeGenerated?: boolean | null;
                    createdAt: string;
                    executionDate: string;
                    updatedAt: string;
                    originalAmount: { __typename: "Amount"; currency: string; value: string };
                    reservedAmount?: {
                      __typename: "Amount";
                      currency: string;
                      value: string;
                    } | null;
                    cardDetails?:
                      | {
                          __typename: "CardInDetails";
                          paymentMandate: {
                            __typename: "CardPaymentMandate";
                            id: string;
                            name?: string | null;
                            createdAt: string;
                            updatedAt: string;
                            executedAt?: string | null;
                          };
                        }
                      | {
                          __typename: "CardOutDetails";
                          maskedPan: string;
                          card?: {
                            __typename: "Card";
                            id: string;
                            name?: string | null;
                            accountMembership: {
                              __typename: "AccountMembership";
                              id: string;
                              user?: {
                                __typename: "User";
                                id: string;
                                firstName?: string | null;
                                preferredLastName?: string | null;
                                fullName?: string | null;
                              } | null;
                            };
                          } | null;
                        }
                      | null;
                    merchant?:
                      | { __typename: "CardInMerchant" }
                      | {
                          __typename: "CardOutMerchant";
                          merchantId: string;
                          merchantCity: string;
                          merchantCountry?: string | null;
                        }
                      | null;
                    enrichedTransactionInfo?: {
                      __typename: "EnrichedTransactionInfo";
                      enrichedMerchantName?: string | null;
                      isSubscription?: boolean | null;
                      carbonFootprint?: string | null;
                      contactEmail?: string | null;
                      contactPhone?: string | null;
                      contactWebsite?: string | null;
                      logoUrl?: string | null;
                      category?: MerchantCategory | null;
                      subcategory?: MerchantSubCategory | null;
                      address?: string | null;
                      city?: string | null;
                      postalCode?: string | null;
                      country?: string | null;
                    } | null;
                    currencyExchange: Array<{
                      __typename: "ReportExchangeRate";
                      exchangeRate: number;
                    }>;
                    payment?: { __typename: "Payment"; id: string; createdAt: string } | null;
                    originTransaction?:
                      | {
                          __typename: "CardTransaction";
                          id: string;
                          type: TransactionTypeEnum;
                          executionDate: string;
                          amount: { __typename: "Amount"; currency: string; value: string };
                          statusInfo:
                            | {
                                __typename: "BookedTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "CanceledTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "DeferredTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "PendingTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "RejectedTransactionStatusInfo";
                                status: TransactionStatus;
                                reason: RejectedReasonCode;
                              }
                            | {
                                __typename: "ReleasedTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "SettledTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "UpcomingTransactionStatusInfo";
                                status: TransactionStatus;
                              };
                        }
                      | {
                          __typename: "CheckTransaction";
                          id: string;
                          type: TransactionTypeEnum;
                          executionDate: string;
                          amount: { __typename: "Amount"; currency: string; value: string };
                          statusInfo:
                            | {
                                __typename: "BookedTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "CanceledTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "DeferredTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "PendingTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "RejectedTransactionStatusInfo";
                                status: TransactionStatus;
                                reason: RejectedReasonCode;
                              }
                            | {
                                __typename: "ReleasedTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "SettledTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "UpcomingTransactionStatusInfo";
                                status: TransactionStatus;
                              };
                        }
                      | {
                          __typename: "FeeTransaction";
                          id: string;
                          type: TransactionTypeEnum;
                          executionDate: string;
                          amount: { __typename: "Amount"; currency: string; value: string };
                          statusInfo:
                            | {
                                __typename: "BookedTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "CanceledTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "DeferredTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "PendingTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "RejectedTransactionStatusInfo";
                                status: TransactionStatus;
                                reason: RejectedReasonCode;
                              }
                            | {
                                __typename: "ReleasedTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "SettledTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "UpcomingTransactionStatusInfo";
                                status: TransactionStatus;
                              };
                        }
                      | {
                          __typename: "InternalCreditTransfer";
                          id: string;
                          type: TransactionTypeEnum;
                          executionDate: string;
                          amount: { __typename: "Amount"; currency: string; value: string };
                          statusInfo:
                            | {
                                __typename: "BookedTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "CanceledTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "DeferredTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "PendingTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "RejectedTransactionStatusInfo";
                                status: TransactionStatus;
                                reason: RejectedReasonCode;
                              }
                            | {
                                __typename: "ReleasedTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "SettledTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "UpcomingTransactionStatusInfo";
                                status: TransactionStatus;
                              };
                        }
                      | {
                          __typename: "InternalDirectDebitTransaction";
                          id: string;
                          type: TransactionTypeEnum;
                          executionDate: string;
                          amount: { __typename: "Amount"; currency: string; value: string };
                          statusInfo:
                            | {
                                __typename: "BookedTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "CanceledTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "DeferredTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "PendingTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "RejectedTransactionStatusInfo";
                                status: TransactionStatus;
                                reason: RejectedReasonCode;
                              }
                            | {
                                __typename: "ReleasedTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "SettledTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "UpcomingTransactionStatusInfo";
                                status: TransactionStatus;
                              };
                        }
                      | {
                          __typename: "InternationalCreditTransferTransaction";
                          id: string;
                          type: TransactionTypeEnum;
                          executionDate: string;
                          amount: { __typename: "Amount"; currency: string; value: string };
                          statusInfo:
                            | {
                                __typename: "BookedTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "CanceledTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "DeferredTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "PendingTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "RejectedTransactionStatusInfo";
                                status: TransactionStatus;
                                reason: RejectedReasonCode;
                              }
                            | {
                                __typename: "ReleasedTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "SettledTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "UpcomingTransactionStatusInfo";
                                status: TransactionStatus;
                              };
                        }
                      | {
                          __typename: "SEPACreditTransferTransaction";
                          id: string;
                          type: TransactionTypeEnum;
                          executionDate: string;
                          amount: { __typename: "Amount"; currency: string; value: string };
                          statusInfo:
                            | {
                                __typename: "BookedTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "CanceledTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "DeferredTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "PendingTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "RejectedTransactionStatusInfo";
                                status: TransactionStatus;
                                reason: RejectedReasonCode;
                              }
                            | {
                                __typename: "ReleasedTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "SettledTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "UpcomingTransactionStatusInfo";
                                status: TransactionStatus;
                              };
                        }
                      | {
                          __typename: "SEPADirectDebitTransaction";
                          id: string;
                          type: TransactionTypeEnum;
                          executionDate: string;
                          amount: { __typename: "Amount"; currency: string; value: string };
                          statusInfo:
                            | {
                                __typename: "BookedTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "CanceledTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "DeferredTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "PendingTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "RejectedTransactionStatusInfo";
                                status: TransactionStatus;
                                reason: RejectedReasonCode;
                              }
                            | {
                                __typename: "ReleasedTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "SettledTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "UpcomingTransactionStatusInfo";
                                status: TransactionStatus;
                              };
                        }
                      | null;
                    statusInfo:
                      | {
                          __typename: "BookedTransactionStatusInfo";
                          bookingDate: string;
                          status: TransactionStatus;
                        }
                      | {
                          __typename: "CanceledTransactionStatusInfo";
                          canceledDate?: string | null;
                          status: TransactionStatus;
                        }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "PendingTransactionStatusInfo";
                          pendingEndDate?: string | null;
                          status: TransactionStatus;
                        }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          reason: RejectedReasonCode;
                          status: TransactionStatus;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "UpcomingTransactionStatusInfo";
                          executionDate: string;
                          status: TransactionStatus;
                        };
                    amount: { __typename: "Amount"; currency: string; value: string };
                  }
                | {
                    __typename: "CheckTransaction";
                    reservedAmountReleasedAt?: string | null;
                    cmc7: string;
                    rlmcKey: string;
                    id: string;
                    side: TransactionSide;
                    type: TransactionTypeEnum;
                    label: string;
                    counterparty: string;
                    reference: string;
                    externalReference?: string | null;
                    statementCanBeGenerated?: boolean | null;
                    createdAt: string;
                    executionDate: string;
                    updatedAt: string;
                    reservedAmount?: {
                      __typename: "Amount";
                      currency: string;
                      value: string;
                    } | null;
                    payment?: { __typename: "Payment"; id: string; createdAt: string } | null;
                    originTransaction?:
                      | {
                          __typename: "CardTransaction";
                          id: string;
                          type: TransactionTypeEnum;
                          executionDate: string;
                          amount: { __typename: "Amount"; currency: string; value: string };
                          statusInfo:
                            | {
                                __typename: "BookedTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "CanceledTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "DeferredTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "PendingTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "RejectedTransactionStatusInfo";
                                status: TransactionStatus;
                                reason: RejectedReasonCode;
                              }
                            | {
                                __typename: "ReleasedTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "SettledTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "UpcomingTransactionStatusInfo";
                                status: TransactionStatus;
                              };
                        }
                      | {
                          __typename: "CheckTransaction";
                          id: string;
                          type: TransactionTypeEnum;
                          executionDate: string;
                          amount: { __typename: "Amount"; currency: string; value: string };
                          statusInfo:
                            | {
                                __typename: "BookedTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "CanceledTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "DeferredTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "PendingTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "RejectedTransactionStatusInfo";
                                status: TransactionStatus;
                                reason: RejectedReasonCode;
                              }
                            | {
                                __typename: "ReleasedTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "SettledTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "UpcomingTransactionStatusInfo";
                                status: TransactionStatus;
                              };
                        }
                      | {
                          __typename: "FeeTransaction";
                          id: string;
                          type: TransactionTypeEnum;
                          executionDate: string;
                          amount: { __typename: "Amount"; currency: string; value: string };
                          statusInfo:
                            | {
                                __typename: "BookedTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "CanceledTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "DeferredTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "PendingTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "RejectedTransactionStatusInfo";
                                status: TransactionStatus;
                                reason: RejectedReasonCode;
                              }
                            | {
                                __typename: "ReleasedTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "SettledTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "UpcomingTransactionStatusInfo";
                                status: TransactionStatus;
                              };
                        }
                      | {
                          __typename: "InternalCreditTransfer";
                          id: string;
                          type: TransactionTypeEnum;
                          executionDate: string;
                          amount: { __typename: "Amount"; currency: string; value: string };
                          statusInfo:
                            | {
                                __typename: "BookedTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "CanceledTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "DeferredTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "PendingTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "RejectedTransactionStatusInfo";
                                status: TransactionStatus;
                                reason: RejectedReasonCode;
                              }
                            | {
                                __typename: "ReleasedTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "SettledTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "UpcomingTransactionStatusInfo";
                                status: TransactionStatus;
                              };
                        }
                      | {
                          __typename: "InternalDirectDebitTransaction";
                          id: string;
                          type: TransactionTypeEnum;
                          executionDate: string;
                          amount: { __typename: "Amount"; currency: string; value: string };
                          statusInfo:
                            | {
                                __typename: "BookedTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "CanceledTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "DeferredTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "PendingTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "RejectedTransactionStatusInfo";
                                status: TransactionStatus;
                                reason: RejectedReasonCode;
                              }
                            | {
                                __typename: "ReleasedTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "SettledTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "UpcomingTransactionStatusInfo";
                                status: TransactionStatus;
                              };
                        }
                      | {
                          __typename: "InternationalCreditTransferTransaction";
                          id: string;
                          type: TransactionTypeEnum;
                          executionDate: string;
                          amount: { __typename: "Amount"; currency: string; value: string };
                          statusInfo:
                            | {
                                __typename: "BookedTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "CanceledTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "DeferredTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "PendingTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "RejectedTransactionStatusInfo";
                                status: TransactionStatus;
                                reason: RejectedReasonCode;
                              }
                            | {
                                __typename: "ReleasedTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "SettledTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "UpcomingTransactionStatusInfo";
                                status: TransactionStatus;
                              };
                        }
                      | {
                          __typename: "SEPACreditTransferTransaction";
                          id: string;
                          type: TransactionTypeEnum;
                          executionDate: string;
                          amount: { __typename: "Amount"; currency: string; value: string };
                          statusInfo:
                            | {
                                __typename: "BookedTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "CanceledTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "DeferredTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "PendingTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "RejectedTransactionStatusInfo";
                                status: TransactionStatus;
                                reason: RejectedReasonCode;
                              }
                            | {
                                __typename: "ReleasedTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "SettledTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "UpcomingTransactionStatusInfo";
                                status: TransactionStatus;
                              };
                        }
                      | {
                          __typename: "SEPADirectDebitTransaction";
                          id: string;
                          type: TransactionTypeEnum;
                          executionDate: string;
                          amount: { __typename: "Amount"; currency: string; value: string };
                          statusInfo:
                            | {
                                __typename: "BookedTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "CanceledTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "DeferredTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "PendingTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "RejectedTransactionStatusInfo";
                                status: TransactionStatus;
                                reason: RejectedReasonCode;
                              }
                            | {
                                __typename: "ReleasedTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "SettledTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "UpcomingTransactionStatusInfo";
                                status: TransactionStatus;
                              };
                        }
                      | null;
                    statusInfo:
                      | {
                          __typename: "BookedTransactionStatusInfo";
                          bookingDate: string;
                          status: TransactionStatus;
                        }
                      | {
                          __typename: "CanceledTransactionStatusInfo";
                          canceledDate?: string | null;
                          status: TransactionStatus;
                        }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "PendingTransactionStatusInfo";
                          pendingEndDate?: string | null;
                          status: TransactionStatus;
                        }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          reason: RejectedReasonCode;
                          status: TransactionStatus;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "UpcomingTransactionStatusInfo";
                          executionDate: string;
                          status: TransactionStatus;
                        };
                    amount: { __typename: "Amount"; currency: string; value: string };
                  }
                | {
                    __typename: "FeeTransaction";
                    feesType: FeesTypeEnum;
                    id: string;
                    side: TransactionSide;
                    type: TransactionTypeEnum;
                    label: string;
                    counterparty: string;
                    reference: string;
                    externalReference?: string | null;
                    statementCanBeGenerated?: boolean | null;
                    createdAt: string;
                    executionDate: string;
                    updatedAt: string;
                    creditor:
                      | { __typename: "FeeInCreditor"; name: string }
                      | { __typename: "FeeOutCreditor"; name: string };
                    originTransaction?:
                      | {
                          __typename: "CardTransaction";
                          id: string;
                          label: string;
                          type: TransactionTypeEnum;
                          updatedAt: string;
                          executionDate: string;
                          createdAt: string;
                          statusInfo:
                            | {
                                __typename: "BookedTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "CanceledTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "DeferredTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "PendingTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "RejectedTransactionStatusInfo";
                                reason: RejectedReasonCode;
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "ReleasedTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "SettledTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "UpcomingTransactionStatusInfo";
                                status: TransactionStatus;
                              };
                          amount: { __typename: "Amount"; currency: string; value: string };
                        }
                      | {
                          __typename: "CheckTransaction";
                          id: string;
                          label: string;
                          type: TransactionTypeEnum;
                          updatedAt: string;
                          executionDate: string;
                          createdAt: string;
                          statusInfo:
                            | {
                                __typename: "BookedTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "CanceledTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "DeferredTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "PendingTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "RejectedTransactionStatusInfo";
                                reason: RejectedReasonCode;
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "ReleasedTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "SettledTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "UpcomingTransactionStatusInfo";
                                status: TransactionStatus;
                              };
                          amount: { __typename: "Amount"; currency: string; value: string };
                        }
                      | {
                          __typename: "FeeTransaction";
                          id: string;
                          label: string;
                          type: TransactionTypeEnum;
                          updatedAt: string;
                          executionDate: string;
                          createdAt: string;
                          statusInfo:
                            | {
                                __typename: "BookedTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "CanceledTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "DeferredTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "PendingTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "RejectedTransactionStatusInfo";
                                reason: RejectedReasonCode;
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "ReleasedTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "SettledTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "UpcomingTransactionStatusInfo";
                                status: TransactionStatus;
                              };
                          amount: { __typename: "Amount"; currency: string; value: string };
                        }
                      | {
                          __typename: "InternalCreditTransfer";
                          id: string;
                          label: string;
                          type: TransactionTypeEnum;
                          updatedAt: string;
                          executionDate: string;
                          createdAt: string;
                          statusInfo:
                            | {
                                __typename: "BookedTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "CanceledTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "DeferredTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "PendingTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "RejectedTransactionStatusInfo";
                                reason: RejectedReasonCode;
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "ReleasedTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "SettledTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "UpcomingTransactionStatusInfo";
                                status: TransactionStatus;
                              };
                          amount: { __typename: "Amount"; currency: string; value: string };
                        }
                      | {
                          __typename: "InternalDirectDebitTransaction";
                          id: string;
                          label: string;
                          type: TransactionTypeEnum;
                          updatedAt: string;
                          executionDate: string;
                          createdAt: string;
                          statusInfo:
                            | {
                                __typename: "BookedTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "CanceledTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "DeferredTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "PendingTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "RejectedTransactionStatusInfo";
                                reason: RejectedReasonCode;
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "ReleasedTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "SettledTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "UpcomingTransactionStatusInfo";
                                status: TransactionStatus;
                              };
                          amount: { __typename: "Amount"; currency: string; value: string };
                        }
                      | {
                          __typename: "InternationalCreditTransferTransaction";
                          id: string;
                          label: string;
                          type: TransactionTypeEnum;
                          updatedAt: string;
                          executionDate: string;
                          createdAt: string;
                          statusInfo:
                            | {
                                __typename: "BookedTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "CanceledTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "DeferredTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "PendingTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "RejectedTransactionStatusInfo";
                                reason: RejectedReasonCode;
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "ReleasedTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "SettledTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "UpcomingTransactionStatusInfo";
                                status: TransactionStatus;
                              };
                          amount: { __typename: "Amount"; currency: string; value: string };
                        }
                      | {
                          __typename: "SEPACreditTransferTransaction";
                          id: string;
                          label: string;
                          type: TransactionTypeEnum;
                          updatedAt: string;
                          executionDate: string;
                          createdAt: string;
                          statusInfo:
                            | {
                                __typename: "BookedTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "CanceledTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "DeferredTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "PendingTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "RejectedTransactionStatusInfo";
                                reason: RejectedReasonCode;
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "ReleasedTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "SettledTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "UpcomingTransactionStatusInfo";
                                status: TransactionStatus;
                              };
                          amount: { __typename: "Amount"; currency: string; value: string };
                        }
                      | {
                          __typename: "SEPADirectDebitTransaction";
                          id: string;
                          label: string;
                          type: TransactionTypeEnum;
                          updatedAt: string;
                          executionDate: string;
                          createdAt: string;
                          statusInfo:
                            | {
                                __typename: "BookedTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "CanceledTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "DeferredTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "PendingTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "RejectedTransactionStatusInfo";
                                reason: RejectedReasonCode;
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "ReleasedTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "SettledTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "UpcomingTransactionStatusInfo";
                                status: TransactionStatus;
                              };
                          amount: { __typename: "Amount"; currency: string; value: string };
                        }
                      | null;
                    payment?: { __typename: "Payment"; id: string; createdAt: string } | null;
                    statusInfo:
                      | {
                          __typename: "BookedTransactionStatusInfo";
                          bookingDate: string;
                          status: TransactionStatus;
                        }
                      | {
                          __typename: "CanceledTransactionStatusInfo";
                          canceledDate?: string | null;
                          status: TransactionStatus;
                        }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "PendingTransactionStatusInfo";
                          pendingEndDate?: string | null;
                          status: TransactionStatus;
                        }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          reason: RejectedReasonCode;
                          status: TransactionStatus;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "UpcomingTransactionStatusInfo";
                          executionDate: string;
                          status: TransactionStatus;
                        };
                    amount: { __typename: "Amount"; currency: string; value: string };
                  }
                | {
                    __typename: "InternalCreditTransfer";
                    id: string;
                    side: TransactionSide;
                    type: TransactionTypeEnum;
                    label: string;
                    counterparty: string;
                    reference: string;
                    externalReference?: string | null;
                    statementCanBeGenerated?: boolean | null;
                    createdAt: string;
                    executionDate: string;
                    updatedAt: string;
                    creditor:
                      | { __typename: "InternalCreditTransferInCreditor"; name: string }
                      | { __typename: "InternalCreditTransferOutCreditor"; name: string };
                    payment?: { __typename: "Payment"; id: string; createdAt: string } | null;
                    originTransaction?:
                      | {
                          __typename: "CardTransaction";
                          id: string;
                          type: TransactionTypeEnum;
                          executionDate: string;
                          amount: { __typename: "Amount"; currency: string; value: string };
                          statusInfo:
                            | {
                                __typename: "BookedTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "CanceledTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "DeferredTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "PendingTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "RejectedTransactionStatusInfo";
                                status: TransactionStatus;
                                reason: RejectedReasonCode;
                              }
                            | {
                                __typename: "ReleasedTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "SettledTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "UpcomingTransactionStatusInfo";
                                status: TransactionStatus;
                              };
                        }
                      | {
                          __typename: "CheckTransaction";
                          id: string;
                          type: TransactionTypeEnum;
                          executionDate: string;
                          amount: { __typename: "Amount"; currency: string; value: string };
                          statusInfo:
                            | {
                                __typename: "BookedTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "CanceledTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "DeferredTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "PendingTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "RejectedTransactionStatusInfo";
                                status: TransactionStatus;
                                reason: RejectedReasonCode;
                              }
                            | {
                                __typename: "ReleasedTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "SettledTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "UpcomingTransactionStatusInfo";
                                status: TransactionStatus;
                              };
                        }
                      | {
                          __typename: "FeeTransaction";
                          id: string;
                          type: TransactionTypeEnum;
                          executionDate: string;
                          amount: { __typename: "Amount"; currency: string; value: string };
                          statusInfo:
                            | {
                                __typename: "BookedTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "CanceledTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "DeferredTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "PendingTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "RejectedTransactionStatusInfo";
                                status: TransactionStatus;
                                reason: RejectedReasonCode;
                              }
                            | {
                                __typename: "ReleasedTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "SettledTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "UpcomingTransactionStatusInfo";
                                status: TransactionStatus;
                              };
                        }
                      | {
                          __typename: "InternalCreditTransfer";
                          id: string;
                          type: TransactionTypeEnum;
                          executionDate: string;
                          amount: { __typename: "Amount"; currency: string; value: string };
                          statusInfo:
                            | {
                                __typename: "BookedTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "CanceledTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "DeferredTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "PendingTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "RejectedTransactionStatusInfo";
                                status: TransactionStatus;
                                reason: RejectedReasonCode;
                              }
                            | {
                                __typename: "ReleasedTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "SettledTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "UpcomingTransactionStatusInfo";
                                status: TransactionStatus;
                              };
                        }
                      | {
                          __typename: "InternalDirectDebitTransaction";
                          id: string;
                          type: TransactionTypeEnum;
                          executionDate: string;
                          amount: { __typename: "Amount"; currency: string; value: string };
                          statusInfo:
                            | {
                                __typename: "BookedTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "CanceledTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "DeferredTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "PendingTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "RejectedTransactionStatusInfo";
                                status: TransactionStatus;
                                reason: RejectedReasonCode;
                              }
                            | {
                                __typename: "ReleasedTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "SettledTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "UpcomingTransactionStatusInfo";
                                status: TransactionStatus;
                              };
                        }
                      | {
                          __typename: "InternationalCreditTransferTransaction";
                          id: string;
                          type: TransactionTypeEnum;
                          executionDate: string;
                          amount: { __typename: "Amount"; currency: string; value: string };
                          statusInfo:
                            | {
                                __typename: "BookedTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "CanceledTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "DeferredTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "PendingTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "RejectedTransactionStatusInfo";
                                status: TransactionStatus;
                                reason: RejectedReasonCode;
                              }
                            | {
                                __typename: "ReleasedTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "SettledTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "UpcomingTransactionStatusInfo";
                                status: TransactionStatus;
                              };
                        }
                      | {
                          __typename: "SEPACreditTransferTransaction";
                          id: string;
                          type: TransactionTypeEnum;
                          executionDate: string;
                          amount: { __typename: "Amount"; currency: string; value: string };
                          statusInfo:
                            | {
                                __typename: "BookedTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "CanceledTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "DeferredTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "PendingTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "RejectedTransactionStatusInfo";
                                status: TransactionStatus;
                                reason: RejectedReasonCode;
                              }
                            | {
                                __typename: "ReleasedTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "SettledTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "UpcomingTransactionStatusInfo";
                                status: TransactionStatus;
                              };
                        }
                      | {
                          __typename: "SEPADirectDebitTransaction";
                          id: string;
                          type: TransactionTypeEnum;
                          executionDate: string;
                          amount: { __typename: "Amount"; currency: string; value: string };
                          statusInfo:
                            | {
                                __typename: "BookedTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "CanceledTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "DeferredTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "PendingTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "RejectedTransactionStatusInfo";
                                status: TransactionStatus;
                                reason: RejectedReasonCode;
                              }
                            | {
                                __typename: "ReleasedTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "SettledTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "UpcomingTransactionStatusInfo";
                                status: TransactionStatus;
                              };
                        }
                      | null;
                    statusInfo:
                      | {
                          __typename: "BookedTransactionStatusInfo";
                          bookingDate: string;
                          status: TransactionStatus;
                        }
                      | {
                          __typename: "CanceledTransactionStatusInfo";
                          canceledDate?: string | null;
                          status: TransactionStatus;
                        }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "PendingTransactionStatusInfo";
                          pendingEndDate?: string | null;
                          status: TransactionStatus;
                        }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          reason: RejectedReasonCode;
                          status: TransactionStatus;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "UpcomingTransactionStatusInfo";
                          executionDate: string;
                          status: TransactionStatus;
                        };
                    amount: { __typename: "Amount"; currency: string; value: string };
                  }
                | {
                    __typename: "InternalDirectDebitTransaction";
                    reservedAmountReleasedAt?: string | null;
                    id: string;
                    side: TransactionSide;
                    type: TransactionTypeEnum;
                    label: string;
                    counterparty: string;
                    reference: string;
                    externalReference?: string | null;
                    statementCanBeGenerated?: boolean | null;
                    createdAt: string;
                    executionDate: string;
                    updatedAt: string;
                    reservedAmount?: {
                      __typename: "Amount";
                      currency: string;
                      value: string;
                    } | null;
                    creditor: { __typename: "InternalDirectDebitCreditor"; accountId: string };
                    mandate?:
                      | { __typename: "InternalPaymentDirectDebitMandate"; id: string }
                      | { __typename: "InternalReceivedDirectDebitMandate"; id: string }
                      | null;
                    payment?: { __typename: "Payment"; id: string; createdAt: string } | null;
                    originTransaction?:
                      | {
                          __typename: "CardTransaction";
                          id: string;
                          type: TransactionTypeEnum;
                          executionDate: string;
                          amount: { __typename: "Amount"; currency: string; value: string };
                          statusInfo:
                            | {
                                __typename: "BookedTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "CanceledTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "DeferredTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "PendingTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "RejectedTransactionStatusInfo";
                                status: TransactionStatus;
                                reason: RejectedReasonCode;
                              }
                            | {
                                __typename: "ReleasedTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "SettledTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "UpcomingTransactionStatusInfo";
                                status: TransactionStatus;
                              };
                        }
                      | {
                          __typename: "CheckTransaction";
                          id: string;
                          type: TransactionTypeEnum;
                          executionDate: string;
                          amount: { __typename: "Amount"; currency: string; value: string };
                          statusInfo:
                            | {
                                __typename: "BookedTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "CanceledTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "DeferredTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "PendingTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "RejectedTransactionStatusInfo";
                                status: TransactionStatus;
                                reason: RejectedReasonCode;
                              }
                            | {
                                __typename: "ReleasedTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "SettledTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "UpcomingTransactionStatusInfo";
                                status: TransactionStatus;
                              };
                        }
                      | {
                          __typename: "FeeTransaction";
                          id: string;
                          type: TransactionTypeEnum;
                          executionDate: string;
                          amount: { __typename: "Amount"; currency: string; value: string };
                          statusInfo:
                            | {
                                __typename: "BookedTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "CanceledTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "DeferredTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "PendingTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "RejectedTransactionStatusInfo";
                                status: TransactionStatus;
                                reason: RejectedReasonCode;
                              }
                            | {
                                __typename: "ReleasedTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "SettledTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "UpcomingTransactionStatusInfo";
                                status: TransactionStatus;
                              };
                        }
                      | {
                          __typename: "InternalCreditTransfer";
                          id: string;
                          type: TransactionTypeEnum;
                          executionDate: string;
                          amount: { __typename: "Amount"; currency: string; value: string };
                          statusInfo:
                            | {
                                __typename: "BookedTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "CanceledTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "DeferredTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "PendingTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "RejectedTransactionStatusInfo";
                                status: TransactionStatus;
                                reason: RejectedReasonCode;
                              }
                            | {
                                __typename: "ReleasedTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "SettledTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "UpcomingTransactionStatusInfo";
                                status: TransactionStatus;
                              };
                        }
                      | {
                          __typename: "InternalDirectDebitTransaction";
                          id: string;
                          type: TransactionTypeEnum;
                          executionDate: string;
                          amount: { __typename: "Amount"; currency: string; value: string };
                          statusInfo:
                            | {
                                __typename: "BookedTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "CanceledTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "DeferredTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "PendingTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "RejectedTransactionStatusInfo";
                                status: TransactionStatus;
                                reason: RejectedReasonCode;
                              }
                            | {
                                __typename: "ReleasedTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "SettledTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "UpcomingTransactionStatusInfo";
                                status: TransactionStatus;
                              };
                        }
                      | {
                          __typename: "InternationalCreditTransferTransaction";
                          id: string;
                          type: TransactionTypeEnum;
                          executionDate: string;
                          amount: { __typename: "Amount"; currency: string; value: string };
                          statusInfo:
                            | {
                                __typename: "BookedTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "CanceledTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "DeferredTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "PendingTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "RejectedTransactionStatusInfo";
                                status: TransactionStatus;
                                reason: RejectedReasonCode;
                              }
                            | {
                                __typename: "ReleasedTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "SettledTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "UpcomingTransactionStatusInfo";
                                status: TransactionStatus;
                              };
                        }
                      | {
                          __typename: "SEPACreditTransferTransaction";
                          id: string;
                          type: TransactionTypeEnum;
                          executionDate: string;
                          amount: { __typename: "Amount"; currency: string; value: string };
                          statusInfo:
                            | {
                                __typename: "BookedTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "CanceledTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "DeferredTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "PendingTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "RejectedTransactionStatusInfo";
                                status: TransactionStatus;
                                reason: RejectedReasonCode;
                              }
                            | {
                                __typename: "ReleasedTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "SettledTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "UpcomingTransactionStatusInfo";
                                status: TransactionStatus;
                              };
                        }
                      | {
                          __typename: "SEPADirectDebitTransaction";
                          id: string;
                          type: TransactionTypeEnum;
                          executionDate: string;
                          amount: { __typename: "Amount"; currency: string; value: string };
                          statusInfo:
                            | {
                                __typename: "BookedTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "CanceledTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "DeferredTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "PendingTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "RejectedTransactionStatusInfo";
                                status: TransactionStatus;
                                reason: RejectedReasonCode;
                              }
                            | {
                                __typename: "ReleasedTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "SettledTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "UpcomingTransactionStatusInfo";
                                status: TransactionStatus;
                              };
                        }
                      | null;
                    statusInfo:
                      | {
                          __typename: "BookedTransactionStatusInfo";
                          bookingDate: string;
                          status: TransactionStatus;
                        }
                      | {
                          __typename: "CanceledTransactionStatusInfo";
                          canceledDate?: string | null;
                          status: TransactionStatus;
                        }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "PendingTransactionStatusInfo";
                          pendingEndDate?: string | null;
                          status: TransactionStatus;
                        }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          reason: RejectedReasonCode;
                          status: TransactionStatus;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "UpcomingTransactionStatusInfo";
                          executionDate: string;
                          status: TransactionStatus;
                        };
                    amount: { __typename: "Amount"; currency: string; value: string };
                  }
                | {
                    __typename: "InternationalCreditTransferTransaction";
                    reference: string;
                    paymentProduct: PaymentProduct;
                    id: string;
                    side: TransactionSide;
                    type: TransactionTypeEnum;
                    label: string;
                    counterparty: string;
                    externalReference?: string | null;
                    statementCanBeGenerated?: boolean | null;
                    createdAt: string;
                    executionDate: string;
                    updatedAt: string;
                    creditor:
                      | { __typename: "InternationalCreditTransferInCreditor"; name: string }
                      | { __typename: "InternationalCreditTransferInDebtor" }
                      | {
                          __typename: "InternationalCreditTransferOutCreditor";
                          name: string;
                          details: Array<{
                            __typename: "InternationalCreditTransferDetails";
                            key: string;
                            value: string;
                          }>;
                        };
                    statusInfo:
                      | {
                          __typename: "BookedTransactionStatusInfo";
                          bookingDate: string;
                          status: TransactionStatus;
                        }
                      | {
                          __typename: "CanceledTransactionStatusInfo";
                          canceledDate?: string | null;
                          status: TransactionStatus;
                        }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "PendingTransactionStatusInfo";
                          pendingEndDate?: string | null;
                          status: TransactionStatus;
                        }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          reason: RejectedReasonCode;
                          status: TransactionStatus;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "UpcomingTransactionStatusInfo";
                          executionDate: string;
                          status: TransactionStatus;
                        };
                    internationalCurrencyExchange: {
                      __typename: "InternationalCreditTransferCurrencyExchange";
                      exchangeRate: string;
                      sourceAmount?: {
                        __typename: "Amount";
                        currency: string;
                        value: string;
                      } | null;
                      targetAmount?: {
                        __typename: "Amount";
                        currency: string;
                        value: string;
                      } | null;
                    };
                    beneficiary?:
                      | {
                          __typename: "TrustedInternationalBeneficiary";
                          name: string;
                          currency: string;
                          route: InternationalCreditTransferRoute;
                          details: Array<{
                            __typename: "InternationalCreditTransferDetails";
                            key: string;
                            value: string;
                          }>;
                        }
                      | {
                          __typename: "UnsavedInternationalBeneficiary";
                          name: string;
                          currency: string;
                          route: InternationalCreditTransferRoute;
                          details: Array<{
                            __typename: "InternationalCreditTransferDetails";
                            key: string;
                            value: string;
                          }>;
                        }
                      | null;
                    payment?: { __typename: "Payment"; id: string; createdAt: string } | null;
                    originTransaction?:
                      | {
                          __typename: "CardTransaction";
                          id: string;
                          type: TransactionTypeEnum;
                          executionDate: string;
                          amount: { __typename: "Amount"; currency: string; value: string };
                          statusInfo:
                            | {
                                __typename: "BookedTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "CanceledTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "DeferredTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "PendingTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "RejectedTransactionStatusInfo";
                                status: TransactionStatus;
                                reason: RejectedReasonCode;
                              }
                            | {
                                __typename: "ReleasedTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "SettledTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "UpcomingTransactionStatusInfo";
                                status: TransactionStatus;
                              };
                        }
                      | {
                          __typename: "CheckTransaction";
                          id: string;
                          type: TransactionTypeEnum;
                          executionDate: string;
                          amount: { __typename: "Amount"; currency: string; value: string };
                          statusInfo:
                            | {
                                __typename: "BookedTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "CanceledTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "DeferredTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "PendingTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "RejectedTransactionStatusInfo";
                                status: TransactionStatus;
                                reason: RejectedReasonCode;
                              }
                            | {
                                __typename: "ReleasedTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "SettledTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "UpcomingTransactionStatusInfo";
                                status: TransactionStatus;
                              };
                        }
                      | {
                          __typename: "FeeTransaction";
                          id: string;
                          type: TransactionTypeEnum;
                          executionDate: string;
                          amount: { __typename: "Amount"; currency: string; value: string };
                          statusInfo:
                            | {
                                __typename: "BookedTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "CanceledTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "DeferredTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "PendingTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "RejectedTransactionStatusInfo";
                                status: TransactionStatus;
                                reason: RejectedReasonCode;
                              }
                            | {
                                __typename: "ReleasedTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "SettledTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "UpcomingTransactionStatusInfo";
                                status: TransactionStatus;
                              };
                        }
                      | {
                          __typename: "InternalCreditTransfer";
                          id: string;
                          type: TransactionTypeEnum;
                          executionDate: string;
                          amount: { __typename: "Amount"; currency: string; value: string };
                          statusInfo:
                            | {
                                __typename: "BookedTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "CanceledTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "DeferredTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "PendingTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "RejectedTransactionStatusInfo";
                                status: TransactionStatus;
                                reason: RejectedReasonCode;
                              }
                            | {
                                __typename: "ReleasedTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "SettledTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "UpcomingTransactionStatusInfo";
                                status: TransactionStatus;
                              };
                        }
                      | {
                          __typename: "InternalDirectDebitTransaction";
                          id: string;
                          type: TransactionTypeEnum;
                          executionDate: string;
                          amount: { __typename: "Amount"; currency: string; value: string };
                          statusInfo:
                            | {
                                __typename: "BookedTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "CanceledTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "DeferredTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "PendingTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "RejectedTransactionStatusInfo";
                                status: TransactionStatus;
                                reason: RejectedReasonCode;
                              }
                            | {
                                __typename: "ReleasedTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "SettledTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "UpcomingTransactionStatusInfo";
                                status: TransactionStatus;
                              };
                        }
                      | {
                          __typename: "InternationalCreditTransferTransaction";
                          id: string;
                          type: TransactionTypeEnum;
                          executionDate: string;
                          amount: { __typename: "Amount"; currency: string; value: string };
                          statusInfo:
                            | {
                                __typename: "BookedTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "CanceledTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "DeferredTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "PendingTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "RejectedTransactionStatusInfo";
                                status: TransactionStatus;
                                reason: RejectedReasonCode;
                              }
                            | {
                                __typename: "ReleasedTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "SettledTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "UpcomingTransactionStatusInfo";
                                status: TransactionStatus;
                              };
                        }
                      | {
                          __typename: "SEPACreditTransferTransaction";
                          id: string;
                          type: TransactionTypeEnum;
                          executionDate: string;
                          amount: { __typename: "Amount"; currency: string; value: string };
                          statusInfo:
                            | {
                                __typename: "BookedTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "CanceledTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "DeferredTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "PendingTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "RejectedTransactionStatusInfo";
                                status: TransactionStatus;
                                reason: RejectedReasonCode;
                              }
                            | {
                                __typename: "ReleasedTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "SettledTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "UpcomingTransactionStatusInfo";
                                status: TransactionStatus;
                              };
                        }
                      | {
                          __typename: "SEPADirectDebitTransaction";
                          id: string;
                          type: TransactionTypeEnum;
                          executionDate: string;
                          amount: { __typename: "Amount"; currency: string; value: string };
                          statusInfo:
                            | {
                                __typename: "BookedTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "CanceledTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "DeferredTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "PendingTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "RejectedTransactionStatusInfo";
                                status: TransactionStatus;
                                reason: RejectedReasonCode;
                              }
                            | {
                                __typename: "ReleasedTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "SettledTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "UpcomingTransactionStatusInfo";
                                status: TransactionStatus;
                              };
                        }
                      | null;
                    amount: { __typename: "Amount"; currency: string; value: string };
                  }
                | {
                    __typename: "SEPACreditTransferTransaction";
                    id: string;
                    side: TransactionSide;
                    type: TransactionTypeEnum;
                    label: string;
                    counterparty: string;
                    reference: string;
                    externalReference?: string | null;
                    statementCanBeGenerated?: boolean | null;
                    createdAt: string;
                    executionDate: string;
                    updatedAt: string;
                    creditor:
                      | {
                          __typename: "SEPACreditTransferInCreditor";
                          name: string;
                          IBAN?: string | null;
                        }
                      | {
                          __typename: "SEPACreditTransferInternalOutCreditor";
                          name: string;
                          IBAN?: string | null;
                        }
                      | {
                          __typename: "SEPACreditTransferOutCreditor";
                          name: string;
                          IBAN?: string | null;
                        };
                    debtor:
                      | {
                          __typename: "SEPACreditTransferInDebtor";
                          name: string;
                          IBAN?: string | null;
                        }
                      | {
                          __typename: "SEPACreditTransferInternalInDebtor";
                          name: string;
                          IBAN?: string | null;
                        }
                      | {
                          __typename: "SEPACreditTransferOutDebtor";
                          name: string;
                          IBAN?: string | null;
                        };
                    beneficiary?:
                      | {
                          __typename: "TrustedSepaBeneficiary";
                          iban: string;
                          id: string;
                          label: string;
                          name: string;
                          type: BeneficiaryType;
                          createdAt: string;
                          address?: {
                            __typename: "Address";
                            addressLine1?: string | null;
                            addressLine2?: string | null;
                            city?: string | null;
                            country?: string | null;
                            postalCode?: string | null;
                            state?: string | null;
                          } | null;
                          statusInfo:
                            | {
                                __typename: "TrustedBeneficiaryCanceledStatusInfo";
                                status: TrustedBeneficiaryStatus;
                              }
                            | {
                                __typename: "TrustedBeneficiaryConsentPendingStatusInfo";
                                status: TrustedBeneficiaryStatus;
                              }
                            | {
                                __typename: "TrustedBeneficiaryEnabledStatusInfo";
                                status: TrustedBeneficiaryStatus;
                              };
                        }
                      | {
                          __typename: "UnsavedSepaBeneficiary";
                          name: string;
                          iban: string;
                          address?: {
                            __typename: "Address";
                            addressLine1?: string | null;
                            addressLine2?: string | null;
                            city?: string | null;
                            country?: string | null;
                            postalCode?: string | null;
                            state?: string | null;
                          } | null;
                        }
                      | null;
                    payment?: { __typename: "Payment"; id: string; createdAt: string } | null;
                    originTransaction?:
                      | {
                          __typename: "CardTransaction";
                          id: string;
                          type: TransactionTypeEnum;
                          executionDate: string;
                          amount: { __typename: "Amount"; currency: string; value: string };
                          statusInfo:
                            | {
                                __typename: "BookedTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "CanceledTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "DeferredTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "PendingTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "RejectedTransactionStatusInfo";
                                status: TransactionStatus;
                                reason: RejectedReasonCode;
                              }
                            | {
                                __typename: "ReleasedTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "SettledTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "UpcomingTransactionStatusInfo";
                                status: TransactionStatus;
                              };
                        }
                      | {
                          __typename: "CheckTransaction";
                          id: string;
                          type: TransactionTypeEnum;
                          executionDate: string;
                          amount: { __typename: "Amount"; currency: string; value: string };
                          statusInfo:
                            | {
                                __typename: "BookedTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "CanceledTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "DeferredTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "PendingTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "RejectedTransactionStatusInfo";
                                status: TransactionStatus;
                                reason: RejectedReasonCode;
                              }
                            | {
                                __typename: "ReleasedTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "SettledTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "UpcomingTransactionStatusInfo";
                                status: TransactionStatus;
                              };
                        }
                      | {
                          __typename: "FeeTransaction";
                          id: string;
                          type: TransactionTypeEnum;
                          executionDate: string;
                          amount: { __typename: "Amount"; currency: string; value: string };
                          statusInfo:
                            | {
                                __typename: "BookedTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "CanceledTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "DeferredTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "PendingTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "RejectedTransactionStatusInfo";
                                status: TransactionStatus;
                                reason: RejectedReasonCode;
                              }
                            | {
                                __typename: "ReleasedTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "SettledTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "UpcomingTransactionStatusInfo";
                                status: TransactionStatus;
                              };
                        }
                      | {
                          __typename: "InternalCreditTransfer";
                          id: string;
                          type: TransactionTypeEnum;
                          executionDate: string;
                          amount: { __typename: "Amount"; currency: string; value: string };
                          statusInfo:
                            | {
                                __typename: "BookedTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "CanceledTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "DeferredTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "PendingTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "RejectedTransactionStatusInfo";
                                status: TransactionStatus;
                                reason: RejectedReasonCode;
                              }
                            | {
                                __typename: "ReleasedTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "SettledTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "UpcomingTransactionStatusInfo";
                                status: TransactionStatus;
                              };
                        }
                      | {
                          __typename: "InternalDirectDebitTransaction";
                          id: string;
                          type: TransactionTypeEnum;
                          executionDate: string;
                          amount: { __typename: "Amount"; currency: string; value: string };
                          statusInfo:
                            | {
                                __typename: "BookedTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "CanceledTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "DeferredTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "PendingTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "RejectedTransactionStatusInfo";
                                status: TransactionStatus;
                                reason: RejectedReasonCode;
                              }
                            | {
                                __typename: "ReleasedTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "SettledTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "UpcomingTransactionStatusInfo";
                                status: TransactionStatus;
                              };
                        }
                      | {
                          __typename: "InternationalCreditTransferTransaction";
                          id: string;
                          type: TransactionTypeEnum;
                          executionDate: string;
                          amount: { __typename: "Amount"; currency: string; value: string };
                          statusInfo:
                            | {
                                __typename: "BookedTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "CanceledTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "DeferredTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "PendingTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "RejectedTransactionStatusInfo";
                                status: TransactionStatus;
                                reason: RejectedReasonCode;
                              }
                            | {
                                __typename: "ReleasedTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "SettledTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "UpcomingTransactionStatusInfo";
                                status: TransactionStatus;
                              };
                        }
                      | {
                          __typename: "SEPACreditTransferTransaction";
                          id: string;
                          type: TransactionTypeEnum;
                          executionDate: string;
                          amount: { __typename: "Amount"; currency: string; value: string };
                          statusInfo:
                            | {
                                __typename: "BookedTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "CanceledTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "DeferredTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "PendingTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "RejectedTransactionStatusInfo";
                                status: TransactionStatus;
                                reason: RejectedReasonCode;
                              }
                            | {
                                __typename: "ReleasedTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "SettledTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "UpcomingTransactionStatusInfo";
                                status: TransactionStatus;
                              };
                        }
                      | {
                          __typename: "SEPADirectDebitTransaction";
                          id: string;
                          type: TransactionTypeEnum;
                          executionDate: string;
                          amount: { __typename: "Amount"; currency: string; value: string };
                          statusInfo:
                            | {
                                __typename: "BookedTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "CanceledTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "DeferredTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "PendingTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "RejectedTransactionStatusInfo";
                                status: TransactionStatus;
                                reason: RejectedReasonCode;
                              }
                            | {
                                __typename: "ReleasedTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "SettledTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "UpcomingTransactionStatusInfo";
                                status: TransactionStatus;
                              };
                        }
                      | null;
                    statusInfo:
                      | {
                          __typename: "BookedTransactionStatusInfo";
                          bookingDate: string;
                          status: TransactionStatus;
                        }
                      | {
                          __typename: "CanceledTransactionStatusInfo";
                          canceledDate?: string | null;
                          status: TransactionStatus;
                        }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "PendingTransactionStatusInfo";
                          pendingEndDate?: string | null;
                          status: TransactionStatus;
                        }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          reason: RejectedReasonCode;
                          status: TransactionStatus;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "UpcomingTransactionStatusInfo";
                          executionDate: string;
                          status: TransactionStatus;
                        };
                    amount: { __typename: "Amount"; currency: string; value: string };
                  }
                | {
                    __typename: "SEPADirectDebitTransaction";
                    reservedAmountReleasedAt?: string | null;
                    id: string;
                    side: TransactionSide;
                    type: TransactionTypeEnum;
                    label: string;
                    counterparty: string;
                    reference: string;
                    externalReference?: string | null;
                    statementCanBeGenerated?: boolean | null;
                    createdAt: string;
                    executionDate: string;
                    updatedAt: string;
                    creditor:
                      | {
                          __typename: "SEPADirectDebitInCreditor";
                          name: string;
                          IBAN?: string | null;
                        }
                      | {
                          __typename: "SEPADirectDebitOutCreditor";
                          name: string;
                          IBAN?: string | null;
                        };
                    debtor:
                      | {
                          __typename: "SEPADirectDebitInDebtor";
                          name: string;
                          IBAN?: string | null;
                        }
                      | {
                          __typename: "SEPADirectDebitOutDebtor";
                          name: string;
                          IBAN?: string | null;
                        };
                    reservedAmount?: {
                      __typename: "Amount";
                      value: string;
                      currency: string;
                    } | null;
                    mandate?:
                      | {
                          __typename: "SEPAPaymentDirectDebitMandate";
                          id: string;
                          debtor: { __typename: "SEPAPaymentMandateDebtor"; name: string };
                        }
                      | {
                          __typename: "SEPAReceivedDirectDebitMandate";
                          ultimateCreditorName?: string | null;
                          id: string;
                        }
                      | null;
                    payment?: { __typename: "Payment"; id: string; createdAt: string } | null;
                    originTransaction?:
                      | {
                          __typename: "CardTransaction";
                          id: string;
                          type: TransactionTypeEnum;
                          executionDate: string;
                          amount: { __typename: "Amount"; currency: string; value: string };
                          statusInfo:
                            | {
                                __typename: "BookedTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "CanceledTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "DeferredTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "PendingTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "RejectedTransactionStatusInfo";
                                status: TransactionStatus;
                                reason: RejectedReasonCode;
                              }
                            | {
                                __typename: "ReleasedTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "SettledTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "UpcomingTransactionStatusInfo";
                                status: TransactionStatus;
                              };
                        }
                      | {
                          __typename: "CheckTransaction";
                          id: string;
                          type: TransactionTypeEnum;
                          executionDate: string;
                          amount: { __typename: "Amount"; currency: string; value: string };
                          statusInfo:
                            | {
                                __typename: "BookedTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "CanceledTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "DeferredTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "PendingTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "RejectedTransactionStatusInfo";
                                status: TransactionStatus;
                                reason: RejectedReasonCode;
                              }
                            | {
                                __typename: "ReleasedTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "SettledTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "UpcomingTransactionStatusInfo";
                                status: TransactionStatus;
                              };
                        }
                      | {
                          __typename: "FeeTransaction";
                          id: string;
                          type: TransactionTypeEnum;
                          executionDate: string;
                          amount: { __typename: "Amount"; currency: string; value: string };
                          statusInfo:
                            | {
                                __typename: "BookedTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "CanceledTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "DeferredTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "PendingTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "RejectedTransactionStatusInfo";
                                status: TransactionStatus;
                                reason: RejectedReasonCode;
                              }
                            | {
                                __typename: "ReleasedTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "SettledTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "UpcomingTransactionStatusInfo";
                                status: TransactionStatus;
                              };
                        }
                      | {
                          __typename: "InternalCreditTransfer";
                          id: string;
                          type: TransactionTypeEnum;
                          executionDate: string;
                          amount: { __typename: "Amount"; currency: string; value: string };
                          statusInfo:
                            | {
                                __typename: "BookedTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "CanceledTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "DeferredTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "PendingTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "RejectedTransactionStatusInfo";
                                status: TransactionStatus;
                                reason: RejectedReasonCode;
                              }
                            | {
                                __typename: "ReleasedTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "SettledTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "UpcomingTransactionStatusInfo";
                                status: TransactionStatus;
                              };
                        }
                      | {
                          __typename: "InternalDirectDebitTransaction";
                          id: string;
                          type: TransactionTypeEnum;
                          executionDate: string;
                          amount: { __typename: "Amount"; currency: string; value: string };
                          statusInfo:
                            | {
                                __typename: "BookedTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "CanceledTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "DeferredTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "PendingTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "RejectedTransactionStatusInfo";
                                status: TransactionStatus;
                                reason: RejectedReasonCode;
                              }
                            | {
                                __typename: "ReleasedTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "SettledTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "UpcomingTransactionStatusInfo";
                                status: TransactionStatus;
                              };
                        }
                      | {
                          __typename: "InternationalCreditTransferTransaction";
                          id: string;
                          type: TransactionTypeEnum;
                          executionDate: string;
                          amount: { __typename: "Amount"; currency: string; value: string };
                          statusInfo:
                            | {
                                __typename: "BookedTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "CanceledTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "DeferredTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "PendingTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "RejectedTransactionStatusInfo";
                                status: TransactionStatus;
                                reason: RejectedReasonCode;
                              }
                            | {
                                __typename: "ReleasedTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "SettledTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "UpcomingTransactionStatusInfo";
                                status: TransactionStatus;
                              };
                        }
                      | {
                          __typename: "SEPACreditTransferTransaction";
                          id: string;
                          type: TransactionTypeEnum;
                          executionDate: string;
                          amount: { __typename: "Amount"; currency: string; value: string };
                          statusInfo:
                            | {
                                __typename: "BookedTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "CanceledTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "DeferredTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "PendingTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "RejectedTransactionStatusInfo";
                                status: TransactionStatus;
                                reason: RejectedReasonCode;
                              }
                            | {
                                __typename: "ReleasedTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "SettledTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "UpcomingTransactionStatusInfo";
                                status: TransactionStatus;
                              };
                        }
                      | {
                          __typename: "SEPADirectDebitTransaction";
                          id: string;
                          type: TransactionTypeEnum;
                          executionDate: string;
                          amount: { __typename: "Amount"; currency: string; value: string };
                          statusInfo:
                            | {
                                __typename: "BookedTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "CanceledTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "DeferredTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "PendingTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "RejectedTransactionStatusInfo";
                                status: TransactionStatus;
                                reason: RejectedReasonCode;
                              }
                            | {
                                __typename: "ReleasedTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "SettledTransactionStatusInfo";
                                status: TransactionStatus;
                              }
                            | {
                                __typename: "UpcomingTransactionStatusInfo";
                                status: TransactionStatus;
                              };
                        }
                      | null;
                    statusInfo:
                      | {
                          __typename: "BookedTransactionStatusInfo";
                          bookingDate: string;
                          status: TransactionStatus;
                        }
                      | {
                          __typename: "CanceledTransactionStatusInfo";
                          canceledDate?: string | null;
                          status: TransactionStatus;
                        }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "PendingTransactionStatusInfo";
                          pendingEndDate?: string | null;
                          status: TransactionStatus;
                        }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          reason: RejectedReasonCode;
                          status: TransactionStatus;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "UpcomingTransactionStatusInfo";
                          executionDate: string;
                          status: TransactionStatus;
                        };
                    amount: { __typename: "Amount"; currency: string; value: string };
                  };
            }>;
          } | null;
        };
      }>;
    };
  } | null;
};

export type GetStandingOrdersQueryVariables = Exact<{
  accountId: Scalars["ID"]["input"];
  status?: InputMaybe<Array<StandingOrderStatus> | StandingOrderStatus>;
  first: Scalars["Int"]["input"];
  after?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type GetStandingOrdersQuery = {
  __typename: "Query";
  account?: {
    __typename: "Account";
    id: string;
    standingOrders: {
      __typename: "StandingOrderConnection";
      pageInfo: { __typename: "PageInfo"; endCursor?: string | null; hasNextPage?: boolean | null };
      edges: Array<{
        __typename: "StandingOrderEdge";
        cursor: string;
        node: {
          __typename: "StandingOrder";
          id: string;
          label?: string | null;
          period: StandingOrderPeriod;
          reference?: string | null;
          lastExecutionDate?: string | null;
          firstExecutionDate?: string | null;
          nextExecutionDate?: string | null;
          statusInfo:
            | { __typename: "StandingOrderCanceledStatusInfo"; status: StandingOrderStatus }
            | { __typename: "StandingOrderConsentPendingStatusInfo"; status: StandingOrderStatus }
            | { __typename: "StandingOrderEnabledStatusInfo"; status: StandingOrderStatus };
          sepaBeneficiary: { __typename: "SEPABeneficiary"; name: string };
          targetAvailableBalance?: { __typename: "Amount"; currency: string; value: string } | null;
          amount?: { __typename: "Amount"; currency: string; value: string } | null;
          createdBy: {
            __typename: "User";
            id: string;
            firstName?: string | null;
            preferredLastName?: string | null;
            fullName?: string | null;
          };
        };
      }>;
    };
  } | null;
};

export type AccountMembershipFragment = {
  __typename: "AccountMembership";
  id: string;
  accountId: string;
  accountCountry: AccountCountry;
  createdAt: string;
  updatedAt: string;
  email: string;
  legalRepresentative: boolean;
  hasRequiredIdentificationLevel?: boolean | null;
  language?: AccountLanguage | null;
  taxIdentificationNumber?: string | null;
  canInitiatePayments: boolean;
  canManageCards: boolean;
  canManageAccountMembership: boolean;
  canManageBeneficiaries: boolean;
  canViewAccount: boolean;
  statusInfo:
    | {
        __typename: "AccountMembershipBindingUserErrorStatusInfo";
        emailVerifiedMatchError: boolean;
        idVerifiedMatchError: boolean;
        status: AccountMembershipStatus;
        restrictedTo: {
          __typename: "RestrictedTo";
          birthDate?: string | null;
          firstName: string;
          lastName: string;
          phoneNumber?: string | null;
        };
      }
    | { __typename: "AccountMembershipConsentPendingStatusInfo"; status: AccountMembershipStatus }
    | { __typename: "AccountMembershipDisabledStatusInfo"; status: AccountMembershipStatus }
    | { __typename: "AccountMembershipEnabledStatusInfo"; status: AccountMembershipStatus }
    | {
        __typename: "AccountMembershipInvitationSentStatusInfo";
        status: AccountMembershipStatus;
        restrictedTo: {
          __typename: "RestrictedTo";
          birthDate?: string | null;
          firstName: string;
          lastName: string;
          phoneNumber?: string | null;
        };
      }
    | { __typename: "AccountMembershipSuspendedStatusInfo"; status: AccountMembershipStatus };
  residencyAddress?: {
    __typename: "AddressInfo";
    addressLine1?: string | null;
    postalCode?: string | null;
    city?: string | null;
    country?: string | null;
  } | null;
  user?: {
    __typename: "User";
    id: string;
    birthDate?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    birthLastName?: string | null;
    preferredLastName?: string | null;
    fullName?: string | null;
    mobilePhoneNumber?: string | null;
    verifiedEmails: Array<string>;
  } | null;
  account?: {
    __typename: "Account";
    id: string;
    name: string;
    country: AccountCountry;
    holder: {
      __typename: "AccountHolder";
      id: string;
      info:
        | { __typename: "AccountHolderCompanyInfo"; name: string; type: AccountHolderType }
        | { __typename: "AccountHolderIndividualInfo"; name: string; type: AccountHolderType };
    };
  } | null;
  activeCards: { __typename: "CardConnection"; totalCount: number };
};

export type MembershipDetailQueryVariables = Exact<{
  accountMembershipId: Scalars["ID"]["input"];
}>;

export type MembershipDetailQuery = {
  __typename: "Query";
  projectInfo: {
    __typename: "ProjectInfo";
    id: string;
    B2BMembershipIDVerification?: boolean | null;
  };
  accountMembership?: {
    __typename: "AccountMembership";
    id: string;
    accountId: string;
    accountCountry: AccountCountry;
    createdAt: string;
    updatedAt: string;
    email: string;
    legalRepresentative: boolean;
    hasRequiredIdentificationLevel?: boolean | null;
    language?: AccountLanguage | null;
    taxIdentificationNumber?: string | null;
    canInitiatePayments: boolean;
    canManageCards: boolean;
    canManageAccountMembership: boolean;
    canManageBeneficiaries: boolean;
    canViewAccount: boolean;
    statusInfo:
      | {
          __typename: "AccountMembershipBindingUserErrorStatusInfo";
          emailVerifiedMatchError: boolean;
          idVerifiedMatchError: boolean;
          status: AccountMembershipStatus;
          restrictedTo: {
            __typename: "RestrictedTo";
            birthDate?: string | null;
            firstName: string;
            lastName: string;
            phoneNumber?: string | null;
          };
        }
      | { __typename: "AccountMembershipConsentPendingStatusInfo"; status: AccountMembershipStatus }
      | { __typename: "AccountMembershipDisabledStatusInfo"; status: AccountMembershipStatus }
      | { __typename: "AccountMembershipEnabledStatusInfo"; status: AccountMembershipStatus }
      | {
          __typename: "AccountMembershipInvitationSentStatusInfo";
          status: AccountMembershipStatus;
          restrictedTo: {
            __typename: "RestrictedTo";
            birthDate?: string | null;
            firstName: string;
            lastName: string;
            phoneNumber?: string | null;
          };
        }
      | { __typename: "AccountMembershipSuspendedStatusInfo"; status: AccountMembershipStatus };
    residencyAddress?: {
      __typename: "AddressInfo";
      addressLine1?: string | null;
      postalCode?: string | null;
      city?: string | null;
      country?: string | null;
    } | null;
    user?: {
      __typename: "User";
      id: string;
      birthDate?: string | null;
      firstName?: string | null;
      lastName?: string | null;
      birthLastName?: string | null;
      preferredLastName?: string | null;
      fullName?: string | null;
      mobilePhoneNumber?: string | null;
      verifiedEmails: Array<string>;
    } | null;
    account?: {
      __typename: "Account";
      id: string;
      name: string;
      country: AccountCountry;
      holder: {
        __typename: "AccountHolder";
        id: string;
        info:
          | { __typename: "AccountHolderCompanyInfo"; name: string; type: AccountHolderType }
          | { __typename: "AccountHolderIndividualInfo"; name: string; type: AccountHolderType };
      };
    } | null;
    activeCards: { __typename: "CardConnection"; totalCount: number };
  } | null;
};

export type MembersPageQueryVariables = Exact<{
  accountId: Scalars["ID"]["input"];
  first: Scalars["Int"]["input"];
  after?: InputMaybe<Scalars["String"]["input"]>;
  status?: InputMaybe<Array<AccountMembershipStatus> | AccountMembershipStatus>;
  canManageAccountMembership?: InputMaybe<Scalars["Boolean"]["input"]>;
  canManageBeneficiaries?: InputMaybe<Scalars["Boolean"]["input"]>;
  canViewAccount?: InputMaybe<Scalars["Boolean"]["input"]>;
  canManageCards?: InputMaybe<Scalars["Boolean"]["input"]>;
  canInitiatePayments?: InputMaybe<Scalars["Boolean"]["input"]>;
  search?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type MembersPageQuery = {
  __typename: "Query";
  accountMemberships: {
    __typename: "AccountMembershipConnection";
    totalCount: number;
    pageInfo: { __typename: "PageInfo"; endCursor?: string | null; hasNextPage?: boolean | null };
    edges: Array<{
      __typename: "AccountMembershipEdge";
      cursor: string;
      node: {
        __typename: "AccountMembership";
        id: string;
        accountId: string;
        accountCountry: AccountCountry;
        createdAt: string;
        updatedAt: string;
        email: string;
        legalRepresentative: boolean;
        hasRequiredIdentificationLevel?: boolean | null;
        language?: AccountLanguage | null;
        taxIdentificationNumber?: string | null;
        canInitiatePayments: boolean;
        canManageCards: boolean;
        canManageAccountMembership: boolean;
        canManageBeneficiaries: boolean;
        canViewAccount: boolean;
        statusInfo:
          | {
              __typename: "AccountMembershipBindingUserErrorStatusInfo";
              emailVerifiedMatchError: boolean;
              idVerifiedMatchError: boolean;
              status: AccountMembershipStatus;
              restrictedTo: {
                __typename: "RestrictedTo";
                birthDate?: string | null;
                firstName: string;
                lastName: string;
                phoneNumber?: string | null;
              };
            }
          | {
              __typename: "AccountMembershipConsentPendingStatusInfo";
              status: AccountMembershipStatus;
            }
          | { __typename: "AccountMembershipDisabledStatusInfo"; status: AccountMembershipStatus }
          | { __typename: "AccountMembershipEnabledStatusInfo"; status: AccountMembershipStatus }
          | {
              __typename: "AccountMembershipInvitationSentStatusInfo";
              status: AccountMembershipStatus;
              restrictedTo: {
                __typename: "RestrictedTo";
                birthDate?: string | null;
                firstName: string;
                lastName: string;
                phoneNumber?: string | null;
              };
            }
          | { __typename: "AccountMembershipSuspendedStatusInfo"; status: AccountMembershipStatus };
        residencyAddress?: {
          __typename: "AddressInfo";
          addressLine1?: string | null;
          postalCode?: string | null;
          city?: string | null;
          country?: string | null;
        } | null;
        user?: {
          __typename: "User";
          id: string;
          birthDate?: string | null;
          firstName?: string | null;
          lastName?: string | null;
          birthLastName?: string | null;
          preferredLastName?: string | null;
          fullName?: string | null;
          mobilePhoneNumber?: string | null;
          verifiedEmails: Array<string>;
        } | null;
        account?: {
          __typename: "Account";
          id: string;
          name: string;
          country: AccountCountry;
          holder: {
            __typename: "AccountHolder";
            id: string;
            info:
              | { __typename: "AccountHolderCompanyInfo"; name: string; type: AccountHolderType }
              | {
                  __typename: "AccountHolderIndividualInfo";
                  name: string;
                  type: AccountHolderType;
                };
          };
        } | null;
        activeCards: { __typename: "CardConnection"; totalCount: number };
      };
    }>;
  };
  account?: {
    __typename: "Account";
    id: string;
    number: string;
    name: string;
    statusInfo:
      | { __typename: "AccountClosedStatus"; status: AccountStatus }
      | { __typename: "AccountClosingStatus"; status: AccountStatus }
      | { __typename: "AccountOpenedStatus"; status: AccountStatus }
      | { __typename: "AccountSuspendedStatus"; status: AccountStatus };
    holder: {
      __typename: "AccountHolder";
      id: string;
      info:
        | { __typename: "AccountHolderCompanyInfo"; name: string }
        | { __typename: "AccountHolderIndividualInfo"; name: string };
    };
  } | null;
};

export type ProfilePageQueryVariables = Exact<{ [key: string]: never }>;

export type ProfilePageQuery = {
  __typename: "Query";
  projectInfo: {
    __typename: "ProjectInfo";
    id: string;
    B2BMembershipIDVerification?: boolean | null;
  };
  user?: {
    __typename: "User";
    id: string;
    firstName?: string | null;
    preferredLastName?: string | null;
    fullName?: string | null;
    mobilePhoneNumber?: string | null;
    birthDate?: string | null;
  } | null;
};

export type AccountActivationPageQueryVariables = Exact<{
  accountMembershipId: Scalars["ID"]["input"];
}>;

export type AccountActivationPageQuery = {
  __typename: "Query";
  accountMembership?: {
    __typename: "AccountMembership";
    id: string;
    account?: {
      __typename: "Account";
      id: string;
      IBAN?: string | null;
      BIC: string;
      paymentLevel: PaymentLevel;
      paymentAccountType: PaymentAccountType;
      holder: {
        __typename: "AccountHolder";
        id: string;
        verificationStatus: VerificationStatus;
        verificationStatusInfo:
          | { __typename: "AccountHolderNotStartedVerificationStatusInfo" }
          | { __typename: "AccountHolderPendingVerificationStatusInfo" }
          | { __typename: "AccountHolderRefusedVerificationStatusInfo" }
          | { __typename: "AccountHolderVerifiedVerificationStatusInfo" }
          | {
              __typename: "AccountHolderWaitingForInformationVerificationStatusInfo";
              waitingForInformationAt: string;
              verificationRequirements: Array<{
                __typename: "VerificationRequirement";
                id: string;
                type: VerificationRequirementType;
              }>;
            };
        info:
          | { __typename: "AccountHolderCompanyInfo"; name: string }
          | { __typename: "AccountHolderIndividualInfo"; name: string };
        residencyAddress: { __typename: "AddressInfo"; country?: string | null };
        supportingDocumentCollections: {
          __typename: "SupportingDocumentCollectionConnection";
          edges: Array<{
            __typename: "SupportingDocumentCollectionEdge";
            node: {
              __typename: "SupportingDocumentCollection";
              id: string;
              requiredSupportingDocumentPurposes: Array<{
                __typename: "SupportingDocumentPurpose";
                name: SupportingDocumentPurposeEnum;
              }>;
              statusInfo:
                | {
                    __typename: "SupportingDocumentCollectionApprovedStatusInfo";
                    status: SupportingDocumentCollectionStatus;
                  }
                | {
                    __typename: "SupportingDocumentCollectionCanceledStatusInfo";
                    status: SupportingDocumentCollectionStatus;
                  }
                | {
                    __typename: "SupportingDocumentCollectionPendingReviewStatusInfo";
                    status: SupportingDocumentCollectionStatus;
                  }
                | {
                    __typename: "SupportingDocumentCollectionRejectedStatusInfo";
                    status: SupportingDocumentCollectionStatus;
                  }
                | {
                    __typename: "SupportingDocumentCollectionWaitingForDocumentStatusInfo";
                    status: SupportingDocumentCollectionStatus;
                  };
              supportingDocuments: Array<{
                __typename: "SupportingDocument";
                id: string;
                supportingDocumentPurpose: SupportingDocumentPurposeEnum;
                statusInfo:
                  | { __typename: "SupportingDocumentNotUploadedStatusInfo" }
                  | {
                      __typename: "SupportingDocumentRefusedStatusInfo";
                      filename: string;
                      reason: string;
                      reasonCode: SupportingDocumentReasonCode;
                    }
                  | { __typename: "SupportingDocumentUploadedStatusInfo"; filename: string }
                  | { __typename: "SupportingDocumentValidatedStatusInfo"; filename: string }
                  | { __typename: "SupportingDocumentWaitingForUploadStatusInfo" };
              }>;
            };
          }>;
        };
      };
      legalRepresentativeMembership: { __typename: "AccountMembership"; id: string; email: string };
      transactions?: { __typename: "TransactionConnection"; totalCount: number } | null;
    } | null;
    user?: {
      __typename: "User";
      id: string;
      firstName?: string | null;
      preferredLastName?: string | null;
      fullName?: string | null;
      birthDate?: string | null;
      mobilePhoneNumber?: string | null;
      lastIdentification?: {
        __typename: "IdentificationConnection";
        edges: Array<{
          __typename: "IdentificationEdge";
          node: {
            __typename: "Identification";
            id: string;
            process: IdentificationProcess;
            levels: {
              __typename: "IdentificationLevelStatusesInfo";
              expert:
                | {
                    __typename: "CanceledIdentificationLevelStatusInfo";
                    status: SwanIdentificationStatus;
                  }
                | {
                    __typename: "ExpiredIdentificationLevelStatusInfo";
                    status: SwanIdentificationStatus;
                    expiredAt: string;
                  }
                | {
                    __typename: "InvalidIdentificationLevelStatusInfo";
                    reasons?: Array<IdentificationInvalidReason> | null;
                    status: SwanIdentificationStatus;
                  }
                | { __typename: "NotStartedIdentificationLevelStatusInfo" }
                | {
                    __typename: "NotSupportedIdentificationLevelStatusInfo";
                    status: SwanIdentificationStatus;
                  }
                | {
                    __typename: "PendingIdentificationLevelStatusInfo";
                    status: SwanIdentificationStatus;
                  }
                | {
                    __typename: "StartedIdentificationLevelStatusInfo";
                    status: SwanIdentificationStatus;
                  }
                | {
                    __typename: "ValidIdentificationLevelStatusInfo";
                    status: SwanIdentificationStatus;
                  };
              pvid:
                | {
                    __typename: "CanceledIdentificationLevelStatusInfo";
                    status: SwanIdentificationStatus;
                  }
                | {
                    __typename: "ExpiredIdentificationLevelStatusInfo";
                    status: SwanIdentificationStatus;
                    expiredAt: string;
                  }
                | {
                    __typename: "InvalidIdentificationLevelStatusInfo";
                    reasons?: Array<IdentificationInvalidReason> | null;
                    status: SwanIdentificationStatus;
                  }
                | { __typename: "NotStartedIdentificationLevelStatusInfo" }
                | {
                    __typename: "NotSupportedIdentificationLevelStatusInfo";
                    status: SwanIdentificationStatus;
                  }
                | {
                    __typename: "PendingIdentificationLevelStatusInfo";
                    status: SwanIdentificationStatus;
                  }
                | {
                    __typename: "StartedIdentificationLevelStatusInfo";
                    status: SwanIdentificationStatus;
                  }
                | {
                    __typename: "ValidIdentificationLevelStatusInfo";
                    status: SwanIdentificationStatus;
                  };
              qes:
                | {
                    __typename: "CanceledIdentificationLevelStatusInfo";
                    status: SwanIdentificationStatus;
                  }
                | {
                    __typename: "ExpiredIdentificationLevelStatusInfo";
                    status: SwanIdentificationStatus;
                    expiredAt: string;
                  }
                | {
                    __typename: "InvalidIdentificationLevelStatusInfo";
                    reasons?: Array<IdentificationInvalidReason> | null;
                    status: SwanIdentificationStatus;
                  }
                | { __typename: "NotStartedIdentificationLevelStatusInfo" }
                | {
                    __typename: "NotSupportedIdentificationLevelStatusInfo";
                    status: SwanIdentificationStatus;
                  }
                | {
                    __typename: "PendingIdentificationLevelStatusInfo";
                    status: SwanIdentificationStatus;
                  }
                | {
                    __typename: "StartedIdentificationLevelStatusInfo";
                    status: SwanIdentificationStatus;
                  }
                | {
                    __typename: "ValidIdentificationLevelStatusInfo";
                    status: SwanIdentificationStatus;
                  };
            };
          };
        }>;
      } | null;
    } | null;
  } | null;
  projectInfo: {
    __typename: "ProjectInfo";
    id: string;
    supportingDocumentSettings?: {
      __typename: "SupportingDocumentSettings";
      collectMode: SupportingDocumentCollectMode;
    } | null;
  };
};

export type GenerateSupportingDocumentUploadUrlMutationVariables = Exact<{
  input: GenerateSupportingDocumentUploadUrlInput;
}>;

export type GenerateSupportingDocumentUploadUrlMutation = {
  __typename: "Mutation";
  generateSupportingDocumentUploadUrl:
    | { __typename: "ForbiddenRejection" }
    | {
        __typename: "GenerateSupportingDocumentUploadUrlSuccessPayload";
        supportingDocumentId: string;
        upload: {
          __typename: "SupportingDocumentUploadInfo";
          url: string;
          fields: Array<{ __typename: "SupportingDocumentPostField"; key: string; value: string }>;
        };
      }
    | { __typename: "InternalErrorRejection" }
    | { __typename: "SupportingDocumentCollectionNotFoundRejection" }
    | { __typename: "SupportingDocumentUploadNotAllowedRejection" }
    | { __typename: "ValidationRejection" };
};

export type DeleteSupportingDocumentMutationVariables = Exact<{
  input: DeleteSupportingDocumentInput;
}>;

export type DeleteSupportingDocumentMutation = {
  __typename: "Mutation";
  deleteSupportingDocument:
    | { __typename: "DeleteSupportingDocumentSuccessPayload"; id: string }
    | { __typename: "ForbiddenRejection"; message: string }
    | { __typename: "InternalErrorRejection"; message: string }
    | { __typename: "SupportingDocumentCollectionNotFoundRejection"; message: string }
    | {
        __typename: "SupportingDocumentCollectionStatusDoesNotAllowDeletionRejection";
        message: string;
      }
    | { __typename: "SupportingDocumentNotFoundRejection"; message: string }
    | { __typename: "SupportingDocumentStatusDoesNotAllowDeletionRejection"; message: string }
    | { __typename: "ValidationRejection"; message: string };
};

export type RequestSupportingDocumentCollectionReviewMutationVariables = Exact<{
  input?: InputMaybe<RequestSupportingDocumentCollectionReviewInput>;
}>;

export type RequestSupportingDocumentCollectionReviewMutation = {
  __typename: "Mutation";
  requestSupportingDocumentCollectionReview:
    | { __typename: "ForbiddenRejection"; message: string }
    | {
        __typename: "RequestSupportingDocumentCollectionReviewSuccessPayload";
        supportingDocumentCollection: { __typename: "SupportingDocumentCollection"; id: string };
      }
    | { __typename: "SupportingDocumentCollectionNotFoundRejection"; message: string }
    | { __typename: "SupportingDocumentCollectionStatusNotAllowedRejection"; message: string }
    | { __typename: "ValidationRejection"; message: string };
};

export type TransactionListPageQueryVariables = Exact<{
  accountId: Scalars["ID"]["input"];
  first: Scalars["Int"]["input"];
  canQueryCardOnTransaction: Scalars["Boolean"]["input"];
  after?: InputMaybe<Scalars["String"]["input"]>;
  filters?: InputMaybe<TransactionsFiltersInput>;
  orderBy?: InputMaybe<TransactionsOrderByInput>;
}>;

export type TransactionListPageQuery = {
  __typename: "Query";
  account?: {
    __typename: "Account";
    id: string;
    number: string;
    name: string;
    balances?: {
      __typename: "AccountBalances";
      available: { __typename: "Amount"; value: string; currency: string };
      pending: { __typename: "Amount"; value: string; currency: string };
      booked: { __typename: "Amount"; value: string; currency: string };
      reserved: { __typename: "Amount"; value: string; currency: string };
    } | null;
    transactions?: {
      __typename: "TransactionConnection";
      pageInfo: { __typename: "PageInfo"; endCursor?: string | null; hasNextPage?: boolean | null };
      edges: Array<{
        __typename: "TransactionEdge";
        node:
          | {
              __typename: "CardTransaction";
              reservedAmountReleasedAt?: string | null;
              id: string;
              side: TransactionSide;
              type: TransactionTypeEnum;
              label: string;
              counterparty: string;
              reference: string;
              externalReference?: string | null;
              statementCanBeGenerated?: boolean | null;
              createdAt: string;
              executionDate: string;
              updatedAt: string;
              originalAmount: { __typename: "Amount"; currency: string; value: string };
              reservedAmount?: { __typename: "Amount"; currency: string; value: string } | null;
              cardDetails?:
                | {
                    __typename: "CardInDetails";
                    paymentMandate: {
                      __typename: "CardPaymentMandate";
                      id: string;
                      name?: string | null;
                      createdAt: string;
                      updatedAt: string;
                      executedAt?: string | null;
                    };
                  }
                | {
                    __typename: "CardOutDetails";
                    maskedPan: string;
                    card?: {
                      __typename: "Card";
                      id: string;
                      name?: string | null;
                      accountMembership: {
                        __typename: "AccountMembership";
                        id: string;
                        user?: {
                          __typename: "User";
                          id: string;
                          firstName?: string | null;
                          preferredLastName?: string | null;
                          fullName?: string | null;
                        } | null;
                      };
                    } | null;
                  }
                | null;
              merchant?:
                | { __typename: "CardInMerchant" }
                | {
                    __typename: "CardOutMerchant";
                    merchantId: string;
                    merchantCity: string;
                    merchantCountry?: string | null;
                  }
                | null;
              enrichedTransactionInfo?: {
                __typename: "EnrichedTransactionInfo";
                enrichedMerchantName?: string | null;
                isSubscription?: boolean | null;
                carbonFootprint?: string | null;
                contactEmail?: string | null;
                contactPhone?: string | null;
                contactWebsite?: string | null;
                logoUrl?: string | null;
                category?: MerchantCategory | null;
                subcategory?: MerchantSubCategory | null;
                address?: string | null;
                city?: string | null;
                postalCode?: string | null;
                country?: string | null;
              } | null;
              currencyExchange: Array<{ __typename: "ReportExchangeRate"; exchangeRate: number }>;
              payment?: { __typename: "Payment"; id: string; createdAt: string } | null;
              originTransaction?:
                | {
                    __typename: "CardTransaction";
                    id: string;
                    type: TransactionTypeEnum;
                    executionDate: string;
                    amount: { __typename: "Amount"; currency: string; value: string };
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          status: TransactionStatus;
                          reason: RejectedReasonCode;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                  }
                | {
                    __typename: "CheckTransaction";
                    id: string;
                    type: TransactionTypeEnum;
                    executionDate: string;
                    amount: { __typename: "Amount"; currency: string; value: string };
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          status: TransactionStatus;
                          reason: RejectedReasonCode;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                  }
                | {
                    __typename: "FeeTransaction";
                    id: string;
                    type: TransactionTypeEnum;
                    executionDate: string;
                    amount: { __typename: "Amount"; currency: string; value: string };
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          status: TransactionStatus;
                          reason: RejectedReasonCode;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                  }
                | {
                    __typename: "InternalCreditTransfer";
                    id: string;
                    type: TransactionTypeEnum;
                    executionDate: string;
                    amount: { __typename: "Amount"; currency: string; value: string };
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          status: TransactionStatus;
                          reason: RejectedReasonCode;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                  }
                | {
                    __typename: "InternalDirectDebitTransaction";
                    id: string;
                    type: TransactionTypeEnum;
                    executionDate: string;
                    amount: { __typename: "Amount"; currency: string; value: string };
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          status: TransactionStatus;
                          reason: RejectedReasonCode;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                  }
                | {
                    __typename: "InternationalCreditTransferTransaction";
                    id: string;
                    type: TransactionTypeEnum;
                    executionDate: string;
                    amount: { __typename: "Amount"; currency: string; value: string };
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          status: TransactionStatus;
                          reason: RejectedReasonCode;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                  }
                | {
                    __typename: "SEPACreditTransferTransaction";
                    id: string;
                    type: TransactionTypeEnum;
                    executionDate: string;
                    amount: { __typename: "Amount"; currency: string; value: string };
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          status: TransactionStatus;
                          reason: RejectedReasonCode;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                  }
                | {
                    __typename: "SEPADirectDebitTransaction";
                    id: string;
                    type: TransactionTypeEnum;
                    executionDate: string;
                    amount: { __typename: "Amount"; currency: string; value: string };
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          status: TransactionStatus;
                          reason: RejectedReasonCode;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                  }
                | null;
              statusInfo:
                | {
                    __typename: "BookedTransactionStatusInfo";
                    bookingDate: string;
                    status: TransactionStatus;
                  }
                | {
                    __typename: "CanceledTransactionStatusInfo";
                    canceledDate?: string | null;
                    status: TransactionStatus;
                  }
                | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                | {
                    __typename: "PendingTransactionStatusInfo";
                    pendingEndDate?: string | null;
                    status: TransactionStatus;
                  }
                | {
                    __typename: "RejectedTransactionStatusInfo";
                    reason: RejectedReasonCode;
                    status: TransactionStatus;
                  }
                | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                | {
                    __typename: "UpcomingTransactionStatusInfo";
                    executionDate: string;
                    status: TransactionStatus;
                  };
              amount: { __typename: "Amount"; currency: string; value: string };
            }
          | {
              __typename: "CheckTransaction";
              reservedAmountReleasedAt?: string | null;
              cmc7: string;
              rlmcKey: string;
              id: string;
              side: TransactionSide;
              type: TransactionTypeEnum;
              label: string;
              counterparty: string;
              reference: string;
              externalReference?: string | null;
              statementCanBeGenerated?: boolean | null;
              createdAt: string;
              executionDate: string;
              updatedAt: string;
              reservedAmount?: { __typename: "Amount"; currency: string; value: string } | null;
              payment?: { __typename: "Payment"; id: string; createdAt: string } | null;
              originTransaction?:
                | {
                    __typename: "CardTransaction";
                    id: string;
                    type: TransactionTypeEnum;
                    executionDate: string;
                    amount: { __typename: "Amount"; currency: string; value: string };
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          status: TransactionStatus;
                          reason: RejectedReasonCode;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                  }
                | {
                    __typename: "CheckTransaction";
                    id: string;
                    type: TransactionTypeEnum;
                    executionDate: string;
                    amount: { __typename: "Amount"; currency: string; value: string };
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          status: TransactionStatus;
                          reason: RejectedReasonCode;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                  }
                | {
                    __typename: "FeeTransaction";
                    id: string;
                    type: TransactionTypeEnum;
                    executionDate: string;
                    amount: { __typename: "Amount"; currency: string; value: string };
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          status: TransactionStatus;
                          reason: RejectedReasonCode;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                  }
                | {
                    __typename: "InternalCreditTransfer";
                    id: string;
                    type: TransactionTypeEnum;
                    executionDate: string;
                    amount: { __typename: "Amount"; currency: string; value: string };
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          status: TransactionStatus;
                          reason: RejectedReasonCode;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                  }
                | {
                    __typename: "InternalDirectDebitTransaction";
                    id: string;
                    type: TransactionTypeEnum;
                    executionDate: string;
                    amount: { __typename: "Amount"; currency: string; value: string };
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          status: TransactionStatus;
                          reason: RejectedReasonCode;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                  }
                | {
                    __typename: "InternationalCreditTransferTransaction";
                    id: string;
                    type: TransactionTypeEnum;
                    executionDate: string;
                    amount: { __typename: "Amount"; currency: string; value: string };
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          status: TransactionStatus;
                          reason: RejectedReasonCode;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                  }
                | {
                    __typename: "SEPACreditTransferTransaction";
                    id: string;
                    type: TransactionTypeEnum;
                    executionDate: string;
                    amount: { __typename: "Amount"; currency: string; value: string };
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          status: TransactionStatus;
                          reason: RejectedReasonCode;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                  }
                | {
                    __typename: "SEPADirectDebitTransaction";
                    id: string;
                    type: TransactionTypeEnum;
                    executionDate: string;
                    amount: { __typename: "Amount"; currency: string; value: string };
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          status: TransactionStatus;
                          reason: RejectedReasonCode;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                  }
                | null;
              statusInfo:
                | {
                    __typename: "BookedTransactionStatusInfo";
                    bookingDate: string;
                    status: TransactionStatus;
                  }
                | {
                    __typename: "CanceledTransactionStatusInfo";
                    canceledDate?: string | null;
                    status: TransactionStatus;
                  }
                | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                | {
                    __typename: "PendingTransactionStatusInfo";
                    pendingEndDate?: string | null;
                    status: TransactionStatus;
                  }
                | {
                    __typename: "RejectedTransactionStatusInfo";
                    reason: RejectedReasonCode;
                    status: TransactionStatus;
                  }
                | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                | {
                    __typename: "UpcomingTransactionStatusInfo";
                    executionDate: string;
                    status: TransactionStatus;
                  };
              amount: { __typename: "Amount"; currency: string; value: string };
            }
          | {
              __typename: "FeeTransaction";
              feesType: FeesTypeEnum;
              id: string;
              side: TransactionSide;
              type: TransactionTypeEnum;
              label: string;
              counterparty: string;
              reference: string;
              externalReference?: string | null;
              statementCanBeGenerated?: boolean | null;
              createdAt: string;
              executionDate: string;
              updatedAt: string;
              creditor:
                | { __typename: "FeeInCreditor"; name: string }
                | { __typename: "FeeOutCreditor"; name: string };
              originTransaction?:
                | {
                    __typename: "CardTransaction";
                    id: string;
                    label: string;
                    type: TransactionTypeEnum;
                    updatedAt: string;
                    executionDate: string;
                    createdAt: string;
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          reason: RejectedReasonCode;
                          status: TransactionStatus;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                    amount: { __typename: "Amount"; currency: string; value: string };
                  }
                | {
                    __typename: "CheckTransaction";
                    id: string;
                    label: string;
                    type: TransactionTypeEnum;
                    updatedAt: string;
                    executionDate: string;
                    createdAt: string;
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          reason: RejectedReasonCode;
                          status: TransactionStatus;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                    amount: { __typename: "Amount"; currency: string; value: string };
                  }
                | {
                    __typename: "FeeTransaction";
                    id: string;
                    label: string;
                    type: TransactionTypeEnum;
                    updatedAt: string;
                    executionDate: string;
                    createdAt: string;
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          reason: RejectedReasonCode;
                          status: TransactionStatus;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                    amount: { __typename: "Amount"; currency: string; value: string };
                  }
                | {
                    __typename: "InternalCreditTransfer";
                    id: string;
                    label: string;
                    type: TransactionTypeEnum;
                    updatedAt: string;
                    executionDate: string;
                    createdAt: string;
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          reason: RejectedReasonCode;
                          status: TransactionStatus;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                    amount: { __typename: "Amount"; currency: string; value: string };
                  }
                | {
                    __typename: "InternalDirectDebitTransaction";
                    id: string;
                    label: string;
                    type: TransactionTypeEnum;
                    updatedAt: string;
                    executionDate: string;
                    createdAt: string;
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          reason: RejectedReasonCode;
                          status: TransactionStatus;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                    amount: { __typename: "Amount"; currency: string; value: string };
                  }
                | {
                    __typename: "InternationalCreditTransferTransaction";
                    id: string;
                    label: string;
                    type: TransactionTypeEnum;
                    updatedAt: string;
                    executionDate: string;
                    createdAt: string;
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          reason: RejectedReasonCode;
                          status: TransactionStatus;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                    amount: { __typename: "Amount"; currency: string; value: string };
                  }
                | {
                    __typename: "SEPACreditTransferTransaction";
                    id: string;
                    label: string;
                    type: TransactionTypeEnum;
                    updatedAt: string;
                    executionDate: string;
                    createdAt: string;
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          reason: RejectedReasonCode;
                          status: TransactionStatus;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                    amount: { __typename: "Amount"; currency: string; value: string };
                  }
                | {
                    __typename: "SEPADirectDebitTransaction";
                    id: string;
                    label: string;
                    type: TransactionTypeEnum;
                    updatedAt: string;
                    executionDate: string;
                    createdAt: string;
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          reason: RejectedReasonCode;
                          status: TransactionStatus;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                    amount: { __typename: "Amount"; currency: string; value: string };
                  }
                | null;
              payment?: { __typename: "Payment"; id: string; createdAt: string } | null;
              statusInfo:
                | {
                    __typename: "BookedTransactionStatusInfo";
                    bookingDate: string;
                    status: TransactionStatus;
                  }
                | {
                    __typename: "CanceledTransactionStatusInfo";
                    canceledDate?: string | null;
                    status: TransactionStatus;
                  }
                | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                | {
                    __typename: "PendingTransactionStatusInfo";
                    pendingEndDate?: string | null;
                    status: TransactionStatus;
                  }
                | {
                    __typename: "RejectedTransactionStatusInfo";
                    reason: RejectedReasonCode;
                    status: TransactionStatus;
                  }
                | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                | {
                    __typename: "UpcomingTransactionStatusInfo";
                    executionDate: string;
                    status: TransactionStatus;
                  };
              amount: { __typename: "Amount"; currency: string; value: string };
            }
          | {
              __typename: "InternalCreditTransfer";
              id: string;
              side: TransactionSide;
              type: TransactionTypeEnum;
              label: string;
              counterparty: string;
              reference: string;
              externalReference?: string | null;
              statementCanBeGenerated?: boolean | null;
              createdAt: string;
              executionDate: string;
              updatedAt: string;
              creditor:
                | { __typename: "InternalCreditTransferInCreditor"; name: string }
                | { __typename: "InternalCreditTransferOutCreditor"; name: string };
              payment?: { __typename: "Payment"; id: string; createdAt: string } | null;
              originTransaction?:
                | {
                    __typename: "CardTransaction";
                    id: string;
                    type: TransactionTypeEnum;
                    executionDate: string;
                    amount: { __typename: "Amount"; currency: string; value: string };
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          status: TransactionStatus;
                          reason: RejectedReasonCode;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                  }
                | {
                    __typename: "CheckTransaction";
                    id: string;
                    type: TransactionTypeEnum;
                    executionDate: string;
                    amount: { __typename: "Amount"; currency: string; value: string };
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          status: TransactionStatus;
                          reason: RejectedReasonCode;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                  }
                | {
                    __typename: "FeeTransaction";
                    id: string;
                    type: TransactionTypeEnum;
                    executionDate: string;
                    amount: { __typename: "Amount"; currency: string; value: string };
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          status: TransactionStatus;
                          reason: RejectedReasonCode;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                  }
                | {
                    __typename: "InternalCreditTransfer";
                    id: string;
                    type: TransactionTypeEnum;
                    executionDate: string;
                    amount: { __typename: "Amount"; currency: string; value: string };
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          status: TransactionStatus;
                          reason: RejectedReasonCode;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                  }
                | {
                    __typename: "InternalDirectDebitTransaction";
                    id: string;
                    type: TransactionTypeEnum;
                    executionDate: string;
                    amount: { __typename: "Amount"; currency: string; value: string };
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          status: TransactionStatus;
                          reason: RejectedReasonCode;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                  }
                | {
                    __typename: "InternationalCreditTransferTransaction";
                    id: string;
                    type: TransactionTypeEnum;
                    executionDate: string;
                    amount: { __typename: "Amount"; currency: string; value: string };
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          status: TransactionStatus;
                          reason: RejectedReasonCode;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                  }
                | {
                    __typename: "SEPACreditTransferTransaction";
                    id: string;
                    type: TransactionTypeEnum;
                    executionDate: string;
                    amount: { __typename: "Amount"; currency: string; value: string };
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          status: TransactionStatus;
                          reason: RejectedReasonCode;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                  }
                | {
                    __typename: "SEPADirectDebitTransaction";
                    id: string;
                    type: TransactionTypeEnum;
                    executionDate: string;
                    amount: { __typename: "Amount"; currency: string; value: string };
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          status: TransactionStatus;
                          reason: RejectedReasonCode;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                  }
                | null;
              statusInfo:
                | {
                    __typename: "BookedTransactionStatusInfo";
                    bookingDate: string;
                    status: TransactionStatus;
                  }
                | {
                    __typename: "CanceledTransactionStatusInfo";
                    canceledDate?: string | null;
                    status: TransactionStatus;
                  }
                | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                | {
                    __typename: "PendingTransactionStatusInfo";
                    pendingEndDate?: string | null;
                    status: TransactionStatus;
                  }
                | {
                    __typename: "RejectedTransactionStatusInfo";
                    reason: RejectedReasonCode;
                    status: TransactionStatus;
                  }
                | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                | {
                    __typename: "UpcomingTransactionStatusInfo";
                    executionDate: string;
                    status: TransactionStatus;
                  };
              amount: { __typename: "Amount"; currency: string; value: string };
            }
          | {
              __typename: "InternalDirectDebitTransaction";
              reservedAmountReleasedAt?: string | null;
              id: string;
              side: TransactionSide;
              type: TransactionTypeEnum;
              label: string;
              counterparty: string;
              reference: string;
              externalReference?: string | null;
              statementCanBeGenerated?: boolean | null;
              createdAt: string;
              executionDate: string;
              updatedAt: string;
              reservedAmount?: { __typename: "Amount"; currency: string; value: string } | null;
              creditor: { __typename: "InternalDirectDebitCreditor"; accountId: string };
              mandate?:
                | { __typename: "InternalPaymentDirectDebitMandate"; id: string }
                | { __typename: "InternalReceivedDirectDebitMandate"; id: string }
                | null;
              payment?: { __typename: "Payment"; id: string; createdAt: string } | null;
              originTransaction?:
                | {
                    __typename: "CardTransaction";
                    id: string;
                    type: TransactionTypeEnum;
                    executionDate: string;
                    amount: { __typename: "Amount"; currency: string; value: string };
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          status: TransactionStatus;
                          reason: RejectedReasonCode;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                  }
                | {
                    __typename: "CheckTransaction";
                    id: string;
                    type: TransactionTypeEnum;
                    executionDate: string;
                    amount: { __typename: "Amount"; currency: string; value: string };
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          status: TransactionStatus;
                          reason: RejectedReasonCode;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                  }
                | {
                    __typename: "FeeTransaction";
                    id: string;
                    type: TransactionTypeEnum;
                    executionDate: string;
                    amount: { __typename: "Amount"; currency: string; value: string };
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          status: TransactionStatus;
                          reason: RejectedReasonCode;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                  }
                | {
                    __typename: "InternalCreditTransfer";
                    id: string;
                    type: TransactionTypeEnum;
                    executionDate: string;
                    amount: { __typename: "Amount"; currency: string; value: string };
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          status: TransactionStatus;
                          reason: RejectedReasonCode;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                  }
                | {
                    __typename: "InternalDirectDebitTransaction";
                    id: string;
                    type: TransactionTypeEnum;
                    executionDate: string;
                    amount: { __typename: "Amount"; currency: string; value: string };
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          status: TransactionStatus;
                          reason: RejectedReasonCode;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                  }
                | {
                    __typename: "InternationalCreditTransferTransaction";
                    id: string;
                    type: TransactionTypeEnum;
                    executionDate: string;
                    amount: { __typename: "Amount"; currency: string; value: string };
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          status: TransactionStatus;
                          reason: RejectedReasonCode;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                  }
                | {
                    __typename: "SEPACreditTransferTransaction";
                    id: string;
                    type: TransactionTypeEnum;
                    executionDate: string;
                    amount: { __typename: "Amount"; currency: string; value: string };
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          status: TransactionStatus;
                          reason: RejectedReasonCode;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                  }
                | {
                    __typename: "SEPADirectDebitTransaction";
                    id: string;
                    type: TransactionTypeEnum;
                    executionDate: string;
                    amount: { __typename: "Amount"; currency: string; value: string };
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          status: TransactionStatus;
                          reason: RejectedReasonCode;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                  }
                | null;
              statusInfo:
                | {
                    __typename: "BookedTransactionStatusInfo";
                    bookingDate: string;
                    status: TransactionStatus;
                  }
                | {
                    __typename: "CanceledTransactionStatusInfo";
                    canceledDate?: string | null;
                    status: TransactionStatus;
                  }
                | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                | {
                    __typename: "PendingTransactionStatusInfo";
                    pendingEndDate?: string | null;
                    status: TransactionStatus;
                  }
                | {
                    __typename: "RejectedTransactionStatusInfo";
                    reason: RejectedReasonCode;
                    status: TransactionStatus;
                  }
                | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                | {
                    __typename: "UpcomingTransactionStatusInfo";
                    executionDate: string;
                    status: TransactionStatus;
                  };
              amount: { __typename: "Amount"; currency: string; value: string };
            }
          | {
              __typename: "InternationalCreditTransferTransaction";
              reference: string;
              paymentProduct: PaymentProduct;
              id: string;
              side: TransactionSide;
              type: TransactionTypeEnum;
              label: string;
              counterparty: string;
              externalReference?: string | null;
              statementCanBeGenerated?: boolean | null;
              createdAt: string;
              executionDate: string;
              updatedAt: string;
              creditor:
                | { __typename: "InternationalCreditTransferInCreditor"; name: string }
                | { __typename: "InternationalCreditTransferInDebtor" }
                | {
                    __typename: "InternationalCreditTransferOutCreditor";
                    name: string;
                    details: Array<{
                      __typename: "InternationalCreditTransferDetails";
                      key: string;
                      value: string;
                    }>;
                  };
              statusInfo:
                | {
                    __typename: "BookedTransactionStatusInfo";
                    bookingDate: string;
                    status: TransactionStatus;
                  }
                | {
                    __typename: "CanceledTransactionStatusInfo";
                    canceledDate?: string | null;
                    status: TransactionStatus;
                  }
                | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                | {
                    __typename: "PendingTransactionStatusInfo";
                    pendingEndDate?: string | null;
                    status: TransactionStatus;
                  }
                | {
                    __typename: "RejectedTransactionStatusInfo";
                    reason: RejectedReasonCode;
                    status: TransactionStatus;
                  }
                | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                | {
                    __typename: "UpcomingTransactionStatusInfo";
                    executionDate: string;
                    status: TransactionStatus;
                  };
              internationalCurrencyExchange: {
                __typename: "InternationalCreditTransferCurrencyExchange";
                exchangeRate: string;
                sourceAmount?: { __typename: "Amount"; currency: string; value: string } | null;
                targetAmount?: { __typename: "Amount"; currency: string; value: string } | null;
              };
              beneficiary?:
                | {
                    __typename: "TrustedInternationalBeneficiary";
                    name: string;
                    currency: string;
                    route: InternationalCreditTransferRoute;
                    details: Array<{
                      __typename: "InternationalCreditTransferDetails";
                      key: string;
                      value: string;
                    }>;
                  }
                | {
                    __typename: "UnsavedInternationalBeneficiary";
                    name: string;
                    currency: string;
                    route: InternationalCreditTransferRoute;
                    details: Array<{
                      __typename: "InternationalCreditTransferDetails";
                      key: string;
                      value: string;
                    }>;
                  }
                | null;
              payment?: { __typename: "Payment"; id: string; createdAt: string } | null;
              originTransaction?:
                | {
                    __typename: "CardTransaction";
                    id: string;
                    type: TransactionTypeEnum;
                    executionDate: string;
                    amount: { __typename: "Amount"; currency: string; value: string };
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          status: TransactionStatus;
                          reason: RejectedReasonCode;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                  }
                | {
                    __typename: "CheckTransaction";
                    id: string;
                    type: TransactionTypeEnum;
                    executionDate: string;
                    amount: { __typename: "Amount"; currency: string; value: string };
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          status: TransactionStatus;
                          reason: RejectedReasonCode;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                  }
                | {
                    __typename: "FeeTransaction";
                    id: string;
                    type: TransactionTypeEnum;
                    executionDate: string;
                    amount: { __typename: "Amount"; currency: string; value: string };
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          status: TransactionStatus;
                          reason: RejectedReasonCode;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                  }
                | {
                    __typename: "InternalCreditTransfer";
                    id: string;
                    type: TransactionTypeEnum;
                    executionDate: string;
                    amount: { __typename: "Amount"; currency: string; value: string };
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          status: TransactionStatus;
                          reason: RejectedReasonCode;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                  }
                | {
                    __typename: "InternalDirectDebitTransaction";
                    id: string;
                    type: TransactionTypeEnum;
                    executionDate: string;
                    amount: { __typename: "Amount"; currency: string; value: string };
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          status: TransactionStatus;
                          reason: RejectedReasonCode;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                  }
                | {
                    __typename: "InternationalCreditTransferTransaction";
                    id: string;
                    type: TransactionTypeEnum;
                    executionDate: string;
                    amount: { __typename: "Amount"; currency: string; value: string };
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          status: TransactionStatus;
                          reason: RejectedReasonCode;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                  }
                | {
                    __typename: "SEPACreditTransferTransaction";
                    id: string;
                    type: TransactionTypeEnum;
                    executionDate: string;
                    amount: { __typename: "Amount"; currency: string; value: string };
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          status: TransactionStatus;
                          reason: RejectedReasonCode;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                  }
                | {
                    __typename: "SEPADirectDebitTransaction";
                    id: string;
                    type: TransactionTypeEnum;
                    executionDate: string;
                    amount: { __typename: "Amount"; currency: string; value: string };
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          status: TransactionStatus;
                          reason: RejectedReasonCode;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                  }
                | null;
              amount: { __typename: "Amount"; currency: string; value: string };
            }
          | {
              __typename: "SEPACreditTransferTransaction";
              id: string;
              side: TransactionSide;
              type: TransactionTypeEnum;
              label: string;
              counterparty: string;
              reference: string;
              externalReference?: string | null;
              statementCanBeGenerated?: boolean | null;
              createdAt: string;
              executionDate: string;
              updatedAt: string;
              creditor:
                | { __typename: "SEPACreditTransferInCreditor"; name: string; IBAN?: string | null }
                | {
                    __typename: "SEPACreditTransferInternalOutCreditor";
                    name: string;
                    IBAN?: string | null;
                  }
                | {
                    __typename: "SEPACreditTransferOutCreditor";
                    name: string;
                    IBAN?: string | null;
                  };
              debtor:
                | { __typename: "SEPACreditTransferInDebtor"; name: string; IBAN?: string | null }
                | {
                    __typename: "SEPACreditTransferInternalInDebtor";
                    name: string;
                    IBAN?: string | null;
                  }
                | { __typename: "SEPACreditTransferOutDebtor"; name: string; IBAN?: string | null };
              beneficiary?:
                | {
                    __typename: "TrustedSepaBeneficiary";
                    iban: string;
                    id: string;
                    label: string;
                    name: string;
                    type: BeneficiaryType;
                    createdAt: string;
                    address?: {
                      __typename: "Address";
                      addressLine1?: string | null;
                      addressLine2?: string | null;
                      city?: string | null;
                      country?: string | null;
                      postalCode?: string | null;
                      state?: string | null;
                    } | null;
                    statusInfo:
                      | {
                          __typename: "TrustedBeneficiaryCanceledStatusInfo";
                          status: TrustedBeneficiaryStatus;
                        }
                      | {
                          __typename: "TrustedBeneficiaryConsentPendingStatusInfo";
                          status: TrustedBeneficiaryStatus;
                        }
                      | {
                          __typename: "TrustedBeneficiaryEnabledStatusInfo";
                          status: TrustedBeneficiaryStatus;
                        };
                  }
                | {
                    __typename: "UnsavedSepaBeneficiary";
                    name: string;
                    iban: string;
                    address?: {
                      __typename: "Address";
                      addressLine1?: string | null;
                      addressLine2?: string | null;
                      city?: string | null;
                      country?: string | null;
                      postalCode?: string | null;
                      state?: string | null;
                    } | null;
                  }
                | null;
              payment?: { __typename: "Payment"; id: string; createdAt: string } | null;
              originTransaction?:
                | {
                    __typename: "CardTransaction";
                    id: string;
                    type: TransactionTypeEnum;
                    executionDate: string;
                    amount: { __typename: "Amount"; currency: string; value: string };
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          status: TransactionStatus;
                          reason: RejectedReasonCode;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                  }
                | {
                    __typename: "CheckTransaction";
                    id: string;
                    type: TransactionTypeEnum;
                    executionDate: string;
                    amount: { __typename: "Amount"; currency: string; value: string };
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          status: TransactionStatus;
                          reason: RejectedReasonCode;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                  }
                | {
                    __typename: "FeeTransaction";
                    id: string;
                    type: TransactionTypeEnum;
                    executionDate: string;
                    amount: { __typename: "Amount"; currency: string; value: string };
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          status: TransactionStatus;
                          reason: RejectedReasonCode;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                  }
                | {
                    __typename: "InternalCreditTransfer";
                    id: string;
                    type: TransactionTypeEnum;
                    executionDate: string;
                    amount: { __typename: "Amount"; currency: string; value: string };
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          status: TransactionStatus;
                          reason: RejectedReasonCode;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                  }
                | {
                    __typename: "InternalDirectDebitTransaction";
                    id: string;
                    type: TransactionTypeEnum;
                    executionDate: string;
                    amount: { __typename: "Amount"; currency: string; value: string };
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          status: TransactionStatus;
                          reason: RejectedReasonCode;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                  }
                | {
                    __typename: "InternationalCreditTransferTransaction";
                    id: string;
                    type: TransactionTypeEnum;
                    executionDate: string;
                    amount: { __typename: "Amount"; currency: string; value: string };
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          status: TransactionStatus;
                          reason: RejectedReasonCode;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                  }
                | {
                    __typename: "SEPACreditTransferTransaction";
                    id: string;
                    type: TransactionTypeEnum;
                    executionDate: string;
                    amount: { __typename: "Amount"; currency: string; value: string };
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          status: TransactionStatus;
                          reason: RejectedReasonCode;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                  }
                | {
                    __typename: "SEPADirectDebitTransaction";
                    id: string;
                    type: TransactionTypeEnum;
                    executionDate: string;
                    amount: { __typename: "Amount"; currency: string; value: string };
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          status: TransactionStatus;
                          reason: RejectedReasonCode;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                  }
                | null;
              statusInfo:
                | {
                    __typename: "BookedTransactionStatusInfo";
                    bookingDate: string;
                    status: TransactionStatus;
                  }
                | {
                    __typename: "CanceledTransactionStatusInfo";
                    canceledDate?: string | null;
                    status: TransactionStatus;
                  }
                | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                | {
                    __typename: "PendingTransactionStatusInfo";
                    pendingEndDate?: string | null;
                    status: TransactionStatus;
                  }
                | {
                    __typename: "RejectedTransactionStatusInfo";
                    reason: RejectedReasonCode;
                    status: TransactionStatus;
                  }
                | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                | {
                    __typename: "UpcomingTransactionStatusInfo";
                    executionDate: string;
                    status: TransactionStatus;
                  };
              amount: { __typename: "Amount"; currency: string; value: string };
            }
          | {
              __typename: "SEPADirectDebitTransaction";
              reservedAmountReleasedAt?: string | null;
              id: string;
              side: TransactionSide;
              type: TransactionTypeEnum;
              label: string;
              counterparty: string;
              reference: string;
              externalReference?: string | null;
              statementCanBeGenerated?: boolean | null;
              createdAt: string;
              executionDate: string;
              updatedAt: string;
              creditor:
                | { __typename: "SEPADirectDebitInCreditor"; name: string; IBAN?: string | null }
                | { __typename: "SEPADirectDebitOutCreditor"; name: string; IBAN?: string | null };
              debtor:
                | { __typename: "SEPADirectDebitInDebtor"; name: string; IBAN?: string | null }
                | { __typename: "SEPADirectDebitOutDebtor"; name: string; IBAN?: string | null };
              reservedAmount?: { __typename: "Amount"; value: string; currency: string } | null;
              mandate?:
                | {
                    __typename: "SEPAPaymentDirectDebitMandate";
                    id: string;
                    debtor: { __typename: "SEPAPaymentMandateDebtor"; name: string };
                  }
                | {
                    __typename: "SEPAReceivedDirectDebitMandate";
                    ultimateCreditorName?: string | null;
                    id: string;
                  }
                | null;
              payment?: { __typename: "Payment"; id: string; createdAt: string } | null;
              originTransaction?:
                | {
                    __typename: "CardTransaction";
                    id: string;
                    type: TransactionTypeEnum;
                    executionDate: string;
                    amount: { __typename: "Amount"; currency: string; value: string };
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          status: TransactionStatus;
                          reason: RejectedReasonCode;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                  }
                | {
                    __typename: "CheckTransaction";
                    id: string;
                    type: TransactionTypeEnum;
                    executionDate: string;
                    amount: { __typename: "Amount"; currency: string; value: string };
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          status: TransactionStatus;
                          reason: RejectedReasonCode;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                  }
                | {
                    __typename: "FeeTransaction";
                    id: string;
                    type: TransactionTypeEnum;
                    executionDate: string;
                    amount: { __typename: "Amount"; currency: string; value: string };
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          status: TransactionStatus;
                          reason: RejectedReasonCode;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                  }
                | {
                    __typename: "InternalCreditTransfer";
                    id: string;
                    type: TransactionTypeEnum;
                    executionDate: string;
                    amount: { __typename: "Amount"; currency: string; value: string };
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          status: TransactionStatus;
                          reason: RejectedReasonCode;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                  }
                | {
                    __typename: "InternalDirectDebitTransaction";
                    id: string;
                    type: TransactionTypeEnum;
                    executionDate: string;
                    amount: { __typename: "Amount"; currency: string; value: string };
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          status: TransactionStatus;
                          reason: RejectedReasonCode;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                  }
                | {
                    __typename: "InternationalCreditTransferTransaction";
                    id: string;
                    type: TransactionTypeEnum;
                    executionDate: string;
                    amount: { __typename: "Amount"; currency: string; value: string };
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          status: TransactionStatus;
                          reason: RejectedReasonCode;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                  }
                | {
                    __typename: "SEPACreditTransferTransaction";
                    id: string;
                    type: TransactionTypeEnum;
                    executionDate: string;
                    amount: { __typename: "Amount"; currency: string; value: string };
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          status: TransactionStatus;
                          reason: RejectedReasonCode;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                  }
                | {
                    __typename: "SEPADirectDebitTransaction";
                    id: string;
                    type: TransactionTypeEnum;
                    executionDate: string;
                    amount: { __typename: "Amount"; currency: string; value: string };
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          status: TransactionStatus;
                          reason: RejectedReasonCode;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                  }
                | null;
              statusInfo:
                | {
                    __typename: "BookedTransactionStatusInfo";
                    bookingDate: string;
                    status: TransactionStatus;
                  }
                | {
                    __typename: "CanceledTransactionStatusInfo";
                    canceledDate?: string | null;
                    status: TransactionStatus;
                  }
                | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                | {
                    __typename: "PendingTransactionStatusInfo";
                    pendingEndDate?: string | null;
                    status: TransactionStatus;
                  }
                | {
                    __typename: "RejectedTransactionStatusInfo";
                    reason: RejectedReasonCode;
                    status: TransactionStatus;
                  }
                | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                | {
                    __typename: "UpcomingTransactionStatusInfo";
                    executionDate: string;
                    status: TransactionStatus;
                  };
              amount: { __typename: "Amount"; currency: string; value: string };
            };
      }>;
    } | null;
  } | null;
};

export type TransactionStatementFragment = {
  __typename: "TransactionStatement";
  id: string;
  statusInfo:
    | {
        __typename: "ExpiredTransactionStatementStatusInfo";
        status: TransactionStatementStatusEnum;
      }
    | { __typename: "FailedTransactionStatementStatusInfo"; status: TransactionStatementStatusEnum }
    | {
        __typename: "GeneratedTransactionStatementStatusInfo";
        url: string;
        status: TransactionStatementStatusEnum;
      }
    | {
        __typename: "PendingTransactionStatementStatusInfo";
        status: TransactionStatementStatusEnum;
      };
};

export type GenerateTransactionStatementMutationVariables = Exact<{
  input: GenerateTransactionStatementInput;
}>;

export type GenerateTransactionStatementMutation = {
  __typename: "Mutation";
  generateTransactionStatement:
    | { __typename: "ForbiddenRejection" }
    | {
        __typename: "GenerateTransactionStatementSuccessPayload";
        transactionStatement?: {
          __typename: "TransactionStatement";
          id: string;
          statusInfo:
            | {
                __typename: "ExpiredTransactionStatementStatusInfo";
                status: TransactionStatementStatusEnum;
              }
            | {
                __typename: "FailedTransactionStatementStatusInfo";
                status: TransactionStatementStatusEnum;
              }
            | {
                __typename: "GeneratedTransactionStatementStatusInfo";
                url: string;
                status: TransactionStatementStatusEnum;
              }
            | {
                __typename: "PendingTransactionStatementStatusInfo";
                status: TransactionStatementStatusEnum;
              };
        } | null;
      }
    | { __typename: "GenerationNotAllowedRejection" }
    | { __typename: "TransactionNotFoundRejection" }
    | { __typename: "ValidationRejection" };
};

export type TransactionStatementQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type TransactionStatementQuery = {
  __typename: "Query";
  transactionStatement: {
    __typename: "TransactionStatement";
    id: string;
    statusInfo:
      | {
          __typename: "ExpiredTransactionStatementStatusInfo";
          status: TransactionStatementStatusEnum;
        }
      | {
          __typename: "FailedTransactionStatementStatusInfo";
          status: TransactionStatementStatusEnum;
        }
      | {
          __typename: "GeneratedTransactionStatementStatusInfo";
          url: string;
          status: TransactionStatementStatusEnum;
        }
      | {
          __typename: "PendingTransactionStatementStatusInfo";
          status: TransactionStatementStatusEnum;
        };
  };
};

export type BeneficiariesListQueryVariables = Exact<{
  accountId: Scalars["ID"]["input"];
  first: Scalars["Int"]["input"];
  after?: InputMaybe<Scalars["String"]["input"]>;
  filters?: InputMaybe<TrustedBeneficiaryFiltersInput>;
}>;

export type BeneficiariesListQuery = {
  __typename: "Query";
  account?: {
    __typename: "Account";
    id: string;
    trustedBeneficiaries: {
      __typename: "TrustedBeneficiaryConnection";
      totalCount: number;
      pageInfo: { __typename: "PageInfo"; endCursor?: string | null; hasNextPage?: boolean | null };
      edges: Array<{
        __typename: "TrustedBeneficiaryEdge";
        cursor: string;
        node:
          | {
              __typename: "TrustedInternalBeneficiary";
              accountId: string;
              id: string;
              label: string;
              name: string;
              type: BeneficiaryType;
              createdAt: string;
              statusInfo:
                | {
                    __typename: "TrustedBeneficiaryCanceledStatusInfo";
                    status: TrustedBeneficiaryStatus;
                  }
                | {
                    __typename: "TrustedBeneficiaryConsentPendingStatusInfo";
                    status: TrustedBeneficiaryStatus;
                  }
                | {
                    __typename: "TrustedBeneficiaryEnabledStatusInfo";
                    status: TrustedBeneficiaryStatus;
                  };
            }
          | {
              __typename: "TrustedInternationalBeneficiary";
              currency: string;
              route: InternationalCreditTransferRoute;
              id: string;
              label: string;
              name: string;
              type: BeneficiaryType;
              createdAt: string;
              details: Array<{
                __typename: "InternationalCreditTransferDetails";
                key: string;
                value: string;
              }>;
              statusInfo:
                | {
                    __typename: "TrustedBeneficiaryCanceledStatusInfo";
                    status: TrustedBeneficiaryStatus;
                  }
                | {
                    __typename: "TrustedBeneficiaryConsentPendingStatusInfo";
                    status: TrustedBeneficiaryStatus;
                  }
                | {
                    __typename: "TrustedBeneficiaryEnabledStatusInfo";
                    status: TrustedBeneficiaryStatus;
                  };
            }
          | {
              __typename: "TrustedSepaBeneficiary";
              iban: string;
              id: string;
              label: string;
              name: string;
              type: BeneficiaryType;
              createdAt: string;
              address?: {
                __typename: "Address";
                addressLine1?: string | null;
                addressLine2?: string | null;
                city?: string | null;
                country?: string | null;
                postalCode?: string | null;
                state?: string | null;
              } | null;
              statusInfo:
                | {
                    __typename: "TrustedBeneficiaryCanceledStatusInfo";
                    status: TrustedBeneficiaryStatus;
                  }
                | {
                    __typename: "TrustedBeneficiaryConsentPendingStatusInfo";
                    status: TrustedBeneficiaryStatus;
                  }
                | {
                    __typename: "TrustedBeneficiaryEnabledStatusInfo";
                    status: TrustedBeneficiaryStatus;
                  };
            };
      }>;
    };
  } | null;
};

export type TrustedBeneficiaryDetailsQueryVariables = Exact<{
  id: Scalars["String"]["input"];
}>;

export type TrustedBeneficiaryDetailsQuery = {
  __typename: "Query";
  trustedBeneficiary?:
    | {
        __typename: "TrustedInternalBeneficiary";
        accountId: string;
        id: string;
        label: string;
        name: string;
        type: BeneficiaryType;
        createdAt: string;
        statusInfo:
          | { __typename: "TrustedBeneficiaryCanceledStatusInfo"; status: TrustedBeneficiaryStatus }
          | {
              __typename: "TrustedBeneficiaryConsentPendingStatusInfo";
              status: TrustedBeneficiaryStatus;
            }
          | { __typename: "TrustedBeneficiaryEnabledStatusInfo"; status: TrustedBeneficiaryStatus };
      }
    | {
        __typename: "TrustedInternationalBeneficiary";
        currency: string;
        route: InternationalCreditTransferRoute;
        id: string;
        label: string;
        name: string;
        type: BeneficiaryType;
        createdAt: string;
        details: Array<{
          __typename: "InternationalCreditTransferDetails";
          key: string;
          value: string;
        }>;
        statusInfo:
          | { __typename: "TrustedBeneficiaryCanceledStatusInfo"; status: TrustedBeneficiaryStatus }
          | {
              __typename: "TrustedBeneficiaryConsentPendingStatusInfo";
              status: TrustedBeneficiaryStatus;
            }
          | { __typename: "TrustedBeneficiaryEnabledStatusInfo"; status: TrustedBeneficiaryStatus };
      }
    | {
        __typename: "TrustedSepaBeneficiary";
        iban: string;
        id: string;
        label: string;
        name: string;
        type: BeneficiaryType;
        createdAt: string;
        address?: {
          __typename: "Address";
          addressLine1?: string | null;
          addressLine2?: string | null;
          city?: string | null;
          country?: string | null;
          postalCode?: string | null;
          state?: string | null;
        } | null;
        statusInfo:
          | { __typename: "TrustedBeneficiaryCanceledStatusInfo"; status: TrustedBeneficiaryStatus }
          | {
              __typename: "TrustedBeneficiaryConsentPendingStatusInfo";
              status: TrustedBeneficiaryStatus;
            }
          | { __typename: "TrustedBeneficiaryEnabledStatusInfo"; status: TrustedBeneficiaryStatus };
      }
    | null;
};

export type TrustedBeneficiaryTransfersQueryVariables = Exact<{
  id: Scalars["String"]["input"];
  first: Scalars["Int"]["input"];
  canQueryCardOnTransaction: Scalars["Boolean"]["input"];
  after?: InputMaybe<Scalars["String"]["input"]>;
  filters?: InputMaybe<TransactionsFiltersInput>;
}>;

export type TrustedBeneficiaryTransfersQuery = {
  __typename: "Query";
  trustedBeneficiary?:
    | {
        __typename: "TrustedInternalBeneficiary";
        id: string;
        transactions?: {
          __typename: "TransactionConnection";
          totalCount: number;
          pageInfo: {
            __typename: "PageInfo";
            endCursor?: string | null;
            hasNextPage?: boolean | null;
          };
          edges: Array<{
            __typename: "TransactionEdge";
            node:
              | {
                  __typename: "CardTransaction";
                  reservedAmountReleasedAt?: string | null;
                  id: string;
                  side: TransactionSide;
                  type: TransactionTypeEnum;
                  label: string;
                  counterparty: string;
                  reference: string;
                  externalReference?: string | null;
                  statementCanBeGenerated?: boolean | null;
                  createdAt: string;
                  executionDate: string;
                  updatedAt: string;
                  originalAmount: { __typename: "Amount"; currency: string; value: string };
                  reservedAmount?: { __typename: "Amount"; currency: string; value: string } | null;
                  cardDetails?:
                    | {
                        __typename: "CardInDetails";
                        paymentMandate: {
                          __typename: "CardPaymentMandate";
                          id: string;
                          name?: string | null;
                          createdAt: string;
                          updatedAt: string;
                          executedAt?: string | null;
                        };
                      }
                    | {
                        __typename: "CardOutDetails";
                        maskedPan: string;
                        card?: {
                          __typename: "Card";
                          id: string;
                          name?: string | null;
                          accountMembership: {
                            __typename: "AccountMembership";
                            id: string;
                            user?: {
                              __typename: "User";
                              id: string;
                              firstName?: string | null;
                              preferredLastName?: string | null;
                              fullName?: string | null;
                            } | null;
                          };
                        } | null;
                      }
                    | null;
                  merchant?:
                    | { __typename: "CardInMerchant" }
                    | {
                        __typename: "CardOutMerchant";
                        merchantId: string;
                        merchantCity: string;
                        merchantCountry?: string | null;
                      }
                    | null;
                  enrichedTransactionInfo?: {
                    __typename: "EnrichedTransactionInfo";
                    enrichedMerchantName?: string | null;
                    isSubscription?: boolean | null;
                    carbonFootprint?: string | null;
                    contactEmail?: string | null;
                    contactPhone?: string | null;
                    contactWebsite?: string | null;
                    logoUrl?: string | null;
                    category?: MerchantCategory | null;
                    subcategory?: MerchantSubCategory | null;
                    address?: string | null;
                    city?: string | null;
                    postalCode?: string | null;
                    country?: string | null;
                  } | null;
                  currencyExchange: Array<{
                    __typename: "ReportExchangeRate";
                    exchangeRate: number;
                  }>;
                  payment?: { __typename: "Payment"; id: string; createdAt: string } | null;
                  originTransaction?:
                    | {
                        __typename: "CardTransaction";
                        id: string;
                        type: TransactionTypeEnum;
                        executionDate: string;
                        amount: { __typename: "Amount"; currency: string; value: string };
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              status: TransactionStatus;
                              reason: RejectedReasonCode;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                      }
                    | {
                        __typename: "CheckTransaction";
                        id: string;
                        type: TransactionTypeEnum;
                        executionDate: string;
                        amount: { __typename: "Amount"; currency: string; value: string };
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              status: TransactionStatus;
                              reason: RejectedReasonCode;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                      }
                    | {
                        __typename: "FeeTransaction";
                        id: string;
                        type: TransactionTypeEnum;
                        executionDate: string;
                        amount: { __typename: "Amount"; currency: string; value: string };
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              status: TransactionStatus;
                              reason: RejectedReasonCode;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                      }
                    | {
                        __typename: "InternalCreditTransfer";
                        id: string;
                        type: TransactionTypeEnum;
                        executionDate: string;
                        amount: { __typename: "Amount"; currency: string; value: string };
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              status: TransactionStatus;
                              reason: RejectedReasonCode;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                      }
                    | {
                        __typename: "InternalDirectDebitTransaction";
                        id: string;
                        type: TransactionTypeEnum;
                        executionDate: string;
                        amount: { __typename: "Amount"; currency: string; value: string };
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              status: TransactionStatus;
                              reason: RejectedReasonCode;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                      }
                    | {
                        __typename: "InternationalCreditTransferTransaction";
                        id: string;
                        type: TransactionTypeEnum;
                        executionDate: string;
                        amount: { __typename: "Amount"; currency: string; value: string };
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              status: TransactionStatus;
                              reason: RejectedReasonCode;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                      }
                    | {
                        __typename: "SEPACreditTransferTransaction";
                        id: string;
                        type: TransactionTypeEnum;
                        executionDate: string;
                        amount: { __typename: "Amount"; currency: string; value: string };
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              status: TransactionStatus;
                              reason: RejectedReasonCode;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                      }
                    | {
                        __typename: "SEPADirectDebitTransaction";
                        id: string;
                        type: TransactionTypeEnum;
                        executionDate: string;
                        amount: { __typename: "Amount"; currency: string; value: string };
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              status: TransactionStatus;
                              reason: RejectedReasonCode;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                      }
                    | null;
                  statusInfo:
                    | {
                        __typename: "BookedTransactionStatusInfo";
                        bookingDate: string;
                        status: TransactionStatus;
                      }
                    | {
                        __typename: "CanceledTransactionStatusInfo";
                        canceledDate?: string | null;
                        status: TransactionStatus;
                      }
                    | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                    | {
                        __typename: "PendingTransactionStatusInfo";
                        pendingEndDate?: string | null;
                        status: TransactionStatus;
                      }
                    | {
                        __typename: "RejectedTransactionStatusInfo";
                        reason: RejectedReasonCode;
                        status: TransactionStatus;
                      }
                    | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                    | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                    | {
                        __typename: "UpcomingTransactionStatusInfo";
                        executionDate: string;
                        status: TransactionStatus;
                      };
                  amount: { __typename: "Amount"; currency: string; value: string };
                }
              | {
                  __typename: "CheckTransaction";
                  reservedAmountReleasedAt?: string | null;
                  cmc7: string;
                  rlmcKey: string;
                  id: string;
                  side: TransactionSide;
                  type: TransactionTypeEnum;
                  label: string;
                  counterparty: string;
                  reference: string;
                  externalReference?: string | null;
                  statementCanBeGenerated?: boolean | null;
                  createdAt: string;
                  executionDate: string;
                  updatedAt: string;
                  reservedAmount?: { __typename: "Amount"; currency: string; value: string } | null;
                  payment?: { __typename: "Payment"; id: string; createdAt: string } | null;
                  originTransaction?:
                    | {
                        __typename: "CardTransaction";
                        id: string;
                        type: TransactionTypeEnum;
                        executionDate: string;
                        amount: { __typename: "Amount"; currency: string; value: string };
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              status: TransactionStatus;
                              reason: RejectedReasonCode;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                      }
                    | {
                        __typename: "CheckTransaction";
                        id: string;
                        type: TransactionTypeEnum;
                        executionDate: string;
                        amount: { __typename: "Amount"; currency: string; value: string };
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              status: TransactionStatus;
                              reason: RejectedReasonCode;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                      }
                    | {
                        __typename: "FeeTransaction";
                        id: string;
                        type: TransactionTypeEnum;
                        executionDate: string;
                        amount: { __typename: "Amount"; currency: string; value: string };
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              status: TransactionStatus;
                              reason: RejectedReasonCode;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                      }
                    | {
                        __typename: "InternalCreditTransfer";
                        id: string;
                        type: TransactionTypeEnum;
                        executionDate: string;
                        amount: { __typename: "Amount"; currency: string; value: string };
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              status: TransactionStatus;
                              reason: RejectedReasonCode;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                      }
                    | {
                        __typename: "InternalDirectDebitTransaction";
                        id: string;
                        type: TransactionTypeEnum;
                        executionDate: string;
                        amount: { __typename: "Amount"; currency: string; value: string };
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              status: TransactionStatus;
                              reason: RejectedReasonCode;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                      }
                    | {
                        __typename: "InternationalCreditTransferTransaction";
                        id: string;
                        type: TransactionTypeEnum;
                        executionDate: string;
                        amount: { __typename: "Amount"; currency: string; value: string };
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              status: TransactionStatus;
                              reason: RejectedReasonCode;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                      }
                    | {
                        __typename: "SEPACreditTransferTransaction";
                        id: string;
                        type: TransactionTypeEnum;
                        executionDate: string;
                        amount: { __typename: "Amount"; currency: string; value: string };
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              status: TransactionStatus;
                              reason: RejectedReasonCode;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                      }
                    | {
                        __typename: "SEPADirectDebitTransaction";
                        id: string;
                        type: TransactionTypeEnum;
                        executionDate: string;
                        amount: { __typename: "Amount"; currency: string; value: string };
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              status: TransactionStatus;
                              reason: RejectedReasonCode;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                      }
                    | null;
                  statusInfo:
                    | {
                        __typename: "BookedTransactionStatusInfo";
                        bookingDate: string;
                        status: TransactionStatus;
                      }
                    | {
                        __typename: "CanceledTransactionStatusInfo";
                        canceledDate?: string | null;
                        status: TransactionStatus;
                      }
                    | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                    | {
                        __typename: "PendingTransactionStatusInfo";
                        pendingEndDate?: string | null;
                        status: TransactionStatus;
                      }
                    | {
                        __typename: "RejectedTransactionStatusInfo";
                        reason: RejectedReasonCode;
                        status: TransactionStatus;
                      }
                    | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                    | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                    | {
                        __typename: "UpcomingTransactionStatusInfo";
                        executionDate: string;
                        status: TransactionStatus;
                      };
                  amount: { __typename: "Amount"; currency: string; value: string };
                }
              | {
                  __typename: "FeeTransaction";
                  feesType: FeesTypeEnum;
                  id: string;
                  side: TransactionSide;
                  type: TransactionTypeEnum;
                  label: string;
                  counterparty: string;
                  reference: string;
                  externalReference?: string | null;
                  statementCanBeGenerated?: boolean | null;
                  createdAt: string;
                  executionDate: string;
                  updatedAt: string;
                  creditor:
                    | { __typename: "FeeInCreditor"; name: string }
                    | { __typename: "FeeOutCreditor"; name: string };
                  originTransaction?:
                    | {
                        __typename: "CardTransaction";
                        id: string;
                        label: string;
                        type: TransactionTypeEnum;
                        updatedAt: string;
                        executionDate: string;
                        createdAt: string;
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              reason: RejectedReasonCode;
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                        amount: { __typename: "Amount"; currency: string; value: string };
                      }
                    | {
                        __typename: "CheckTransaction";
                        id: string;
                        label: string;
                        type: TransactionTypeEnum;
                        updatedAt: string;
                        executionDate: string;
                        createdAt: string;
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              reason: RejectedReasonCode;
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                        amount: { __typename: "Amount"; currency: string; value: string };
                      }
                    | {
                        __typename: "FeeTransaction";
                        id: string;
                        label: string;
                        type: TransactionTypeEnum;
                        updatedAt: string;
                        executionDate: string;
                        createdAt: string;
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              reason: RejectedReasonCode;
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                        amount: { __typename: "Amount"; currency: string; value: string };
                      }
                    | {
                        __typename: "InternalCreditTransfer";
                        id: string;
                        label: string;
                        type: TransactionTypeEnum;
                        updatedAt: string;
                        executionDate: string;
                        createdAt: string;
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              reason: RejectedReasonCode;
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                        amount: { __typename: "Amount"; currency: string; value: string };
                      }
                    | {
                        __typename: "InternalDirectDebitTransaction";
                        id: string;
                        label: string;
                        type: TransactionTypeEnum;
                        updatedAt: string;
                        executionDate: string;
                        createdAt: string;
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              reason: RejectedReasonCode;
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                        amount: { __typename: "Amount"; currency: string; value: string };
                      }
                    | {
                        __typename: "InternationalCreditTransferTransaction";
                        id: string;
                        label: string;
                        type: TransactionTypeEnum;
                        updatedAt: string;
                        executionDate: string;
                        createdAt: string;
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              reason: RejectedReasonCode;
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                        amount: { __typename: "Amount"; currency: string; value: string };
                      }
                    | {
                        __typename: "SEPACreditTransferTransaction";
                        id: string;
                        label: string;
                        type: TransactionTypeEnum;
                        updatedAt: string;
                        executionDate: string;
                        createdAt: string;
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              reason: RejectedReasonCode;
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                        amount: { __typename: "Amount"; currency: string; value: string };
                      }
                    | {
                        __typename: "SEPADirectDebitTransaction";
                        id: string;
                        label: string;
                        type: TransactionTypeEnum;
                        updatedAt: string;
                        executionDate: string;
                        createdAt: string;
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              reason: RejectedReasonCode;
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                        amount: { __typename: "Amount"; currency: string; value: string };
                      }
                    | null;
                  payment?: { __typename: "Payment"; id: string; createdAt: string } | null;
                  statusInfo:
                    | {
                        __typename: "BookedTransactionStatusInfo";
                        bookingDate: string;
                        status: TransactionStatus;
                      }
                    | {
                        __typename: "CanceledTransactionStatusInfo";
                        canceledDate?: string | null;
                        status: TransactionStatus;
                      }
                    | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                    | {
                        __typename: "PendingTransactionStatusInfo";
                        pendingEndDate?: string | null;
                        status: TransactionStatus;
                      }
                    | {
                        __typename: "RejectedTransactionStatusInfo";
                        reason: RejectedReasonCode;
                        status: TransactionStatus;
                      }
                    | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                    | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                    | {
                        __typename: "UpcomingTransactionStatusInfo";
                        executionDate: string;
                        status: TransactionStatus;
                      };
                  amount: { __typename: "Amount"; currency: string; value: string };
                }
              | {
                  __typename: "InternalCreditTransfer";
                  id: string;
                  side: TransactionSide;
                  type: TransactionTypeEnum;
                  label: string;
                  counterparty: string;
                  reference: string;
                  externalReference?: string | null;
                  statementCanBeGenerated?: boolean | null;
                  createdAt: string;
                  executionDate: string;
                  updatedAt: string;
                  creditor:
                    | { __typename: "InternalCreditTransferInCreditor"; name: string }
                    | { __typename: "InternalCreditTransferOutCreditor"; name: string };
                  payment?: { __typename: "Payment"; id: string; createdAt: string } | null;
                  originTransaction?:
                    | {
                        __typename: "CardTransaction";
                        id: string;
                        type: TransactionTypeEnum;
                        executionDate: string;
                        amount: { __typename: "Amount"; currency: string; value: string };
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              status: TransactionStatus;
                              reason: RejectedReasonCode;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                      }
                    | {
                        __typename: "CheckTransaction";
                        id: string;
                        type: TransactionTypeEnum;
                        executionDate: string;
                        amount: { __typename: "Amount"; currency: string; value: string };
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              status: TransactionStatus;
                              reason: RejectedReasonCode;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                      }
                    | {
                        __typename: "FeeTransaction";
                        id: string;
                        type: TransactionTypeEnum;
                        executionDate: string;
                        amount: { __typename: "Amount"; currency: string; value: string };
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              status: TransactionStatus;
                              reason: RejectedReasonCode;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                      }
                    | {
                        __typename: "InternalCreditTransfer";
                        id: string;
                        type: TransactionTypeEnum;
                        executionDate: string;
                        amount: { __typename: "Amount"; currency: string; value: string };
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              status: TransactionStatus;
                              reason: RejectedReasonCode;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                      }
                    | {
                        __typename: "InternalDirectDebitTransaction";
                        id: string;
                        type: TransactionTypeEnum;
                        executionDate: string;
                        amount: { __typename: "Amount"; currency: string; value: string };
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              status: TransactionStatus;
                              reason: RejectedReasonCode;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                      }
                    | {
                        __typename: "InternationalCreditTransferTransaction";
                        id: string;
                        type: TransactionTypeEnum;
                        executionDate: string;
                        amount: { __typename: "Amount"; currency: string; value: string };
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              status: TransactionStatus;
                              reason: RejectedReasonCode;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                      }
                    | {
                        __typename: "SEPACreditTransferTransaction";
                        id: string;
                        type: TransactionTypeEnum;
                        executionDate: string;
                        amount: { __typename: "Amount"; currency: string; value: string };
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              status: TransactionStatus;
                              reason: RejectedReasonCode;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                      }
                    | {
                        __typename: "SEPADirectDebitTransaction";
                        id: string;
                        type: TransactionTypeEnum;
                        executionDate: string;
                        amount: { __typename: "Amount"; currency: string; value: string };
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              status: TransactionStatus;
                              reason: RejectedReasonCode;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                      }
                    | null;
                  statusInfo:
                    | {
                        __typename: "BookedTransactionStatusInfo";
                        bookingDate: string;
                        status: TransactionStatus;
                      }
                    | {
                        __typename: "CanceledTransactionStatusInfo";
                        canceledDate?: string | null;
                        status: TransactionStatus;
                      }
                    | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                    | {
                        __typename: "PendingTransactionStatusInfo";
                        pendingEndDate?: string | null;
                        status: TransactionStatus;
                      }
                    | {
                        __typename: "RejectedTransactionStatusInfo";
                        reason: RejectedReasonCode;
                        status: TransactionStatus;
                      }
                    | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                    | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                    | {
                        __typename: "UpcomingTransactionStatusInfo";
                        executionDate: string;
                        status: TransactionStatus;
                      };
                  amount: { __typename: "Amount"; currency: string; value: string };
                }
              | {
                  __typename: "InternalDirectDebitTransaction";
                  reservedAmountReleasedAt?: string | null;
                  id: string;
                  side: TransactionSide;
                  type: TransactionTypeEnum;
                  label: string;
                  counterparty: string;
                  reference: string;
                  externalReference?: string | null;
                  statementCanBeGenerated?: boolean | null;
                  createdAt: string;
                  executionDate: string;
                  updatedAt: string;
                  reservedAmount?: { __typename: "Amount"; currency: string; value: string } | null;
                  creditor: { __typename: "InternalDirectDebitCreditor"; accountId: string };
                  mandate?:
                    | { __typename: "InternalPaymentDirectDebitMandate"; id: string }
                    | { __typename: "InternalReceivedDirectDebitMandate"; id: string }
                    | null;
                  payment?: { __typename: "Payment"; id: string; createdAt: string } | null;
                  originTransaction?:
                    | {
                        __typename: "CardTransaction";
                        id: string;
                        type: TransactionTypeEnum;
                        executionDate: string;
                        amount: { __typename: "Amount"; currency: string; value: string };
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              status: TransactionStatus;
                              reason: RejectedReasonCode;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                      }
                    | {
                        __typename: "CheckTransaction";
                        id: string;
                        type: TransactionTypeEnum;
                        executionDate: string;
                        amount: { __typename: "Amount"; currency: string; value: string };
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              status: TransactionStatus;
                              reason: RejectedReasonCode;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                      }
                    | {
                        __typename: "FeeTransaction";
                        id: string;
                        type: TransactionTypeEnum;
                        executionDate: string;
                        amount: { __typename: "Amount"; currency: string; value: string };
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              status: TransactionStatus;
                              reason: RejectedReasonCode;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                      }
                    | {
                        __typename: "InternalCreditTransfer";
                        id: string;
                        type: TransactionTypeEnum;
                        executionDate: string;
                        amount: { __typename: "Amount"; currency: string; value: string };
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              status: TransactionStatus;
                              reason: RejectedReasonCode;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                      }
                    | {
                        __typename: "InternalDirectDebitTransaction";
                        id: string;
                        type: TransactionTypeEnum;
                        executionDate: string;
                        amount: { __typename: "Amount"; currency: string; value: string };
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              status: TransactionStatus;
                              reason: RejectedReasonCode;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                      }
                    | {
                        __typename: "InternationalCreditTransferTransaction";
                        id: string;
                        type: TransactionTypeEnum;
                        executionDate: string;
                        amount: { __typename: "Amount"; currency: string; value: string };
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              status: TransactionStatus;
                              reason: RejectedReasonCode;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                      }
                    | {
                        __typename: "SEPACreditTransferTransaction";
                        id: string;
                        type: TransactionTypeEnum;
                        executionDate: string;
                        amount: { __typename: "Amount"; currency: string; value: string };
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              status: TransactionStatus;
                              reason: RejectedReasonCode;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                      }
                    | {
                        __typename: "SEPADirectDebitTransaction";
                        id: string;
                        type: TransactionTypeEnum;
                        executionDate: string;
                        amount: { __typename: "Amount"; currency: string; value: string };
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              status: TransactionStatus;
                              reason: RejectedReasonCode;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                      }
                    | null;
                  statusInfo:
                    | {
                        __typename: "BookedTransactionStatusInfo";
                        bookingDate: string;
                        status: TransactionStatus;
                      }
                    | {
                        __typename: "CanceledTransactionStatusInfo";
                        canceledDate?: string | null;
                        status: TransactionStatus;
                      }
                    | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                    | {
                        __typename: "PendingTransactionStatusInfo";
                        pendingEndDate?: string | null;
                        status: TransactionStatus;
                      }
                    | {
                        __typename: "RejectedTransactionStatusInfo";
                        reason: RejectedReasonCode;
                        status: TransactionStatus;
                      }
                    | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                    | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                    | {
                        __typename: "UpcomingTransactionStatusInfo";
                        executionDate: string;
                        status: TransactionStatus;
                      };
                  amount: { __typename: "Amount"; currency: string; value: string };
                }
              | {
                  __typename: "InternationalCreditTransferTransaction";
                  reference: string;
                  paymentProduct: PaymentProduct;
                  id: string;
                  side: TransactionSide;
                  type: TransactionTypeEnum;
                  label: string;
                  counterparty: string;
                  externalReference?: string | null;
                  statementCanBeGenerated?: boolean | null;
                  createdAt: string;
                  executionDate: string;
                  updatedAt: string;
                  creditor:
                    | { __typename: "InternationalCreditTransferInCreditor"; name: string }
                    | { __typename: "InternationalCreditTransferInDebtor" }
                    | {
                        __typename: "InternationalCreditTransferOutCreditor";
                        name: string;
                        details: Array<{
                          __typename: "InternationalCreditTransferDetails";
                          key: string;
                          value: string;
                        }>;
                      };
                  statusInfo:
                    | {
                        __typename: "BookedTransactionStatusInfo";
                        bookingDate: string;
                        status: TransactionStatus;
                      }
                    | {
                        __typename: "CanceledTransactionStatusInfo";
                        canceledDate?: string | null;
                        status: TransactionStatus;
                      }
                    | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                    | {
                        __typename: "PendingTransactionStatusInfo";
                        pendingEndDate?: string | null;
                        status: TransactionStatus;
                      }
                    | {
                        __typename: "RejectedTransactionStatusInfo";
                        reason: RejectedReasonCode;
                        status: TransactionStatus;
                      }
                    | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                    | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                    | {
                        __typename: "UpcomingTransactionStatusInfo";
                        executionDate: string;
                        status: TransactionStatus;
                      };
                  internationalCurrencyExchange: {
                    __typename: "InternationalCreditTransferCurrencyExchange";
                    exchangeRate: string;
                    sourceAmount?: { __typename: "Amount"; currency: string; value: string } | null;
                    targetAmount?: { __typename: "Amount"; currency: string; value: string } | null;
                  };
                  beneficiary?:
                    | {
                        __typename: "TrustedInternationalBeneficiary";
                        name: string;
                        currency: string;
                        route: InternationalCreditTransferRoute;
                        details: Array<{
                          __typename: "InternationalCreditTransferDetails";
                          key: string;
                          value: string;
                        }>;
                      }
                    | {
                        __typename: "UnsavedInternationalBeneficiary";
                        name: string;
                        currency: string;
                        route: InternationalCreditTransferRoute;
                        details: Array<{
                          __typename: "InternationalCreditTransferDetails";
                          key: string;
                          value: string;
                        }>;
                      }
                    | null;
                  payment?: { __typename: "Payment"; id: string; createdAt: string } | null;
                  originTransaction?:
                    | {
                        __typename: "CardTransaction";
                        id: string;
                        type: TransactionTypeEnum;
                        executionDate: string;
                        amount: { __typename: "Amount"; currency: string; value: string };
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              status: TransactionStatus;
                              reason: RejectedReasonCode;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                      }
                    | {
                        __typename: "CheckTransaction";
                        id: string;
                        type: TransactionTypeEnum;
                        executionDate: string;
                        amount: { __typename: "Amount"; currency: string; value: string };
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              status: TransactionStatus;
                              reason: RejectedReasonCode;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                      }
                    | {
                        __typename: "FeeTransaction";
                        id: string;
                        type: TransactionTypeEnum;
                        executionDate: string;
                        amount: { __typename: "Amount"; currency: string; value: string };
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              status: TransactionStatus;
                              reason: RejectedReasonCode;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                      }
                    | {
                        __typename: "InternalCreditTransfer";
                        id: string;
                        type: TransactionTypeEnum;
                        executionDate: string;
                        amount: { __typename: "Amount"; currency: string; value: string };
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              status: TransactionStatus;
                              reason: RejectedReasonCode;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                      }
                    | {
                        __typename: "InternalDirectDebitTransaction";
                        id: string;
                        type: TransactionTypeEnum;
                        executionDate: string;
                        amount: { __typename: "Amount"; currency: string; value: string };
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              status: TransactionStatus;
                              reason: RejectedReasonCode;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                      }
                    | {
                        __typename: "InternationalCreditTransferTransaction";
                        id: string;
                        type: TransactionTypeEnum;
                        executionDate: string;
                        amount: { __typename: "Amount"; currency: string; value: string };
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              status: TransactionStatus;
                              reason: RejectedReasonCode;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                      }
                    | {
                        __typename: "SEPACreditTransferTransaction";
                        id: string;
                        type: TransactionTypeEnum;
                        executionDate: string;
                        amount: { __typename: "Amount"; currency: string; value: string };
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              status: TransactionStatus;
                              reason: RejectedReasonCode;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                      }
                    | {
                        __typename: "SEPADirectDebitTransaction";
                        id: string;
                        type: TransactionTypeEnum;
                        executionDate: string;
                        amount: { __typename: "Amount"; currency: string; value: string };
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              status: TransactionStatus;
                              reason: RejectedReasonCode;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                      }
                    | null;
                  amount: { __typename: "Amount"; currency: string; value: string };
                }
              | {
                  __typename: "SEPACreditTransferTransaction";
                  id: string;
                  side: TransactionSide;
                  type: TransactionTypeEnum;
                  label: string;
                  counterparty: string;
                  reference: string;
                  externalReference?: string | null;
                  statementCanBeGenerated?: boolean | null;
                  createdAt: string;
                  executionDate: string;
                  updatedAt: string;
                  creditor:
                    | {
                        __typename: "SEPACreditTransferInCreditor";
                        name: string;
                        IBAN?: string | null;
                      }
                    | {
                        __typename: "SEPACreditTransferInternalOutCreditor";
                        name: string;
                        IBAN?: string | null;
                      }
                    | {
                        __typename: "SEPACreditTransferOutCreditor";
                        name: string;
                        IBAN?: string | null;
                      };
                  debtor:
                    | {
                        __typename: "SEPACreditTransferInDebtor";
                        name: string;
                        IBAN?: string | null;
                      }
                    | {
                        __typename: "SEPACreditTransferInternalInDebtor";
                        name: string;
                        IBAN?: string | null;
                      }
                    | {
                        __typename: "SEPACreditTransferOutDebtor";
                        name: string;
                        IBAN?: string | null;
                      };
                  beneficiary?:
                    | {
                        __typename: "TrustedSepaBeneficiary";
                        iban: string;
                        id: string;
                        label: string;
                        name: string;
                        type: BeneficiaryType;
                        createdAt: string;
                        address?: {
                          __typename: "Address";
                          addressLine1?: string | null;
                          addressLine2?: string | null;
                          city?: string | null;
                          country?: string | null;
                          postalCode?: string | null;
                          state?: string | null;
                        } | null;
                        statusInfo:
                          | {
                              __typename: "TrustedBeneficiaryCanceledStatusInfo";
                              status: TrustedBeneficiaryStatus;
                            }
                          | {
                              __typename: "TrustedBeneficiaryConsentPendingStatusInfo";
                              status: TrustedBeneficiaryStatus;
                            }
                          | {
                              __typename: "TrustedBeneficiaryEnabledStatusInfo";
                              status: TrustedBeneficiaryStatus;
                            };
                      }
                    | {
                        __typename: "UnsavedSepaBeneficiary";
                        name: string;
                        iban: string;
                        address?: {
                          __typename: "Address";
                          addressLine1?: string | null;
                          addressLine2?: string | null;
                          city?: string | null;
                          country?: string | null;
                          postalCode?: string | null;
                          state?: string | null;
                        } | null;
                      }
                    | null;
                  payment?: { __typename: "Payment"; id: string; createdAt: string } | null;
                  originTransaction?:
                    | {
                        __typename: "CardTransaction";
                        id: string;
                        type: TransactionTypeEnum;
                        executionDate: string;
                        amount: { __typename: "Amount"; currency: string; value: string };
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              status: TransactionStatus;
                              reason: RejectedReasonCode;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                      }
                    | {
                        __typename: "CheckTransaction";
                        id: string;
                        type: TransactionTypeEnum;
                        executionDate: string;
                        amount: { __typename: "Amount"; currency: string; value: string };
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              status: TransactionStatus;
                              reason: RejectedReasonCode;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                      }
                    | {
                        __typename: "FeeTransaction";
                        id: string;
                        type: TransactionTypeEnum;
                        executionDate: string;
                        amount: { __typename: "Amount"; currency: string; value: string };
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              status: TransactionStatus;
                              reason: RejectedReasonCode;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                      }
                    | {
                        __typename: "InternalCreditTransfer";
                        id: string;
                        type: TransactionTypeEnum;
                        executionDate: string;
                        amount: { __typename: "Amount"; currency: string; value: string };
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              status: TransactionStatus;
                              reason: RejectedReasonCode;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                      }
                    | {
                        __typename: "InternalDirectDebitTransaction";
                        id: string;
                        type: TransactionTypeEnum;
                        executionDate: string;
                        amount: { __typename: "Amount"; currency: string; value: string };
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              status: TransactionStatus;
                              reason: RejectedReasonCode;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                      }
                    | {
                        __typename: "InternationalCreditTransferTransaction";
                        id: string;
                        type: TransactionTypeEnum;
                        executionDate: string;
                        amount: { __typename: "Amount"; currency: string; value: string };
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              status: TransactionStatus;
                              reason: RejectedReasonCode;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                      }
                    | {
                        __typename: "SEPACreditTransferTransaction";
                        id: string;
                        type: TransactionTypeEnum;
                        executionDate: string;
                        amount: { __typename: "Amount"; currency: string; value: string };
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              status: TransactionStatus;
                              reason: RejectedReasonCode;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                      }
                    | {
                        __typename: "SEPADirectDebitTransaction";
                        id: string;
                        type: TransactionTypeEnum;
                        executionDate: string;
                        amount: { __typename: "Amount"; currency: string; value: string };
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              status: TransactionStatus;
                              reason: RejectedReasonCode;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                      }
                    | null;
                  statusInfo:
                    | {
                        __typename: "BookedTransactionStatusInfo";
                        bookingDate: string;
                        status: TransactionStatus;
                      }
                    | {
                        __typename: "CanceledTransactionStatusInfo";
                        canceledDate?: string | null;
                        status: TransactionStatus;
                      }
                    | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                    | {
                        __typename: "PendingTransactionStatusInfo";
                        pendingEndDate?: string | null;
                        status: TransactionStatus;
                      }
                    | {
                        __typename: "RejectedTransactionStatusInfo";
                        reason: RejectedReasonCode;
                        status: TransactionStatus;
                      }
                    | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                    | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                    | {
                        __typename: "UpcomingTransactionStatusInfo";
                        executionDate: string;
                        status: TransactionStatus;
                      };
                  amount: { __typename: "Amount"; currency: string; value: string };
                }
              | {
                  __typename: "SEPADirectDebitTransaction";
                  reservedAmountReleasedAt?: string | null;
                  id: string;
                  side: TransactionSide;
                  type: TransactionTypeEnum;
                  label: string;
                  counterparty: string;
                  reference: string;
                  externalReference?: string | null;
                  statementCanBeGenerated?: boolean | null;
                  createdAt: string;
                  executionDate: string;
                  updatedAt: string;
                  creditor:
                    | {
                        __typename: "SEPADirectDebitInCreditor";
                        name: string;
                        IBAN?: string | null;
                      }
                    | {
                        __typename: "SEPADirectDebitOutCreditor";
                        name: string;
                        IBAN?: string | null;
                      };
                  debtor:
                    | { __typename: "SEPADirectDebitInDebtor"; name: string; IBAN?: string | null }
                    | {
                        __typename: "SEPADirectDebitOutDebtor";
                        name: string;
                        IBAN?: string | null;
                      };
                  reservedAmount?: { __typename: "Amount"; value: string; currency: string } | null;
                  mandate?:
                    | {
                        __typename: "SEPAPaymentDirectDebitMandate";
                        id: string;
                        debtor: { __typename: "SEPAPaymentMandateDebtor"; name: string };
                      }
                    | {
                        __typename: "SEPAReceivedDirectDebitMandate";
                        ultimateCreditorName?: string | null;
                        id: string;
                      }
                    | null;
                  payment?: { __typename: "Payment"; id: string; createdAt: string } | null;
                  originTransaction?:
                    | {
                        __typename: "CardTransaction";
                        id: string;
                        type: TransactionTypeEnum;
                        executionDate: string;
                        amount: { __typename: "Amount"; currency: string; value: string };
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              status: TransactionStatus;
                              reason: RejectedReasonCode;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                      }
                    | {
                        __typename: "CheckTransaction";
                        id: string;
                        type: TransactionTypeEnum;
                        executionDate: string;
                        amount: { __typename: "Amount"; currency: string; value: string };
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              status: TransactionStatus;
                              reason: RejectedReasonCode;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                      }
                    | {
                        __typename: "FeeTransaction";
                        id: string;
                        type: TransactionTypeEnum;
                        executionDate: string;
                        amount: { __typename: "Amount"; currency: string; value: string };
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              status: TransactionStatus;
                              reason: RejectedReasonCode;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                      }
                    | {
                        __typename: "InternalCreditTransfer";
                        id: string;
                        type: TransactionTypeEnum;
                        executionDate: string;
                        amount: { __typename: "Amount"; currency: string; value: string };
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              status: TransactionStatus;
                              reason: RejectedReasonCode;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                      }
                    | {
                        __typename: "InternalDirectDebitTransaction";
                        id: string;
                        type: TransactionTypeEnum;
                        executionDate: string;
                        amount: { __typename: "Amount"; currency: string; value: string };
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              status: TransactionStatus;
                              reason: RejectedReasonCode;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                      }
                    | {
                        __typename: "InternationalCreditTransferTransaction";
                        id: string;
                        type: TransactionTypeEnum;
                        executionDate: string;
                        amount: { __typename: "Amount"; currency: string; value: string };
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              status: TransactionStatus;
                              reason: RejectedReasonCode;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                      }
                    | {
                        __typename: "SEPACreditTransferTransaction";
                        id: string;
                        type: TransactionTypeEnum;
                        executionDate: string;
                        amount: { __typename: "Amount"; currency: string; value: string };
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              status: TransactionStatus;
                              reason: RejectedReasonCode;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                      }
                    | {
                        __typename: "SEPADirectDebitTransaction";
                        id: string;
                        type: TransactionTypeEnum;
                        executionDate: string;
                        amount: { __typename: "Amount"; currency: string; value: string };
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              status: TransactionStatus;
                              reason: RejectedReasonCode;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                      }
                    | null;
                  statusInfo:
                    | {
                        __typename: "BookedTransactionStatusInfo";
                        bookingDate: string;
                        status: TransactionStatus;
                      }
                    | {
                        __typename: "CanceledTransactionStatusInfo";
                        canceledDate?: string | null;
                        status: TransactionStatus;
                      }
                    | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                    | {
                        __typename: "PendingTransactionStatusInfo";
                        pendingEndDate?: string | null;
                        status: TransactionStatus;
                      }
                    | {
                        __typename: "RejectedTransactionStatusInfo";
                        reason: RejectedReasonCode;
                        status: TransactionStatus;
                      }
                    | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                    | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                    | {
                        __typename: "UpcomingTransactionStatusInfo";
                        executionDate: string;
                        status: TransactionStatus;
                      };
                  amount: { __typename: "Amount"; currency: string; value: string };
                };
          }>;
        } | null;
      }
    | {
        __typename: "TrustedInternationalBeneficiary";
        id: string;
        transactions?: {
          __typename: "TransactionConnection";
          totalCount: number;
          pageInfo: {
            __typename: "PageInfo";
            endCursor?: string | null;
            hasNextPage?: boolean | null;
          };
          edges: Array<{
            __typename: "TransactionEdge";
            node:
              | {
                  __typename: "CardTransaction";
                  reservedAmountReleasedAt?: string | null;
                  id: string;
                  side: TransactionSide;
                  type: TransactionTypeEnum;
                  label: string;
                  counterparty: string;
                  reference: string;
                  externalReference?: string | null;
                  statementCanBeGenerated?: boolean | null;
                  createdAt: string;
                  executionDate: string;
                  updatedAt: string;
                  originalAmount: { __typename: "Amount"; currency: string; value: string };
                  reservedAmount?: { __typename: "Amount"; currency: string; value: string } | null;
                  cardDetails?:
                    | {
                        __typename: "CardInDetails";
                        paymentMandate: {
                          __typename: "CardPaymentMandate";
                          id: string;
                          name?: string | null;
                          createdAt: string;
                          updatedAt: string;
                          executedAt?: string | null;
                        };
                      }
                    | {
                        __typename: "CardOutDetails";
                        maskedPan: string;
                        card?: {
                          __typename: "Card";
                          id: string;
                          name?: string | null;
                          accountMembership: {
                            __typename: "AccountMembership";
                            id: string;
                            user?: {
                              __typename: "User";
                              id: string;
                              firstName?: string | null;
                              preferredLastName?: string | null;
                              fullName?: string | null;
                            } | null;
                          };
                        } | null;
                      }
                    | null;
                  merchant?:
                    | { __typename: "CardInMerchant" }
                    | {
                        __typename: "CardOutMerchant";
                        merchantId: string;
                        merchantCity: string;
                        merchantCountry?: string | null;
                      }
                    | null;
                  enrichedTransactionInfo?: {
                    __typename: "EnrichedTransactionInfo";
                    enrichedMerchantName?: string | null;
                    isSubscription?: boolean | null;
                    carbonFootprint?: string | null;
                    contactEmail?: string | null;
                    contactPhone?: string | null;
                    contactWebsite?: string | null;
                    logoUrl?: string | null;
                    category?: MerchantCategory | null;
                    subcategory?: MerchantSubCategory | null;
                    address?: string | null;
                    city?: string | null;
                    postalCode?: string | null;
                    country?: string | null;
                  } | null;
                  currencyExchange: Array<{
                    __typename: "ReportExchangeRate";
                    exchangeRate: number;
                  }>;
                  payment?: { __typename: "Payment"; id: string; createdAt: string } | null;
                  originTransaction?:
                    | {
                        __typename: "CardTransaction";
                        id: string;
                        type: TransactionTypeEnum;
                        executionDate: string;
                        amount: { __typename: "Amount"; currency: string; value: string };
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              status: TransactionStatus;
                              reason: RejectedReasonCode;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                      }
                    | {
                        __typename: "CheckTransaction";
                        id: string;
                        type: TransactionTypeEnum;
                        executionDate: string;
                        amount: { __typename: "Amount"; currency: string; value: string };
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              status: TransactionStatus;
                              reason: RejectedReasonCode;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                      }
                    | {
                        __typename: "FeeTransaction";
                        id: string;
                        type: TransactionTypeEnum;
                        executionDate: string;
                        amount: { __typename: "Amount"; currency: string; value: string };
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              status: TransactionStatus;
                              reason: RejectedReasonCode;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                      }
                    | {
                        __typename: "InternalCreditTransfer";
                        id: string;
                        type: TransactionTypeEnum;
                        executionDate: string;
                        amount: { __typename: "Amount"; currency: string; value: string };
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              status: TransactionStatus;
                              reason: RejectedReasonCode;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                      }
                    | {
                        __typename: "InternalDirectDebitTransaction";
                        id: string;
                        type: TransactionTypeEnum;
                        executionDate: string;
                        amount: { __typename: "Amount"; currency: string; value: string };
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              status: TransactionStatus;
                              reason: RejectedReasonCode;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                      }
                    | {
                        __typename: "InternationalCreditTransferTransaction";
                        id: string;
                        type: TransactionTypeEnum;
                        executionDate: string;
                        amount: { __typename: "Amount"; currency: string; value: string };
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              status: TransactionStatus;
                              reason: RejectedReasonCode;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                      }
                    | {
                        __typename: "SEPACreditTransferTransaction";
                        id: string;
                        type: TransactionTypeEnum;
                        executionDate: string;
                        amount: { __typename: "Amount"; currency: string; value: string };
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              status: TransactionStatus;
                              reason: RejectedReasonCode;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                      }
                    | {
                        __typename: "SEPADirectDebitTransaction";
                        id: string;
                        type: TransactionTypeEnum;
                        executionDate: string;
                        amount: { __typename: "Amount"; currency: string; value: string };
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              status: TransactionStatus;
                              reason: RejectedReasonCode;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                      }
                    | null;
                  statusInfo:
                    | {
                        __typename: "BookedTransactionStatusInfo";
                        bookingDate: string;
                        status: TransactionStatus;
                      }
                    | {
                        __typename: "CanceledTransactionStatusInfo";
                        canceledDate?: string | null;
                        status: TransactionStatus;
                      }
                    | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                    | {
                        __typename: "PendingTransactionStatusInfo";
                        pendingEndDate?: string | null;
                        status: TransactionStatus;
                      }
                    | {
                        __typename: "RejectedTransactionStatusInfo";
                        reason: RejectedReasonCode;
                        status: TransactionStatus;
                      }
                    | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                    | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                    | {
                        __typename: "UpcomingTransactionStatusInfo";
                        executionDate: string;
                        status: TransactionStatus;
                      };
                  amount: { __typename: "Amount"; currency: string; value: string };
                }
              | {
                  __typename: "CheckTransaction";
                  reservedAmountReleasedAt?: string | null;
                  cmc7: string;
                  rlmcKey: string;
                  id: string;
                  side: TransactionSide;
                  type: TransactionTypeEnum;
                  label: string;
                  counterparty: string;
                  reference: string;
                  externalReference?: string | null;
                  statementCanBeGenerated?: boolean | null;
                  createdAt: string;
                  executionDate: string;
                  updatedAt: string;
                  reservedAmount?: { __typename: "Amount"; currency: string; value: string } | null;
                  payment?: { __typename: "Payment"; id: string; createdAt: string } | null;
                  originTransaction?:
                    | {
                        __typename: "CardTransaction";
                        id: string;
                        type: TransactionTypeEnum;
                        executionDate: string;
                        amount: { __typename: "Amount"; currency: string; value: string };
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              status: TransactionStatus;
                              reason: RejectedReasonCode;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                      }
                    | {
                        __typename: "CheckTransaction";
                        id: string;
                        type: TransactionTypeEnum;
                        executionDate: string;
                        amount: { __typename: "Amount"; currency: string; value: string };
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              status: TransactionStatus;
                              reason: RejectedReasonCode;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                      }
                    | {
                        __typename: "FeeTransaction";
                        id: string;
                        type: TransactionTypeEnum;
                        executionDate: string;
                        amount: { __typename: "Amount"; currency: string; value: string };
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              status: TransactionStatus;
                              reason: RejectedReasonCode;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                      }
                    | {
                        __typename: "InternalCreditTransfer";
                        id: string;
                        type: TransactionTypeEnum;
                        executionDate: string;
                        amount: { __typename: "Amount"; currency: string; value: string };
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              status: TransactionStatus;
                              reason: RejectedReasonCode;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                      }
                    | {
                        __typename: "InternalDirectDebitTransaction";
                        id: string;
                        type: TransactionTypeEnum;
                        executionDate: string;
                        amount: { __typename: "Amount"; currency: string; value: string };
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              status: TransactionStatus;
                              reason: RejectedReasonCode;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                      }
                    | {
                        __typename: "InternationalCreditTransferTransaction";
                        id: string;
                        type: TransactionTypeEnum;
                        executionDate: string;
                        amount: { __typename: "Amount"; currency: string; value: string };
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              status: TransactionStatus;
                              reason: RejectedReasonCode;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                      }
                    | {
                        __typename: "SEPACreditTransferTransaction";
                        id: string;
                        type: TransactionTypeEnum;
                        executionDate: string;
                        amount: { __typename: "Amount"; currency: string; value: string };
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              status: TransactionStatus;
                              reason: RejectedReasonCode;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                      }
                    | {
                        __typename: "SEPADirectDebitTransaction";
                        id: string;
                        type: TransactionTypeEnum;
                        executionDate: string;
                        amount: { __typename: "Amount"; currency: string; value: string };
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              status: TransactionStatus;
                              reason: RejectedReasonCode;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                      }
                    | null;
                  statusInfo:
                    | {
                        __typename: "BookedTransactionStatusInfo";
                        bookingDate: string;
                        status: TransactionStatus;
                      }
                    | {
                        __typename: "CanceledTransactionStatusInfo";
                        canceledDate?: string | null;
                        status: TransactionStatus;
                      }
                    | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                    | {
                        __typename: "PendingTransactionStatusInfo";
                        pendingEndDate?: string | null;
                        status: TransactionStatus;
                      }
                    | {
                        __typename: "RejectedTransactionStatusInfo";
                        reason: RejectedReasonCode;
                        status: TransactionStatus;
                      }
                    | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                    | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                    | {
                        __typename: "UpcomingTransactionStatusInfo";
                        executionDate: string;
                        status: TransactionStatus;
                      };
                  amount: { __typename: "Amount"; currency: string; value: string };
                }
              | {
                  __typename: "FeeTransaction";
                  feesType: FeesTypeEnum;
                  id: string;
                  side: TransactionSide;
                  type: TransactionTypeEnum;
                  label: string;
                  counterparty: string;
                  reference: string;
                  externalReference?: string | null;
                  statementCanBeGenerated?: boolean | null;
                  createdAt: string;
                  executionDate: string;
                  updatedAt: string;
                  creditor:
                    | { __typename: "FeeInCreditor"; name: string }
                    | { __typename: "FeeOutCreditor"; name: string };
                  originTransaction?:
                    | {
                        __typename: "CardTransaction";
                        id: string;
                        label: string;
                        type: TransactionTypeEnum;
                        updatedAt: string;
                        executionDate: string;
                        createdAt: string;
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              reason: RejectedReasonCode;
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                        amount: { __typename: "Amount"; currency: string; value: string };
                      }
                    | {
                        __typename: "CheckTransaction";
                        id: string;
                        label: string;
                        type: TransactionTypeEnum;
                        updatedAt: string;
                        executionDate: string;
                        createdAt: string;
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              reason: RejectedReasonCode;
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                        amount: { __typename: "Amount"; currency: string; value: string };
                      }
                    | {
                        __typename: "FeeTransaction";
                        id: string;
                        label: string;
                        type: TransactionTypeEnum;
                        updatedAt: string;
                        executionDate: string;
                        createdAt: string;
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              reason: RejectedReasonCode;
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                        amount: { __typename: "Amount"; currency: string; value: string };
                      }
                    | {
                        __typename: "InternalCreditTransfer";
                        id: string;
                        label: string;
                        type: TransactionTypeEnum;
                        updatedAt: string;
                        executionDate: string;
                        createdAt: string;
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              reason: RejectedReasonCode;
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                        amount: { __typename: "Amount"; currency: string; value: string };
                      }
                    | {
                        __typename: "InternalDirectDebitTransaction";
                        id: string;
                        label: string;
                        type: TransactionTypeEnum;
                        updatedAt: string;
                        executionDate: string;
                        createdAt: string;
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              reason: RejectedReasonCode;
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                        amount: { __typename: "Amount"; currency: string; value: string };
                      }
                    | {
                        __typename: "InternationalCreditTransferTransaction";
                        id: string;
                        label: string;
                        type: TransactionTypeEnum;
                        updatedAt: string;
                        executionDate: string;
                        createdAt: string;
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              reason: RejectedReasonCode;
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                        amount: { __typename: "Amount"; currency: string; value: string };
                      }
                    | {
                        __typename: "SEPACreditTransferTransaction";
                        id: string;
                        label: string;
                        type: TransactionTypeEnum;
                        updatedAt: string;
                        executionDate: string;
                        createdAt: string;
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              reason: RejectedReasonCode;
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                        amount: { __typename: "Amount"; currency: string; value: string };
                      }
                    | {
                        __typename: "SEPADirectDebitTransaction";
                        id: string;
                        label: string;
                        type: TransactionTypeEnum;
                        updatedAt: string;
                        executionDate: string;
                        createdAt: string;
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              reason: RejectedReasonCode;
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                        amount: { __typename: "Amount"; currency: string; value: string };
                      }
                    | null;
                  payment?: { __typename: "Payment"; id: string; createdAt: string } | null;
                  statusInfo:
                    | {
                        __typename: "BookedTransactionStatusInfo";
                        bookingDate: string;
                        status: TransactionStatus;
                      }
                    | {
                        __typename: "CanceledTransactionStatusInfo";
                        canceledDate?: string | null;
                        status: TransactionStatus;
                      }
                    | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                    | {
                        __typename: "PendingTransactionStatusInfo";
                        pendingEndDate?: string | null;
                        status: TransactionStatus;
                      }
                    | {
                        __typename: "RejectedTransactionStatusInfo";
                        reason: RejectedReasonCode;
                        status: TransactionStatus;
                      }
                    | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                    | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                    | {
                        __typename: "UpcomingTransactionStatusInfo";
                        executionDate: string;
                        status: TransactionStatus;
                      };
                  amount: { __typename: "Amount"; currency: string; value: string };
                }
              | {
                  __typename: "InternalCreditTransfer";
                  id: string;
                  side: TransactionSide;
                  type: TransactionTypeEnum;
                  label: string;
                  counterparty: string;
                  reference: string;
                  externalReference?: string | null;
                  statementCanBeGenerated?: boolean | null;
                  createdAt: string;
                  executionDate: string;
                  updatedAt: string;
                  creditor:
                    | { __typename: "InternalCreditTransferInCreditor"; name: string }
                    | { __typename: "InternalCreditTransferOutCreditor"; name: string };
                  payment?: { __typename: "Payment"; id: string; createdAt: string } | null;
                  originTransaction?:
                    | {
                        __typename: "CardTransaction";
                        id: string;
                        type: TransactionTypeEnum;
                        executionDate: string;
                        amount: { __typename: "Amount"; currency: string; value: string };
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              status: TransactionStatus;
                              reason: RejectedReasonCode;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                      }
                    | {
                        __typename: "CheckTransaction";
                        id: string;
                        type: TransactionTypeEnum;
                        executionDate: string;
                        amount: { __typename: "Amount"; currency: string; value: string };
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              status: TransactionStatus;
                              reason: RejectedReasonCode;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                      }
                    | {
                        __typename: "FeeTransaction";
                        id: string;
                        type: TransactionTypeEnum;
                        executionDate: string;
                        amount: { __typename: "Amount"; currency: string; value: string };
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              status: TransactionStatus;
                              reason: RejectedReasonCode;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                      }
                    | {
                        __typename: "InternalCreditTransfer";
                        id: string;
                        type: TransactionTypeEnum;
                        executionDate: string;
                        amount: { __typename: "Amount"; currency: string; value: string };
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              status: TransactionStatus;
                              reason: RejectedReasonCode;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                      }
                    | {
                        __typename: "InternalDirectDebitTransaction";
                        id: string;
                        type: TransactionTypeEnum;
                        executionDate: string;
                        amount: { __typename: "Amount"; currency: string; value: string };
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              status: TransactionStatus;
                              reason: RejectedReasonCode;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                      }
                    | {
                        __typename: "InternationalCreditTransferTransaction";
                        id: string;
                        type: TransactionTypeEnum;
                        executionDate: string;
                        amount: { __typename: "Amount"; currency: string; value: string };
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              status: TransactionStatus;
                              reason: RejectedReasonCode;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                      }
                    | {
                        __typename: "SEPACreditTransferTransaction";
                        id: string;
                        type: TransactionTypeEnum;
                        executionDate: string;
                        amount: { __typename: "Amount"; currency: string; value: string };
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              status: TransactionStatus;
                              reason: RejectedReasonCode;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                      }
                    | {
                        __typename: "SEPADirectDebitTransaction";
                        id: string;
                        type: TransactionTypeEnum;
                        executionDate: string;
                        amount: { __typename: "Amount"; currency: string; value: string };
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              status: TransactionStatus;
                              reason: RejectedReasonCode;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                      }
                    | null;
                  statusInfo:
                    | {
                        __typename: "BookedTransactionStatusInfo";
                        bookingDate: string;
                        status: TransactionStatus;
                      }
                    | {
                        __typename: "CanceledTransactionStatusInfo";
                        canceledDate?: string | null;
                        status: TransactionStatus;
                      }
                    | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                    | {
                        __typename: "PendingTransactionStatusInfo";
                        pendingEndDate?: string | null;
                        status: TransactionStatus;
                      }
                    | {
                        __typename: "RejectedTransactionStatusInfo";
                        reason: RejectedReasonCode;
                        status: TransactionStatus;
                      }
                    | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                    | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                    | {
                        __typename: "UpcomingTransactionStatusInfo";
                        executionDate: string;
                        status: TransactionStatus;
                      };
                  amount: { __typename: "Amount"; currency: string; value: string };
                }
              | {
                  __typename: "InternalDirectDebitTransaction";
                  reservedAmountReleasedAt?: string | null;
                  id: string;
                  side: TransactionSide;
                  type: TransactionTypeEnum;
                  label: string;
                  counterparty: string;
                  reference: string;
                  externalReference?: string | null;
                  statementCanBeGenerated?: boolean | null;
                  createdAt: string;
                  executionDate: string;
                  updatedAt: string;
                  reservedAmount?: { __typename: "Amount"; currency: string; value: string } | null;
                  creditor: { __typename: "InternalDirectDebitCreditor"; accountId: string };
                  mandate?:
                    | { __typename: "InternalPaymentDirectDebitMandate"; id: string }
                    | { __typename: "InternalReceivedDirectDebitMandate"; id: string }
                    | null;
                  payment?: { __typename: "Payment"; id: string; createdAt: string } | null;
                  originTransaction?:
                    | {
                        __typename: "CardTransaction";
                        id: string;
                        type: TransactionTypeEnum;
                        executionDate: string;
                        amount: { __typename: "Amount"; currency: string; value: string };
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              status: TransactionStatus;
                              reason: RejectedReasonCode;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                      }
                    | {
                        __typename: "CheckTransaction";
                        id: string;
                        type: TransactionTypeEnum;
                        executionDate: string;
                        amount: { __typename: "Amount"; currency: string; value: string };
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              status: TransactionStatus;
                              reason: RejectedReasonCode;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                      }
                    | {
                        __typename: "FeeTransaction";
                        id: string;
                        type: TransactionTypeEnum;
                        executionDate: string;
                        amount: { __typename: "Amount"; currency: string; value: string };
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              status: TransactionStatus;
                              reason: RejectedReasonCode;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                      }
                    | {
                        __typename: "InternalCreditTransfer";
                        id: string;
                        type: TransactionTypeEnum;
                        executionDate: string;
                        amount: { __typename: "Amount"; currency: string; value: string };
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              status: TransactionStatus;
                              reason: RejectedReasonCode;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                      }
                    | {
                        __typename: "InternalDirectDebitTransaction";
                        id: string;
                        type: TransactionTypeEnum;
                        executionDate: string;
                        amount: { __typename: "Amount"; currency: string; value: string };
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              status: TransactionStatus;
                              reason: RejectedReasonCode;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                      }
                    | {
                        __typename: "InternationalCreditTransferTransaction";
                        id: string;
                        type: TransactionTypeEnum;
                        executionDate: string;
                        amount: { __typename: "Amount"; currency: string; value: string };
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              status: TransactionStatus;
                              reason: RejectedReasonCode;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                      }
                    | {
                        __typename: "SEPACreditTransferTransaction";
                        id: string;
                        type: TransactionTypeEnum;
                        executionDate: string;
                        amount: { __typename: "Amount"; currency: string; value: string };
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              status: TransactionStatus;
                              reason: RejectedReasonCode;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                      }
                    | {
                        __typename: "SEPADirectDebitTransaction";
                        id: string;
                        type: TransactionTypeEnum;
                        executionDate: string;
                        amount: { __typename: "Amount"; currency: string; value: string };
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              status: TransactionStatus;
                              reason: RejectedReasonCode;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                      }
                    | null;
                  statusInfo:
                    | {
                        __typename: "BookedTransactionStatusInfo";
                        bookingDate: string;
                        status: TransactionStatus;
                      }
                    | {
                        __typename: "CanceledTransactionStatusInfo";
                        canceledDate?: string | null;
                        status: TransactionStatus;
                      }
                    | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                    | {
                        __typename: "PendingTransactionStatusInfo";
                        pendingEndDate?: string | null;
                        status: TransactionStatus;
                      }
                    | {
                        __typename: "RejectedTransactionStatusInfo";
                        reason: RejectedReasonCode;
                        status: TransactionStatus;
                      }
                    | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                    | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                    | {
                        __typename: "UpcomingTransactionStatusInfo";
                        executionDate: string;
                        status: TransactionStatus;
                      };
                  amount: { __typename: "Amount"; currency: string; value: string };
                }
              | {
                  __typename: "InternationalCreditTransferTransaction";
                  reference: string;
                  paymentProduct: PaymentProduct;
                  id: string;
                  side: TransactionSide;
                  type: TransactionTypeEnum;
                  label: string;
                  counterparty: string;
                  externalReference?: string | null;
                  statementCanBeGenerated?: boolean | null;
                  createdAt: string;
                  executionDate: string;
                  updatedAt: string;
                  creditor:
                    | { __typename: "InternationalCreditTransferInCreditor"; name: string }
                    | { __typename: "InternationalCreditTransferInDebtor" }
                    | {
                        __typename: "InternationalCreditTransferOutCreditor";
                        name: string;
                        details: Array<{
                          __typename: "InternationalCreditTransferDetails";
                          key: string;
                          value: string;
                        }>;
                      };
                  statusInfo:
                    | {
                        __typename: "BookedTransactionStatusInfo";
                        bookingDate: string;
                        status: TransactionStatus;
                      }
                    | {
                        __typename: "CanceledTransactionStatusInfo";
                        canceledDate?: string | null;
                        status: TransactionStatus;
                      }
                    | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                    | {
                        __typename: "PendingTransactionStatusInfo";
                        pendingEndDate?: string | null;
                        status: TransactionStatus;
                      }
                    | {
                        __typename: "RejectedTransactionStatusInfo";
                        reason: RejectedReasonCode;
                        status: TransactionStatus;
                      }
                    | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                    | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                    | {
                        __typename: "UpcomingTransactionStatusInfo";
                        executionDate: string;
                        status: TransactionStatus;
                      };
                  internationalCurrencyExchange: {
                    __typename: "InternationalCreditTransferCurrencyExchange";
                    exchangeRate: string;
                    sourceAmount?: { __typename: "Amount"; currency: string; value: string } | null;
                    targetAmount?: { __typename: "Amount"; currency: string; value: string } | null;
                  };
                  beneficiary?:
                    | {
                        __typename: "TrustedInternationalBeneficiary";
                        name: string;
                        currency: string;
                        route: InternationalCreditTransferRoute;
                        details: Array<{
                          __typename: "InternationalCreditTransferDetails";
                          key: string;
                          value: string;
                        }>;
                      }
                    | {
                        __typename: "UnsavedInternationalBeneficiary";
                        name: string;
                        currency: string;
                        route: InternationalCreditTransferRoute;
                        details: Array<{
                          __typename: "InternationalCreditTransferDetails";
                          key: string;
                          value: string;
                        }>;
                      }
                    | null;
                  payment?: { __typename: "Payment"; id: string; createdAt: string } | null;
                  originTransaction?:
                    | {
                        __typename: "CardTransaction";
                        id: string;
                        type: TransactionTypeEnum;
                        executionDate: string;
                        amount: { __typename: "Amount"; currency: string; value: string };
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              status: TransactionStatus;
                              reason: RejectedReasonCode;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                      }
                    | {
                        __typename: "CheckTransaction";
                        id: string;
                        type: TransactionTypeEnum;
                        executionDate: string;
                        amount: { __typename: "Amount"; currency: string; value: string };
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              status: TransactionStatus;
                              reason: RejectedReasonCode;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                      }
                    | {
                        __typename: "FeeTransaction";
                        id: string;
                        type: TransactionTypeEnum;
                        executionDate: string;
                        amount: { __typename: "Amount"; currency: string; value: string };
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              status: TransactionStatus;
                              reason: RejectedReasonCode;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                      }
                    | {
                        __typename: "InternalCreditTransfer";
                        id: string;
                        type: TransactionTypeEnum;
                        executionDate: string;
                        amount: { __typename: "Amount"; currency: string; value: string };
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              status: TransactionStatus;
                              reason: RejectedReasonCode;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                      }
                    | {
                        __typename: "InternalDirectDebitTransaction";
                        id: string;
                        type: TransactionTypeEnum;
                        executionDate: string;
                        amount: { __typename: "Amount"; currency: string; value: string };
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              status: TransactionStatus;
                              reason: RejectedReasonCode;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                      }
                    | {
                        __typename: "InternationalCreditTransferTransaction";
                        id: string;
                        type: TransactionTypeEnum;
                        executionDate: string;
                        amount: { __typename: "Amount"; currency: string; value: string };
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              status: TransactionStatus;
                              reason: RejectedReasonCode;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                      }
                    | {
                        __typename: "SEPACreditTransferTransaction";
                        id: string;
                        type: TransactionTypeEnum;
                        executionDate: string;
                        amount: { __typename: "Amount"; currency: string; value: string };
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              status: TransactionStatus;
                              reason: RejectedReasonCode;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                      }
                    | {
                        __typename: "SEPADirectDebitTransaction";
                        id: string;
                        type: TransactionTypeEnum;
                        executionDate: string;
                        amount: { __typename: "Amount"; currency: string; value: string };
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              status: TransactionStatus;
                              reason: RejectedReasonCode;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                      }
                    | null;
                  amount: { __typename: "Amount"; currency: string; value: string };
                }
              | {
                  __typename: "SEPACreditTransferTransaction";
                  id: string;
                  side: TransactionSide;
                  type: TransactionTypeEnum;
                  label: string;
                  counterparty: string;
                  reference: string;
                  externalReference?: string | null;
                  statementCanBeGenerated?: boolean | null;
                  createdAt: string;
                  executionDate: string;
                  updatedAt: string;
                  creditor:
                    | {
                        __typename: "SEPACreditTransferInCreditor";
                        name: string;
                        IBAN?: string | null;
                      }
                    | {
                        __typename: "SEPACreditTransferInternalOutCreditor";
                        name: string;
                        IBAN?: string | null;
                      }
                    | {
                        __typename: "SEPACreditTransferOutCreditor";
                        name: string;
                        IBAN?: string | null;
                      };
                  debtor:
                    | {
                        __typename: "SEPACreditTransferInDebtor";
                        name: string;
                        IBAN?: string | null;
                      }
                    | {
                        __typename: "SEPACreditTransferInternalInDebtor";
                        name: string;
                        IBAN?: string | null;
                      }
                    | {
                        __typename: "SEPACreditTransferOutDebtor";
                        name: string;
                        IBAN?: string | null;
                      };
                  beneficiary?:
                    | {
                        __typename: "TrustedSepaBeneficiary";
                        iban: string;
                        id: string;
                        label: string;
                        name: string;
                        type: BeneficiaryType;
                        createdAt: string;
                        address?: {
                          __typename: "Address";
                          addressLine1?: string | null;
                          addressLine2?: string | null;
                          city?: string | null;
                          country?: string | null;
                          postalCode?: string | null;
                          state?: string | null;
                        } | null;
                        statusInfo:
                          | {
                              __typename: "TrustedBeneficiaryCanceledStatusInfo";
                              status: TrustedBeneficiaryStatus;
                            }
                          | {
                              __typename: "TrustedBeneficiaryConsentPendingStatusInfo";
                              status: TrustedBeneficiaryStatus;
                            }
                          | {
                              __typename: "TrustedBeneficiaryEnabledStatusInfo";
                              status: TrustedBeneficiaryStatus;
                            };
                      }
                    | {
                        __typename: "UnsavedSepaBeneficiary";
                        name: string;
                        iban: string;
                        address?: {
                          __typename: "Address";
                          addressLine1?: string | null;
                          addressLine2?: string | null;
                          city?: string | null;
                          country?: string | null;
                          postalCode?: string | null;
                          state?: string | null;
                        } | null;
                      }
                    | null;
                  payment?: { __typename: "Payment"; id: string; createdAt: string } | null;
                  originTransaction?:
                    | {
                        __typename: "CardTransaction";
                        id: string;
                        type: TransactionTypeEnum;
                        executionDate: string;
                        amount: { __typename: "Amount"; currency: string; value: string };
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              status: TransactionStatus;
                              reason: RejectedReasonCode;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                      }
                    | {
                        __typename: "CheckTransaction";
                        id: string;
                        type: TransactionTypeEnum;
                        executionDate: string;
                        amount: { __typename: "Amount"; currency: string; value: string };
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              status: TransactionStatus;
                              reason: RejectedReasonCode;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                      }
                    | {
                        __typename: "FeeTransaction";
                        id: string;
                        type: TransactionTypeEnum;
                        executionDate: string;
                        amount: { __typename: "Amount"; currency: string; value: string };
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              status: TransactionStatus;
                              reason: RejectedReasonCode;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                      }
                    | {
                        __typename: "InternalCreditTransfer";
                        id: string;
                        type: TransactionTypeEnum;
                        executionDate: string;
                        amount: { __typename: "Amount"; currency: string; value: string };
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              status: TransactionStatus;
                              reason: RejectedReasonCode;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                      }
                    | {
                        __typename: "InternalDirectDebitTransaction";
                        id: string;
                        type: TransactionTypeEnum;
                        executionDate: string;
                        amount: { __typename: "Amount"; currency: string; value: string };
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              status: TransactionStatus;
                              reason: RejectedReasonCode;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                      }
                    | {
                        __typename: "InternationalCreditTransferTransaction";
                        id: string;
                        type: TransactionTypeEnum;
                        executionDate: string;
                        amount: { __typename: "Amount"; currency: string; value: string };
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              status: TransactionStatus;
                              reason: RejectedReasonCode;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                      }
                    | {
                        __typename: "SEPACreditTransferTransaction";
                        id: string;
                        type: TransactionTypeEnum;
                        executionDate: string;
                        amount: { __typename: "Amount"; currency: string; value: string };
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              status: TransactionStatus;
                              reason: RejectedReasonCode;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                      }
                    | {
                        __typename: "SEPADirectDebitTransaction";
                        id: string;
                        type: TransactionTypeEnum;
                        executionDate: string;
                        amount: { __typename: "Amount"; currency: string; value: string };
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              status: TransactionStatus;
                              reason: RejectedReasonCode;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                      }
                    | null;
                  statusInfo:
                    | {
                        __typename: "BookedTransactionStatusInfo";
                        bookingDate: string;
                        status: TransactionStatus;
                      }
                    | {
                        __typename: "CanceledTransactionStatusInfo";
                        canceledDate?: string | null;
                        status: TransactionStatus;
                      }
                    | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                    | {
                        __typename: "PendingTransactionStatusInfo";
                        pendingEndDate?: string | null;
                        status: TransactionStatus;
                      }
                    | {
                        __typename: "RejectedTransactionStatusInfo";
                        reason: RejectedReasonCode;
                        status: TransactionStatus;
                      }
                    | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                    | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                    | {
                        __typename: "UpcomingTransactionStatusInfo";
                        executionDate: string;
                        status: TransactionStatus;
                      };
                  amount: { __typename: "Amount"; currency: string; value: string };
                }
              | {
                  __typename: "SEPADirectDebitTransaction";
                  reservedAmountReleasedAt?: string | null;
                  id: string;
                  side: TransactionSide;
                  type: TransactionTypeEnum;
                  label: string;
                  counterparty: string;
                  reference: string;
                  externalReference?: string | null;
                  statementCanBeGenerated?: boolean | null;
                  createdAt: string;
                  executionDate: string;
                  updatedAt: string;
                  creditor:
                    | {
                        __typename: "SEPADirectDebitInCreditor";
                        name: string;
                        IBAN?: string | null;
                      }
                    | {
                        __typename: "SEPADirectDebitOutCreditor";
                        name: string;
                        IBAN?: string | null;
                      };
                  debtor:
                    | { __typename: "SEPADirectDebitInDebtor"; name: string; IBAN?: string | null }
                    | {
                        __typename: "SEPADirectDebitOutDebtor";
                        name: string;
                        IBAN?: string | null;
                      };
                  reservedAmount?: { __typename: "Amount"; value: string; currency: string } | null;
                  mandate?:
                    | {
                        __typename: "SEPAPaymentDirectDebitMandate";
                        id: string;
                        debtor: { __typename: "SEPAPaymentMandateDebtor"; name: string };
                      }
                    | {
                        __typename: "SEPAReceivedDirectDebitMandate";
                        ultimateCreditorName?: string | null;
                        id: string;
                      }
                    | null;
                  payment?: { __typename: "Payment"; id: string; createdAt: string } | null;
                  originTransaction?:
                    | {
                        __typename: "CardTransaction";
                        id: string;
                        type: TransactionTypeEnum;
                        executionDate: string;
                        amount: { __typename: "Amount"; currency: string; value: string };
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              status: TransactionStatus;
                              reason: RejectedReasonCode;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                      }
                    | {
                        __typename: "CheckTransaction";
                        id: string;
                        type: TransactionTypeEnum;
                        executionDate: string;
                        amount: { __typename: "Amount"; currency: string; value: string };
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              status: TransactionStatus;
                              reason: RejectedReasonCode;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                      }
                    | {
                        __typename: "FeeTransaction";
                        id: string;
                        type: TransactionTypeEnum;
                        executionDate: string;
                        amount: { __typename: "Amount"; currency: string; value: string };
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              status: TransactionStatus;
                              reason: RejectedReasonCode;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                      }
                    | {
                        __typename: "InternalCreditTransfer";
                        id: string;
                        type: TransactionTypeEnum;
                        executionDate: string;
                        amount: { __typename: "Amount"; currency: string; value: string };
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              status: TransactionStatus;
                              reason: RejectedReasonCode;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                      }
                    | {
                        __typename: "InternalDirectDebitTransaction";
                        id: string;
                        type: TransactionTypeEnum;
                        executionDate: string;
                        amount: { __typename: "Amount"; currency: string; value: string };
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              status: TransactionStatus;
                              reason: RejectedReasonCode;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                      }
                    | {
                        __typename: "InternationalCreditTransferTransaction";
                        id: string;
                        type: TransactionTypeEnum;
                        executionDate: string;
                        amount: { __typename: "Amount"; currency: string; value: string };
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              status: TransactionStatus;
                              reason: RejectedReasonCode;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                      }
                    | {
                        __typename: "SEPACreditTransferTransaction";
                        id: string;
                        type: TransactionTypeEnum;
                        executionDate: string;
                        amount: { __typename: "Amount"; currency: string; value: string };
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              status: TransactionStatus;
                              reason: RejectedReasonCode;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                      }
                    | {
                        __typename: "SEPADirectDebitTransaction";
                        id: string;
                        type: TransactionTypeEnum;
                        executionDate: string;
                        amount: { __typename: "Amount"; currency: string; value: string };
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              status: TransactionStatus;
                              reason: RejectedReasonCode;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                      }
                    | null;
                  statusInfo:
                    | {
                        __typename: "BookedTransactionStatusInfo";
                        bookingDate: string;
                        status: TransactionStatus;
                      }
                    | {
                        __typename: "CanceledTransactionStatusInfo";
                        canceledDate?: string | null;
                        status: TransactionStatus;
                      }
                    | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                    | {
                        __typename: "PendingTransactionStatusInfo";
                        pendingEndDate?: string | null;
                        status: TransactionStatus;
                      }
                    | {
                        __typename: "RejectedTransactionStatusInfo";
                        reason: RejectedReasonCode;
                        status: TransactionStatus;
                      }
                    | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                    | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                    | {
                        __typename: "UpcomingTransactionStatusInfo";
                        executionDate: string;
                        status: TransactionStatus;
                      };
                  amount: { __typename: "Amount"; currency: string; value: string };
                };
          }>;
        } | null;
      }
    | {
        __typename: "TrustedSepaBeneficiary";
        id: string;
        transactions?: {
          __typename: "TransactionConnection";
          totalCount: number;
          pageInfo: {
            __typename: "PageInfo";
            endCursor?: string | null;
            hasNextPage?: boolean | null;
          };
          edges: Array<{
            __typename: "TransactionEdge";
            node:
              | {
                  __typename: "CardTransaction";
                  reservedAmountReleasedAt?: string | null;
                  id: string;
                  side: TransactionSide;
                  type: TransactionTypeEnum;
                  label: string;
                  counterparty: string;
                  reference: string;
                  externalReference?: string | null;
                  statementCanBeGenerated?: boolean | null;
                  createdAt: string;
                  executionDate: string;
                  updatedAt: string;
                  originalAmount: { __typename: "Amount"; currency: string; value: string };
                  reservedAmount?: { __typename: "Amount"; currency: string; value: string } | null;
                  cardDetails?:
                    | {
                        __typename: "CardInDetails";
                        paymentMandate: {
                          __typename: "CardPaymentMandate";
                          id: string;
                          name?: string | null;
                          createdAt: string;
                          updatedAt: string;
                          executedAt?: string | null;
                        };
                      }
                    | {
                        __typename: "CardOutDetails";
                        maskedPan: string;
                        card?: {
                          __typename: "Card";
                          id: string;
                          name?: string | null;
                          accountMembership: {
                            __typename: "AccountMembership";
                            id: string;
                            user?: {
                              __typename: "User";
                              id: string;
                              firstName?: string | null;
                              preferredLastName?: string | null;
                              fullName?: string | null;
                            } | null;
                          };
                        } | null;
                      }
                    | null;
                  merchant?:
                    | { __typename: "CardInMerchant" }
                    | {
                        __typename: "CardOutMerchant";
                        merchantId: string;
                        merchantCity: string;
                        merchantCountry?: string | null;
                      }
                    | null;
                  enrichedTransactionInfo?: {
                    __typename: "EnrichedTransactionInfo";
                    enrichedMerchantName?: string | null;
                    isSubscription?: boolean | null;
                    carbonFootprint?: string | null;
                    contactEmail?: string | null;
                    contactPhone?: string | null;
                    contactWebsite?: string | null;
                    logoUrl?: string | null;
                    category?: MerchantCategory | null;
                    subcategory?: MerchantSubCategory | null;
                    address?: string | null;
                    city?: string | null;
                    postalCode?: string | null;
                    country?: string | null;
                  } | null;
                  currencyExchange: Array<{
                    __typename: "ReportExchangeRate";
                    exchangeRate: number;
                  }>;
                  payment?: { __typename: "Payment"; id: string; createdAt: string } | null;
                  originTransaction?:
                    | {
                        __typename: "CardTransaction";
                        id: string;
                        type: TransactionTypeEnum;
                        executionDate: string;
                        amount: { __typename: "Amount"; currency: string; value: string };
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              status: TransactionStatus;
                              reason: RejectedReasonCode;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                      }
                    | {
                        __typename: "CheckTransaction";
                        id: string;
                        type: TransactionTypeEnum;
                        executionDate: string;
                        amount: { __typename: "Amount"; currency: string; value: string };
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              status: TransactionStatus;
                              reason: RejectedReasonCode;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                      }
                    | {
                        __typename: "FeeTransaction";
                        id: string;
                        type: TransactionTypeEnum;
                        executionDate: string;
                        amount: { __typename: "Amount"; currency: string; value: string };
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              status: TransactionStatus;
                              reason: RejectedReasonCode;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                      }
                    | {
                        __typename: "InternalCreditTransfer";
                        id: string;
                        type: TransactionTypeEnum;
                        executionDate: string;
                        amount: { __typename: "Amount"; currency: string; value: string };
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              status: TransactionStatus;
                              reason: RejectedReasonCode;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                      }
                    | {
                        __typename: "InternalDirectDebitTransaction";
                        id: string;
                        type: TransactionTypeEnum;
                        executionDate: string;
                        amount: { __typename: "Amount"; currency: string; value: string };
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              status: TransactionStatus;
                              reason: RejectedReasonCode;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                      }
                    | {
                        __typename: "InternationalCreditTransferTransaction";
                        id: string;
                        type: TransactionTypeEnum;
                        executionDate: string;
                        amount: { __typename: "Amount"; currency: string; value: string };
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              status: TransactionStatus;
                              reason: RejectedReasonCode;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                      }
                    | {
                        __typename: "SEPACreditTransferTransaction";
                        id: string;
                        type: TransactionTypeEnum;
                        executionDate: string;
                        amount: { __typename: "Amount"; currency: string; value: string };
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              status: TransactionStatus;
                              reason: RejectedReasonCode;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                      }
                    | {
                        __typename: "SEPADirectDebitTransaction";
                        id: string;
                        type: TransactionTypeEnum;
                        executionDate: string;
                        amount: { __typename: "Amount"; currency: string; value: string };
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              status: TransactionStatus;
                              reason: RejectedReasonCode;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                      }
                    | null;
                  statusInfo:
                    | {
                        __typename: "BookedTransactionStatusInfo";
                        bookingDate: string;
                        status: TransactionStatus;
                      }
                    | {
                        __typename: "CanceledTransactionStatusInfo";
                        canceledDate?: string | null;
                        status: TransactionStatus;
                      }
                    | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                    | {
                        __typename: "PendingTransactionStatusInfo";
                        pendingEndDate?: string | null;
                        status: TransactionStatus;
                      }
                    | {
                        __typename: "RejectedTransactionStatusInfo";
                        reason: RejectedReasonCode;
                        status: TransactionStatus;
                      }
                    | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                    | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                    | {
                        __typename: "UpcomingTransactionStatusInfo";
                        executionDate: string;
                        status: TransactionStatus;
                      };
                  amount: { __typename: "Amount"; currency: string; value: string };
                }
              | {
                  __typename: "CheckTransaction";
                  reservedAmountReleasedAt?: string | null;
                  cmc7: string;
                  rlmcKey: string;
                  id: string;
                  side: TransactionSide;
                  type: TransactionTypeEnum;
                  label: string;
                  counterparty: string;
                  reference: string;
                  externalReference?: string | null;
                  statementCanBeGenerated?: boolean | null;
                  createdAt: string;
                  executionDate: string;
                  updatedAt: string;
                  reservedAmount?: { __typename: "Amount"; currency: string; value: string } | null;
                  payment?: { __typename: "Payment"; id: string; createdAt: string } | null;
                  originTransaction?:
                    | {
                        __typename: "CardTransaction";
                        id: string;
                        type: TransactionTypeEnum;
                        executionDate: string;
                        amount: { __typename: "Amount"; currency: string; value: string };
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              status: TransactionStatus;
                              reason: RejectedReasonCode;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                      }
                    | {
                        __typename: "CheckTransaction";
                        id: string;
                        type: TransactionTypeEnum;
                        executionDate: string;
                        amount: { __typename: "Amount"; currency: string; value: string };
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              status: TransactionStatus;
                              reason: RejectedReasonCode;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                      }
                    | {
                        __typename: "FeeTransaction";
                        id: string;
                        type: TransactionTypeEnum;
                        executionDate: string;
                        amount: { __typename: "Amount"; currency: string; value: string };
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              status: TransactionStatus;
                              reason: RejectedReasonCode;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                      }
                    | {
                        __typename: "InternalCreditTransfer";
                        id: string;
                        type: TransactionTypeEnum;
                        executionDate: string;
                        amount: { __typename: "Amount"; currency: string; value: string };
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              status: TransactionStatus;
                              reason: RejectedReasonCode;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                      }
                    | {
                        __typename: "InternalDirectDebitTransaction";
                        id: string;
                        type: TransactionTypeEnum;
                        executionDate: string;
                        amount: { __typename: "Amount"; currency: string; value: string };
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              status: TransactionStatus;
                              reason: RejectedReasonCode;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                      }
                    | {
                        __typename: "InternationalCreditTransferTransaction";
                        id: string;
                        type: TransactionTypeEnum;
                        executionDate: string;
                        amount: { __typename: "Amount"; currency: string; value: string };
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              status: TransactionStatus;
                              reason: RejectedReasonCode;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                      }
                    | {
                        __typename: "SEPACreditTransferTransaction";
                        id: string;
                        type: TransactionTypeEnum;
                        executionDate: string;
                        amount: { __typename: "Amount"; currency: string; value: string };
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              status: TransactionStatus;
                              reason: RejectedReasonCode;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                      }
                    | {
                        __typename: "SEPADirectDebitTransaction";
                        id: string;
                        type: TransactionTypeEnum;
                        executionDate: string;
                        amount: { __typename: "Amount"; currency: string; value: string };
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              status: TransactionStatus;
                              reason: RejectedReasonCode;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                      }
                    | null;
                  statusInfo:
                    | {
                        __typename: "BookedTransactionStatusInfo";
                        bookingDate: string;
                        status: TransactionStatus;
                      }
                    | {
                        __typename: "CanceledTransactionStatusInfo";
                        canceledDate?: string | null;
                        status: TransactionStatus;
                      }
                    | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                    | {
                        __typename: "PendingTransactionStatusInfo";
                        pendingEndDate?: string | null;
                        status: TransactionStatus;
                      }
                    | {
                        __typename: "RejectedTransactionStatusInfo";
                        reason: RejectedReasonCode;
                        status: TransactionStatus;
                      }
                    | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                    | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                    | {
                        __typename: "UpcomingTransactionStatusInfo";
                        executionDate: string;
                        status: TransactionStatus;
                      };
                  amount: { __typename: "Amount"; currency: string; value: string };
                }
              | {
                  __typename: "FeeTransaction";
                  feesType: FeesTypeEnum;
                  id: string;
                  side: TransactionSide;
                  type: TransactionTypeEnum;
                  label: string;
                  counterparty: string;
                  reference: string;
                  externalReference?: string | null;
                  statementCanBeGenerated?: boolean | null;
                  createdAt: string;
                  executionDate: string;
                  updatedAt: string;
                  creditor:
                    | { __typename: "FeeInCreditor"; name: string }
                    | { __typename: "FeeOutCreditor"; name: string };
                  originTransaction?:
                    | {
                        __typename: "CardTransaction";
                        id: string;
                        label: string;
                        type: TransactionTypeEnum;
                        updatedAt: string;
                        executionDate: string;
                        createdAt: string;
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              reason: RejectedReasonCode;
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                        amount: { __typename: "Amount"; currency: string; value: string };
                      }
                    | {
                        __typename: "CheckTransaction";
                        id: string;
                        label: string;
                        type: TransactionTypeEnum;
                        updatedAt: string;
                        executionDate: string;
                        createdAt: string;
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              reason: RejectedReasonCode;
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                        amount: { __typename: "Amount"; currency: string; value: string };
                      }
                    | {
                        __typename: "FeeTransaction";
                        id: string;
                        label: string;
                        type: TransactionTypeEnum;
                        updatedAt: string;
                        executionDate: string;
                        createdAt: string;
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              reason: RejectedReasonCode;
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                        amount: { __typename: "Amount"; currency: string; value: string };
                      }
                    | {
                        __typename: "InternalCreditTransfer";
                        id: string;
                        label: string;
                        type: TransactionTypeEnum;
                        updatedAt: string;
                        executionDate: string;
                        createdAt: string;
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              reason: RejectedReasonCode;
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                        amount: { __typename: "Amount"; currency: string; value: string };
                      }
                    | {
                        __typename: "InternalDirectDebitTransaction";
                        id: string;
                        label: string;
                        type: TransactionTypeEnum;
                        updatedAt: string;
                        executionDate: string;
                        createdAt: string;
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              reason: RejectedReasonCode;
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                        amount: { __typename: "Amount"; currency: string; value: string };
                      }
                    | {
                        __typename: "InternationalCreditTransferTransaction";
                        id: string;
                        label: string;
                        type: TransactionTypeEnum;
                        updatedAt: string;
                        executionDate: string;
                        createdAt: string;
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              reason: RejectedReasonCode;
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                        amount: { __typename: "Amount"; currency: string; value: string };
                      }
                    | {
                        __typename: "SEPACreditTransferTransaction";
                        id: string;
                        label: string;
                        type: TransactionTypeEnum;
                        updatedAt: string;
                        executionDate: string;
                        createdAt: string;
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              reason: RejectedReasonCode;
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                        amount: { __typename: "Amount"; currency: string; value: string };
                      }
                    | {
                        __typename: "SEPADirectDebitTransaction";
                        id: string;
                        label: string;
                        type: TransactionTypeEnum;
                        updatedAt: string;
                        executionDate: string;
                        createdAt: string;
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              reason: RejectedReasonCode;
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                        amount: { __typename: "Amount"; currency: string; value: string };
                      }
                    | null;
                  payment?: { __typename: "Payment"; id: string; createdAt: string } | null;
                  statusInfo:
                    | {
                        __typename: "BookedTransactionStatusInfo";
                        bookingDate: string;
                        status: TransactionStatus;
                      }
                    | {
                        __typename: "CanceledTransactionStatusInfo";
                        canceledDate?: string | null;
                        status: TransactionStatus;
                      }
                    | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                    | {
                        __typename: "PendingTransactionStatusInfo";
                        pendingEndDate?: string | null;
                        status: TransactionStatus;
                      }
                    | {
                        __typename: "RejectedTransactionStatusInfo";
                        reason: RejectedReasonCode;
                        status: TransactionStatus;
                      }
                    | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                    | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                    | {
                        __typename: "UpcomingTransactionStatusInfo";
                        executionDate: string;
                        status: TransactionStatus;
                      };
                  amount: { __typename: "Amount"; currency: string; value: string };
                }
              | {
                  __typename: "InternalCreditTransfer";
                  id: string;
                  side: TransactionSide;
                  type: TransactionTypeEnum;
                  label: string;
                  counterparty: string;
                  reference: string;
                  externalReference?: string | null;
                  statementCanBeGenerated?: boolean | null;
                  createdAt: string;
                  executionDate: string;
                  updatedAt: string;
                  creditor:
                    | { __typename: "InternalCreditTransferInCreditor"; name: string }
                    | { __typename: "InternalCreditTransferOutCreditor"; name: string };
                  payment?: { __typename: "Payment"; id: string; createdAt: string } | null;
                  originTransaction?:
                    | {
                        __typename: "CardTransaction";
                        id: string;
                        type: TransactionTypeEnum;
                        executionDate: string;
                        amount: { __typename: "Amount"; currency: string; value: string };
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              status: TransactionStatus;
                              reason: RejectedReasonCode;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                      }
                    | {
                        __typename: "CheckTransaction";
                        id: string;
                        type: TransactionTypeEnum;
                        executionDate: string;
                        amount: { __typename: "Amount"; currency: string; value: string };
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              status: TransactionStatus;
                              reason: RejectedReasonCode;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                      }
                    | {
                        __typename: "FeeTransaction";
                        id: string;
                        type: TransactionTypeEnum;
                        executionDate: string;
                        amount: { __typename: "Amount"; currency: string; value: string };
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              status: TransactionStatus;
                              reason: RejectedReasonCode;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                      }
                    | {
                        __typename: "InternalCreditTransfer";
                        id: string;
                        type: TransactionTypeEnum;
                        executionDate: string;
                        amount: { __typename: "Amount"; currency: string; value: string };
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              status: TransactionStatus;
                              reason: RejectedReasonCode;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                      }
                    | {
                        __typename: "InternalDirectDebitTransaction";
                        id: string;
                        type: TransactionTypeEnum;
                        executionDate: string;
                        amount: { __typename: "Amount"; currency: string; value: string };
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              status: TransactionStatus;
                              reason: RejectedReasonCode;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                      }
                    | {
                        __typename: "InternationalCreditTransferTransaction";
                        id: string;
                        type: TransactionTypeEnum;
                        executionDate: string;
                        amount: { __typename: "Amount"; currency: string; value: string };
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              status: TransactionStatus;
                              reason: RejectedReasonCode;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                      }
                    | {
                        __typename: "SEPACreditTransferTransaction";
                        id: string;
                        type: TransactionTypeEnum;
                        executionDate: string;
                        amount: { __typename: "Amount"; currency: string; value: string };
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              status: TransactionStatus;
                              reason: RejectedReasonCode;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                      }
                    | {
                        __typename: "SEPADirectDebitTransaction";
                        id: string;
                        type: TransactionTypeEnum;
                        executionDate: string;
                        amount: { __typename: "Amount"; currency: string; value: string };
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              status: TransactionStatus;
                              reason: RejectedReasonCode;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                      }
                    | null;
                  statusInfo:
                    | {
                        __typename: "BookedTransactionStatusInfo";
                        bookingDate: string;
                        status: TransactionStatus;
                      }
                    | {
                        __typename: "CanceledTransactionStatusInfo";
                        canceledDate?: string | null;
                        status: TransactionStatus;
                      }
                    | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                    | {
                        __typename: "PendingTransactionStatusInfo";
                        pendingEndDate?: string | null;
                        status: TransactionStatus;
                      }
                    | {
                        __typename: "RejectedTransactionStatusInfo";
                        reason: RejectedReasonCode;
                        status: TransactionStatus;
                      }
                    | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                    | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                    | {
                        __typename: "UpcomingTransactionStatusInfo";
                        executionDate: string;
                        status: TransactionStatus;
                      };
                  amount: { __typename: "Amount"; currency: string; value: string };
                }
              | {
                  __typename: "InternalDirectDebitTransaction";
                  reservedAmountReleasedAt?: string | null;
                  id: string;
                  side: TransactionSide;
                  type: TransactionTypeEnum;
                  label: string;
                  counterparty: string;
                  reference: string;
                  externalReference?: string | null;
                  statementCanBeGenerated?: boolean | null;
                  createdAt: string;
                  executionDate: string;
                  updatedAt: string;
                  reservedAmount?: { __typename: "Amount"; currency: string; value: string } | null;
                  creditor: { __typename: "InternalDirectDebitCreditor"; accountId: string };
                  mandate?:
                    | { __typename: "InternalPaymentDirectDebitMandate"; id: string }
                    | { __typename: "InternalReceivedDirectDebitMandate"; id: string }
                    | null;
                  payment?: { __typename: "Payment"; id: string; createdAt: string } | null;
                  originTransaction?:
                    | {
                        __typename: "CardTransaction";
                        id: string;
                        type: TransactionTypeEnum;
                        executionDate: string;
                        amount: { __typename: "Amount"; currency: string; value: string };
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              status: TransactionStatus;
                              reason: RejectedReasonCode;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                      }
                    | {
                        __typename: "CheckTransaction";
                        id: string;
                        type: TransactionTypeEnum;
                        executionDate: string;
                        amount: { __typename: "Amount"; currency: string; value: string };
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              status: TransactionStatus;
                              reason: RejectedReasonCode;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                      }
                    | {
                        __typename: "FeeTransaction";
                        id: string;
                        type: TransactionTypeEnum;
                        executionDate: string;
                        amount: { __typename: "Amount"; currency: string; value: string };
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              status: TransactionStatus;
                              reason: RejectedReasonCode;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                      }
                    | {
                        __typename: "InternalCreditTransfer";
                        id: string;
                        type: TransactionTypeEnum;
                        executionDate: string;
                        amount: { __typename: "Amount"; currency: string; value: string };
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              status: TransactionStatus;
                              reason: RejectedReasonCode;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                      }
                    | {
                        __typename: "InternalDirectDebitTransaction";
                        id: string;
                        type: TransactionTypeEnum;
                        executionDate: string;
                        amount: { __typename: "Amount"; currency: string; value: string };
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              status: TransactionStatus;
                              reason: RejectedReasonCode;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                      }
                    | {
                        __typename: "InternationalCreditTransferTransaction";
                        id: string;
                        type: TransactionTypeEnum;
                        executionDate: string;
                        amount: { __typename: "Amount"; currency: string; value: string };
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              status: TransactionStatus;
                              reason: RejectedReasonCode;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                      }
                    | {
                        __typename: "SEPACreditTransferTransaction";
                        id: string;
                        type: TransactionTypeEnum;
                        executionDate: string;
                        amount: { __typename: "Amount"; currency: string; value: string };
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              status: TransactionStatus;
                              reason: RejectedReasonCode;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                      }
                    | {
                        __typename: "SEPADirectDebitTransaction";
                        id: string;
                        type: TransactionTypeEnum;
                        executionDate: string;
                        amount: { __typename: "Amount"; currency: string; value: string };
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              status: TransactionStatus;
                              reason: RejectedReasonCode;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                      }
                    | null;
                  statusInfo:
                    | {
                        __typename: "BookedTransactionStatusInfo";
                        bookingDate: string;
                        status: TransactionStatus;
                      }
                    | {
                        __typename: "CanceledTransactionStatusInfo";
                        canceledDate?: string | null;
                        status: TransactionStatus;
                      }
                    | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                    | {
                        __typename: "PendingTransactionStatusInfo";
                        pendingEndDate?: string | null;
                        status: TransactionStatus;
                      }
                    | {
                        __typename: "RejectedTransactionStatusInfo";
                        reason: RejectedReasonCode;
                        status: TransactionStatus;
                      }
                    | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                    | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                    | {
                        __typename: "UpcomingTransactionStatusInfo";
                        executionDate: string;
                        status: TransactionStatus;
                      };
                  amount: { __typename: "Amount"; currency: string; value: string };
                }
              | {
                  __typename: "InternationalCreditTransferTransaction";
                  reference: string;
                  paymentProduct: PaymentProduct;
                  id: string;
                  side: TransactionSide;
                  type: TransactionTypeEnum;
                  label: string;
                  counterparty: string;
                  externalReference?: string | null;
                  statementCanBeGenerated?: boolean | null;
                  createdAt: string;
                  executionDate: string;
                  updatedAt: string;
                  creditor:
                    | { __typename: "InternationalCreditTransferInCreditor"; name: string }
                    | { __typename: "InternationalCreditTransferInDebtor" }
                    | {
                        __typename: "InternationalCreditTransferOutCreditor";
                        name: string;
                        details: Array<{
                          __typename: "InternationalCreditTransferDetails";
                          key: string;
                          value: string;
                        }>;
                      };
                  statusInfo:
                    | {
                        __typename: "BookedTransactionStatusInfo";
                        bookingDate: string;
                        status: TransactionStatus;
                      }
                    | {
                        __typename: "CanceledTransactionStatusInfo";
                        canceledDate?: string | null;
                        status: TransactionStatus;
                      }
                    | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                    | {
                        __typename: "PendingTransactionStatusInfo";
                        pendingEndDate?: string | null;
                        status: TransactionStatus;
                      }
                    | {
                        __typename: "RejectedTransactionStatusInfo";
                        reason: RejectedReasonCode;
                        status: TransactionStatus;
                      }
                    | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                    | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                    | {
                        __typename: "UpcomingTransactionStatusInfo";
                        executionDate: string;
                        status: TransactionStatus;
                      };
                  internationalCurrencyExchange: {
                    __typename: "InternationalCreditTransferCurrencyExchange";
                    exchangeRate: string;
                    sourceAmount?: { __typename: "Amount"; currency: string; value: string } | null;
                    targetAmount?: { __typename: "Amount"; currency: string; value: string } | null;
                  };
                  beneficiary?:
                    | {
                        __typename: "TrustedInternationalBeneficiary";
                        name: string;
                        currency: string;
                        route: InternationalCreditTransferRoute;
                        details: Array<{
                          __typename: "InternationalCreditTransferDetails";
                          key: string;
                          value: string;
                        }>;
                      }
                    | {
                        __typename: "UnsavedInternationalBeneficiary";
                        name: string;
                        currency: string;
                        route: InternationalCreditTransferRoute;
                        details: Array<{
                          __typename: "InternationalCreditTransferDetails";
                          key: string;
                          value: string;
                        }>;
                      }
                    | null;
                  payment?: { __typename: "Payment"; id: string; createdAt: string } | null;
                  originTransaction?:
                    | {
                        __typename: "CardTransaction";
                        id: string;
                        type: TransactionTypeEnum;
                        executionDate: string;
                        amount: { __typename: "Amount"; currency: string; value: string };
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              status: TransactionStatus;
                              reason: RejectedReasonCode;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                      }
                    | {
                        __typename: "CheckTransaction";
                        id: string;
                        type: TransactionTypeEnum;
                        executionDate: string;
                        amount: { __typename: "Amount"; currency: string; value: string };
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              status: TransactionStatus;
                              reason: RejectedReasonCode;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                      }
                    | {
                        __typename: "FeeTransaction";
                        id: string;
                        type: TransactionTypeEnum;
                        executionDate: string;
                        amount: { __typename: "Amount"; currency: string; value: string };
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              status: TransactionStatus;
                              reason: RejectedReasonCode;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                      }
                    | {
                        __typename: "InternalCreditTransfer";
                        id: string;
                        type: TransactionTypeEnum;
                        executionDate: string;
                        amount: { __typename: "Amount"; currency: string; value: string };
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              status: TransactionStatus;
                              reason: RejectedReasonCode;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                      }
                    | {
                        __typename: "InternalDirectDebitTransaction";
                        id: string;
                        type: TransactionTypeEnum;
                        executionDate: string;
                        amount: { __typename: "Amount"; currency: string; value: string };
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              status: TransactionStatus;
                              reason: RejectedReasonCode;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                      }
                    | {
                        __typename: "InternationalCreditTransferTransaction";
                        id: string;
                        type: TransactionTypeEnum;
                        executionDate: string;
                        amount: { __typename: "Amount"; currency: string; value: string };
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              status: TransactionStatus;
                              reason: RejectedReasonCode;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                      }
                    | {
                        __typename: "SEPACreditTransferTransaction";
                        id: string;
                        type: TransactionTypeEnum;
                        executionDate: string;
                        amount: { __typename: "Amount"; currency: string; value: string };
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              status: TransactionStatus;
                              reason: RejectedReasonCode;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                      }
                    | {
                        __typename: "SEPADirectDebitTransaction";
                        id: string;
                        type: TransactionTypeEnum;
                        executionDate: string;
                        amount: { __typename: "Amount"; currency: string; value: string };
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              status: TransactionStatus;
                              reason: RejectedReasonCode;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                      }
                    | null;
                  amount: { __typename: "Amount"; currency: string; value: string };
                }
              | {
                  __typename: "SEPACreditTransferTransaction";
                  id: string;
                  side: TransactionSide;
                  type: TransactionTypeEnum;
                  label: string;
                  counterparty: string;
                  reference: string;
                  externalReference?: string | null;
                  statementCanBeGenerated?: boolean | null;
                  createdAt: string;
                  executionDate: string;
                  updatedAt: string;
                  creditor:
                    | {
                        __typename: "SEPACreditTransferInCreditor";
                        name: string;
                        IBAN?: string | null;
                      }
                    | {
                        __typename: "SEPACreditTransferInternalOutCreditor";
                        name: string;
                        IBAN?: string | null;
                      }
                    | {
                        __typename: "SEPACreditTransferOutCreditor";
                        name: string;
                        IBAN?: string | null;
                      };
                  debtor:
                    | {
                        __typename: "SEPACreditTransferInDebtor";
                        name: string;
                        IBAN?: string | null;
                      }
                    | {
                        __typename: "SEPACreditTransferInternalInDebtor";
                        name: string;
                        IBAN?: string | null;
                      }
                    | {
                        __typename: "SEPACreditTransferOutDebtor";
                        name: string;
                        IBAN?: string | null;
                      };
                  beneficiary?:
                    | {
                        __typename: "TrustedSepaBeneficiary";
                        iban: string;
                        id: string;
                        label: string;
                        name: string;
                        type: BeneficiaryType;
                        createdAt: string;
                        address?: {
                          __typename: "Address";
                          addressLine1?: string | null;
                          addressLine2?: string | null;
                          city?: string | null;
                          country?: string | null;
                          postalCode?: string | null;
                          state?: string | null;
                        } | null;
                        statusInfo:
                          | {
                              __typename: "TrustedBeneficiaryCanceledStatusInfo";
                              status: TrustedBeneficiaryStatus;
                            }
                          | {
                              __typename: "TrustedBeneficiaryConsentPendingStatusInfo";
                              status: TrustedBeneficiaryStatus;
                            }
                          | {
                              __typename: "TrustedBeneficiaryEnabledStatusInfo";
                              status: TrustedBeneficiaryStatus;
                            };
                      }
                    | {
                        __typename: "UnsavedSepaBeneficiary";
                        name: string;
                        iban: string;
                        address?: {
                          __typename: "Address";
                          addressLine1?: string | null;
                          addressLine2?: string | null;
                          city?: string | null;
                          country?: string | null;
                          postalCode?: string | null;
                          state?: string | null;
                        } | null;
                      }
                    | null;
                  payment?: { __typename: "Payment"; id: string; createdAt: string } | null;
                  originTransaction?:
                    | {
                        __typename: "CardTransaction";
                        id: string;
                        type: TransactionTypeEnum;
                        executionDate: string;
                        amount: { __typename: "Amount"; currency: string; value: string };
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              status: TransactionStatus;
                              reason: RejectedReasonCode;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                      }
                    | {
                        __typename: "CheckTransaction";
                        id: string;
                        type: TransactionTypeEnum;
                        executionDate: string;
                        amount: { __typename: "Amount"; currency: string; value: string };
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              status: TransactionStatus;
                              reason: RejectedReasonCode;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                      }
                    | {
                        __typename: "FeeTransaction";
                        id: string;
                        type: TransactionTypeEnum;
                        executionDate: string;
                        amount: { __typename: "Amount"; currency: string; value: string };
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              status: TransactionStatus;
                              reason: RejectedReasonCode;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                      }
                    | {
                        __typename: "InternalCreditTransfer";
                        id: string;
                        type: TransactionTypeEnum;
                        executionDate: string;
                        amount: { __typename: "Amount"; currency: string; value: string };
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              status: TransactionStatus;
                              reason: RejectedReasonCode;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                      }
                    | {
                        __typename: "InternalDirectDebitTransaction";
                        id: string;
                        type: TransactionTypeEnum;
                        executionDate: string;
                        amount: { __typename: "Amount"; currency: string; value: string };
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              status: TransactionStatus;
                              reason: RejectedReasonCode;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                      }
                    | {
                        __typename: "InternationalCreditTransferTransaction";
                        id: string;
                        type: TransactionTypeEnum;
                        executionDate: string;
                        amount: { __typename: "Amount"; currency: string; value: string };
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              status: TransactionStatus;
                              reason: RejectedReasonCode;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                      }
                    | {
                        __typename: "SEPACreditTransferTransaction";
                        id: string;
                        type: TransactionTypeEnum;
                        executionDate: string;
                        amount: { __typename: "Amount"; currency: string; value: string };
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              status: TransactionStatus;
                              reason: RejectedReasonCode;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                      }
                    | {
                        __typename: "SEPADirectDebitTransaction";
                        id: string;
                        type: TransactionTypeEnum;
                        executionDate: string;
                        amount: { __typename: "Amount"; currency: string; value: string };
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              status: TransactionStatus;
                              reason: RejectedReasonCode;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                      }
                    | null;
                  statusInfo:
                    | {
                        __typename: "BookedTransactionStatusInfo";
                        bookingDate: string;
                        status: TransactionStatus;
                      }
                    | {
                        __typename: "CanceledTransactionStatusInfo";
                        canceledDate?: string | null;
                        status: TransactionStatus;
                      }
                    | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                    | {
                        __typename: "PendingTransactionStatusInfo";
                        pendingEndDate?: string | null;
                        status: TransactionStatus;
                      }
                    | {
                        __typename: "RejectedTransactionStatusInfo";
                        reason: RejectedReasonCode;
                        status: TransactionStatus;
                      }
                    | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                    | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                    | {
                        __typename: "UpcomingTransactionStatusInfo";
                        executionDate: string;
                        status: TransactionStatus;
                      };
                  amount: { __typename: "Amount"; currency: string; value: string };
                }
              | {
                  __typename: "SEPADirectDebitTransaction";
                  reservedAmountReleasedAt?: string | null;
                  id: string;
                  side: TransactionSide;
                  type: TransactionTypeEnum;
                  label: string;
                  counterparty: string;
                  reference: string;
                  externalReference?: string | null;
                  statementCanBeGenerated?: boolean | null;
                  createdAt: string;
                  executionDate: string;
                  updatedAt: string;
                  creditor:
                    | {
                        __typename: "SEPADirectDebitInCreditor";
                        name: string;
                        IBAN?: string | null;
                      }
                    | {
                        __typename: "SEPADirectDebitOutCreditor";
                        name: string;
                        IBAN?: string | null;
                      };
                  debtor:
                    | { __typename: "SEPADirectDebitInDebtor"; name: string; IBAN?: string | null }
                    | {
                        __typename: "SEPADirectDebitOutDebtor";
                        name: string;
                        IBAN?: string | null;
                      };
                  reservedAmount?: { __typename: "Amount"; value: string; currency: string } | null;
                  mandate?:
                    | {
                        __typename: "SEPAPaymentDirectDebitMandate";
                        id: string;
                        debtor: { __typename: "SEPAPaymentMandateDebtor"; name: string };
                      }
                    | {
                        __typename: "SEPAReceivedDirectDebitMandate";
                        ultimateCreditorName?: string | null;
                        id: string;
                      }
                    | null;
                  payment?: { __typename: "Payment"; id: string; createdAt: string } | null;
                  originTransaction?:
                    | {
                        __typename: "CardTransaction";
                        id: string;
                        type: TransactionTypeEnum;
                        executionDate: string;
                        amount: { __typename: "Amount"; currency: string; value: string };
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              status: TransactionStatus;
                              reason: RejectedReasonCode;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                      }
                    | {
                        __typename: "CheckTransaction";
                        id: string;
                        type: TransactionTypeEnum;
                        executionDate: string;
                        amount: { __typename: "Amount"; currency: string; value: string };
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              status: TransactionStatus;
                              reason: RejectedReasonCode;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                      }
                    | {
                        __typename: "FeeTransaction";
                        id: string;
                        type: TransactionTypeEnum;
                        executionDate: string;
                        amount: { __typename: "Amount"; currency: string; value: string };
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              status: TransactionStatus;
                              reason: RejectedReasonCode;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                      }
                    | {
                        __typename: "InternalCreditTransfer";
                        id: string;
                        type: TransactionTypeEnum;
                        executionDate: string;
                        amount: { __typename: "Amount"; currency: string; value: string };
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              status: TransactionStatus;
                              reason: RejectedReasonCode;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                      }
                    | {
                        __typename: "InternalDirectDebitTransaction";
                        id: string;
                        type: TransactionTypeEnum;
                        executionDate: string;
                        amount: { __typename: "Amount"; currency: string; value: string };
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              status: TransactionStatus;
                              reason: RejectedReasonCode;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                      }
                    | {
                        __typename: "InternationalCreditTransferTransaction";
                        id: string;
                        type: TransactionTypeEnum;
                        executionDate: string;
                        amount: { __typename: "Amount"; currency: string; value: string };
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              status: TransactionStatus;
                              reason: RejectedReasonCode;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                      }
                    | {
                        __typename: "SEPACreditTransferTransaction";
                        id: string;
                        type: TransactionTypeEnum;
                        executionDate: string;
                        amount: { __typename: "Amount"; currency: string; value: string };
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              status: TransactionStatus;
                              reason: RejectedReasonCode;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                      }
                    | {
                        __typename: "SEPADirectDebitTransaction";
                        id: string;
                        type: TransactionTypeEnum;
                        executionDate: string;
                        amount: { __typename: "Amount"; currency: string; value: string };
                        statusInfo:
                          | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                          | {
                              __typename: "CanceledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "DeferredTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "PendingTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "RejectedTransactionStatusInfo";
                              status: TransactionStatus;
                              reason: RejectedReasonCode;
                            }
                          | {
                              __typename: "ReleasedTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "SettledTransactionStatusInfo";
                              status: TransactionStatus;
                            }
                          | {
                              __typename: "UpcomingTransactionStatusInfo";
                              status: TransactionStatus;
                            };
                      }
                    | null;
                  statusInfo:
                    | {
                        __typename: "BookedTransactionStatusInfo";
                        bookingDate: string;
                        status: TransactionStatus;
                      }
                    | {
                        __typename: "CanceledTransactionStatusInfo";
                        canceledDate?: string | null;
                        status: TransactionStatus;
                      }
                    | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                    | {
                        __typename: "PendingTransactionStatusInfo";
                        pendingEndDate?: string | null;
                        status: TransactionStatus;
                      }
                    | {
                        __typename: "RejectedTransactionStatusInfo";
                        reason: RejectedReasonCode;
                        status: TransactionStatus;
                      }
                    | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                    | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                    | {
                        __typename: "UpcomingTransactionStatusInfo";
                        executionDate: string;
                        status: TransactionStatus;
                      };
                  amount: { __typename: "Amount"; currency: string; value: string };
                };
          }>;
        } | null;
      }
    | null;
};

export type AddSepaBeneficiaryMutationVariables = Exact<{
  input: AddTrustedSepaBeneficiaryInput;
}>;

export type AddSepaBeneficiaryMutation = {
  __typename: "Mutation";
  addTrustedSepaBeneficiary?:
    | { __typename: "AccountNotFoundRejection" }
    | {
        __typename: "AddTrustedSepaBeneficiarySuccessPayload";
        trustedBeneficiary: {
          __typename: "TrustedSepaBeneficiary";
          id: string;
          statusInfo:
            | { __typename: "TrustedBeneficiaryCanceledStatusInfo" }
            | {
                __typename: "TrustedBeneficiaryConsentPendingStatusInfo";
                consent: { __typename: "Consent"; id: string; consentUrl: string };
              }
            | { __typename: "TrustedBeneficiaryEnabledStatusInfo" };
        };
      }
    | { __typename: "ForbiddenRejection" }
    | { __typename: "InternalErrorRejection" }
    | {
        __typename: "ValidationRejection";
        fields: Array<{ __typename: "ValidationFieldError"; path: Array<string> }>;
      }
    | null;
};

export type AddInternationalBeneficiaryMutationVariables = Exact<{
  input: AddTrustedInternationalBeneficiaryInput;
}>;

export type AddInternationalBeneficiaryMutation = {
  __typename: "Mutation";
  addTrustedInternationalBeneficiary?:
    | { __typename: "AccountNotFoundRejection" }
    | {
        __typename: "AddTrustedInternationalBeneficiarySuccessPayload";
        trustedBeneficiary: {
          __typename: "TrustedInternationalBeneficiary";
          id: string;
          statusInfo:
            | { __typename: "TrustedBeneficiaryCanceledStatusInfo" }
            | {
                __typename: "TrustedBeneficiaryConsentPendingStatusInfo";
                consent: { __typename: "Consent"; id: string; consentUrl: string };
              }
            | { __typename: "TrustedBeneficiaryEnabledStatusInfo" };
        };
      }
    | { __typename: "ForbiddenRejection" }
    | { __typename: "InternalErrorRejection" }
    | {
        __typename: "ValidationRejection";
        fields: Array<{ __typename: "ValidationFieldError"; path: Array<string> }>;
      }
    | null;
};

export type TransactionQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
  canQueryCardOnTransaction: Scalars["Boolean"]["input"];
}>;

export type TransactionQuery = {
  __typename: "Query";
  transaction:
    | {
        __typename: "CardTransaction";
        reservedAmountReleasedAt?: string | null;
        id: string;
        side: TransactionSide;
        type: TransactionTypeEnum;
        label: string;
        counterparty: string;
        reference: string;
        externalReference?: string | null;
        statementCanBeGenerated?: boolean | null;
        createdAt: string;
        executionDate: string;
        updatedAt: string;
        originalAmount: { __typename: "Amount"; currency: string; value: string };
        reservedAmount?: { __typename: "Amount"; currency: string; value: string } | null;
        cardDetails?:
          | {
              __typename: "CardInDetails";
              paymentMandate: {
                __typename: "CardPaymentMandate";
                id: string;
                name?: string | null;
                createdAt: string;
                updatedAt: string;
                executedAt?: string | null;
              };
            }
          | {
              __typename: "CardOutDetails";
              maskedPan: string;
              card?: {
                __typename: "Card";
                id: string;
                name?: string | null;
                accountMembership: {
                  __typename: "AccountMembership";
                  id: string;
                  user?: {
                    __typename: "User";
                    id: string;
                    firstName?: string | null;
                    preferredLastName?: string | null;
                    fullName?: string | null;
                  } | null;
                };
              } | null;
            }
          | null;
        merchant?:
          | { __typename: "CardInMerchant" }
          | {
              __typename: "CardOutMerchant";
              merchantId: string;
              merchantCity: string;
              merchantCountry?: string | null;
            }
          | null;
        enrichedTransactionInfo?: {
          __typename: "EnrichedTransactionInfo";
          enrichedMerchantName?: string | null;
          isSubscription?: boolean | null;
          carbonFootprint?: string | null;
          contactEmail?: string | null;
          contactPhone?: string | null;
          contactWebsite?: string | null;
          logoUrl?: string | null;
          category?: MerchantCategory | null;
          subcategory?: MerchantSubCategory | null;
          address?: string | null;
          city?: string | null;
          postalCode?: string | null;
          country?: string | null;
        } | null;
        currencyExchange: Array<{ __typename: "ReportExchangeRate"; exchangeRate: number }>;
        payment?: { __typename: "Payment"; id: string; createdAt: string } | null;
        originTransaction?:
          | {
              __typename: "CardTransaction";
              id: string;
              type: TransactionTypeEnum;
              executionDate: string;
              amount: { __typename: "Amount"; currency: string; value: string };
              statusInfo:
                | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                | {
                    __typename: "RejectedTransactionStatusInfo";
                    status: TransactionStatus;
                    reason: RejectedReasonCode;
                  }
                | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
            }
          | {
              __typename: "CheckTransaction";
              id: string;
              type: TransactionTypeEnum;
              executionDate: string;
              amount: { __typename: "Amount"; currency: string; value: string };
              statusInfo:
                | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                | {
                    __typename: "RejectedTransactionStatusInfo";
                    status: TransactionStatus;
                    reason: RejectedReasonCode;
                  }
                | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
            }
          | {
              __typename: "FeeTransaction";
              id: string;
              type: TransactionTypeEnum;
              executionDate: string;
              amount: { __typename: "Amount"; currency: string; value: string };
              statusInfo:
                | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                | {
                    __typename: "RejectedTransactionStatusInfo";
                    status: TransactionStatus;
                    reason: RejectedReasonCode;
                  }
                | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
            }
          | {
              __typename: "InternalCreditTransfer";
              id: string;
              type: TransactionTypeEnum;
              executionDate: string;
              amount: { __typename: "Amount"; currency: string; value: string };
              statusInfo:
                | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                | {
                    __typename: "RejectedTransactionStatusInfo";
                    status: TransactionStatus;
                    reason: RejectedReasonCode;
                  }
                | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
            }
          | {
              __typename: "InternalDirectDebitTransaction";
              id: string;
              type: TransactionTypeEnum;
              executionDate: string;
              amount: { __typename: "Amount"; currency: string; value: string };
              statusInfo:
                | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                | {
                    __typename: "RejectedTransactionStatusInfo";
                    status: TransactionStatus;
                    reason: RejectedReasonCode;
                  }
                | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
            }
          | {
              __typename: "InternationalCreditTransferTransaction";
              id: string;
              type: TransactionTypeEnum;
              executionDate: string;
              amount: { __typename: "Amount"; currency: string; value: string };
              statusInfo:
                | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                | {
                    __typename: "RejectedTransactionStatusInfo";
                    status: TransactionStatus;
                    reason: RejectedReasonCode;
                  }
                | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
            }
          | {
              __typename: "SEPACreditTransferTransaction";
              id: string;
              type: TransactionTypeEnum;
              executionDate: string;
              amount: { __typename: "Amount"; currency: string; value: string };
              statusInfo:
                | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                | {
                    __typename: "RejectedTransactionStatusInfo";
                    status: TransactionStatus;
                    reason: RejectedReasonCode;
                  }
                | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
            }
          | {
              __typename: "SEPADirectDebitTransaction";
              id: string;
              type: TransactionTypeEnum;
              executionDate: string;
              amount: { __typename: "Amount"; currency: string; value: string };
              statusInfo:
                | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                | {
                    __typename: "RejectedTransactionStatusInfo";
                    status: TransactionStatus;
                    reason: RejectedReasonCode;
                  }
                | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
            }
          | null;
        statusInfo:
          | {
              __typename: "BookedTransactionStatusInfo";
              bookingDate: string;
              status: TransactionStatus;
            }
          | {
              __typename: "CanceledTransactionStatusInfo";
              canceledDate?: string | null;
              status: TransactionStatus;
            }
          | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
          | {
              __typename: "PendingTransactionStatusInfo";
              pendingEndDate?: string | null;
              status: TransactionStatus;
            }
          | {
              __typename: "RejectedTransactionStatusInfo";
              reason: RejectedReasonCode;
              status: TransactionStatus;
            }
          | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
          | {
              __typename: "UpcomingTransactionStatusInfo";
              executionDate: string;
              status: TransactionStatus;
            };
        amount: { __typename: "Amount"; currency: string; value: string };
      }
    | {
        __typename: "CheckTransaction";
        reservedAmountReleasedAt?: string | null;
        cmc7: string;
        rlmcKey: string;
        id: string;
        side: TransactionSide;
        type: TransactionTypeEnum;
        label: string;
        counterparty: string;
        reference: string;
        externalReference?: string | null;
        statementCanBeGenerated?: boolean | null;
        createdAt: string;
        executionDate: string;
        updatedAt: string;
        reservedAmount?: { __typename: "Amount"; currency: string; value: string } | null;
        payment?: { __typename: "Payment"; id: string; createdAt: string } | null;
        originTransaction?:
          | {
              __typename: "CardTransaction";
              id: string;
              type: TransactionTypeEnum;
              executionDate: string;
              amount: { __typename: "Amount"; currency: string; value: string };
              statusInfo:
                | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                | {
                    __typename: "RejectedTransactionStatusInfo";
                    status: TransactionStatus;
                    reason: RejectedReasonCode;
                  }
                | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
            }
          | {
              __typename: "CheckTransaction";
              id: string;
              type: TransactionTypeEnum;
              executionDate: string;
              amount: { __typename: "Amount"; currency: string; value: string };
              statusInfo:
                | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                | {
                    __typename: "RejectedTransactionStatusInfo";
                    status: TransactionStatus;
                    reason: RejectedReasonCode;
                  }
                | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
            }
          | {
              __typename: "FeeTransaction";
              id: string;
              type: TransactionTypeEnum;
              executionDate: string;
              amount: { __typename: "Amount"; currency: string; value: string };
              statusInfo:
                | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                | {
                    __typename: "RejectedTransactionStatusInfo";
                    status: TransactionStatus;
                    reason: RejectedReasonCode;
                  }
                | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
            }
          | {
              __typename: "InternalCreditTransfer";
              id: string;
              type: TransactionTypeEnum;
              executionDate: string;
              amount: { __typename: "Amount"; currency: string; value: string };
              statusInfo:
                | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                | {
                    __typename: "RejectedTransactionStatusInfo";
                    status: TransactionStatus;
                    reason: RejectedReasonCode;
                  }
                | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
            }
          | {
              __typename: "InternalDirectDebitTransaction";
              id: string;
              type: TransactionTypeEnum;
              executionDate: string;
              amount: { __typename: "Amount"; currency: string; value: string };
              statusInfo:
                | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                | {
                    __typename: "RejectedTransactionStatusInfo";
                    status: TransactionStatus;
                    reason: RejectedReasonCode;
                  }
                | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
            }
          | {
              __typename: "InternationalCreditTransferTransaction";
              id: string;
              type: TransactionTypeEnum;
              executionDate: string;
              amount: { __typename: "Amount"; currency: string; value: string };
              statusInfo:
                | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                | {
                    __typename: "RejectedTransactionStatusInfo";
                    status: TransactionStatus;
                    reason: RejectedReasonCode;
                  }
                | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
            }
          | {
              __typename: "SEPACreditTransferTransaction";
              id: string;
              type: TransactionTypeEnum;
              executionDate: string;
              amount: { __typename: "Amount"; currency: string; value: string };
              statusInfo:
                | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                | {
                    __typename: "RejectedTransactionStatusInfo";
                    status: TransactionStatus;
                    reason: RejectedReasonCode;
                  }
                | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
            }
          | {
              __typename: "SEPADirectDebitTransaction";
              id: string;
              type: TransactionTypeEnum;
              executionDate: string;
              amount: { __typename: "Amount"; currency: string; value: string };
              statusInfo:
                | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                | {
                    __typename: "RejectedTransactionStatusInfo";
                    status: TransactionStatus;
                    reason: RejectedReasonCode;
                  }
                | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
            }
          | null;
        statusInfo:
          | {
              __typename: "BookedTransactionStatusInfo";
              bookingDate: string;
              status: TransactionStatus;
            }
          | {
              __typename: "CanceledTransactionStatusInfo";
              canceledDate?: string | null;
              status: TransactionStatus;
            }
          | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
          | {
              __typename: "PendingTransactionStatusInfo";
              pendingEndDate?: string | null;
              status: TransactionStatus;
            }
          | {
              __typename: "RejectedTransactionStatusInfo";
              reason: RejectedReasonCode;
              status: TransactionStatus;
            }
          | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
          | {
              __typename: "UpcomingTransactionStatusInfo";
              executionDate: string;
              status: TransactionStatus;
            };
        amount: { __typename: "Amount"; currency: string; value: string };
      }
    | {
        __typename: "FeeTransaction";
        feesType: FeesTypeEnum;
        id: string;
        side: TransactionSide;
        type: TransactionTypeEnum;
        label: string;
        counterparty: string;
        reference: string;
        externalReference?: string | null;
        statementCanBeGenerated?: boolean | null;
        createdAt: string;
        executionDate: string;
        updatedAt: string;
        creditor:
          | { __typename: "FeeInCreditor"; name: string }
          | { __typename: "FeeOutCreditor"; name: string };
        originTransaction?:
          | {
              __typename: "CardTransaction";
              id: string;
              label: string;
              type: TransactionTypeEnum;
              updatedAt: string;
              executionDate: string;
              createdAt: string;
              statusInfo:
                | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                | {
                    __typename: "RejectedTransactionStatusInfo";
                    reason: RejectedReasonCode;
                    status: TransactionStatus;
                  }
                | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
              amount: { __typename: "Amount"; currency: string; value: string };
            }
          | {
              __typename: "CheckTransaction";
              id: string;
              label: string;
              type: TransactionTypeEnum;
              updatedAt: string;
              executionDate: string;
              createdAt: string;
              statusInfo:
                | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                | {
                    __typename: "RejectedTransactionStatusInfo";
                    reason: RejectedReasonCode;
                    status: TransactionStatus;
                  }
                | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
              amount: { __typename: "Amount"; currency: string; value: string };
            }
          | {
              __typename: "FeeTransaction";
              id: string;
              label: string;
              type: TransactionTypeEnum;
              updatedAt: string;
              executionDate: string;
              createdAt: string;
              statusInfo:
                | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                | {
                    __typename: "RejectedTransactionStatusInfo";
                    reason: RejectedReasonCode;
                    status: TransactionStatus;
                  }
                | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
              amount: { __typename: "Amount"; currency: string; value: string };
            }
          | {
              __typename: "InternalCreditTransfer";
              id: string;
              label: string;
              type: TransactionTypeEnum;
              updatedAt: string;
              executionDate: string;
              createdAt: string;
              statusInfo:
                | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                | {
                    __typename: "RejectedTransactionStatusInfo";
                    reason: RejectedReasonCode;
                    status: TransactionStatus;
                  }
                | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
              amount: { __typename: "Amount"; currency: string; value: string };
            }
          | {
              __typename: "InternalDirectDebitTransaction";
              id: string;
              label: string;
              type: TransactionTypeEnum;
              updatedAt: string;
              executionDate: string;
              createdAt: string;
              statusInfo:
                | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                | {
                    __typename: "RejectedTransactionStatusInfo";
                    reason: RejectedReasonCode;
                    status: TransactionStatus;
                  }
                | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
              amount: { __typename: "Amount"; currency: string; value: string };
            }
          | {
              __typename: "InternationalCreditTransferTransaction";
              id: string;
              label: string;
              type: TransactionTypeEnum;
              updatedAt: string;
              executionDate: string;
              createdAt: string;
              statusInfo:
                | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                | {
                    __typename: "RejectedTransactionStatusInfo";
                    reason: RejectedReasonCode;
                    status: TransactionStatus;
                  }
                | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
              amount: { __typename: "Amount"; currency: string; value: string };
            }
          | {
              __typename: "SEPACreditTransferTransaction";
              id: string;
              label: string;
              type: TransactionTypeEnum;
              updatedAt: string;
              executionDate: string;
              createdAt: string;
              statusInfo:
                | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                | {
                    __typename: "RejectedTransactionStatusInfo";
                    reason: RejectedReasonCode;
                    status: TransactionStatus;
                  }
                | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
              amount: { __typename: "Amount"; currency: string; value: string };
            }
          | {
              __typename: "SEPADirectDebitTransaction";
              id: string;
              label: string;
              type: TransactionTypeEnum;
              updatedAt: string;
              executionDate: string;
              createdAt: string;
              statusInfo:
                | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                | {
                    __typename: "RejectedTransactionStatusInfo";
                    reason: RejectedReasonCode;
                    status: TransactionStatus;
                  }
                | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
              amount: { __typename: "Amount"; currency: string; value: string };
            }
          | null;
        payment?: { __typename: "Payment"; id: string; createdAt: string } | null;
        statusInfo:
          | {
              __typename: "BookedTransactionStatusInfo";
              bookingDate: string;
              status: TransactionStatus;
            }
          | {
              __typename: "CanceledTransactionStatusInfo";
              canceledDate?: string | null;
              status: TransactionStatus;
            }
          | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
          | {
              __typename: "PendingTransactionStatusInfo";
              pendingEndDate?: string | null;
              status: TransactionStatus;
            }
          | {
              __typename: "RejectedTransactionStatusInfo";
              reason: RejectedReasonCode;
              status: TransactionStatus;
            }
          | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
          | {
              __typename: "UpcomingTransactionStatusInfo";
              executionDate: string;
              status: TransactionStatus;
            };
        amount: { __typename: "Amount"; currency: string; value: string };
      }
    | {
        __typename: "InternalCreditTransfer";
        id: string;
        side: TransactionSide;
        type: TransactionTypeEnum;
        label: string;
        counterparty: string;
        reference: string;
        externalReference?: string | null;
        statementCanBeGenerated?: boolean | null;
        createdAt: string;
        executionDate: string;
        updatedAt: string;
        creditor:
          | { __typename: "InternalCreditTransferInCreditor"; name: string }
          | { __typename: "InternalCreditTransferOutCreditor"; name: string };
        payment?: { __typename: "Payment"; id: string; createdAt: string } | null;
        originTransaction?:
          | {
              __typename: "CardTransaction";
              id: string;
              type: TransactionTypeEnum;
              executionDate: string;
              amount: { __typename: "Amount"; currency: string; value: string };
              statusInfo:
                | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                | {
                    __typename: "RejectedTransactionStatusInfo";
                    status: TransactionStatus;
                    reason: RejectedReasonCode;
                  }
                | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
            }
          | {
              __typename: "CheckTransaction";
              id: string;
              type: TransactionTypeEnum;
              executionDate: string;
              amount: { __typename: "Amount"; currency: string; value: string };
              statusInfo:
                | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                | {
                    __typename: "RejectedTransactionStatusInfo";
                    status: TransactionStatus;
                    reason: RejectedReasonCode;
                  }
                | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
            }
          | {
              __typename: "FeeTransaction";
              id: string;
              type: TransactionTypeEnum;
              executionDate: string;
              amount: { __typename: "Amount"; currency: string; value: string };
              statusInfo:
                | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                | {
                    __typename: "RejectedTransactionStatusInfo";
                    status: TransactionStatus;
                    reason: RejectedReasonCode;
                  }
                | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
            }
          | {
              __typename: "InternalCreditTransfer";
              id: string;
              type: TransactionTypeEnum;
              executionDate: string;
              amount: { __typename: "Amount"; currency: string; value: string };
              statusInfo:
                | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                | {
                    __typename: "RejectedTransactionStatusInfo";
                    status: TransactionStatus;
                    reason: RejectedReasonCode;
                  }
                | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
            }
          | {
              __typename: "InternalDirectDebitTransaction";
              id: string;
              type: TransactionTypeEnum;
              executionDate: string;
              amount: { __typename: "Amount"; currency: string; value: string };
              statusInfo:
                | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                | {
                    __typename: "RejectedTransactionStatusInfo";
                    status: TransactionStatus;
                    reason: RejectedReasonCode;
                  }
                | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
            }
          | {
              __typename: "InternationalCreditTransferTransaction";
              id: string;
              type: TransactionTypeEnum;
              executionDate: string;
              amount: { __typename: "Amount"; currency: string; value: string };
              statusInfo:
                | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                | {
                    __typename: "RejectedTransactionStatusInfo";
                    status: TransactionStatus;
                    reason: RejectedReasonCode;
                  }
                | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
            }
          | {
              __typename: "SEPACreditTransferTransaction";
              id: string;
              type: TransactionTypeEnum;
              executionDate: string;
              amount: { __typename: "Amount"; currency: string; value: string };
              statusInfo:
                | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                | {
                    __typename: "RejectedTransactionStatusInfo";
                    status: TransactionStatus;
                    reason: RejectedReasonCode;
                  }
                | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
            }
          | {
              __typename: "SEPADirectDebitTransaction";
              id: string;
              type: TransactionTypeEnum;
              executionDate: string;
              amount: { __typename: "Amount"; currency: string; value: string };
              statusInfo:
                | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                | {
                    __typename: "RejectedTransactionStatusInfo";
                    status: TransactionStatus;
                    reason: RejectedReasonCode;
                  }
                | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
            }
          | null;
        statusInfo:
          | {
              __typename: "BookedTransactionStatusInfo";
              bookingDate: string;
              status: TransactionStatus;
            }
          | {
              __typename: "CanceledTransactionStatusInfo";
              canceledDate?: string | null;
              status: TransactionStatus;
            }
          | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
          | {
              __typename: "PendingTransactionStatusInfo";
              pendingEndDate?: string | null;
              status: TransactionStatus;
            }
          | {
              __typename: "RejectedTransactionStatusInfo";
              reason: RejectedReasonCode;
              status: TransactionStatus;
            }
          | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
          | {
              __typename: "UpcomingTransactionStatusInfo";
              executionDate: string;
              status: TransactionStatus;
            };
        amount: { __typename: "Amount"; currency: string; value: string };
      }
    | {
        __typename: "InternalDirectDebitTransaction";
        reservedAmountReleasedAt?: string | null;
        id: string;
        side: TransactionSide;
        type: TransactionTypeEnum;
        label: string;
        counterparty: string;
        reference: string;
        externalReference?: string | null;
        statementCanBeGenerated?: boolean | null;
        createdAt: string;
        executionDate: string;
        updatedAt: string;
        reservedAmount?: { __typename: "Amount"; currency: string; value: string } | null;
        creditor: { __typename: "InternalDirectDebitCreditor"; accountId: string };
        mandate?:
          | { __typename: "InternalPaymentDirectDebitMandate"; id: string }
          | { __typename: "InternalReceivedDirectDebitMandate"; id: string }
          | null;
        payment?: { __typename: "Payment"; id: string; createdAt: string } | null;
        originTransaction?:
          | {
              __typename: "CardTransaction";
              id: string;
              type: TransactionTypeEnum;
              executionDate: string;
              amount: { __typename: "Amount"; currency: string; value: string };
              statusInfo:
                | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                | {
                    __typename: "RejectedTransactionStatusInfo";
                    status: TransactionStatus;
                    reason: RejectedReasonCode;
                  }
                | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
            }
          | {
              __typename: "CheckTransaction";
              id: string;
              type: TransactionTypeEnum;
              executionDate: string;
              amount: { __typename: "Amount"; currency: string; value: string };
              statusInfo:
                | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                | {
                    __typename: "RejectedTransactionStatusInfo";
                    status: TransactionStatus;
                    reason: RejectedReasonCode;
                  }
                | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
            }
          | {
              __typename: "FeeTransaction";
              id: string;
              type: TransactionTypeEnum;
              executionDate: string;
              amount: { __typename: "Amount"; currency: string; value: string };
              statusInfo:
                | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                | {
                    __typename: "RejectedTransactionStatusInfo";
                    status: TransactionStatus;
                    reason: RejectedReasonCode;
                  }
                | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
            }
          | {
              __typename: "InternalCreditTransfer";
              id: string;
              type: TransactionTypeEnum;
              executionDate: string;
              amount: { __typename: "Amount"; currency: string; value: string };
              statusInfo:
                | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                | {
                    __typename: "RejectedTransactionStatusInfo";
                    status: TransactionStatus;
                    reason: RejectedReasonCode;
                  }
                | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
            }
          | {
              __typename: "InternalDirectDebitTransaction";
              id: string;
              type: TransactionTypeEnum;
              executionDate: string;
              amount: { __typename: "Amount"; currency: string; value: string };
              statusInfo:
                | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                | {
                    __typename: "RejectedTransactionStatusInfo";
                    status: TransactionStatus;
                    reason: RejectedReasonCode;
                  }
                | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
            }
          | {
              __typename: "InternationalCreditTransferTransaction";
              id: string;
              type: TransactionTypeEnum;
              executionDate: string;
              amount: { __typename: "Amount"; currency: string; value: string };
              statusInfo:
                | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                | {
                    __typename: "RejectedTransactionStatusInfo";
                    status: TransactionStatus;
                    reason: RejectedReasonCode;
                  }
                | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
            }
          | {
              __typename: "SEPACreditTransferTransaction";
              id: string;
              type: TransactionTypeEnum;
              executionDate: string;
              amount: { __typename: "Amount"; currency: string; value: string };
              statusInfo:
                | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                | {
                    __typename: "RejectedTransactionStatusInfo";
                    status: TransactionStatus;
                    reason: RejectedReasonCode;
                  }
                | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
            }
          | {
              __typename: "SEPADirectDebitTransaction";
              id: string;
              type: TransactionTypeEnum;
              executionDate: string;
              amount: { __typename: "Amount"; currency: string; value: string };
              statusInfo:
                | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                | {
                    __typename: "RejectedTransactionStatusInfo";
                    status: TransactionStatus;
                    reason: RejectedReasonCode;
                  }
                | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
            }
          | null;
        statusInfo:
          | {
              __typename: "BookedTransactionStatusInfo";
              bookingDate: string;
              status: TransactionStatus;
            }
          | {
              __typename: "CanceledTransactionStatusInfo";
              canceledDate?: string | null;
              status: TransactionStatus;
            }
          | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
          | {
              __typename: "PendingTransactionStatusInfo";
              pendingEndDate?: string | null;
              status: TransactionStatus;
            }
          | {
              __typename: "RejectedTransactionStatusInfo";
              reason: RejectedReasonCode;
              status: TransactionStatus;
            }
          | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
          | {
              __typename: "UpcomingTransactionStatusInfo";
              executionDate: string;
              status: TransactionStatus;
            };
        amount: { __typename: "Amount"; currency: string; value: string };
      }
    | {
        __typename: "InternationalCreditTransferTransaction";
        reference: string;
        paymentProduct: PaymentProduct;
        id: string;
        side: TransactionSide;
        type: TransactionTypeEnum;
        label: string;
        counterparty: string;
        externalReference?: string | null;
        statementCanBeGenerated?: boolean | null;
        createdAt: string;
        executionDate: string;
        updatedAt: string;
        creditor:
          | { __typename: "InternationalCreditTransferInCreditor"; name: string }
          | { __typename: "InternationalCreditTransferInDebtor" }
          | {
              __typename: "InternationalCreditTransferOutCreditor";
              name: string;
              details: Array<{
                __typename: "InternationalCreditTransferDetails";
                key: string;
                value: string;
              }>;
            };
        statusInfo:
          | {
              __typename: "BookedTransactionStatusInfo";
              bookingDate: string;
              status: TransactionStatus;
            }
          | {
              __typename: "CanceledTransactionStatusInfo";
              canceledDate?: string | null;
              status: TransactionStatus;
            }
          | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
          | {
              __typename: "PendingTransactionStatusInfo";
              pendingEndDate?: string | null;
              status: TransactionStatus;
            }
          | {
              __typename: "RejectedTransactionStatusInfo";
              reason: RejectedReasonCode;
              status: TransactionStatus;
            }
          | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
          | {
              __typename: "UpcomingTransactionStatusInfo";
              executionDate: string;
              status: TransactionStatus;
            };
        internationalCurrencyExchange: {
          __typename: "InternationalCreditTransferCurrencyExchange";
          exchangeRate: string;
          sourceAmount?: { __typename: "Amount"; currency: string; value: string } | null;
          targetAmount?: { __typename: "Amount"; currency: string; value: string } | null;
        };
        beneficiary?:
          | {
              __typename: "TrustedInternationalBeneficiary";
              name: string;
              currency: string;
              route: InternationalCreditTransferRoute;
              details: Array<{
                __typename: "InternationalCreditTransferDetails";
                key: string;
                value: string;
              }>;
            }
          | {
              __typename: "UnsavedInternationalBeneficiary";
              name: string;
              currency: string;
              route: InternationalCreditTransferRoute;
              details: Array<{
                __typename: "InternationalCreditTransferDetails";
                key: string;
                value: string;
              }>;
            }
          | null;
        payment?: { __typename: "Payment"; id: string; createdAt: string } | null;
        originTransaction?:
          | {
              __typename: "CardTransaction";
              id: string;
              type: TransactionTypeEnum;
              executionDate: string;
              amount: { __typename: "Amount"; currency: string; value: string };
              statusInfo:
                | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                | {
                    __typename: "RejectedTransactionStatusInfo";
                    status: TransactionStatus;
                    reason: RejectedReasonCode;
                  }
                | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
            }
          | {
              __typename: "CheckTransaction";
              id: string;
              type: TransactionTypeEnum;
              executionDate: string;
              amount: { __typename: "Amount"; currency: string; value: string };
              statusInfo:
                | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                | {
                    __typename: "RejectedTransactionStatusInfo";
                    status: TransactionStatus;
                    reason: RejectedReasonCode;
                  }
                | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
            }
          | {
              __typename: "FeeTransaction";
              id: string;
              type: TransactionTypeEnum;
              executionDate: string;
              amount: { __typename: "Amount"; currency: string; value: string };
              statusInfo:
                | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                | {
                    __typename: "RejectedTransactionStatusInfo";
                    status: TransactionStatus;
                    reason: RejectedReasonCode;
                  }
                | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
            }
          | {
              __typename: "InternalCreditTransfer";
              id: string;
              type: TransactionTypeEnum;
              executionDate: string;
              amount: { __typename: "Amount"; currency: string; value: string };
              statusInfo:
                | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                | {
                    __typename: "RejectedTransactionStatusInfo";
                    status: TransactionStatus;
                    reason: RejectedReasonCode;
                  }
                | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
            }
          | {
              __typename: "InternalDirectDebitTransaction";
              id: string;
              type: TransactionTypeEnum;
              executionDate: string;
              amount: { __typename: "Amount"; currency: string; value: string };
              statusInfo:
                | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                | {
                    __typename: "RejectedTransactionStatusInfo";
                    status: TransactionStatus;
                    reason: RejectedReasonCode;
                  }
                | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
            }
          | {
              __typename: "InternationalCreditTransferTransaction";
              id: string;
              type: TransactionTypeEnum;
              executionDate: string;
              amount: { __typename: "Amount"; currency: string; value: string };
              statusInfo:
                | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                | {
                    __typename: "RejectedTransactionStatusInfo";
                    status: TransactionStatus;
                    reason: RejectedReasonCode;
                  }
                | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
            }
          | {
              __typename: "SEPACreditTransferTransaction";
              id: string;
              type: TransactionTypeEnum;
              executionDate: string;
              amount: { __typename: "Amount"; currency: string; value: string };
              statusInfo:
                | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                | {
                    __typename: "RejectedTransactionStatusInfo";
                    status: TransactionStatus;
                    reason: RejectedReasonCode;
                  }
                | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
            }
          | {
              __typename: "SEPADirectDebitTransaction";
              id: string;
              type: TransactionTypeEnum;
              executionDate: string;
              amount: { __typename: "Amount"; currency: string; value: string };
              statusInfo:
                | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                | {
                    __typename: "RejectedTransactionStatusInfo";
                    status: TransactionStatus;
                    reason: RejectedReasonCode;
                  }
                | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
            }
          | null;
        amount: { __typename: "Amount"; currency: string; value: string };
      }
    | {
        __typename: "SEPACreditTransferTransaction";
        id: string;
        side: TransactionSide;
        type: TransactionTypeEnum;
        label: string;
        counterparty: string;
        reference: string;
        externalReference?: string | null;
        statementCanBeGenerated?: boolean | null;
        createdAt: string;
        executionDate: string;
        updatedAt: string;
        creditor:
          | { __typename: "SEPACreditTransferInCreditor"; name: string; IBAN?: string | null }
          | {
              __typename: "SEPACreditTransferInternalOutCreditor";
              name: string;
              IBAN?: string | null;
            }
          | { __typename: "SEPACreditTransferOutCreditor"; name: string; IBAN?: string | null };
        debtor:
          | { __typename: "SEPACreditTransferInDebtor"; name: string; IBAN?: string | null }
          | { __typename: "SEPACreditTransferInternalInDebtor"; name: string; IBAN?: string | null }
          | { __typename: "SEPACreditTransferOutDebtor"; name: string; IBAN?: string | null };
        beneficiary?:
          | {
              __typename: "TrustedSepaBeneficiary";
              iban: string;
              id: string;
              label: string;
              name: string;
              type: BeneficiaryType;
              createdAt: string;
              address?: {
                __typename: "Address";
                addressLine1?: string | null;
                addressLine2?: string | null;
                city?: string | null;
                country?: string | null;
                postalCode?: string | null;
                state?: string | null;
              } | null;
              statusInfo:
                | {
                    __typename: "TrustedBeneficiaryCanceledStatusInfo";
                    status: TrustedBeneficiaryStatus;
                  }
                | {
                    __typename: "TrustedBeneficiaryConsentPendingStatusInfo";
                    status: TrustedBeneficiaryStatus;
                  }
                | {
                    __typename: "TrustedBeneficiaryEnabledStatusInfo";
                    status: TrustedBeneficiaryStatus;
                  };
            }
          | {
              __typename: "UnsavedSepaBeneficiary";
              name: string;
              iban: string;
              address?: {
                __typename: "Address";
                addressLine1?: string | null;
                addressLine2?: string | null;
                city?: string | null;
                country?: string | null;
                postalCode?: string | null;
                state?: string | null;
              } | null;
            }
          | null;
        payment?: { __typename: "Payment"; id: string; createdAt: string } | null;
        originTransaction?:
          | {
              __typename: "CardTransaction";
              id: string;
              type: TransactionTypeEnum;
              executionDate: string;
              amount: { __typename: "Amount"; currency: string; value: string };
              statusInfo:
                | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                | {
                    __typename: "RejectedTransactionStatusInfo";
                    status: TransactionStatus;
                    reason: RejectedReasonCode;
                  }
                | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
            }
          | {
              __typename: "CheckTransaction";
              id: string;
              type: TransactionTypeEnum;
              executionDate: string;
              amount: { __typename: "Amount"; currency: string; value: string };
              statusInfo:
                | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                | {
                    __typename: "RejectedTransactionStatusInfo";
                    status: TransactionStatus;
                    reason: RejectedReasonCode;
                  }
                | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
            }
          | {
              __typename: "FeeTransaction";
              id: string;
              type: TransactionTypeEnum;
              executionDate: string;
              amount: { __typename: "Amount"; currency: string; value: string };
              statusInfo:
                | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                | {
                    __typename: "RejectedTransactionStatusInfo";
                    status: TransactionStatus;
                    reason: RejectedReasonCode;
                  }
                | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
            }
          | {
              __typename: "InternalCreditTransfer";
              id: string;
              type: TransactionTypeEnum;
              executionDate: string;
              amount: { __typename: "Amount"; currency: string; value: string };
              statusInfo:
                | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                | {
                    __typename: "RejectedTransactionStatusInfo";
                    status: TransactionStatus;
                    reason: RejectedReasonCode;
                  }
                | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
            }
          | {
              __typename: "InternalDirectDebitTransaction";
              id: string;
              type: TransactionTypeEnum;
              executionDate: string;
              amount: { __typename: "Amount"; currency: string; value: string };
              statusInfo:
                | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                | {
                    __typename: "RejectedTransactionStatusInfo";
                    status: TransactionStatus;
                    reason: RejectedReasonCode;
                  }
                | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
            }
          | {
              __typename: "InternationalCreditTransferTransaction";
              id: string;
              type: TransactionTypeEnum;
              executionDate: string;
              amount: { __typename: "Amount"; currency: string; value: string };
              statusInfo:
                | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                | {
                    __typename: "RejectedTransactionStatusInfo";
                    status: TransactionStatus;
                    reason: RejectedReasonCode;
                  }
                | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
            }
          | {
              __typename: "SEPACreditTransferTransaction";
              id: string;
              type: TransactionTypeEnum;
              executionDate: string;
              amount: { __typename: "Amount"; currency: string; value: string };
              statusInfo:
                | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                | {
                    __typename: "RejectedTransactionStatusInfo";
                    status: TransactionStatus;
                    reason: RejectedReasonCode;
                  }
                | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
            }
          | {
              __typename: "SEPADirectDebitTransaction";
              id: string;
              type: TransactionTypeEnum;
              executionDate: string;
              amount: { __typename: "Amount"; currency: string; value: string };
              statusInfo:
                | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                | {
                    __typename: "RejectedTransactionStatusInfo";
                    status: TransactionStatus;
                    reason: RejectedReasonCode;
                  }
                | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
            }
          | null;
        statusInfo:
          | {
              __typename: "BookedTransactionStatusInfo";
              bookingDate: string;
              status: TransactionStatus;
            }
          | {
              __typename: "CanceledTransactionStatusInfo";
              canceledDate?: string | null;
              status: TransactionStatus;
            }
          | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
          | {
              __typename: "PendingTransactionStatusInfo";
              pendingEndDate?: string | null;
              status: TransactionStatus;
            }
          | {
              __typename: "RejectedTransactionStatusInfo";
              reason: RejectedReasonCode;
              status: TransactionStatus;
            }
          | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
          | {
              __typename: "UpcomingTransactionStatusInfo";
              executionDate: string;
              status: TransactionStatus;
            };
        amount: { __typename: "Amount"; currency: string; value: string };
      }
    | {
        __typename: "SEPADirectDebitTransaction";
        reservedAmountReleasedAt?: string | null;
        id: string;
        side: TransactionSide;
        type: TransactionTypeEnum;
        label: string;
        counterparty: string;
        reference: string;
        externalReference?: string | null;
        statementCanBeGenerated?: boolean | null;
        createdAt: string;
        executionDate: string;
        updatedAt: string;
        creditor:
          | { __typename: "SEPADirectDebitInCreditor"; name: string; IBAN?: string | null }
          | { __typename: "SEPADirectDebitOutCreditor"; name: string; IBAN?: string | null };
        debtor:
          | { __typename: "SEPADirectDebitInDebtor"; name: string; IBAN?: string | null }
          | { __typename: "SEPADirectDebitOutDebtor"; name: string; IBAN?: string | null };
        reservedAmount?: { __typename: "Amount"; value: string; currency: string } | null;
        mandate?:
          | {
              __typename: "SEPAPaymentDirectDebitMandate";
              id: string;
              debtor: { __typename: "SEPAPaymentMandateDebtor"; name: string };
            }
          | {
              __typename: "SEPAReceivedDirectDebitMandate";
              ultimateCreditorName?: string | null;
              id: string;
            }
          | null;
        payment?: { __typename: "Payment"; id: string; createdAt: string } | null;
        originTransaction?:
          | {
              __typename: "CardTransaction";
              id: string;
              type: TransactionTypeEnum;
              executionDate: string;
              amount: { __typename: "Amount"; currency: string; value: string };
              statusInfo:
                | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                | {
                    __typename: "RejectedTransactionStatusInfo";
                    status: TransactionStatus;
                    reason: RejectedReasonCode;
                  }
                | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
            }
          | {
              __typename: "CheckTransaction";
              id: string;
              type: TransactionTypeEnum;
              executionDate: string;
              amount: { __typename: "Amount"; currency: string; value: string };
              statusInfo:
                | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                | {
                    __typename: "RejectedTransactionStatusInfo";
                    status: TransactionStatus;
                    reason: RejectedReasonCode;
                  }
                | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
            }
          | {
              __typename: "FeeTransaction";
              id: string;
              type: TransactionTypeEnum;
              executionDate: string;
              amount: { __typename: "Amount"; currency: string; value: string };
              statusInfo:
                | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                | {
                    __typename: "RejectedTransactionStatusInfo";
                    status: TransactionStatus;
                    reason: RejectedReasonCode;
                  }
                | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
            }
          | {
              __typename: "InternalCreditTransfer";
              id: string;
              type: TransactionTypeEnum;
              executionDate: string;
              amount: { __typename: "Amount"; currency: string; value: string };
              statusInfo:
                | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                | {
                    __typename: "RejectedTransactionStatusInfo";
                    status: TransactionStatus;
                    reason: RejectedReasonCode;
                  }
                | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
            }
          | {
              __typename: "InternalDirectDebitTransaction";
              id: string;
              type: TransactionTypeEnum;
              executionDate: string;
              amount: { __typename: "Amount"; currency: string; value: string };
              statusInfo:
                | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                | {
                    __typename: "RejectedTransactionStatusInfo";
                    status: TransactionStatus;
                    reason: RejectedReasonCode;
                  }
                | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
            }
          | {
              __typename: "InternationalCreditTransferTransaction";
              id: string;
              type: TransactionTypeEnum;
              executionDate: string;
              amount: { __typename: "Amount"; currency: string; value: string };
              statusInfo:
                | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                | {
                    __typename: "RejectedTransactionStatusInfo";
                    status: TransactionStatus;
                    reason: RejectedReasonCode;
                  }
                | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
            }
          | {
              __typename: "SEPACreditTransferTransaction";
              id: string;
              type: TransactionTypeEnum;
              executionDate: string;
              amount: { __typename: "Amount"; currency: string; value: string };
              statusInfo:
                | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                | {
                    __typename: "RejectedTransactionStatusInfo";
                    status: TransactionStatus;
                    reason: RejectedReasonCode;
                  }
                | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
            }
          | {
              __typename: "SEPADirectDebitTransaction";
              id: string;
              type: TransactionTypeEnum;
              executionDate: string;
              amount: { __typename: "Amount"; currency: string; value: string };
              statusInfo:
                | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                | {
                    __typename: "RejectedTransactionStatusInfo";
                    status: TransactionStatus;
                    reason: RejectedReasonCode;
                  }
                | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
            }
          | null;
        statusInfo:
          | {
              __typename: "BookedTransactionStatusInfo";
              bookingDate: string;
              status: TransactionStatus;
            }
          | {
              __typename: "CanceledTransactionStatusInfo";
              canceledDate?: string | null;
              status: TransactionStatus;
            }
          | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
          | {
              __typename: "PendingTransactionStatusInfo";
              pendingEndDate?: string | null;
              status: TransactionStatus;
            }
          | {
              __typename: "RejectedTransactionStatusInfo";
              reason: RejectedReasonCode;
              status: TransactionStatus;
            }
          | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
          | {
              __typename: "UpcomingTransactionStatusInfo";
              executionDate: string;
              status: TransactionStatus;
            };
        amount: { __typename: "Amount"; currency: string; value: string };
      };
};

export type UpcomingTransactionListPageQueryVariables = Exact<{
  accountId: Scalars["ID"]["input"];
  first: Scalars["Int"]["input"];
  canQueryCardOnTransaction: Scalars["Boolean"]["input"];
  after?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type UpcomingTransactionListPageQuery = {
  __typename: "Query";
  account?: {
    __typename: "Account";
    id: string;
    number: string;
    name: string;
    transactions?: {
      __typename: "TransactionConnection";
      totalCount: number;
      pageInfo: { __typename: "PageInfo"; endCursor?: string | null; hasNextPage?: boolean | null };
      edges: Array<{
        __typename: "TransactionEdge";
        node:
          | {
              __typename: "CardTransaction";
              reservedAmountReleasedAt?: string | null;
              id: string;
              side: TransactionSide;
              type: TransactionTypeEnum;
              label: string;
              counterparty: string;
              reference: string;
              externalReference?: string | null;
              statementCanBeGenerated?: boolean | null;
              createdAt: string;
              executionDate: string;
              updatedAt: string;
              originalAmount: { __typename: "Amount"; currency: string; value: string };
              reservedAmount?: { __typename: "Amount"; currency: string; value: string } | null;
              cardDetails?:
                | {
                    __typename: "CardInDetails";
                    paymentMandate: {
                      __typename: "CardPaymentMandate";
                      id: string;
                      name?: string | null;
                      createdAt: string;
                      updatedAt: string;
                      executedAt?: string | null;
                    };
                  }
                | {
                    __typename: "CardOutDetails";
                    maskedPan: string;
                    card?: {
                      __typename: "Card";
                      id: string;
                      name?: string | null;
                      accountMembership: {
                        __typename: "AccountMembership";
                        id: string;
                        user?: {
                          __typename: "User";
                          id: string;
                          firstName?: string | null;
                          preferredLastName?: string | null;
                          fullName?: string | null;
                        } | null;
                      };
                    } | null;
                  }
                | null;
              merchant?:
                | { __typename: "CardInMerchant" }
                | {
                    __typename: "CardOutMerchant";
                    merchantId: string;
                    merchantCity: string;
                    merchantCountry?: string | null;
                  }
                | null;
              enrichedTransactionInfo?: {
                __typename: "EnrichedTransactionInfo";
                enrichedMerchantName?: string | null;
                isSubscription?: boolean | null;
                carbonFootprint?: string | null;
                contactEmail?: string | null;
                contactPhone?: string | null;
                contactWebsite?: string | null;
                logoUrl?: string | null;
                category?: MerchantCategory | null;
                subcategory?: MerchantSubCategory | null;
                address?: string | null;
                city?: string | null;
                postalCode?: string | null;
                country?: string | null;
              } | null;
              currencyExchange: Array<{ __typename: "ReportExchangeRate"; exchangeRate: number }>;
              payment?: { __typename: "Payment"; id: string; createdAt: string } | null;
              originTransaction?:
                | {
                    __typename: "CardTransaction";
                    id: string;
                    type: TransactionTypeEnum;
                    executionDate: string;
                    amount: { __typename: "Amount"; currency: string; value: string };
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          status: TransactionStatus;
                          reason: RejectedReasonCode;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                  }
                | {
                    __typename: "CheckTransaction";
                    id: string;
                    type: TransactionTypeEnum;
                    executionDate: string;
                    amount: { __typename: "Amount"; currency: string; value: string };
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          status: TransactionStatus;
                          reason: RejectedReasonCode;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                  }
                | {
                    __typename: "FeeTransaction";
                    id: string;
                    type: TransactionTypeEnum;
                    executionDate: string;
                    amount: { __typename: "Amount"; currency: string; value: string };
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          status: TransactionStatus;
                          reason: RejectedReasonCode;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                  }
                | {
                    __typename: "InternalCreditTransfer";
                    id: string;
                    type: TransactionTypeEnum;
                    executionDate: string;
                    amount: { __typename: "Amount"; currency: string; value: string };
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          status: TransactionStatus;
                          reason: RejectedReasonCode;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                  }
                | {
                    __typename: "InternalDirectDebitTransaction";
                    id: string;
                    type: TransactionTypeEnum;
                    executionDate: string;
                    amount: { __typename: "Amount"; currency: string; value: string };
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          status: TransactionStatus;
                          reason: RejectedReasonCode;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                  }
                | {
                    __typename: "InternationalCreditTransferTransaction";
                    id: string;
                    type: TransactionTypeEnum;
                    executionDate: string;
                    amount: { __typename: "Amount"; currency: string; value: string };
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          status: TransactionStatus;
                          reason: RejectedReasonCode;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                  }
                | {
                    __typename: "SEPACreditTransferTransaction";
                    id: string;
                    type: TransactionTypeEnum;
                    executionDate: string;
                    amount: { __typename: "Amount"; currency: string; value: string };
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          status: TransactionStatus;
                          reason: RejectedReasonCode;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                  }
                | {
                    __typename: "SEPADirectDebitTransaction";
                    id: string;
                    type: TransactionTypeEnum;
                    executionDate: string;
                    amount: { __typename: "Amount"; currency: string; value: string };
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          status: TransactionStatus;
                          reason: RejectedReasonCode;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                  }
                | null;
              statusInfo:
                | {
                    __typename: "BookedTransactionStatusInfo";
                    bookingDate: string;
                    status: TransactionStatus;
                  }
                | {
                    __typename: "CanceledTransactionStatusInfo";
                    canceledDate?: string | null;
                    status: TransactionStatus;
                  }
                | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                | {
                    __typename: "PendingTransactionStatusInfo";
                    pendingEndDate?: string | null;
                    status: TransactionStatus;
                  }
                | {
                    __typename: "RejectedTransactionStatusInfo";
                    reason: RejectedReasonCode;
                    status: TransactionStatus;
                  }
                | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                | {
                    __typename: "UpcomingTransactionStatusInfo";
                    executionDate: string;
                    status: TransactionStatus;
                  };
              amount: { __typename: "Amount"; currency: string; value: string };
            }
          | {
              __typename: "CheckTransaction";
              reservedAmountReleasedAt?: string | null;
              cmc7: string;
              rlmcKey: string;
              id: string;
              side: TransactionSide;
              type: TransactionTypeEnum;
              label: string;
              counterparty: string;
              reference: string;
              externalReference?: string | null;
              statementCanBeGenerated?: boolean | null;
              createdAt: string;
              executionDate: string;
              updatedAt: string;
              reservedAmount?: { __typename: "Amount"; currency: string; value: string } | null;
              payment?: { __typename: "Payment"; id: string; createdAt: string } | null;
              originTransaction?:
                | {
                    __typename: "CardTransaction";
                    id: string;
                    type: TransactionTypeEnum;
                    executionDate: string;
                    amount: { __typename: "Amount"; currency: string; value: string };
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          status: TransactionStatus;
                          reason: RejectedReasonCode;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                  }
                | {
                    __typename: "CheckTransaction";
                    id: string;
                    type: TransactionTypeEnum;
                    executionDate: string;
                    amount: { __typename: "Amount"; currency: string; value: string };
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          status: TransactionStatus;
                          reason: RejectedReasonCode;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                  }
                | {
                    __typename: "FeeTransaction";
                    id: string;
                    type: TransactionTypeEnum;
                    executionDate: string;
                    amount: { __typename: "Amount"; currency: string; value: string };
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          status: TransactionStatus;
                          reason: RejectedReasonCode;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                  }
                | {
                    __typename: "InternalCreditTransfer";
                    id: string;
                    type: TransactionTypeEnum;
                    executionDate: string;
                    amount: { __typename: "Amount"; currency: string; value: string };
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          status: TransactionStatus;
                          reason: RejectedReasonCode;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                  }
                | {
                    __typename: "InternalDirectDebitTransaction";
                    id: string;
                    type: TransactionTypeEnum;
                    executionDate: string;
                    amount: { __typename: "Amount"; currency: string; value: string };
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          status: TransactionStatus;
                          reason: RejectedReasonCode;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                  }
                | {
                    __typename: "InternationalCreditTransferTransaction";
                    id: string;
                    type: TransactionTypeEnum;
                    executionDate: string;
                    amount: { __typename: "Amount"; currency: string; value: string };
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          status: TransactionStatus;
                          reason: RejectedReasonCode;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                  }
                | {
                    __typename: "SEPACreditTransferTransaction";
                    id: string;
                    type: TransactionTypeEnum;
                    executionDate: string;
                    amount: { __typename: "Amount"; currency: string; value: string };
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          status: TransactionStatus;
                          reason: RejectedReasonCode;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                  }
                | {
                    __typename: "SEPADirectDebitTransaction";
                    id: string;
                    type: TransactionTypeEnum;
                    executionDate: string;
                    amount: { __typename: "Amount"; currency: string; value: string };
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          status: TransactionStatus;
                          reason: RejectedReasonCode;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                  }
                | null;
              statusInfo:
                | {
                    __typename: "BookedTransactionStatusInfo";
                    bookingDate: string;
                    status: TransactionStatus;
                  }
                | {
                    __typename: "CanceledTransactionStatusInfo";
                    canceledDate?: string | null;
                    status: TransactionStatus;
                  }
                | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                | {
                    __typename: "PendingTransactionStatusInfo";
                    pendingEndDate?: string | null;
                    status: TransactionStatus;
                  }
                | {
                    __typename: "RejectedTransactionStatusInfo";
                    reason: RejectedReasonCode;
                    status: TransactionStatus;
                  }
                | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                | {
                    __typename: "UpcomingTransactionStatusInfo";
                    executionDate: string;
                    status: TransactionStatus;
                  };
              amount: { __typename: "Amount"; currency: string; value: string };
            }
          | {
              __typename: "FeeTransaction";
              feesType: FeesTypeEnum;
              id: string;
              side: TransactionSide;
              type: TransactionTypeEnum;
              label: string;
              counterparty: string;
              reference: string;
              externalReference?: string | null;
              statementCanBeGenerated?: boolean | null;
              createdAt: string;
              executionDate: string;
              updatedAt: string;
              creditor:
                | { __typename: "FeeInCreditor"; name: string }
                | { __typename: "FeeOutCreditor"; name: string };
              originTransaction?:
                | {
                    __typename: "CardTransaction";
                    id: string;
                    label: string;
                    type: TransactionTypeEnum;
                    updatedAt: string;
                    executionDate: string;
                    createdAt: string;
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          reason: RejectedReasonCode;
                          status: TransactionStatus;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                    amount: { __typename: "Amount"; currency: string; value: string };
                  }
                | {
                    __typename: "CheckTransaction";
                    id: string;
                    label: string;
                    type: TransactionTypeEnum;
                    updatedAt: string;
                    executionDate: string;
                    createdAt: string;
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          reason: RejectedReasonCode;
                          status: TransactionStatus;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                    amount: { __typename: "Amount"; currency: string; value: string };
                  }
                | {
                    __typename: "FeeTransaction";
                    id: string;
                    label: string;
                    type: TransactionTypeEnum;
                    updatedAt: string;
                    executionDate: string;
                    createdAt: string;
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          reason: RejectedReasonCode;
                          status: TransactionStatus;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                    amount: { __typename: "Amount"; currency: string; value: string };
                  }
                | {
                    __typename: "InternalCreditTransfer";
                    id: string;
                    label: string;
                    type: TransactionTypeEnum;
                    updatedAt: string;
                    executionDate: string;
                    createdAt: string;
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          reason: RejectedReasonCode;
                          status: TransactionStatus;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                    amount: { __typename: "Amount"; currency: string; value: string };
                  }
                | {
                    __typename: "InternalDirectDebitTransaction";
                    id: string;
                    label: string;
                    type: TransactionTypeEnum;
                    updatedAt: string;
                    executionDate: string;
                    createdAt: string;
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          reason: RejectedReasonCode;
                          status: TransactionStatus;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                    amount: { __typename: "Amount"; currency: string; value: string };
                  }
                | {
                    __typename: "InternationalCreditTransferTransaction";
                    id: string;
                    label: string;
                    type: TransactionTypeEnum;
                    updatedAt: string;
                    executionDate: string;
                    createdAt: string;
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          reason: RejectedReasonCode;
                          status: TransactionStatus;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                    amount: { __typename: "Amount"; currency: string; value: string };
                  }
                | {
                    __typename: "SEPACreditTransferTransaction";
                    id: string;
                    label: string;
                    type: TransactionTypeEnum;
                    updatedAt: string;
                    executionDate: string;
                    createdAt: string;
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          reason: RejectedReasonCode;
                          status: TransactionStatus;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                    amount: { __typename: "Amount"; currency: string; value: string };
                  }
                | {
                    __typename: "SEPADirectDebitTransaction";
                    id: string;
                    label: string;
                    type: TransactionTypeEnum;
                    updatedAt: string;
                    executionDate: string;
                    createdAt: string;
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          reason: RejectedReasonCode;
                          status: TransactionStatus;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                    amount: { __typename: "Amount"; currency: string; value: string };
                  }
                | null;
              payment?: { __typename: "Payment"; id: string; createdAt: string } | null;
              statusInfo:
                | {
                    __typename: "BookedTransactionStatusInfo";
                    bookingDate: string;
                    status: TransactionStatus;
                  }
                | {
                    __typename: "CanceledTransactionStatusInfo";
                    canceledDate?: string | null;
                    status: TransactionStatus;
                  }
                | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                | {
                    __typename: "PendingTransactionStatusInfo";
                    pendingEndDate?: string | null;
                    status: TransactionStatus;
                  }
                | {
                    __typename: "RejectedTransactionStatusInfo";
                    reason: RejectedReasonCode;
                    status: TransactionStatus;
                  }
                | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                | {
                    __typename: "UpcomingTransactionStatusInfo";
                    executionDate: string;
                    status: TransactionStatus;
                  };
              amount: { __typename: "Amount"; currency: string; value: string };
            }
          | {
              __typename: "InternalCreditTransfer";
              id: string;
              side: TransactionSide;
              type: TransactionTypeEnum;
              label: string;
              counterparty: string;
              reference: string;
              externalReference?: string | null;
              statementCanBeGenerated?: boolean | null;
              createdAt: string;
              executionDate: string;
              updatedAt: string;
              creditor:
                | { __typename: "InternalCreditTransferInCreditor"; name: string }
                | { __typename: "InternalCreditTransferOutCreditor"; name: string };
              payment?: { __typename: "Payment"; id: string; createdAt: string } | null;
              originTransaction?:
                | {
                    __typename: "CardTransaction";
                    id: string;
                    type: TransactionTypeEnum;
                    executionDate: string;
                    amount: { __typename: "Amount"; currency: string; value: string };
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          status: TransactionStatus;
                          reason: RejectedReasonCode;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                  }
                | {
                    __typename: "CheckTransaction";
                    id: string;
                    type: TransactionTypeEnum;
                    executionDate: string;
                    amount: { __typename: "Amount"; currency: string; value: string };
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          status: TransactionStatus;
                          reason: RejectedReasonCode;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                  }
                | {
                    __typename: "FeeTransaction";
                    id: string;
                    type: TransactionTypeEnum;
                    executionDate: string;
                    amount: { __typename: "Amount"; currency: string; value: string };
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          status: TransactionStatus;
                          reason: RejectedReasonCode;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                  }
                | {
                    __typename: "InternalCreditTransfer";
                    id: string;
                    type: TransactionTypeEnum;
                    executionDate: string;
                    amount: { __typename: "Amount"; currency: string; value: string };
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          status: TransactionStatus;
                          reason: RejectedReasonCode;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                  }
                | {
                    __typename: "InternalDirectDebitTransaction";
                    id: string;
                    type: TransactionTypeEnum;
                    executionDate: string;
                    amount: { __typename: "Amount"; currency: string; value: string };
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          status: TransactionStatus;
                          reason: RejectedReasonCode;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                  }
                | {
                    __typename: "InternationalCreditTransferTransaction";
                    id: string;
                    type: TransactionTypeEnum;
                    executionDate: string;
                    amount: { __typename: "Amount"; currency: string; value: string };
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          status: TransactionStatus;
                          reason: RejectedReasonCode;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                  }
                | {
                    __typename: "SEPACreditTransferTransaction";
                    id: string;
                    type: TransactionTypeEnum;
                    executionDate: string;
                    amount: { __typename: "Amount"; currency: string; value: string };
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          status: TransactionStatus;
                          reason: RejectedReasonCode;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                  }
                | {
                    __typename: "SEPADirectDebitTransaction";
                    id: string;
                    type: TransactionTypeEnum;
                    executionDate: string;
                    amount: { __typename: "Amount"; currency: string; value: string };
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          status: TransactionStatus;
                          reason: RejectedReasonCode;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                  }
                | null;
              statusInfo:
                | {
                    __typename: "BookedTransactionStatusInfo";
                    bookingDate: string;
                    status: TransactionStatus;
                  }
                | {
                    __typename: "CanceledTransactionStatusInfo";
                    canceledDate?: string | null;
                    status: TransactionStatus;
                  }
                | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                | {
                    __typename: "PendingTransactionStatusInfo";
                    pendingEndDate?: string | null;
                    status: TransactionStatus;
                  }
                | {
                    __typename: "RejectedTransactionStatusInfo";
                    reason: RejectedReasonCode;
                    status: TransactionStatus;
                  }
                | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                | {
                    __typename: "UpcomingTransactionStatusInfo";
                    executionDate: string;
                    status: TransactionStatus;
                  };
              amount: { __typename: "Amount"; currency: string; value: string };
            }
          | {
              __typename: "InternalDirectDebitTransaction";
              reservedAmountReleasedAt?: string | null;
              id: string;
              side: TransactionSide;
              type: TransactionTypeEnum;
              label: string;
              counterparty: string;
              reference: string;
              externalReference?: string | null;
              statementCanBeGenerated?: boolean | null;
              createdAt: string;
              executionDate: string;
              updatedAt: string;
              reservedAmount?: { __typename: "Amount"; currency: string; value: string } | null;
              creditor: { __typename: "InternalDirectDebitCreditor"; accountId: string };
              mandate?:
                | { __typename: "InternalPaymentDirectDebitMandate"; id: string }
                | { __typename: "InternalReceivedDirectDebitMandate"; id: string }
                | null;
              payment?: { __typename: "Payment"; id: string; createdAt: string } | null;
              originTransaction?:
                | {
                    __typename: "CardTransaction";
                    id: string;
                    type: TransactionTypeEnum;
                    executionDate: string;
                    amount: { __typename: "Amount"; currency: string; value: string };
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          status: TransactionStatus;
                          reason: RejectedReasonCode;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                  }
                | {
                    __typename: "CheckTransaction";
                    id: string;
                    type: TransactionTypeEnum;
                    executionDate: string;
                    amount: { __typename: "Amount"; currency: string; value: string };
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          status: TransactionStatus;
                          reason: RejectedReasonCode;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                  }
                | {
                    __typename: "FeeTransaction";
                    id: string;
                    type: TransactionTypeEnum;
                    executionDate: string;
                    amount: { __typename: "Amount"; currency: string; value: string };
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          status: TransactionStatus;
                          reason: RejectedReasonCode;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                  }
                | {
                    __typename: "InternalCreditTransfer";
                    id: string;
                    type: TransactionTypeEnum;
                    executionDate: string;
                    amount: { __typename: "Amount"; currency: string; value: string };
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          status: TransactionStatus;
                          reason: RejectedReasonCode;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                  }
                | {
                    __typename: "InternalDirectDebitTransaction";
                    id: string;
                    type: TransactionTypeEnum;
                    executionDate: string;
                    amount: { __typename: "Amount"; currency: string; value: string };
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          status: TransactionStatus;
                          reason: RejectedReasonCode;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                  }
                | {
                    __typename: "InternationalCreditTransferTransaction";
                    id: string;
                    type: TransactionTypeEnum;
                    executionDate: string;
                    amount: { __typename: "Amount"; currency: string; value: string };
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          status: TransactionStatus;
                          reason: RejectedReasonCode;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                  }
                | {
                    __typename: "SEPACreditTransferTransaction";
                    id: string;
                    type: TransactionTypeEnum;
                    executionDate: string;
                    amount: { __typename: "Amount"; currency: string; value: string };
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          status: TransactionStatus;
                          reason: RejectedReasonCode;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                  }
                | {
                    __typename: "SEPADirectDebitTransaction";
                    id: string;
                    type: TransactionTypeEnum;
                    executionDate: string;
                    amount: { __typename: "Amount"; currency: string; value: string };
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          status: TransactionStatus;
                          reason: RejectedReasonCode;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                  }
                | null;
              statusInfo:
                | {
                    __typename: "BookedTransactionStatusInfo";
                    bookingDate: string;
                    status: TransactionStatus;
                  }
                | {
                    __typename: "CanceledTransactionStatusInfo";
                    canceledDate?: string | null;
                    status: TransactionStatus;
                  }
                | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                | {
                    __typename: "PendingTransactionStatusInfo";
                    pendingEndDate?: string | null;
                    status: TransactionStatus;
                  }
                | {
                    __typename: "RejectedTransactionStatusInfo";
                    reason: RejectedReasonCode;
                    status: TransactionStatus;
                  }
                | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                | {
                    __typename: "UpcomingTransactionStatusInfo";
                    executionDate: string;
                    status: TransactionStatus;
                  };
              amount: { __typename: "Amount"; currency: string; value: string };
            }
          | {
              __typename: "InternationalCreditTransferTransaction";
              reference: string;
              paymentProduct: PaymentProduct;
              id: string;
              side: TransactionSide;
              type: TransactionTypeEnum;
              label: string;
              counterparty: string;
              externalReference?: string | null;
              statementCanBeGenerated?: boolean | null;
              createdAt: string;
              executionDate: string;
              updatedAt: string;
              creditor:
                | { __typename: "InternationalCreditTransferInCreditor"; name: string }
                | { __typename: "InternationalCreditTransferInDebtor" }
                | {
                    __typename: "InternationalCreditTransferOutCreditor";
                    name: string;
                    details: Array<{
                      __typename: "InternationalCreditTransferDetails";
                      key: string;
                      value: string;
                    }>;
                  };
              statusInfo:
                | {
                    __typename: "BookedTransactionStatusInfo";
                    bookingDate: string;
                    status: TransactionStatus;
                  }
                | {
                    __typename: "CanceledTransactionStatusInfo";
                    canceledDate?: string | null;
                    status: TransactionStatus;
                  }
                | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                | {
                    __typename: "PendingTransactionStatusInfo";
                    pendingEndDate?: string | null;
                    status: TransactionStatus;
                  }
                | {
                    __typename: "RejectedTransactionStatusInfo";
                    reason: RejectedReasonCode;
                    status: TransactionStatus;
                  }
                | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                | {
                    __typename: "UpcomingTransactionStatusInfo";
                    executionDate: string;
                    status: TransactionStatus;
                  };
              internationalCurrencyExchange: {
                __typename: "InternationalCreditTransferCurrencyExchange";
                exchangeRate: string;
                sourceAmount?: { __typename: "Amount"; currency: string; value: string } | null;
                targetAmount?: { __typename: "Amount"; currency: string; value: string } | null;
              };
              beneficiary?:
                | {
                    __typename: "TrustedInternationalBeneficiary";
                    name: string;
                    currency: string;
                    route: InternationalCreditTransferRoute;
                    details: Array<{
                      __typename: "InternationalCreditTransferDetails";
                      key: string;
                      value: string;
                    }>;
                  }
                | {
                    __typename: "UnsavedInternationalBeneficiary";
                    name: string;
                    currency: string;
                    route: InternationalCreditTransferRoute;
                    details: Array<{
                      __typename: "InternationalCreditTransferDetails";
                      key: string;
                      value: string;
                    }>;
                  }
                | null;
              payment?: { __typename: "Payment"; id: string; createdAt: string } | null;
              originTransaction?:
                | {
                    __typename: "CardTransaction";
                    id: string;
                    type: TransactionTypeEnum;
                    executionDate: string;
                    amount: { __typename: "Amount"; currency: string; value: string };
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          status: TransactionStatus;
                          reason: RejectedReasonCode;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                  }
                | {
                    __typename: "CheckTransaction";
                    id: string;
                    type: TransactionTypeEnum;
                    executionDate: string;
                    amount: { __typename: "Amount"; currency: string; value: string };
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          status: TransactionStatus;
                          reason: RejectedReasonCode;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                  }
                | {
                    __typename: "FeeTransaction";
                    id: string;
                    type: TransactionTypeEnum;
                    executionDate: string;
                    amount: { __typename: "Amount"; currency: string; value: string };
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          status: TransactionStatus;
                          reason: RejectedReasonCode;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                  }
                | {
                    __typename: "InternalCreditTransfer";
                    id: string;
                    type: TransactionTypeEnum;
                    executionDate: string;
                    amount: { __typename: "Amount"; currency: string; value: string };
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          status: TransactionStatus;
                          reason: RejectedReasonCode;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                  }
                | {
                    __typename: "InternalDirectDebitTransaction";
                    id: string;
                    type: TransactionTypeEnum;
                    executionDate: string;
                    amount: { __typename: "Amount"; currency: string; value: string };
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          status: TransactionStatus;
                          reason: RejectedReasonCode;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                  }
                | {
                    __typename: "InternationalCreditTransferTransaction";
                    id: string;
                    type: TransactionTypeEnum;
                    executionDate: string;
                    amount: { __typename: "Amount"; currency: string; value: string };
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          status: TransactionStatus;
                          reason: RejectedReasonCode;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                  }
                | {
                    __typename: "SEPACreditTransferTransaction";
                    id: string;
                    type: TransactionTypeEnum;
                    executionDate: string;
                    amount: { __typename: "Amount"; currency: string; value: string };
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          status: TransactionStatus;
                          reason: RejectedReasonCode;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                  }
                | {
                    __typename: "SEPADirectDebitTransaction";
                    id: string;
                    type: TransactionTypeEnum;
                    executionDate: string;
                    amount: { __typename: "Amount"; currency: string; value: string };
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          status: TransactionStatus;
                          reason: RejectedReasonCode;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                  }
                | null;
              amount: { __typename: "Amount"; currency: string; value: string };
            }
          | {
              __typename: "SEPACreditTransferTransaction";
              id: string;
              side: TransactionSide;
              type: TransactionTypeEnum;
              label: string;
              counterparty: string;
              reference: string;
              externalReference?: string | null;
              statementCanBeGenerated?: boolean | null;
              createdAt: string;
              executionDate: string;
              updatedAt: string;
              creditor:
                | { __typename: "SEPACreditTransferInCreditor"; name: string; IBAN?: string | null }
                | {
                    __typename: "SEPACreditTransferInternalOutCreditor";
                    name: string;
                    IBAN?: string | null;
                  }
                | {
                    __typename: "SEPACreditTransferOutCreditor";
                    name: string;
                    IBAN?: string | null;
                  };
              debtor:
                | { __typename: "SEPACreditTransferInDebtor"; name: string; IBAN?: string | null }
                | {
                    __typename: "SEPACreditTransferInternalInDebtor";
                    name: string;
                    IBAN?: string | null;
                  }
                | { __typename: "SEPACreditTransferOutDebtor"; name: string; IBAN?: string | null };
              beneficiary?:
                | {
                    __typename: "TrustedSepaBeneficiary";
                    iban: string;
                    id: string;
                    label: string;
                    name: string;
                    type: BeneficiaryType;
                    createdAt: string;
                    address?: {
                      __typename: "Address";
                      addressLine1?: string | null;
                      addressLine2?: string | null;
                      city?: string | null;
                      country?: string | null;
                      postalCode?: string | null;
                      state?: string | null;
                    } | null;
                    statusInfo:
                      | {
                          __typename: "TrustedBeneficiaryCanceledStatusInfo";
                          status: TrustedBeneficiaryStatus;
                        }
                      | {
                          __typename: "TrustedBeneficiaryConsentPendingStatusInfo";
                          status: TrustedBeneficiaryStatus;
                        }
                      | {
                          __typename: "TrustedBeneficiaryEnabledStatusInfo";
                          status: TrustedBeneficiaryStatus;
                        };
                  }
                | {
                    __typename: "UnsavedSepaBeneficiary";
                    name: string;
                    iban: string;
                    address?: {
                      __typename: "Address";
                      addressLine1?: string | null;
                      addressLine2?: string | null;
                      city?: string | null;
                      country?: string | null;
                      postalCode?: string | null;
                      state?: string | null;
                    } | null;
                  }
                | null;
              payment?: { __typename: "Payment"; id: string; createdAt: string } | null;
              originTransaction?:
                | {
                    __typename: "CardTransaction";
                    id: string;
                    type: TransactionTypeEnum;
                    executionDate: string;
                    amount: { __typename: "Amount"; currency: string; value: string };
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          status: TransactionStatus;
                          reason: RejectedReasonCode;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                  }
                | {
                    __typename: "CheckTransaction";
                    id: string;
                    type: TransactionTypeEnum;
                    executionDate: string;
                    amount: { __typename: "Amount"; currency: string; value: string };
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          status: TransactionStatus;
                          reason: RejectedReasonCode;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                  }
                | {
                    __typename: "FeeTransaction";
                    id: string;
                    type: TransactionTypeEnum;
                    executionDate: string;
                    amount: { __typename: "Amount"; currency: string; value: string };
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          status: TransactionStatus;
                          reason: RejectedReasonCode;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                  }
                | {
                    __typename: "InternalCreditTransfer";
                    id: string;
                    type: TransactionTypeEnum;
                    executionDate: string;
                    amount: { __typename: "Amount"; currency: string; value: string };
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          status: TransactionStatus;
                          reason: RejectedReasonCode;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                  }
                | {
                    __typename: "InternalDirectDebitTransaction";
                    id: string;
                    type: TransactionTypeEnum;
                    executionDate: string;
                    amount: { __typename: "Amount"; currency: string; value: string };
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          status: TransactionStatus;
                          reason: RejectedReasonCode;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                  }
                | {
                    __typename: "InternationalCreditTransferTransaction";
                    id: string;
                    type: TransactionTypeEnum;
                    executionDate: string;
                    amount: { __typename: "Amount"; currency: string; value: string };
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          status: TransactionStatus;
                          reason: RejectedReasonCode;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                  }
                | {
                    __typename: "SEPACreditTransferTransaction";
                    id: string;
                    type: TransactionTypeEnum;
                    executionDate: string;
                    amount: { __typename: "Amount"; currency: string; value: string };
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          status: TransactionStatus;
                          reason: RejectedReasonCode;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                  }
                | {
                    __typename: "SEPADirectDebitTransaction";
                    id: string;
                    type: TransactionTypeEnum;
                    executionDate: string;
                    amount: { __typename: "Amount"; currency: string; value: string };
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          status: TransactionStatus;
                          reason: RejectedReasonCode;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                  }
                | null;
              statusInfo:
                | {
                    __typename: "BookedTransactionStatusInfo";
                    bookingDate: string;
                    status: TransactionStatus;
                  }
                | {
                    __typename: "CanceledTransactionStatusInfo";
                    canceledDate?: string | null;
                    status: TransactionStatus;
                  }
                | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                | {
                    __typename: "PendingTransactionStatusInfo";
                    pendingEndDate?: string | null;
                    status: TransactionStatus;
                  }
                | {
                    __typename: "RejectedTransactionStatusInfo";
                    reason: RejectedReasonCode;
                    status: TransactionStatus;
                  }
                | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                | {
                    __typename: "UpcomingTransactionStatusInfo";
                    executionDate: string;
                    status: TransactionStatus;
                  };
              amount: { __typename: "Amount"; currency: string; value: string };
            }
          | {
              __typename: "SEPADirectDebitTransaction";
              reservedAmountReleasedAt?: string | null;
              id: string;
              side: TransactionSide;
              type: TransactionTypeEnum;
              label: string;
              counterparty: string;
              reference: string;
              externalReference?: string | null;
              statementCanBeGenerated?: boolean | null;
              createdAt: string;
              executionDate: string;
              updatedAt: string;
              creditor:
                | { __typename: "SEPADirectDebitInCreditor"; name: string; IBAN?: string | null }
                | { __typename: "SEPADirectDebitOutCreditor"; name: string; IBAN?: string | null };
              debtor:
                | { __typename: "SEPADirectDebitInDebtor"; name: string; IBAN?: string | null }
                | { __typename: "SEPADirectDebitOutDebtor"; name: string; IBAN?: string | null };
              reservedAmount?: { __typename: "Amount"; value: string; currency: string } | null;
              mandate?:
                | {
                    __typename: "SEPAPaymentDirectDebitMandate";
                    id: string;
                    debtor: { __typename: "SEPAPaymentMandateDebtor"; name: string };
                  }
                | {
                    __typename: "SEPAReceivedDirectDebitMandate";
                    ultimateCreditorName?: string | null;
                    id: string;
                  }
                | null;
              payment?: { __typename: "Payment"; id: string; createdAt: string } | null;
              originTransaction?:
                | {
                    __typename: "CardTransaction";
                    id: string;
                    type: TransactionTypeEnum;
                    executionDate: string;
                    amount: { __typename: "Amount"; currency: string; value: string };
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          status: TransactionStatus;
                          reason: RejectedReasonCode;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                  }
                | {
                    __typename: "CheckTransaction";
                    id: string;
                    type: TransactionTypeEnum;
                    executionDate: string;
                    amount: { __typename: "Amount"; currency: string; value: string };
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          status: TransactionStatus;
                          reason: RejectedReasonCode;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                  }
                | {
                    __typename: "FeeTransaction";
                    id: string;
                    type: TransactionTypeEnum;
                    executionDate: string;
                    amount: { __typename: "Amount"; currency: string; value: string };
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          status: TransactionStatus;
                          reason: RejectedReasonCode;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                  }
                | {
                    __typename: "InternalCreditTransfer";
                    id: string;
                    type: TransactionTypeEnum;
                    executionDate: string;
                    amount: { __typename: "Amount"; currency: string; value: string };
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          status: TransactionStatus;
                          reason: RejectedReasonCode;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                  }
                | {
                    __typename: "InternalDirectDebitTransaction";
                    id: string;
                    type: TransactionTypeEnum;
                    executionDate: string;
                    amount: { __typename: "Amount"; currency: string; value: string };
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          status: TransactionStatus;
                          reason: RejectedReasonCode;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                  }
                | {
                    __typename: "InternationalCreditTransferTransaction";
                    id: string;
                    type: TransactionTypeEnum;
                    executionDate: string;
                    amount: { __typename: "Amount"; currency: string; value: string };
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          status: TransactionStatus;
                          reason: RejectedReasonCode;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                  }
                | {
                    __typename: "SEPACreditTransferTransaction";
                    id: string;
                    type: TransactionTypeEnum;
                    executionDate: string;
                    amount: { __typename: "Amount"; currency: string; value: string };
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          status: TransactionStatus;
                          reason: RejectedReasonCode;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                  }
                | {
                    __typename: "SEPADirectDebitTransaction";
                    id: string;
                    type: TransactionTypeEnum;
                    executionDate: string;
                    amount: { __typename: "Amount"; currency: string; value: string };
                    statusInfo:
                      | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                      | {
                          __typename: "RejectedTransactionStatusInfo";
                          status: TransactionStatus;
                          reason: RejectedReasonCode;
                        }
                      | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                      | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
                  }
                | null;
              statusInfo:
                | {
                    __typename: "BookedTransactionStatusInfo";
                    bookingDate: string;
                    status: TransactionStatus;
                  }
                | {
                    __typename: "CanceledTransactionStatusInfo";
                    canceledDate?: string | null;
                    status: TransactionStatus;
                  }
                | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                | {
                    __typename: "PendingTransactionStatusInfo";
                    pendingEndDate?: string | null;
                    status: TransactionStatus;
                  }
                | {
                    __typename: "RejectedTransactionStatusInfo";
                    reason: RejectedReasonCode;
                    status: TransactionStatus;
                  }
                | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                | {
                    __typename: "UpcomingTransactionStatusInfo";
                    executionDate: string;
                    status: TransactionStatus;
                  };
              amount: { __typename: "Amount"; currency: string; value: string };
            };
      }>;
    } | null;
  } | null;
};

export type GetAccountMembershipsQueryVariables = Exact<{
  first: Scalars["Int"]["input"];
  after?: InputMaybe<Scalars["String"]["input"]>;
  filters: AccountMembershipsFilterInput;
}>;

export type GetAccountMembershipsQuery = {
  __typename: "Query";
  user?: {
    __typename: "User";
    id: string;
    accountMemberships: {
      __typename: "AccountMembershipConnection";
      totalCount: number;
      pageInfo: { __typename: "PageInfo"; endCursor?: string | null; hasNextPage?: boolean | null };
      edges: Array<{
        __typename: "AccountMembershipEdge";
        cursor: string;
        node: {
          __typename: "AccountMembership";
          id: string;
          canInitiatePayments: boolean;
          legalRepresentative: boolean;
          canManageAccountMembership: boolean;
          canManageBeneficiaries: boolean;
          canViewAccount: boolean;
          email: string;
          statusInfo:
            | {
                __typename: "AccountMembershipBindingUserErrorStatusInfo";
                status: AccountMembershipStatus;
              }
            | {
                __typename: "AccountMembershipConsentPendingStatusInfo";
                status: AccountMembershipStatus;
              }
            | { __typename: "AccountMembershipDisabledStatusInfo"; status: AccountMembershipStatus }
            | { __typename: "AccountMembershipEnabledStatusInfo"; status: AccountMembershipStatus }
            | {
                __typename: "AccountMembershipInvitationSentStatusInfo";
                status: AccountMembershipStatus;
              }
            | {
                __typename: "AccountMembershipSuspendedStatusInfo";
                status: AccountMembershipStatus;
              };
          account?: {
            __typename: "Account";
            id: string;
            number: string;
            name: string;
            balances?: {
              __typename: "AccountBalances";
              available: { __typename: "Amount"; value: string; currency: string };
              pending: { __typename: "Amount"; value: string; currency: string };
              booked: { __typename: "Amount"; value: string; currency: string };
              reserved: { __typename: "Amount"; value: string; currency: string };
            } | null;
            holder: {
              __typename: "AccountHolder";
              id: string;
              info:
                | { __typename: "AccountHolderCompanyInfo"; name: string }
                | { __typename: "AccountHolderIndividualInfo"; name: string };
            };
          } | null;
        };
      }>;
    };
  } | null;
};

export type GetFirstAccountMembershipQueryVariables = Exact<{
  filters: AccountMembershipsFilterInput;
}>;

export type GetFirstAccountMembershipQuery = {
  __typename: "Query";
  user?: {
    __typename: "User";
    id: string;
    accountMemberships: {
      __typename: "AccountMembershipConnection";
      edges: Array<{
        __typename: "AccountMembershipEdge";
        cursor: string;
        node: { __typename: "AccountMembership"; id: string };
      }>;
    };
  } | null;
  projectInfo: { __typename: "ProjectInfo"; id: string; name: string };
};

export type AddressInfoFragment = {
  __typename: "AddressInfo";
  addressLine1?: string | null;
  addressLine2?: string | null;
  city?: string | null;
  country?: string | null;
  postalCode?: string | null;
  state?: string | null;
};

export type GetCardProductsQueryVariables = Exact<{
  accountMembershipId: Scalars["ID"]["input"];
  after?: InputMaybe<Scalars["String"]["input"]>;
  first: Scalars["Int"]["input"];
  search?: InputMaybe<Scalars["String"]["input"]>;
  accountId: Scalars["ID"]["input"];
}>;

export type GetCardProductsQuery = {
  __typename: "Query";
  allMemberships: { __typename: "AccountMembershipConnection"; totalCount: number };
  accountMemberships: {
    __typename: "AccountMembershipConnection";
    totalCount: number;
    pageInfo: { __typename: "PageInfo"; endCursor?: string | null; hasNextPage?: boolean | null };
    edges: Array<{
      __typename: "AccountMembershipEdge";
      cursor: string;
      node: {
        __typename: "AccountMembership";
        id: string;
        accountId: string;
        accountCountry: AccountCountry;
        createdAt: string;
        updatedAt: string;
        email: string;
        legalRepresentative: boolean;
        hasRequiredIdentificationLevel?: boolean | null;
        language?: AccountLanguage | null;
        taxIdentificationNumber?: string | null;
        canInitiatePayments: boolean;
        canManageCards: boolean;
        canManageAccountMembership: boolean;
        canManageBeneficiaries: boolean;
        canViewAccount: boolean;
        statusInfo:
          | {
              __typename: "AccountMembershipBindingUserErrorStatusInfo";
              emailVerifiedMatchError: boolean;
              idVerifiedMatchError: boolean;
              status: AccountMembershipStatus;
              restrictedTo: {
                __typename: "RestrictedTo";
                birthDate?: string | null;
                firstName: string;
                lastName: string;
                phoneNumber?: string | null;
              };
            }
          | {
              __typename: "AccountMembershipConsentPendingStatusInfo";
              status: AccountMembershipStatus;
            }
          | { __typename: "AccountMembershipDisabledStatusInfo"; status: AccountMembershipStatus }
          | { __typename: "AccountMembershipEnabledStatusInfo"; status: AccountMembershipStatus }
          | {
              __typename: "AccountMembershipInvitationSentStatusInfo";
              status: AccountMembershipStatus;
              restrictedTo: {
                __typename: "RestrictedTo";
                birthDate?: string | null;
                firstName: string;
                lastName: string;
                phoneNumber?: string | null;
              };
            }
          | { __typename: "AccountMembershipSuspendedStatusInfo"; status: AccountMembershipStatus };
        residencyAddress?: {
          __typename: "AddressInfo";
          addressLine1?: string | null;
          postalCode?: string | null;
          city?: string | null;
          country?: string | null;
        } | null;
        user?: {
          __typename: "User";
          id: string;
          birthDate?: string | null;
          firstName?: string | null;
          lastName?: string | null;
          birthLastName?: string | null;
          preferredLastName?: string | null;
          fullName?: string | null;
          mobilePhoneNumber?: string | null;
          verifiedEmails: Array<string>;
        } | null;
        account?: {
          __typename: "Account";
          id: string;
          name: string;
          country: AccountCountry;
          holder: {
            __typename: "AccountHolder";
            id: string;
            info:
              | { __typename: "AccountHolderCompanyInfo"; name: string; type: AccountHolderType }
              | {
                  __typename: "AccountHolderIndividualInfo";
                  name: string;
                  type: AccountHolderType;
                };
          };
        } | null;
        activeCards: { __typename: "CardConnection"; totalCount: number };
      };
    }>;
  };
  accountMembership?: {
    __typename: "AccountMembership";
    id: string;
    accountHolderType: AccountHolderType;
    account?: {
      __typename: "Account";
      id: string;
      legalRepresentativeMembership: { __typename: "AccountMembership"; id: string };
      creditLimitSettings?: {
        __typename: "CreditLimitSettings";
        statusInfo:
          | { __typename: "CreditLimitStatusActivatedInfo"; status: CreditLimitStatus }
          | { __typename: "CreditLimitStatusDeactivatedInfo"; status: CreditLimitStatus }
          | { __typename: "CreditLimitStatusPendingInfo"; status: CreditLimitStatus }
          | { __typename: "CreditLimitStatusSuspendedInfo"; status: CreditLimitStatus };
      } | null;
      holder: {
        __typename: "AccountHolder";
        id: string;
        info:
          | { __typename: "AccountHolderCompanyInfo"; name: string }
          | { __typename: "AccountHolderIndividualInfo"; name: string };
        residencyAddress: {
          __typename: "AddressInfo";
          addressLine1?: string | null;
          addressLine2?: string | null;
          city?: string | null;
          country?: string | null;
          postalCode?: string | null;
          state?: string | null;
        };
      };
    } | null;
    user?: {
      __typename: "User";
      id: string;
      firstName?: string | null;
      preferredLastName?: string | null;
      fullName?: string | null;
      mobilePhoneNumber?: string | null;
    } | null;
  } | null;
  projectInfo: {
    __typename: "ProjectInfo";
    id: string;
    cardProducts?: Array<{
      __typename: "CardProduct";
      id: string;
      name?: string | null;
      fundingType: CardProductFundingType;
      projectId: string;
      status: CardProductStatus;
      createdAt: string;
      updatedAt: string;
      applicableToPhysicalCards: boolean;
      defaultCardProduct: boolean;
      companySpendingLimit: {
        __typename: "SpendingLimit";
        period: SpendingLimitPeriod;
        amount: { __typename: "Amount"; value: string; currency: string };
      };
      individualSpendingLimit: {
        __typename: "SpendingLimit";
        period: SpendingLimitPeriod;
        amount: { __typename: "Amount"; value: string; currency: string };
      };
      cardDesigns: Array<{
        __typename: "CardProductDesign";
        id: string;
        version: number;
        cardProjectLogoSvgUrl?: string | null;
        cardProjectLogo300dpiUrl?: string | null;
        cardProjectLogo600dpiUrl?: string | null;
        zoomRatioProjectLogo?: number | null;
        cardDesignUrl?: string | null;
        accentColor: string;
        createdAt: string;
        updatedAt: string;
        status: CardDesignStatus;
        cardBackground: {
          __typename: "CardDesignBackground";
          id: string;
          name: string;
          type: string;
          cardTextColor: string;
          cardBackgroundUrl: string;
          createdAt: string;
          updatedAt: string;
        };
      }>;
      insurance?: {
        __typename: "CardInsuranceConfiguration";
        defaultInsurancePackage?: {
          __typename: "CardInsurancePackage";
          id: string;
          name: string;
          level: CardInsurancePackageLevel;
          noticeUrl?: string | null;
        } | null;
        availableInsurancePackages?: Array<{
          __typename: "CardInsurancePackage";
          id: string;
          name: string;
          level: CardInsurancePackageLevel;
          noticeUrl?: string | null;
        }> | null;
      } | null;
    }> | null;
  };
};

export type CardInsurancePackageFragment = {
  __typename: "CardInsurancePackage";
  id: string;
  name: string;
  level: CardInsurancePackageLevel;
  noticeUrl?: string | null;
};

export type CardProductFragment = {
  __typename: "CardProduct";
  id: string;
  name?: string | null;
  fundingType: CardProductFundingType;
  projectId: string;
  status: CardProductStatus;
  createdAt: string;
  updatedAt: string;
  applicableToPhysicalCards: boolean;
  defaultCardProduct: boolean;
  companySpendingLimit: {
    __typename: "SpendingLimit";
    period: SpendingLimitPeriod;
    amount: { __typename: "Amount"; value: string; currency: string };
  };
  individualSpendingLimit: {
    __typename: "SpendingLimit";
    period: SpendingLimitPeriod;
    amount: { __typename: "Amount"; value: string; currency: string };
  };
  cardDesigns: Array<{
    __typename: "CardProductDesign";
    id: string;
    version: number;
    cardProjectLogoSvgUrl?: string | null;
    cardProjectLogo300dpiUrl?: string | null;
    cardProjectLogo600dpiUrl?: string | null;
    zoomRatioProjectLogo?: number | null;
    cardDesignUrl?: string | null;
    accentColor: string;
    createdAt: string;
    updatedAt: string;
    status: CardDesignStatus;
    cardBackground: {
      __typename: "CardDesignBackground";
      id: string;
      name: string;
      type: string;
      cardTextColor: string;
      cardBackgroundUrl: string;
      createdAt: string;
      updatedAt: string;
    };
  }>;
  insurance?: {
    __typename: "CardInsuranceConfiguration";
    defaultInsurancePackage?: {
      __typename: "CardInsurancePackage";
      id: string;
      name: string;
      level: CardInsurancePackageLevel;
      noticeUrl?: string | null;
    } | null;
    availableInsurancePackages?: Array<{
      __typename: "CardInsurancePackage";
      id: string;
      name: string;
      level: CardInsurancePackageLevel;
      noticeUrl?: string | null;
    }> | null;
  } | null;
};

export type GetEligibleCardMembershipsQueryVariables = Exact<{
  after?: InputMaybe<Scalars["String"]["input"]>;
  first: Scalars["Int"]["input"];
  search?: InputMaybe<Scalars["String"]["input"]>;
  accountId: Scalars["ID"]["input"];
}>;

export type GetEligibleCardMembershipsQuery = {
  __typename: "Query";
  allMemberships: { __typename: "AccountMembershipConnection"; totalCount: number };
  accountMemberships: {
    __typename: "AccountMembershipConnection";
    totalCount: number;
    pageInfo: { __typename: "PageInfo"; endCursor?: string | null; hasNextPage?: boolean | null };
    edges: Array<{
      __typename: "AccountMembershipEdge";
      cursor: string;
      node: {
        __typename: "AccountMembership";
        id: string;
        accountId: string;
        accountCountry: AccountCountry;
        createdAt: string;
        updatedAt: string;
        email: string;
        legalRepresentative: boolean;
        hasRequiredIdentificationLevel?: boolean | null;
        language?: AccountLanguage | null;
        taxIdentificationNumber?: string | null;
        canInitiatePayments: boolean;
        canManageCards: boolean;
        canManageAccountMembership: boolean;
        canManageBeneficiaries: boolean;
        canViewAccount: boolean;
        statusInfo:
          | {
              __typename: "AccountMembershipBindingUserErrorStatusInfo";
              emailVerifiedMatchError: boolean;
              idVerifiedMatchError: boolean;
              status: AccountMembershipStatus;
              restrictedTo: {
                __typename: "RestrictedTo";
                birthDate?: string | null;
                firstName: string;
                lastName: string;
                phoneNumber?: string | null;
              };
            }
          | {
              __typename: "AccountMembershipConsentPendingStatusInfo";
              status: AccountMembershipStatus;
            }
          | { __typename: "AccountMembershipDisabledStatusInfo"; status: AccountMembershipStatus }
          | { __typename: "AccountMembershipEnabledStatusInfo"; status: AccountMembershipStatus }
          | {
              __typename: "AccountMembershipInvitationSentStatusInfo";
              status: AccountMembershipStatus;
              restrictedTo: {
                __typename: "RestrictedTo";
                birthDate?: string | null;
                firstName: string;
                lastName: string;
                phoneNumber?: string | null;
              };
            }
          | { __typename: "AccountMembershipSuspendedStatusInfo"; status: AccountMembershipStatus };
        residencyAddress?: {
          __typename: "AddressInfo";
          addressLine1?: string | null;
          postalCode?: string | null;
          city?: string | null;
          country?: string | null;
        } | null;
        user?: {
          __typename: "User";
          id: string;
          birthDate?: string | null;
          firstName?: string | null;
          lastName?: string | null;
          birthLastName?: string | null;
          preferredLastName?: string | null;
          fullName?: string | null;
          mobilePhoneNumber?: string | null;
          verifiedEmails: Array<string>;
        } | null;
        account?: {
          __typename: "Account";
          id: string;
          name: string;
          country: AccountCountry;
          holder: {
            __typename: "AccountHolder";
            id: string;
            info:
              | { __typename: "AccountHolderCompanyInfo"; name: string; type: AccountHolderType }
              | {
                  __typename: "AccountHolderIndividualInfo";
                  name: string;
                  type: AccountHolderType;
                };
          };
        } | null;
        activeCards: { __typename: "CardConnection"; totalCount: number };
      };
    }>;
  };
};

export type GetTransactionDetailsQueryVariables = Exact<{
  transactionId: Scalars["ID"]["input"];
  canQueryCardOnTransaction: Scalars["Boolean"]["input"];
}>;

export type GetTransactionDetailsQuery = {
  __typename: "Query";
  transaction:
    | {
        __typename: "CardTransaction";
        reservedAmountReleasedAt?: string | null;
        id: string;
        side: TransactionSide;
        type: TransactionTypeEnum;
        label: string;
        counterparty: string;
        reference: string;
        externalReference?: string | null;
        statementCanBeGenerated?: boolean | null;
        createdAt: string;
        executionDate: string;
        updatedAt: string;
        originalAmount: { __typename: "Amount"; currency: string; value: string };
        reservedAmount?: { __typename: "Amount"; currency: string; value: string } | null;
        cardDetails?:
          | {
              __typename: "CardInDetails";
              paymentMandate: {
                __typename: "CardPaymentMandate";
                id: string;
                name?: string | null;
                createdAt: string;
                updatedAt: string;
                executedAt?: string | null;
              };
            }
          | {
              __typename: "CardOutDetails";
              maskedPan: string;
              card?: {
                __typename: "Card";
                id: string;
                name?: string | null;
                accountMembership: {
                  __typename: "AccountMembership";
                  id: string;
                  user?: {
                    __typename: "User";
                    id: string;
                    firstName?: string | null;
                    preferredLastName?: string | null;
                    fullName?: string | null;
                  } | null;
                };
              } | null;
            }
          | null;
        merchant?:
          | { __typename: "CardInMerchant" }
          | {
              __typename: "CardOutMerchant";
              merchantId: string;
              merchantCity: string;
              merchantCountry?: string | null;
            }
          | null;
        enrichedTransactionInfo?: {
          __typename: "EnrichedTransactionInfo";
          enrichedMerchantName?: string | null;
          isSubscription?: boolean | null;
          carbonFootprint?: string | null;
          contactEmail?: string | null;
          contactPhone?: string | null;
          contactWebsite?: string | null;
          logoUrl?: string | null;
          category?: MerchantCategory | null;
          subcategory?: MerchantSubCategory | null;
          address?: string | null;
          city?: string | null;
          postalCode?: string | null;
          country?: string | null;
        } | null;
        currencyExchange: Array<{ __typename: "ReportExchangeRate"; exchangeRate: number }>;
        payment?: { __typename: "Payment"; id: string; createdAt: string } | null;
        originTransaction?:
          | {
              __typename: "CardTransaction";
              id: string;
              type: TransactionTypeEnum;
              executionDate: string;
              amount: { __typename: "Amount"; currency: string; value: string };
              statusInfo:
                | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                | {
                    __typename: "RejectedTransactionStatusInfo";
                    status: TransactionStatus;
                    reason: RejectedReasonCode;
                  }
                | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
            }
          | {
              __typename: "CheckTransaction";
              id: string;
              type: TransactionTypeEnum;
              executionDate: string;
              amount: { __typename: "Amount"; currency: string; value: string };
              statusInfo:
                | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                | {
                    __typename: "RejectedTransactionStatusInfo";
                    status: TransactionStatus;
                    reason: RejectedReasonCode;
                  }
                | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
            }
          | {
              __typename: "FeeTransaction";
              id: string;
              type: TransactionTypeEnum;
              executionDate: string;
              amount: { __typename: "Amount"; currency: string; value: string };
              statusInfo:
                | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                | {
                    __typename: "RejectedTransactionStatusInfo";
                    status: TransactionStatus;
                    reason: RejectedReasonCode;
                  }
                | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
            }
          | {
              __typename: "InternalCreditTransfer";
              id: string;
              type: TransactionTypeEnum;
              executionDate: string;
              amount: { __typename: "Amount"; currency: string; value: string };
              statusInfo:
                | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                | {
                    __typename: "RejectedTransactionStatusInfo";
                    status: TransactionStatus;
                    reason: RejectedReasonCode;
                  }
                | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
            }
          | {
              __typename: "InternalDirectDebitTransaction";
              id: string;
              type: TransactionTypeEnum;
              executionDate: string;
              amount: { __typename: "Amount"; currency: string; value: string };
              statusInfo:
                | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                | {
                    __typename: "RejectedTransactionStatusInfo";
                    status: TransactionStatus;
                    reason: RejectedReasonCode;
                  }
                | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
            }
          | {
              __typename: "InternationalCreditTransferTransaction";
              id: string;
              type: TransactionTypeEnum;
              executionDate: string;
              amount: { __typename: "Amount"; currency: string; value: string };
              statusInfo:
                | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                | {
                    __typename: "RejectedTransactionStatusInfo";
                    status: TransactionStatus;
                    reason: RejectedReasonCode;
                  }
                | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
            }
          | {
              __typename: "SEPACreditTransferTransaction";
              id: string;
              type: TransactionTypeEnum;
              executionDate: string;
              amount: { __typename: "Amount"; currency: string; value: string };
              statusInfo:
                | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                | {
                    __typename: "RejectedTransactionStatusInfo";
                    status: TransactionStatus;
                    reason: RejectedReasonCode;
                  }
                | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
            }
          | {
              __typename: "SEPADirectDebitTransaction";
              id: string;
              type: TransactionTypeEnum;
              executionDate: string;
              amount: { __typename: "Amount"; currency: string; value: string };
              statusInfo:
                | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                | {
                    __typename: "RejectedTransactionStatusInfo";
                    status: TransactionStatus;
                    reason: RejectedReasonCode;
                  }
                | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
            }
          | null;
        statusInfo:
          | {
              __typename: "BookedTransactionStatusInfo";
              bookingDate: string;
              status: TransactionStatus;
            }
          | {
              __typename: "CanceledTransactionStatusInfo";
              canceledDate?: string | null;
              status: TransactionStatus;
            }
          | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
          | {
              __typename: "PendingTransactionStatusInfo";
              pendingEndDate?: string | null;
              status: TransactionStatus;
            }
          | {
              __typename: "RejectedTransactionStatusInfo";
              reason: RejectedReasonCode;
              status: TransactionStatus;
            }
          | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
          | {
              __typename: "UpcomingTransactionStatusInfo";
              executionDate: string;
              status: TransactionStatus;
            };
        amount: { __typename: "Amount"; currency: string; value: string };
      }
    | {
        __typename: "CheckTransaction";
        reservedAmountReleasedAt?: string | null;
        cmc7: string;
        rlmcKey: string;
        id: string;
        side: TransactionSide;
        type: TransactionTypeEnum;
        label: string;
        counterparty: string;
        reference: string;
        externalReference?: string | null;
        statementCanBeGenerated?: boolean | null;
        createdAt: string;
        executionDate: string;
        updatedAt: string;
        reservedAmount?: { __typename: "Amount"; currency: string; value: string } | null;
        payment?: { __typename: "Payment"; id: string; createdAt: string } | null;
        originTransaction?:
          | {
              __typename: "CardTransaction";
              id: string;
              type: TransactionTypeEnum;
              executionDate: string;
              amount: { __typename: "Amount"; currency: string; value: string };
              statusInfo:
                | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                | {
                    __typename: "RejectedTransactionStatusInfo";
                    status: TransactionStatus;
                    reason: RejectedReasonCode;
                  }
                | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
            }
          | {
              __typename: "CheckTransaction";
              id: string;
              type: TransactionTypeEnum;
              executionDate: string;
              amount: { __typename: "Amount"; currency: string; value: string };
              statusInfo:
                | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                | {
                    __typename: "RejectedTransactionStatusInfo";
                    status: TransactionStatus;
                    reason: RejectedReasonCode;
                  }
                | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
            }
          | {
              __typename: "FeeTransaction";
              id: string;
              type: TransactionTypeEnum;
              executionDate: string;
              amount: { __typename: "Amount"; currency: string; value: string };
              statusInfo:
                | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                | {
                    __typename: "RejectedTransactionStatusInfo";
                    status: TransactionStatus;
                    reason: RejectedReasonCode;
                  }
                | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
            }
          | {
              __typename: "InternalCreditTransfer";
              id: string;
              type: TransactionTypeEnum;
              executionDate: string;
              amount: { __typename: "Amount"; currency: string; value: string };
              statusInfo:
                | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                | {
                    __typename: "RejectedTransactionStatusInfo";
                    status: TransactionStatus;
                    reason: RejectedReasonCode;
                  }
                | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
            }
          | {
              __typename: "InternalDirectDebitTransaction";
              id: string;
              type: TransactionTypeEnum;
              executionDate: string;
              amount: { __typename: "Amount"; currency: string; value: string };
              statusInfo:
                | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                | {
                    __typename: "RejectedTransactionStatusInfo";
                    status: TransactionStatus;
                    reason: RejectedReasonCode;
                  }
                | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
            }
          | {
              __typename: "InternationalCreditTransferTransaction";
              id: string;
              type: TransactionTypeEnum;
              executionDate: string;
              amount: { __typename: "Amount"; currency: string; value: string };
              statusInfo:
                | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                | {
                    __typename: "RejectedTransactionStatusInfo";
                    status: TransactionStatus;
                    reason: RejectedReasonCode;
                  }
                | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
            }
          | {
              __typename: "SEPACreditTransferTransaction";
              id: string;
              type: TransactionTypeEnum;
              executionDate: string;
              amount: { __typename: "Amount"; currency: string; value: string };
              statusInfo:
                | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                | {
                    __typename: "RejectedTransactionStatusInfo";
                    status: TransactionStatus;
                    reason: RejectedReasonCode;
                  }
                | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
            }
          | {
              __typename: "SEPADirectDebitTransaction";
              id: string;
              type: TransactionTypeEnum;
              executionDate: string;
              amount: { __typename: "Amount"; currency: string; value: string };
              statusInfo:
                | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                | {
                    __typename: "RejectedTransactionStatusInfo";
                    status: TransactionStatus;
                    reason: RejectedReasonCode;
                  }
                | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
            }
          | null;
        statusInfo:
          | {
              __typename: "BookedTransactionStatusInfo";
              bookingDate: string;
              status: TransactionStatus;
            }
          | {
              __typename: "CanceledTransactionStatusInfo";
              canceledDate?: string | null;
              status: TransactionStatus;
            }
          | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
          | {
              __typename: "PendingTransactionStatusInfo";
              pendingEndDate?: string | null;
              status: TransactionStatus;
            }
          | {
              __typename: "RejectedTransactionStatusInfo";
              reason: RejectedReasonCode;
              status: TransactionStatus;
            }
          | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
          | {
              __typename: "UpcomingTransactionStatusInfo";
              executionDate: string;
              status: TransactionStatus;
            };
        amount: { __typename: "Amount"; currency: string; value: string };
      }
    | {
        __typename: "FeeTransaction";
        feesType: FeesTypeEnum;
        id: string;
        side: TransactionSide;
        type: TransactionTypeEnum;
        label: string;
        counterparty: string;
        reference: string;
        externalReference?: string | null;
        statementCanBeGenerated?: boolean | null;
        createdAt: string;
        executionDate: string;
        updatedAt: string;
        creditor:
          | { __typename: "FeeInCreditor"; name: string }
          | { __typename: "FeeOutCreditor"; name: string };
        originTransaction?:
          | {
              __typename: "CardTransaction";
              id: string;
              label: string;
              type: TransactionTypeEnum;
              updatedAt: string;
              executionDate: string;
              createdAt: string;
              statusInfo:
                | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                | {
                    __typename: "RejectedTransactionStatusInfo";
                    reason: RejectedReasonCode;
                    status: TransactionStatus;
                  }
                | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
              amount: { __typename: "Amount"; currency: string; value: string };
            }
          | {
              __typename: "CheckTransaction";
              id: string;
              label: string;
              type: TransactionTypeEnum;
              updatedAt: string;
              executionDate: string;
              createdAt: string;
              statusInfo:
                | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                | {
                    __typename: "RejectedTransactionStatusInfo";
                    reason: RejectedReasonCode;
                    status: TransactionStatus;
                  }
                | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
              amount: { __typename: "Amount"; currency: string; value: string };
            }
          | {
              __typename: "FeeTransaction";
              id: string;
              label: string;
              type: TransactionTypeEnum;
              updatedAt: string;
              executionDate: string;
              createdAt: string;
              statusInfo:
                | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                | {
                    __typename: "RejectedTransactionStatusInfo";
                    reason: RejectedReasonCode;
                    status: TransactionStatus;
                  }
                | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
              amount: { __typename: "Amount"; currency: string; value: string };
            }
          | {
              __typename: "InternalCreditTransfer";
              id: string;
              label: string;
              type: TransactionTypeEnum;
              updatedAt: string;
              executionDate: string;
              createdAt: string;
              statusInfo:
                | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                | {
                    __typename: "RejectedTransactionStatusInfo";
                    reason: RejectedReasonCode;
                    status: TransactionStatus;
                  }
                | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
              amount: { __typename: "Amount"; currency: string; value: string };
            }
          | {
              __typename: "InternalDirectDebitTransaction";
              id: string;
              label: string;
              type: TransactionTypeEnum;
              updatedAt: string;
              executionDate: string;
              createdAt: string;
              statusInfo:
                | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                | {
                    __typename: "RejectedTransactionStatusInfo";
                    reason: RejectedReasonCode;
                    status: TransactionStatus;
                  }
                | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
              amount: { __typename: "Amount"; currency: string; value: string };
            }
          | {
              __typename: "InternationalCreditTransferTransaction";
              id: string;
              label: string;
              type: TransactionTypeEnum;
              updatedAt: string;
              executionDate: string;
              createdAt: string;
              statusInfo:
                | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                | {
                    __typename: "RejectedTransactionStatusInfo";
                    reason: RejectedReasonCode;
                    status: TransactionStatus;
                  }
                | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
              amount: { __typename: "Amount"; currency: string; value: string };
            }
          | {
              __typename: "SEPACreditTransferTransaction";
              id: string;
              label: string;
              type: TransactionTypeEnum;
              updatedAt: string;
              executionDate: string;
              createdAt: string;
              statusInfo:
                | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                | {
                    __typename: "RejectedTransactionStatusInfo";
                    reason: RejectedReasonCode;
                    status: TransactionStatus;
                  }
                | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
              amount: { __typename: "Amount"; currency: string; value: string };
            }
          | {
              __typename: "SEPADirectDebitTransaction";
              id: string;
              label: string;
              type: TransactionTypeEnum;
              updatedAt: string;
              executionDate: string;
              createdAt: string;
              statusInfo:
                | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                | {
                    __typename: "RejectedTransactionStatusInfo";
                    reason: RejectedReasonCode;
                    status: TransactionStatus;
                  }
                | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
              amount: { __typename: "Amount"; currency: string; value: string };
            }
          | null;
        payment?: { __typename: "Payment"; id: string; createdAt: string } | null;
        statusInfo:
          | {
              __typename: "BookedTransactionStatusInfo";
              bookingDate: string;
              status: TransactionStatus;
            }
          | {
              __typename: "CanceledTransactionStatusInfo";
              canceledDate?: string | null;
              status: TransactionStatus;
            }
          | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
          | {
              __typename: "PendingTransactionStatusInfo";
              pendingEndDate?: string | null;
              status: TransactionStatus;
            }
          | {
              __typename: "RejectedTransactionStatusInfo";
              reason: RejectedReasonCode;
              status: TransactionStatus;
            }
          | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
          | {
              __typename: "UpcomingTransactionStatusInfo";
              executionDate: string;
              status: TransactionStatus;
            };
        amount: { __typename: "Amount"; currency: string; value: string };
      }
    | {
        __typename: "InternalCreditTransfer";
        id: string;
        side: TransactionSide;
        type: TransactionTypeEnum;
        label: string;
        counterparty: string;
        reference: string;
        externalReference?: string | null;
        statementCanBeGenerated?: boolean | null;
        createdAt: string;
        executionDate: string;
        updatedAt: string;
        creditor:
          | { __typename: "InternalCreditTransferInCreditor"; name: string }
          | { __typename: "InternalCreditTransferOutCreditor"; name: string };
        payment?: { __typename: "Payment"; id: string; createdAt: string } | null;
        originTransaction?:
          | {
              __typename: "CardTransaction";
              id: string;
              type: TransactionTypeEnum;
              executionDate: string;
              amount: { __typename: "Amount"; currency: string; value: string };
              statusInfo:
                | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                | {
                    __typename: "RejectedTransactionStatusInfo";
                    status: TransactionStatus;
                    reason: RejectedReasonCode;
                  }
                | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
            }
          | {
              __typename: "CheckTransaction";
              id: string;
              type: TransactionTypeEnum;
              executionDate: string;
              amount: { __typename: "Amount"; currency: string; value: string };
              statusInfo:
                | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                | {
                    __typename: "RejectedTransactionStatusInfo";
                    status: TransactionStatus;
                    reason: RejectedReasonCode;
                  }
                | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
            }
          | {
              __typename: "FeeTransaction";
              id: string;
              type: TransactionTypeEnum;
              executionDate: string;
              amount: { __typename: "Amount"; currency: string; value: string };
              statusInfo:
                | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                | {
                    __typename: "RejectedTransactionStatusInfo";
                    status: TransactionStatus;
                    reason: RejectedReasonCode;
                  }
                | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
            }
          | {
              __typename: "InternalCreditTransfer";
              id: string;
              type: TransactionTypeEnum;
              executionDate: string;
              amount: { __typename: "Amount"; currency: string; value: string };
              statusInfo:
                | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                | {
                    __typename: "RejectedTransactionStatusInfo";
                    status: TransactionStatus;
                    reason: RejectedReasonCode;
                  }
                | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
            }
          | {
              __typename: "InternalDirectDebitTransaction";
              id: string;
              type: TransactionTypeEnum;
              executionDate: string;
              amount: { __typename: "Amount"; currency: string; value: string };
              statusInfo:
                | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                | {
                    __typename: "RejectedTransactionStatusInfo";
                    status: TransactionStatus;
                    reason: RejectedReasonCode;
                  }
                | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
            }
          | {
              __typename: "InternationalCreditTransferTransaction";
              id: string;
              type: TransactionTypeEnum;
              executionDate: string;
              amount: { __typename: "Amount"; currency: string; value: string };
              statusInfo:
                | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                | {
                    __typename: "RejectedTransactionStatusInfo";
                    status: TransactionStatus;
                    reason: RejectedReasonCode;
                  }
                | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
            }
          | {
              __typename: "SEPACreditTransferTransaction";
              id: string;
              type: TransactionTypeEnum;
              executionDate: string;
              amount: { __typename: "Amount"; currency: string; value: string };
              statusInfo:
                | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                | {
                    __typename: "RejectedTransactionStatusInfo";
                    status: TransactionStatus;
                    reason: RejectedReasonCode;
                  }
                | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
            }
          | {
              __typename: "SEPADirectDebitTransaction";
              id: string;
              type: TransactionTypeEnum;
              executionDate: string;
              amount: { __typename: "Amount"; currency: string; value: string };
              statusInfo:
                | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                | {
                    __typename: "RejectedTransactionStatusInfo";
                    status: TransactionStatus;
                    reason: RejectedReasonCode;
                  }
                | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
            }
          | null;
        statusInfo:
          | {
              __typename: "BookedTransactionStatusInfo";
              bookingDate: string;
              status: TransactionStatus;
            }
          | {
              __typename: "CanceledTransactionStatusInfo";
              canceledDate?: string | null;
              status: TransactionStatus;
            }
          | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
          | {
              __typename: "PendingTransactionStatusInfo";
              pendingEndDate?: string | null;
              status: TransactionStatus;
            }
          | {
              __typename: "RejectedTransactionStatusInfo";
              reason: RejectedReasonCode;
              status: TransactionStatus;
            }
          | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
          | {
              __typename: "UpcomingTransactionStatusInfo";
              executionDate: string;
              status: TransactionStatus;
            };
        amount: { __typename: "Amount"; currency: string; value: string };
      }
    | {
        __typename: "InternalDirectDebitTransaction";
        reservedAmountReleasedAt?: string | null;
        id: string;
        side: TransactionSide;
        type: TransactionTypeEnum;
        label: string;
        counterparty: string;
        reference: string;
        externalReference?: string | null;
        statementCanBeGenerated?: boolean | null;
        createdAt: string;
        executionDate: string;
        updatedAt: string;
        reservedAmount?: { __typename: "Amount"; currency: string; value: string } | null;
        creditor: { __typename: "InternalDirectDebitCreditor"; accountId: string };
        mandate?:
          | { __typename: "InternalPaymentDirectDebitMandate"; id: string }
          | { __typename: "InternalReceivedDirectDebitMandate"; id: string }
          | null;
        payment?: { __typename: "Payment"; id: string; createdAt: string } | null;
        originTransaction?:
          | {
              __typename: "CardTransaction";
              id: string;
              type: TransactionTypeEnum;
              executionDate: string;
              amount: { __typename: "Amount"; currency: string; value: string };
              statusInfo:
                | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                | {
                    __typename: "RejectedTransactionStatusInfo";
                    status: TransactionStatus;
                    reason: RejectedReasonCode;
                  }
                | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
            }
          | {
              __typename: "CheckTransaction";
              id: string;
              type: TransactionTypeEnum;
              executionDate: string;
              amount: { __typename: "Amount"; currency: string; value: string };
              statusInfo:
                | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                | {
                    __typename: "RejectedTransactionStatusInfo";
                    status: TransactionStatus;
                    reason: RejectedReasonCode;
                  }
                | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
            }
          | {
              __typename: "FeeTransaction";
              id: string;
              type: TransactionTypeEnum;
              executionDate: string;
              amount: { __typename: "Amount"; currency: string; value: string };
              statusInfo:
                | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                | {
                    __typename: "RejectedTransactionStatusInfo";
                    status: TransactionStatus;
                    reason: RejectedReasonCode;
                  }
                | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
            }
          | {
              __typename: "InternalCreditTransfer";
              id: string;
              type: TransactionTypeEnum;
              executionDate: string;
              amount: { __typename: "Amount"; currency: string; value: string };
              statusInfo:
                | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                | {
                    __typename: "RejectedTransactionStatusInfo";
                    status: TransactionStatus;
                    reason: RejectedReasonCode;
                  }
                | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
            }
          | {
              __typename: "InternalDirectDebitTransaction";
              id: string;
              type: TransactionTypeEnum;
              executionDate: string;
              amount: { __typename: "Amount"; currency: string; value: string };
              statusInfo:
                | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                | {
                    __typename: "RejectedTransactionStatusInfo";
                    status: TransactionStatus;
                    reason: RejectedReasonCode;
                  }
                | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
            }
          | {
              __typename: "InternationalCreditTransferTransaction";
              id: string;
              type: TransactionTypeEnum;
              executionDate: string;
              amount: { __typename: "Amount"; currency: string; value: string };
              statusInfo:
                | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                | {
                    __typename: "RejectedTransactionStatusInfo";
                    status: TransactionStatus;
                    reason: RejectedReasonCode;
                  }
                | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
            }
          | {
              __typename: "SEPACreditTransferTransaction";
              id: string;
              type: TransactionTypeEnum;
              executionDate: string;
              amount: { __typename: "Amount"; currency: string; value: string };
              statusInfo:
                | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                | {
                    __typename: "RejectedTransactionStatusInfo";
                    status: TransactionStatus;
                    reason: RejectedReasonCode;
                  }
                | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
            }
          | {
              __typename: "SEPADirectDebitTransaction";
              id: string;
              type: TransactionTypeEnum;
              executionDate: string;
              amount: { __typename: "Amount"; currency: string; value: string };
              statusInfo:
                | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                | {
                    __typename: "RejectedTransactionStatusInfo";
                    status: TransactionStatus;
                    reason: RejectedReasonCode;
                  }
                | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
            }
          | null;
        statusInfo:
          | {
              __typename: "BookedTransactionStatusInfo";
              bookingDate: string;
              status: TransactionStatus;
            }
          | {
              __typename: "CanceledTransactionStatusInfo";
              canceledDate?: string | null;
              status: TransactionStatus;
            }
          | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
          | {
              __typename: "PendingTransactionStatusInfo";
              pendingEndDate?: string | null;
              status: TransactionStatus;
            }
          | {
              __typename: "RejectedTransactionStatusInfo";
              reason: RejectedReasonCode;
              status: TransactionStatus;
            }
          | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
          | {
              __typename: "UpcomingTransactionStatusInfo";
              executionDate: string;
              status: TransactionStatus;
            };
        amount: { __typename: "Amount"; currency: string; value: string };
      }
    | {
        __typename: "InternationalCreditTransferTransaction";
        reference: string;
        paymentProduct: PaymentProduct;
        id: string;
        side: TransactionSide;
        type: TransactionTypeEnum;
        label: string;
        counterparty: string;
        externalReference?: string | null;
        statementCanBeGenerated?: boolean | null;
        createdAt: string;
        executionDate: string;
        updatedAt: string;
        creditor:
          | { __typename: "InternationalCreditTransferInCreditor"; name: string }
          | { __typename: "InternationalCreditTransferInDebtor" }
          | {
              __typename: "InternationalCreditTransferOutCreditor";
              name: string;
              details: Array<{
                __typename: "InternationalCreditTransferDetails";
                key: string;
                value: string;
              }>;
            };
        statusInfo:
          | {
              __typename: "BookedTransactionStatusInfo";
              bookingDate: string;
              status: TransactionStatus;
            }
          | {
              __typename: "CanceledTransactionStatusInfo";
              canceledDate?: string | null;
              status: TransactionStatus;
            }
          | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
          | {
              __typename: "PendingTransactionStatusInfo";
              pendingEndDate?: string | null;
              status: TransactionStatus;
            }
          | {
              __typename: "RejectedTransactionStatusInfo";
              reason: RejectedReasonCode;
              status: TransactionStatus;
            }
          | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
          | {
              __typename: "UpcomingTransactionStatusInfo";
              executionDate: string;
              status: TransactionStatus;
            };
        internationalCurrencyExchange: {
          __typename: "InternationalCreditTransferCurrencyExchange";
          exchangeRate: string;
          sourceAmount?: { __typename: "Amount"; currency: string; value: string } | null;
          targetAmount?: { __typename: "Amount"; currency: string; value: string } | null;
        };
        beneficiary?:
          | {
              __typename: "TrustedInternationalBeneficiary";
              name: string;
              currency: string;
              route: InternationalCreditTransferRoute;
              details: Array<{
                __typename: "InternationalCreditTransferDetails";
                key: string;
                value: string;
              }>;
            }
          | {
              __typename: "UnsavedInternationalBeneficiary";
              name: string;
              currency: string;
              route: InternationalCreditTransferRoute;
              details: Array<{
                __typename: "InternationalCreditTransferDetails";
                key: string;
                value: string;
              }>;
            }
          | null;
        payment?: { __typename: "Payment"; id: string; createdAt: string } | null;
        originTransaction?:
          | {
              __typename: "CardTransaction";
              id: string;
              type: TransactionTypeEnum;
              executionDate: string;
              amount: { __typename: "Amount"; currency: string; value: string };
              statusInfo:
                | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                | {
                    __typename: "RejectedTransactionStatusInfo";
                    status: TransactionStatus;
                    reason: RejectedReasonCode;
                  }
                | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
            }
          | {
              __typename: "CheckTransaction";
              id: string;
              type: TransactionTypeEnum;
              executionDate: string;
              amount: { __typename: "Amount"; currency: string; value: string };
              statusInfo:
                | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                | {
                    __typename: "RejectedTransactionStatusInfo";
                    status: TransactionStatus;
                    reason: RejectedReasonCode;
                  }
                | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
            }
          | {
              __typename: "FeeTransaction";
              id: string;
              type: TransactionTypeEnum;
              executionDate: string;
              amount: { __typename: "Amount"; currency: string; value: string };
              statusInfo:
                | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                | {
                    __typename: "RejectedTransactionStatusInfo";
                    status: TransactionStatus;
                    reason: RejectedReasonCode;
                  }
                | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
            }
          | {
              __typename: "InternalCreditTransfer";
              id: string;
              type: TransactionTypeEnum;
              executionDate: string;
              amount: { __typename: "Amount"; currency: string; value: string };
              statusInfo:
                | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                | {
                    __typename: "RejectedTransactionStatusInfo";
                    status: TransactionStatus;
                    reason: RejectedReasonCode;
                  }
                | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
            }
          | {
              __typename: "InternalDirectDebitTransaction";
              id: string;
              type: TransactionTypeEnum;
              executionDate: string;
              amount: { __typename: "Amount"; currency: string; value: string };
              statusInfo:
                | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                | {
                    __typename: "RejectedTransactionStatusInfo";
                    status: TransactionStatus;
                    reason: RejectedReasonCode;
                  }
                | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
            }
          | {
              __typename: "InternationalCreditTransferTransaction";
              id: string;
              type: TransactionTypeEnum;
              executionDate: string;
              amount: { __typename: "Amount"; currency: string; value: string };
              statusInfo:
                | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                | {
                    __typename: "RejectedTransactionStatusInfo";
                    status: TransactionStatus;
                    reason: RejectedReasonCode;
                  }
                | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
            }
          | {
              __typename: "SEPACreditTransferTransaction";
              id: string;
              type: TransactionTypeEnum;
              executionDate: string;
              amount: { __typename: "Amount"; currency: string; value: string };
              statusInfo:
                | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                | {
                    __typename: "RejectedTransactionStatusInfo";
                    status: TransactionStatus;
                    reason: RejectedReasonCode;
                  }
                | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
            }
          | {
              __typename: "SEPADirectDebitTransaction";
              id: string;
              type: TransactionTypeEnum;
              executionDate: string;
              amount: { __typename: "Amount"; currency: string; value: string };
              statusInfo:
                | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                | {
                    __typename: "RejectedTransactionStatusInfo";
                    status: TransactionStatus;
                    reason: RejectedReasonCode;
                  }
                | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
            }
          | null;
        amount: { __typename: "Amount"; currency: string; value: string };
      }
    | {
        __typename: "SEPACreditTransferTransaction";
        id: string;
        side: TransactionSide;
        type: TransactionTypeEnum;
        label: string;
        counterparty: string;
        reference: string;
        externalReference?: string | null;
        statementCanBeGenerated?: boolean | null;
        createdAt: string;
        executionDate: string;
        updatedAt: string;
        creditor:
          | { __typename: "SEPACreditTransferInCreditor"; name: string; IBAN?: string | null }
          | {
              __typename: "SEPACreditTransferInternalOutCreditor";
              name: string;
              IBAN?: string | null;
            }
          | { __typename: "SEPACreditTransferOutCreditor"; name: string; IBAN?: string | null };
        debtor:
          | { __typename: "SEPACreditTransferInDebtor"; name: string; IBAN?: string | null }
          | { __typename: "SEPACreditTransferInternalInDebtor"; name: string; IBAN?: string | null }
          | { __typename: "SEPACreditTransferOutDebtor"; name: string; IBAN?: string | null };
        beneficiary?:
          | {
              __typename: "TrustedSepaBeneficiary";
              iban: string;
              id: string;
              label: string;
              name: string;
              type: BeneficiaryType;
              createdAt: string;
              address?: {
                __typename: "Address";
                addressLine1?: string | null;
                addressLine2?: string | null;
                city?: string | null;
                country?: string | null;
                postalCode?: string | null;
                state?: string | null;
              } | null;
              statusInfo:
                | {
                    __typename: "TrustedBeneficiaryCanceledStatusInfo";
                    status: TrustedBeneficiaryStatus;
                  }
                | {
                    __typename: "TrustedBeneficiaryConsentPendingStatusInfo";
                    status: TrustedBeneficiaryStatus;
                  }
                | {
                    __typename: "TrustedBeneficiaryEnabledStatusInfo";
                    status: TrustedBeneficiaryStatus;
                  };
            }
          | {
              __typename: "UnsavedSepaBeneficiary";
              name: string;
              iban: string;
              address?: {
                __typename: "Address";
                addressLine1?: string | null;
                addressLine2?: string | null;
                city?: string | null;
                country?: string | null;
                postalCode?: string | null;
                state?: string | null;
              } | null;
            }
          | null;
        payment?: { __typename: "Payment"; id: string; createdAt: string } | null;
        originTransaction?:
          | {
              __typename: "CardTransaction";
              id: string;
              type: TransactionTypeEnum;
              executionDate: string;
              amount: { __typename: "Amount"; currency: string; value: string };
              statusInfo:
                | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                | {
                    __typename: "RejectedTransactionStatusInfo";
                    status: TransactionStatus;
                    reason: RejectedReasonCode;
                  }
                | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
            }
          | {
              __typename: "CheckTransaction";
              id: string;
              type: TransactionTypeEnum;
              executionDate: string;
              amount: { __typename: "Amount"; currency: string; value: string };
              statusInfo:
                | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                | {
                    __typename: "RejectedTransactionStatusInfo";
                    status: TransactionStatus;
                    reason: RejectedReasonCode;
                  }
                | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
            }
          | {
              __typename: "FeeTransaction";
              id: string;
              type: TransactionTypeEnum;
              executionDate: string;
              amount: { __typename: "Amount"; currency: string; value: string };
              statusInfo:
                | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                | {
                    __typename: "RejectedTransactionStatusInfo";
                    status: TransactionStatus;
                    reason: RejectedReasonCode;
                  }
                | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
            }
          | {
              __typename: "InternalCreditTransfer";
              id: string;
              type: TransactionTypeEnum;
              executionDate: string;
              amount: { __typename: "Amount"; currency: string; value: string };
              statusInfo:
                | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                | {
                    __typename: "RejectedTransactionStatusInfo";
                    status: TransactionStatus;
                    reason: RejectedReasonCode;
                  }
                | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
            }
          | {
              __typename: "InternalDirectDebitTransaction";
              id: string;
              type: TransactionTypeEnum;
              executionDate: string;
              amount: { __typename: "Amount"; currency: string; value: string };
              statusInfo:
                | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                | {
                    __typename: "RejectedTransactionStatusInfo";
                    status: TransactionStatus;
                    reason: RejectedReasonCode;
                  }
                | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
            }
          | {
              __typename: "InternationalCreditTransferTransaction";
              id: string;
              type: TransactionTypeEnum;
              executionDate: string;
              amount: { __typename: "Amount"; currency: string; value: string };
              statusInfo:
                | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                | {
                    __typename: "RejectedTransactionStatusInfo";
                    status: TransactionStatus;
                    reason: RejectedReasonCode;
                  }
                | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
            }
          | {
              __typename: "SEPACreditTransferTransaction";
              id: string;
              type: TransactionTypeEnum;
              executionDate: string;
              amount: { __typename: "Amount"; currency: string; value: string };
              statusInfo:
                | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                | {
                    __typename: "RejectedTransactionStatusInfo";
                    status: TransactionStatus;
                    reason: RejectedReasonCode;
                  }
                | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
            }
          | {
              __typename: "SEPADirectDebitTransaction";
              id: string;
              type: TransactionTypeEnum;
              executionDate: string;
              amount: { __typename: "Amount"; currency: string; value: string };
              statusInfo:
                | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                | {
                    __typename: "RejectedTransactionStatusInfo";
                    status: TransactionStatus;
                    reason: RejectedReasonCode;
                  }
                | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
            }
          | null;
        statusInfo:
          | {
              __typename: "BookedTransactionStatusInfo";
              bookingDate: string;
              status: TransactionStatus;
            }
          | {
              __typename: "CanceledTransactionStatusInfo";
              canceledDate?: string | null;
              status: TransactionStatus;
            }
          | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
          | {
              __typename: "PendingTransactionStatusInfo";
              pendingEndDate?: string | null;
              status: TransactionStatus;
            }
          | {
              __typename: "RejectedTransactionStatusInfo";
              reason: RejectedReasonCode;
              status: TransactionStatus;
            }
          | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
          | {
              __typename: "UpcomingTransactionStatusInfo";
              executionDate: string;
              status: TransactionStatus;
            };
        amount: { __typename: "Amount"; currency: string; value: string };
      }
    | {
        __typename: "SEPADirectDebitTransaction";
        reservedAmountReleasedAt?: string | null;
        id: string;
        side: TransactionSide;
        type: TransactionTypeEnum;
        label: string;
        counterparty: string;
        reference: string;
        externalReference?: string | null;
        statementCanBeGenerated?: boolean | null;
        createdAt: string;
        executionDate: string;
        updatedAt: string;
        creditor:
          | { __typename: "SEPADirectDebitInCreditor"; name: string; IBAN?: string | null }
          | { __typename: "SEPADirectDebitOutCreditor"; name: string; IBAN?: string | null };
        debtor:
          | { __typename: "SEPADirectDebitInDebtor"; name: string; IBAN?: string | null }
          | { __typename: "SEPADirectDebitOutDebtor"; name: string; IBAN?: string | null };
        reservedAmount?: { __typename: "Amount"; value: string; currency: string } | null;
        mandate?:
          | {
              __typename: "SEPAPaymentDirectDebitMandate";
              id: string;
              debtor: { __typename: "SEPAPaymentMandateDebtor"; name: string };
            }
          | {
              __typename: "SEPAReceivedDirectDebitMandate";
              ultimateCreditorName?: string | null;
              id: string;
            }
          | null;
        payment?: { __typename: "Payment"; id: string; createdAt: string } | null;
        originTransaction?:
          | {
              __typename: "CardTransaction";
              id: string;
              type: TransactionTypeEnum;
              executionDate: string;
              amount: { __typename: "Amount"; currency: string; value: string };
              statusInfo:
                | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                | {
                    __typename: "RejectedTransactionStatusInfo";
                    status: TransactionStatus;
                    reason: RejectedReasonCode;
                  }
                | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
            }
          | {
              __typename: "CheckTransaction";
              id: string;
              type: TransactionTypeEnum;
              executionDate: string;
              amount: { __typename: "Amount"; currency: string; value: string };
              statusInfo:
                | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                | {
                    __typename: "RejectedTransactionStatusInfo";
                    status: TransactionStatus;
                    reason: RejectedReasonCode;
                  }
                | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
            }
          | {
              __typename: "FeeTransaction";
              id: string;
              type: TransactionTypeEnum;
              executionDate: string;
              amount: { __typename: "Amount"; currency: string; value: string };
              statusInfo:
                | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                | {
                    __typename: "RejectedTransactionStatusInfo";
                    status: TransactionStatus;
                    reason: RejectedReasonCode;
                  }
                | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
            }
          | {
              __typename: "InternalCreditTransfer";
              id: string;
              type: TransactionTypeEnum;
              executionDate: string;
              amount: { __typename: "Amount"; currency: string; value: string };
              statusInfo:
                | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                | {
                    __typename: "RejectedTransactionStatusInfo";
                    status: TransactionStatus;
                    reason: RejectedReasonCode;
                  }
                | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
            }
          | {
              __typename: "InternalDirectDebitTransaction";
              id: string;
              type: TransactionTypeEnum;
              executionDate: string;
              amount: { __typename: "Amount"; currency: string; value: string };
              statusInfo:
                | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                | {
                    __typename: "RejectedTransactionStatusInfo";
                    status: TransactionStatus;
                    reason: RejectedReasonCode;
                  }
                | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
            }
          | {
              __typename: "InternationalCreditTransferTransaction";
              id: string;
              type: TransactionTypeEnum;
              executionDate: string;
              amount: { __typename: "Amount"; currency: string; value: string };
              statusInfo:
                | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                | {
                    __typename: "RejectedTransactionStatusInfo";
                    status: TransactionStatus;
                    reason: RejectedReasonCode;
                  }
                | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
            }
          | {
              __typename: "SEPACreditTransferTransaction";
              id: string;
              type: TransactionTypeEnum;
              executionDate: string;
              amount: { __typename: "Amount"; currency: string; value: string };
              statusInfo:
                | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                | {
                    __typename: "RejectedTransactionStatusInfo";
                    status: TransactionStatus;
                    reason: RejectedReasonCode;
                  }
                | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
            }
          | {
              __typename: "SEPADirectDebitTransaction";
              id: string;
              type: TransactionTypeEnum;
              executionDate: string;
              amount: { __typename: "Amount"; currency: string; value: string };
              statusInfo:
                | { __typename: "BookedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "CanceledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "PendingTransactionStatusInfo"; status: TransactionStatus }
                | {
                    __typename: "RejectedTransactionStatusInfo";
                    status: TransactionStatus;
                    reason: RejectedReasonCode;
                  }
                | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
                | { __typename: "UpcomingTransactionStatusInfo"; status: TransactionStatus };
            }
          | null;
        statusInfo:
          | {
              __typename: "BookedTransactionStatusInfo";
              bookingDate: string;
              status: TransactionStatus;
            }
          | {
              __typename: "CanceledTransactionStatusInfo";
              canceledDate?: string | null;
              status: TransactionStatus;
            }
          | { __typename: "DeferredTransactionStatusInfo"; status: TransactionStatus }
          | {
              __typename: "PendingTransactionStatusInfo";
              pendingEndDate?: string | null;
              status: TransactionStatus;
            }
          | {
              __typename: "RejectedTransactionStatusInfo";
              reason: RejectedReasonCode;
              status: TransactionStatus;
            }
          | { __typename: "ReleasedTransactionStatusInfo"; status: TransactionStatus }
          | { __typename: "SettledTransactionStatusInfo"; status: TransactionStatus }
          | {
              __typename: "UpcomingTransactionStatusInfo";
              executionDate: string;
              status: TransactionStatus;
            };
        amount: { __typename: "Amount"; currency: string; value: string };
      };
};

export type AccountBalancesFragment = {
  __typename: "AccountBalances";
  available: { __typename: "Amount"; value: string; currency: string };
  pending: { __typename: "Amount"; value: string; currency: string };
  booked: { __typename: "Amount"; value: string; currency: string };
  reserved: { __typename: "Amount"; value: string; currency: string };
};

export type GetAccountBalanceQueryVariables = Exact<{
  accountId: Scalars["ID"]["input"];
}>;

export type GetAccountBalanceQuery = {
  __typename: "Query";
  account?: {
    __typename: "Account";
    id: string;
    merchantProfiles?: { __typename: "MerchantProfileConnection"; totalCount: number } | null;
    fundingSources?: { __typename: "FundingSourceConnection"; totalCount: number } | null;
    balances?: {
      __typename: "AccountBalances";
      available: { __typename: "Amount"; value: string; currency: string };
      pending: { __typename: "Amount"; value: string; currency: string };
      booked: { __typename: "Amount"; value: string; currency: string };
      reserved: { __typename: "Amount"; value: string; currency: string };
    } | null;
    upcomingTransactions?: { __typename: "TransactionConnection"; totalCount: number } | null;
  } | null;
};

export type ValidIbanInformationFragment = {
  __typename: "ValidIban";
  iban: string;
  bank: {
    __typename: "Bank";
    name: string;
    address: {
      __typename: "Address";
      addressLine1?: string | null;
      addressLine2?: string | null;
      city?: string | null;
      country?: string | null;
      postalCode?: string | null;
      state?: string | null;
    };
  };
  reachability: { __typename: "Reachability"; sepaCreditTransferInst: boolean };
};

export type GetIbanValidationQueryVariables = Exact<{
  iban: Scalars["IBAN"]["input"];
}>;

export type GetIbanValidationQuery = {
  __typename: "Query";
  ibanValidation?:
    | { __typename: "InvalidIban"; iban: string; code: InvalidIbanCode }
    | {
        __typename: "ValidIban";
        iban: string;
        bank: {
          __typename: "Bank";
          name: string;
          address: {
            __typename: "Address";
            addressLine1?: string | null;
            addressLine2?: string | null;
            city?: string | null;
            country?: string | null;
            postalCode?: string | null;
            state?: string | null;
          };
        };
        reachability: { __typename: "Reachability"; sepaCreditTransferInst: boolean };
      }
    | null;
};

export type GetAvailableAccountBalanceQueryVariables = Exact<{
  accountMembershipId: Scalars["ID"]["input"];
}>;

export type GetAvailableAccountBalanceQuery = {
  __typename: "Query";
  accountMembership?: {
    __typename: "AccountMembership";
    id: string;
    account?: {
      __typename: "Account";
      id: string;
      balances?: {
        __typename: "AccountBalances";
        available: { __typename: "Amount"; value: string; currency: string };
        pending: { __typename: "Amount"; value: string; currency: string };
        booked: { __typename: "Amount"; value: string; currency: string };
        reserved: { __typename: "Amount"; value: string; currency: string };
      } | null;
    } | null;
  } | null;
};

export type GetInternationalCreditTransferQuoteQueryVariables = Exact<{
  value: Scalars["AmountValue"]["input"];
  currency: Scalars["Currency"]["input"];
  accountId: Scalars["ID"]["input"];
}>;

export type GetInternationalCreditTransferQuoteQuery = {
  __typename: "Query";
  internationalCreditTransferQuote?: {
    __typename: "InternationalCreditTransferQuote";
    exchangeRate: string;
    feesAmount: { __typename: "Amount"; value: string; currency: string };
    targetAmount: { __typename: "Amount"; value: string; currency: string };
    sourceAmount: { __typename: "Amount"; value: string; currency: string };
  } | null;
};

export type GetInternationalBeneficiaryDynamicFormsQueryVariables = Exact<{
  amountValue: Scalars["AmountValue"]["input"];
  currency: Scalars["Currency"]["input"];
  language: InternationalCreditTransferDisplayLanguage;
  dynamicFields?: InputMaybe<
    Array<InternationalBeneficiaryDetailsInput> | InternationalBeneficiaryDetailsInput
  >;
}>;

export type GetInternationalBeneficiaryDynamicFormsQuery = {
  __typename: "Query";
  internationalBeneficiaryDynamicForms?: {
    __typename: "InternationalBeneficiaryDynamicForms";
    schemes: Array<{
      __typename: "Scheme";
      title: string;
      type: InternationalCreditTransferRouteInput;
      remainingFieldsToRefreshCount: number;
      fields: Array<
        | {
            __typename: "DateField";
            example?: string | null;
            validationRegex?: string | null;
            required: boolean;
            key: string;
            name: string;
          }
        | {
            __typename: "RadioField";
            refreshDynamicFieldsOnChange: boolean;
            required: boolean;
            key: string;
            name: string;
            allowedValues: Array<{ __typename: "AllowedValue"; key: string; name: string }>;
          }
        | {
            __typename: "SelectField";
            refreshDynamicFieldsOnChange: boolean;
            required: boolean;
            key: string;
            name: string;
            allowedValues: Array<{ __typename: "AllowedValue"; key: string; name: string }>;
          }
        | {
            __typename: "TextField";
            displayFormat?: string | null;
            example?: string | null;
            minLength?: number | null;
            maxLength?: number | null;
            refreshDynamicFieldsOnChange: boolean;
            validationRegex?: string | null;
            required: boolean;
            key: string;
            name: string;
          }
      >;
    }>;
  } | null;
};

export type GetInternationalCreditTransferTransactionDetailsDynamicFormQueryVariables = Exact<{
  name: Scalars["String"]["input"];
  route: InternationalCreditTransferRouteInput;
  amountValue: Scalars["AmountValue"]["input"];
  currency: Scalars["Currency"]["input"];
  language: InternationalCreditTransferDisplayLanguage;
  beneficiaryDetails:
    | Array<InternationalBeneficiaryDetailsInput>
    | InternationalBeneficiaryDetailsInput;
  dynamicFields?: InputMaybe<
    Array<InternationalCreditTransferDetailsInput> | InternationalCreditTransferDetailsInput
  >;
}>;

export type GetInternationalCreditTransferTransactionDetailsDynamicFormQuery = {
  __typename: "Query";
  internationalCreditTransferTransactionDetailsDynamicForm?: {
    __typename: "InternationalCreditTransferDynamicForm";
    remainingFieldsToRefreshCount: number;
    fields: Array<
      | {
          __typename: "DateField";
          example?: string | null;
          validationRegex?: string | null;
          key: string;
          name: string;
          required: boolean;
        }
      | {
          __typename: "RadioField";
          name: string;
          key: string;
          refreshDynamicFieldsOnChange: boolean;
          required: boolean;
          allowedValues: Array<{ __typename: "AllowedValue"; key: string; name: string }>;
        }
      | {
          __typename: "SelectField";
          key: string;
          name: string;
          refreshDynamicFieldsOnChange: boolean;
          required: boolean;
          allowedValues: Array<{ __typename: "AllowedValue"; key: string; name: string }>;
        }
      | {
          __typename: "TextField";
          displayFormat?: string | null;
          example?: string | null;
          key: string;
          maxLength?: number | null;
          minLength?: number | null;
          name: string;
          refreshDynamicFieldsOnChange: boolean;
          required: boolean;
          validationRegex?: string | null;
        }
    >;
  } | null;
};

export type MerchantRootQueryVariables = Exact<{
  accountId: Scalars["ID"]["input"];
}>;

export type MerchantRootQuery = {
  __typename: "Query";
  account?: {
    __typename: "Account";
    id: string;
    merchantProfiles?: {
      __typename: "MerchantProfileConnection";
      totalCount: number;
      edges: Array<{
        __typename: "MerchantProfileEdge";
        node: { __typename: "MerchantProfile"; id: string };
      }>;
    } | null;
  } | null;
};

export type MerchantProfileQueryVariables = Exact<{
  merchantProfileId: Scalars["ID"]["input"];
}>;

export type MerchantProfileQuery = {
  __typename: "Query";
  merchantProfile?: {
    __typename: "MerchantProfile";
    id: string;
    accentColor?: string | null;
    accountId: string;
    createdAt: string;
    updatedAt: string;
    expectedMonthlyMerchantProcessingVolume: ExpectedMonthlyMerchantProcessingVolume;
    merchantLogoUrl?: string | null;
    merchantName: string;
    merchantWebsiteUrl?: string | null;
    productType: ProductType;
    expectedAverageBasket: { __typename: "Amount"; value: string; currency: string };
    statusInfo:
      | { __typename: "DisabledMerchantProfileStatusInfo"; status: MerchantProfileStatus }
      | { __typename: "EnabledMerchantProfileStatusInfo"; status: MerchantProfileStatus }
      | { __typename: "PendingReviewMerchantProfileStatusInfo"; status: MerchantProfileStatus }
      | { __typename: "RejectedMerchantProfileStatusInfo"; status: MerchantProfileStatus }
      | { __typename: "SuspendedMerchantProfileStatusInfo"; status: MerchantProfileStatus };
    merchantPaymentMethods?: Array<
      | {
          __typename: "CardMerchantPaymentMethod";
          id: string;
          type: MerchantPaymentMethodType;
          methodId: string;
          updatedAt: string;
          version: number;
          rollingReserve?: {
            __typename: "RollingReserve";
            percentage: number;
            rollingDays: number;
          } | null;
          statusInfo:
            | {
                __typename: "DisabledMerchantPaymentMethodStatusInfo";
                status: MerchantPaymentMethodStatus;
              }
            | {
                __typename: "EnabledMerchantPaymentMethodStatusInfo";
                status: MerchantPaymentMethodStatus;
              }
            | {
                __typename: "PendingMerchantPaymentMethodStatusInfo";
                status: MerchantPaymentMethodStatus;
              }
            | {
                __typename: "RejectedMerchantPaymentMethodStatusInfo";
                status: MerchantPaymentMethodStatus;
              }
            | {
                __typename: "SuspendedMerchantPaymentMethodStatusInfo";
                status: MerchantPaymentMethodStatus;
              }
            | {
                __typename: "WaitingForInformationMerchantPaymentMethodStatusInfo";
                status: MerchantPaymentMethodStatus;
                verificationRequirements: Array<
                  | {
                      __typename: "AdditionalInformationRequirements";
                      additionalInformation: Array<AdditionalInformationType>;
                    }
                  | { __typename: "MerchantRequirements"; fields: Array<MerchantRequirementType> }
                  | {
                      __typename: "OtherAdditionalInformationRequirements";
                      otherAdditionalInformation: Array<string>;
                    }
                  | {
                      __typename: "SupportingDocumentRequirements";
                      supportingDocumentPurposes: Array<SupportingDocumentPurposeEnum>;
                    }
                >;
              };
        }
      | {
          __typename: "CheckMerchantPaymentMethod";
          id: string;
          type: MerchantPaymentMethodType;
          methodId: string;
          updatedAt: string;
          version: number;
          rollingReserve?: {
            __typename: "RollingReserve";
            percentage: number;
            rollingDays: number;
          } | null;
          statusInfo:
            | {
                __typename: "DisabledMerchantPaymentMethodStatusInfo";
                status: MerchantPaymentMethodStatus;
              }
            | {
                __typename: "EnabledMerchantPaymentMethodStatusInfo";
                status: MerchantPaymentMethodStatus;
              }
            | {
                __typename: "PendingMerchantPaymentMethodStatusInfo";
                status: MerchantPaymentMethodStatus;
              }
            | {
                __typename: "RejectedMerchantPaymentMethodStatusInfo";
                status: MerchantPaymentMethodStatus;
              }
            | {
                __typename: "SuspendedMerchantPaymentMethodStatusInfo";
                status: MerchantPaymentMethodStatus;
              }
            | {
                __typename: "WaitingForInformationMerchantPaymentMethodStatusInfo";
                status: MerchantPaymentMethodStatus;
                verificationRequirements: Array<
                  | {
                      __typename: "AdditionalInformationRequirements";
                      additionalInformation: Array<AdditionalInformationType>;
                    }
                  | { __typename: "MerchantRequirements"; fields: Array<MerchantRequirementType> }
                  | {
                      __typename: "OtherAdditionalInformationRequirements";
                      otherAdditionalInformation: Array<string>;
                    }
                  | {
                      __typename: "SupportingDocumentRequirements";
                      supportingDocumentPurposes: Array<SupportingDocumentPurposeEnum>;
                    }
                >;
              };
        }
      | {
          __typename: "InPersonCardMerchantPaymentMethod";
          id: string;
          type: MerchantPaymentMethodType;
          methodId: string;
          updatedAt: string;
          version: number;
          rollingReserve?: {
            __typename: "RollingReserve";
            percentage: number;
            rollingDays: number;
          } | null;
          statusInfo:
            | {
                __typename: "DisabledMerchantPaymentMethodStatusInfo";
                status: MerchantPaymentMethodStatus;
              }
            | {
                __typename: "EnabledMerchantPaymentMethodStatusInfo";
                status: MerchantPaymentMethodStatus;
              }
            | {
                __typename: "PendingMerchantPaymentMethodStatusInfo";
                status: MerchantPaymentMethodStatus;
              }
            | {
                __typename: "RejectedMerchantPaymentMethodStatusInfo";
                status: MerchantPaymentMethodStatus;
              }
            | {
                __typename: "SuspendedMerchantPaymentMethodStatusInfo";
                status: MerchantPaymentMethodStatus;
              }
            | {
                __typename: "WaitingForInformationMerchantPaymentMethodStatusInfo";
                status: MerchantPaymentMethodStatus;
                verificationRequirements: Array<
                  | {
                      __typename: "AdditionalInformationRequirements";
                      additionalInformation: Array<AdditionalInformationType>;
                    }
                  | { __typename: "MerchantRequirements"; fields: Array<MerchantRequirementType> }
                  | {
                      __typename: "OtherAdditionalInformationRequirements";
                      otherAdditionalInformation: Array<string>;
                    }
                  | {
                      __typename: "SupportingDocumentRequirements";
                      supportingDocumentPurposes: Array<SupportingDocumentPurposeEnum>;
                    }
                >;
              };
        }
      | {
          __typename: "InternalDirectDebitB2BMerchantPaymentMethod";
          id: string;
          type: MerchantPaymentMethodType;
          methodId: string;
          updatedAt: string;
          version: number;
          rollingReserve?: {
            __typename: "RollingReserve";
            percentage: number;
            rollingDays: number;
          } | null;
          statusInfo:
            | {
                __typename: "DisabledMerchantPaymentMethodStatusInfo";
                status: MerchantPaymentMethodStatus;
              }
            | {
                __typename: "EnabledMerchantPaymentMethodStatusInfo";
                status: MerchantPaymentMethodStatus;
              }
            | {
                __typename: "PendingMerchantPaymentMethodStatusInfo";
                status: MerchantPaymentMethodStatus;
              }
            | {
                __typename: "RejectedMerchantPaymentMethodStatusInfo";
                status: MerchantPaymentMethodStatus;
              }
            | {
                __typename: "SuspendedMerchantPaymentMethodStatusInfo";
                status: MerchantPaymentMethodStatus;
              }
            | {
                __typename: "WaitingForInformationMerchantPaymentMethodStatusInfo";
                status: MerchantPaymentMethodStatus;
                verificationRequirements: Array<
                  | {
                      __typename: "AdditionalInformationRequirements";
                      additionalInformation: Array<AdditionalInformationType>;
                    }
                  | { __typename: "MerchantRequirements"; fields: Array<MerchantRequirementType> }
                  | {
                      __typename: "OtherAdditionalInformationRequirements";
                      otherAdditionalInformation: Array<string>;
                    }
                  | {
                      __typename: "SupportingDocumentRequirements";
                      supportingDocumentPurposes: Array<SupportingDocumentPurposeEnum>;
                    }
                >;
              };
        }
      | {
          __typename: "InternalDirectDebitStandardMerchantPaymentMethod";
          id: string;
          type: MerchantPaymentMethodType;
          methodId: string;
          updatedAt: string;
          version: number;
          rollingReserve?: {
            __typename: "RollingReserve";
            percentage: number;
            rollingDays: number;
          } | null;
          statusInfo:
            | {
                __typename: "DisabledMerchantPaymentMethodStatusInfo";
                status: MerchantPaymentMethodStatus;
              }
            | {
                __typename: "EnabledMerchantPaymentMethodStatusInfo";
                status: MerchantPaymentMethodStatus;
              }
            | {
                __typename: "PendingMerchantPaymentMethodStatusInfo";
                status: MerchantPaymentMethodStatus;
              }
            | {
                __typename: "RejectedMerchantPaymentMethodStatusInfo";
                status: MerchantPaymentMethodStatus;
              }
            | {
                __typename: "SuspendedMerchantPaymentMethodStatusInfo";
                status: MerchantPaymentMethodStatus;
              }
            | {
                __typename: "WaitingForInformationMerchantPaymentMethodStatusInfo";
                status: MerchantPaymentMethodStatus;
                verificationRequirements: Array<
                  | {
                      __typename: "AdditionalInformationRequirements";
                      additionalInformation: Array<AdditionalInformationType>;
                    }
                  | { __typename: "MerchantRequirements"; fields: Array<MerchantRequirementType> }
                  | {
                      __typename: "OtherAdditionalInformationRequirements";
                      otherAdditionalInformation: Array<string>;
                    }
                  | {
                      __typename: "SupportingDocumentRequirements";
                      supportingDocumentPurposes: Array<SupportingDocumentPurposeEnum>;
                    }
                >;
              };
        }
      | {
          __typename: "SepaDirectDebitB2BMerchantPaymentMethod";
          sepaCreditorIdentifier?: string | null;
          useSwanSepaCreditorIdentifier: boolean;
          id: string;
          type: MerchantPaymentMethodType;
          methodId: string;
          updatedAt: string;
          version: number;
          rollingReserve?: {
            __typename: "RollingReserve";
            percentage: number;
            rollingDays: number;
          } | null;
          statusInfo:
            | {
                __typename: "DisabledMerchantPaymentMethodStatusInfo";
                status: MerchantPaymentMethodStatus;
              }
            | {
                __typename: "EnabledMerchantPaymentMethodStatusInfo";
                status: MerchantPaymentMethodStatus;
              }
            | {
                __typename: "PendingMerchantPaymentMethodStatusInfo";
                status: MerchantPaymentMethodStatus;
              }
            | {
                __typename: "RejectedMerchantPaymentMethodStatusInfo";
                status: MerchantPaymentMethodStatus;
              }
            | {
                __typename: "SuspendedMerchantPaymentMethodStatusInfo";
                status: MerchantPaymentMethodStatus;
              }
            | {
                __typename: "WaitingForInformationMerchantPaymentMethodStatusInfo";
                status: MerchantPaymentMethodStatus;
                verificationRequirements: Array<
                  | {
                      __typename: "AdditionalInformationRequirements";
                      additionalInformation: Array<AdditionalInformationType>;
                    }
                  | { __typename: "MerchantRequirements"; fields: Array<MerchantRequirementType> }
                  | {
                      __typename: "OtherAdditionalInformationRequirements";
                      otherAdditionalInformation: Array<string>;
                    }
                  | {
                      __typename: "SupportingDocumentRequirements";
                      supportingDocumentPurposes: Array<SupportingDocumentPurposeEnum>;
                    }
                >;
              };
        }
      | {
          __typename: "SepaDirectDebitCoreMerchantPaymentMethod";
          sepaCreditorIdentifier?: string | null;
          useSwanSepaCreditorIdentifier: boolean;
          id: string;
          type: MerchantPaymentMethodType;
          methodId: string;
          updatedAt: string;
          version: number;
          rollingReserve?: {
            __typename: "RollingReserve";
            percentage: number;
            rollingDays: number;
          } | null;
          statusInfo:
            | {
                __typename: "DisabledMerchantPaymentMethodStatusInfo";
                status: MerchantPaymentMethodStatus;
              }
            | {
                __typename: "EnabledMerchantPaymentMethodStatusInfo";
                status: MerchantPaymentMethodStatus;
              }
            | {
                __typename: "PendingMerchantPaymentMethodStatusInfo";
                status: MerchantPaymentMethodStatus;
              }
            | {
                __typename: "RejectedMerchantPaymentMethodStatusInfo";
                status: MerchantPaymentMethodStatus;
              }
            | {
                __typename: "SuspendedMerchantPaymentMethodStatusInfo";
                status: MerchantPaymentMethodStatus;
              }
            | {
                __typename: "WaitingForInformationMerchantPaymentMethodStatusInfo";
                status: MerchantPaymentMethodStatus;
                verificationRequirements: Array<
                  | {
                      __typename: "AdditionalInformationRequirements";
                      additionalInformation: Array<AdditionalInformationType>;
                    }
                  | { __typename: "MerchantRequirements"; fields: Array<MerchantRequirementType> }
                  | {
                      __typename: "OtherAdditionalInformationRequirements";
                      otherAdditionalInformation: Array<string>;
                    }
                  | {
                      __typename: "SupportingDocumentRequirements";
                      supportingDocumentPurposes: Array<SupportingDocumentPurposeEnum>;
                    }
                >;
              };
        }
    > | null;
    requestMerchantProfileUpdate?: {
      __typename: "RequestMerchantProfileUpdate";
      id: string;
      status: RequestMerchantProfileUpdateStatus;
      merchantName?: string | null;
      merchantWebsiteUrl?: string | null;
      merchantLogoUrl?: string | null;
      productType?: ProductType | null;
      expectedMonthlyMerchantProcessingVolume?: ExpectedMonthlyMerchantProcessingVolume | null;
      expectedAverageBasket?: { __typename: "Amount"; value: string; currency: string } | null;
    } | null;
  } | null;
};

export type MerchantProfilesQueryVariables = Exact<{
  accountId: Scalars["ID"]["input"];
  filters: MerchantProfileFiltersInput;
  first: Scalars["Int"]["input"];
  after?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type MerchantProfilesQuery = {
  __typename: "Query";
  account?: {
    __typename: "Account";
    id: string;
    merchantProfiles?: {
      __typename: "MerchantProfileConnection";
      totalCount: number;
      edges: Array<{
        __typename: "MerchantProfileEdge";
        cursor: string;
        node: {
          __typename: "MerchantProfile";
          id: string;
          accentColor?: string | null;
          accountId: string;
          createdAt: string;
          updatedAt: string;
          expectedMonthlyMerchantProcessingVolume: ExpectedMonthlyMerchantProcessingVolume;
          merchantLogoUrl?: string | null;
          merchantName: string;
          merchantWebsiteUrl?: string | null;
          productType: ProductType;
          expectedAverageBasket: { __typename: "Amount"; value: string; currency: string };
          statusInfo:
            | { __typename: "DisabledMerchantProfileStatusInfo"; status: MerchantProfileStatus }
            | { __typename: "EnabledMerchantProfileStatusInfo"; status: MerchantProfileStatus }
            | {
                __typename: "PendingReviewMerchantProfileStatusInfo";
                status: MerchantProfileStatus;
              }
            | { __typename: "RejectedMerchantProfileStatusInfo"; status: MerchantProfileStatus }
            | { __typename: "SuspendedMerchantProfileStatusInfo"; status: MerchantProfileStatus };
          merchantPaymentMethods?: Array<
            | {
                __typename: "CardMerchantPaymentMethod";
                id: string;
                type: MerchantPaymentMethodType;
                methodId: string;
                updatedAt: string;
                version: number;
                rollingReserve?: {
                  __typename: "RollingReserve";
                  percentage: number;
                  rollingDays: number;
                } | null;
                statusInfo:
                  | {
                      __typename: "DisabledMerchantPaymentMethodStatusInfo";
                      status: MerchantPaymentMethodStatus;
                    }
                  | {
                      __typename: "EnabledMerchantPaymentMethodStatusInfo";
                      status: MerchantPaymentMethodStatus;
                    }
                  | {
                      __typename: "PendingMerchantPaymentMethodStatusInfo";
                      status: MerchantPaymentMethodStatus;
                    }
                  | {
                      __typename: "RejectedMerchantPaymentMethodStatusInfo";
                      status: MerchantPaymentMethodStatus;
                    }
                  | {
                      __typename: "SuspendedMerchantPaymentMethodStatusInfo";
                      status: MerchantPaymentMethodStatus;
                    }
                  | {
                      __typename: "WaitingForInformationMerchantPaymentMethodStatusInfo";
                      status: MerchantPaymentMethodStatus;
                      verificationRequirements: Array<
                        | {
                            __typename: "AdditionalInformationRequirements";
                            additionalInformation: Array<AdditionalInformationType>;
                          }
                        | {
                            __typename: "MerchantRequirements";
                            fields: Array<MerchantRequirementType>;
                          }
                        | {
                            __typename: "OtherAdditionalInformationRequirements";
                            otherAdditionalInformation: Array<string>;
                          }
                        | {
                            __typename: "SupportingDocumentRequirements";
                            supportingDocumentPurposes: Array<SupportingDocumentPurposeEnum>;
                          }
                      >;
                    };
              }
            | {
                __typename: "CheckMerchantPaymentMethod";
                id: string;
                type: MerchantPaymentMethodType;
                methodId: string;
                updatedAt: string;
                version: number;
                rollingReserve?: {
                  __typename: "RollingReserve";
                  percentage: number;
                  rollingDays: number;
                } | null;
                statusInfo:
                  | {
                      __typename: "DisabledMerchantPaymentMethodStatusInfo";
                      status: MerchantPaymentMethodStatus;
                    }
                  | {
                      __typename: "EnabledMerchantPaymentMethodStatusInfo";
                      status: MerchantPaymentMethodStatus;
                    }
                  | {
                      __typename: "PendingMerchantPaymentMethodStatusInfo";
                      status: MerchantPaymentMethodStatus;
                    }
                  | {
                      __typename: "RejectedMerchantPaymentMethodStatusInfo";
                      status: MerchantPaymentMethodStatus;
                    }
                  | {
                      __typename: "SuspendedMerchantPaymentMethodStatusInfo";
                      status: MerchantPaymentMethodStatus;
                    }
                  | {
                      __typename: "WaitingForInformationMerchantPaymentMethodStatusInfo";
                      status: MerchantPaymentMethodStatus;
                      verificationRequirements: Array<
                        | {
                            __typename: "AdditionalInformationRequirements";
                            additionalInformation: Array<AdditionalInformationType>;
                          }
                        | {
                            __typename: "MerchantRequirements";
                            fields: Array<MerchantRequirementType>;
                          }
                        | {
                            __typename: "OtherAdditionalInformationRequirements";
                            otherAdditionalInformation: Array<string>;
                          }
                        | {
                            __typename: "SupportingDocumentRequirements";
                            supportingDocumentPurposes: Array<SupportingDocumentPurposeEnum>;
                          }
                      >;
                    };
              }
            | {
                __typename: "InPersonCardMerchantPaymentMethod";
                id: string;
                type: MerchantPaymentMethodType;
                methodId: string;
                updatedAt: string;
                version: number;
                rollingReserve?: {
                  __typename: "RollingReserve";
                  percentage: number;
                  rollingDays: number;
                } | null;
                statusInfo:
                  | {
                      __typename: "DisabledMerchantPaymentMethodStatusInfo";
                      status: MerchantPaymentMethodStatus;
                    }
                  | {
                      __typename: "EnabledMerchantPaymentMethodStatusInfo";
                      status: MerchantPaymentMethodStatus;
                    }
                  | {
                      __typename: "PendingMerchantPaymentMethodStatusInfo";
                      status: MerchantPaymentMethodStatus;
                    }
                  | {
                      __typename: "RejectedMerchantPaymentMethodStatusInfo";
                      status: MerchantPaymentMethodStatus;
                    }
                  | {
                      __typename: "SuspendedMerchantPaymentMethodStatusInfo";
                      status: MerchantPaymentMethodStatus;
                    }
                  | {
                      __typename: "WaitingForInformationMerchantPaymentMethodStatusInfo";
                      status: MerchantPaymentMethodStatus;
                      verificationRequirements: Array<
                        | {
                            __typename: "AdditionalInformationRequirements";
                            additionalInformation: Array<AdditionalInformationType>;
                          }
                        | {
                            __typename: "MerchantRequirements";
                            fields: Array<MerchantRequirementType>;
                          }
                        | {
                            __typename: "OtherAdditionalInformationRequirements";
                            otherAdditionalInformation: Array<string>;
                          }
                        | {
                            __typename: "SupportingDocumentRequirements";
                            supportingDocumentPurposes: Array<SupportingDocumentPurposeEnum>;
                          }
                      >;
                    };
              }
            | {
                __typename: "InternalDirectDebitB2BMerchantPaymentMethod";
                id: string;
                type: MerchantPaymentMethodType;
                methodId: string;
                updatedAt: string;
                version: number;
                rollingReserve?: {
                  __typename: "RollingReserve";
                  percentage: number;
                  rollingDays: number;
                } | null;
                statusInfo:
                  | {
                      __typename: "DisabledMerchantPaymentMethodStatusInfo";
                      status: MerchantPaymentMethodStatus;
                    }
                  | {
                      __typename: "EnabledMerchantPaymentMethodStatusInfo";
                      status: MerchantPaymentMethodStatus;
                    }
                  | {
                      __typename: "PendingMerchantPaymentMethodStatusInfo";
                      status: MerchantPaymentMethodStatus;
                    }
                  | {
                      __typename: "RejectedMerchantPaymentMethodStatusInfo";
                      status: MerchantPaymentMethodStatus;
                    }
                  | {
                      __typename: "SuspendedMerchantPaymentMethodStatusInfo";
                      status: MerchantPaymentMethodStatus;
                    }
                  | {
                      __typename: "WaitingForInformationMerchantPaymentMethodStatusInfo";
                      status: MerchantPaymentMethodStatus;
                      verificationRequirements: Array<
                        | {
                            __typename: "AdditionalInformationRequirements";
                            additionalInformation: Array<AdditionalInformationType>;
                          }
                        | {
                            __typename: "MerchantRequirements";
                            fields: Array<MerchantRequirementType>;
                          }
                        | {
                            __typename: "OtherAdditionalInformationRequirements";
                            otherAdditionalInformation: Array<string>;
                          }
                        | {
                            __typename: "SupportingDocumentRequirements";
                            supportingDocumentPurposes: Array<SupportingDocumentPurposeEnum>;
                          }
                      >;
                    };
              }
            | {
                __typename: "InternalDirectDebitStandardMerchantPaymentMethod";
                id: string;
                type: MerchantPaymentMethodType;
                methodId: string;
                updatedAt: string;
                version: number;
                rollingReserve?: {
                  __typename: "RollingReserve";
                  percentage: number;
                  rollingDays: number;
                } | null;
                statusInfo:
                  | {
                      __typename: "DisabledMerchantPaymentMethodStatusInfo";
                      status: MerchantPaymentMethodStatus;
                    }
                  | {
                      __typename: "EnabledMerchantPaymentMethodStatusInfo";
                      status: MerchantPaymentMethodStatus;
                    }
                  | {
                      __typename: "PendingMerchantPaymentMethodStatusInfo";
                      status: MerchantPaymentMethodStatus;
                    }
                  | {
                      __typename: "RejectedMerchantPaymentMethodStatusInfo";
                      status: MerchantPaymentMethodStatus;
                    }
                  | {
                      __typename: "SuspendedMerchantPaymentMethodStatusInfo";
                      status: MerchantPaymentMethodStatus;
                    }
                  | {
                      __typename: "WaitingForInformationMerchantPaymentMethodStatusInfo";
                      status: MerchantPaymentMethodStatus;
                      verificationRequirements: Array<
                        | {
                            __typename: "AdditionalInformationRequirements";
                            additionalInformation: Array<AdditionalInformationType>;
                          }
                        | {
                            __typename: "MerchantRequirements";
                            fields: Array<MerchantRequirementType>;
                          }
                        | {
                            __typename: "OtherAdditionalInformationRequirements";
                            otherAdditionalInformation: Array<string>;
                          }
                        | {
                            __typename: "SupportingDocumentRequirements";
                            supportingDocumentPurposes: Array<SupportingDocumentPurposeEnum>;
                          }
                      >;
                    };
              }
            | {
                __typename: "SepaDirectDebitB2BMerchantPaymentMethod";
                sepaCreditorIdentifier?: string | null;
                useSwanSepaCreditorIdentifier: boolean;
                id: string;
                type: MerchantPaymentMethodType;
                methodId: string;
                updatedAt: string;
                version: number;
                rollingReserve?: {
                  __typename: "RollingReserve";
                  percentage: number;
                  rollingDays: number;
                } | null;
                statusInfo:
                  | {
                      __typename: "DisabledMerchantPaymentMethodStatusInfo";
                      status: MerchantPaymentMethodStatus;
                    }
                  | {
                      __typename: "EnabledMerchantPaymentMethodStatusInfo";
                      status: MerchantPaymentMethodStatus;
                    }
                  | {
                      __typename: "PendingMerchantPaymentMethodStatusInfo";
                      status: MerchantPaymentMethodStatus;
                    }
                  | {
                      __typename: "RejectedMerchantPaymentMethodStatusInfo";
                      status: MerchantPaymentMethodStatus;
                    }
                  | {
                      __typename: "SuspendedMerchantPaymentMethodStatusInfo";
                      status: MerchantPaymentMethodStatus;
                    }
                  | {
                      __typename: "WaitingForInformationMerchantPaymentMethodStatusInfo";
                      status: MerchantPaymentMethodStatus;
                      verificationRequirements: Array<
                        | {
                            __typename: "AdditionalInformationRequirements";
                            additionalInformation: Array<AdditionalInformationType>;
                          }
                        | {
                            __typename: "MerchantRequirements";
                            fields: Array<MerchantRequirementType>;
                          }
                        | {
                            __typename: "OtherAdditionalInformationRequirements";
                            otherAdditionalInformation: Array<string>;
                          }
                        | {
                            __typename: "SupportingDocumentRequirements";
                            supportingDocumentPurposes: Array<SupportingDocumentPurposeEnum>;
                          }
                      >;
                    };
              }
            | {
                __typename: "SepaDirectDebitCoreMerchantPaymentMethod";
                sepaCreditorIdentifier?: string | null;
                useSwanSepaCreditorIdentifier: boolean;
                id: string;
                type: MerchantPaymentMethodType;
                methodId: string;
                updatedAt: string;
                version: number;
                rollingReserve?: {
                  __typename: "RollingReserve";
                  percentage: number;
                  rollingDays: number;
                } | null;
                statusInfo:
                  | {
                      __typename: "DisabledMerchantPaymentMethodStatusInfo";
                      status: MerchantPaymentMethodStatus;
                    }
                  | {
                      __typename: "EnabledMerchantPaymentMethodStatusInfo";
                      status: MerchantPaymentMethodStatus;
                    }
                  | {
                      __typename: "PendingMerchantPaymentMethodStatusInfo";
                      status: MerchantPaymentMethodStatus;
                    }
                  | {
                      __typename: "RejectedMerchantPaymentMethodStatusInfo";
                      status: MerchantPaymentMethodStatus;
                    }
                  | {
                      __typename: "SuspendedMerchantPaymentMethodStatusInfo";
                      status: MerchantPaymentMethodStatus;
                    }
                  | {
                      __typename: "WaitingForInformationMerchantPaymentMethodStatusInfo";
                      status: MerchantPaymentMethodStatus;
                      verificationRequirements: Array<
                        | {
                            __typename: "AdditionalInformationRequirements";
                            additionalInformation: Array<AdditionalInformationType>;
                          }
                        | {
                            __typename: "MerchantRequirements";
                            fields: Array<MerchantRequirementType>;
                          }
                        | {
                            __typename: "OtherAdditionalInformationRequirements";
                            otherAdditionalInformation: Array<string>;
                          }
                        | {
                            __typename: "SupportingDocumentRequirements";
                            supportingDocumentPurposes: Array<SupportingDocumentPurposeEnum>;
                          }
                      >;
                    };
              }
          > | null;
          requestMerchantProfileUpdate?: {
            __typename: "RequestMerchantProfileUpdate";
            id: string;
            status: RequestMerchantProfileUpdateStatus;
            merchantName?: string | null;
            merchantWebsiteUrl?: string | null;
            merchantLogoUrl?: string | null;
            productType?: ProductType | null;
            expectedMonthlyMerchantProcessingVolume?: ExpectedMonthlyMerchantProcessingVolume | null;
            expectedAverageBasket?: {
              __typename: "Amount";
              value: string;
              currency: string;
            } | null;
          } | null;
        };
      }>;
      pageInfo: {
        __typename: "PageInfo";
        hasNextPage?: boolean | null;
        hasPreviousPage?: boolean | null;
        startCursor?: string | null;
        endCursor?: string | null;
      };
    } | null;
  } | null;
};

export type PaymentLinkFragment = {
  __typename: "MerchantPaymentLink";
  id: string;
  label?: string | null;
  url: string;
  reference?: string | null;
  externalReference?: string | null;
  statusInfo:
    | { __typename: "ActiveMerchantPaymentLinkStatusInfo"; status: MerchantPaymentLinkStatus }
    | { __typename: "CompletedMerchantPaymentLinkStatusInfo"; status: MerchantPaymentLinkStatus }
    | { __typename: "ExpiredMerchantPaymentLinkStatusInfo"; status: MerchantPaymentLinkStatus };
  amount: { __typename: "Amount"; currency: string; value: string };
};

type MerchantPayment_CardMerchantPayment_Fragment = {
  __typename: "CardMerchantPayment";
  id: string;
  label?: string | null;
  externalReference?: string | null;
  reference?: string | null;
  paymentLink?: { __typename: "MerchantPaymentLink"; id: string } | null;
  threeDs?: {
    __typename: "ThreeDS";
    statusInfo:
      | { __typename: "ExemptThreeDsStatusInfo"; status: IncomingThreeDsStatus }
      | {
          __typename: "FailedThreeDsStatusInfo";
          reasonCode: FailedThreeDsReason;
          status: IncomingThreeDsStatus;
        }
      | { __typename: "NotRequestedThreeDsStatusInfo"; status: IncomingThreeDsStatus }
      | { __typename: "RequestedThreeDsStatusInfo"; status: IncomingThreeDsStatus }
      | { __typename: "SucceededThreeDsStatusInfo"; status: IncomingThreeDsStatus };
  } | null;
  statusInfo:
    | {
        __typename: "MerchantPaymentAuthorized";
        createdAt: string;
        authorizedAt: string;
        status: MerchantPaymentStatus;
      }
    | {
        __typename: "MerchantPaymentCanceled";
        createdAt: string;
        canceledAt: string;
        status: MerchantPaymentStatus;
      }
    | {
        __typename: "MerchantPaymentCaptured";
        createdAt: string;
        authorizedAt: string;
        capturedAt: string;
        status: MerchantPaymentStatus;
      }
    | {
        __typename: "MerchantPaymentDisputed";
        createdAt: string;
        authorizedAt: string;
        capturedAt: string;
        disputedAt: string;
        status: MerchantPaymentStatus;
      }
    | { __typename: "MerchantPaymentInitiated"; createdAt: string; status: MerchantPaymentStatus }
    | {
        __typename: "MerchantPaymentPartiallyDisputed";
        createdAt: string;
        authorizedAt: string;
        capturedAt: string;
        disputedAt: string;
        status: MerchantPaymentStatus;
      }
    | {
        __typename: "MerchantPaymentRejected";
        rejectedReasonCode: MerchantPaymentRejectedReason;
        createdAt: string;
        rejectedAt: string;
        status: MerchantPaymentStatus;
      };
  amount: { __typename: "Amount"; currency: string; value: string };
  paymentMethod:
    | { __typename: "CardMerchantPaymentMethod"; id: string; type: MerchantPaymentMethodType }
    | { __typename: "CheckMerchantPaymentMethod"; id: string; type: MerchantPaymentMethodType }
    | {
        __typename: "InPersonCardMerchantPaymentMethod";
        id: string;
        type: MerchantPaymentMethodType;
      }
    | {
        __typename: "InternalDirectDebitB2BMerchantPaymentMethod";
        id: string;
        type: MerchantPaymentMethodType;
      }
    | {
        __typename: "InternalDirectDebitStandardMerchantPaymentMethod";
        id: string;
        type: MerchantPaymentMethodType;
      }
    | {
        __typename: "SepaDirectDebitB2BMerchantPaymentMethod";
        id: string;
        type: MerchantPaymentMethodType;
      }
    | {
        __typename: "SepaDirectDebitCoreMerchantPaymentMethod";
        id: string;
        type: MerchantPaymentMethodType;
      };
  merchantProfile: { __typename: "MerchantProfile"; id: string };
  balance: {
    __typename: "MerchantBalance";
    totalAuthorized: { __typename: "Amount"; currency: string; value: string };
    totalCaptured: { __typename: "Amount"; currency: string; value: string };
    availableToCapture: { __typename: "Amount"; currency: string; value: string };
    totalRefunded: { __typename: "Amount"; currency: string; value: string };
    availableToRefund: { __typename: "Amount"; currency: string; value: string };
    availableToCancel: { __typename: "Amount"; currency: string; value: string };
    totalCanceled: { __typename: "Amount"; currency: string; value: string };
    totalDisputed: { __typename: "Amount"; currency: string; value: string };
  };
};

type MerchantPayment_CheckMerchantPayment_Fragment = {
  __typename: "CheckMerchantPayment";
  id: string;
  label?: string | null;
  externalReference?: string | null;
  reference?: string | null;
  statusInfo:
    | {
        __typename: "MerchantPaymentAuthorized";
        createdAt: string;
        authorizedAt: string;
        status: MerchantPaymentStatus;
      }
    | {
        __typename: "MerchantPaymentCanceled";
        createdAt: string;
        canceledAt: string;
        status: MerchantPaymentStatus;
      }
    | {
        __typename: "MerchantPaymentCaptured";
        createdAt: string;
        authorizedAt: string;
        capturedAt: string;
        status: MerchantPaymentStatus;
      }
    | {
        __typename: "MerchantPaymentDisputed";
        createdAt: string;
        authorizedAt: string;
        capturedAt: string;
        disputedAt: string;
        status: MerchantPaymentStatus;
      }
    | { __typename: "MerchantPaymentInitiated"; createdAt: string; status: MerchantPaymentStatus }
    | {
        __typename: "MerchantPaymentPartiallyDisputed";
        createdAt: string;
        authorizedAt: string;
        capturedAt: string;
        disputedAt: string;
        status: MerchantPaymentStatus;
      }
    | {
        __typename: "MerchantPaymentRejected";
        rejectedReasonCode: MerchantPaymentRejectedReason;
        createdAt: string;
        rejectedAt: string;
        status: MerchantPaymentStatus;
      };
  amount: { __typename: "Amount"; currency: string; value: string };
  paymentMethod:
    | { __typename: "CardMerchantPaymentMethod"; id: string; type: MerchantPaymentMethodType }
    | { __typename: "CheckMerchantPaymentMethod"; id: string; type: MerchantPaymentMethodType }
    | {
        __typename: "InPersonCardMerchantPaymentMethod";
        id: string;
        type: MerchantPaymentMethodType;
      }
    | {
        __typename: "InternalDirectDebitB2BMerchantPaymentMethod";
        id: string;
        type: MerchantPaymentMethodType;
      }
    | {
        __typename: "InternalDirectDebitStandardMerchantPaymentMethod";
        id: string;
        type: MerchantPaymentMethodType;
      }
    | {
        __typename: "SepaDirectDebitB2BMerchantPaymentMethod";
        id: string;
        type: MerchantPaymentMethodType;
      }
    | {
        __typename: "SepaDirectDebitCoreMerchantPaymentMethod";
        id: string;
        type: MerchantPaymentMethodType;
      };
  merchantProfile: { __typename: "MerchantProfile"; id: string };
  balance: {
    __typename: "MerchantBalance";
    totalAuthorized: { __typename: "Amount"; currency: string; value: string };
    totalCaptured: { __typename: "Amount"; currency: string; value: string };
    availableToCapture: { __typename: "Amount"; currency: string; value: string };
    totalRefunded: { __typename: "Amount"; currency: string; value: string };
    availableToRefund: { __typename: "Amount"; currency: string; value: string };
    availableToCancel: { __typename: "Amount"; currency: string; value: string };
    totalCanceled: { __typename: "Amount"; currency: string; value: string };
    totalDisputed: { __typename: "Amount"; currency: string; value: string };
  };
};

type MerchantPayment_SepaDirectDebitMerchantPayment_Fragment = {
  __typename: "SepaDirectDebitMerchantPayment";
  id: string;
  label?: string | null;
  externalReference?: string | null;
  reference?: string | null;
  paymentLink?: { __typename: "MerchantPaymentLink"; id: string } | null;
  statusInfo:
    | {
        __typename: "MerchantPaymentAuthorized";
        createdAt: string;
        authorizedAt: string;
        status: MerchantPaymentStatus;
      }
    | {
        __typename: "MerchantPaymentCanceled";
        createdAt: string;
        canceledAt: string;
        status: MerchantPaymentStatus;
      }
    | {
        __typename: "MerchantPaymentCaptured";
        createdAt: string;
        authorizedAt: string;
        capturedAt: string;
        status: MerchantPaymentStatus;
      }
    | {
        __typename: "MerchantPaymentDisputed";
        createdAt: string;
        authorizedAt: string;
        capturedAt: string;
        disputedAt: string;
        status: MerchantPaymentStatus;
      }
    | { __typename: "MerchantPaymentInitiated"; createdAt: string; status: MerchantPaymentStatus }
    | {
        __typename: "MerchantPaymentPartiallyDisputed";
        createdAt: string;
        authorizedAt: string;
        capturedAt: string;
        disputedAt: string;
        status: MerchantPaymentStatus;
      }
    | {
        __typename: "MerchantPaymentRejected";
        rejectedReasonCode: MerchantPaymentRejectedReason;
        createdAt: string;
        rejectedAt: string;
        status: MerchantPaymentStatus;
      };
  amount: { __typename: "Amount"; currency: string; value: string };
  paymentMethod:
    | { __typename: "CardMerchantPaymentMethod"; id: string; type: MerchantPaymentMethodType }
    | { __typename: "CheckMerchantPaymentMethod"; id: string; type: MerchantPaymentMethodType }
    | {
        __typename: "InPersonCardMerchantPaymentMethod";
        id: string;
        type: MerchantPaymentMethodType;
      }
    | {
        __typename: "InternalDirectDebitB2BMerchantPaymentMethod";
        id: string;
        type: MerchantPaymentMethodType;
      }
    | {
        __typename: "InternalDirectDebitStandardMerchantPaymentMethod";
        id: string;
        type: MerchantPaymentMethodType;
      }
    | {
        __typename: "SepaDirectDebitB2BMerchantPaymentMethod";
        id: string;
        type: MerchantPaymentMethodType;
      }
    | {
        __typename: "SepaDirectDebitCoreMerchantPaymentMethod";
        id: string;
        type: MerchantPaymentMethodType;
      };
  merchantProfile: { __typename: "MerchantProfile"; id: string };
  balance: {
    __typename: "MerchantBalance";
    totalAuthorized: { __typename: "Amount"; currency: string; value: string };
    totalCaptured: { __typename: "Amount"; currency: string; value: string };
    availableToCapture: { __typename: "Amount"; currency: string; value: string };
    totalRefunded: { __typename: "Amount"; currency: string; value: string };
    availableToRefund: { __typename: "Amount"; currency: string; value: string };
    availableToCancel: { __typename: "Amount"; currency: string; value: string };
    totalCanceled: { __typename: "Amount"; currency: string; value: string };
    totalDisputed: { __typename: "Amount"; currency: string; value: string };
  };
};

export type MerchantPaymentFragment =
  | MerchantPayment_CardMerchantPayment_Fragment
  | MerchantPayment_CheckMerchantPayment_Fragment
  | MerchantPayment_SepaDirectDebitMerchantPayment_Fragment;

export type MerchantPaymentsConnectionFragment = {
  __typename: "MerchantPaymentConnection";
  totalCount: number;
  pageInfo: { __typename: "PageInfo"; endCursor?: string | null; hasNextPage?: boolean | null };
  edges: Array<{
    __typename: "MerchantPaymentEdge";
    node:
      | {
          __typename: "CardMerchantPayment";
          id: string;
          label?: string | null;
          externalReference?: string | null;
          reference?: string | null;
          paymentLink?: { __typename: "MerchantPaymentLink"; id: string } | null;
          threeDs?: {
            __typename: "ThreeDS";
            statusInfo:
              | { __typename: "ExemptThreeDsStatusInfo"; status: IncomingThreeDsStatus }
              | {
                  __typename: "FailedThreeDsStatusInfo";
                  reasonCode: FailedThreeDsReason;
                  status: IncomingThreeDsStatus;
                }
              | { __typename: "NotRequestedThreeDsStatusInfo"; status: IncomingThreeDsStatus }
              | { __typename: "RequestedThreeDsStatusInfo"; status: IncomingThreeDsStatus }
              | { __typename: "SucceededThreeDsStatusInfo"; status: IncomingThreeDsStatus };
          } | null;
          statusInfo:
            | {
                __typename: "MerchantPaymentAuthorized";
                createdAt: string;
                authorizedAt: string;
                status: MerchantPaymentStatus;
              }
            | {
                __typename: "MerchantPaymentCanceled";
                createdAt: string;
                canceledAt: string;
                status: MerchantPaymentStatus;
              }
            | {
                __typename: "MerchantPaymentCaptured";
                createdAt: string;
                authorizedAt: string;
                capturedAt: string;
                status: MerchantPaymentStatus;
              }
            | {
                __typename: "MerchantPaymentDisputed";
                createdAt: string;
                authorizedAt: string;
                capturedAt: string;
                disputedAt: string;
                status: MerchantPaymentStatus;
              }
            | {
                __typename: "MerchantPaymentInitiated";
                createdAt: string;
                status: MerchantPaymentStatus;
              }
            | {
                __typename: "MerchantPaymentPartiallyDisputed";
                createdAt: string;
                authorizedAt: string;
                capturedAt: string;
                disputedAt: string;
                status: MerchantPaymentStatus;
              }
            | {
                __typename: "MerchantPaymentRejected";
                rejectedReasonCode: MerchantPaymentRejectedReason;
                createdAt: string;
                rejectedAt: string;
                status: MerchantPaymentStatus;
              };
          amount: { __typename: "Amount"; currency: string; value: string };
          paymentMethod:
            | {
                __typename: "CardMerchantPaymentMethod";
                id: string;
                type: MerchantPaymentMethodType;
              }
            | {
                __typename: "CheckMerchantPaymentMethod";
                id: string;
                type: MerchantPaymentMethodType;
              }
            | {
                __typename: "InPersonCardMerchantPaymentMethod";
                id: string;
                type: MerchantPaymentMethodType;
              }
            | {
                __typename: "InternalDirectDebitB2BMerchantPaymentMethod";
                id: string;
                type: MerchantPaymentMethodType;
              }
            | {
                __typename: "InternalDirectDebitStandardMerchantPaymentMethod";
                id: string;
                type: MerchantPaymentMethodType;
              }
            | {
                __typename: "SepaDirectDebitB2BMerchantPaymentMethod";
                id: string;
                type: MerchantPaymentMethodType;
              }
            | {
                __typename: "SepaDirectDebitCoreMerchantPaymentMethod";
                id: string;
                type: MerchantPaymentMethodType;
              };
          merchantProfile: { __typename: "MerchantProfile"; id: string };
          balance: {
            __typename: "MerchantBalance";
            totalAuthorized: { __typename: "Amount"; currency: string; value: string };
            totalCaptured: { __typename: "Amount"; currency: string; value: string };
            availableToCapture: { __typename: "Amount"; currency: string; value: string };
            totalRefunded: { __typename: "Amount"; currency: string; value: string };
            availableToRefund: { __typename: "Amount"; currency: string; value: string };
            availableToCancel: { __typename: "Amount"; currency: string; value: string };
            totalCanceled: { __typename: "Amount"; currency: string; value: string };
            totalDisputed: { __typename: "Amount"; currency: string; value: string };
          };
        }
      | {
          __typename: "CheckMerchantPayment";
          id: string;
          label?: string | null;
          externalReference?: string | null;
          reference?: string | null;
          statusInfo:
            | {
                __typename: "MerchantPaymentAuthorized";
                createdAt: string;
                authorizedAt: string;
                status: MerchantPaymentStatus;
              }
            | {
                __typename: "MerchantPaymentCanceled";
                createdAt: string;
                canceledAt: string;
                status: MerchantPaymentStatus;
              }
            | {
                __typename: "MerchantPaymentCaptured";
                createdAt: string;
                authorizedAt: string;
                capturedAt: string;
                status: MerchantPaymentStatus;
              }
            | {
                __typename: "MerchantPaymentDisputed";
                createdAt: string;
                authorizedAt: string;
                capturedAt: string;
                disputedAt: string;
                status: MerchantPaymentStatus;
              }
            | {
                __typename: "MerchantPaymentInitiated";
                createdAt: string;
                status: MerchantPaymentStatus;
              }
            | {
                __typename: "MerchantPaymentPartiallyDisputed";
                createdAt: string;
                authorizedAt: string;
                capturedAt: string;
                disputedAt: string;
                status: MerchantPaymentStatus;
              }
            | {
                __typename: "MerchantPaymentRejected";
                rejectedReasonCode: MerchantPaymentRejectedReason;
                createdAt: string;
                rejectedAt: string;
                status: MerchantPaymentStatus;
              };
          amount: { __typename: "Amount"; currency: string; value: string };
          paymentMethod:
            | {
                __typename: "CardMerchantPaymentMethod";
                id: string;
                type: MerchantPaymentMethodType;
              }
            | {
                __typename: "CheckMerchantPaymentMethod";
                id: string;
                type: MerchantPaymentMethodType;
              }
            | {
                __typename: "InPersonCardMerchantPaymentMethod";
                id: string;
                type: MerchantPaymentMethodType;
              }
            | {
                __typename: "InternalDirectDebitB2BMerchantPaymentMethod";
                id: string;
                type: MerchantPaymentMethodType;
              }
            | {
                __typename: "InternalDirectDebitStandardMerchantPaymentMethod";
                id: string;
                type: MerchantPaymentMethodType;
              }
            | {
                __typename: "SepaDirectDebitB2BMerchantPaymentMethod";
                id: string;
                type: MerchantPaymentMethodType;
              }
            | {
                __typename: "SepaDirectDebitCoreMerchantPaymentMethod";
                id: string;
                type: MerchantPaymentMethodType;
              };
          merchantProfile: { __typename: "MerchantProfile"; id: string };
          balance: {
            __typename: "MerchantBalance";
            totalAuthorized: { __typename: "Amount"; currency: string; value: string };
            totalCaptured: { __typename: "Amount"; currency: string; value: string };
            availableToCapture: { __typename: "Amount"; currency: string; value: string };
            totalRefunded: { __typename: "Amount"; currency: string; value: string };
            availableToRefund: { __typename: "Amount"; currency: string; value: string };
            availableToCancel: { __typename: "Amount"; currency: string; value: string };
            totalCanceled: { __typename: "Amount"; currency: string; value: string };
            totalDisputed: { __typename: "Amount"; currency: string; value: string };
          };
        }
      | {
          __typename: "SepaDirectDebitMerchantPayment";
          id: string;
          label?: string | null;
          externalReference?: string | null;
          reference?: string | null;
          paymentLink?: { __typename: "MerchantPaymentLink"; id: string } | null;
          statusInfo:
            | {
                __typename: "MerchantPaymentAuthorized";
                createdAt: string;
                authorizedAt: string;
                status: MerchantPaymentStatus;
              }
            | {
                __typename: "MerchantPaymentCanceled";
                createdAt: string;
                canceledAt: string;
                status: MerchantPaymentStatus;
              }
            | {
                __typename: "MerchantPaymentCaptured";
                createdAt: string;
                authorizedAt: string;
                capturedAt: string;
                status: MerchantPaymentStatus;
              }
            | {
                __typename: "MerchantPaymentDisputed";
                createdAt: string;
                authorizedAt: string;
                capturedAt: string;
                disputedAt: string;
                status: MerchantPaymentStatus;
              }
            | {
                __typename: "MerchantPaymentInitiated";
                createdAt: string;
                status: MerchantPaymentStatus;
              }
            | {
                __typename: "MerchantPaymentPartiallyDisputed";
                createdAt: string;
                authorizedAt: string;
                capturedAt: string;
                disputedAt: string;
                status: MerchantPaymentStatus;
              }
            | {
                __typename: "MerchantPaymentRejected";
                rejectedReasonCode: MerchantPaymentRejectedReason;
                createdAt: string;
                rejectedAt: string;
                status: MerchantPaymentStatus;
              };
          amount: { __typename: "Amount"; currency: string; value: string };
          paymentMethod:
            | {
                __typename: "CardMerchantPaymentMethod";
                id: string;
                type: MerchantPaymentMethodType;
              }
            | {
                __typename: "CheckMerchantPaymentMethod";
                id: string;
                type: MerchantPaymentMethodType;
              }
            | {
                __typename: "InPersonCardMerchantPaymentMethod";
                id: string;
                type: MerchantPaymentMethodType;
              }
            | {
                __typename: "InternalDirectDebitB2BMerchantPaymentMethod";
                id: string;
                type: MerchantPaymentMethodType;
              }
            | {
                __typename: "InternalDirectDebitStandardMerchantPaymentMethod";
                id: string;
                type: MerchantPaymentMethodType;
              }
            | {
                __typename: "SepaDirectDebitB2BMerchantPaymentMethod";
                id: string;
                type: MerchantPaymentMethodType;
              }
            | {
                __typename: "SepaDirectDebitCoreMerchantPaymentMethod";
                id: string;
                type: MerchantPaymentMethodType;
              };
          merchantProfile: { __typename: "MerchantProfile"; id: string };
          balance: {
            __typename: "MerchantBalance";
            totalAuthorized: { __typename: "Amount"; currency: string; value: string };
            totalCaptured: { __typename: "Amount"; currency: string; value: string };
            availableToCapture: { __typename: "Amount"; currency: string; value: string };
            totalRefunded: { __typename: "Amount"; currency: string; value: string };
            availableToRefund: { __typename: "Amount"; currency: string; value: string };
            availableToCancel: { __typename: "Amount"; currency: string; value: string };
            totalCanceled: { __typename: "Amount"; currency: string; value: string };
            totalDisputed: { __typename: "Amount"; currency: string; value: string };
          };
        };
  }>;
};

export type MerchantPaymentsQueryVariables = Exact<{
  merchantProfileId: Scalars["ID"]["input"];
  filters: MerchantPaymentFiltersInput;
  first: Scalars["Int"]["input"];
  after?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type MerchantPaymentsQuery = {
  __typename: "Query";
  merchantProfile?: {
    __typename: "MerchantProfile";
    id: string;
    accentColor?: string | null;
    merchantLogoUrl?: string | null;
    merchantName: string;
    statusInfo:
      | { __typename: "DisabledMerchantProfileStatusInfo"; status: MerchantProfileStatus }
      | { __typename: "EnabledMerchantProfileStatusInfo"; status: MerchantProfileStatus }
      | { __typename: "PendingReviewMerchantProfileStatusInfo"; status: MerchantProfileStatus }
      | { __typename: "RejectedMerchantProfileStatusInfo"; status: MerchantProfileStatus }
      | { __typename: "SuspendedMerchantProfileStatusInfo"; status: MerchantProfileStatus };
    merchantPayments?: {
      __typename: "MerchantPaymentConnection";
      totalCount: number;
      pageInfo: { __typename: "PageInfo"; endCursor?: string | null; hasNextPage?: boolean | null };
      edges: Array<{
        __typename: "MerchantPaymentEdge";
        node:
          | {
              __typename: "CardMerchantPayment";
              id: string;
              label?: string | null;
              externalReference?: string | null;
              reference?: string | null;
              paymentLink?: { __typename: "MerchantPaymentLink"; id: string } | null;
              threeDs?: {
                __typename: "ThreeDS";
                statusInfo:
                  | { __typename: "ExemptThreeDsStatusInfo"; status: IncomingThreeDsStatus }
                  | {
                      __typename: "FailedThreeDsStatusInfo";
                      reasonCode: FailedThreeDsReason;
                      status: IncomingThreeDsStatus;
                    }
                  | { __typename: "NotRequestedThreeDsStatusInfo"; status: IncomingThreeDsStatus }
                  | { __typename: "RequestedThreeDsStatusInfo"; status: IncomingThreeDsStatus }
                  | { __typename: "SucceededThreeDsStatusInfo"; status: IncomingThreeDsStatus };
              } | null;
              statusInfo:
                | {
                    __typename: "MerchantPaymentAuthorized";
                    createdAt: string;
                    authorizedAt: string;
                    status: MerchantPaymentStatus;
                  }
                | {
                    __typename: "MerchantPaymentCanceled";
                    createdAt: string;
                    canceledAt: string;
                    status: MerchantPaymentStatus;
                  }
                | {
                    __typename: "MerchantPaymentCaptured";
                    createdAt: string;
                    authorizedAt: string;
                    capturedAt: string;
                    status: MerchantPaymentStatus;
                  }
                | {
                    __typename: "MerchantPaymentDisputed";
                    createdAt: string;
                    authorizedAt: string;
                    capturedAt: string;
                    disputedAt: string;
                    status: MerchantPaymentStatus;
                  }
                | {
                    __typename: "MerchantPaymentInitiated";
                    createdAt: string;
                    status: MerchantPaymentStatus;
                  }
                | {
                    __typename: "MerchantPaymentPartiallyDisputed";
                    createdAt: string;
                    authorizedAt: string;
                    capturedAt: string;
                    disputedAt: string;
                    status: MerchantPaymentStatus;
                  }
                | {
                    __typename: "MerchantPaymentRejected";
                    rejectedReasonCode: MerchantPaymentRejectedReason;
                    createdAt: string;
                    rejectedAt: string;
                    status: MerchantPaymentStatus;
                  };
              amount: { __typename: "Amount"; currency: string; value: string };
              paymentMethod:
                | {
                    __typename: "CardMerchantPaymentMethod";
                    id: string;
                    type: MerchantPaymentMethodType;
                  }
                | {
                    __typename: "CheckMerchantPaymentMethod";
                    id: string;
                    type: MerchantPaymentMethodType;
                  }
                | {
                    __typename: "InPersonCardMerchantPaymentMethod";
                    id: string;
                    type: MerchantPaymentMethodType;
                  }
                | {
                    __typename: "InternalDirectDebitB2BMerchantPaymentMethod";
                    id: string;
                    type: MerchantPaymentMethodType;
                  }
                | {
                    __typename: "InternalDirectDebitStandardMerchantPaymentMethod";
                    id: string;
                    type: MerchantPaymentMethodType;
                  }
                | {
                    __typename: "SepaDirectDebitB2BMerchantPaymentMethod";
                    id: string;
                    type: MerchantPaymentMethodType;
                  }
                | {
                    __typename: "SepaDirectDebitCoreMerchantPaymentMethod";
                    id: string;
                    type: MerchantPaymentMethodType;
                  };
              merchantProfile: { __typename: "MerchantProfile"; id: string };
              balance: {
                __typename: "MerchantBalance";
                totalAuthorized: { __typename: "Amount"; currency: string; value: string };
                totalCaptured: { __typename: "Amount"; currency: string; value: string };
                availableToCapture: { __typename: "Amount"; currency: string; value: string };
                totalRefunded: { __typename: "Amount"; currency: string; value: string };
                availableToRefund: { __typename: "Amount"; currency: string; value: string };
                availableToCancel: { __typename: "Amount"; currency: string; value: string };
                totalCanceled: { __typename: "Amount"; currency: string; value: string };
                totalDisputed: { __typename: "Amount"; currency: string; value: string };
              };
            }
          | {
              __typename: "CheckMerchantPayment";
              id: string;
              label?: string | null;
              externalReference?: string | null;
              reference?: string | null;
              statusInfo:
                | {
                    __typename: "MerchantPaymentAuthorized";
                    createdAt: string;
                    authorizedAt: string;
                    status: MerchantPaymentStatus;
                  }
                | {
                    __typename: "MerchantPaymentCanceled";
                    createdAt: string;
                    canceledAt: string;
                    status: MerchantPaymentStatus;
                  }
                | {
                    __typename: "MerchantPaymentCaptured";
                    createdAt: string;
                    authorizedAt: string;
                    capturedAt: string;
                    status: MerchantPaymentStatus;
                  }
                | {
                    __typename: "MerchantPaymentDisputed";
                    createdAt: string;
                    authorizedAt: string;
                    capturedAt: string;
                    disputedAt: string;
                    status: MerchantPaymentStatus;
                  }
                | {
                    __typename: "MerchantPaymentInitiated";
                    createdAt: string;
                    status: MerchantPaymentStatus;
                  }
                | {
                    __typename: "MerchantPaymentPartiallyDisputed";
                    createdAt: string;
                    authorizedAt: string;
                    capturedAt: string;
                    disputedAt: string;
                    status: MerchantPaymentStatus;
                  }
                | {
                    __typename: "MerchantPaymentRejected";
                    rejectedReasonCode: MerchantPaymentRejectedReason;
                    createdAt: string;
                    rejectedAt: string;
                    status: MerchantPaymentStatus;
                  };
              amount: { __typename: "Amount"; currency: string; value: string };
              paymentMethod:
                | {
                    __typename: "CardMerchantPaymentMethod";
                    id: string;
                    type: MerchantPaymentMethodType;
                  }
                | {
                    __typename: "CheckMerchantPaymentMethod";
                    id: string;
                    type: MerchantPaymentMethodType;
                  }
                | {
                    __typename: "InPersonCardMerchantPaymentMethod";
                    id: string;
                    type: MerchantPaymentMethodType;
                  }
                | {
                    __typename: "InternalDirectDebitB2BMerchantPaymentMethod";
                    id: string;
                    type: MerchantPaymentMethodType;
                  }
                | {
                    __typename: "InternalDirectDebitStandardMerchantPaymentMethod";
                    id: string;
                    type: MerchantPaymentMethodType;
                  }
                | {
                    __typename: "SepaDirectDebitB2BMerchantPaymentMethod";
                    id: string;
                    type: MerchantPaymentMethodType;
                  }
                | {
                    __typename: "SepaDirectDebitCoreMerchantPaymentMethod";
                    id: string;
                    type: MerchantPaymentMethodType;
                  };
              merchantProfile: { __typename: "MerchantProfile"; id: string };
              balance: {
                __typename: "MerchantBalance";
                totalAuthorized: { __typename: "Amount"; currency: string; value: string };
                totalCaptured: { __typename: "Amount"; currency: string; value: string };
                availableToCapture: { __typename: "Amount"; currency: string; value: string };
                totalRefunded: { __typename: "Amount"; currency: string; value: string };
                availableToRefund: { __typename: "Amount"; currency: string; value: string };
                availableToCancel: { __typename: "Amount"; currency: string; value: string };
                totalCanceled: { __typename: "Amount"; currency: string; value: string };
                totalDisputed: { __typename: "Amount"; currency: string; value: string };
              };
            }
          | {
              __typename: "SepaDirectDebitMerchantPayment";
              id: string;
              label?: string | null;
              externalReference?: string | null;
              reference?: string | null;
              paymentLink?: { __typename: "MerchantPaymentLink"; id: string } | null;
              statusInfo:
                | {
                    __typename: "MerchantPaymentAuthorized";
                    createdAt: string;
                    authorizedAt: string;
                    status: MerchantPaymentStatus;
                  }
                | {
                    __typename: "MerchantPaymentCanceled";
                    createdAt: string;
                    canceledAt: string;
                    status: MerchantPaymentStatus;
                  }
                | {
                    __typename: "MerchantPaymentCaptured";
                    createdAt: string;
                    authorizedAt: string;
                    capturedAt: string;
                    status: MerchantPaymentStatus;
                  }
                | {
                    __typename: "MerchantPaymentDisputed";
                    createdAt: string;
                    authorizedAt: string;
                    capturedAt: string;
                    disputedAt: string;
                    status: MerchantPaymentStatus;
                  }
                | {
                    __typename: "MerchantPaymentInitiated";
                    createdAt: string;
                    status: MerchantPaymentStatus;
                  }
                | {
                    __typename: "MerchantPaymentPartiallyDisputed";
                    createdAt: string;
                    authorizedAt: string;
                    capturedAt: string;
                    disputedAt: string;
                    status: MerchantPaymentStatus;
                  }
                | {
                    __typename: "MerchantPaymentRejected";
                    rejectedReasonCode: MerchantPaymentRejectedReason;
                    createdAt: string;
                    rejectedAt: string;
                    status: MerchantPaymentStatus;
                  };
              amount: { __typename: "Amount"; currency: string; value: string };
              paymentMethod:
                | {
                    __typename: "CardMerchantPaymentMethod";
                    id: string;
                    type: MerchantPaymentMethodType;
                  }
                | {
                    __typename: "CheckMerchantPaymentMethod";
                    id: string;
                    type: MerchantPaymentMethodType;
                  }
                | {
                    __typename: "InPersonCardMerchantPaymentMethod";
                    id: string;
                    type: MerchantPaymentMethodType;
                  }
                | {
                    __typename: "InternalDirectDebitB2BMerchantPaymentMethod";
                    id: string;
                    type: MerchantPaymentMethodType;
                  }
                | {
                    __typename: "InternalDirectDebitStandardMerchantPaymentMethod";
                    id: string;
                    type: MerchantPaymentMethodType;
                  }
                | {
                    __typename: "SepaDirectDebitB2BMerchantPaymentMethod";
                    id: string;
                    type: MerchantPaymentMethodType;
                  }
                | {
                    __typename: "SepaDirectDebitCoreMerchantPaymentMethod";
                    id: string;
                    type: MerchantPaymentMethodType;
                  };
              merchantProfile: { __typename: "MerchantProfile"; id: string };
              balance: {
                __typename: "MerchantBalance";
                totalAuthorized: { __typename: "Amount"; currency: string; value: string };
                totalCaptured: { __typename: "Amount"; currency: string; value: string };
                availableToCapture: { __typename: "Amount"; currency: string; value: string };
                totalRefunded: { __typename: "Amount"; currency: string; value: string };
                availableToRefund: { __typename: "Amount"; currency: string; value: string };
                availableToCancel: { __typename: "Amount"; currency: string; value: string };
                totalCanceled: { __typename: "Amount"; currency: string; value: string };
                totalDisputed: { __typename: "Amount"; currency: string; value: string };
              };
            };
      }>;
    } | null;
    merchantPaymentMethods?: Array<
      | {
          __typename: "CardMerchantPaymentMethod";
          id: string;
          type: MerchantPaymentMethodType;
          methodId: string;
          updatedAt: string;
          version: number;
          rollingReserve?: {
            __typename: "RollingReserve";
            percentage: number;
            rollingDays: number;
          } | null;
          statusInfo:
            | {
                __typename: "DisabledMerchantPaymentMethodStatusInfo";
                status: MerchantPaymentMethodStatus;
              }
            | {
                __typename: "EnabledMerchantPaymentMethodStatusInfo";
                status: MerchantPaymentMethodStatus;
              }
            | {
                __typename: "PendingMerchantPaymentMethodStatusInfo";
                status: MerchantPaymentMethodStatus;
              }
            | {
                __typename: "RejectedMerchantPaymentMethodStatusInfo";
                status: MerchantPaymentMethodStatus;
              }
            | {
                __typename: "SuspendedMerchantPaymentMethodStatusInfo";
                status: MerchantPaymentMethodStatus;
              }
            | {
                __typename: "WaitingForInformationMerchantPaymentMethodStatusInfo";
                status: MerchantPaymentMethodStatus;
                verificationRequirements: Array<
                  | {
                      __typename: "AdditionalInformationRequirements";
                      additionalInformation: Array<AdditionalInformationType>;
                    }
                  | { __typename: "MerchantRequirements"; fields: Array<MerchantRequirementType> }
                  | {
                      __typename: "OtherAdditionalInformationRequirements";
                      otherAdditionalInformation: Array<string>;
                    }
                  | {
                      __typename: "SupportingDocumentRequirements";
                      supportingDocumentPurposes: Array<SupportingDocumentPurposeEnum>;
                    }
                >;
              };
        }
      | {
          __typename: "CheckMerchantPaymentMethod";
          id: string;
          type: MerchantPaymentMethodType;
          methodId: string;
          updatedAt: string;
          version: number;
          rollingReserve?: {
            __typename: "RollingReserve";
            percentage: number;
            rollingDays: number;
          } | null;
          statusInfo:
            | {
                __typename: "DisabledMerchantPaymentMethodStatusInfo";
                status: MerchantPaymentMethodStatus;
              }
            | {
                __typename: "EnabledMerchantPaymentMethodStatusInfo";
                status: MerchantPaymentMethodStatus;
              }
            | {
                __typename: "PendingMerchantPaymentMethodStatusInfo";
                status: MerchantPaymentMethodStatus;
              }
            | {
                __typename: "RejectedMerchantPaymentMethodStatusInfo";
                status: MerchantPaymentMethodStatus;
              }
            | {
                __typename: "SuspendedMerchantPaymentMethodStatusInfo";
                status: MerchantPaymentMethodStatus;
              }
            | {
                __typename: "WaitingForInformationMerchantPaymentMethodStatusInfo";
                status: MerchantPaymentMethodStatus;
                verificationRequirements: Array<
                  | {
                      __typename: "AdditionalInformationRequirements";
                      additionalInformation: Array<AdditionalInformationType>;
                    }
                  | { __typename: "MerchantRequirements"; fields: Array<MerchantRequirementType> }
                  | {
                      __typename: "OtherAdditionalInformationRequirements";
                      otherAdditionalInformation: Array<string>;
                    }
                  | {
                      __typename: "SupportingDocumentRequirements";
                      supportingDocumentPurposes: Array<SupportingDocumentPurposeEnum>;
                    }
                >;
              };
        }
      | {
          __typename: "InPersonCardMerchantPaymentMethod";
          id: string;
          type: MerchantPaymentMethodType;
          methodId: string;
          updatedAt: string;
          version: number;
          rollingReserve?: {
            __typename: "RollingReserve";
            percentage: number;
            rollingDays: number;
          } | null;
          statusInfo:
            | {
                __typename: "DisabledMerchantPaymentMethodStatusInfo";
                status: MerchantPaymentMethodStatus;
              }
            | {
                __typename: "EnabledMerchantPaymentMethodStatusInfo";
                status: MerchantPaymentMethodStatus;
              }
            | {
                __typename: "PendingMerchantPaymentMethodStatusInfo";
                status: MerchantPaymentMethodStatus;
              }
            | {
                __typename: "RejectedMerchantPaymentMethodStatusInfo";
                status: MerchantPaymentMethodStatus;
              }
            | {
                __typename: "SuspendedMerchantPaymentMethodStatusInfo";
                status: MerchantPaymentMethodStatus;
              }
            | {
                __typename: "WaitingForInformationMerchantPaymentMethodStatusInfo";
                status: MerchantPaymentMethodStatus;
                verificationRequirements: Array<
                  | {
                      __typename: "AdditionalInformationRequirements";
                      additionalInformation: Array<AdditionalInformationType>;
                    }
                  | { __typename: "MerchantRequirements"; fields: Array<MerchantRequirementType> }
                  | {
                      __typename: "OtherAdditionalInformationRequirements";
                      otherAdditionalInformation: Array<string>;
                    }
                  | {
                      __typename: "SupportingDocumentRequirements";
                      supportingDocumentPurposes: Array<SupportingDocumentPurposeEnum>;
                    }
                >;
              };
        }
      | {
          __typename: "InternalDirectDebitB2BMerchantPaymentMethod";
          id: string;
          type: MerchantPaymentMethodType;
          methodId: string;
          updatedAt: string;
          version: number;
          rollingReserve?: {
            __typename: "RollingReserve";
            percentage: number;
            rollingDays: number;
          } | null;
          statusInfo:
            | {
                __typename: "DisabledMerchantPaymentMethodStatusInfo";
                status: MerchantPaymentMethodStatus;
              }
            | {
                __typename: "EnabledMerchantPaymentMethodStatusInfo";
                status: MerchantPaymentMethodStatus;
              }
            | {
                __typename: "PendingMerchantPaymentMethodStatusInfo";
                status: MerchantPaymentMethodStatus;
              }
            | {
                __typename: "RejectedMerchantPaymentMethodStatusInfo";
                status: MerchantPaymentMethodStatus;
              }
            | {
                __typename: "SuspendedMerchantPaymentMethodStatusInfo";
                status: MerchantPaymentMethodStatus;
              }
            | {
                __typename: "WaitingForInformationMerchantPaymentMethodStatusInfo";
                status: MerchantPaymentMethodStatus;
                verificationRequirements: Array<
                  | {
                      __typename: "AdditionalInformationRequirements";
                      additionalInformation: Array<AdditionalInformationType>;
                    }
                  | { __typename: "MerchantRequirements"; fields: Array<MerchantRequirementType> }
                  | {
                      __typename: "OtherAdditionalInformationRequirements";
                      otherAdditionalInformation: Array<string>;
                    }
                  | {
                      __typename: "SupportingDocumentRequirements";
                      supportingDocumentPurposes: Array<SupportingDocumentPurposeEnum>;
                    }
                >;
              };
        }
      | {
          __typename: "InternalDirectDebitStandardMerchantPaymentMethod";
          id: string;
          type: MerchantPaymentMethodType;
          methodId: string;
          updatedAt: string;
          version: number;
          rollingReserve?: {
            __typename: "RollingReserve";
            percentage: number;
            rollingDays: number;
          } | null;
          statusInfo:
            | {
                __typename: "DisabledMerchantPaymentMethodStatusInfo";
                status: MerchantPaymentMethodStatus;
              }
            | {
                __typename: "EnabledMerchantPaymentMethodStatusInfo";
                status: MerchantPaymentMethodStatus;
              }
            | {
                __typename: "PendingMerchantPaymentMethodStatusInfo";
                status: MerchantPaymentMethodStatus;
              }
            | {
                __typename: "RejectedMerchantPaymentMethodStatusInfo";
                status: MerchantPaymentMethodStatus;
              }
            | {
                __typename: "SuspendedMerchantPaymentMethodStatusInfo";
                status: MerchantPaymentMethodStatus;
              }
            | {
                __typename: "WaitingForInformationMerchantPaymentMethodStatusInfo";
                status: MerchantPaymentMethodStatus;
                verificationRequirements: Array<
                  | {
                      __typename: "AdditionalInformationRequirements";
                      additionalInformation: Array<AdditionalInformationType>;
                    }
                  | { __typename: "MerchantRequirements"; fields: Array<MerchantRequirementType> }
                  | {
                      __typename: "OtherAdditionalInformationRequirements";
                      otherAdditionalInformation: Array<string>;
                    }
                  | {
                      __typename: "SupportingDocumentRequirements";
                      supportingDocumentPurposes: Array<SupportingDocumentPurposeEnum>;
                    }
                >;
              };
        }
      | {
          __typename: "SepaDirectDebitB2BMerchantPaymentMethod";
          sepaCreditorIdentifier?: string | null;
          useSwanSepaCreditorIdentifier: boolean;
          id: string;
          type: MerchantPaymentMethodType;
          methodId: string;
          updatedAt: string;
          version: number;
          rollingReserve?: {
            __typename: "RollingReserve";
            percentage: number;
            rollingDays: number;
          } | null;
          statusInfo:
            | {
                __typename: "DisabledMerchantPaymentMethodStatusInfo";
                status: MerchantPaymentMethodStatus;
              }
            | {
                __typename: "EnabledMerchantPaymentMethodStatusInfo";
                status: MerchantPaymentMethodStatus;
              }
            | {
                __typename: "PendingMerchantPaymentMethodStatusInfo";
                status: MerchantPaymentMethodStatus;
              }
            | {
                __typename: "RejectedMerchantPaymentMethodStatusInfo";
                status: MerchantPaymentMethodStatus;
              }
            | {
                __typename: "SuspendedMerchantPaymentMethodStatusInfo";
                status: MerchantPaymentMethodStatus;
              }
            | {
                __typename: "WaitingForInformationMerchantPaymentMethodStatusInfo";
                status: MerchantPaymentMethodStatus;
                verificationRequirements: Array<
                  | {
                      __typename: "AdditionalInformationRequirements";
                      additionalInformation: Array<AdditionalInformationType>;
                    }
                  | { __typename: "MerchantRequirements"; fields: Array<MerchantRequirementType> }
                  | {
                      __typename: "OtherAdditionalInformationRequirements";
                      otherAdditionalInformation: Array<string>;
                    }
                  | {
                      __typename: "SupportingDocumentRequirements";
                      supportingDocumentPurposes: Array<SupportingDocumentPurposeEnum>;
                    }
                >;
              };
        }
      | {
          __typename: "SepaDirectDebitCoreMerchantPaymentMethod";
          sepaCreditorIdentifier?: string | null;
          useSwanSepaCreditorIdentifier: boolean;
          id: string;
          type: MerchantPaymentMethodType;
          methodId: string;
          updatedAt: string;
          version: number;
          rollingReserve?: {
            __typename: "RollingReserve";
            percentage: number;
            rollingDays: number;
          } | null;
          statusInfo:
            | {
                __typename: "DisabledMerchantPaymentMethodStatusInfo";
                status: MerchantPaymentMethodStatus;
              }
            | {
                __typename: "EnabledMerchantPaymentMethodStatusInfo";
                status: MerchantPaymentMethodStatus;
              }
            | {
                __typename: "PendingMerchantPaymentMethodStatusInfo";
                status: MerchantPaymentMethodStatus;
              }
            | {
                __typename: "RejectedMerchantPaymentMethodStatusInfo";
                status: MerchantPaymentMethodStatus;
              }
            | {
                __typename: "SuspendedMerchantPaymentMethodStatusInfo";
                status: MerchantPaymentMethodStatus;
              }
            | {
                __typename: "WaitingForInformationMerchantPaymentMethodStatusInfo";
                status: MerchantPaymentMethodStatus;
                verificationRequirements: Array<
                  | {
                      __typename: "AdditionalInformationRequirements";
                      additionalInformation: Array<AdditionalInformationType>;
                    }
                  | { __typename: "MerchantRequirements"; fields: Array<MerchantRequirementType> }
                  | {
                      __typename: "OtherAdditionalInformationRequirements";
                      otherAdditionalInformation: Array<string>;
                    }
                  | {
                      __typename: "SupportingDocumentRequirements";
                      supportingDocumentPurposes: Array<SupportingDocumentPurposeEnum>;
                    }
                >;
              };
        }
    > | null;
  } | null;
};

export type GetMainMerchantPaymentDetailsQueryVariables = Exact<{
  paymentId: Scalars["ID"]["input"];
}>;

export type GetMainMerchantPaymentDetailsQuery = {
  __typename: "Query";
  merchantPayment?:
    | {
        __typename: "CardMerchantPayment";
        id: string;
        label?: string | null;
        externalReference?: string | null;
        reference?: string | null;
        paymentLink?: { __typename: "MerchantPaymentLink"; id: string } | null;
        threeDs?: {
          __typename: "ThreeDS";
          statusInfo:
            | { __typename: "ExemptThreeDsStatusInfo"; status: IncomingThreeDsStatus }
            | {
                __typename: "FailedThreeDsStatusInfo";
                reasonCode: FailedThreeDsReason;
                status: IncomingThreeDsStatus;
              }
            | { __typename: "NotRequestedThreeDsStatusInfo"; status: IncomingThreeDsStatus }
            | { __typename: "RequestedThreeDsStatusInfo"; status: IncomingThreeDsStatus }
            | { __typename: "SucceededThreeDsStatusInfo"; status: IncomingThreeDsStatus };
        } | null;
        statusInfo:
          | {
              __typename: "MerchantPaymentAuthorized";
              createdAt: string;
              authorizedAt: string;
              status: MerchantPaymentStatus;
            }
          | {
              __typename: "MerchantPaymentCanceled";
              createdAt: string;
              canceledAt: string;
              status: MerchantPaymentStatus;
            }
          | {
              __typename: "MerchantPaymentCaptured";
              createdAt: string;
              authorizedAt: string;
              capturedAt: string;
              status: MerchantPaymentStatus;
            }
          | {
              __typename: "MerchantPaymentDisputed";
              createdAt: string;
              authorizedAt: string;
              capturedAt: string;
              disputedAt: string;
              status: MerchantPaymentStatus;
            }
          | {
              __typename: "MerchantPaymentInitiated";
              createdAt: string;
              status: MerchantPaymentStatus;
            }
          | {
              __typename: "MerchantPaymentPartiallyDisputed";
              createdAt: string;
              authorizedAt: string;
              capturedAt: string;
              disputedAt: string;
              status: MerchantPaymentStatus;
            }
          | {
              __typename: "MerchantPaymentRejected";
              rejectedReasonCode: MerchantPaymentRejectedReason;
              createdAt: string;
              rejectedAt: string;
              status: MerchantPaymentStatus;
            };
        amount: { __typename: "Amount"; currency: string; value: string };
        paymentMethod:
          | { __typename: "CardMerchantPaymentMethod"; id: string; type: MerchantPaymentMethodType }
          | {
              __typename: "CheckMerchantPaymentMethod";
              id: string;
              type: MerchantPaymentMethodType;
            }
          | {
              __typename: "InPersonCardMerchantPaymentMethod";
              id: string;
              type: MerchantPaymentMethodType;
            }
          | {
              __typename: "InternalDirectDebitB2BMerchantPaymentMethod";
              id: string;
              type: MerchantPaymentMethodType;
            }
          | {
              __typename: "InternalDirectDebitStandardMerchantPaymentMethod";
              id: string;
              type: MerchantPaymentMethodType;
            }
          | {
              __typename: "SepaDirectDebitB2BMerchantPaymentMethod";
              id: string;
              type: MerchantPaymentMethodType;
            }
          | {
              __typename: "SepaDirectDebitCoreMerchantPaymentMethod";
              id: string;
              type: MerchantPaymentMethodType;
            };
        merchantProfile: { __typename: "MerchantProfile"; id: string };
        balance: {
          __typename: "MerchantBalance";
          totalAuthorized: { __typename: "Amount"; currency: string; value: string };
          totalCaptured: { __typename: "Amount"; currency: string; value: string };
          availableToCapture: { __typename: "Amount"; currency: string; value: string };
          totalRefunded: { __typename: "Amount"; currency: string; value: string };
          availableToRefund: { __typename: "Amount"; currency: string; value: string };
          availableToCancel: { __typename: "Amount"; currency: string; value: string };
          totalCanceled: { __typename: "Amount"; currency: string; value: string };
          totalDisputed: { __typename: "Amount"; currency: string; value: string };
        };
      }
    | {
        __typename: "CheckMerchantPayment";
        id: string;
        label?: string | null;
        externalReference?: string | null;
        reference?: string | null;
        statusInfo:
          | {
              __typename: "MerchantPaymentAuthorized";
              createdAt: string;
              authorizedAt: string;
              status: MerchantPaymentStatus;
            }
          | {
              __typename: "MerchantPaymentCanceled";
              createdAt: string;
              canceledAt: string;
              status: MerchantPaymentStatus;
            }
          | {
              __typename: "MerchantPaymentCaptured";
              createdAt: string;
              authorizedAt: string;
              capturedAt: string;
              status: MerchantPaymentStatus;
            }
          | {
              __typename: "MerchantPaymentDisputed";
              createdAt: string;
              authorizedAt: string;
              capturedAt: string;
              disputedAt: string;
              status: MerchantPaymentStatus;
            }
          | {
              __typename: "MerchantPaymentInitiated";
              createdAt: string;
              status: MerchantPaymentStatus;
            }
          | {
              __typename: "MerchantPaymentPartiallyDisputed";
              createdAt: string;
              authorizedAt: string;
              capturedAt: string;
              disputedAt: string;
              status: MerchantPaymentStatus;
            }
          | {
              __typename: "MerchantPaymentRejected";
              rejectedReasonCode: MerchantPaymentRejectedReason;
              createdAt: string;
              rejectedAt: string;
              status: MerchantPaymentStatus;
            };
        amount: { __typename: "Amount"; currency: string; value: string };
        paymentMethod:
          | { __typename: "CardMerchantPaymentMethod"; id: string; type: MerchantPaymentMethodType }
          | {
              __typename: "CheckMerchantPaymentMethod";
              id: string;
              type: MerchantPaymentMethodType;
            }
          | {
              __typename: "InPersonCardMerchantPaymentMethod";
              id: string;
              type: MerchantPaymentMethodType;
            }
          | {
              __typename: "InternalDirectDebitB2BMerchantPaymentMethod";
              id: string;
              type: MerchantPaymentMethodType;
            }
          | {
              __typename: "InternalDirectDebitStandardMerchantPaymentMethod";
              id: string;
              type: MerchantPaymentMethodType;
            }
          | {
              __typename: "SepaDirectDebitB2BMerchantPaymentMethod";
              id: string;
              type: MerchantPaymentMethodType;
            }
          | {
              __typename: "SepaDirectDebitCoreMerchantPaymentMethod";
              id: string;
              type: MerchantPaymentMethodType;
            };
        merchantProfile: { __typename: "MerchantProfile"; id: string };
        balance: {
          __typename: "MerchantBalance";
          totalAuthorized: { __typename: "Amount"; currency: string; value: string };
          totalCaptured: { __typename: "Amount"; currency: string; value: string };
          availableToCapture: { __typename: "Amount"; currency: string; value: string };
          totalRefunded: { __typename: "Amount"; currency: string; value: string };
          availableToRefund: { __typename: "Amount"; currency: string; value: string };
          availableToCancel: { __typename: "Amount"; currency: string; value: string };
          totalCanceled: { __typename: "Amount"; currency: string; value: string };
          totalDisputed: { __typename: "Amount"; currency: string; value: string };
        };
      }
    | {
        __typename: "SepaDirectDebitMerchantPayment";
        id: string;
        label?: string | null;
        externalReference?: string | null;
        reference?: string | null;
        paymentLink?: { __typename: "MerchantPaymentLink"; id: string } | null;
        statusInfo:
          | {
              __typename: "MerchantPaymentAuthorized";
              createdAt: string;
              authorizedAt: string;
              status: MerchantPaymentStatus;
            }
          | {
              __typename: "MerchantPaymentCanceled";
              createdAt: string;
              canceledAt: string;
              status: MerchantPaymentStatus;
            }
          | {
              __typename: "MerchantPaymentCaptured";
              createdAt: string;
              authorizedAt: string;
              capturedAt: string;
              status: MerchantPaymentStatus;
            }
          | {
              __typename: "MerchantPaymentDisputed";
              createdAt: string;
              authorizedAt: string;
              capturedAt: string;
              disputedAt: string;
              status: MerchantPaymentStatus;
            }
          | {
              __typename: "MerchantPaymentInitiated";
              createdAt: string;
              status: MerchantPaymentStatus;
            }
          | {
              __typename: "MerchantPaymentPartiallyDisputed";
              createdAt: string;
              authorizedAt: string;
              capturedAt: string;
              disputedAt: string;
              status: MerchantPaymentStatus;
            }
          | {
              __typename: "MerchantPaymentRejected";
              rejectedReasonCode: MerchantPaymentRejectedReason;
              createdAt: string;
              rejectedAt: string;
              status: MerchantPaymentStatus;
            };
        amount: { __typename: "Amount"; currency: string; value: string };
        paymentMethod:
          | { __typename: "CardMerchantPaymentMethod"; id: string; type: MerchantPaymentMethodType }
          | {
              __typename: "CheckMerchantPaymentMethod";
              id: string;
              type: MerchantPaymentMethodType;
            }
          | {
              __typename: "InPersonCardMerchantPaymentMethod";
              id: string;
              type: MerchantPaymentMethodType;
            }
          | {
              __typename: "InternalDirectDebitB2BMerchantPaymentMethod";
              id: string;
              type: MerchantPaymentMethodType;
            }
          | {
              __typename: "InternalDirectDebitStandardMerchantPaymentMethod";
              id: string;
              type: MerchantPaymentMethodType;
            }
          | {
              __typename: "SepaDirectDebitB2BMerchantPaymentMethod";
              id: string;
              type: MerchantPaymentMethodType;
            }
          | {
              __typename: "SepaDirectDebitCoreMerchantPaymentMethod";
              id: string;
              type: MerchantPaymentMethodType;
            };
        merchantProfile: { __typename: "MerchantProfile"; id: string };
        balance: {
          __typename: "MerchantBalance";
          totalAuthorized: { __typename: "Amount"; currency: string; value: string };
          totalCaptured: { __typename: "Amount"; currency: string; value: string };
          availableToCapture: { __typename: "Amount"; currency: string; value: string };
          totalRefunded: { __typename: "Amount"; currency: string; value: string };
          availableToRefund: { __typename: "Amount"; currency: string; value: string };
          availableToCancel: { __typename: "Amount"; currency: string; value: string };
          totalCanceled: { __typename: "Amount"; currency: string; value: string };
          totalDisputed: { __typename: "Amount"; currency: string; value: string };
        };
      }
    | null;
};

export type GetFullMerchantPaymentDetailsQueryVariables = Exact<{
  paymentId: Scalars["ID"]["input"];
  paymentLinkId: Scalars["ID"]["input"];
}>;

export type GetFullMerchantPaymentDetailsQuery = {
  __typename: "Query";
  merchantPayment?:
    | {
        __typename: "CardMerchantPayment";
        id: string;
        label?: string | null;
        externalReference?: string | null;
        reference?: string | null;
        paymentLink?: { __typename: "MerchantPaymentLink"; id: string } | null;
        threeDs?: {
          __typename: "ThreeDS";
          statusInfo:
            | { __typename: "ExemptThreeDsStatusInfo"; status: IncomingThreeDsStatus }
            | {
                __typename: "FailedThreeDsStatusInfo";
                reasonCode: FailedThreeDsReason;
                status: IncomingThreeDsStatus;
              }
            | { __typename: "NotRequestedThreeDsStatusInfo"; status: IncomingThreeDsStatus }
            | { __typename: "RequestedThreeDsStatusInfo"; status: IncomingThreeDsStatus }
            | { __typename: "SucceededThreeDsStatusInfo"; status: IncomingThreeDsStatus };
        } | null;
        statusInfo:
          | {
              __typename: "MerchantPaymentAuthorized";
              createdAt: string;
              authorizedAt: string;
              status: MerchantPaymentStatus;
            }
          | {
              __typename: "MerchantPaymentCanceled";
              createdAt: string;
              canceledAt: string;
              status: MerchantPaymentStatus;
            }
          | {
              __typename: "MerchantPaymentCaptured";
              createdAt: string;
              authorizedAt: string;
              capturedAt: string;
              status: MerchantPaymentStatus;
            }
          | {
              __typename: "MerchantPaymentDisputed";
              createdAt: string;
              authorizedAt: string;
              capturedAt: string;
              disputedAt: string;
              status: MerchantPaymentStatus;
            }
          | {
              __typename: "MerchantPaymentInitiated";
              createdAt: string;
              status: MerchantPaymentStatus;
            }
          | {
              __typename: "MerchantPaymentPartiallyDisputed";
              createdAt: string;
              authorizedAt: string;
              capturedAt: string;
              disputedAt: string;
              status: MerchantPaymentStatus;
            }
          | {
              __typename: "MerchantPaymentRejected";
              rejectedReasonCode: MerchantPaymentRejectedReason;
              createdAt: string;
              rejectedAt: string;
              status: MerchantPaymentStatus;
            };
        amount: { __typename: "Amount"; currency: string; value: string };
        paymentMethod:
          | { __typename: "CardMerchantPaymentMethod"; id: string; type: MerchantPaymentMethodType }
          | {
              __typename: "CheckMerchantPaymentMethod";
              id: string;
              type: MerchantPaymentMethodType;
            }
          | {
              __typename: "InPersonCardMerchantPaymentMethod";
              id: string;
              type: MerchantPaymentMethodType;
            }
          | {
              __typename: "InternalDirectDebitB2BMerchantPaymentMethod";
              id: string;
              type: MerchantPaymentMethodType;
            }
          | {
              __typename: "InternalDirectDebitStandardMerchantPaymentMethod";
              id: string;
              type: MerchantPaymentMethodType;
            }
          | {
              __typename: "SepaDirectDebitB2BMerchantPaymentMethod";
              id: string;
              type: MerchantPaymentMethodType;
            }
          | {
              __typename: "SepaDirectDebitCoreMerchantPaymentMethod";
              id: string;
              type: MerchantPaymentMethodType;
            };
        merchantProfile: { __typename: "MerchantProfile"; id: string };
        balance: {
          __typename: "MerchantBalance";
          totalAuthorized: { __typename: "Amount"; currency: string; value: string };
          totalCaptured: { __typename: "Amount"; currency: string; value: string };
          availableToCapture: { __typename: "Amount"; currency: string; value: string };
          totalRefunded: { __typename: "Amount"; currency: string; value: string };
          availableToRefund: { __typename: "Amount"; currency: string; value: string };
          availableToCancel: { __typename: "Amount"; currency: string; value: string };
          totalCanceled: { __typename: "Amount"; currency: string; value: string };
          totalDisputed: { __typename: "Amount"; currency: string; value: string };
        };
      }
    | {
        __typename: "CheckMerchantPayment";
        id: string;
        label?: string | null;
        externalReference?: string | null;
        reference?: string | null;
        statusInfo:
          | {
              __typename: "MerchantPaymentAuthorized";
              createdAt: string;
              authorizedAt: string;
              status: MerchantPaymentStatus;
            }
          | {
              __typename: "MerchantPaymentCanceled";
              createdAt: string;
              canceledAt: string;
              status: MerchantPaymentStatus;
            }
          | {
              __typename: "MerchantPaymentCaptured";
              createdAt: string;
              authorizedAt: string;
              capturedAt: string;
              status: MerchantPaymentStatus;
            }
          | {
              __typename: "MerchantPaymentDisputed";
              createdAt: string;
              authorizedAt: string;
              capturedAt: string;
              disputedAt: string;
              status: MerchantPaymentStatus;
            }
          | {
              __typename: "MerchantPaymentInitiated";
              createdAt: string;
              status: MerchantPaymentStatus;
            }
          | {
              __typename: "MerchantPaymentPartiallyDisputed";
              createdAt: string;
              authorizedAt: string;
              capturedAt: string;
              disputedAt: string;
              status: MerchantPaymentStatus;
            }
          | {
              __typename: "MerchantPaymentRejected";
              rejectedReasonCode: MerchantPaymentRejectedReason;
              createdAt: string;
              rejectedAt: string;
              status: MerchantPaymentStatus;
            };
        amount: { __typename: "Amount"; currency: string; value: string };
        paymentMethod:
          | { __typename: "CardMerchantPaymentMethod"; id: string; type: MerchantPaymentMethodType }
          | {
              __typename: "CheckMerchantPaymentMethod";
              id: string;
              type: MerchantPaymentMethodType;
            }
          | {
              __typename: "InPersonCardMerchantPaymentMethod";
              id: string;
              type: MerchantPaymentMethodType;
            }
          | {
              __typename: "InternalDirectDebitB2BMerchantPaymentMethod";
              id: string;
              type: MerchantPaymentMethodType;
            }
          | {
              __typename: "InternalDirectDebitStandardMerchantPaymentMethod";
              id: string;
              type: MerchantPaymentMethodType;
            }
          | {
              __typename: "SepaDirectDebitB2BMerchantPaymentMethod";
              id: string;
              type: MerchantPaymentMethodType;
            }
          | {
              __typename: "SepaDirectDebitCoreMerchantPaymentMethod";
              id: string;
              type: MerchantPaymentMethodType;
            };
        merchantProfile: { __typename: "MerchantProfile"; id: string };
        balance: {
          __typename: "MerchantBalance";
          totalAuthorized: { __typename: "Amount"; currency: string; value: string };
          totalCaptured: { __typename: "Amount"; currency: string; value: string };
          availableToCapture: { __typename: "Amount"; currency: string; value: string };
          totalRefunded: { __typename: "Amount"; currency: string; value: string };
          availableToRefund: { __typename: "Amount"; currency: string; value: string };
          availableToCancel: { __typename: "Amount"; currency: string; value: string };
          totalCanceled: { __typename: "Amount"; currency: string; value: string };
          totalDisputed: { __typename: "Amount"; currency: string; value: string };
        };
      }
    | {
        __typename: "SepaDirectDebitMerchantPayment";
        id: string;
        label?: string | null;
        externalReference?: string | null;
        reference?: string | null;
        paymentLink?: { __typename: "MerchantPaymentLink"; id: string } | null;
        statusInfo:
          | {
              __typename: "MerchantPaymentAuthorized";
              createdAt: string;
              authorizedAt: string;
              status: MerchantPaymentStatus;
            }
          | {
              __typename: "MerchantPaymentCanceled";
              createdAt: string;
              canceledAt: string;
              status: MerchantPaymentStatus;
            }
          | {
              __typename: "MerchantPaymentCaptured";
              createdAt: string;
              authorizedAt: string;
              capturedAt: string;
              status: MerchantPaymentStatus;
            }
          | {
              __typename: "MerchantPaymentDisputed";
              createdAt: string;
              authorizedAt: string;
              capturedAt: string;
              disputedAt: string;
              status: MerchantPaymentStatus;
            }
          | {
              __typename: "MerchantPaymentInitiated";
              createdAt: string;
              status: MerchantPaymentStatus;
            }
          | {
              __typename: "MerchantPaymentPartiallyDisputed";
              createdAt: string;
              authorizedAt: string;
              capturedAt: string;
              disputedAt: string;
              status: MerchantPaymentStatus;
            }
          | {
              __typename: "MerchantPaymentRejected";
              rejectedReasonCode: MerchantPaymentRejectedReason;
              createdAt: string;
              rejectedAt: string;
              status: MerchantPaymentStatus;
            };
        amount: { __typename: "Amount"; currency: string; value: string };
        paymentMethod:
          | { __typename: "CardMerchantPaymentMethod"; id: string; type: MerchantPaymentMethodType }
          | {
              __typename: "CheckMerchantPaymentMethod";
              id: string;
              type: MerchantPaymentMethodType;
            }
          | {
              __typename: "InPersonCardMerchantPaymentMethod";
              id: string;
              type: MerchantPaymentMethodType;
            }
          | {
              __typename: "InternalDirectDebitB2BMerchantPaymentMethod";
              id: string;
              type: MerchantPaymentMethodType;
            }
          | {
              __typename: "InternalDirectDebitStandardMerchantPaymentMethod";
              id: string;
              type: MerchantPaymentMethodType;
            }
          | {
              __typename: "SepaDirectDebitB2BMerchantPaymentMethod";
              id: string;
              type: MerchantPaymentMethodType;
            }
          | {
              __typename: "SepaDirectDebitCoreMerchantPaymentMethod";
              id: string;
              type: MerchantPaymentMethodType;
            };
        merchantProfile: { __typename: "MerchantProfile"; id: string };
        balance: {
          __typename: "MerchantBalance";
          totalAuthorized: { __typename: "Amount"; currency: string; value: string };
          totalCaptured: { __typename: "Amount"; currency: string; value: string };
          availableToCapture: { __typename: "Amount"; currency: string; value: string };
          totalRefunded: { __typename: "Amount"; currency: string; value: string };
          availableToRefund: { __typename: "Amount"; currency: string; value: string };
          availableToCancel: { __typename: "Amount"; currency: string; value: string };
          totalCanceled: { __typename: "Amount"; currency: string; value: string };
          totalDisputed: { __typename: "Amount"; currency: string; value: string };
        };
      }
    | null;
  merchantPaymentLink?: {
    __typename: "MerchantPaymentLink";
    id: string;
    label?: string | null;
    url: string;
    reference?: string | null;
    externalReference?: string | null;
    statusInfo:
      | { __typename: "ActiveMerchantPaymentLinkStatusInfo"; status: MerchantPaymentLinkStatus }
      | { __typename: "CompletedMerchantPaymentLinkStatusInfo"; status: MerchantPaymentLinkStatus }
      | { __typename: "ExpiredMerchantPaymentLinkStatusInfo"; status: MerchantPaymentLinkStatus };
    amount: { __typename: "Amount"; currency: string; value: string };
  } | null;
};

export type PaymentLinkConnectionFragment = {
  __typename: "MerchantPaymentLinkConnection";
  totalCount: number;
  pageInfo: { __typename: "PageInfo"; endCursor?: string | null; hasNextPage?: boolean | null };
  edges: Array<{
    __typename: "MerchantPaymentLinkEdge";
    node: {
      __typename: "MerchantPaymentLink";
      id: string;
      label?: string | null;
      url: string;
      reference?: string | null;
      externalReference?: string | null;
      statusInfo:
        | { __typename: "ActiveMerchantPaymentLinkStatusInfo"; status: MerchantPaymentLinkStatus }
        | {
            __typename: "CompletedMerchantPaymentLinkStatusInfo";
            status: MerchantPaymentLinkStatus;
          }
        | { __typename: "ExpiredMerchantPaymentLinkStatusInfo"; status: MerchantPaymentLinkStatus };
      amount: { __typename: "Amount"; currency: string; value: string };
    };
  }>;
};

export type MerchantPaymentLinksQueryVariables = Exact<{
  merchantProfileId: Scalars["ID"]["input"];
  filters: MerchantPaymentLinkFiltersInput;
  first: Scalars["Int"]["input"];
  after?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type MerchantPaymentLinksQuery = {
  __typename: "Query";
  merchantProfile?: {
    __typename: "MerchantProfile";
    id: string;
    accentColor?: string | null;
    merchantName: string;
    merchantLogoUrl?: string | null;
    merchantPaymentMethods?: Array<
      | {
          __typename: "CardMerchantPaymentMethod";
          id: string;
          type: MerchantPaymentMethodType;
          updatedAt: string;
          statusInfo:
            | {
                __typename: "DisabledMerchantPaymentMethodStatusInfo";
                status: MerchantPaymentMethodStatus;
              }
            | {
                __typename: "EnabledMerchantPaymentMethodStatusInfo";
                status: MerchantPaymentMethodStatus;
              }
            | {
                __typename: "PendingMerchantPaymentMethodStatusInfo";
                status: MerchantPaymentMethodStatus;
              }
            | {
                __typename: "RejectedMerchantPaymentMethodStatusInfo";
                status: MerchantPaymentMethodStatus;
              }
            | {
                __typename: "SuspendedMerchantPaymentMethodStatusInfo";
                status: MerchantPaymentMethodStatus;
              }
            | {
                __typename: "WaitingForInformationMerchantPaymentMethodStatusInfo";
                status: MerchantPaymentMethodStatus;
              };
        }
      | {
          __typename: "CheckMerchantPaymentMethod";
          id: string;
          type: MerchantPaymentMethodType;
          updatedAt: string;
          statusInfo:
            | {
                __typename: "DisabledMerchantPaymentMethodStatusInfo";
                status: MerchantPaymentMethodStatus;
              }
            | {
                __typename: "EnabledMerchantPaymentMethodStatusInfo";
                status: MerchantPaymentMethodStatus;
              }
            | {
                __typename: "PendingMerchantPaymentMethodStatusInfo";
                status: MerchantPaymentMethodStatus;
              }
            | {
                __typename: "RejectedMerchantPaymentMethodStatusInfo";
                status: MerchantPaymentMethodStatus;
              }
            | {
                __typename: "SuspendedMerchantPaymentMethodStatusInfo";
                status: MerchantPaymentMethodStatus;
              }
            | {
                __typename: "WaitingForInformationMerchantPaymentMethodStatusInfo";
                status: MerchantPaymentMethodStatus;
              };
        }
      | {
          __typename: "InPersonCardMerchantPaymentMethod";
          id: string;
          type: MerchantPaymentMethodType;
          updatedAt: string;
          statusInfo:
            | {
                __typename: "DisabledMerchantPaymentMethodStatusInfo";
                status: MerchantPaymentMethodStatus;
              }
            | {
                __typename: "EnabledMerchantPaymentMethodStatusInfo";
                status: MerchantPaymentMethodStatus;
              }
            | {
                __typename: "PendingMerchantPaymentMethodStatusInfo";
                status: MerchantPaymentMethodStatus;
              }
            | {
                __typename: "RejectedMerchantPaymentMethodStatusInfo";
                status: MerchantPaymentMethodStatus;
              }
            | {
                __typename: "SuspendedMerchantPaymentMethodStatusInfo";
                status: MerchantPaymentMethodStatus;
              }
            | {
                __typename: "WaitingForInformationMerchantPaymentMethodStatusInfo";
                status: MerchantPaymentMethodStatus;
              };
        }
      | {
          __typename: "InternalDirectDebitB2BMerchantPaymentMethod";
          id: string;
          type: MerchantPaymentMethodType;
          updatedAt: string;
          statusInfo:
            | {
                __typename: "DisabledMerchantPaymentMethodStatusInfo";
                status: MerchantPaymentMethodStatus;
              }
            | {
                __typename: "EnabledMerchantPaymentMethodStatusInfo";
                status: MerchantPaymentMethodStatus;
              }
            | {
                __typename: "PendingMerchantPaymentMethodStatusInfo";
                status: MerchantPaymentMethodStatus;
              }
            | {
                __typename: "RejectedMerchantPaymentMethodStatusInfo";
                status: MerchantPaymentMethodStatus;
              }
            | {
                __typename: "SuspendedMerchantPaymentMethodStatusInfo";
                status: MerchantPaymentMethodStatus;
              }
            | {
                __typename: "WaitingForInformationMerchantPaymentMethodStatusInfo";
                status: MerchantPaymentMethodStatus;
              };
        }
      | {
          __typename: "InternalDirectDebitStandardMerchantPaymentMethod";
          id: string;
          type: MerchantPaymentMethodType;
          updatedAt: string;
          statusInfo:
            | {
                __typename: "DisabledMerchantPaymentMethodStatusInfo";
                status: MerchantPaymentMethodStatus;
              }
            | {
                __typename: "EnabledMerchantPaymentMethodStatusInfo";
                status: MerchantPaymentMethodStatus;
              }
            | {
                __typename: "PendingMerchantPaymentMethodStatusInfo";
                status: MerchantPaymentMethodStatus;
              }
            | {
                __typename: "RejectedMerchantPaymentMethodStatusInfo";
                status: MerchantPaymentMethodStatus;
              }
            | {
                __typename: "SuspendedMerchantPaymentMethodStatusInfo";
                status: MerchantPaymentMethodStatus;
              }
            | {
                __typename: "WaitingForInformationMerchantPaymentMethodStatusInfo";
                status: MerchantPaymentMethodStatus;
              };
        }
      | {
          __typename: "SepaDirectDebitB2BMerchantPaymentMethod";
          id: string;
          type: MerchantPaymentMethodType;
          updatedAt: string;
          statusInfo:
            | {
                __typename: "DisabledMerchantPaymentMethodStatusInfo";
                status: MerchantPaymentMethodStatus;
              }
            | {
                __typename: "EnabledMerchantPaymentMethodStatusInfo";
                status: MerchantPaymentMethodStatus;
              }
            | {
                __typename: "PendingMerchantPaymentMethodStatusInfo";
                status: MerchantPaymentMethodStatus;
              }
            | {
                __typename: "RejectedMerchantPaymentMethodStatusInfo";
                status: MerchantPaymentMethodStatus;
              }
            | {
                __typename: "SuspendedMerchantPaymentMethodStatusInfo";
                status: MerchantPaymentMethodStatus;
              }
            | {
                __typename: "WaitingForInformationMerchantPaymentMethodStatusInfo";
                status: MerchantPaymentMethodStatus;
              };
        }
      | {
          __typename: "SepaDirectDebitCoreMerchantPaymentMethod";
          id: string;
          type: MerchantPaymentMethodType;
          updatedAt: string;
          statusInfo:
            | {
                __typename: "DisabledMerchantPaymentMethodStatusInfo";
                status: MerchantPaymentMethodStatus;
              }
            | {
                __typename: "EnabledMerchantPaymentMethodStatusInfo";
                status: MerchantPaymentMethodStatus;
              }
            | {
                __typename: "PendingMerchantPaymentMethodStatusInfo";
                status: MerchantPaymentMethodStatus;
              }
            | {
                __typename: "RejectedMerchantPaymentMethodStatusInfo";
                status: MerchantPaymentMethodStatus;
              }
            | {
                __typename: "SuspendedMerchantPaymentMethodStatusInfo";
                status: MerchantPaymentMethodStatus;
              }
            | {
                __typename: "WaitingForInformationMerchantPaymentMethodStatusInfo";
                status: MerchantPaymentMethodStatus;
              };
        }
    > | null;
    merchantPaymentLinks?: {
      __typename: "MerchantPaymentLinkConnection";
      totalCount: number;
      pageInfo: { __typename: "PageInfo"; endCursor?: string | null; hasNextPage?: boolean | null };
      edges: Array<{
        __typename: "MerchantPaymentLinkEdge";
        node: {
          __typename: "MerchantPaymentLink";
          id: string;
          label?: string | null;
          url: string;
          reference?: string | null;
          externalReference?: string | null;
          statusInfo:
            | {
                __typename: "ActiveMerchantPaymentLinkStatusInfo";
                status: MerchantPaymentLinkStatus;
              }
            | {
                __typename: "CompletedMerchantPaymentLinkStatusInfo";
                status: MerchantPaymentLinkStatus;
              }
            | {
                __typename: "ExpiredMerchantPaymentLinkStatusInfo";
                status: MerchantPaymentLinkStatus;
              };
          amount: { __typename: "Amount"; currency: string; value: string };
        };
      }>;
    } | null;
  } | null;
};

export type MerchantPaymentLinkQueryVariables = Exact<{
  paymentLinkId: Scalars["ID"]["input"];
}>;

export type MerchantPaymentLinkQuery = {
  __typename: "Query";
  merchantPaymentLink?: {
    __typename: "MerchantPaymentLink";
    id: string;
    label?: string | null;
    url: string;
    reference?: string | null;
    externalReference?: string | null;
    statusInfo:
      | { __typename: "ActiveMerchantPaymentLinkStatusInfo"; status: MerchantPaymentLinkStatus }
      | { __typename: "CompletedMerchantPaymentLinkStatusInfo"; status: MerchantPaymentLinkStatus }
      | { __typename: "ExpiredMerchantPaymentLinkStatusInfo"; status: MerchantPaymentLinkStatus };
    amount: { __typename: "Amount"; currency: string; value: string };
  } | null;
};

export type CancelMerchantPaymentMutationVariables = Exact<{
  input: CancelMerchantPaymentInput;
}>;

export type CancelMerchantPaymentMutation = {
  __typename: "Mutation";
  cancelMerchantPayment?:
    | {
        __typename: "CancelMerchantPaymentSuccessPayload";
        merchantPayment:
          | {
              __typename: "CardMerchantPayment";
              id: string;
              statusInfo:
                | { __typename: "MerchantPaymentAuthorized"; status: MerchantPaymentStatus }
                | { __typename: "MerchantPaymentCanceled"; status: MerchantPaymentStatus }
                | { __typename: "MerchantPaymentCaptured"; status: MerchantPaymentStatus }
                | { __typename: "MerchantPaymentDisputed"; status: MerchantPaymentStatus }
                | { __typename: "MerchantPaymentInitiated"; status: MerchantPaymentStatus }
                | { __typename: "MerchantPaymentPartiallyDisputed"; status: MerchantPaymentStatus }
                | { __typename: "MerchantPaymentRejected"; status: MerchantPaymentStatus };
            }
          | {
              __typename: "CheckMerchantPayment";
              id: string;
              statusInfo:
                | { __typename: "MerchantPaymentAuthorized"; status: MerchantPaymentStatus }
                | { __typename: "MerchantPaymentCanceled"; status: MerchantPaymentStatus }
                | { __typename: "MerchantPaymentCaptured"; status: MerchantPaymentStatus }
                | { __typename: "MerchantPaymentDisputed"; status: MerchantPaymentStatus }
                | { __typename: "MerchantPaymentInitiated"; status: MerchantPaymentStatus }
                | { __typename: "MerchantPaymentPartiallyDisputed"; status: MerchantPaymentStatus }
                | { __typename: "MerchantPaymentRejected"; status: MerchantPaymentStatus };
            }
          | {
              __typename: "SepaDirectDebitMerchantPayment";
              id: string;
              statusInfo:
                | { __typename: "MerchantPaymentAuthorized"; status: MerchantPaymentStatus }
                | { __typename: "MerchantPaymentCanceled"; status: MerchantPaymentStatus }
                | { __typename: "MerchantPaymentCaptured"; status: MerchantPaymentStatus }
                | { __typename: "MerchantPaymentDisputed"; status: MerchantPaymentStatus }
                | { __typename: "MerchantPaymentInitiated"; status: MerchantPaymentStatus }
                | { __typename: "MerchantPaymentPartiallyDisputed"; status: MerchantPaymentStatus }
                | { __typename: "MerchantPaymentRejected"; status: MerchantPaymentStatus };
            };
      }
    | { __typename: "ForbiddenRejection"; message: string }
    | { __typename: "InternalErrorRejection"; message: string }
    | { __typename: "MerchantPaymentMethodNotCompatibleRejection"; message: string }
    | { __typename: "MerchantPaymentNotCancellableRejection"; message: string }
    | { __typename: "MerchantPaymentNotFoundRejection"; message: string }
    | { __typename: "MerchantPaymentNotPartiallyCancellableRejection"; message: string }
    | { __typename: "ValidationRejection"; message: string }
    | null;
};

export type AccountClosingQueryVariables = Exact<{
  accountId: Scalars["ID"]["input"];
  after?: InputMaybe<Scalars["String"]["input"]>;
  first: Scalars["Int"]["input"];
}>;

export type AccountClosingQuery = {
  __typename: "Query";
  projectInfo: {
    __typename: "ProjectInfo";
    id: string;
    accentColor?: string | null;
    webBankingSettings?: {
      __typename: "WebBankingSettings";
      canViewAccountStatement?: boolean | null;
      canViewAccountDetails?: boolean | null;
      canAddNewMembers?: boolean | null;
      canViewMembers?: boolean | null;
      canViewPaymentList?: boolean | null;
      canOrderPhysicalCards?: boolean | null;
      canInitiatePaymentsToNewBeneficiaries?: boolean | null;
      canOrderVirtualCards?: boolean | null;
      canManageVirtualIbans?: boolean | null;
      canCreateMerchantProfile?: boolean | null;
      canRequestOnlineCardsPaymentMethod?: boolean | null;
      canRequestSepaDirectDebitCorePaymentMethod?: boolean | null;
      canRequestSepaDirectDebitB2BPaymentMethod?: boolean | null;
      canRequestInternalDirectDebitCorePaymentMethod?: boolean | null;
      canRequestInternalDirectDebitB2BPaymentMethod?: boolean | null;
      canRequestChecksPaymentMethod?: boolean | null;
      canInitiateCheckMerchantPayments?: boolean | null;
      canCreateMerchantPaymentLinks?: boolean | null;
      canUpdateCards?: boolean | null;
    } | null;
  };
  account?: {
    __typename: "Account";
    id: string;
    country: AccountCountry;
    statusInfo:
      | { __typename: "AccountClosedStatus"; status: AccountStatus }
      | { __typename: "AccountClosingStatus"; status: AccountStatus }
      | { __typename: "AccountOpenedStatus"; status: AccountStatus }
      | { __typename: "AccountSuspendedStatus"; status: AccountStatus };
    legalRepresentativeMembership: {
      __typename: "AccountMembership";
      id: string;
      email: string;
      canViewAccount: boolean;
      canManageBeneficiaries: boolean;
      canInitiatePayments: boolean;
      canManageAccountMembership: boolean;
      canManageCards: boolean;
      legalRepresentative: boolean;
      user?: {
        __typename: "User";
        id: string;
        firstName?: string | null;
        preferredLastName?: string | null;
        fullName?: string | null;
      } | null;
      statusInfo:
        | {
            __typename: "AccountMembershipBindingUserErrorStatusInfo";
            status: AccountMembershipStatus;
          }
        | {
            __typename: "AccountMembershipConsentPendingStatusInfo";
            status: AccountMembershipStatus;
          }
        | { __typename: "AccountMembershipDisabledStatusInfo"; status: AccountMembershipStatus }
        | { __typename: "AccountMembershipEnabledStatusInfo"; status: AccountMembershipStatus }
        | {
            __typename: "AccountMembershipInvitationSentStatusInfo";
            status: AccountMembershipStatus;
          }
        | { __typename: "AccountMembershipSuspendedStatusInfo"; status: AccountMembershipStatus };
      allCards: { __typename: "CardConnection"; totalCount: number };
      account?: {
        __typename: "Account";
        id: string;
        paymentLevel: PaymentLevel;
        statusInfo:
          | { __typename: "AccountClosedStatus"; status: AccountStatus }
          | { __typename: "AccountClosingStatus"; status: AccountStatus }
          | { __typename: "AccountOpenedStatus"; status: AccountStatus }
          | { __typename: "AccountSuspendedStatus"; status: AccountStatus };
        merchantProfiles?: { __typename: "MerchantProfileConnection"; totalCount: number } | null;
      } | null;
    };
    balances?: {
      __typename: "AccountBalances";
      available: { __typename: "Amount"; value: string; currency: string };
    } | null;
  } | null;
  user?: {
    __typename: "User";
    id: string;
    accountMemberships: {
      __typename: "AccountMembershipConnection";
      edges: Array<{
        __typename: "AccountMembershipEdge";
        node: { __typename: "AccountMembership"; id: string; accountId: string };
      }>;
      pageInfo: { __typename: "PageInfo"; hasNextPage?: boolean | null; endCursor?: string | null };
    };
  } | null;
};

export type RepaymentAccountFragment = {
  __typename: "Account";
  id: string;
  IBAN?: string | null;
  holder: {
    __typename: "AccountHolder";
    id: string;
    verificationStatus: VerificationStatus;
    residencyAddress: {
      __typename: "AddressInfo";
      addressLine1?: string | null;
      city?: string | null;
      postalCode?: string | null;
      country?: string | null;
    };
    info:
      | { __typename: "AccountHolderCompanyInfo"; name: string }
      | { __typename: "AccountHolderIndividualInfo"; name: string };
  };
};

export type CreditLimitRequestQueryVariables = Exact<{
  accountId: Scalars["ID"]["input"];
  after?: InputMaybe<Scalars["String"]["input"]>;
  first: Scalars["Int"]["input"];
}>;

export type CreditLimitRequestQuery = {
  __typename: "Query";
  projectInfo: {
    __typename: "ProjectInfo";
    id: string;
    accentColor?: string | null;
    webBankingSettings?: {
      __typename: "WebBankingSettings";
      canViewAccountStatement?: boolean | null;
      canViewAccountDetails?: boolean | null;
      canAddNewMembers?: boolean | null;
      canViewMembers?: boolean | null;
      canViewPaymentList?: boolean | null;
      canOrderPhysicalCards?: boolean | null;
      canInitiatePaymentsToNewBeneficiaries?: boolean | null;
      canOrderVirtualCards?: boolean | null;
      canManageVirtualIbans?: boolean | null;
      canCreateMerchantProfile?: boolean | null;
      canRequestOnlineCardsPaymentMethod?: boolean | null;
      canRequestSepaDirectDebitCorePaymentMethod?: boolean | null;
      canRequestSepaDirectDebitB2BPaymentMethod?: boolean | null;
      canRequestInternalDirectDebitCorePaymentMethod?: boolean | null;
      canRequestInternalDirectDebitB2BPaymentMethod?: boolean | null;
      canRequestChecksPaymentMethod?: boolean | null;
      canInitiateCheckMerchantPayments?: boolean | null;
      canCreateMerchantPaymentLinks?: boolean | null;
      canUpdateCards?: boolean | null;
    } | null;
  };
  account?: {
    __typename: "Account";
    id: string;
    country: AccountCountry;
    IBAN?: string | null;
    statusInfo:
      | { __typename: "AccountClosedStatus"; status: AccountStatus }
      | { __typename: "AccountClosingStatus"; status: AccountStatus }
      | { __typename: "AccountOpenedStatus"; status: AccountStatus }
      | { __typename: "AccountSuspendedStatus"; status: AccountStatus };
    creditLimitSettings?: {
      __typename: "CreditLimitSettings";
      creditLimitSettingsRequests: {
        __typename: "CreditLimitSettingsRequestConnection";
        edges: Array<{
          __typename: "CreditLimitSettingsRequestEdge";
          node: {
            __typename: "CreditLimitSettingsRequest";
            id: string;
            updatedAt: string;
            statusInfo:
              | { __typename: "CreditLimitSettingsRequestApprovedStatusInfo" }
              | { __typename: "CreditLimitSettingsRequestCanceledStatusInfo" }
              | { __typename: "CreditLimitSettingsRequestConsentPendingStatusInfo" }
              | { __typename: "CreditLimitSettingsRequestPendingReviewStatusInfo" }
              | { __typename: "CreditLimitSettingsRequestRefusedStatusInfo" };
            amount: { __typename: "Amount"; value: string; currency: string };
          };
        }>;
      };
      authorizedAmount?: { __typename: "Amount"; currency: string; value: string } | null;
      statusInfo:
        | { __typename: "CreditLimitStatusActivatedInfo"; status: CreditLimitStatus }
        | { __typename: "CreditLimitStatusDeactivatedInfo"; status: CreditLimitStatus }
        | { __typename: "CreditLimitStatusPendingInfo"; status: CreditLimitStatus }
        | { __typename: "CreditLimitStatusSuspendedInfo"; status: CreditLimitStatus };
    } | null;
    legalRepresentativeMembership: {
      __typename: "AccountMembership";
      id: string;
      email: string;
      canViewAccount: boolean;
      canManageBeneficiaries: boolean;
      canInitiatePayments: boolean;
      canManageAccountMembership: boolean;
      canManageCards: boolean;
      legalRepresentative: boolean;
      user?: {
        __typename: "User";
        id: string;
        firstName?: string | null;
        preferredLastName?: string | null;
        fullName?: string | null;
      } | null;
      statusInfo:
        | {
            __typename: "AccountMembershipBindingUserErrorStatusInfo";
            status: AccountMembershipStatus;
          }
        | {
            __typename: "AccountMembershipConsentPendingStatusInfo";
            status: AccountMembershipStatus;
          }
        | { __typename: "AccountMembershipDisabledStatusInfo"; status: AccountMembershipStatus }
        | { __typename: "AccountMembershipEnabledStatusInfo"; status: AccountMembershipStatus }
        | {
            __typename: "AccountMembershipInvitationSentStatusInfo";
            status: AccountMembershipStatus;
          }
        | { __typename: "AccountMembershipSuspendedStatusInfo"; status: AccountMembershipStatus };
      allCards: { __typename: "CardConnection"; totalCount: number };
      account?: {
        __typename: "Account";
        id: string;
        paymentLevel: PaymentLevel;
        statusInfo:
          | { __typename: "AccountClosedStatus"; status: AccountStatus }
          | { __typename: "AccountClosingStatus"; status: AccountStatus }
          | { __typename: "AccountOpenedStatus"; status: AccountStatus }
          | { __typename: "AccountSuspendedStatus"; status: AccountStatus };
        merchantProfiles?: { __typename: "MerchantProfileConnection"; totalCount: number } | null;
      } | null;
    };
    holder: {
      __typename: "AccountHolder";
      id: string;
      verificationStatus: VerificationStatus;
      residencyAddress: {
        __typename: "AddressInfo";
        addressLine1?: string | null;
        city?: string | null;
        postalCode?: string | null;
        country?: string | null;
      };
      info:
        | { __typename: "AccountHolderCompanyInfo"; name: string }
        | { __typename: "AccountHolderIndividualInfo"; name: string };
    };
  } | null;
  user?: {
    __typename: "User";
    id: string;
    accountMemberships: {
      __typename: "AccountMembershipConnection";
      edges: Array<{
        __typename: "AccountMembershipEdge";
        node: { __typename: "AccountMembership"; id: string; accountId: string };
      }>;
      pageInfo: { __typename: "PageInfo"; hasNextPage?: boolean | null; endCursor?: string | null };
    };
  } | null;
};

export type RequestCreditLimitSettingsMutationVariables = Exact<{
  input: RequestCreditLimitSettingsInput;
}>;

export type RequestCreditLimitSettingsMutation = {
  __typename: "Mutation";
  requestCreditLimitSettings?:
    | { __typename: "AccountHolderNotFoundRejection"; message: string }
    | { __typename: "AccountNotFoundRejection"; message: string }
    | { __typename: "BadRequestRejection"; message: string }
    | { __typename: "ForbiddenRejection"; message: string }
    | { __typename: "MissingAddressItemRejection"; message: string }
    | { __typename: "NotLegalRepresentativeRejection"; message: string }
    | {
        __typename: "RequestCreditLimitSettingsSuccessPayload";
        creditLimitSettingsRequest: {
          __typename: "CreditLimitSettingsRequest";
          id: string;
          consent: { __typename: "Consent"; id: string; consentUrl: string };
        };
      }
    | null;
};

export type AddReceivedSepaDirectDebitB2bMandateInfoQueryVariables = Exact<{
  first: Scalars["Int"]["input"];
  accountId: Scalars["ID"]["input"];
}>;

export type AddReceivedSepaDirectDebitB2bMandateInfoQuery = {
  __typename: "Query";
  user?: {
    __typename: "User";
    id: string;
    accountMemberships: {
      __typename: "AccountMembershipConnection";
      edges: Array<{
        __typename: "AccountMembershipEdge";
        node: {
          __typename: "AccountMembership";
          id: string;
          canViewAccount: boolean;
          canInitiatePayments: boolean;
          account?: {
            __typename: "Account";
            id: string;
            name: string;
            holder: {
              __typename: "AccountHolder";
              id: string;
              info:
                | { __typename: "AccountHolderCompanyInfo"; name: string }
                | { __typename: "AccountHolderIndividualInfo" };
            };
          } | null;
        };
      }>;
    };
  } | null;
  projectInfo: {
    __typename: "ProjectInfo";
    id: string;
    name: string;
    logoUri?: string | null;
    accentColor?: string | null;
  };
};

export type TransferBulkWizardQueryVariables = Exact<{
  accountId: Scalars["ID"]["input"];
}>;

export type TransferBulkWizardQuery = {
  __typename: "Query";
  account?: {
    __typename: "Account";
    id: string;
    settings: {
      __typename: "AccountSettings";
      allowBulkCreditTransfersWithoutBeneficiaryVerification?: boolean | null;
    };
    holder: {
      __typename: "AccountHolder";
      id: string;
      info:
        | { __typename: "AccountHolderCompanyInfo"; type: AccountHolderType }
        | { __typename: "AccountHolderIndividualInfo"; type: AccountHolderType };
    };
  } | null;
};

export type CreatePaymentLinkMutationVariables = Exact<{
  input: CreateMerchantPaymentLinkInput;
}>;

export type CreatePaymentLinkMutation = {
  __typename: "Mutation";
  createMerchantPaymentLink:
    | {
        __typename: "CreateMerchantPaymentLinkSuccessPayload";
        merchantPaymentLink: {
          __typename: "MerchantPaymentLink";
          id: string;
          label?: string | null;
          url: string;
          reference?: string | null;
          externalReference?: string | null;
          statusInfo:
            | {
                __typename: "ActiveMerchantPaymentLinkStatusInfo";
                status: MerchantPaymentLinkStatus;
              }
            | {
                __typename: "CompletedMerchantPaymentLinkStatusInfo";
                status: MerchantPaymentLinkStatus;
              }
            | {
                __typename: "ExpiredMerchantPaymentLinkStatusInfo";
                status: MerchantPaymentLinkStatus;
              };
          amount: { __typename: "Amount"; currency: string; value: string };
        };
      }
    | { __typename: "ForbiddenRejection"; message: string }
    | { __typename: "InternalErrorRejection"; message: string }
    | { __typename: "MerchantPaymentMethodNotActiveRejection"; message: string }
    | { __typename: "MerchantProfileWrongStatusRejection"; message: string }
    | { __typename: "PaymentMethodNotCompatibleRejection"; message: string }
    | { __typename: "ValidationRejection"; message: string };
};

export type CreateMultiConsentMutationVariables = Exact<{
  input: CreateMultiConsentInput;
}>;

export type CreateMultiConsentMutation = {
  __typename: "Mutation";
  createMultiConsent?:
    | { __typename: "ConsentsAlreadyLinkedToMultiConsentRejection"; message: string }
    | { __typename: "ConsentsNotAllInCreatedStatusRejection"; message: string }
    | { __typename: "ConsentsNotFoundRejection"; message: string }
    | {
        __typename: "CreateMultiConsentSuccessPayload";
        consent?: { __typename: "Consent"; id: string; consentUrl: string } | null;
      }
    | { __typename: "TooManyChildConsentsRejection"; message: string }
    | null;
};

export type CardFragment = {
  __typename: "Card";
  id: string;
  insuranceSubscription?: {
    __typename: "CardInsuranceSubscription";
    id: string;
    package: {
      __typename: "CardInsurancePackage";
      id: string;
      name: string;
      level: CardInsurancePackageLevel;
    };
  } | null;
  statusInfo:
    | { __typename: "CardCanceledStatusInfo" }
    | { __typename: "CardCancelingStatusInfo" }
    | {
        __typename: "CardConsentPendingStatusInfo";
        consent: { __typename: "Consent"; id: string; consentUrl: string };
      }
    | { __typename: "CardEnabledStatusInfo" }
    | { __typename: "CardProcessingStatusInfo" };
};

export type AddCardsMutationVariables = Exact<{
  input: AddCardsInput;
}>;

export type AddCardsMutation = {
  __typename: "Mutation";
  addCards:
    | { __typename: "AccountMembershipNotAllowedRejection"; message: string }
    | {
        __typename: "AddCardsSuccessPayload";
        cards: Array<{
          __typename: "Card";
          id: string;
          insuranceSubscription?: {
            __typename: "CardInsuranceSubscription";
            id: string;
            package: {
              __typename: "CardInsurancePackage";
              id: string;
              name: string;
              level: CardInsurancePackageLevel;
            };
          } | null;
          statusInfo:
            | { __typename: "CardCanceledStatusInfo" }
            | { __typename: "CardCancelingStatusInfo" }
            | {
                __typename: "CardConsentPendingStatusInfo";
                consent: { __typename: "Consent"; id: string; consentUrl: string };
              }
            | { __typename: "CardEnabledStatusInfo" }
            | { __typename: "CardProcessingStatusInfo" };
        }>;
      }
    | { __typename: "AddingCardsToDifferentAccountsRejection"; message: string }
    | { __typename: "BadAccountStatusRejection"; message: string }
    | { __typename: "CardProductDisabledRejection"; message: string }
    | { __typename: "CardProductInvalidFundingTypeRejection"; message: string }
    | { __typename: "CardProductNotApplicableToPhysicalCardsRejection"; message: string }
    | { __typename: "CardProductSuspendedRejection"; message: string }
    | { __typename: "EnabledCardDesignNotFoundRejection"; message: string }
    | { __typename: "InvalidShippingProviderRejection"; message: string }
    | { __typename: "MissingMandatoryFieldRejection"; message: string }
    | { __typename: "TooManyItemsRejection"; message: string }
    | { __typename: "ValidationRejection"; message: string };
};

export type AddCardMutationVariables = Exact<{
  input: AddCardInput;
}>;

export type AddCardMutation = {
  __typename: "Mutation";
  addCard:
    | { __typename: "AccountMembershipNotAllowedRejection"; message: string }
    | {
        __typename: "AddCardSuccessPayload";
        card: {
          __typename: "Card";
          id: string;
          insuranceSubscription?: {
            __typename: "CardInsuranceSubscription";
            id: string;
            package: {
              __typename: "CardInsurancePackage";
              id: string;
              name: string;
              level: CardInsurancePackageLevel;
            };
          } | null;
          statusInfo:
            | { __typename: "CardCanceledStatusInfo" }
            | { __typename: "CardCancelingStatusInfo" }
            | {
                __typename: "CardConsentPendingStatusInfo";
                consent: { __typename: "Consent"; id: string; consentUrl: string };
              }
            | { __typename: "CardEnabledStatusInfo" }
            | { __typename: "CardProcessingStatusInfo" };
        };
      }
    | { __typename: "BadAccountStatusRejection"; message: string }
    | { __typename: "CardProductDisabledRejection"; message: string }
    | { __typename: "CardProductInvalidFundingTypeRejection"; message: string }
    | { __typename: "CardProductSuspendedRejection"; message: string }
    | { __typename: "EnabledCardDesignNotFoundRejection"; message: string }
    | { __typename: "ForbiddenRejection"; message: string }
    | { __typename: "MissingMandatoryFieldRejection"; message: string }
    | { __typename: "ValidationRejection"; message: string };
};

export type AddCardsWithGroupDeliveryMutationVariables = Exact<{
  input: AddCardsWithGroupDeliveryInput;
}>;

export type AddCardsWithGroupDeliveryMutation = {
  __typename: "Mutation";
  addCardsWithGroupDelivery:
    | { __typename: "AccountMembershipNotAllowedRejection"; message: string }
    | {
        __typename: "AddCardsWithGroupDeliverySuccessPayload";
        cards: Array<{
          __typename: "Card";
          id: string;
          insuranceSubscription?: {
            __typename: "CardInsuranceSubscription";
            id: string;
            package: {
              __typename: "CardInsurancePackage";
              id: string;
              name: string;
              level: CardInsurancePackageLevel;
            };
          } | null;
          statusInfo:
            | { __typename: "CardCanceledStatusInfo" }
            | { __typename: "CardCancelingStatusInfo" }
            | {
                __typename: "CardConsentPendingStatusInfo";
                consent: { __typename: "Consent"; id: string; consentUrl: string };
              }
            | { __typename: "CardEnabledStatusInfo" }
            | { __typename: "CardProcessingStatusInfo" };
        }>;
      }
    | { __typename: "AddingCardsToDifferentAccountsRejection"; message: string }
    | { __typename: "BadAccountStatusRejection"; message: string }
    | { __typename: "CardProductDisabledRejection"; message: string }
    | { __typename: "CardProductInvalidFundingTypeRejection"; message: string }
    | { __typename: "CardProductNotApplicableToPhysicalCardsRejection"; message: string }
    | { __typename: "CardProductSuspendedRejection"; message: string }
    | { __typename: "EnabledCardDesignNotFoundRejection"; message: string }
    | { __typename: "MissingMandatoryFieldRejection"; message: string }
    | { __typename: "TooManyItemsRejection"; message: string }
    | { __typename: "ValidationRejection"; message: string };
};

export type AddSingleUseVirtualCardsMutationVariables = Exact<{
  input: AddSingleUseVirtualCardsInput;
}>;

export type AddSingleUseVirtualCardsMutation = {
  __typename: "Mutation";
  addSingleUseVirtualCards:
    | { __typename: "AccountMembershipNotAllowedRejection"; message: string }
    | {
        __typename: "AddSingleUseVirtualCardsSuccessPayload";
        cards: Array<{
          __typename: "Card";
          id: string;
          insuranceSubscription?: {
            __typename: "CardInsuranceSubscription";
            id: string;
            package: {
              __typename: "CardInsurancePackage";
              id: string;
              name: string;
              level: CardInsurancePackageLevel;
            };
          } | null;
          statusInfo:
            | { __typename: "CardCanceledStatusInfo" }
            | { __typename: "CardCancelingStatusInfo" }
            | {
                __typename: "CardConsentPendingStatusInfo";
                consent: { __typename: "Consent"; id: string; consentUrl: string };
              }
            | { __typename: "CardEnabledStatusInfo" }
            | { __typename: "CardProcessingStatusInfo" };
        }>;
      }
    | { __typename: "AddingCardsToDifferentAccountsRejection"; message: string }
    | { __typename: "BadAccountStatusRejection"; message: string }
    | { __typename: "CardProductDisabledRejection"; message: string }
    | { __typename: "CardProductInvalidFundingTypeRejection"; message: string }
    | { __typename: "CardProductSuspendedRejection"; message: string }
    | { __typename: "EnabledCardDesignNotFoundRejection"; message: string }
    | { __typename: "MissingMandatoryFieldRejection"; message: string }
    | { __typename: "TooManyItemsRejection"; message: string }
    | { __typename: "ValidationRejection"; message: string };
};

export type AddSingleUseVirtualCardMutationVariables = Exact<{
  input: AddSingleUseVirtualCardInput;
}>;

export type AddSingleUseVirtualCardMutation = {
  __typename: "Mutation";
  addSingleUseVirtualCard:
    | { __typename: "AccountMembershipNotAllowedRejection"; message: string }
    | {
        __typename: "AddSingleUseVirtualCardSuccessForProjectOwnerPayload";
        card: {
          __typename: "Card";
          id: string;
          insuranceSubscription?: {
            __typename: "CardInsuranceSubscription";
            id: string;
            package: {
              __typename: "CardInsurancePackage";
              id: string;
              name: string;
              level: CardInsurancePackageLevel;
            };
          } | null;
          statusInfo:
            | { __typename: "CardCanceledStatusInfo" }
            | { __typename: "CardCancelingStatusInfo" }
            | {
                __typename: "CardConsentPendingStatusInfo";
                consent: { __typename: "Consent"; id: string; consentUrl: string };
              }
            | { __typename: "CardEnabledStatusInfo" }
            | { __typename: "CardProcessingStatusInfo" };
        };
      }
    | {
        __typename: "AddSingleUseVirtualCardSuccessForUserPayload";
        card: {
          __typename: "Card";
          id: string;
          insuranceSubscription?: {
            __typename: "CardInsuranceSubscription";
            id: string;
            package: {
              __typename: "CardInsurancePackage";
              id: string;
              name: string;
              level: CardInsurancePackageLevel;
            };
          } | null;
          statusInfo:
            | { __typename: "CardCanceledStatusInfo" }
            | { __typename: "CardCancelingStatusInfo" }
            | {
                __typename: "CardConsentPendingStatusInfo";
                consent: { __typename: "Consent"; id: string; consentUrl: string };
              }
            | { __typename: "CardEnabledStatusInfo" }
            | { __typename: "CardProcessingStatusInfo" };
        };
      }
    | { __typename: "BadAccountStatusRejection"; message: string }
    | { __typename: "CardProductDisabledRejection"; message: string }
    | { __typename: "CardProductInvalidFundingTypeRejection"; message: string }
    | { __typename: "CardProductSuspendedRejection"; message: string }
    | { __typename: "EnabledCardDesignNotFoundRejection"; message: string }
    | { __typename: "MissingMandatoryFieldRejection"; message: string }
    | { __typename: "ValidationRejection"; message: string };
};

export type InitiateSepaCreditTransfersMutationVariables = Exact<{
  input: InitiateCreditTransfersInput;
}>;

export type InitiateSepaCreditTransfersMutation = {
  __typename: "Mutation";
  initiateCreditTransfers:
    | { __typename: "AccountNotFoundRejection"; id: string; message: string }
    | { __typename: "BeneficiaryVerificationTokenAlreadyConsumedRejection" }
    | { __typename: "ForbiddenRejection"; message: string }
    | { __typename: "IdempotencyConflictRejection" }
    | {
        __typename: "InitiateCreditTransfersSuccessPayload";
        payment: {
          __typename: "Payment";
          id: string;
          statusInfo:
            | {
                __typename: "PaymentConsentPending";
                consent: { __typename: "Consent"; id: string; consentUrl: string };
              }
            | { __typename: "PaymentInitiated" }
            | { __typename: "PaymentRejected"; reason: string };
        };
      }
    | { __typename: "InternalErrorRejection" }
    | { __typename: "ValidationRejection" };
};

export type ResumeAccountMembershipMutationVariables = Exact<{
  input: ResumeAccountMembershipInput;
}>;

export type ResumeAccountMembershipMutation = {
  __typename: "Mutation";
  resumeAccountMembership:
    | { __typename: "ForbiddenRejection" }
    | {
        __typename: "ResumeAccountMembershipSuccessPayload";
        consent: { __typename: "Consent"; id: string; consentUrl: string };
      }
    | { __typename: "UserNotAllowedToManageAccountMembershipRejection" }
    | { __typename: "ValidationRejection" };
};

export type SuspendAccountMembershipMutationVariables = Exact<{
  input: SuspendAccountMembershipInput;
}>;

export type SuspendAccountMembershipMutation = {
  __typename: "Mutation";
  suspendAccountMembership:
    | { __typename: "InternalErrorRejection" }
    | { __typename: "LegalRepresentativeAccountMembershipCannotBeSuspendedRejection" }
    | { __typename: "SuspendAccountMembershipSuccessPayload" }
    | { __typename: "UserNotAllowedToManageAccountMembershipRejection" }
    | { __typename: "UserNotAllowedToSuspendItsOwnAccountMembershipRejection" }
    | { __typename: "ValidationRejection" };
};

export type UpdateAccountMembershipMutationVariables = Exact<{
  input: UpdateAccountMembershipInput;
}>;

export type UpdateAccountMembershipMutation = {
  __typename: "Mutation";
  updateAccountMembership:
    | { __typename: "AccountMembershipCannotBeUpdatedRejection" }
    | { __typename: "AccountMembershipNotFoundRejection" }
    | { __typename: "AccountMembershipNotReadyToBeUpdatedRejection" }
    | { __typename: "AccountNotFoundRejection" }
    | { __typename: "ForbiddenRejection" }
    | { __typename: "InternalErrorRejection" }
    | { __typename: "InvalidPhoneNumberRejection" }
    | { __typename: "LegalRepresentativeEmailCannotBeUpdatedRejection" }
    | { __typename: "LegalRepresentativePermissionsCannotBeUpdatedRejection" }
    | { __typename: "MissingBirthDateRejection" }
    | { __typename: "MissingPhoneNumberRestrictionRejection" }
    | { __typename: "PermissionCannotBeGrantedRejection" }
    | {
        __typename: "UpdateAccountMembershipSuccessPayload";
        consent: { __typename: "Consent"; id: string; consentUrl: string };
      }
    | { __typename: "UserNotAllowedToManageAccountMembershipRejection" }
    | {
        __typename: "ValidationRejection";
        fields: Array<{ __typename: "ValidationFieldError"; path: Array<string> }>;
      };
};

export type DisableAccountMembershipMutationVariables = Exact<{
  accountMembershipId: Scalars["ID"]["input"];
}>;

export type DisableAccountMembershipMutation = {
  __typename: "Mutation";
  disableAccountMembership:
    | { __typename: "AccountMembershipCannotBeDisabledRejection" }
    | { __typename: "AccountMembershipNotFoundRejection" }
    | { __typename: "DisableAccountMembershipSuccessPayload" }
    | { __typename: "ForbiddenRejection" }
    | { __typename: "InternalErrorRejection" }
    | { __typename: "LegalRepresentativeAccountMembershipCannotBeDisabledRejection" }
    | { __typename: "UserNotAllowedToDisableItsOwnAccountMembershipRejection" }
    | { __typename: "ValidationRejection" };
};

export type ViewCardNumbersMutationVariables = Exact<{
  input: ViewCardNumbersInput;
}>;

export type ViewCardNumbersMutation = {
  __typename: "Mutation";
  viewCardNumbers:
    | { __typename: "CardNotFoundRejection"; message: string }
    | { __typename: "ForbiddenRejection"; message: string }
    | { __typename: "UserNotCardHolderRejection"; message: string }
    | { __typename: "ValidationRejection"; message: string }
    | {
        __typename: "ViewCardNumbersSuccessPayload";
        consent: {
          __typename: "Consent";
          id: string;
          consentUrl: string;
          purpose: ConsentPurpose;
          redirectUrl: string;
          status: ConsentStatus;
        };
      };
};

export type ViewPhysicalCardNumbersMutationVariables = Exact<{
  input: ViewPhysicalCardNumbersInput;
}>;

export type ViewPhysicalCardNumbersMutation = {
  __typename: "Mutation";
  viewPhysicalCardNumbers:
    | { __typename: "CardNotFoundRejection"; message: string }
    | { __typename: "ForbiddenRejection"; message: string }
    | { __typename: "UserNotCardHolderRejection"; message: string }
    | { __typename: "ValidationRejection"; message: string }
    | {
        __typename: "ViewPhysicalCardNumbersSuccessPayload";
        consent: {
          __typename: "Consent";
          id: string;
          consentUrl: string;
          purpose: ConsentPurpose;
          redirectUrl: string;
          status: ConsentStatus;
        };
      };
};

export type ViewPhysicalCardPinMutationVariables = Exact<{
  input: ViewPhysicalCardPinInput;
}>;

export type ViewPhysicalCardPinMutation = {
  __typename: "Mutation";
  viewPhysicalCardPin:
    | { __typename: "CardNotFoundRejection" }
    | { __typename: "ForbiddenRejection" }
    | { __typename: "PINNotReadyRejection" }
    | { __typename: "PhysicalCardNotFoundRejection" }
    | { __typename: "UserNotCardHolderRejection" }
    | { __typename: "ValidationRejection" }
    | {
        __typename: "ViewPhysicalCardPinSuccessPayload";
        consent: { __typename: "Consent"; id: string; consentUrl: string };
      };
};

export type ActivatePhysicalCardMutationVariables = Exact<{
  input: ActivatePhysicalCardInput;
}>;

export type ActivatePhysicalCardMutation = {
  __typename: "Mutation";
  activatePhysicalCard:
    | {
        __typename: "ActivatePhysicalCardSuccessPayload";
        consent: { __typename: "Consent"; id: string; consentUrl: string };
      }
    | { __typename: "BadAccountStatusRejection" }
    | { __typename: "CannotActivatePhysicalCardRejection" }
    | { __typename: "CardNotFoundRejection" }
    | { __typename: "ForbiddenRejection" }
    | { __typename: "PhysicalCardNotFoundRejection" }
    | { __typename: "PhysicalCardWrongStatusRejection" }
    | { __typename: "UserNotCardHolderRejection" }
    | { __typename: "ValidationRejection" };
};

export type CancelCardMutationVariables = Exact<{
  cardId: Scalars["ID"]["input"];
}>;

export type CancelCardMutation = {
  __typename: "Mutation";
  cancelCard:
    | { __typename: "AccountMembershipNotAllowedRejection" }
    | { __typename: "CancelCardSuccessPayload"; card: { __typename: "Card"; id: string } }
    | { __typename: "CardNotFoundRejection" }
    | { __typename: "ForbiddenRejection" }
    | { __typename: "ValidationRejection" };
};

export type CancelDigitalCardMutationVariables = Exact<{
  digitalCardId: Scalars["ID"]["input"];
}>;

export type CancelDigitalCardMutation = {
  __typename: "Mutation";
  cancelDigitalCard:
    | { __typename: "AccountMembershipNotAllowedRejection" }
    | {
        __typename: "CancelDigitalCardSuccessPayload";
        digitalCard:
          | { __typename: "CompleteDigitalCard"; id: string }
          | { __typename: "PendingDigitalCard"; id: string };
      }
    | { __typename: "CardNotFoundRejection" }
    | { __typename: "DigitalCardNotFoundRejection" }
    | { __typename: "ForbiddenRejection" }
    | { __typename: "ValidationRejection" };
};

export type CancelPhysicalCardMutationVariables = Exact<{
  input: CancelPhysicalCardInput;
}>;

export type CancelPhysicalCardMutation = {
  __typename: "Mutation";
  cancelPhysicalCard:
    | { __typename: "AccountMembershipNotAllowedRejection" }
    | {
        __typename: "CancelPhysicalCardSuccessPayload";
        physicalCard: { __typename: "PhysicalCard"; identifier?: string | null };
      }
    | { __typename: "CardNotFoundRejection" }
    | { __typename: "ForbiddenRejection" }
    | { __typename: "PhysicalCardNotFoundRejection" }
    | { __typename: "ValidationRejection" };
};

export type UpdateCardMutationVariables = Exact<{
  input: UpdateCardInput;
}>;

export type UpdateCardMutation = {
  __typename: "Mutation";
  updateCard?:
    | { __typename: "AccountMembershipNotAllowedRejection" }
    | { __typename: "AccountNotFoundRejection" }
    | { __typename: "CardNotFoundRejection" }
    | { __typename: "ForbiddenRejection" }
    | {
        __typename: "UpdateCardSuccessPayload";
        consent: { __typename: "Consent"; id: string; consentUrl: string };
      }
    | { __typename: "ValidationRejection" }
    | null;
};

export type ConfirmPhysicalCardRenewalMutationVariables = Exact<{
  input: ConfirmPhysicalCardRenewalInput;
}>;

export type ConfirmPhysicalCardRenewalMutation = {
  __typename: "Mutation";
  confirmPhysicalCardRenewal:
    | { __typename: "CardNotFoundRejection"; message: string }
    | {
        __typename: "ConfirmPhysicalCardRenewalSuccessPayload";
        physicalCard: { __typename: "PhysicalCard"; identifier?: string | null };
      }
    | { __typename: "ForbiddenRejection"; message: string }
    | { __typename: "InvalidShippingProviderRejection"; message: string }
    | { __typename: "PhysicalCardWrongStatusRejection"; message: string }
    | { __typename: "ValidationRejection"; message: string };
};

export type ScheduleStandingOrderMutationVariables = Exact<{
  input: ScheduleStandingOrderInput;
}>;

export type ScheduleStandingOrderMutation = {
  __typename: "Mutation";
  scheduleStandingOrder:
    | { __typename: "ForbiddenRejection" }
    | { __typename: "InternalErrorRejection" }
    | { __typename: "InvalidArgumentRejection" }
    | {
        __typename: "ScheduleStandingOrderSuccessPayload";
        standingOrder: {
          __typename: "StandingOrder";
          id: string;
          statusInfo:
            | { __typename: "StandingOrderCanceledStatusInfo" }
            | {
                __typename: "StandingOrderConsentPendingStatusInfo";
                consent: { __typename: "Consent"; id: string; consentUrl: string };
              }
            | { __typename: "StandingOrderEnabledStatusInfo" };
        };
      };
};

export type CancelStandingOrderMutationVariables = Exact<{
  id: Scalars["String"]["input"];
}>;

export type CancelStandingOrderMutation = {
  __typename: "Mutation";
  cancelStandingOrder:
    | {
        __typename: "CancelStandingOrderSuccessPayload";
        standingOrder: { __typename: "StandingOrder"; id: string };
      }
    | { __typename: "ForbiddenRejection" }
    | { __typename: "InternalErrorRejection" }
    | { __typename: "StandingOrderNotFoundRejection" };
};

export type SuspendPhysicalCardMutationVariables = Exact<{
  cardId: Scalars["ID"]["input"];
}>;

export type SuspendPhysicalCardMutation = {
  __typename: "Mutation";
  suspendPhysicalCard:
    | { __typename: "AccountMembershipNotAllowedRejection" }
    | { __typename: "CardNotFoundRejection" }
    | { __typename: "ForbiddenRejection" }
    | { __typename: "PhysicalCardNotFoundRejection" }
    | { __typename: "SuspendPhysicalCardSuccessPayload" }
    | { __typename: "ValidationRejection" };
};

export type ResumePhysicalCardMutationVariables = Exact<{
  input: ResumePhysicalCardInput;
}>;

export type ResumePhysicalCardMutation = {
  __typename: "Mutation";
  resumePhysicalCard:
    | { __typename: "CardNotFoundRejection" }
    | { __typename: "ForbiddenRejection" }
    | { __typename: "PhysicalCardNotFoundRejection" }
    | { __typename: "PhysicalCardWrongStatusRejection" }
    | {
        __typename: "ResumePhysicalCardSuccessPayload";
        consent: { __typename: "Consent"; id: string; consentUrl: string };
      }
    | { __typename: "UserNotCardHolderRejection" }
    | { __typename: "ValidationRejection" };
};

export type AddAccountMembershipMutationVariables = Exact<{
  input: AddAccountMembershipInput;
}>;

export type AddAccountMembershipMutation = {
  __typename: "Mutation";
  addAccountMembership:
    | {
        __typename: "AddAccountMembershipSuccessPayload";
        accountMembership: {
          __typename: "AccountMembership";
          id: string;
          email: string;
          canInitiatePayments: boolean;
          canManageAccountMembership: boolean;
          canManageBeneficiaries: boolean;
          canViewAccount: boolean;
          statusInfo:
            | {
                __typename: "AccountMembershipBindingUserErrorStatusInfo";
                status: AccountMembershipStatus;
              }
            | {
                __typename: "AccountMembershipConsentPendingStatusInfo";
                status: AccountMembershipStatus;
                consent: { __typename: "Consent"; id: string; consentUrl: string };
              }
            | { __typename: "AccountMembershipDisabledStatusInfo"; status: AccountMembershipStatus }
            | { __typename: "AccountMembershipEnabledStatusInfo"; status: AccountMembershipStatus }
            | {
                __typename: "AccountMembershipInvitationSentStatusInfo";
                status: AccountMembershipStatus;
              }
            | {
                __typename: "AccountMembershipSuspendedStatusInfo";
                status: AccountMembershipStatus;
              };
          user?: {
            __typename: "User";
            id: string;
            birthDate?: string | null;
            firstName?: string | null;
            preferredLastName?: string | null;
            fullName?: string | null;
            mobilePhoneNumber?: string | null;
          } | null;
          account?: { __typename: "Account"; id: string } | null;
        };
      }
    | { __typename: "BadAccountStatusRejection" }
    | { __typename: "ForbiddenRejection" }
    | { __typename: "InvalidPhoneNumberRejection" }
    | { __typename: "MissingPhoneNumberRestrictionRejection" }
    | { __typename: "PermissionCannotBeGrantedRejection" }
    | { __typename: "ValidationRejection" };
};

export type GenerateAccountStatementMutationVariables = Exact<{
  input: GenerateAccountStatementInput;
}>;

export type GenerateAccountStatementMutation = {
  __typename: "Mutation";
  generateAccountStatement: { __typename: "Statement"; id: string };
};

export type InitiateInternationalCreditTransferMutationVariables = Exact<{
  input: InitiateInternationalCreditTransferInput;
}>;

export type InitiateInternationalCreditTransferMutation = {
  __typename: "Mutation";
  initiateInternationalCreditTransfer?:
    | { __typename: "AccountNotFoundRejection"; message: string }
    | { __typename: "ForbiddenRejection"; message: string }
    | {
        __typename: "InitiateInternationalCreditTransferResponseSuccessPayload";
        payment: {
          __typename: "Payment";
          id: string;
          statusInfo:
            | {
                __typename: "PaymentConsentPending";
                consent: { __typename: "Consent"; id: string; consentUrl: string };
              }
            | { __typename: "PaymentInitiated" }
            | { __typename: "PaymentRejected"; reason: string };
        };
      }
    | { __typename: "InternalErrorRejection"; message: string }
    | { __typename: "ValidationRejection"; message: string }
    | null;
};

type MerchantPaymentMethod_CardMerchantPaymentMethod_Fragment = {
  __typename: "CardMerchantPaymentMethod";
  id: string;
  type: MerchantPaymentMethodType;
  methodId: string;
  updatedAt: string;
  version: number;
  rollingReserve?: { __typename: "RollingReserve"; percentage: number; rollingDays: number } | null;
  statusInfo:
    | { __typename: "DisabledMerchantPaymentMethodStatusInfo"; status: MerchantPaymentMethodStatus }
    | { __typename: "EnabledMerchantPaymentMethodStatusInfo"; status: MerchantPaymentMethodStatus }
    | { __typename: "PendingMerchantPaymentMethodStatusInfo"; status: MerchantPaymentMethodStatus }
    | { __typename: "RejectedMerchantPaymentMethodStatusInfo"; status: MerchantPaymentMethodStatus }
    | {
        __typename: "SuspendedMerchantPaymentMethodStatusInfo";
        status: MerchantPaymentMethodStatus;
      }
    | {
        __typename: "WaitingForInformationMerchantPaymentMethodStatusInfo";
        status: MerchantPaymentMethodStatus;
        verificationRequirements: Array<
          | {
              __typename: "AdditionalInformationRequirements";
              additionalInformation: Array<AdditionalInformationType>;
            }
          | { __typename: "MerchantRequirements"; fields: Array<MerchantRequirementType> }
          | {
              __typename: "OtherAdditionalInformationRequirements";
              otherAdditionalInformation: Array<string>;
            }
          | {
              __typename: "SupportingDocumentRequirements";
              supportingDocumentPurposes: Array<SupportingDocumentPurposeEnum>;
            }
        >;
      };
};

type MerchantPaymentMethod_CheckMerchantPaymentMethod_Fragment = {
  __typename: "CheckMerchantPaymentMethod";
  id: string;
  type: MerchantPaymentMethodType;
  methodId: string;
  updatedAt: string;
  version: number;
  rollingReserve?: { __typename: "RollingReserve"; percentage: number; rollingDays: number } | null;
  statusInfo:
    | { __typename: "DisabledMerchantPaymentMethodStatusInfo"; status: MerchantPaymentMethodStatus }
    | { __typename: "EnabledMerchantPaymentMethodStatusInfo"; status: MerchantPaymentMethodStatus }
    | { __typename: "PendingMerchantPaymentMethodStatusInfo"; status: MerchantPaymentMethodStatus }
    | { __typename: "RejectedMerchantPaymentMethodStatusInfo"; status: MerchantPaymentMethodStatus }
    | {
        __typename: "SuspendedMerchantPaymentMethodStatusInfo";
        status: MerchantPaymentMethodStatus;
      }
    | {
        __typename: "WaitingForInformationMerchantPaymentMethodStatusInfo";
        status: MerchantPaymentMethodStatus;
        verificationRequirements: Array<
          | {
              __typename: "AdditionalInformationRequirements";
              additionalInformation: Array<AdditionalInformationType>;
            }
          | { __typename: "MerchantRequirements"; fields: Array<MerchantRequirementType> }
          | {
              __typename: "OtherAdditionalInformationRequirements";
              otherAdditionalInformation: Array<string>;
            }
          | {
              __typename: "SupportingDocumentRequirements";
              supportingDocumentPurposes: Array<SupportingDocumentPurposeEnum>;
            }
        >;
      };
};

type MerchantPaymentMethod_InPersonCardMerchantPaymentMethod_Fragment = {
  __typename: "InPersonCardMerchantPaymentMethod";
  id: string;
  type: MerchantPaymentMethodType;
  methodId: string;
  updatedAt: string;
  version: number;
  rollingReserve?: { __typename: "RollingReserve"; percentage: number; rollingDays: number } | null;
  statusInfo:
    | { __typename: "DisabledMerchantPaymentMethodStatusInfo"; status: MerchantPaymentMethodStatus }
    | { __typename: "EnabledMerchantPaymentMethodStatusInfo"; status: MerchantPaymentMethodStatus }
    | { __typename: "PendingMerchantPaymentMethodStatusInfo"; status: MerchantPaymentMethodStatus }
    | { __typename: "RejectedMerchantPaymentMethodStatusInfo"; status: MerchantPaymentMethodStatus }
    | {
        __typename: "SuspendedMerchantPaymentMethodStatusInfo";
        status: MerchantPaymentMethodStatus;
      }
    | {
        __typename: "WaitingForInformationMerchantPaymentMethodStatusInfo";
        status: MerchantPaymentMethodStatus;
        verificationRequirements: Array<
          | {
              __typename: "AdditionalInformationRequirements";
              additionalInformation: Array<AdditionalInformationType>;
            }
          | { __typename: "MerchantRequirements"; fields: Array<MerchantRequirementType> }
          | {
              __typename: "OtherAdditionalInformationRequirements";
              otherAdditionalInformation: Array<string>;
            }
          | {
              __typename: "SupportingDocumentRequirements";
              supportingDocumentPurposes: Array<SupportingDocumentPurposeEnum>;
            }
        >;
      };
};

type MerchantPaymentMethod_InternalDirectDebitB2BMerchantPaymentMethod_Fragment = {
  __typename: "InternalDirectDebitB2BMerchantPaymentMethod";
  id: string;
  type: MerchantPaymentMethodType;
  methodId: string;
  updatedAt: string;
  version: number;
  rollingReserve?: { __typename: "RollingReserve"; percentage: number; rollingDays: number } | null;
  statusInfo:
    | { __typename: "DisabledMerchantPaymentMethodStatusInfo"; status: MerchantPaymentMethodStatus }
    | { __typename: "EnabledMerchantPaymentMethodStatusInfo"; status: MerchantPaymentMethodStatus }
    | { __typename: "PendingMerchantPaymentMethodStatusInfo"; status: MerchantPaymentMethodStatus }
    | { __typename: "RejectedMerchantPaymentMethodStatusInfo"; status: MerchantPaymentMethodStatus }
    | {
        __typename: "SuspendedMerchantPaymentMethodStatusInfo";
        status: MerchantPaymentMethodStatus;
      }
    | {
        __typename: "WaitingForInformationMerchantPaymentMethodStatusInfo";
        status: MerchantPaymentMethodStatus;
        verificationRequirements: Array<
          | {
              __typename: "AdditionalInformationRequirements";
              additionalInformation: Array<AdditionalInformationType>;
            }
          | { __typename: "MerchantRequirements"; fields: Array<MerchantRequirementType> }
          | {
              __typename: "OtherAdditionalInformationRequirements";
              otherAdditionalInformation: Array<string>;
            }
          | {
              __typename: "SupportingDocumentRequirements";
              supportingDocumentPurposes: Array<SupportingDocumentPurposeEnum>;
            }
        >;
      };
};

type MerchantPaymentMethod_InternalDirectDebitStandardMerchantPaymentMethod_Fragment = {
  __typename: "InternalDirectDebitStandardMerchantPaymentMethod";
  id: string;
  type: MerchantPaymentMethodType;
  methodId: string;
  updatedAt: string;
  version: number;
  rollingReserve?: { __typename: "RollingReserve"; percentage: number; rollingDays: number } | null;
  statusInfo:
    | { __typename: "DisabledMerchantPaymentMethodStatusInfo"; status: MerchantPaymentMethodStatus }
    | { __typename: "EnabledMerchantPaymentMethodStatusInfo"; status: MerchantPaymentMethodStatus }
    | { __typename: "PendingMerchantPaymentMethodStatusInfo"; status: MerchantPaymentMethodStatus }
    | { __typename: "RejectedMerchantPaymentMethodStatusInfo"; status: MerchantPaymentMethodStatus }
    | {
        __typename: "SuspendedMerchantPaymentMethodStatusInfo";
        status: MerchantPaymentMethodStatus;
      }
    | {
        __typename: "WaitingForInformationMerchantPaymentMethodStatusInfo";
        status: MerchantPaymentMethodStatus;
        verificationRequirements: Array<
          | {
              __typename: "AdditionalInformationRequirements";
              additionalInformation: Array<AdditionalInformationType>;
            }
          | { __typename: "MerchantRequirements"; fields: Array<MerchantRequirementType> }
          | {
              __typename: "OtherAdditionalInformationRequirements";
              otherAdditionalInformation: Array<string>;
            }
          | {
              __typename: "SupportingDocumentRequirements";
              supportingDocumentPurposes: Array<SupportingDocumentPurposeEnum>;
            }
        >;
      };
};

type MerchantPaymentMethod_SepaDirectDebitB2BMerchantPaymentMethod_Fragment = {
  __typename: "SepaDirectDebitB2BMerchantPaymentMethod";
  sepaCreditorIdentifier?: string | null;
  useSwanSepaCreditorIdentifier: boolean;
  id: string;
  type: MerchantPaymentMethodType;
  methodId: string;
  updatedAt: string;
  version: number;
  rollingReserve?: { __typename: "RollingReserve"; percentage: number; rollingDays: number } | null;
  statusInfo:
    | { __typename: "DisabledMerchantPaymentMethodStatusInfo"; status: MerchantPaymentMethodStatus }
    | { __typename: "EnabledMerchantPaymentMethodStatusInfo"; status: MerchantPaymentMethodStatus }
    | { __typename: "PendingMerchantPaymentMethodStatusInfo"; status: MerchantPaymentMethodStatus }
    | { __typename: "RejectedMerchantPaymentMethodStatusInfo"; status: MerchantPaymentMethodStatus }
    | {
        __typename: "SuspendedMerchantPaymentMethodStatusInfo";
        status: MerchantPaymentMethodStatus;
      }
    | {
        __typename: "WaitingForInformationMerchantPaymentMethodStatusInfo";
        status: MerchantPaymentMethodStatus;
        verificationRequirements: Array<
          | {
              __typename: "AdditionalInformationRequirements";
              additionalInformation: Array<AdditionalInformationType>;
            }
          | { __typename: "MerchantRequirements"; fields: Array<MerchantRequirementType> }
          | {
              __typename: "OtherAdditionalInformationRequirements";
              otherAdditionalInformation: Array<string>;
            }
          | {
              __typename: "SupportingDocumentRequirements";
              supportingDocumentPurposes: Array<SupportingDocumentPurposeEnum>;
            }
        >;
      };
};

type MerchantPaymentMethod_SepaDirectDebitCoreMerchantPaymentMethod_Fragment = {
  __typename: "SepaDirectDebitCoreMerchantPaymentMethod";
  sepaCreditorIdentifier?: string | null;
  useSwanSepaCreditorIdentifier: boolean;
  id: string;
  type: MerchantPaymentMethodType;
  methodId: string;
  updatedAt: string;
  version: number;
  rollingReserve?: { __typename: "RollingReserve"; percentage: number; rollingDays: number } | null;
  statusInfo:
    | { __typename: "DisabledMerchantPaymentMethodStatusInfo"; status: MerchantPaymentMethodStatus }
    | { __typename: "EnabledMerchantPaymentMethodStatusInfo"; status: MerchantPaymentMethodStatus }
    | { __typename: "PendingMerchantPaymentMethodStatusInfo"; status: MerchantPaymentMethodStatus }
    | { __typename: "RejectedMerchantPaymentMethodStatusInfo"; status: MerchantPaymentMethodStatus }
    | {
        __typename: "SuspendedMerchantPaymentMethodStatusInfo";
        status: MerchantPaymentMethodStatus;
      }
    | {
        __typename: "WaitingForInformationMerchantPaymentMethodStatusInfo";
        status: MerchantPaymentMethodStatus;
        verificationRequirements: Array<
          | {
              __typename: "AdditionalInformationRequirements";
              additionalInformation: Array<AdditionalInformationType>;
            }
          | { __typename: "MerchantRequirements"; fields: Array<MerchantRequirementType> }
          | {
              __typename: "OtherAdditionalInformationRequirements";
              otherAdditionalInformation: Array<string>;
            }
          | {
              __typename: "SupportingDocumentRequirements";
              supportingDocumentPurposes: Array<SupportingDocumentPurposeEnum>;
            }
        >;
      };
};

export type MerchantPaymentMethodFragment =
  | MerchantPaymentMethod_CardMerchantPaymentMethod_Fragment
  | MerchantPaymentMethod_CheckMerchantPaymentMethod_Fragment
  | MerchantPaymentMethod_InPersonCardMerchantPaymentMethod_Fragment
  | MerchantPaymentMethod_InternalDirectDebitB2BMerchantPaymentMethod_Fragment
  | MerchantPaymentMethod_InternalDirectDebitStandardMerchantPaymentMethod_Fragment
  | MerchantPaymentMethod_SepaDirectDebitB2BMerchantPaymentMethod_Fragment
  | MerchantPaymentMethod_SepaDirectDebitCoreMerchantPaymentMethod_Fragment;

export type MerchantProfileFragment = {
  __typename: "MerchantProfile";
  id: string;
  accentColor?: string | null;
  accountId: string;
  createdAt: string;
  updatedAt: string;
  expectedMonthlyMerchantProcessingVolume: ExpectedMonthlyMerchantProcessingVolume;
  merchantLogoUrl?: string | null;
  merchantName: string;
  merchantWebsiteUrl?: string | null;
  productType: ProductType;
  expectedAverageBasket: { __typename: "Amount"; value: string; currency: string };
  statusInfo:
    | { __typename: "DisabledMerchantProfileStatusInfo"; status: MerchantProfileStatus }
    | { __typename: "EnabledMerchantProfileStatusInfo"; status: MerchantProfileStatus }
    | { __typename: "PendingReviewMerchantProfileStatusInfo"; status: MerchantProfileStatus }
    | { __typename: "RejectedMerchantProfileStatusInfo"; status: MerchantProfileStatus }
    | { __typename: "SuspendedMerchantProfileStatusInfo"; status: MerchantProfileStatus };
  merchantPaymentMethods?: Array<
    | {
        __typename: "CardMerchantPaymentMethod";
        id: string;
        type: MerchantPaymentMethodType;
        methodId: string;
        updatedAt: string;
        version: number;
        rollingReserve?: {
          __typename: "RollingReserve";
          percentage: number;
          rollingDays: number;
        } | null;
        statusInfo:
          | {
              __typename: "DisabledMerchantPaymentMethodStatusInfo";
              status: MerchantPaymentMethodStatus;
            }
          | {
              __typename: "EnabledMerchantPaymentMethodStatusInfo";
              status: MerchantPaymentMethodStatus;
            }
          | {
              __typename: "PendingMerchantPaymentMethodStatusInfo";
              status: MerchantPaymentMethodStatus;
            }
          | {
              __typename: "RejectedMerchantPaymentMethodStatusInfo";
              status: MerchantPaymentMethodStatus;
            }
          | {
              __typename: "SuspendedMerchantPaymentMethodStatusInfo";
              status: MerchantPaymentMethodStatus;
            }
          | {
              __typename: "WaitingForInformationMerchantPaymentMethodStatusInfo";
              status: MerchantPaymentMethodStatus;
              verificationRequirements: Array<
                | {
                    __typename: "AdditionalInformationRequirements";
                    additionalInformation: Array<AdditionalInformationType>;
                  }
                | { __typename: "MerchantRequirements"; fields: Array<MerchantRequirementType> }
                | {
                    __typename: "OtherAdditionalInformationRequirements";
                    otherAdditionalInformation: Array<string>;
                  }
                | {
                    __typename: "SupportingDocumentRequirements";
                    supportingDocumentPurposes: Array<SupportingDocumentPurposeEnum>;
                  }
              >;
            };
      }
    | {
        __typename: "CheckMerchantPaymentMethod";
        id: string;
        type: MerchantPaymentMethodType;
        methodId: string;
        updatedAt: string;
        version: number;
        rollingReserve?: {
          __typename: "RollingReserve";
          percentage: number;
          rollingDays: number;
        } | null;
        statusInfo:
          | {
              __typename: "DisabledMerchantPaymentMethodStatusInfo";
              status: MerchantPaymentMethodStatus;
            }
          | {
              __typename: "EnabledMerchantPaymentMethodStatusInfo";
              status: MerchantPaymentMethodStatus;
            }
          | {
              __typename: "PendingMerchantPaymentMethodStatusInfo";
              status: MerchantPaymentMethodStatus;
            }
          | {
              __typename: "RejectedMerchantPaymentMethodStatusInfo";
              status: MerchantPaymentMethodStatus;
            }
          | {
              __typename: "SuspendedMerchantPaymentMethodStatusInfo";
              status: MerchantPaymentMethodStatus;
            }
          | {
              __typename: "WaitingForInformationMerchantPaymentMethodStatusInfo";
              status: MerchantPaymentMethodStatus;
              verificationRequirements: Array<
                | {
                    __typename: "AdditionalInformationRequirements";
                    additionalInformation: Array<AdditionalInformationType>;
                  }
                | { __typename: "MerchantRequirements"; fields: Array<MerchantRequirementType> }
                | {
                    __typename: "OtherAdditionalInformationRequirements";
                    otherAdditionalInformation: Array<string>;
                  }
                | {
                    __typename: "SupportingDocumentRequirements";
                    supportingDocumentPurposes: Array<SupportingDocumentPurposeEnum>;
                  }
              >;
            };
      }
    | {
        __typename: "InPersonCardMerchantPaymentMethod";
        id: string;
        type: MerchantPaymentMethodType;
        methodId: string;
        updatedAt: string;
        version: number;
        rollingReserve?: {
          __typename: "RollingReserve";
          percentage: number;
          rollingDays: number;
        } | null;
        statusInfo:
          | {
              __typename: "DisabledMerchantPaymentMethodStatusInfo";
              status: MerchantPaymentMethodStatus;
            }
          | {
              __typename: "EnabledMerchantPaymentMethodStatusInfo";
              status: MerchantPaymentMethodStatus;
            }
          | {
              __typename: "PendingMerchantPaymentMethodStatusInfo";
              status: MerchantPaymentMethodStatus;
            }
          | {
              __typename: "RejectedMerchantPaymentMethodStatusInfo";
              status: MerchantPaymentMethodStatus;
            }
          | {
              __typename: "SuspendedMerchantPaymentMethodStatusInfo";
              status: MerchantPaymentMethodStatus;
            }
          | {
              __typename: "WaitingForInformationMerchantPaymentMethodStatusInfo";
              status: MerchantPaymentMethodStatus;
              verificationRequirements: Array<
                | {
                    __typename: "AdditionalInformationRequirements";
                    additionalInformation: Array<AdditionalInformationType>;
                  }
                | { __typename: "MerchantRequirements"; fields: Array<MerchantRequirementType> }
                | {
                    __typename: "OtherAdditionalInformationRequirements";
                    otherAdditionalInformation: Array<string>;
                  }
                | {
                    __typename: "SupportingDocumentRequirements";
                    supportingDocumentPurposes: Array<SupportingDocumentPurposeEnum>;
                  }
              >;
            };
      }
    | {
        __typename: "InternalDirectDebitB2BMerchantPaymentMethod";
        id: string;
        type: MerchantPaymentMethodType;
        methodId: string;
        updatedAt: string;
        version: number;
        rollingReserve?: {
          __typename: "RollingReserve";
          percentage: number;
          rollingDays: number;
        } | null;
        statusInfo:
          | {
              __typename: "DisabledMerchantPaymentMethodStatusInfo";
              status: MerchantPaymentMethodStatus;
            }
          | {
              __typename: "EnabledMerchantPaymentMethodStatusInfo";
              status: MerchantPaymentMethodStatus;
            }
          | {
              __typename: "PendingMerchantPaymentMethodStatusInfo";
              status: MerchantPaymentMethodStatus;
            }
          | {
              __typename: "RejectedMerchantPaymentMethodStatusInfo";
              status: MerchantPaymentMethodStatus;
            }
          | {
              __typename: "SuspendedMerchantPaymentMethodStatusInfo";
              status: MerchantPaymentMethodStatus;
            }
          | {
              __typename: "WaitingForInformationMerchantPaymentMethodStatusInfo";
              status: MerchantPaymentMethodStatus;
              verificationRequirements: Array<
                | {
                    __typename: "AdditionalInformationRequirements";
                    additionalInformation: Array<AdditionalInformationType>;
                  }
                | { __typename: "MerchantRequirements"; fields: Array<MerchantRequirementType> }
                | {
                    __typename: "OtherAdditionalInformationRequirements";
                    otherAdditionalInformation: Array<string>;
                  }
                | {
                    __typename: "SupportingDocumentRequirements";
                    supportingDocumentPurposes: Array<SupportingDocumentPurposeEnum>;
                  }
              >;
            };
      }
    | {
        __typename: "InternalDirectDebitStandardMerchantPaymentMethod";
        id: string;
        type: MerchantPaymentMethodType;
        methodId: string;
        updatedAt: string;
        version: number;
        rollingReserve?: {
          __typename: "RollingReserve";
          percentage: number;
          rollingDays: number;
        } | null;
        statusInfo:
          | {
              __typename: "DisabledMerchantPaymentMethodStatusInfo";
              status: MerchantPaymentMethodStatus;
            }
          | {
              __typename: "EnabledMerchantPaymentMethodStatusInfo";
              status: MerchantPaymentMethodStatus;
            }
          | {
              __typename: "PendingMerchantPaymentMethodStatusInfo";
              status: MerchantPaymentMethodStatus;
            }
          | {
              __typename: "RejectedMerchantPaymentMethodStatusInfo";
              status: MerchantPaymentMethodStatus;
            }
          | {
              __typename: "SuspendedMerchantPaymentMethodStatusInfo";
              status: MerchantPaymentMethodStatus;
            }
          | {
              __typename: "WaitingForInformationMerchantPaymentMethodStatusInfo";
              status: MerchantPaymentMethodStatus;
              verificationRequirements: Array<
                | {
                    __typename: "AdditionalInformationRequirements";
                    additionalInformation: Array<AdditionalInformationType>;
                  }
                | { __typename: "MerchantRequirements"; fields: Array<MerchantRequirementType> }
                | {
                    __typename: "OtherAdditionalInformationRequirements";
                    otherAdditionalInformation: Array<string>;
                  }
                | {
                    __typename: "SupportingDocumentRequirements";
                    supportingDocumentPurposes: Array<SupportingDocumentPurposeEnum>;
                  }
              >;
            };
      }
    | {
        __typename: "SepaDirectDebitB2BMerchantPaymentMethod";
        sepaCreditorIdentifier?: string | null;
        useSwanSepaCreditorIdentifier: boolean;
        id: string;
        type: MerchantPaymentMethodType;
        methodId: string;
        updatedAt: string;
        version: number;
        rollingReserve?: {
          __typename: "RollingReserve";
          percentage: number;
          rollingDays: number;
        } | null;
        statusInfo:
          | {
              __typename: "DisabledMerchantPaymentMethodStatusInfo";
              status: MerchantPaymentMethodStatus;
            }
          | {
              __typename: "EnabledMerchantPaymentMethodStatusInfo";
              status: MerchantPaymentMethodStatus;
            }
          | {
              __typename: "PendingMerchantPaymentMethodStatusInfo";
              status: MerchantPaymentMethodStatus;
            }
          | {
              __typename: "RejectedMerchantPaymentMethodStatusInfo";
              status: MerchantPaymentMethodStatus;
            }
          | {
              __typename: "SuspendedMerchantPaymentMethodStatusInfo";
              status: MerchantPaymentMethodStatus;
            }
          | {
              __typename: "WaitingForInformationMerchantPaymentMethodStatusInfo";
              status: MerchantPaymentMethodStatus;
              verificationRequirements: Array<
                | {
                    __typename: "AdditionalInformationRequirements";
                    additionalInformation: Array<AdditionalInformationType>;
                  }
                | { __typename: "MerchantRequirements"; fields: Array<MerchantRequirementType> }
                | {
                    __typename: "OtherAdditionalInformationRequirements";
                    otherAdditionalInformation: Array<string>;
                  }
                | {
                    __typename: "SupportingDocumentRequirements";
                    supportingDocumentPurposes: Array<SupportingDocumentPurposeEnum>;
                  }
              >;
            };
      }
    | {
        __typename: "SepaDirectDebitCoreMerchantPaymentMethod";
        sepaCreditorIdentifier?: string | null;
        useSwanSepaCreditorIdentifier: boolean;
        id: string;
        type: MerchantPaymentMethodType;
        methodId: string;
        updatedAt: string;
        version: number;
        rollingReserve?: {
          __typename: "RollingReserve";
          percentage: number;
          rollingDays: number;
        } | null;
        statusInfo:
          | {
              __typename: "DisabledMerchantPaymentMethodStatusInfo";
              status: MerchantPaymentMethodStatus;
            }
          | {
              __typename: "EnabledMerchantPaymentMethodStatusInfo";
              status: MerchantPaymentMethodStatus;
            }
          | {
              __typename: "PendingMerchantPaymentMethodStatusInfo";
              status: MerchantPaymentMethodStatus;
            }
          | {
              __typename: "RejectedMerchantPaymentMethodStatusInfo";
              status: MerchantPaymentMethodStatus;
            }
          | {
              __typename: "SuspendedMerchantPaymentMethodStatusInfo";
              status: MerchantPaymentMethodStatus;
            }
          | {
              __typename: "WaitingForInformationMerchantPaymentMethodStatusInfo";
              status: MerchantPaymentMethodStatus;
              verificationRequirements: Array<
                | {
                    __typename: "AdditionalInformationRequirements";
                    additionalInformation: Array<AdditionalInformationType>;
                  }
                | { __typename: "MerchantRequirements"; fields: Array<MerchantRequirementType> }
                | {
                    __typename: "OtherAdditionalInformationRequirements";
                    otherAdditionalInformation: Array<string>;
                  }
                | {
                    __typename: "SupportingDocumentRequirements";
                    supportingDocumentPurposes: Array<SupportingDocumentPurposeEnum>;
                  }
              >;
            };
      }
  > | null;
  requestMerchantProfileUpdate?: {
    __typename: "RequestMerchantProfileUpdate";
    id: string;
    status: RequestMerchantProfileUpdateStatus;
    merchantName?: string | null;
    merchantWebsiteUrl?: string | null;
    merchantLogoUrl?: string | null;
    productType?: ProductType | null;
    expectedMonthlyMerchantProcessingVolume?: ExpectedMonthlyMerchantProcessingVolume | null;
    expectedAverageBasket?: { __typename: "Amount"; value: string; currency: string } | null;
  } | null;
};

export type AddMerchantProfileMutationVariables = Exact<{
  input: RequestMerchantProfileInput;
}>;

export type AddMerchantProfileMutation = {
  __typename: "Mutation";
  requestMerchantProfile?:
    | { __typename: "AccountNotFoundRejection"; message: string }
    | { __typename: "ForbiddenRejection"; message: string }
    | { __typename: "InternalErrorRejection"; message: string }
    | {
        __typename: "RequestMerchantProfileSuccessPayload";
        merchantProfile: {
          __typename: "MerchantProfile";
          id: string;
          accentColor?: string | null;
          accountId: string;
          createdAt: string;
          updatedAt: string;
          expectedMonthlyMerchantProcessingVolume: ExpectedMonthlyMerchantProcessingVolume;
          merchantLogoUrl?: string | null;
          merchantName: string;
          merchantWebsiteUrl?: string | null;
          productType: ProductType;
          expectedAverageBasket: { __typename: "Amount"; value: string; currency: string };
          statusInfo:
            | { __typename: "DisabledMerchantProfileStatusInfo"; status: MerchantProfileStatus }
            | { __typename: "EnabledMerchantProfileStatusInfo"; status: MerchantProfileStatus }
            | {
                __typename: "PendingReviewMerchantProfileStatusInfo";
                status: MerchantProfileStatus;
              }
            | { __typename: "RejectedMerchantProfileStatusInfo"; status: MerchantProfileStatus }
            | { __typename: "SuspendedMerchantProfileStatusInfo"; status: MerchantProfileStatus };
          merchantPaymentMethods?: Array<
            | {
                __typename: "CardMerchantPaymentMethod";
                id: string;
                type: MerchantPaymentMethodType;
                methodId: string;
                updatedAt: string;
                version: number;
                rollingReserve?: {
                  __typename: "RollingReserve";
                  percentage: number;
                  rollingDays: number;
                } | null;
                statusInfo:
                  | {
                      __typename: "DisabledMerchantPaymentMethodStatusInfo";
                      status: MerchantPaymentMethodStatus;
                    }
                  | {
                      __typename: "EnabledMerchantPaymentMethodStatusInfo";
                      status: MerchantPaymentMethodStatus;
                    }
                  | {
                      __typename: "PendingMerchantPaymentMethodStatusInfo";
                      status: MerchantPaymentMethodStatus;
                    }
                  | {
                      __typename: "RejectedMerchantPaymentMethodStatusInfo";
                      status: MerchantPaymentMethodStatus;
                    }
                  | {
                      __typename: "SuspendedMerchantPaymentMethodStatusInfo";
                      status: MerchantPaymentMethodStatus;
                    }
                  | {
                      __typename: "WaitingForInformationMerchantPaymentMethodStatusInfo";
                      status: MerchantPaymentMethodStatus;
                      verificationRequirements: Array<
                        | {
                            __typename: "AdditionalInformationRequirements";
                            additionalInformation: Array<AdditionalInformationType>;
                          }
                        | {
                            __typename: "MerchantRequirements";
                            fields: Array<MerchantRequirementType>;
                          }
                        | {
                            __typename: "OtherAdditionalInformationRequirements";
                            otherAdditionalInformation: Array<string>;
                          }
                        | {
                            __typename: "SupportingDocumentRequirements";
                            supportingDocumentPurposes: Array<SupportingDocumentPurposeEnum>;
                          }
                      >;
                    };
              }
            | {
                __typename: "CheckMerchantPaymentMethod";
                id: string;
                type: MerchantPaymentMethodType;
                methodId: string;
                updatedAt: string;
                version: number;
                rollingReserve?: {
                  __typename: "RollingReserve";
                  percentage: number;
                  rollingDays: number;
                } | null;
                statusInfo:
                  | {
                      __typename: "DisabledMerchantPaymentMethodStatusInfo";
                      status: MerchantPaymentMethodStatus;
                    }
                  | {
                      __typename: "EnabledMerchantPaymentMethodStatusInfo";
                      status: MerchantPaymentMethodStatus;
                    }
                  | {
                      __typename: "PendingMerchantPaymentMethodStatusInfo";
                      status: MerchantPaymentMethodStatus;
                    }
                  | {
                      __typename: "RejectedMerchantPaymentMethodStatusInfo";
                      status: MerchantPaymentMethodStatus;
                    }
                  | {
                      __typename: "SuspendedMerchantPaymentMethodStatusInfo";
                      status: MerchantPaymentMethodStatus;
                    }
                  | {
                      __typename: "WaitingForInformationMerchantPaymentMethodStatusInfo";
                      status: MerchantPaymentMethodStatus;
                      verificationRequirements: Array<
                        | {
                            __typename: "AdditionalInformationRequirements";
                            additionalInformation: Array<AdditionalInformationType>;
                          }
                        | {
                            __typename: "MerchantRequirements";
                            fields: Array<MerchantRequirementType>;
                          }
                        | {
                            __typename: "OtherAdditionalInformationRequirements";
                            otherAdditionalInformation: Array<string>;
                          }
                        | {
                            __typename: "SupportingDocumentRequirements";
                            supportingDocumentPurposes: Array<SupportingDocumentPurposeEnum>;
                          }
                      >;
                    };
              }
            | {
                __typename: "InPersonCardMerchantPaymentMethod";
                id: string;
                type: MerchantPaymentMethodType;
                methodId: string;
                updatedAt: string;
                version: number;
                rollingReserve?: {
                  __typename: "RollingReserve";
                  percentage: number;
                  rollingDays: number;
                } | null;
                statusInfo:
                  | {
                      __typename: "DisabledMerchantPaymentMethodStatusInfo";
                      status: MerchantPaymentMethodStatus;
                    }
                  | {
                      __typename: "EnabledMerchantPaymentMethodStatusInfo";
                      status: MerchantPaymentMethodStatus;
                    }
                  | {
                      __typename: "PendingMerchantPaymentMethodStatusInfo";
                      status: MerchantPaymentMethodStatus;
                    }
                  | {
                      __typename: "RejectedMerchantPaymentMethodStatusInfo";
                      status: MerchantPaymentMethodStatus;
                    }
                  | {
                      __typename: "SuspendedMerchantPaymentMethodStatusInfo";
                      status: MerchantPaymentMethodStatus;
                    }
                  | {
                      __typename: "WaitingForInformationMerchantPaymentMethodStatusInfo";
                      status: MerchantPaymentMethodStatus;
                      verificationRequirements: Array<
                        | {
                            __typename: "AdditionalInformationRequirements";
                            additionalInformation: Array<AdditionalInformationType>;
                          }
                        | {
                            __typename: "MerchantRequirements";
                            fields: Array<MerchantRequirementType>;
                          }
                        | {
                            __typename: "OtherAdditionalInformationRequirements";
                            otherAdditionalInformation: Array<string>;
                          }
                        | {
                            __typename: "SupportingDocumentRequirements";
                            supportingDocumentPurposes: Array<SupportingDocumentPurposeEnum>;
                          }
                      >;
                    };
              }
            | {
                __typename: "InternalDirectDebitB2BMerchantPaymentMethod";
                id: string;
                type: MerchantPaymentMethodType;
                methodId: string;
                updatedAt: string;
                version: number;
                rollingReserve?: {
                  __typename: "RollingReserve";
                  percentage: number;
                  rollingDays: number;
                } | null;
                statusInfo:
                  | {
                      __typename: "DisabledMerchantPaymentMethodStatusInfo";
                      status: MerchantPaymentMethodStatus;
                    }
                  | {
                      __typename: "EnabledMerchantPaymentMethodStatusInfo";
                      status: MerchantPaymentMethodStatus;
                    }
                  | {
                      __typename: "PendingMerchantPaymentMethodStatusInfo";
                      status: MerchantPaymentMethodStatus;
                    }
                  | {
                      __typename: "RejectedMerchantPaymentMethodStatusInfo";
                      status: MerchantPaymentMethodStatus;
                    }
                  | {
                      __typename: "SuspendedMerchantPaymentMethodStatusInfo";
                      status: MerchantPaymentMethodStatus;
                    }
                  | {
                      __typename: "WaitingForInformationMerchantPaymentMethodStatusInfo";
                      status: MerchantPaymentMethodStatus;
                      verificationRequirements: Array<
                        | {
                            __typename: "AdditionalInformationRequirements";
                            additionalInformation: Array<AdditionalInformationType>;
                          }
                        | {
                            __typename: "MerchantRequirements";
                            fields: Array<MerchantRequirementType>;
                          }
                        | {
                            __typename: "OtherAdditionalInformationRequirements";
                            otherAdditionalInformation: Array<string>;
                          }
                        | {
                            __typename: "SupportingDocumentRequirements";
                            supportingDocumentPurposes: Array<SupportingDocumentPurposeEnum>;
                          }
                      >;
                    };
              }
            | {
                __typename: "InternalDirectDebitStandardMerchantPaymentMethod";
                id: string;
                type: MerchantPaymentMethodType;
                methodId: string;
                updatedAt: string;
                version: number;
                rollingReserve?: {
                  __typename: "RollingReserve";
                  percentage: number;
                  rollingDays: number;
                } | null;
                statusInfo:
                  | {
                      __typename: "DisabledMerchantPaymentMethodStatusInfo";
                      status: MerchantPaymentMethodStatus;
                    }
                  | {
                      __typename: "EnabledMerchantPaymentMethodStatusInfo";
                      status: MerchantPaymentMethodStatus;
                    }
                  | {
                      __typename: "PendingMerchantPaymentMethodStatusInfo";
                      status: MerchantPaymentMethodStatus;
                    }
                  | {
                      __typename: "RejectedMerchantPaymentMethodStatusInfo";
                      status: MerchantPaymentMethodStatus;
                    }
                  | {
                      __typename: "SuspendedMerchantPaymentMethodStatusInfo";
                      status: MerchantPaymentMethodStatus;
                    }
                  | {
                      __typename: "WaitingForInformationMerchantPaymentMethodStatusInfo";
                      status: MerchantPaymentMethodStatus;
                      verificationRequirements: Array<
                        | {
                            __typename: "AdditionalInformationRequirements";
                            additionalInformation: Array<AdditionalInformationType>;
                          }
                        | {
                            __typename: "MerchantRequirements";
                            fields: Array<MerchantRequirementType>;
                          }
                        | {
                            __typename: "OtherAdditionalInformationRequirements";
                            otherAdditionalInformation: Array<string>;
                          }
                        | {
                            __typename: "SupportingDocumentRequirements";
                            supportingDocumentPurposes: Array<SupportingDocumentPurposeEnum>;
                          }
                      >;
                    };
              }
            | {
                __typename: "SepaDirectDebitB2BMerchantPaymentMethod";
                sepaCreditorIdentifier?: string | null;
                useSwanSepaCreditorIdentifier: boolean;
                id: string;
                type: MerchantPaymentMethodType;
                methodId: string;
                updatedAt: string;
                version: number;
                rollingReserve?: {
                  __typename: "RollingReserve";
                  percentage: number;
                  rollingDays: number;
                } | null;
                statusInfo:
                  | {
                      __typename: "DisabledMerchantPaymentMethodStatusInfo";
                      status: MerchantPaymentMethodStatus;
                    }
                  | {
                      __typename: "EnabledMerchantPaymentMethodStatusInfo";
                      status: MerchantPaymentMethodStatus;
                    }
                  | {
                      __typename: "PendingMerchantPaymentMethodStatusInfo";
                      status: MerchantPaymentMethodStatus;
                    }
                  | {
                      __typename: "RejectedMerchantPaymentMethodStatusInfo";
                      status: MerchantPaymentMethodStatus;
                    }
                  | {
                      __typename: "SuspendedMerchantPaymentMethodStatusInfo";
                      status: MerchantPaymentMethodStatus;
                    }
                  | {
                      __typename: "WaitingForInformationMerchantPaymentMethodStatusInfo";
                      status: MerchantPaymentMethodStatus;
                      verificationRequirements: Array<
                        | {
                            __typename: "AdditionalInformationRequirements";
                            additionalInformation: Array<AdditionalInformationType>;
                          }
                        | {
                            __typename: "MerchantRequirements";
                            fields: Array<MerchantRequirementType>;
                          }
                        | {
                            __typename: "OtherAdditionalInformationRequirements";
                            otherAdditionalInformation: Array<string>;
                          }
                        | {
                            __typename: "SupportingDocumentRequirements";
                            supportingDocumentPurposes: Array<SupportingDocumentPurposeEnum>;
                          }
                      >;
                    };
              }
            | {
                __typename: "SepaDirectDebitCoreMerchantPaymentMethod";
                sepaCreditorIdentifier?: string | null;
                useSwanSepaCreditorIdentifier: boolean;
                id: string;
                type: MerchantPaymentMethodType;
                methodId: string;
                updatedAt: string;
                version: number;
                rollingReserve?: {
                  __typename: "RollingReserve";
                  percentage: number;
                  rollingDays: number;
                } | null;
                statusInfo:
                  | {
                      __typename: "DisabledMerchantPaymentMethodStatusInfo";
                      status: MerchantPaymentMethodStatus;
                    }
                  | {
                      __typename: "EnabledMerchantPaymentMethodStatusInfo";
                      status: MerchantPaymentMethodStatus;
                    }
                  | {
                      __typename: "PendingMerchantPaymentMethodStatusInfo";
                      status: MerchantPaymentMethodStatus;
                    }
                  | {
                      __typename: "RejectedMerchantPaymentMethodStatusInfo";
                      status: MerchantPaymentMethodStatus;
                    }
                  | {
                      __typename: "SuspendedMerchantPaymentMethodStatusInfo";
                      status: MerchantPaymentMethodStatus;
                    }
                  | {
                      __typename: "WaitingForInformationMerchantPaymentMethodStatusInfo";
                      status: MerchantPaymentMethodStatus;
                      verificationRequirements: Array<
                        | {
                            __typename: "AdditionalInformationRequirements";
                            additionalInformation: Array<AdditionalInformationType>;
                          }
                        | {
                            __typename: "MerchantRequirements";
                            fields: Array<MerchantRequirementType>;
                          }
                        | {
                            __typename: "OtherAdditionalInformationRequirements";
                            otherAdditionalInformation: Array<string>;
                          }
                        | {
                            __typename: "SupportingDocumentRequirements";
                            supportingDocumentPurposes: Array<SupportingDocumentPurposeEnum>;
                          }
                      >;
                    };
              }
          > | null;
          requestMerchantProfileUpdate?: {
            __typename: "RequestMerchantProfileUpdate";
            id: string;
            status: RequestMerchantProfileUpdateStatus;
            merchantName?: string | null;
            merchantWebsiteUrl?: string | null;
            merchantLogoUrl?: string | null;
            productType?: ProductType | null;
            expectedMonthlyMerchantProcessingVolume?: ExpectedMonthlyMerchantProcessingVolume | null;
            expectedAverageBasket?: {
              __typename: "Amount";
              value: string;
              currency: string;
            } | null;
          } | null;
        };
      }
    | { __typename: "ValidationRejection"; message: string }
    | null;
};

export type RequestMerchantPaymentMethodsMutationVariables = Exact<{
  input: RequestMerchantPaymentMethodsInput;
}>;

export type RequestMerchantPaymentMethodsMutation = {
  __typename: "Mutation";
  requestMerchantPaymentMethods?:
    | { __typename: "ForbiddenRejection"; message: string }
    | { __typename: "InternalErrorRejection"; message: string }
    | { __typename: "InvalidPaymentMethodRequestRejection"; message: string }
    | { __typename: "NotFoundRejection"; message: string }
    | {
        __typename: "RequestMerchantPaymentMethodsSuccessPayload";
        merchantProfile?: { __typename: "MerchantProfile"; id: string } | null;
      }
    | {
        __typename: "ValidationRejection";
        message: string;
        fields: Array<{
          __typename: "ValidationFieldError";
          path: Array<string>;
          code: ValidationFieldErrorCode;
        }>;
      }
    | null;
};

export type RequestMerchantPaymentMethodsUpdateMutationVariables = Exact<{
  input: RequestMerchantPaymentMethodsUpdateInput;
}>;

export type RequestMerchantPaymentMethodsUpdateMutation = {
  __typename: "Mutation";
  requestMerchantPaymentMethodsUpdate?:
    | { __typename: "ForbiddenRejection"; message: string }
    | { __typename: "InternalErrorRejection"; message: string }
    | { __typename: "MerchantPaymentMethodSepaDirectDebitInvalidRejection"; message: string }
    | { __typename: "MerchantPaymentMethodWrongStatusRejection"; message: string }
    | { __typename: "NotFoundRejection"; message: string }
    | { __typename: "RequestMerchantPaymentMethodsUpdateSuccessPayload"; paymentMethodId: string }
    | { __typename: "ValidationRejection"; message: string }
    | null;
};

export type RequestMerchantProfileUpdateMutationVariables = Exact<{
  input: RequestMerchantProfileUpdateInput;
}>;

export type RequestMerchantProfileUpdateMutation = {
  __typename: "Mutation";
  requestMerchantProfileUpdate?:
    | { __typename: "AccountNotFoundRejection"; message: string }
    | { __typename: "ForbiddenRejection"; message: string }
    | { __typename: "InternalErrorRejection"; message: string }
    | {
        __typename: "RequestMerchantProfileUpdateSuccessPayload";
        merchantProfile: { __typename: "MerchantProfile"; id: string };
      }
    | { __typename: "ValidationRejection"; message: string }
    | null;
};

export type FnciInfoFragment = {
  __typename: "FnciInfo";
  colorCode: FnciColorCode;
  cpt1: number;
  cpt2: number;
  cpt3: number;
  holderEstablishment: string;
};

export type InitiateCheckMerchantPaymentMutationVariables = Exact<{
  input: InitiateCheckMerchantPaymentInput;
}>;

export type InitiateCheckMerchantPaymentMutation = {
  __typename: "Mutation";
  initiateCheckMerchantPayment?:
    | {
        __typename: "CheckRejection";
        message: string;
        fnciInfo: {
          __typename: "FnciInfo";
          colorCode: FnciColorCode;
          cpt1: number;
          cpt2: number;
          cpt3: number;
          holderEstablishment: string;
        };
      }
    | { __typename: "DuplicateCheckRejection"; message: string }
    | { __typename: "ForbiddenRejection"; message: string }
    | {
        __typename: "InitiateCheckMerchantPaymentSuccessPayload";
        fnciInfo: {
          __typename: "FnciInfo";
          colorCode: FnciColorCode;
          cpt1: number;
          cpt2: number;
          cpt3: number;
          holderEstablishment: string;
        };
      }
    | { __typename: "InternalErrorRejection"; message: string }
    | { __typename: "NotFoundRejection"; message: string }
    | {
        __typename: "ValidationRejection";
        message: string;
        fields: Array<{ __typename: "ValidationFieldError"; path: Array<string> }>;
      }
    | null;
};

export type CloseAccountMutationVariables = Exact<{
  input: CloseAccountInput;
}>;

export type CloseAccountMutation = {
  __typename: "Mutation";
  closeAccount:
    | { __typename: "AccountNotFoundRejection"; message: string }
    | { __typename: "BadAccountStatusRejection"; message: string }
    | {
        __typename: "CloseAccountSuccessPayload";
        consent: { __typename: "Consent"; id: string; consentUrl: string };
      }
    | { __typename: "ForbiddenRejection"; message: string }
    | { __typename: "InternalErrorRejection"; message: string }
    | { __typename: "ValidationRejection"; message: string };
};

export type AddReceivedSepaDirectDebitB2bMandateMutationVariables = Exact<{
  input: AddReceivedSepaDirectDebitB2bMandateInput;
}>;

export type AddReceivedSepaDirectDebitB2bMandateMutation = {
  __typename: "Mutation";
  addReceivedSepaDirectDebitB2bMandate:
    | { __typename: "AccountHolderTypeIndividualRejection"; message: string }
    | { __typename: "AccountNotFoundRejection"; message: string }
    | {
        __typename: "AddReceivedSepaDirectDebitB2bMandateSuccessPayload";
        receivedDirectDebitMandate:
          | {
              __typename: "InternalReceivedDirectDebitMandate";
              id: string;
              statusInfo:
                | { __typename: "ReceivedDirectDebitMandateStatusInfoCanceled" }
                | { __typename: "ReceivedDirectDebitMandateStatusInfoConsentInitiationPending" }
                | {
                    __typename: "ReceivedDirectDebitMandateStatusInfoConsentPending";
                    consent: { __typename: "Consent"; id: string; consentUrl: string };
                  }
                | { __typename: "ReceivedDirectDebitMandateStatusInfoEnabled" }
                | { __typename: "ReceivedDirectDebitMandateStatusInfoSuspended" };
            }
          | {
              __typename: "SEPAReceivedDirectDebitMandate";
              id: string;
              statusInfo:
                | { __typename: "ReceivedDirectDebitMandateStatusInfoCanceled" }
                | { __typename: "ReceivedDirectDebitMandateStatusInfoConsentInitiationPending" }
                | {
                    __typename: "ReceivedDirectDebitMandateStatusInfoConsentPending";
                    consent: { __typename: "Consent"; id: string; consentUrl: string };
                  }
                | { __typename: "ReceivedDirectDebitMandateStatusInfoEnabled" }
                | { __typename: "ReceivedDirectDebitMandateStatusInfoSuspended" };
            };
      }
    | { __typename: "ForbiddenRejection"; message: string }
    | {
        __typename: "ValidationRejection";
        message: string;
        fields: Array<{
          __typename: "ValidationFieldError";
          code: ValidationFieldErrorCode;
          path: Array<string>;
        }>;
      };
};

export type VerifyBeneficiarySuccessPayloadFragment = {
  __typename: "VerifyBeneficiarySuccessPayload";
  expiresAt: string;
  beneficiaryVerificationToken: string;
  verifyBeneficiaryResult:
    | {
        __typename: "VerifyBeneficiaryCloseMatch";
        nameSuggestion: string;
        status: VerifyBeneficiaryStatus;
      }
    | { __typename: "VerifyBeneficiaryMatch"; status: VerifyBeneficiaryStatus }
    | { __typename: "VerifyBeneficiaryNoMatch"; status: VerifyBeneficiaryStatus }
    | { __typename: "VerifyBeneficiaryNotPossible"; status: VerifyBeneficiaryStatus };
};

export type VerifyBeneficiaryMutationVariables = Exact<{
  input: VerifyBeneficiaryInput;
}>;

export type VerifyBeneficiaryMutation = {
  __typename: "Mutation";
  verifyBeneficiary:
    | { __typename: "AccountNotFoundRejection"; message: string }
    | { __typename: "ForbiddenRejection"; message: string }
    | { __typename: "InternalErrorRejection"; message: string }
    | { __typename: "TrustedBeneficiaryNotFoundRejection"; message: string }
    | { __typename: "ValidationRejection"; message: string }
    | {
        __typename: "VerifyBeneficiarySuccessPayload";
        expiresAt: string;
        beneficiaryVerificationToken: string;
        verifyBeneficiaryResult:
          | {
              __typename: "VerifyBeneficiaryCloseMatch";
              nameSuggestion: string;
              status: VerifyBeneficiaryStatus;
            }
          | { __typename: "VerifyBeneficiaryMatch"; status: VerifyBeneficiaryStatus }
          | { __typename: "VerifyBeneficiaryNoMatch"; status: VerifyBeneficiaryStatus }
          | { __typename: "VerifyBeneficiaryNotPossible"; status: VerifyBeneficiaryStatus };
      };
};

export type SendAccountMembershipInviteNotificationMutationVariables = Exact<{
  input: SendAccountMembershipInviteNotificationInput;
}>;

export type SendAccountMembershipInviteNotificationMutation = {
  __typename: "Mutation";
  sendAccountMembershipInviteNotification:
    | { __typename: "AccountMembershipNotFoundRejection"; message: string }
    | { __typename: "AccountMembershipStatusNotEligibleRejection"; message: string }
    | { __typename: "ForbiddenRejection"; message: string }
    | { __typename: "MaximumDailyInvitationsReachedRejection"; message: string }
    | {
        __typename: "SendAccountMembershipInviteNotificationSuccessPayload";
        notificationRequestId: string;
      }
    | { __typename: "UserNotAllowedToManageAccountMembershipRejection"; message: string }
    | { __typename: "UserNotAllowedToSendAccountMembershipInvitationRejection"; message: string }
    | { __typename: "ValidationRejection"; message: string };
};

export type SupportingDocumentRenewalFragment = {
  __typename: "SupportingDocumentCollection";
  id: string;
  type: SupportingDocumentCollectionType;
  createdAt: string;
  updatedAt: string;
  supportingDocuments: Array<{
    __typename: "SupportingDocument";
    id: string;
    supportingDocumentPurpose: SupportingDocumentPurposeEnum;
    statusInfo:
      | { __typename: "SupportingDocumentNotUploadedStatusInfo"; status: SupportingDocumentStatus }
      | {
          __typename: "SupportingDocumentRefusedStatusInfo";
          filename: string;
          reason: string;
          reasonCode: SupportingDocumentReasonCode;
          status: SupportingDocumentStatus;
        }
      | {
          __typename: "SupportingDocumentUploadedStatusInfo";
          filename: string;
          status: SupportingDocumentStatus;
        }
      | { __typename: "SupportingDocumentValidatedStatusInfo"; status: SupportingDocumentStatus }
      | {
          __typename: "SupportingDocumentWaitingForUploadStatusInfo";
          status: SupportingDocumentStatus;
        };
  }>;
  requiredSupportingDocumentPurposes: Array<{
    __typename: "SupportingDocumentPurpose";
    name: SupportingDocumentPurposeEnum;
    label: string;
    acceptableSupportingDocumentTypes: Array<SupportingDocumentType>;
    description: string;
  }>;
  statusInfo:
    | {
        __typename: "SupportingDocumentCollectionApprovedStatusInfo";
        status: SupportingDocumentCollectionStatus;
      }
    | {
        __typename: "SupportingDocumentCollectionCanceledStatusInfo";
        status: SupportingDocumentCollectionStatus;
      }
    | {
        __typename: "SupportingDocumentCollectionPendingReviewStatusInfo";
        status: SupportingDocumentCollectionStatus;
      }
    | {
        __typename: "SupportingDocumentCollectionRejectedStatusInfo";
        status: SupportingDocumentCollectionStatus;
      }
    | {
        __typename: "SupportingDocumentCollectionWaitingForDocumentStatusInfo";
        status: SupportingDocumentCollectionStatus;
      };
};

export type VerificationRenewalUboFragment = {
  __typename: "VerificationRenewalUltimateBeneficialOwner";
  taxIdentificationNumber?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  sex?: Sex | null;
  qualificationType?: UltimateBeneficialOwnerQualificationType | null;
  address?: {
    __typename: "AddressInfo";
    addressLine1?: string | null;
    addressLine2?: string | null;
    city?: string | null;
    country?: string | null;
    postalCode?: string | null;
    state?: string | null;
  } | null;
  ownership?: {
    __typename: "UltimateBeneficialOwnerOwnership";
    totalPercentage?: number | null;
    type: UltimateBeneficialOwnerOwnershipType;
  } | null;
  birthInfo?: {
    __typename: "BirthInfo";
    city?: string | null;
    country?: string | null;
    birthDate?: string | null;
    postalCode?: string | null;
  } | null;
};

export type CompanyRenewalInfoFragment = {
  __typename: "CompanyVerificationRenewalInfo";
  type: AccountHolderType;
  additionalDetails?: string | null;
  company: {
    __typename: "CompanyVerificationRenewalCompanyInfo";
    name: string;
    businessActivityDescription: string;
    monthlyPaymentVolume: MonthlyPaymentVolume;
    residencyAddress: {
      __typename: "Address";
      addressLine1?: string | null;
      addressLine2?: string | null;
      city?: string | null;
      postalCode?: string | null;
      country?: string | null;
    };
    ultimateBeneficialOwners: Array<{
      __typename: "VerificationRenewalUltimateBeneficialOwner";
      taxIdentificationNumber?: string | null;
      firstName?: string | null;
      lastName?: string | null;
      sex?: Sex | null;
      qualificationType?: UltimateBeneficialOwnerQualificationType | null;
      address?: {
        __typename: "AddressInfo";
        addressLine1?: string | null;
        addressLine2?: string | null;
        city?: string | null;
        country?: string | null;
        postalCode?: string | null;
        state?: string | null;
      } | null;
      ownership?: {
        __typename: "UltimateBeneficialOwnerOwnership";
        totalPercentage?: number | null;
        type: UltimateBeneficialOwnerOwnershipType;
      } | null;
      birthInfo?: {
        __typename: "BirthInfo";
        city?: string | null;
        country?: string | null;
        birthDate?: string | null;
        postalCode?: string | null;
      } | null;
    }>;
  };
  accountAdmin: {
    __typename: "CompanyVerificationRenewalAccountAdmin";
    firstName: string;
    lastName: string;
    typeOfRepresentation?: TypeOfRepresentation | null;
    email: string;
    birthInfo: {
      __typename: "BirthInfo";
      city?: string | null;
      country?: string | null;
      birthDate?: string | null;
      postalCode?: string | null;
    };
  };
};

export type IndividualRenewalInfoFragment = {
  __typename: "IndividualVerificationRenewalInfo";
  type: AccountHolderType;
  additionalDetails?: string | null;
  accountAdmin: {
    __typename: "IndividualVerificationRenewalAccountAdmin";
    firstName: string;
    lastName: string;
    employmentStatus: EmploymentStatus;
    monthlyIncome: MonthlyIncome;
    residencyAddress: {
      __typename: "Address";
      addressLine1?: string | null;
      addressLine2?: string | null;
      city?: string | null;
      postalCode?: string | null;
      state?: string | null;
      country?: string | null;
    };
  };
};

export type GetVerificationRenewalQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type GetVerificationRenewalQuery = {
  __typename: "Query";
  projectInfo: {
    __typename: "ProjectInfo";
    id: string;
    accentColor?: string | null;
    name: string;
    logoUri?: string | null;
  };
  verificationRenewal?:
    | {
        __typename: "CompletedVerificationRenewal";
        id: string;
        info:
          | {
              __typename: "CompanyVerificationRenewalInfo";
              type: AccountHolderType;
              additionalDetails?: string | null;
              company: {
                __typename: "CompanyVerificationRenewalCompanyInfo";
                name: string;
                businessActivityDescription: string;
                monthlyPaymentVolume: MonthlyPaymentVolume;
                residencyAddress: {
                  __typename: "Address";
                  addressLine1?: string | null;
                  addressLine2?: string | null;
                  city?: string | null;
                  postalCode?: string | null;
                  country?: string | null;
                };
                ultimateBeneficialOwners: Array<{
                  __typename: "VerificationRenewalUltimateBeneficialOwner";
                  taxIdentificationNumber?: string | null;
                  firstName?: string | null;
                  lastName?: string | null;
                  sex?: Sex | null;
                  qualificationType?: UltimateBeneficialOwnerQualificationType | null;
                  address?: {
                    __typename: "AddressInfo";
                    addressLine1?: string | null;
                    addressLine2?: string | null;
                    city?: string | null;
                    country?: string | null;
                    postalCode?: string | null;
                    state?: string | null;
                  } | null;
                  ownership?: {
                    __typename: "UltimateBeneficialOwnerOwnership";
                    totalPercentage?: number | null;
                    type: UltimateBeneficialOwnerOwnershipType;
                  } | null;
                  birthInfo?: {
                    __typename: "BirthInfo";
                    city?: string | null;
                    country?: string | null;
                    birthDate?: string | null;
                    postalCode?: string | null;
                  } | null;
                }>;
              };
              accountAdmin: {
                __typename: "CompanyVerificationRenewalAccountAdmin";
                firstName: string;
                lastName: string;
                typeOfRepresentation?: TypeOfRepresentation | null;
                email: string;
                birthInfo: {
                  __typename: "BirthInfo";
                  city?: string | null;
                  country?: string | null;
                  birthDate?: string | null;
                  postalCode?: string | null;
                };
              };
            }
          | {
              __typename: "IndividualVerificationRenewalInfo";
              type: AccountHolderType;
              additionalDetails?: string | null;
              accountAdmin: {
                __typename: "IndividualVerificationRenewalAccountAdmin";
                firstName: string;
                lastName: string;
                employmentStatus: EmploymentStatus;
                monthlyIncome: MonthlyIncome;
                residencyAddress: {
                  __typename: "Address";
                  addressLine1?: string | null;
                  addressLine2?: string | null;
                  city?: string | null;
                  postalCode?: string | null;
                  state?: string | null;
                  country?: string | null;
                };
              };
            };
      }
    | {
        __typename: "PendingVerificationRenewal";
        id: string;
        info:
          | {
              __typename: "CompanyVerificationRenewalInfo";
              type: AccountHolderType;
              additionalDetails?: string | null;
              company: {
                __typename: "CompanyVerificationRenewalCompanyInfo";
                name: string;
                businessActivityDescription: string;
                monthlyPaymentVolume: MonthlyPaymentVolume;
                residencyAddress: {
                  __typename: "Address";
                  addressLine1?: string | null;
                  addressLine2?: string | null;
                  city?: string | null;
                  postalCode?: string | null;
                  country?: string | null;
                };
                ultimateBeneficialOwners: Array<{
                  __typename: "VerificationRenewalUltimateBeneficialOwner";
                  taxIdentificationNumber?: string | null;
                  firstName?: string | null;
                  lastName?: string | null;
                  sex?: Sex | null;
                  qualificationType?: UltimateBeneficialOwnerQualificationType | null;
                  address?: {
                    __typename: "AddressInfo";
                    addressLine1?: string | null;
                    addressLine2?: string | null;
                    city?: string | null;
                    country?: string | null;
                    postalCode?: string | null;
                    state?: string | null;
                  } | null;
                  ownership?: {
                    __typename: "UltimateBeneficialOwnerOwnership";
                    totalPercentage?: number | null;
                    type: UltimateBeneficialOwnerOwnershipType;
                  } | null;
                  birthInfo?: {
                    __typename: "BirthInfo";
                    city?: string | null;
                    country?: string | null;
                    birthDate?: string | null;
                    postalCode?: string | null;
                  } | null;
                }>;
              };
              accountAdmin: {
                __typename: "CompanyVerificationRenewalAccountAdmin";
                firstName: string;
                lastName: string;
                typeOfRepresentation?: TypeOfRepresentation | null;
                email: string;
                birthInfo: {
                  __typename: "BirthInfo";
                  city?: string | null;
                  country?: string | null;
                  birthDate?: string | null;
                  postalCode?: string | null;
                };
              };
            }
          | {
              __typename: "IndividualVerificationRenewalInfo";
              type: AccountHolderType;
              additionalDetails?: string | null;
              accountAdmin: {
                __typename: "IndividualVerificationRenewalAccountAdmin";
                firstName: string;
                lastName: string;
                employmentStatus: EmploymentStatus;
                monthlyIncome: MonthlyIncome;
                residencyAddress: {
                  __typename: "Address";
                  addressLine1?: string | null;
                  addressLine2?: string | null;
                  city?: string | null;
                  postalCode?: string | null;
                  state?: string | null;
                  country?: string | null;
                };
              };
            };
      }
    | {
        __typename: "RefusedVerificationRenewal";
        id: string;
        info:
          | {
              __typename: "CompanyVerificationRenewalInfo";
              type: AccountHolderType;
              additionalDetails?: string | null;
              company: {
                __typename: "CompanyVerificationRenewalCompanyInfo";
                name: string;
                businessActivityDescription: string;
                monthlyPaymentVolume: MonthlyPaymentVolume;
                residencyAddress: {
                  __typename: "Address";
                  addressLine1?: string | null;
                  addressLine2?: string | null;
                  city?: string | null;
                  postalCode?: string | null;
                  country?: string | null;
                };
                ultimateBeneficialOwners: Array<{
                  __typename: "VerificationRenewalUltimateBeneficialOwner";
                  taxIdentificationNumber?: string | null;
                  firstName?: string | null;
                  lastName?: string | null;
                  sex?: Sex | null;
                  qualificationType?: UltimateBeneficialOwnerQualificationType | null;
                  address?: {
                    __typename: "AddressInfo";
                    addressLine1?: string | null;
                    addressLine2?: string | null;
                    city?: string | null;
                    country?: string | null;
                    postalCode?: string | null;
                    state?: string | null;
                  } | null;
                  ownership?: {
                    __typename: "UltimateBeneficialOwnerOwnership";
                    totalPercentage?: number | null;
                    type: UltimateBeneficialOwnerOwnershipType;
                  } | null;
                  birthInfo?: {
                    __typename: "BirthInfo";
                    city?: string | null;
                    country?: string | null;
                    birthDate?: string | null;
                    postalCode?: string | null;
                  } | null;
                }>;
              };
              accountAdmin: {
                __typename: "CompanyVerificationRenewalAccountAdmin";
                firstName: string;
                lastName: string;
                typeOfRepresentation?: TypeOfRepresentation | null;
                email: string;
                birthInfo: {
                  __typename: "BirthInfo";
                  city?: string | null;
                  country?: string | null;
                  birthDate?: string | null;
                  postalCode?: string | null;
                };
              };
            }
          | {
              __typename: "IndividualVerificationRenewalInfo";
              type: AccountHolderType;
              additionalDetails?: string | null;
              accountAdmin: {
                __typename: "IndividualVerificationRenewalAccountAdmin";
                firstName: string;
                lastName: string;
                employmentStatus: EmploymentStatus;
                monthlyIncome: MonthlyIncome;
                residencyAddress: {
                  __typename: "Address";
                  addressLine1?: string | null;
                  addressLine2?: string | null;
                  city?: string | null;
                  postalCode?: string | null;
                  state?: string | null;
                  country?: string | null;
                };
              };
            };
      }
    | {
        __typename: "SuspendedVerificationRenewal";
        id: string;
        info:
          | {
              __typename: "CompanyVerificationRenewalInfo";
              type: AccountHolderType;
              additionalDetails?: string | null;
              company: {
                __typename: "CompanyVerificationRenewalCompanyInfo";
                name: string;
                businessActivityDescription: string;
                monthlyPaymentVolume: MonthlyPaymentVolume;
                residencyAddress: {
                  __typename: "Address";
                  addressLine1?: string | null;
                  addressLine2?: string | null;
                  city?: string | null;
                  postalCode?: string | null;
                  country?: string | null;
                };
                ultimateBeneficialOwners: Array<{
                  __typename: "VerificationRenewalUltimateBeneficialOwner";
                  taxIdentificationNumber?: string | null;
                  firstName?: string | null;
                  lastName?: string | null;
                  sex?: Sex | null;
                  qualificationType?: UltimateBeneficialOwnerQualificationType | null;
                  address?: {
                    __typename: "AddressInfo";
                    addressLine1?: string | null;
                    addressLine2?: string | null;
                    city?: string | null;
                    country?: string | null;
                    postalCode?: string | null;
                    state?: string | null;
                  } | null;
                  ownership?: {
                    __typename: "UltimateBeneficialOwnerOwnership";
                    totalPercentage?: number | null;
                    type: UltimateBeneficialOwnerOwnershipType;
                  } | null;
                  birthInfo?: {
                    __typename: "BirthInfo";
                    city?: string | null;
                    country?: string | null;
                    birthDate?: string | null;
                    postalCode?: string | null;
                  } | null;
                }>;
              };
              accountAdmin: {
                __typename: "CompanyVerificationRenewalAccountAdmin";
                firstName: string;
                lastName: string;
                typeOfRepresentation?: TypeOfRepresentation | null;
                email: string;
                birthInfo: {
                  __typename: "BirthInfo";
                  city?: string | null;
                  country?: string | null;
                  birthDate?: string | null;
                  postalCode?: string | null;
                };
              };
            }
          | {
              __typename: "IndividualVerificationRenewalInfo";
              type: AccountHolderType;
              additionalDetails?: string | null;
              accountAdmin: {
                __typename: "IndividualVerificationRenewalAccountAdmin";
                firstName: string;
                lastName: string;
                employmentStatus: EmploymentStatus;
                monthlyIncome: MonthlyIncome;
                residencyAddress: {
                  __typename: "Address";
                  addressLine1?: string | null;
                  addressLine2?: string | null;
                  city?: string | null;
                  postalCode?: string | null;
                  state?: string | null;
                  country?: string | null;
                };
              };
            };
      }
    | {
        __typename: "WaitingForInformationVerificationRenewal";
        id: string;
        accountCountries?: Array<AccountCountry> | null;
        verificationRequirements: Array<VerificationRenewalRequirement>;
        supportingDocumentCollection?: {
          __typename: "SupportingDocumentCollection";
          id: string;
          type: SupportingDocumentCollectionType;
          createdAt: string;
          updatedAt: string;
          supportingDocuments: Array<{
            __typename: "SupportingDocument";
            id: string;
            supportingDocumentPurpose: SupportingDocumentPurposeEnum;
            statusInfo:
              | {
                  __typename: "SupportingDocumentNotUploadedStatusInfo";
                  status: SupportingDocumentStatus;
                }
              | {
                  __typename: "SupportingDocumentRefusedStatusInfo";
                  filename: string;
                  reason: string;
                  reasonCode: SupportingDocumentReasonCode;
                  status: SupportingDocumentStatus;
                }
              | {
                  __typename: "SupportingDocumentUploadedStatusInfo";
                  filename: string;
                  status: SupportingDocumentStatus;
                }
              | {
                  __typename: "SupportingDocumentValidatedStatusInfo";
                  status: SupportingDocumentStatus;
                }
              | {
                  __typename: "SupportingDocumentWaitingForUploadStatusInfo";
                  status: SupportingDocumentStatus;
                };
          }>;
          requiredSupportingDocumentPurposes: Array<{
            __typename: "SupportingDocumentPurpose";
            name: SupportingDocumentPurposeEnum;
            label: string;
            acceptableSupportingDocumentTypes: Array<SupportingDocumentType>;
            description: string;
          }>;
          statusInfo:
            | {
                __typename: "SupportingDocumentCollectionApprovedStatusInfo";
                status: SupportingDocumentCollectionStatus;
              }
            | {
                __typename: "SupportingDocumentCollectionCanceledStatusInfo";
                status: SupportingDocumentCollectionStatus;
              }
            | {
                __typename: "SupportingDocumentCollectionPendingReviewStatusInfo";
                status: SupportingDocumentCollectionStatus;
              }
            | {
                __typename: "SupportingDocumentCollectionRejectedStatusInfo";
                status: SupportingDocumentCollectionStatus;
              }
            | {
                __typename: "SupportingDocumentCollectionWaitingForDocumentStatusInfo";
                status: SupportingDocumentCollectionStatus;
              };
        } | null;
        info:
          | {
              __typename: "CompanyVerificationRenewalInfo";
              type: AccountHolderType;
              additionalDetails?: string | null;
              company: {
                __typename: "CompanyVerificationRenewalCompanyInfo";
                name: string;
                businessActivityDescription: string;
                monthlyPaymentVolume: MonthlyPaymentVolume;
                residencyAddress: {
                  __typename: "Address";
                  addressLine1?: string | null;
                  addressLine2?: string | null;
                  city?: string | null;
                  postalCode?: string | null;
                  country?: string | null;
                };
                ultimateBeneficialOwners: Array<{
                  __typename: "VerificationRenewalUltimateBeneficialOwner";
                  taxIdentificationNumber?: string | null;
                  firstName?: string | null;
                  lastName?: string | null;
                  sex?: Sex | null;
                  qualificationType?: UltimateBeneficialOwnerQualificationType | null;
                  address?: {
                    __typename: "AddressInfo";
                    addressLine1?: string | null;
                    addressLine2?: string | null;
                    city?: string | null;
                    country?: string | null;
                    postalCode?: string | null;
                    state?: string | null;
                  } | null;
                  ownership?: {
                    __typename: "UltimateBeneficialOwnerOwnership";
                    totalPercentage?: number | null;
                    type: UltimateBeneficialOwnerOwnershipType;
                  } | null;
                  birthInfo?: {
                    __typename: "BirthInfo";
                    city?: string | null;
                    country?: string | null;
                    birthDate?: string | null;
                    postalCode?: string | null;
                  } | null;
                }>;
              };
              accountAdmin: {
                __typename: "CompanyVerificationRenewalAccountAdmin";
                firstName: string;
                lastName: string;
                typeOfRepresentation?: TypeOfRepresentation | null;
                email: string;
                birthInfo: {
                  __typename: "BirthInfo";
                  city?: string | null;
                  country?: string | null;
                  birthDate?: string | null;
                  postalCode?: string | null;
                };
              };
            }
          | {
              __typename: "IndividualVerificationRenewalInfo";
              type: AccountHolderType;
              additionalDetails?: string | null;
              accountAdmin: {
                __typename: "IndividualVerificationRenewalAccountAdmin";
                firstName: string;
                lastName: string;
                employmentStatus: EmploymentStatus;
                monthlyIncome: MonthlyIncome;
                residencyAddress: {
                  __typename: "Address";
                  addressLine1?: string | null;
                  addressLine2?: string | null;
                  city?: string | null;
                  postalCode?: string | null;
                  state?: string | null;
                  country?: string | null;
                };
              };
            };
      }
    | null;
};

export type UpdateIndividualVerificationRenewalMutationVariables = Exact<{
  input: UpdateIndividualVerificationRenewalInput;
}>;

export type UpdateIndividualVerificationRenewalMutation = {
  __typename: "Mutation";
  updateIndividualVerificationRenewal:
    | { __typename: "ForbiddenRejection"; message: string }
    | {
        __typename: "UpdateIndividualVerificationRenewalSuccessPayload";
        verificationRenewal:
          | {
              __typename: "CompletedVerificationRenewal";
              id: string;
              info:
                | {
                    __typename: "CompanyVerificationRenewalInfo";
                    type: AccountHolderType;
                    additionalDetails?: string | null;
                    company: {
                      __typename: "CompanyVerificationRenewalCompanyInfo";
                      name: string;
                      businessActivityDescription: string;
                      monthlyPaymentVolume: MonthlyPaymentVolume;
                      residencyAddress: {
                        __typename: "Address";
                        addressLine1?: string | null;
                        addressLine2?: string | null;
                        city?: string | null;
                        postalCode?: string | null;
                        country?: string | null;
                      };
                      ultimateBeneficialOwners: Array<{
                        __typename: "VerificationRenewalUltimateBeneficialOwner";
                        taxIdentificationNumber?: string | null;
                        firstName?: string | null;
                        lastName?: string | null;
                        sex?: Sex | null;
                        qualificationType?: UltimateBeneficialOwnerQualificationType | null;
                        address?: {
                          __typename: "AddressInfo";
                          addressLine1?: string | null;
                          addressLine2?: string | null;
                          city?: string | null;
                          country?: string | null;
                          postalCode?: string | null;
                          state?: string | null;
                        } | null;
                        ownership?: {
                          __typename: "UltimateBeneficialOwnerOwnership";
                          totalPercentage?: number | null;
                          type: UltimateBeneficialOwnerOwnershipType;
                        } | null;
                        birthInfo?: {
                          __typename: "BirthInfo";
                          city?: string | null;
                          country?: string | null;
                          birthDate?: string | null;
                          postalCode?: string | null;
                        } | null;
                      }>;
                    };
                    accountAdmin: {
                      __typename: "CompanyVerificationRenewalAccountAdmin";
                      firstName: string;
                      lastName: string;
                      typeOfRepresentation?: TypeOfRepresentation | null;
                      email: string;
                      birthInfo: {
                        __typename: "BirthInfo";
                        city?: string | null;
                        country?: string | null;
                        birthDate?: string | null;
                        postalCode?: string | null;
                      };
                    };
                  }
                | {
                    __typename: "IndividualVerificationRenewalInfo";
                    type: AccountHolderType;
                    additionalDetails?: string | null;
                    accountAdmin: {
                      __typename: "IndividualVerificationRenewalAccountAdmin";
                      firstName: string;
                      lastName: string;
                      employmentStatus: EmploymentStatus;
                      monthlyIncome: MonthlyIncome;
                      residencyAddress: {
                        __typename: "Address";
                        addressLine1?: string | null;
                        addressLine2?: string | null;
                        city?: string | null;
                        postalCode?: string | null;
                        state?: string | null;
                        country?: string | null;
                      };
                    };
                  };
            }
          | {
              __typename: "PendingVerificationRenewal";
              id: string;
              info:
                | {
                    __typename: "CompanyVerificationRenewalInfo";
                    type: AccountHolderType;
                    additionalDetails?: string | null;
                    company: {
                      __typename: "CompanyVerificationRenewalCompanyInfo";
                      name: string;
                      businessActivityDescription: string;
                      monthlyPaymentVolume: MonthlyPaymentVolume;
                      residencyAddress: {
                        __typename: "Address";
                        addressLine1?: string | null;
                        addressLine2?: string | null;
                        city?: string | null;
                        postalCode?: string | null;
                        country?: string | null;
                      };
                      ultimateBeneficialOwners: Array<{
                        __typename: "VerificationRenewalUltimateBeneficialOwner";
                        taxIdentificationNumber?: string | null;
                        firstName?: string | null;
                        lastName?: string | null;
                        sex?: Sex | null;
                        qualificationType?: UltimateBeneficialOwnerQualificationType | null;
                        address?: {
                          __typename: "AddressInfo";
                          addressLine1?: string | null;
                          addressLine2?: string | null;
                          city?: string | null;
                          country?: string | null;
                          postalCode?: string | null;
                          state?: string | null;
                        } | null;
                        ownership?: {
                          __typename: "UltimateBeneficialOwnerOwnership";
                          totalPercentage?: number | null;
                          type: UltimateBeneficialOwnerOwnershipType;
                        } | null;
                        birthInfo?: {
                          __typename: "BirthInfo";
                          city?: string | null;
                          country?: string | null;
                          birthDate?: string | null;
                          postalCode?: string | null;
                        } | null;
                      }>;
                    };
                    accountAdmin: {
                      __typename: "CompanyVerificationRenewalAccountAdmin";
                      firstName: string;
                      lastName: string;
                      typeOfRepresentation?: TypeOfRepresentation | null;
                      email: string;
                      birthInfo: {
                        __typename: "BirthInfo";
                        city?: string | null;
                        country?: string | null;
                        birthDate?: string | null;
                        postalCode?: string | null;
                      };
                    };
                  }
                | {
                    __typename: "IndividualVerificationRenewalInfo";
                    type: AccountHolderType;
                    additionalDetails?: string | null;
                    accountAdmin: {
                      __typename: "IndividualVerificationRenewalAccountAdmin";
                      firstName: string;
                      lastName: string;
                      employmentStatus: EmploymentStatus;
                      monthlyIncome: MonthlyIncome;
                      residencyAddress: {
                        __typename: "Address";
                        addressLine1?: string | null;
                        addressLine2?: string | null;
                        city?: string | null;
                        postalCode?: string | null;
                        state?: string | null;
                        country?: string | null;
                      };
                    };
                  };
            }
          | {
              __typename: "RefusedVerificationRenewal";
              id: string;
              info:
                | {
                    __typename: "CompanyVerificationRenewalInfo";
                    type: AccountHolderType;
                    additionalDetails?: string | null;
                    company: {
                      __typename: "CompanyVerificationRenewalCompanyInfo";
                      name: string;
                      businessActivityDescription: string;
                      monthlyPaymentVolume: MonthlyPaymentVolume;
                      residencyAddress: {
                        __typename: "Address";
                        addressLine1?: string | null;
                        addressLine2?: string | null;
                        city?: string | null;
                        postalCode?: string | null;
                        country?: string | null;
                      };
                      ultimateBeneficialOwners: Array<{
                        __typename: "VerificationRenewalUltimateBeneficialOwner";
                        taxIdentificationNumber?: string | null;
                        firstName?: string | null;
                        lastName?: string | null;
                        sex?: Sex | null;
                        qualificationType?: UltimateBeneficialOwnerQualificationType | null;
                        address?: {
                          __typename: "AddressInfo";
                          addressLine1?: string | null;
                          addressLine2?: string | null;
                          city?: string | null;
                          country?: string | null;
                          postalCode?: string | null;
                          state?: string | null;
                        } | null;
                        ownership?: {
                          __typename: "UltimateBeneficialOwnerOwnership";
                          totalPercentage?: number | null;
                          type: UltimateBeneficialOwnerOwnershipType;
                        } | null;
                        birthInfo?: {
                          __typename: "BirthInfo";
                          city?: string | null;
                          country?: string | null;
                          birthDate?: string | null;
                          postalCode?: string | null;
                        } | null;
                      }>;
                    };
                    accountAdmin: {
                      __typename: "CompanyVerificationRenewalAccountAdmin";
                      firstName: string;
                      lastName: string;
                      typeOfRepresentation?: TypeOfRepresentation | null;
                      email: string;
                      birthInfo: {
                        __typename: "BirthInfo";
                        city?: string | null;
                        country?: string | null;
                        birthDate?: string | null;
                        postalCode?: string | null;
                      };
                    };
                  }
                | {
                    __typename: "IndividualVerificationRenewalInfo";
                    type: AccountHolderType;
                    additionalDetails?: string | null;
                    accountAdmin: {
                      __typename: "IndividualVerificationRenewalAccountAdmin";
                      firstName: string;
                      lastName: string;
                      employmentStatus: EmploymentStatus;
                      monthlyIncome: MonthlyIncome;
                      residencyAddress: {
                        __typename: "Address";
                        addressLine1?: string | null;
                        addressLine2?: string | null;
                        city?: string | null;
                        postalCode?: string | null;
                        state?: string | null;
                        country?: string | null;
                      };
                    };
                  };
            }
          | {
              __typename: "SuspendedVerificationRenewal";
              id: string;
              info:
                | {
                    __typename: "CompanyVerificationRenewalInfo";
                    type: AccountHolderType;
                    additionalDetails?: string | null;
                    company: {
                      __typename: "CompanyVerificationRenewalCompanyInfo";
                      name: string;
                      businessActivityDescription: string;
                      monthlyPaymentVolume: MonthlyPaymentVolume;
                      residencyAddress: {
                        __typename: "Address";
                        addressLine1?: string | null;
                        addressLine2?: string | null;
                        city?: string | null;
                        postalCode?: string | null;
                        country?: string | null;
                      };
                      ultimateBeneficialOwners: Array<{
                        __typename: "VerificationRenewalUltimateBeneficialOwner";
                        taxIdentificationNumber?: string | null;
                        firstName?: string | null;
                        lastName?: string | null;
                        sex?: Sex | null;
                        qualificationType?: UltimateBeneficialOwnerQualificationType | null;
                        address?: {
                          __typename: "AddressInfo";
                          addressLine1?: string | null;
                          addressLine2?: string | null;
                          city?: string | null;
                          country?: string | null;
                          postalCode?: string | null;
                          state?: string | null;
                        } | null;
                        ownership?: {
                          __typename: "UltimateBeneficialOwnerOwnership";
                          totalPercentage?: number | null;
                          type: UltimateBeneficialOwnerOwnershipType;
                        } | null;
                        birthInfo?: {
                          __typename: "BirthInfo";
                          city?: string | null;
                          country?: string | null;
                          birthDate?: string | null;
                          postalCode?: string | null;
                        } | null;
                      }>;
                    };
                    accountAdmin: {
                      __typename: "CompanyVerificationRenewalAccountAdmin";
                      firstName: string;
                      lastName: string;
                      typeOfRepresentation?: TypeOfRepresentation | null;
                      email: string;
                      birthInfo: {
                        __typename: "BirthInfo";
                        city?: string | null;
                        country?: string | null;
                        birthDate?: string | null;
                        postalCode?: string | null;
                      };
                    };
                  }
                | {
                    __typename: "IndividualVerificationRenewalInfo";
                    type: AccountHolderType;
                    additionalDetails?: string | null;
                    accountAdmin: {
                      __typename: "IndividualVerificationRenewalAccountAdmin";
                      firstName: string;
                      lastName: string;
                      employmentStatus: EmploymentStatus;
                      monthlyIncome: MonthlyIncome;
                      residencyAddress: {
                        __typename: "Address";
                        addressLine1?: string | null;
                        addressLine2?: string | null;
                        city?: string | null;
                        postalCode?: string | null;
                        state?: string | null;
                        country?: string | null;
                      };
                    };
                  };
            }
          | {
              __typename: "WaitingForInformationVerificationRenewal";
              verificationRequirements: Array<VerificationRenewalRequirement>;
              id: string;
              supportingDocumentCollection?: {
                __typename: "SupportingDocumentCollection";
                id: string;
                type: SupportingDocumentCollectionType;
                createdAt: string;
                updatedAt: string;
                supportingDocuments: Array<{
                  __typename: "SupportingDocument";
                  id: string;
                  supportingDocumentPurpose: SupportingDocumentPurposeEnum;
                  statusInfo:
                    | {
                        __typename: "SupportingDocumentNotUploadedStatusInfo";
                        status: SupportingDocumentStatus;
                      }
                    | {
                        __typename: "SupportingDocumentRefusedStatusInfo";
                        filename: string;
                        reason: string;
                        reasonCode: SupportingDocumentReasonCode;
                        status: SupportingDocumentStatus;
                      }
                    | {
                        __typename: "SupportingDocumentUploadedStatusInfo";
                        filename: string;
                        status: SupportingDocumentStatus;
                      }
                    | {
                        __typename: "SupportingDocumentValidatedStatusInfo";
                        status: SupportingDocumentStatus;
                      }
                    | {
                        __typename: "SupportingDocumentWaitingForUploadStatusInfo";
                        status: SupportingDocumentStatus;
                      };
                }>;
                requiredSupportingDocumentPurposes: Array<{
                  __typename: "SupportingDocumentPurpose";
                  name: SupportingDocumentPurposeEnum;
                  label: string;
                  acceptableSupportingDocumentTypes: Array<SupportingDocumentType>;
                  description: string;
                }>;
                statusInfo:
                  | {
                      __typename: "SupportingDocumentCollectionApprovedStatusInfo";
                      status: SupportingDocumentCollectionStatus;
                    }
                  | {
                      __typename: "SupportingDocumentCollectionCanceledStatusInfo";
                      status: SupportingDocumentCollectionStatus;
                    }
                  | {
                      __typename: "SupportingDocumentCollectionPendingReviewStatusInfo";
                      status: SupportingDocumentCollectionStatus;
                    }
                  | {
                      __typename: "SupportingDocumentCollectionRejectedStatusInfo";
                      status: SupportingDocumentCollectionStatus;
                    }
                  | {
                      __typename: "SupportingDocumentCollectionWaitingForDocumentStatusInfo";
                      status: SupportingDocumentCollectionStatus;
                    };
              } | null;
              info:
                | {
                    __typename: "CompanyVerificationRenewalInfo";
                    type: AccountHolderType;
                    additionalDetails?: string | null;
                    company: {
                      __typename: "CompanyVerificationRenewalCompanyInfo";
                      name: string;
                      businessActivityDescription: string;
                      monthlyPaymentVolume: MonthlyPaymentVolume;
                      residencyAddress: {
                        __typename: "Address";
                        addressLine1?: string | null;
                        addressLine2?: string | null;
                        city?: string | null;
                        postalCode?: string | null;
                        country?: string | null;
                      };
                      ultimateBeneficialOwners: Array<{
                        __typename: "VerificationRenewalUltimateBeneficialOwner";
                        taxIdentificationNumber?: string | null;
                        firstName?: string | null;
                        lastName?: string | null;
                        sex?: Sex | null;
                        qualificationType?: UltimateBeneficialOwnerQualificationType | null;
                        address?: {
                          __typename: "AddressInfo";
                          addressLine1?: string | null;
                          addressLine2?: string | null;
                          city?: string | null;
                          country?: string | null;
                          postalCode?: string | null;
                          state?: string | null;
                        } | null;
                        ownership?: {
                          __typename: "UltimateBeneficialOwnerOwnership";
                          totalPercentage?: number | null;
                          type: UltimateBeneficialOwnerOwnershipType;
                        } | null;
                        birthInfo?: {
                          __typename: "BirthInfo";
                          city?: string | null;
                          country?: string | null;
                          birthDate?: string | null;
                          postalCode?: string | null;
                        } | null;
                      }>;
                    };
                    accountAdmin: {
                      __typename: "CompanyVerificationRenewalAccountAdmin";
                      firstName: string;
                      lastName: string;
                      typeOfRepresentation?: TypeOfRepresentation | null;
                      email: string;
                      birthInfo: {
                        __typename: "BirthInfo";
                        city?: string | null;
                        country?: string | null;
                        birthDate?: string | null;
                        postalCode?: string | null;
                      };
                    };
                  }
                | {
                    __typename: "IndividualVerificationRenewalInfo";
                    type: AccountHolderType;
                    additionalDetails?: string | null;
                    accountAdmin: {
                      __typename: "IndividualVerificationRenewalAccountAdmin";
                      firstName: string;
                      lastName: string;
                      employmentStatus: EmploymentStatus;
                      monthlyIncome: MonthlyIncome;
                      residencyAddress: {
                        __typename: "Address";
                        addressLine1?: string | null;
                        addressLine2?: string | null;
                        city?: string | null;
                        postalCode?: string | null;
                        state?: string | null;
                        country?: string | null;
                      };
                    };
                  };
            };
      }
    | {
        __typename: "ValidationRejection";
        message: string;
        fields: Array<{ __typename: "ValidationFieldError"; path: Array<string>; message: string }>;
      }
    | { __typename: "VerificationRenewalNotFoundRejection"; message: string }
    | { __typename: "VerificationRenewalUpdateNotAllowedRejection"; message: string };
};

export type UpdateCompanyVerificationRenewalMutationVariables = Exact<{
  input: UpdateCompanyVerificationRenewalInput;
}>;

export type UpdateCompanyVerificationRenewalMutation = {
  __typename: "Mutation";
  updateCompanyVerificationRenewal:
    | { __typename: "ForbiddenRejection"; message: string }
    | {
        __typename: "UpdateCompanyVerificationRenewalSuccessPayload";
        verificationRenewal:
          | {
              __typename: "CompletedVerificationRenewal";
              id: string;
              info:
                | {
                    __typename: "CompanyVerificationRenewalInfo";
                    type: AccountHolderType;
                    additionalDetails?: string | null;
                    company: {
                      __typename: "CompanyVerificationRenewalCompanyInfo";
                      name: string;
                      businessActivityDescription: string;
                      monthlyPaymentVolume: MonthlyPaymentVolume;
                      residencyAddress: {
                        __typename: "Address";
                        addressLine1?: string | null;
                        addressLine2?: string | null;
                        city?: string | null;
                        postalCode?: string | null;
                        country?: string | null;
                      };
                      ultimateBeneficialOwners: Array<{
                        __typename: "VerificationRenewalUltimateBeneficialOwner";
                        taxIdentificationNumber?: string | null;
                        firstName?: string | null;
                        lastName?: string | null;
                        sex?: Sex | null;
                        qualificationType?: UltimateBeneficialOwnerQualificationType | null;
                        address?: {
                          __typename: "AddressInfo";
                          addressLine1?: string | null;
                          addressLine2?: string | null;
                          city?: string | null;
                          country?: string | null;
                          postalCode?: string | null;
                          state?: string | null;
                        } | null;
                        ownership?: {
                          __typename: "UltimateBeneficialOwnerOwnership";
                          totalPercentage?: number | null;
                          type: UltimateBeneficialOwnerOwnershipType;
                        } | null;
                        birthInfo?: {
                          __typename: "BirthInfo";
                          city?: string | null;
                          country?: string | null;
                          birthDate?: string | null;
                          postalCode?: string | null;
                        } | null;
                      }>;
                    };
                    accountAdmin: {
                      __typename: "CompanyVerificationRenewalAccountAdmin";
                      firstName: string;
                      lastName: string;
                      typeOfRepresentation?: TypeOfRepresentation | null;
                      email: string;
                      birthInfo: {
                        __typename: "BirthInfo";
                        city?: string | null;
                        country?: string | null;
                        birthDate?: string | null;
                        postalCode?: string | null;
                      };
                    };
                  }
                | {
                    __typename: "IndividualVerificationRenewalInfo";
                    type: AccountHolderType;
                    additionalDetails?: string | null;
                    accountAdmin: {
                      __typename: "IndividualVerificationRenewalAccountAdmin";
                      firstName: string;
                      lastName: string;
                      employmentStatus: EmploymentStatus;
                      monthlyIncome: MonthlyIncome;
                      residencyAddress: {
                        __typename: "Address";
                        addressLine1?: string | null;
                        addressLine2?: string | null;
                        city?: string | null;
                        postalCode?: string | null;
                        state?: string | null;
                        country?: string | null;
                      };
                    };
                  };
            }
          | {
              __typename: "PendingVerificationRenewal";
              id: string;
              info:
                | {
                    __typename: "CompanyVerificationRenewalInfo";
                    type: AccountHolderType;
                    additionalDetails?: string | null;
                    company: {
                      __typename: "CompanyVerificationRenewalCompanyInfo";
                      name: string;
                      businessActivityDescription: string;
                      monthlyPaymentVolume: MonthlyPaymentVolume;
                      residencyAddress: {
                        __typename: "Address";
                        addressLine1?: string | null;
                        addressLine2?: string | null;
                        city?: string | null;
                        postalCode?: string | null;
                        country?: string | null;
                      };
                      ultimateBeneficialOwners: Array<{
                        __typename: "VerificationRenewalUltimateBeneficialOwner";
                        taxIdentificationNumber?: string | null;
                        firstName?: string | null;
                        lastName?: string | null;
                        sex?: Sex | null;
                        qualificationType?: UltimateBeneficialOwnerQualificationType | null;
                        address?: {
                          __typename: "AddressInfo";
                          addressLine1?: string | null;
                          addressLine2?: string | null;
                          city?: string | null;
                          country?: string | null;
                          postalCode?: string | null;
                          state?: string | null;
                        } | null;
                        ownership?: {
                          __typename: "UltimateBeneficialOwnerOwnership";
                          totalPercentage?: number | null;
                          type: UltimateBeneficialOwnerOwnershipType;
                        } | null;
                        birthInfo?: {
                          __typename: "BirthInfo";
                          city?: string | null;
                          country?: string | null;
                          birthDate?: string | null;
                          postalCode?: string | null;
                        } | null;
                      }>;
                    };
                    accountAdmin: {
                      __typename: "CompanyVerificationRenewalAccountAdmin";
                      firstName: string;
                      lastName: string;
                      typeOfRepresentation?: TypeOfRepresentation | null;
                      email: string;
                      birthInfo: {
                        __typename: "BirthInfo";
                        city?: string | null;
                        country?: string | null;
                        birthDate?: string | null;
                        postalCode?: string | null;
                      };
                    };
                  }
                | {
                    __typename: "IndividualVerificationRenewalInfo";
                    type: AccountHolderType;
                    additionalDetails?: string | null;
                    accountAdmin: {
                      __typename: "IndividualVerificationRenewalAccountAdmin";
                      firstName: string;
                      lastName: string;
                      employmentStatus: EmploymentStatus;
                      monthlyIncome: MonthlyIncome;
                      residencyAddress: {
                        __typename: "Address";
                        addressLine1?: string | null;
                        addressLine2?: string | null;
                        city?: string | null;
                        postalCode?: string | null;
                        state?: string | null;
                        country?: string | null;
                      };
                    };
                  };
            }
          | {
              __typename: "RefusedVerificationRenewal";
              id: string;
              info:
                | {
                    __typename: "CompanyVerificationRenewalInfo";
                    type: AccountHolderType;
                    additionalDetails?: string | null;
                    company: {
                      __typename: "CompanyVerificationRenewalCompanyInfo";
                      name: string;
                      businessActivityDescription: string;
                      monthlyPaymentVolume: MonthlyPaymentVolume;
                      residencyAddress: {
                        __typename: "Address";
                        addressLine1?: string | null;
                        addressLine2?: string | null;
                        city?: string | null;
                        postalCode?: string | null;
                        country?: string | null;
                      };
                      ultimateBeneficialOwners: Array<{
                        __typename: "VerificationRenewalUltimateBeneficialOwner";
                        taxIdentificationNumber?: string | null;
                        firstName?: string | null;
                        lastName?: string | null;
                        sex?: Sex | null;
                        qualificationType?: UltimateBeneficialOwnerQualificationType | null;
                        address?: {
                          __typename: "AddressInfo";
                          addressLine1?: string | null;
                          addressLine2?: string | null;
                          city?: string | null;
                          country?: string | null;
                          postalCode?: string | null;
                          state?: string | null;
                        } | null;
                        ownership?: {
                          __typename: "UltimateBeneficialOwnerOwnership";
                          totalPercentage?: number | null;
                          type: UltimateBeneficialOwnerOwnershipType;
                        } | null;
                        birthInfo?: {
                          __typename: "BirthInfo";
                          city?: string | null;
                          country?: string | null;
                          birthDate?: string | null;
                          postalCode?: string | null;
                        } | null;
                      }>;
                    };
                    accountAdmin: {
                      __typename: "CompanyVerificationRenewalAccountAdmin";
                      firstName: string;
                      lastName: string;
                      typeOfRepresentation?: TypeOfRepresentation | null;
                      email: string;
                      birthInfo: {
                        __typename: "BirthInfo";
                        city?: string | null;
                        country?: string | null;
                        birthDate?: string | null;
                        postalCode?: string | null;
                      };
                    };
                  }
                | {
                    __typename: "IndividualVerificationRenewalInfo";
                    type: AccountHolderType;
                    additionalDetails?: string | null;
                    accountAdmin: {
                      __typename: "IndividualVerificationRenewalAccountAdmin";
                      firstName: string;
                      lastName: string;
                      employmentStatus: EmploymentStatus;
                      monthlyIncome: MonthlyIncome;
                      residencyAddress: {
                        __typename: "Address";
                        addressLine1?: string | null;
                        addressLine2?: string | null;
                        city?: string | null;
                        postalCode?: string | null;
                        state?: string | null;
                        country?: string | null;
                      };
                    };
                  };
            }
          | {
              __typename: "SuspendedVerificationRenewal";
              id: string;
              info:
                | {
                    __typename: "CompanyVerificationRenewalInfo";
                    type: AccountHolderType;
                    additionalDetails?: string | null;
                    company: {
                      __typename: "CompanyVerificationRenewalCompanyInfo";
                      name: string;
                      businessActivityDescription: string;
                      monthlyPaymentVolume: MonthlyPaymentVolume;
                      residencyAddress: {
                        __typename: "Address";
                        addressLine1?: string | null;
                        addressLine2?: string | null;
                        city?: string | null;
                        postalCode?: string | null;
                        country?: string | null;
                      };
                      ultimateBeneficialOwners: Array<{
                        __typename: "VerificationRenewalUltimateBeneficialOwner";
                        taxIdentificationNumber?: string | null;
                        firstName?: string | null;
                        lastName?: string | null;
                        sex?: Sex | null;
                        qualificationType?: UltimateBeneficialOwnerQualificationType | null;
                        address?: {
                          __typename: "AddressInfo";
                          addressLine1?: string | null;
                          addressLine2?: string | null;
                          city?: string | null;
                          country?: string | null;
                          postalCode?: string | null;
                          state?: string | null;
                        } | null;
                        ownership?: {
                          __typename: "UltimateBeneficialOwnerOwnership";
                          totalPercentage?: number | null;
                          type: UltimateBeneficialOwnerOwnershipType;
                        } | null;
                        birthInfo?: {
                          __typename: "BirthInfo";
                          city?: string | null;
                          country?: string | null;
                          birthDate?: string | null;
                          postalCode?: string | null;
                        } | null;
                      }>;
                    };
                    accountAdmin: {
                      __typename: "CompanyVerificationRenewalAccountAdmin";
                      firstName: string;
                      lastName: string;
                      typeOfRepresentation?: TypeOfRepresentation | null;
                      email: string;
                      birthInfo: {
                        __typename: "BirthInfo";
                        city?: string | null;
                        country?: string | null;
                        birthDate?: string | null;
                        postalCode?: string | null;
                      };
                    };
                  }
                | {
                    __typename: "IndividualVerificationRenewalInfo";
                    type: AccountHolderType;
                    additionalDetails?: string | null;
                    accountAdmin: {
                      __typename: "IndividualVerificationRenewalAccountAdmin";
                      firstName: string;
                      lastName: string;
                      employmentStatus: EmploymentStatus;
                      monthlyIncome: MonthlyIncome;
                      residencyAddress: {
                        __typename: "Address";
                        addressLine1?: string | null;
                        addressLine2?: string | null;
                        city?: string | null;
                        postalCode?: string | null;
                        state?: string | null;
                        country?: string | null;
                      };
                    };
                  };
            }
          | {
              __typename: "WaitingForInformationVerificationRenewal";
              verificationRequirements: Array<VerificationRenewalRequirement>;
              id: string;
              supportingDocumentCollection?: {
                __typename: "SupportingDocumentCollection";
                id: string;
                type: SupportingDocumentCollectionType;
                createdAt: string;
                updatedAt: string;
                supportingDocuments: Array<{
                  __typename: "SupportingDocument";
                  id: string;
                  supportingDocumentPurpose: SupportingDocumentPurposeEnum;
                  statusInfo:
                    | {
                        __typename: "SupportingDocumentNotUploadedStatusInfo";
                        status: SupportingDocumentStatus;
                      }
                    | {
                        __typename: "SupportingDocumentRefusedStatusInfo";
                        filename: string;
                        reason: string;
                        reasonCode: SupportingDocumentReasonCode;
                        status: SupportingDocumentStatus;
                      }
                    | {
                        __typename: "SupportingDocumentUploadedStatusInfo";
                        filename: string;
                        status: SupportingDocumentStatus;
                      }
                    | {
                        __typename: "SupportingDocumentValidatedStatusInfo";
                        status: SupportingDocumentStatus;
                      }
                    | {
                        __typename: "SupportingDocumentWaitingForUploadStatusInfo";
                        status: SupportingDocumentStatus;
                      };
                }>;
                requiredSupportingDocumentPurposes: Array<{
                  __typename: "SupportingDocumentPurpose";
                  name: SupportingDocumentPurposeEnum;
                  label: string;
                  acceptableSupportingDocumentTypes: Array<SupportingDocumentType>;
                  description: string;
                }>;
                statusInfo:
                  | {
                      __typename: "SupportingDocumentCollectionApprovedStatusInfo";
                      status: SupportingDocumentCollectionStatus;
                    }
                  | {
                      __typename: "SupportingDocumentCollectionCanceledStatusInfo";
                      status: SupportingDocumentCollectionStatus;
                    }
                  | {
                      __typename: "SupportingDocumentCollectionPendingReviewStatusInfo";
                      status: SupportingDocumentCollectionStatus;
                    }
                  | {
                      __typename: "SupportingDocumentCollectionRejectedStatusInfo";
                      status: SupportingDocumentCollectionStatus;
                    }
                  | {
                      __typename: "SupportingDocumentCollectionWaitingForDocumentStatusInfo";
                      status: SupportingDocumentCollectionStatus;
                    };
              } | null;
              info:
                | {
                    __typename: "CompanyVerificationRenewalInfo";
                    type: AccountHolderType;
                    additionalDetails?: string | null;
                    company: {
                      __typename: "CompanyVerificationRenewalCompanyInfo";
                      name: string;
                      businessActivityDescription: string;
                      monthlyPaymentVolume: MonthlyPaymentVolume;
                      residencyAddress: {
                        __typename: "Address";
                        addressLine1?: string | null;
                        addressLine2?: string | null;
                        city?: string | null;
                        postalCode?: string | null;
                        country?: string | null;
                      };
                      ultimateBeneficialOwners: Array<{
                        __typename: "VerificationRenewalUltimateBeneficialOwner";
                        taxIdentificationNumber?: string | null;
                        firstName?: string | null;
                        lastName?: string | null;
                        sex?: Sex | null;
                        qualificationType?: UltimateBeneficialOwnerQualificationType | null;
                        address?: {
                          __typename: "AddressInfo";
                          addressLine1?: string | null;
                          addressLine2?: string | null;
                          city?: string | null;
                          country?: string | null;
                          postalCode?: string | null;
                          state?: string | null;
                        } | null;
                        ownership?: {
                          __typename: "UltimateBeneficialOwnerOwnership";
                          totalPercentage?: number | null;
                          type: UltimateBeneficialOwnerOwnershipType;
                        } | null;
                        birthInfo?: {
                          __typename: "BirthInfo";
                          city?: string | null;
                          country?: string | null;
                          birthDate?: string | null;
                          postalCode?: string | null;
                        } | null;
                      }>;
                    };
                    accountAdmin: {
                      __typename: "CompanyVerificationRenewalAccountAdmin";
                      firstName: string;
                      lastName: string;
                      typeOfRepresentation?: TypeOfRepresentation | null;
                      email: string;
                      birthInfo: {
                        __typename: "BirthInfo";
                        city?: string | null;
                        country?: string | null;
                        birthDate?: string | null;
                        postalCode?: string | null;
                      };
                    };
                  }
                | {
                    __typename: "IndividualVerificationRenewalInfo";
                    type: AccountHolderType;
                    additionalDetails?: string | null;
                    accountAdmin: {
                      __typename: "IndividualVerificationRenewalAccountAdmin";
                      firstName: string;
                      lastName: string;
                      employmentStatus: EmploymentStatus;
                      monthlyIncome: MonthlyIncome;
                      residencyAddress: {
                        __typename: "Address";
                        addressLine1?: string | null;
                        addressLine2?: string | null;
                        city?: string | null;
                        postalCode?: string | null;
                        state?: string | null;
                        country?: string | null;
                      };
                    };
                  };
            };
      }
    | { __typename: "ValidationRejection"; message: string }
    | { __typename: "VerificationRenewalNotFoundRejection"; message: string }
    | { __typename: "VerificationRenewalUpdateNotAllowedRejection"; message: string };
};

export type FinalizeVerificationRenewalMutationVariables = Exact<{
  input: FinalizeVerificationRenewalInput;
}>;

export type FinalizeVerificationRenewalMutation = {
  __typename: "Mutation";
  finalizeVerificationRenewal:
    | {
        __typename: "FinalizeVerificationRenewalSuccessPayload";
        verificationRenewal:
          | { __typename: "CompletedVerificationRenewal"; id: string }
          | { __typename: "PendingVerificationRenewal"; id: string }
          | { __typename: "RefusedVerificationRenewal"; id: string }
          | { __typename: "SuspendedVerificationRenewal"; id: string }
          | { __typename: "WaitingForInformationVerificationRenewal"; id: string };
      }
    | { __typename: "ForbiddenRejection"; message: string }
    | { __typename: "ValidationRejection"; message: string }
    | { __typename: "VerificationRenewalNotFoundRejection"; message: string }
    | { __typename: "VerificationRenewalUpdateNotAllowedRejection"; message: string };
};

export const AddressDetailsFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AddressDetails" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Address" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "addressLine1" } },
          { kind: "Field", name: { kind: "Name", value: "addressLine2" } },
          { kind: "Field", name: { kind: "Name", value: "city" } },
          { kind: "Field", name: { kind: "Name", value: "country" } },
          { kind: "Field", name: { kind: "Name", value: "postalCode" } },
          { kind: "Field", name: { kind: "Name", value: "state" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AddressDetailsFragment, unknown>;
export const TrustedBeneficiaryDetailsFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TrustedBeneficiaryDetails" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "TrustedBeneficiary" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "label" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "statusInfo" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "TrustedInternalBeneficiary" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "accountId" } },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "TrustedInternationalBeneficiary" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "currency" } },
                { kind: "Field", name: { kind: "Name", value: "route" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "details" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "key" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "TrustedSepaBeneficiary" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "iban" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "address" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "FragmentSpread", name: { kind: "Name", value: "AddressDetails" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AddressDetails" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Address" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "addressLine1" } },
          { kind: "Field", name: { kind: "Name", value: "addressLine2" } },
          { kind: "Field", name: { kind: "Name", value: "city" } },
          { kind: "Field", name: { kind: "Name", value: "country" } },
          { kind: "Field", name: { kind: "Name", value: "postalCode" } },
          { kind: "Field", name: { kind: "Name", value: "state" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TrustedBeneficiaryDetailsFragment, unknown>;
export const TransactionDetailsFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TransactionDetails" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Transaction" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "side" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "label" } },
          { kind: "Field", name: { kind: "Name", value: "counterparty" } },
          { kind: "Field", name: { kind: "Name", value: "reference" } },
          { kind: "Field", name: { kind: "Name", value: "externalReference" } },
          { kind: "Field", name: { kind: "Name", value: "statementCanBeGenerated" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "payment" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "createdAt" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "originTransaction" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
                { kind: "Field", name: { kind: "Name", value: "executionDate" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "amount" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "currency" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "statusInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "status" } },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "RejectedTransactionStatusInfo" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "status" } },
                            { kind: "Field", name: { kind: "Name", value: "reason" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "statusInfo" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "BookedTransactionStatusInfo" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "bookingDate" } },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "PendingTransactionStatusInfo" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "pendingEndDate" } },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "CanceledTransactionStatusInfo" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "canceledDate" } },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "RejectedTransactionStatusInfo" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "reason" } },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "UpcomingTransactionStatusInfo" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "executionDate" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "amount" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "currency" } },
                { kind: "Field", name: { kind: "Name", value: "value" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "executionDate" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "InlineFragment",
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "CardTransaction" } },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "originalAmount" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "currency" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "reservedAmount" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "currency" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "reservedAmountReleasedAt" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "cardDetails" },
                  directives: [
                    {
                      kind: "Directive",
                      name: { kind: "Name", value: "include" },
                      arguments: [
                        {
                          kind: "Argument",
                          name: { kind: "Name", value: "if" },
                          value: {
                            kind: "Variable",
                            name: { kind: "Name", value: "canQueryCardOnTransaction" },
                          },
                        },
                      ],
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "CardOutDetails" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "maskedPan" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "card" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  { kind: "Field", name: { kind: "Name", value: "id" } },
                                  { kind: "Field", name: { kind: "Name", value: "name" } },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "accountMembership" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "__typename" },
                                        },
                                        { kind: "Field", name: { kind: "Name", value: "id" } },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "user" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: { kind: "Name", value: "__typename" },
                                              },
                                              {
                                                kind: "Field",
                                                name: { kind: "Name", value: "id" },
                                              },
                                              {
                                                kind: "Field",
                                                name: { kind: "Name", value: "firstName" },
                                              },
                                              {
                                                kind: "Field",
                                                name: { kind: "Name", value: "preferredLastName" },
                                              },
                                              {
                                                kind: "Field",
                                                name: { kind: "Name", value: "fullName" },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "CardInDetails" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "paymentMandate" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  { kind: "Field", name: { kind: "Name", value: "id" } },
                                  { kind: "Field", name: { kind: "Name", value: "name" } },
                                  { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                                  { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                                  { kind: "Field", name: { kind: "Name", value: "executedAt" } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "merchant" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "CardOutMerchant" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "merchantId" } },
                            { kind: "Field", name: { kind: "Name", value: "merchantCity" } },
                            { kind: "Field", name: { kind: "Name", value: "merchantCountry" } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "originalAmount" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "currency" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "enrichedTransactionInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "enrichedMerchantName" } },
                      { kind: "Field", name: { kind: "Name", value: "isSubscription" } },
                      { kind: "Field", name: { kind: "Name", value: "carbonFootprint" } },
                      { kind: "Field", name: { kind: "Name", value: "contactEmail" } },
                      { kind: "Field", name: { kind: "Name", value: "contactPhone" } },
                      { kind: "Field", name: { kind: "Name", value: "contactWebsite" } },
                      { kind: "Field", name: { kind: "Name", value: "logoUrl" } },
                      { kind: "Field", name: { kind: "Name", value: "category" } },
                      { kind: "Field", name: { kind: "Name", value: "subcategory" } },
                      { kind: "Field", name: { kind: "Name", value: "address" } },
                      { kind: "Field", name: { kind: "Name", value: "city" } },
                      { kind: "Field", name: { kind: "Name", value: "postalCode" } },
                      { kind: "Field", name: { kind: "Name", value: "country" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "currencyExchange" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "exchangeRate" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "SEPACreditTransferTransaction" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "creditor" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "IBAN" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "debtor" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "IBAN" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "beneficiary" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "TrustedBeneficiary" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "TrustedBeneficiaryDetails" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "UnsavedSepaBeneficiary" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "name" } },
                            { kind: "Field", name: { kind: "Name", value: "iban" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "address" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  {
                                    kind: "FragmentSpread",
                                    name: { kind: "Name", value: "AddressDetails" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "InternalDirectDebitTransaction" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "reservedAmount" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "currency" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "reservedAmountReleasedAt" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "creditor" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "accountId" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "mandate" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "FeeTransaction" } },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "feesType" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "creditor" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "originTransaction" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "label" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "statusInfo" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "status" } },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: { kind: "Name", value: "RejectedTransactionStatusInfo" },
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  { kind: "Field", name: { kind: "Name", value: "reason" } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                      { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                      { kind: "Field", name: { kind: "Name", value: "executionDate" } },
                      { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "amount" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "currency" } },
                            { kind: "Field", name: { kind: "Name", value: "value" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "SEPADirectDebitTransaction" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "reservedAmountReleasedAt" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "creditor" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "IBAN" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "debtor" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "IBAN" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "reservedAmount" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                      { kind: "Field", name: { kind: "Name", value: "currency" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "mandate" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "SEPAReceivedDirectDebitMandate" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "ultimateCreditorName" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "SEPAPaymentDirectDebitMandate" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "debtor" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  { kind: "Field", name: { kind: "Name", value: "name" } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "InternationalCreditTransferTransaction" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "creditor" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "InternationalCreditTransferInCreditor" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "name" } },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "InternationalCreditTransferOutCreditor" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "name" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "details" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  { kind: "Field", name: { kind: "Name", value: "key" } },
                                  { kind: "Field", name: { kind: "Name", value: "value" } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "reference" } },
                { kind: "Field", name: { kind: "Name", value: "paymentProduct" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "statusInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "status" } },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "RejectedTransactionStatusInfo" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "reason" } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  alias: { kind: "Name", value: "internationalCurrencyExchange" },
                  name: { kind: "Name", value: "currencyExchange" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "exchangeRate" } },
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "sourceAmount" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "currency" } },
                            { kind: "Field", name: { kind: "Name", value: "value" } },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "targetAmount" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "currency" } },
                            { kind: "Field", name: { kind: "Name", value: "value" } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "beneficiary" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "currency" } },
                      { kind: "Field", name: { kind: "Name", value: "route" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "details" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "key" } },
                            { kind: "Field", name: { kind: "Name", value: "value" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "InternalCreditTransfer" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "creditor" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "CheckTransaction" } },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "reservedAmount" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "currency" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "reservedAmountReleasedAt" } },
                { kind: "Field", name: { kind: "Name", value: "cmc7" } },
                { kind: "Field", name: { kind: "Name", value: "rlmcKey" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AddressDetails" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Address" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "addressLine1" } },
          { kind: "Field", name: { kind: "Name", value: "addressLine2" } },
          { kind: "Field", name: { kind: "Name", value: "city" } },
          { kind: "Field", name: { kind: "Name", value: "country" } },
          { kind: "Field", name: { kind: "Name", value: "postalCode" } },
          { kind: "Field", name: { kind: "Name", value: "state" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TrustedBeneficiaryDetails" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "TrustedBeneficiary" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "label" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "statusInfo" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "TrustedInternalBeneficiary" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "accountId" } },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "TrustedInternationalBeneficiary" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "currency" } },
                { kind: "Field", name: { kind: "Name", value: "route" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "details" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "key" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "TrustedSepaBeneficiary" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "iban" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "address" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "FragmentSpread", name: { kind: "Name", value: "AddressDetails" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TransactionDetailsFragment, unknown>;
export const IdentificationLevelsFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "IdentificationLevelsFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "IdentificationLevels" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "expert" } },
          { kind: "Field", name: { kind: "Name", value: "QES" } },
          { kind: "Field", name: { kind: "Name", value: "PVID" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<IdentificationLevelsFragment, unknown>;
export const IdentificationLevelFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "IdentificationLevelFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "IdentificationLevelStatusInfo" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "NotSupportedIdentificationLevelStatusInfo" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "StartedIdentificationLevelStatusInfo" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "PendingIdentificationLevelStatusInfo" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "ValidIdentificationLevelStatusInfo" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "InvalidIdentificationLevelStatusInfo" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "reasons" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "CanceledIdentificationLevelStatusInfo" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "ExpiredIdentificationLevelStatusInfo" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                { kind: "Field", name: { kind: "Name", value: "expiredAt" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<IdentificationLevelFragment, unknown>;
export const IdentificationFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Identification" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Identification" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "levels" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "expert" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "IdentificationLevelFragment" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pvid" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "IdentificationLevelFragment" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "qes" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "IdentificationLevelFragment" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "process" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "IdentificationLevelFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "IdentificationLevelStatusInfo" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "NotSupportedIdentificationLevelStatusInfo" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "StartedIdentificationLevelStatusInfo" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "PendingIdentificationLevelStatusInfo" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "ValidIdentificationLevelStatusInfo" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "InvalidIdentificationLevelStatusInfo" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "reasons" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "CanceledIdentificationLevelStatusInfo" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "ExpiredIdentificationLevelStatusInfo" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                { kind: "Field", name: { kind: "Name", value: "expiredAt" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<IdentificationFragment, unknown>;
export const AccountMembershipPermissionsFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AccountMembershipPermissions" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "AccountMembership" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "canViewAccount" } },
          { kind: "Field", name: { kind: "Name", value: "canManageBeneficiaries" } },
          { kind: "Field", name: { kind: "Name", value: "canInitiatePayments" } },
          { kind: "Field", name: { kind: "Name", value: "canManageAccountMembership" } },
          { kind: "Field", name: { kind: "Name", value: "canManageCards" } },
          { kind: "Field", name: { kind: "Name", value: "legalRepresentative" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "statusInfo" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
              ],
            },
          },
          {
            kind: "Field",
            alias: { kind: "Name", value: "allCards" },
            name: { kind: "Name", value: "cards" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "statuses" },
                      value: {
                        kind: "ListValue",
                        values: [
                          { kind: "EnumValue", value: "Enabled" },
                          { kind: "EnumValue", value: "Processing" },
                          { kind: "EnumValue", value: "Canceling" },
                          { kind: "EnumValue", value: "Canceled" },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "totalCount" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "account" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "statusInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "status" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "paymentLevel" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "merchantProfiles" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "first" },
                      value: { kind: "IntValue", value: "0" },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "totalCount" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AccountMembershipPermissionsFragment, unknown>;
export const WebBankingSettingsFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "WebBankingSettings" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "WebBankingSettings" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "canViewAccountStatement" } },
          { kind: "Field", name: { kind: "Name", value: "canViewAccountDetails" } },
          { kind: "Field", name: { kind: "Name", value: "canAddNewMembers" } },
          { kind: "Field", name: { kind: "Name", value: "canViewMembers" } },
          { kind: "Field", name: { kind: "Name", value: "canViewPaymentList" } },
          { kind: "Field", name: { kind: "Name", value: "canOrderPhysicalCards" } },
          { kind: "Field", name: { kind: "Name", value: "canInitiatePaymentsToNewBeneficiaries" } },
          { kind: "Field", name: { kind: "Name", value: "canOrderVirtualCards" } },
          { kind: "Field", name: { kind: "Name", value: "canManageVirtualIbans" } },
          { kind: "Field", name: { kind: "Name", value: "canCreateMerchantProfile" } },
          { kind: "Field", name: { kind: "Name", value: "canRequestOnlineCardsPaymentMethod" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "canRequestSepaDirectDebitCorePaymentMethod" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "canRequestSepaDirectDebitB2BPaymentMethod" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "canRequestInternalDirectDebitCorePaymentMethod" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "canRequestInternalDirectDebitB2BPaymentMethod" },
          },
          { kind: "Field", name: { kind: "Name", value: "canRequestChecksPaymentMethod" } },
          { kind: "Field", name: { kind: "Name", value: "canInitiateCheckMerchantPayments" } },
          { kind: "Field", name: { kind: "Name", value: "canCreateMerchantPaymentLinks" } },
          { kind: "Field", name: { kind: "Name", value: "canUpdateCards" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<WebBankingSettingsFragment, unknown>;
export const CreditLimitSettingsRequestFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CreditLimitSettingsRequest" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CreditLimitSettingsRequest" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "statusInfo" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "Field", name: { kind: "Name", value: "__typename" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "amount" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "value" } },
                { kind: "Field", name: { kind: "Name", value: "currency" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreditLimitSettingsRequestFragment, unknown>;
export const AccountMembershipsTotalCountFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AccountMembershipsTotalCount" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "AccountMembership" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "account" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "memberships" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "filters" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "status" },
                            value: {
                              kind: "ListValue",
                              values: [
                                { kind: "EnumValue", value: "Enabled" },
                                { kind: "EnumValue", value: "InvitationSent" },
                                { kind: "EnumValue", value: "BindingUserError" },
                                { kind: "EnumValue", value: "Suspended" },
                              ],
                            },
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "totalCount" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AccountMembershipsTotalCountFragment, unknown>;
export const CardListItemFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CardListItem" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Card" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "statusInfo" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "spendingLimits" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "period" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "amount" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "currency" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "spending" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "period" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "amount" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "currency" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "physicalCard" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "statusInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "status" } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "cardDesignUrl" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "cardProduct" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "fundingType" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "insuranceSubscription" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "package" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "level" } },
                      { kind: "Field", name: { kind: "Name", value: "noticeUrl" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "accountMembership" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "account" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "number" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "holder" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "info" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  { kind: "Field", name: { kind: "Name", value: "name" } },
                                  { kind: "Field", name: { kind: "Name", value: "type" } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "statusInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: {
                            kind: "Name",
                            value: "AccountMembershipBindingUserErrorStatusInfo",
                          },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "restrictedTo" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  { kind: "Field", name: { kind: "Name", value: "firstName" } },
                                  { kind: "Field", name: { kind: "Name", value: "lastName" } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: {
                            kind: "Name",
                            value: "AccountMembershipInvitationSentStatusInfo",
                          },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "restrictedTo" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  { kind: "Field", name: { kind: "Name", value: "firstName" } },
                                  { kind: "Field", name: { kind: "Name", value: "lastName" } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "user" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "firstName" } },
                      { kind: "Field", name: { kind: "Name", value: "preferredLastName" } },
                      { kind: "Field", name: { kind: "Name", value: "fullName" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CardListItemFragment, unknown>;
export const CardListPageDataFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CardListPageData" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "CardConnection" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "pageInfo" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "endCursor" } },
                { kind: "Field", name: { kind: "Name", value: "hasNextPage" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "edges" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "cursor" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "node" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "FragmentSpread", name: { kind: "Name", value: "CardListItem" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CardListItem" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Card" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "statusInfo" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "spendingLimits" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "period" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "amount" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "currency" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "spending" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "period" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "amount" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "currency" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "physicalCard" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "statusInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "status" } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "cardDesignUrl" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "cardProduct" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "fundingType" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "insuranceSubscription" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "package" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "level" } },
                      { kind: "Field", name: { kind: "Name", value: "noticeUrl" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "accountMembership" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "account" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "number" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "holder" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "info" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  { kind: "Field", name: { kind: "Name", value: "name" } },
                                  { kind: "Field", name: { kind: "Name", value: "type" } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "statusInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: {
                            kind: "Name",
                            value: "AccountMembershipBindingUserErrorStatusInfo",
                          },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "restrictedTo" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  { kind: "Field", name: { kind: "Name", value: "firstName" } },
                                  { kind: "Field", name: { kind: "Name", value: "lastName" } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: {
                            kind: "Name",
                            value: "AccountMembershipInvitationSentStatusInfo",
                          },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "restrictedTo" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  { kind: "Field", name: { kind: "Name", value: "firstName" } },
                                  { kind: "Field", name: { kind: "Name", value: "lastName" } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "user" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "firstName" } },
                      { kind: "Field", name: { kind: "Name", value: "preferredLastName" } },
                      { kind: "Field", name: { kind: "Name", value: "fullName" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CardListPageDataFragment, unknown>;
export const DigitalCardFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "DigitalCard" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "DigitalCard" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "walletProvider" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "CompleteDigitalCard" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "device" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DigitalCardFragment, unknown>;
export const AccountHolderForCardSettingsFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AccountHolderForCardSettings" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "AccountHolder" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "info" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AccountHolderForCardSettingsFragment, unknown>;
export const AccountMembershipFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AccountMembership" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "AccountMembership" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "accountId" } },
          { kind: "Field", name: { kind: "Name", value: "accountCountry" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "legalRepresentative" } },
          { kind: "Field", name: { kind: "Name", value: "hasRequiredIdentificationLevel" } },
          { kind: "Field", name: { kind: "Name", value: "language" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "statusInfo" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "AccountMembershipBindingUserErrorStatusInfo" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "restrictedTo" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "birthDate" } },
                            { kind: "Field", name: { kind: "Name", value: "firstName" } },
                            { kind: "Field", name: { kind: "Name", value: "lastName" } },
                            { kind: "Field", name: { kind: "Name", value: "phoneNumber" } },
                          ],
                        },
                      },
                      { kind: "Field", name: { kind: "Name", value: "emailVerifiedMatchError" } },
                      { kind: "Field", name: { kind: "Name", value: "idVerifiedMatchError" } },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "AccountMembershipInvitationSentStatusInfo" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "restrictedTo" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "birthDate" } },
                            { kind: "Field", name: { kind: "Name", value: "firstName" } },
                            { kind: "Field", name: { kind: "Name", value: "lastName" } },
                            { kind: "Field", name: { kind: "Name", value: "phoneNumber" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "taxIdentificationNumber" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "residencyAddress" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "addressLine1" } },
                { kind: "Field", name: { kind: "Name", value: "postalCode" } },
                { kind: "Field", name: { kind: "Name", value: "city" } },
                { kind: "Field", name: { kind: "Name", value: "country" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "canInitiatePayments" } },
          { kind: "Field", name: { kind: "Name", value: "canManageCards" } },
          { kind: "Field", name: { kind: "Name", value: "canManageAccountMembership" } },
          { kind: "Field", name: { kind: "Name", value: "canManageBeneficiaries" } },
          { kind: "Field", name: { kind: "Name", value: "canViewAccount" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "birthDate" } },
                { kind: "Field", name: { kind: "Name", value: "firstName" } },
                { kind: "Field", name: { kind: "Name", value: "lastName" } },
                { kind: "Field", name: { kind: "Name", value: "birthLastName" } },
                { kind: "Field", name: { kind: "Name", value: "preferredLastName" } },
                { kind: "Field", name: { kind: "Name", value: "fullName" } },
                { kind: "Field", name: { kind: "Name", value: "mobilePhoneNumber" } },
                { kind: "Field", name: { kind: "Name", value: "verifiedEmails" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "account" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "country" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "holder" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "AccountHolderForCardSettings" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            alias: { kind: "Name", value: "activeCards" },
            name: { kind: "Name", value: "cards" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "statuses" },
                      value: {
                        kind: "ListValue",
                        values: [
                          { kind: "EnumValue", value: "Enabled" },
                          { kind: "EnumValue", value: "Processing" },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "totalCount" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AccountHolderForCardSettings" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "AccountHolder" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "info" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AccountMembershipFragment, unknown>;
export const TransactionStatementFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TransactionStatement" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "TransactionStatement" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "statusInfo" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "GeneratedTransactionStatementStatusInfo" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TransactionStatementFragment, unknown>;
export const CardInsurancePackageFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CardInsurancePackage" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "CardInsurancePackage" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "level" } },
          { kind: "Field", name: { kind: "Name", value: "noticeUrl" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CardInsurancePackageFragment, unknown>;
export const CardProductFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CardProduct" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "CardProduct" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "fundingType" } },
          { kind: "Field", name: { kind: "Name", value: "projectId" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "applicableToPhysicalCards" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "companySpendingLimit" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "amount" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                      { kind: "Field", name: { kind: "Name", value: "currency" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "period" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "individualSpendingLimit" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "amount" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                      { kind: "Field", name: { kind: "Name", value: "currency" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "period" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "cardDesigns" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "version" } },
                { kind: "Field", name: { kind: "Name", value: "cardProjectLogoSvgUrl" } },
                { kind: "Field", name: { kind: "Name", value: "cardProjectLogo300dpiUrl" } },
                { kind: "Field", name: { kind: "Name", value: "cardProjectLogo600dpiUrl" } },
                { kind: "Field", name: { kind: "Name", value: "zoomRatioProjectLogo" } },
                { kind: "Field", name: { kind: "Name", value: "cardDesignUrl" } },
                { kind: "Field", name: { kind: "Name", value: "accentColor" } },
                { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "cardBackground" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                      { kind: "Field", name: { kind: "Name", value: "cardTextColor" } },
                      { kind: "Field", name: { kind: "Name", value: "cardBackgroundUrl" } },
                      { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                      { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "insurance" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "defaultInsurancePackage" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "CardInsurancePackage" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "availableInsurancePackages" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "CardInsurancePackage" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultCardProduct" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CardInsurancePackage" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "CardInsurancePackage" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "level" } },
          { kind: "Field", name: { kind: "Name", value: "noticeUrl" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CardProductFragment, unknown>;
export const AccountBalancesFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AccountBalances" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "AccountBalances" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "available" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "value" } },
                { kind: "Field", name: { kind: "Name", value: "currency" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "pending" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "value" } },
                { kind: "Field", name: { kind: "Name", value: "currency" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "booked" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "value" } },
                { kind: "Field", name: { kind: "Name", value: "currency" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "reserved" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "value" } },
                { kind: "Field", name: { kind: "Name", value: "currency" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AccountBalancesFragment, unknown>;
export const ValidIbanInformationFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ValidIbanInformation" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ValidIban" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "iban" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "bank" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "address" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "addressLine1" } },
                      { kind: "Field", name: { kind: "Name", value: "addressLine2" } },
                      { kind: "Field", name: { kind: "Name", value: "city" } },
                      { kind: "Field", name: { kind: "Name", value: "country" } },
                      { kind: "Field", name: { kind: "Name", value: "postalCode" } },
                      { kind: "Field", name: { kind: "Name", value: "state" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "reachability" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "sepaCreditTransferInst" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ValidIbanInformationFragment, unknown>;
export const MerchantPaymentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MerchantPayment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "MerchantPayment" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "label" } },
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "externalReference" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "statusInfo" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "MerchantPaymentAuthorized" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                      { kind: "Field", name: { kind: "Name", value: "authorizedAt" } },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "MerchantPaymentCanceled" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                      { kind: "Field", name: { kind: "Name", value: "canceledAt" } },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "MerchantPaymentCaptured" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                      { kind: "Field", name: { kind: "Name", value: "authorizedAt" } },
                      { kind: "Field", name: { kind: "Name", value: "capturedAt" } },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "MerchantPaymentDisputed" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                      { kind: "Field", name: { kind: "Name", value: "authorizedAt" } },
                      { kind: "Field", name: { kind: "Name", value: "capturedAt" } },
                      { kind: "Field", name: { kind: "Name", value: "disputedAt" } },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "MerchantPaymentInitiated" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "MerchantPaymentPartiallyDisputed" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                      { kind: "Field", name: { kind: "Name", value: "authorizedAt" } },
                      { kind: "Field", name: { kind: "Name", value: "capturedAt" } },
                      { kind: "Field", name: { kind: "Name", value: "disputedAt" } },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "MerchantPaymentRejected" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "rejectedReasonCode" } },
                      { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                      { kind: "Field", name: { kind: "Name", value: "rejectedAt" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "amount" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "currency" } },
                { kind: "Field", name: { kind: "Name", value: "value" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "paymentMethod" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "merchantProfile" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "balance" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "totalAuthorized" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "currency" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "totalCaptured" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "currency" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "availableToCapture" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "currency" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "totalRefunded" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "currency" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "availableToRefund" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "currency" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "availableToCancel" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "currency" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "totalCanceled" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "currency" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "totalDisputed" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "currency" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "reference" } },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "SepaDirectDebitMerchantPayment" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "paymentLink" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "CardMerchantPayment" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "paymentLink" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "threeDs" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "statusInfo" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "status" } },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: { kind: "Name", value: "FailedThreeDsStatusInfo" },
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  { kind: "Field", name: { kind: "Name", value: "reasonCode" } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MerchantPaymentFragment, unknown>;
export const MerchantPaymentsConnectionFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MerchantPaymentsConnection" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "MerchantPaymentConnection" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "pageInfo" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "endCursor" } },
                { kind: "Field", name: { kind: "Name", value: "hasNextPage" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "totalCount" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "edges" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "node" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "FragmentSpread", name: { kind: "Name", value: "MerchantPayment" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MerchantPayment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "MerchantPayment" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "label" } },
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "externalReference" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "statusInfo" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "MerchantPaymentAuthorized" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                      { kind: "Field", name: { kind: "Name", value: "authorizedAt" } },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "MerchantPaymentCanceled" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                      { kind: "Field", name: { kind: "Name", value: "canceledAt" } },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "MerchantPaymentCaptured" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                      { kind: "Field", name: { kind: "Name", value: "authorizedAt" } },
                      { kind: "Field", name: { kind: "Name", value: "capturedAt" } },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "MerchantPaymentDisputed" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                      { kind: "Field", name: { kind: "Name", value: "authorizedAt" } },
                      { kind: "Field", name: { kind: "Name", value: "capturedAt" } },
                      { kind: "Field", name: { kind: "Name", value: "disputedAt" } },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "MerchantPaymentInitiated" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "MerchantPaymentPartiallyDisputed" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                      { kind: "Field", name: { kind: "Name", value: "authorizedAt" } },
                      { kind: "Field", name: { kind: "Name", value: "capturedAt" } },
                      { kind: "Field", name: { kind: "Name", value: "disputedAt" } },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "MerchantPaymentRejected" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "rejectedReasonCode" } },
                      { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                      { kind: "Field", name: { kind: "Name", value: "rejectedAt" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "amount" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "currency" } },
                { kind: "Field", name: { kind: "Name", value: "value" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "paymentMethod" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "merchantProfile" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "balance" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "totalAuthorized" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "currency" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "totalCaptured" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "currency" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "availableToCapture" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "currency" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "totalRefunded" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "currency" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "availableToRefund" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "currency" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "availableToCancel" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "currency" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "totalCanceled" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "currency" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "totalDisputed" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "currency" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "reference" } },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "SepaDirectDebitMerchantPayment" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "paymentLink" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "CardMerchantPayment" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "paymentLink" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "threeDs" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "statusInfo" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "status" } },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: { kind: "Name", value: "FailedThreeDsStatusInfo" },
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  { kind: "Field", name: { kind: "Name", value: "reasonCode" } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MerchantPaymentsConnectionFragment, unknown>;
export const PaymentLinkFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PaymentLink" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "MerchantPaymentLink" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "label" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "reference" } },
          { kind: "Field", name: { kind: "Name", value: "externalReference" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "statusInfo" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "amount" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "currency" } },
                { kind: "Field", name: { kind: "Name", value: "value" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PaymentLinkFragment, unknown>;
export const PaymentLinkConnectionFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PaymentLinkConnection" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "MerchantPaymentLinkConnection" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "pageInfo" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "endCursor" } },
                { kind: "Field", name: { kind: "Name", value: "hasNextPage" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "totalCount" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "edges" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "node" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "FragmentSpread", name: { kind: "Name", value: "PaymentLink" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PaymentLink" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "MerchantPaymentLink" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "label" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "reference" } },
          { kind: "Field", name: { kind: "Name", value: "externalReference" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "statusInfo" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "amount" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "currency" } },
                { kind: "Field", name: { kind: "Name", value: "value" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PaymentLinkConnectionFragment, unknown>;
export const RepaymentAccountFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RepaymentAccount" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Account" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "IBAN" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "holder" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "residencyAddress" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "addressLine1" } },
                      { kind: "Field", name: { kind: "Name", value: "city" } },
                      { kind: "Field", name: { kind: "Name", value: "postalCode" } },
                      { kind: "Field", name: { kind: "Name", value: "country" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "verificationStatus" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "info" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "AccountHolderCompanyInfo" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "name" } },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "AccountHolderIndividualInfo" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "name" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RepaymentAccountFragment, unknown>;
export const CardFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CardFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Card" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "insuranceSubscription" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "package" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "level" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "statusInfo" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "CardConsentPendingStatusInfo" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "consent" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "consentUrl" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CardFragment, unknown>;
export const MerchantPaymentMethodFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MerchantPaymentMethod" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "MerchantPaymentMethod" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "methodId" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "version" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "rollingReserve" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "percentage" } },
                { kind: "Field", name: { kind: "Name", value: "rollingDays" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "statusInfo" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "WaitingForInformationMerchantPaymentMethodStatusInfo",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "verificationRequirements" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: { kind: "Name", value: "AdditionalInformationRequirements" },
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "additionalInformation" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: { kind: "Name", value: "MerchantRequirements" },
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  { kind: "Field", name: { kind: "Name", value: "fields" } },
                                ],
                              },
                            },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: {
                                  kind: "Name",
                                  value: "OtherAdditionalInformationRequirements",
                                },
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "otherAdditionalInformation" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: { kind: "Name", value: "SupportingDocumentRequirements" },
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "supportingDocumentPurposes" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "SepaDirectDebitB2BMerchantPaymentMethod" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "sepaCreditorIdentifier" } },
                { kind: "Field", name: { kind: "Name", value: "useSwanSepaCreditorIdentifier" } },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "SepaDirectDebitCoreMerchantPaymentMethod" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "sepaCreditorIdentifier" } },
                { kind: "Field", name: { kind: "Name", value: "useSwanSepaCreditorIdentifier" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MerchantPaymentMethodFragment, unknown>;
export const MerchantProfileFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MerchantProfile" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "MerchantProfile" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "accentColor" } },
          { kind: "Field", name: { kind: "Name", value: "accountId" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "expectedAverageBasket" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "value" } },
                { kind: "Field", name: { kind: "Name", value: "currency" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "expectedMonthlyMerchantProcessingVolume" },
          },
          { kind: "Field", name: { kind: "Name", value: "merchantLogoUrl" } },
          { kind: "Field", name: { kind: "Name", value: "merchantName" } },
          { kind: "Field", name: { kind: "Name", value: "merchantWebsiteUrl" } },
          { kind: "Field", name: { kind: "Name", value: "productType" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "statusInfo" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "merchantPaymentMethods" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "FragmentSpread", name: { kind: "Name", value: "MerchantPaymentMethod" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "requestMerchantProfileUpdate" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                { kind: "Field", name: { kind: "Name", value: "merchantName" } },
                { kind: "Field", name: { kind: "Name", value: "merchantWebsiteUrl" } },
                { kind: "Field", name: { kind: "Name", value: "merchantLogoUrl" } },
                { kind: "Field", name: { kind: "Name", value: "productType" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "expectedMonthlyMerchantProcessingVolume" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "expectedAverageBasket" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                      { kind: "Field", name: { kind: "Name", value: "currency" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MerchantPaymentMethod" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "MerchantPaymentMethod" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "methodId" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "version" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "rollingReserve" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "percentage" } },
                { kind: "Field", name: { kind: "Name", value: "rollingDays" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "statusInfo" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "WaitingForInformationMerchantPaymentMethodStatusInfo",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "verificationRequirements" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: { kind: "Name", value: "AdditionalInformationRequirements" },
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "additionalInformation" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: { kind: "Name", value: "MerchantRequirements" },
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  { kind: "Field", name: { kind: "Name", value: "fields" } },
                                ],
                              },
                            },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: {
                                  kind: "Name",
                                  value: "OtherAdditionalInformationRequirements",
                                },
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "otherAdditionalInformation" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: { kind: "Name", value: "SupportingDocumentRequirements" },
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "supportingDocumentPurposes" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "SepaDirectDebitB2BMerchantPaymentMethod" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "sepaCreditorIdentifier" } },
                { kind: "Field", name: { kind: "Name", value: "useSwanSepaCreditorIdentifier" } },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "SepaDirectDebitCoreMerchantPaymentMethod" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "sepaCreditorIdentifier" } },
                { kind: "Field", name: { kind: "Name", value: "useSwanSepaCreditorIdentifier" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MerchantProfileFragment, unknown>;
export const FnciInfoFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FnciInfo" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "FnciInfo" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "colorCode" } },
          { kind: "Field", name: { kind: "Name", value: "cpt1" } },
          { kind: "Field", name: { kind: "Name", value: "cpt2" } },
          { kind: "Field", name: { kind: "Name", value: "cpt3" } },
          { kind: "Field", name: { kind: "Name", value: "holderEstablishment" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FnciInfoFragment, unknown>;
export const VerifyBeneficiarySuccessPayloadFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "VerifyBeneficiarySuccessPayload" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "VerifyBeneficiarySuccessPayload" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "expiresAt" } },
          { kind: "Field", name: { kind: "Name", value: "beneficiaryVerificationToken" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "verifyBeneficiaryResult" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "VerifyBeneficiaryCloseMatch" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "nameSuggestion" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<VerifyBeneficiarySuccessPayloadFragment, unknown>;
export const SupportingDocumentRenewalFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SupportingDocumentRenewal" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "SupportingDocumentCollection" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "supportingDocuments" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "statusInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "status" } },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "SupportingDocumentRefusedStatusInfo" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "filename" } },
                            { kind: "Field", name: { kind: "Name", value: "reason" } },
                            { kind: "Field", name: { kind: "Name", value: "reasonCode" } },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "SupportingDocumentUploadedStatusInfo" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "filename" } },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "supportingDocumentPurpose" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "requiredSupportingDocumentPurposes" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "label" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "statusInfo" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "requiredSupportingDocumentPurposes" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "acceptableSupportingDocumentTypes" },
                },
                { kind: "Field", name: { kind: "Name", value: "label" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SupportingDocumentRenewalFragment, unknown>;
export const AddressInfoFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AddressInfo" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "AddressInfo" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "addressLine1" } },
          { kind: "Field", name: { kind: "Name", value: "addressLine2" } },
          { kind: "Field", name: { kind: "Name", value: "city" } },
          { kind: "Field", name: { kind: "Name", value: "country" } },
          { kind: "Field", name: { kind: "Name", value: "postalCode" } },
          { kind: "Field", name: { kind: "Name", value: "state" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AddressInfoFragment, unknown>;
export const VerificationRenewalUboFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "VerificationRenewalUBO" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "VerificationRenewalUltimateBeneficialOwner" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "address" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "FragmentSpread", name: { kind: "Name", value: "AddressInfo" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "taxIdentificationNumber" } },
          { kind: "Field", name: { kind: "Name", value: "firstName" } },
          { kind: "Field", name: { kind: "Name", value: "lastName" } },
          { kind: "Field", name: { kind: "Name", value: "sex" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "ownership" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "totalPercentage" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "birthInfo" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "city" } },
                { kind: "Field", name: { kind: "Name", value: "country" } },
                { kind: "Field", name: { kind: "Name", value: "birthDate" } },
                { kind: "Field", name: { kind: "Name", value: "postalCode" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "qualificationType" } },
          { kind: "Field", name: { kind: "Name", value: "taxIdentificationNumber" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AddressInfo" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "AddressInfo" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "addressLine1" } },
          { kind: "Field", name: { kind: "Name", value: "addressLine2" } },
          { kind: "Field", name: { kind: "Name", value: "city" } },
          { kind: "Field", name: { kind: "Name", value: "country" } },
          { kind: "Field", name: { kind: "Name", value: "postalCode" } },
          { kind: "Field", name: { kind: "Name", value: "state" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<VerificationRenewalUboFragment, unknown>;
export const CompanyRenewalInfoFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CompanyRenewalInfo" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CompanyVerificationRenewalInfo" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "additionalDetails" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "company" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "residencyAddress" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "addressLine1" } },
                      { kind: "Field", name: { kind: "Name", value: "addressLine2" } },
                      { kind: "Field", name: { kind: "Name", value: "city" } },
                      { kind: "Field", name: { kind: "Name", value: "postalCode" } },
                      { kind: "Field", name: { kind: "Name", value: "country" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "businessActivityDescription" } },
                { kind: "Field", name: { kind: "Name", value: "monthlyPaymentVolume" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "ultimateBeneficialOwners" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "VerificationRenewalUBO" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "accountAdmin" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "firstName" } },
                { kind: "Field", name: { kind: "Name", value: "lastName" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "birthInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "city" } },
                      { kind: "Field", name: { kind: "Name", value: "country" } },
                      { kind: "Field", name: { kind: "Name", value: "birthDate" } },
                      { kind: "Field", name: { kind: "Name", value: "postalCode" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "typeOfRepresentation" } },
                { kind: "Field", name: { kind: "Name", value: "email" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AddressInfo" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "AddressInfo" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "addressLine1" } },
          { kind: "Field", name: { kind: "Name", value: "addressLine2" } },
          { kind: "Field", name: { kind: "Name", value: "city" } },
          { kind: "Field", name: { kind: "Name", value: "country" } },
          { kind: "Field", name: { kind: "Name", value: "postalCode" } },
          { kind: "Field", name: { kind: "Name", value: "state" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "VerificationRenewalUBO" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "VerificationRenewalUltimateBeneficialOwner" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "address" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "FragmentSpread", name: { kind: "Name", value: "AddressInfo" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "taxIdentificationNumber" } },
          { kind: "Field", name: { kind: "Name", value: "firstName" } },
          { kind: "Field", name: { kind: "Name", value: "lastName" } },
          { kind: "Field", name: { kind: "Name", value: "sex" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "ownership" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "totalPercentage" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "birthInfo" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "city" } },
                { kind: "Field", name: { kind: "Name", value: "country" } },
                { kind: "Field", name: { kind: "Name", value: "birthDate" } },
                { kind: "Field", name: { kind: "Name", value: "postalCode" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "qualificationType" } },
          { kind: "Field", name: { kind: "Name", value: "taxIdentificationNumber" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CompanyRenewalInfoFragment, unknown>;
export const IndividualRenewalInfoFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "IndividualRenewalInfo" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "IndividualVerificationRenewalInfo" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "additionalDetails" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "accountAdmin" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "firstName" } },
                { kind: "Field", name: { kind: "Name", value: "lastName" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "residencyAddress" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "addressLine1" } },
                      { kind: "Field", name: { kind: "Name", value: "addressLine2" } },
                      { kind: "Field", name: { kind: "Name", value: "city" } },
                      { kind: "Field", name: { kind: "Name", value: "postalCode" } },
                      { kind: "Field", name: { kind: "Name", value: "state" } },
                      { kind: "Field", name: { kind: "Name", value: "country" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "employmentStatus" } },
                { kind: "Field", name: { kind: "Name", value: "monthlyIncome" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<IndividualRenewalInfoFragment, unknown>;
export const AuthStatusDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AuthStatus" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AuthStatusQuery, AuthStatusQueryVariables>;
export const LastIdentificationDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "LastIdentification" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "accountMembershipId" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "accountMembership" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: { kind: "Variable", name: { kind: "Name", value: "accountMembershipId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "user" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "identifications" },
                        arguments: [
                          {
                            kind: "Argument",
                            name: { kind: "Name", value: "first" },
                            value: { kind: "IntValue", value: "1" },
                          },
                          {
                            kind: "Argument",
                            name: { kind: "Name", value: "orderBy" },
                            value: {
                              kind: "ObjectValue",
                              fields: [
                                {
                                  kind: "ObjectField",
                                  name: { kind: "Name", value: "field" },
                                  value: { kind: "EnumValue", value: "updatedAt" },
                                },
                                {
                                  kind: "ObjectField",
                                  name: { kind: "Name", value: "direction" },
                                  value: { kind: "EnumValue", value: "Desc" },
                                },
                              ],
                            },
                          },
                        ],
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "edges" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "node" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "__typename" },
                                        },
                                        {
                                          kind: "FragmentSpread",
                                          name: { kind: "Name", value: "Identification" },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "IdentificationLevelFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "IdentificationLevelStatusInfo" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "NotSupportedIdentificationLevelStatusInfo" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "StartedIdentificationLevelStatusInfo" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "PendingIdentificationLevelStatusInfo" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "ValidIdentificationLevelStatusInfo" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "InvalidIdentificationLevelStatusInfo" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "reasons" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "CanceledIdentificationLevelStatusInfo" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "ExpiredIdentificationLevelStatusInfo" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                { kind: "Field", name: { kind: "Name", value: "expiredAt" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Identification" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Identification" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "levels" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "expert" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "IdentificationLevelFragment" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pvid" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "IdentificationLevelFragment" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "qes" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "IdentificationLevelFragment" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "process" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<LastIdentificationQuery, LastIdentificationQueryVariables>;
export const AccountAreaDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AccountArea" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "accountMembershipId" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "accountMembership" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: { kind: "Variable", name: { kind: "Name", value: "accountMembershipId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "AccountMembershipPermissions" },
                },
                { kind: "FragmentSpread", name: { kind: "Name", value: "AccountMembership" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "account" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "statusInfo" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "status" } },
                          ],
                        },
                      },
                      { kind: "Field", name: { kind: "Name", value: "IBAN" } },
                      { kind: "Field", name: { kind: "Name", value: "bankDetails" } },
                      { kind: "Field", name: { kind: "Name", value: "language" } },
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "paymentLevel" } },
                      { kind: "Field", name: { kind: "Name", value: "paymentAccountType" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "balances" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "AccountBalances" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "holder" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "info" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  { kind: "Field", name: { kind: "Name", value: "type" } },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "supportingDocumentCollections" },
                              arguments: [
                                {
                                  kind: "Argument",
                                  name: { kind: "Name", value: "first" },
                                  value: { kind: "IntValue", value: "1" },
                                },
                              ],
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "edges" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "__typename" },
                                        },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "node" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: { kind: "Name", value: "__typename" },
                                              },
                                              {
                                                kind: "Field",
                                                name: { kind: "Name", value: "id" },
                                              },
                                              {
                                                kind: "Field",
                                                name: { kind: "Name", value: "statusInfo" },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    {
                                                      kind: "Field",
                                                      name: { kind: "Name", value: "__typename" },
                                                    },
                                                    {
                                                      kind: "Field",
                                                      name: { kind: "Name", value: "status" },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            { kind: "Field", name: { kind: "Name", value: "verificationStatus" } },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "transactions" },
                        arguments: [
                          {
                            kind: "Argument",
                            name: { kind: "Name", value: "first" },
                            value: { kind: "IntValue", value: "0" },
                          },
                        ],
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "totalCount" } },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        alias: { kind: "Name", value: "accountMembershipsWithBindingUserError" },
                        name: { kind: "Name", value: "memberships" },
                        arguments: [
                          {
                            kind: "Argument",
                            name: { kind: "Name", value: "first" },
                            value: { kind: "IntValue", value: "0" },
                          },
                          {
                            kind: "Argument",
                            name: { kind: "Name", value: "filters" },
                            value: {
                              kind: "ObjectValue",
                              fields: [
                                {
                                  kind: "ObjectField",
                                  name: { kind: "Name", value: "status" },
                                  value: {
                                    kind: "ListValue",
                                    values: [{ kind: "EnumValue", value: "BindingUserError" }],
                                  },
                                },
                              ],
                            },
                          },
                        ],
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "totalCount" } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "user" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "accountMemberships" },
                        arguments: [
                          {
                            kind: "Argument",
                            name: { kind: "Name", value: "first" },
                            value: { kind: "IntValue", value: "0" },
                          },
                        ],
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "totalCount" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "projectInfo" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "accentColor" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "logoUri" } },
                { kind: "Field", name: { kind: "Name", value: "B2BMembershipIDVerification" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "webBankingSettings" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "WebBankingSettings" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "supportingDocumentSettings" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "collectMode" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstName" } },
                { kind: "Field", name: { kind: "Name", value: "preferredLastName" } },
                { kind: "Field", name: { kind: "Name", value: "fullName" } },
                { kind: "Field", name: { kind: "Name", value: "mobilePhoneNumber" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "identificationLevels" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "IdentificationLevelsFragment" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AccountHolderForCardSettings" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "AccountHolder" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "info" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AccountMembershipPermissions" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "AccountMembership" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "canViewAccount" } },
          { kind: "Field", name: { kind: "Name", value: "canManageBeneficiaries" } },
          { kind: "Field", name: { kind: "Name", value: "canInitiatePayments" } },
          { kind: "Field", name: { kind: "Name", value: "canManageAccountMembership" } },
          { kind: "Field", name: { kind: "Name", value: "canManageCards" } },
          { kind: "Field", name: { kind: "Name", value: "legalRepresentative" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "statusInfo" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
              ],
            },
          },
          {
            kind: "Field",
            alias: { kind: "Name", value: "allCards" },
            name: { kind: "Name", value: "cards" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "statuses" },
                      value: {
                        kind: "ListValue",
                        values: [
                          { kind: "EnumValue", value: "Enabled" },
                          { kind: "EnumValue", value: "Processing" },
                          { kind: "EnumValue", value: "Canceling" },
                          { kind: "EnumValue", value: "Canceled" },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "totalCount" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "account" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "statusInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "status" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "paymentLevel" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "merchantProfiles" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "first" },
                      value: { kind: "IntValue", value: "0" },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "totalCount" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AccountMembership" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "AccountMembership" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "accountId" } },
          { kind: "Field", name: { kind: "Name", value: "accountCountry" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "legalRepresentative" } },
          { kind: "Field", name: { kind: "Name", value: "hasRequiredIdentificationLevel" } },
          { kind: "Field", name: { kind: "Name", value: "language" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "statusInfo" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "AccountMembershipBindingUserErrorStatusInfo" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "restrictedTo" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "birthDate" } },
                            { kind: "Field", name: { kind: "Name", value: "firstName" } },
                            { kind: "Field", name: { kind: "Name", value: "lastName" } },
                            { kind: "Field", name: { kind: "Name", value: "phoneNumber" } },
                          ],
                        },
                      },
                      { kind: "Field", name: { kind: "Name", value: "emailVerifiedMatchError" } },
                      { kind: "Field", name: { kind: "Name", value: "idVerifiedMatchError" } },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "AccountMembershipInvitationSentStatusInfo" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "restrictedTo" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "birthDate" } },
                            { kind: "Field", name: { kind: "Name", value: "firstName" } },
                            { kind: "Field", name: { kind: "Name", value: "lastName" } },
                            { kind: "Field", name: { kind: "Name", value: "phoneNumber" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "taxIdentificationNumber" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "residencyAddress" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "addressLine1" } },
                { kind: "Field", name: { kind: "Name", value: "postalCode" } },
                { kind: "Field", name: { kind: "Name", value: "city" } },
                { kind: "Field", name: { kind: "Name", value: "country" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "canInitiatePayments" } },
          { kind: "Field", name: { kind: "Name", value: "canManageCards" } },
          { kind: "Field", name: { kind: "Name", value: "canManageAccountMembership" } },
          { kind: "Field", name: { kind: "Name", value: "canManageBeneficiaries" } },
          { kind: "Field", name: { kind: "Name", value: "canViewAccount" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "birthDate" } },
                { kind: "Field", name: { kind: "Name", value: "firstName" } },
                { kind: "Field", name: { kind: "Name", value: "lastName" } },
                { kind: "Field", name: { kind: "Name", value: "birthLastName" } },
                { kind: "Field", name: { kind: "Name", value: "preferredLastName" } },
                { kind: "Field", name: { kind: "Name", value: "fullName" } },
                { kind: "Field", name: { kind: "Name", value: "mobilePhoneNumber" } },
                { kind: "Field", name: { kind: "Name", value: "verifiedEmails" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "account" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "country" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "holder" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "AccountHolderForCardSettings" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            alias: { kind: "Name", value: "activeCards" },
            name: { kind: "Name", value: "cards" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "statuses" },
                      value: {
                        kind: "ListValue",
                        values: [
                          { kind: "EnumValue", value: "Enabled" },
                          { kind: "EnumValue", value: "Processing" },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "totalCount" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AccountBalances" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "AccountBalances" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "available" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "value" } },
                { kind: "Field", name: { kind: "Name", value: "currency" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "pending" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "value" } },
                { kind: "Field", name: { kind: "Name", value: "currency" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "booked" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "value" } },
                { kind: "Field", name: { kind: "Name", value: "currency" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "reserved" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "value" } },
                { kind: "Field", name: { kind: "Name", value: "currency" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "WebBankingSettings" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "WebBankingSettings" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "canViewAccountStatement" } },
          { kind: "Field", name: { kind: "Name", value: "canViewAccountDetails" } },
          { kind: "Field", name: { kind: "Name", value: "canAddNewMembers" } },
          { kind: "Field", name: { kind: "Name", value: "canViewMembers" } },
          { kind: "Field", name: { kind: "Name", value: "canViewPaymentList" } },
          { kind: "Field", name: { kind: "Name", value: "canOrderPhysicalCards" } },
          { kind: "Field", name: { kind: "Name", value: "canInitiatePaymentsToNewBeneficiaries" } },
          { kind: "Field", name: { kind: "Name", value: "canOrderVirtualCards" } },
          { kind: "Field", name: { kind: "Name", value: "canManageVirtualIbans" } },
          { kind: "Field", name: { kind: "Name", value: "canCreateMerchantProfile" } },
          { kind: "Field", name: { kind: "Name", value: "canRequestOnlineCardsPaymentMethod" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "canRequestSepaDirectDebitCorePaymentMethod" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "canRequestSepaDirectDebitB2BPaymentMethod" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "canRequestInternalDirectDebitCorePaymentMethod" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "canRequestInternalDirectDebitB2BPaymentMethod" },
          },
          { kind: "Field", name: { kind: "Name", value: "canRequestChecksPaymentMethod" } },
          { kind: "Field", name: { kind: "Name", value: "canInitiateCheckMerchantPayments" } },
          { kind: "Field", name: { kind: "Name", value: "canCreateMerchantPaymentLinks" } },
          { kind: "Field", name: { kind: "Name", value: "canUpdateCards" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "IdentificationLevelsFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "IdentificationLevels" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "expert" } },
          { kind: "Field", name: { kind: "Name", value: "QES" } },
          { kind: "Field", name: { kind: "Name", value: "PVID" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AccountAreaQuery, AccountAreaQueryVariables>;
export const AccountDetailsIbanPageDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AccountDetailsIbanPage" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "accountId" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "account" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "accountId" },
                value: { kind: "Variable", name: { kind: "Name", value: "accountId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "IBAN" } },
                { kind: "Field", name: { kind: "Name", value: "BIC" } },
                { kind: "Field", name: { kind: "Name", value: "bankDetails" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "statusInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "status" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "holder" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "verificationStatus" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "info" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "name" } },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "residencyAddress" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "addressLine1" } },
                            { kind: "Field", name: { kind: "Name", value: "addressLine2" } },
                            { kind: "Field", name: { kind: "Name", value: "city" } },
                            { kind: "Field", name: { kind: "Name", value: "postalCode" } },
                            { kind: "Field", name: { kind: "Name", value: "country" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AccountDetailsIbanPageQuery, AccountDetailsIbanPageQueryVariables>;
export const AccountDetailsVirtualIbansPageDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AccountDetailsVirtualIbansPage" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "accountId" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "first" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "after" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "account" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "accountId" },
                value: { kind: "Variable", name: { kind: "Name", value: "accountId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "virtualIbanEntries" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "first" },
                      value: { kind: "Variable", name: { kind: "Name", value: "first" } },
                    },
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "after" },
                      value: { kind: "Variable", name: { kind: "Name", value: "after" } },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "totalCount" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "pageInfo" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "endCursor" } },
                            { kind: "Field", name: { kind: "Name", value: "hasNextPage" } },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "edges" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "node" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  { kind: "Field", name: { kind: "Name", value: "id" } },
                                  { kind: "Field", name: { kind: "Name", value: "IBAN" } },
                                  { kind: "Field", name: { kind: "Name", value: "BIC" } },
                                  { kind: "Field", name: { kind: "Name", value: "status" } },
                                  { kind: "Field", name: { kind: "Name", value: "bankDetails" } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AccountDetailsVirtualIbansPageQuery,
  AccountDetailsVirtualIbansPageQueryVariables
>;
export const AddVirtualIbanDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AddVirtualIban" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "accountId" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "addVirtualIbanEntry" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "accountId" },
                      value: { kind: "Variable", name: { kind: "Name", value: "accountId" } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "AddVirtualIbanEntrySuccessPayload" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "virtualIbanEntry" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AddVirtualIbanMutation, AddVirtualIbanMutationVariables>;
export const CancelVirtualIbanDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "CancelVirtualIban" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "virtualIbanId" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "cancelVirtualIbanEntry" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "virtualIbanEntryId" },
                      value: { kind: "Variable", name: { kind: "Name", value: "virtualIbanId" } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "CancelVirtualIbanEntrySuccessPayload" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "virtualIbanEntry" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CancelVirtualIbanMutation, CancelVirtualIbanMutationVariables>;
export const CreditLimitPageDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "CreditLimitPage" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "accountId" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "account" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "accountId" },
                value: { kind: "Variable", name: { kind: "Name", value: "accountId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "IBAN" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "legalRepresentativeMembership" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "holder" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "info" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "name" } },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "residencyAddress" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "addressLine1" } },
                            { kind: "Field", name: { kind: "Name", value: "city" } },
                            { kind: "Field", name: { kind: "Name", value: "postalCode" } },
                            { kind: "Field", name: { kind: "Name", value: "country" } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "creditLimitSettings" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "creditLimitSettingsRequests" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "edges" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "node" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "__typename" },
                                        },
                                        {
                                          kind: "FragmentSpread",
                                          name: {
                                            kind: "Name",
                                            value: "CreditLimitSettingsRequest",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "authorizedAmount" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "currency" } },
                            { kind: "Field", name: { kind: "Name", value: "value" } },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "repaymentSettings" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "repaymentCycleLength" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: { kind: "Name", value: "MonthlyPeriod" },
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "__typename" },
                                        },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "dayOfMonth" },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: { kind: "Name", value: "WeeklyPeriod" },
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "__typename" },
                                        },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "dayOfWeek" },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "repaymentMethod" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: { kind: "Name", value: "SepaDirectDebitB2b" },
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "__typename" },
                                        },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "mandate" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: { kind: "Name", value: "__typename" },
                                              },
                                              {
                                                kind: "Field",
                                                name: { kind: "Name", value: "id" },
                                              },
                                              {
                                                kind: "InlineFragment",
                                                typeCondition: {
                                                  kind: "NamedType",
                                                  name: {
                                                    kind: "Name",
                                                    value: "InternalReceivedDirectDebitMandate",
                                                  },
                                                },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    {
                                                      kind: "Field",
                                                      name: { kind: "Name", value: "__typename" },
                                                    },
                                                    {
                                                      kind: "Field",
                                                      name: { kind: "Name", value: "name" },
                                                    },
                                                    {
                                                      kind: "Field",
                                                      name: { kind: "Name", value: "iban" },
                                                    },
                                                    {
                                                      kind: "Field",
                                                      name: { kind: "Name", value: "account" },
                                                      selectionSet: {
                                                        kind: "SelectionSet",
                                                        selections: [
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "__typename",
                                                            },
                                                          },
                                                          {
                                                            kind: "Field",
                                                            name: { kind: "Name", value: "holder" },
                                                            selectionSet: {
                                                              kind: "SelectionSet",
                                                              selections: [
                                                                {
                                                                  kind: "Field",
                                                                  name: {
                                                                    kind: "Name",
                                                                    value: "__typename",
                                                                  },
                                                                },
                                                                {
                                                                  kind: "Field",
                                                                  name: {
                                                                    kind: "Name",
                                                                    value: "residencyAddress",
                                                                  },
                                                                  selectionSet: {
                                                                    kind: "SelectionSet",
                                                                    selections: [
                                                                      {
                                                                        kind: "Field",
                                                                        name: {
                                                                          kind: "Name",
                                                                          value: "__typename",
                                                                        },
                                                                      },
                                                                      {
                                                                        kind: "FragmentSpread",
                                                                        name: {
                                                                          kind: "Name",
                                                                          value: "AddressInfo",
                                                                        },
                                                                      },
                                                                    ],
                                                                  },
                                                                },
                                                              ],
                                                            },
                                                          },
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                              {
                                                kind: "InlineFragment",
                                                typeCondition: {
                                                  kind: "NamedType",
                                                  name: {
                                                    kind: "Name",
                                                    value: "SEPAReceivedDirectDebitMandate",
                                                  },
                                                },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    {
                                                      kind: "Field",
                                                      name: { kind: "Name", value: "__typename" },
                                                    },
                                                    {
                                                      kind: "Field",
                                                      name: { kind: "Name", value: "name" },
                                                    },
                                                    {
                                                      kind: "Field",
                                                      name: { kind: "Name", value: "iban" },
                                                    },
                                                    {
                                                      kind: "Field",
                                                      name: { kind: "Name", value: "account" },
                                                      selectionSet: {
                                                        kind: "SelectionSet",
                                                        selections: [
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "__typename",
                                                            },
                                                          },
                                                          {
                                                            kind: "Field",
                                                            name: { kind: "Name", value: "holder" },
                                                            selectionSet: {
                                                              kind: "SelectionSet",
                                                              selections: [
                                                                {
                                                                  kind: "Field",
                                                                  name: {
                                                                    kind: "Name",
                                                                    value: "__typename",
                                                                  },
                                                                },
                                                                {
                                                                  kind: "Field",
                                                                  name: {
                                                                    kind: "Name",
                                                                    value: "residencyAddress",
                                                                  },
                                                                  selectionSet: {
                                                                    kind: "SelectionSet",
                                                                    selections: [
                                                                      {
                                                                        kind: "Field",
                                                                        name: {
                                                                          kind: "Name",
                                                                          value: "__typename",
                                                                        },
                                                                      },
                                                                      {
                                                                        kind: "FragmentSpread",
                                                                        name: {
                                                                          kind: "Name",
                                                                          value: "AddressInfo",
                                                                        },
                                                                      },
                                                                    ],
                                                                  },
                                                                },
                                                              ],
                                                            },
                                                          },
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "currentCycle" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "startDate" } },
                            { kind: "Field", name: { kind: "Name", value: "endDate" } },
                            { kind: "Field", name: { kind: "Name", value: "status" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "owedAmount" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  { kind: "Field", name: { kind: "Name", value: "value" } },
                                  { kind: "Field", name: { kind: "Name", value: "currency" } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "cycles" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "edges" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "node" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "__typename" },
                                        },
                                        { kind: "Field", name: { kind: "Name", value: "id" } },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "startDate" },
                                        },
                                        { kind: "Field", name: { kind: "Name", value: "endDate" } },
                                        { kind: "Field", name: { kind: "Name", value: "status" } },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "owedAmount" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: { kind: "Name", value: "__typename" },
                                              },
                                              {
                                                kind: "Field",
                                                name: { kind: "Name", value: "value" },
                                              },
                                              {
                                                kind: "Field",
                                                name: { kind: "Name", value: "currency" },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "statusInfo" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "status" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CreditLimitSettingsRequest" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CreditLimitSettingsRequest" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "statusInfo" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "Field", name: { kind: "Name", value: "__typename" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "amount" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "value" } },
                { kind: "Field", name: { kind: "Name", value: "currency" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AddressInfo" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "AddressInfo" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "addressLine1" } },
          { kind: "Field", name: { kind: "Name", value: "addressLine2" } },
          { kind: "Field", name: { kind: "Name", value: "city" } },
          { kind: "Field", name: { kind: "Name", value: "country" } },
          { kind: "Field", name: { kind: "Name", value: "postalCode" } },
          { kind: "Field", name: { kind: "Name", value: "state" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreditLimitPageQuery, CreditLimitPageQueryVariables>;
export const GenerateCreditStatementDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "GenerateCreditStatement" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "GenerateCreditStatementInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "generateCreditStatement" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "CreditStatement" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "type" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: { kind: "Name", value: "PdfStatement" },
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  { kind: "Field", name: { kind: "Name", value: "url" } },
                                ],
                              },
                            },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: { kind: "Name", value: "CsvStatement" },
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  { kind: "Field", name: { kind: "Name", value: "url" } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Rejection" } },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "message" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GenerateCreditStatementMutation,
  GenerateCreditStatementMutationVariables
>;
export const AccountDetailsBillingPageDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AccountDetailsBillingPage" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "accountId" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "first" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "after" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "account" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "accountId" },
                value: { kind: "Variable", name: { kind: "Name", value: "accountId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "invoices" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "first" },
                      value: { kind: "Variable", name: { kind: "Name", value: "first" } },
                    },
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "after" },
                      value: { kind: "Variable", name: { kind: "Name", value: "after" } },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "edges" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "cursor" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "node" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  { kind: "Field", name: { kind: "Name", value: "openingDate" } },
                                  { kind: "Field", name: { kind: "Name", value: "closingDate" } },
                                  { kind: "Field", name: { kind: "Name", value: "id" } },
                                  { kind: "Field", name: { kind: "Name", value: "type" } },
                                  { kind: "Field", name: { kind: "Name", value: "name" } },
                                  { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                                  { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                                  { kind: "Field", name: { kind: "Name", value: "status" } },
                                  { kind: "Field", name: { kind: "Name", value: "url" } },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "amount" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "__typename" },
                                        },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "currency" },
                                        },
                                        { kind: "Field", name: { kind: "Name", value: "value" } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "pageInfo" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "endCursor" } },
                            { kind: "Field", name: { kind: "Name", value: "hasNextPage" } },
                          ],
                        },
                      },
                      { kind: "Field", name: { kind: "Name", value: "totalCount" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AccountDetailsBillingPageQuery,
  AccountDetailsBillingPageQueryVariables
>;
export const AccountDetailsSettingsPageDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AccountDetailsSettingsPage" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "accountId" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "filters" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "LegalDocumentsFilterInput" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "language" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "account" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "accountId" },
                value: { kind: "Variable", name: { kind: "Name", value: "accountId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "country" } },
                { kind: "Field", name: { kind: "Name", value: "language" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "legalDocuments" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "first" },
                      value: { kind: "IntValue", value: "1" },
                    },
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "filters" },
                      value: { kind: "Variable", name: { kind: "Name", value: "filters" } },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "edges" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "node" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  { kind: "Field", name: { kind: "Name", value: "id" } },
                                  { kind: "Field", name: { kind: "Name", value: "type" } },
                                  { kind: "Field", name: { kind: "Name", value: "url" } },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "statusInfo" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "__typename" },
                                        },
                                        { kind: "Field", name: { kind: "Name", value: "status" } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "statusInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "status" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "holder" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "info" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: { kind: "Name", value: "AccountHolderCompanyInfo" },
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  { kind: "Field", name: { kind: "Name", value: "vatNumber" } },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "registrationNumber" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "taxIdentificationNumber" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: { kind: "Name", value: "AccountHolderIndividualInfo" },
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "taxIdentificationNumber" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "residencyAddress" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "country" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "projectInfo" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "tcuDocumentUri" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "language" },
                      value: { kind: "Variable", name: { kind: "Name", value: "language" } },
                    },
                  ],
                },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AccountDetailsSettingsPageQuery,
  AccountDetailsSettingsPageQueryVariables
>;
export const UpdateAccountLanguageDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UpdateAccountLanguage" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "language" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "AccountLanguage" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "updateAccount" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "accountId" },
                      value: { kind: "Variable", name: { kind: "Name", value: "id" } },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "language" },
                      value: { kind: "Variable", name: { kind: "Name", value: "language" } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "UpdateAccountSuccessPayload" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "account" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateAccountLanguageMutation, UpdateAccountLanguageMutationVariables>;
export const UpdateAccountDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UpdateAccount" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "updateAccountInput" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "UpdateAccountInput" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "updateAccountHolderInput" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "UpdateAccountHolderInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "updateAccount" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: { kind: "Variable", name: { kind: "Name", value: "updateAccountInput" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "UpdateAccountSuccessPayload" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "account" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "name" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "updateAccountHolder" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "updateAccountHolderInput" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "UpdateAccountHolderSuccessPayload" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "accountHolder" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateAccountMutation, UpdateAccountMutationVariables>;
export const AccountStatementsPageDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AccountStatementsPage" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "accountId" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "first" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "after" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "filters" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "StatementFiltersInput" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "account" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "accountId" },
                value: { kind: "Variable", name: { kind: "Name", value: "accountId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "number" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "holder" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "info" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "name" } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "statements" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "first" },
                      value: { kind: "Variable", name: { kind: "Name", value: "first" } },
                    },
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "after" },
                      value: { kind: "Variable", name: { kind: "Name", value: "after" } },
                    },
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "filters" },
                      value: { kind: "Variable", name: { kind: "Name", value: "filters" } },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "totalCount" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "pageInfo" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "endCursor" } },
                            { kind: "Field", name: { kind: "Name", value: "hasNextPage" } },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "edges" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "cursor" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "node" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  { kind: "Field", name: { kind: "Name", value: "id" } },
                                  { kind: "Field", name: { kind: "Name", value: "closingDate" } },
                                  { kind: "Field", name: { kind: "Name", value: "openingDate" } },
                                  { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                                  { kind: "Field", name: { kind: "Name", value: "status" } },
                                  { kind: "Field", name: { kind: "Name", value: "period" } },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "type" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "__typename" },
                                        },
                                        {
                                          kind: "InlineFragment",
                                          typeCondition: {
                                            kind: "NamedType",
                                            name: { kind: "Name", value: "PdfStatement" },
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: { kind: "Name", value: "__typename" },
                                              },
                                              {
                                                kind: "Field",
                                                name: { kind: "Name", value: "url" },
                                              },
                                            ],
                                          },
                                        },
                                        {
                                          kind: "InlineFragment",
                                          typeCondition: {
                                            kind: "NamedType",
                                            name: { kind: "Name", value: "CsvStatement" },
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: { kind: "Name", value: "__typename" },
                                              },
                                              {
                                                kind: "Field",
                                                name: { kind: "Name", value: "url" },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AccountStatementsPageQuery, AccountStatementsPageQueryVariables>;
export const CardListPageDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "CardListPage" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "filters" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "CardFiltersInput" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "first" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "after" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "cards" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: { kind: "Variable", name: { kind: "Name", value: "filters" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "orderBy" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "field" },
                      value: { kind: "EnumValue", value: "createdAt" },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "direction" },
                      value: { kind: "EnumValue", value: "Desc" },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "first" },
                value: { kind: "Variable", name: { kind: "Name", value: "first" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "after" },
                value: { kind: "Variable", name: { kind: "Name", value: "after" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "FragmentSpread", name: { kind: "Name", value: "CardListPageData" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CardListItem" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Card" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "statusInfo" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "spendingLimits" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "period" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "amount" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "currency" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "spending" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "period" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "amount" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "currency" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "physicalCard" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "statusInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "status" } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "cardDesignUrl" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "cardProduct" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "fundingType" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "insuranceSubscription" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "package" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "level" } },
                      { kind: "Field", name: { kind: "Name", value: "noticeUrl" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "accountMembership" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "account" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "number" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "holder" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "info" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  { kind: "Field", name: { kind: "Name", value: "name" } },
                                  { kind: "Field", name: { kind: "Name", value: "type" } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "statusInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: {
                            kind: "Name",
                            value: "AccountMembershipBindingUserErrorStatusInfo",
                          },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "restrictedTo" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  { kind: "Field", name: { kind: "Name", value: "firstName" } },
                                  { kind: "Field", name: { kind: "Name", value: "lastName" } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: {
                            kind: "Name",
                            value: "AccountMembershipInvitationSentStatusInfo",
                          },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "restrictedTo" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  { kind: "Field", name: { kind: "Name", value: "firstName" } },
                                  { kind: "Field", name: { kind: "Name", value: "lastName" } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "user" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "firstName" } },
                      { kind: "Field", name: { kind: "Name", value: "preferredLastName" } },
                      { kind: "Field", name: { kind: "Name", value: "fullName" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CardListPageData" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "CardConnection" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "pageInfo" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "endCursor" } },
                { kind: "Field", name: { kind: "Name", value: "hasNextPage" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "edges" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "cursor" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "node" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "FragmentSpread", name: { kind: "Name", value: "CardListItem" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CardListPageQuery, CardListPageQueryVariables>;
export const AccountMembershipCardListPageDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AccountMembershipCardListPage" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "accountMembershipId" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "filters" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "CardFiltersInput" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "first" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "after" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "accountMembership" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: { kind: "Variable", name: { kind: "Name", value: "accountMembershipId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "AccountMembershipsTotalCount" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "cards" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "filters" },
                      value: { kind: "Variable", name: { kind: "Name", value: "filters" } },
                    },
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "orderBy" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "field" },
                            value: { kind: "EnumValue", value: "createdAt" },
                          },
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "direction" },
                            value: { kind: "EnumValue", value: "Desc" },
                          },
                        ],
                      },
                    },
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "first" },
                      value: { kind: "Variable", name: { kind: "Name", value: "first" } },
                    },
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "after" },
                      value: { kind: "Variable", name: { kind: "Name", value: "after" } },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "FragmentSpread", name: { kind: "Name", value: "CardListPageData" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CardListItem" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Card" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "statusInfo" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "spendingLimits" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "period" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "amount" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "currency" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "spending" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "period" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "amount" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "currency" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "physicalCard" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "statusInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "status" } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "cardDesignUrl" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "cardProduct" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "fundingType" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "insuranceSubscription" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "package" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "level" } },
                      { kind: "Field", name: { kind: "Name", value: "noticeUrl" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "accountMembership" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "account" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "number" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "holder" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "info" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  { kind: "Field", name: { kind: "Name", value: "name" } },
                                  { kind: "Field", name: { kind: "Name", value: "type" } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "statusInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: {
                            kind: "Name",
                            value: "AccountMembershipBindingUserErrorStatusInfo",
                          },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "restrictedTo" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  { kind: "Field", name: { kind: "Name", value: "firstName" } },
                                  { kind: "Field", name: { kind: "Name", value: "lastName" } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: {
                            kind: "Name",
                            value: "AccountMembershipInvitationSentStatusInfo",
                          },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "restrictedTo" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  { kind: "Field", name: { kind: "Name", value: "firstName" } },
                                  { kind: "Field", name: { kind: "Name", value: "lastName" } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "user" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "firstName" } },
                      { kind: "Field", name: { kind: "Name", value: "preferredLastName" } },
                      { kind: "Field", name: { kind: "Name", value: "fullName" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AccountMembershipsTotalCount" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "AccountMembership" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "account" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "memberships" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "filters" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "status" },
                            value: {
                              kind: "ListValue",
                              values: [
                                { kind: "EnumValue", value: "Enabled" },
                                { kind: "EnumValue", value: "InvitationSent" },
                                { kind: "EnumValue", value: "BindingUserError" },
                                { kind: "EnumValue", value: "Suspended" },
                              ],
                            },
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "totalCount" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CardListPageData" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "CardConnection" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "pageInfo" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "endCursor" } },
                { kind: "Field", name: { kind: "Name", value: "hasNextPage" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "edges" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "cursor" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "node" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "FragmentSpread", name: { kind: "Name", value: "CardListItem" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AccountMembershipCardListPageQuery,
  AccountMembershipCardListPageQueryVariables
>;
export const CardCountDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "CardCount" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "filters" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "CardFiltersInput" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "first" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "cards" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: { kind: "Variable", name: { kind: "Name", value: "filters" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "orderBy" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "field" },
                      value: { kind: "EnumValue", value: "createdAt" },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "direction" },
                      value: { kind: "EnumValue", value: "Desc" },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "first" },
                value: { kind: "Variable", name: { kind: "Name", value: "first" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "totalCount" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "cursor" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CardCountQuery, CardCountQueryVariables>;
export const CardPageDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "CardPage" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "cardId" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "projectInfo" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "B2BMembershipIDVerification" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "card" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "cardId" },
                value: { kind: "Variable", name: { kind: "Name", value: "cardId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
                { kind: "Field", name: { kind: "Name", value: "cardMaskedNumber" } },
                { kind: "Field", name: { kind: "Name", value: "expiryDate" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "cardDesignUrl" } },
                { kind: "Field", name: { kind: "Name", value: "mainCurrency" } },
                { kind: "Field", name: { kind: "Name", value: "eCommerce" } },
                { kind: "Field", name: { kind: "Name", value: "withdrawal" } },
                { kind: "Field", name: { kind: "Name", value: "nonMainCurrencyTransactions" } },
                { kind: "Field", name: { kind: "Name", value: "international" } },
                { kind: "Field", name: { kind: "Name", value: "issuingCountry" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "insuranceSubscription" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "claimsUrl" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "package" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "name" } },
                            { kind: "Field", name: { kind: "Name", value: "level" } },
                            { kind: "Field", name: { kind: "Name", value: "noticeUrl" } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "statusInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "status" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "cardProduct" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "FragmentSpread", name: { kind: "Name", value: "CardProduct" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "accountMembership" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "canManageAccountMembership" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "hasRequiredIdentificationLevel" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "canViewAccount" } },
                      { kind: "Field", name: { kind: "Name", value: "canManageBeneficiaries" } },
                      { kind: "Field", name: { kind: "Name", value: "canInitiatePayments" } },
                      { kind: "Field", name: { kind: "Name", value: "canManageCards" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "statusInfo" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "status" } },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: {
                                  kind: "Name",
                                  value: "AccountMembershipBindingUserErrorStatusInfo",
                                },
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "idVerifiedMatchError" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "firstNameMatchError" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "lastNameMatchError" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "phoneNumberMatchError" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "emailVerifiedMatchError" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "birthDateMatchError" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "restrictedTo" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "__typename" },
                                        },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "firstName" },
                                        },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "lastName" },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: {
                                  kind: "Name",
                                  value: "AccountMembershipInvitationSentStatusInfo",
                                },
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "restrictedTo" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "__typename" },
                                        },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "firstName" },
                                        },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "lastName" },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "user" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "firstName" } },
                            { kind: "Field", name: { kind: "Name", value: "preferredLastName" } },
                            { kind: "Field", name: { kind: "Name", value: "fullName" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "identificationLevels" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  { kind: "Field", name: { kind: "Name", value: "expert" } },
                                  { kind: "Field", name: { kind: "Name", value: "QES" } },
                                  { kind: "Field", name: { kind: "Name", value: "PVID" } },
                                ],
                              },
                            },
                            { kind: "Field", name: { kind: "Name", value: "verifiedEmails" } },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "account" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "paymentLevel" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "holder" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  { kind: "Field", name: { kind: "Name", value: "id" } },
                                  {
                                    kind: "FragmentSpread",
                                    name: { kind: "Name", value: "AccountHolderForCardSettings" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "residencyAddress" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "__typename" },
                                        },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "addressLine1" },
                                        },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "addressLine2" },
                                        },
                                        { kind: "Field", name: { kind: "Name", value: "city" } },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "postalCode" },
                                        },
                                        { kind: "Field", name: { kind: "Name", value: "country" } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "spendingLimits" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "amount" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "currency" } },
                            { kind: "Field", name: { kind: "Name", value: "value" } },
                          ],
                        },
                      },
                      { kind: "Field", name: { kind: "Name", value: "period" } },
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "spending" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "amount" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "currency" } },
                            { kind: "Field", name: { kind: "Name", value: "value" } },
                          ],
                        },
                      },
                      { kind: "Field", name: { kind: "Name", value: "period" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "digitalCards" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "first" },
                      value: { kind: "IntValue", value: "100" },
                    },
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "filters" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "status" },
                            value: { kind: "StringValue", value: "Enabled", block: false },
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "edges" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "node" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  {
                                    kind: "FragmentSpread",
                                    name: { kind: "Name", value: "DigitalCard" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "transactions" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "first" },
                      value: { kind: "IntValue", value: "1" },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "totalCount" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "physicalCard" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "expiryDate" } },
                      { kind: "Field", name: { kind: "Name", value: "cardMaskedNumber" } },
                      { kind: "Field", name: { kind: "Name", value: "identifier" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "statusInfo" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "status" } },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: { kind: "Name", value: "PhysicalCardToActivateStatusInfo" },
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  { kind: "Field", name: { kind: "Name", value: "isPINReady" } },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "estimatedDeliveryDate" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "trackingNumber" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "shippingProvider" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "address" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "__typename" },
                                        },
                                        {
                                          kind: "FragmentSpread",
                                          name: { kind: "Name", value: "AddressDetails" },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: { kind: "Name", value: "PhysicalCardRenewedStatusInfo" },
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  { kind: "Field", name: { kind: "Name", value: "isPINReady" } },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "estimatedDeliveryDate" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "trackingNumber" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "shippingProvider" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "address" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "__typename" },
                                        },
                                        {
                                          kind: "FragmentSpread",
                                          name: { kind: "Name", value: "AddressDetails" },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: {
                                  kind: "Name",
                                  value: "PhysicalCardConsentPendingStatusInfo",
                                },
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "consent" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "__typename" },
                                        },
                                        { kind: "Field", name: { kind: "Name", value: "id" } },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "consentUrl" },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: { kind: "Name", value: "PhysicalCardToRenewStatusInfo" },
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "address" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "__typename" },
                                        },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "addressLine1" },
                                        },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "addressLine2" },
                                        },
                                        { kind: "Field", name: { kind: "Name", value: "city" } },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "postalCode" },
                                        },
                                        { kind: "Field", name: { kind: "Name", value: "country" } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "previousPhysicalCards" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "cardMaskedNumber" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "customOptions" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "additionalPrintedLine" },
                                  },
                                ],
                              },
                            },
                            { kind: "Field", name: { kind: "Name", value: "expiryDate" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "offlineSpendingLimit" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  { kind: "Field", name: { kind: "Name", value: "currency" } },
                                  { kind: "Field", name: { kind: "Name", value: "value" } },
                                ],
                              },
                            },
                            { kind: "Field", name: { kind: "Name", value: "isExpired" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CardInsurancePackage" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "CardInsurancePackage" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "level" } },
          { kind: "Field", name: { kind: "Name", value: "noticeUrl" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CardProduct" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "CardProduct" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "fundingType" } },
          { kind: "Field", name: { kind: "Name", value: "projectId" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "applicableToPhysicalCards" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "companySpendingLimit" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "amount" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                      { kind: "Field", name: { kind: "Name", value: "currency" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "period" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "individualSpendingLimit" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "amount" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                      { kind: "Field", name: { kind: "Name", value: "currency" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "period" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "cardDesigns" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "version" } },
                { kind: "Field", name: { kind: "Name", value: "cardProjectLogoSvgUrl" } },
                { kind: "Field", name: { kind: "Name", value: "cardProjectLogo300dpiUrl" } },
                { kind: "Field", name: { kind: "Name", value: "cardProjectLogo600dpiUrl" } },
                { kind: "Field", name: { kind: "Name", value: "zoomRatioProjectLogo" } },
                { kind: "Field", name: { kind: "Name", value: "cardDesignUrl" } },
                { kind: "Field", name: { kind: "Name", value: "accentColor" } },
                { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "cardBackground" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                      { kind: "Field", name: { kind: "Name", value: "cardTextColor" } },
                      { kind: "Field", name: { kind: "Name", value: "cardBackgroundUrl" } },
                      { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                      { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "insurance" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "defaultInsurancePackage" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "CardInsurancePackage" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "availableInsurancePackages" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "CardInsurancePackage" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultCardProduct" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AccountHolderForCardSettings" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "AccountHolder" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "info" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "DigitalCard" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "DigitalCard" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "walletProvider" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "CompleteDigitalCard" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "device" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AddressDetails" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Address" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "addressLine1" } },
          { kind: "Field", name: { kind: "Name", value: "addressLine2" } },
          { kind: "Field", name: { kind: "Name", value: "city" } },
          { kind: "Field", name: { kind: "Name", value: "country" } },
          { kind: "Field", name: { kind: "Name", value: "postalCode" } },
          { kind: "Field", name: { kind: "Name", value: "state" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CardPageQuery, CardPageQueryVariables>;
export const CardTransactionsPageDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "CardTransactionsPage" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "cardId" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "first" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "canQueryCardOnTransaction" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "after" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "filters" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "TransactionsFiltersInput" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "card" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "cardId" },
                value: { kind: "Variable", name: { kind: "Name", value: "cardId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "cardDesignUrl" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "statusInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "status" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "accountMembership" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "statusInfo" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: {
                                  kind: "Name",
                                  value: "AccountMembershipBindingUserErrorStatusInfo",
                                },
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "restrictedTo" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "__typename" },
                                        },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "firstName" },
                                        },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "lastName" },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: {
                                  kind: "Name",
                                  value: "AccountMembershipInvitationSentStatusInfo",
                                },
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "restrictedTo" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "__typename" },
                                        },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "firstName" },
                                        },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "lastName" },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "user" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "firstName" } },
                            { kind: "Field", name: { kind: "Name", value: "preferredLastName" } },
                            { kind: "Field", name: { kind: "Name", value: "fullName" } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "transactions" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "first" },
                      value: { kind: "Variable", name: { kind: "Name", value: "first" } },
                    },
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "after" },
                      value: { kind: "Variable", name: { kind: "Name", value: "after" } },
                    },
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "filters" },
                      value: { kind: "Variable", name: { kind: "Name", value: "filters" } },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "pageInfo" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "endCursor" } },
                            { kind: "Field", name: { kind: "Name", value: "hasNextPage" } },
                          ],
                        },
                      },
                      { kind: "Field", name: { kind: "Name", value: "totalCount" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "edges" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "node" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  {
                                    kind: "FragmentSpread",
                                    name: { kind: "Name", value: "TransactionDetails" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AddressDetails" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Address" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "addressLine1" } },
          { kind: "Field", name: { kind: "Name", value: "addressLine2" } },
          { kind: "Field", name: { kind: "Name", value: "city" } },
          { kind: "Field", name: { kind: "Name", value: "country" } },
          { kind: "Field", name: { kind: "Name", value: "postalCode" } },
          { kind: "Field", name: { kind: "Name", value: "state" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TrustedBeneficiaryDetails" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "TrustedBeneficiary" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "label" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "statusInfo" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "TrustedInternalBeneficiary" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "accountId" } },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "TrustedInternationalBeneficiary" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "currency" } },
                { kind: "Field", name: { kind: "Name", value: "route" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "details" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "key" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "TrustedSepaBeneficiary" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "iban" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "address" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "FragmentSpread", name: { kind: "Name", value: "AddressDetails" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TransactionDetails" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Transaction" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "side" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "label" } },
          { kind: "Field", name: { kind: "Name", value: "counterparty" } },
          { kind: "Field", name: { kind: "Name", value: "reference" } },
          { kind: "Field", name: { kind: "Name", value: "externalReference" } },
          { kind: "Field", name: { kind: "Name", value: "statementCanBeGenerated" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "payment" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "createdAt" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "originTransaction" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
                { kind: "Field", name: { kind: "Name", value: "executionDate" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "amount" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "currency" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "statusInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "status" } },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "RejectedTransactionStatusInfo" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "status" } },
                            { kind: "Field", name: { kind: "Name", value: "reason" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "statusInfo" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "BookedTransactionStatusInfo" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "bookingDate" } },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "PendingTransactionStatusInfo" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "pendingEndDate" } },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "CanceledTransactionStatusInfo" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "canceledDate" } },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "RejectedTransactionStatusInfo" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "reason" } },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "UpcomingTransactionStatusInfo" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "executionDate" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "amount" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "currency" } },
                { kind: "Field", name: { kind: "Name", value: "value" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "executionDate" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "InlineFragment",
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "CardTransaction" } },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "originalAmount" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "currency" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "reservedAmount" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "currency" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "reservedAmountReleasedAt" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "cardDetails" },
                  directives: [
                    {
                      kind: "Directive",
                      name: { kind: "Name", value: "include" },
                      arguments: [
                        {
                          kind: "Argument",
                          name: { kind: "Name", value: "if" },
                          value: {
                            kind: "Variable",
                            name: { kind: "Name", value: "canQueryCardOnTransaction" },
                          },
                        },
                      ],
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "CardOutDetails" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "maskedPan" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "card" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  { kind: "Field", name: { kind: "Name", value: "id" } },
                                  { kind: "Field", name: { kind: "Name", value: "name" } },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "accountMembership" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "__typename" },
                                        },
                                        { kind: "Field", name: { kind: "Name", value: "id" } },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "user" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: { kind: "Name", value: "__typename" },
                                              },
                                              {
                                                kind: "Field",
                                                name: { kind: "Name", value: "id" },
                                              },
                                              {
                                                kind: "Field",
                                                name: { kind: "Name", value: "firstName" },
                                              },
                                              {
                                                kind: "Field",
                                                name: { kind: "Name", value: "preferredLastName" },
                                              },
                                              {
                                                kind: "Field",
                                                name: { kind: "Name", value: "fullName" },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "CardInDetails" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "paymentMandate" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  { kind: "Field", name: { kind: "Name", value: "id" } },
                                  { kind: "Field", name: { kind: "Name", value: "name" } },
                                  { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                                  { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                                  { kind: "Field", name: { kind: "Name", value: "executedAt" } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "merchant" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "CardOutMerchant" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "merchantId" } },
                            { kind: "Field", name: { kind: "Name", value: "merchantCity" } },
                            { kind: "Field", name: { kind: "Name", value: "merchantCountry" } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "originalAmount" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "currency" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "enrichedTransactionInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "enrichedMerchantName" } },
                      { kind: "Field", name: { kind: "Name", value: "isSubscription" } },
                      { kind: "Field", name: { kind: "Name", value: "carbonFootprint" } },
                      { kind: "Field", name: { kind: "Name", value: "contactEmail" } },
                      { kind: "Field", name: { kind: "Name", value: "contactPhone" } },
                      { kind: "Field", name: { kind: "Name", value: "contactWebsite" } },
                      { kind: "Field", name: { kind: "Name", value: "logoUrl" } },
                      { kind: "Field", name: { kind: "Name", value: "category" } },
                      { kind: "Field", name: { kind: "Name", value: "subcategory" } },
                      { kind: "Field", name: { kind: "Name", value: "address" } },
                      { kind: "Field", name: { kind: "Name", value: "city" } },
                      { kind: "Field", name: { kind: "Name", value: "postalCode" } },
                      { kind: "Field", name: { kind: "Name", value: "country" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "currencyExchange" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "exchangeRate" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "SEPACreditTransferTransaction" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "creditor" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "IBAN" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "debtor" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "IBAN" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "beneficiary" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "TrustedBeneficiary" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "TrustedBeneficiaryDetails" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "UnsavedSepaBeneficiary" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "name" } },
                            { kind: "Field", name: { kind: "Name", value: "iban" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "address" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  {
                                    kind: "FragmentSpread",
                                    name: { kind: "Name", value: "AddressDetails" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "InternalDirectDebitTransaction" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "reservedAmount" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "currency" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "reservedAmountReleasedAt" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "creditor" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "accountId" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "mandate" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "FeeTransaction" } },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "feesType" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "creditor" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "originTransaction" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "label" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "statusInfo" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "status" } },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: { kind: "Name", value: "RejectedTransactionStatusInfo" },
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  { kind: "Field", name: { kind: "Name", value: "reason" } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                      { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                      { kind: "Field", name: { kind: "Name", value: "executionDate" } },
                      { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "amount" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "currency" } },
                            { kind: "Field", name: { kind: "Name", value: "value" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "SEPADirectDebitTransaction" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "reservedAmountReleasedAt" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "creditor" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "IBAN" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "debtor" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "IBAN" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "reservedAmount" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                      { kind: "Field", name: { kind: "Name", value: "currency" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "mandate" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "SEPAReceivedDirectDebitMandate" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "ultimateCreditorName" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "SEPAPaymentDirectDebitMandate" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "debtor" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  { kind: "Field", name: { kind: "Name", value: "name" } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "InternationalCreditTransferTransaction" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "creditor" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "InternationalCreditTransferInCreditor" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "name" } },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "InternationalCreditTransferOutCreditor" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "name" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "details" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  { kind: "Field", name: { kind: "Name", value: "key" } },
                                  { kind: "Field", name: { kind: "Name", value: "value" } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "reference" } },
                { kind: "Field", name: { kind: "Name", value: "paymentProduct" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "statusInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "status" } },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "RejectedTransactionStatusInfo" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "reason" } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  alias: { kind: "Name", value: "internationalCurrencyExchange" },
                  name: { kind: "Name", value: "currencyExchange" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "exchangeRate" } },
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "sourceAmount" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "currency" } },
                            { kind: "Field", name: { kind: "Name", value: "value" } },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "targetAmount" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "currency" } },
                            { kind: "Field", name: { kind: "Name", value: "value" } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "beneficiary" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "currency" } },
                      { kind: "Field", name: { kind: "Name", value: "route" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "details" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "key" } },
                            { kind: "Field", name: { kind: "Name", value: "value" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "InternalCreditTransfer" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "creditor" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "CheckTransaction" } },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "reservedAmount" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "currency" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "reservedAmountReleasedAt" } },
                { kind: "Field", name: { kind: "Name", value: "cmc7" } },
                { kind: "Field", name: { kind: "Name", value: "rlmcKey" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CardTransactionsPageQuery, CardTransactionsPageQueryVariables>;
export const PrintPhysicalCardDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "PrintPhysicalCard" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "PrintPhysicalCardInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "printPhysicalCard" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "PrintPhysicalCardSuccessPayload" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "physicalCard" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "statusInfo" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: {
                                        kind: "Name",
                                        value: "PhysicalCardConsentPendingStatusInfo",
                                      },
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "__typename" },
                                        },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "consent" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: { kind: "Name", value: "__typename" },
                                              },
                                              {
                                                kind: "Field",
                                                name: { kind: "Name", value: "id" },
                                              },
                                              {
                                                kind: "Field",
                                                name: { kind: "Name", value: "consentUrl" },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PrintPhysicalCardMutation, PrintPhysicalCardMutationVariables>;
export const ConsentCallbackPageDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "ConsentCallbackPage" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "consentId" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "consent" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: { kind: "Variable", name: { kind: "Name", value: "consentId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ConsentCallbackPageQuery, ConsentCallbackPageQueryVariables>;
export const StandingOrdersHistoryPageDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "StandingOrdersHistoryPage" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "standingOrderId" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "first" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "canQueryCardOnTransaction" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "after" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "filters" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "PaymentFiltersInput" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "orderBy" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "PaymentOrderByInput" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "standingOrder" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "standingOrderId" },
                value: { kind: "Variable", name: { kind: "Name", value: "standingOrderId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "label" } },
                { kind: "Field", name: { kind: "Name", value: "reference" } },
                { kind: "Field", name: { kind: "Name", value: "period" } },
                { kind: "Field", name: { kind: "Name", value: "firstExecutionDate" } },
                { kind: "Field", name: { kind: "Name", value: "lastExecutionDate" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "statusInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "status" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "targetAvailableBalance" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "amount" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sepaBeneficiary" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "payments" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "first" },
                      value: { kind: "Variable", name: { kind: "Name", value: "first" } },
                    },
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "after" },
                      value: { kind: "Variable", name: { kind: "Name", value: "after" } },
                    },
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "filters" },
                      value: { kind: "Variable", name: { kind: "Name", value: "filters" } },
                    },
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "orderBy" },
                      value: { kind: "Variable", name: { kind: "Name", value: "orderBy" } },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "pageInfo" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "endCursor" } },
                            { kind: "Field", name: { kind: "Name", value: "hasNextPage" } },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "edges" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "node" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  { kind: "Field", name: { kind: "Name", value: "id" } },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "transactions" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "__typename" },
                                        },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "pageInfo" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: { kind: "Name", value: "__typename" },
                                              },
                                              {
                                                kind: "Field",
                                                name: { kind: "Name", value: "endCursor" },
                                              },
                                              {
                                                kind: "Field",
                                                name: { kind: "Name", value: "hasNextPage" },
                                              },
                                            ],
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "edges" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: { kind: "Name", value: "__typename" },
                                              },
                                              {
                                                kind: "Field",
                                                name: { kind: "Name", value: "node" },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    {
                                                      kind: "Field",
                                                      name: { kind: "Name", value: "__typename" },
                                                    },
                                                    {
                                                      kind: "FragmentSpread",
                                                      name: {
                                                        kind: "Name",
                                                        value: "TransactionDetails",
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "totalCount" },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AddressDetails" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Address" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "addressLine1" } },
          { kind: "Field", name: { kind: "Name", value: "addressLine2" } },
          { kind: "Field", name: { kind: "Name", value: "city" } },
          { kind: "Field", name: { kind: "Name", value: "country" } },
          { kind: "Field", name: { kind: "Name", value: "postalCode" } },
          { kind: "Field", name: { kind: "Name", value: "state" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TrustedBeneficiaryDetails" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "TrustedBeneficiary" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "label" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "statusInfo" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "TrustedInternalBeneficiary" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "accountId" } },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "TrustedInternationalBeneficiary" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "currency" } },
                { kind: "Field", name: { kind: "Name", value: "route" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "details" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "key" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "TrustedSepaBeneficiary" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "iban" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "address" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "FragmentSpread", name: { kind: "Name", value: "AddressDetails" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TransactionDetails" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Transaction" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "side" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "label" } },
          { kind: "Field", name: { kind: "Name", value: "counterparty" } },
          { kind: "Field", name: { kind: "Name", value: "reference" } },
          { kind: "Field", name: { kind: "Name", value: "externalReference" } },
          { kind: "Field", name: { kind: "Name", value: "statementCanBeGenerated" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "payment" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "createdAt" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "originTransaction" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
                { kind: "Field", name: { kind: "Name", value: "executionDate" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "amount" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "currency" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "statusInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "status" } },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "RejectedTransactionStatusInfo" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "status" } },
                            { kind: "Field", name: { kind: "Name", value: "reason" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "statusInfo" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "BookedTransactionStatusInfo" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "bookingDate" } },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "PendingTransactionStatusInfo" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "pendingEndDate" } },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "CanceledTransactionStatusInfo" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "canceledDate" } },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "RejectedTransactionStatusInfo" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "reason" } },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "UpcomingTransactionStatusInfo" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "executionDate" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "amount" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "currency" } },
                { kind: "Field", name: { kind: "Name", value: "value" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "executionDate" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "InlineFragment",
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "CardTransaction" } },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "originalAmount" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "currency" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "reservedAmount" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "currency" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "reservedAmountReleasedAt" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "cardDetails" },
                  directives: [
                    {
                      kind: "Directive",
                      name: { kind: "Name", value: "include" },
                      arguments: [
                        {
                          kind: "Argument",
                          name: { kind: "Name", value: "if" },
                          value: {
                            kind: "Variable",
                            name: { kind: "Name", value: "canQueryCardOnTransaction" },
                          },
                        },
                      ],
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "CardOutDetails" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "maskedPan" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "card" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  { kind: "Field", name: { kind: "Name", value: "id" } },
                                  { kind: "Field", name: { kind: "Name", value: "name" } },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "accountMembership" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "__typename" },
                                        },
                                        { kind: "Field", name: { kind: "Name", value: "id" } },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "user" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: { kind: "Name", value: "__typename" },
                                              },
                                              {
                                                kind: "Field",
                                                name: { kind: "Name", value: "id" },
                                              },
                                              {
                                                kind: "Field",
                                                name: { kind: "Name", value: "firstName" },
                                              },
                                              {
                                                kind: "Field",
                                                name: { kind: "Name", value: "preferredLastName" },
                                              },
                                              {
                                                kind: "Field",
                                                name: { kind: "Name", value: "fullName" },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "CardInDetails" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "paymentMandate" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  { kind: "Field", name: { kind: "Name", value: "id" } },
                                  { kind: "Field", name: { kind: "Name", value: "name" } },
                                  { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                                  { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                                  { kind: "Field", name: { kind: "Name", value: "executedAt" } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "merchant" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "CardOutMerchant" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "merchantId" } },
                            { kind: "Field", name: { kind: "Name", value: "merchantCity" } },
                            { kind: "Field", name: { kind: "Name", value: "merchantCountry" } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "originalAmount" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "currency" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "enrichedTransactionInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "enrichedMerchantName" } },
                      { kind: "Field", name: { kind: "Name", value: "isSubscription" } },
                      { kind: "Field", name: { kind: "Name", value: "carbonFootprint" } },
                      { kind: "Field", name: { kind: "Name", value: "contactEmail" } },
                      { kind: "Field", name: { kind: "Name", value: "contactPhone" } },
                      { kind: "Field", name: { kind: "Name", value: "contactWebsite" } },
                      { kind: "Field", name: { kind: "Name", value: "logoUrl" } },
                      { kind: "Field", name: { kind: "Name", value: "category" } },
                      { kind: "Field", name: { kind: "Name", value: "subcategory" } },
                      { kind: "Field", name: { kind: "Name", value: "address" } },
                      { kind: "Field", name: { kind: "Name", value: "city" } },
                      { kind: "Field", name: { kind: "Name", value: "postalCode" } },
                      { kind: "Field", name: { kind: "Name", value: "country" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "currencyExchange" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "exchangeRate" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "SEPACreditTransferTransaction" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "creditor" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "IBAN" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "debtor" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "IBAN" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "beneficiary" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "TrustedBeneficiary" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "TrustedBeneficiaryDetails" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "UnsavedSepaBeneficiary" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "name" } },
                            { kind: "Field", name: { kind: "Name", value: "iban" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "address" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  {
                                    kind: "FragmentSpread",
                                    name: { kind: "Name", value: "AddressDetails" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "InternalDirectDebitTransaction" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "reservedAmount" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "currency" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "reservedAmountReleasedAt" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "creditor" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "accountId" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "mandate" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "FeeTransaction" } },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "feesType" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "creditor" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "originTransaction" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "label" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "statusInfo" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "status" } },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: { kind: "Name", value: "RejectedTransactionStatusInfo" },
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  { kind: "Field", name: { kind: "Name", value: "reason" } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                      { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                      { kind: "Field", name: { kind: "Name", value: "executionDate" } },
                      { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "amount" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "currency" } },
                            { kind: "Field", name: { kind: "Name", value: "value" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "SEPADirectDebitTransaction" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "reservedAmountReleasedAt" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "creditor" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "IBAN" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "debtor" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "IBAN" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "reservedAmount" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                      { kind: "Field", name: { kind: "Name", value: "currency" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "mandate" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "SEPAReceivedDirectDebitMandate" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "ultimateCreditorName" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "SEPAPaymentDirectDebitMandate" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "debtor" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  { kind: "Field", name: { kind: "Name", value: "name" } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "InternationalCreditTransferTransaction" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "creditor" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "InternationalCreditTransferInCreditor" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "name" } },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "InternationalCreditTransferOutCreditor" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "name" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "details" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  { kind: "Field", name: { kind: "Name", value: "key" } },
                                  { kind: "Field", name: { kind: "Name", value: "value" } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "reference" } },
                { kind: "Field", name: { kind: "Name", value: "paymentProduct" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "statusInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "status" } },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "RejectedTransactionStatusInfo" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "reason" } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  alias: { kind: "Name", value: "internationalCurrencyExchange" },
                  name: { kind: "Name", value: "currencyExchange" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "exchangeRate" } },
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "sourceAmount" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "currency" } },
                            { kind: "Field", name: { kind: "Name", value: "value" } },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "targetAmount" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "currency" } },
                            { kind: "Field", name: { kind: "Name", value: "value" } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "beneficiary" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "currency" } },
                      { kind: "Field", name: { kind: "Name", value: "route" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "details" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "key" } },
                            { kind: "Field", name: { kind: "Name", value: "value" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "InternalCreditTransfer" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "creditor" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "CheckTransaction" } },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "reservedAmount" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "currency" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "reservedAmountReleasedAt" } },
                { kind: "Field", name: { kind: "Name", value: "cmc7" } },
                { kind: "Field", name: { kind: "Name", value: "rlmcKey" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  StandingOrdersHistoryPageQuery,
  StandingOrdersHistoryPageQueryVariables
>;
export const GetStandingOrdersDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getStandingOrders" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "accountId" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "status" } },
          type: {
            kind: "ListType",
            type: {
              kind: "NonNullType",
              type: { kind: "NamedType", name: { kind: "Name", value: "StandingOrderStatus" } },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "first" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "after" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "account" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "accountId" },
                value: { kind: "Variable", name: { kind: "Name", value: "accountId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "standingOrders" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "filters" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "status" },
                            value: { kind: "Variable", name: { kind: "Name", value: "status" } },
                          },
                        ],
                      },
                    },
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "first" },
                      value: { kind: "Variable", name: { kind: "Name", value: "first" } },
                    },
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "after" },
                      value: { kind: "Variable", name: { kind: "Name", value: "after" } },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "pageInfo" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "endCursor" } },
                            { kind: "Field", name: { kind: "Name", value: "hasNextPage" } },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "edges" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "cursor" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "node" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  { kind: "Field", name: { kind: "Name", value: "id" } },
                                  { kind: "Field", name: { kind: "Name", value: "label" } },
                                  { kind: "Field", name: { kind: "Name", value: "period" } },
                                  { kind: "Field", name: { kind: "Name", value: "reference" } },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "statusInfo" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "__typename" },
                                        },
                                        { kind: "Field", name: { kind: "Name", value: "status" } },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sepaBeneficiary" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "__typename" },
                                        },
                                        { kind: "Field", name: { kind: "Name", value: "name" } },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "targetAvailableBalance" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "__typename" },
                                        },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "currency" },
                                        },
                                        { kind: "Field", name: { kind: "Name", value: "value" } },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "amount" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "__typename" },
                                        },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "currency" },
                                        },
                                        { kind: "Field", name: { kind: "Name", value: "value" } },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "lastExecutionDate" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "firstExecutionDate" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "nextExecutionDate" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "createdBy" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "__typename" },
                                        },
                                        { kind: "Field", name: { kind: "Name", value: "id" } },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "firstName" },
                                        },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "preferredLastName" },
                                        },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "fullName" },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetStandingOrdersQuery, GetStandingOrdersQueryVariables>;
export const MembershipDetailDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "MembershipDetail" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "accountMembershipId" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "projectInfo" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "B2BMembershipIDVerification" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "accountMembership" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: { kind: "Variable", name: { kind: "Name", value: "accountMembershipId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "FragmentSpread", name: { kind: "Name", value: "AccountMembership" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AccountHolderForCardSettings" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "AccountHolder" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "info" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AccountMembership" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "AccountMembership" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "accountId" } },
          { kind: "Field", name: { kind: "Name", value: "accountCountry" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "legalRepresentative" } },
          { kind: "Field", name: { kind: "Name", value: "hasRequiredIdentificationLevel" } },
          { kind: "Field", name: { kind: "Name", value: "language" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "statusInfo" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "AccountMembershipBindingUserErrorStatusInfo" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "restrictedTo" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "birthDate" } },
                            { kind: "Field", name: { kind: "Name", value: "firstName" } },
                            { kind: "Field", name: { kind: "Name", value: "lastName" } },
                            { kind: "Field", name: { kind: "Name", value: "phoneNumber" } },
                          ],
                        },
                      },
                      { kind: "Field", name: { kind: "Name", value: "emailVerifiedMatchError" } },
                      { kind: "Field", name: { kind: "Name", value: "idVerifiedMatchError" } },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "AccountMembershipInvitationSentStatusInfo" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "restrictedTo" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "birthDate" } },
                            { kind: "Field", name: { kind: "Name", value: "firstName" } },
                            { kind: "Field", name: { kind: "Name", value: "lastName" } },
                            { kind: "Field", name: { kind: "Name", value: "phoneNumber" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "taxIdentificationNumber" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "residencyAddress" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "addressLine1" } },
                { kind: "Field", name: { kind: "Name", value: "postalCode" } },
                { kind: "Field", name: { kind: "Name", value: "city" } },
                { kind: "Field", name: { kind: "Name", value: "country" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "canInitiatePayments" } },
          { kind: "Field", name: { kind: "Name", value: "canManageCards" } },
          { kind: "Field", name: { kind: "Name", value: "canManageAccountMembership" } },
          { kind: "Field", name: { kind: "Name", value: "canManageBeneficiaries" } },
          { kind: "Field", name: { kind: "Name", value: "canViewAccount" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "birthDate" } },
                { kind: "Field", name: { kind: "Name", value: "firstName" } },
                { kind: "Field", name: { kind: "Name", value: "lastName" } },
                { kind: "Field", name: { kind: "Name", value: "birthLastName" } },
                { kind: "Field", name: { kind: "Name", value: "preferredLastName" } },
                { kind: "Field", name: { kind: "Name", value: "fullName" } },
                { kind: "Field", name: { kind: "Name", value: "mobilePhoneNumber" } },
                { kind: "Field", name: { kind: "Name", value: "verifiedEmails" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "account" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "country" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "holder" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "AccountHolderForCardSettings" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            alias: { kind: "Name", value: "activeCards" },
            name: { kind: "Name", value: "cards" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "statuses" },
                      value: {
                        kind: "ListValue",
                        values: [
                          { kind: "EnumValue", value: "Enabled" },
                          { kind: "EnumValue", value: "Processing" },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "totalCount" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MembershipDetailQuery, MembershipDetailQueryVariables>;
export const MembersPageDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "MembersPage" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "accountId" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "first" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "after" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "status" } },
          type: {
            kind: "ListType",
            type: {
              kind: "NonNullType",
              type: { kind: "NamedType", name: { kind: "Name", value: "AccountMembershipStatus" } },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "canManageAccountMembership" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "canManageBeneficiaries" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "canViewAccount" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "canManageCards" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "canInitiatePayments" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "search" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "accountMemberships" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "first" },
                value: { kind: "Variable", name: { kind: "Name", value: "first" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "after" },
                value: { kind: "Variable", name: { kind: "Name", value: "after" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "canManageAccountMembership" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "canManageAccountMembership" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "canManageBeneficiaries" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "canManageBeneficiaries" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "canInitiatePayments" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "canInitiatePayments" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "canViewAccount" },
                      value: { kind: "Variable", name: { kind: "Name", value: "canViewAccount" } },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "canManageCards" },
                      value: { kind: "Variable", name: { kind: "Name", value: "canManageCards" } },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "status" },
                      value: { kind: "Variable", name: { kind: "Name", value: "status" } },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "search" },
                      value: { kind: "Variable", name: { kind: "Name", value: "search" } },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "accountId" },
                      value: { kind: "Variable", name: { kind: "Name", value: "accountId" } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "totalCount" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pageInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "endCursor" } },
                      { kind: "Field", name: { kind: "Name", value: "hasNextPage" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "cursor" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "AccountMembership" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "account" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "accountId" },
                value: { kind: "Variable", name: { kind: "Name", value: "accountId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "number" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "statusInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "status" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "holder" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "info" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "name" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AccountHolderForCardSettings" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "AccountHolder" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "info" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AccountMembership" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "AccountMembership" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "accountId" } },
          { kind: "Field", name: { kind: "Name", value: "accountCountry" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "legalRepresentative" } },
          { kind: "Field", name: { kind: "Name", value: "hasRequiredIdentificationLevel" } },
          { kind: "Field", name: { kind: "Name", value: "language" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "statusInfo" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "AccountMembershipBindingUserErrorStatusInfo" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "restrictedTo" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "birthDate" } },
                            { kind: "Field", name: { kind: "Name", value: "firstName" } },
                            { kind: "Field", name: { kind: "Name", value: "lastName" } },
                            { kind: "Field", name: { kind: "Name", value: "phoneNumber" } },
                          ],
                        },
                      },
                      { kind: "Field", name: { kind: "Name", value: "emailVerifiedMatchError" } },
                      { kind: "Field", name: { kind: "Name", value: "idVerifiedMatchError" } },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "AccountMembershipInvitationSentStatusInfo" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "restrictedTo" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "birthDate" } },
                            { kind: "Field", name: { kind: "Name", value: "firstName" } },
                            { kind: "Field", name: { kind: "Name", value: "lastName" } },
                            { kind: "Field", name: { kind: "Name", value: "phoneNumber" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "taxIdentificationNumber" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "residencyAddress" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "addressLine1" } },
                { kind: "Field", name: { kind: "Name", value: "postalCode" } },
                { kind: "Field", name: { kind: "Name", value: "city" } },
                { kind: "Field", name: { kind: "Name", value: "country" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "canInitiatePayments" } },
          { kind: "Field", name: { kind: "Name", value: "canManageCards" } },
          { kind: "Field", name: { kind: "Name", value: "canManageAccountMembership" } },
          { kind: "Field", name: { kind: "Name", value: "canManageBeneficiaries" } },
          { kind: "Field", name: { kind: "Name", value: "canViewAccount" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "birthDate" } },
                { kind: "Field", name: { kind: "Name", value: "firstName" } },
                { kind: "Field", name: { kind: "Name", value: "lastName" } },
                { kind: "Field", name: { kind: "Name", value: "birthLastName" } },
                { kind: "Field", name: { kind: "Name", value: "preferredLastName" } },
                { kind: "Field", name: { kind: "Name", value: "fullName" } },
                { kind: "Field", name: { kind: "Name", value: "mobilePhoneNumber" } },
                { kind: "Field", name: { kind: "Name", value: "verifiedEmails" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "account" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "country" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "holder" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "AccountHolderForCardSettings" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            alias: { kind: "Name", value: "activeCards" },
            name: { kind: "Name", value: "cards" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "statuses" },
                      value: {
                        kind: "ListValue",
                        values: [
                          { kind: "EnumValue", value: "Enabled" },
                          { kind: "EnumValue", value: "Processing" },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "totalCount" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MembersPageQuery, MembersPageQueryVariables>;
export const ProfilePageDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "ProfilePage" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "projectInfo" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "B2BMembershipIDVerification" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstName" } },
                { kind: "Field", name: { kind: "Name", value: "preferredLastName" } },
                { kind: "Field", name: { kind: "Name", value: "fullName" } },
                { kind: "Field", name: { kind: "Name", value: "mobilePhoneNumber" } },
                { kind: "Field", name: { kind: "Name", value: "birthDate" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ProfilePageQuery, ProfilePageQueryVariables>;
export const AccountActivationPageDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AccountActivationPage" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "accountMembershipId" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "accountMembership" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: { kind: "Variable", name: { kind: "Name", value: "accountMembershipId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "account" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "IBAN" } },
                      { kind: "Field", name: { kind: "Name", value: "BIC" } },
                      { kind: "Field", name: { kind: "Name", value: "paymentLevel" } },
                      { kind: "Field", name: { kind: "Name", value: "paymentAccountType" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "holder" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "verificationStatusInfo" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: {
                                        kind: "Name",
                                        value:
                                          "AccountHolderWaitingForInformationVerificationStatusInfo",
                                      },
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "__typename" },
                                        },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "verificationRequirements" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: { kind: "Name", value: "__typename" },
                                              },
                                              {
                                                kind: "Field",
                                                name: { kind: "Name", value: "id" },
                                              },
                                              {
                                                kind: "Field",
                                                name: { kind: "Name", value: "type" },
                                              },
                                            ],
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "waitingForInformationAt" },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "verificationStatus" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "info" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  { kind: "Field", name: { kind: "Name", value: "name" } },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "residencyAddress" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  { kind: "Field", name: { kind: "Name", value: "country" } },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "supportingDocumentCollections" },
                              arguments: [
                                {
                                  kind: "Argument",
                                  name: { kind: "Name", value: "first" },
                                  value: { kind: "IntValue", value: "1" },
                                },
                              ],
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "edges" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "__typename" },
                                        },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "node" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: { kind: "Name", value: "__typename" },
                                              },
                                              {
                                                kind: "Field",
                                                name: { kind: "Name", value: "id" },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "requiredSupportingDocumentPurposes",
                                                },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    {
                                                      kind: "Field",
                                                      name: { kind: "Name", value: "__typename" },
                                                    },
                                                    {
                                                      kind: "Field",
                                                      name: { kind: "Name", value: "name" },
                                                    },
                                                  ],
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: { kind: "Name", value: "statusInfo" },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    {
                                                      kind: "Field",
                                                      name: { kind: "Name", value: "__typename" },
                                                    },
                                                    {
                                                      kind: "Field",
                                                      name: { kind: "Name", value: "status" },
                                                    },
                                                  ],
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "supportingDocuments",
                                                },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    {
                                                      kind: "Field",
                                                      name: { kind: "Name", value: "__typename" },
                                                    },
                                                    {
                                                      kind: "Field",
                                                      name: { kind: "Name", value: "id" },
                                                    },
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "supportingDocumentPurpose",
                                                      },
                                                    },
                                                    {
                                                      kind: "Field",
                                                      name: { kind: "Name", value: "statusInfo" },
                                                      selectionSet: {
                                                        kind: "SelectionSet",
                                                        selections: [
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "__typename",
                                                            },
                                                          },
                                                          {
                                                            kind: "InlineFragment",
                                                            typeCondition: {
                                                              kind: "NamedType",
                                                              name: {
                                                                kind: "Name",
                                                                value:
                                                                  "SupportingDocumentRefusedStatusInfo",
                                                              },
                                                            },
                                                            selectionSet: {
                                                              kind: "SelectionSet",
                                                              selections: [
                                                                {
                                                                  kind: "Field",
                                                                  name: {
                                                                    kind: "Name",
                                                                    value: "__typename",
                                                                  },
                                                                },
                                                                {
                                                                  kind: "Field",
                                                                  name: {
                                                                    kind: "Name",
                                                                    value: "filename",
                                                                  },
                                                                },
                                                                {
                                                                  kind: "Field",
                                                                  name: {
                                                                    kind: "Name",
                                                                    value: "reason",
                                                                  },
                                                                },
                                                                {
                                                                  kind: "Field",
                                                                  name: {
                                                                    kind: "Name",
                                                                    value: "reasonCode",
                                                                  },
                                                                },
                                                              ],
                                                            },
                                                          },
                                                          {
                                                            kind: "InlineFragment",
                                                            typeCondition: {
                                                              kind: "NamedType",
                                                              name: {
                                                                kind: "Name",
                                                                value:
                                                                  "SupportingDocumentUploadedStatusInfo",
                                                              },
                                                            },
                                                            selectionSet: {
                                                              kind: "SelectionSet",
                                                              selections: [
                                                                {
                                                                  kind: "Field",
                                                                  name: {
                                                                    kind: "Name",
                                                                    value: "__typename",
                                                                  },
                                                                },
                                                                {
                                                                  kind: "Field",
                                                                  name: {
                                                                    kind: "Name",
                                                                    value: "filename",
                                                                  },
                                                                },
                                                              ],
                                                            },
                                                          },
                                                          {
                                                            kind: "InlineFragment",
                                                            typeCondition: {
                                                              kind: "NamedType",
                                                              name: {
                                                                kind: "Name",
                                                                value:
                                                                  "SupportingDocumentValidatedStatusInfo",
                                                              },
                                                            },
                                                            selectionSet: {
                                                              kind: "SelectionSet",
                                                              selections: [
                                                                {
                                                                  kind: "Field",
                                                                  name: {
                                                                    kind: "Name",
                                                                    value: "__typename",
                                                                  },
                                                                },
                                                                {
                                                                  kind: "Field",
                                                                  name: {
                                                                    kind: "Name",
                                                                    value: "filename",
                                                                  },
                                                                },
                                                              ],
                                                            },
                                                          },
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "legalRepresentativeMembership" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "email" } },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "transactions" },
                        arguments: [
                          {
                            kind: "Argument",
                            name: { kind: "Name", value: "first" },
                            value: { kind: "IntValue", value: "0" },
                          },
                        ],
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "totalCount" } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "user" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "firstName" } },
                      { kind: "Field", name: { kind: "Name", value: "preferredLastName" } },
                      { kind: "Field", name: { kind: "Name", value: "fullName" } },
                      { kind: "Field", name: { kind: "Name", value: "birthDate" } },
                      { kind: "Field", name: { kind: "Name", value: "mobilePhoneNumber" } },
                      {
                        kind: "Field",
                        alias: { kind: "Name", value: "lastIdentification" },
                        name: { kind: "Name", value: "identifications" },
                        arguments: [
                          {
                            kind: "Argument",
                            name: { kind: "Name", value: "first" },
                            value: { kind: "IntValue", value: "1" },
                          },
                          {
                            kind: "Argument",
                            name: { kind: "Name", value: "orderBy" },
                            value: {
                              kind: "ObjectValue",
                              fields: [
                                {
                                  kind: "ObjectField",
                                  name: { kind: "Name", value: "field" },
                                  value: { kind: "EnumValue", value: "updatedAt" },
                                },
                                {
                                  kind: "ObjectField",
                                  name: { kind: "Name", value: "direction" },
                                  value: { kind: "EnumValue", value: "Desc" },
                                },
                              ],
                            },
                          },
                        ],
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "edges" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "node" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "__typename" },
                                        },
                                        {
                                          kind: "FragmentSpread",
                                          name: { kind: "Name", value: "Identification" },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "projectInfo" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "supportingDocumentSettings" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "collectMode" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "IdentificationLevelFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "IdentificationLevelStatusInfo" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "NotSupportedIdentificationLevelStatusInfo" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "StartedIdentificationLevelStatusInfo" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "PendingIdentificationLevelStatusInfo" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "ValidIdentificationLevelStatusInfo" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "InvalidIdentificationLevelStatusInfo" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "reasons" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "CanceledIdentificationLevelStatusInfo" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "ExpiredIdentificationLevelStatusInfo" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                { kind: "Field", name: { kind: "Name", value: "expiredAt" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Identification" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Identification" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "levels" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "expert" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "IdentificationLevelFragment" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pvid" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "IdentificationLevelFragment" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "qes" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "IdentificationLevelFragment" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "process" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AccountActivationPageQuery, AccountActivationPageQueryVariables>;
export const GenerateSupportingDocumentUploadUrlDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "GenerateSupportingDocumentUploadUrl" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "GenerateSupportingDocumentUploadUrlInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "generateSupportingDocumentUploadUrl" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "GenerateSupportingDocumentUploadUrlSuccessPayload",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "supportingDocumentId" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "upload" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "fields" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  { kind: "Field", name: { kind: "Name", value: "key" } },
                                  { kind: "Field", name: { kind: "Name", value: "value" } },
                                ],
                              },
                            },
                            { kind: "Field", name: { kind: "Name", value: "url" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GenerateSupportingDocumentUploadUrlMutation,
  GenerateSupportingDocumentUploadUrlMutationVariables
>;
export const DeleteSupportingDocumentDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "DeleteSupportingDocument" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "DeleteSupportingDocumentInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteSupportingDocument" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Rejection" } },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "message" } },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "DeleteSupportingDocumentSuccessPayload" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteSupportingDocumentMutation,
  DeleteSupportingDocumentMutationVariables
>;
export const RequestSupportingDocumentCollectionReviewDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "RequestSupportingDocumentCollectionReview" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "RequestSupportingDocumentCollectionReviewInput" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "requestSupportingDocumentCollectionReview" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Rejection" } },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "message" } },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "RequestSupportingDocumentCollectionReviewSuccessPayload",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "supportingDocumentCollection" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  RequestSupportingDocumentCollectionReviewMutation,
  RequestSupportingDocumentCollectionReviewMutationVariables
>;
export const TransactionListPageDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "TransactionListPage" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "accountId" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "first" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "canQueryCardOnTransaction" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "after" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "filters" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "TransactionsFiltersInput" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "orderBy" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "TransactionsOrderByInput" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "account" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "accountId" },
                value: { kind: "Variable", name: { kind: "Name", value: "accountId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "number" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "balances" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "FragmentSpread", name: { kind: "Name", value: "AccountBalances" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "transactions" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "first" },
                      value: { kind: "Variable", name: { kind: "Name", value: "first" } },
                    },
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "after" },
                      value: { kind: "Variable", name: { kind: "Name", value: "after" } },
                    },
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "filters" },
                      value: { kind: "Variable", name: { kind: "Name", value: "filters" } },
                    },
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "orderBy" },
                      value: { kind: "Variable", name: { kind: "Name", value: "orderBy" } },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "pageInfo" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "endCursor" } },
                            { kind: "Field", name: { kind: "Name", value: "hasNextPage" } },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "edges" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "node" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  {
                                    kind: "FragmentSpread",
                                    name: { kind: "Name", value: "TransactionDetails" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AddressDetails" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Address" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "addressLine1" } },
          { kind: "Field", name: { kind: "Name", value: "addressLine2" } },
          { kind: "Field", name: { kind: "Name", value: "city" } },
          { kind: "Field", name: { kind: "Name", value: "country" } },
          { kind: "Field", name: { kind: "Name", value: "postalCode" } },
          { kind: "Field", name: { kind: "Name", value: "state" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TrustedBeneficiaryDetails" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "TrustedBeneficiary" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "label" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "statusInfo" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "TrustedInternalBeneficiary" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "accountId" } },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "TrustedInternationalBeneficiary" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "currency" } },
                { kind: "Field", name: { kind: "Name", value: "route" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "details" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "key" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "TrustedSepaBeneficiary" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "iban" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "address" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "FragmentSpread", name: { kind: "Name", value: "AddressDetails" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AccountBalances" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "AccountBalances" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "available" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "value" } },
                { kind: "Field", name: { kind: "Name", value: "currency" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "pending" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "value" } },
                { kind: "Field", name: { kind: "Name", value: "currency" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "booked" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "value" } },
                { kind: "Field", name: { kind: "Name", value: "currency" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "reserved" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "value" } },
                { kind: "Field", name: { kind: "Name", value: "currency" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TransactionDetails" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Transaction" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "side" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "label" } },
          { kind: "Field", name: { kind: "Name", value: "counterparty" } },
          { kind: "Field", name: { kind: "Name", value: "reference" } },
          { kind: "Field", name: { kind: "Name", value: "externalReference" } },
          { kind: "Field", name: { kind: "Name", value: "statementCanBeGenerated" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "payment" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "createdAt" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "originTransaction" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
                { kind: "Field", name: { kind: "Name", value: "executionDate" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "amount" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "currency" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "statusInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "status" } },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "RejectedTransactionStatusInfo" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "status" } },
                            { kind: "Field", name: { kind: "Name", value: "reason" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "statusInfo" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "BookedTransactionStatusInfo" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "bookingDate" } },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "PendingTransactionStatusInfo" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "pendingEndDate" } },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "CanceledTransactionStatusInfo" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "canceledDate" } },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "RejectedTransactionStatusInfo" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "reason" } },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "UpcomingTransactionStatusInfo" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "executionDate" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "amount" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "currency" } },
                { kind: "Field", name: { kind: "Name", value: "value" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "executionDate" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "InlineFragment",
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "CardTransaction" } },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "originalAmount" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "currency" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "reservedAmount" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "currency" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "reservedAmountReleasedAt" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "cardDetails" },
                  directives: [
                    {
                      kind: "Directive",
                      name: { kind: "Name", value: "include" },
                      arguments: [
                        {
                          kind: "Argument",
                          name: { kind: "Name", value: "if" },
                          value: {
                            kind: "Variable",
                            name: { kind: "Name", value: "canQueryCardOnTransaction" },
                          },
                        },
                      ],
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "CardOutDetails" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "maskedPan" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "card" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  { kind: "Field", name: { kind: "Name", value: "id" } },
                                  { kind: "Field", name: { kind: "Name", value: "name" } },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "accountMembership" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "__typename" },
                                        },
                                        { kind: "Field", name: { kind: "Name", value: "id" } },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "user" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: { kind: "Name", value: "__typename" },
                                              },
                                              {
                                                kind: "Field",
                                                name: { kind: "Name", value: "id" },
                                              },
                                              {
                                                kind: "Field",
                                                name: { kind: "Name", value: "firstName" },
                                              },
                                              {
                                                kind: "Field",
                                                name: { kind: "Name", value: "preferredLastName" },
                                              },
                                              {
                                                kind: "Field",
                                                name: { kind: "Name", value: "fullName" },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "CardInDetails" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "paymentMandate" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  { kind: "Field", name: { kind: "Name", value: "id" } },
                                  { kind: "Field", name: { kind: "Name", value: "name" } },
                                  { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                                  { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                                  { kind: "Field", name: { kind: "Name", value: "executedAt" } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "merchant" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "CardOutMerchant" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "merchantId" } },
                            { kind: "Field", name: { kind: "Name", value: "merchantCity" } },
                            { kind: "Field", name: { kind: "Name", value: "merchantCountry" } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "originalAmount" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "currency" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "enrichedTransactionInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "enrichedMerchantName" } },
                      { kind: "Field", name: { kind: "Name", value: "isSubscription" } },
                      { kind: "Field", name: { kind: "Name", value: "carbonFootprint" } },
                      { kind: "Field", name: { kind: "Name", value: "contactEmail" } },
                      { kind: "Field", name: { kind: "Name", value: "contactPhone" } },
                      { kind: "Field", name: { kind: "Name", value: "contactWebsite" } },
                      { kind: "Field", name: { kind: "Name", value: "logoUrl" } },
                      { kind: "Field", name: { kind: "Name", value: "category" } },
                      { kind: "Field", name: { kind: "Name", value: "subcategory" } },
                      { kind: "Field", name: { kind: "Name", value: "address" } },
                      { kind: "Field", name: { kind: "Name", value: "city" } },
                      { kind: "Field", name: { kind: "Name", value: "postalCode" } },
                      { kind: "Field", name: { kind: "Name", value: "country" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "currencyExchange" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "exchangeRate" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "SEPACreditTransferTransaction" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "creditor" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "IBAN" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "debtor" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "IBAN" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "beneficiary" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "TrustedBeneficiary" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "TrustedBeneficiaryDetails" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "UnsavedSepaBeneficiary" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "name" } },
                            { kind: "Field", name: { kind: "Name", value: "iban" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "address" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  {
                                    kind: "FragmentSpread",
                                    name: { kind: "Name", value: "AddressDetails" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "InternalDirectDebitTransaction" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "reservedAmount" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "currency" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "reservedAmountReleasedAt" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "creditor" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "accountId" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "mandate" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "FeeTransaction" } },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "feesType" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "creditor" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "originTransaction" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "label" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "statusInfo" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "status" } },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: { kind: "Name", value: "RejectedTransactionStatusInfo" },
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  { kind: "Field", name: { kind: "Name", value: "reason" } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                      { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                      { kind: "Field", name: { kind: "Name", value: "executionDate" } },
                      { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "amount" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "currency" } },
                            { kind: "Field", name: { kind: "Name", value: "value" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "SEPADirectDebitTransaction" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "reservedAmountReleasedAt" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "creditor" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "IBAN" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "debtor" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "IBAN" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "reservedAmount" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                      { kind: "Field", name: { kind: "Name", value: "currency" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "mandate" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "SEPAReceivedDirectDebitMandate" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "ultimateCreditorName" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "SEPAPaymentDirectDebitMandate" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "debtor" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  { kind: "Field", name: { kind: "Name", value: "name" } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "InternationalCreditTransferTransaction" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "creditor" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "InternationalCreditTransferInCreditor" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "name" } },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "InternationalCreditTransferOutCreditor" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "name" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "details" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  { kind: "Field", name: { kind: "Name", value: "key" } },
                                  { kind: "Field", name: { kind: "Name", value: "value" } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "reference" } },
                { kind: "Field", name: { kind: "Name", value: "paymentProduct" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "statusInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "status" } },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "RejectedTransactionStatusInfo" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "reason" } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  alias: { kind: "Name", value: "internationalCurrencyExchange" },
                  name: { kind: "Name", value: "currencyExchange" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "exchangeRate" } },
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "sourceAmount" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "currency" } },
                            { kind: "Field", name: { kind: "Name", value: "value" } },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "targetAmount" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "currency" } },
                            { kind: "Field", name: { kind: "Name", value: "value" } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "beneficiary" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "currency" } },
                      { kind: "Field", name: { kind: "Name", value: "route" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "details" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "key" } },
                            { kind: "Field", name: { kind: "Name", value: "value" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "InternalCreditTransfer" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "creditor" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "CheckTransaction" } },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "reservedAmount" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "currency" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "reservedAmountReleasedAt" } },
                { kind: "Field", name: { kind: "Name", value: "cmc7" } },
                { kind: "Field", name: { kind: "Name", value: "rlmcKey" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TransactionListPageQuery, TransactionListPageQueryVariables>;
export const GenerateTransactionStatementDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "GenerateTransactionStatement" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "GenerateTransactionStatementInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "generateTransactionStatement" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "GenerateTransactionStatementSuccessPayload" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "transactionStatement" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "TransactionStatement" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TransactionStatement" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "TransactionStatement" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "statusInfo" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "GeneratedTransactionStatementStatusInfo" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GenerateTransactionStatementMutation,
  GenerateTransactionStatementMutationVariables
>;
export const TransactionStatementDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "TransactionStatement" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "transactionStatement" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: { kind: "Variable", name: { kind: "Name", value: "id" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "FragmentSpread", name: { kind: "Name", value: "TransactionStatement" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TransactionStatement" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "TransactionStatement" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "statusInfo" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "GeneratedTransactionStatementStatusInfo" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TransactionStatementQuery, TransactionStatementQueryVariables>;
export const BeneficiariesListDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "BeneficiariesList" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "accountId" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "first" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "after" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "filters" } },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "TrustedBeneficiaryFiltersInput" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "account" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "accountId" },
                value: { kind: "Variable", name: { kind: "Name", value: "accountId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "trustedBeneficiaries" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "first" },
                      value: { kind: "Variable", name: { kind: "Name", value: "first" } },
                    },
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "after" },
                      value: { kind: "Variable", name: { kind: "Name", value: "after" } },
                    },
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "orderBy" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "field" },
                            value: { kind: "EnumValue", value: "createdAt" },
                          },
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "direction" },
                            value: { kind: "EnumValue", value: "Desc" },
                          },
                        ],
                      },
                    },
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "filters" },
                      value: { kind: "Variable", name: { kind: "Name", value: "filters" } },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "totalCount" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "pageInfo" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "endCursor" } },
                            { kind: "Field", name: { kind: "Name", value: "hasNextPage" } },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "edges" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "cursor" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "node" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  {
                                    kind: "FragmentSpread",
                                    name: { kind: "Name", value: "TrustedBeneficiaryDetails" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AddressDetails" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Address" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "addressLine1" } },
          { kind: "Field", name: { kind: "Name", value: "addressLine2" } },
          { kind: "Field", name: { kind: "Name", value: "city" } },
          { kind: "Field", name: { kind: "Name", value: "country" } },
          { kind: "Field", name: { kind: "Name", value: "postalCode" } },
          { kind: "Field", name: { kind: "Name", value: "state" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TrustedBeneficiaryDetails" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "TrustedBeneficiary" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "label" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "statusInfo" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "TrustedInternalBeneficiary" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "accountId" } },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "TrustedInternationalBeneficiary" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "currency" } },
                { kind: "Field", name: { kind: "Name", value: "route" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "details" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "key" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "TrustedSepaBeneficiary" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "iban" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "address" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "FragmentSpread", name: { kind: "Name", value: "AddressDetails" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BeneficiariesListQuery, BeneficiariesListQueryVariables>;
export const TrustedBeneficiaryDetailsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "TrustedBeneficiaryDetails" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "trustedBeneficiary" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: { kind: "Variable", name: { kind: "Name", value: "id" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "TrustedBeneficiaryDetails" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AddressDetails" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Address" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "addressLine1" } },
          { kind: "Field", name: { kind: "Name", value: "addressLine2" } },
          { kind: "Field", name: { kind: "Name", value: "city" } },
          { kind: "Field", name: { kind: "Name", value: "country" } },
          { kind: "Field", name: { kind: "Name", value: "postalCode" } },
          { kind: "Field", name: { kind: "Name", value: "state" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TrustedBeneficiaryDetails" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "TrustedBeneficiary" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "label" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "statusInfo" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "TrustedInternalBeneficiary" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "accountId" } },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "TrustedInternationalBeneficiary" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "currency" } },
                { kind: "Field", name: { kind: "Name", value: "route" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "details" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "key" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "TrustedSepaBeneficiary" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "iban" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "address" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "FragmentSpread", name: { kind: "Name", value: "AddressDetails" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  TrustedBeneficiaryDetailsQuery,
  TrustedBeneficiaryDetailsQueryVariables
>;
export const TrustedBeneficiaryTransfersDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "TrustedBeneficiaryTransfers" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "first" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "canQueryCardOnTransaction" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "after" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "filters" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "TransactionsFiltersInput" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "trustedBeneficiary" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: { kind: "Variable", name: { kind: "Name", value: "id" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "transactions" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "first" },
                      value: { kind: "Variable", name: { kind: "Name", value: "first" } },
                    },
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "after" },
                      value: { kind: "Variable", name: { kind: "Name", value: "after" } },
                    },
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "filters" },
                      value: { kind: "Variable", name: { kind: "Name", value: "filters" } },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "pageInfo" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "endCursor" } },
                            { kind: "Field", name: { kind: "Name", value: "hasNextPage" } },
                          ],
                        },
                      },
                      { kind: "Field", name: { kind: "Name", value: "totalCount" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "edges" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "node" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  {
                                    kind: "FragmentSpread",
                                    name: { kind: "Name", value: "TransactionDetails" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AddressDetails" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Address" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "addressLine1" } },
          { kind: "Field", name: { kind: "Name", value: "addressLine2" } },
          { kind: "Field", name: { kind: "Name", value: "city" } },
          { kind: "Field", name: { kind: "Name", value: "country" } },
          { kind: "Field", name: { kind: "Name", value: "postalCode" } },
          { kind: "Field", name: { kind: "Name", value: "state" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TrustedBeneficiaryDetails" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "TrustedBeneficiary" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "label" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "statusInfo" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "TrustedInternalBeneficiary" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "accountId" } },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "TrustedInternationalBeneficiary" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "currency" } },
                { kind: "Field", name: { kind: "Name", value: "route" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "details" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "key" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "TrustedSepaBeneficiary" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "iban" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "address" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "FragmentSpread", name: { kind: "Name", value: "AddressDetails" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TransactionDetails" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Transaction" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "side" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "label" } },
          { kind: "Field", name: { kind: "Name", value: "counterparty" } },
          { kind: "Field", name: { kind: "Name", value: "reference" } },
          { kind: "Field", name: { kind: "Name", value: "externalReference" } },
          { kind: "Field", name: { kind: "Name", value: "statementCanBeGenerated" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "payment" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "createdAt" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "originTransaction" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
                { kind: "Field", name: { kind: "Name", value: "executionDate" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "amount" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "currency" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "statusInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "status" } },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "RejectedTransactionStatusInfo" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "status" } },
                            { kind: "Field", name: { kind: "Name", value: "reason" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "statusInfo" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "BookedTransactionStatusInfo" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "bookingDate" } },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "PendingTransactionStatusInfo" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "pendingEndDate" } },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "CanceledTransactionStatusInfo" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "canceledDate" } },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "RejectedTransactionStatusInfo" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "reason" } },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "UpcomingTransactionStatusInfo" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "executionDate" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "amount" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "currency" } },
                { kind: "Field", name: { kind: "Name", value: "value" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "executionDate" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "InlineFragment",
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "CardTransaction" } },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "originalAmount" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "currency" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "reservedAmount" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "currency" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "reservedAmountReleasedAt" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "cardDetails" },
                  directives: [
                    {
                      kind: "Directive",
                      name: { kind: "Name", value: "include" },
                      arguments: [
                        {
                          kind: "Argument",
                          name: { kind: "Name", value: "if" },
                          value: {
                            kind: "Variable",
                            name: { kind: "Name", value: "canQueryCardOnTransaction" },
                          },
                        },
                      ],
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "CardOutDetails" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "maskedPan" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "card" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  { kind: "Field", name: { kind: "Name", value: "id" } },
                                  { kind: "Field", name: { kind: "Name", value: "name" } },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "accountMembership" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "__typename" },
                                        },
                                        { kind: "Field", name: { kind: "Name", value: "id" } },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "user" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: { kind: "Name", value: "__typename" },
                                              },
                                              {
                                                kind: "Field",
                                                name: { kind: "Name", value: "id" },
                                              },
                                              {
                                                kind: "Field",
                                                name: { kind: "Name", value: "firstName" },
                                              },
                                              {
                                                kind: "Field",
                                                name: { kind: "Name", value: "preferredLastName" },
                                              },
                                              {
                                                kind: "Field",
                                                name: { kind: "Name", value: "fullName" },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "CardInDetails" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "paymentMandate" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  { kind: "Field", name: { kind: "Name", value: "id" } },
                                  { kind: "Field", name: { kind: "Name", value: "name" } },
                                  { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                                  { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                                  { kind: "Field", name: { kind: "Name", value: "executedAt" } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "merchant" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "CardOutMerchant" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "merchantId" } },
                            { kind: "Field", name: { kind: "Name", value: "merchantCity" } },
                            { kind: "Field", name: { kind: "Name", value: "merchantCountry" } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "originalAmount" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "currency" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "enrichedTransactionInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "enrichedMerchantName" } },
                      { kind: "Field", name: { kind: "Name", value: "isSubscription" } },
                      { kind: "Field", name: { kind: "Name", value: "carbonFootprint" } },
                      { kind: "Field", name: { kind: "Name", value: "contactEmail" } },
                      { kind: "Field", name: { kind: "Name", value: "contactPhone" } },
                      { kind: "Field", name: { kind: "Name", value: "contactWebsite" } },
                      { kind: "Field", name: { kind: "Name", value: "logoUrl" } },
                      { kind: "Field", name: { kind: "Name", value: "category" } },
                      { kind: "Field", name: { kind: "Name", value: "subcategory" } },
                      { kind: "Field", name: { kind: "Name", value: "address" } },
                      { kind: "Field", name: { kind: "Name", value: "city" } },
                      { kind: "Field", name: { kind: "Name", value: "postalCode" } },
                      { kind: "Field", name: { kind: "Name", value: "country" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "currencyExchange" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "exchangeRate" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "SEPACreditTransferTransaction" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "creditor" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "IBAN" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "debtor" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "IBAN" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "beneficiary" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "TrustedBeneficiary" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "TrustedBeneficiaryDetails" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "UnsavedSepaBeneficiary" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "name" } },
                            { kind: "Field", name: { kind: "Name", value: "iban" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "address" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  {
                                    kind: "FragmentSpread",
                                    name: { kind: "Name", value: "AddressDetails" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "InternalDirectDebitTransaction" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "reservedAmount" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "currency" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "reservedAmountReleasedAt" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "creditor" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "accountId" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "mandate" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "FeeTransaction" } },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "feesType" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "creditor" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "originTransaction" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "label" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "statusInfo" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "status" } },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: { kind: "Name", value: "RejectedTransactionStatusInfo" },
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  { kind: "Field", name: { kind: "Name", value: "reason" } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                      { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                      { kind: "Field", name: { kind: "Name", value: "executionDate" } },
                      { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "amount" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "currency" } },
                            { kind: "Field", name: { kind: "Name", value: "value" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "SEPADirectDebitTransaction" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "reservedAmountReleasedAt" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "creditor" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "IBAN" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "debtor" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "IBAN" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "reservedAmount" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                      { kind: "Field", name: { kind: "Name", value: "currency" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "mandate" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "SEPAReceivedDirectDebitMandate" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "ultimateCreditorName" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "SEPAPaymentDirectDebitMandate" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "debtor" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  { kind: "Field", name: { kind: "Name", value: "name" } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "InternationalCreditTransferTransaction" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "creditor" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "InternationalCreditTransferInCreditor" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "name" } },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "InternationalCreditTransferOutCreditor" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "name" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "details" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  { kind: "Field", name: { kind: "Name", value: "key" } },
                                  { kind: "Field", name: { kind: "Name", value: "value" } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "reference" } },
                { kind: "Field", name: { kind: "Name", value: "paymentProduct" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "statusInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "status" } },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "RejectedTransactionStatusInfo" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "reason" } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  alias: { kind: "Name", value: "internationalCurrencyExchange" },
                  name: { kind: "Name", value: "currencyExchange" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "exchangeRate" } },
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "sourceAmount" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "currency" } },
                            { kind: "Field", name: { kind: "Name", value: "value" } },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "targetAmount" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "currency" } },
                            { kind: "Field", name: { kind: "Name", value: "value" } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "beneficiary" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "currency" } },
                      { kind: "Field", name: { kind: "Name", value: "route" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "details" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "key" } },
                            { kind: "Field", name: { kind: "Name", value: "value" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "InternalCreditTransfer" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "creditor" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "CheckTransaction" } },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "reservedAmount" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "currency" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "reservedAmountReleasedAt" } },
                { kind: "Field", name: { kind: "Name", value: "cmc7" } },
                { kind: "Field", name: { kind: "Name", value: "rlmcKey" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  TrustedBeneficiaryTransfersQuery,
  TrustedBeneficiaryTransfersQueryVariables
>;
export const AddSepaBeneficiaryDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AddSepaBeneficiary" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "AddTrustedSepaBeneficiaryInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "addTrustedSepaBeneficiary" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "AddTrustedSepaBeneficiarySuccessPayload" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "trustedBeneficiary" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "statusInfo" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: {
                                        kind: "Name",
                                        value: "TrustedBeneficiaryConsentPendingStatusInfo",
                                      },
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "__typename" },
                                        },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "consent" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: { kind: "Name", value: "__typename" },
                                              },
                                              {
                                                kind: "Field",
                                                name: { kind: "Name", value: "id" },
                                              },
                                              {
                                                kind: "Field",
                                                name: { kind: "Name", value: "consentUrl" },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "ValidationRejection" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "fields" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "path" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AddSepaBeneficiaryMutation, AddSepaBeneficiaryMutationVariables>;
export const AddInternationalBeneficiaryDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AddInternationalBeneficiary" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "AddTrustedInternationalBeneficiaryInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "addTrustedInternationalBeneficiary" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "AddTrustedInternationalBeneficiarySuccessPayload",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "trustedBeneficiary" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "statusInfo" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: {
                                        kind: "Name",
                                        value: "TrustedBeneficiaryConsentPendingStatusInfo",
                                      },
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "__typename" },
                                        },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "consent" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: { kind: "Name", value: "__typename" },
                                              },
                                              {
                                                kind: "Field",
                                                name: { kind: "Name", value: "id" },
                                              },
                                              {
                                                kind: "Field",
                                                name: { kind: "Name", value: "consentUrl" },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "ValidationRejection" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "fields" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "path" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AddInternationalBeneficiaryMutation,
  AddInternationalBeneficiaryMutationVariables
>;
export const TransactionDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "Transaction" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "canQueryCardOnTransaction" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "transaction" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: { kind: "Variable", name: { kind: "Name", value: "id" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "FragmentSpread", name: { kind: "Name", value: "TransactionDetails" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AddressDetails" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Address" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "addressLine1" } },
          { kind: "Field", name: { kind: "Name", value: "addressLine2" } },
          { kind: "Field", name: { kind: "Name", value: "city" } },
          { kind: "Field", name: { kind: "Name", value: "country" } },
          { kind: "Field", name: { kind: "Name", value: "postalCode" } },
          { kind: "Field", name: { kind: "Name", value: "state" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TrustedBeneficiaryDetails" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "TrustedBeneficiary" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "label" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "statusInfo" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "TrustedInternalBeneficiary" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "accountId" } },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "TrustedInternationalBeneficiary" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "currency" } },
                { kind: "Field", name: { kind: "Name", value: "route" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "details" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "key" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "TrustedSepaBeneficiary" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "iban" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "address" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "FragmentSpread", name: { kind: "Name", value: "AddressDetails" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TransactionDetails" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Transaction" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "side" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "label" } },
          { kind: "Field", name: { kind: "Name", value: "counterparty" } },
          { kind: "Field", name: { kind: "Name", value: "reference" } },
          { kind: "Field", name: { kind: "Name", value: "externalReference" } },
          { kind: "Field", name: { kind: "Name", value: "statementCanBeGenerated" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "payment" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "createdAt" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "originTransaction" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
                { kind: "Field", name: { kind: "Name", value: "executionDate" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "amount" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "currency" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "statusInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "status" } },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "RejectedTransactionStatusInfo" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "status" } },
                            { kind: "Field", name: { kind: "Name", value: "reason" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "statusInfo" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "BookedTransactionStatusInfo" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "bookingDate" } },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "PendingTransactionStatusInfo" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "pendingEndDate" } },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "CanceledTransactionStatusInfo" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "canceledDate" } },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "RejectedTransactionStatusInfo" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "reason" } },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "UpcomingTransactionStatusInfo" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "executionDate" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "amount" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "currency" } },
                { kind: "Field", name: { kind: "Name", value: "value" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "executionDate" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "InlineFragment",
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "CardTransaction" } },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "originalAmount" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "currency" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "reservedAmount" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "currency" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "reservedAmountReleasedAt" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "cardDetails" },
                  directives: [
                    {
                      kind: "Directive",
                      name: { kind: "Name", value: "include" },
                      arguments: [
                        {
                          kind: "Argument",
                          name: { kind: "Name", value: "if" },
                          value: {
                            kind: "Variable",
                            name: { kind: "Name", value: "canQueryCardOnTransaction" },
                          },
                        },
                      ],
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "CardOutDetails" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "maskedPan" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "card" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  { kind: "Field", name: { kind: "Name", value: "id" } },
                                  { kind: "Field", name: { kind: "Name", value: "name" } },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "accountMembership" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "__typename" },
                                        },
                                        { kind: "Field", name: { kind: "Name", value: "id" } },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "user" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: { kind: "Name", value: "__typename" },
                                              },
                                              {
                                                kind: "Field",
                                                name: { kind: "Name", value: "id" },
                                              },
                                              {
                                                kind: "Field",
                                                name: { kind: "Name", value: "firstName" },
                                              },
                                              {
                                                kind: "Field",
                                                name: { kind: "Name", value: "preferredLastName" },
                                              },
                                              {
                                                kind: "Field",
                                                name: { kind: "Name", value: "fullName" },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "CardInDetails" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "paymentMandate" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  { kind: "Field", name: { kind: "Name", value: "id" } },
                                  { kind: "Field", name: { kind: "Name", value: "name" } },
                                  { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                                  { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                                  { kind: "Field", name: { kind: "Name", value: "executedAt" } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "merchant" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "CardOutMerchant" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "merchantId" } },
                            { kind: "Field", name: { kind: "Name", value: "merchantCity" } },
                            { kind: "Field", name: { kind: "Name", value: "merchantCountry" } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "originalAmount" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "currency" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "enrichedTransactionInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "enrichedMerchantName" } },
                      { kind: "Field", name: { kind: "Name", value: "isSubscription" } },
                      { kind: "Field", name: { kind: "Name", value: "carbonFootprint" } },
                      { kind: "Field", name: { kind: "Name", value: "contactEmail" } },
                      { kind: "Field", name: { kind: "Name", value: "contactPhone" } },
                      { kind: "Field", name: { kind: "Name", value: "contactWebsite" } },
                      { kind: "Field", name: { kind: "Name", value: "logoUrl" } },
                      { kind: "Field", name: { kind: "Name", value: "category" } },
                      { kind: "Field", name: { kind: "Name", value: "subcategory" } },
                      { kind: "Field", name: { kind: "Name", value: "address" } },
                      { kind: "Field", name: { kind: "Name", value: "city" } },
                      { kind: "Field", name: { kind: "Name", value: "postalCode" } },
                      { kind: "Field", name: { kind: "Name", value: "country" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "currencyExchange" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "exchangeRate" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "SEPACreditTransferTransaction" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "creditor" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "IBAN" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "debtor" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "IBAN" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "beneficiary" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "TrustedBeneficiary" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "TrustedBeneficiaryDetails" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "UnsavedSepaBeneficiary" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "name" } },
                            { kind: "Field", name: { kind: "Name", value: "iban" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "address" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  {
                                    kind: "FragmentSpread",
                                    name: { kind: "Name", value: "AddressDetails" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "InternalDirectDebitTransaction" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "reservedAmount" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "currency" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "reservedAmountReleasedAt" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "creditor" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "accountId" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "mandate" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "FeeTransaction" } },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "feesType" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "creditor" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "originTransaction" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "label" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "statusInfo" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "status" } },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: { kind: "Name", value: "RejectedTransactionStatusInfo" },
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  { kind: "Field", name: { kind: "Name", value: "reason" } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                      { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                      { kind: "Field", name: { kind: "Name", value: "executionDate" } },
                      { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "amount" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "currency" } },
                            { kind: "Field", name: { kind: "Name", value: "value" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "SEPADirectDebitTransaction" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "reservedAmountReleasedAt" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "creditor" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "IBAN" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "debtor" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "IBAN" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "reservedAmount" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                      { kind: "Field", name: { kind: "Name", value: "currency" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "mandate" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "SEPAReceivedDirectDebitMandate" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "ultimateCreditorName" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "SEPAPaymentDirectDebitMandate" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "debtor" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  { kind: "Field", name: { kind: "Name", value: "name" } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "InternationalCreditTransferTransaction" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "creditor" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "InternationalCreditTransferInCreditor" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "name" } },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "InternationalCreditTransferOutCreditor" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "name" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "details" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  { kind: "Field", name: { kind: "Name", value: "key" } },
                                  { kind: "Field", name: { kind: "Name", value: "value" } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "reference" } },
                { kind: "Field", name: { kind: "Name", value: "paymentProduct" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "statusInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "status" } },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "RejectedTransactionStatusInfo" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "reason" } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  alias: { kind: "Name", value: "internationalCurrencyExchange" },
                  name: { kind: "Name", value: "currencyExchange" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "exchangeRate" } },
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "sourceAmount" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "currency" } },
                            { kind: "Field", name: { kind: "Name", value: "value" } },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "targetAmount" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "currency" } },
                            { kind: "Field", name: { kind: "Name", value: "value" } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "beneficiary" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "currency" } },
                      { kind: "Field", name: { kind: "Name", value: "route" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "details" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "key" } },
                            { kind: "Field", name: { kind: "Name", value: "value" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "InternalCreditTransfer" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "creditor" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "CheckTransaction" } },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "reservedAmount" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "currency" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "reservedAmountReleasedAt" } },
                { kind: "Field", name: { kind: "Name", value: "cmc7" } },
                { kind: "Field", name: { kind: "Name", value: "rlmcKey" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TransactionQuery, TransactionQueryVariables>;
export const UpcomingTransactionListPageDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "UpcomingTransactionListPage" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "accountId" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "first" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "canQueryCardOnTransaction" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "after" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "account" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "accountId" },
                value: { kind: "Variable", name: { kind: "Name", value: "accountId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "number" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "transactions" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "first" },
                      value: { kind: "Variable", name: { kind: "Name", value: "first" } },
                    },
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "after" },
                      value: { kind: "Variable", name: { kind: "Name", value: "after" } },
                    },
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "filters" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "status" },
                            value: { kind: "EnumValue", value: "Upcoming" },
                          },
                        ],
                      },
                    },
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "orderBy" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "field" },
                            value: { kind: "EnumValue", value: "executionDate" },
                          },
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "direction" },
                            value: { kind: "EnumValue", value: "Asc" },
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "pageInfo" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "endCursor" } },
                            { kind: "Field", name: { kind: "Name", value: "hasNextPage" } },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "edges" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "node" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  {
                                    kind: "FragmentSpread",
                                    name: { kind: "Name", value: "TransactionDetails" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      { kind: "Field", name: { kind: "Name", value: "totalCount" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AddressDetails" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Address" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "addressLine1" } },
          { kind: "Field", name: { kind: "Name", value: "addressLine2" } },
          { kind: "Field", name: { kind: "Name", value: "city" } },
          { kind: "Field", name: { kind: "Name", value: "country" } },
          { kind: "Field", name: { kind: "Name", value: "postalCode" } },
          { kind: "Field", name: { kind: "Name", value: "state" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TrustedBeneficiaryDetails" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "TrustedBeneficiary" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "label" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "statusInfo" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "TrustedInternalBeneficiary" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "accountId" } },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "TrustedInternationalBeneficiary" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "currency" } },
                { kind: "Field", name: { kind: "Name", value: "route" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "details" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "key" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "TrustedSepaBeneficiary" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "iban" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "address" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "FragmentSpread", name: { kind: "Name", value: "AddressDetails" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TransactionDetails" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Transaction" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "side" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "label" } },
          { kind: "Field", name: { kind: "Name", value: "counterparty" } },
          { kind: "Field", name: { kind: "Name", value: "reference" } },
          { kind: "Field", name: { kind: "Name", value: "externalReference" } },
          { kind: "Field", name: { kind: "Name", value: "statementCanBeGenerated" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "payment" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "createdAt" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "originTransaction" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
                { kind: "Field", name: { kind: "Name", value: "executionDate" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "amount" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "currency" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "statusInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "status" } },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "RejectedTransactionStatusInfo" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "status" } },
                            { kind: "Field", name: { kind: "Name", value: "reason" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "statusInfo" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "BookedTransactionStatusInfo" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "bookingDate" } },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "PendingTransactionStatusInfo" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "pendingEndDate" } },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "CanceledTransactionStatusInfo" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "canceledDate" } },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "RejectedTransactionStatusInfo" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "reason" } },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "UpcomingTransactionStatusInfo" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "executionDate" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "amount" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "currency" } },
                { kind: "Field", name: { kind: "Name", value: "value" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "executionDate" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "InlineFragment",
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "CardTransaction" } },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "originalAmount" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "currency" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "reservedAmount" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "currency" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "reservedAmountReleasedAt" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "cardDetails" },
                  directives: [
                    {
                      kind: "Directive",
                      name: { kind: "Name", value: "include" },
                      arguments: [
                        {
                          kind: "Argument",
                          name: { kind: "Name", value: "if" },
                          value: {
                            kind: "Variable",
                            name: { kind: "Name", value: "canQueryCardOnTransaction" },
                          },
                        },
                      ],
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "CardOutDetails" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "maskedPan" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "card" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  { kind: "Field", name: { kind: "Name", value: "id" } },
                                  { kind: "Field", name: { kind: "Name", value: "name" } },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "accountMembership" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "__typename" },
                                        },
                                        { kind: "Field", name: { kind: "Name", value: "id" } },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "user" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: { kind: "Name", value: "__typename" },
                                              },
                                              {
                                                kind: "Field",
                                                name: { kind: "Name", value: "id" },
                                              },
                                              {
                                                kind: "Field",
                                                name: { kind: "Name", value: "firstName" },
                                              },
                                              {
                                                kind: "Field",
                                                name: { kind: "Name", value: "preferredLastName" },
                                              },
                                              {
                                                kind: "Field",
                                                name: { kind: "Name", value: "fullName" },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "CardInDetails" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "paymentMandate" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  { kind: "Field", name: { kind: "Name", value: "id" } },
                                  { kind: "Field", name: { kind: "Name", value: "name" } },
                                  { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                                  { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                                  { kind: "Field", name: { kind: "Name", value: "executedAt" } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "merchant" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "CardOutMerchant" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "merchantId" } },
                            { kind: "Field", name: { kind: "Name", value: "merchantCity" } },
                            { kind: "Field", name: { kind: "Name", value: "merchantCountry" } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "originalAmount" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "currency" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "enrichedTransactionInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "enrichedMerchantName" } },
                      { kind: "Field", name: { kind: "Name", value: "isSubscription" } },
                      { kind: "Field", name: { kind: "Name", value: "carbonFootprint" } },
                      { kind: "Field", name: { kind: "Name", value: "contactEmail" } },
                      { kind: "Field", name: { kind: "Name", value: "contactPhone" } },
                      { kind: "Field", name: { kind: "Name", value: "contactWebsite" } },
                      { kind: "Field", name: { kind: "Name", value: "logoUrl" } },
                      { kind: "Field", name: { kind: "Name", value: "category" } },
                      { kind: "Field", name: { kind: "Name", value: "subcategory" } },
                      { kind: "Field", name: { kind: "Name", value: "address" } },
                      { kind: "Field", name: { kind: "Name", value: "city" } },
                      { kind: "Field", name: { kind: "Name", value: "postalCode" } },
                      { kind: "Field", name: { kind: "Name", value: "country" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "currencyExchange" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "exchangeRate" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "SEPACreditTransferTransaction" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "creditor" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "IBAN" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "debtor" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "IBAN" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "beneficiary" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "TrustedBeneficiary" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "TrustedBeneficiaryDetails" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "UnsavedSepaBeneficiary" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "name" } },
                            { kind: "Field", name: { kind: "Name", value: "iban" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "address" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  {
                                    kind: "FragmentSpread",
                                    name: { kind: "Name", value: "AddressDetails" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "InternalDirectDebitTransaction" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "reservedAmount" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "currency" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "reservedAmountReleasedAt" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "creditor" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "accountId" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "mandate" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "FeeTransaction" } },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "feesType" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "creditor" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "originTransaction" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "label" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "statusInfo" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "status" } },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: { kind: "Name", value: "RejectedTransactionStatusInfo" },
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  { kind: "Field", name: { kind: "Name", value: "reason" } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                      { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                      { kind: "Field", name: { kind: "Name", value: "executionDate" } },
                      { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "amount" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "currency" } },
                            { kind: "Field", name: { kind: "Name", value: "value" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "SEPADirectDebitTransaction" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "reservedAmountReleasedAt" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "creditor" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "IBAN" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "debtor" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "IBAN" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "reservedAmount" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                      { kind: "Field", name: { kind: "Name", value: "currency" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "mandate" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "SEPAReceivedDirectDebitMandate" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "ultimateCreditorName" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "SEPAPaymentDirectDebitMandate" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "debtor" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  { kind: "Field", name: { kind: "Name", value: "name" } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "InternationalCreditTransferTransaction" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "creditor" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "InternationalCreditTransferInCreditor" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "name" } },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "InternationalCreditTransferOutCreditor" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "name" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "details" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  { kind: "Field", name: { kind: "Name", value: "key" } },
                                  { kind: "Field", name: { kind: "Name", value: "value" } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "reference" } },
                { kind: "Field", name: { kind: "Name", value: "paymentProduct" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "statusInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "status" } },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "RejectedTransactionStatusInfo" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "reason" } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  alias: { kind: "Name", value: "internationalCurrencyExchange" },
                  name: { kind: "Name", value: "currencyExchange" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "exchangeRate" } },
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "sourceAmount" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "currency" } },
                            { kind: "Field", name: { kind: "Name", value: "value" } },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "targetAmount" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "currency" } },
                            { kind: "Field", name: { kind: "Name", value: "value" } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "beneficiary" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "currency" } },
                      { kind: "Field", name: { kind: "Name", value: "route" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "details" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "key" } },
                            { kind: "Field", name: { kind: "Name", value: "value" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "InternalCreditTransfer" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "creditor" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "CheckTransaction" } },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "reservedAmount" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "currency" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "reservedAmountReleasedAt" } },
                { kind: "Field", name: { kind: "Name", value: "cmc7" } },
                { kind: "Field", name: { kind: "Name", value: "rlmcKey" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpcomingTransactionListPageQuery,
  UpcomingTransactionListPageQueryVariables
>;
export const GetAccountMembershipsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetAccountMemberships" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "first" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "after" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "filters" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "AccountMembershipsFilterInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "accountMemberships" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "first" },
                      value: { kind: "Variable", name: { kind: "Name", value: "first" } },
                    },
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "after" },
                      value: { kind: "Variable", name: { kind: "Name", value: "after" } },
                    },
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "filters" },
                      value: { kind: "Variable", name: { kind: "Name", value: "filters" } },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "pageInfo" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "endCursor" } },
                            { kind: "Field", name: { kind: "Name", value: "hasNextPage" } },
                          ],
                        },
                      },
                      { kind: "Field", name: { kind: "Name", value: "totalCount" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "edges" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "cursor" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "node" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  { kind: "Field", name: { kind: "Name", value: "id" } },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "canInitiatePayments" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "legalRepresentative" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "canManageAccountMembership" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "canManageBeneficiaries" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "canViewAccount" },
                                  },
                                  { kind: "Field", name: { kind: "Name", value: "email" } },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "statusInfo" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "__typename" },
                                        },
                                        { kind: "Field", name: { kind: "Name", value: "status" } },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "account" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "__typename" },
                                        },
                                        { kind: "Field", name: { kind: "Name", value: "id" } },
                                        { kind: "Field", name: { kind: "Name", value: "number" } },
                                        { kind: "Field", name: { kind: "Name", value: "name" } },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "balances" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: { kind: "Name", value: "__typename" },
                                              },
                                              {
                                                kind: "FragmentSpread",
                                                name: { kind: "Name", value: "AccountBalances" },
                                              },
                                            ],
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "holder" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: { kind: "Name", value: "__typename" },
                                              },
                                              {
                                                kind: "Field",
                                                name: { kind: "Name", value: "id" },
                                              },
                                              {
                                                kind: "Field",
                                                name: { kind: "Name", value: "info" },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    {
                                                      kind: "Field",
                                                      name: { kind: "Name", value: "__typename" },
                                                    },
                                                    {
                                                      kind: "Field",
                                                      name: { kind: "Name", value: "name" },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AccountBalances" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "AccountBalances" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "available" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "value" } },
                { kind: "Field", name: { kind: "Name", value: "currency" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "pending" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "value" } },
                { kind: "Field", name: { kind: "Name", value: "currency" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "booked" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "value" } },
                { kind: "Field", name: { kind: "Name", value: "currency" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "reserved" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "value" } },
                { kind: "Field", name: { kind: "Name", value: "currency" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetAccountMembershipsQuery, GetAccountMembershipsQueryVariables>;
export const GetFirstAccountMembershipDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetFirstAccountMembership" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "filters" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "AccountMembershipsFilterInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "accountMemberships" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "first" },
                      value: { kind: "IntValue", value: "1" },
                    },
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "filters" },
                      value: { kind: "Variable", name: { kind: "Name", value: "filters" } },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "edges" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "cursor" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "node" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  { kind: "Field", name: { kind: "Name", value: "id" } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "projectInfo" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetFirstAccountMembershipQuery,
  GetFirstAccountMembershipQueryVariables
>;
export const GetCardProductsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetCardProducts" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "accountMembershipId" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "after" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "first" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "search" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "accountId" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          {
            kind: "Field",
            alias: { kind: "Name", value: "allMemberships" },
            name: { kind: "Name", value: "accountMemberships" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "status" },
                      value: {
                        kind: "ListValue",
                        values: [
                          { kind: "EnumValue", value: "Enabled" },
                          { kind: "EnumValue", value: "InvitationSent" },
                          { kind: "EnumValue", value: "BindingUserError" },
                        ],
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "accountId" },
                      value: { kind: "Variable", name: { kind: "Name", value: "accountId" } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "totalCount" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "accountMemberships" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "after" },
                value: { kind: "Variable", name: { kind: "Name", value: "after" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "first" },
                value: { kind: "Variable", name: { kind: "Name", value: "first" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "search" },
                      value: { kind: "Variable", name: { kind: "Name", value: "search" } },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "status" },
                      value: {
                        kind: "ListValue",
                        values: [
                          { kind: "EnumValue", value: "Enabled" },
                          { kind: "EnumValue", value: "InvitationSent" },
                          { kind: "EnumValue", value: "BindingUserError" },
                        ],
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "accountId" },
                      value: { kind: "Variable", name: { kind: "Name", value: "accountId" } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "totalCount" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pageInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "endCursor" } },
                      { kind: "Field", name: { kind: "Name", value: "hasNextPage" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "cursor" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "AccountMembership" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "accountMembership" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: { kind: "Variable", name: { kind: "Name", value: "accountMembershipId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "accountHolderType" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "account" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "legalRepresentativeMembership" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "creditLimitSettings" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "statusInfo" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  { kind: "Field", name: { kind: "Name", value: "status" } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "holder" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "info" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: { kind: "Name", value: "AccountHolderCompanyInfo" },
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "__typename" },
                                        },
                                        { kind: "Field", name: { kind: "Name", value: "name" } },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: { kind: "Name", value: "AccountHolderIndividualInfo" },
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "__typename" },
                                        },
                                        { kind: "Field", name: { kind: "Name", value: "name" } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "residencyAddress" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  {
                                    kind: "FragmentSpread",
                                    name: { kind: "Name", value: "AddressInfo" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "user" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "firstName" } },
                      { kind: "Field", name: { kind: "Name", value: "preferredLastName" } },
                      { kind: "Field", name: { kind: "Name", value: "fullName" } },
                      { kind: "Field", name: { kind: "Name", value: "mobilePhoneNumber" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "projectInfo" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "cardProducts" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "FragmentSpread", name: { kind: "Name", value: "CardProduct" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AccountHolderForCardSettings" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "AccountHolder" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "info" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CardInsurancePackage" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "CardInsurancePackage" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "level" } },
          { kind: "Field", name: { kind: "Name", value: "noticeUrl" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AccountMembership" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "AccountMembership" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "accountId" } },
          { kind: "Field", name: { kind: "Name", value: "accountCountry" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "legalRepresentative" } },
          { kind: "Field", name: { kind: "Name", value: "hasRequiredIdentificationLevel" } },
          { kind: "Field", name: { kind: "Name", value: "language" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "statusInfo" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "AccountMembershipBindingUserErrorStatusInfo" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "restrictedTo" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "birthDate" } },
                            { kind: "Field", name: { kind: "Name", value: "firstName" } },
                            { kind: "Field", name: { kind: "Name", value: "lastName" } },
                            { kind: "Field", name: { kind: "Name", value: "phoneNumber" } },
                          ],
                        },
                      },
                      { kind: "Field", name: { kind: "Name", value: "emailVerifiedMatchError" } },
                      { kind: "Field", name: { kind: "Name", value: "idVerifiedMatchError" } },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "AccountMembershipInvitationSentStatusInfo" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "restrictedTo" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "birthDate" } },
                            { kind: "Field", name: { kind: "Name", value: "firstName" } },
                            { kind: "Field", name: { kind: "Name", value: "lastName" } },
                            { kind: "Field", name: { kind: "Name", value: "phoneNumber" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "taxIdentificationNumber" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "residencyAddress" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "addressLine1" } },
                { kind: "Field", name: { kind: "Name", value: "postalCode" } },
                { kind: "Field", name: { kind: "Name", value: "city" } },
                { kind: "Field", name: { kind: "Name", value: "country" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "canInitiatePayments" } },
          { kind: "Field", name: { kind: "Name", value: "canManageCards" } },
          { kind: "Field", name: { kind: "Name", value: "canManageAccountMembership" } },
          { kind: "Field", name: { kind: "Name", value: "canManageBeneficiaries" } },
          { kind: "Field", name: { kind: "Name", value: "canViewAccount" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "birthDate" } },
                { kind: "Field", name: { kind: "Name", value: "firstName" } },
                { kind: "Field", name: { kind: "Name", value: "lastName" } },
                { kind: "Field", name: { kind: "Name", value: "birthLastName" } },
                { kind: "Field", name: { kind: "Name", value: "preferredLastName" } },
                { kind: "Field", name: { kind: "Name", value: "fullName" } },
                { kind: "Field", name: { kind: "Name", value: "mobilePhoneNumber" } },
                { kind: "Field", name: { kind: "Name", value: "verifiedEmails" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "account" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "country" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "holder" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "AccountHolderForCardSettings" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            alias: { kind: "Name", value: "activeCards" },
            name: { kind: "Name", value: "cards" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "statuses" },
                      value: {
                        kind: "ListValue",
                        values: [
                          { kind: "EnumValue", value: "Enabled" },
                          { kind: "EnumValue", value: "Processing" },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "totalCount" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AddressInfo" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "AddressInfo" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "addressLine1" } },
          { kind: "Field", name: { kind: "Name", value: "addressLine2" } },
          { kind: "Field", name: { kind: "Name", value: "city" } },
          { kind: "Field", name: { kind: "Name", value: "country" } },
          { kind: "Field", name: { kind: "Name", value: "postalCode" } },
          { kind: "Field", name: { kind: "Name", value: "state" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CardProduct" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "CardProduct" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "fundingType" } },
          { kind: "Field", name: { kind: "Name", value: "projectId" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "applicableToPhysicalCards" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "companySpendingLimit" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "amount" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                      { kind: "Field", name: { kind: "Name", value: "currency" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "period" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "individualSpendingLimit" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "amount" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                      { kind: "Field", name: { kind: "Name", value: "currency" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "period" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "cardDesigns" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "version" } },
                { kind: "Field", name: { kind: "Name", value: "cardProjectLogoSvgUrl" } },
                { kind: "Field", name: { kind: "Name", value: "cardProjectLogo300dpiUrl" } },
                { kind: "Field", name: { kind: "Name", value: "cardProjectLogo600dpiUrl" } },
                { kind: "Field", name: { kind: "Name", value: "zoomRatioProjectLogo" } },
                { kind: "Field", name: { kind: "Name", value: "cardDesignUrl" } },
                { kind: "Field", name: { kind: "Name", value: "accentColor" } },
                { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "cardBackground" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                      { kind: "Field", name: { kind: "Name", value: "cardTextColor" } },
                      { kind: "Field", name: { kind: "Name", value: "cardBackgroundUrl" } },
                      { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                      { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "insurance" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "defaultInsurancePackage" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "CardInsurancePackage" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "availableInsurancePackages" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "CardInsurancePackage" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "defaultCardProduct" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetCardProductsQuery, GetCardProductsQueryVariables>;
export const GetEligibleCardMembershipsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetEligibleCardMemberships" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "after" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "first" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "search" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "accountId" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          {
            kind: "Field",
            alias: { kind: "Name", value: "allMemberships" },
            name: { kind: "Name", value: "accountMemberships" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "after" },
                value: { kind: "Variable", name: { kind: "Name", value: "after" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "first" },
                value: { kind: "Variable", name: { kind: "Name", value: "first" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "status" },
                      value: {
                        kind: "ListValue",
                        values: [
                          { kind: "EnumValue", value: "Enabled" },
                          { kind: "EnumValue", value: "InvitationSent" },
                          { kind: "EnumValue", value: "BindingUserError" },
                        ],
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "accountId" },
                      value: { kind: "Variable", name: { kind: "Name", value: "accountId" } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "totalCount" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "accountMemberships" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "after" },
                value: { kind: "Variable", name: { kind: "Name", value: "after" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "first" },
                value: { kind: "Variable", name: { kind: "Name", value: "first" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "search" },
                      value: { kind: "Variable", name: { kind: "Name", value: "search" } },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "status" },
                      value: {
                        kind: "ListValue",
                        values: [
                          { kind: "EnumValue", value: "Enabled" },
                          { kind: "EnumValue", value: "InvitationSent" },
                          { kind: "EnumValue", value: "BindingUserError" },
                        ],
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "accountId" },
                      value: { kind: "Variable", name: { kind: "Name", value: "accountId" } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "totalCount" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pageInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "endCursor" } },
                      { kind: "Field", name: { kind: "Name", value: "hasNextPage" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "cursor" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "AccountMembership" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AccountHolderForCardSettings" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "AccountHolder" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "info" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AccountMembership" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "AccountMembership" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "accountId" } },
          { kind: "Field", name: { kind: "Name", value: "accountCountry" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "legalRepresentative" } },
          { kind: "Field", name: { kind: "Name", value: "hasRequiredIdentificationLevel" } },
          { kind: "Field", name: { kind: "Name", value: "language" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "statusInfo" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "AccountMembershipBindingUserErrorStatusInfo" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "restrictedTo" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "birthDate" } },
                            { kind: "Field", name: { kind: "Name", value: "firstName" } },
                            { kind: "Field", name: { kind: "Name", value: "lastName" } },
                            { kind: "Field", name: { kind: "Name", value: "phoneNumber" } },
                          ],
                        },
                      },
                      { kind: "Field", name: { kind: "Name", value: "emailVerifiedMatchError" } },
                      { kind: "Field", name: { kind: "Name", value: "idVerifiedMatchError" } },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "AccountMembershipInvitationSentStatusInfo" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "restrictedTo" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "birthDate" } },
                            { kind: "Field", name: { kind: "Name", value: "firstName" } },
                            { kind: "Field", name: { kind: "Name", value: "lastName" } },
                            { kind: "Field", name: { kind: "Name", value: "phoneNumber" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "taxIdentificationNumber" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "residencyAddress" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "addressLine1" } },
                { kind: "Field", name: { kind: "Name", value: "postalCode" } },
                { kind: "Field", name: { kind: "Name", value: "city" } },
                { kind: "Field", name: { kind: "Name", value: "country" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "canInitiatePayments" } },
          { kind: "Field", name: { kind: "Name", value: "canManageCards" } },
          { kind: "Field", name: { kind: "Name", value: "canManageAccountMembership" } },
          { kind: "Field", name: { kind: "Name", value: "canManageBeneficiaries" } },
          { kind: "Field", name: { kind: "Name", value: "canViewAccount" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "birthDate" } },
                { kind: "Field", name: { kind: "Name", value: "firstName" } },
                { kind: "Field", name: { kind: "Name", value: "lastName" } },
                { kind: "Field", name: { kind: "Name", value: "birthLastName" } },
                { kind: "Field", name: { kind: "Name", value: "preferredLastName" } },
                { kind: "Field", name: { kind: "Name", value: "fullName" } },
                { kind: "Field", name: { kind: "Name", value: "mobilePhoneNumber" } },
                { kind: "Field", name: { kind: "Name", value: "verifiedEmails" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "account" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "country" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "holder" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "AccountHolderForCardSettings" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            alias: { kind: "Name", value: "activeCards" },
            name: { kind: "Name", value: "cards" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "statuses" },
                      value: {
                        kind: "ListValue",
                        values: [
                          { kind: "EnumValue", value: "Enabled" },
                          { kind: "EnumValue", value: "Processing" },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "totalCount" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetEligibleCardMembershipsQuery,
  GetEligibleCardMembershipsQueryVariables
>;
export const GetTransactionDetailsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetTransactionDetails" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "transactionId" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "canQueryCardOnTransaction" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "transaction" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: { kind: "Variable", name: { kind: "Name", value: "transactionId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "FragmentSpread", name: { kind: "Name", value: "TransactionDetails" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AddressDetails" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Address" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "addressLine1" } },
          { kind: "Field", name: { kind: "Name", value: "addressLine2" } },
          { kind: "Field", name: { kind: "Name", value: "city" } },
          { kind: "Field", name: { kind: "Name", value: "country" } },
          { kind: "Field", name: { kind: "Name", value: "postalCode" } },
          { kind: "Field", name: { kind: "Name", value: "state" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TrustedBeneficiaryDetails" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "TrustedBeneficiary" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "label" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "statusInfo" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "TrustedInternalBeneficiary" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "accountId" } },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "TrustedInternationalBeneficiary" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "currency" } },
                { kind: "Field", name: { kind: "Name", value: "route" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "details" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "key" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "TrustedSepaBeneficiary" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "iban" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "address" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "FragmentSpread", name: { kind: "Name", value: "AddressDetails" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "TransactionDetails" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Transaction" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "side" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "label" } },
          { kind: "Field", name: { kind: "Name", value: "counterparty" } },
          { kind: "Field", name: { kind: "Name", value: "reference" } },
          { kind: "Field", name: { kind: "Name", value: "externalReference" } },
          { kind: "Field", name: { kind: "Name", value: "statementCanBeGenerated" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "payment" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "createdAt" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "originTransaction" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
                { kind: "Field", name: { kind: "Name", value: "executionDate" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "amount" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "currency" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "statusInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "status" } },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "RejectedTransactionStatusInfo" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "status" } },
                            { kind: "Field", name: { kind: "Name", value: "reason" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "statusInfo" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "BookedTransactionStatusInfo" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "bookingDate" } },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "PendingTransactionStatusInfo" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "pendingEndDate" } },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "CanceledTransactionStatusInfo" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "canceledDate" } },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "RejectedTransactionStatusInfo" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "reason" } },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "UpcomingTransactionStatusInfo" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "executionDate" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "amount" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "currency" } },
                { kind: "Field", name: { kind: "Name", value: "value" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "executionDate" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "InlineFragment",
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "CardTransaction" } },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "originalAmount" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "currency" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "reservedAmount" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "currency" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "reservedAmountReleasedAt" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "cardDetails" },
                  directives: [
                    {
                      kind: "Directive",
                      name: { kind: "Name", value: "include" },
                      arguments: [
                        {
                          kind: "Argument",
                          name: { kind: "Name", value: "if" },
                          value: {
                            kind: "Variable",
                            name: { kind: "Name", value: "canQueryCardOnTransaction" },
                          },
                        },
                      ],
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "CardOutDetails" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "maskedPan" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "card" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  { kind: "Field", name: { kind: "Name", value: "id" } },
                                  { kind: "Field", name: { kind: "Name", value: "name" } },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "accountMembership" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "__typename" },
                                        },
                                        { kind: "Field", name: { kind: "Name", value: "id" } },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "user" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: { kind: "Name", value: "__typename" },
                                              },
                                              {
                                                kind: "Field",
                                                name: { kind: "Name", value: "id" },
                                              },
                                              {
                                                kind: "Field",
                                                name: { kind: "Name", value: "firstName" },
                                              },
                                              {
                                                kind: "Field",
                                                name: { kind: "Name", value: "preferredLastName" },
                                              },
                                              {
                                                kind: "Field",
                                                name: { kind: "Name", value: "fullName" },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "CardInDetails" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "paymentMandate" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  { kind: "Field", name: { kind: "Name", value: "id" } },
                                  { kind: "Field", name: { kind: "Name", value: "name" } },
                                  { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                                  { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                                  { kind: "Field", name: { kind: "Name", value: "executedAt" } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "merchant" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "CardOutMerchant" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "merchantId" } },
                            { kind: "Field", name: { kind: "Name", value: "merchantCity" } },
                            { kind: "Field", name: { kind: "Name", value: "merchantCountry" } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "originalAmount" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "currency" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "enrichedTransactionInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "enrichedMerchantName" } },
                      { kind: "Field", name: { kind: "Name", value: "isSubscription" } },
                      { kind: "Field", name: { kind: "Name", value: "carbonFootprint" } },
                      { kind: "Field", name: { kind: "Name", value: "contactEmail" } },
                      { kind: "Field", name: { kind: "Name", value: "contactPhone" } },
                      { kind: "Field", name: { kind: "Name", value: "contactWebsite" } },
                      { kind: "Field", name: { kind: "Name", value: "logoUrl" } },
                      { kind: "Field", name: { kind: "Name", value: "category" } },
                      { kind: "Field", name: { kind: "Name", value: "subcategory" } },
                      { kind: "Field", name: { kind: "Name", value: "address" } },
                      { kind: "Field", name: { kind: "Name", value: "city" } },
                      { kind: "Field", name: { kind: "Name", value: "postalCode" } },
                      { kind: "Field", name: { kind: "Name", value: "country" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "currencyExchange" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "exchangeRate" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "SEPACreditTransferTransaction" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "creditor" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "IBAN" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "debtor" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "IBAN" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "beneficiary" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "TrustedBeneficiary" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "TrustedBeneficiaryDetails" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "UnsavedSepaBeneficiary" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "name" } },
                            { kind: "Field", name: { kind: "Name", value: "iban" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "address" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  {
                                    kind: "FragmentSpread",
                                    name: { kind: "Name", value: "AddressDetails" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "InternalDirectDebitTransaction" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "reservedAmount" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "currency" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "reservedAmountReleasedAt" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "creditor" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "accountId" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "mandate" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "FeeTransaction" } },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "feesType" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "creditor" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "originTransaction" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "label" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "statusInfo" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "status" } },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: { kind: "Name", value: "RejectedTransactionStatusInfo" },
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  { kind: "Field", name: { kind: "Name", value: "reason" } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                      { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                      { kind: "Field", name: { kind: "Name", value: "executionDate" } },
                      { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "amount" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "currency" } },
                            { kind: "Field", name: { kind: "Name", value: "value" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "SEPADirectDebitTransaction" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "reservedAmountReleasedAt" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "creditor" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "IBAN" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "debtor" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "IBAN" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "reservedAmount" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                      { kind: "Field", name: { kind: "Name", value: "currency" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "mandate" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "SEPAReceivedDirectDebitMandate" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "ultimateCreditorName" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "SEPAPaymentDirectDebitMandate" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "debtor" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  { kind: "Field", name: { kind: "Name", value: "name" } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "InternationalCreditTransferTransaction" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "creditor" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "InternationalCreditTransferInCreditor" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "name" } },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "InternationalCreditTransferOutCreditor" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "name" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "details" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  { kind: "Field", name: { kind: "Name", value: "key" } },
                                  { kind: "Field", name: { kind: "Name", value: "value" } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "reference" } },
                { kind: "Field", name: { kind: "Name", value: "paymentProduct" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "statusInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "status" } },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "RejectedTransactionStatusInfo" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "reason" } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  alias: { kind: "Name", value: "internationalCurrencyExchange" },
                  name: { kind: "Name", value: "currencyExchange" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "exchangeRate" } },
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "sourceAmount" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "currency" } },
                            { kind: "Field", name: { kind: "Name", value: "value" } },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "targetAmount" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "currency" } },
                            { kind: "Field", name: { kind: "Name", value: "value" } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "beneficiary" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "currency" } },
                      { kind: "Field", name: { kind: "Name", value: "route" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "details" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "key" } },
                            { kind: "Field", name: { kind: "Name", value: "value" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "InternalCreditTransfer" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "creditor" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: { kind: "NamedType", name: { kind: "Name", value: "CheckTransaction" } },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "reservedAmount" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "currency" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "reservedAmountReleasedAt" } },
                { kind: "Field", name: { kind: "Name", value: "cmc7" } },
                { kind: "Field", name: { kind: "Name", value: "rlmcKey" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetTransactionDetailsQuery, GetTransactionDetailsQueryVariables>;
export const GetAccountBalanceDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetAccountBalance" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "accountId" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "account" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "accountId" },
                value: { kind: "Variable", name: { kind: "Name", value: "accountId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "merchantProfiles" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "totalCount" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "fundingSources" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "totalCount" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "balances" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "FragmentSpread", name: { kind: "Name", value: "AccountBalances" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  alias: { kind: "Name", value: "upcomingTransactions" },
                  name: { kind: "Name", value: "transactions" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "filters" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "status" },
                            value: { kind: "EnumValue", value: "Upcoming" },
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "totalCount" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AccountBalances" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "AccountBalances" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "available" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "value" } },
                { kind: "Field", name: { kind: "Name", value: "currency" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "pending" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "value" } },
                { kind: "Field", name: { kind: "Name", value: "currency" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "booked" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "value" } },
                { kind: "Field", name: { kind: "Name", value: "currency" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "reserved" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "value" } },
                { kind: "Field", name: { kind: "Name", value: "currency" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetAccountBalanceQuery, GetAccountBalanceQueryVariables>;
export const GetIbanValidationDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getIbanValidation" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "iban" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "IBAN" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "ibanValidation" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "iban" },
                      value: { kind: "Variable", name: { kind: "Name", value: "iban" } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ValidIban" } },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "ValidIbanInformation" },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "InvalidIban" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "iban" } },
                      { kind: "Field", name: { kind: "Name", value: "code" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ValidIbanInformation" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ValidIban" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "iban" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "bank" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "address" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "addressLine1" } },
                      { kind: "Field", name: { kind: "Name", value: "addressLine2" } },
                      { kind: "Field", name: { kind: "Name", value: "city" } },
                      { kind: "Field", name: { kind: "Name", value: "country" } },
                      { kind: "Field", name: { kind: "Name", value: "postalCode" } },
                      { kind: "Field", name: { kind: "Name", value: "state" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "reachability" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "sepaCreditTransferInst" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetIbanValidationQuery, GetIbanValidationQueryVariables>;
export const GetAvailableAccountBalanceDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetAvailableAccountBalance" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "accountMembershipId" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "accountMembership" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: { kind: "Variable", name: { kind: "Name", value: "accountMembershipId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "account" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "balances" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "AccountBalances" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AccountBalances" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "AccountBalances" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "available" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "value" } },
                { kind: "Field", name: { kind: "Name", value: "currency" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "pending" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "value" } },
                { kind: "Field", name: { kind: "Name", value: "currency" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "booked" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "value" } },
                { kind: "Field", name: { kind: "Name", value: "currency" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "reserved" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "value" } },
                { kind: "Field", name: { kind: "Name", value: "currency" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetAvailableAccountBalanceQuery,
  GetAvailableAccountBalanceQueryVariables
>;
export const GetInternationalCreditTransferQuoteDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetInternationalCreditTransferQuote" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "value" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "AmountValue" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "currency" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Currency" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "accountId" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "internationalCreditTransferQuote" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "accountId" },
                value: { kind: "Variable", name: { kind: "Name", value: "accountId" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "targetAmount" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "value" },
                      value: { kind: "Variable", name: { kind: "Name", value: "value" } },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "currency" },
                      value: { kind: "Variable", name: { kind: "Name", value: "currency" } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "exchangeRate" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "feesAmount" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                      { kind: "Field", name: { kind: "Name", value: "currency" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "targetAmount" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                      { kind: "Field", name: { kind: "Name", value: "currency" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sourceAmount" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                      { kind: "Field", name: { kind: "Name", value: "currency" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetInternationalCreditTransferQuoteQuery,
  GetInternationalCreditTransferQuoteQueryVariables
>;
export const GetInternationalBeneficiaryDynamicFormsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetInternationalBeneficiaryDynamicForms" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "amountValue" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "AmountValue" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "currency" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Currency" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "language" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "InternationalCreditTransferDisplayLanguage" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "dynamicFields" } },
          type: {
            kind: "ListType",
            type: {
              kind: "NonNullType",
              type: {
                kind: "NamedType",
                name: { kind: "Name", value: "InternationalBeneficiaryDetailsInput" },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "internationalBeneficiaryDynamicForms" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "amount" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "value" },
                      value: { kind: "Variable", name: { kind: "Name", value: "amountValue" } },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "currency" },
                      value: { kind: "Variable", name: { kind: "Name", value: "currency" } },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "language" },
                value: { kind: "Variable", name: { kind: "Name", value: "language" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "dynamicFields" },
                value: { kind: "Variable", name: { kind: "Name", value: "dynamicFields" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "schemes" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "remainingFieldsToRefreshCount" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "fields" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "required" } },
                            { kind: "Field", name: { kind: "Name", value: "key" } },
                            { kind: "Field", name: { kind: "Name", value: "name" } },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: { kind: "Name", value: "DateField" },
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  { kind: "Field", name: { kind: "Name", value: "example" } },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "validationRegex" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: { kind: "Name", value: "RadioField" },
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "refreshDynamicFieldsOnChange" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "allowedValues" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "__typename" },
                                        },
                                        { kind: "Field", name: { kind: "Name", value: "key" } },
                                        { kind: "Field", name: { kind: "Name", value: "name" } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: { kind: "Name", value: "SelectField" },
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "refreshDynamicFieldsOnChange" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "allowedValues" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "__typename" },
                                        },
                                        { kind: "Field", name: { kind: "Name", value: "key" } },
                                        { kind: "Field", name: { kind: "Name", value: "name" } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: { kind: "Name", value: "TextField" },
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  { kind: "Field", name: { kind: "Name", value: "displayFormat" } },
                                  { kind: "Field", name: { kind: "Name", value: "example" } },
                                  { kind: "Field", name: { kind: "Name", value: "minLength" } },
                                  { kind: "Field", name: { kind: "Name", value: "maxLength" } },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "refreshDynamicFieldsOnChange" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "validationRegex" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetInternationalBeneficiaryDynamicFormsQuery,
  GetInternationalBeneficiaryDynamicFormsQueryVariables
>;
export const GetInternationalCreditTransferTransactionDetailsDynamicFormDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetInternationalCreditTransferTransactionDetailsDynamicForm" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "name" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "route" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "InternationalCreditTransferRouteInput" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "amountValue" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "AmountValue" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "currency" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Currency" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "language" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "InternationalCreditTransferDisplayLanguage" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "beneficiaryDetails" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: {
                  kind: "NamedType",
                  name: { kind: "Name", value: "InternationalBeneficiaryDetailsInput" },
                },
              },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "dynamicFields" } },
          type: {
            kind: "ListType",
            type: {
              kind: "NonNullType",
              type: {
                kind: "NamedType",
                name: { kind: "Name", value: "InternationalCreditTransferDetailsInput" },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "internationalCreditTransferTransactionDetailsDynamicForm",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "internationalBeneficiary" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "details" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "beneficiaryDetails" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "name" },
                      value: { kind: "Variable", name: { kind: "Name", value: "name" } },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "route" },
                      value: { kind: "Variable", name: { kind: "Name", value: "route" } },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "currency" },
                      value: { kind: "Variable", name: { kind: "Name", value: "currency" } },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "targetAmount" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "value" },
                      value: { kind: "Variable", name: { kind: "Name", value: "amountValue" } },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "currency" },
                      value: { kind: "Variable", name: { kind: "Name", value: "currency" } },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "language" },
                value: { kind: "Variable", name: { kind: "Name", value: "language" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "refreshableFields" },
                value: { kind: "Variable", name: { kind: "Name", value: "dynamicFields" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "fields" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "TextField" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "displayFormat" } },
                            { kind: "Field", name: { kind: "Name", value: "example" } },
                            { kind: "Field", name: { kind: "Name", value: "key" } },
                            { kind: "Field", name: { kind: "Name", value: "maxLength" } },
                            { kind: "Field", name: { kind: "Name", value: "minLength" } },
                            { kind: "Field", name: { kind: "Name", value: "name" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "refreshDynamicFieldsOnChange" },
                            },
                            { kind: "Field", name: { kind: "Name", value: "required" } },
                            { kind: "Field", name: { kind: "Name", value: "validationRegex" } },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "SelectField" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "allowedValues" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  { kind: "Field", name: { kind: "Name", value: "key" } },
                                  { kind: "Field", name: { kind: "Name", value: "name" } },
                                ],
                              },
                            },
                            { kind: "Field", name: { kind: "Name", value: "key" } },
                            { kind: "Field", name: { kind: "Name", value: "name" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "refreshDynamicFieldsOnChange" },
                            },
                            { kind: "Field", name: { kind: "Name", value: "required" } },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "RadioField" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "allowedValues" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  { kind: "Field", name: { kind: "Name", value: "key" } },
                                  { kind: "Field", name: { kind: "Name", value: "name" } },
                                ],
                              },
                            },
                            { kind: "Field", name: { kind: "Name", value: "name" } },
                            { kind: "Field", name: { kind: "Name", value: "key" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "refreshDynamicFieldsOnChange" },
                            },
                            { kind: "Field", name: { kind: "Name", value: "required" } },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "DateField" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "example" } },
                            { kind: "Field", name: { kind: "Name", value: "validationRegex" } },
                            { kind: "Field", name: { kind: "Name", value: "key" } },
                            { kind: "Field", name: { kind: "Name", value: "name" } },
                            { kind: "Field", name: { kind: "Name", value: "required" } },
                          ],
                        },
                      },
                      { kind: "Field", name: { kind: "Name", value: "required" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "key" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "remainingFieldsToRefreshCount" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetInternationalCreditTransferTransactionDetailsDynamicFormQuery,
  GetInternationalCreditTransferTransactionDetailsDynamicFormQueryVariables
>;
export const MerchantRootDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "MerchantRoot" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "accountId" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "account" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "accountId" },
                value: { kind: "Variable", name: { kind: "Name", value: "accountId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "merchantProfiles" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "first" },
                      value: { kind: "IntValue", value: "1" },
                    },
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "orderBy" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "field" },
                            value: { kind: "EnumValue", value: "createdAt" },
                          },
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "direction" },
                            value: { kind: "EnumValue", value: "Desc" },
                          },
                        ],
                      },
                    },
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "filters" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "status" },
                            value: {
                              kind: "ListValue",
                              values: [
                                { kind: "EnumValue", value: "PendingReview" },
                                { kind: "EnumValue", value: "Enabled" },
                              ],
                            },
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "totalCount" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "edges" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "node" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  { kind: "Field", name: { kind: "Name", value: "id" } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MerchantRootQuery, MerchantRootQueryVariables>;
export const MerchantProfileDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "MerchantProfile" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "merchantProfileId" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "merchantProfile" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: { kind: "Variable", name: { kind: "Name", value: "merchantProfileId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "FragmentSpread", name: { kind: "Name", value: "MerchantProfile" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MerchantPaymentMethod" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "MerchantPaymentMethod" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "methodId" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "version" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "rollingReserve" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "percentage" } },
                { kind: "Field", name: { kind: "Name", value: "rollingDays" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "statusInfo" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "WaitingForInformationMerchantPaymentMethodStatusInfo",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "verificationRequirements" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: { kind: "Name", value: "AdditionalInformationRequirements" },
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "additionalInformation" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: { kind: "Name", value: "MerchantRequirements" },
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  { kind: "Field", name: { kind: "Name", value: "fields" } },
                                ],
                              },
                            },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: {
                                  kind: "Name",
                                  value: "OtherAdditionalInformationRequirements",
                                },
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "otherAdditionalInformation" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: { kind: "Name", value: "SupportingDocumentRequirements" },
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "supportingDocumentPurposes" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "SepaDirectDebitB2BMerchantPaymentMethod" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "sepaCreditorIdentifier" } },
                { kind: "Field", name: { kind: "Name", value: "useSwanSepaCreditorIdentifier" } },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "SepaDirectDebitCoreMerchantPaymentMethod" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "sepaCreditorIdentifier" } },
                { kind: "Field", name: { kind: "Name", value: "useSwanSepaCreditorIdentifier" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MerchantProfile" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "MerchantProfile" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "accentColor" } },
          { kind: "Field", name: { kind: "Name", value: "accountId" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "expectedAverageBasket" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "value" } },
                { kind: "Field", name: { kind: "Name", value: "currency" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "expectedMonthlyMerchantProcessingVolume" },
          },
          { kind: "Field", name: { kind: "Name", value: "merchantLogoUrl" } },
          { kind: "Field", name: { kind: "Name", value: "merchantName" } },
          { kind: "Field", name: { kind: "Name", value: "merchantWebsiteUrl" } },
          { kind: "Field", name: { kind: "Name", value: "productType" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "statusInfo" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "merchantPaymentMethods" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "FragmentSpread", name: { kind: "Name", value: "MerchantPaymentMethod" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "requestMerchantProfileUpdate" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                { kind: "Field", name: { kind: "Name", value: "merchantName" } },
                { kind: "Field", name: { kind: "Name", value: "merchantWebsiteUrl" } },
                { kind: "Field", name: { kind: "Name", value: "merchantLogoUrl" } },
                { kind: "Field", name: { kind: "Name", value: "productType" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "expectedMonthlyMerchantProcessingVolume" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "expectedAverageBasket" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                      { kind: "Field", name: { kind: "Name", value: "currency" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MerchantProfileQuery, MerchantProfileQueryVariables>;
export const MerchantProfilesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "MerchantProfiles" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "accountId" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "filters" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "MerchantProfileFiltersInput" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "first" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "after" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "account" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "accountId" },
                value: { kind: "Variable", name: { kind: "Name", value: "accountId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "merchantProfiles" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "filters" },
                      value: { kind: "Variable", name: { kind: "Name", value: "filters" } },
                    },
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "first" },
                      value: { kind: "Variable", name: { kind: "Name", value: "first" } },
                    },
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "after" },
                      value: { kind: "Variable", name: { kind: "Name", value: "after" } },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "totalCount" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "edges" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "cursor" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "node" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  {
                                    kind: "FragmentSpread",
                                    name: { kind: "Name", value: "MerchantProfile" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "pageInfo" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "hasNextPage" } },
                            { kind: "Field", name: { kind: "Name", value: "hasPreviousPage" } },
                            { kind: "Field", name: { kind: "Name", value: "startCursor" } },
                            { kind: "Field", name: { kind: "Name", value: "endCursor" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MerchantPaymentMethod" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "MerchantPaymentMethod" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "methodId" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "version" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "rollingReserve" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "percentage" } },
                { kind: "Field", name: { kind: "Name", value: "rollingDays" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "statusInfo" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "WaitingForInformationMerchantPaymentMethodStatusInfo",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "verificationRequirements" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: { kind: "Name", value: "AdditionalInformationRequirements" },
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "additionalInformation" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: { kind: "Name", value: "MerchantRequirements" },
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  { kind: "Field", name: { kind: "Name", value: "fields" } },
                                ],
                              },
                            },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: {
                                  kind: "Name",
                                  value: "OtherAdditionalInformationRequirements",
                                },
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "otherAdditionalInformation" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: { kind: "Name", value: "SupportingDocumentRequirements" },
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "supportingDocumentPurposes" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "SepaDirectDebitB2BMerchantPaymentMethod" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "sepaCreditorIdentifier" } },
                { kind: "Field", name: { kind: "Name", value: "useSwanSepaCreditorIdentifier" } },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "SepaDirectDebitCoreMerchantPaymentMethod" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "sepaCreditorIdentifier" } },
                { kind: "Field", name: { kind: "Name", value: "useSwanSepaCreditorIdentifier" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MerchantProfile" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "MerchantProfile" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "accentColor" } },
          { kind: "Field", name: { kind: "Name", value: "accountId" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "expectedAverageBasket" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "value" } },
                { kind: "Field", name: { kind: "Name", value: "currency" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "expectedMonthlyMerchantProcessingVolume" },
          },
          { kind: "Field", name: { kind: "Name", value: "merchantLogoUrl" } },
          { kind: "Field", name: { kind: "Name", value: "merchantName" } },
          { kind: "Field", name: { kind: "Name", value: "merchantWebsiteUrl" } },
          { kind: "Field", name: { kind: "Name", value: "productType" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "statusInfo" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "merchantPaymentMethods" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "FragmentSpread", name: { kind: "Name", value: "MerchantPaymentMethod" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "requestMerchantProfileUpdate" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                { kind: "Field", name: { kind: "Name", value: "merchantName" } },
                { kind: "Field", name: { kind: "Name", value: "merchantWebsiteUrl" } },
                { kind: "Field", name: { kind: "Name", value: "merchantLogoUrl" } },
                { kind: "Field", name: { kind: "Name", value: "productType" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "expectedMonthlyMerchantProcessingVolume" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "expectedAverageBasket" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                      { kind: "Field", name: { kind: "Name", value: "currency" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MerchantProfilesQuery, MerchantProfilesQueryVariables>;
export const MerchantPaymentsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "MerchantPayments" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "merchantProfileId" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "filters" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "MerchantPaymentFiltersInput" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "first" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "after" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "merchantProfile" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: { kind: "Variable", name: { kind: "Name", value: "merchantProfileId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "statusInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "status" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "accentColor" } },
                { kind: "Field", name: { kind: "Name", value: "merchantLogoUrl" } },
                { kind: "Field", name: { kind: "Name", value: "merchantName" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "merchantPayments" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "filters" },
                      value: { kind: "Variable", name: { kind: "Name", value: "filters" } },
                    },
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "first" },
                      value: { kind: "Variable", name: { kind: "Name", value: "first" } },
                    },
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "after" },
                      value: { kind: "Variable", name: { kind: "Name", value: "after" } },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "MerchantPaymentsConnection" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "merchantPaymentMethods" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "MerchantPaymentMethod" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MerchantPayment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "MerchantPayment" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "label" } },
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "externalReference" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "statusInfo" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "MerchantPaymentAuthorized" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                      { kind: "Field", name: { kind: "Name", value: "authorizedAt" } },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "MerchantPaymentCanceled" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                      { kind: "Field", name: { kind: "Name", value: "canceledAt" } },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "MerchantPaymentCaptured" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                      { kind: "Field", name: { kind: "Name", value: "authorizedAt" } },
                      { kind: "Field", name: { kind: "Name", value: "capturedAt" } },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "MerchantPaymentDisputed" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                      { kind: "Field", name: { kind: "Name", value: "authorizedAt" } },
                      { kind: "Field", name: { kind: "Name", value: "capturedAt" } },
                      { kind: "Field", name: { kind: "Name", value: "disputedAt" } },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "MerchantPaymentInitiated" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "MerchantPaymentPartiallyDisputed" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                      { kind: "Field", name: { kind: "Name", value: "authorizedAt" } },
                      { kind: "Field", name: { kind: "Name", value: "capturedAt" } },
                      { kind: "Field", name: { kind: "Name", value: "disputedAt" } },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "MerchantPaymentRejected" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "rejectedReasonCode" } },
                      { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                      { kind: "Field", name: { kind: "Name", value: "rejectedAt" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "amount" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "currency" } },
                { kind: "Field", name: { kind: "Name", value: "value" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "paymentMethod" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "merchantProfile" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "balance" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "totalAuthorized" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "currency" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "totalCaptured" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "currency" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "availableToCapture" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "currency" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "totalRefunded" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "currency" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "availableToRefund" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "currency" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "availableToCancel" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "currency" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "totalCanceled" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "currency" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "totalDisputed" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "currency" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "reference" } },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "SepaDirectDebitMerchantPayment" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "paymentLink" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "CardMerchantPayment" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "paymentLink" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "threeDs" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "statusInfo" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "status" } },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: { kind: "Name", value: "FailedThreeDsStatusInfo" },
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  { kind: "Field", name: { kind: "Name", value: "reasonCode" } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MerchantPaymentsConnection" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "MerchantPaymentConnection" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "pageInfo" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "endCursor" } },
                { kind: "Field", name: { kind: "Name", value: "hasNextPage" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "totalCount" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "edges" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "node" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "FragmentSpread", name: { kind: "Name", value: "MerchantPayment" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MerchantPaymentMethod" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "MerchantPaymentMethod" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "methodId" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "version" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "rollingReserve" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "percentage" } },
                { kind: "Field", name: { kind: "Name", value: "rollingDays" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "statusInfo" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "WaitingForInformationMerchantPaymentMethodStatusInfo",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "verificationRequirements" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: { kind: "Name", value: "AdditionalInformationRequirements" },
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "additionalInformation" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: { kind: "Name", value: "MerchantRequirements" },
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  { kind: "Field", name: { kind: "Name", value: "fields" } },
                                ],
                              },
                            },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: {
                                  kind: "Name",
                                  value: "OtherAdditionalInformationRequirements",
                                },
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "otherAdditionalInformation" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: { kind: "Name", value: "SupportingDocumentRequirements" },
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "supportingDocumentPurposes" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "SepaDirectDebitB2BMerchantPaymentMethod" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "sepaCreditorIdentifier" } },
                { kind: "Field", name: { kind: "Name", value: "useSwanSepaCreditorIdentifier" } },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "SepaDirectDebitCoreMerchantPaymentMethod" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "sepaCreditorIdentifier" } },
                { kind: "Field", name: { kind: "Name", value: "useSwanSepaCreditorIdentifier" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MerchantPaymentsQuery, MerchantPaymentsQueryVariables>;
export const GetMainMerchantPaymentDetailsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetMainMerchantPaymentDetails" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "paymentId" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "merchantPayment" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: { kind: "Variable", name: { kind: "Name", value: "paymentId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "FragmentSpread", name: { kind: "Name", value: "MerchantPayment" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MerchantPayment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "MerchantPayment" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "label" } },
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "externalReference" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "statusInfo" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "MerchantPaymentAuthorized" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                      { kind: "Field", name: { kind: "Name", value: "authorizedAt" } },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "MerchantPaymentCanceled" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                      { kind: "Field", name: { kind: "Name", value: "canceledAt" } },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "MerchantPaymentCaptured" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                      { kind: "Field", name: { kind: "Name", value: "authorizedAt" } },
                      { kind: "Field", name: { kind: "Name", value: "capturedAt" } },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "MerchantPaymentDisputed" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                      { kind: "Field", name: { kind: "Name", value: "authorizedAt" } },
                      { kind: "Field", name: { kind: "Name", value: "capturedAt" } },
                      { kind: "Field", name: { kind: "Name", value: "disputedAt" } },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "MerchantPaymentInitiated" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "MerchantPaymentPartiallyDisputed" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                      { kind: "Field", name: { kind: "Name", value: "authorizedAt" } },
                      { kind: "Field", name: { kind: "Name", value: "capturedAt" } },
                      { kind: "Field", name: { kind: "Name", value: "disputedAt" } },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "MerchantPaymentRejected" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "rejectedReasonCode" } },
                      { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                      { kind: "Field", name: { kind: "Name", value: "rejectedAt" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "amount" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "currency" } },
                { kind: "Field", name: { kind: "Name", value: "value" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "paymentMethod" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "merchantProfile" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "balance" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "totalAuthorized" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "currency" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "totalCaptured" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "currency" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "availableToCapture" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "currency" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "totalRefunded" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "currency" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "availableToRefund" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "currency" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "availableToCancel" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "currency" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "totalCanceled" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "currency" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "totalDisputed" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "currency" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "reference" } },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "SepaDirectDebitMerchantPayment" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "paymentLink" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "CardMerchantPayment" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "paymentLink" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "threeDs" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "statusInfo" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "status" } },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: { kind: "Name", value: "FailedThreeDsStatusInfo" },
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  { kind: "Field", name: { kind: "Name", value: "reasonCode" } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetMainMerchantPaymentDetailsQuery,
  GetMainMerchantPaymentDetailsQueryVariables
>;
export const GetFullMerchantPaymentDetailsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetFullMerchantPaymentDetails" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "paymentId" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "paymentLinkId" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "merchantPayment" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: { kind: "Variable", name: { kind: "Name", value: "paymentId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "FragmentSpread", name: { kind: "Name", value: "MerchantPayment" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "merchantPaymentLink" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: { kind: "Variable", name: { kind: "Name", value: "paymentLinkId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "FragmentSpread", name: { kind: "Name", value: "PaymentLink" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MerchantPayment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "MerchantPayment" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "label" } },
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "externalReference" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "statusInfo" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "MerchantPaymentAuthorized" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                      { kind: "Field", name: { kind: "Name", value: "authorizedAt" } },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "MerchantPaymentCanceled" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                      { kind: "Field", name: { kind: "Name", value: "canceledAt" } },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "MerchantPaymentCaptured" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                      { kind: "Field", name: { kind: "Name", value: "authorizedAt" } },
                      { kind: "Field", name: { kind: "Name", value: "capturedAt" } },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "MerchantPaymentDisputed" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                      { kind: "Field", name: { kind: "Name", value: "authorizedAt" } },
                      { kind: "Field", name: { kind: "Name", value: "capturedAt" } },
                      { kind: "Field", name: { kind: "Name", value: "disputedAt" } },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "MerchantPaymentInitiated" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "MerchantPaymentPartiallyDisputed" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                      { kind: "Field", name: { kind: "Name", value: "authorizedAt" } },
                      { kind: "Field", name: { kind: "Name", value: "capturedAt" } },
                      { kind: "Field", name: { kind: "Name", value: "disputedAt" } },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "MerchantPaymentRejected" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "rejectedReasonCode" } },
                      { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                      { kind: "Field", name: { kind: "Name", value: "rejectedAt" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "amount" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "currency" } },
                { kind: "Field", name: { kind: "Name", value: "value" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "paymentMethod" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "merchantProfile" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "balance" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "totalAuthorized" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "currency" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "totalCaptured" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "currency" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "availableToCapture" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "currency" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "totalRefunded" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "currency" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "availableToRefund" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "currency" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "availableToCancel" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "currency" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "totalCanceled" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "currency" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "totalDisputed" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "currency" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "reference" } },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "SepaDirectDebitMerchantPayment" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "paymentLink" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "CardMerchantPayment" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "paymentLink" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "threeDs" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "statusInfo" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "status" } },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: { kind: "Name", value: "FailedThreeDsStatusInfo" },
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  { kind: "Field", name: { kind: "Name", value: "reasonCode" } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PaymentLink" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "MerchantPaymentLink" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "label" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "reference" } },
          { kind: "Field", name: { kind: "Name", value: "externalReference" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "statusInfo" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "amount" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "currency" } },
                { kind: "Field", name: { kind: "Name", value: "value" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetFullMerchantPaymentDetailsQuery,
  GetFullMerchantPaymentDetailsQueryVariables
>;
export const MerchantPaymentLinksDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "MerchantPaymentLinks" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "merchantProfileId" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "filters" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "MerchantPaymentLinkFiltersInput" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "first" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "after" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "merchantProfile" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: { kind: "Variable", name: { kind: "Name", value: "merchantProfileId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "merchantPaymentMethods" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                      { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "statusInfo" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "status" } },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "accentColor" } },
                { kind: "Field", name: { kind: "Name", value: "merchantName" } },
                { kind: "Field", name: { kind: "Name", value: "merchantLogoUrl" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "merchantPaymentLinks" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "filters" },
                      value: { kind: "Variable", name: { kind: "Name", value: "filters" } },
                    },
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "first" },
                      value: { kind: "Variable", name: { kind: "Name", value: "first" } },
                    },
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "after" },
                      value: { kind: "Variable", name: { kind: "Name", value: "after" } },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "PaymentLinkConnection" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PaymentLink" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "MerchantPaymentLink" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "label" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "reference" } },
          { kind: "Field", name: { kind: "Name", value: "externalReference" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "statusInfo" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "amount" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "currency" } },
                { kind: "Field", name: { kind: "Name", value: "value" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PaymentLinkConnection" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "MerchantPaymentLinkConnection" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "pageInfo" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "endCursor" } },
                { kind: "Field", name: { kind: "Name", value: "hasNextPage" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "totalCount" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "edges" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "node" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "FragmentSpread", name: { kind: "Name", value: "PaymentLink" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MerchantPaymentLinksQuery, MerchantPaymentLinksQueryVariables>;
export const MerchantPaymentLinkDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "MerchantPaymentLink" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "paymentLinkId" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "merchantPaymentLink" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: { kind: "Variable", name: { kind: "Name", value: "paymentLinkId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "FragmentSpread", name: { kind: "Name", value: "PaymentLink" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PaymentLink" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "MerchantPaymentLink" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "label" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "reference" } },
          { kind: "Field", name: { kind: "Name", value: "externalReference" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "statusInfo" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "amount" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "currency" } },
                { kind: "Field", name: { kind: "Name", value: "value" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MerchantPaymentLinkQuery, MerchantPaymentLinkQueryVariables>;
export const CancelMerchantPaymentDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "CancelMerchantPayment" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "CancelMerchantPaymentInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "cancelMerchantPayment" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "CancelMerchantPaymentSuccessPayload" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "merchantPayment" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "statusInfo" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  { kind: "Field", name: { kind: "Name", value: "status" } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Rejection" } },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "message" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CancelMerchantPaymentMutation, CancelMerchantPaymentMutationVariables>;
export const AccountClosingDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AccountClosing" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "accountId" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "after" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "first" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "projectInfo" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "accentColor" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "webBankingSettings" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "WebBankingSettings" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "account" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "accountId" },
                value: { kind: "Variable", name: { kind: "Name", value: "accountId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "country" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "statusInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "status" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "legalRepresentativeMembership" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "user" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "firstName" } },
                            { kind: "Field", name: { kind: "Name", value: "preferredLastName" } },
                            { kind: "Field", name: { kind: "Name", value: "fullName" } },
                          ],
                        },
                      },
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "AccountMembershipPermissions" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "balances" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "available" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "value" } },
                            { kind: "Field", name: { kind: "Name", value: "currency" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "accountMemberships" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "first" },
                      value: { kind: "Variable", name: { kind: "Name", value: "first" } },
                    },
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "after" },
                      value: { kind: "Variable", name: { kind: "Name", value: "after" } },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "edges" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "node" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  { kind: "Field", name: { kind: "Name", value: "id" } },
                                  { kind: "Field", name: { kind: "Name", value: "accountId" } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "pageInfo" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "hasNextPage" } },
                            { kind: "Field", name: { kind: "Name", value: "endCursor" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "WebBankingSettings" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "WebBankingSettings" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "canViewAccountStatement" } },
          { kind: "Field", name: { kind: "Name", value: "canViewAccountDetails" } },
          { kind: "Field", name: { kind: "Name", value: "canAddNewMembers" } },
          { kind: "Field", name: { kind: "Name", value: "canViewMembers" } },
          { kind: "Field", name: { kind: "Name", value: "canViewPaymentList" } },
          { kind: "Field", name: { kind: "Name", value: "canOrderPhysicalCards" } },
          { kind: "Field", name: { kind: "Name", value: "canInitiatePaymentsToNewBeneficiaries" } },
          { kind: "Field", name: { kind: "Name", value: "canOrderVirtualCards" } },
          { kind: "Field", name: { kind: "Name", value: "canManageVirtualIbans" } },
          { kind: "Field", name: { kind: "Name", value: "canCreateMerchantProfile" } },
          { kind: "Field", name: { kind: "Name", value: "canRequestOnlineCardsPaymentMethod" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "canRequestSepaDirectDebitCorePaymentMethod" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "canRequestSepaDirectDebitB2BPaymentMethod" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "canRequestInternalDirectDebitCorePaymentMethod" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "canRequestInternalDirectDebitB2BPaymentMethod" },
          },
          { kind: "Field", name: { kind: "Name", value: "canRequestChecksPaymentMethod" } },
          { kind: "Field", name: { kind: "Name", value: "canInitiateCheckMerchantPayments" } },
          { kind: "Field", name: { kind: "Name", value: "canCreateMerchantPaymentLinks" } },
          { kind: "Field", name: { kind: "Name", value: "canUpdateCards" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AccountMembershipPermissions" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "AccountMembership" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "canViewAccount" } },
          { kind: "Field", name: { kind: "Name", value: "canManageBeneficiaries" } },
          { kind: "Field", name: { kind: "Name", value: "canInitiatePayments" } },
          { kind: "Field", name: { kind: "Name", value: "canManageAccountMembership" } },
          { kind: "Field", name: { kind: "Name", value: "canManageCards" } },
          { kind: "Field", name: { kind: "Name", value: "legalRepresentative" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "statusInfo" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
              ],
            },
          },
          {
            kind: "Field",
            alias: { kind: "Name", value: "allCards" },
            name: { kind: "Name", value: "cards" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "statuses" },
                      value: {
                        kind: "ListValue",
                        values: [
                          { kind: "EnumValue", value: "Enabled" },
                          { kind: "EnumValue", value: "Processing" },
                          { kind: "EnumValue", value: "Canceling" },
                          { kind: "EnumValue", value: "Canceled" },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "totalCount" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "account" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "statusInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "status" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "paymentLevel" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "merchantProfiles" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "first" },
                      value: { kind: "IntValue", value: "0" },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "totalCount" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AccountClosingQuery, AccountClosingQueryVariables>;
export const CreditLimitRequestDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "CreditLimitRequest" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "accountId" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "after" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "first" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "projectInfo" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "accentColor" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "webBankingSettings" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "WebBankingSettings" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "account" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "accountId" },
                value: { kind: "Variable", name: { kind: "Name", value: "accountId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "country" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "statusInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "status" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "creditLimitSettings" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "creditLimitSettingsRequests" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "edges" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "node" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "__typename" },
                                        },
                                        {
                                          kind: "FragmentSpread",
                                          name: {
                                            kind: "Name",
                                            value: "CreditLimitSettingsRequest",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "authorizedAmount" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "currency" } },
                            { kind: "Field", name: { kind: "Name", value: "value" } },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "statusInfo" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "status" } },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: "FragmentSpread", name: { kind: "Name", value: "RepaymentAccount" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "legalRepresentativeMembership" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "user" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "firstName" } },
                            { kind: "Field", name: { kind: "Name", value: "preferredLastName" } },
                            { kind: "Field", name: { kind: "Name", value: "fullName" } },
                          ],
                        },
                      },
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "AccountMembershipPermissions" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "accountMemberships" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "first" },
                      value: { kind: "Variable", name: { kind: "Name", value: "first" } },
                    },
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "after" },
                      value: { kind: "Variable", name: { kind: "Name", value: "after" } },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "edges" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "node" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  { kind: "Field", name: { kind: "Name", value: "id" } },
                                  { kind: "Field", name: { kind: "Name", value: "accountId" } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "pageInfo" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "hasNextPage" } },
                            { kind: "Field", name: { kind: "Name", value: "endCursor" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "WebBankingSettings" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "WebBankingSettings" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "canViewAccountStatement" } },
          { kind: "Field", name: { kind: "Name", value: "canViewAccountDetails" } },
          { kind: "Field", name: { kind: "Name", value: "canAddNewMembers" } },
          { kind: "Field", name: { kind: "Name", value: "canViewMembers" } },
          { kind: "Field", name: { kind: "Name", value: "canViewPaymentList" } },
          { kind: "Field", name: { kind: "Name", value: "canOrderPhysicalCards" } },
          { kind: "Field", name: { kind: "Name", value: "canInitiatePaymentsToNewBeneficiaries" } },
          { kind: "Field", name: { kind: "Name", value: "canOrderVirtualCards" } },
          { kind: "Field", name: { kind: "Name", value: "canManageVirtualIbans" } },
          { kind: "Field", name: { kind: "Name", value: "canCreateMerchantProfile" } },
          { kind: "Field", name: { kind: "Name", value: "canRequestOnlineCardsPaymentMethod" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "canRequestSepaDirectDebitCorePaymentMethod" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "canRequestSepaDirectDebitB2BPaymentMethod" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "canRequestInternalDirectDebitCorePaymentMethod" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "canRequestInternalDirectDebitB2BPaymentMethod" },
          },
          { kind: "Field", name: { kind: "Name", value: "canRequestChecksPaymentMethod" } },
          { kind: "Field", name: { kind: "Name", value: "canInitiateCheckMerchantPayments" } },
          { kind: "Field", name: { kind: "Name", value: "canCreateMerchantPaymentLinks" } },
          { kind: "Field", name: { kind: "Name", value: "canUpdateCards" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CreditLimitSettingsRequest" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CreditLimitSettingsRequest" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "statusInfo" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "Field", name: { kind: "Name", value: "__typename" } }],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "amount" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "value" } },
                { kind: "Field", name: { kind: "Name", value: "currency" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RepaymentAccount" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Account" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "IBAN" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "holder" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "residencyAddress" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "addressLine1" } },
                      { kind: "Field", name: { kind: "Name", value: "city" } },
                      { kind: "Field", name: { kind: "Name", value: "postalCode" } },
                      { kind: "Field", name: { kind: "Name", value: "country" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "verificationStatus" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "info" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "AccountHolderCompanyInfo" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "name" } },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "AccountHolderIndividualInfo" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "name" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AccountMembershipPermissions" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "AccountMembership" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "canViewAccount" } },
          { kind: "Field", name: { kind: "Name", value: "canManageBeneficiaries" } },
          { kind: "Field", name: { kind: "Name", value: "canInitiatePayments" } },
          { kind: "Field", name: { kind: "Name", value: "canManageAccountMembership" } },
          { kind: "Field", name: { kind: "Name", value: "canManageCards" } },
          { kind: "Field", name: { kind: "Name", value: "legalRepresentative" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "statusInfo" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
              ],
            },
          },
          {
            kind: "Field",
            alias: { kind: "Name", value: "allCards" },
            name: { kind: "Name", value: "cards" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "statuses" },
                      value: {
                        kind: "ListValue",
                        values: [
                          { kind: "EnumValue", value: "Enabled" },
                          { kind: "EnumValue", value: "Processing" },
                          { kind: "EnumValue", value: "Canceling" },
                          { kind: "EnumValue", value: "Canceled" },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "totalCount" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "account" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "statusInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "status" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "paymentLevel" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "merchantProfiles" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "first" },
                      value: { kind: "IntValue", value: "0" },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "totalCount" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreditLimitRequestQuery, CreditLimitRequestQueryVariables>;
export const RequestCreditLimitSettingsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "RequestCreditLimitSettings" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "RequestCreditLimitSettingsInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "requestCreditLimitSettings" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "RequestCreditLimitSettingsSuccessPayload" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "creditLimitSettingsRequest" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "consent" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  { kind: "Field", name: { kind: "Name", value: "id" } },
                                  { kind: "Field", name: { kind: "Name", value: "consentUrl" } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Rejection" } },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "message" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  RequestCreditLimitSettingsMutation,
  RequestCreditLimitSettingsMutationVariables
>;
export const AddReceivedSepaDirectDebitB2bMandateInfoDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AddReceivedSepaDirectDebitB2bMandateInfo" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "first" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "accountId" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "accountMemberships" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "first" },
                      value: { kind: "Variable", name: { kind: "Name", value: "first" } },
                    },
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "filters" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "accountId" },
                            value: { kind: "Variable", name: { kind: "Name", value: "accountId" } },
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "edges" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "node" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  { kind: "Field", name: { kind: "Name", value: "id" } },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "canViewAccount" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "canInitiatePayments" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "account" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "__typename" },
                                        },
                                        { kind: "Field", name: { kind: "Name", value: "id" } },
                                        { kind: "Field", name: { kind: "Name", value: "name" } },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "holder" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: { kind: "Name", value: "__typename" },
                                              },
                                              {
                                                kind: "Field",
                                                name: { kind: "Name", value: "id" },
                                              },
                                              {
                                                kind: "Field",
                                                name: { kind: "Name", value: "info" },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    {
                                                      kind: "Field",
                                                      name: { kind: "Name", value: "__typename" },
                                                    },
                                                    {
                                                      kind: "InlineFragment",
                                                      typeCondition: {
                                                        kind: "NamedType",
                                                        name: {
                                                          kind: "Name",
                                                          value: "AccountHolderCompanyInfo",
                                                        },
                                                      },
                                                      selectionSet: {
                                                        kind: "SelectionSet",
                                                        selections: [
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "__typename",
                                                            },
                                                          },
                                                          {
                                                            kind: "Field",
                                                            name: { kind: "Name", value: "name" },
                                                          },
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "projectInfo" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "logoUri" } },
                { kind: "Field", name: { kind: "Name", value: "accentColor" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AddReceivedSepaDirectDebitB2bMandateInfoQuery,
  AddReceivedSepaDirectDebitB2bMandateInfoQueryVariables
>;
export const TransferBulkWizardDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "TransferBulkWizard" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "accountId" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "account" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "accountId" },
                value: { kind: "Variable", name: { kind: "Name", value: "accountId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "settings" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "allowBulkCreditTransfersWithoutBeneficiaryVerification",
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "holder" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "info" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "type" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TransferBulkWizardQuery, TransferBulkWizardQueryVariables>;
export const CreatePaymentLinkDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "CreatePaymentLink" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "CreateMerchantPaymentLinkInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "createMerchantPaymentLink" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "CreateMerchantPaymentLinkSuccessPayload" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "merchantPaymentLink" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "PaymentLink" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Rejection" } },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "message" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PaymentLink" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "MerchantPaymentLink" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "label" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "reference" } },
          { kind: "Field", name: { kind: "Name", value: "externalReference" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "statusInfo" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "amount" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "currency" } },
                { kind: "Field", name: { kind: "Name", value: "value" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreatePaymentLinkMutation, CreatePaymentLinkMutationVariables>;
export const CreateMultiConsentDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "CreateMultiConsent" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "CreateMultiConsentInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "createMultiConsent" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "CreateMultiConsentSuccessPayload" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "consent" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "consentUrl" } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Rejection" } },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "message" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateMultiConsentMutation, CreateMultiConsentMutationVariables>;
export const AddCardsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AddCards" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "AddCardsInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "addCards" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "AddCardsSuccessPayload" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "cards" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "CardFragment" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Rejection" } },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "message" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CardFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Card" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "insuranceSubscription" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "package" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "level" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "statusInfo" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "CardConsentPendingStatusInfo" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "consent" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "consentUrl" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AddCardsMutation, AddCardsMutationVariables>;
export const AddCardDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AddCard" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "AddCardInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "addCard" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "AddCardSuccessPayload" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "card" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "CardFragment" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Rejection" } },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "message" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CardFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Card" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "insuranceSubscription" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "package" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "level" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "statusInfo" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "CardConsentPendingStatusInfo" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "consent" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "consentUrl" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AddCardMutation, AddCardMutationVariables>;
export const AddCardsWithGroupDeliveryDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AddCardsWithGroupDelivery" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "AddCardsWithGroupDeliveryInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "addCardsWithGroupDelivery" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "AddCardsWithGroupDeliverySuccessPayload" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "cards" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "CardFragment" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Rejection" } },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "message" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CardFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Card" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "insuranceSubscription" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "package" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "level" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "statusInfo" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "CardConsentPendingStatusInfo" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "consent" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "consentUrl" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AddCardsWithGroupDeliveryMutation,
  AddCardsWithGroupDeliveryMutationVariables
>;
export const AddSingleUseVirtualCardsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AddSingleUseVirtualCards" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "AddSingleUseVirtualCardsInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "addSingleUseVirtualCards" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "AddSingleUseVirtualCardsSuccessPayload" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "cards" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "CardFragment" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Rejection" } },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "message" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CardFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Card" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "insuranceSubscription" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "package" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "level" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "statusInfo" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "CardConsentPendingStatusInfo" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "consent" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "consentUrl" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AddSingleUseVirtualCardsMutation,
  AddSingleUseVirtualCardsMutationVariables
>;
export const AddSingleUseVirtualCardDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AddSingleUseVirtualCard" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "AddSingleUseVirtualCardInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "addSingleUseVirtualCard" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "AddSingleUseVirtualCardSuccessForUserPayload" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "card" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "CardFragment" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "AddSingleUseVirtualCardSuccessForProjectOwnerPayload",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "card" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "CardFragment" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Rejection" } },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "message" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CardFragment" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Card" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "insuranceSubscription" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "package" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "level" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "statusInfo" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "CardConsentPendingStatusInfo" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "consent" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "consentUrl" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AddSingleUseVirtualCardMutation,
  AddSingleUseVirtualCardMutationVariables
>;
export const InitiateSepaCreditTransfersDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "InitiateSepaCreditTransfers" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "InitiateCreditTransfersInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "initiateCreditTransfers" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "AccountNotFoundRejection" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "message" } },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "ForbiddenRejection" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "message" } },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "InitiateCreditTransfersSuccessPayload" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "payment" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "statusInfo" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: { kind: "Name", value: "PaymentRejected" },
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "__typename" },
                                        },
                                        { kind: "Field", name: { kind: "Name", value: "reason" } },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: { kind: "Name", value: "PaymentConsentPending" },
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "__typename" },
                                        },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "consent" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: { kind: "Name", value: "__typename" },
                                              },
                                              {
                                                kind: "Field",
                                                name: { kind: "Name", value: "id" },
                                              },
                                              {
                                                kind: "Field",
                                                name: { kind: "Name", value: "consentUrl" },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  InitiateSepaCreditTransfersMutation,
  InitiateSepaCreditTransfersMutationVariables
>;
export const ResumeAccountMembershipDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "ResumeAccountMembership" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "ResumeAccountMembershipInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "resumeAccountMembership" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "ResumeAccountMembershipSuccessPayload" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "consent" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "consentUrl" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ResumeAccountMembershipMutation,
  ResumeAccountMembershipMutationVariables
>;
export const SuspendAccountMembershipDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "SuspendAccountMembership" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "SuspendAccountMembershipInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "suspendAccountMembership" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "Field", name: { kind: "Name", value: "__typename" } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SuspendAccountMembershipMutation,
  SuspendAccountMembershipMutationVariables
>;
export const UpdateAccountMembershipDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UpdateAccountMembership" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "UpdateAccountMembershipInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "updateAccountMembership" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "UpdateAccountMembershipSuccessPayload" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "consent" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "consentUrl" } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "ValidationRejection" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "fields" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "path" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateAccountMembershipMutation,
  UpdateAccountMembershipMutationVariables
>;
export const DisableAccountMembershipDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "DisableAccountMembership" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "accountMembershipId" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "disableAccountMembership" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "accountMembershipId" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "accountMembershipId" },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "Field", name: { kind: "Name", value: "__typename" } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DisableAccountMembershipMutation,
  DisableAccountMembershipMutationVariables
>;
export const ViewCardNumbersDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "ViewCardNumbers" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ViewCardNumbersInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "viewCardNumbers" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "ViewCardNumbersSuccessPayload" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "consent" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "consentUrl" } },
                            { kind: "Field", name: { kind: "Name", value: "purpose" } },
                            { kind: "Field", name: { kind: "Name", value: "redirectUrl" } },
                            { kind: "Field", name: { kind: "Name", value: "status" } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Rejection" } },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "message" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ViewCardNumbersMutation, ViewCardNumbersMutationVariables>;
export const ViewPhysicalCardNumbersDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "ViewPhysicalCardNumbers" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "ViewPhysicalCardNumbersInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "viewPhysicalCardNumbers" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "ViewPhysicalCardNumbersSuccessPayload" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "consent" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "consentUrl" } },
                            { kind: "Field", name: { kind: "Name", value: "purpose" } },
                            { kind: "Field", name: { kind: "Name", value: "redirectUrl" } },
                            { kind: "Field", name: { kind: "Name", value: "status" } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Rejection" } },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "message" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ViewPhysicalCardNumbersMutation,
  ViewPhysicalCardNumbersMutationVariables
>;
export const ViewPhysicalCardPinDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "ViewPhysicalCardPin" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ViewPhysicalCardPinInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "viewPhysicalCardPin" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "ViewPhysicalCardPinSuccessPayload" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "consent" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "consentUrl" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ViewPhysicalCardPinMutation, ViewPhysicalCardPinMutationVariables>;
export const ActivatePhysicalCardDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "ActivatePhysicalCard" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ActivatePhysicalCardInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "activatePhysicalCard" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "ActivatePhysicalCardSuccessPayload" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "consent" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "consentUrl" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ActivatePhysicalCardMutation, ActivatePhysicalCardMutationVariables>;
export const CancelCardDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "CancelCard" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "cardId" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "cancelCard" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "cardId" },
                      value: { kind: "Variable", name: { kind: "Name", value: "cardId" } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "CancelCardSuccessPayload" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "card" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CancelCardMutation, CancelCardMutationVariables>;
export const CancelDigitalCardDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "CancelDigitalCard" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "digitalCardId" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "cancelDigitalCard" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "digitalCardId" },
                      value: { kind: "Variable", name: { kind: "Name", value: "digitalCardId" } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "CancelDigitalCardSuccessPayload" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "digitalCard" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CancelDigitalCardMutation, CancelDigitalCardMutationVariables>;
export const CancelPhysicalCardDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "CancelPhysicalCard" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "CancelPhysicalCardInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "cancelPhysicalCard" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "CancelPhysicalCardSuccessPayload" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "physicalCard" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "identifier" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CancelPhysicalCardMutation, CancelPhysicalCardMutationVariables>;
export const UpdateCardDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UpdateCard" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "UpdateCardInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "updateCard" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "UpdateCardSuccessPayload" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "consent" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "consentUrl" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateCardMutation, UpdateCardMutationVariables>;
export const ConfirmPhysicalCardRenewalDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "ConfirmPhysicalCardRenewal" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "ConfirmPhysicalCardRenewalInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "confirmPhysicalCardRenewal" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "ConfirmPhysicalCardRenewalSuccessPayload" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "physicalCard" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "identifier" } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Rejection" } },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "message" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ConfirmPhysicalCardRenewalMutation,
  ConfirmPhysicalCardRenewalMutationVariables
>;
export const ScheduleStandingOrderDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "ScheduleStandingOrder" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "ScheduleStandingOrderInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "scheduleStandingOrder" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "ScheduleStandingOrderSuccessPayload" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "standingOrder" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "statusInfo" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: {
                                        kind: "Name",
                                        value: "StandingOrderConsentPendingStatusInfo",
                                      },
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "__typename" },
                                        },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "consent" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: { kind: "Name", value: "__typename" },
                                              },
                                              {
                                                kind: "Field",
                                                name: { kind: "Name", value: "id" },
                                              },
                                              {
                                                kind: "Field",
                                                name: { kind: "Name", value: "consentUrl" },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ScheduleStandingOrderMutation, ScheduleStandingOrderMutationVariables>;
export const CancelStandingOrderDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "CancelStandingOrder" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "cancelStandingOrder" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "standingOrderId" },
                      value: { kind: "Variable", name: { kind: "Name", value: "id" } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "CancelStandingOrderSuccessPayload" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "standingOrder" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CancelStandingOrderMutation, CancelStandingOrderMutationVariables>;
export const SuspendPhysicalCardDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "SuspendPhysicalCard" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "cardId" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "suspendPhysicalCard" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "cardId" },
                      value: { kind: "Variable", name: { kind: "Name", value: "cardId" } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "Field", name: { kind: "Name", value: "__typename" } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SuspendPhysicalCardMutation, SuspendPhysicalCardMutationVariables>;
export const ResumePhysicalCardDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "ResumePhysicalCard" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ResumePhysicalCardInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "resumePhysicalCard" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "ResumePhysicalCardSuccessPayload" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "consent" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "consentUrl" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ResumePhysicalCardMutation, ResumePhysicalCardMutationVariables>;
export const AddAccountMembershipDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AddAccountMembership" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "AddAccountMembershipInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "addAccountMembership" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "AddAccountMembershipSuccessPayload" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "accountMembership" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "email" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "statusInfo" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  { kind: "Field", name: { kind: "Name", value: "status" } },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: {
                                        kind: "Name",
                                        value: "AccountMembershipConsentPendingStatusInfo",
                                      },
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "__typename" },
                                        },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "consent" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: { kind: "Name", value: "__typename" },
                                              },
                                              {
                                                kind: "Field",
                                                name: { kind: "Name", value: "id" },
                                              },
                                              {
                                                kind: "Field",
                                                name: { kind: "Name", value: "consentUrl" },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            { kind: "Field", name: { kind: "Name", value: "canInitiatePayments" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "canManageAccountMembership" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "canManageBeneficiaries" },
                            },
                            { kind: "Field", name: { kind: "Name", value: "canViewAccount" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "user" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  { kind: "Field", name: { kind: "Name", value: "id" } },
                                  { kind: "Field", name: { kind: "Name", value: "birthDate" } },
                                  { kind: "Field", name: { kind: "Name", value: "firstName" } },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "preferredLastName" },
                                  },
                                  { kind: "Field", name: { kind: "Name", value: "fullName" } },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "mobilePhoneNumber" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "account" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  { kind: "Field", name: { kind: "Name", value: "id" } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AddAccountMembershipMutation, AddAccountMembershipMutationVariables>;
export const GenerateAccountStatementDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "GenerateAccountStatement" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "GenerateAccountStatementInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "generateAccountStatement" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GenerateAccountStatementMutation,
  GenerateAccountStatementMutationVariables
>;
export const InitiateInternationalCreditTransferDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "InitiateInternationalCreditTransfer" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "InitiateInternationalCreditTransferInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "initiateInternationalCreditTransfer" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Rejection" } },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "message" } },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "InitiateInternationalCreditTransferResponseSuccessPayload",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "payment" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "statusInfo" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: { kind: "Name", value: "PaymentRejected" },
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "__typename" },
                                        },
                                        { kind: "Field", name: { kind: "Name", value: "reason" } },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: { kind: "Name", value: "PaymentConsentPending" },
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "__typename" },
                                        },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "consent" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: { kind: "Name", value: "__typename" },
                                              },
                                              {
                                                kind: "Field",
                                                name: { kind: "Name", value: "id" },
                                              },
                                              {
                                                kind: "Field",
                                                name: { kind: "Name", value: "consentUrl" },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  InitiateInternationalCreditTransferMutation,
  InitiateInternationalCreditTransferMutationVariables
>;
export const AddMerchantProfileDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AddMerchantProfile" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "RequestMerchantProfileInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "requestMerchantProfile" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "RequestMerchantProfileSuccessPayload" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "merchantProfile" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "MerchantProfile" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Rejection" } },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "message" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MerchantPaymentMethod" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "MerchantPaymentMethod" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "methodId" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "version" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "rollingReserve" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "percentage" } },
                { kind: "Field", name: { kind: "Name", value: "rollingDays" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "statusInfo" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "WaitingForInformationMerchantPaymentMethodStatusInfo",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "verificationRequirements" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: { kind: "Name", value: "AdditionalInformationRequirements" },
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "additionalInformation" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: { kind: "Name", value: "MerchantRequirements" },
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  { kind: "Field", name: { kind: "Name", value: "fields" } },
                                ],
                              },
                            },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: {
                                  kind: "Name",
                                  value: "OtherAdditionalInformationRequirements",
                                },
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "otherAdditionalInformation" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: { kind: "Name", value: "SupportingDocumentRequirements" },
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "supportingDocumentPurposes" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "SepaDirectDebitB2BMerchantPaymentMethod" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "sepaCreditorIdentifier" } },
                { kind: "Field", name: { kind: "Name", value: "useSwanSepaCreditorIdentifier" } },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "SepaDirectDebitCoreMerchantPaymentMethod" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "sepaCreditorIdentifier" } },
                { kind: "Field", name: { kind: "Name", value: "useSwanSepaCreditorIdentifier" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "MerchantProfile" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "MerchantProfile" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "accentColor" } },
          { kind: "Field", name: { kind: "Name", value: "accountId" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "expectedAverageBasket" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "value" } },
                { kind: "Field", name: { kind: "Name", value: "currency" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "expectedMonthlyMerchantProcessingVolume" },
          },
          { kind: "Field", name: { kind: "Name", value: "merchantLogoUrl" } },
          { kind: "Field", name: { kind: "Name", value: "merchantName" } },
          { kind: "Field", name: { kind: "Name", value: "merchantWebsiteUrl" } },
          { kind: "Field", name: { kind: "Name", value: "productType" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "statusInfo" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "merchantPaymentMethods" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "FragmentSpread", name: { kind: "Name", value: "MerchantPaymentMethod" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "requestMerchantProfileUpdate" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                { kind: "Field", name: { kind: "Name", value: "merchantName" } },
                { kind: "Field", name: { kind: "Name", value: "merchantWebsiteUrl" } },
                { kind: "Field", name: { kind: "Name", value: "merchantLogoUrl" } },
                { kind: "Field", name: { kind: "Name", value: "productType" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "expectedMonthlyMerchantProcessingVolume" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "expectedAverageBasket" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                      { kind: "Field", name: { kind: "Name", value: "currency" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AddMerchantProfileMutation, AddMerchantProfileMutationVariables>;
export const RequestMerchantPaymentMethodsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "RequestMerchantPaymentMethods" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "RequestMerchantPaymentMethodsInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "requestMerchantPaymentMethods" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "RequestMerchantPaymentMethodsSuccessPayload" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "merchantProfile" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "ValidationRejection" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "message" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "fields" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "path" } },
                            { kind: "Field", name: { kind: "Name", value: "code" } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Rejection" } },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "message" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  RequestMerchantPaymentMethodsMutation,
  RequestMerchantPaymentMethodsMutationVariables
>;
export const RequestMerchantPaymentMethodsUpdateDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "RequestMerchantPaymentMethodsUpdate" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "RequestMerchantPaymentMethodsUpdateInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "requestMerchantPaymentMethodsUpdate" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "RequestMerchantPaymentMethodsUpdateSuccessPayload",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "paymentMethodId" } },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Rejection" } },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "message" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  RequestMerchantPaymentMethodsUpdateMutation,
  RequestMerchantPaymentMethodsUpdateMutationVariables
>;
export const RequestMerchantProfileUpdateDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "RequestMerchantProfileUpdate" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "RequestMerchantProfileUpdateInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "requestMerchantProfileUpdate" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "RequestMerchantProfileUpdateSuccessPayload" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "merchantProfile" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Rejection" } },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "message" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  RequestMerchantProfileUpdateMutation,
  RequestMerchantProfileUpdateMutationVariables
>;
export const InitiateCheckMerchantPaymentDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "InitiateCheckMerchantPayment" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "InitiateCheckMerchantPaymentInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "initiateCheckMerchantPayment" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "InitiateCheckMerchantPaymentSuccessPayload" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "fnciInfo" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "FragmentSpread", name: { kind: "Name", value: "FnciInfo" } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "CheckRejection" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "fnciInfo" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "FragmentSpread", name: { kind: "Name", value: "FnciInfo" } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "ValidationRejection" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "fields" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "path" } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Rejection" } },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "message" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FnciInfo" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "FnciInfo" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "colorCode" } },
          { kind: "Field", name: { kind: "Name", value: "cpt1" } },
          { kind: "Field", name: { kind: "Name", value: "cpt2" } },
          { kind: "Field", name: { kind: "Name", value: "cpt3" } },
          { kind: "Field", name: { kind: "Name", value: "holderEstablishment" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  InitiateCheckMerchantPaymentMutation,
  InitiateCheckMerchantPaymentMutationVariables
>;
export const CloseAccountDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "CloseAccount" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "CloseAccountInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "closeAccount" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "CloseAccountSuccessPayload" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "consent" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "consentUrl" } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Rejection" } },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "message" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CloseAccountMutation, CloseAccountMutationVariables>;
export const AddReceivedSepaDirectDebitB2bMandateDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AddReceivedSepaDirectDebitB2bMandate" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "AddReceivedSepaDirectDebitB2bMandateInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "addReceivedSepaDirectDebitB2bMandate" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "AddReceivedSepaDirectDebitB2bMandateSuccessPayload",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "receivedDirectDebitMandate" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "statusInfo" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: {
                                        kind: "Name",
                                        value: "ReceivedDirectDebitMandateStatusInfoConsentPending",
                                      },
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "__typename" },
                                        },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "consent" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: { kind: "Name", value: "__typename" },
                                              },
                                              {
                                                kind: "Field",
                                                name: { kind: "Name", value: "id" },
                                              },
                                              {
                                                kind: "Field",
                                                name: { kind: "Name", value: "consentUrl" },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "ValidationRejection" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "fields" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "code" } },
                            { kind: "Field", name: { kind: "Name", value: "path" } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Rejection" } },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "message" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AddReceivedSepaDirectDebitB2bMandateMutation,
  AddReceivedSepaDirectDebitB2bMandateMutationVariables
>;
export const VerifyBeneficiaryDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "VerifyBeneficiary" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "VerifyBeneficiaryInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "verifyBeneficiary" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "VerifyBeneficiarySuccessPayload" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "VerifyBeneficiarySuccessPayload" },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Rejection" } },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "message" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "VerifyBeneficiarySuccessPayload" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "VerifyBeneficiarySuccessPayload" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "expiresAt" } },
          { kind: "Field", name: { kind: "Name", value: "beneficiaryVerificationToken" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "verifyBeneficiaryResult" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "VerifyBeneficiaryCloseMatch" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "nameSuggestion" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<VerifyBeneficiaryMutation, VerifyBeneficiaryMutationVariables>;
export const SendAccountMembershipInviteNotificationDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "SendAccountMembershipInviteNotification" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "SendAccountMembershipInviteNotificationInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "sendAccountMembershipInviteNotification" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "SendAccountMembershipInviteNotificationSuccessPayload",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "notificationRequestId" } },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Rejection" } },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "message" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SendAccountMembershipInviteNotificationMutation,
  SendAccountMembershipInviteNotificationMutationVariables
>;
export const GetVerificationRenewalDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetVerificationRenewal" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "projectInfo" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "accentColor" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "logoUri" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "verificationRenewal" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: { kind: "Variable", name: { kind: "Name", value: "id" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "WaitingForInformationVerificationRenewal" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "accountCountries" } },
                      { kind: "Field", name: { kind: "Name", value: "verificationRequirements" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "supportingDocumentCollection" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "SupportingDocumentRenewal" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "info" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "CompanyVerificationRenewalInfo" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "CompanyRenewalInfo" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "IndividualVerificationRenewalInfo" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "IndividualRenewalInfo" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AddressInfo" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "AddressInfo" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "addressLine1" } },
          { kind: "Field", name: { kind: "Name", value: "addressLine2" } },
          { kind: "Field", name: { kind: "Name", value: "city" } },
          { kind: "Field", name: { kind: "Name", value: "country" } },
          { kind: "Field", name: { kind: "Name", value: "postalCode" } },
          { kind: "Field", name: { kind: "Name", value: "state" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "VerificationRenewalUBO" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "VerificationRenewalUltimateBeneficialOwner" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "address" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "FragmentSpread", name: { kind: "Name", value: "AddressInfo" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "taxIdentificationNumber" } },
          { kind: "Field", name: { kind: "Name", value: "firstName" } },
          { kind: "Field", name: { kind: "Name", value: "lastName" } },
          { kind: "Field", name: { kind: "Name", value: "sex" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "ownership" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "totalPercentage" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "birthInfo" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "city" } },
                { kind: "Field", name: { kind: "Name", value: "country" } },
                { kind: "Field", name: { kind: "Name", value: "birthDate" } },
                { kind: "Field", name: { kind: "Name", value: "postalCode" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "qualificationType" } },
          { kind: "Field", name: { kind: "Name", value: "taxIdentificationNumber" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SupportingDocumentRenewal" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "SupportingDocumentCollection" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "supportingDocuments" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "statusInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "status" } },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "SupportingDocumentRefusedStatusInfo" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "filename" } },
                            { kind: "Field", name: { kind: "Name", value: "reason" } },
                            { kind: "Field", name: { kind: "Name", value: "reasonCode" } },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "SupportingDocumentUploadedStatusInfo" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "filename" } },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "supportingDocumentPurpose" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "requiredSupportingDocumentPurposes" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "label" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "statusInfo" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "requiredSupportingDocumentPurposes" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "acceptableSupportingDocumentTypes" },
                },
                { kind: "Field", name: { kind: "Name", value: "label" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CompanyRenewalInfo" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CompanyVerificationRenewalInfo" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "additionalDetails" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "company" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "residencyAddress" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "addressLine1" } },
                      { kind: "Field", name: { kind: "Name", value: "addressLine2" } },
                      { kind: "Field", name: { kind: "Name", value: "city" } },
                      { kind: "Field", name: { kind: "Name", value: "postalCode" } },
                      { kind: "Field", name: { kind: "Name", value: "country" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "businessActivityDescription" } },
                { kind: "Field", name: { kind: "Name", value: "monthlyPaymentVolume" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "ultimateBeneficialOwners" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "VerificationRenewalUBO" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "accountAdmin" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "firstName" } },
                { kind: "Field", name: { kind: "Name", value: "lastName" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "birthInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "city" } },
                      { kind: "Field", name: { kind: "Name", value: "country" } },
                      { kind: "Field", name: { kind: "Name", value: "birthDate" } },
                      { kind: "Field", name: { kind: "Name", value: "postalCode" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "typeOfRepresentation" } },
                { kind: "Field", name: { kind: "Name", value: "email" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "IndividualRenewalInfo" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "IndividualVerificationRenewalInfo" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "additionalDetails" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "accountAdmin" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "firstName" } },
                { kind: "Field", name: { kind: "Name", value: "lastName" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "residencyAddress" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "addressLine1" } },
                      { kind: "Field", name: { kind: "Name", value: "addressLine2" } },
                      { kind: "Field", name: { kind: "Name", value: "city" } },
                      { kind: "Field", name: { kind: "Name", value: "postalCode" } },
                      { kind: "Field", name: { kind: "Name", value: "state" } },
                      { kind: "Field", name: { kind: "Name", value: "country" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "employmentStatus" } },
                { kind: "Field", name: { kind: "Name", value: "monthlyIncome" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetVerificationRenewalQuery, GetVerificationRenewalQueryVariables>;
export const UpdateIndividualVerificationRenewalDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UpdateIndividualVerificationRenewal" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "UpdateIndividualVerificationRenewalInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "updateIndividualVerificationRenewal" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "UpdateIndividualVerificationRenewalSuccessPayload",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "verificationRenewal" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: {
                                  kind: "Name",
                                  value: "WaitingForInformationVerificationRenewal",
                                },
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "verificationRequirements" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "supportingDocumentCollection" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "__typename" },
                                        },
                                        {
                                          kind: "FragmentSpread",
                                          name: {
                                            kind: "Name",
                                            value: "SupportingDocumentRenewal",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "info" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: {
                                        kind: "Name",
                                        value: "CompanyVerificationRenewalInfo",
                                      },
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "__typename" },
                                        },
                                        {
                                          kind: "FragmentSpread",
                                          name: { kind: "Name", value: "CompanyRenewalInfo" },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: {
                                        kind: "Name",
                                        value: "IndividualVerificationRenewalInfo",
                                      },
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "__typename" },
                                        },
                                        {
                                          kind: "FragmentSpread",
                                          name: { kind: "Name", value: "IndividualRenewalInfo" },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "ValidationRejection" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "fields" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "path" } },
                            { kind: "Field", name: { kind: "Name", value: "message" } },
                          ],
                        },
                      },
                      { kind: "Field", name: { kind: "Name", value: "message" } },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Rejection" } },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "message" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AddressInfo" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "AddressInfo" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "addressLine1" } },
          { kind: "Field", name: { kind: "Name", value: "addressLine2" } },
          { kind: "Field", name: { kind: "Name", value: "city" } },
          { kind: "Field", name: { kind: "Name", value: "country" } },
          { kind: "Field", name: { kind: "Name", value: "postalCode" } },
          { kind: "Field", name: { kind: "Name", value: "state" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "VerificationRenewalUBO" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "VerificationRenewalUltimateBeneficialOwner" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "address" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "FragmentSpread", name: { kind: "Name", value: "AddressInfo" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "taxIdentificationNumber" } },
          { kind: "Field", name: { kind: "Name", value: "firstName" } },
          { kind: "Field", name: { kind: "Name", value: "lastName" } },
          { kind: "Field", name: { kind: "Name", value: "sex" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "ownership" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "totalPercentage" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "birthInfo" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "city" } },
                { kind: "Field", name: { kind: "Name", value: "country" } },
                { kind: "Field", name: { kind: "Name", value: "birthDate" } },
                { kind: "Field", name: { kind: "Name", value: "postalCode" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "qualificationType" } },
          { kind: "Field", name: { kind: "Name", value: "taxIdentificationNumber" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SupportingDocumentRenewal" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "SupportingDocumentCollection" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "supportingDocuments" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "statusInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "status" } },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "SupportingDocumentRefusedStatusInfo" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "filename" } },
                            { kind: "Field", name: { kind: "Name", value: "reason" } },
                            { kind: "Field", name: { kind: "Name", value: "reasonCode" } },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "SupportingDocumentUploadedStatusInfo" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "filename" } },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "supportingDocumentPurpose" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "requiredSupportingDocumentPurposes" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "label" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "statusInfo" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "requiredSupportingDocumentPurposes" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "acceptableSupportingDocumentTypes" },
                },
                { kind: "Field", name: { kind: "Name", value: "label" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CompanyRenewalInfo" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CompanyVerificationRenewalInfo" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "additionalDetails" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "company" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "residencyAddress" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "addressLine1" } },
                      { kind: "Field", name: { kind: "Name", value: "addressLine2" } },
                      { kind: "Field", name: { kind: "Name", value: "city" } },
                      { kind: "Field", name: { kind: "Name", value: "postalCode" } },
                      { kind: "Field", name: { kind: "Name", value: "country" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "businessActivityDescription" } },
                { kind: "Field", name: { kind: "Name", value: "monthlyPaymentVolume" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "ultimateBeneficialOwners" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "VerificationRenewalUBO" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "accountAdmin" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "firstName" } },
                { kind: "Field", name: { kind: "Name", value: "lastName" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "birthInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "city" } },
                      { kind: "Field", name: { kind: "Name", value: "country" } },
                      { kind: "Field", name: { kind: "Name", value: "birthDate" } },
                      { kind: "Field", name: { kind: "Name", value: "postalCode" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "typeOfRepresentation" } },
                { kind: "Field", name: { kind: "Name", value: "email" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "IndividualRenewalInfo" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "IndividualVerificationRenewalInfo" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "additionalDetails" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "accountAdmin" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "firstName" } },
                { kind: "Field", name: { kind: "Name", value: "lastName" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "residencyAddress" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "addressLine1" } },
                      { kind: "Field", name: { kind: "Name", value: "addressLine2" } },
                      { kind: "Field", name: { kind: "Name", value: "city" } },
                      { kind: "Field", name: { kind: "Name", value: "postalCode" } },
                      { kind: "Field", name: { kind: "Name", value: "state" } },
                      { kind: "Field", name: { kind: "Name", value: "country" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "employmentStatus" } },
                { kind: "Field", name: { kind: "Name", value: "monthlyIncome" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateIndividualVerificationRenewalMutation,
  UpdateIndividualVerificationRenewalMutationVariables
>;
export const UpdateCompanyVerificationRenewalDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UpdateCompanyVerificationRenewal" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "UpdateCompanyVerificationRenewalInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "updateCompanyVerificationRenewal" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "UpdateCompanyVerificationRenewalSuccessPayload" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "verificationRenewal" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: {
                                  kind: "Name",
                                  value: "WaitingForInformationVerificationRenewal",
                                },
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "verificationRequirements" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "supportingDocumentCollection" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "__typename" },
                                        },
                                        {
                                          kind: "FragmentSpread",
                                          name: {
                                            kind: "Name",
                                            value: "SupportingDocumentRenewal",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "info" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "__typename" } },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: {
                                        kind: "Name",
                                        value: "CompanyVerificationRenewalInfo",
                                      },
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "__typename" },
                                        },
                                        {
                                          kind: "FragmentSpread",
                                          name: { kind: "Name", value: "CompanyRenewalInfo" },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                      kind: "NamedType",
                                      name: {
                                        kind: "Name",
                                        value: "IndividualVerificationRenewalInfo",
                                      },
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "__typename" },
                                        },
                                        {
                                          kind: "FragmentSpread",
                                          name: { kind: "Name", value: "IndividualRenewalInfo" },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Rejection" } },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "message" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AddressInfo" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "AddressInfo" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "addressLine1" } },
          { kind: "Field", name: { kind: "Name", value: "addressLine2" } },
          { kind: "Field", name: { kind: "Name", value: "city" } },
          { kind: "Field", name: { kind: "Name", value: "country" } },
          { kind: "Field", name: { kind: "Name", value: "postalCode" } },
          { kind: "Field", name: { kind: "Name", value: "state" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "VerificationRenewalUBO" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "VerificationRenewalUltimateBeneficialOwner" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "address" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "FragmentSpread", name: { kind: "Name", value: "AddressInfo" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "taxIdentificationNumber" } },
          { kind: "Field", name: { kind: "Name", value: "firstName" } },
          { kind: "Field", name: { kind: "Name", value: "lastName" } },
          { kind: "Field", name: { kind: "Name", value: "sex" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "ownership" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "totalPercentage" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "birthInfo" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "city" } },
                { kind: "Field", name: { kind: "Name", value: "country" } },
                { kind: "Field", name: { kind: "Name", value: "birthDate" } },
                { kind: "Field", name: { kind: "Name", value: "postalCode" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "qualificationType" } },
          { kind: "Field", name: { kind: "Name", value: "taxIdentificationNumber" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SupportingDocumentRenewal" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "SupportingDocumentCollection" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "supportingDocuments" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "statusInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "status" } },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "SupportingDocumentRefusedStatusInfo" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "filename" } },
                            { kind: "Field", name: { kind: "Name", value: "reason" } },
                            { kind: "Field", name: { kind: "Name", value: "reasonCode" } },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "SupportingDocumentUploadedStatusInfo" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "filename" } },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "supportingDocumentPurpose" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "requiredSupportingDocumentPurposes" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "label" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "statusInfo" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "requiredSupportingDocumentPurposes" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "acceptableSupportingDocumentTypes" },
                },
                { kind: "Field", name: { kind: "Name", value: "label" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CompanyRenewalInfo" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CompanyVerificationRenewalInfo" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "additionalDetails" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "company" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "residencyAddress" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "addressLine1" } },
                      { kind: "Field", name: { kind: "Name", value: "addressLine2" } },
                      { kind: "Field", name: { kind: "Name", value: "city" } },
                      { kind: "Field", name: { kind: "Name", value: "postalCode" } },
                      { kind: "Field", name: { kind: "Name", value: "country" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "businessActivityDescription" } },
                { kind: "Field", name: { kind: "Name", value: "monthlyPaymentVolume" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "ultimateBeneficialOwners" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "VerificationRenewalUBO" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "accountAdmin" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "firstName" } },
                { kind: "Field", name: { kind: "Name", value: "lastName" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "birthInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "city" } },
                      { kind: "Field", name: { kind: "Name", value: "country" } },
                      { kind: "Field", name: { kind: "Name", value: "birthDate" } },
                      { kind: "Field", name: { kind: "Name", value: "postalCode" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "typeOfRepresentation" } },
                { kind: "Field", name: { kind: "Name", value: "email" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "IndividualRenewalInfo" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "IndividualVerificationRenewalInfo" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "additionalDetails" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "accountAdmin" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "firstName" } },
                { kind: "Field", name: { kind: "Name", value: "lastName" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "residencyAddress" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "addressLine1" } },
                      { kind: "Field", name: { kind: "Name", value: "addressLine2" } },
                      { kind: "Field", name: { kind: "Name", value: "city" } },
                      { kind: "Field", name: { kind: "Name", value: "postalCode" } },
                      { kind: "Field", name: { kind: "Name", value: "state" } },
                      { kind: "Field", name: { kind: "Name", value: "country" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "employmentStatus" } },
                { kind: "Field", name: { kind: "Name", value: "monthlyIncome" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateCompanyVerificationRenewalMutation,
  UpdateCompanyVerificationRenewalMutationVariables
>;
export const FinalizeVerificationRenewalDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "FinalizeVerificationRenewal" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "FinalizeVerificationRenewalInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "__typename" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "finalizeVerificationRenewal" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "FinalizeVerificationRenewalSuccessPayload" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "verificationRenewal" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Rejection" } },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "__typename" } },
                      { kind: "Field", name: { kind: "Name", value: "message" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  FinalizeVerificationRenewalMutation,
  FinalizeVerificationRenewalMutationVariables
>;
